/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	window.jQuery = window.$ = __webpack_require__(2);
	__webpack_require__(534).shim();
	__webpack_require__(531); // Needs to be loaded before angular
	__webpack_require__(76);
	__webpack_require__(47);
	__webpack_require__(448);
	__webpack_require__(439);
	__webpack_require__(450);
	__webpack_require__(456);
	__webpack_require__(455);
	__webpack_require__(530);
	__webpack_require__(460);
	__webpack_require__(532);
	__webpack_require__(440);
	__webpack_require__(445);
	__webpack_require__(453);
	__webpack_require__(454);
	__webpack_require__(442);
	__webpack_require__(446);
	__webpack_require__(256);
	__webpack_require__(444);
	__webpack_require__(510);
	__webpack_require__(274);
	__webpack_require__(263);
	__webpack_require__(458);
	__webpack_require__(457);
	
	__webpack_require__(459);
	__webpack_require__(560);
	__webpack_require__(559);
	__webpack_require__(553);
	__webpack_require__(539);
	__webpack_require__(547);
	__webpack_require__(551);
	__webpack_require__(543);
	__webpack_require__(549);
	__webpack_require__(557);
	__webpack_require__(541);
	__webpack_require__(555);
	__webpack_require__(545);
	__webpack_require__(78);
	__webpack_require__(262);
	
	
	__webpack_require__(441);
	
	__webpack_require__(1).locale("sv-se");
	
	// Declare app level module which depends on filters, and services
	angular.module('dokiv', [
	  'ngResource',
	  'ngAnimate',
	  'ngSanitize',
	  'ui.router',
	  'pascalprecht.translate',
	  'ngFileUpload',
	  'xeditable',
	  'ngTagsInput',
	  'colorpicker.module',
	  'ngPasswordGenerator',
	  'angular-growl',
	  'mgcrea.ngStrap',
	  'timer',
	  'mw-typeahead',
	  'monospaced.elastic',
	  'angular-clipboard',
	  'chart.js',
	  'google.places',
	  'ui.sortable',
	  'ui.sortable.multiselection', 
	  'ui.tinymce'
	])
	  .factory("dokivTranslateLocalStorage", function() {
	    return {
	      set: function(key, value) {
	        if(window.localStorage) {
	          window.localStorage.setItem(key, value);
	        }
	      },
	      get: function(key) {
	        if(window.localStorage) {
	          return window.localStorage.getItem(key);
	        }
	      }
	    };
	  })
	  .config(['$translateProvider', function($translateProvider) {
	    $translateProvider.useLoader('TranslateCustomLoader', {});
	    //$translateProvider.use('en_US');
	    // Tell the module what language to use by default
	    $translateProvider.preferredLanguage('en');
	  }])
	  .config(['$httpProvider', function($httpProvider) {
	    $httpProvider.defaults.timeout = 30000;
	  }])
	  .factory('TranslateCustomLoader', ['$http', '$q', function($http, $q) {
	    return function (options) {
	      var deferred = $q.defer();
	      $http({
	        method:'GET',
	        url:'locale/locale-' + options.key + '.json?appHash=' + ("fe34c35b755a3f647875c7d0f5b2c07c69aea2c3\n")
	      }).success(function (data) {
	        deferred.resolve(data);
	      }).error(function () {
	        deferred.reject(options.key);
	      });
	      return deferred.promise;
	    };
	  }])
	  .config(['growlProvider', function(growlProvider) {
	    growlProvider.globalTimeToLive(4000);
	  }])
	  .config(['mwTypeaheadConfigProvider', function(mwTypeaheadConfigProvider) {
	    mwTypeaheadConfigProvider.setActiveClass('active');
	  }])
	  .filter('bytes', function() {
	    return function(bytes, precision) {
	      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
	        return '-';
	      }
	      if (typeof precision === 'undefined') {
	        precision = 1;
	      }
	      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
	        number = Math.floor(Math.log(bytes) / Math.log(1024));
	      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
	    };
	  });
	
	
	angular.module('dokiv')
	
	  .config(['$datepickerProvider', function($datepickerProvider) {
	    angular.extend($datepickerProvider.defaults, {
	      startWeek: 1
	    });
	  }])
	
	  .constant('publicationTypes', [
	    'ORDER',
	    'DEFAULT',
	    'ALBUM',
	    'FOLDER',
	    'NOTE',
	    'FORM',
	    'KEYPASS',
	    'WALL',
	    'PLANT',
	    'COMPANY_ORDER',
	    'ORDER_SUBCRIPTION',
	    'BLOG',
	    'INVESTIGATION',
	    'SK3_FOLDER']
	  )
	
	  .run(['$rootScope', '$sce', '$state', '$translate', '$location', 'growl', 'config', '$compile', 'CurrentUserService', function($rootScope, $sce, $state, $translate, $location, growl, config, $compile, currentUserService) {
	
	    $rootScope.$on('$stateChangeStart', function() {
	      $rootScope.loading = true;
	    });
	
	    var emojiList = ['😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓', '😛', '😜', '😠', '😇', '😷', '😈', '👻', 
	                '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈', '🙉', '🙊', '👼', '👮', '🕵️', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃', 
	                '⛷', '🏂', '🏌️', '🏄', '🚣', '🏊', '⛹️', '🏋️', '🚴', '👫', '💪', '👈', '👉', '👆', '🖕', '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', 
	                '🙌', '🙏', '🐵', '🐶', '🐇', '🐥', '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸', '🍺', '🌍', 
	                '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌧', '🌩', '⛄', '🔥', '🎄', '🎈', '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', 
	                '🎵', '🎷', '💰', '🖊', '📅', '✅', '❎', '💯'];
	
	    $rootScope.tinymceOptions = {
	      format: "raw",
	      setup: function(editor) {
	        editor.on('NodeChange', function (e) {
	          if(e.element.tagName === "IMG"){          
	            e.element.setAttribute("class", "image-editor");
	          }
	        });
	        editor.editorManager.AddOnManager.PluginManager.add("emojis", function(
	          editor
	        ) {
	          var html = "<div>";
	          emojiList.forEach(function(emoji){
	            html +=
	              '<span style="float:left; padding: 4px; font-size: 1.5em; cursor: pointer;" data-chr="' +
	              emoji +
	              '">' +
	              emoji +
	              "</span>";
	          });
	
	          html += "</div>";
	
	          var body = [
	            {
	              type: "container",
	              title: "emojis",
	              html: html,
	              onClick: function(e) {
	                var target = e.target;
	                if (/^(SPAN)$/.test(target.nodeName)) {
	                  if (target.hasAttribute("data-chr")) {
	                    var char = target.getAttribute("data-chr");
	                    editor.execCommand(
	                      "mceInsertContent",
	                      false,
	                      char
	                    );
	                  }
	                }
	              }
	            }
	          ];
	
	          function showDialog() {
	            var win = editor.windowManager.open({
	              autoScroll: true,
	              width: 300,
	              height: 250,
	              title: "Insert Emoji",
	              bodyType: "container",
	              layout: "fit",
	              body: body,
	              buttons: [
	                {
	                  text: "Close",
	                  onclick: function(){
	                    win.close();
	                  }
	                }
	              ]
	            });
	          }
	
	          editor.addCommand("emojiShowDialog", showDialog);
	          editor.addButton("tinymceEmoji", {
	            text: "😀",
	            icon: false,
	            cmd: "emojiShowDialog"
	          });
	        });
	      },
	      content_css : "../../../styles/components/tinymce.css",
	      height: '500',
	      plugins:
	        'emojis image autolink link paste media hr lists textcolor colorpicker table',
	      toolbar:
	        'formatselect | bold italic underline strikethrough | subscript superscript hr | forecolor backcolor tinymceEmoji link image media | alignleft aligncenter alignright alignjustify | fontsizeselect | fontselect | undo redo | numlist bullist outdent indent table  | removeformat',
	      branding: false,
	      menubar: false
	    };
	
	    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
	      $rootScope.loading      = false;
	      $rootScope.currentState = toState;
	    });
	
	    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
	      $rootScope.loading = false;
	
	      switch(error.status) {
	        case 401:
	          window.location.href = '/login?redirect='+$location.url();
	          break;
	        case 403:
	          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
	            $state.get('root.company.403').error = error;
	            $state.go('root.company.403', {}, { location: false });
	          } else {
	            $state.get('403').error = error;
	            $state.go('403', {}, { location: false });
	          }
	          break;
	        case 404:
	          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
	            $state.get('root.company.404').error = error;
	            $state.go('root.company.404', {}, { location: false });
	          } else {
	            $state.get('404').error = error;
	            $state.go('404', {}, { location: false });
	          }
	          break;
	        case 0:
	          growl.addErrorMessage(
	            $translate.instant('error.network-connectivity-issues') + '. <a href="#" onclick="window.location.reload()"><i class="fa fa-refresh"></i> ' + $translate.instant('click-to-reload-page') + '</a>',
	            {
	              ttl: -1,
	              enableHtml: true
	            }
	          );
	          break;
	        default:
	          if (error && error.config && error.config.url === config.apiBase + "/files/startpage_300") {
	            break;
	          }
	          
	          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
	            $state.get('root.company.error').error = error;
	            $state.go('root.company.error', {}, { location: false });
	          } else {
	            $state.get('error').error = error;
	            $state.go('error', {}, { location: false });
	          }
	      }
	      throw error;
	    });
	
	    var keyMap = 'https://maps.googleapis.com/maps/api/js?libraries=places&key='+config.keyMap;
	    var domElem = '<script src="'+keyMap+'"></script>';
	    angular.element('html head').append(domElem);
	    
	    var clientId = 'https://apis.google.com/js/client:platform.js?onload=start';
	    var domElem2 = '<script src="'+clientId+'"></script><script>function start() {gapi.load("auth2", function() {auth2 = gapi.auth2.init({client_id: "'+config.clienID+'", fetch_basic_profile: true, scope: "profile"});});}</script>';
	    angular.element('html head').append(domElem2);
	
	    if(window["WebSocket"]) {
	      var updateSocket = null;
	      var reconnecting = null;
	
	      var createWebsocket = function(userId) {
	        if(updateSocket) {
	          updateSocket.close();
	        }
	
	        updateSocket = new WebSocket(config.apiBase.replace("http://", "ws://").replace("https://", "wss://") + "/webapp-updates?userId="+userId);
	
	        updateSocket.onerror = function() {
	          if(window.console) {
	            window.console.log('Websocket error:', arguments);
	          }
	        };
	
	        updateSocket.onclose = function() {
	          if(!reconnecting) {
	            reconnecting = setTimeout(function() {
	              reconnecting = null;
	              createWebsocket(userId);
	            }, 5000);
	          }
	        };
	        updateSocket.onmessage = function(data) {
	          var message = angular.fromJson(data.data);
	          if (message) {
	            if(message.notification) {
	              $rootScope.$broadcast('notification', message.notification);
	            }
	            if(message.event && (message.event.name === 'EDITTING' || message.event.name === 'END_EDIT')) {
	              $rootScope.$broadcast('edittingObject', message.event);
	            }
	            if(message.event === 'RELOAD_DASHBOARD') {
	              $rootScope.$broadcast('eventReloadDashboard', message.event);
	            } if(message.event === 'SERVICE_TIMESTAMP') {
	              $rootScope.$broadcast('eventServiceTimestamp', message);
	            }
	
	            if (message.event === 'SEND_ACL') {
	              $rootScope.$broadcast('eventModifyPermissions', message.acls);
	            }
	            if (message.event === 'SEND_READ_NOTIFICATION') {
	              $rootScope.$broadcast('eventReadNotification');
	            }
	          }
	        };
	      };
	
	      if(window.localStorage && window.localStorage.userId) {
	        currentUserService.get().then(function(user) {
	          createWebsocket(user.id);
	        });
	      }
	
	      $rootScope.$on('auth-login', function(e, args) {
	        createWebsocket(args.userId);
	      });
	      $rootScope.$on('auth-logout', function() {
	        if(updateSocket) {
	          /* Hack to prevent reconnect */
	          reconnecting = true;
	          updateSocket.close();
	          reconnecting = false;
	        }
	      });
	    }
	
	    $rootScope.sendUpdateEdit = function(isEdit, currentUser, publication){
	      if(isEdit){
	        updateSocket.send(JSON.stringify(
	          { 
	            event: "EDITTING",
	            user: {
	                "id": currentUser.id,
	                "email": currentUser.email
	            },
	            object:{
	                "id": publication.id,
	                "name": publication.name
	            }
	          }
	        ));
	      }else{
	        updateSocket.send(JSON.stringify(
	          { 
	            event: "END_EDIT",
	            user: {
	                "id": currentUser.id,
	                "email": currentUser.email
	            },
	            object:{
	                "id": publication.id,
	                "name": publication.name
	            }
	          }
	        ));
	      }
	    };
	
	    $rootScope.trustAsHtml = function(string) {
	      return $sce.trustAsHtml(string);
	    };
	  }]);
	
	__webpack_require__(272);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(232);
	__webpack_require__(253);
	__webpack_require__(236);
	__webpack_require__(255);
	__webpack_require__(246);
	__webpack_require__(242);
	__webpack_require__(258);
	__webpack_require__(265);
	__webpack_require__(247);
	__webpack_require__(436);
	__webpack_require__(18);
	__webpack_require__(434);
	__webpack_require__(243);
	__webpack_require__(377);
	__webpack_require__(392);
	__webpack_require__(354);
	__webpack_require__(311);
	__webpack_require__(68);
	__webpack_require__(275);
	__webpack_require__(433);
	__webpack_require__(429);
	__webpack_require__(237);
	__webpack_require__(244);
	__webpack_require__(240);
	__webpack_require__(249);
	__webpack_require__(252);
	__webpack_require__(267);
	__webpack_require__(260);
	__webpack_require__(269);
	__webpack_require__(239);
	__webpack_require__(235);
	__webpack_require__(270);
	__webpack_require__(257);
	__webpack_require__(261);
	__webpack_require__(245);
	__webpack_require__(251);
	__webpack_require__(248);
	__webpack_require__(266);
	__webpack_require__(264);
	__webpack_require__(238);
	__webpack_require__(271);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(529)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.1.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-04-28T16:01Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//
	
	var arr = [];
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		version = "2.1.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isPlainObject: function( obj ) {
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf("use strict") === 1 ) {
					script = document.createElement("script");
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;
	
			while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var matched = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}
	
			return matched;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter(function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.unique( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// Flag to know if list is currently firing
			firing,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// We once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[0], key ) : emptyGet;
	};
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	function Data() {
		// Support: Android<4,
		// Old WebKit does not have Object.preventExtensions/freeze method,
		// return new empty object instead with no [[set]] accessor
		Object.defineProperty( this.cache = {}, 0, {
			get: function() {
				return {};
			}
		});
	
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	Data.accepts = jQuery.acceptData;
	
	Data.prototype = {
		key: function( owner ) {
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return the key for a frozen object.
			if ( !Data.accepts( owner ) ) {
				return 0;
			}
	
			var descriptor = {},
				// Check if the owner object already has a cache key
				unlock = owner[ this.expando ];
	
			// If not, create one
			if ( !unlock ) {
				unlock = Data.uid++;
	
				// Secure it in a non-enumerable, non-writable property
				try {
					descriptor[ this.expando ] = { value: unlock };
					Object.defineProperties( owner, descriptor );
	
				// Support: Android<4
				// Fallback to a less secure definition
				} catch ( e ) {
					descriptor[ this.expando ] = unlock;
					jQuery.extend( owner, descriptor );
				}
			}
	
			// Ensure the cache object
			if ( !this.cache[ unlock ] ) {
				this.cache[ unlock ] = {};
			}
	
			return unlock;
		},
		set: function( owner, data, value ) {
			var prop,
				// There may be an unlock assigned to this node,
				// if there is no entry for this "owner", create one inline
				// and set the unlock as though an owner entry had always existed
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
				// Fresh assignments by object are shallow copied
				if ( jQuery.isEmptyObject( cache ) ) {
					jQuery.extend( this.cache[ unlock ], data );
				// Otherwise, copy the properties one-by-one to the cache object
				} else {
					for ( prop in data ) {
						cache[ prop ] = data[ prop ];
					}
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			// Either a valid cache is found, or will be created.
			// New caches will be created and the unlock returned,
			// allowing direct access to the newly created
			// empty data object. A valid owner object must be provided.
			var cache = this.cache[ this.key( owner ) ];
	
			return key === undefined ?
				cache : cache[ key ];
		},
		access: function( owner, key, value ) {
			var stored;
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					((key && typeof key === "string") && value === undefined) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase(key) );
			}
	
			// [*]When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			if ( key === undefined ) {
				this.cache[ unlock ] = {};
	
			} else {
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
		},
		hasData: function( owner ) {
			return !jQuery.isEmptyObject(
				this.cache[ owner[ this.expando ] ] || {}
			);
		},
		discard: function( owner ) {
			if ( owner[ this.expando ] ) {
				delete this.cache[ owner[ this.expando ] ];
			}
		}
	};
	var data_priv = new Data();
	
	var data_user = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				data_user.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend({
		hasData: function( elem ) {
			return data_user.hasData( elem ) || data_priv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return data_user.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			data_user.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to data_priv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return data_priv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			data_priv.remove( elem, name );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = data_user.get( elem );
	
					if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						data_priv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					data_user.set( this, key );
				});
			}
	
			return access( this, function( value ) {
				var data,
					camelKey = jQuery.camelCase( key );
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
					// Attempt to get data from the cache
					// with the key as-is
					data = data_user.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to get data from the cache
					// with the key camelized
					data = data_user.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each(function() {
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = data_user.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					data_user.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf("-") !== -1 && data !== undefined ) {
						data_user.set( this, key, value );
					}
				});
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each(function() {
				data_user.remove( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = data_priv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = data_priv.access( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return data_priv.get( elem, key ) || data_priv.access( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					data_priv.remove( elem, [ type + "queue", key ] );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = data_priv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;
	
	
	
	support.focusinBubbles = "onfocusin" in window;
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.hasData( elem ) && data_priv.get( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
				data_priv.remove( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.disabled !== true || event.type !== "click" ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && e.preventDefault ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && e.stopPropagation ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// Support: Firefox, Chrome, Safari
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						data_priv.remove( doc, fix );
	
					} else {
						data_priv.access( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
	
			// Support: IE9
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			_default: [ 0, "", "" ]
		};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute("type");
		}
	
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			data_priv.set(
				elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( data_priv.hasData( src ) ) {
			pdataOld = data_priv.access( src );
			pdataCur = data_priv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( data_user.hasData( src ) ) {
			udataOld = data_user.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			data_user.set( dest, udataCur );
		}
	}
	
	function getAll( context, tag ) {
		var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
				context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var elem, tmp, tag, wrap, contains, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];
	
						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			return fragment;
		},
	
		cleanData: function( elems ) {
			var data, elem, type, key,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
				if ( jQuery.acceptData( elem ) ) {
					key = elem[ data_priv.expando ];
	
					if ( key && (data = data_priv.cache[ key ]) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
						if ( data_priv.cache[ key ] ) {
							// Discard any remaining `private` data
							delete data_priv.cache[ key ];
						}
					}
				}
				// Discard any remaining `user` data
				delete data_user.cache[ elem[ data_user.expando ] ];
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each(function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					});
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[ 0 ],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								// Support: QtWebKit
								// jQuery.merge because push.apply(_, arraylike) throws
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[ i ], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
								}
							}
						}
					}
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optimization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
		}
	
		if ( computed ) {
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// Support: iOS < 6
			// A tribute to the "awesome hack by Dean Edwards"
			// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
			// Support: IE
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		var pixelPositionVal, boxSizingReliableVal,
			docElem = document.documentElement,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
			"position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computePixelPositionAndBoxSizingReliable() {
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
			div.innerHTML = "";
			docElem.appendChild( container );
	
			var divStyle = window.getComputedStyle( div, null );
			pixelPositionVal = divStyle.top !== "1%";
			boxSizingReliableVal = divStyle.width === "4px";
	
			docElem.removeChild( container );
		}
	
		// Support: node.js jsdom
		// Don't assume that getComputedStyle is a property of the global object
		if ( window.getComputedStyle ) {
			jQuery.extend( support, {
				pixelPosition: function() {
	
					// This test is executed only once but we still do memoizing
					// since we can use the boxSizingReliable pre-computing.
					// No need to check if the test was already performed, though.
					computePixelPositionAndBoxSizingReliable();
					return pixelPositionVal;
				},
				boxSizingReliable: function() {
					if ( boxSizingReliableVal == null ) {
						computePixelPositionAndBoxSizingReliable();
					}
					return boxSizingReliableVal;
				},
				reliableMarginRight: function() {
	
					// Support: Android 2.3
					// Check if div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container. (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					// This support function is only executed once so no memoizing is needed.
					var ret,
						marginDiv = div.appendChild( document.createElement( "div" ) );
	
					// Reset CSS: box-sizing; display; margin; border; padding
					marginDiv.style.cssText = div.style.cssText =
						// Support: Firefox<29, Android 2.3
						// Vendor-prefix box-sizing
						"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
						"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					marginDiv.style.marginRight = marginDiv.style.width = "0";
					div.style.width = "1px";
					docElem.appendChild( container );
	
					ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );
	
					docElem.removeChild( container );
					div.removeChild( marginDiv );
	
					return ret;
				}
			});
		}
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
		// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = data_priv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend({
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
					style[ name ] = value;
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*.
						// Use string for doubling so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur(),
					// break the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = data_priv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// Ensure the complete handler is called before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = data_priv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
	
				data_priv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || data_priv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = data_priv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = data_priv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	});
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each(function() {
				delete this[ jQuery.propFix[ name ] || name ];
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
						elem.tabIndex :
						-1;
				}
			}
		}
	});
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = arguments.length === 0 || typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// Toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						data_priv.set( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// Handle most common string cases
						ret.replace(rreturn, "") :
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE6-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = window.location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType[0] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
				// URL without anti-cache param
				cacheURL,
				// Response headers
				responseHeadersString,
				responseHeaders,
				// timeout handle
				timeoutTimer,
				// Cross-domain detection vars
				parts,
				// To know if global events are to be dispatched
				fireGlobals,
				// Loop variable
				i,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new XMLHttpRequest();
		} catch( e ) {}
	};
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSuccessStatus = {
			// file protocol always yields status code 0, assume 200
			0: 200,
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]();
			}
		});
	}
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport(function( options ) {
		var callback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;
	
					xhr.open( options.type, options.url, options.async, options.username, options.password );
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								delete xhrCallbacks[ id ];
								callback = xhr.onload = xhr.onerror = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
									complete(
										// file: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
										// Support: IE9
										// Accessing binary-data responseText throws an exception
										// (#11426)
										typeof xhr.responseText === "string" ? {
											text: xhr.responseText
										} : undefined,
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					xhr.onerror = callback("error");
	
					// Create the abort callback
					callback = xhrCallbacks[ id ] = callback("abort");
	
					try {
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery("<script>").prop({
						async: true,
						charset: s.scriptCharset,
						src: s.url
					}).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf("auto") > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// Support: BlackBerry 5, iOS 3 (original iPhone)
			// If we don't have gBCR, just use 0,0 rather than error
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : window.pageXOffset,
						top ? val : window.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Support: Safari<7+, Chrome<37+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId', {companyId: '@id'}, {
	    'update': { method:'PUT' },
	    'queryTags': {
	      url: config.apiBase + '/companies/:companyId/tags',
	      method: 'GET',
	      isArray: true
	    },
	    'queryTagSuggestions': {
	      url: config.apiBase + '/companies/:companyId/tag-suggestions',
	      method: 'GET',
	      isArray: true
	    },
	    'updateTagSuggestions': {
	      url: config.apiBase + '/companies/:companyId/tag-suggestions',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryPriorities': {
	      url: config.apiBase + '/companies/:companyId/priorities',
	      method: 'GET',
	      isArray: true
	    },
	    'updatePriorities': {
	      url: config.apiBase + '/companies/:companyId/priorities',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryTaskStatuses': {
	      url: config.apiBase + '/companies/:companyId/reminder-status',
	      method: 'GET',
	      isArray: true
	    },
	    'updateTaskStatuses': {
	      url: config.apiBase + '/companies/:companyId/reminder-status',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryTaskTypes': {
	      url: config.apiBase + '/companies/:companyId/reminder-type',
	      method: 'GET',
	      isArray: true
	    },
	    'updateTaskTypes': {
	      url: config.apiBase + '/companies/:companyId/reminder-type',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryCustomerStatus': {
	      url: config.apiBase + '/companies/:companyId/customerStatuses',
	      method: 'GET',
	      isArray: true
	    },
	    'queryCustomerCategory': {
	      url: config.apiBase + '/companies/:companyId/customers/categories',
	      method: 'GET',
	      isArray: true
	    },
	    'updateCustomerStatuses': {
	      url: config.apiBase + '/companies/:companyId/customerStatuses',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryOrderStatuses': {
	      url: config.apiBase + '/companies/:companyId/order-status',
	      method: 'GET',
	      isArray: true
	    },
	    'updateOrderStatus': {
	      url: config.apiBase + '/companies/:companyId/order-status',
	      method: 'PUT',
	      isArray: true
	    },
	    'queryNotices':  {
	      url: config.apiBase + '/notices',
	      method: 'GET',
	      isArray: true
	    },
	    'queryUnits': {
	      url: config.apiBase + '/companies/:companyId/units',
	      method: 'GET',
	      isArray: true
	    },
	    'updateUnits': {
	      url: config.apiBase + '/companies/:companyId/units',
	      method: 'POST'
	    },
	    'queryPdfTemplates': {
	      url: config.apiBase + '/companies/:companyId/pdf-templates',
	      method: 'GET',
	      isArray: true
	    },
	    'queryFeed': {
	      url: config.apiBase + '/companies/:companyId/feed',
	      method: 'GET',
	      isArray: true
	    },
	    'getLoginAnalytics': {
	      url: config.apiBase + '/companies/:companyId/third-logins',
	      method: 'GET',
	      isArray: true
	    },
	    'updateThirdPartyLogin': {
	      url: config.apiBase + '/companies/:companyId/third-logins/:id',
	      method: 'PUT',
	      isArray: false
	    },
	    'createThirdPartyLogin': {
	      url: config.apiBase + '/companies/:companyId/third-logins',
	      method: 'POST',
	      isArray: false
	    },
	    'createReportAnalyticsPdf2': {
	      url: config.apiBase + '/companies/:companyId/report-analytics/pdf2',
	      method: 'POST'
	    },
	    'loginAnalytic': {
	      url: config.apiBase + '/companies/:companyId/report-analytics/login',
	      method: 'POST'
	    },
	    'updateAnalytic': {
	      url: config.apiBase + '/companies/:companyId/third-logins/:loginId',
	      method: 'PUT'
	    },
	    'deleteLoginAnalytic': {
	      url: config.apiBase + '/companies/:companyId/third-logins/:loginId',
	      method: 'DELETE'
	    }
	  });
	}
	
	function CompanyCustomerService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/services/:serviceId', {}, {
	    'update': {
	      url: config.apiBase + '/companies/:companyId/services/:serviceId',
	      method: 'PUT'
	    },
	    'queryComments': {
	      url: config.apiBase + '/companies/:companyId/services/:serviceId/comments',
	      method: 'GET',
	      isArray: true
	    },
	    'createComment': {
	      url: config.apiBase + '/companies/:companyId/services/:serviceId/comments',
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyService', ['$resource', 'config', CompanyService])
	  .factory('CompanyCustomerService', ['$resource', 'config', CompanyCustomerService]);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId', {companyId: '@companyId', publicationId: '@id'}, {
	    'update': {
	      method: 'PUT'
	    },
	    'updateMassEdit': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/publications/mass-edit'
	    },
	    'updateCertifyDoc': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/verify'
	    },
	    'queryDrafts': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/drafts',
	      isArray: true
	    },
	    'lockFileUpload': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/upload-lock'
	    },
	    'unlockFileUpload': {
	      method: 'DELETE',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/upload-lock'
	    },
	    "queryWatched": {
	      method: "GET",
	      isArray: true,
	      url: config.apiBase + '/companies/:companyId/users/:userId/watched-publications'
	    },
	    "deleteArchives": {
	      method: "DELETE",
	      url: config.apiBase + '/companies/:companyId/publications/archives'
	    },
	    'createFlowVerify': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies'
	    },
	    'updateFlowVerify': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies/:publicationsVerifyId'
	    },
	    'queryFlowVerifies': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/flow-verifies',
	      isArray: true
	    },
	    'getFlowVerify': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/flow-verifies/:publicationsVerifyId',
	    },
	    "getPostLastest": {
	      method: "GET",
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/posts/lastest',
	      isArray: true
	    },
	    'copyObject':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/copy',
	      method: 'POST'
	    },
	    'createCard': {
	      url:  config.apiBase + '/companies/:companyId/publications/:publicationId/convert',
	      method: 'POST',
	      params: {"target" : "@target"},
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationService', ['$resource', 'config', CompanyPublicationService]);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	var LIMIT = 20;
	
	function createdAtIs(prop) {
	  return function(a) {
	    a.createdAt = a[prop];
	    
	    return a;
	  };
	}
	
	function identity(a) {
	  return a;
	}
	
	function CompanyPublicationActivityFactory(config, $q, $http) {
	  function Source(uri, type, parse) {
	    this._uri       = uri;
	    this._type      = type;
	    this._parse     = typeof parse === "function" ? parse : identity;
	    this._data      = [];
	    this._exhausted = false;
	    this._loading   = null;
	    this._setType   = function(a) {
	      a.activityType = type;
	
	      return a;
	    };
	  }
	  
	  Source.prototype.next = function(offset) {
	    var self = this;
	    
	    if(this._loading) {
	      /* Wait until current loading is done, then try again */
	      return this._loading.then(function() {
	        return self.next(offset, offset + 1);
	      });
	    }
	
	    if(offset + 1 < this._data.length || this._exhausted) {
	      /* Already cached or nothing more to fetch */
	      return this._data.slice(offset, offset + 1);
	    }
	    
	    var uri = this._uri + (this._uri.indexOf("?") === -1 ? "?" : "&" ) + "offset=" + this._data.length + "&limit=" + (LIMIT + 1);
	
	    this._loading = $http({
	      method: "GET",
	      url:    config.apiBase + uri,
	    }).then(function(response) {
	      /* We got fewer items than we asked for, source is exhausted */
	      if(response.data.length < LIMIT + 1) {
	        self._exhausted = true;
	      }
	
	      self._data    = self._data.concat(response.data.map(self._parse).map(self._setType));
	      self._loading = null;
	      
	      return self._data.slice(offset, offset + 1);
	    });
	    
	    return this._loading;
	  };
	  
	  Source.prototype.isExhausted = function() {
	    return this._exhausted;
	  };
	  
	  Source.prototype.numLoaded = function() {
	    return this._data.length;
	  };
	  
	  Source.prototype.getType = function() {
	    return this._type;
	  };
	  
	  Source.prototype.prependData = function(data) {
	    this._data = data.map(this._setType).concat(this._data);
	  };
	
	  function CompanyPublicationActivity(companyId, publicationId, q) {
	    this._sources = [
	      new Source("/companies/" + companyId + "/comments?objectId=" + publicationId + (q ? ("&text=" + q + "&title=" + q) : ""), "COMMENT"),
	      new Source("/companies/" + companyId + "/feed?objectId=" + publicationId, "AUDITLOG", createdAtIs("performedAt"))
	    ];
	  }
	  
	  CompanyPublicationActivity.prototype.prependDataTo = function(type /* , ... */) {
	    var source = null;
	    
	    this._sources.forEach(function(s) {
	      if(s.getType() === type) {
	        source = s;
	      }
	    });
	
	    if(source) {
	      source.prependData.call(source, Array.prototype.slice.call(arguments, 1));
	
	      return true;
	    }
	    else {
	      return false;
	    }
	  };
	
	  CompanyPublicationActivity.prototype.next = function(offset, limit, types) {
	    offset = typeof offset === "number" ? offset : 0;
	    limit  = typeof limit  === "number" ? limit  : LIMIT;
	    types  = Array.isArray(types) && types.length > 0 ? types : this._sources.map(function(s) { return s.getType(); });
	
	    var list    = [];
	    var d       = $q.defer();
	    var sources = this._sources.filter(function(s) {
	      return types.indexOf(s.getType()) !== -1;
	    }).map(function(s) {
	      return {
	        offset : 0,
	        source:  s
	      };
	    });
	
	    /**
	     * Unless we have enough data or exhausted all sources, take
	     * the newest item from any of the sources and increment the
	     * offset counter for that source and repeat.
	     */
	    function consume() {
	      if(list.length === limit + offset || sources.every(function(v) { return v.source.numLoaded() === v.offset && v.source.isExhausted(); })) {
	        d.resolve(list.slice(offset));
	
	        return;
	      }
	      
	      /* Read one item off all sources */
	      $q.all(sources.map(function(s) {
	        return s.source.next(s.offset);
	      })).then(function(datas) {
	        var min      = null;
	        var selected = null;
	
	        for(var i = 0; i < datas.length; i++) {
	          if(datas[i].length > 0 && (min === null || new Date(datas[i][0].createdAt) > new Date(min.createdAt))) {
	            min      = datas[i][0];
	            selected = i;
	          }
	        }
	        
	        if( ! min) {
	          d.resolve(list.slice(offset));
	          
	          /* All are consumed */
	          return;
	        }
	        
	        /* We got the most current event out of all datas,
	         * consume that and increase the offset for the source. */
	        list.push(min);
	        
	        sources[selected].offset++;
	
	        consume();
	      }, function(e) {
	        d.reject(e);
	      });
	    }
	    
	    consume();
	    
	    return d.promise;
	  };
	
	  return CompanyPublicationActivity;
	}
	
	angular.module("dokiv")
	  .factory("CompanyPublicationActivity", ["config", "$q", "$http", CompanyPublicationActivityFactory]);


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGroupService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId', {type: 'HIDDEN'}, {
	    'update': { method: 'PUT' },
	    'getMyPortals': {
	    	method: 'GET',
	    	url: config.apiBase + '/companies/:companyId/groups?userId=:userId',
	    	isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyGroupService', ['$resource', 'config', CompanyGroupService]);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var PAGESIZE = 20;
	
	__webpack_require__(6);
	__webpack_require__(42);
	__webpack_require__(19);
	
	function PublicationActivity(CompanyPublicationActivity, CompanyCommentsService, CompanyPublicationActivityTranslator, $stateParams) {
	  return {
	    restrict:    "A",
	    templateUrl: "partials/company/publications/activity.html",
	    scope: {
	      source:   "=publicationActivity",
	      user:     "=user",
	      types:    "=?types"
	    },
	    link: function($scope) {
	      $scope.type       = {type: "comment"};
	      $scope.newComment = "";
	      $scope.loading    = false;
	      $scope.page       = 0;
	      $scope.activity   = [];
	      $scope.PAGESIZE   = PAGESIZE;
	
	      if($scope.types && $scope.types[0] === 'ACTIVITY'){
	        $scope.type.type = '';
	        $scope.types = [];
	      }
	      
	      $scope.loadData = function loadData() {
	        $scope.loading = true;
	        $scope.page    = $scope.page > 0 ? $scope.page : 0;
	
	        /* TODO: That toUpperCase() should be removed
	         * and all constants should be uppercase instead.
	         */
	        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, $scope.type.type ? [$scope.type.type.toUpperCase()] : $scope.types).then(function(activity) {
	          $scope.hasNextPage = activity.length > PAGESIZE;
	          $scope.loading     = false;
	          $scope.activity    = activity.map(CompanyPublicationActivityTranslator);
	        });
	      };
	      
	      if( ! $scope.types) {
	        $scope.types = [];
	      }
	
	      $scope.$on('notification', function(){
	        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	        $scope.page = 0;
	        $scope.loading = true;
	        $scope.loadData();
	      });
	      
	      $scope.setFilter = function setFilter(type) {
	        $scope.type.type = type;
	        $scope.page      = 0;
	
	        $scope.loadData();
	      };
	
	      $scope.addComment = function addComment(newComment, parentId) {
	        if( ! newComment) {
	          return false;
	        }
	        var c = {
	          activityType: "COMMENT",
	          user:         $scope.user,
	          type:         "comment",
	          pageSize: 10
	        };
	        
	        $scope.loading = true;
	
	        var comment = {
	          text: newComment, 
	          group: null, 
	          objectRelative: {
	            id: $stateParams.publicationId
	          }, 
	          objectRelativeType: 'PUBLICATION', 
	          parentId: parentId || null
	        };
	
	        CompanyCommentsService.createComment({companyId: $stateParams.companyId}, comment, function(comment) {
	          $scope.loading = false;
	          c.id = comment.id;
	          c.text = comment.text;
	          c.createdAt = comment.createdAt;
	          c.createdBy = comment.createdBy;
	          if(parentId){
	            angular.forEach($scope.activity, function(item){
	              if(item.id === parentId){
	                if(!item.commentChild){
	                  item.commentChild = [];
	                }
	                item.commentChild.push(c);
	                if(item.commentChild.length >= item.pageSize){
	                  item.pageSize += 10;
	                }
	              }
	            });
	          }else{
	            $scope.activity.unshift(c);
	            $scope.source.prependDataTo("COMMENT", c);
	            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
	          }
	        });
	
	        return false;
	      };
	      
	      $scope.loadData();
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("publicationActivity", ["CompanyPublicationActivity", "CompanyCommentsService", "CompanyPublicationActivityTranslator", "$stateParams", PublicationActivity]);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationFileService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'getFileToken': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/tokens'
	    },
	    'getPreview': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/preview'
	    },
	    'getLastFile': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/last-file'
	    },
	    'getShowFile': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/show-files/:fileId'
	    },
	    'rotateImage':  {
	      method: 'PATCH',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/rotate'
	    },
	    'fileContent': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/content'
	    },
	    'updateSearchable': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/search-able'
	    },
	    'updateFileContent': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/content'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationFileService', ['$resource', 'config', CompanyPublicationFileService]);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyChecklistService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/checklist/:checklistID', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    },
	    'queryConnected': {
	      url: config.apiBase + '/companies/:companyId/checklist/:checklistID/connecteds',
	      method: 'GET',
	      isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyChecklistService', ['$resource', 'config', CompanyChecklistService]);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyUserService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/users/:userId', {}, {
	    'update': { method:'PUT' },
	    'queryUsersInvited': {
	      url: config.apiBase + '/companies/:companyId/users/invited',
	      method: 'GET',
	      isArray: true
	    },
	    'queryInactive': {
	      url: config.apiBase + '/companies/:companyId/users?active=false&all=true&limit=1000',
	      method: 'GET',
	      isArray: true
	    },
	    'removeInvited': {
	      url: config.apiBase + '/companies/:companyId/users/delete-invited',
	      method: 'DELETE'
	    },
	    'queryUserTags': {
	      url: config.apiBase + '/companies/:companyId/users/:userId/tags',
	      method: 'GET',
	      isArray: true
	    },
	    'createUserTag': {
	      url: config.apiBase + '/companies/:companyId/users/:userId/tags',
	      method: 'POST'
	    },
	    'deleteUserTag': {
	      url: config.apiBase + '/companies/:companyId/users/:userId/tags/:tagId',
	      method: 'DELETE',
	      isArray: true
	    },
	    'updateMassEdit': {
	      url: config.apiBase + '/companies/:companyId/users/massedit',
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyUserService', ['$resource', 'config', CompanyUserService]);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationOrderService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'delete': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId',
	      method: 'DELETE'
	    },
	    'queryPlants': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants',
	      method: 'GET',
	      isArray: true
	    },
	    'addPlant': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants',
	      method: 'POST'
	    },
	    'removePlant': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants/:id',
	      method: 'DELETE'
	    },
	    'queryUsers': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users',
	      method: 'GET',
	      isArray: true
	    },
	    'addUser': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users',
	      method: 'POST'
	    },
	    'removeUser': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users/:id',
	      method: 'DELETE'
	    },
	    'queryProjects': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects',
	      method: 'GET',
	      isArray: true
	    },
	    'addProject': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects',
	      method: 'POST'
	    },
	    'removeProject': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects/:id',
	      method: 'DELETE'
	    },
	    'queryDeliveries': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries',
	      method: 'GET',
	      isArray: true
	    },
	    'updateDelivery': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries/:deliveryId',
	      method: 'PUT'
	    },
	    'download': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries?export=true',
	      method: 'GET',
	      transformResponse: function(data, headers) {
	        var getFileNameFromHeader = function(header) {
	          if (!header) {
	            return null;
	          }
	          var result = header.split(";")[1].trim().split("=")[1];
	          return result.replace(/"/g, '');
	        };
	
	        var excel = null;
	        if (data) {
	          excel = new Blob([data], {
	            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	          });
	        }
	        var fileName = getFileNameFromHeader(headers('content-disposition'));
	        var result = {
	          blob: excel,
	          fileName: fileName
	        };
	        return {
	          response: result
	        };
	      }
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationOrderService', ['$resource', 'config', CompanyPublicationOrderService]);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCategoryService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/categories/:categoryId', {companyId: '@companyId', categoryId: '@id'}, {
	    'update': { method:'PUT' }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyCategoryService', ['$resource', 'config', CompanyCategoryService]);


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGroupUserService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId/users/:userId');
	}
	
	angular.module('dokiv')
	  .factory('CompanyGroupUserService', ['$resource', 'config', CompanyGroupUserService]);
	


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCustomersService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/customers/:customerId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    },
	    'queryFiles': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/files',
	      isArray: true
	    },
	    'uploadFiles': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/files'
	    },
	    'deleteFile': {
	      method: 'DELETE',
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/files/:fileId'
	    },
	    'fileToken': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/files/:fileId/tokens'
	    },
	    'queryAddresses': {
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/address',
	      method: 'GET',
	      isArray: true
	    },
	    'updateAddress': {
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/address/:addressId',
	      method: 'POST'
	    },
	    'deleteAddress': {
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/address/:addressId',
	      method: 'DELETE'
	    },
	    'addObject': {
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/objects',
	      method: 'POST'
	    },
	    'removeObject': {
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/objects/:objectId',
	      method: 'DELETE'
	    },
	    'queryUnits': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/customers/:customerId/units',
	      isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyCustomersService', ['$resource', 'config', CompanyCustomersService]);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyUserRoleService.$inject = ['config', '$resource'];
	function CompanyUserRoleService(config, $resource) {
	  return $resource(config.apiBase + '/companies/:companyId/user-roles/:roleId' , {}, {
	    "update": {
	      method: 'PUT'
	    },
	    "queryTemplates":  {
	      url: config.apiBase + '/companies/:companyId/templates',
	      method: 'GET',
	      isArray: true
	    },
	    "addMember": {
	      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users',
	      method: 'POST'
	    },
	    "queryUsers":  {
	      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users',
	      method: 'GET',
	      isArray: true
	    },
	    "removeMember": {
	      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/users/:userId',
	      method: 'DELETE'
	    },
	    "saveTextbox": {
	      url: config.apiBase + '/companies/:companyId/user-roles/:roleId',
	      method: 'POST',
	      transformRequest:  function(data) {
	        var fd = new FormData();
	        angular.forEach(data, function(value, key) {
	            fd.append(key, value);
	        });
	        return fd;
	      },
	      headers: {"Content-Type": undefined, enctype:'multipart/form-data'}
	    },
	    "copyUserRole": {
	      url: config.apiBase + '/companies/:companyId/user-roles/:roleId/copy',
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyUserRoleService', CompanyUserRoleService);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(21);
	__webpack_require__(67);
	
	function CurrentUserService(
	  $q,
	  UserService,
	  $window,
	  CompanyUserPermissionService
	) {
	  var currentUser;
	  return {
	    get: function() {
	      var deferred = $q.defer();
	      if (!currentUser || currentUser.id !== $window.localStorage.userId) {
	        UserService.get({userId: $window.localStorage.userId}, function(user) {
	          deferred.resolve(user);
	          currentUser = user;
	        });
	      } else {
	        deferred.resolve(currentUser);
	      }
	
	      return deferred.promise;
	    },
	    destroy: function() {
	      currentUser = null;
	    },
	    getPermissions: function(companyId) {
	      return this.get().then(function(user) {
	        return CompanyUserPermissionService.query({companyId: companyId, userId: user.id}).$promise;
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .factory('CurrentUserService', [
	    '$q',
	    'UserService',
	    '$window',
	    'CompanyUserPermissionService',
	    CurrentUserService
	  ]);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCommentsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/visible-comments', {}, {
	    "queryComments": {
	      method: "GET",
	      isArray: true,
	      url: config.apiBase + '/companies/:companyId/comments'
	    },
	    'createComment': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/comments'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyCommentsService', ['$resource', 'config', CompanyCommentsService]);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyProductsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/products/:productId', {}, {
	    'update':  {
	      method: 'PUT'
	    },
	    'updatePrice': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/products/:productId/prices'
	    },
	    'priceDelete': {
	      method: 'delete',
	      url: config.apiBase + '/companies/:companyId/products/:productId/prices/:priceId'
	    },
	    'priceListUpdate': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/products/pricelists'
	    },
	    'priceListQuery': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/products/pricelists',
	      isArray: true
	    },
	    'priceListDelete': {
	      method: 'DELETE',
	      url: config.apiBase + '/companies/:companyId/products/pricelists/:priceListId'
	    },
	    'priceListDetail': {
	      method: 'GET',
	      url: config.apiBase + '/companies/:companyId/products/pricelists/:priceListId',
	      isArray: false
	    },
	    'updateImage': {
	      method: 'PUT',
	      url: config.apiBase + '/companies/:companyId/products/:productId/image/:imageId'
	    },
	    'ImageDelete': {
	      method: 'DELETE',
	      url: config.apiBase + '/companies/:companyId/products/:productId/image/:imageId'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyProductsService', ['$resource', 'config', CompanyProductsService]);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	function UserService($resource, config) {
	  return $resource(config.apiBase + '/users/:userId', {}, {
	    'update': { method:'PUT' },
	    'createInvite': {
	      method:  'POST',
	      isArray: false,
	      url:     config.apiBase + '/users/invite'
	    },
	    'createAliasEmail': {
	      method:  'POST',
	      isArray: false,
	      url:     config.apiBase + '/users/:userId/alias'
	    },
	    'setMainEmail': {
	      method:  'GET',
	      url:     config.apiBase + '/users/:userId/alias/:aliasId/main'
	    },
	    'getAliasEmail': {
	      method:  'GET',
	      isArray: true,
	      url:     config.apiBase + '/users/:userId/alias'
	    },
	    'getActivateAlias': {
	      method:  'GET',
	      url:     config.apiBase + '/users/activate-alias'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('UserService', ['$resource', 'config', UserService]);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Error = __webpack_require__(506);
	var $EvalError = __webpack_require__(505);
	var $RangeError = __webpack_require__(507);
	var $ReferenceError = __webpack_require__(508);
	var $SyntaxError = __webpack_require__(75);
	var $TypeError = __webpack_require__(32);
	var $URIError = __webpack_require__(509);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(514)();
	var hasProto = __webpack_require__(513)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(49);
	var hasOwn = __webpack_require__(515);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyInfoService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/info', {}, {
	    'update': { method:'PUT' }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyInfoService', ['$resource', 'config', CompanyInfoService]);
	


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyMessageService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/posts/:messageId', {}, {
	    "update": {
	      method: "PUT"
	    },
	    "delete": {
	      method: "DELETE"
	    },
	    "sendMail": {
	      method: "POST",
	      url: config.apiBase + '/companies/:companyId/posts/:messageId/send-mail'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyMessageService', ['$resource', 'config', CompanyMessageService]);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	function FormAppSubmitGroupUserService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId/users/:userId');
	}
	
	angular.module('dokiv')
	  .factory('FormAppSubmitGroupUserService', ['$resource', 'config', FormAppSubmitGroupUserService]);
	


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyPublicationMassEditCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$q',
	  'growl',
	  '$translate',
	  'CompanyCategoryService',
	  'CompanyPublicationWatcherService',
	  'CompanyUserService',
	  'CompanyPublicationService',
	  'priorities',
	  'groups',
	  'categories'
	];
	
	function CompanyPublicationMassEditCtrl(
	  $scope,
	  $stateParams,
	  $q,
	  growl,
	  $translate,
	  CompanyCategoryService,
	  CompanyPublicationWatcherService,
	  CompanyUserService,
	  CompanyPublicationService,
	  priorities,
	  groups,
	  categories) {
	
	  $scope.massEdit = {
	    "publications": $scope.publicationsMassEdit,
	    "status": "PUBLISHED",
	    "watchers": [],
	    "priority": null,
	    "category": null,
	    "groups": [],
	    "removeWatchers": [],
	    "removeGroups": []
	  };
	
	  var nonWatchersPromise;
	  var nonRemoveWatchersPromise;
	  $scope.nonWatchers = [];
	  $scope.watchers = [];
	  $scope.nonRemoveWatchers = [];
	  $scope.removeWatchers = [];
	  $scope.groups = groups;
	  $scope.priorities = priorities;
	  $scope.categories = categories;
	  $scope.groupHidden = null;
	  $scope.portals = [];
	  $scope.removePortals = [];
	
	  $scope.updateNonWatchers = function(filter) {
	    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !$scope.watchers.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    nonWatchersPromise = p;
	  };
	
	  $scope.addWatcher = function(watcher) {
	    $scope.watchers.push(watcher);
	    $scope.massEdit.watchers.push(watcher.id);
	    angular.element('#filterWatchers').val('');
	    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
	  };
	
	  $scope.deleteWatcher = function(watcher, removeWatcher) {
	    if(removeWatcher){
	      $scope.removeWatchers.splice($scope.removeWatchers.indexOf(watcher), 1);
	      $scope.massEdit.removeWatchers.splice($scope.massEdit.removeWatchers.indexOf(watcher.id), 1);
	    }else{
	      $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
	      $scope.massEdit.watchers.splice($scope.massEdit.watchers.indexOf(watcher.id), 1);
	    }
	  };
	
	  $scope.updateNonRemoveWatchers = function(filter) {
	    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !$scope.removeWatchers.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonRemoveWatchers) {
	      if(nonRemoveWatchersPromise === p) {
	        $scope.nonRemoveWatchers = nonRemoveWatchers;
	      }
	    });
	    nonRemoveWatchersPromise = p;
	  };
	
	  $scope.addRemoveWatcher = function(watcher) {
	    $scope.removeWatchers.push(watcher);
	    $scope.massEdit.removeWatchers.push(watcher.id);
	    angular.element('#filterRemoveWatchers').val('');
	    $scope.nonRemoveWatchers.splice($scope.nonRemoveWatchers.indexOf(watcher), 1);
	  };
	
	  $scope.savePublicationsMassEdit = function() {
	    if($scope.groupHidden !== null){
	      $scope.massEdit.groups.push($scope.groupHidden);
	    }
	    $q.all(
	      angular.forEach($scope.portals, function(value){
	        $scope.massEdit.groups.push(value.id);
	      })
	    ).then(function(){
	      $q.all(
	        angular.forEach($scope.removePortals, function(value){
	          $scope.massEdit.removeGroups.push(value.id);
	        })
	      ).then(function(){
	        CompanyPublicationService.updateMassEdit({companyId: $scope.companyId}, $scope.massEdit, function(){
	          growl.addSuccessMessage($translate.instant('publication.mass-edit-success'));
	          $scope.$hide();
	          angular.forEach($scope.$parent.$parent.publications, function(value){
	            value.selected = false;
	          });
	        }, function(){
	          growl.addErrorMessage($translate.instant('publication.mass-edit-failure'));
	        });
	      });
	    });
	  };
	
	}
	
	
	angular.module('dokiv')
	  .controller('CompanyPublicationMassEditCtrl', CompanyPublicationMassEditCtrl);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var PAGESIZE = 20;
	
	__webpack_require__(6);
	__webpack_require__(42);
	__webpack_require__(19);
	
	function WallActivity(CompanyPublicationActivity, CompanyCommentsService, CompanyPublicationActivityTranslator, $stateParams) {
	  return {
	    restrict:    "A",
	    templateUrl: "partials/company/publications/wall-activity.html",
	    scope: {
	      source:   "=wallActivity",
	      user:     "=user",
	    },
	    link: function($scope) {
	      $scope.newComment = "";
	      $scope.loading    = false;
	      $scope.page       = 0;
	      $scope.activity   = [];
	      $scope.PAGESIZE   = PAGESIZE;
	
	      $scope.loadData = function loadData() {
	        $scope.loading = true;
	        $scope.page    = $scope.page > 0 ? $scope.page : 0;
	        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, ['COMMENT']).then(function(activity) {
	          $scope.hasNextPage = activity.length > PAGESIZE;
	          $scope.loading     = false;
	          $scope.activity    = activity.map(CompanyPublicationActivityTranslator);
	        });
	      };
	
	      $scope.$on('notification', function(){
	        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	        $scope.page = 0;
	        $scope.loading = true;
	        $scope.loadData();
	      });
	
	      $scope.searchComments = function(filterText){
	        $scope.filterText = filterText;
	        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId, filterText);
	        $scope.page = 0;
	        $scope.loading = true;
	        $scope.loadData();
	      };
	
	      $scope.addComment = function addComment(newComment, parentId) {
	        if(!newComment.length) {
	          return false;
	        }
	        var c = {
	          activityType: "COMMENT",
	          user:         $scope.user,
	          type:         "comment",
	          pageSize: 10
	        };
	
	        $scope.loading = true;
	
	        var comment = {
	          text: newComment, 
	          group: null, 
	          objectRelative: {
	            id: $stateParams.publicationId
	          }, 
	          objectRelativeType: 'PUBLICATION', 
	          parentId: parentId || null
	        };
	
	        CompanyCommentsService.createComment({companyId: $stateParams.companyId}, comment, function(comment) {
	          $scope.loading = false;
	          c.id = comment.id;
	          c.text = comment.text;
	          c.createdAt = comment.createdAt;
	          c.createdBy = comment.createdBy;
	          if(parentId){
	            angular.forEach($scope.activity, function(item){
	              if(item.id === parentId){
	                if(!item.commentChild){
	                  item.commentChild = [];
	                }
	                item.commentChild.push(c);
	                if(item.commentChild.length >= item.pageSize){
	                  item.pageSize += 10;
	                }
	              }
	            });
	          }else{
	            $scope.activity.unshift(c);
	            $scope.source.prependDataTo("COMMENT", c);
	            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
	          }
	        });
	
	        return false;
	      };
	
	      $scope.loadData();
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("wallActivity", ["CompanyPublicationActivity", "CompanyCommentsService", "CompanyPublicationActivityTranslator", "$stateParams", WallActivity]);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(5);
	
	function PublicationTypeaheadDirective(CompanyPublicationService, growl, $translate) {
	  return {
	    restrict: "EA",
	    templateUrl: "partials/company/publications/publication-typeahead.html",
	    scope: {
	      company:       "=pCompany",
	      target:        "=pTarget",
	      publications:  "=pCurrent",
	      appFormSubmit: "=?appFormSubmit"
	    },
	    link: function($scope, element) {
	      $scope.addPublication = function(publication) {
	        if (!$scope.appFormSubmit) {
	          publication.groups.push($scope.target);
	
	          CompanyPublicationService.update({
	            companyId: $scope.company,
	            publicationId: publication.id
	          }, publication).$promise.then(function() {
	
	            $scope.publications.unshift(publication);
	            $scope.addNewPublication = {};
	
	            growl.addSuccessMessage($translate.instant('publication.add-success'));
	            $scope.addNewPublication.addedPublication = "";
	
	          }, function() {
	            growl.addErrorMessage($translate.instant('publication.add-failure'));
	          });
	        } else {
	          $scope.appFormSubmit.publicationIds.push(publication.id);
	          $scope.appFormSubmit.$update({
	            companyId: $scope.company,
	            groupId: $scope.appFormSubmit.id
	          },function(){
	            $scope.publications.unshift(publication);
	            growl.addSuccessMessage($translate.instant('publication.add-success'));
	            $scope.addNewPublication.addedPublication = "";
	          }, function(resp){
	            if (resp.status && resp.status === 304 ) {
	              growl.addErrorMessage($translate.instant('publication.reached-your-limit'));
	            } else {
	              growl.addErrorMessage($translate.instant('publication.add-failure'));
	            }
	            
	          });
	        }
	      };
	
	      $scope.queryPublications = function(text) {
	        var filter = {
	          companyId: $scope.company,
	          q:         text,
	          limit:     10
	        };
	      
	        if ($scope.appFormSubmit) {
	          filter.type = 'FORM';
	        }
	        return CompanyPublicationService.query(filter).$promise.then(function(p) {
	          return p.filter(function(p) {
	            return !$scope.publications.some(function(publication) {
	              return publication.id === p.id;
	            });
	          });
	        });
	      };
	
	      element.find('input[type="text"]').bind("keydown keypress", function (event) {
	        if(event.which === 13) {
	          $scope.$apply(function (){
	            $scope.addPublication($scope.addNewPublication.addedPublication);
	          });
	          event.preventDefault();
	        }
	      });
	    }
	  };
	}
	
	
	angular.module("dokiv")
	  .directive("pTypeahead", [
	    'CompanyPublicationService',
	    'growl',
	    '$translate',
	    PublicationTypeaheadDirective
	  ]);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationCompanyOrderService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'updateItems':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items',
	      method: 'POST'
	    },
	    'updateItem':  {
	        url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items/:itemId',
	        method: 'PUT'
	    },
	    'deleteItem': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items/:itemId',
	      method: 'DELETE'
	    },
	    'copyOrder':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/copy',
	      method: 'POST'
	    },
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationCompanyOrderService', ['$resource', 'config', CompanyPublicationCompanyOrderService]);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationPlantService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/plants/:plantId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'queryDeliveries': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/plants/:plantId/deliveries',
	      method: 'GET',
	      isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationPlantService', ['$resource', 'config', CompanyPublicationPlantService]);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
	(function(s,H,f,w){var K=f("html"),q=f(s),p=f(H),b=f.fancybox=function(){b.open.apply(this,arguments)},J=navigator.userAgent.match(/msie/i),C=null,t=H.createTouch!==w,u=function(a){return a&&a.hasOwnProperty&&a instanceof f},r=function(a){return a&&"string"===f.type(a)},F=function(a){return r(a)&&0<a.indexOf("%")},m=function(a,d){var e=parseInt(a,10)||0;d&&F(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},x=function(a,b){return m(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20,
	width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!t,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"},
	keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+
	(J?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0,
	openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"elastic",nextSpeed:250,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"elastic",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1,
	isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=u(a)?f(a).get():[a]),f.each(a,function(e,c){var l={},g,h,k,n,m;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),u(c)?(l={href:c.data("fancybox-href")||c.attr("href"),title:f("<div/>").text(c.data("fancybox-title")||c.attr("title")).html(),isDom:!0,element:c},
	f.metadata&&f.extend(!0,l,c.metadata())):l=c);g=d.href||l.href||(r(c)?c:null);h=d.title!==w?d.title:l.title||"";n=(k=d.content||l.content)?"html":d.type||l.type;!n&&l.isDom&&(n=c.data("fancybox-type"),n||(n=(n=c.prop("class").match(/fancybox\.(\w+)/))?n[1]:null));r(g)&&(n||(b.isImage(g)?n="image":b.isSWF(g)?n="swf":"#"===g.charAt(0)?n="inline":r(c)&&(n="html",k=c)),"ajax"===n&&(m=g.split(/\s+/,2),g=m.shift(),m=m.shift()));k||("inline"===n?g?k=f(r(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):l.isDom&&(k=c):
	"html"===n?k=g:n||g||!l.isDom||(n="inline",k=c));f.extend(l,{href:g,type:n,content:k,title:h,selector:m});a[e]=l}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==w&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1===b.trigger("onCancel")||(b.hideLoading(),a&&(b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),
	b.coming=null,b.current||b._afterZoomOut(a)))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(b.isOpen&&!0!==a?(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]()):(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&
	(b.player.timer=setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};!0===a||!b.player.isActive&&!1!==a?b.current&&(b.current.loop||b.current.index<b.group.length-1)&&(b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")):c()},next:function(a){var d=b.current;d&&(r(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=
	b.current;d&&(r(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=m(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==w&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,l;c&&(l=b._getPosition(d),a&&"scroll"===a.type?(delete l.position,c.stop(!0,!0).animate(l,200)):(c.css(l),e.pos=f.extend({},e.dim,l)))},
	update:function(a){var d=a&&a.originalEvent&&a.originalEvent.type,e=!d||"orientationchange"===d;e&&(clearTimeout(C),C=null);b.isOpen&&!C&&(C=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),C=null)},e&&!t?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,t&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),
	b.trigger("onUpdate")),b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){27===(a.which||a.keyCode)&&(a.preventDefault(),b.cancel())});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}));b.trigger("onLoading")},getViewport:function(){var a=b.current&&
	b.current.locked||!1,d={x:q.scrollLeft(),y:q.scrollTop()};a&&a.length?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=t&&s.innerWidth?s.innerWidth:q.width(),d.h=t&&s.innerHeight?s.innerHeight:q.height());return d},unbindEvents:function(){b.wrap&&u(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");q.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(q.bind("orientationchange.fb"+(t?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=
	e.which||e.keyCode,l=e.target||e.srcElement;if(27===c&&b.coming)return!1;e.ctrlKey||e.altKey||e.shiftKey||e.metaKey||l&&(l.type||f(l).is("[contenteditable]"))||f.each(d,function(d,l){if(1<a.group.length&&l[c]!==w)return b[d](l[c]),e.preventDefault(),!1;if(-1<f.inArray(c,l))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,l,g){for(var h=f(d.target||null),k=!1;h.length&&!(k||h.is(".fancybox-skin")||h.is(".fancybox-wrap"));)k=h[0]&&!(h[0].style.overflow&&
	"hidden"===h[0].style.overflow)&&(h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();0!==c&&!k&&1<b.group.length&&!a.canShrink&&(0<g||0<l?b.prev(0<g?"down":"left"):(0>g||0>l)&&b.next(0>g?"up":"right"),d.preventDefault())}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&
	b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0,{},b.helpers[d].defaults,e),c)})}p.trigger(a)},isImage:function(a){return r(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return r(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=m(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,
	c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1,mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===
	c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio=!0);"iframe"===c&&t&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(t?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,x(d.padding[a]))});b.trigger("onReady");
	if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href");"image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=
	this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload=this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,
	d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",t?"auto":a.iframe.scrolling).attr("src",a.href);f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);t||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||
	b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload,e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,l,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());
	b.unbindEvents();e=a.content;c=a.type;l=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin,outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):u(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",
	!1)}));break;case "image":e=a.tpl.image.replace(/\{href\}/g,g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}u(e)&&e.parent().is(a.inner)||a.inner.append(e);b.trigger("beforeShow");
	a.inner.css("overflow","yes"===l?"scroll":"no"===l?"hidden":l);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(!b.isOpened)f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();else if(d.prevMethod)b.transitions[d.prevMethod]();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,l=b.skin,g=b.inner,h=b.current,c=h.width,k=h.height,n=h.minWidth,v=h.minHeight,p=h.maxWidth,
	q=h.maxHeight,t=h.scrolling,r=h.scrollOutside?h.scrollbarWidth:0,y=h.margin,z=m(y[1]+y[3]),s=m(y[0]+y[2]),w,A,u,D,B,G,C,E,I;e.add(l).add(g).width("auto").height("auto").removeClass("fancybox-tmp");y=m(l.outerWidth(!0)-l.width());w=m(l.outerHeight(!0)-l.height());A=z+y;u=s+w;D=F(c)?(a.w-A)*m(c)/100:c;B=F(k)?(a.h-u)*m(k)/100:k;if("iframe"===h.type){if(I=h.content,h.autoHeight&&1===I.data("ready"))try{I[0].contentWindow.document.location&&(g.width(D).height(9999),G=I.contents().find("body"),r&&G.css("overflow-x",
	"hidden"),B=G.outerHeight(!0))}catch(H){}}else if(h.autoWidth||h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(D),h.autoHeight||g.height(B),h.autoWidth&&(D=g.width()),h.autoHeight&&(B=g.height()),g.removeClass("fancybox-tmp");c=m(D);k=m(B);E=D/B;n=m(F(n)?m(n,"w")-A:n);p=m(F(p)?m(p,"w")-A:p);v=m(F(v)?m(v,"h")-u:v);q=m(F(q)?m(q,"h")-u:q);G=p;C=q;h.fitToView&&(p=Math.min(a.w-A,p),q=Math.min(a.h-u,q));A=a.w-z;s=a.h-s;h.aspectRatio?(c>p&&(c=p,k=m(c/E)),k>q&&(k=q,c=m(k*E)),c<n&&(c=n,k=m(c/
	E)),k<v&&(k=v,c=m(k*E))):(c=Math.max(n,Math.min(c,p)),h.autoHeight&&"iframe"!==h.type&&(g.width(c),k=g.height()),k=Math.max(v,Math.min(k,q)));if(h.fitToView)if(g.width(c).height(k),e.width(c+y),a=e.width(),z=e.height(),h.aspectRatio)for(;(a>A||z>s)&&c>n&&k>v&&!(19<d++);)k=Math.max(v,Math.min(q,k-10)),c=m(k*E),c<n&&(c=n,k=m(c/E)),c>p&&(c=p,k=m(c/E)),g.width(c).height(k),e.width(c+y),a=e.width(),z=e.height();else c=Math.max(n,Math.min(c,c-(a-A))),k=Math.max(v,Math.min(k,k-(z-s)));r&&"auto"===t&&k<B&&
	c+y+r<A&&(c+=r);g.width(c).height(k);e.width(c+y);a=e.width();z=e.height();e=(a>A||z>s)&&c>n&&k>v;c=h.aspectRatio?c<G&&k<C&&c<D&&k<B:(c<G||k<C)&&(c<D||k<B);f.extend(h,{dim:{width:x(a),height:x(z)},origWidth:D,origHeight:B,canShrink:e,canExpand:c,wPadding:y,hPadding:w,wrapSpace:z-l.outerHeight(!0),skinSpace:l.height()-k});!I&&h.autoHeight&&k>v&&k<q&&!c&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",
	top:c[0],left:c[3]};d.autoCenter&&d.fixed&&!a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=x(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=x(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&((b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){f(d.target).is("a")||f(d.target).parent().is("a")||
	(d.preventDefault(),b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),a.loop||a.index!==a.group.length-1)?b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play(!0)):b.play(!1))},
	_afterZoomOut:function(a){a=a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,k=a.wPadding,n=b.getViewport();!e&&a.isDom&&d.is(":visible")&&(e=d.find("img:first"),e.length||(e=d));u(e)?(c=e.offset(),e.is("img")&&
	(f=e.outerWidth(),g=e.outerHeight())):(c.top=n.y+(n.h-g)*a.topRatio,c.left=n.x+(n.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=n.y,c.left-=n.x;return c={top:x(c.top-h*a.topRatio),left:x(c.left-k*a.leftRatio),width:x(f+k),height:x(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](m("width"===
	f?c:c-g*e)),b.inner[f](m("width"===f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,l=f.extend({opacity:1},d);delete l.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(l,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&
	(c.opacity=0.1));b.wrap.animate(c,{duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=x(m(e[g])-200),c[g]="+=200px"):(e[g]=x(m(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},
	changeOut:function(){var a=b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!t,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){var d;a=f.extend({},this.defaults,a);this.overlay&&
	this.close();d=b.coming?b.coming.parent:a.parent;this.overlay=f('<div class="fancybox-overlay"></div>').appendTo(d&&d.lenth?d:"body");this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(q.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",
	function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive?b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){q.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),this.el.removeClass("fancybox-lock"),q.scrollTop(this.scrollV).scrollLeft(this.scrollH));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");
	J?(b=Math.max(H.documentElement.offsetWidth,H.body.offsetWidth),p.width()>b&&(a=p.width())):p.width()>q.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&this.fixed&&b.fixed&&(b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){b.locked&&!this.el.hasClass("fancybox-lock")&&(!1!==this.fixPosition&&f("*").filter(function(){return"fixed"===
	f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin"),this.scrollV=q.scrollTop(),this.scrollH=q.scrollLeft(),this.el.addClass("fancybox-lock"),q.scrollTop(this.scrollV).scrollLeft(this.scrollH));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",
	position:"bottom"},beforeShow:function(a){var d=b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(r(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),J&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(m(d.css("margin-bottom")))}d["top"===a.position?"prependTo":
	"appendTo"](c)}}};f.fn.fancybox=function(a){var d,e=f(this),c=this.selector||"",l=function(g){var h=f(this).blur(),k=d,l,m;g.ctrlKey||g.altKey||g.shiftKey||g.metaKey||h.is(".fancybox-wrap")||(l=a.groupAttr||"data-fancybox-group",m=h.attr(l),m||(l="rel",m=h.get(0)[l]),m&&""!==m&&"nofollow"!==m&&(h=c.length?f(c):e,h=h.filter("["+l+'="'+m+'"]'),k=h.index(this)),a.index=k,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;c&&!1!==a.live?p.undelegate(c,"click.fb-start").delegate(c+":not('.fancybox-item, .fancybox-nav')",
	"click.fb-start",l):e.unbind("click.fb-start").bind("click.fb-start",l);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===w&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});f.support.fixedPosition===w&&(f.support.fixedPosition=function(){var a=f('<div style="position:fixed;top:20px;"></div>').appendTo("body"),
	b=20===a[0].offsetTop||15===a[0].offsetTop;a.remove();return b}());f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(s).width();K.addClass("fancybox-lock-test");d=f(s).width();K.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(84),
				__webpack_require__(3),
				__webpack_require__(23)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyLogoService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/logo');
	}
	
	angular.module('dokiv')
	  .factory('CompanyLogoService', ['$resource', 'config', CompanyLogoService]);
	
	


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyFlowVerifiesService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/flow-verifies/:flowVerifyID', {}, {
	    'update': {
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyFlowVerifiesService', ['$resource', 'config', CompanyFlowVerifiesService]);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(25);
	__webpack_require__(37);
	__webpack_require__(7);
	
	
	function groupsToString(groups) {
	  var ids = "";
	  angular.forEach(groups, function(v, k){
	    if (k === 0) {
	      ids = v.id;
	    } else {
	      ids = ids + ',' + v.id;
	    }
	  });
	  return ids;
	}
	
	CompanyMessageDetailCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$translate',
	  '$q',
	  'members',
	  'CompanyMessageService',
	  'CompanyGroupService',
	  'CompanyGroupUserService',
	  'CompanyUserService',
	  'message',
	  'growl'];
	
	function CompanyMessageDetailCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $translate,
	  $q,
	  members,
	  CompanyMessageService,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  CompanyUserService,
	  message,
	  growl) {
	
	  $scope.post = message;
	  $scope.submitting = false;
	  $scope.members = members.map(function(m){
	    return {email: m.email};
	  });
	
	  if (!message) {
	    $scope.post = {
	      name: "",
	      groups: [],
	      extra: {
	        sendToList: true,
	        sendToAll: false,
	        sendEmail: false,
	        listSendMail: []
	      },
	      showMessageList: false
	    };
	  }
	
	  function filterIds(groups) {
	    return groups.map(function(v){
	      return v.id;
	    });
	  }
	
	  $scope.ids = filterIds($scope.post.groups);
	
	  $scope.addGroup = function(g) {
	    $scope.post.groups.push(g);
	    $scope.ids = filterIds($scope.post.groups);
	    if($scope.post.extra.sendToAll){
	      CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        groupIds: groupsToString($scope.post.groups),
	        all: true
	      }).$promise.then(function(members){
	        $scope.members = $scope.members.concat(members.map(function(m){
	          return {email: m.email, name: m.name};
	        }));
	      });
	    }
	  };
	
	  $scope.removeGroup = function(i) {
	    $scope.post.groups.splice(i, 1);
	    $scope.ids = filterIds($scope.post.groups);
	  };
	
	  $scope.sendMail = function() {
	    $scope.submitting = true;
	    return CompanyMessageService.sendMail({
	      companyId: $stateParams.companyId,
	      messageId: $scope.post.id
	    }, {
	      listSendMail: $scope.members
	    }, function(){
	      growl.addSuccessMessage($translate.instant('blog.send-mail-success'));
	      $scope.submitting = false;
	    }, function(){
	      growl.addErrorMessage($translate.instant('blog.send-mail-failure'));
	      $scope.submitting = false;
	    });
	  };
	
	  $scope.save = function() {
	    $scope.submitting = true;
	    if($scope.members.length > 0){
	      $scope.post.extra.listSendMail = angular.copy($scope.members);
	    }
	    if (!message) {
	      CompanyMessageService.save({companyId: $stateParams.companyId}, $scope.post, function(resp){
	        $scope.post.id = resp.id;
	        if ($scope.members.length > 0) {
	          if($scope.post.extra.sendEmail){
	            $scope.sendMail().$promise.then(function(){
	              $state.go('root.company.message-detail', {messageId: resp.id});
	            });
	          } else {
	            $state.go('root.company.message-detail', {messageId: resp.id});
	          }
	        } else {
	          $state.go('root.company.message-detail', {messageId: resp.id});
	        }
	        growl.addSuccessMessage($translate.instant('blog.save-success'));
	      }, function(){
	        $scope.submitting = false;
	        growl.addErrorMessage($translate.instant('blog.save-failure'));
	      });
	    } else {
	      CompanyMessageService.update({companyId: $stateParams.companyId, messageId: $scope.post.id}, $scope.post, function(){
	        $scope.submitting = false;
	        growl.addSuccessMessage($translate.instant('blog.save-success'));
	        if ($scope.members.length > 0) {
	          if($scope.post.extra.sendEmail){
	            $scope.sendMail().$promise.then(function(){
	              $scope.members = $scope.members.map(function(v){
	                return {
	                  email: v.email,
	                  sentAt: new Date()
	                };
	              });
	            });
	          }
	        }
	      }, function(){
	        $scope.submitting = false;
	        growl.addErrorMessage($translate.instant('blog.save-failure'));
	      });
	    }
	  };
	
	  $scope.addEmail = function() {
	    $scope.members.push({email: $scope.addedEmail});
	    $scope.addedEmail = null;
	  };
	
	  $scope.queryGroups = function(filter) {
	    CompanyGroupService.query({companyId: $stateParams.companyId, q: filter, limit: 6, type: null}).$promise.then(function(groups) {
	      $scope.groups = groups.filter(function(g) {
	        return !$scope.post.groups.some(function(g1) {
	          return g1.id === g.id;
	        });
	      });
	    });
	  };
	
	  $scope.deleteMessage = function() {
	    CompanyMessageService.delete({companyId: $stateParams.companyId, messageId: $scope.post.id}).$promise.then(function() {
	      growl.addSuccessMessage($translate.instant('blog.delete-message-success'));
	      $state.go("root.company.comments.messages");
	    }, function() {
	      growl.addErrorMessage($translate.instant('blog.delete-message-failure'));
	    })
	
	  }
	}
	
	CompanyMessageDetailCtrl.resolve = {
	  message: ['CompanyMessageService', '$stateParams', function(CompanyMessageService, $stateParams) {
	    if ($stateParams.messageId) {
	      return CompanyMessageService.get({
	        companyId: $stateParams.companyId,
	        messageId: $stateParams.messageId
	      }).$promise;
	    }
	    return false; 
	  }],
	  members: ['CompanyUserService', '$stateParams', 'message', function(CompanyUserService, $stateParams, message) {
	    if (message && message.groups.length > 0) {
	      return CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        groupIds: groupsToString(message.groups),
	        all: true
	      }).$promise;
	    }
	    return [];    
	  }]
	};
	
	module.exports = CompanyMessageDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyMessageDetailCtrl', CompanyMessageDetailCtrl);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	
	var LIMIT = 20;
	
	function identity(a) {
	  return a;
	}
	
	function CompanyFeedFactory(config, $q, $http) {
	  function Source(uri, type, parse) {
	    this._uri       = uri;
	    this._type      = type;
	    this._parse     = typeof parse === "function" ? parse : identity;
	    this._data      = [];
	    this._exhausted = false;
	    this._loading   = null;
	    this._setType   = function(a) {
	      a.activityType = type;
	
	      return a;
	    };
	  }
	
	  Source.prototype.next = function(offset, q) {
	    var self = this;
	
	    if(this._loading) {
	      /* Wait until current loading is done, then try again */
	      return this._loading.then(function() {
	        return self.next(offset, offset + 1);
	      });
	    }
	
	    if(offset + 1 < this._data.length || this._exhausted) {
	      /* Already cached or nothing more to fetch */
	      return this._data.slice(offset, offset + 1);
	    }
	
	    var uri = this._uri + (this._uri.indexOf("?") === -1 ? "?" : "&" ) + "offset=" + this._data.length + "&limit=" + (LIMIT + 1) + "&text=" + q + "&title=" + q;
	
	    this._loading = $http({
	      method: "GET",
	      url:    config.apiBase + uri,
	    }).then(function(response) {
	      /* We got fewer items than we asked for, source is exhausted */
	      if(response.data.length < LIMIT + 1) {
	        self._exhausted = true;
	      }
	
	      self._data    = self._data.concat(response.data.map(self._parse).map(self._setType));
	      self._loading = null;
	
	      return self._data.slice(offset, offset + 1);
	    });
	
	    return this._loading;
	  };
	
	  Source.prototype.isExhausted = function() {
	    return this._exhausted;
	  };
	
	  Source.prototype.numLoaded = function() {
	    return this._data.length;
	  };
	
	  Source.prototype.getType = function() {
	    return this._type;
	  };
	
	  Source.prototype.prependData = function(data) {
	    this._data = data.map(this._setType).concat(this._data);
	  };
	
	  function CompanyFeedActivity(companyId, blogEnable) {
	    this._sources = [
	      new Source("/companies/" + companyId + "/comments", "COMMENT")
	    ];
	    if (blogEnable) {
	      this._sources.push(new Source("/companies/" + companyId + "/posts", "MESSAGE"));
	    }
	  }
	
	  CompanyFeedActivity.prototype.prependDataTo = function(type /* , ... */) {
	    var source = null;
	
	    this._sources.forEach(function(s) {
	      if(s.getType() === type) {
	        source = s;
	      }
	    });
	
	    if(source) {
	      source.prependData.call(source, Array.prototype.slice.call(arguments, 1));
	
	      return true;
	    }
	    else {
	      return false;
	    }
	  };
	
	  CompanyFeedActivity.prototype.next = function(offset, limit, types, q) {
	    offset = typeof offset === "number" ? offset : 0;
	    limit  = typeof limit  === "number" ? limit  : LIMIT;
	    types  = Array.isArray(types) && types.length > 0 ? types : this._sources.map(function(s) { return s.getType(); });
	
	    var list    = [];
	    var d       = $q.defer();
	    var sources = this._sources.filter(function(s) {
	      return types.indexOf(s.getType()) !== -1;
	    }).map(function(s) {
	      return {
	        offset : 0,
	        source:  s
	      };
	    });
	
	    /**
	     * Unless we have enough data or exhausted all sources, take
	     * the newest item from any of the sources and increment the
	     * offset counter for that source and repeat.
	     */
	    function consume() {
	      if(list.length === limit + offset || sources.every(function(v) { return v.source.numLoaded() === v.offset && v.source.isExhausted(); })) {
	        d.resolve(list.slice(offset));
	
	        return;
	      }
	
	      /* Read one item off all sources */
	      $q.all(sources.map(function(s) {
	        return s.source.next(s.offset, q);
	      })).then(function(datas) {
	        var min      = null;
	        var selected = null;
	
	        for(var i = 0; i < datas.length; i++) {
	          if(datas[i].length > 0 && (min === null || new Date(datas[i][0].createdAt) > new Date(min.createdAt))) {
	            min      = datas[i][0];
	            selected = i;
	          }
	        }
	
	        if( ! min) {
	          d.resolve(list.slice(offset));
	
	          /* All are consumed */
	          return;
	        }
	
	        /* We got the most current event out of all datas,
	         * consume that and increase the offset for the source. */
	        list.push(min);
	
	        sources[selected].offset++;
	
	        consume();
	      }, function(e) {
	        d.reject(e);
	      });
	    }
	
	    consume();
	
	    return d.promise;
	  };
	
	  return CompanyFeedActivity;
	}
	
	angular.module("dokiv")
	  .factory("CompanyFeedActivity", ["config", "$q", "$http", CompanyFeedFactory]);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyDeviationWatcherService.$inject = ['config', '$resource'];
	function CompanyDeviationWatcherService(config, $resource) {
	  return $resource(config.apiBase + '/companies/:companyId/deviation-watchers/:deviationWatcherId' , {}, {
	    "update": {
	      method: 'PUT'
	    },
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyDeviationWatcherService', CompanyDeviationWatcherService);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	function FormAppSubmitGroupService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId', {}, {
	    'update': { method: 'PUT' },
	    'getMyFormAppGroups': {
	    	method: 'GET',
	    	url: config.apiBase + '/companies/:companyId/groups?userId=:userId',
	    	isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('FormAppSubmitGroupService', ['$resource', 'config', FormAppSubmitGroupService]);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyNoticeService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/notices/:noticeId', {}, {
	    "update": {
	      method: "PUT"
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyNoticeService', [
	    '$resource',
	    'config',
	    CompanyNoticeService
	  ]);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	
	function historyTranslationKey(k) {
	  return 'publication.activity.history.' + k;
	}
	
	function CompanyPublicationActivityTranslator($translate) {
	  var translate = function(k) {
	    return $translate.instant(k);
	  };
	
	  var types = {
	    COMMENT: function(c) {
	      return {
	        text: c.text,
	        id: c.id,
	        createdAt: c.createdAt,
	        type:      "comment",
	        user:      c.createdBy,
	        commentChild: c.commentChild,
	        pageSize: 10
	      };
	    },
	    AUDITLOG: function(a) {
	      switch (a.action) {
	        case 'UPDATE':
	          if (a.extra.newData) {
	            if (a.extra.newData.Features) {
	              delete a.extra.newData.Features;
	            }
	            var objectKey = Object.keys(a.extra.newData).length > 1 ? Object.keys(a.extra.newData)[Object.keys(a.extra.newData).length - 1] : Object.keys(a.extra.newData)[0];
	            var textMore = (a.extra.newData.Status ? (' to ' + $translate.instant('publication.' + angular.lowercase(a.extra.newData.Status))) : '') + (a.extra.newData.Priority ? (' to ' + a.extra.newData.Priority.name) : '') + (a.extra.newData.Reference ? (' to ' + a.extra.newData.Reference) : '');
	            if(a.extra.newData.Tags){
	              textMore = ': ';
	              angular.forEach(a.extra.newData.Tags, function(value, key){
	                if(key>0){
	                  textMore += ', ' + value;
	                }else{
	                  textMore += value;
	                }
	              });
	            }
	            if(a.extra.newData.Category){
	              textMore = " " + $translate.instant("to").toLowerCase() + " " + a.extra.newData.Category.name;
	            }
	            if (objectKey === 'Parent') {
	              return {
	                text: a.extra.newData.Parent ? $translate.instant("publication.activity.history.updated") + ": " + $translate.instant('publication.activity.history.set-parent', {
	                  user:    a.performedBy.name
	                }) : $translate.instant("publication.activity.history.updated") + ": " + $translate.instant('publication.activity.history.unset-parent', {
	                  user:    a.performedBy.name
	                }) + textMore,
	                createdAt:  a.performedAt,
	                type:       "history",
	                user:       a.performedBy
	              };
	            } else {
	              if(objectKey){
	                console.log(textMore);
	                return {
	                  text: $translate.instant("publication.activity.history.updated") + ": " +
	                         [objectKey]
	                           .map(historyTranslationKey)
	                           .map(translate)
	                           .join(", ") + textMore,
	                  createdAt: a.performedAt,
	                  user:      a.performedBy,
	                  type:      "history"
	                };
	              }
	            }
	          } 
	          if(a.extra.data && a.extra.data.step){
	            return {
	              text: $translate.instant("publication.activity.history.updated") + " " + $translate.instant("step") + " " + a.extra.data.step,
	              createdAt: a.performedAt,
	              user:      a.performedBy,
	              type:      "history"
	            };
	          }
	          if(a.extra.inforName){
	            return {
	              text: $translate.instant("notification.actions.updated") + ": keypass " + $translate.instant("notification.named") + " " + a.extra.inforName,
	              createdAt: a.performedAt,
	              user:      a.performedBy,
	              type:      "history"
	            };
	          }
	          break;  
	        case 'CREATE':
	          if(a.extra.inforName){
	            return {
	              text: $translate.instant("notification.actions.created") + ": keypass " + $translate.instant("notification.named") + " " + a.extra.inforName,
	              createdAt: a.performedAt,
	              user:      a.performedBy,
	              type:      "history"
	            };
	          }else{
	            if(a.extra.objectType === 'CHECKLIST'){
	              if(a.extra.isItem){
	                return {
	                  text: $translate.instant("publication.activity.history." + a.action + "-item", {
	                    user:     a.performedBy.name,
	                    checkItem: a.extra.checkItem,
	                    checklist: a.extra.object.name
	                  }),
	                  createdAt: a.performedAt,
	                  user:      a.performedBy,
	                  type:      "history"
	                };
	              }else{
	                return {
	                  text: $translate.instant("publication.activity.history." + a.action + "-checklist", {
	                    user:     a.performedBy.name,
	                    checkItem: a.extra.checkItem,
	                    checklist: a.extra.object.name
	                  }),
	                  createdAt: a.performedAt,
	                  user:      a.performedBy,
	                  type:      "history"
	                };
	              }
	            }else{
	              return {
	                text: $translate.instant("notification.actions.object." + a.action),
	                createdAt: a.performedAt,
	                user:      a.performedBy,
	                type:      "history"
	              };
	            }
	          }
	          break;
	        case 'DELETE':
	          if(a.extra.inforName){
	            return {
	              text: $translate.instant("notification.actions.deleted") + ": keypass " + a.extra.inforName,
	              createdAt: a.performedAt,
	              user:      a.performedBy,
	              type:      "history"
	            };
	          }else{
	            if(a.extra.objectType === 'CHECKLIST'){
	              if(a.extra.isItem){
	                return {
	                  text: $translate.instant("publication.activity.history." + a.action + "-item", {
	                    user:     a.performedBy.name,
	                    checkItem: a.extra.checkItem,
	                    checklist: a.extra.object.name
	                  }),
	                  createdAt: a.performedAt,
	                  user:      a.performedBy,
	                  type:      "history"
	                };
	              }else{
	                return {
	                  text: $translate.instant("publication.activity.history." + a.action + "-checklist", {
	                    user:     a.performedBy.name,
	                    checkItem: a.extra.checkItem,
	                    checklist: a.extra.object.name
	                  }),
	                  createdAt: a.performedAt,
	                  user:      a.performedBy,
	                  type:      "history"
	                };
	              }
	            }
	          }
	          break;
	        case 'FILE_UPLOADED':
	          return {
	            text:       $translate.instant('publication.activity.uploaded', {
	              user:     a.performedBy.name,
	              filename: a.extra.fileName
	            }),
	            createdAt:  a.performedAt,
	            type:       "upload",
	            user:       a.performedBy
	          };
	        case 'FILE_VIEW':
	          return {
	            text:       $translate.instant('publication.activity.viewed', {
	              user:     a.performedBy.name,
	              filename: a.extra.fileName
	            }),
	            createdAt:  a.performedAt,
	            type:       "upload",
	            user:       a.performedBy
	          };
	        case 'FILE_DOWNLOADED':
	          return {
	            text:       $translate.instant('publication.activity.history.downloaded-file'),
	            createdAt:  a.performedAt,
	            type:       "upload",
	            user:       a.performedBy
	          };
	        case 'ADDED_WATCHER':
	          return {
	            text:       $translate.instant('publication.activity.history.add-watcher', {
	              user:     a.performedBy.name,
	              watcher: a.extra.watcher.name
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'REMOVED_WATCHER':
	          return {
	            text:       $translate.instant('publication.activity.history.remove-watcher', {
	              user:     a.performedBy.name,
	              watcher: a.extra.watcher.name
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'CHECK':
	          return {
	            text:       $translate.instant('publication.activity.history.check', {
	              user:     a.performedBy.name,
	              checkItem: a.extra.checkItem,
	              checklist: a.extra.object.name
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'UNCHECK':
	          return {
	            text:       $translate.instant('publication.activity.history.uncheck', {
	              user:     a.performedBy.name,
	              checkItem: a.extra.checkItem,
	              checklist: a.extra.object.name
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'DONE':
	          return {
	            text:       $translate.instant('publication.activity.history.done', {
	              user:     a.performedBy.name,
	              checklist: a.extra.object.name
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'FILE_INVISIBLE':
	          return {
	            text:       $translate.instant('publication.activity.history.invisible', {
	              user:     a.performedBy.name,
	              filename: a.extra.fileName
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'FILE_VISIBLE':
	          return {
	            text:       $translate.instant('publication.activity.history.visible', {
	              user:     a.performedBy.name,
	              filename: a.extra.fileName
	            }),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       a.performedBy
	          };
	        case 'SHARED':
	          if (a.extra.action === 'END_SHARE') {
	            return {
	              text:      $translate.instant('publication.activity.end-shared', {
	                user:    a.performedBy.name
	              }),
	              createdAt:  a.performedAt,
	              type:       "shares",
	              user:       a.performedBy
	            };
	          }
	          return {
	            text:      $translate.instant('publication.activity.shared', {
	              user:    a.performedBy.name,
	              email:   a.extra.email
	            }),
	            createdAt:  a.performedAt,
	            type:       "shares",
	            user:       a.performedBy
	          };
	        case 'FORM_SUBMIT':
	          return {
	            text:      $translate.instant('publication.activity.history.form-submit'),
	            createdAt:  a.performedAt,
	            type:       "history",
	            user:       null
	          };   
	        case 'VERIFY':
	          return {
	            text: $translate.instant('publication.activity.history.verified'),
	            createdAt: a.performedAt,
	            user:      a.performedBy,
	            type:      "history"
	          };      
	        case 'CREATED_E_SIGN':
	          return {
	            text: $translate.instant('publication.activity.history.created-esign', {
	              user:    a.performedBy.name,
	              emails:  a.extra.emails
	            }),
	            createdAt: a.performedAt,
	            user:      a.performedBy,
	            type:      "history"
	          };       
	        case 'SIGNED':
	          return {
	            text: $translate.instant('publication.activity.history.signed', {
	              user:    a.extra.email,
	              ip:      a.extra.ip
	            }),
	            createdAt: a.performedAt,
	            user:      {email: a.extra.email},
	            type:      "history"
	          };         
	        case 'ALL_SIGNED':
	          return {
	            text: $translate.instant('publication.activity.history.all-signed'),
	            createdAt: a.performedAt,
	            user:      {name: 'A L L'},
	            type:      "history"
	          };       
	        case 'VISIT_E_SIGN':
	          return {
	            text: $translate.instant('publication.activity.history.visit-esign', {
	              user:    a.extra.email,
	              ip:      a.extra.ip
	            }),
	            createdAt: a.performedAt,
	            user:      {email: a.extra.email},
	            type:      "history"
	          };      
	        case 'SEND_EMAIL':
	          return {
	            text: $translate.instant('publication.activity.history.send-email', {
	              email:    a.extra.to
	            }),
	            createdAt: a.performedAt,
	            user:      {email: a.extra.to},
	            type:      "history"
	          };  
	      }
	    }
	  };
	  
	  return function(item) {
	    if(types.hasOwnProperty(item.activityType)) {
	      return types[item.activityType](item);
	    }
	    
	    return false;
	  };
	}
	
	angular.module("dokiv")
	  .factory("CompanyPublicationActivityTranslator", ["$translate", CompanyPublicationActivityTranslator]);


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyTaskService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/reminders/:taskId', {}, {
	    "update": {
	      method: "PUT"
	    },
	    'queryCategories': {
	      url: config.apiBase + '/companies/:companyId/reminders/categories',
	      method: 'GET',
	      isArray: true
	    },
	    'updateCategories': {
	      url: config.apiBase + '/companies/:companyId/reminders/categories',
	      method: 'PUT',
	      isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyTaskService', [
	    '$resource',
	    'config',
	    CompanyTaskService
	  ]);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyTimestampsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/timestamps/:timestampId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'queryTotalTime': {
				url: config.apiBase + '/companies/:companyId/timestamps/sum',
				method: 'GET'
	    },
	    'queryWorkTime': {
	      url: config.apiBase + '/companies/:companyId/timestamps/worktime',
	      method: 'GET',
	      isArray: true
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyTimestampsService', ['$resource', 'config', CompanyTimestampsService]);

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyUserStarService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/users/:userId/starred/:publicationId', {}, {
	    'add': {
	      method:'PUT',
	      url: config.apiBase + '/companies/:companyId/users/:userId/starred/:publicationId'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyUserStarService', ['$resource', 'config', CompanyUserStarService]);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(11);
	__webpack_require__(14);
	__webpack_require__(26);
	
	function UserTypeaheadDirective(
	  CompanyUserService,
	  CompanyGroupUserService,
	  growl,
	  $stateParams,
	  FormAppSubmitGroupUserService,
	  $translate) {
	  return {
	    restrict: "EA",
	    templateUrl: "partials/company/users/userTypeahead.tpl.html",
	    scope: {
	      members:        "=uCurrent",
	      placeholder:    "=uPlaceholder",
	      target:         "=uTarget",
	      formAppSubmit:   "=formAppSubmit"
	
	    },
	    link: function($scope) {
	      $scope.addMember = function(user) {
	        if (!$scope.formAppSubmit) {
	          CompanyGroupUserService.save({companyId: $stateParams.companyId, groupId: $scope.target}, user, function() {
	            $scope.members.push(user);
	            growl.addSuccessMessage($translate.instant('customer-portals.add-member-success'));
	            $scope.addedUser = '';
	          }, function() {
	            growl.addErrorMessage($translate.instant('customer-portals.add-member-failure'));
	          });
	        } else {
	          FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: $scope.target}, user, function() {
	            $scope.members.push(user);
	            growl.addSuccessMessage($translate.instant('customer-portals.add-member-success'));
	            $scope.addedUser = '';
	          }, function() {
	            growl.addErrorMessage($translate.instant('customer-portals.add-member-failure'));
	          });
	        }
	        
	      };
	
	      $scope.queryUsers = function(text) {
	        return CompanyUserService.query({
	          companyId: $stateParams.companyId,
	          q: text,
	          limit: 10
	        }).$promise.then(function(u){
	          return u.filter(function(u){
	            return !$scope.members.some(function(member){
	              return member.id === u.id;
	            });
	          });
	        });
	      };
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("uTypeahead", [
	    'CompanyUserService',
	    'CompanyGroupUserService',
	    'growl',
	    '$stateParams',
	    'FormAppSubmitGroupUserService',
	    '$translate',
	    UserTypeaheadDirective
	  ]);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(461);
	module.exports = angular;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(22);
	
	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(512);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	return $.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
					instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	} ) );


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("dokiv")
	  .factory("reloadUserRoleDashboard", ["$timeout", "$state", function($timeout, $state) {
	    var reloadDashboard = {};
	    var r;
	    reloadDashboard.reload = function() {
	      if(r) {
	        $timeout.cancel(r);
	        r = null;
	      }
	      r = $timeout(function(){
	        $state.reload();
	      }, 300000);
	    };
	
	    reloadDashboard.stop = function() {
	      $timeout.cancel(r);
	      r = null;
	    };
	    return reloadDashboard;
	  }]);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(15) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(15) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(306);
	
	function AddressBookCtrl(
	  $scope,
	  contacts,
	  growl,
	  translations,
	  CompanyService,
	  AddressBookService
	) {
	  $scope.contacts = contacts;
	
	  $scope.addContact = function() {
	    $scope.newContact = {
	      "name":      "",
	      "companies":   [],
	      "email":     "",
	      "telephone": "",
	      "note":      ""
	    };
	
	    $scope.contacts.unshift($scope.newContact);
	  };
	
	  $scope.searchCompaniesContact = function(filterCompanies, contact) {
	    var nonCompaniesPromise;
	    $scope.contacts[$scope.contacts.indexOf(contact)].nonCompanies = [];
	    var p = CompanyService.query({limit: 21, q: filterCompanies}).$promise.then(function(companies){
	      return companies.filter(function(item) {
	        return !$scope.contacts[$scope.contacts.indexOf(contact)].companies.some(function(company) {
	          return item.id === company.id;
	        });
	      });
	    }).then(function(nonCompanies) {
	      if(nonCompaniesPromise === p) {
	        $scope.contacts[$scope.contacts.indexOf(contact)].nonCompanies = nonCompanies;
	      }
	    });
	    nonCompaniesPromise = p;
	  };
	
	  $scope.saveContact = function(contact) {
	    if (contact.id) {
	      AddressBookService.update(contact);
	
	      growl.addSuccessMessage(translations['address-book.update-successful']);
	    }
	    else {
	      AddressBookService.insert(contact).$promise.then(function(resp) {
	        $scope.newContact = null;
	
	        contact.id = resp.id;
	
	        growl.addSuccessMessage(translations['address-book.insert-successful']);
	      });
	    }
	  };
	
	  $scope.removeContact = function(contact) {
	    if (contact.id) {
	      AddressBookService.delete(contact).$promise.then(function() {
	        $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
	
	        growl.addSuccessMessage(translations['address-book.delete-successful']);
	      });
	    }
	    else {
	      $scope.newContact = null;
	      $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
	    }
	  };
	
	  $scope.searchCompanies = function(filterText) {
	    CompanyService.query({limit: 21, q: filterText}).$promise.then(function(companies){
	      $scope.resultCompanies = companies;
	    });
	  };
	
	  $scope.searchContacts = function(companyId){
	    AddressBookService.query({companyId: companyId}).$promise.then(function(contacts){
	      $scope.contacts = contacts;
	    });
	  };
	}
	
	AddressBookCtrl.resolve = {
	  contacts: ['AddressBookService', function(AddressBookService) {
	    return AddressBookService.query().$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'address-book.insert-successful',
	      'address-book.update-successful',
	      'address-book.delete-successful'
	    ]);
	  }]
	};
	
	module.exports = AddressBookCtrl;
	
	angular.module('dokiv')
	  .controller('AddressBookCtrl', [
	    '$scope',
	    'contacts',
	    'growl',
	    'translations',
	    'CompanyService',
	    'AddressBookService',
	    AddressBookCtrl
	  ]);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyAddressBookService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/contacts/:contactId', { }, {
	    'update': {
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyAddressBookService', [
	    '$resource',
	    'config',
	    CompanyAddressBookService
	  ]);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(13);
	__webpack_require__(4);
	__webpack_require__(24);
	__webpack_require__(7);
	__webpack_require__(5);
	__webpack_require__(11);
	__webpack_require__(420);
	__webpack_require__(309);
	__webpack_require__(19);
	__webpack_require__(63);
	__webpack_require__(17);
	__webpack_require__(10);
	__webpack_require__(419);
	
	var deviationCategory = [
	    {
	        "category": "OLYCKA",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "FORBATTRINGAR",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "REKLAMATIONER",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "TILLBUD",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "AVVIKELSE",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "KUND_ARENDEN",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "EKONOMI",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "LEVERANTORS_ARENDEN",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "KUND",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "LEVERANTOR",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "MILJO",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "OLYCKS_PERSON_SKADA",
	        "color": 0,
	        "description": ""
	    },
	    {
	        "category": "ARBETSMIL_RISK_OLYCKS_RISK",
	        "color": 0,
	        "description": ""
	    }
	  ];
	
	function CompanyCtrl(
	  $scope,
	  $rootScope,
	  stateSnapshot,
	  publicationTypes,
	  categories,
	  groups,
	  tags,
	  customerPortals,
	  currentUserPermissions,
	  currentUser,
	  userInformation,
	  role,
	  translations,
	  $state,
	  $stateParams,
	  $timeout,
	  $translate,
	  $filter,
	  uploadTracker,
	  $q,
	  $modal,
	  $window,
	  growl,
	  config,
	  company,
	  CompanyCategoryService,
	  CompanyService,
	  CompanyPublicationService,
	  CompanyCommentsService,
	  CompanyInfoService,
	  CompanyUserService,
	  info,
	  notices,
	  CompanyChecklistService
	) {
	  if (userInformation && userInformation.features && userInformation.features.denyLoginOnWeb) {
	    $state.go('root.company.403', {}, { location: false });
	  }
	  $scope.isHideComment = userInformation.hide_comments || false;
	  $scope.publicationQuery = {
	    q: '',
	    qType: 'GENERAL',
	    groupId: '',
	    categoryId: '',
	    tags: [],
	    page: 0,
	    priorityId: null,
	    type: null,
	    from: null,
	    to: null,
	    orderby: 'created'
	  };
	
	  $scope.info = info;
	  
	
	  if(!info.extra.deviationCategory){
	    $scope.info.extra.deviationCategory = deviationCategory;
	  }else{
	    $scope.info.extra.deviationCategory = 
	      $scope.info.extra.deviationCategory.filter(function(dC){
	        return $scope.info.extra.deviationCategory.some(function(c){
	                return dC.category===c.category
	              })
	      }).concat(
	        deviationCategory.filter(function(dC){
	          return !$scope.info.extra.deviationCategory.some(function(c){
	                  return dC.category===c.category
	                })
	        })
	      );
	  }
	  $scope.$on('companyInfoChanged', function(){
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise.then(function(resp){
	      $scope.info = resp;
	    });
	  });
	
	  $scope.$on('eventModifyPermissions', function(e, data) {
	    $scope.$apply(function() {
	      $scope.currentUserPermissions = data;
	    });
	    
	  });
	  
	  $scope.company = company;
	  $scope.categoryActive = false;
	  $scope.categories = categories;
	  $scope.groups = groups;
	  $scope.tags = tags;
	  $scope.userType = $stateParams.userType;
	  $scope.currentUserPermissions = currentUserPermissions;
	  $scope.state = $state;
	  $scope.userInfo = userInformation;
	  $scope.apiBase = config.apiBase;
	  $scope.portalUrl = config.portalUrl
	  $scope.currency = 'sek';
	  $scope.showAll = $stateParams.showAll || false;
	  $scope.currentType = $stateParams.type;
	  $scope.toggleMenuSearch = true;
	
	  if(userInformation && !userInformation.features.selectedRole){
	      if(userInformation.roles !== null && userInformation.roles[0]){
	        $scope.userInfo.features.selectedRole = userInformation.roles[0];
	      }
	  }
	
	  $scope.changetoggleMenuSearch = function(){
	    $scope.toggleMenuSearch = !$scope.toggleMenuSearch;
	  };
	
	  function checkHasSubMenu() {
	    if ($scope.role !== null || ($scope.role && $scope.role.template !== null)) {
	      angular.forEach($scope.role.menus, function(v){
	        var hasSub = $scope.role.menus.some(function(m){
	          return m.parentId === v.id;
	        });
	
	        if (hasSub) {
	          v.hasSub = true;
	        }
	      });
	    }
	  }
	
	  $scope.role = role;
	  $scope.$on('roleChanged', function(event, data) {
	    $scope.role = angular.copy(data);
	    checkHasSubMenu();
	  });
	  checkHasSubMenu();
	
	  $scope.notices = notices;
	  $scope.types = publicationTypes;
	  $scope.customerPortals = customerPortals;
	
	  function checkPermissionGroup(group) {
	    if (!group) {
	      group = [];
	    }
	    if (group.length === 0) {
	      return true;
	    }
	
	    var matched = false;
	    angular.forEach(group, function(val){
	      if (!matched) {
	        matched = $scope.groups.some(function(g){
	          return g.id === val.id;
	        });
	      }
	    });
	    return matched;
	  }
	
	  if ($scope.role && $scope.role.template !== undefined) {
	    angular.forEach($scope.role.links, function(v){
	      v.show = true;
	      if (v.link.indexOf(config.appBase) !== -1) {
	        if (!angular.isArray(v.groups)) {
	          v.group = [];
	        }
	        if (!checkPermissionGroup(v.groups)) {
	          v.show = false;
	        }
	      }
	    });
	  }
	
	  var modal;
	  $scope.showTaskModal = function(publication, data) {
	    modal = $modal({
	      scope: $scope,
	      controller: 'CompanyTaskNewCtrl',
	      templateUrl: 'partials/company/tasks/modal-new.html',
	      show: false,
	      resolve: {
	        publication: function() {
	          return publication || false;
	        },
	        taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	          return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
	        }],
	        data: function() { return data; }
	      }
	    });
	    modal.$promise.then(modal.show);
	  };
	
	  $scope.showTaskDetailModal = function(task) {
	    $rootScope.loading = true;
	    modal = $modal({
	      scope: $scope,
	      controller: 'CompanyTaskDetailCtrl',
	      templateUrl: 'partials/company/tasks/modal-detail.html',
	      show: false,
	      resolve: {
	        task: function() {
	          return task;
	        },
	        taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	          return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
	        }],
	        checklists: function() {
	          return CompanyChecklistService.query({
	            companyId: $stateParams.companyId,
	            relativeID: task.id
	          }).$promise;
	        }
	      }
	    });
	
	    modal.$promise.then(function(){
	      modal.show();
	      $rootScope.loading = false;
	    });
	  };
	
	  $scope.showModalCustomer = function(stt, order100) {
	    $rootScope.loading = true;
	    modal = $modal({
	      scope: $scope,
	      controller: 'CompanyCustomerNewPopupCtrl',
	      templateUrl: 'partials/company/customers-dashboard/new.html',
	      show: false,
	      resolve: {
	        order100: function(){
	          return order100 || false;
	        },
	        status: function() {
	          return stt || false;
	        },
	        customerStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	          return CompanyService.queryCustomerStatus({companyId: $stateParams.companyId}).$promise;
	        }],
	        customerCategories: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
	          return CompanyCustomerCategoriesService.query({
	            companyId: $stateParams.companyId,
	            type: 'CATEGORY',
	            limit: 1000
	          }).$promise;
	        }],
	        customerTypes: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
	          return CompanyCustomerCategoriesService.query({
	            companyId: $stateParams.companyId,
	            type: 'TYPE',
	            limit: 1000
	          }).$promise;
	        }],
	        priceLists: ['$stateParams', 'CompanyProductsService', function($stateParams, CompanyProductsService) {
	          if(info.features.products){
	            return CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, limit: 1000}).$promise;
	          }
	          return false;
	        }]
	      }
	    });
	    modal.$promise.then(function(){
	      modal.show();
	      $rootScope.loading = false;
	    });
	  };
	
	  $scope.$on('customerCreated', function(evt, resp){
	    $scope.$broadcast('customerOrder100', resp);
	  });
	
	  $scope.$on('modal.hide', function(){
	    if (typeof modal === 'object') {
	      modal.destroy();
	      modal = null;
	    }
	  });
	
	  $scope.toggleTag = function(tag) {
	    if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
	      $scope.publicationQuery.tags.push(tag);
	    } else {
	      $scope.publicationQuery.tags.splice($scope.publicationQuery.tags.indexOf(tag), 1);
	    }
	  };
	
	  $scope.currentCompany = company;
	
	  $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
	    var attr;
	    for (attr in $scope.publicationQuery) {
	      if($scope.publicationQuery.hasOwnProperty(attr)) {
	        if('tags' === attr) {
	          if(!toParams[attr]) {
	            $scope.publicationQuery[attr] = [];
	            continue;
	          }
	
	          if(!Array.isArray(toParams[attr])) {
	            $scope.publicationQuery[attr] = toParams[attr].split(',');
	          }
	          else  {
	            $scope.publicationQuery[attr] = toParams[attr];
	          }
	        } else {
	          $scope.publicationQuery[attr] = toParams[attr];
	        }
	      }
	    }
	
	  });
	
	  $scope.$parent.companyId = company.id;
	
	  $scope.$on('categoriesChanged', function(ev, categories) {
	    if(categories) {
	      $scope.categories = categories;
	    } else {
	      CompanyCategoryService.query({companyId: company.id}, function(categories) {
	        $scope.categories = categories;
	      });
	    }
	  });
	
	  var reloadTagsTimeout;
	  $scope.$on('tagsChanged', function() {
	    if(reloadTagsTimeout) {
	      $timeout.cancel(reloadTagsTimeout);
	      reloadTagsTimeout = null;
	    }
	    reloadTagsTimeout = $timeout(function() {
	      CompanyService.queryTags({companyId: company.id}, function(tags) {
	        $scope.tags = tags;
	      });
	    }, 1000 * 61);
	  });
	
	  var searchTimeout;
	  $scope.filterPublications = function(url) {
	
	    if(!url) {
	      url = 'root.company.publications-list';
	    }
	    if(searchTimeout){
	      $timeout.cancel(searchTimeout);
	      searchTimeout = null;
	    }
	    searchTimeout = $timeout(function () {
	      var q = angular.copy($scope.publicationQuery);
	
	      // Remove tags from query string if it is empty
	      if(q.tags) {
	        if(q.tags.length === 0) {
	          q.tags = null;
	        } else {
	          q.tags = q.tags.join(',');
	        }
	      }
	      if(q.tags && 0 === q.tags.length) {
	        q.tags = null;
	      }
	      $state.go(url, q);
	      searchTimeout = null;
	    }, 200);
	  };
	
	  $scope.filterStatus = function(priority, url) {
	    $scope.publicationQuery.priorityId = priority.id;
	    $scope.filterPublications(url);
	  };
	
	  /* FIXME: Transform to directive */
	  $scope.getPublicationIcon = function(type) {
	    switch(type) {
	      case 'DEFAULT':                        return 'fa-files-o';
	      case 'FOLDER':                         return 'fa-briefcase';
	      case 'ALBUM':                          return 'fa-image';
	      case 'FORM':                           return 'fa-clipboard';
	      case 'NOTE':                           return 'fa-file-text-o';
	      case 'KEYPASS':                        return 'fa-key';
	      case 'MASTERFILE':                     return 'fa-file-text';
	      case 'WALL':                           return 'fa-comments-o';
	      case 'PLANT':                          return 'fa-industry';
	      case 'ORDER':                          return 'fa-list';
	      case 'CUSTOMER_ADAPTION':              return 'fa-cogs';
	      case 'ENGINE_MODEL':                   return 'fa-folder';
	      case 'PUBLICATION_GROUP':              return 'fa-object-group';
	      case 'COMPANY_ORDER':                  return 'fa-shopping-cart';
	      case 'ORDER_SUBCRIPTION':              return 'fa-shopping-cart';
	      case 'PUBLICATION_SPREAD_SHEET':       return 'fa-table';
	      case 'BLOG':                           return 'fa-blog';
	      case 'INVESTIGATION':                  return 'fa-investigation';
	      case 'SK3_FOLDER':                     return 'fa-lock';
	    }
	  };
	
	  /* FIXME: Move to service */
	  $scope.setPublicationStatus = function(origPublication, s) {
	    /* We need to make a clone here to prevent changes from
	     * appearing too early in the interface.
	     */
	    var p = angular.copy(origPublication);
	
	    p.status = s;
	
	    p.$update({companyId: $stateParams.companyId, status: s},
	      function() {
	        growl.addSuccessMessage(translations['publication.save-success']);
	
	        origPublication.status = s;
	      },
	      function(resp) {
	        if (304 === resp.status) {
	          return;
	        }
	
	        growl.addErrorMessage(translations['publication.save-failure'] + ': ' + resp.data.error.message);
	      });
	  };
	
	  /* FIXME: Move to service */
	  $scope.uploadFilesForPublication = function(files, publicationId) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
	        file: f,
	      };
	    }));
	  };
	
	  /* FIXME: Move to service or where it is used */
	  $scope.getPublicationsByQuery = function(q) {
	    if (q && q.length > 0) {
	      return CompanyPublicationService.query({companyId: $stateParams.companyId, q: q}).$promise.then(function(publications) {
	        return publications;
	      });
	    }
	  };
	
	  /* FIXME: Move to service */
	  $scope.toggleUploadLock = function(publication) {
	    if (publication.uploadLock) {
	      CompanyPublicationService.unlockFileUpload({companyId: $stateParams.companyId, publicationId: publication.id}, function () {
	        growl.addSuccessMessage(translations['publication.unlock-file-upload-success']);
	
	        publication.uploadLock = null;
	      }, function () {
	        growl.addErrorMessage(translations['publication.unlock-file-upload-failure']);
	      });
	    }
	
	    else {
	      CompanyPublicationService.lockFileUpload({companyId: $stateParams.companyId, publicationId: publication.id}, {}, function () {
	        growl.addSuccessMessage(translations['publication.lock-file-upload-success']);
	
	        publication.uploadLock = {
	          id: currentUser.id,
	          name: currentUser.name,
	          lockedAt: (new Date()).toISOString()
	        };
	      }, function () {
	        growl.addErrorMessage(translations['publication.lock-file-upload-failure']);
	      });
	    }
	  };
	
	  /* FIXME: Move to service */
	  $scope.savePublication = function(origPublication, tagsChanged) {
	    var p = angular.copy(origPublication);
	
	    // Format empty group value
	    if(!p.groups[0]) {
	      p.groups = [];
	    }
	    return p.$update({companyId: $stateParams.companyId},
	      function() {
	        if (tagsChanged) {
	          $scope.$emit('tagsChanged');
	        }
	        growl.addSuccessMessage(translations['publication.save-success']);
	        $scope.$broadcast('publicationSaved');
	      },
	      function(resp) {
	        if (304 === resp.status) {
	          $rootScope.sendUpdateEdit(true, currentUser, origPublication);
	          return;
	        }
	        CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: origPublication.id}, function (publication) {
	          origPublication = publication;
	        });
	
	        growl.addErrorMessage(translations['publication.save-failure'] + ': ' + resp.data.error.message);
	      }
	    );
	  };
	
	  /* FIXME: Move to service */
	  $scope.removeTag = function(publication, tag) {
	    publication.tags.splice(publication.tags.indexOf(tag), 1);
	
	    return $scope.savePublication(publication, true);
	  };
	
	  /* FIXME: Move to service */
	  $scope.addTagToPublication = function(publication, tag) {
	    if(publication.tags.indexOf(tag) === -1) {
	      publication.tags.push(tag);
	
	      angular.element('#filterTags').val('');
	
	      return $scope.savePublication(publication, true);
	    }
	  };
	
	  $scope.$on('eventReloadDashboard', function(){
	    if(stateSnapshot.previous.state.name === 'root.company.publications-list'){
	      $state.go(stateSnapshot.previous.state.name, stateSnapshot.previous.params, {reload: true});
	    }else{
	      if($state.current.name === 'root.company.publications-list'){
	        $state.reload();
	      }else{
	        window.localStorage.needToFetchDashboard = true;
	      }
	    }
	  });
	
	  $scope.openNewWindow = function(menu){
	    if(!menu.mainMenu){
	      if(menu.targetBlank){
	        $window.open(menu.link, 'newwindow', 'width=1200, height=800');
	      }else{
	        $window.location.href = menu.link;
	      }
	    }
	    return false;
	  };
	
	  $scope.showMoreMenu = function(){
	    var widthUl = angular.element('#manyMenu').width();
	    var widthLis = 0;
	    var i = 1;
	    angular.forEach(angular.element('#manyMenu > li'), function(ele){
	      widthLis += angular.element(ele).width();
	      if((widthLis + 29) > widthUl){
	        angular.element(ele).css('display', 'none');
	        angular.element('.menu-more').css('display', 'inherit');
	      }else{
	        angular.element(ele).css('display', 'inherit');
	        angular.element('.menu-more').css('display', 'none');
	        i++;
	      }
	    });
	    angular.element('#manyMenu > li:nth-child('+i+')').css('display', 'none');
	    var j = 1;
	    angular.forEach(angular.element('#manyMenu > li.menu-more > ul > li'), function(ele){
	      if(j < i){
	        angular.element(ele).css('display', 'none');
	      }else{
	        angular.element(ele).css('display', 'inherit');
	      }
	      j++;
	    });
	
	    if(angular.element('.header__nav').hasClass('nested-nav__search-focus')){
	      var widthWindowH = angular.element($window).width();
	      if(widthWindowH > 807){
	        var widthLogo = 253;
	        if(widthWindowH < 999){
	          widthLogo = 151;
	        }
	        angular.element('.header__nav').css('width', (widthWindowH-widthLogo)+'px');
	        angular.element('.header__nav .header__search').css('width', (widthWindowH-widthLogo-59)+'px');
	      }else{
	        angular.element('.header__nav').css('width', 'inherit');
	        angular.element('.header__nav .header__search').css('width', 'inherit');
	      }
	    }
	  }
	
	  setTimeout(function(){
	    $scope.showMoreMenu();
	  }, 50);
	
	  angular.element($window).on('resize', function () {
	    $scope.showMoreMenu();
	  });
	}
	
	var isStandardCompanyState = /^root\.company(\..*|$)/i;
	
	CompanyCtrl.resolve = {
	  company: ['$stateParams', 'stateSnapshot', '$state', 'CompanyService', function($stateParams, stateSnapshot, $state, CompanyService) {
	    return CompanyService.get({
	      companyId: $stateParams.companyId,
	      leaveCompany: stateSnapshot.previous.params.companyId || null
	    }).$promise.then(function(company) {
	      if(company.userType === "GUEST" && isStandardCompanyState.test(stateSnapshot.next.state.name)) {
	        $state.go(stateSnapshot.next.state.name.replace(isStandardCompanyState, 'root.company-guest$1'), stateSnapshot.next.params);
	
	        /* Required to prevent anything depending on company
	           from actually sending XHRs. */
	        throw new Error("Restarting routing");
	      }
	
	      return company;
	    });
	  }],
	  categories: ['$stateParams', 'CompanyCategoryService', 'company', function($stateParams, CompanyCategoryService) {
	    var page = parseInt($stateParams.pageCat, 10) || 1;
	
	    return CompanyCategoryService.query({
	      companyId: $stateParams.companyId,
	      nonEmpty:  "true",
	      limit:     21,
	      offset:    (page - 1) * 20
	    }).$promise;
	  }],
	  tags: ['$stateParams', 'CompanyService', 'company', function($stateParams, CompanyService) {
	    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
	  }],
	  customerPortals: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, type: 'VISIBLE', all: true}).$promise;
	  }],
	  currentUserPermissions: ['CurrentUserService', '$stateParams', function(CurrentUserService, $stateParams) {
	    return CurrentUserService.getPermissions($stateParams.companyId);
	  }],
	  priorities: ['$stateParams', 'CompanyService', 'userInformation', function($stateParams, CompanyService, userInformation) {
	    if(userInformation.type === 'DEFAULT'){
	      return CompanyService.queryPriorities({companyId: $stateParams.companyId}).$promise;
	    }
	    return [];
	  }],
	  groups: ['$stateParams', '$window', 'CompanyGroupService', function ($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({
	      companyId: $stateParams.companyId,
	      userId: $window.localStorage.userId,
	      type: null,
	      all: true
	    }).$promise;
	  }],
	  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
	    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
	  }],
	  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService) {
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
	  }],
	  role: ['CompanyUserRoleService', '$stateParams', 'userInformation', 'info', function(CompanyUserRoleService, $stateParams, userInformation, info){
	    var selectedRole = null;
	    if(userInformation.features.selectedRole){
	      selectedRole = userInformation.features.selectedRole;
	    }else if(userInformation.roles !== null && userInformation.roles[0]){
	      selectedRole = userInformation.roles[0];
	    }
	    if (info.features.userRole && selectedRole) {
	      return CompanyUserRoleService.get({
	        companyId: $stateParams.companyId,
	        roleId: selectedRole.id
	      }).$promise;
	    }
	    return null;
	  }],
	  notices: ['CompanyService', function(CompanyService){
	    return CompanyService.queryNotices().$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.save-success',
	      'publication.save-failure',
	      'publication.lock-file-upload-success',
	      'publication.lock-file-upload-failure',
	      'publication.unlock-file-upload-success',
	      'publication.unlock-file-upload-failure'
	    ]);
	  }]
	};
	module.exports = CompanyCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCtrl', [
	    '$scope',
	    '$rootScope',
	    'stateSnapshot',
	    'publicationTypes',
	    'categories',
	    'groups',
	    'tags',
	    'customerPortals',
	    'currentUserPermissions',
	    'currentUser',
	    'userInformation',
	    'role',
	    'translations',
	    '$state',
	    '$stateParams',
	    '$timeout',
	    '$translate',
	    '$filter',
	    'UploadTracker',
	    '$q',
	    '$modal',
	    '$window',
	    'growl',
	    'config',
	    'company',
	    'CompanyCategoryService',
	    'CompanyService',
	    'CompanyPublicationService',
	    'CompanyCommentsService',
	    'CompanyInfoService',
	    'CompanyUserService',
	    'info',
	    'notices',
	    'CompanyChecklistService',
	    CompanyCtrl
	  ]);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	
	"use strict";
	
	var PAGESIZE = 20;
	
	__webpack_require__(38);
	__webpack_require__(324);
	
	function FeedActivity(
	  CompanyFeedActivity,
	  CompanyFeedActivityTranslator,
	  $stateParams,
	  $state,
	  $modal,
	  $translate) {
	  return {
	    restrict:    "A",
	    templateUrl: "partials/company/comments/activities.html",
	    scope: {
	      source:       "=feedActivity",
	      user:         "=user",
	      types:        "=?types",
	      blogEnable:   "=?blogEnable",
	      blogEditable: "=?blogEditable",
	      guestView:    "=?guestView"
	    },
	    link: function($scope) {
	      $scope.loading    = false;
	      $scope.page       = 0;
	      $scope.activity   = [];
	      $scope.PAGESIZE   = PAGESIZE;
	      $scope.type       = '';
	      $scope.filterText = '';
	      $scope.companyId = $stateParams.companyId;
	
	      if ($stateParams.query) {
	        $scope.filterText = $stateParams.query;
	      }
	
	      if ($stateParams.type) {
	        $scope.type = $stateParams.type;
	      }
	      if($state.current.name === 'root.company.comments.list'){
	        $scope.type = 'COMMENT';
	      }
	      if($state.current.name === 'root.company.comments.messages'){
	        $scope.type = 'MESSAGE';
	      }
	
	      var modal;
	      $scope.showModalMessage = function(message) {
	        message.title = message.object.name;
	        message.content = message.text;
	        modal = $modal({
	          scope: $scope,
	          controller: 'CompanyBlogNewCtrl',
	          templateUrl: 'partials/company/blogs/modal-new.html',
	          show: true,
	          prefixEvent: 'modalMessageDirective',
	          resolve: {
	            message: function() {
	              return message;
	            }
	          }
	        });
	      };
	
	      $scope.$on('modalMessageDirective', function(){
	          modal.destroy();
	      });
	
	      $scope.loadData = function() {
	        $scope.loading = true;
	        $scope.page    = $scope.page > 0 ? $scope.page : 0;
	
	        /* TODO: That toUpperCase() should be removed
	         * and all constants should be uppercase instead.
	         */
	        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, $scope.type ? [$scope.type.toUpperCase()] : $scope.types, $scope.filterText).then(function(activity) {
	          $scope.hasNextPage = activity.length > PAGESIZE;
	          $scope.loading     = false;
	          $scope.activity    = activity.map(CompanyFeedActivityTranslator);
	          jQuery("html, body").animate({ scrollTop: 0 }, "slow");
	        });
	      };
	
	      $scope.search = function(text) {
	        if (!$scope.guestView)  {
	          if($state.current.name === 'root.company.comments.list'){
	            $state.go('root.company.comments.list', {query: text});
	          }else{
	            if($state.current.name === 'root.company.comments.messages'){
	              $state.go('root.company.comments.messages', {query: text});
	            }
	          }
	        } else {
	          $state.go('root.company-guest.comments', {query: text});
	        }
	      };
	
	      if( ! $scope.types) {
	        $scope.types = [];
	      }
	
	      $scope.filterType = [
	        {
	          label: $translate.instant('all'),
	          value: ''
	        },
	        {
	          label: $translate.instant('comment'),
	          value: 'COMMENT'
	        },
	        {
	          label: $translate.instant('message'),
	          value: 'MESSAGE'
	        }
	      ];
	
	      $scope.loadData();
	
	      $scope.$on('notification', function(e, data) {
	        if (data.type === 'COMMENT' && data.message.parentID === 'undefined') {
	          var c = {
	            text: data.message.text,
	            createdAt: (new Date()).toISOString(),
	            type: "comment",
	            user:      data.sourceUser,
	            object: data.publication
	          };
	          $scope.$apply(function(){
	            $scope.activity.unshift(c);
	            $scope.source.prependDataTo("COMMENT", c);
	            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
	          });
	        }
	      });
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("feedActivity", [
	    "CompanyFeedActivity",
	    "CompanyFeedActivityTranslator",
	    "$stateParams",
	    "$state",
	    "$modal",
	    "$translate", FeedActivity]);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	function SearchPortalDirective($stateParams, CompanyGroupService) {
	  return {
	    restrict: 'EA',
	    scope: {
	      currentPortals: '='
	    },
	    replace: true,
	    link: function(scope) {
	      scope.queryPortals = function(text) {
	        CompanyGroupService.query({
	          companyId: $stateParams.companyId,
	          q: text,
	          type: 'VISIBLE',
	          limit: 10
	        }, function(resp){
	          scope.portals = resp.filter(function(g){
	            return !scope.currentPortals.some(function(c){
	              return c.id === g.id;
	            });
	          });
	        });
	      };
	
	      scope.addPortal = function(portal) {
	        scope.currentPortals.push(portal);
	        scope.portals.splice(scope.portals.indexOf(portal), 1);
	      };
	
	      scope.removePortal = function(portal) {
	        scope.currentPortals.splice(scope.currentPortals.indexOf(portal), 1);
	      };
	    },
	    templateUrl: 'partials/company/email-to-object/search-portal.html'
	  };
	}
	
	angular.module('dokiv')
	  .directive('searchPortal', ['$stateParams', 'CompanyGroupService', SearchPortalDirective]);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGroupCategoryService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/group-category/:categoryId', {categoryId: "@id"}, {
	    'update': { method: 'PUT' },
	    'delete': { method: 'DELETE'}
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyGroupCategoryService', ['$resource', 'config', CompanyGroupCategoryService]);


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationKeypassService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/keypass', {}, {
	    'update': {
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationKeypassService', ['$resource', 'config', CompanyPublicationKeypassService]);


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationWatcherService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/watchers/:watcherId', {});
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationWatcherService', ['$resource', 'config', CompanyPublicationWatcherService]);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyUserLinksCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'link',
	  'index'
	];
	
	function CompanyUserLinksCtrl(
	  $scope,
	  $stateParams,
	  link,
	  index) {
	
	  $scope.isEdit = false;
	  if (link) {
	    $scope.shortcut = link;
	    $scope.isEdit = true;
	  }
	
	  $scope.saveUserLink = function(shortcut) {
	    if (!$scope.isEdit) {
	      $scope.userLinks.push(shortcut);
	    } else {
	      $scope.userInfo.features.userLinks[index] = shortcut;
	    }
	
	    $scope.userInfo.features.userLinks = $scope.userLinks;
	    $scope.userInfo.$update({companyId: $stateParams.companyId, userId: $scope.userInfo.id});
	  };
	
	  $scope.deleteUserLink = function() {
	    $scope.userLinks.splice(index, 1);
	    $scope.userInfo.features.userLinks = $scope.userLinks;
	    $scope.userInfo.$update({companyId: $stateParams.companyId, userId: $scope.userInfo.id});
	    $scope.$hide();
	  };
	
	}
	
	
	angular.module('dokiv')
	  .controller('CompanyUserLinksCtrl', CompanyUserLinksCtrl);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationBlogService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/posts/:postId', {}, {
	    'updatePost': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/posts/:postId',
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationBlogService', ['$resource', 'config', CompanyPublicationBlogService]);


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationCompanyOrderSubcriptionService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'updateItems':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items',
	      method: 'POST'
	    },
	    'updateItem':  {
	        url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items/:itemId',
	        method: 'PUT'
	    },
	    'deleteItem': {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items/:itemId',
	      method: 'DELETE'
	    },
	    'createNextOrder':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/orders',
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationCompanyOrderSubcriptionService', ['$resource', 'config', CompanyPublicationCompanyOrderSubcriptionService]);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanySkillsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/skills/:skillId', {}, {
	    'update':  {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanySkillsService', ['$resource', 'config', CompanySkillsService]);


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyUserPermissionService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/users/:userId/permissions/:permissionId', {}, {
	    'query': { method: 'GET', isArray: false },
	    'update': { method:'PUT' }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyUserPermissionService', ['$resource', 'config', CompanyUserPermissionService]);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var config;
	if (true) {
	    config = {
	        'apiBase': 'https://api.dokiv.com/v1',
	        'shareURLBase': 'https://share.dokiv.com/',
	        'formApiBase': 'http://api.dokiv.com/v1',
	        'appId': '340c61b6-db42-4273-a91c-46e47ab94c14',
	        'portalUrl': 'https://portal.dokiv.com'
	    };
	} else {
	    console.log('Using dev config');
	    config = {
	        'apiBase': 'https://api.devnew.dokiv.se/v1',
	        'shareURLBase': 'https://share.devnew.dokiv.com/',
	        'formApiBase': 'http://api.devnew.dokiv.se/v1',
	        'appId': '3f49d195-e061-49ea-9ba8-987ded37c9e9',
	        'portalUrl': 'https://portal.devnew.dokiv.se'
	    };
	}
	
	angular.module('dokiv')
	    .value('config', config);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	function HowToCtrl(
	  $scope,
	  translations
	) {
	  $scope.translations = translations;
	}
	
	HowToCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'guide.markdown'
	    ]);
	  }]
	};
	
	module.exports = HowToCtrl;
	
	angular.module('dokiv')
	  .controller('HowToCtrl', [
	    '$scope',
	    'translations',
	    HowToCtrl
	  ]);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(49);
	var GetIntrinsic = __webpack_require__(22);
	var setFunctionLength = __webpack_require__(536);
	
	var $TypeError = __webpack_require__(32);
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = __webpack_require__(48);
	var $max = GetIntrinsic('%Math.max%');
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(72);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(48);
	
	var $SyntaxError = __webpack_require__(75);
	var $TypeError = __webpack_require__(32);
	
	var gopd = __webpack_require__(77);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(227);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(73);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(79)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var flatpickr = function flatpickr(selector, config) {
		var elements = void 0;
	
		var createInstance = function createInstance(element) {
			if (element._flatpickr) {
				element._flatpickr.destroy();
			}
	
			element._flatpickr = new flatpickr.init(element, config);
			return element._flatpickr;
		};
	
		if (selector.nodeName) {
			return createInstance(selector);
		}
		/*
	 Utilize the performance of native getters if applicable
	 https://jsperf.com/getelementsbyclassname-vs-queryselectorall/18
	 https://jsperf.com/jquery-vs-javascript-performance-comparison/22
	 */
		else if (/^#[a-zA-Z0-9\-_]*$/.test(selector)) {
				return createInstance(document.getElementById(selector.slice(1)));
			} else if (/^\.[a-zA-Z0-9\-_]*$/.test(selector)) {
				elements = document.getElementsByClassName(selector.slice(1));
			} else {
				elements = document.querySelectorAll(selector);
			}
	
		var instances = [];
	
		for (var i = 0; i < elements.length; i++) {
			instances.push(createInstance(elements[i]));
		}
	
		if (instances.length === 1) {
			return instances[0];
		}
	
		return {
			calendars: instances,
			byID: function byID(id) {
				return document.getElementById(id)._flatpickr;
			}
		};
	};
	
	/**
	 * @constructor
	 */
	flatpickr.init = function (element, instanceConfig) {
		function createElement(tag, className, content) {
			var newElement = document.createElement(tag);
	
			if (content) {
				newElement.textContent = content;
			}
	
			if (className) {
				newElement.className = className;
			}
	
			return newElement;
		}
	
		var debounce = function debounce(func, wait, immediate) {
			var timeout = void 0;
			return function () {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}
	
				var context = this;
	
				var later = function later() {
					timeout = null;
					if (!immediate) {
						func.apply(context, args);
					}
				};
	
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (immediate && !timeout) {
					func.apply(context, args);
				}
			};
		};
	
		// functions
		var self = this;
		var parseConfig = void 0,
		    init = void 0,
		    wrap = void 0,
		    uDate = void 0,
		    equalDates = void 0,
		    pad = void 0,
		    monthToStr = void 0,
		    isEnabled = void 0,
		    buildMonthNavigation = void 0,
		    buildWeekdays = void 0,
		    buildCalendar = void 0,
		    buildDays = void 0,
		    buildWeeks = void 0,
		    buildTime = void 0,
		    timeWrapper = void 0,
		    yearScroll = void 0,
		    updateValue = void 0,
		    amPMToggle = void 0,
		    onKeyDown = void 0,
		    onResize = void 0,
		    updateNavigationCurrentMonth = void 0,
		    handleYearChange = void 0,
		    changeMonth = void 0,
		    getDaysinMonth = void 0,
		    documentClick = void 0,
		    selectDate = void 0,
		    getRandomCalendarIdStr = void 0,
		    bind = void 0,
		    triggerChange = void 0;
	
		// elements & variables
		var calendarContainer = void 0,
		    weekdayContainer = void 0,
		    timeContainer = void 0,
		    navigationCurrentMonth = void 0,
		    monthsNav = void 0,
		    prevMonthNav = void 0,
		    currentYearElement = void 0,
		    currentMonthElement = void 0,
		    nextMonthNav = void 0,
		    calendar = void 0,
		    weekNumbers = void 0,
		    now = new Date(),
		    wrapperElement = void 0,
		    clickEvt = void 0;
	
		self.formats = {
			// weekday name, short, e.g. Thu
			D: function D() {
				return self.l10n.weekdays.shorthand[self.formats.w()];
			},
	
			// full month name e.g. January
			F: function F() {
				return monthToStr(self.formats.n() - 1, false);
			},
	
			// hours with leading zero e.g. 03
			H: function H() {
				return pad(self.selectedDateObj.getHours());
			},
	
			// day (1-30) with ordinal suffix e.g. 1st, 2nd
			J: function J() {
				return self.formats.j() + self.l10n.ordinal(self.formats.j());
			},
	
			// AM/PM
			K: function K() {
				return self.selectedDateObj.getHours() > 11 ? "PM" : "AM";
			},
	
			// shorthand month e.g. Jan, Sep, Oct, etc
			M: function M() {
				return monthToStr(self.formats.n() - 1, true);
			},
	
			// seconds 00-59
			S: function S() {
				return pad(self.selectedDateObj.getSeconds());
			},
	
			// unix timestamp
			U: function U() {
				return self.selectedDateObj.getTime() / 1000;
			},
	
			// full year e.g. 2016
			Y: function Y() {
				return self.selectedDateObj.getFullYear();
			},
	
			// day in month, padded (01-30)
			d: function d() {
				return pad(self.formats.j());
			},
	
			// hour from 1-12 (am/pm)
			h: function h() {
				return self.selectedDateObj.getHours() % 12 ? self.selectedDateObj.getHours() % 12 : 12;
			},
	
			// minutes, padded with leading zero e.g. 09
			i: function i() {
				return pad(self.selectedDateObj.getMinutes());
			},
	
			// day in month (1-30)
			j: function j() {
				return self.selectedDateObj.getDate();
			},
	
			// weekday name, full, e.g. Thursday
			l: function l() {
				return self.l10n.weekdays.longhand[self.formats.w()];
			},
	
			// padded month number (01-12)
			m: function m() {
				return pad(self.formats.n());
			},
	
			// the month number (1-12)
			n: function n() {
				return self.selectedDateObj.getMonth() + 1;
			},
	
			// seconds 0-59
			s: function s() {
				return self.selectedDateObj.getSeconds();
			},
	
			// number of the day of the week
			w: function w() {
				return self.selectedDateObj.getDay();
			},
	
			// last two digits of year e.g. 16 for 2016
			y: function y() {
				return String(self.formats.Y()).substring(2);
			}
		};
	
		self.defaultConfig = {
			/* if true, dates will be parsed, formatted, and displayed in UTC.
	  preloading date strings w/ timezones is recommended but not necessary */
			utc: false,
	
			// wrap: see https://chmln.github.io/flatpickr/#strap
			wrap: false,
	
			// enables week numbers
			weekNumbers: false,
	
			allowInput: false,
	
			/*
	  	clicking on input opens the date(time)picker.
	  	disable if you wish to open the calendar manually with .open()
	  */
			clickOpens: true,
	
			// display time picker in 24 hour mode
			time_24hr: false,
	
			// enables the time picker functionality
			enableTime: false,
	
			// noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
			noCalendar: false,
	
			// more date format chars at https://chmln.github.io/flatpickr/#dateformat
			dateFormat: "Y-m-d",
	
			// altInput - see https://chmln.github.io/flatpickr/#altinput
			altInput: false,
	
			// the created altInput element will have this class.
			altInputClass: "",
	
			// same as dateFormat, but for altInput
			altFormat: "F j, Y", // defaults to e.g. June 10, 2016
	
			// defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
			defaultDate: null,
	
			// the minimum date that user can pick (inclusive)
			minDate: null,
	
			// the maximum date that user can pick (inclusive)
			maxDate: null,
	
			// dateparser that transforms a given string to a date object
			parseDate: null,
	
			// see https://chmln.github.io/flatpickr/#disable
			enable: [],
	
			// see https://chmln.github.io/flatpickr/#disable
			disable: [],
	
			// display the short version of month names - e.g. Sep instead of September
			shorthandCurrentMonth: false,
	
			// displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
			inline: false,
	
			// position calendar inside wrapper and next to the input element
			// leave at false unless you know what you"re doing
			static: false,
	
			// code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
			prevArrow: "&lt;",
			nextArrow: "&gt;",
	
			// enables seconds in the time picker
			enableSeconds: false,
	
			// step size used when scrolling/incrementing the hour element
			hourIncrement: 1,
	
			// step size used when scrolling/incrementing the minute element
			minuteIncrement: 5,
	
			// onChange callback when user selects a date or time
			onChange: null, // function (dateObj, dateStr) {}
	
			// called every time calendar is opened
			onOpen: null, // function (dateObj, dateStr) {}
	
			// called every time calendar is closed
			onClose: null, // function (dateObj, dateStr) {}
	
			onValueUpdate: null
		};
	
		init = function init() {
			instanceConfig = instanceConfig || {};
	
			self.element = element;
	
			parseConfig();
	
			self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
			self.input.classList.add("flatpickr-input");
	
			if (self.config.defaultDate) {
				self.config.defaultDate = uDate(self.config.defaultDate);
			}
	
			if (self.input.value || self.config.defaultDate) {
				self.selectedDateObj = uDate(self.config.defaultDate || self.input.value);
			}
	
			wrap();
			buildCalendar();
			bind();
	
			self.uDate = uDate;
			self.jumpToDate();
			updateValue();
		};
	
		parseConfig = function parseConfig() {
			self.config = {};
	
			Object.keys(self.defaultConfig).forEach(function (key) {
				if (instanceConfig.hasOwnProperty(key)) {
					self.config[key] = instanceConfig[key];
				} else if (self.element.dataset && self.element.dataset.hasOwnProperty(key.toLowerCase())) {
					self.config[key] = self.element.dataset[key.toLowerCase()];
				} else if (!self.element.dataset && self.element.hasAttribute("data-" + key)) {
					self.config[key] = self.element.getAttribute("data-" + key);
				} else {
					self.config[key] = flatpickr.init.prototype.defaultConfig[key] || self.defaultConfig[key];
				}
	
				if (typeof self.defaultConfig[key] === "boolean") {
					self.config[key] = self.config[key] === true || self.config[key] === "" || self.config[key] === "true";
				}
	
				if (key === "enableTime" && self.config[key]) {
					self.defaultConfig.dateFormat = !self.config.time_24hr ? "Y-m-d h:i K" : "Y-m-d H:i";
					self.defaultConfig.altFormat = !self.config.time_24hr ? "F j Y, h:i K" : "F j, Y H:i";
				} else if (key === "noCalendar" && self.config[key]) {
					self.defaultConfig.dateFormat = "h:i K";
					self.defaultConfig.altFormat = "h:i K";
				}
			});
		};
	
		getRandomCalendarIdStr = function getRandomCalendarIdStr() {
			var randNum = void 0,
			    idStr = void 0;
			do {
				randNum = Math.round(Math.random() * Math.pow(10, 10));
				idStr = "flatpickr-" + randNum;
			} while (document.getElementById(idStr) !== null);
	
			return idStr;
		};
	
		uDate = function uDate(date, timeless) {
			timeless = timeless || false;
	
			if (date === "today") {
				date = new Date();
				timeless = true;
			} else if (typeof date === "string") {
				date = date.trim();
	
				if (self.config.parseDate) {
					date = self.config.parseDate(date);
				} else if (/^\d\d\d\d\-\d{1,2}\-\d\d$/.test(date)) {
					// this utc datestring gets parsed, but incorrectly by Date.parse
					date = new Date(date.replace(/(\d)-(\d)/g, "$1/$2"));
				} else if (Date.parse(date)) {
					date = new Date(date);
				} else if (/^\d\d\d\d\-\d\d\-\d\d/.test(date)) {
					// disable special utc datestring
					date = new Date(date.replace(/(\d)-(\d)/g, "$1/$2"));
				} else if (/^(\d?\d):(\d\d)/.test(date)) {
					// time-only picker
					var matches = date.match(/^(\d?\d):(\d\d)(:(\d\d))?/),
					    seconds = matches[4] !== undefined ? matches[4] : 0;
	
					date = new Date();
					date.setHours(matches[1], matches[2], seconds, 0);
				} else {
					console.error("flatpickr: invalid date string " + date);
					console.info(self.element);
				}
			}
	
			if (!(date instanceof Date) || !date.getTime()) {
				return null;
			}
	
			if (self.config.utc && !date.fp_isUTC) {
				date = date.fp_toUTC();
			}
	
			if (timeless) {
				date.setHours(0, 0, 0, 0);
			}
	
			return date;
		};
	
		equalDates = function equalDates(date1, date2) {
			return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
		};
	
		wrap = function wrap() {
			wrapperElement = createElement("div", "flatpickr-wrapper");
	
			if (self.config.inline || self.config.static) {
				// Wrap input and place calendar underneath
				self.element.parentNode.insertBefore(wrapperElement, self.element);
				wrapperElement.appendChild(self.element);
	
				wrapperElement.classList.add(self.config.inline ? "inline" : "static");
			} else {
				// Insert at bottom of BODY tag to display outside
				// of relative positioned elements with css "overflow: hidden;"
				// property set.
				document.body.appendChild(wrapperElement);
			}
	
			if (self.config.altInput) {
				// replicate self.element
				self.altInput = createElement(self.input.nodeName, self.config.altInputClass + " flatpickr-input");
				self.altInput.placeholder = self.input.placeholder;
				self.altInput.type = "text";
	
				self.input.type = "hidden";
				self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
			}
		};
	
		getDaysinMonth = function getDaysinMonth() {
			var month = arguments.length <= 0 || arguments[0] === undefined ? self.currentMonth : arguments[0];
	
			var yr = self.currentYear;
	
			if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) {
				return 29;
			}
	
			return self.l10n.daysInMonth[month];
		};
	
		updateValue = function updateValue(e) {
			if (self.config.noCalendar && !self.selectedDateObj) {
				// picking time only and method triggered from picker
				self.selectedDateObj = new Date();
			} else if (!self.selectedDateObj) {
				return;
			}
	
			if (e) {
				e.target.blur();
			}
	
			var timeHasChanged = void 0;
	
			if (self.config.enableTime) {
				var previousTimestamp = self.selectedDateObj.getTime();
	
				// update time
				var hours = parseInt(self.hourElement.value, 10) || 0,
				    seconds = void 0;
	
				var minutes = (60 + (parseInt(self.minuteElement.value, 10) || 0)) % 60;
	
				if (self.config.enableSeconds) {
					seconds = (60 + parseInt(self.secondElement.value, 10) || 0) % 60;
				}
	
				if (!self.config.time_24hr) {
					// the real number of hours for the date object
					hours = hours % 12 + 12 * (self.amPM.innerHTML === "PM");
				}
	
				self.selectedDateObj.setHours(hours, minutes, seconds === undefined ? self.selectedDateObj.getSeconds() : seconds);
	
				self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (hours % 12 === 0) : hours);
				self.minuteElement.value = pad(minutes);
	
				if (seconds !== undefined) {
					self.secondElement.value = pad(seconds);
				}
	
				timeHasChanged = self.selectedDateObj.getTime() !== previousTimestamp;
			}
	
			self.input.value = self.formatDate(self.config.dateFormat);
	
			if (self.altInput) {
				self.altInput.value = self.formatDate(self.config.altFormat);
			}
	
			if (e && (timeHasChanged || e.target.classList.contains("flatpickr-day"))) {
				triggerChange();
			}
	
			if (self.config.onValueUpdate) {
				self.config.onValueUpdate(self.selectedDateObj, self.input.value, self);
			}
		};
	
		pad = function pad(num) {
			return ("0" + num).slice(-2);
		};
	
		self.formatDate = function (dateFormat) {
			var formattedDate = "";
			var formatPieces = dateFormat.split("");
	
			for (var i = 0; i < formatPieces.length; i++) {
				var c = formatPieces[i];
				if (self.formats.hasOwnProperty(c) && formatPieces[i - 1] !== "\\") {
					formattedDate += self.formats[c]();
				} else if (c !== "\\") {
					formattedDate += c;
				}
			}
	
			return formattedDate;
		};
	
		monthToStr = function monthToStr(date, shorthand) {
			if (shorthand || self.config.shorthandCurrentMonth) {
				return self.l10n.months.shorthand[date];
			}
	
			return self.l10n.months.longhand[date];
		};
	
		isEnabled = function isEnabled(dateToCheck) {
			if (self.config.minDate && dateToCheck < self.config.minDate || self.config.maxDate && dateToCheck > self.config.maxDate) {
				return false;
			}
	
			dateToCheck = uDate(dateToCheck, true); // timeless
	
			var bool = self.config.enable.length > 0,
			    array = bool ? self.config.enable : self.config.disable;
	
			var d = void 0;
	
			for (var i = 0; i < array.length; i++) {
				d = array[i];
	
				if (d instanceof Function && d(dateToCheck)) {
					// disabled by function
					return bool;
				} else if ( // disabled weekday
				typeof d === "string" && /^wkd/.test(d) && dateToCheck.getDay() === (parseInt(d.slice(-1), 10) + self.l10n.firstDayOfWeek - 1) % 7) {
					return bool;
				} else if ((d instanceof Date || typeof d === "string" && !/^wkd/.test(d)) && uDate(d, true).getTime() === dateToCheck.getTime()) {
					// disabled by date string
					return bool;
				} else if ( // disabled by range
				(typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" && d.hasOwnProperty("from") && dateToCheck >= uDate(d.from) && dateToCheck <= uDate(d.to)) {
					return bool;
				}
			}
	
			return !bool;
		};
	
		yearScroll = function yearScroll(event) {
			event.preventDefault();
	
			var delta = Math.max(-1, Math.min(1, event.wheelDelta || -event.deltaY));
			self.currentYear = event.target.value = parseInt(event.target.value, 10) + delta;
			self.redraw();
		};
	
		timeWrapper = function timeWrapper(e) {
			e.preventDefault();
	
			var min = parseInt(e.target.min, 10),
			    max = parseInt(e.target.max, 10),
			    step = parseInt(e.target.step, 10),
			    value = parseInt(e.target.value, 10);
	
			var newValue = value;
	
			if (e.type === "wheel") {
				newValue = value + step * Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY));
			}
	
			if (newValue <= min) {
				newValue = max - step;
			} else if (newValue >= max) {
				newValue = min + step;
			}
	
			e.target.value = pad(newValue);
		};
	
		updateNavigationCurrentMonth = function updateNavigationCurrentMonth() {
			currentMonthElement.textContent = monthToStr(self.currentMonth) + " ";
			currentYearElement.value = self.currentYear;
		};
	
		handleYearChange = function handleYearChange() {
			if (self.currentMonth < 0 || self.currentMonth > 11) {
				self.currentYear += self.currentMonth % 11;
				self.currentMonth = (self.currentMonth + 12) % 12;
			}
		};
	
		documentClick = function documentClick(e) {
			var isCalendarElement = wrapperElement.contains(e.relatedTarget || e.target),
			    isInput = self.element.contains(e.relatedTarget || e.target) || e.relatedTarget || e.target === self.altInput;
	
			if (self.isOpen && !isCalendarElement && !isInput) {
				self.close();
			}
		};
	
		changeMonth = function changeMonth(offset) {
			self.currentMonth += offset;
	
			handleYearChange();
			updateNavigationCurrentMonth();
			buildDays();
			(self.config.noCalendar ? timeContainer : calendar).focus();
		};
	
		selectDate = function selectDate(e) {
			e.preventDefault();
			e.stopPropagation();
	
			if (self.config.allowInput && e.target === (self.altInput || self.input) && e.which === 13) {
				self.setDate((self.altInput || self.input).value);
				self.redraw();
			} else if (e.target.classList.contains("flatpickr-day")) {
				var isPrevMonthDay = e.target.classList.contains("prevMonthDay"),
				    isNextMonthDay = e.target.classList.contains("nextMonthDay"),
				    monthNum = self.currentMonth - isPrevMonthDay + isNextMonthDay;
	
				if (isPrevMonthDay || isNextMonthDay) {
					changeMonth(+isNextMonthDay - isPrevMonthDay);
				}
	
				self.selectedDateObj = new Date(self.currentYear, monthNum, e.target.innerHTML);
	
				updateValue(e);
				buildDays();
	
				if (!self.config.enableTime) {
					self.close();
				}
			}
		};
	
		buildCalendar = function buildCalendar() {
			calendarContainer = createElement("div", "flatpickr-calendar");
			calendarContainer.id = getRandomCalendarIdStr();
	
			calendar = createElement("div", "flatpickr-days");
			calendar.tabIndex = -1;
	
			if (!self.config.noCalendar) {
				buildMonthNavigation();
				buildWeekdays();
	
				if (self.config.weekNumbers) {
					buildWeeks();
				}
	
				buildDays();
	
				calendarContainer.appendChild(calendar);
			}
	
			wrapperElement.appendChild(calendarContainer);
	
			if (self.config.enableTime) {
				buildTime();
			}
		};
	
		buildMonthNavigation = function buildMonthNavigation() {
			monthsNav = createElement("div", "flatpickr-month");
	
			prevMonthNav = createElement("span", "flatpickr-prev-month");
			prevMonthNav.innerHTML = self.config.prevArrow;
	
			currentMonthElement = createElement("span", "cur_month");
	
			currentYearElement = createElement("input", "cur_year");
			currentYearElement.type = "number";
			currentYearElement.title = self.l10n.scrollTitle;
	
			nextMonthNav = createElement("span", "flatpickr-next-month");
			nextMonthNav.innerHTML = self.config.nextArrow;
	
			navigationCurrentMonth = createElement("span", "flatpickr-current-month");
			navigationCurrentMonth.appendChild(currentMonthElement);
			navigationCurrentMonth.appendChild(currentYearElement);
	
			monthsNav.appendChild(prevMonthNav);
			monthsNav.appendChild(navigationCurrentMonth);
			monthsNav.appendChild(nextMonthNav);
	
			calendarContainer.appendChild(monthsNav);
			updateNavigationCurrentMonth();
		};
	
		buildWeekdays = function buildWeekdays() {
			weekdayContainer = createElement("div", "flatpickr-weekdays");
			var firstDayOfWeek = self.l10n.firstDayOfWeek;
	
			var weekdays = self.l10n.weekdays.shorthand.slice();
	
			if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
				weekdays = [].concat(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
			}
	
			if (self.config.weekNumbers) {
				weekdayContainer.innerHTML = "<span>" + self.l10n.weekAbbreviation + "</span>";
			}
	
			weekdayContainer.innerHTML += "<span>" + weekdays.join("</span><span>") + "</span>";
	
			calendarContainer.appendChild(weekdayContainer);
		};
	
		buildWeeks = function buildWeeks() {
			calendarContainer.classList.add("hasWeeks");
	
			weekNumbers = createElement("div", "flatpickr-weeks");
			calendarContainer.appendChild(weekNumbers);
		};
	
		buildDays = function buildDays() {
			var firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7,
			    daysInMonth = getDaysinMonth(),
			    prevMonthDays = getDaysinMonth((self.currentMonth - 1 + 12) % 12),
			    days = document.createDocumentFragment();
	
			var dayNumber = prevMonthDays + 1 - firstOfMonth,
			    currentDate = void 0,
			    dateIsDisabled = void 0;
	
			if (self.config.weekNumbers) {
				weekNumbers.innerHTML = "";
			}
	
			calendar.innerHTML = "";
	
			self.config.minDate = uDate(self.config.minDate, true);
			self.config.maxDate = uDate(self.config.maxDate, true);
	
			// prepend days from the ending of previous month
			for (; dayNumber <= prevMonthDays; dayNumber++) {
				var curDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber, 0, 0, 0, 0, 0),
				    dateIsEnabled = isEnabled(curDate),
				    dayElem = createElement("span", dateIsEnabled ? "flatpickr-day prevMonthDay" : "disabled", dayNumber);
	
				if (dateIsEnabled) {
					dayElem.tabIndex = 0;
				}
	
				days.appendChild(dayElem);
			}
	
			// Start at 1 since there is no 0th day
			for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
				currentDate = new Date(self.currentYear, self.currentMonth, dayNumber, 0, 0, 0, 0, 0);
	
				if (self.config.weekNumbers && dayNumber % 7 === 1) {
					weekNumbers.appendChild(createElement("span", "disabled flatpickr-day", currentDate.fp_getWeek()));
				}
	
				dateIsDisabled = !isEnabled(currentDate);
	
				var dayElement = createElement("span", dateIsDisabled ? "disabled" : "flatpickr-day", dayNumber);
	
				if (!dateIsDisabled) {
					dayElement.tabIndex = 0;
	
					if (equalDates(currentDate, now)) {
						dayElement.classList.add("today");
					}
	
					if (self.selectedDateObj && equalDates(currentDate, self.selectedDateObj)) {
						dayElement.classList.add("selected");
					}
				}
	
				days.appendChild(dayElement);
			}
	
			// append days from the next month
			for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth; dayNum++) {
				var _curDate = new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth, 0, 0, 0, 0, 0),
				    _dateIsEnabled = isEnabled(_curDate),
				    _dayElement = createElement("span", _dateIsEnabled ? "nextMonthDay flatpickr-day" : "disabled", dayNum % daysInMonth);
	
				if (self.config.weekNumbers && dayNum % 7 === 1) {
					weekNumbers.appendChild(createElement("span", "disabled", _curDate.fp_getWeek()));
				}
	
				if (_dateIsEnabled) {
					_dayElement.tabIndex = 0;
				}
	
				days.appendChild(_dayElement);
			}
	
			calendar.appendChild(days);
		};
	
		buildTime = function buildTime() {
			timeContainer = createElement("div", "flatpickr-time");
			timeContainer.tabIndex = -1;
			var separator = createElement("span", "flatpickr-time-separator", ":");
	
			self.hourElement = createElement("input", "flatpickr-hour");
			self.minuteElement = createElement("input", "flatpickr-minute");
	
			self.hourElement.tabIndex = self.minuteElement.tabIndex = 0;
			self.hourElement.type = self.minuteElement.type = "number";
	
			self.hourElement.value = self.selectedDateObj ? pad(self.selectedDateObj.getHours()) : 12;
	
			self.minuteElement.value = self.selectedDateObj ? pad(self.selectedDateObj.getMinutes()) : "00";
	
			self.hourElement.step = self.config.hourIncrement;
			self.minuteElement.step = self.config.minuteIncrement;
	
			self.hourElement.min = -self.config.time_24hr;
			self.hourElement.max = self.config.time_24hr ? 24 : 13;
	
			self.minuteElement.min = -self.minuteElement.step;
			self.minuteElement.max = 60;
	
			self.hourElement.title = self.minuteElement.title = self.l10n.scrollTitle;
	
			timeContainer.appendChild(self.hourElement);
			timeContainer.appendChild(separator);
			timeContainer.appendChild(self.minuteElement);
	
			if (self.config.enableSeconds) {
				timeContainer.classList.add("has-seconds");
	
				self.secondElement = createElement("input", "flatpickr-second");
				self.secondElement.type = "number";
				self.secondElement.value = self.selectedDateObj ? pad(self.selectedDateObj.getSeconds()) : "00";
	
				self.secondElement.step = self.minuteElement.step;
				self.secondElement.min = self.minuteElement.min;
				self.secondElement.max = self.minuteElement.max;
	
				timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
				timeContainer.appendChild(self.secondElement);
			}
	
			if (!self.config.time_24hr) {
				// add self.amPM if appropriate
				self.amPM = createElement("span", "flatpickr-am-pm", ["AM", "PM"][self.hourElement.value > 11 | 0]);
				self.amPM.title = self.l10n.toggleTitle;
				self.amPM.tabIndex = 0;
				timeContainer.appendChild(self.amPM);
			}
	
			calendarContainer.appendChild(timeContainer);
		};
	
		bind = function bind() {
			document.addEventListener("keydown", onKeyDown);
			window.addEventListener("resize", onResize);
	
			if (self.config.clickOpens) {
				(self.altInput || self.input).addEventListener("click", self.open);
				(self.altInput || self.input).addEventListener("focus", self.open);
			}
	
			if (self.config.wrap && self.element.querySelector("[data-open]")) {
				self.element.querySelector("[data-open]").addEventListener("click", self.open);
			}
	
			if (self.config.wrap && self.element.querySelector("[data-close]")) {
				self.element.querySelector("[data-close]").addEventListener("click", self.close);
			}
	
			if (self.config.wrap && self.element.querySelector("[data-toggle]")) {
				self.element.querySelector("[data-toggle]").addEventListener("click", self.toggle);
			}
	
			if (self.config.wrap && self.element.querySelector("[data-clear]")) {
				self.element.querySelector("[data-clear]").addEventListener("click", self.clear);
			}
	
			if (!self.config.noCalendar) {
				prevMonthNav.addEventListener("click", function () {
					changeMonth(-1);
				});
	
				nextMonthNav.addEventListener("click", function () {
					changeMonth(1);
				});
	
				currentYearElement.addEventListener("wheel", yearScroll);
				currentYearElement.addEventListener("focus", currentYearElement.select);
	
				currentYearElement.addEventListener("input", function (event) {
					self.currentYear = parseInt(event.target.value, 10);
					self.redraw();
				});
	
				calendar.addEventListener("click", selectDate);
			}
	
			document.addEventListener("click", documentClick, true);
			document.addEventListener("focus", documentClick, true);
	
			if (self.config.enableTime) {
				self.hourElement.addEventListener("wheel", timeWrapper);
				self.minuteElement.addEventListener("wheel", timeWrapper);
	
				self.hourElement.addEventListener("input", timeWrapper);
				self.minuteElement.addEventListener("input", timeWrapper);
	
				self.hourElement.addEventListener("mouseout", updateValue);
				self.minuteElement.addEventListener("mouseout", updateValue);
	
				self.hourElement.addEventListener("change", updateValue);
				self.minuteElement.addEventListener("change", updateValue);
	
				self.hourElement.addEventListener("focus", self.hourElement.select);
				self.minuteElement.addEventListener("focus", self.minuteElement.select);
	
				if (self.config.enableSeconds) {
					self.secondElement.addEventListener("wheel", timeWrapper);
					self.secondElement.addEventListener("input", timeWrapper);
					self.secondElement.addEventListener("mouseout", updateValue);
					self.secondElement.addEventListener("change", updateValue);
					self.secondElement.addEventListener("focus", self.secondElement.select);
				}
	
				if (!self.config.time_24hr) {
					self.amPM.addEventListener("click", amPMToggle);
	
					self.amPM.addEventListener("wheel", amPMToggle);
					self.amPM.addEventListener("mouseout", updateValue);
	
					self.amPM.addEventListener("keydown", function (e) {
						if (e.which === 38 || e.which === 40) {
							amPMToggle(e);
						}
					});
				}
			}
	
			if (document.createEvent) {
				clickEvt = document.createEvent("MouseEvent");
				// without all these args ms edge spergs out
				clickEvt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			} else {
				clickEvt = new MouseEvent("click", {
					view: window,
					bubbles: true,
					cancelable: true
				});
			}
		};
	
		self.open = function () {
			if (self.isOpen || (self.altInput || self.input).disabled || self.config.inline) {
				return;
			} else if (!self.config.static) {
				self.positionCalendar();
			}
	
			self.isOpen = true;
	
			wrapperElement.classList.add("open");
	
			if (!self.config.allowInput) {
				(self.altInput || self.input).blur();
				(self.config.noCalendar ? timeContainer : calendar).focus();
			}
	
			(self.altInput || self.input).classList.add("active");
	
			if (self.config.onOpen) {
				self.config.onOpen(self.selectedDateObj, self.input.value, self);
			}
		};
	
		// For calendars inserted in BODY (as opposed to inline wrapper)
		// it"s necessary to properly calculate top/left position.
		self.positionCalendar = function () {
			var calendarHeight = calendarContainer.offsetHeight,
			    input = self.altInput || self.input,
			    inputBounds = input.getBoundingClientRect(),
			    distanceFromBottom = window.innerHeight - inputBounds.bottom + input.offsetHeight;
	
			var top = void 0,
			    left = window.pageXOffset + inputBounds.left;
	
			if (distanceFromBottom < calendarHeight) {
				top = window.pageYOffset - calendarHeight + inputBounds.top - 2;
				calendarContainer.classList.remove("arrowTop");
				calendarContainer.classList.add("arrowBottom");
			} else {
				top = window.pageYOffset + input.offsetHeight + inputBounds.top + 2;
				calendarContainer.classList.remove("arrowBottom");
				calendarContainer.classList.add("arrowTop");
			}
	
			wrapperElement.style.top = top + "px";
			wrapperElement.style.left = left + "px";
		};
	
		self.toggle = function () {
			if (self.isOpen) {
				self.close();
			} else {
				self.open();
			}
		};
	
		self.close = function () {
			self.isOpen = false;
			wrapperElement.classList.remove("open");
			(self.altInput || self.input).classList.remove("active");
	
			if (self.config.onClose) {
				self.config.onClose(self.selectedDateObj, self.input.value, self);
			}
		};
	
		self.clear = function () {
			self.input.value = "";
	
			if (self.altInput) {
				self.altInput.value = "";
			}
	
			self.selectedDateObj = null;
	
			triggerChange();
			self.jumpToDate();
		};
	
		triggerChange = function triggerChange() {
			self.input.dispatchEvent(clickEvt);
	
			if (self.config.onChange) {
				self.config.onChange(self.selectedDateObj, self.input.value, self);
			}
		};
	
		self.destroy = function () {
			document.removeEventListener("click", documentClick, false);
	
			if (self.altInput) {
				self.altInput.parentNode.removeChild(self.altInput);
			}
	
			if (self.config.inline) {
				var parent = self.element.parentNode,
				    removedElement = parent.removeChild(self.element);
	
				parent.removeChild(calendarContainer);
				parent.parentNode.replaceChild(removedElement, parent);
			} else {
				document.getElementsByTagName("body")[0].removeChild(wrapperElement);
			}
		};
	
		self.redraw = function () {
			if (self.config.noCalendar) {
				return;
			}
	
			updateNavigationCurrentMonth();
			buildDays();
		};
	
		self.jumpToDate = function (jumpDate) {
			jumpDate = uDate(jumpDate || self.selectedDateObj || self.config.defaultDate || self.config.minDate || now);
	
			self.currentYear = jumpDate.getFullYear();
			self.currentMonth = jumpDate.getMonth();
			self.redraw();
		};
	
		self.setDate = function (date, triggerChangeEvent) {
			date = uDate(date);
	
			if (date instanceof Date && date.getTime()) {
				self.selectedDateObj = uDate(date);
				self.jumpToDate(self.selectedDateObj);
				updateValue();
	
				if (triggerChangeEvent) {
					triggerChange();
				}
			}
		};
	
		self.setTime = function (hour, minute, triggerChangeEvent) {
			if (!self.selectedDateObj) {
				return;
			}
	
			self.hourElement.value = parseInt(hour, 10) % 24;
			self.minuteElement.value = parseInt(minute || 0, 10) % 60;
	
			if (!self.config.time_24hr) {
				self.amPM.innerHTML = hour > 11 ? "PM" : "AM";
			}
	
			updateValue();
	
			if (triggerChangeEvent) {
				triggerChange();
			}
		};
	
		self.set = function (key, value) {
			if (key in self.config) {
				self.config[key] = value;
				self.jumpToDate();
			}
		};
	
		amPMToggle = function amPMToggle(e) {
			e.preventDefault();
			self.amPM.textContent = ["AM", "PM"][self.amPM.innerHTML === "AM" | 0];
		};
	
		onKeyDown = function onKeyDown(e) {
			if (!self.isOpen || self.config.enableTime && timeContainer.contains(e.target)) {
				return;
			}
	
			switch (e.which) {
				case 13:
					selectDate(e);
					break;
	
				case 27:
					self.close();
					break;
	
				case 37:
					changeMonth(-1);
					break;
	
				case 38:
					e.preventDefault();
					self.currentYear++;
					self.redraw();
					break;
	
				case 39:
					changeMonth(1);
					break;
	
				case 40:
					e.preventDefault();
					self.currentYear--;
					self.redraw();
					break;
	
				default:
					break;
			}
		};
	
		onResize = debounce(function () {
			if (self.isOpen && !self.config.inline && !self.config.static) {
				self.positionCalendar();
			}
		}, 300);
	
		try {
			init();
		} catch (error) {
			// skip and carry on
			console.error(error);
			console.info(self.element);
		}
	
		return self;
	};
	
	flatpickr.init.prototype = {
	
		defaultConfig: {},
	
		l10n: {
			weekdays: {
				shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			},
			months: {
				shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
			},
			daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			firstDayOfWeek: 0,
			ordinal: function ordinal(nth) {
				var s = nth % 100;
				if (s > 3 && s < 21) return "th";
				switch (s % 10) {
					case 1:
						return "st";
					case 2:
						return "nd";
					case 3:
						return "rd";
					default:
						return "th";
				}
			},
			weekAbbreviation: "Wk",
			scrollTitle: "Scroll to increment",
			toggleTitle: "Click to toggle"
		}
	
	};
	
	Date.prototype.fp_incr = function (days) {
		return new Date(this.getFullYear(), this.getMonth(), this.getDate() + parseInt(days, 10));
	};
	
	Date.prototype.fp_isUTC = false;
	Date.prototype.fp_toUTC = function () {
		var newDate = new Date(this.getTime() + this.getTimezoneOffset() * 60000);
		newDate.fp_isUTC = true;
	
		return newDate;
	};
	
	Date.prototype.fp_getWeek = function () {
		var date = new Date(this.getTime());
		date.setHours(0, 0, 0, 0);
	
		// Thursday in current week decides the year.
		date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
		// January 4 is always in week 1.
		var week1 = new Date(date.getFullYear(), 0, 4);
		// Adjust to Thursday in week 1 and count number of weeks from date to week1.
		return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	// classList polyfill
	if (!("classList" in document.documentElement) && Object.defineProperty && typeof HTMLElement !== "undefined") {
		Object.defineProperty(HTMLElement.prototype, "classList", {
			get: function get() {
				var selfElements = this;
				function update(fn) {
					return function (value) {
						var classes = selfElements.className.split(/\s+/);
						var index = classes.indexOf(value);
	
						fn(classes, index, value);
						selfElements.className = classes.join(" ");
					};
				}
	
				var ret = {
					add: update(function (classes, index, value) {
						return ~index || classes.push(value);
					}),
					remove: update(function (classes, index) {
						return ~index && classes.splice(index, 1);
					}),
					toggle: update(function (classes, index, value) {
						if (~index) {
							classes.splice(index, 1);
						} else {
							classes.push(value);
						}
					}),
					contains: function contains(value) {
						return !! ~selfElements.className.split(/\s+/).indexOf(value);
					}
				};
	
				return ret;
			}
		});
	}
	
	if (true) {
		module.exports = flatpickr;
	}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(22);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * gridstack.js 0.4.0
	 * http://troolee.github.io/gridstack.js/
	 * (c) 2014-2018 Pavel Reznikov, Dylan Weiss
	 * gridstack.js may be freely distributed under the MIT license.
	 * @preserve
	*/
	(function(factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(89)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        try { jQuery = require('jquery'); } catch (e) {}
	        try { _ = require('lodash'); } catch (e) {}
	        factory(jQuery, _);
	    } else {
	        factory(jQuery, _);
	    }
	})(function($, _) {
	
	    var scope = window;
	
	    var obsolete = function(f, oldName, newName) {
	        var wrapper = function() {
	            console.warn('gridstack.js: Function `' + oldName + '` is deprecated as of v0.2.5 and has been replaced ' +
	            'with `' + newName + '`. It will be **completely** removed in v1.0.');
	            return f.apply(this, arguments);
	        };
	        wrapper.prototype = f.prototype;
	
	        return wrapper;
	    };
	
	    var obsoleteOpts = function(oldName, newName) {
	        console.warn('gridstack.js: Option `' + oldName + '` is deprecated as of v0.2.5 and has been replaced with `' +
	            newName + '`. It will be **completely** removed in v1.0.');
	    };
	
	    var Utils = {
	        isIntercepted: function(a, b) {
	            return !(a.x + a.width <= b.x || b.x + b.width <= a.x || a.y + a.height <= b.y || b.y + b.height <= a.y);
	        },
	
	        sort: function(nodes, dir, width) {
	            width = width || _.chain(nodes).map(function(node) { return node.x + node.width; }).max().value();
	            dir = dir != -1 ? 1 : -1;
	            return _.sortBy(nodes, [function(n) { return dir * (n.x + n.y * width); }]);
	        },
	
	        createStylesheet: function(id) {
	            var style = document.createElement('style');
	            style.setAttribute('type', 'text/css');
	            style.setAttribute('data-gs-style-id', id);
	            if (style.styleSheet) {
	                style.styleSheet.cssText = '';
	            } else {
	                style.appendChild(document.createTextNode(''));
	            }
	            document.getElementsByTagName('head')[0].appendChild(style);
	            return style.sheet;
	        },
	
	        removeStylesheet: function(id) {
	            $('STYLE[data-gs-style-id=' + id + ']').remove();
	        },
	
	        insertCSSRule: function(sheet, selector, rules, index) {
	            if (typeof sheet.insertRule === 'function') {
	                sheet.insertRule(selector + '{' + rules + '}', index);
	            } else if (typeof sheet.addRule === 'function') {
	                sheet.addRule(selector, rules, index);
	            }
	        },
	
	        toBool: function(v) {
	            if (typeof v == 'boolean') {
	                return v;
	            }
	            if (typeof v == 'string') {
	                v = v.toLowerCase();
	                return !(v === '' || v == 'no' || v == 'false' || v == '0');
	            }
	            return Boolean(v);
	        },
	
	        _collisionNodeCheck: function(n) {
	            return n != this.node && Utils.isIntercepted(n, this.nn);
	        },
	
	        _didCollide: function(bn) {
	            return Utils.isIntercepted({x: this.n.x, y: this.newY, width: this.n.width, height: this.n.height}, bn);
	        },
	
	        _isAddNodeIntercepted: function(n) {
	            return Utils.isIntercepted({x: this.x, y: this.y, width: this.node.width, height: this.node.height}, n);
	        },
	
	        parseHeight: function(val) {
	            var height = val;
	            var heightUnit = 'px';
	            if (height && _.isString(height)) {
	                var match = height.match(/^(-[0-9]+\.[0-9]+|[0-9]*\.[0-9]+|-[0-9]+|[0-9]+)(px|em|rem|vh|vw)?$/);
	                if (!match) {
	                    throw new Error('Invalid height');
	                }
	                heightUnit = match[2] || 'px';
	                height = parseFloat(match[1]);
	            }
	            return {height: height, unit: heightUnit};
	        },
	
	        removePositioningStyles: function(el) {
	            var style = el[0].style;
	            if (style.position) {
	                style.removeProperty('position');
	            }
	            if (style.left) {
	                style.removeProperty('left');
	            }
	            if (style.top) {
	                style.removeProperty('top');
	            }
	            if (style.width) {
	                style.removeProperty('width');
	            }
	            if (style.height) {
	                style.removeProperty('height');
	            }
	        },
	        getScrollParent: function(el) {
	            var returnEl;
	            if (el == null) {
	                returnEl = null;
	            } else if (el.scrollHeight > el.clientHeight) {
	                returnEl = el;
	            } else {
	                returnEl = Utils.getScrollParent(el.parentNode);
	            }
	            return returnEl;
	        },
	        updateScrollPosition: function(el, ui, distance) {
	            // is widget in view?
	            var rect = el.getBoundingClientRect();
	            var innerHeightOrClientHeight = (window.innerHeight || document.documentElement.clientHeight);
	            if (rect.top < 0 ||
	                rect.bottom > innerHeightOrClientHeight
	            ) {
	                // set scrollTop of first parent that scrolls
	                // if parent is larger than el, set as low as possible
	                // to get entire widget on screen
	                var offsetDiffDown = rect.bottom - innerHeightOrClientHeight;
	                var offsetDiffUp = rect.top;
	                var scrollEl = Utils.getScrollParent(el);
	                var prevScroll = scrollEl.scrollTop;
	                if (scrollEl != null) {
	                    if (rect.top < 0 && distance < 0) {
	                        // moving up
	                        if (el.offsetHeight > innerHeightOrClientHeight) {
	                            scrollEl.scrollTop += distance;
	                        } else {
	                            scrollEl.scrollTop += Math.abs(offsetDiffUp) > Math.abs(distance) ? distance : offsetDiffUp;
	                        }
	                    } else if (distance > 0) {
	                        // moving down
	                        if (el.offsetHeight > innerHeightOrClientHeight) {
	                            scrollEl.scrollTop += distance;
	                        } else {
	                            scrollEl.scrollTop += offsetDiffDown > distance ? distance : offsetDiffDown;
	                        }
	                    }
	                    // move widget y by amount scrolled
	                    ui.position.top += scrollEl.scrollTop - prevScroll;
	                }
	            }
	        }
	    };
	
	    // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	    Utils.is_intercepted = obsolete(Utils.isIntercepted, 'is_intercepted', 'isIntercepted');
	
	    Utils.create_stylesheet = obsolete(Utils.createStylesheet, 'create_stylesheet', 'createStylesheet');
	
	    Utils.remove_stylesheet = obsolete(Utils.removeStylesheet, 'remove_stylesheet', 'removeStylesheet');
	
	    Utils.insert_css_rule = obsolete(Utils.insertCSSRule, 'insert_css_rule', 'insertCSSRule');
	    // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	
	    /**
	    * @class GridStackDragDropPlugin
	    * Base class for drag'n'drop plugin.
	    */
	    function GridStackDragDropPlugin(grid) {
	        this.grid = grid;
	    }
	
	    GridStackDragDropPlugin.registeredPlugins = [];
	
	    GridStackDragDropPlugin.registerPlugin = function(pluginClass) {
	        GridStackDragDropPlugin.registeredPlugins.push(pluginClass);
	    };
	
	    GridStackDragDropPlugin.prototype.resizable = function(el, opts) {
	        return this;
	    };
	
	    GridStackDragDropPlugin.prototype.draggable = function(el, opts) {
	        return this;
	    };
	
	    GridStackDragDropPlugin.prototype.droppable = function(el, opts) {
	        return this;
	    };
	
	    GridStackDragDropPlugin.prototype.isDroppable = function(el) {
	        return false;
	    };
	
	    GridStackDragDropPlugin.prototype.on = function(el, eventName, callback) {
	        return this;
	    };
	
	
	    var idSeq = 0;
	
	    var GridStackEngine = function(width, onchange, floatMode, height, items) {
	        this.width = width;
	        this.float = floatMode || false;
	        this.height = height || 0;
	
	        this.nodes = items || [];
	        this.onchange = onchange || function() {};
	
	        this._updateCounter = 0;
	        this._float = this.float;
	
	        this._addedNodes = [];
	        this._removedNodes = [];
	    };
	
	    GridStackEngine.prototype.batchUpdate = function() {
	        this._updateCounter = 1;
	        this.float = true;
	    };
	
	    GridStackEngine.prototype.commit = function() {
	        if (this._updateCounter !== 0) {
	            this._updateCounter = 0;
	            this.float = this._float;
	            this._packNodes();
	            this._notify();
	        }
	    };
	
	    // For Meteor support: https://github.com/troolee/gridstack.js/pull/272
	    GridStackEngine.prototype.getNodeDataByDOMEl = function(el) {
	        return _.find(this.nodes, function(n) { return el.get(0) === n.el.get(0); });
	    };
	
	    GridStackEngine.prototype._fixCollisions = function(node) {
	        var self = this;
	        this._sortNodes(-1);
	
	        var nn = node;
	        var hasLocked = Boolean(_.find(this.nodes, function(n) { return n.locked; }));
	        if (!this.float && !hasLocked) {
	            nn = {x: 0, y: node.y, width: this.width, height: node.height};
	        }
	        while (true) {
	            var collisionNode = _.find(this.nodes, _.bind(Utils._collisionNodeCheck, {node: node, nn: nn}));
	            if (typeof collisionNode == 'undefined') {
	                return;
	            }
	            this.moveNode(collisionNode, collisionNode.x, node.y + node.height,
	                collisionNode.width, collisionNode.height, true);
	        }
	    };
	
	    GridStackEngine.prototype.isAreaEmpty = function(x, y, width, height) {
	        var nn = {x: x || 0, y: y || 0, width: width || 1, height: height || 1};
	        var collisionNode = _.find(this.nodes, _.bind(function(n) {
	            return Utils.isIntercepted(n, nn);
	        }, this));
	        return collisionNode === null || typeof collisionNode === 'undefined';
	    };
	
	    GridStackEngine.prototype._sortNodes = function(dir) {
	        this.nodes = Utils.sort(this.nodes, dir, this.width);
	    };
	
	    GridStackEngine.prototype._packNodes = function() {
	        this._sortNodes();
	
	        if (this.float) {
	            _.each(this.nodes, _.bind(function(n, i) {
	                if (n._updating || typeof n._origY == 'undefined' || n.y == n._origY) {
	                    return;
	                }
	
	                var newY = n.y;
	                while (newY >= n._origY) {
	                    var collisionNode = _.chain(this.nodes)
	                        .take(i)
	                        .find(_.bind(Utils._didCollide, {n: n, newY: newY}))
	                        .value();
	
	                    if (!collisionNode) {
	                        n._dirty = true;
	                        n.y = newY;
	                    }
	                    --newY;
	                }
	            }, this));
	        } else {
	            _.each(this.nodes, _.bind(function(n, i) {
	                if (n.locked) {
	                    return;
	                }
	                while (n.y > 0) {
	                    var newY = n.y - 1;
	                    var canBeMoved = i === 0;
	
	                    if (i > 0) {
	                        var collisionNode = _.chain(this.nodes)
	                            .take(i)
	                            .find(_.bind(Utils._didCollide, {n: n, newY: newY}))
	                            .value();
	                        canBeMoved = typeof collisionNode == 'undefined';
	                    }
	
	                    if (!canBeMoved) {
	                        break;
	                    }
	                    n._dirty = n.y != newY;
	                    n.y = newY;
	                }
	            }, this));
	        }
	    };
	
	    GridStackEngine.prototype._prepareNode = function(node, resizing) {
	        node = _.defaults(node || {}, {width: 1, height: 1, x: 0, y: 0});
	
	        node.x = parseInt('' + node.x);
	        node.y = parseInt('' + node.y);
	        node.width = parseInt('' + node.width);
	        node.height = parseInt('' + node.height);
	        node.autoPosition = node.autoPosition || false;
	        node.noResize = node.noResize || false;
	        node.noMove = node.noMove || false;
	
	        if (node.width > this.width) {
	            node.width = this.width;
	        } else if (node.width < 1) {
	            node.width = 1;
	        }
	
	        if (node.height < 1) {
	            node.height = 1;
	        }
	
	        if (node.x < 0) {
	            node.x = 0;
	        }
	
	        if (node.x + node.width > this.width) {
	            if (resizing) {
	                node.width = this.width - node.x;
	            } else {
	                node.x = this.width - node.width;
	            }
	        }
	
	        if (node.y < 0) {
	            node.y = 0;
	        }
	
	        return node;
	    };
	
	    GridStackEngine.prototype._notify = function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        args[0] = typeof args[0] === 'undefined' ? [] : [args[0]];
	        args[1] = typeof args[1] === 'undefined' ? true : args[1];
	        if (this._updateCounter) {
	            return;
	        }
	        var deletedNodes = args[0].concat(this.getDirtyNodes());
	        this.onchange(deletedNodes, args[1]);
	    };
	
	    GridStackEngine.prototype.cleanNodes = function() {
	        if (this._updateCounter) {
	            return;
	        }
	        _.each(this.nodes, function(n) {n._dirty = false; });
	    };
	
	    GridStackEngine.prototype.getDirtyNodes = function() {
	        return _.filter(this.nodes, function(n) { return n._dirty; });
	    };
	
	    GridStackEngine.prototype.addNode = function(node, triggerAddEvent) {
	        node = this._prepareNode(node);
	
	        if (typeof node.maxWidth != 'undefined') { node.width = Math.min(node.width, node.maxWidth); }
	        if (typeof node.maxHeight != 'undefined') { node.height = Math.min(node.height, node.maxHeight); }
	        if (typeof node.minWidth != 'undefined') { node.width = Math.max(node.width, node.minWidth); }
	        if (typeof node.minHeight != 'undefined') { node.height = Math.max(node.height, node.minHeight); }
	
	        node._id = ++idSeq;
	        node._dirty = true;
	
	        if (node.autoPosition) {
	            this._sortNodes();
	
	            for (var i = 0;; ++i) {
	                var x = i % this.width;
	                var y = Math.floor(i / this.width);
	                if (x + node.width > this.width) {
	                    continue;
	                }
	                if (!_.find(this.nodes, _.bind(Utils._isAddNodeIntercepted, {x: x, y: y, node: node}))) {
	                    node.x = x;
	                    node.y = y;
	                    break;
	                }
	            }
	        }
	
	        this.nodes.push(node);
	        if (typeof triggerAddEvent != 'undefined' && triggerAddEvent) {
	            this._addedNodes.push(_.clone(node));
	        }
	
	        this._fixCollisions(node);
	        this._packNodes();
	        this._notify();
	        return node;
	    };
	
	    GridStackEngine.prototype.removeNode = function(node, detachNode) {
	        detachNode = typeof detachNode === 'undefined' ? true : detachNode;
	        this._removedNodes.push(_.clone(node));
	        node._id = null;
	        this.nodes = _.without(this.nodes, node);
	        this._packNodes();
	        this._notify(node, detachNode);
	    };
	
	    GridStackEngine.prototype.canMoveNode = function(node, x, y, width, height) {
	        if (!this.isNodeChangedPosition(node, x, y, width, height)) {
	            return false;
	        }
	        var hasLocked = Boolean(_.find(this.nodes, function(n) { return n.locked; }));
	
	        if (!this.height && !hasLocked) {
	            return true;
	        }
	
	        var clonedNode;
	        var clone = new GridStackEngine(
	            this.width,
	            null,
	            this.float,
	            0,
	            _.map(this.nodes, function(n) {
	                if (n == node) {
	                    clonedNode = $.extend({}, n);
	                    return clonedNode;
	                }
	                return $.extend({}, n);
	            }));
	
	        if (typeof clonedNode === 'undefined') {
	            return true;
	        }
	
	        clone.moveNode(clonedNode, x, y, width, height);
	
	        var res = true;
	
	        if (hasLocked) {
	            res &= !Boolean(_.find(clone.nodes, function(n) {
	                return n != clonedNode && Boolean(n.locked) && Boolean(n._dirty);
	            }));
	        }
	        if (this.height) {
	            res &= clone.getGridHeight() <= this.height;
	        }
	
	        return res;
	    };
	
	    GridStackEngine.prototype.canBePlacedWithRespectToHeight = function(node) {
	        if (!this.height) {
	            return true;
	        }
	
	        var clone = new GridStackEngine(
	            this.width,
	            null,
	            this.float,
	            0,
	            _.map(this.nodes, function(n) { return $.extend({}, n); }));
	        clone.addNode(node);
	        return clone.getGridHeight() <= this.height;
	    };
	
	    GridStackEngine.prototype.isNodeChangedPosition = function(node, x, y, width, height) {
	        if (typeof x != 'number') { x = node.x; }
	        if (typeof y != 'number') { y = node.y; }
	        if (typeof width != 'number') { width = node.width; }
	        if (typeof height != 'number') { height = node.height; }
	
	        if (typeof node.maxWidth != 'undefined') { width = Math.min(width, node.maxWidth); }
	        if (typeof node.maxHeight != 'undefined') { height = Math.min(height, node.maxHeight); }
	        if (typeof node.minWidth != 'undefined') { width = Math.max(width, node.minWidth); }
	        if (typeof node.minHeight != 'undefined') { height = Math.max(height, node.minHeight); }
	
	        if (node.x == x && node.y == y && node.width == width && node.height == height) {
	            return false;
	        }
	        return true;
	    };
	
	    GridStackEngine.prototype.moveNode = function(node, x, y, width, height, noPack) {
	        if (!this.isNodeChangedPosition(node, x, y, width, height)) {
	            return node;
	        }
	        if (typeof x != 'number') { x = node.x; }
	        if (typeof y != 'number') { y = node.y; }
	        if (typeof width != 'number') { width = node.width; }
	        if (typeof height != 'number') { height = node.height; }
	
	        if (typeof node.maxWidth != 'undefined') { width = Math.min(width, node.maxWidth); }
	        if (typeof node.maxHeight != 'undefined') { height = Math.min(height, node.maxHeight); }
	        if (typeof node.minWidth != 'undefined') { width = Math.max(width, node.minWidth); }
	        if (typeof node.minHeight != 'undefined') { height = Math.max(height, node.minHeight); }
	
	        if (node.x == x && node.y == y && node.width == width && node.height == height) {
	            return node;
	        }
	
	        var resizing = node.width != width;
	        node._dirty = true;
	
	        node.x = x;
	        node.y = y;
	        node.width = width;
	        node.height = height;
	
	        node.lastTriedX = x;
	        node.lastTriedY = y;
	        node.lastTriedWidth = width;
	        node.lastTriedHeight = height;
	
	        node = this._prepareNode(node, resizing);
	
	        this._fixCollisions(node);
	        if (!noPack) {
	            this._packNodes();
	            this._notify();
	        }
	        return node;
	    };
	
	    GridStackEngine.prototype.getGridHeight = function() {
	        return _.reduce(this.nodes, function(memo, n) { return Math.max(memo, n.y + n.height); }, 0);
	    };
	
	    GridStackEngine.prototype.beginUpdate = function(node) {
	        _.each(this.nodes, function(n) {
	            n._origY = n.y;
	        });
	        node._updating = true;
	    };
	
	    GridStackEngine.prototype.endUpdate = function() {
	        _.each(this.nodes, function(n) {
	            n._origY = n.y;
	        });
	        var n = _.find(this.nodes, function(n) { return n._updating; });
	        if (n) {
	            n._updating = false;
	        }
	    };
	
	    var GridStack = function(el, opts) {
	        var self = this;
	        var oneColumnMode, isAutoCellHeight;
	
	        opts = opts || {};
	
	        this.container = $(el);
	
	        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	        if (typeof opts.handle_class !== 'undefined') {
	            opts.handleClass = opts.handle_class;
	            obsoleteOpts('handle_class', 'handleClass');
	        }
	        if (typeof opts.item_class !== 'undefined') {
	            opts.itemClass = opts.item_class;
	            obsoleteOpts('item_class', 'itemClass');
	        }
	        if (typeof opts.placeholder_class !== 'undefined') {
	            opts.placeholderClass = opts.placeholder_class;
	            obsoleteOpts('placeholder_class', 'placeholderClass');
	        }
	        if (typeof opts.placeholder_text !== 'undefined') {
	            opts.placeholderText = opts.placeholder_text;
	            obsoleteOpts('placeholder_text', 'placeholderText');
	        }
	        if (typeof opts.cell_height !== 'undefined') {
	            opts.cellHeight = opts.cell_height;
	            obsoleteOpts('cell_height', 'cellHeight');
	        }
	        if (typeof opts.vertical_margin !== 'undefined') {
	            opts.verticalMargin = opts.vertical_margin;
	            obsoleteOpts('vertical_margin', 'verticalMargin');
	        }
	        if (typeof opts.min_width !== 'undefined') {
	            opts.minWidth = opts.min_width;
	            obsoleteOpts('min_width', 'minWidth');
	        }
	        if (typeof opts.static_grid !== 'undefined') {
	            opts.staticGrid = opts.static_grid;
	            obsoleteOpts('static_grid', 'staticGrid');
	        }
	        if (typeof opts.is_nested !== 'undefined') {
	            opts.isNested = opts.is_nested;
	            obsoleteOpts('is_nested', 'isNested');
	        }
	        if (typeof opts.always_show_resize_handle !== 'undefined') {
	            opts.alwaysShowResizeHandle = opts.always_show_resize_handle;
	            obsoleteOpts('always_show_resize_handle', 'alwaysShowResizeHandle');
	        }
	        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	
	        opts.itemClass = opts.itemClass || 'grid-stack-item';
	        var isNested = this.container.closest('.' + opts.itemClass).length > 0;
	
	        this.opts = _.defaults(opts || {}, {
	            width: parseInt(this.container.attr('data-gs-width')) || 12,
	            height: parseInt(this.container.attr('data-gs-height')) || 0,
	            itemClass: 'grid-stack-item',
	            placeholderClass: 'grid-stack-placeholder',
	            placeholderText: '',
	            handle: '.grid-stack-item-content',
	            handleClass: null,
	            cellHeight: 60,
	            verticalMargin: 20,
	            auto: true,
	            minWidth: 768,
	            float: false,
	            staticGrid: false,
	            _class: 'grid-stack-instance-' + (Math.random() * 10000).toFixed(0),
	            animate: Boolean(this.container.attr('data-gs-animate')) || false,
	            alwaysShowResizeHandle: opts.alwaysShowResizeHandle || false,
	            resizable: _.defaults(opts.resizable || {}, {
	                autoHide: !(opts.alwaysShowResizeHandle || false),
	                handles: 'se'
	            }),
	            draggable: _.defaults(opts.draggable || {}, {
	                handle: (opts.handleClass ? '.' + opts.handleClass : (opts.handle ? opts.handle : '')) ||
	                    '.grid-stack-item-content',
	                scroll: false,
	                appendTo: 'body'
	            }),
	            disableDrag: opts.disableDrag || false,
	            disableResize: opts.disableResize || false,
	            rtl: 'auto',
	            removable: false,
	            removableOptions: _.defaults(opts.removableOptions || {}, {
	                accept: '.' + opts.itemClass
	            }),
	            removeTimeout: 2000,
	            verticalMarginUnit: 'px',
	            cellHeightUnit: 'px',
	            disableOneColumnMode: opts.disableOneColumnMode || false,
	            oneColumnModeClass: opts.oneColumnModeClass || 'grid-stack-one-column-mode',
	            ddPlugin: null
	        });
	
	        if (this.opts.ddPlugin === false) {
	            this.opts.ddPlugin = GridStackDragDropPlugin;
	        } else if (this.opts.ddPlugin === null) {
	            this.opts.ddPlugin = _.first(GridStackDragDropPlugin.registeredPlugins) || GridStackDragDropPlugin;
	        }
	
	        this.dd = new this.opts.ddPlugin(this);
	
	        if (this.opts.rtl === 'auto') {
	            this.opts.rtl = this.container.css('direction') === 'rtl';
	        }
	
	        if (this.opts.rtl) {
	            this.container.addClass('grid-stack-rtl');
	        }
	
	        this.opts.isNested = isNested;
	
	        isAutoCellHeight = this.opts.cellHeight === 'auto';
	        if (isAutoCellHeight) {
	            self.cellHeight(self.cellWidth(), true);
	        } else {
	            this.cellHeight(this.opts.cellHeight, true);
	        }
	        this.verticalMargin(this.opts.verticalMargin, true);
	
	        this.container.addClass(this.opts._class);
	
	        this._setStaticClass();
	
	        if (isNested) {
	            this.container.addClass('grid-stack-nested');
	        }
	
	        this._initStyles();
	
	        this.grid = new GridStackEngine(this.opts.width, function(nodes, detachNode) {
	            detachNode = typeof detachNode === 'undefined' ? true : detachNode;
	            var maxHeight = 0;
	            _.each(this.nodes, function(n) {
	                maxHeight = Math.max(maxHeight, n.y + n.height);
	            });
	            _.each(nodes, function(n) {
	                if (detachNode && n._id === null) {
	                    if (n.el) {
	                        n.el.remove();
	                    }
	                } else {
	                    n.el
	                        .attr('data-gs-x', n.x)
	                        .attr('data-gs-y', n.y)
	                        .attr('data-gs-width', n.width)
	                        .attr('data-gs-height', n.height);
	                }
	            });
	            self._updateStyles(maxHeight + 10);
	        }, this.opts.float, this.opts.height);
	
	        if (this.opts.auto) {
	            var elements = [];
	            var _this = this;
	            this.container.children('.' + this.opts.itemClass + ':not(.' + this.opts.placeholderClass + ')')
	                .each(function(index, el) {
	                el = $(el);
	                elements.push({
	                    el: el,
	                    i: parseInt(el.attr('data-gs-x')) + parseInt(el.attr('data-gs-y')) * _this.opts.width
	                });
	            });
	            _.chain(elements).sortBy(function(x) { return x.i; }).each(function(i) {
	                self._prepareElement(i.el);
	            }).value();
	        }
	
	        this.setAnimation(this.opts.animate);
	
	        this.placeholder = $(
	            '<div class="' + this.opts.placeholderClass + ' ' + this.opts.itemClass + '">' +
	            '<div class="placeholder-content">' + this.opts.placeholderText + '</div></div>').hide();
	
	        this._updateContainerHeight();
	
	        this._updateHeightsOnResize = _.throttle(function() {
	            self.cellHeight(self.cellWidth(), false);
	        }, 100);
	
	        this.onResizeHandler = function() {
	            if (isAutoCellHeight) {
	                self._updateHeightsOnResize();
	            }
	
	            if (self._isOneColumnMode() && !self.opts.disableOneColumnMode) {
	                if (oneColumnMode) {
	                    return;
	                }
	                self.container.addClass(self.opts.oneColumnModeClass);
	                oneColumnMode = true;
	
	                self.grid._sortNodes();
	                _.each(self.grid.nodes, function(node) {
	                    self.container.append(node.el);
	
	                    if (self.opts.staticGrid) {
	                        return;
	                    }
	                    self.dd.draggable(node.el, 'disable');
	                    self.dd.resizable(node.el, 'disable');
	
	                    node.el.trigger('resize');
	                });
	            } else {
	                if (!oneColumnMode) {
	                    return;
	                }
	
	                self.container.removeClass(self.opts.oneColumnModeClass);
	                oneColumnMode = false;
	
	                if (self.opts.staticGrid) {
	                    return;
	                }
	
	                _.each(self.grid.nodes, function(node) {
	                    if (!node.noMove && !self.opts.disableDrag) {
	                        self.dd.draggable(node.el, 'enable');
	                    }
	                    if (!node.noResize && !self.opts.disableResize) {
	                        self.dd.resizable(node.el, 'enable');
	                    }
	
	                    node.el.trigger('resize');
	                });
	            }
	        };
	
	        $(window).resize(this.onResizeHandler);
	        this.onResizeHandler();
	
	        if (!self.opts.staticGrid && typeof self.opts.removable === 'string') {
	            var trashZone = $(self.opts.removable);
	            if (!this.dd.isDroppable(trashZone)) {
	                this.dd.droppable(trashZone, self.opts.removableOptions);
	            }
	            this.dd
	                .on(trashZone, 'dropover', function(event, ui) {
	                    var el = $(ui.draggable);
	                    var node = el.data('_gridstack_node');
	                    if (node._grid !== self) {
	                        return;
	                    }
	                    el.data('inTrashZone', true);
	                    self._setupRemovingTimeout(el);
	                })
	                .on(trashZone, 'dropout', function(event, ui) {
	                    var el = $(ui.draggable);
	                    var node = el.data('_gridstack_node');
	                    if (node._grid !== self) {
	                        return;
	                    }
	                    el.data('inTrashZone', false);
	                    self._clearRemovingTimeout(el);
	                });
	        }
	
	        if (!self.opts.staticGrid && self.opts.acceptWidgets) {
	            var draggingElement = null;
	
	            var onDrag = function(event, ui) {
	                var el = draggingElement;
	                var node = el.data('_gridstack_node');
	                var pos = self.getCellFromPixel({left: event.pageX, top: event.pageY}, true);
	                var x = Math.max(0, pos.x);
	                var y = Math.max(0, pos.y);
	                if (!node._added) {
	                    node._added = true;
	
	                    node.el = el;
	                    node.autoPosition = true;
	                    node.x = x;
	                    node.y = y;
	                    self.grid.cleanNodes();
	                    self.grid.beginUpdate(node);
	                    self.grid.addNode(node);
	
	                    self.container.append(self.placeholder);
	                    self.placeholder
	                        .attr('data-gs-x', node.x)
	                        .attr('data-gs-y', node.y)
	                        .attr('data-gs-width', node.width)
	                        .attr('data-gs-height', node.height)
	                        .show();
	                    node.el = self.placeholder;
	                    node._beforeDragX = node.x;
	                    node._beforeDragY = node.y;
	
	                    self._updateContainerHeight();
	                }
	                if (!self.grid.canMoveNode(node, x, y)) {
	                    return;
	                }
	                self.grid.moveNode(node, x, y);
	                self._updateContainerHeight();
	            };
	
	            this.dd
	                .droppable(self.container, {
	                    accept: function(el) {
	                        el = $(el);
	                        var node = el.data('_gridstack_node');
	                        if (node && node._grid === self) {
	                            return false;
	                        }
	                        return el.is(self.opts.acceptWidgets === true ? '.grid-stack-item' : self.opts.acceptWidgets);
	                    }
	                })
	                .on(self.container, 'dropover', function(event, ui) {
	                    var offset = self.container.offset();
	                    var el = $(ui.draggable);
	                    var cellWidth = self.cellWidth();
	                    var cellHeight = self.cellHeight();
	                    var origNode = el.data('_gridstack_node');
	
	                    var width = origNode ? origNode.width : (Math.ceil(el.outerWidth() / cellWidth));
	                    var height = origNode ? origNode.height : (Math.ceil(el.outerHeight() / cellHeight));
	
	                    draggingElement = el;
	
	                    var node = self.grid._prepareNode({width: width, height: height, _added: false, _temporary: true});
	                    el.data('_gridstack_node', node);
	                    el.data('_gridstack_node_orig', origNode);
	
	                    el.on('drag', onDrag);
	                })
	                .on(self.container, 'dropout', function(event, ui) {
	                    var el = $(ui.draggable);
	                    if (!el.data('_gridstack_node')) {
	                        return;
	                    }
	                    el.unbind('drag', onDrag);
	                    var node = el.data('_gridstack_node');
	                    node.el = null;
	                    self.grid.removeNode(node);
	                    self.placeholder.detach();
	                    self._updateContainerHeight();
	                    el.data('_gridstack_node', el.data('_gridstack_node_orig'));
	                })
	                .on(self.container, 'drop', function(event, ui) {
	                    self.placeholder.detach();
	
	                    var node = $(ui.draggable).data('_gridstack_node');
	                    node._grid = self;
	                    var el = $(ui.draggable).clone(false);
	                    el.data('_gridstack_node', node);
	                    var originalNode = $(ui.draggable).data('_gridstack_node_orig');
	                    if (typeof originalNode !== 'undefined' && typeof originalNode._grid !== 'undefined') {
	                        originalNode._grid._triggerRemoveEvent();
	                    }
	                    $(ui.helper).remove();
	                    node.el = el;
	                    self.placeholder.hide();
	                    Utils.removePositioningStyles(el);
	                    el.find('div.ui-resizable-handle').remove();
	
	                    el
	                        .attr('data-gs-x', node.x)
	                        .attr('data-gs-y', node.y)
	                        .attr('data-gs-width', node.width)
	                        .attr('data-gs-height', node.height)
	                        .addClass(self.opts.itemClass)
	                        .enableSelection()
	                        .removeData('draggable')
	                        .removeClass('ui-draggable ui-draggable-dragging ui-draggable-disabled')
	                        .unbind('drag', onDrag);
	                    self.container.append(el);
	                    self._prepareElementsByNode(el, node);
	                    self._updateContainerHeight();
	                    self.grid._addedNodes.push(node);
	                    self._triggerAddEvent();
	                    self._triggerChangeEvent();
	
	                    self.grid.endUpdate();
	                    $(ui.draggable).unbind('drag', onDrag);
	                    $(ui.draggable).removeData('_gridstack_node');
	                    $(ui.draggable).removeData('_gridstack_node_orig');
	                });
	        }
	    };
	
	    GridStack.prototype._triggerChangeEvent = function(forceTrigger) {
	        var elements = this.grid.getDirtyNodes();
	        var hasChanges = false;
	
	        var eventParams = [];
	        if (elements && elements.length) {
	            eventParams.push(elements);
	            hasChanges = true;
	        }
	
	        if (hasChanges || forceTrigger === true) {
	            this.container.trigger('change', eventParams);
	        }
	    };
	
	    GridStack.prototype._triggerAddEvent = function() {
	        if (this.grid._addedNodes && this.grid._addedNodes.length > 0) {
	            this.container.trigger('added', [_.map(this.grid._addedNodes, _.clone)]);
	            this.grid._addedNodes = [];
	        }
	    };
	
	    GridStack.prototype._triggerRemoveEvent = function() {
	        if (this.grid._removedNodes && this.grid._removedNodes.length > 0) {
	            this.container.trigger('removed', [_.map(this.grid._removedNodes, _.clone)]);
	            this.grid._removedNodes = [];
	        }
	    };
	
	    GridStack.prototype._initStyles = function() {
	        if (this._stylesId) {
	            Utils.removeStylesheet(this._stylesId);
	        }
	        this._stylesId = 'gridstack-style-' + (Math.random() * 100000).toFixed();
	        this._styles = Utils.createStylesheet(this._stylesId);
	        if (this._styles !== null) {
	            this._styles._max = 0;
	        }
	    };
	
	    GridStack.prototype._updateStyles = function(maxHeight) {
	        if (this._styles === null || typeof this._styles === 'undefined') {
	            return;
	        }
	
	        var prefix = '.' + this.opts._class + ' .' + this.opts.itemClass;
	        var self = this;
	        var getHeight;
	
	        if (typeof maxHeight == 'undefined') {
	            maxHeight = this._styles._max;
	        }
	        this._initStyles();
	        this._updateContainerHeight();
	        if (!this.opts.cellHeight) { // The rest will be handled by CSS
	            return ;
	        }
	        if (this._styles._max !== 0 && maxHeight <= this._styles._max) { // Keep this._styles._max increasing
	            return ;
	        }
	
	        if (!this.opts.verticalMargin || this.opts.cellHeightUnit === this.opts.verticalMarginUnit) {
	            getHeight = function(nbRows, nbMargins) {
	                return (self.opts.cellHeight * nbRows + self.opts.verticalMargin * nbMargins) +
	                    self.opts.cellHeightUnit;
	            };
	        } else {
	            getHeight = function(nbRows, nbMargins) {
	                if (!nbRows || !nbMargins) {
	                    return (self.opts.cellHeight * nbRows + self.opts.verticalMargin * nbMargins) +
	                        self.opts.cellHeightUnit;
	                }
	                return 'calc(' + ((self.opts.cellHeight * nbRows) + self.opts.cellHeightUnit) + ' + ' +
	                    ((self.opts.verticalMargin * nbMargins) + self.opts.verticalMarginUnit) + ')';
	            };
	        }
	
	        if (this._styles._max === 0) {
	            Utils.insertCSSRule(this._styles, prefix, 'min-height: ' + getHeight(1, 0) + ';', 0);
	        }
	
	        if (maxHeight > this._styles._max) {
	            for (var i = this._styles._max; i < maxHeight; ++i) {
	                Utils.insertCSSRule(this._styles,
	                    prefix + '[data-gs-height="' + (i + 1) + '"]',
	                    'height: ' + getHeight(i + 1, i) + ';',
	                    i
	                );
	                Utils.insertCSSRule(this._styles,
	                    prefix + '[data-gs-min-height="' + (i + 1) + '"]',
	                    'min-height: ' + getHeight(i + 1, i) + ';',
	                    i
	                );
	                Utils.insertCSSRule(this._styles,
	                    prefix + '[data-gs-max-height="' + (i + 1) + '"]',
	                    'max-height: ' + getHeight(i + 1, i) + ';',
	                    i
	                );
	                Utils.insertCSSRule(this._styles,
	                    prefix + '[data-gs-y="' + i + '"]',
	                    'top: ' + getHeight(i, i) + ';',
	                    i
	                );
	            }
	            this._styles._max = maxHeight;
	        }
	    };
	
	    GridStack.prototype._updateContainerHeight = function() {
	        if (this.grid._updateCounter) {
	            return;
	        }
	        var height = this.grid.getGridHeight();
	        // check for css min height. Each row is cellHeight + verticalMargin, until last one which has no margin below
	        var cssMinHeight = parseInt(this.container.css('min-height'));
	        if (cssMinHeight > 0) {
	            var minHeight = (cssMinHeight + this.opts.verticalMargin) / (this.cellHeight() + this.opts.verticalMargin);
	            if (height < minHeight) {
	                height = minHeight;
	            }
	        }
	        this.container.attr('data-gs-current-height', height);
	        if (!this.opts.cellHeight) {
	            return ;
	        }
	        if (!this.opts.verticalMargin) {
	            this.container.css('height', (height * (this.opts.cellHeight)) + this.opts.cellHeightUnit);
	        } else if (this.opts.cellHeightUnit === this.opts.verticalMarginUnit) {
	            this.container.css('height', (height * (this.opts.cellHeight + this.opts.verticalMargin) -
	                this.opts.verticalMargin) + this.opts.cellHeightUnit);
	        } else {
	            this.container.css('height', 'calc(' + ((height * (this.opts.cellHeight)) + this.opts.cellHeightUnit) +
	                ' + ' + ((height * (this.opts.verticalMargin - 1)) + this.opts.verticalMarginUnit) + ')');
	        }
	    };
	
	    GridStack.prototype._isOneColumnMode = function() {
	        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <=
	            this.opts.minWidth;
	    };
	
	    GridStack.prototype._setupRemovingTimeout = function(el) {
	        var self = this;
	        var node = $(el).data('_gridstack_node');
	
	        if (node._removeTimeout || !self.opts.removable) {
	            return;
	        }
	        node._removeTimeout = setTimeout(function() {
	            el.addClass('grid-stack-item-removing');
	            node._isAboutToRemove = true;
	        }, self.opts.removeTimeout);
	    };
	
	    GridStack.prototype._clearRemovingTimeout = function(el) {
	        var node = $(el).data('_gridstack_node');
	
	        if (!node._removeTimeout) {
	            return;
	        }
	        clearTimeout(node._removeTimeout);
	        node._removeTimeout = null;
	        el.removeClass('grid-stack-item-removing');
	        node._isAboutToRemove = false;
	    };
	
	    GridStack.prototype._prepareElementsByNode = function(el, node) {
	        var self = this;
	
	        var cellWidth;
	        var cellHeight;
	
	        var dragOrResize = function(event, ui) {
	            var x = Math.round(ui.position.left / cellWidth);
	            var y = Math.floor((ui.position.top + cellHeight / 2) / cellHeight);
	            var width;
	            var height;
	
	            if (event.type != 'drag') {
	                width = Math.round(ui.size.width / cellWidth);
	                height = Math.round(ui.size.height / cellHeight);
	            }
	
	            if (event.type == 'drag') {
	                var distance = ui.position.top - node._prevYPix;
	                node._prevYPix = ui.position.top;
	                Utils.updateScrollPosition(el[0], ui, distance);
	                if (el.data('inTrashZone') || x < 0 || x >= self.grid.width || y < 0 ||
	                    (!self.grid.float && y > self.grid.getGridHeight())) {
	                    if (!node._temporaryRemoved) {
	                        if (self.opts.removable === true) {
	                            self._setupRemovingTimeout(el);
	                        }
	
	                        x = node._beforeDragX;
	                        y = node._beforeDragY;
	
	                        self.placeholder.detach();
	                        self.placeholder.hide();
	                        self.grid.removeNode(node);
	                        self._updateContainerHeight();
	
	                        node._temporaryRemoved = true;
	                    }
	                } else {
	                    self._clearRemovingTimeout(el);
	
	                    if (node._temporaryRemoved) {
	                        self.grid.addNode(node);
	                        self.placeholder
	                            .attr('data-gs-x', x)
	                            .attr('data-gs-y', y)
	                            .attr('data-gs-width', width)
	                            .attr('data-gs-height', height)
	                            .show();
	                        self.container.append(self.placeholder);
	                        node.el = self.placeholder;
	                        node._temporaryRemoved = false;
	                    }
	                }
	            } else if (event.type == 'resize')  {
	                if (x < 0) {
	                    return;
	                }
	            }
	            // width and height are undefined if not resizing
	            var lastTriedWidth = typeof width !== 'undefined' ? width : node.lastTriedWidth;
	            var lastTriedHeight = typeof height !== 'undefined' ? height : node.lastTriedHeight;
	            if (!self.grid.canMoveNode(node, x, y, width, height) ||
	                (node.lastTriedX === x && node.lastTriedY === y &&
	                node.lastTriedWidth === lastTriedWidth && node.lastTriedHeight === lastTriedHeight)) {
	                return;
	            }
	            node.lastTriedX = x;
	            node.lastTriedY = y;
	            node.lastTriedWidth = width;
	            node.lastTriedHeight = height;
	            self.grid.moveNode(node, x, y, width, height);
	            self._updateContainerHeight();
	        };
	
	        var onStartMoving = function(event, ui) {
	            self.container.append(self.placeholder);
	            var o = $(this);
	            self.grid.cleanNodes();
	            self.grid.beginUpdate(node);
	            cellWidth = self.cellWidth();
	            var strictCellHeight = Math.ceil(o.outerHeight() / o.attr('data-gs-height'));
	            cellHeight = self.container.height() / parseInt(self.container.attr('data-gs-current-height'));
	            self.placeholder
	                .attr('data-gs-x', o.attr('data-gs-x'))
	                .attr('data-gs-y', o.attr('data-gs-y'))
	                .attr('data-gs-width', o.attr('data-gs-width'))
	                .attr('data-gs-height', o.attr('data-gs-height'))
	                .show();
	            node.el = self.placeholder;
	            node._beforeDragX = node.x;
	            node._beforeDragY = node.y;
	            node._prevYPix = ui.position.top;
	
	            self.dd.resizable(el, 'option', 'minWidth', cellWidth * (node.minWidth || 1));
	            self.dd.resizable(el, 'option', 'minHeight', strictCellHeight * (node.minHeight || 1));
	
	            if (event.type == 'resizestart') {
	                o.find('.grid-stack-item').trigger('resizestart');
	            }
	        };
	
	        var onEndMoving = function(event, ui) {
	            var o = $(this);
	            if (!o.data('_gridstack_node')) {
	                return;
	            }
	
	            var forceNotify = false;
	            self.placeholder.detach();
	            node.el = o;
	            self.placeholder.hide();
	
	            if (node._isAboutToRemove) {
	                forceNotify = true;
	                var gridToNotify = el.data('_gridstack_node')._grid;
	                gridToNotify._triggerRemoveEvent();
	                el.removeData('_gridstack_node');
	                el.remove();
	            } else {
	                self._clearRemovingTimeout(el);
	                if (!node._temporaryRemoved) {
	                    Utils.removePositioningStyles(o);
	                    o
	                        .attr('data-gs-x', node.x)
	                        .attr('data-gs-y', node.y)
	                        .attr('data-gs-width', node.width)
	                        .attr('data-gs-height', node.height);
	                } else {
	                    Utils.removePositioningStyles(o);
	                    o
	                        .attr('data-gs-x', node._beforeDragX)
	                        .attr('data-gs-y', node._beforeDragY)
	                        .attr('data-gs-width', node.width)
	                        .attr('data-gs-height', node.height);
	                    node.x = node._beforeDragX;
	                    node.y = node._beforeDragY;
	                    node._temporaryRemoved = false;
	                    self.grid.addNode(node);
	                }
	            }
	            self._updateContainerHeight();
	            self._triggerChangeEvent(forceNotify);
	
	            self.grid.endUpdate();
	
	            var nestedGrids = o.find('.grid-stack');
	            if (nestedGrids.length && event.type == 'resizestop') {
	                nestedGrids.each(function(index, el) {
	                    $(el).data('gridstack').onResizeHandler();
	                });
	                o.find('.grid-stack-item').trigger('resizestop');
	                o.find('.grid-stack-item').trigger('gsresizestop');
	            }
	            if (event.type == 'resizestop') {
	                self.container.trigger('gsresizestop', o);
	            }
	        };
	
	        this.dd
	            .draggable(el, {
	                start: onStartMoving,
	                stop: onEndMoving,
	                drag: dragOrResize
	            })
	            .resizable(el, {
	                start: onStartMoving,
	                stop: onEndMoving,
	                resize: dragOrResize
	            });
	
	        if (node.noMove || (this._isOneColumnMode() && !self.opts.disableOneColumnMode) || this.opts.disableDrag ||
	            this.opts.staticGrid) {
	            this.dd.draggable(el, 'disable');
	        }
	
	        if (node.noResize || (this._isOneColumnMode() && !self.opts.disableOneColumnMode) || this.opts.disableResize ||
	            this.opts.staticGrid) {
	            this.dd.resizable(el, 'disable');
	        }
	
	        el.attr('data-gs-locked', node.locked ? 'yes' : null);
	    };
	
	    GridStack.prototype._prepareElement = function(el, triggerAddEvent) {
	        triggerAddEvent = typeof triggerAddEvent != 'undefined' ? triggerAddEvent : false;
	        var self = this;
	        el = $(el);
	
	        el.addClass(this.opts.itemClass);
	        var node = self.grid.addNode({
	            x: parseInt(el.attr('data-gs-x'), 10),
	            y: parseInt(el.attr('data-gs-y'), 10),
	            width: el.attr('data-gs-width'),
	            height: el.attr('data-gs-height'),
	            maxWidth: el.attr('data-gs-max-width'),
	            minWidth: el.attr('data-gs-min-width'),
	            maxHeight: el.attr('data-gs-max-height'),
	            minHeight: el.attr('data-gs-min-height'),
	            autoPosition: Utils.toBool(el.attr('data-gs-auto-position')),
	            noResize: Utils.toBool(el.attr('data-gs-no-resize')),
	            noMove: Utils.toBool(el.attr('data-gs-no-move')),
	            locked: Utils.toBool(el.attr('data-gs-locked')),
	            resizeHandles: el.attr('data-gs-resize-handles'),
	            el: el,
	            id: el.attr('data-gs-id'),
	            _grid: self
	        }, triggerAddEvent);
	        el.data('_gridstack_node', node);
	
	        this._prepareElementsByNode(el, node);
	    };
	
	    GridStack.prototype.setAnimation = function(enable) {
	        if (enable) {
	            this.container.addClass('grid-stack-animate');
	        } else {
	            this.container.removeClass('grid-stack-animate');
	        }
	    };
	
	    GridStack.prototype.addWidget = function(el, x, y, width, height, autoPosition, minWidth, maxWidth,
	        minHeight, maxHeight, id) {
	        el = $(el);
	        if (typeof x != 'undefined') { el.attr('data-gs-x', x); }
	        if (typeof y != 'undefined') { el.attr('data-gs-y', y); }
	        if (typeof width != 'undefined') { el.attr('data-gs-width', width); }
	        if (typeof height != 'undefined') { el.attr('data-gs-height', height); }
	        if (typeof autoPosition != 'undefined') { el.attr('data-gs-auto-position', autoPosition ? 'yes' : null); }
	        if (typeof minWidth != 'undefined') { el.attr('data-gs-min-width', minWidth); }
	        if (typeof maxWidth != 'undefined') { el.attr('data-gs-max-width', maxWidth); }
	        if (typeof minHeight != 'undefined') { el.attr('data-gs-min-height', minHeight); }
	        if (typeof maxHeight != 'undefined') { el.attr('data-gs-max-height', maxHeight); }
	        if (typeof id != 'undefined') { el.attr('data-gs-id', id); }
	        this.container.append(el);
	        this._prepareElement(el, true);
	        this._triggerAddEvent();
	        this._updateContainerHeight();
	        this._triggerChangeEvent(true);
	
	        return el;
	    };
	
	    GridStack.prototype.makeWidget = function(el) {
	        el = $(el);
	        this._prepareElement(el, true);
	        this._triggerAddEvent();
	        this._updateContainerHeight();
	        this._triggerChangeEvent(true);
	
	        return el;
	    };
	
	    GridStack.prototype.willItFit = function(x, y, width, height, autoPosition) {
	        var node = {x: x, y: y, width: width, height: height, autoPosition: autoPosition};
	        return this.grid.canBePlacedWithRespectToHeight(node);
	    };
	
	    GridStack.prototype.removeWidget = function(el, detachNode) {
	        detachNode = typeof detachNode === 'undefined' ? true : detachNode;
	        el = $(el);
	        var node = el.data('_gridstack_node');
	
	        // For Meteor support: https://github.com/troolee/gridstack.js/pull/272
	        if (!node) {
	            node = this.grid.getNodeDataByDOMEl(el);
	        }
	
	        this.grid.removeNode(node, detachNode);
	        el.removeData('_gridstack_node');
	        this._updateContainerHeight();
	        if (detachNode) {
	            el.remove();
	        }
	        this._triggerChangeEvent(true);
	        this._triggerRemoveEvent();
	    };
	
	    GridStack.prototype.removeAll = function(detachNode) {
	        _.each(this.grid.nodes, _.bind(function(node) {
	            this.removeWidget(node.el, detachNode);
	        }, this));
	        this.grid.nodes = [];
	        this._updateContainerHeight();
	    };
	
	    GridStack.prototype.destroy = function(detachGrid) {
	        $(window).off('resize', this.onResizeHandler);
	        this.disable();
	        if (typeof detachGrid != 'undefined' && !detachGrid) {
	            this.removeAll(false);
	            this.container.removeData('gridstack');
	        } else {
	            this.container.remove();
	        }
	        Utils.removeStylesheet(this._stylesId);
	        if (this.grid) {
	            this.grid = null;
	        }
	    };
	
	    GridStack.prototype.resizable = function(el, val) {
	        var self = this;
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node == 'undefined' || node === null) {
	                return;
	            }
	
	            node.noResize = !(val || false);
	            if (node.noResize || (self._isOneColumnMode() && !self.opts.disableOneColumnMode)) {
	                self.dd.resizable(el, 'disable');
	            } else {
	                self.dd.resizable(el, 'enable');
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype.movable = function(el, val) {
	        var self = this;
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node == 'undefined' || node === null) {
	                return;
	            }
	
	            node.noMove = !(val || false);
	            if (node.noMove || (self._isOneColumnMode() && !self.opts.disableOneColumnMode)) {
	                self.dd.draggable(el, 'disable');
	                el.removeClass('ui-draggable-handle');
	            } else {
	                self.dd.draggable(el, 'enable');
	                el.addClass('ui-draggable-handle');
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype.enableMove = function(doEnable, includeNewWidgets) {
	        this.movable(this.container.children('.' + this.opts.itemClass), doEnable);
	        if (includeNewWidgets) {
	            this.opts.disableDrag = !doEnable;
	        }
	    };
	
	    GridStack.prototype.enableResize = function(doEnable, includeNewWidgets) {
	        this.resizable(this.container.children('.' + this.opts.itemClass), doEnable);
	        if (includeNewWidgets) {
	            this.opts.disableResize = !doEnable;
	        }
	    };
	
	    GridStack.prototype.disable = function() {
	        this.movable(this.container.children('.' + this.opts.itemClass), false);
	        this.resizable(this.container.children('.' + this.opts.itemClass), false);
	        this.container.trigger('disable');
	    };
	
	    GridStack.prototype.enable = function() {
	        this.movable(this.container.children('.' + this.opts.itemClass), true);
	        this.resizable(this.container.children('.' + this.opts.itemClass), true);
	        this.container.trigger('enable');
	    };
	
	    GridStack.prototype.locked = function(el, val) {
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node == 'undefined' || node === null) {
	                return;
	            }
	
	            node.locked = (val || false);
	            el.attr('data-gs-locked', node.locked ? 'yes' : null);
	        });
	        return this;
	    };
	
	    GridStack.prototype.maxHeight = function(el, val) {
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node === 'undefined' || node === null) {
	                return;
	            }
	
	            if (!isNaN(val)) {
	                node.maxHeight = (val || false);
	                el.attr('data-gs-max-height', val);
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype.minHeight = function(el, val) {
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node === 'undefined' || node === null) {
	                return;
	            }
	
	            if (!isNaN(val)) {
	                node.minHeight = (val || false);
	                el.attr('data-gs-min-height', val);
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype.maxWidth = function(el, val) {
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node === 'undefined' || node === null) {
	                return;
	            }
	
	            if (!isNaN(val)) {
	                node.maxWidth = (val || false);
	                el.attr('data-gs-max-width', val);
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype.minWidth = function(el, val) {
	        el = $(el);
	        el.each(function(index, el) {
	            el = $(el);
	            var node = el.data('_gridstack_node');
	            if (typeof node === 'undefined' || node === null) {
	                return;
	            }
	
	            if (!isNaN(val)) {
	                node.minWidth = (val || false);
	                el.attr('data-gs-min-width', val);
	            }
	        });
	        return this;
	    };
	
	    GridStack.prototype._updateElement = function(el, callback) {
	        el = $(el).first();
	        var node = el.data('_gridstack_node');
	        if (typeof node == 'undefined' || node === null) {
	            return;
	        }
	
	        var self = this;
	
	        self.grid.cleanNodes();
	        self.grid.beginUpdate(node);
	
	        callback.call(this, el, node);
	
	        self._updateContainerHeight();
	        self._triggerChangeEvent();
	
	        self.grid.endUpdate();
	    };
	
	    GridStack.prototype.resize = function(el, width, height) {
	        this._updateElement(el, function(el, node) {
	            width = (width !== null && typeof width != 'undefined') ? width : node.width;
	            height = (height !== null && typeof height != 'undefined') ? height : node.height;
	
	            this.grid.moveNode(node, node.x, node.y, width, height);
	        });
	    };
	
	    GridStack.prototype.move = function(el, x, y) {
	        this._updateElement(el, function(el, node) {
	            x = (x !== null && typeof x != 'undefined') ? x : node.x;
	            y = (y !== null && typeof y != 'undefined') ? y : node.y;
	
	            this.grid.moveNode(node, x, y, node.width, node.height);
	        });
	    };
	
	    GridStack.prototype.update = function(el, x, y, width, height) {
	        this._updateElement(el, function(el, node) {
	            x = (x !== null && typeof x != 'undefined') ? x : node.x;
	            y = (y !== null && typeof y != 'undefined') ? y : node.y;
	            width = (width !== null && typeof width != 'undefined') ? width : node.width;
	            height = (height !== null && typeof height != 'undefined') ? height : node.height;
	
	            this.grid.moveNode(node, x, y, width, height);
	        });
	    };
	
	    GridStack.prototype.verticalMargin = function(val, noUpdate) {
	        if (typeof val == 'undefined') {
	            return this.opts.verticalMargin;
	        }
	
	        var heightData = Utils.parseHeight(val);
	
	        if (this.opts.verticalMarginUnit === heightData.unit && this.opts.height === heightData.height) {
	            return ;
	        }
	        this.opts.verticalMarginUnit = heightData.unit;
	        this.opts.verticalMargin = heightData.height;
	
	        if (!noUpdate) {
	            this._updateStyles();
	        }
	    };
	
	    GridStack.prototype.cellHeight = function(val, noUpdate) {
	        if (typeof val == 'undefined') {
	            if (this.opts.cellHeight) {
	                return this.opts.cellHeight;
	            }
	            var o = this.container.children('.' + this.opts.itemClass).first();
	            return Math.ceil(o.outerHeight() / o.attr('data-gs-height'));
	        }
	        var heightData = Utils.parseHeight(val);
	
	        if (this.opts.cellHeightUnit === heightData.unit && this.opts.cellHeight === heightData.height) {
	            return ;
	        }
	        this.opts.cellHeightUnit = heightData.unit;
	        this.opts.cellHeight = heightData.height;
	
	        if (!noUpdate) {
	            this._updateStyles();
	        }
	
	    };
	
	    GridStack.prototype.cellWidth = function() {
	        return Math.round(this.container.outerWidth() / this.opts.width);
	    };
	
	    GridStack.prototype.getCellFromPixel = function(position, useOffset) {
	        var containerPos = (typeof useOffset != 'undefined' && useOffset) ?
	            this.container.offset() : this.container.position();
	        var relativeLeft = position.left - containerPos.left;
	        var relativeTop = position.top - containerPos.top;
	
	        var columnWidth = Math.floor(this.container.width() / this.opts.width);
	        var rowHeight = Math.floor(this.container.height() / parseInt(this.container.attr('data-gs-current-height')));
	
	        return {x: Math.floor(relativeLeft / columnWidth), y: Math.floor(relativeTop / rowHeight)};
	    };
	
	    GridStack.prototype.batchUpdate = function() {
	        this.grid.batchUpdate();
	    };
	
	    GridStack.prototype.commit = function() {
	        this.grid.commit();
	        this._updateContainerHeight();
	    };
	
	    GridStack.prototype.isAreaEmpty = function(x, y, width, height) {
	        return this.grid.isAreaEmpty(x, y, width, height);
	    };
	
	    GridStack.prototype.setStatic = function(staticValue) {
	        this.opts.staticGrid = (staticValue === true);
	        this.enableMove(!staticValue);
	        this.enableResize(!staticValue);
	        this._setStaticClass();
	    };
	
	    GridStack.prototype._setStaticClass = function() {
	        var staticClassName = 'grid-stack-static';
	
	        if (this.opts.staticGrid === true) {
	            this.container.addClass(staticClassName);
	        } else {
	            this.container.removeClass(staticClassName);
	        }
	    };
	
	    GridStack.prototype._updateNodeWidths = function(oldWidth, newWidth) {
	        this.grid._sortNodes();
	        this.grid.batchUpdate();
	        var node = {};
	        for (var i = 0; i < this.grid.nodes.length; i++) {
	            node = this.grid.nodes[i];
	            this.update(node.el, Math.round(node.x * newWidth / oldWidth), undefined,
	                Math.round(node.width * newWidth / oldWidth), undefined);
	        }
	        this.grid.commit();
	    };
	
	    GridStack.prototype.setGridWidth = function(gridWidth,doNotPropagate) {
	        this.container.removeClass('grid-stack-' + this.opts.width);
	        if (doNotPropagate !== true) {
	            this._updateNodeWidths(this.opts.width, gridWidth);
	        }
	        this.opts.width = gridWidth;
	        this.grid.width = gridWidth;
	        this.container.addClass('grid-stack-' + gridWidth);
	    };
	
	    // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
	    GridStackEngine.prototype.batch_update = obsolete(GridStackEngine.prototype.batchUpdate);
	    GridStackEngine.prototype._fix_collisions = obsolete(GridStackEngine.prototype._fixCollisions,
	        '_fix_collisions', '_fixCollisions');
	    GridStackEngine.prototype.is_area_empty = obsolete(GridStackEngine.prototype.isAreaEmpty,
	        'is_area_empty', 'isAreaEmpty');
	    GridStackEngine.prototype._sort_nodes = obsolete(GridStackEngine.prototype._sortNodes,
	        '_sort_nodes', '_sortNodes');
	    GridStackEngine.prototype._pack_nodes = obsolete(GridStackEngine.prototype._packNodes,
	        '_pack_nodes', '_packNodes');
	    GridStackEngine.prototype._prepare_node = obsolete(GridStackEngine.prototype._prepareNode,
	        '_prepare_node', '_prepareNode');
	    GridStackEngine.prototype.clean_nodes = obsolete(GridStackEngine.prototype.cleanNodes,
	        'clean_nodes', 'cleanNodes');
	    GridStackEngine.prototype.get_dirty_nodes = obsolete(GridStackEngine.prototype.getDirtyNodes,
	        'get_dirty_nodes', 'getDirtyNodes');
	    GridStackEngine.prototype.add_node = obsolete(GridStackEngine.prototype.addNode,
	        'add_node', 'addNode, ');
	    GridStackEngine.prototype.remove_node = obsolete(GridStackEngine.prototype.removeNode,
	        'remove_node', 'removeNode');
	    GridStackEngine.prototype.can_move_node = obsolete(GridStackEngine.prototype.canMoveNode,
	        'can_move_node', 'canMoveNode');
	    GridStackEngine.prototype.move_node = obsolete(GridStackEngine.prototype.moveNode,
	        'move_node', 'moveNode');
	    GridStackEngine.prototype.get_grid_height = obsolete(GridStackEngine.prototype.getGridHeight,
	        'get_grid_height', 'getGridHeight');
	    GridStackEngine.prototype.begin_update = obsolete(GridStackEngine.prototype.beginUpdate,
	        'begin_update', 'beginUpdate');
	    GridStackEngine.prototype.end_update = obsolete(GridStackEngine.prototype.endUpdate,
	        'end_update', 'endUpdate');
	    GridStackEngine.prototype.can_be_placed_with_respect_to_height =
	        obsolete(GridStackEngine.prototype.canBePlacedWithRespectToHeight,
	        'can_be_placed_with_respect_to_height', 'canBePlacedWithRespectToHeight');
	    GridStack.prototype._trigger_change_event = obsolete(GridStack.prototype._triggerChangeEvent,
	        '_trigger_change_event', '_triggerChangeEvent');
	    GridStack.prototype._init_styles = obsolete(GridStack.prototype._initStyles,
	        '_init_styles', '_initStyles');
	    GridStack.prototype._update_styles = obsolete(GridStack.prototype._updateStyles,
	        '_update_styles', '_updateStyles');
	    GridStack.prototype._update_container_height = obsolete(GridStack.prototype._updateContainerHeight,
	        '_update_container_height', '_updateContainerHeight');
	    GridStack.prototype._is_one_column_mode = obsolete(GridStack.prototype._isOneColumnMode,
	        '_is_one_column_mode','_isOneColumnMode');
	    GridStack.prototype._prepare_element = obsolete(GridStack.prototype._prepareElement,
	        '_prepare_element', '_prepareElement');
	    GridStack.prototype.set_animation = obsolete(GridStack.prototype.setAnimation,
	        'set_animation', 'setAnimation');
	    GridStack.prototype.add_widget = obsolete(GridStack.prototype.addWidget,
	        'add_widget', 'addWidget');
	    GridStack.prototype.make_widget = obsolete(GridStack.prototype.makeWidget,
	        'make_widget', 'makeWidget');
	    GridStack.prototype.will_it_fit = obsolete(GridStack.prototype.willItFit,
	        'will_it_fit', 'willItFit');
	    GridStack.prototype.remove_widget = obsolete(GridStack.prototype.removeWidget,
	        'remove_widget', 'removeWidget');
	    GridStack.prototype.remove_all = obsolete(GridStack.prototype.removeAll,
	        'remove_all', 'removeAll');
	    GridStack.prototype.min_height = obsolete(GridStack.prototype.minHeight,
	        'min_height', 'minHeight');
	    GridStack.prototype.min_width = obsolete(GridStack.prototype.minWidth,
	        'min_width', 'minWidth');
	    GridStack.prototype._update_element = obsolete(GridStack.prototype._updateElement,
	        '_update_element', '_updateElement');
	    GridStack.prototype.cell_height = obsolete(GridStack.prototype.cellHeight,
	        'cell_height', 'cellHeight');
	    GridStack.prototype.cell_width = obsolete(GridStack.prototype.cellWidth,
	        'cell_width', 'cellWidth');
	    GridStack.prototype.get_cell_from_pixel = obsolete(GridStack.prototype.getCellFromPixel,
	        'get_cell_from_pixel', 'getCellFromPixel');
	    GridStack.prototype.batch_update = obsolete(GridStack.prototype.batchUpdate,
	        'batch_update', 'batchUpdate');
	    GridStack.prototype.is_area_empty = obsolete(GridStack.prototype.isAreaEmpty,
	        'is_area_empty', 'isAreaEmpty');
	    GridStack.prototype.set_static = obsolete(GridStack.prototype.setStatic,
	        'set_static', 'setStatic');
	    GridStack.prototype._set_static_class = obsolete(GridStack.prototype._setStaticClass,
	        '_set_static_class', '_setStaticClass');
	    // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
	
	    scope.GridStackUI = GridStack;
	
	    scope.GridStackUI.Utils = Utils;
	    scope.GridStackUI.Engine = GridStackEngine;
	    scope.GridStackUI.GridStackDragDropPlugin = GridStackDragDropPlugin;
	
	    $.fn.gridstack = function(opts) {
	        return this.each(function() {
	            var o = $(this);
	            if (!o.data('gridstack')) {
	                o
	                    .data('gridstack', new GridStack(this, opts));
	            }
	        });
	    };
	
	    return scope.GridStackUI;
	});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(48);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	} ) );


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Disable Selection 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: disableSelection
	//>>group: Core
	//>>description: Disable selection of text content within the set of matched elements.
	//>>docs: http://api.jqueryui.com/disableSelection/
	
	// This file is deprecated
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.extend( {
		disableSelection: ( function() {
			var eventType = "onselectstart" in document.createElement( "div" ) ?
				"selectstart" :
				"mousedown";
	
			return function() {
				return this.on( eventType + ".ui-disableSelection", function( event ) {
					event.preventDefault();
				} );
			};
		} )(),
	
		enableSelection: function() {
			return this.off( ".ui-disableSelection" );
		}
	} );
	
	} ) );


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Focusable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :focusable Selector
	//>>group: Core
	//>>description: Selects elements which can be focused.
	//>>docs: http://api.jqueryui.com/focusable-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// Selectors
	$.ui.focusable = function( element, hasTabindex ) {
		var map, mapName, img, focusableIfVisible, fieldset,
			nodeName = element.nodeName.toLowerCase();
	
		if ( "area" === nodeName ) {
			map = element.parentNode;
			mapName = map.name;
			if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
				return false;
			}
			img = $( "img[usemap='#" + mapName + "']" );
			return img.length > 0 && img.is( ":visible" );
		}
	
		if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
			focusableIfVisible = !element.disabled;
	
			if ( focusableIfVisible ) {
	
				// Form controls within a disabled fieldset are disabled.
				// However, controls within the fieldset's legend do not get disabled.
				// Since controls generally aren't placed inside legends, we skip
				// this portion of the check.
				fieldset = $( element ).closest( "fieldset" )[ 0 ];
				if ( fieldset ) {
					focusableIfVisible = !fieldset.disabled;
				}
			}
		} else if ( "a" === nodeName ) {
			focusableIfVisible = element.href || hasTabindex;
		} else {
			focusableIfVisible = hasTabindex;
		}
	
		return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
	};
	
	// Support: IE 8 only
	// IE 8 doesn't resolve inherit to visible/hidden for computed values
	function visible( element ) {
		var visibility = element.css( "visibility" );
		while ( visibility === "inherit" ) {
			element = element.parent();
			visibility = element.css( "visibility" );
		}
		return visibility !== "hidden";
	}
	
	$.extend( $.expr[ ":" ], {
		focusable: function( element ) {
			return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
		}
	} );
	
	return $.ui.focusable;
	
	} ) );


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeActiveElement = function( document ) {
		var activeElement;
	
		// Support: IE 9 only
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {
			activeElement = document.activeElement;
		} catch ( error ) {
			activeElement = document.body;
		}
	
		// Support: IE 9 - 11 only
		// IE may return null instead of an element
		// Interestingly, this only seems to occur when NOT in an iframe
		if ( !activeElement ) {
			activeElement = document.body;
		}
	
		// Support: IE 11 only
		// IE11 returns a seemingly empty object in some cases when accessing
		// document.activeElement from an <iframe>
		if ( !activeElement.nodeName ) {
			activeElement = document.body;
		}
	
		return activeElement;
	};
	
	} ) );


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeBlur = function( element ) {
	
		// Support: IE9 - 10 only
		// If the <body> is blurred, IE will switch windows, see #9420
		if ( element && element.nodeName.toLowerCase() !== "body" ) {
			$( element ).trigger( "blur" );
		}
	};
	
	} ) );


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	} ) );


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Draggable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Draggable
	//>>group: Interactions
	//>>description: Enables dragging functionality for any element.
	//>>docs: http://api.jqueryui.com/draggable/
	//>>demos: http://jqueryui.com/draggable/
	//>>css.structure: ../../themes/base/draggable.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(34),
				__webpack_require__(81),
				__webpack_require__(50),
				__webpack_require__(85),
				__webpack_require__(86),
				__webpack_require__(87),
				__webpack_require__(3),
				__webpack_require__(23)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.draggable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// Callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if ( this.options.addClasses ) {
				this._addClass( "ui-draggable" );
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var o = this.options;
	
			// Among others, prevent a drag on a resizable-handle
			if ( this.helper || o.disabled ||
					$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle( event );
			if ( !this.handle ) {
				return false;
			}
	
			this._blurActiveElement( event );
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map( function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			} );
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				target = $( event.target );
	
			// Don't blur if the event occurred on an element that is within
			// the currently focused element
			// See #10527, #12472
			if ( target.closest( activeElement ).length ) {
				return;
			}
	
			// Blur any element that currently has focus, see #4261
			$.ui.safeBlur( activeElement );
		},
	
		_mouseStart: function( event ) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			this._addClass( this.helper, "ui-draggable-dragging" );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter( function() {
					return $( this ).css( "position" ) === "fixed";
				} ).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if ( this._trigger( "start", event ) === false ) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			// Execute the drag once - this causes the helper not to be visible before getting its
			// correct position
			this._mouseDrag( event, true );
	
			// If the ddmanager is used for droppables, inform the manager that dragging has started
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart( this, event );
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function( event, noPropagation ) {
	
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if ( !noPropagation ) {
				var ui = this._uiHash();
				if ( this._trigger( "drag", event, ui ) === false ) {
					this._mouseUp( new $.Event( "mouseup", event ) );
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				dropped = $.ui.ddmanager.drop( this, event );
			}
	
			//if a drop comes from outside (a sortable)
			if ( this.dropped ) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ( ( this.options.revert === "invalid" && !dropped ) ||
					( this.options.revert === "valid" && dropped ) ||
					this.options.revert === true || ( $.isFunction( this.options.revert ) &&
					this.options.revert.call( this.element, dropped ) )
			) {
				$( this.helper ).animate(
					this.originalPosition,
					parseInt( this.options.revertDuration, 10 ),
					function() {
						if ( that._trigger( "stop", event ) !== false ) {
							that._clear();
						}
					}
				);
			} else {
				if ( this._trigger( "stop", event ) !== false ) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			// If the ddmanager is used for droppables, inform the manager that dragging has stopped
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop( this, event );
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
	
				// The interaction is over; whether or not the click resulted in a drag,
				// focus the element
				this.element.trigger( "focus" );
			}
	
			return $.ui.mouse.prototype._mouseUp.call( this, event );
		},
	
		cancel: function() {
	
			if ( this.helper.is( ".ui-draggable-dragging" ) ) {
				this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function( event ) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this._addClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this._removeClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if ( !helper.parents( "body" ).length ) {
				helper.appendTo( ( o.appendTo === "parent" ?
					this.element[ 0 ].parentNode :
					o.appendTo ) );
			}
	
			// Http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if ( helper[ 0 ] !== this.element[ 0 ] &&
					!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
				helper.css( "position", "absolute" );
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
				right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
				bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() -
						this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() +
						( $( window ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document" ) {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ) {
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
						pageX = containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
						pageY = containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
						pageX = containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
						pageY = containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
	
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
					// argument errors in IE (see ticket #6950)
					top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
						this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
					pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
						top - this.offset.click.top > containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;
	
					left = o.grid[ 0 ] ? this.originalPageX +
						Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
						this.originalPageX;
					pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
						left - this.offset.click.left > containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this._removeClass( this.helper, "ui-draggable-dragging" );
			if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	} );
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each( function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// RefreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger( "activate", event, uiSortable );
				}
			} );
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop( event );
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
	
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			} );
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
	
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					} );
				}
	
				if ( innermostIntersecting ) {
	
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
	
						// Hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
	
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
	
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// Restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
					}
				}
			} );
		}
	} );
	
	$.ui.plugin.add( "draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if ( t.css( "cursor" ) ) {
				o._cursor = t.css( "cursor" );
			}
			t.css( "cursor", o.cursor );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._cursor ) {
				$( "body" ).css( "cursor", o._cursor );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if ( t.css( "opacity" ) ) {
				o._opacity = t.css( "opacity" );
			}
			t.css( "opacity", o.opacity );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._opacity ) {
				$( ui.helper ).css( "opacity", o._opacity );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
					i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
							o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
							o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if ( !o.axis || o.axis !== "x" ) {
					if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
					} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() - o.scrollSpeed
						);
					} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() + o.scrollSpeed
						);
					}
				}
	
			}
	
			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( i, event );
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
				.each( function() {
					var $t = $( this ),
						$o = $t.offset();
					if ( this !== i.element[ 0 ] ) {
						i.snapElements.push( {
							item: this,
							width: $t.outerWidth(), height: $t.outerHeight(),
							top: $o.top, left: $o.left
						} );
					}
				} );
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {
	
				l = inst.snapElements[ i ].left - inst.margins.left;
				r = l + inst.snapElements[ i ].width;
				t = inst.snapElements[ i ].top - inst.margins.top;
				b = t + inst.snapElements[ i ].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
						!$.contains( inst.snapElements[ i ].item.ownerDocument,
						inst.snapElements[ i ].item ) ) {
					if ( inst.snapElements[ i ].snapping ) {
						( inst.options.snap.release &&
							inst.options.snap.release.call(
								inst.element,
								event,
								$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
							) );
					}
					inst.snapElements[ i ].snapping = false;
					continue;
				}
	
				if ( o.snapMode !== "inner" ) {
					ts = Math.abs( t - y2 ) <= d;
					bs = Math.abs( b - y1 ) <= d;
					ls = Math.abs( l - x2 ) <= d;
					rs = Math.abs( r - x1 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l - inst.helperProportions.width
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r
						} ).left;
					}
				}
	
				first = ( ts || bs || ls || rs );
	
				if ( o.snapMode !== "outer" ) {
					ts = Math.abs( t - y1 ) <= d;
					bs = Math.abs( b - y2 ) <= d;
					ls = Math.abs( l - x1 ) <= d;
					rs = Math.abs( r - x2 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r - inst.helperProportions.width
						} ).left;
					}
				}
	
				if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
					( inst.options.snap.snap &&
						inst.options.snap.snap.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), {
								snapItem: inst.snapElements[ i ].item
							} ) ) );
				}
				inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );
	
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
					return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
						( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
				} );
	
			if ( !group.length ) { return; }
	
			min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
			$( group ).each( function( i ) {
				$( this ).css( "zIndex", min + i );
			} );
			this.css( "zIndex", ( min + group.length ) );
		}
	} );
	
	$.ui.plugin.add( "draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if ( t.css( "zIndex" ) ) {
				o._zIndex = t.css( "zIndex" );
			}
			t.css( "zIndex", o.zIndex );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if ( o._zIndex ) {
				$( ui.helper ).css( "zIndex", o._zIndex );
			}
		}
	} );
	
	return $.ui.draggable;
	
	} ) );


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(231)(module)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(228);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(533);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var objectKeys = __webpack_require__(227);
	var hasSymbols = __webpack_require__(80)();
	var callBound = __webpack_require__(462);
	var toObject = Object;
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function assign(target, source1) {
		if (target == null) { throw new TypeError('target must be an object'); }
		var to = toObject(target); // step 1
		if (arguments.length === 1) {
			return to; // step 2
		}
		for (var s = 1; s < arguments.length; ++s) {
			var from = toObject(arguments[s]); // step 3.a.i
	
			// step 3.a.ii:
			var keys = objectKeys(from);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				var syms = getSymbols(from);
				for (var j = 0; j < syms.length; ++j) {
					var key = syms[j];
					if ($propIsEnumerable(from, key)) {
						$push(keys, key);
					}
				}
			}
	
			// step 3.a.iii:
			for (var i = 0; i < keys.length; ++i) {
				var nextKey = keys[i];
				if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
					var propValue = from[nextKey]; // step 3.a.iii.2.a
					to[nextKey] = propValue; // step 3.a.iii.2.b
				}
			}
		}
	
		return to; // step 4
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(229);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';
	
	function ARGB2HexDirective() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function($scope, element, attr, ngModel) {
	      function toHex(argb) {
	        return '#'+ ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6);
	      }
	
	      function fromHex(hex) {
	        if (7 !== hex.length) {
	          return 0;
	        }
	
	        return parseInt("FF" + hex.substr(1), 16);
	      }
	
	      ngModel.$formatters.push(toHex);
	      ngModel.$parsers.push(fromHex);
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('argb2hex', ARGB2HexDirective);


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	function ARGB2HexFilter() {
	  return function(color) {
	    return '#'+ ('000000' + (color & 0xFFFFFF).toString(16)).slice(-6);
	  };
	}
	
	function Hex2ARGBFilter() {
	  return function(color) {
	    if (7 !== color.length) {
	      return 0;
	    }
	
	    return parseInt("FF" + color.substr(1), 16);
	  };
	}
	
	angular.module('dokiv')
	  .filter('ARGB2HexFilter', ARGB2HexFilter)
	  .filter('Hex2ARGBFilter', Hex2ARGBFilter);


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	// Function to return text color with best contrast by aRBG value
	function ARGBTextColorFilter() {
	  return function(color) {
	    var R = ((color & 0x00ff0000) >> 16) / 255;
	    var B = ((color & 0x0000ff00) >> 8) / 255;
	    var G = (color & 0x000000ff) / 255;
	
	    var L = (0.299 * R + 0.587 * G + 0.114 * B);
	
	    if (L >= 0.5) {
	      return '#000000';
	    }
	
	    return '#ffffff';
	  };
	}
	
	angular.module('dokiv')
	  .filter('ARGBTextColorFilter', ARGBTextColorFilter);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var DATE_TIME = 'Y-m-d H:i';
	var DATE      = 'Y-m-d';
	  
	FlatpickrDirective.$inject = [];
	function FlatpickrDirective() {
	  return {
	    require: '^ngModel',
	    restrict : 'A',
	    scope : {
	      dateOnly: "=",
	      minDate: "=",
	      maxDate: "="
	    },
	    link : function(scope, element, attrs, ngModel) {
	      var el        = element[0];
	      var flatpickr = __webpack_require__(76);
	      flatpickr.init.prototype.l10n.firstDayOfWeek = 1;
	      flatpickr.init.prototype.l10n.weekdays = {
	        shorthand: ['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör'],
	        longhand: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],         
	      };
	      flatpickr.init.prototype.l10n.months = {
	        shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
	        longhand: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
	      };
	      var vp;
	
	      function dateIsEqual(a, b) {
	        if(a instanceof Date && b instanceof Date) {
	          return a.getTime() === b.getTime();
	        }
	
	        return false;
	      }
	
	      function options(dateOnly) {
	        return {
	          defaultDate: new Date(ngModel.$modelValue),
	          dateFormat:  dateOnly ? DATE : DATE_TIME,
	          enableTime:  !dateOnly,
	          time_24hr:   true,
	          minDate: angular.isDefined(scope.minDate) ? new Date(scope.minDate) : null,
	          maxDate: angular.isDefined(scope.maxDate) ? new Date(scope.maxDate) : null,
	          onChange:    function() {
	            scope.$apply(function() {
	              ngModel.$setViewValue(vp.selectedDateObj);
	            });
	          }
	        };
	      }
	
	      ngModel.$render = function() {
	        if(!vp) {
	          // Flatpickr needs to have a defaultDate all the time, or it will default to 12:00
	          // so we wait until we actually try to render before we create the Flatpickr
	          vp = flatpickr(el, options(scope.dateOnly));
	
	          scope.$watch('dateOnly', function(dateOnly, old) {
	            if(dateOnly !== old) {
	              // Reinitialize to make flatpickr recreate the picker
	              vp = flatpickr(el, options(dateOnly));
	            }
	          });
	          scope.$watch("[minDate,maxDate]", function(newValue, oldValue){
	            if ((newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])) || (newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1]))) {
	              vp = flatpickr(el, options(scope.dateOnly));
	            }
	          });
	        } else {
	          if (ngModel.$modelValue !== null) {
	            // defaultDate is used to read the time from
	            vp.set("defaultDate", new Date(ngModel.$modelValue));
	            // Then we set the date to update it
	            vp.setDate(new Date(ngModel.$modelValue));
	            if (!scope.dateOnly) {
	              vp.setTime(ngModel.$modelValue.getHours(), ngModel.$modelValue.getMinutes());
	            }
	          }
	        }
	      };
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('ngFlatpickr', [FlatpickrDirective]);


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	function ArrowNavDirective() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem) {
	      elem.attr('tabindex', '1');
	      elem.addClass('focusable');
	      elem.on('keydown', function(e) {
	        if (e.keyCode === 38) { // up
	          $(elem[0]).prev('.focusable').focus();
	          e.preventDefault();
	        }
	
	        else if (e.keyCode === 40) { // down
	          $(elem[0]).next('.focusable').focus();
	          e.preventDefault();
	        }
	
	        else if (e.keyCode === 13) { // enter
	          elem.triggerHandler('click');
	        }
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('arrowNav', ArrowNavDirective);


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	
	function getValue(data) {
	  if(typeof data === "function") {
	    return data();
	  }
	
	  return data;
	}
	
	function toCamelCase(str) {
	  return str.replace(/-([a-z])/g, function (g) {
	    return g[1].toUpperCase();
	  });
	}
	
	function BindEarlyAttrCtrl(elem, attrs, scope) {
	  var data = scope.$eval(attrs.bindEarlyAttr);
	
	  for (var attr in data) {
	    if (data.hasOwnProperty(attr)) {
	      /* Update the internal representation to propagate to other directives */
	      attrs[toCamelCase(attr)] = getValue(data[attr]);
	
	      elem.attr(attr, getValue(data[attr]));
	    }
	  }
	}
	
	function BindEarlyAttr() {
	  return {
	    priority:   999999,
	    restrict:   'A',
	    controller: ['$element', '$attrs', '$scope', BindEarlyAttrCtrl]
	  };
	}
	
	angular.module('dokiv')
	  .directive('bindEarlyAttr', BindEarlyAttr);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('dokiv')
	  .factory('CompanyFeedService', ['$translate', function($translate) {
	    return {
	      feedTranslator: function(f, userType) {
	        var router;
	        switch (f.action) {
	          case 'ENTER_COMPANY':
	          case 'LEAVE_COMPANY':
	          case 'LOGIN':
	          case 'LOGOUT':
	          case 'RESET_PASSWORD':
	            f.extra.objectTypeName = f.extra.objectType;
	            return {
	              router: router,
	              feed: f,
	              type: 1
	            };
	
	          case 'CREATE':
	            f.extra.objectTypeName = f.extra.objectType;
	            if (userType === 'DEFAULT') {
	              if (f.extra.objectType === 'PUBLICATION') {
	                router = 'root.company.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	                f.extra.objectTypeName = 'OBJECT';
	              } else if (f.extra.objectType === 'CUSTOMER') {
	                router = 'root.company.customers-dashboard.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	              } else if (f.extra.objectType === 'CHECKLIST') {
	                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
	              }
	            } else {
	              if (f.extra.objectType === 'PUBLICATION') {
	                router = 'root.company-guest.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	                f.extra.objectTypeName = 'OBJECT';
	              }
	            }
	            return {
	              router: router,
	              feed: f,
	              type: 2
	            };
	
	          case 'UPDATE':
	          case 'VERIFY':
	          case 'CHECK':
	          case 'UNCHECK':
	          case 'DONE':
	          case 'DELETE':
	          case 'FILE_INVISIBLE':
	          case 'FILE_VISIBLE':
	          case 'FILE_UPLOADED':
	          case 'FILE_DOWNLOADED':
	          case 'FORM_SUBMIT':
	          case 'SHARED':
	          case 'SEND':
	            var modifiedProperty = null;
	            f.extra.objectTypeName = f.extra.objectType;
	            if (f.extra.objectType === 'PUBLICATION') {
	              f.extra.objectTypeName = 'OBJECT';
	              if (userType === 'DEFAULT') {
	                router = 'root.company.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	              } else {
	                router = 'root.company-guest.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	              }
	              var textMore = '';
	              if (f.extra.newData) {
	                if (f.extra.newData.Features) {
	                  break;
	                }
	                var objectKey = Object.keys(f.extra.newData).length > 1 ? Object.keys(f.extra.newData)[Object.keys(f.extra.newData).length -1] : Object.keys(f.extra.newData)[0];
	                textMore += (f.extra.newData.Priority ? (' to ' + f.extra.newData.Priority.name) : '') + (f.extra.newData.Reference ? (' to ' + f.extra.newData.Reference) : '');
	                if (objectKey === 'Parent') {
	                  if (f.extra.newData.Parent) {
	                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.set-parent') + textMore;
	                  } else {
	                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.unset-parent') + textMore;
	                  }
	                } else if (objectKey === 'Status') {
	                  if (f.extra.newData.Status === 'DELETED') {
	                    break;
	                  }
	                  modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('notification.actions.change-status', {status: $translate.instant('publication.' + angular.lowercase(f.extra.newData.Status))});
	                } else {
	                  if(objectKey){
	                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.' + objectKey) + textMore;
	                  }
	                }
	              } else if (f.action === 'FILE_INVISIBLE' || f.action === 'FILE_VISIBLE' || f.action === 'FILE_UPLOADED') {
	                modifiedProperty = $translate.instant('notification.actions.' + f.action, {
	                  fileName: f.extra.fileName
	                });
	              } else if (f.action === 'FILE_DOWNLOADED') {
	                modifiedProperty = $translate.instant('notification.actions.FILE_DOWNLOADED');
	              } else if (f.action === 'DELETE') {
	                textMore += (f.extra.inforName ? (" keypass " + f.extra.inforName) : "");
	                modifiedProperty = $translate.instant('notification.actions.deleted') + textMore;
	              } else if (f.action === 'SHARED') {
	                router = 'root.company.publication.shares({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
	                if (f.extra.action === 'CREATE_SHARE') {
	                  modifiedProperty = $translate.instant('publication.activity.shared', {email: f.extra.email});
	                } else if (f.extra.action === 'END_SHARE') {
	                  modifiedProperty = $translate.instant('publication.activity.end-shared');
	                } 
	              } else if (f.extra.inforName){
	                modifiedProperty = $translate.instant('notification.actions.updated') + ': keypass ' + $translate.instant('notification.named') + " " + f.extra.inforName;
	              } else if (f.action === 'VERIFY'){
	                modifiedProperty = $translate.instant('notification.actions.verified');
	              }
	            } else {
	              if (f.action === 'CHECK' || f.action === 'UNCHECK' || f.action === 'DONE') {
	                modifiedProperty = $translate.instant('publication.activity.history.' + angular.lowercase(f.action), {
	                  user:     f.performedBy.name,
	                  checkItem: f.extra.checkItem,
	                  checklist: f.extra.object.name
	                });
	                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
	              } else if (f.action === 'UPDATE') {
	                modifiedProperty = $translate.instant('notification.actions.updated');
	                if (f.extra.objectType === 'CUSTOMER') {
	                  router = 'root.company.customers-dashboard.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
	                }
	              } else if (f.action === 'DELETE') {
	                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
	                modifiedProperty = f.performedBy.name + ' ' +$translate.instant('notification.actions.deleted');
	              } else if (f.action === 'FORM_SUBMIT') {
	                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
	                modifiedProperty = $translate.instant('notification.actions.' + f.action, {formName: f.extra.humanReadableID});
	              } else if (f.action === 'SEND') {
	                modifiedProperty = $translate.instant('notification.actions.sent-email');
	              }
	            }
	            return {
	              router: router,
	              modifiedProperty: modifiedProperty,
	              feed: f,
	              type: 3
	            };
	
	          case 'JOIN':
	          case 'LEFT':
	          case 'GRANTED_PERMISSION':
	          case 'REMOVED_PERMISSION':
	          case 'INVITED':
	            f.extra.objectTypeName = f.extra.objectType;
	            modifiedProperty = $translate.instant('notification.actions.' + f.action);
	            if (f.action === 'GRANTED_PERMISSION' || f.action === 'REMOVED_PERMISSION') {
	              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
	                permission: f.extra.permission,
	                user: f.extra.user.name
	              });
	            } else if (f.action === 'INVITED') {
	              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
	                email: f.extra.object.email
	              });
	            } else if (f.action === 'JOIN') {
	              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
	                user: f.extra.object.name
	              });
	            } else if (f.action === 'LEFT') {
	              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
	                user: f.extra.user.name
	              });
	            }
	            return {
	              router: router,
	              modifiedProperty: modifiedProperty,
	              feed: f,
	              type: 4
	            };
	        }
	      }
	    };
	  }]);

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	
	DecacheImageDirective.$inject = ['config'];
	function DecacheImageDirective(config) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope:  {
	      "src": "=imgSrc"
	    },
	    link: function(scope, element) {
	      scope.apiBase = config.apiBase;
	      scope.currentTime = new Date().getTime();
	      scope.$on('imageChanged', function() {
	        element[0].src = scope.apiBase + '/files/' + scope.src + '?decache=' + new Date().getTime();
	      });
	    },
	    template: '<img src="{{apiBase}}/files/{{src}}?decache={{currentTime}}">'
	  };
	}
	
	angular.module('dokiv')
	  .directive('decacheImage', ['config', DecacheImageDirective]);

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	"use strict";
	
	var CSS_STYLE = '<link rel="stylesheet" href="/styles/components/components.css">';
	
	function dokivPrint() {
	  return {
	    restrict: "A",
	    scope: {
	      id: "@dokivPrint"
	    },
	    link: function(scope, el) {
	
	      var iframe = document.createElement("iframe");
	
	      iframe.setAttribute("style", "height: 0; width: 0; position: absolute; bottom: 100%; right: 100%;");
	
	      document.body.appendChild(iframe);
	
	      el.bind("click", function() {
	        var toPrint = $(scope.id)[0];
	        var win     = iframe.contentWindow;
	
	        win.document.open();
	        win.document.write(CSS_STYLE);
	        win.document.write(toPrint.innerHTML);
	        win.document.close();
	
	        win.focus();
	
	        setTimeout(function() {
	          win.print();
	        }, 200);
	      });
	
	      scope.$on("$destroy", function() {
	        iframe.remove();
	      });
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("dokivPrint", dokivPrint);


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	function ErrorCtrl($scope, $rootScope, errorObj, config) {
	  $rootScope.loading = false;
	  $scope.error = errorObj;
	  setTimeout(function() {
	    console.log('here');
	    window.location = config.appBase;
	  }, 5000);
	}
	
	ErrorCtrl.resolve = {
	  errorObj: function() {
	    return this.self.error;
	  }
	};
	module.exports = ErrorCtrl;
	
	angular.module('dokiv')
	  .controller('ErrorCtrl', ['$scope', '$rootScope', 'errorObj', 'config', ErrorCtrl]);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	
	function ExecOnBlurDirective($document) {
	  return {
	    restrict: 'A',
	
	    link: function($scope, $elem, $attrs) {
	      $document.on('click', function(e) {
	        if($elem.find(e.target).length === 0) {
	          $scope.$evalAsync($attrs.execOnBlur);
	        }
	      });
	    }
	
	  };
	}
	
	angular.module('dokiv')
	  .directive('execOnBlur', ['$document', ExecOnBlurDirective]);


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	function FormDirtyConfirmDirective($translate) {
	  return {
	    require: '^form',
	    link: function($scope, elem, attrs, formCtrl) {
	      // Translations
	      var confirmMsg, unsavedMsg;
	
	      confirmMsg = $translate.instant('confirm-form-dirty.question');
	      unsavedMsg = $translate.instant('confirm-form-dirty.unsaved');
	
	      function confirmFormDirty(event) {
	        if(formCtrl.$dirty && !window.confirm(confirmMsg)) {
	          event.preventDefault();
	        }
	      }
	
	      function windowUnload(event) {
	        if(formCtrl.$dirty) {
	          (event || window.event).returnValue = unsavedMsg;
	          return false;
	        }
	
	        return true;
	      }
	      $scope.$on('$stateChangeStart', confirmFormDirty);
	      window.addEventListener('beforeunload', windowUnload, false);
	
	      $scope.$on('$destroy', function() {
	        window.removeEventListener('beforeunload', windowUnload, false);
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('formDirtyConfirm', ['$translate', FormDirtyConfirmDirective]);
	


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	function midPointBtw(p1, p2) {
	  return {
	    x: p1.x + (p2.x - p1.x) / 2,
	    y: p1.y + (p2.y - p1.y) / 2
	  };
	}
	
	function freehandCanvas() {
	  return {
	    restrict: "E",
	    replace:  true,
	    template: "<canvas></canvas>",
	    require: "ngModel",
	    link: function(scope, elem, attrs, ngModel) {
	      var el        = elem[0];
	      var ctx       = el.getContext('2d');
	      var isDrawing = false;
	      var points    = [];
	      var lines     = [];
	
	      function start(e) {
	        isDrawing = true;
	
	        addPoint(e.clientX, e.clientY);
	      }
	
	      function mouseMove(e) {
	        if( ! isDrawing) {
	          return;
	        }
	
	        move(e.clientX, e.clientY);
	      }
	      
	      function touchMove(e) {
	        e.preventDefault();
	
	        move(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
	      }
	      
	      function addPoint(viewportX, viewportY) {
	        var rect = el.getBoundingClientRect();
	        
	        points.push({
	          x: viewportX - rect.left,
	          y: viewportY - rect.top
	        });
	      }
	      
	      function move(x, y) {
	        addPoint(x, y);
	
	        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	
	        for(var i = 0; i < lines.length; i++) {
	          drawLine(lines[i]);
	        }
	
	        drawLine(points);
	      }
	      
	      function drawLine(line) {
	        if(line.length < 2) {
	          return;
	        }
	
	        var p1 = line[0];
	        var p2 = line[1];
	
	        ctx.beginPath();
	        ctx.moveTo(p1.x, p1.y);
	
	        for(var i = 1, len = line.length; i < len; i++) {
	          // we pick the point between pi+1 & pi+2 as the
	          // end point and p1 as our control point
	          var midPoint = midPointBtw(p1, p2);
	
	          ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
	
	          p1 = line[i];
	          p2 = line[i + 1];
	        }
	
	        // Draw last line as a straight line while
	        // we wait for the next point to be able to calculate
	        // the bezier control point
	        ctx.lineTo(p1.x, p1.y);
	        ctx.stroke();
	      }
	
	      function end() {
	        if(points.length < 2) {
	          return;
	        }
	
	        lines.push(points);
	
	        isDrawing       = false;
	        points          = [];
	
	        scope.$apply(function() {
	          ngModel.$setViewValue(lines.length ? el.toDataURL("image/png") : "");
	        });
	      }
	
	      ctx.lineWidth   = parseInt(attrs.lineWidth, 10) || 3;
	      ctx.lineJoin    = ctx.lineCap = 'round';
	      ctx.lineStyle   = "#000";
	      ctx.strokeStyle = "#000";
	
	      el.addEventListener("mousedown",  start,     false);
	      el.addEventListener("mousemove",  mouseMove, false);
	      el.addEventListener("mouseup",    end,       false);
	
	      el.addEventListener("touchstart", start,     false);
	      el.addEventListener("touchmove",  touchMove, true);
	      el.addEventListener("touchend",   end,       false);
	
	      document.body.addEventListener("mouseup",     end, false);
	      document.body.addEventListener("touchcancel", end, false);
	      
	      ngModel.$render = function() {
	        if( ! ngModel.$viewValue) {
	          lines = [];
	
	          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	        }
	      };
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("freehandCanvas", freehandCanvas);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	function groupsToString(groups) {
	  var ids = "";
	  angular.forEach(groups, function(v, k){
	    if (angular.isObject(v)) {
	      if (k === 0) {
	        ids = v.id;
	      } else {
	        ids = ids + ',' + v.id;
	      }
	    } else if (angular.isString(v)) {
	      if (k === 0) {
	        ids = v;
	      } else {
	        ids = ids + ',' + v;
	      }
	    }
	  });
	  return ids;
	}
	
	function GroupMembersDirective($stateParams, CompanyUserService, $modal) {
	  return {
	    restrict: 'A',
	    require: '^ngModel',
	    scope: {
	      showAllUsers: "=?",
	      seeAllObjects: "=?"
	    },
	    link: function(scope, elm, attrs, ngModel) {
	      var LIMIT = 20;
	      scope.page = 0;
	      scope.hasMore = false;
	      if (!attrs.customTitle) {
	        scope.customTitle = 'publication.user-access';
	      } else {
	        scope.customTitle = attrs.customTitle;
	      }
	      ngModel.$render = function() {
	        scope.listGroups = ngModel.$modelValue;
	        loadMembers(scope.listGroups);
	        scope.$watch('listGroups', function(newData, oldData) {
	          if (newData === oldData) {
	            return;
	          }
	          loadMembers(scope.listGroups);
	        }, true);
	
	        var usersModal = $modal({
	          controller: ShowAllUsersCtrl,
	          templateUrl: 'partials/company/publications/members-group/modal.html',
	          show: false,
	          resolve: {
	            groups: function() {
	              return groupsToString(scope.listGroups);
	            }
	          }
	        });
	        scope.showModal = function() {
	          usersModal.$promise.then(usersModal.show);
	        };
	      };
	      function loadMembers(groups) {
	        scope.hasMore = false;
	
	        if (scope.seeAllObjects) {
	          CompanyUserService.query({companyId: $stateParams.companyId, seeAllObjects: true, all: true}).$promise.then(function(resp){
	            scope.members = resp;
	          });
	        } else {
	          var ids = groupsToString(groups),
	            params = {
	              companyId: $stateParams.companyId,
	              groupIds: ids
	            };
	          if (scope.showAllUsers) {
	            params.all = true;
	          } else {
	            params.limit = LIMIT + 1;
	          }
	
	          if (ids !== "") {
	            CompanyUserService.query(params).$promise.then(function(resp){
	              if (!scope.showAllUsers) {
	                if (resp.length === LIMIT + 1) {
	                  scope.hasMore = true;
	                  resp.pop();
	                }
	              }
	              scope.members = resp;
	            });
	          }
	        }
	      }
	    },
	    templateUrl:'partials/company/publications/members-group/main.html'
	  };
	}
	
	ShowAllUsersCtrl.$inject = ['$scope', 'groups', '$stateParams', 'CompanyUserService'];
	function ShowAllUsersCtrl($scope, groups, $stateParams, CompanyUserService) {
	  $scope.members = [];
	  if (groups !== "") {
	    CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      groupIds: groups,
	      all: true
	    }).$promise.then(function(resp){
	      $scope.members = resp;
	    });
	  }
	}
	
	angular.module('dokiv')
	  .directive('groupMembers', ['$stateParams', 'CompanyUserService', '$modal', GroupMembersDirective]);


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	"use strict";
	
	function InfoBoxDirective() {
	  return {
	    restrict: 'E',
	    scope: {
	      langKey: '@key'
	    },
	
	    link: function(scope, elem) {
	      elem.addClass('info-box__wrap');
	    },
	
	    template: '<h5 class="info-box__header">' +
	                '<i class="fa fa-info"></i>' +
	                '{{\'publication.information\' | translate}}' +
	              '</h5>' +
	              '<p class="info-box__text">{{langKey | translate}}</p>'
	  };
	}
	
	angular.module('dokiv')
	  .directive('infoBox', InfoBoxDirective);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var markdown = __webpack_require__(527);
	
	angular.module('dokiv')
	  .filter('markdown', ['$sanitize', function($sanitize) {
	    return function(text) {
	      if(text) {
	        return $sanitize(markdown.markdown.toHTML(String(text)));
	      }
	      else {
	        return "";
	      }
	    };
	  }]);


/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	ReadMoreLessToggle.$inject = [];
	function ReadMoreLessToggle() {
	  return {
	    restrict: 'A',
	    link: function(scope, element) {
	      scope.$watch(function () {
	      }, function () {
	        if (element.children()[0].offsetHeight > 100) {
	          angular.element(element.children()[0]).addClass('short-text');
	          scope.showMore = true;
	        }
	      });
	
	      angular.element(element.children()[1]).on("click", function(){
	        scope.showMore = false;
	        scope.showLess = true;
	        angular.element(element.children()[0]).removeClass('short-text');
	      });
	      angular.element(element.children()[2]).on("click", function(){
	        scope.showMore = true;
	        scope.showLess = false;
	        angular.element(element.children()[0]).addClass('short-text');
	      });        
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('moreLessToggle', ReadMoreLessToggle);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('dokiv')
	  .filter('reverse', function() {
	    return function(items) {
	      return items.slice().reverse();
	    };
	  });

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MAX_NOTIFICATIONS = 50;
	
	__webpack_require__(18);
	__webpack_require__(276);
	__webpack_require__(254);
	__webpack_require__(4);
	__webpack_require__(365);
	
	function RootCtrl(
	  $rootScope,
	  $scope,
	  $state,
	  $timeout,
	  $window,
	  currentUser,
	  AuthService,
	  companies,
	  config,
	  $document,
	  CompanyService,
	  CompanyNotificationsService,
	  $translate) {
	  $scope.companies = companies;
	  $scope.currentUser = currentUser;
	  $scope.logout = AuthService.logout;
	  $scope.userMenuOpen = false;
	  $scope.sidebarOpen = false;
	  $scope.fileUploads = [];
	  $scope.apiBase = config.apiBase;
	
	  $scope.listPublications = function(companyId, userType) {
	    CompanyService.get({
	      companyId: companyId,
	      enterCompany: true
	    });
	
	    var route; 
	
	    switch (userType) {
	      case 'GUEST':
	        route = 'root.company-guest.publications';
	        break;
	      default:
	        route = 'root.company.publications-list';
	    }
	
	    $state.go(route, {companyId: companyId});
	  };
	
	  $rootScope.notifications       = [];
	  $rootScope.notificationsUnread = 0;
	
	  $translate.use(angular.lowercase($scope.currentUser.language));
	  $window.localStorage.language = $scope.currentUser.language;
	  $scope.$on('languageChanged', function(event, data) {
	    $translate.use(angular.lowercase(data));
	    $window.localStorage.language = data;
	  });
	
	  function loadData(offset){
	    if ($state.current.name === 'root.company-selection') {
	      CompanyNotificationsService.queryNotificationsUser({userId: currentUser.id, offset: offset, limit: MAX_NOTIFICATIONS}, function(notificationsObject){
	        $rootScope.notifications = $rootScope.notifications.concat(notificationsObject.notifications);
	        $rootScope.notificationsUnread = notificationsObject.unView;
	      });
	    }
	  }
	
	  $scope.$on('$stateChangeSuccess', function(){
	    loadData(0);
	  });
	
	  $scope.$on('notification', function() {
	    $scope.$apply(function() {
	      loadData(0);
	    });
	  });
	
	  $scope.closeNotifications = function() {
	    if (!$scope.preventBlur) {
	      $scope.notificationsOpen = false;
	    }
	
	    $scope.preventBlur = false;
	  };
	
	  $scope.toggleNotificationsOpen = function(preventBlur) {
	    $scope.notificationsOpen = $scope.notificationsOpen ? false : true;
	    $scope.notificationLimit = MAX_NOTIFICATIONS;
	
	    if (preventBlur) {
	      $scope.preventBlur = true;
	    }
	
	    setTimeout(function(){
	      if ($state.current.name === 'root.company-selection' && $rootScope.notificationsUnread > 0) {
	        CompanyNotificationsService.updateNotificationsUser({userId: currentUser.id}, {}, function(){
	          $rootScope.notificationsUnread = 0;
	          angular.forEach($rootScope.notifications, function(notification){
	            notification.viewed = true;
	          });
	        });
	      }
	    }, 5000);
	  };
	
	  $scope.loadMoreNotifications = function() {
	    loadData($scope.notificationLimit + 1);
	    $scope.notificationLimit = $scope.notificationLimit + MAX_NOTIFICATIONS;
	  };
	
	  $scope.markAsRead = function(notification, companyId) {
	    notification.viewed = true;
	    CompanyNotificationsService.update({companyId: companyId, notificationId: notification.id}, {viewed: true}, function(){
	      $rootScope.notificationsUnread--;
	    });
	  };
	
	  $scope.toggleSidebar = function() {
	    $scope.sidebarOpen = !$scope.sidebarOpen;
	  };
	
	  $scope.closeSidebar = function() {
	    $scope.sidebarOpen = false;
	  };
	
	  $scope.removeFileUpload = function(upload) {
	    var idx = $scope.fileUploads.indexOf(upload);
	
	    if(idx !== -1) {
	      $scope.fileUploads[idx].abort();
	      $scope.fileUploads.splice(idx, 1);
	    }
	  };
	
	  $rootScope.$on("file-upload.start", function(event, upload) {
	    $scope.fileUploads.push(upload);
	  });
	
	  $rootScope.$on("file-upload.complete", function(event, upload) {
	    $timeout(function() {
	      $scope.removeFileUpload(upload);
	    }, 2000);
	  });
	
	}
	
	RootCtrl.resolve = {
	  currentUser: ['CurrentUserService', function(CurrentUserService) {
	    return CurrentUserService.get();
	  }],
	  companies: ['CompanyService', function(CompanyService) {
	    return CompanyService.query({limit: 100}).$promise;
	  }]
	};
	module.exports = RootCtrl;
	
	angular.module('dokiv')
	  .controller('RootCtrl', [
	    '$rootScope',
	    '$scope',
	    '$state',
	    '$timeout',
	    '$window',
	    'currentUser',
	    'AuthService',
	    'companies',
	    'config',
	    '$document',
	    'CompanyService',
	    'CompanyNotificationsService',
	    '$translate', RootCtrl]);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(4);
	
	TextCarouselDirective.$inject = [];
	function TextCarouselDirective() {
	  return {
	    restrict : 'AE',
	    replace: true,
	    link: function(scope, elm) {
	      scope.$on('ngRepeatCompleted', function(){
	        var counter = 0;
	        var items = angular.element(elm).find('p');
	        var amount = items.length;
	        var current = items[0];      
	
	        function navigate(direction) {
	          angular.element(current).removeClass('current');
	          counter = counter + direction;
	          if (direction === -1 && 
	              counter < 0) { 
	            counter = amount - 1; 
	          }
	          if (direction === 1 && 
	              !items[counter]) { 
	            counter = 0;
	          }
	          current = items[counter];
	          angular.element(current).addClass('current');
	        }
	        navigate(0);
	        setInterval(function(){
	          navigate(1);
	        }, 8000);
	      });
	    }
	  };
	}
	
	ngRepeatCompletedDirective.$inject = [];
	function ngRepeatCompletedDirective() {
	  return {
	    restrict: 'AE',
	    link: function(scope) {
	      scope.$watch('$last', function(newData){
	        if (newData) {
	          scope.$emit('ngRepeatCompleted');
	        }
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('textCarousel', TextCarouselDirective)
	  .directive('ngRepeatCompleted', ngRepeatCompletedDirective);


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	function togglePassword($compile) {
	  return {
	    restrict: 'A',
	    scope: {},
	    link: function(scope, elem){
	      scope.typeDefault = elem.attr('type');
	      scope.tgl = function(){
	        elem.attr('type', (elem.attr('type')==='text' ? 'password' : 'text'));
	        scope.typeDefault = elem.attr('type');
	      };
	      var lnk = angular.element('<button class="button keypass__icon-password keypass__icon-copy icon-only" ng-click="tgl()" ng-class="{\'active\': typeDefault == \'text\'}" type="button"><i ng-show="typeDefault == \'text\'" class="fa fa-eye-slash" aria-hidden="true"></i><i ng-show="typeDefault == \'password\'" class="fa fa-eye" aria-hidden="true"></i></button>');
	      $compile(lnk)(scope);
	      elem.after(lnk);
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('togglePassword', ['$compile', togglePassword]);

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	"use strict";
	
	function TooltipDirective($animate) {
	  return {
	    restrict: 'A',
	    scope: {
	      langKey: '@tooltip'
	    },
	    link: function(scope, elem) {
	      var el = angular.element('<div>');
	
	      el.addClass('tooltip__wrap');
	
	      scope.$watch('langKey', function(value) {
	        el.text(value);
	        if (value.indexOf(' ') === -1) {
	          el.addClass('tooltip__single');
	        }
	      });
	
	      elem.on('mouseenter', function() {
	        $animate.enter(el, elem);
	      });
	
	      elem.on('mouseleave', function() {
	        el.remove();
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('tooltip', ['$animate', TooltipDirective]);


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	
	function remove(array, object) {
	  var idx = array.indexOf(object);
	
	  if(idx !== -1) {
	    array.splice(idx, 1);
	  }
	}
	UploadTracker.$inject = ["$rootScope", "$q", "Upload"];
	function UploadTracker($rootScope, $q, Upload) {
	  var queue = [];
	
	  function maybeApplyEmit(event, upload, error) {
	    if($rootScope.$$phase) {
	      $rootScope.$emit(event, upload, error || null);
	    }
	    else {
	      $rootScope.$apply(function() {
	        $rootScope.$emit(event, upload, error || null);
	      });
	    }
	  }
	
	  function enqueue(file) {
	    file.fileFormDataName = "files";
	
	    var upload = Upload.upload(file);
	
	    upload.uploadName   = file.file.name;
	    upload.uploadStatus = "INPROGRESS";
	    upload.uploadLoaded = 0;
	    upload.uploadTotal  = 0;
	
	    upload.then(function() {
	      remove(queue, upload);
	
	      upload.uploadStatus = "COMPLETE";
	
	      maybeApplyEmit("file-upload.complete", upload);
	    }, function(error) {
	      remove(queue, upload);
	
	      upload.uploadError  = error;
	      upload.uploadStatus = "ERROR";
	
	      maybeApplyEmit("file-upload.error", upload, error);
	    });
	
	    queue.push(upload);
	
	    maybeApplyEmit("file-upload.start", upload);
	
	    return upload;
	  }
	
	  function onProgress(upload, event) {
	    upload.uploadStatus = "INPROGRESS";
	    upload.uploadLoaded = event.loaded;
	    upload.uploadTotal  = event.total;
	
	    maybeApplyEmit("file-upload.progress", upload);
	  }
	
	  return function(uploadData) {
	    var deferred = $q.defer();
	    var complete = [];
	
	    if( ! Array.isArray(uploadData)) {
	      uploadData = [uploadData];
	    }
	
	    var uploads = uploadData.map(function(f) {
	      var u = enqueue(f);
	
	      function onEnd() {
	        remove(uploads, u);
	
	        if(uploads.length === 0) {
	          deferred.resolve(complete);
	        }
	      }
	
	      u.success(function(data, status, headers) {
	        complete.push(headers("Location"));
	
	        onEnd(u);
	      });
	
	      u.error(onEnd);
	
	      u.progress(function(event) {
	        onProgress(u, event);
	      });
	
	      return u;
	    });
	
	    deferred.promise.abort = function() {
	      uploads.forEach(function(u) {
	        u.abort();
	      });
	    };
	
	    return deferred.promise;
	  };
	}
	
	angular.module("dokiv")
	  .factory("UploadTracker", UploadTracker);


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	function UserEnterDirective() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      elem.on('keydown keypress', function(e) {
	        if(e.which === 13) {
	          scope.$apply(attrs.userEnter);
	          e.preventDefault();
	        }
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('userEnter', UserEnterDirective);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * angular-chart.js - An angular.js wrapper for Chart.js
	 * http://jtblin.github.io/angular-chart.js/
	 * Version: 1.1.1
	 *
	 * Copyright 2016 Jerome Touffe-Blin
	 * Released under the BSD-2-Clause license
	 * https://github.com/jtblin/angular-chart.js/blob/master/LICENSE
	 */
	(function (factory) {
	  'use strict';
	  if (true) {
	    // Node/CommonJS
	    module.exports = factory(
	      typeof angular !== 'undefined' ? angular : __webpack_require__(47),
	      __webpack_require__(463));
	  } else {
	    // Browser globals
	    if (typeof angular === 'undefined') {
	        throw new Error('AngularJS framework needs to be included, see https://angularjs.org/');
	    } else if (typeof Chart === 'undefined') {
	      throw new Error('Chart.js library needs to be included, see http://jtblin.github.io/angular-chart.js/');
	    }
	  }
	}(function (angular, Chart) {
	  'use strict';
	
	  Chart.defaults.global.multiTooltipTemplate = '<%if (datasetLabel){%><%=datasetLabel%>: <%}%><%= value %>';
	  Chart.defaults.global.tooltips.mode = 'label';
	  Chart.defaults.global.elements.line.borderWidth = 2;
	  Chart.defaults.global.elements.rectangle.borderWidth = 2;
	  Chart.defaults.global.legend.display = false;
	  Chart.defaults.global.colors = [
	    '#97BBCD', // blue
	    '#DCDCDC', // light grey
	    '#F7464A', // red
	    '#46BFBD', // green
	    '#FDB45C', // yellow
	    '#949FB1', // grey
	    '#4D5360'  // dark grey
	  ];
	
	  var useExcanvas = typeof window.G_vmlCanvasManager === 'object' &&
	    window.G_vmlCanvasManager !== null &&
	    typeof window.G_vmlCanvasManager.initElement === 'function';
	
	  if (useExcanvas) {Chart.defaults.global.animation = false;}
	
	  return angular.module('chart.js', [])
	    .provider('ChartJs', ChartJsProvider)
	    .factory('ChartJsFactory', ['ChartJs', '$timeout', ChartJsFactory])
	    .directive('chartBase', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory(); }])
	    .directive('chartLine', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('line'); }])
	    .directive('chartBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bar'); }])
	    .directive('chartHorizontalBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('horizontalBar'); }])
	    .directive('chartRadar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('radar'); }])
	    .directive('chartDoughnut', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('doughnut'); }])
	    .directive('chartPie', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('pie'); }])
	    .directive('chartPolarArea', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('polarArea'); }])
	    .directive('chartBubble', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bubble'); }])
	    .name;
	
	  /**
	   * Wrapper for chart.js
	   * Allows configuring chart js using the provider
	   *
	   * angular.module('myModule', ['chart.js']).config(function(ChartJsProvider) {
	   *   ChartJsProvider.setOptions({ responsive: false });
	   *   ChartJsProvider.setOptions('Line', { responsive: true });
	   * })))
	   */
	  function ChartJsProvider () {
	    var options = { responsive: true };
	    var ChartJs = {
	      Chart: Chart,
	      getOptions: function (type) {
	        var typeOptions = type && options[type] || {};
	        return angular.extend({}, options, typeOptions);
	      }
	    };
	
	    /**
	     * Allow to set global options during configuration
	     */
	    this.setOptions = function (type, customOptions) {
	      // If no type was specified set option for the global object
	      if (! customOptions) {
	        customOptions = type;
	        options = angular.extend(options, customOptions);
	      } else {
	        // Set options for the specific chart
	        options[type] = angular.extend(options[type] || {}, customOptions);
	      }
	
	      angular.extend(ChartJs.Chart.defaults, options);
	    };
	
	    this.$get = function () {
	      return ChartJs;
	    };
	  }
	
	  function ChartJsFactory (ChartJs, $timeout) {
	    return function chart (type) {
	      return {
	        restrict: 'CA',
	        scope: {
	          chartGetColor: '=?',
	          chartType: '=',
	          chartData: '=?',
	          chartLabels: '=?',
	          chartOptions: '=?',
	          chartSeries: '=?',
	          chartColors: '=?',
	          chartClick: '=?',
	          chartHover: '=?',
	          chartDatasetOverride: '=?'
	        },
	        link: function (scope, elem/*, attrs */) {
	          if (useExcanvas) {window.G_vmlCanvasManager.initElement(elem[0]);}
	
	          // Order of setting "watch" matter
	          scope.$watch('chartData', watchData, true);
	          scope.$watch('chartSeries', watchOther, true);
	          scope.$watch('chartLabels', watchOther, true);
	          scope.$watch('chartOptions', watchOther, true);
	          scope.$watch('chartColors', watchOther, true);
	          scope.$watch('chartDatasetOverride', watchOther, true);
	          scope.$watch('chartType', watchType, false);
	
	          scope.$on('$destroy', function () {
	            destroyChart(scope);
	          });
	
	          scope.$on('$resize', function () {
	            if (scope.chart) {scope.chart.resize();}
	          });
	
	          function watchData (newVal, oldVal) {
	            if (! newVal || ! newVal.length || (Array.isArray(newVal[0]) && ! newVal[0].length)) {
	              destroyChart(scope);
	              return;
	            }
	            var chartType = type || scope.chartType;
	            if (! chartType) {return;}
	
	            if (scope.chart && canUpdateChart(newVal, oldVal)){
	              return updateChart(newVal, scope);
	            }
	
	            createChart(chartType, scope, elem);
	          }
	
	          function watchOther (newVal, oldVal) {
	            if (isEmpty(newVal)) {return;}
	            if (angular.equals(newVal, oldVal)) {return;}
	            var chartType = type || scope.chartType;
	            if (! chartType) {return;}
	
	            // chart.update() doesn't work for series and labels
	            // so we have to re-create the chart entirely
	            createChart(chartType, scope, elem);
	          }
	
	          function watchType (newVal, oldVal) {
	            if (isEmpty(newVal)) {return;}
	            if (angular.equals(newVal, oldVal)) {return;}
	            createChart(newVal, scope, elem);
	          }
	        }
	      };
	    };
	
	    function createChart (type, scope, elem) {
	      var options = getChartOptions(type, scope);
	      if (! hasData(scope) || ! canDisplay(type, scope, elem, options)) {return;}
	
	      var cvs = elem[0];
	      var ctx = cvs.getContext('2d');
	
	      scope.chartGetColor = getChartColorFn(scope);
	      var data = getChartData(type, scope);
	      // Destroy old chart if it exists to avoid ghost charts issue
	      // https://github.com/jtblin/angular-chart.js/issues/187
	      destroyChart(scope);
	
	      scope.chart = new ChartJs.Chart(ctx, {
	        type: type,
	        data: data,
	        options: options
	      });
	      scope.$emit('chart-create', scope.chart);
	      bindEvents(cvs, scope);
	    }
	
	    function canUpdateChart (newVal, oldVal) {
	      if (newVal && oldVal && newVal.length && oldVal.length) {
	        return Array.isArray(newVal[0]) ?
	        newVal.length === oldVal.length && newVal.every(function (element, index) {
	          return element.length === oldVal[index].length; }) :
	          oldVal.reduce(sum, 0) > 0 ? newVal.length === oldVal.length : false;
	      }
	      return false;
	    }
	
	    function sum (carry, val) {
	      return carry + val;
	    }
	
	    function getEventHandler (scope, action, triggerOnlyOnChange) {
	      var lastState = {
	        point: void 0,
	        points: void 0
	      };
	      return function (evt) {
	        var atEvent = scope.chart.getElementAtEvent || scope.chart.getPointAtEvent;
	        var atEvents = scope.chart.getElementsAtEvent || scope.chart.getPointsAtEvent;
	        if (atEvents) {
	          var points = atEvents.call(scope.chart, evt);
	          var point = atEvent ? atEvent.call(scope.chart, evt)[0] : void 0;
	
	          if (triggerOnlyOnChange === false ||
	            (! angular.equals(lastState.points, points) && ! angular.equals(lastState.point, point))
	          ) {
	            lastState.point = point;
	            lastState.points = points;
	            scope[action](points, evt, point);
	          }
	        }
	      };
	    }
	
	    function getColors (type, scope) {
	      var colors = angular.copy(scope.chartColors ||
	        ChartJs.getOptions(type).chartColors ||
	        Chart.defaults.global.colors
	      );
	      var notEnoughColors = colors.length < scope.chartData.length;
	      while (colors.length < scope.chartData.length) {
	        colors.push(scope.chartGetColor());
	      }
	      // mutate colors in this case as we don't want
	      // the colors to change on each refresh
	      if (notEnoughColors) {scope.chartColors = colors;}
	      return colors.map(convertColor);
	    }
	
	    function convertColor (color) {
	      // Allows RGB and RGBA colors to be input as a string: e.g.: "rgb(159,204,0)", "rgba(159,204,0, 0.5)"
	      if (typeof color === 'string' && color[0] === 'r') {return getColor(rgbStringToRgb(color));}
	      // Allows hex colors to be input as a string.
	      if (typeof color === 'string' && color[0] === '#') {return getColor(hexToRgb(color.substr(1)));}
	      // Allows colors to be input as an object, bypassing getColor() entirely
	      if (typeof color === 'object' && color !== null) {return color;}
	      return getRandomColor();
	    }
	
	    function getRandomColor () {
	      var color = [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
	      return getColor(color);
	    }
	
	    function getColor (color) {
	      var alpha = color[3] || 1;
	      color = color.slice(0, 3);
	      return {
	        backgroundColor: rgba(color, 0.2),
	        pointBackgroundColor: rgba(color, alpha),
	        pointHoverBackgroundColor: rgba(color, 0.8),
	        borderColor: rgba(color, alpha),
	        pointBorderColor: '#fff',
	        pointHoverBorderColor: rgba(color, alpha)
	      };
	    }
	
	    function getRandomInt (min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    }
	
	    function rgba (color, alpha) {
	      // rgba not supported by IE8
	      return useExcanvas ? 'rgb(' + color.join(',') + ')' : 'rgba(' + color.concat(alpha).join(',') + ')';
	    }
	
	    // Credit: http://stackoverflow.com/a/11508164/1190235
	    function hexToRgb (hex) {
	      var bigint = parseInt(hex, 16),
	        r = (bigint >> 16) & 255,
	        g = (bigint >> 8) & 255,
	        b = bigint & 255;
	
	      return [r, g, b];
	    }
	
	    function rgbStringToRgb (color) {
	      var match = color.match(/^rgba?\(([\d,.]+)\)$/);
	      if (! match){ throw new Error('Cannot parse rgb value');}
	      color = match[1].split(',');
	      return color.map(Number);
	    }
	
	    function hasData (scope) {
	      return scope.chartData && scope.chartData.length;
	    }
	
	    function getChartColorFn (scope) {
	      return typeof scope.chartGetColor === 'function' ? scope.chartGetColor : getRandomColor;
	    }
	
	    function getChartData (type, scope) {
	      var colors = getColors(type, scope);
	      return Array.isArray(scope.chartData[0]) ?
	        getDataSets(scope.chartLabels, scope.chartData, scope.chartSeries || [], colors, scope.chartDatasetOverride) :
	        getData(scope.chartLabels, scope.chartData, colors, scope.chartDatasetOverride);
	    }
	
	    function getDataSets (labels, data, series, colors, datasetOverride) {
	      return {
	        labels: labels,
	        datasets: data.map(function (item, i) {
	          var dataset = angular.extend({}, colors[i], {
	            label: series[i],
	            data: item
	          });
	          if (datasetOverride && datasetOverride.length >= i) {
	            angular.extend(dataset, datasetOverride[i]);
	          }
	          return dataset;
	        })
	      };
	    }
	
	    function getData (labels, data, colors, datasetOverride) {
	      var dataset = {
	        labels: labels,
	        datasets: [{
	          data: data,
	          backgroundColor: colors.map(function (color) {
	            return color.pointBackgroundColor;
	          }),
	          hoverBackgroundColor: colors.map(function (color) {
	            return color.backgroundColor;
	          })
	        }]
	      };
	      if (datasetOverride) {
	        angular.extend(dataset.datasets[0], datasetOverride);
	      }
	      return dataset;
	    }
	
	    function getChartOptions (type, scope) {
	      return angular.extend({}, ChartJs.getOptions(type), scope.chartOptions);
	    }
	
	    function bindEvents (cvs, scope) {
	      cvs.onclick = scope.chartClick ? getEventHandler(scope, 'chartClick', false) : angular.noop;
	      cvs.onmousemove = scope.chartHover ? getEventHandler(scope, 'chartHover', true) : angular.noop;
	    }
	
	    function updateChart (values, scope) {
	      if (Array.isArray(scope.chartData[0])) {
	        scope.chart.data.datasets.forEach(function (dataset, i) {
	          dataset.data = values[i];
	        });
	      } else {
	        scope.chart.data.datasets[0].data = values;
	      }
	
	      scope.chart.update();
	      scope.$emit('chart-update', scope.chart);
	    }
	
	    function isEmpty (value) {
	      return ! value ||
	        (Array.isArray(value) && ! value.length) ||
	        (typeof value === 'object' && ! Object.keys(value).length);
	    }
	
	    function canDisplay (type, scope, elem, options) {
	      // TODO: check parent?
	      if (options.responsive && elem[0].clientHeight === 0) {
	        $timeout(function () {
	          createChart(type, scope, elem);
	        }, 50, false);
	        return false;
	      }
	      return true;
	    }
	
	    function destroyChart(scope) {
	      if(! scope.chart) {return;}
	      scope.chart.destroy();
	      scope.$emit('chart-destroy', scope.chart);
	    }
	  }
	}));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var footable = __webpack_require__(511);
	
	angularFootable.$inject = ['$translate'];
	function angularFootable($translate) {
	  var events = {
	     beforeFiltering: 'footable_filtering'
	  };
	
	  var bindEventHandler = function(tableObj, scope, attrs) {
	    var k;
	    for (k in attrs) {
	      if (k !== 'filter' && (!angular.isUndefined(events[k]))) {
	        var targetEventName = events[k];
	        if (angular.isFunction(scope.$eval(attrs[k]))) {
	          tableObj.bind(targetEventName, scope.$eval(attrs[k]));
	        }
	      }
	    }
	  };
	
	  return {
	    restrict: 'C',
	    scope: {
	        loadWhen: '='
	    },
	    link: function(scope, element, attrs) {
	      var tableOpts = {
	        'event-filtering': null
	      };
	      angular.extend(
	        tableOpts,
	        footable.options
	      );
	      angular.extend(
	        tableOpts,
	        function(tableOpts, attrs) {
				    var extracted = {},
				        k;
				    for (k in tableOpts) {
				      if (k !== 'filter' && (!angular.isUndefined(events[k]))) {
				          if (!angular.isFunction(scope.$eval(attrs[k]))) {
				            extracted[k] = attrs[k];
				          }
				      }
				    }
				    return extracted;
				  }
	      );
	
	      tableOpts.createDetail = function(element, data, createGroupedDetail, separatorChar, classes) {
	
	        var groups = createGroupedDetail(data);
	        for (var group in groups) {
	          if (groups[group].data.length === 0) {
	          	continue;
	          }
	          if (group !== '_none') {
	          	element.append('<div class="' + classes.detailInnerGroup + '">' + groups[group].name + '</div>');
	         	}
	          for (var j = 0; j < groups[group].data.length; j++) {
	            var separator = (groups[group].data[j].name) ? separatorChar : '';
	            element.append($('<div></div>').addClass(classes.detailInnerRow).append($('<div></div>').addClass(classes.detailInnerName)
	              .append($translate.instant(groups[group].data[j].name) + separator)).append($('<div></div>').addClass(classes.detailInnerValue)
	              .attr('data-bind-value', groups[group].data[j].bindName).append(groups[group].data[j].display)));
	          }
	        }
	      };
	
	      tableOpts.calculateWidthOverride = function() {
			    return { width: $(window).width() };
			  };
	
	      var tableObj = {};
	      var initTable = function() {
	        if (typeof element.footable === 'function') {
	            tableObj = element.footable(tableOpts);
	        } else {
	            tableObj = jQuery(element).footable(tableOpts);
	        }
	        bindEventHandler(tableObj, scope, attrs);
	      };
	      if (typeof attrs.loadWhen !== 'undefined') {
	        scope.$watch(function() {
	            return scope.loadWhen;
	        }, function(data) {
	            if (typeof data !== 'undefined' && data.length) {
	                initTable();
	            }
	        });
	      } else {
	        initTable();
	      }
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('footable', angularFootable)
	  .directive('fooRepeatDone', function() {
	    return function(scope) {
	      if (scope.$last) { // all are rendered
	          $('.footable').trigger('footable_redraw');
	      }
	    };
	  });

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	function customAutoFocusDirective() {
	  return {
	    restrict: 'A',
	
	    link: function(scope, element, attrs) {
	      scope.$watch(function() {
	        return scope.$eval(attrs.customAutofocus);
	      }, function (newValue) {
	        if (newValue === true) {
	          setTimeout(function() {
	            element[0].focus();
	          }, 0);
	        }
	     });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('customAutofocus', customAutoFocusDirective);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(15) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	} ) );


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('dokiv').filter('encodeUri', [
	  '$window',
	  function ($window) {
	    return $window.encodeURIComponent;
	  }
	]);

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";
	
	function goBack() {
	  return {
	    restrict: "EA",
	    replace: true,
	    template: "<div class=\"button__bar button__bar--back {{classes}}\"><button class=\"button button__back\" type=\"button\" ng-click=\"goBack()\"><i class=\"fa fa-chevron-left\"></i><span>{{'back' | translate}}</span></button></div>",
	    link: function($scope, elem, attrs) {
	      $scope.classes = "";
	      if (angular.isDefined(attrs.goBack)) {
	        $scope.classes = attrs.goBack; 
	      }
	      $scope.goBack = function() {
	        window.history.back();
	      };
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("goBack", goBack);


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * gridstack.js 1.0.0-dev
	 * http://troolee.github.io/gridstack.js/
	 * (c) 2014-2017 Pavel Reznikov, Dylan Weiss
	 * gridstack.js may be freely distributed under the MIT license.
	 * @preserve
	*/
	(function(factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(89), __webpack_require__(78), __webpack_require__(81), __webpack_require__(82), __webpack_require__(83),
	            __webpack_require__(519), __webpack_require__(84), __webpack_require__(521), __webpack_require__(522), __webpack_require__(520),
	            __webpack_require__(50), __webpack_require__(85), __webpack_require__(86), __webpack_require__(87),
	            __webpack_require__(523), __webpack_require__(524), __webpack_require__(3), __webpack_require__(23),
	            __webpack_require__(34), __webpack_require__(88), __webpack_require__(525),
	            __webpack_require__(526)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        try { jQuery = require('jquery'); } catch (e) {}
	        try { _ = require('lodash'); } catch (e) {}
	        try { GridStackUI = require('gridstack'); } catch (e) {}
	        factory(jQuery, _, GridStackUI);
	    } else {
	        factory(jQuery, _, GridStackUI);
	    }
	})(function($, _, GridStackUI) {
	
	    var scope = window;
	
	    /**
	    * @class JQueryUIGridStackDragDropPlugin
	    * jQuery UI implementation of drag'n'drop gridstack plugin.
	    */
	    function JQueryUIGridStackDragDropPlugin(grid) {
	        GridStackUI.GridStackDragDropPlugin.call(this, grid);
	    }
	
	    GridStackUI.GridStackDragDropPlugin.registerPlugin(JQueryUIGridStackDragDropPlugin);
	
	    JQueryUIGridStackDragDropPlugin.prototype = Object.create(GridStackUI.GridStackDragDropPlugin.prototype);
	    JQueryUIGridStackDragDropPlugin.prototype.constructor = JQueryUIGridStackDragDropPlugin;
	
	    JQueryUIGridStackDragDropPlugin.prototype.resizable = function(el, opts) {
	        el = $(el);
	        if (opts === 'disable' || opts === 'enable') {
	            el.resizable(opts);
	        } else if (opts === 'option') {
	            var key = arguments[2];
	            var value = arguments[3];
	            el.resizable(opts, key, value);
	        } else {
	            var handles = el.data('gs-resize-handles') ? el.data('gs-resize-handles') :
	                this.grid.opts.resizable.handles;
	            el.resizable(_.extend({}, this.grid.opts.resizable, {
	                handles: handles
	            }, {
	                start: opts.start || function() {},
	                stop: opts.stop || function() {},
	                resize: opts.resize || function() {}
	            }));
	        }
	        return this;
	    };
	
	    JQueryUIGridStackDragDropPlugin.prototype.draggable = function(el, opts) {
	        el = $(el);
	        if (opts === 'disable' || opts === 'enable') {
	            el.draggable(opts);
	        } else {
	            el.draggable(_.extend({}, this.grid.opts.draggable, {
	                containment: this.grid.opts.isNested ? this.grid.container.parent() : null,
	                start: opts.start || function() {},
	                stop: opts.stop || function() {},
	                drag: opts.drag || function() {}
	            }));
	        }
	        return this;
	    };
	
	    JQueryUIGridStackDragDropPlugin.prototype.droppable = function(el, opts) {
	        el = $(el);
	        el.droppable(opts);
	        return this;
	    };
	
	    JQueryUIGridStackDragDropPlugin.prototype.isDroppable = function(el, opts) {
	        el = $(el);
	        return Boolean(el.data('droppable'));
	    };
	
	    JQueryUIGridStackDragDropPlugin.prototype.on = function(el, eventName, callback) {
	        $(el).on(eventName, callback);
	        return this;
	    };
	
	    return JQueryUIGridStackDragDropPlugin;
	});


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/*!
	 * jQuery UI Touch Punch 0.2.3
	 *
	 * Copyright 2011–2014, Dave Furfero
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 *
	 * Depends:
	 *  jquery.ui.widget.js
	 *  jquery.ui.mouse.js
	 */
	(function ($) {
	
	  // Detect touch support
	  $.support.touch = 'ontouchend' in document;
	
	  // Ignore browsers without touch support
	  if (!$.support.touch) {
	    return;
	  }
	
	  var mouseProto = $.ui.mouse.prototype,
	      _mouseInit = mouseProto._mouseInit,
	      _mouseDestroy = mouseProto._mouseDestroy,
	      touchHandled;
	
	  /**
	   * Simulate a mouse event based on a corresponding touch event
	   * @param {Object} event A touch event
	   * @param {String} simulatedType The corresponding mouse event
	   */
	  function simulateMouseEvent (event, simulatedType) {
	
	    // Ignore multi-touch events
	    if (event.originalEvent.touches.length > 1) {
	      return;
	    }
	
	    event.preventDefault();
	
	    var touch = event.originalEvent.changedTouches[0],
	        simulatedEvent = document.createEvent('MouseEvents');
	    
	    // Initialize the simulated mouse event using the touch event's coordinates
	    simulatedEvent.initMouseEvent(
	      simulatedType,    // type
	      true,             // bubbles                    
	      true,             // cancelable                 
	      window,           // view                       
	      1,                // detail                     
	      touch.screenX,    // screenX                    
	      touch.screenY,    // screenY                    
	      touch.clientX,    // clientX                    
	      touch.clientY,    // clientY                    
	      false,            // ctrlKey                    
	      false,            // altKey                     
	      false,            // shiftKey                   
	      false,            // metaKey                    
	      0,                // button                     
	      null              // relatedTarget              
	    );
	
	    // Dispatch the simulated event to the target element
	    event.target.dispatchEvent(simulatedEvent);
	  }
	
	  /**
	   * Handle the jQuery UI widget's touchstart events
	   * @param {Object} event The widget element's touchstart event
	   */
	  mouseProto._touchStart = function (event) {
	
	    var self = this;
	
	    // Ignore the event if another widget is already being handled
	    if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
	      return;
	    }
	
	    // Set the flag to prevent other widgets from inheriting the touch event
	    touchHandled = true;
	
	    // Track movement to determine if interaction was a click
	    self._touchMoved = false;
	
	    // Simulate the mouseover event
	    simulateMouseEvent(event, 'mouseover');
	
	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');
	
	    // Simulate the mousedown event
	    simulateMouseEvent(event, 'mousedown');
	  };
	
	  /**
	   * Handle the jQuery UI widget's touchmove events
	   * @param {Object} event The document's touchmove event
	   */
	  mouseProto._touchMove = function (event) {
	
	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }
	
	    // Interaction was not a click
	    this._touchMoved = true;
	
	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');
	  };
	
	  /**
	   * Handle the jQuery UI widget's touchend events
	   * @param {Object} event The document's touchend event
	   */
	  mouseProto._touchEnd = function (event) {
	
	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }
	
	    // Simulate the mouseup event
	    simulateMouseEvent(event, 'mouseup');
	
	    // Simulate the mouseout event
	    simulateMouseEvent(event, 'mouseout');
	
	    // If the touch interaction did not move, it should trigger a click
	    if (!this._touchMoved) {
	
	      // Simulate the click event
	      simulateMouseEvent(event, 'click');
	    }
	
	    // Unset the flag to allow other widgets to inherit the touch event
	    touchHandled = false;
	  };
	
	  /**
	   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
	   * This method extends the widget with bound touch event handlers that
	   * translate touch events to mouse events and pass them to the widget's
	   * original mouse event handling methods.
	   */
	  mouseProto._mouseInit = function () {
	    
	    var self = this;
	
	    // Delegate the touch handlers to the widget's element
	    self.element.bind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });
	
	    // Call the original $.ui.mouse init method
	    _mouseInit.call(self);
	  };
	
	  /**
	   * Remove the touch event handlers
	   */
	  mouseProto._mouseDestroy = function () {
	    
	    var self = this;
	
	    // Delegate the touch handlers to the widget's element
	    self.element.unbind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });
	
	    // Call the original $.ui.mouse destroy method
	    _mouseDestroy.call(self);
	  };
	
	})(jQuery);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/*!
	 * ng - password - generator - AngularJS directive to generate a password
	 * Author: Aitor Rodríguez - http://www.frontendfactory.es/
	 * Version: 1.1.2
	 * License: MIT
	 */
	
	'use strict';
	
	angular
		.module('ngPasswordGenerator', [])
		.controller('passwordGeneratorController', ['$scope', function($scope) {
	
			$scope.passwordField = '';
	
			$scope.options = {
				passwordLength: 8,
				uppercase: true,
				numbers: true,
				specials: true
			};
	
		}])
		.directive('passwordGenerator', function() {
	
			return {
				restrict: 'AE',
				replace: true,
				scope: {
					field: '=field',
					passwordLength: '=?passwordLength',
					uppercase: '=?uppercase',
					numbers: '=?numbers',
					specials: '=?specials',
					buttonText: '@?buttonText',
					customClass: '=?'
				},
				template: '<button type="button" class="button button--positive {{customClass}}" data-ng-click="generatePassword()">{{ buttonText }}</button>',
				link: function(scope) {
	
					// Initialize the default values
					scope.passwordLength = (scope.passwordLength) ? scope.passwordLength : 8;
					scope.uppercase = (scope.uppercase) ? scope.uppercase : false;
					scope.numbers = (scope.numbers) ? scope.numbers : false;
					scope.specials = (scope.specials) ? scope.specials : false;
					scope.buttonText = (scope.buttonText !== undefined) ? scope.buttonText : 'Generate password';
	
					// Enable password generation
					scope.generatePassword = function() {
	
						// Create variables with characters, numbers and special
						var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
							upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
							numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
							specials = ['!', '"', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
	
						// Concatenate the differents variables according to true/false
						var finalCharacters = lowerCharacters;
	
						if (scope.uppercase) {
							finalCharacters = finalCharacters.concat(upperCharacters);
						}
	
						if (scope.numbers) {
							finalCharacters = finalCharacters.concat(numbers);
						}
	
						if (scope.specials) {
							finalCharacters = finalCharacters.concat(specials);
						}
	
						// Iterate while the number is less than passwordLength
						var finalPassword = [];
	
						for (var i = 0; i < scope.passwordLength; i++) {
							finalPassword.push(finalCharacters[Math.floor(Math.random() * finalCharacters.length)]);
						}
	
						// Save the result on field
						scope.field = finalPassword.join('');
	
					};
	
				}
	
			};
	
		});


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('dokiv')
	  .filter('nl2br', ['$sanitize', function($sanitize) {
	    return function (text) {
	      return text ? $sanitize(text.replace(/\n/g, '<br>')) : '';
	    };
	  }]);


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	"use strict";
	
	function orInfinFilter() {
	  return function(value) {
	    return value > 0 ? value : "\u221E";
	  };
	}
	
	angular.module("dokiv")
	  .filter("orInfin", orInfinFilter);


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	checkExpire.$inject = [];
	function checkExpire() {
	  return function(reminder) {
	    var dueAt = new Date(reminder.dueAt),
	        currentDate = new Date();
	    if (dueAt.getTime() < currentDate.getTime()) {
	      return true;
	    }
	    return false;
	  };
	}
	
	angular.module('dokiv')
	  .filter('reminderCheckExpire', checkExpire);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(15) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	} ) );


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	"use strict";
	
	function scrollbarOnTopContent() {
	  return {
	    scope: {
	      "columns": "=scrollbarOnTopContent"
	    },
	    link: function(scope, element) {
	      var colunmWidth = angular.element(document.getElementsByClassName('customers-dashboard__column')).outerWidth();
	
	      function updateScroll() {
	        $div2.width(scope.columns * colunmWidth);
	        // make the scroll bars the same width
	        $div1.width(scope.columns * colunmWidth);
	
	        // sync the real scrollbar with the virtual one.
	        $wrapper1.scroll(function(){
	          $wrapper2.scrollLeft($wrapper1.scrollLeft());
	        });
	
	        // sync the virtual scrollbar with the real one.
	        $wrapper2.scroll(function(){
	          $wrapper1.scrollLeft($wrapper2.scrollLeft());
	        });
	      }
	
	      // creates the top virtual scrollbar
	      element.wrapInner("<div class='ct-scrollbar__content' />");
	      element.wrapInner("<div class='ct-scrollbar__wrapper-bottom' />");
	
	      // contains the element with a real scrollbar
	      element.prepend("<div class='ct-scrollbar__wrapper-top'><div class='ct-scrollbar__placehoder'></div></div>");
	
	      var $wrapper1 = element.find('.ct-scrollbar__wrapper-top'),
	          $div1 = element.find('.ct-scrollbar__placehoder'),
	          $wrapper2 = element.find('.ct-scrollbar__wrapper-bottom'),
	          $div2 = element.find('.ct-scrollbar__content');
	
	      // force our virtual scrollbar to work the way we want.
	      $wrapper1.css({
	        width: "100%",
	        border: "none 0px rgba(0, 0, 0, 0)",
	        overflowX: "auto",
	        overflowY: "hidden",
	        height: "20px",
	        marginBottom: "1em",
	        marginTop: "-1em"
	      });
	
	      $div1.css({
	        height: "20px",
	      });
	
	      $wrapper2.css({
	        width: "100%",
	        overflowX: "auto",
	      });
	
	      updateScroll();
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('scrollbarOnTopContent', scrollbarOnTopContent);
	


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	function selectAllOnFocus() {
	  return {
	    restrict: 'A',
	    replace: false,
	    link: function (scope, element) {
	      element.on('focus', function () {
	        var domElement = element[0];
	        if (angular.isFunction(domElement.setSelectionRange)) {
	          domElement.setSelectionRange(0, domElement.value.length);
	        }
	      });
	    },
	  };
	}
	
	angular.module('dokiv')
	  .directive('selectAllOnFocus', [selectAllOnFocus]);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	
	function isUrlValid(url) {
	  var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
	  return regex.test(url);
	}
	
	function sglClick($parse) {
	  return {
	    restrict: 'A',
	      link: function(scope, element, attr) {
	        var fn = $parse(attr['sgl-click']);
	        var delay = 300, clicks = 0, timer = null;
	        element.on('click', function (event) {
	          clicks++;
	          if(clicks === 1) {
	            timer = setTimeout(function() {
	              scope.$apply(function () {
	                fn(scope, { $event: event });
	              }); 
	              var text = attr['sglClick'];
	              if (isUrlValid(text)) {
	                window.open(text, '_blank');
	              }  
	              clicks = 0;  
	            }, delay);
	          } else {
	            clearTimeout(timer); 
	            clicks = 0;   
	          }
	        });
	      }
	  };
	}
	
	angular.module("dokiv")
	  .directive("sglClick", ["$parse", sglClick]);


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("dokiv")
	  .factory("stateSnapshot", ["$rootScope", function($rootScope) {
	    var obj = {
	      previous: {
	        state:  null,
	        params: {}
	      },
	      current: {
	        state:  null,
	        params: {}
	      },
	      next: {
	        state:  null,
	        params: {}
	      }
	    };
	    
	    $rootScope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
	      obj.previous = {
	        state:  fromState,
	        params: fromParams
	      };
	      
	      obj.next = {
	        state:  toState,
	        params: toParams
	      };
	    });
	    
	    $rootScope.$on("$stateChangeSuccess", function(e, toState, toParams) {
	      obj.current = {
	        state:  toState,
	        params: toParams
	      };
	    });
	    
	    return obj;
	  }])
	  .run(["stateSnapshot", function() {
	    /* Needed to initialize the stateSnapshot hooks */
	  }]);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(53),
				__webpack_require__(15),
				__webpack_require__(54)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Sortable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Sortable
	//>>group: Interactions
	//>>description: Enables items in a list to be sorted using the mouse.
	//>>docs: http://api.jqueryui.com/sortable/
	//>>demos: http://jqueryui.com/sortable/
	//>>css.structure: ../../themes/base/sortable.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(273),
				__webpack_require__(259),
				__webpack_require__(53),
				__webpack_require__(268),
				__webpack_require__(15),
				__webpack_require__(54)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.widget( "ui.sortable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// Callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
	
		_isOverAxis: function( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		},
	
		_isFloating: function( item ) {
			return ( /left|right/ ).test( item.css( "float" ) ) ||
				( /inline|table-cell/ ).test( item.css( "display" ) );
		},
	
		_create: function() {
			this.containerCache = {};
			this._addClass( "ui-sortable" );
	
			//Get the items
			this.refresh();
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			this._setHandleClassName();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			if ( key === "handle" ) {
				this._setHandleClassName();
			}
		},
	
		_setHandleClassName: function() {
			var that = this;
			this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
			$.each( this.items, function() {
				that._addClass(
					this.instance.options.handle ?
						this.item.find( this.instance.options.handle ) :
						this.item,
					"ui-sortable-handle"
				);
			} );
		},
	
		_destroy: function() {
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[ i ].item.removeData( this.widgetName + "-item" );
			}
	
			return this;
		},
	
		_mouseCapture: function( event, overrideHandle ) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if ( this.reverting ) {
				return false;
			}
	
			if ( this.options.disabled || this.options.type === "static" ) {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems( event );
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$( event.target ).parents().each( function() {
				if ( $.data( this, that.widgetName + "-item" ) === that ) {
					currentItem = $( this );
					return false;
				}
			} );
			if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
				currentItem = $( event.target );
			}
	
			if ( !currentItem ) {
				return false;
			}
			if ( this.options.handle && !overrideHandle ) {
				$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
					if ( this === event.target ) {
						validHandle = true;
					}
				} );
				if ( !validHandle ) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function( event, overrideHandle, noActivation ) {
	
			var i, body,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to
			// mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend( this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
	
				// This is a relative to absolute position minus the actual position calculation -
				// only used for relative positioned helper
				relative: this._getRelativeOffset()
			} );
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css( "position", "absolute" );
			this.cssPosition = this.helper.css( "position" );
	
			//Generate the original position
			this.originalPosition = this._generatePosition( event );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Cache the former DOM position
			this.domPosition = {
				prev: this.currentItem.prev()[ 0 ],
				parent: this.currentItem.parent()[ 0 ]
			};
	
			// If the helper is not the original, hide the original so it's not playing any role during
			// the drag, won't cause anything bad this way
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if ( o.containment ) {
				this._setContainment();
			}
	
			if ( o.cursor && o.cursor !== "auto" ) { // cursor option
				body = this.document.find( "body" );
	
				// Support: IE
				this.storedCursor = body.css( "cursor" );
				body.css( "cursor", o.cursor );
	
				this.storedStylesheet =
					$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
			}
	
			if ( o.opacity ) { // opacity option
				if ( this.helper.css( "opacity" ) ) {
					this._storedOpacity = this.helper.css( "opacity" );
				}
				this.helper.css( "opacity", o.opacity );
			}
	
			if ( o.zIndex ) { // zIndex option
				if ( this.helper.css( "zIndex" ) ) {
					this._storedZIndex = this.helper.css( "zIndex" );
				}
				this.helper.css( "zIndex", o.zIndex );
			}
	
			//Prepare scrolling
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger( "start", event, this._uiHash() );
	
			//Recache the helper size
			if ( !this._preserveHelperProportions ) {
				this._cacheHelperProportions();
			}
	
			//Post "activate" events to possible containers
			if ( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			this.dragging = true;
	
			this._addClass( this.helper, "ui-sortable-helper" );
	
			// Execute the drag once - this causes the helper not to be visiblebefore getting its
			// correct position
			this._mouseDrag( event );
			return true;
	
		},
	
		_mouseDrag: function( event ) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition( event );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			if ( !this.lastPositionAbs ) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if ( this.options.scroll ) {
				if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
						this.scrollParent[ 0 ].tagName !== "HTML" ) {
	
					if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
							event.pageY < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
					} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
					}
	
					if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
							event.pageX < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
					} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
					}
	
					if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() - o.scrollSpeed
						);
					} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() + o.scrollSpeed
						);
					}
	
				}
	
				if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
					$.ui.ddmanager.prepareOffsets( this, event );
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Set the helper position
			if ( !this.options.axis || this.options.axis !== "y" ) {
				this.helper[ 0 ].style.left = this.position.left + "px";
			}
			if ( !this.options.axis || this.options.axis !== "x" ) {
				this.helper[ 0 ].style.top = this.position.top + "px";
			}
	
			//Rearrange
			for ( i = this.items.length - 1; i >= 0; i-- ) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[ i ];
				itemElement = item.item[ 0 ];
				intersection = this._intersectsWithPointer( item );
				if ( !intersection ) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items from other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this, moving items in "sub-sortables" can cause
				// the placeholder to jitter between the outer and inner container.
				if ( item.instance !== this.currentContainer ) {
					continue;
				}
	
				// Cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if ( itemElement !== this.currentItem[ 0 ] &&
					this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
					!$.contains( this.placeholder[ 0 ], itemElement ) &&
					( this.options.type === "semi-dynamic" ?
						!$.contains( this.element[ 0 ], itemElement ) :
						true
					)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
						this._rearrange( event, item );
					} else {
						break;
					}
	
					this._trigger( "change", event, this._uiHash() );
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers( event );
	
			//Interconnect with droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			//Call callbacks
			this._trigger( "sort", event, this._uiHash() );
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function( event, noPropagation ) {
	
			if ( !event ) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				$.ui.ddmanager.drop( this, event );
			}
	
			if ( this.options.revert ) {
				var that = this,
					cur = this.placeholder.offset(),
					axis = this.options.axis,
					animation = {};
	
				if ( !axis || axis === "x" ) {
					animation.left = cur.left - this.offset.parent.left - this.margins.left +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollLeft
						);
				}
				if ( !axis || axis === "y" ) {
					animation.top = cur.top - this.offset.parent.top - this.margins.top +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollTop
						);
				}
				this.reverting = true;
				$( this.helper ).animate(
					animation,
					parseInt( this.options.revert, 10 ) || 500,
					function() {
						that._clear( event );
					}
				);
			} else {
				this._clear( event, noPropagation );
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if ( this.dragging ) {
	
				this._mouseUp( new $.Event( "mouseup", { target: null } ) );
	
				if ( this.options.helper === "original" ) {
					this.currentItem.css( this._storedCSS );
					this._removeClass( this.currentItem, "ui-sortable-helper" );
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for ( var i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			if ( this.placeholder ) {
	
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
				// it unbinds ALL events from the original node!
				if ( this.placeholder[ 0 ].parentNode ) {
					this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
				}
				if ( this.options.helper !== "original" && this.helper &&
						this.helper[ 0 ].parentNode ) {
					this.helper.remove();
				}
	
				$.extend( this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				} );
	
				if ( this.domPosition.prev ) {
					$( this.domPosition.prev ).after( this.currentItem );
				} else {
					$( this.domPosition.parent ).prepend( this.currentItem );
				}
			}
	
			return this;
	
		},
	
		serialize: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				str = [];
			o = o || {};
	
			$( items ).each( function() {
				var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
					.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
				if ( res ) {
					str.push(
						( o.key || res[ 1 ] + "[]" ) +
						"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
				}
			} );
	
			if ( !str.length && o.key ) {
				str.push( o.key + "=" );
			}
	
			return str.join( "&" );
	
		},
	
		toArray: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				ret = [];
	
			o = o || {};
	
			items.each( function() {
				ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
			} );
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function( item ) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
					( y1 + dyClick ) < b ),
				isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
					( x1 + dxClick ) < r ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				( this.options.tolerance !== "pointer" &&
					this.helperProportions[ this.floating ? "width" : "height" ] >
					item[ this.floating ? "width" : "height" ] )
			) {
				return isOverElement;
			} else {
	
				return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
					x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function( item ) {
			var verticalDirection, horizontalDirection,
				isOverElementHeight = ( this.options.axis === "x" ) ||
					this._isOverAxis(
						this.positionAbs.top + this.offset.click.top, item.top, item.height ),
				isOverElementWidth = ( this.options.axis === "y" ) ||
					this._isOverAxis(
						this.positionAbs.left + this.offset.click.left, item.left, item.width ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( !isOverElement ) {
				return false;
			}
	
			verticalDirection = this._getDragVerticalDirection();
			horizontalDirection = this._getDragHorizontalDirection();
	
			return this.floating ?
				( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
				: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );
	
		},
	
		_intersectsWithSides: function( item ) {
	
			var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
					this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
				isOverRightHalf = this._isOverAxis( this.positionAbs.left +
					this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if ( this.floating && horizontalDirection ) {
				return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
					( horizontalDirection === "left" && !isOverRightHalf ) );
			} else {
				return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
					( verticalDirection === "up" && !isOverBottomHalf ) );
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && ( delta > 0 ? "down" : "up" );
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && ( delta > 0 ? "right" : "left" );
		},
	
		refresh: function( event ) {
			this._refreshItems( event );
			this._setHandleClassName();
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ?
				[ options.connectWith ] :
				options.connectWith;
		},
	
		_getItemsAsjQuery: function( connected ) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if ( connectWith && connected ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items.call( inst.element ) :
								$( inst.options.items, inst.element )
									.not( ".ui-sortable-helper" )
									.not( ".ui-sortable-placeholder" ), inst ] );
						}
					}
				}
			}
	
			queries.push( [ $.isFunction( this.options.items ) ?
				this.options.items
					.call( this.element, null, { options: this.options, item: this.currentItem } ) :
				$( this.options.items, this.element )
					.not( ".ui-sortable-helper" )
					.not( ".ui-sortable-placeholder" ), this ] );
	
			function addItems() {
				items.push( this );
			}
			for ( i = queries.length - 1; i >= 0; i-- ) {
				queries[ i ][ 0 ].each( addItems );
			}
	
			return $( items );
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );
	
			this.items = $.grep( this.items, function( item ) {
				for ( var j = 0; j < list.length; j++ ) {
					if ( list[ j ] === item.item[ 0 ] ) {
						return false;
					}
				}
				return true;
			} );
	
		},
	
		_refreshItems: function( event ) {
	
			this.items = [];
			this.containers = [ this ];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [ [ $.isFunction( this.options.items ) ?
					this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
					$( this.options.items, this.element ), this ] ],
				connectWith = this._connectWith();
	
			//Shouldn't be run the first time through due to massive slow-down
			if ( connectWith && this.ready ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items
									.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
								$( inst.options.items, inst.element ), inst ] );
							this.containers.push( inst );
						}
					}
				}
			}
	
			for ( i = queries.length - 1; i >= 0; i-- ) {
				targetData = queries[ i ][ 1 ];
				_queries = queries[ i ][ 0 ];
	
				for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
					item = $( _queries[ j ] );
	
					// Data for target checking (mouse manager)
					item.data( this.widgetName + "-item", targetData );
	
					items.push( {
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					} );
				}
			}
	
		},
	
		refreshPositions: function( fast ) {
	
			// Determine whether items are being displayed horizontally
			this.floating = this.items.length ?
				this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
				false;
	
			//This has to be redone because due to the item being moved out/into the offsetParent,
			// the offsetParent's position will change
			if ( this.offsetParent && this.helper ) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for ( i = this.items.length - 1; i >= 0; i-- ) {
				item = this.items[ i ];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if ( item.instance !== this.currentContainer && this.currentContainer &&
						item.item[ 0 ] !== this.currentItem[ 0 ] ) {
					continue;
				}
	
				t = this.options.toleranceElement ?
					$( this.options.toleranceElement, item.item ) :
					item.item;
	
				if ( !fast ) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if ( this.options.custom && this.options.custom.refreshContainers ) {
				this.options.custom.refreshContainers.call( this );
			} else {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					p = this.containers[ i ].element.offset();
					this.containers[ i ].containerCache.left = p.left;
					this.containers[ i ].containerCache.top = p.top;
					this.containers[ i ].containerCache.width =
						this.containers[ i ].element.outerWidth();
					this.containers[ i ].containerCache.height =
						this.containers[ i ].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function( that ) {
			that = that || this;
			var className,
				o = that.options;
	
			if ( !o.placeholder || o.placeholder.constructor === String ) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
							element = $( "<" + nodeName + ">", that.document[ 0 ] );
	
							that._addClass( element, "ui-sortable-placeholder",
									className || that.currentItem[ 0 ].className )
								._removeClass( element, "ui-sortable-helper" );
	
						if ( nodeName === "tbody" ) {
							that._createTrPlaceholder(
								that.currentItem.find( "tr" ).eq( 0 ),
								$( "<tr>", that.document[ 0 ] ).appendTo( element )
							);
						} else if ( nodeName === "tr" ) {
							that._createTrPlaceholder( that.currentItem, element );
						} else if ( nodeName === "img" ) {
							element.attr( "src", that.currentItem.attr( "src" ) );
						}
	
						if ( !className ) {
							element.css( "visibility", "hidden" );
						}
	
						return element;
					},
					update: function( container, p ) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes -
						// the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
						// class name is specified
						if ( className && !o.forcePlaceholderSize ) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming
						// from a stylesheet), it receives the inline height from the dragged item
						if ( !p.height() ) {
							p.height(
								that.currentItem.innerHeight() -
								parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
						}
						if ( !p.width() ) {
							p.width(
								that.currentItem.innerWidth() -
								parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
						}
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );
	
			//Append it after the actual current item
			that.currentItem.after( that.placeholder );
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update( that, that.placeholder );
	
		},
	
		_createTrPlaceholder: function( sourceTr, targetTr ) {
			var that = this;
	
			sourceTr.children().each( function() {
				$( "<td>&#160;</td>", that.document[ 0 ] )
					.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
					.appendTo( targetTr );
			} );
		},
	
		_contactContainers: function( event ) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
				floating, axis,
				innermostContainer = null,
				innermostIndex = null;
	
			// Get innermost container that intersects with item
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
	
				// Never consider a container that's located within the item itself
				if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
					continue;
				}
	
				if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {
	
					// If we've already found a container and it's more "inner" than this, then continue
					if ( innermostContainer &&
							$.contains(
								this.containers[ i ].element[ 0 ],
								innermostContainer.element[ 0 ] ) ) {
						continue;
					}
	
					innermostContainer = this.containers[ i ];
					innermostIndex = i;
	
				} else {
	
					// container doesn't intersect. trigger "out" event if necessary
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			// If no intersecting containers found, return
			if ( !innermostContainer ) {
				return;
			}
	
			// Move the item into the container if it's not there already
			if ( this.containers.length === 1 ) {
				if ( !this.containers[ innermostIndex ].containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
					this.containers[ innermostIndex ].containerCache.over = 1;
				}
			} else {
	
				// When entering a new container, we will find the item with the least distance and
				// append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				floating = innermostContainer.floating || this._isFloating( this.currentItem );
				posProperty = floating ? "left" : "top";
				sizeProperty = floating ? "width" : "height";
				axis = floating ? "pageX" : "pageY";
	
				for ( j = this.items.length - 1; j >= 0; j-- ) {
					if ( !$.contains(
							this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
					) {
						continue;
					}
					if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
						continue;
					}
	
					cur = this.items[ j ].item.offset()[ posProperty ];
					nearBottom = false;
					if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
						nearBottom = true;
					}
	
					if ( Math.abs( event[ axis ] - cur ) < dist ) {
						dist = Math.abs( event[ axis ] - cur );
						itemWithLeastDistance = this.items[ j ];
						this.direction = nearBottom ? "up" : "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
					return;
				}
	
				if ( this.currentContainer === this.containers[ innermostIndex ] ) {
					if ( !this.currentContainer.containerCache.over ) {
						this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
						this.currentContainer.containerCache.over = 1;
					}
					return;
				}
	
				itemWithLeastDistance ?
					this._rearrange( event, itemWithLeastDistance, null, true ) :
					this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
				this._trigger( "change", event, this._uiHash() );
				this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
				this.currentContainer = this.containers[ innermostIndex ];
	
				//Update the placeholder
				this.options.placeholder.update( this.currentContainer, this.placeholder );
	
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
	
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helper = $.isFunction( o.helper ) ?
					$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
					( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );
	
			//Add the helper to the DOM if that didn't happen already
			if ( !helper.parents( "body" ).length ) {
				$( o.appendTo !== "parent" ?
					o.appendTo :
					this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
			}
	
			if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
				this._storedCSS = {
					width: this.currentItem[ 0 ].style.width,
					height: this.currentItem[ 0 ].style.height,
					position: this.currentItem.css( "position" ),
					top: this.currentItem.css( "top" ),
					left: this.currentItem.css( "left" )
				};
			}
	
			if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
				helper.width( this.currentItem.width() );
			}
			if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
				helper.height( this.currentItem.height() );
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this
			// information with an ugly IE fix
			if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
					( this.offsetParent[ 0 ].tagName &&
					this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if ( this.cssPosition === "relative" ) {
				var p = this.currentItem.position();
				return {
					top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
						this.scrollParent.scrollTop(),
					left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
						this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
			if ( o.containment === "document" || o.containment === "window" ) {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					o.containment === "document" ?
						this.document.width() :
						this.window.width() - this.helperProportions.width - this.margins.left,
					( o.containment === "document" ?
						( this.document.height() || document.body.parentNode.scrollHeight ) :
						this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
					) - this.helperProportions.height - this.margins.top
				];
			}
	
			if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
				ce = $( o.containment )[ 0 ];
				co = $( o.containment ).offset();
				over = ( $( ce ).css( "overflow" ) !== "hidden" );
	
				this.containment = [
					co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
					co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
					co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
						( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
						this.helperProportions.width - this.margins.left,
					co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
						( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
						this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
						scroll.scrollLeft() ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event ) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
					scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options
	
				if ( this.containment ) {
					if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
						pageX = this.containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
						pageY = this.containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
						pageX = this.containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
						pageY = this.containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
					top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
						o.grid[ 1 ] ) * o.grid[ 1 ];
					pageY = this.containment ?
						( ( top - this.offset.click.top >= this.containment[ 1 ] &&
							top - this.offset.click.top <= this.containment[ 3 ] ) ?
								top :
								( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
									top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
									top;
	
					left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
						o.grid[ 0 ] ) * o.grid[ 0 ];
					pageX = this.containment ?
						( ( left - this.offset.click.left >= this.containment[ 0 ] &&
							left - this.offset.click.left <= this.containment[ 2 ] ) ?
								left :
								( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
									left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
									left;
				}
	
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() :
						scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
				)
			};
	
		},
	
		_rearrange: function( event, i, a, hardRefresh ) {
	
			a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
				i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
					( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout,
			// if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay( function() {
				if ( counter === this.counter ) {
	
					//Precompute after each DOM insertion, NOT on mousemove
					this.refreshPositions( !hardRefresh );
				}
			} );
	
		},
	
		_clear: function( event, noPropagation ) {
	
			this.reverting = false;
	
			// We delay all events that have to be triggered to after the point where the placeholder
			// has been removed and everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets
			// reappended (see #4088)
			if ( !this._noFinalSort && this.currentItem.parent().length ) {
				this.placeholder.before( this.currentItem );
			}
			this._noFinalSort = null;
	
			if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
				for ( i in this._storedCSS ) {
					if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
						this._storedCSS[ i ] = "";
					}
				}
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}
	
			if ( this.fromOutside && !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
				} );
			}
			if ( ( this.fromOutside ||
					this.domPosition.prev !==
					this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
					this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {
	
				// Trigger update callback if the DOM position has changed
				delayedTriggers.push( function( event ) {
					this._trigger( "update", event, this._uiHash() );
				} );
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if ( this !== this.currentContainer ) {
				if ( !noPropagation ) {
					delayedTriggers.push( function( event ) {
						this._trigger( "remove", event, this._uiHash() );
					} );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "receive", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "update", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
				}
			}
	
			//Post events to containers
			function delayEvent( type, instance, container ) {
				return function( event ) {
					container._trigger( type, event, instance._uiHash( instance ) );
				};
			}
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				if ( !noPropagation ) {
					delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
				}
				if ( this.containers[ i ].containerCache.over ) {
					delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if ( this.storedCursor ) {
				this.document.find( "body" ).css( "cursor", this.storedCursor );
				this.storedStylesheet.remove();
			}
			if ( this._storedOpacity ) {
				this.helper.css( "opacity", this._storedOpacity );
			}
			if ( this._storedZIndex ) {
				this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
			}
	
			this.dragging = false;
	
			if ( !noPropagation ) {
				this._trigger( "beforeStop", event, this._uiHash() );
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
	
			if ( !this.cancelHelperRemoval ) {
				if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
					this.helper.remove();
				}
				this.helper = null;
			}
	
			if ( !noPropagation ) {
				for ( i = 0; i < delayedTriggers.length; i++ ) {
	
					// Trigger all delayed events
					delayedTriggers[ i ].call( this, event );
				}
				this._trigger( "stop", event, this._uiHash() );
			}
	
			this.fromOutside = false;
			return !this.cancelHelperRemoval;
	
		},
	
		_trigger: function() {
			if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
				this.cancel();
			}
		},
	
		_uiHash: function( _inst ) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $( [] ),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	} );
	
	} ) );


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	function shouldExclude(reqConfig, config) {
	  return reqConfig.url.indexOf(config.apiBase) !== 0 &&
	         reqConfig.url.indexOf(config.formApiBase) !== 0 ||
	         reqConfig.method === 'POST' && (
	           reqConfig.url === config.apiBase + '/tokens' ||
	           reqConfig.url === config.apiBase + '/users/forgot-password' ||
	           reqConfig.url === config.apiBase + '/users' ||
	           reqConfig.url === config.apiBase + '/authorize?appId=' + config.appId
	         ) || (reqConfig.url.indexOf(config.apiBase + '/users/') === 0 && reqConfig.url.indexOf('reset-password?code=') > -1);
	}
	
	var noTokenSet = {
	  data:   {
	    error: {
	      message: "No token has been set"
	    }
	  },
	  status: 401
	};
	
	function AuthInterceptor($window, $q, config) {
	  return {
	    request: function(reqConfig) {
	      if(shouldExclude(reqConfig, config)) {
	        return reqConfig;
	      }
	
	      if(!$window.localStorage.token) {
	        return $q.reject(noTokenSet);
	      }
	
	      reqConfig.headers               = reqConfig.headers || {};
	      reqConfig.headers.Authorization = 'Bearer ' + $window.localStorage.token;
	      reqConfig.headers['Accept-Language'] = $window.localStorage.language || 'se';
	
	      return reqConfig;
	    }
	  };
	}
	
	function registerAuthInterceptor($httpProvider) {
	  $httpProvider.interceptors.push('AuthInterceptor');
	}
	
	angular.module('dokiv')
	  .factory('AuthInterceptor', ['$window', '$q', 'config', AuthInterceptor])
	  .config(['$httpProvider', registerAuthInterceptor]);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(18);
	
	function AuthService(
	  $window,
	  $state,
	  $injector,
	  $rootScope,
	  config
	) {
	  var $http;
	  return {
	    getToken: function() {
	      return $window.localStorage.token;
	    },
	    logout: function(isOut) {
	      var CurrentUserService = $injector.get('CurrentUserService');
	      $http = $http || $injector.get('$http');
	
	      function killSession() {
	        delete $window.localStorage.token;
	        delete $window.localStorage.userId;
	        delete $window.localStorage.language;
	
	        CurrentUserService.destroy();
	
	        $rootScope.$broadcast('auth-logout');
	        if(isOut){
	          window.location.href = '/login?isOut='+isOut;
	        }else{
	          window.location.href = '/login';
	        }
	      }
	
	      if ($window.localStorage.token) {
	        $http.delete(config.apiBase + '/tokens/' + $window.localStorage.token).success(killSession);
	      }
	      else {
	        killSession();
	      }
	    }
	};
	}
	
	angular.module('dokiv')
	  .factory('AuthService', [
	    '$window',
	    '$state',
	    '$injector',
	    '$rootScope',
	    'config',
	    AuthService
	  ]);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	function ResetPasswordCtrl($scope, translations, $state, config, $window, $http, $translate, growl) {
	  $scope.resetPassword = function(email) {
	    var data = {Email: email};
	    $http({
	      method: 'POST',
	      url: config.apiBase + '/users/forgot-password',
	      data: data
	    })
	    .success(function() {
	      growl.addSuccessMessage(translations['user.request-password-reset-success']);
	      window.location.href = '/login';
	    })
	    .error(function() {
	      growl.addErrorMessage(translations['user.request-password-reset-failure']);
	    });
	  };
	
	  $scope.availableLanguages = [
	    {value: "en", label: "English"},
	    {value: "se", label: "Svenska"}
	  ];
	
	  $scope.lang = {
	    selectedLanguage: $translate.use()
	  };
	
	  $scope.switchLanguage = function(langKey) {
	    $translate.use(langKey);
	  };
	}
	
	ResetPasswordCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'user.request-password-reset-success',
	      'user.request-password-reset-failure'
	    ]);
	  }]
	};
	module.exports = ResetPasswordCtrl;
	
	angular.module('dokiv')
	  .controller('ResetPasswordCtrl', ['$scope', 'translations', '$state', 'config', '$window', '$http', '$translate', 'growl', ResetPasswordCtrl]);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(21);
	
	function UserActivateCtrl(
	  $scope,
	  UserService,
	  $translate,
	  $stateParams,
	  $state,
	  $window,
	  growl) {
	  //Kill session
	  delete $window.localStorage.token;
	  delete $window.localStorage.userId;
	  delete $window.localStorage.language;
	  $scope.companyName = decodeURIComponent($stateParams.company);
	  $scope.user = {};
	  $scope.user.email = decodeURIComponent($stateParams.email);
	
	  $scope.availableLanguages = [
	    {value: "en", label: "English"},
	    {value: "se", label: "Svenska"}
	  ];
	
	  $scope.user.language = 'se';
	  $translate.use($scope.user.language);
	  $scope.switchLanguage = function(langKey) {
	    $translate.use(langKey);
	  };
	
	  $scope.createUser = function(){
	    UserService.save({companyId: $stateParams.companyId, code: decodeURIComponent($stateParams.code)}, $scope.user)
	      .$promise
	      .then(function(){
	        growl.addSuccessMessage('signup.success');
	        window.location.href = '/login';
	      }, function(){
	        growl.addErrorMessage('signup.failure');
	      });
	  };
	}
	
	angular.module('dokiv')
	  .controller('UserActivateCtrl', [
	    '$scope',
	    'UserService',
	    '$translate',
	    '$stateParams',
	    '$state',
	    '$window',
	    'growl', UserActivateCtrl]);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	__webpack_require__(21);
	
	function UsersResetPasswordCtrl(
	  $scope,
	  UserService,
	  translations,
	  $stateParams,
	  $state,
	  $http,
	  config,
	  growl
	) {
	
	  $http({
	    method: 'GET',
	    url: config.apiBase + '/users/'+$stateParams.userId+'/reset-password?code='+encodeURIComponent($stateParams.code)
	  })
	  .success(function() {
	    $scope.password = "";
	    $scope.retypePassword = "";
	  })
	  .error(function(resp) {
	    if(resp.error.code !== 200){
	      window.location.href = '/login';
	    }
	  });
	  
	  $scope.setPassword = function() {
	    $http({
	      method: 'POST',
	      url: config.apiBase + '/users/'+$stateParams.userId+'/reset-password?code='+encodeURIComponent($stateParams.code),
	      data: {password: $scope.password},
	      transformRequest: function(obj) {
	        var str = [];
	        angular.forEach(obj, function(v, k){
	          str.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
	        });
	        return str.join("&");
	      },
	      headers: {"Content-Type": "application/x-www-form-urlencoded"}
	    })
	    .success(function() {
	      growl.addSuccessMessage(translations['user.password-reset-success']);
	      window.location.href = '/login';
	    })
	    .error(function() {
	      growl.addErrorMessage(translations['user.password-reset-failure']);
	    });
	  };
	}
	
	UsersResetPasswordCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'user.password-reset-success',
	      'user.password-reset-failure'
	    ]);
	  }]
	};
	
	module.exports = UsersResetPasswordCtrl;
	
	angular.module('dokiv')
	  .controller('UsersResetPasswordCtrl', [
	    '$scope',
	    'UserService',
	    'translations',
	    '$stateParams',
	    '$state',
	    '$http',
	    'config',
	    'growl',
	    UsersResetPasswordCtrl
	  ]);
	


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(33);
	__webpack_require__(9);
	__webpack_require__(13);
	__webpack_require__(4);
	__webpack_require__(7);
	__webpack_require__(11);
	__webpack_require__(17);
	__webpack_require__(68);
	
	function CompanyGuestCtrl(
	  $scope,
	  customerPortals,
	  $state,
	  $stateParams,
	  $timeout,
	  $modal,
	  $window,
	  config,
	  company,
	  categories,
	  userInformation,
	  info,
	  role,
	  userGroups,
	  CompanyCategoryService,
	  CompanyPublicationFileService,
	  CompanyService
	  ) {
	  if (userInformation && userInformation.features && userInformation.features.denyLoginOnWeb) {
	    $state.go('403', {}, { location: false });
	  }
	  $scope.publicationQuery = {
	    groupId: '',
	    categoryId: '',
	    tags: [],
	    page: 1
	  };
	  $scope.role = role;
	
	  if ($scope.role !== null || ($scope.role && $scope.role.template !== null)) {
	    angular.forEach($scope.role.menus, function(v){
	      var hasSub = $scope.role.menus.some(function(m){
	        return m.parentId === v.id;
	      });
	
	      if (hasSub) {
	        v.hasSub = true;
	      }
	    });
	  }
	  
	  $scope.companyId       = $stateParams.companyId;
	  $scope.categoryActive  = false;
	  $scope.categories      = categories;
	  $scope.apiBase = config.apiBase;
	  $scope.userGroups = userGroups;
	
	  function checkPermissionGroup(group) {
	    if (!group) {
	      group = [];
	    }
	  
	    if (group.length === 0) {
	      return true;
	    }
	    
	    var match = false;
	    angular.forEach(group, function(val){
	      if (!match) {
	        match = $scope.userGroups.some(function(g){
	          return g.id === val.id;
	        });
	      }
	    });
	    return match;
	  }
	
	  if ($scope.role && $scope.role.template !== undefined) {
	    angular.forEach($scope.role.links, function(v){
	      v.show = true;
	      if (v.guestLink.indexOf(config.appBase) !== -1) {
	        if (!angular.isArray(v.groups)) {
	          v.group = [];
	        }
	        if (!checkPermissionGroup(v.groups)) {
	          v.show = false;
	        }
	      }
	    });
	  } 
	
	  $scope.isHideComment = userInformation.hide_comments;
	
	  $scope.customerPortals = customerPortals;
	
	  $scope.currency = 'sek';
	
	  $scope.info = info;
	
	  $scope.viewPublicationDetail = function(companyId, publication) {
	    var route;
	    switch (publication.type) {
	      case 'FOLDER':
	        route = 'root.company-guest.folder.detail';
	        break;
	      case 'ALBUM':
	        route = 'root.company-guest.album.detail';
	        break;
	      case 'NOTE':
	        route = 'root.company-guest.note.detail';
	        break;
	      case 'FORM':
	        route = '';
	        if (
	          publication.features.formActived === "false" ||
	          !!publication.features.formActived === false || !publication.features
	        ) {
	          window.location.href = '/forms/companies/'+companyId+'/publications/'+publication.id+'/detail';
	        }else{
	          window.location.href = '/forms/companies/'+companyId+'/publications/'+publication.id+'/form-submit';
	        }
	        break;
	      case 'KEYPASS':
	        route = 'root.company-guest.keypass.detail';
	        break;
	      case 'WALL':
	        route = 'root.company-guest.wall.detail';
	        break;
	      case 'PLANT':
	        route = 'root.company-guest.plant.detail';
	        break;
	      case 'CUSTOMER_ADAPTION':
	        route = 'root.company-guest.customer-adaption.detail';
	        break;
	      case 'ENGINE_MODEL':
	        route = 'root.company-guest.engine-model.detail';
	        break;
	      case 'PUBLICATION_GROUP':
	        route = 'root.company-guest.publication-group.detail';
	        break;
	      case 'ORDER':
	        route = 'root.company-guest.order.detail';
	        break;
	      case 'COMPANY_ORDER':
	        route = '';
	        window.location.href = '/order/'+companyId+'/detail/'+publication.id;
	        break;
	      case 'ORDER_SUBCRIPTION':
	        route = '';
	        window.location.href = '/order/'+companyId+'/subcription-detail/'+publication.id;
	        break;
	      case 'BLOG':
	        route = 'root.company-guest.blog.detail';
	        break;
	      case 'SK3_FOLDER':
	        route = 'root.company-guest.sk3-folder.detail';
	        break;
	      default:
	        route = 'root.company-guest.publications.detail';
	    }
	    if(route){
	      $state.go(route, {companyId: companyId, publicationId: publication.id});
	    }
	  };
	
	  $scope.getPublicationIcon = function(type) {
	    switch(type) {
	      case 'DEFAULT':              return 'fa-files-o';
	      case 'FOLDER':               return 'fa-briefcase';
	      case 'ALBUM':                return 'fa-image';
	      case 'FORM':                 return 'fa-clipboard';
	      case 'NOTE':                 return 'fa-file-text-o';
	      case 'KEYPASS':              return 'fa-key';
	      case 'WALL':                 return 'fa-comments-o';
	      case 'PLANT':                return 'fa-industry';
	      case 'CUSTOMER_ADAPTION':    return 'fa-cogs';
	      case 'ENGINE_MODEL':         return 'fa-folder';
	      case 'PUBLICATION_GROUP':    return 'fa-object-group';
	      case 'ORDER':                return 'fa-list';
	      case 'COMPANY_ORDER':        return 'fa-shopping-cart';
	      case 'BLOG':                  return 'fa-blog';
	      case 'SK3_FOLDER':                  return 'fa-lock';
	    }
	  };
	
	  $scope.toggleTag = function(tag) {
	    if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
	      $scope.publicationQuery.tags.push(tag);
	    } else {
	      $scope.publicationQuery.tags.splice($scope.publicationQuery.tags.indexOf(tag), 1);
	    }
	  };
	
	  $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
	    for (var attr in $scope.publicationQuery) {
	      if($scope.publicationQuery.hasOwnProperty(attr)) {
	        if('tags' === attr) {
	          if(!toParams[attr]) {
	            $scope.publicationQuery[attr] = [];
	            continue;
	          }
	
	          $scope.publicationQuery[attr] = toParams[attr].split(',');
	        } else {
	          $scope.publicationQuery[attr] = toParams[attr];
	        }
	      }
	    }
	
	  });
	
	  $scope.$on('categoriesChanged', function(ev, categories) {
	    if(categories) {
	      $scope.categories = categories;
	    } else {
	      CompanyCategoryService.query({companyId: company.id}, function(categories) {
	        $scope.categories = categories;
	      });
	    }
	  });
	
	  var reloadTagsTimeout;
	  $scope.$on('tagsChanged', function() {
	    if(reloadTagsTimeout) {
	      $timeout.cancel(reloadTagsTimeout);
	      reloadTagsTimeout = null;
	    }
	    reloadTagsTimeout = $timeout(function() {
	      CompanyService.queryTags({companyId: company.id}, function(tags) {
	        $scope.tags = tags;
	      });
	    }, 1000 * 61);
	  });
	
	  var searchTimeout;
	  $scope.filterPublications = function() {
	    if(searchTimeout){
	      $timeout.cancel(searchTimeout);
	      searchTimeout = null;
	    }
	    searchTimeout = $timeout(function () {
	      var q = angular.copy($scope.publicationQuery);
	
	      // Remove tags from query string if it is empty
	      if(q.tags && 0 === q.tags.length) {
	        q.tags = null;
	      }
	      $state.go('root.company-guest.publications.list', q);
	      searchTimeout = null;
	    }, 200);
	  };
	
	  $scope.downloadZip = function(publicationId) {
	    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	    if (true === iOS) {
	      window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/zip?lang=' + window.localStorage.language, '_self');
	      return;
	    }
	
	    var elm = angular.element(document.querySelector('body'));
	    var iFrame = elm.find('#downloadWindow');
	    if (!(iFrame && iFrame.length > 0)) {
	      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	      elm.append(iFrame);
	    }
	    iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/zip?lang=' + window.localStorage.language);
	  };
	
	  $scope.openPreview = function(file, publicationId) {
	    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
	        return $scope.download(file, publicationId);
	      }
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;
	
	      var type;
	      switch(file.mimeType) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          type = 'image';
	          break;
	        case 'application/pdf':
	          if (true === iOS) {
	            window.open(url, '_self');
	            return;
	          }
	          type = 'iframe';
	          break;
	        default:
	          type = 'iframe';
	      }
	
	      jQuery.fancybox.open([{
	        type: type,
	        iframe: {
	          preload: false
	        },
	        padding: 0,
	        margin: 0,
	        href: url
	      }]);
	    });
	
	    return false;
	  };
	
	  $scope.download = function(file, publicationId) {
	    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true', '_self');
	        return;
	      }
	      
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadWindow');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	
	      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true');
	    });
	  };
	
	  $scope.openNewWindow = function(menu){
	    if(!menu.mainMenu){
	      if(menu.targetBlank){
	        $window.open(menu.guestLink, 'newwindow', 'width=1200, height=800');
	      }else{
	        $window.location.href = menu.guestLink;
	      }
	    }
	    return false;
	  };
	
	}
	
	var isGuestCompanyState = /^root\.company-guest(\..*|$)/i;
	
	CompanyGuestCtrl.resolve = {
	  company: ['$stateParams', 'stateSnapshot', '$state', 'CompanyService', function($stateParams, stateSnapshot, $state, CompanyService) {
	    return CompanyService.get({
	      companyId: $stateParams.companyId,
	      leaveCompany: stateSnapshot.previous.params.companyId || null,
	      enterCompany: true
	    }).$promise.then(function(company) {
	      if(company.userType !== "GUEST" && isGuestCompanyState.test(stateSnapshot.next.state.name)) {
	        $state.go(stateSnapshot.next.state.name.replace(isGuestCompanyState, 'root.company$1-list'), stateSnapshot.next.params);
	
	        /* Required to prevent anything depending on company
	           from actually sending XHRs. */
	        throw new Error("Restarting routing");
	      }
	
	      return company;
	    });
	  }],
	  customerPortals: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, type: 'VISIBLE', userId: $window.localStorage.userId, all: true}).$promise;
	  }],
	  categories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService){
	    return CompanyCategoryService.query({companyId: $stateParams.companyId, nonEmpty: true}).$promise;
	  }],
	  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
	    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
	  }],
	  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService){
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
	  }],
	  role: ['CompanyUserRoleService', '$stateParams', 'userInformation', 'info', function(CompanyUserRoleService, $stateParams, userInformation, info){
	      var selectedRole = null;
	      if(userInformation.features.selectedRole){
	        selectedRole = userInformation.features.selectedRole;
	      }else if(userInformation.roles !== null && userInformation.roles[0]){
	        selectedRole = userInformation.roles[0];
	      }
	      if (info.features.userRole && selectedRole) {
	        return CompanyUserRoleService.get({
	          companyId: $stateParams.companyId,
	          roleId: selectedRole.id
	        }).$promise;
	      }
	      return null;
	  }],
	  userGroups: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, type: null, userId: $window.localStorage.userId, all: true}).$promise;
	  }]
	};
	module.exports = CompanyGuestCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestCtrl', [
	    '$scope',
	    'customerPortals',
	    '$state',
	    '$stateParams',
	    '$timeout',
	    '$modal',
	    '$window',
	    'config',
	    'company',
	    'categories',
	    'userInformation',
	    'info',
	    'role',
	    'userGroups',
	    'CompanyCategoryService',
	    'CompanyPublicationFileService',
	    'CompanyService',
	    CompanyGuestCtrl]);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(35);
	function CompanyGuestNavCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $timeout,
	  logo,
	  companies,
	  userInformation
	) {
	  var searchTimeout;
	  $scope.logo = logo;
	  $scope.companies = companies;
	  $scope.companyId = $stateParams.companyId;
	  $scope.userInfo = userInformation;
	
	  $scope.filter = {
	    q:     null,
	    qType: "GENERAL",
	    page:  null
	  };
	
	  $scope.$on('$stateChangeSuccess', function() {
	    if(!searchTimeout) {
	      $scope.filter.q     = $state.params.q;
	      $scope.filter.qType = $state.params.qType || "GENERAL";
	    }
	  });
	
	  function getCompanyById(companies, companyId) {
	    var ret = false;
	
	    companies.forEach(function(c) {
	      if(c.id === companyId) {
	        ret = c;
	      }
	    });
	
	    return ret;
	  }
	
	  $scope.currentCompany = getCompanyById($scope.companies, $stateParams.companyId);
	
	  $scope.$watchCollection("[filter.q, filter.qType]", function(newValues, oldValues) {
	    var newQ = newValues[0] || "";
	    var oldQ = oldValues[0] || "";
	
	    /* If we have a string and a change, it is either q or qType.
	       If we do not have a string but the string is changed, then user might want
	       unfiltered list */
	    if(newQ.trim().length > 0 || newQ !== oldQ) {
	      if(searchTimeout){
	        $timeout.cancel(searchTimeout);
	
	        searchTimeout = null;
	      }
	
	      searchTimeout = $timeout(function () {
	        if (angular.isDefined(newValues[0])) {
	          if('' === newValues[0].trim()) {
	            $scope.filter.q = null;
	          }
	
	          $state.go('root.company-guest.publications.list', $scope.filter);
	
	          searchTimeout = null;
	        }
	      }, 300);
	    }
	  });
	}
	
	CompanyGuestNavCtrl.resolve = {
	  logo: ['$stateParams', 'CompanyLogoService', function($stateParams, CompanyLogoService) {
	    return CompanyLogoService.get({companyId: $stateParams.companyId}).$promise;
	  }],
	  companies: ['CompanyService', function(CompanyService) {
	    return CompanyService.query().$promise;
	  }]
	};
	
	module.exports = CompanyGuestNavCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestNavCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    '$timeout',
	    'logo',
	    'companies',
	    'userInformation',
	    CompanyGuestNavCtrl
	  ]);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(9);
	function GuestPublicationImageDirective(CompanyPublicationFileService) {
	  return {
	    restrict: 'EA',
	    link: function($scope, $elem) {
	      CompanyPublicationFileService.query({companyId: $scope.companyId, publicationId: $scope.publication.id}).$promise.then(function(resp){
	        if (resp.length > 0) {
	          var fileId = resp[0].id;
	          CompanyPublicationFileService.getPreview({companyId: $scope.companyId, publicationId: $scope.publication.id, fileId: fileId}, function(data) {
	            $elem.attr('src', 'data:' + data.dataUrl + '');
	          });
	        }
	      });
	    }
	
	  };
	}
	angular.module('dokiv')
	  .directive('guestPublicationImage', ['CompanyPublicationFileService', GuestPublicationImageDirective]);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	CompanyGuestAlbumsCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'publication',
	  'UploadTracker',
	  'config',
	  'growl',
	  'translations'
	];
	function CompanyGuestAlbumsCtrl(
		$scope, 
		$stateParams, 
		publication,
		uploadTracker,
		config,
		growl,
		translations) {
	  $scope.publication = publication;
	
	  $scope.uploadFilesForPublication = function(files, publicationId) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
	        file: f,
	      };
	    }));
	  };
	
	  $scope.onFileSelect = function($files) {
	    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id) {
	      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
	        publication.versionNumber += files.length;
	        $scope.$broadcast("files-uploaded", files);
	      });
	    } else {
	      growl.addErrorMessage(translations['publication.file-upload-locked']);
	      return false;
	    }
	  };
	}
	
	CompanyGuestAlbumsCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.file-upload-locked'
	    ]);
	  }]
	};
	module.exports = CompanyGuestAlbumsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestAlbumsCtrl', CompanyGuestAlbumsCtrl);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(10);
	
	var LIMIT = 21;
	
	function CompanyGuestAlbumsDetailCtrl(
	  $scope,
	  files,
	  checklists,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  publication,
	  CompanyPublicationFileService,
	  userInformation,
	  $sce,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.files               = files.slice(0, LIMIT);
	  $scope.checklists          = checklists;
	  $scope.translations        = translations;
	  $scope.activityService     = activityService;
	  $scope.currentPage         = $stateParams.page|0;
	  $scope.hasMore             = files.length > LIMIT;
	  $scope.searchFileStr       = $stateParams.searchFile || "";
	  $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	  $scope.showFileDrop        = !$scope.showInvisibleFiles;
	  $scope.userInfo = userInformation;
	
	  if($scope.publication.type === 'ALBUM'){
	    $scope.tabs = [
	      {
	        'title': $sce.trustAsHtml(translations['publication.information']),
	          'content': '',
	          'template': 'partials/company-guest/albums/detail/latest.html',
	          'icon': 'info-circle'
	      }
	    ];
	  }else{
	    if($scope.publication.type === 'SK3_FOLDER'){
	      $scope.tabs = [
	        {
	          'title': $sce.trustAsHtml(translations['publication.information']),
	            'content': '',
	            'template': 'partials/company-guest/sk3-folder/detail/latest.html',
	            'icon': 'info-circle'
	        }
	      ];
	      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/list.html';
	    }
	  }
	
	  $scope.tabs.activeTab = 0;
	
	  var queryFiles =  function() {
	    return CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         21,
	      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	      offset:        ($stateParams.page|0) * 20
	    }).$promise.then(function(files) {
	      $scope.$emit('publicationSaved');
	      $scope.files   = files.slice(0, 20);
	      $scope.hasMore = files.length > 20;
	    });
	  };
	
	  $scope.$on("files-uploaded", queryFiles);
	}
	
	CompanyGuestAlbumsDetailCtrl.resolve = {
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
	    return checklistService.query({
	      companyId: $stateParams.companyId,
	      relativeID: $stateParams.publicationId
	    }).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: LIMIT + 1,
	      q: $stateParams.searchFile || "",
	      offset: ($stateParams.page|0) * LIMIT,
	      visible: true
	    }).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestAlbumsDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestAlbumsDetailCtrl', [
	  '$scope',
	  'files',
	  'checklists',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'publication',
	  'CompanyPublicationFileService',
	  'userInformation',
	  '$sce',
	  'activityService',
	  CompanyGuestAlbumsDetailCtrl
	]);
	
	


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(25);
	
	function CompanyGuestPublicationBlogDetailCtrl(
	  $scope,
	  $stateParams,
	  publication,
	  translations,
	  posts,
	  $sce
	) {
	  $scope.publication         = publication;
	  $scope.translations        = translations;
	  $scope.posts               = posts.slice(0, 21);
	  $scope.translations        = translations;
	  $scope.currentPage         = $stateParams.page|0;
	  $scope.hasMore             = posts.length > 21;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	      'content': '',
	      'template': 'partials/company-guest/blog/detail/latest.html',
	      'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	}
	
	CompanyGuestPublicationBlogDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }).$promise;
	  }],
	  posts: ['CompanyPublicationBlogService', '$stateParams', function(CompanyPublicationBlogService, $stateParams){
	    return CompanyPublicationBlogService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         22,
	      offset:        ($stateParams.page|0) * 21
	    }).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }]
	};
	
	module.exports = CompanyGuestPublicationBlogDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationBlogDetailCtrl', [
	  '$scope',
	  '$stateParams',
	  'publication',
	  'translations',
	  'posts',
	  '$sce',
	  CompanyGuestPublicationBlogDetailCtrl
	]);
	
	


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(38);
	__webpack_require__(58);
	
	
	CompanyGuestCommentsCtrl.$inject = [
	  '$scope',
	  'comments',
	  'messages',
	  'activities'];
	function CompanyGuestCommentsCtrl(
	  $scope,
	  comments,
	  messages,
	  activities) {
	  $scope.comments = comments;
	  $scope.messages = messages;
	  $scope.activities= activities;
	}
	
	CompanyGuestCommentsCtrl.resolve = {
	  comments: ['$stateParams', 'CompanyCommentsService' , function($stateParams, CompanyCommentsService) {
	    return CompanyCommentsService.query({companyId: $stateParams.companyId, limit: 4}).$promise;
	  }],
	  messages: ['$stateParams', 'CompanyMessageService', 'info', function($stateParams, CompanyMessageService, info) {
	    if (info.features.blogs === false) {
	      return false;
	    }
	    return CompanyMessageService.query({companyId: $stateParams.companyId, limit: 4}).$promise;
	  }],
	  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService){
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
	  }],
	  activities: ['$stateParams', 'CompanyFeedActivity', 'info', function($stateParams, CompanyFeedActivity, info) {
	    return new CompanyFeedActivity($stateParams.companyId, info.features.blogs);
	  }]
	};
	
	module.exports = CompanyGuestCommentsCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyGuestCommentsCtrl", CompanyGuestCommentsCtrl);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(30);
	
	var LIMIT = 21;
	function CompanyGuestCompanyOrderDetailCtrl(
	  $scope,
	  publication,
	  order,
	  files,
	  translations,
	  $translate,
	  $stateParams,
	  $state,
	  orderStatuses,
	  CompanyPublicationService,
	  CompanyProductsService,
	  CompanyService,
	  CompanyCustomersService,
	  CompanyPublicationCompanyOrderService,
	  $sce,
	  config,
	  $filter,
	  activityService,
	  $modal,
	  $http,
	  projects,
	  growl
	) {
	  $scope.publication         = publication;
	  $scope.translations        = translations;
	  $scope.activityService     = activityService;
	  $scope.order               = order;
	  $scope.files               = files.slice(0, LIMIT);
	  $scope.currentPage         = $stateParams.page|0;
	  $scope.hasMore             = files.length > LIMIT;
	  $scope.orderStatuses       = orderStatuses;
	  $scope.projects            = projects;
	  $scope.orderStatusesSorted = ($filter('orderBy')($scope.orderStatuses, 'stepNr')).filter(function(v){
	    return v.stepNr > 0;
	  });
	  $scope.searchFileStr       = $stateParams.searchFile || "";
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/company-order/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	  $scope.paymentTypes = [
	    {
	      'name': $translate.instant('order.payment.cash-on-delivery'),
	      'value': 'CASH_ON_DELIVERY'
	    }, {
	      'name': $translate.instant('order.payment.10-days'),
	      'value': '10_DAYS'
	    }, {
	      'name': $translate.instant('order.payment.20-days'),
	      'value': '20_DAYS'
	    }, {
	      'name': $translate.instant('order.payment.30-days'),
	      'value': '30_DAYS'
	    }
	  ];
	
	  $scope.nonProductsAdded = [];
	  var nonProdcutAddedPromise;
	  var totalOrder = function(includeTax) {
	    var total = 0;
	    if ($scope.order) {
	      angular.forEach($scope.order.items, function(v){
	        if (includeTax) {
	          total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
	        } else {
	          total += v.price.soldPrice * v.amount;
	        }
	      });
	    }
	
	    return total;
	  };
	
	  $scope.updateTotal = function() {
	    $scope.totalExcludeTax = totalOrder();
	    $scope.totalIncludeTax = totalOrder(true);
	    $scope.totalTax        = totalOrder(true) - totalOrder();
	  };
	
	  $scope.updateTotal();  
	
	  if($scope.order && $scope.order.customer && $scope.order.customer.priceList !== null){
	    $scope.currentProject = $scope.order.customer.priceList;
	  }else{
	    if ($scope.publication.features.currentOrderProjectId) {
	      var currentProject = $scope.projects.filter(function(project){
	        return project.id === $scope.publication.features.currentOrderProjectId;
	      });
	
	      if (currentProject.length > 0) {
	        $scope.currentProject = currentProject[0].price_list;
	      }
	    }
	  }
	
	  $scope.setDefautPricelist = function() {
	    if ($scope.publication.features.currentOrderProjectId || ($scope.order.customer && $scope.order.customer.priceList !== null)) {
	      angular.forEach($scope.order.items ,function(v){
	        if (v.price.priceListId !== $scope.currentProject.id) {
	          angular.forEach(v.product.pricelist, function(p){
	            if ($scope.currentProject.id === p.priceListId) {
	              v.price = angular.copy(p);
	              v.price.soldPrice = v.price.price;
	              CompanyPublicationCompanyOrderService.updateItem({
	                companyId: $stateParams.companyId,
	                publicationId: $stateParams.publicationId,
	                orderId: $scope.order.id,
	                itemId: v.id
	              }, v);     
	            }
	          });
	        }
	      });
	    }
	    $scope.updateTotal();
	  };
	
	  $scope.updateNonProductsAdded = function(filter) {
	    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
	          return products.filter(function(item) {
	            return !$scope.order.items.some(function(i) {
	              return item.id === i.product.id;
	            });
	          });
	        }).then(function(nonProducts) {
	          if(nonProdcutAddedPromise === p) {
	            $scope.nonProductsAdded = nonProducts;
	          }
	        });
	        nonProdcutAddedPromise = p;
	  };
	
	  $scope.updateProducts = function(filter) {
	    CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
	      nonProdcutAddedPromise = products;
	      $scope.nonProductsAdded = products;
	    });
	  };
	
	  $scope.updateCompanyOrder = function(product) {
	    var item = {
	      product: product,
	      amount: 1,
	      price: {
	        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
	        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
	      }
	    };
	    return CompanyPublicationCompanyOrderService.updateItems({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      orderId: $scope.order.id
	    }, item).$promise;
	  };
	
	  $scope.addProduct = function(product) {
	    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
	    angular.element('#filterProduct').val('');
	    $scope.updateCompanyOrder(product).then(function(resp){
	      resp = checkImageProduct(resp);
	      var index = $scope.order.items.push(resp);
	      $scope.order.items[index-1].price = angular.copy(product.pricelist[0]);
	      $scope.order.items[index-1].price.soldPrice = $scope.order.items[index-1].price.price;
	      $scope.setDefautPricelist();
	      $scope.showModalEditItem($scope.order.items[index-1], index-1);
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  function checkImageProduct(item) {
	    item.product.images = item.product.images.filter(function(item){
	      return item.status === true;
	    }); 
	    if(item.product.images.length > 0){
	      item.product.image = config.apiBase + "/files/" + item.product.images[0].id;
	    }else{
	      item.product.image = "images/no-image.jpg";
	    }
	    return item;
	  }
	
	  if ($scope.order) {
	    angular.forEach($scope.order.items, function(item){
	      checkImageProduct(item);
	    });
	  }
	
	  $scope.update = function() {
	    if($scope.order.customerOrderNr === ''){
	      $scope.order.customerOrderNr = null;
	    }
	    $scope.order.$update({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, function(){
	      growl.addSuccessMessage($translate.instant('order.update-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  $scope.createQuote = function() {
	    $scope.order.$update({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      createQuote: true
	    }, function(){
	      CompanyPublicationCompanyOrderService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: $scope.order.id
	      }).$promise.then(function(resp){
	        $scope.order = resp;
	      });
	      growl.addSuccessMessage($translate.instant('order.update-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  $scope.removeProduct = function(index) {
	    CompanyPublicationCompanyOrderService.deleteItem({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      orderId: $scope.order.id,
	      itemId: $scope.order.items[index].id
	    }, function(){
	      $scope.order.items.splice(index, 1);
	      $scope.updateTotal();
	    });
	  };
	
	  $scope.showModalEditItem = function(item, index) {
	    $modal({
	      scope: $scope,
	      controller: [
	        'CompanyPublicationCompanyOrderService',
	        '$stateParams',
	        '$scope',
	        '$timeout',
	        'item',
	        'index', function(
	          CompanyPublicationCompanyOrderService,
	          $stateParams,
	          $scope,
	          $timeout,
	          item,
	          index){
	        $scope.item = item;
	
	        $scope.save = function() {
	          CompanyPublicationCompanyOrderService.updateItem({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            orderId: $scope.order.id,
	            itemId: $scope.item.id
	          }, $scope.item, function(resp){
	            $scope.order.items[index] = resp;
	            $timeout(function(){
	              angular.element('.footable').trigger('footable_redraw');
	            }, 0);
	            $scope.$hide();
	            $scope.updateTotal();
	          });
	        };
	      }],
	      templateUrl: 'partials/company-guest/company-order/detail/modal.html',
	      show: true,
	      resolve: {
	        item: function() {
	          return item || false;
	        },
	        index: function() {
	          return (angular.isUndefined(index) ? -1 : index);
	        }
	      }
	    });
	  };
	
	  $scope.nextStatus = function() {
	    if ($scope.orderStatusesSorted.length === 0) {
	      return;
	    }
	    if (!$scope.order.orderStatus) {
	      $scope.order.orderStatus = $scope.orderStatusesSorted[0].id;
	      $scope.update();
	    } else {
	      var index = $scope.orderStatusesSorted.findIndex(function(v){
	        return v.id === $scope.order.orderStatus;
	      });
	
	      if (index >= ($scope.orderStatusesSorted.length - 1) || index < 0) {
	        return;
	      }
	      $scope.order.orderStatus = $scope.orderStatusesSorted[index + 1].id;
	      $scope.update();
	    }
	  };
	  
	  $scope.productPreview = function(product) {
	    jQuery.fancybox.open([{
	      type: 'image',
	      padding: 0,
	      margin: 0,
	      href: product ? config.apiBase + '/files/' + product.id : ''
	    }]);
	    return false;
	  };
	}
	
	CompanyGuestCompanyOrderDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: LIMIT + 1,
	      offset: ($stateParams.page|0) * LIMIT,
	      q: $stateParams.searchFile || "",
	    }).$promise;
	  }],
	  order: ['$stateParams', 'CompanyPublicationCompanyOrderService', 'publication', function($stateParams, publicationCompanyOrderService, publication){
	    if (publication.features.currentCompanyOrderId) {
	      return publicationCompanyOrderService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: publication.features.currentCompanyOrderId,
	        q: $stateParams.searchFile || ""
	      }).$promise;
	    }
	  }],
	  orderStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService){
	    return CompanyService.queryOrderStatuses({
	      companyId: $stateParams.companyId
	    }).$promise;
	  }],
	  projects: ['CompanyProjectService', '$stateParams', function(CompanyProjectService, $stateParams){
	    return CompanyProjectService.query({
	      companyId: $stateParams.companyId,
	      limit: 1000
	    }).$promise;
	  }]
	};
	module.exports = CompanyGuestCompanyOrderDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestCompanyOrderDetailCtrl', [
	  '$scope',
	  'publication',
	  'order',
	  'files',
	  'translations',
	  '$translate',
	  '$stateParams',
	  '$state',
	  'orderStatuses',
	  'CompanyPublicationService',
	  'CompanyProductsService',
	  'CompanyService',
	  'CompanyCustomersService',
	  'CompanyPublicationCompanyOrderService',
	  '$sce',
	  'config',
	  '$filter',
	  'activityService',
	  '$modal',
	  '$http',
	  'projects',
	  'growl',
	  CompanyGuestCompanyOrderDetailCtrl
	]);
	
	


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	
	var LIMIT = 21;
	
	function CompanyGuestCustomerAdaptionDetailCtrl(
	  $scope,
	  publication,
	  files,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication        = publication;
	  $scope.files              = files.slice(0, LIMIT);
	  $scope.translations       = translations;
	  $scope.activityService    = activityService;
	  $scope.currentPage        = $stateParams.page|0;
	  $scope.hasMore            = files.length > LIMIT;
	  $scope.searchFileStr      = $stateParams.searchFile || "";
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/customer-adaption/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	}
	
	CompanyGuestCustomerAdaptionDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: LIMIT + 1,
	      offset: ($stateParams.page|0) * LIMIT,
	      q: $stateParams.searchFile || ""
	    }).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestCustomerAdaptionDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestCustomerAdaptionDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestCustomerAdaptionDetailCtrl
	]);
	
	


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	
	function CompanyGuestEngineModelDetailCtrl(
	  $scope,
	  publication,
	  files,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.files = files;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/engine-model/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestEngineModelDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestEngineModelDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestEngineModelDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestEngineModelDetailCtrl
	]);
	
	


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGuestFoldersCtrl() {
	}
	
	angular.module('dokiv')
	  .controller('CompanyGuestFoldersCtrl', [CompanyGuestFoldersCtrl]);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(10);
	__webpack_require__(12);
	
	var LIMIT = 21;
	
	function CompanyGuestFoldersDetailCtrl(
	  $scope,
	  publication,
	  files,
	  checklists,
	  children,
	  order,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication         = publication;
	  $scope.files               = files.slice(0, LIMIT);
	  $scope.checklists          = checklists;
	  $scope.translations        = translations;
	  $scope.children            = children;
	  $scope.order               = order;
	  $scope.activityService     = activityService;
	  $scope.currentPage         = $stateParams.page|0;
	  $scope.hasMore             = files.length > LIMIT;
	  $scope.searchFileStr       = $stateParams.searchFile || "";
	
	  $scope.setDefaultColor = function() {
	    $scope.children.forEach(function(c,i){
	      if (!c.category) {
	        $scope.children[i].category = {};
	        $scope.children[i].category.color = 4279856278; // #196c96
	      }
	    });
	  };
	
	  $scope.setDefaultColor();
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/folders/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestFoldersDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
	    return checklistService.query({
	      companyId: $stateParams.companyId,
	      relativeID: $stateParams.publicationId
	    }).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: LIMIT + 1,
	      q: $stateParams.searchFile || "",
	      offset: ($stateParams.page|0) * LIMIT
	    }).$promise;
	  }],
	  order: ['CompanyCustomersService', '$stateParams', 'publication' , function(CompanyCustomersService, $stateParams, publication){
	    if (publication.features.currentCustomerId) {
	        return CompanyCustomersService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        customerId: publication.features.currentCustomerId
	      }).$promise;
	    }
	    return false;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestFoldersDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestFoldersDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'checklists',
	  'children',
	  'order',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestFoldersDetailCtrl
	]);
	
	


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	/* FIXME: Remove */
	function CompanyGuestKeypassesCtrl() {
	}
	
	angular.module('dokiv')
	  .controller('CompanyGuestKeypassesCtrl', [CompanyGuestKeypassesCtrl]);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(61);
	
	function CompanyGuestKeypassesDetailCtrl(
	  $scope,
	  publication,
	  translations,
	  $stateParams,
	  $state,
	  CompanyService,
	  CompanyPublicationService,
	  CompanyPublicationKeypassService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.companyId = $stateParams.companyId;
	  $scope.publication = publication;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/keypasses/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	  CompanyPublicationKeypassService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
	    $scope.keypass = resp;
	  });
	}
	
	CompanyGuestKeypassesDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestKeypassesDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestKeypassesDetailCtrl', [
	  '$scope',
	  'publication',
	  'translations',
	  '$stateParams',
	  '$state',
	  'CompanyService',
	  'CompanyPublicationService',
	  'CompanyPublicationKeypassService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestKeypassesDetailCtrl
	]);
	
	


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGuestNotesCtrl() {
	}
	
	angular.module('dokiv')
	  .controller('CompanyGuestNotesCtrl', [CompanyGuestNotesCtrl]);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(10);
	
	function CompanyGuestNotesDetailCtrl(
	  $scope,
	  publication,
	  children,
	  checklists,
	  translations,
	  $stateParams,
	  $state,
	  CompanyPublicationService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.translations = translations;
	  $scope.children = children;
	  $scope.checklists = checklists;
	  $scope.activityService = activityService;
	
	  $scope.setDefaultColor = function() {
	    $scope.children.forEach(function(c, i){
	      if (!c.category) {
	        $scope.children[i].category = {};
	        $scope.children[i].category.color = 4279856278; // #196c96
	      }
	    });
	  };
	
	  $scope.setDefaultColor();
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/notes/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestNotesDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
	    return checklistService.query({
	      companyId: $stateParams.companyId,
	      relativeID: $stateParams.publicationId
	    }).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestNotesDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestNotesDetailCtrl', [
	  '$scope',
	  'publication',
	  'children',
	  'checklists',
	  'translations',
	  '$stateParams',
	  '$state',
	  'CompanyPublicationService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestNotesDetailCtrl
	]);
	
	


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(12);
	
	function CompanyGuestPublicationOrderDetailCtrl(
	  $scope,
	  publication,
	  order,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyPublicationService,
	  orderService,
	  $sce,
	  $q,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	  $scope.order = order;
	
	  $scope.orderPlants = [];
	  $scope.orderUsers = [];
	  $scope.orderProjects = [];
	
	  if ($scope.order) {
	    var params = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: $scope.order.id
	    };
	
	    var orderPlants = orderService.queryPlants(params).$promise;
	    var orderUsers = orderService.queryUsers(params).$promise;
	    var orderProjects = orderService.queryProjects(params).$promise;
	
	    $q.all([orderPlants, orderUsers, orderProjects]).then(function(data){
	      $scope.orderPlants = data[0];
	      $scope.orderUsers = data[1];
	      $scope.orderProjects = data[2];
	    });
	  }
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/order/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestPublicationOrderDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }],
	  order: ['$stateParams', 'CompanyPublicationOrderService', 'publication', function($stateParams, CompanyPublicationOrderService, publication){
	    if (publication.features.currentOrderId) {
	      return CompanyPublicationOrderService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: publication.features.currentCompanyOrderId
	      }).$promise;
	    }
	
	    return false;
	  }]
	};
	module.exports = CompanyGuestPublicationOrderDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationOrderDetailCtrl', [
	  '$scope',
	  'publication',
	  'order',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyPublicationService',
	  'CompanyPublicationOrderService',
	  '$sce',
	  '$q',
	  'config',
	  'activityService',
	  CompanyGuestPublicationOrderDetailCtrl
	]);
	
	


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(4);
	__webpack_require__(28);
	__webpack_require__(31);
	
	function CompanyGuestPlantDetailCtrl(
	  $scope,
	  publication,
	  files,
	  plant,
	  translations,
	  $stateParams,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.plant = plant;
	  $scope.publication = publication;
	  $scope.files = files;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	      'content': '',
	      'template': 'partials/company-guest/plants/detail/latest.html',
	      'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestPlantDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  plant: ['$stateParams', 'publication', 'CompanyPublicationPlantService', function($stateParams, publication, CompanyPublicationPlantService) {
	    if (publication.features.currentPlantId) {
	      return CompanyPublicationPlantService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        plantId: publication.features.currentPlantId}).$promise;
	    }
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestPlantDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPlantDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'plant',
	  'translations',
	  '$stateParams',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestPlantDetailCtrl
	]);
	
	


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(12);
	
	function CompanyGuestPublicationGroupDetailCtrl(
	  $scope,
	  publication,
	  files,
	  children,
	  order,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.files = files;
	  $scope.translations = translations;
	  $scope.children = children;
	  $scope.order = order;
	  $scope.activityService = activityService;
	
	  $scope.setDefaultColor = function() {
	    $scope.children.forEach(function(c,i){
	      if (!c.category) {
	        $scope.children[i].category = {};
	        $scope.children[i].category.color = 4279856278; // #196c96
	      }
	    });
	  };
	
	  $scope.setDefaultColor();
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	        'content': '',
	        'template': 'partials/company-guest/publication-group/detail/latest.html',
	        'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestPublicationGroupDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  order: ['CompanyCustomersService', '$stateParams', 'publication' , function(CompanyCustomersService, $stateParams, publication){
	    if (publication.features.currentCustomerId) {
	        return CompanyCustomersService.get({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        customerId: publication.features.currentCustomerId
	      }).$promise;
	    }
	    return false;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestPublicationGroupDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationGroupDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'children',
	  'order',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestPublicationGroupDetailCtrl
	]);
	
	


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(25);
	__webpack_require__(19);
	__webpack_require__(63);
	__webpack_require__(52);
	function CompanyGuestPublicationsCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $modal,
	  $window,
	  reloadUserRoleDashboard,
	  userInformation,
	  CompanyMessageService,
	  CompanyCommentsService,
	  CompanyTaskService,
	  CompanyPublicationService,
	  notices
	  ) {
	  $scope.userInfo = userInformation;
	  $scope.posts = [];
	  $scope.comments = [];
	  $scope.latestTasks = [];
	  $scope.notices = notices;
	  $scope.state = $state;
	  $scope.$on('$stateChangeSuccess', function(){
	    if ($state.current.name === 'root.company-guest.publications') {
	      reloadUserRoleDashboard.reload();
	    }
	  });
	
	  $scope.$on('$stateChangeStart', function(){
	    reloadUserRoleDashboard.stop();
	  });
	  
	  setTimeout(function(){
	    var options = {
	      alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
	      disableOneColumnMode: true
	    };
	    jQuery('.grid-stack').gridstack(options);
	  }, 10);
	
	  angular.element($window).on('resize', function () {
	    var widthWindowH = angular.element($window).width();
	    var grid = jQuery('.grid-stack').data('gridstack');
	    if(widthWindowH < 1016 && widthWindowH > 825){
	      angular.forEach($scope.role.template.data, function(value, key){
	        grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), (value.chartData.gsX === "0" ? 0 : 6), value.chartData.gsY, 6, value.chartData.gsHeigth);
	      });
	    }else{
	      if(widthWindowH >= 1016){
	        angular.forEach($scope.role.template.data, function(value, key){
	          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), parseInt(value.chartData.gsX), parseInt(value.chartData.gsY), parseInt(value.chartData.gsWidth), parseInt(value.chartData.gsHeigth));
	        });
	      }else{
	        angular.forEach($scope.role.template.data, function(value, key){
	          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), 0, parseInt(value.chartData.gsY), 12, parseInt(value.chartData.gsHeigth));
	        });
	      }
	    }
	  });
	
	  if ($scope.role !==  null && $scope.role.template) {
	    var gsYMax = 0;
	    var gsHeigthMax = 4;
	    if($scope.role.template.data){
	      angular.forEach($scope.role.template.data, function(value, key){
	        value.chartData = value.chartData ? value.chartData : {};
	        value.chartData.gsX = angular.isDefined(value.chartData.gsX) ? value.chartData.gsX : (key%3===0 ? 0 : (key%3===1 ? 4 : 8));
	        value.chartData.gsY = angular.isDefined(value.chartData.gsY) ? value.chartData.gsY : 0;
	        value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth) ? value.chartData.gsWidth : 4;
	        value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth) ? value.chartData.gsHeigth : 7;
	        if(parseInt(value.chartData.gsY) > gsYMax){
	          gsYMax = parseInt(value.chartData.gsY);
	          gsHeigthMax = parseInt(value.chartData.gsHeigth);
	        }
	      });
	    }
	    var boxMessage = $scope.role.template.data.filter(function(d){ return d.columnType === 'MESSAGE'; });
	    if ($scope.info.features.blogs && $scope.role.showMessage) {
	      CompanyMessageService.query({
	        companyId: $stateParams.companyId,
	        limit: 4,
	        showInList: false
	      }, function(resp){
	        $scope.posts = resp;
	        if(!boxMessage[0]){
	          if($scope.posts.length > 0){
	            $scope.role.template.data.push({
	              isChart: false,
	              centralInformation: false,
	              columnType: 'MESSAGE',
	              isFullBox: false,
	              chartData: {
	                gsX: 0,
	                gsY: gsYMax+gsHeigthMax,
	                gsWidth: 4,
	                gsHeigth: 4,
	              }
	            });
	          }
	        }else{
	          if($scope.posts.length === 0){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	          }
	        }
	      }, function(){
	        if(boxMessage[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	        }
	      });
	    }else{
	      if(boxMessage[0]){
	        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	      }
	    }
	
	    var boxComment = $scope.role.template.data.filter(function(d){ return d.columnType === 'COMMENT'; });
	    if ($scope.role.showComment) {
	      CompanyCommentsService.queryComments({
	        companyId: $stateParams.companyId,
	        limit: 4
	      }, function(resp){
	        $scope.comments = resp;
	        if(!boxComment[0]){
	          if($scope.comments.length > 0){
	            $scope.role.template.data.push({
	              isChart: false,
	              centralInformation: false,
	              columnType: 'COMMENT',
	              isFullBox: false,
	              chartData: {
	                gsX: 0,
	                gsY: gsYMax+gsHeigthMax,
	                gsWidth: 4,
	                gsHeigth: 4,
	              }
	            });
	          }
	        }else{
	          if($scope.comments.length === 0){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	          }
	        }
	      }, function(){
	        if(boxComment[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	        }
	      });
	
	      $scope.$on('notification', function(e, data) {
	        if (data.type === 'COMMENT') {
	            var c = {
	              id: data.message.id,
	              text: data.message.text,
	              createdAt: (new Date()).toISOString(),
	              createdBy:      data.sourceUser,
	              objectRelative: data.publication
	            };
	            $scope.$apply(function(){
	              if(data.message.parentID === 'undefined'){
	                if ($scope.comments.length === 4) {
	                  $scope.comments.splice($scope.comments.length - 1, 1);
	                }
	                $scope.comments.unshift(c);
	              }else{
	                angular.forEach($scope.comments, function(item){
	                  if(item.id === data.message.parentID){
	                    if(!item.commentChild){
	                      item.commentChild = [];
	                    }
	                    item.commentChild.push(c);
	                  }
	                });
	              }
	            });
	        }
	      });
	    }else{
	      if(boxComment[0]){
	        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	      }
	    }
	      
	    var boxReminder = $scope.role.template.data.filter(function(d){ return d.columnType === 'REMINDER'; });
	    if ($scope.info.features.reminders && $scope.role.showReminder) {
	      CompanyTaskService.query({companyId: $stateParams.companyId, status: 'INCOMPLETE', limit: 4}).$promise.then(function(resp){
	        $scope.latestTasks = resp;
	        if(!boxReminder[0]){
	          if($scope.latestTasks.length > 0){
	            $scope.role.template.data.push({
	              isChart: false,
	              centralInformation: false,
	              columnType: 'REMINDER',
	              isFullBox: false,
	              chartData: {
	                gsX: 0,
	                gsY: gsYMax+gsHeigthMax,
	                gsWidth: 4,
	                gsHeigth: 4,
	              }
	            });
	            setTimeout(function(){
	              var grid = jQuery('.grid-stack').data('gridstack');
	              grid.addWidget(jQuery('.grid-stack-item:last-child'), 0, yMax+heigthMax, 4, 4, true);
	            }, 1000);
	          }
	        }else{
	          if($scope.latestTasks.length === 0){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	          }
	        }
	      }, function(){
	        if(boxReminder[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	        }
	      });
	    }else{
	      if(boxReminder[0]){
	        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	      }
	    }
	    
	    if($scope.role.template !==  null) {
	      $scope.userLinks = angular.isDefined(userInformation.features.userLinks) ? userInformation.features.userLinks : [];
	    }
	
	    $scope.checkColors = function(xAxesDisplay){
	      if($scope.role.template && $scope.role.template.id){
	        angular.forEach($scope.role.template.data, function(v, k){
	          if(v.isChart && v.chartData){
	            if(v.chartData.type === 'line-bar'){
	              $scope.role.template.data[k].options = {
	                legend: { 
	                  display: true , 
	                  position: 'bottom'
	                },
	                scales: {
	                  xAxes: [{
	                    ticks: {
	                      display: true
	                    }
	                  }],
	                  yAxes: []
	                }
	              };
	              
	              if(xAxesDisplay <= 483){
	                $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	              }else{
	                if(xAxesDisplay < 999){
	                  if(xAxesDisplay > 807){
	                    if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
	                      if(k === 0){
	                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                      }else{
	                        if($scope.role.template.id === '6'){
	                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                        }else{
	                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                        }
	                      }
	                    }else{
	                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                    }
	                  }else{
	                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                  }
	                }else{
	                  if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
	                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                  }
	                }
	              }
	            }else{
	              $scope.role.template.data[k].options = { 
	                legend: { 
	                  display: true, 
	                  position: 'bottom'
	                }
	              };
	              if(v.chartData.type === 'bar' || v.chartData.type === 'line'){
	                $scope.role.template.data[k].options = { 
	                  legend: { 
	                    display: true, 
	                    position: 'bottom'
	                  },
	                  scales: {
	                    xAxes: [{
	                      ticks: {
	                        display: true
	                      }
	                    }]
	                  } 
	                };
	                
	                if(xAxesDisplay <= 483){
	                  $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                }else{
	                  if(xAxesDisplay < 999){
	                    if(xAxesDisplay > 807){
	                      if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
	                        if(k === 0){
	                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                        }else{
	                          if($scope.role.template.id === '6'){
	                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                          }else{
	                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                          }
	                        }
	                      }else{
	                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                      }
	                    }else{
	                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                    }
	                  }else{
	                    if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
	                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                    }
	                  }
	                }
	              }
	            }
	            if(v.chartData.type !== 'doughnut' && v.chartData.type !== 'pie'){
	              $scope.role.template.data[k].datasetOverride = [];
	              angular.forEach(v.chartData.colors, function(value, key){
	                if(v.chartData.type === 'line-bar'){
	                  $scope.role.template.data[k].datasetOverride.push({
	                    yAxisID: 'y-axis-'+(key+1),
	                    borderWidth: key === 0 ? 2 : 1,
	                    backgroundColor: key === 0 ? 'transparent' : value,
	                    pointBackgroundColor: key === 0 ? 'transparent' : value,
	                    borderColor: value,
	                    pointBorderColor: value,
	                    type: key === 0 ? 'line' : 'bar'
	                  });
	                  $scope.role.template.data[k].options.scales.yAxes.push({
	                    id: 'y-axis-'+(key+1),
	                    display: true,
	                    position: key === 0 ? 'left' : 'right'
	                  });
	                }else{
	                  $scope.role.template.data[k].datasetOverride.push({
	                    borderWidth: v.chartData.type === 'line' ? 2 : 1,
	                    backgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
	                    pointBackgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
	                    borderColor: value,
	                    pointBorderColor: value
	                  });
	                }
	              });
	            }
	          }
	        });
	      }
	    };
	
	    var widthWindow = angular.element($window).width();
	    $scope.checkColors(widthWindow);
	    angular.element($window).on('resize', function () {
	      widthWindow = angular.element($window).width();
	      $scope.$apply(function(){
	        $scope.checkColors(widthWindow);
	      });
	    });
	
	    $scope.getBlogLastest = function(data){
	      if(data.columnType === 'BLOG' && (data.columnData.object || data.columnData.blogId)){
	        var index = $scope.role.template.data.indexOf(data);
	        CompanyPublicationService.getPostLastest({
	          companyId: $stateParams.companyId,
	          publicationId: (data.columnData.object ? data.columnData.object.id : data.columnData.blogId),
	          only: data.columnData.only,
	          limit: (data.columnData.showThreePosts ? 3 : 1)
	        }, function(resp){
	          $scope.role.template.data[index].blogLastest = resp;
	        });
	      }
	    };
	  }
	
	  $scope.showModalUserLink = function(link, index) {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyUserLinksCtrl',
	      templateUrl: 'partials/company/publications/lists/user-link.html',
	      show: true,
	      resolve: {
	        link: function() {
	          return link || false;
	        },
	        index: function() {
	          return (angular.isUndefined(index) ? -1 : index);
	        }
	      }
	    });
	  };
	}
	
	
	CompanyGuestPublicationsCtrl.resolve = {
	  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
	    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
	  }],
	  notices: ['CompanyService', function(CompanyService){
	    return CompanyService.queryNotices().$promise;
	  }]
	};
	
	module.exports = CompanyGuestPublicationsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationsCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    '$modal',
	    '$window',
	    'reloadUserRoleDashboard',
	    'userInformation',
	    'CompanyMessageService',
	    'CompanyCommentsService',
	    'CompanyTaskService',
	    'CompanyPublicationService',
	    'notices',
	    CompanyGuestPublicationsCtrl]);


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(9);
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(28);
	__webpack_require__(10);
	
	function CompanyGuestPublicationsDetailCtrl(
	  $scope,
	  publication,
	  files,
	  checklists,
	  uploadTracker,
	  translations,
	  $stateParams,
	  $state,
	  CompanyPublicationService,
	  CompanyPublicationFileService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.files = files;
	  $scope.checklists = checklists;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	      'content': '',
	      'template': 'partials/company-guest/publications/detail/latest.html',
	      'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	  $scope.uploadFilesForPublication = function(files, publicationId) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
	        file: f,
	      };
	    }));
	  };
	
	  $scope.onFileSelect = function($files) {
	    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id) {
	      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
	        publication.versionNumber += files.length;
	        $scope.$broadcast("files-uploaded");
	      });
	    } else {
	      growl.addErrorMessage(translations['publication.file-upload-locked']);
	      return false;
	    }
	  };
	
	  $scope.$on("files-uploaded", function() {
	    CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         1
	    }).$promise.then(function(files) {
	      $scope.files = files;
	      if ($scope.files[0]) {
	        $scope.$broadcast('fileProcessed', $scope.files[0]);
	        $scope.$emit('publicationSaved');
	      }
	    });
	  });
	}
	
	CompanyGuestPublicationsDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
	    return checklistService.query({
	      companyId: $stateParams.companyId,
	      relativeID: $stateParams.publicationId
	    }).$promise;
	  }],
	  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information',
	      'publication.file-upload-locked'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestPublicationsDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationsDetailCtrl', [
	  '$scope',
	  'publication',
	  'files',
	  'checklists',
	  'UploadTracker',
	  'translations',
	  '$stateParams',
	  '$state',
	  'CompanyPublicationService',
	  'CompanyPublicationFileService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestPublicationsDetailCtrl
	]);
	
	


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(282);
	
	function CompanyGuestPublicationsListCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  publications,
	  translations,
	  currentPortal
	) {
	  $scope.publications = publications;
	  $scope.$state = $state;
	  $scope.priorityId = $stateParams.priorityId || null;
	  $scope.more = false;
	  $scope.title = translations['all-cards'];
	  $scope.currentPortal = currentPortal;
	
	  $scope.removeCategoryFilter = function() {
	    $state.go($state.current.name, {categoryId: null});
	  };
	
	  if (!$stateParams.categoryId) {
	    $scope.activeCategory = null;
	  } else {
	    $scope.$parent.categories.forEach(function(c) {
	      if (c.id === $stateParams.categoryId) {
	        $scope.activeCategory = c.name;
	      }
	    });
	  }
	
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  if ($stateParams.groupId) {
	    $scope.title = currentPortal.name;
	  }
	
	  $scope.$on('$select.select', function(ev, priorityId) {
	    $scope.priorityId = priorityId;
	    if(!$scope.priorityId) {
	      $scope.priorityId = null;
	    }
	    var filter = {
	      priorityId: $scope.priorityId,
	      page: null
	    };
	    $state.go('root.company-guest.publications.list', filter);
	  });
	
	  $scope.page = parseInt($stateParams.page, 10) || 1;
	  $scope.companyId = $stateParams.companyId;
	
	}
	
	CompanyGuestPublicationsListCtrl.resolve = {
	  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    var companyId = $stateParams.companyId,
	    filter = {};
	
	    filter.companyId = companyId;
	    if('' !== $stateParams.q) {
	      filter.q     = $stateParams.q;
	      filter.qType = $stateParams.qType || "GENERAL";
	      if (filter.qType === "REFERENCE" || filter.qType === 'KEYPASS') {
	        if (filter.qType === 'REFERENCE') {
	          filter.reference = filter.q;
	        } else if (filter.qType === 'KEYPASS') {
	          filter.keypass = filter.q;
	          filter.type = 'KEYPASS';
	        }
	        filter.q = '';
	        filter.qType = '';
	      }
	    }
	    if('' !== $stateParams.categoryId) {
	      filter.categoryId = $stateParams.categoryId;
	    }
	    if('' !== $stateParams.priorityId) {
	      filter.priorityId = $stateParams.priorityId;
	    }
	    if('' !== $stateParams.tags) {
	      filter.tags = $stateParams.tags;
	    }
	    if('' !== $stateParams.groupId) {
	      filter.groupId = $stateParams.groupId;
	    }
	
	    // Fetch 21 for pagination, but the offset should be using 20
	    filter.limit = 21;
	    var page = parseInt($stateParams.page, 10) || 1;
	    filter.offset = (page - 1) * 20;
	
	    return CompanyPublicationService.query(filter).$promise;
	  }],
	  currentPortal: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
	    if ($stateParams.groupId) {
	      return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId, type: 'VISIBLE'}).$promise;
	    }
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'all-cards',
	      'customer-portal.template.default',
	      'customer-portal.template.my-page'
	    ]);
	  }]
	};
	module.exports = CompanyGuestPublicationsListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationsListCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    'publications',
	    'translations',
	    'currentPortal',
	    CompanyGuestPublicationsListCtrl
	  ]);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	function CompanyGuestPublicationsListStarredCtrl($scope, $stateParams, $state, publications, priorities, translations) {
	  var i;
	  $scope.publications = publications;
	  $scope.$state = $state;
	  $scope.priorityId = $stateParams.priorityId || null;
	  $scope.more = false;
	
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	
	  $scope.priorities = priorities;
	  $scope.priorities.unshift({
	    id: null,
	    name: translations['publication.all-status']
	  });
	
	   $scope.$on('$select.select', function(ev, priorityId) {
	    $scope.priorityId = priorityId;
	    if(!$scope.priorityId) {
	      $scope.priorityId = null;
	    }
	    var filter = {
	      priorityId: $scope.priorityId,
	      page: null
	    };
	    $state.go('root.company-guest.publications.listDrafts', filter);
	  });
	
	  priorities.$promise.then(function() {
	    for (i = 0; i < priorities.length; i++) {
	      $scope.priorities[priorities[i].id] = priorities[i];
	    }
	  });
	
	  $scope.page = parseInt($stateParams.page, 10) || 1;
	  $scope.companyId = $stateParams.companyId;
	}
	
	CompanyGuestPublicationsListStarredCtrl.resolve = {
	  publications: ['$stateParams', 'CurrentUserService', 'CompanyUserStarService', function($stateParams, CurrentUserService, CompanyUserStarService) {
	    return CurrentUserService.get().then(function(user) {
	      var companyId = $stateParams.companyId,
	      filter = {};
	
	      filter.companyId = companyId;
	      filter.userId = user.id;
	      // Fetch 21 for pagination, but the offset should be using 20
	      filter.limit = 21;
	      var page = parseInt($stateParams.page, 10) || 1;
	      filter.offset = (page - 1) * 20;
	
	      return CompanyUserStarService.query(filter).$promise;
	    });
	  }],
	  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate(['publication.all-status', 'publication.list-starred']);
	  }]
	};
	module.exports = CompanyGuestPublicationsListStarredCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestPublicationsListStarredCtrl', ['$scope', '$stateParams', '$state', 'publications', 'priorities', 'translations', CompanyGuestPublicationsListStarredCtrl]);


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(24);
	__webpack_require__(11);
	
	function CompanyGuestUsersListCtrl(
	  $scope,
	  company,
	  users,
	  translations,
	  $stateParams,
	  $translate,
	  CompanyUserService,
	  UserService,
	  growl,
	  $state,
	  usersInvited
	) {
	  $scope.company = company;
	  $scope.more = false;
	  $scope.page = parseInt($stateParams.page, 10) || 1;
	  $scope.filterType = $stateParams.type || '';
	  $scope.filterText = $stateParams.emailPrefix;
	  $scope.usersInvited = usersInvited;
	  $scope.users = users;
	
	
	  $scope.userTypes = [
	    {
	      label: translations['user.guest'],
	      value: 'GUEST'
	    },
	    {
	      label: translations['user.default'],
	      value: 'DEFAULT'
	    }
	  ];
	
	  if($scope.users.length === 21) {
	    $scope.more = true;
	    $scope.users.pop();
	  }
	
	  $scope.resend = function(user) {
	    user.company_id = $scope.company.id;
	    UserService.createInvite({code: user.code}, user).$promise.then(function() {
	      CompanyUserService.queryUsersInvited({companyId: $stateParams.companyId}, function(resp){
	        $scope.usersInvited = resp;
	      });
	      growl.addSuccessMessage($translate.instant('signup.invite-success', {email: user.email}));
	    });
	  };
	
	  $scope.removeInvited = function(user, index) {
	    CompanyUserService.removeInvited({
	      companyId: $stateParams.companyId,
	      email: user.email}).$promise.then(function(){
	        $scope.usersInvited.splice(index, 1);
	        growl.addSuccessMessage($translate.instant('user.remove-invited-success', {email: user.email}));
	      }, function(){
	        growl.addErrorMessage($translate.instant('user.remove-invited-failure', {email: user.email}));
	      });
	  };
	
	  $scope.upgradeUser = function(user) {
	    if ($scope.info.usage.users >= $scope.info.features.maxUsers) {
	      growl.addErrorMessage(translations['user.upgrade-failure']);
	    } else {
	      var data = angular.copy(user);
	
	      data.type = "DEFAULT";
	
	      return CompanyUserService.update({companyId: $stateParams.companyId, userId: data.id}, data).$promise.then(function() {
	        user.type = "DEFAULT";
	        $scope.$emit('companyInfoChanged');
	        growl.addSuccessMessage(translations['user.upgrade-success']);
	      }, function() {
	        growl.addErrorMessage(translations['user.upgrade-failure']);
	      });
	    }
	  };
	
	  $scope.search = function(text, type) {
	    $state.go(".", {
	      page:        null,
	      emailPrefix: text,
	      type:        type || null
	    });
	  };
	}
	
	CompanyGuestUsersListCtrl.resolve = {
	  users: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService) {
	    var companyId = $stateParams.companyId;
	    var page      = parseInt($stateParams.page, 10) || 1;
	    var filter    = {
	      companyId: companyId,
	      profileStatus: true,
	      // Fetch 21 for pagination, but the offset should be using 20
	      limit:     21,
	      offset:    (page - 1) * 20
	    };
	
	    if($stateParams.emailPrefix) {
	      filter.q = $stateParams.emailPrefix;
	    }
	    if($stateParams.type) {
	      filter.type = $stateParams.type;
	    }
	
	    return CompanyUserService.query(filter).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'user.remove-from-company-success',
	      'user.remove-from-company-failure',
	      'user.guest',
	      'user.default',
	      'user.upgrade-failure',
	      'user.upgrade-success',
	      'signup.invite-success'
	    ]);
	  }],
	  company: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.get({companyId: $stateParams.companyId});
	  }],
	  usersInvited: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService){
	    return CompanyUserService.queryUsersInvited({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	
	module.exports = CompanyGuestUsersListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestUsersListCtrl', [
	    '$scope',
	    'company',
	    'users',
	    'translations',
	    '$stateParams',
	    '$translate',
	    'CompanyUserService',
	    'UserService',
	    'growl',
	    '$state',
	    'usersInvited',
	    CompanyGuestUsersListCtrl
	  ]);


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(21);
	__webpack_require__(11);
	
	function CompanyGuestUsersProfileCtrl(
	  $scope,
	  user,
	  companyUserInfo,
	  $stateParams,
	  CompanyUserService,
	  UserAvatarService,
	  countryCode
	) {
	  $scope.user = user;
	  $scope.companyUserInfo = companyUserInfo;
	  $scope.profileType = $stateParams.type || null;
	  $scope.countryCode = countryCode;
	
	}
	
	CompanyGuestUsersProfileCtrl.resolve = {
	  user: ['$stateParams', 'UserService', function($stateParams, UserService) {
	    return UserService.get({userId: $stateParams.userId}).$promise;
	  }],
	  companyUserInfo: ['CompanyUserService', '$stateParams', function(CompanyUserService, $stateParams){
	    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $stateParams.userId}).$promise;
	  }],
	  countryCode: ['$http', function($http){
	    return $http.get('country-code/country-code.json').then(function(resp){
	      return resp.data;
	    });
	  }]
	};
	module.exports = CompanyGuestUsersProfileCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestUsersProfileCtrl', [
	    '$scope',
	    'user',
	    'companyUserInfo',
	    '$stateParams',
	    'CompanyUserService',
	    'UserAvatarService',
	    'countryCode',
	    CompanyGuestUsersProfileCtrl
	  ]);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(4);
	__webpack_require__(28);
	__webpack_require__(18);
	
	function CompanyGuestWallDetailCtrl(
	  $scope,
	  publication,
	  translations,
	  $stateParams,
	  CompanyPublicationService,
	  $sce,
	  config,
	  activityService
	) {
	  $scope.publication = publication;
	  $scope.translations = translations;
	  $scope.activityService = activityService;
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['publication.information']),
	      'content': '',
	      'template': 'partials/company-guest/wall/detail/latest.html',
	      'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	}
	
	CompanyGuestWallDetailCtrl.resolve = {
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.information'
	    ]);
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }]
	};
	module.exports = CompanyGuestWallDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyGuestWallDetailCtrl', [
	  '$scope',
	  'publication',
	  'translations',
	  '$stateParams',
	  'CompanyPublicationService',
	  '$sce',
	  'config',
	  'activityService',
	  CompanyGuestWallDetailCtrl
	]);
	
	


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	function AddressBookService($resource, config) {
	  return $resource(config.apiBase + '/addressbook/:id', { id: '@id' }, {
	    'query': {
	      method: 'GET',
	      isArray: true
	    },
	    'insert': {
	      method: 'POST',
	      transformResponse: [function(response, headers) {
	        return {
	          id: headers('Location').split('/').pop()
	        };
	      }]
	    },
	    'update': {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('AddressBookService', [
	    '$resource',
	    'config',
	    AddressBookService
	  ]);


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyAccountCtrl($scope, $stateParams) {
		$scope.stateParams = $stateParams;
	}
	
	angular.module('dokiv')
	  .controller('CompanyAccountCtrl', [
	  '$scope',
	  '$stateParams',
	  CompanyAccountCtrl
	]);


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(56);
	
	function CompanyAddressBookCtrl(
	  $scope,
	  $stateParams,
	  contacts,
	  growl,
	  translations,
	  CompanyAddressBookService
	) {
	  $scope.contacts = contacts;
	
	  $scope.addContact = function() {
	    $scope.newContact = {
	      "contactName":      "",
	      "contactEmail":     "",
	      "contactPhone":     "",
	      "contactWeb":      ""
	    };
	
	    $scope.contacts.unshift($scope.newContact);
	  };
	
	  $scope.saveContact = function(contact) {
	    if (contact.id) {
	      CompanyAddressBookService.update({companyId: $stateParams.companyId, contactId: contact.id}, contact);
	      growl.addSuccessMessage(translations['address-book.update-successful']);
	    } else {
	      CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function(resp) {
	        $scope.newContact = null;
	        contact.id = resp.id;
	        growl.addSuccessMessage(translations['address-book.insert-successful']);
	      });
	    }
	  };
	
	  $scope.removeContact = function(contact) {
	    if (contact.id) {
	      CompanyAddressBookService.delete({companyId: $stateParams.companyId, contactId: contact.id}).$promise.then(function() {
	        $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
	        growl.addSuccessMessage(translations['address-book.delete-successful']);
	      });
	    } else {
	      $scope.newContact = null;
	      $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
	    }
	  };
	}
	
	CompanyAddressBookCtrl.resolve = {
	  contacts: ['CompanyAddressBookService', '$stateParams', function(CompanyAddressBookService, $stateParams) {
	    return CompanyAddressBookService.query({companyId: $stateParams.companyId, all: true}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'address-book.insert-successful',
	      'address-book.update-successful',
	      'address-book.delete-successful'
	    ]);
	  }]
	};
	
	module.exports = CompanyAddressBookCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyAddressBookCtrl', [
	    '$scope',
	    '$stateParams',
	    'contacts',
	    'growl',
	    'translations',
	    'CompanyAddressBookService',
	    CompanyAddressBookCtrl
	  ]);


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyAdvancedSearchDirective.$inject = [
	  "$timeout",
	  "$stateParams",
	  "$state",
	  "$filter",
	  "$translate",
	  "$rootScope",
	  "CompanyInfoService",
	  "CurrentUserService"
	];
	function CompanyAdvancedSearchDirective(
	  $timeout,
	  $stateParams,
	  $state,
	  $filter,
	  $translate,
	  $rootScope,
	  CompanyInfoService,
	  CurrentUserService
	) {
	  return {
	    replace: true,
	    restrict: "AE",
	    scope: {
	      categories: "=asCategories",
	      customerPortals: "=asGroups",
	      types: "=asTypes",
	      priorities: "=asPriorities",
	      tags: "=asTags",
	      toggleMenuSearch: "=asToggle"
	    },
	    templateUrl: "partials/company/publications/advanced-search.html",
	    link: function($scope) {
	      $scope.params = $stateParams;
	      $scope.years = [];
	      for(var y=2010; y<2030; y++){
	        $scope.years.push(y.toString())
	      }
	
	      $scope.months = [];
	      for(var m=1; m<12; m++){
	        $scope.months.push(m.toString())
	      }
	
	      $scope.$on("advancedSearchSidebarToggle", function() {
	        $scope.advancedSearchSidebarOpen = !$scope.advancedSearchSidebarOpen;
	      });
	
	      $scope.toggleShowAll = function() {
	        $rootScope.toggleShowAllPublications = !$rootScope.toggleShowAllPublications;
	      }
	
	      $scope.publicationQuery = {
	        qType: "GENERAL",
	        tags: ""
	      };
	
	      if ($stateParams.openSearchSidebar) {
	        $scope.advancedSearchSidebarOpen = true;
	      }
	
	      if ($stateParams.tags) {
	        $scope.publicationQuery.tags = $stateParams.tags;
	      }
	
	      CompanyInfoService.get({
	        companyId: $stateParams.companyId
	      }).$promise.then(function(resp) {
	        $scope.info = resp;
	      });
	      CurrentUserService.getPermissions($stateParams.companyId).then(function(
	        resp
	      ) {
	        $scope.currentUserPermissions = resp;
	      });
	      $scope.publicationQuery.q = $stateParams.q;
	      $scope.selectedPublicationType = $stateParams.type || null;
	      $scope.selectedOrderBy = $stateParams.orderby || "created";
	      $scope.selectedYear = $stateParams.year || "";
	      $scope.selectedMonth = $stateParams.month || "";
	      $scope.publicationQuery.qType = $stateParams.qType || "GENERAL";
	      $scope.publicationQuery.qTypeObject = $state.params.qTypeObject || "OBJECT";
	      $scope.selectedPriority = null;
	      $scope.publicationQuery.type = $state.params.type;
	
	      if ($scope.publicationQuery.qT === "CUSTOMER") {
	        $scope.placeholderSearch = $translate.instant("search-customer");
	      } else {
	        if ($scope.publicationQuery.qT === "PRODUCT") {
	          $scope.placeholderSearch = $translate.instant("search-products");
	        } else {
	          if ($scope.publicationQuery.qT === "ARCHIVED") {
	            $scope.placeholderSearch = $translate.instant("search-archive");
	          } else {
	            $scope.placeholderSearch = $translate.instant("search-object");
	          }
	        }
	      }
	
	      var startDate = Date.parse($stateParams.from);
	      var endDate = Date.parse($stateParams.to);
	
	      $scope.filterDataSpan = {
	        from: startDate ? new Date(startDate) : null,
	        to: endDate ? new Date(endDate) : null
	      };
	
	      $scope.filterTags = $stateParams.tags;
	
	      for (var i = 0; i < $scope.categories.length; i++) {
	        if ($scope.categories[i].id === $stateParams.categoryId) {
	          $scope.selectedCategory = $scope.categories[i];
	        }
	      }
	
	      for (i = 0; i < $scope.customerPortals.length; i++) {
	        if ($scope.customerPortals[i].id === $stateParams.groupId) {
	          $scope.selectedCustomerPortal = $scope.customerPortals[i];
	        }
	      }
	
	      for (i = 0; i < $scope.priorities.length; i++) {
	        if ($scope.priorities[i].id === $stateParams.priorityId) {
	          $scope.selectedPriority = $scope.priorities[i];
	        }
	      }
	
	      $scope.$watch("toggleMenuSearch", function(toggle, oldToggle) {
	        if (toggle !== oldToggle) {
	          $scope.toggleMenuSearch = toggle;
	        }
	      });
	
	      var searchTimeout;
	      $scope.filterPublications = function() {
	        $rootScope.toggleShowAllPublications = false;
	        var q = angular.copy($scope.publicationQuery);
	        q.openSearchSidebar = null;
	
	        if ($scope.filterDataSpan.from !== "") {
	          q.from = $filter("date")($scope.filterDataSpan.from, "yyyy-MM-dd");
	        }
	
	        if ($scope.filterDataSpan.to !== "") {
	          q.to = $filter("date")($scope.filterDataSpan.to, "yyyy-MM-dd");
	        }
	
	        if ($scope.selectedYear !== "") {
	          q.year = $scope.selectedYear;
	        }
	        
	        if ($scope.selectedMonth !== "") {
	          q.month = $scope.selectedMonth;
	        }
	
	        if ($scope.publicationQuery.qTypeObject === "OBJECT") {
	          $state.go("root.company.publications-list", q);
	        } else {
	          q.companyId = $stateParams.companyId;
	          q.archived = $scope.filterText;
	          $state.go("root.company.publications-list", q);
	        }
	
	        $scope.advancedSearchSidebarOpen = false;
	      };
	
	      $scope.changeSelectedYear = function(year) {
	          $scope.selectedYear = year;
	      };
	
	      $scope.changeSelectedMonth = function(month) {
	          $scope.selectedMonth = month;
	      };
	
	      $scope.filterCategory = function(cat) {
	        $scope.publicationQuery.categoryId = cat.id;
	      };
	
	      $scope.filterCustomerPortal = function(portal) {
	        $scope.publicationQuery.groupId = portal.id;
	      };
	
	      $scope.filterPublicationType = function(pubType) {
	        $scope.publicationQuery.type = pubType;
	      };
	
	      $scope.filterDate = function(dataSpan) {
	        if (dataSpan.from !== '') {
	          $scope.publicationQuery.from = $filter('date')(dataSpan.from, "yyyy-MM-dd");
	        }
	        if (dataSpan.to !== '') {
	          $scope.publicationQuery.to = $filter('date')(dataSpan.to, "yyyy-MM-dd");
	        }
	      };
	
	      $scope.filterByCreatedOrUpdated = function(v) {
	        $scope.publicationQuery.orderby = v;
	      };
	
	      $scope.filterByqTypeObject = function(data) {
	        if (data === "CUSTOMER") {
	          $scope.placeholderSearch = $translate.instant("search-customer");
	        } else {
	          if (data === "PRODUCT") {
	            $scope.placeholderSearch = $translate.instant("search-products");
	          } else {
	            if (data === "ARCHIVED") {
	              $scope.placeholderSearch = $translate.instant("search-archive");
	            } else {
	              $scope.placeholderSearch = $translate.instant("search-object");
	            }
	          }
	        }
	        $scope.publicationQuery.qTypeObject = data;
	      };
	
	      $scope.filterByText = function(data) {
	        $scope.publicationQuery.q = data;
	      };
	
	      $scope.filterStatus = function(priority) {
	        $scope.publicationQuery.priorityId = priority.id;
	      };
	
	      $scope.filterTag = function(tag) {
	        if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
	          $scope.publicationQuery.tags.push(tag);
	        } else {
	          $scope.publicationQuery.tags.splice(
	            $scope.publicationQuery.tags.indexOf(tag),
	            1
	          );
	        }
	      };
	    }
	  };
	}
	
	angular
	  .module("dokiv")
	  .directive("companyAdvancedSearch", CompanyAdvancedSearchDirective);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(7);
	__webpack_require__(14);
	__webpack_require__(5);
	__webpack_require__(29);
	__webpack_require__(67);
	
	function CompanyDefaultGroupCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $sce,
	  members,
	  growl,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  translations,
	  publications,
	  CompanyPublicationService,
	  CompanyUserService,
	  CompanyUserPermissionService
	) {
	  $scope.members = members;
	  $scope.publications = publications;
	  $scope.users = [];
	  $scope.page = 1;
	  $scope.more = false;
	  if ($scope.publications.length === 21) {
	    $scope.more = true;
	  }
	  $scope.pageMember = 1;
	  $scope.moreMember = false;
	  if ($scope.members.length === 21) {
	    $scope.moreMember = true;
	  }
	
	  $scope.tabs = [
	    {
	      title: $sce.trustAsHtml(translations["members"]),
	      content: "",
	      template: "partials/company/settings/default-group/users.html",
	      icon: "users"
	    },
	    {
	      title: $sce.trustAsHtml(translations["customer-portals.documents"]),
	      content: "",
	      template: "partials/company/settings/default-group/documents.html",
	      icon: "files-o"
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	  $scope.addMember = function(user) {
	    CompanyUserPermissionService.update(
	      { companyId: $stateParams.companyId, userId: user.id },
	      { CompanyShowGrouplessPublications: true }
	    ).$promise.then(
	      function() {
	        $scope.members.push(user);
	        growl.addSuccessMessage(translations["settings.save-group-success"]);
	      },
	      function() {
	        growl.addErrorMessage(translations["settings.save-group-failure"]);
	      }
	    );
	  };
	
	  $scope.removeMember = function(user) {
	    CompanyUserPermissionService.update(
	      { companyId: $stateParams.companyId, userId: user.id },
	      { CompanyShowGrouplessPublications: false }
	    ).$promise.then(
	      function() {
	        $scope.members.splice($scope.members.indexOf(user), 1);
	        growl.addSuccessMessage(
	          translations["customer-portals.remove-member-success"]
	        );
	      },
	      function() {
	        growl.addErrorMessage(
	          translations["customer-portals.remove-member-failure"]
	        );
	      }
	    );
	  };
	
	  $scope.queryUsers = function(text) {
	    return CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      q: text,
	      limit: 100
	    }).$promise.then(function(u) {
	      $scope.users = u.filter(function(u) {
	        return !members.some(function(member) {
	          return member.id === u.id;
	        });
	      });
	    });
	  };
	
	  $scope.queryMembers = function(pageMember) {
	    $scope.pageMember = pageMember;
	    return CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      seeAllObjects: true,
	      limit: 21,
	      offset: ($scope.pageMember - 1) * 20
	    }).$promise.then(function(members) {
	      $scope.members = members;
	      if ($scope.members.length === 21) {
	        $scope.moreMember = true;
	      } else {
	        $scope.moreMember = false;
	      }
	    });
	  };
	
	  $scope.queryPublications = function(page) {
	    $scope.page = page;
	    return CompanyPublicationService.query({
	      companyId: $stateParams.companyId,
	      limit: 21,
	      offset: ($scope.page - 1) * 20
	    }).$promise.then(function(pulications) {
	      $scope.publications = pulications;
	      if ($scope.publications.length === 21) {
	        $scope.more = true;
	      } else {
	        $scope.more = false;
	      }
	    });
	  };
	}
	
	CompanyDefaultGroupCtrl.resolve = {
	  members: [
	    "$stateParams",
	    "CompanyUserService",
	    function($stateParams, CompanyUserService) {
	      return CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        seeAllObjects: true,
	        limit: 21
	      }).$promise;
	    }
	  ],
	  translations: [
	    "$translate",
	    function($translate) {
	      return $translate([
	        "customer-portals.add-member-success",
	        "customer-portals.add-member-failure",
	        "customer-portals.remove-member-success",
	        "customer-portals.remove-member-failure",
	        "settings.save-group-success",
	        "settings.save-group-failure",
	        "members",
	        "customer-portals.documents",
	        "publication.remove-success",
	        "publication.remove-failure"
	      ]);
	    }
	  ],
	  publications: [
	    "$stateParams",
	    "CompanyPublicationService",
	    function($stateParams, CompanyPublicationService) {
	      return CompanyPublicationService.query({
	        companyId: $stateParams.companyId,
	        limit: 21
	      }).$promise;
	    }
	  ]
	};
	
	module.exports = CompanyDefaultGroupCtrl;
	
	angular
	  .module("dokiv")
	  .controller("CompanyDefaultGroupCtrl", [
	    "$scope",
	    "$stateParams",
	    "$state",
	    "$sce",
	    "members",
	    "growl",
	    "CompanyGroupService",
	    "CompanyGroupUserService",
	    "translations",
	    "publications",
	    "CompanyPublicationService",
	    "CompanyUserService",
	    "CompanyUserPermissionService",
	    CompanyDefaultGroupCtrl
	  ]);


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(35);
	
	function CompanyLogoDirective(CompanyLogoService) {
	  return {
	    restrict: 'E',
	    scope: {
	      companyId: '&companyId'
	    },
	    link: function(scope, elem) {
	      CompanyLogoService.get({companyId: scope.companyId()}).$promise.then(function(logo) {
	        var $el = $('<img>');
	
	        $el.attr('src', logo.data);
	
	        elem.append($el);
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('companyLogo', ['CompanyLogoService', CompanyLogoDirective]);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(24);
	__webpack_require__(5);
	__webpack_require__(17);
	
	function CompanyMenuTopCtrl(
	  $scope,
	  $rootScope,
	  $state,
	  $stateParams,
	  $translate,
	  growl,
	  $document,
	  CompanyPublicationService,
	  CompanyInfoService,
	  info,
	  userRoles
	) {
	
	  $scope.info = info;
	  $scope.$on('companyInfoChanged', function(){
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise.then(function(resp){
	      $scope.info = resp;
	    });
	  });
	
	  $scope.userRoles = userRoles;
	  angular.forEach($scope.userRoles, function(v){
	    if (angular.isUndefined($scope.selectedUserrole)) {
	      if (v.template && (v.template.id === '1' || v.template.id === '2' || v.template.id === '5' || v.template.id === '6')) {
	        $scope.selectedUserrole = v.id;
	      }
	    }
	  });
	
	  $translate.onReady().then(function() {
	    $rootScope.$broadcast('$translateChangeSuccess');
	  });
	
	  $scope.newOrder = new CompanyPublicationService({
	    name:     "",
	    status:   "PUBLISHED",
	    type:     'COMPANY_ORDER',
	    tags:     [],
	    groups:   []
	  });
	
	  $scope.createOrder = function() {
	    $scope.newOrder.$save({
	      companyId: $stateParams.companyId
	    }, function(resp, headers){
	      var newId = headers('Location').split('/').pop();
	      window.location.href = '/order/'+$stateParams.companyId+'/detail/'+newId;
	      growl.addSuccessMessage($translate.instant('publication.create-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('publication.create-failure'));
	    });
	  };
	}
	
	CompanyMenuTopCtrl.resolve = {
	  userRoles: ['CompanyUserRoleService', '$stateParams', 'info', function(userRoleService, $stateParams, info) {
	    if(info.features.userRole){
	      return userRoleService.query({companyId: $stateParams.companyId, limit: 21, offset: 0}).$promise;
	    }
	    return false;
	  }]
	};
	
	module.exports = CompanyMenuTopCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyMenuTopCtrl', [
	    '$scope',
	    '$rootScope',
	    '$state',
	    '$stateParams',
	    '$translate',
	    'growl',
	    '$document',
	    'CompanyPublicationService',
	    'CompanyInfoService',
	    'info',
	    'userRoles',
	    CompanyMenuTopCtrl
	  ]);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MAX_NOTIFICATIONS = 50;
	
	__webpack_require__(35);
	__webpack_require__(24);
	__webpack_require__(13);
	__webpack_require__(7);
	__webpack_require__(4);
	
	function CompanyNavCtrl(
	  $scope,
	  $rootScope,
	  $state,
	  $stateParams,
	  $timeout,
	  $window,
	  $translate,
	  logo,
	  info,
	  categories,
	  customerPortals,
	  tags,
	  config,
	  priorities,
	  currentUser,
	  publicationTypes,
	  currentUserPermissions,
	  CompanyNotificationsService,
	  userInformation
	) {
	  var searchTimeout;
	  $scope.currentUserPermissions = currentUserPermissions;
	  $scope.logo = logo;
	  $scope.info = info;
	  $scope.userInfo = userInformation;
	  $scope.categories = categories;
	  $scope.customerPortals = customerPortals;
	  $scope.tags = tags;
	  $scope.priorities = priorities;
	  $scope.portalUrl = config.portalUrl
	  priorities.$promise.then(function () {
	    for (var i = 0; i < priorities.length; i++) {
	      if (priorities[i].id === $scope.priorityId) {
	        $scope.selectedPriority = priorities[i];
	      }
	      $scope.priorities[priorities[i].id] = priorities[i];
	    }
	  });
	  $scope.types = publicationTypes;
	  $scope.showAll = $stateParams.showAll || false;
	
	  function loadData(offset){
	    CompanyNotificationsService.queryNotificationsUser({userId: currentUser.id, offset: offset, limit: MAX_NOTIFICATIONS}, function(notificationsObject){
	      if(offset === 0){
	        $rootScope.notifications = notificationsObject.notifications;
	      }else{
	        $rootScope.notifications = $rootScope.notifications.concat(notificationsObject.notifications);
	      }
	      $rootScope.notificationsUnread = notificationsObject.unView;
	    });
	  }
	
	  loadData(0);
	
	  $scope.$on('notification', function() {
	    $scope.$apply(function() {
	      $rootScope.notificationLimit = MAX_NOTIFICATIONS;
	      loadData(0);
	    });
	  });
	
	  $scope.$on('eventReadNotification', function() {
	    $scope.$apply(function() {
	      $rootScope.notificationsUnread = 0;
	      angular.forEach($rootScope.notifications, function(notification){
	        notification.viewed = true;
	      });
	    });
	  });
	
	  $scope.closeNotifications = function() {
	    if (!$scope.preventBlur) {
	      $scope.notificationsOpen = false;
	    }
	
	    $scope.preventBlur = false;
	  };
	
	  $rootScope.notificationLimit = MAX_NOTIFICATIONS;
	  $scope.toggleNotificationsOpen = function(preventBlur) {
	    $scope.notificationsOpen = $scope.notificationsOpen ? false : true;
	
	    if (preventBlur) {
	      $scope.preventBlur = true;
	    }
	
	    setTimeout(function(){
	      if($rootScope.notificationsUnread > 0){
	        CompanyNotificationsService.update({companyId: $stateParams.companyId}, {}, function(){
	          $rootScope.notificationsUnread = 0;
	          angular.forEach($rootScope.notifications, function(notification){
	            notification.viewed = true;
	          });
	        });
	      }
	    }, 5000);
	  };
	
	  $scope.loadMoreNotifications = function() {
	    loadData($rootScope.notificationLimit + 1);
	    $rootScope.notificationLimit = $rootScope.notificationLimit + MAX_NOTIFICATIONS;
	  };
	
	  $scope.toggleSidebarAdvancedSearch = function() {
	    if($state.current.name !== 'root.company.publications-list'){
	      $state.go('root.company.publications-list', {showAll: true});
	    }
	    $rootScope.$broadcast('advancedSearchSidebarToggle');
	  };
	
	  $scope.toggleMenuTop = function() {
	    if($state.current.name === 'root.company.menu'){
	      window.history.back();
	    }else{
	      $state.go('root.company.menu');
	    }
	  };
	
	  function getCompanyById(companies, companyId) {
	    var ret = false;
	
	    companies.forEach(function(c) {
	      if(c.id === companyId) {
	        ret = c;
	      }
	    });
	
	    return ret;
	  }
	
	  $scope.currentCompany = getCompanyById($scope.companies, $stateParams.companyId);
	
	  $scope.filter = {
	    q:     $state.params.q || null,
	    qType: $state.params.qType || "GENERAL",
	    qTypeObject: $state.params.qTypeObject || "OBJECT",
	    page:  null
	  };
	
	  $scope.$on('$stateChangeSuccess', function() {
	    if(!searchTimeout) {
	      $scope.filter.q     = $state.params.q;
	      $scope.filter.qType = $state.params.qType || "GENERAL";
	      $scope.filter.qTypeObject = $state.params.qTypeObject || "OBJECT";
	    }
	  });
	
	  if($scope.filter.qTypeObject === 'CUSTOMER'){
	    $scope.placeholderSearch = $translate.instant('search-customer');
	  }else{
	    if($scope.filter.qTypeObject === 'PRODUCT'){
	      $scope.placeholderSearch = $translate.instant('search-products');
	    }else{
	      if($scope.filter.qTypeObject === 'ARCHIVED'){
	        $scope.placeholderSearch = $translate.instant('search-archive');
	      }else{
	        $scope.placeholderSearch = $translate.instant('search-object');
	      }
	    }
	  }
	
	  $scope.$watchCollection("[filter.q, filter.qType, filter.qTypeObject]", function(newValues, oldValues) {
	    var newQ = newValues[0] || "";
	    var oldQ = oldValues[0] || "";
	
	    if($scope.filter.qTypeObject === 'CUSTOMER'){
	      $scope.placeholderSearch = $translate.instant('search-customer');
	    }else{
	      if($scope.filter.qTypeObject === 'PRODUCT'){
	        $scope.placeholderSearch = $translate.instant('search-products');
	      }else{
	        if($scope.filter.qTypeObject === 'ARCHIVED'){
	          $scope.placeholderSearch = $translate.instant('search-archive');
	        }else{
	          $scope.placeholderSearch = $translate.instant('search-object');
	        }
	      }
	    }
	
	    /* If we have a string and a change, it is either q or qType.
	       If we do not have a string but the string is changed, then user might want
	       unfiltered list */
	    if(newQ.trim().length > 0 || newQ !== oldQ) {
	      if(searchTimeout){
	        $timeout.cancel(searchTimeout);
	
	        searchTimeout = null;
	      }
	
	      searchTimeout = $timeout(function () {
	        if (angular.isDefined(newValues[0])) {
	          if($scope.filter.qTypeObject === 'OBJECT'){
	            $state.go('root.company.publications-list', $scope.filter);
	          }else{
	            if($scope.filter.qTypeObject === 'ARCHIVED'){
	              $scope.filter.companyId = $stateParams.companyId;
	              $scope.filter.queryArchived = $scope.filter.q;
	              $state.go('root.company.publications-listArchived', $scope.filter);
	            }
	          }
	
	          searchTimeout = null;
	        }
	      }, 300);
	    }
	  });
	  
	  if($scope.filter.q){
	    setTimeout(function(){
	      $scope.searchObjectsFocus(true);
	    }, 50);
	  }
	
	  $scope.searchObjectsFocus = function(publicationSearchFocus){
	    if(publicationSearchFocus){
	      var widthWindowH = angular.element($window).width();
	      if(widthWindowH > 807){
	        var widthLogo = 253;
	        if(widthWindowH < 999){
	          widthLogo = 151;
	        }
	        angular.element('.header__nav').css('width', (widthWindowH-widthLogo)+'px');
	        angular.element('.header__nav .header__search').css('width', (widthWindowH-widthLogo-59)+'px');
	      }
	    }else{
	      angular.element('.header__nav').css('width', 'inherit');
	      angular.element('.header__nav .header__search').css('width', 'inherit');
	    }
	  };
	}
	
	CompanyNavCtrl.resolve = {
	  logo: ['$stateParams', 'CompanyLogoService', function($stateParams, CompanyLogoService) {
	    return CompanyLogoService.get({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	module.exports = CompanyNavCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyNavCtrl', [
	    '$scope',
	    '$rootScope',
	    '$state',
	    '$stateParams',
	    '$timeout',
	    '$window',
	    '$translate',
	    'logo',
	    'info',
	    'categories',
	    'customerPortals',
	    'tags',
	    'config',
	    'priorities',
	    'currentUser',
	    'publicationTypes',
	    'currentUserPermissions',
	    'CompanyNotificationsService',
	    'userInformation',
	    CompanyNavCtrl
	  ]);


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyQueriesService(
	  $stateParams,
	  CompanyPublicationService,
	  CompanyUserService) {
	  return {
	    queryPublications: function(text, publications) {
	      var filter = {
	        companyId: $stateParams.companyId,
	        q:         text,
	        limit:     10
	      };
	
	      return CompanyPublicationService.query(filter).$promise.then(function(p) {
	        return p.filter(function(p) {
	          return !publications.some(function(publication) {
	            return publication.id === p.id;
	          });
	        });
	      });
	    },
	    queryUsers: function(text, members) {
	      return CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        q: text,
	        limit: 10
	      }).$promise.then(function(u){
	        return u.filter(function(u){
	          return !members.some(function(member){
	            return member.id === u.id;
	          });
	        });
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .factory('CompanyQueriesService', [
	    '$stateParams',
	    'CompanyPublicationService',
	    'CompanyUserService',
	    CompanyQueriesService
	  ]);
	
	


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(7);
	__webpack_require__(14);
	__webpack_require__(5);
	__webpack_require__(29);
	__webpack_require__(46);
	
	
	function CompanySettingsClassesCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $sce,
	  members,
	  group,
	  growl,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  translations,
	  publications,
	  CompanyPublicationService
	) {
	  $scope.members = members;
	  $scope.group = group;
	  $scope.publications = publications;
	  $scope.newPublication = {};
	
	  $scope.page = 0;
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml(translations['members']),
	      'content': '',
	      'template': 'partials/company/settings/classes/users.html',
	      'icon': 'users'
	    },
	    {
	      'title': $sce.trustAsHtml(translations['customer-portals.documents']),
	      'content': '',
	      'template': 'partials/company/settings/classes/documents.html',
	      'icon': 'files-o'
	    }
	  ];
	
	  $scope.tabs.activeTab = 0;
	
	  $scope.removeMember = function(userId) {
	    CompanyGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.groupId, userId: userId}, function() {
	      $scope.members = $scope.members.filter(function(item) {
	        return item.id !== userId;
	      });
	
	      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
	    });
	  };
	
	  $scope.removePublication = function(publication) {
	    if (publication.groups.indexOf($scope.group.id) > -1) {
	      publication.groups.splice(publication.groups.indexOf($scope.group.id), 1);
	    }
	    CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
	      growl.addSuccessMessage(translations['publication.remove-success']);
	      $scope.publications.splice($scope.publications.indexOf(publication), 1);
	    }, function() {
	      growl.addErrorMessage(translations['publication.remove-failure']);
	    });
	  };
	
	  $scope.updateGroup = function() {
	    $scope.group.$update({
	      companyId: $stateParams.companyId,
	      groupId: $scope.group.id
	    }, function(){
	      angular.element('#filterRole').val('');
	      growl.addSuccessMessage(translations['settings.save-group-success']);
	    }, function(){
	      growl.addErrorMessage(translations['settings.save-group-failure']);
	    });
	  };
	
	  $scope.queryPublications = function(page){
	    $scope.page = page;
	    CompanyPublicationService.query({
	      companyId: $stateParams.companyId, 
	      groupId: $stateParams.groupId,
	      limit: 21,
	      offset: (page*20)
	    }).$promise.then(function(publications){
	      $scope.publications = publications;
	      if($scope.publications.length === 21) {
	        $scope.more = true;
	        $scope.publications.pop();
	      }else{
	        $scope.more = false;
	      }
	    });
	  };
	}
	
	CompanySettingsClassesCtrl.resolve = {
	  group: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
	    return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}).$promise;
	  }],
	  members: ['$stateParams', 'CompanyGroupUserService', function($stateParams, CompanyGroupUserService) {
	    return CompanyGroupUserService.query({
	      companyId: $stateParams.companyId,
	      groupId: $stateParams.groupId,
	      limit: 200}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'customer-portals.add-member-success',
	      'customer-portals.add-member-failure',
	      'customer-portals.remove-member-success',
	      'customer-portals.remove-member-failure',
	      'settings.save-group-success',
	      'settings.save-group-failure',
	      'members',
	      'customer-portals.documents',
	      'publication.remove-success',
	      'publication.remove-failure'
	    ]);
	  }],
	  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({
	      companyId: $stateParams.companyId, 
	      groupId: $stateParams.groupId,
	      limit: 21
	    }).$promise;
	  }]
	};
	
	module.exports = CompanySettingsClassesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingsClassesCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    '$sce',
	    'members',
	    'group',
	    'growl',
	    'CompanyGroupService',
	    'CompanyGroupUserService',
	    'translations',
	    'publications',
	    'CompanyPublicationService',
	    CompanySettingsClassesCtrl
	  ]);


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanySettingsCtrl(
	  $scope,
	  translations,
	  $q
	) {
	   $scope.translations = translations;
	
	   $scope.createQ = function(func) {
	    var d = $q.defer();
	    func(d.resolve.bind(d), d.reject.bind(d));
	    return d.promise;
	  };
	}
	
	CompanySettingsCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings',
	      'settings.statuses',
	      'settings.classes',
	      'categories'
	    ]);
	  }]
	};
	module.exports = CompanySettingsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingsCtrl', [
	  '$scope',
	  'translations',
	  '$q',
	  CompanySettingsCtrl
	]);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyDetailCtrl(
	  $scope,
	  translations,
	  company,
	  info,
	  $stateParams,
	  $translate
	) {
	  $scope.company = company;
	  $scope.info = info;
	
	  $scope.availableLanguages = [
	    { value: "en", label: "English" },
	    { value: "se", label: "Svenska" }
	  ];
	
	  $scope.publicationTypesToLower = [];
	  angular.forEach($scope.types, function(v){
	    $scope.publicationTypesToLower.push(v.toLowerCase());
	    if (!$scope.info.features.publicationNr.hasOwnProperty(v.toLowerCase())) {
	      $scope.info.features.publicationNr[v.toLowerCase()] = 0;
	    }
	  });
	
	  $scope.switchLanguage = function(langKey) {
	    $translate.use(langKey);
	  };
	}
	
	CompanyDetailCtrl.resolve = {
	  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService) {
	    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'company.information'
	    ]);
	  }]
	};
	
	module.exports = CompanyDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyDetailCtrl', [
	  '$scope',
	  'translations',
	  'company',
	  'info',
	  '$stateParams',
	  '$translate',
	  CompanyDetailCtrl
	]);


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyEmbedCtrl($scope, $window) {
	
	  $scope.embedOptions = {
	    imageSizes: ['16', '32', '64', '128', '256'],
	    textColors: {
	      black: {
	        name: 'Black',
	        value: '#333'
	      },
	      white: {
	        name: 'White',
	        value: '#fff'
	      }
	    }
	  };
	
	  $scope.embed = {
	    imageSize: 32,
	    textColor: $scope.embedOptions.textColors.black.value,
	    fontSize: 16
	  };
	
	  $scope.selectAllText = function() {
	    /* global Range */
	    var range     = new Range(),
	        selection = $window.getSelection();
	
	    range.selectNodeContents(event.target);
	    selection.addRange(range);
	  };
	}
	
	angular.module('dokiv')
	  .controller('CompanyEmbedCtrl', ['$scope', '$window', CompanyEmbedCtrl]);


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(36);
	
	CompanyFlowVerifyDetailCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$translate',
	  'CompanyUserService',
	  'CompanyFlowVerifiesService',
	  'flowVerifies',
	  'flowVerify',
	  'growl'];
	function CompanyFlowVerifyDetailCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $translate,
	  CompanyUserService,
	  CompanyFlowVerifiesService,
	  flowVerifies,
	  flowVerify,
	  growl) {
	
	    var nonWatchersPromise;
	    $scope.nonWatchers = [];
	    $scope.flowVerify = flowVerify;
	    $scope.flowVerifies = flowVerifies;
	
	    $scope.updateNonWatchers = function(filter) {
	      var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	        return users.filter(function(item) {
	          return !$scope.flowVerify.watchers.some(function(watcher) {
	            return item.id === watcher.id;
	          });
	        });
	      }).then(function(nonWatchers) {
	        if(nonWatchersPromise === p) {
	          $scope.nonWatchers = nonWatchers;
	        }
	      });
	      nonWatchersPromise = p;
	    };
	
	    $scope.addWatcher = function(watcher) {
	      $scope.flowVerify.watchers.push(watcher);
	      angular.element('#filterWatchers').val('');
	      $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
	    };
	
	    $scope.deleteWatcher = function(watcher) {
	      $scope.flowVerify.watchers.splice($scope.flowVerify.watchers.indexOf(watcher), 1);
	    };
	
	    $scope.updateFlowVerify = function() {
	      CompanyFlowVerifiesService.update({companyId: $stateParams.companyId, flowVerifyID: $scope.flowVerify.id}, $scope.flowVerify, function(){
	        growl.addSuccessMessage($translate.instant('flow.update-flow-success'));
	      }, function(){
	        growl.addErrorMessage($translate.instant('flow.update-flow-failure'));
	      });
	    };
	}
	
	CompanyFlowVerifyDetailCtrl.resolve = {
	  flowVerify: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
	    return CompanyFlowVerifiesService.get({
	      companyId: $stateParams.companyId,
	      flowVerifyID: $stateParams.flowVerifyID
	    }).$promise;
	  }],
	  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
	    return CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	
	module.exports = CompanyFlowVerifyDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyFlowVerifyDetailCtrl', CompanyFlowVerifyDetailCtrl);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	__webpack_require__(36);
	
	function CompanyTagSuggestionCtrl($scope,
	  $stateParams,
	  growl,
	  $http,
	  $translate,
	  tagSuggestions,
	  flowVerifies,
	  uploadTracker,
	  config,
	  CompanyUserService,
	  CompanyFlowVerifiesService,
	  CompanyService) {
	
	  var nonWatchersPromise;
	  $scope.tagSuggestions = tagSuggestions;
	  $scope.flowVerifies = flowVerifies;
	  $scope.nonWatchers = [];
	  var DEFAULT_FLOWVERIFY = {
	    name: '',
	    watchers: [],
	    type: 'MULTI'
	  };
	  $scope.flowVerifyNew = new CompanyFlowVerifiesService(angular.copy(DEFAULT_FLOWVERIFY));
	  $scope.newTime = new Date().getTime();
	  $scope.urlBases = [$scope.types.length];
	  $scope.urlBase = config.apiBase + "/files/" + $stateParams.companyId + "_pub_";
	  angular.forEach($scope.types, function(value, key){
	    if(($scope.info.features.publicationTypes.indexOf(value) !== -1) && (value === 'DEFAULT' || value === 'ALBUM' || value === 'FOLDER' || value === 'NOTE' || value === 'FORM' || value === 'PUBLICATION_GROUP')){
	      $scope.urlBases[key] = true;
	      $http({
	        method: 'GET',
	        url: config.apiBase + "/files/" + $stateParams.companyId + "_pub_" + value.toLowerCase()
	      }).then(function(response){
	        if (response.status === 200) {
	          $scope.urlBases[key] = true;
	        }else{
	          $scope.urlBases[key] = false;
	        }
	      });
	    }else{
	      $scope.urlBases[key] = false;
	    }
	  });
	
	  $scope.saveTagSuggestions = function() {
	    CompanyService.updateTagSuggestions({companyId: $stateParams.companyId}, $scope.tagSuggestions.map(function(item) {
	      return item;
	    }));
	  };
	
	
	  $scope.removeTagSuggestion = function(tag) {
	    $scope.tagSuggestions.splice(tagSuggestions.indexOf(tag), 1);
	
	    return $scope.saveTagSuggestions();
	  };
	
	  $scope.addTagSuggestion = function(tag) {
	    if($scope.tagSuggestions.indexOf(tag) === -1) {
	      $scope.tagSuggestions.push(tag);
	
	      angular.element('#smartphoneTags').val('');
	
	      return $scope.saveTagSuggestions();
	    }
	  };
	
	  $scope.addedTags = function(item) {
	    return $scope.tagSuggestions.indexOf(item) === -1;
	  };
	
	  $scope.updateNonWatchers = function(filter) {
	    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !$scope.flowVerifyNew.watchers.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    nonWatchersPromise = p;
	  };
	
	  $scope.addWatcher = function(watcher) {
	    $scope.flowVerifyNew.watchers.push(watcher);
	    angular.element('#filterWatchers').val('');
	    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
	  };
	
	  $scope.deleteWatcher = function(watcher) {
	    $scope.flowVerifyNew.watchers.splice($scope.flowVerifyNew.watchers.indexOf(watcher), 1);
	  };
	
	  $scope.addFlow = function(){
	    $scope.flowVerifyNew.$save({companyId: $stateParams.companyId}, function(res){
	      growl.addSuccessMessage($translate.instant('flow.add-flow-success'));
	      $scope.flowVerifies.push(res);
	      $scope.flowVerifyNew = new CompanyFlowVerifiesService(angular.copy(DEFAULT_FLOWVERIFY));
	    }, function(){
	      growl.addErrorMessage($translate.instant('flow.add-flow-failure'));
	    });
	  };
	
	  $scope.deleteFlowVerify = function(flowVerify){
	    $scope.flowVerifyNew.$delete({companyId: $stateParams.companyId, flowVerifyID: flowVerify.id}, function(){
	      growl.addSuccessMessage($translate.instant('flow.delete-flow-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('flow.delete-flow-failure'));
	    });
	    $scope.flowVerifies.splice($scope.flowVerifies.indexOf(flowVerify), 1);
	  };
	
	  $scope.uploadBackgroundForPublication = function(files, publicationType) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/background-images?type=" + publicationType.toLowerCase(),
	        file: f,
	      };
	    }));
	  };
	
	  $scope.onFileSelect = function($files, publicationType) {
	    $scope.uploadBackgroundForPublication($files, publicationType).then(function(){
	      $scope.newTime = new Date().getTime();
	      $scope.urlBases[$scope.types.indexOf(publicationType)] = true;
	    });
	  };
	
	  $scope.removeBackgroundForPublication = function(type){
	    $http({
	      method: 'DELETE',
	      url: config.apiBase + "/files/" + $stateParams.companyId + "_pub_" + type.toLowerCase()
	    })
	    .success(function() {
	      $scope.urlBases[$scope.types.indexOf(type)] = false;
	      growl.addSuccessMessage($translate.instant('product.delete-image-success'));
	    })
	    .error(function() {
	      growl.addErrorMessage($translate.instant('product.delete-image-failure'));
	    });
	  };
	}
	
	CompanyTagSuggestionCtrl.resolve = {
	  tagSuggestions: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryTagSuggestions({companyId: $stateParams.companyId}).$promise;
	  }],
	  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
	    return CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	
	module.exports = CompanyTagSuggestionCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyTagSuggestionCtrl', [
	  '$scope',
	  '$stateParams',
	  'growl',
	  '$http',
	  '$translate',
	  'tagSuggestions',
	  'flowVerifies',
	  'UploadTracker',
	  'config',
	  'CompanyUserService',
	  'CompanyFlowVerifiesService',
	  'CompanyService',
	  CompanyTagSuggestionCtrl
	]);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(10);
	
	CompanyChecklistCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'checklists'
	];
	function CompanyChecklistCtrl(
	  $scope,
	  $stateParams,
	  checklists
	) {
	  $scope.checklists = checklists;
	}
	
	CompanyChecklistCtrl.resolve = {
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, CompanyChecklistService){
	    return CompanyChecklistService.query({
	      companyId: $stateParams.companyId,
	      relativeID: $stateParams.companyId,
	      limit: 1000
	    });
	  }]
	};
	
	module.exports = CompanyChecklistCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyChecklistCtrl', CompanyChecklistCtrl);

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyActivitiesCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  'CompanyFeedService',
	  'CompanyService'];
	function CompanyActivitiesCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  CompanyFeedService,
	  CompanyService) {
	  $scope.feedLoading = false;
	
	  $scope.$on('notification', function() {
	    $scope.feedPage = 0;
	    $scope.loadMoreFeed(true);
	  });
	
	  $scope.feedPage = 0;
	  $scope.feed = [];
	  $scope.loadMoreFeed = function(init) {
	    if (!init) {
	      $scope.feedPage += 1;
	    }
	    $scope.feedLoading = true;
	    CompanyService.queryFeed({
	      companyId: $stateParams.companyId,
	      limit: 21,
	      offset: 20 * $scope.feedPage
	    }).$promise.then(function(resp){
	      $scope.feedLoading = false;
	      if (resp.length === 21) {
	        $scope.feedHasMore = true;
	        resp = resp.slice(0, 20);
	      } else {
	        $scope.feedHasMore = false;
	      }
	      resp = resp.map(function(v){
	        return CompanyFeedService.feedTranslator(v, $scope.currentCompany.userType);
	      });
	      angular.forEach(resp, function(value, key){
	        if(value && resp[key+1]){
	          if(value.feed.performedBy === null){
	            value.feed.avatar = {name: 'B O T'};
	          }else{
	            value.feed.avatar = value.feed.performedBy;
	          }
	          
	          if((value.feed.action !== resp[key+1].feed.action && value.feed.performedBy !== resp[key+1].feed.performedBy) || value.feed.extra.objectType === 'CHECKLIST'){
	            value.isShow = true;
	          }else{
	            var firstDatetime   = new Date(value.feed.performedAt);
	            var lastDatetime   = new Date(resp[key+1].feed.performedAt);
	            var timeDiff = Math.abs(firstDatetime.getTime() - lastDatetime.getTime())/(1000 * 60);
	            if(timeDiff>1){
	              var MinutesDiff = Math.abs(firstDatetime.getMinutes() - lastDatetime.getMinutes());
	              if(MinutesDiff>1){
	                value.isShow = true;
	              }
	            }
	          }
	        }
	      });
	      if (init) {
	        $scope.feed = resp;
	      } else {
	        $scope.feed  = $scope.feed.concat(resp);
	      }
	    });
	  };
	
	  $scope.loadMoreFeed(true);
	}
	
	angular.module("dokiv")
	  .controller("CompanyActivitiesCtrl", CompanyActivitiesCtrl);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(19);
	__webpack_require__(38);
	__webpack_require__(58);
	__webpack_require__(25);
	__webpack_require__(37);
	
	
	CompanyCommentsCtrl.$inject = [
	  '$scope',
	  'activities'];
	function CompanyCommentsCtrl(
	  $scope,
	  activities) {
	  $scope.activities= activities;
	}
	
	CompanyCommentsCtrl.resolve = {
	  activities: ['$stateParams', 'CompanyFeedActivity', 'info', function($stateParams, CompanyFeedActivity, info) {
	    return new CompanyFeedActivity($stateParams.companyId, info.features.blogs);
	  }]
	};
	
	module.exports = CompanyCommentsCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyCommentsCtrl", CompanyCommentsCtrl);


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	
	function CompanyFeedActivityTranslator() {
	  var types = {
	    MESSAGE: function(f) {
	      return {
	        text: f.content,
	        createdAt:  f.createdAt,
	        type:       "message",
	        user:       f.createdBy,
	        object: {
	          id: f.id,
	          name: f.title,
	          type: 'MESSAGE'
	
	        },
	        groups: f.groups,
	        id: f.id,
	        extra: f.extra
	      };
	    },
	    COMMENT: function(c) {
	      return {
	        text: c.text,
	        createdAt: c.createdAt,
	        type:      "comment",
	        user:      c.createdBy,
	        object: c.objectRelative
	      };
	    }
	  };
	
	  return function(item) {
	    if(types.hasOwnProperty(item.activityType)) {
	      return types[item.activityType](item);
	    }
	    return false;
	  };
	}
	
	angular.module("dokiv")
	  .factory("CompanyFeedActivityTranslator", [CompanyFeedActivityTranslator]);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	"use strict";
	
	var MAX_NOTIFICATIONS = 50;
	
	CompanyNotificationsCtrl.$inject = [
	  '$rootScope',
	  '$scope',
	  '$stateParams',
	  'CompanyNotificationsService'];
	function CompanyNotificationsCtrl(
	  $rootScope,
	  $scope,
	  $stateParams,
	  CompanyNotificationsService) {
	  
	  setTimeout(function(){
	    if($rootScope.notificationsUnread > 0){
	      CompanyNotificationsService.update({companyId: $stateParams.companyId}, {}, function(){
	        $rootScope.notificationsUnread = 0;
	        angular.forEach($rootScope.notifications, function(notification){
	          notification.viewed = true;
	        });
	      });
	    }
	  }, 5000);
	
	  $rootScope.notificationLimit = MAX_NOTIFICATIONS;
	}
	
	angular.module("dokiv")
	  .controller("CompanyNotificationsCtrl", CompanyNotificationsCtrl);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(327);
	
	var LIMIT = 20;
	
	CompanyShareLinksCtrl.$inject = [
	  '$scope',
	  '$state',
	  '$stateParams',
	  'config',
	  'growl',
	  'translations',
	  'currentUser',
	  'shareLinks'];
	function CompanyShareLinksCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  config,
	  growl,
	  translations,
	  currentUser,
	  shareLinks) {
	  $scope.shareLinks= shareLinks;
	  $scope.currentUser = currentUser;
	  $scope.shareURLBase  = config.shareURLBase;
	  $scope.apiBase  = config.apiBase;
	  $scope.page = $stateParams.page|0;
	  if ($scope.shareLinks.length === (LIMIT + 1)) {
	    $scope.more = true;
	    $scope.shareLinks.pop();
	  }
	  $scope.filter = {
	    q: ($stateParams.filter || ""),
	    active: ($stateParams.active === 'true' ? true : ($stateParams.active === 'false' ? false : null))
	  };
	
	  $scope.copySuccess = function() {
	    growl.addSuccessMessage(translations['publication.share.share-link-copy-success']);
	  };
	
	  $scope.copyFail = function() {
	    growl.addErrorMessage(translations['publication.share.share-link-copy-failure']);
	  };
	
	  $scope.searchShareLinks = function(filter){
	    $state.go('root.company.comments.share-links', {filter: filter.q, active: filter.active});
	  };
	}
	
	CompanyShareLinksCtrl.resolve = {
	  shareLinks: ['$stateParams', 'CompanyShareLinksService', function($stateParams, CompanyShareLinksService) {
	    return CompanyShareLinksService.query({
	  		companyId: $stateParams.companyId,
	      q: $stateParams.filter||null,
	      active: $stateParams.active||null,
	      limit: (LIMIT + 1),
	      offset: ($stateParams.page|0) * LIMIT}).$promise;
	  }],
	  translations: ["$translate", function($translate){
	    return $translate([
	      'publication.share.share-link-copy-success',
	      'publication.share.share-link-copy-failure'
	    ]);
	  }]
	};
	
	module.exports = CompanyShareLinksCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyShareLinksCtrl", CompanyShareLinksCtrl);


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyShareLinksService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/share-links', {}, {});
	}
	
	angular.module('dokiv')
	  .factory('CompanyShareLinksService', ['$resource', 'config', CompanyShareLinksService]);


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(60);
	
	function CompanyCustomerPortalsCtrl($scope, groupCategories) {
	  $scope.groupCategories = groupCategories;
	}
	
	CompanyCustomerPortalsCtrl.resolve = {
	  groupCategories: ['$stateParams', 'CompanyGroupCategoryService', function($stateParams, CompanyGroupCategoryService){
	    return CompanyGroupCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
	  }],
	};
	
	module.exports = CompanyCustomerPortalsCtrl;
	angular.module('dokiv')
	  .controller('CompanyCustomerPortalsCtrl', ["$scope", "groupCategories", CompanyCustomerPortalsCtrl]);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(11);
	__webpack_require__(7);
	__webpack_require__(14);
	__webpack_require__(359);
	__webpack_require__(5);
	__webpack_require__(29);
	__webpack_require__(46);
	__webpack_require__(27);
	
	var LIMIT = 100;
	
	function CompanyCustomerPortalsDetailCtrl(
	  $scope,
	  customerPortal,
	  publications,
	  members,
	  translations,
	  $state,
	  $stateParams,
	  $sce,
	  $filter,
	  $modal,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  CompanyGroupPublicationService,
	  CompanyPublicationService,
	  CompanyService,
	  growl,
	  priorities
	) {
	
	  $scope.customerPortal = customerPortal;
	  $scope.publications = publications;
	  $scope.members = members;
	  $scope.forms = {};
	  $scope.newPublication = {};
	  if($stateParams.priorityId){
	    $scope.selectedPriority = priorities.find(function(p){
	      return p.id === $stateParams.priorityId
	    });
	  }
	  $scope.selectedYear = $stateParams.year || "";
	  $scope.selectedMonth = $stateParams.month || "";
	  $scope.years = [];
	  for(var y=2010; y<2030; y++){
	    $scope.years.push(y.toString())
	  }
	
	  $scope.months = [];
	  for(var m=1; m<12; m++){
	    $scope.months.push(m.toString())
	  }
	
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml('customer-portals.documents'),
	      'content': '',
	      'template': 'partials/company/customer-portals/detail/documents.html',
	      'icon': 'file-o'
	    },
	    {
	      'title': $sce.trustAsHtml('customer-portals.info'),
	      'content': '',
	      'template': 'partials/company/customer-portals/detail/info.html',
	      'icon': 'info-circle'
	    }
	  ];
	
	  $scope.tabs.push(
	    {
	      'title': $sce.trustAsHtml('customer-portals.members'),
	      'content': '',
	      'template': 'partials/company/customer-portals/detail/members.html',
	      'icon': 'users'
	    }
	  );
	
	  $scope.tabs.activeTab = 0;
	  $scope.priorities  = priorities;
	
	  $scope.save = function() {
	    CompanyGroupService.update({companyId: $stateParams.companyId, groupId: $scope.customerPortal.id}, $scope.customerPortal, function() {
	      angular.element('#filterRole').val('');
	      growl.addSuccessMessage(translations['customer-portals.saved-success']);
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.saved-failure']);
	    });
	  };
	
	  $scope.delete = function(id) {
	    CompanyGroupService.delete({companyId: $stateParams.companyId, groupId: id}, function() {
	      growl.addSuccessMessage(translations['customer-portals.removed-success']);
	      $state.go('root.company.customerPortals.list');
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.removed-failure']);
	    });
	  };
	
	
	  $scope.removeMember = function(userId) {
	    CompanyGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.customerPortalId, userId: userId}, function() {
	      $scope.members = $scope.members.filter(function(item) {
	        return item.id !== userId;
	      });
	
	      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
	    });
	  };
	
	  $scope.removePublication = function(publication) {
	    if (publication.groups.indexOf($scope.customerPortal.id) > -1) {
	      publication.groups.splice(publication.groups.indexOf($scope.customerPortal.id), 1);
	    }
	    CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
	      growl.addSuccessMessage(translations['customer-portals.remove-publication-success']);
	      $scope.publications.splice($scope.publications.indexOf(publication), 1);
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.remove-publication-failure']);
	    });
	  };
	
	  $scope.guestViews = [
	    {
	      "label": translations['customer-portal.template.default'],
	      "value": "DEFAULT"
	    },
	    {
	      "label": translations['customer-portal.template.my-page'],
	      "value": "MYPAGE"
	    }
	  ];
	  $scope.selectedView = $filter('filter')($scope.guestViews, {value: customerPortal.view})[0];
	
	  $scope.inputTags = angular.copy($scope.customerPortal.tags);
	  $scope.convertTags = function() {
	    var newTags = [];
	    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
	    angular.copy(newTags, $scope.customerPortal.tags);
	  };
	
	  $scope.loadTags = function() {
	    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
	  };
	
	  $scope.setGroupCategory = function(category) {
	    if (!category) {
	      $scope.customerPortal.category = null;
	    } else {
	      $scope.customerPortal.category = category;
	    }
	  };
	
	  $scope.setPriority = function(publication, priority) {
	    var indexPublication = $scope.publications.indexOf(publication);
	    if( ! priority) {
	      $scope.publications[indexPublication].priority = null;
	    } else {
	      $scope.publications[indexPublication].priority = priority;
	    }
	
	    return $scope.savePublication($scope.publications[indexPublication]);
	  };
	
	  $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
	    return v.stepNr > 0;
	  });
	
	  $scope.nextStatus = function(publication) {
	    var indexPublication = $scope.publications.indexOf(publication);
	    if ($scope.prioritiesSorted.length === 0) {
	      return;
	    }
	    if (!$scope.publications[indexPublication].priority) {
	      $scope.publications[indexPublication].priority = $scope.prioritiesSorted[0];
	      $scope.savePublication($scope.publications[indexPublication]);
	    } else {
	      var index = $scope.prioritiesSorted.findIndex(function(v){
	        return v.id === $scope.publications[indexPublication].priority.id;
	      });
	
	      if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
	        return;
	      }
	
	      $scope.publications[indexPublication].priority = $scope.prioritiesSorted[index + 1];
	      $scope.savePublication($scope.publications[indexPublication]);
	    }
	  };
	
	  $scope.publicationsMassEdit = [];
	  $scope.namePublications = [];
	  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
	    if(publicationSelected){
	      $scope.publicationsMassEdit.push(publication.id);
	      $scope.namePublications.push(publication);
	    }else{
	      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
	      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
	    }
	  };
	
	  $scope.selectAllPublication = function(){
	    $scope.selectAll = !$scope.selectAll;
	    angular.forEach($scope.publications, function(publication){
	      if($scope.selectAll){
	        publication.selected = true;
	        $scope.publicationsMassEdit.push(publication.id);
	        $scope.namePublications.push(publication);
	      }else{
	        publication.selected = false;
	        $scope.publicationsMassEdit = [];
	        $scope.namePublications = [];
	      }
	    });
	  };
	
	  $scope.showModalMassEdit = function() {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyPublicationMassEditCtrl',
	      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
	      show: true,
	      resolve: {
	        priorities: function() {
	          return priorities;
	        },
	        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	          return CompanyGroupService.query({
	            companyId: $stateParams.companyId,
	            all: true
	          }).$promise;
	        }],
	        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	          return CompanyCategoryService.query({
	            companyId: $stateParams.companyId,
	            limit: 1000
	          }).$promise;
	        }]
	      }
	    });
	  };
	
	  $scope.changeSelectedYear = function(year) {
	      $scope.selectedYear = year;
	      $state.go('.', {year: year});
	  };
	
	  $scope.changeSelectedMonth = function(month) {
	      $scope.selectedMonth = month;
	      $state.go('.', {month: month});
	  };
	
	  $scope.filterByStatus = function(selectedPriority) {
	    $scope.selectedPriority = selectedPriority;
	    $state.go('.', {priorityId: (selectedPriority ? selectedPriority.id : null)});
	  };
	  
	  $scope.pagePub = 0;
	  if(publications.length >= LIMIT){
	    $scope.hasMorePub = true;
	  }else{
	    $scope.hasMorePub = false;
	  }
	  
	  window.onscroll = function() {
	    if($scope.tabs.activeTab === 0){
	      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 300) {
	        if($scope.hasMorePub){
	          $scope.pagePub = $scope.pagePub+1;
	          $scope.loadMorePublication();
	          $scope.hasMorePub = false;
	        }
	      }
	    }
	  };
	
	  $scope.loadMorePublication = function() {
	    return CompanyGroupPublicationService.query({
	      companyId: $stateParams.companyId, 
	      groupId: $stateParams.customerPortalId, 
	      year: ($stateParams.year ? $stateParams.year : null), 
	      month: ($stateParams.month ? $stateParams.month : null), 
	      priorityId: ($scope.selectedPriority ? $scope.selectedPriority.id : null), 
	      orderby: 'created', 
	      offset: $scope.pagePub*LIMIT,
	      limit: LIMIT
	    }).$promise.then(function(pubs){
	      $scope.publications = $scope.publications.concat(pubs);
	      if(pubs.length >= LIMIT){
	        $scope.hasMorePub = true;
	      }else{
	        $scope.hasMorePub = false;
	      }
	    });
	  };
	}
	
	CompanyCustomerPortalsDetailCtrl.resolve = {
	  customerPortal: ['$stateParams', '$translate', '$q', 'CompanyGroupService', function($stateParams, $translate, $q, CompanyGroupService) {
	    return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.customerPortalId}).$promise.then(function(group) {
	      if('VISIBLE' !== group.type) {
	        return $q.reject($translate.instant('customer-portals.invalid'));
	      }
	
	      return group;
	    });
	  }],
	  publications: ['$stateParams', 'CompanyGroupPublicationService', function($stateParams, CompanyGroupPublicationService) {
	    return CompanyGroupPublicationService.query({
	      companyId: $stateParams.companyId, 
	      groupId: $stateParams.customerPortalId,
	      year: ($stateParams.year ? $stateParams.year : null), 
	      month: ($stateParams.month ? $stateParams.month : null), 
	      priorityId: ($stateParams.priorityId ? $stateParams.priorityId : null),
	      orderby: 'created', 
	      offset: 0,
	      limit: LIMIT
	    }).$promise;
	  }],
	  members: ['$stateParams', 'CompanyGroupUserService', function($stateParams, CompanyGroupUserService) {
	    return CompanyGroupUserService.query({
	      companyId: $stateParams.companyId,
	      groupId: $stateParams.customerPortalId,
	      limit: 200}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'customer-portals.saved-success',
	      'customer-portals.saved-failure',
	      'customer-portals.removed-success',
	      'customer-portals.removed-failure',
	      'customer-portals.add-member-success',
	      'customer-portals.add-member-failure',
	      'customer-portals.remove-member-success',
	      'customer-portals.remove-member-failure',
	      'customer-portals.remove-publication-success',
	      'customer-portals.remove-publication-failure',
	      'customer-portals.invalid',
	      'customer-portals.documents',
	      'customer-portals.members',
	      'customer-portals.info',
	      'customer-portals.add-publication-success',
	      'customer-portals.add-publication-failure',
	      'customer-portal.template.default',
	      'customer-portal.template.my-page'
	    ]);
	  }]
	};
	module.exports = CompanyCustomerPortalsDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCustomerPortalsDetailCtrl', [
	    '$scope',
	    'customerPortal',
	    'publications',
	    'members',
	    'translations',
	    '$state',
	    '$stateParams',
	    '$sce',
	    '$filter',
	    '$modal',
	    'CompanyGroupService',
	    'CompanyGroupUserService',
	    'CompanyGroupPublicationService',
	    'CompanyPublicationService',
	    'CompanyService',
	    'growl',
	    'priorities',
	    CompanyCustomerPortalsDetailCtrl
	  ]);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(7);
	
	function CompanyCustomerPortalsListCtrl(
	  $scope, 
	  $filter, 
	  $state, 
	  $stateParams, 
	  CompanyGroupService, 
	  portals, 
	  formAppGroups, 
	  customerPortals, 
	  FormAppSubmitGroupService,
	  $translate) {
	  $scope.portals = portals;
	  $scope.formAppGroups = formAppGroups;
	  $scope.customerPortals = customerPortals;
	
	  $scope.page = 0;
	  if ($scope.portals.length === 21) {
	    $scope.more = true;
	    $scope.portals.pop();
	  }
	  $scope.groupsPage = 0;
	  if ($scope.formAppGroups.length === 21) {
	    $scope.moreGroups = true;
	    $scope.formAppGroups.pop();
	  }
	  $scope.customersPage = 0;
	  if ($scope.customerPortals.length === 21) {
	    $scope.moreCustomers = true;
	    $scope.customerPortals.pop();
	  }
	
	  $scope.masterCustomPortals = angular.copy($scope.customerPortals);
	  $scope.companyId = $stateParams.companyId;
	
	  $scope.isCustomerMyPortals = false;
	  $scope.isMyPortals = false;
	  $scope.isMyFormAppGroups = false;
	  $scope.selectedCategory = null;
	  $scope.customerSelectedCategory = null;
	
	  $scope.tabs = [{
	    'title': 'publication.portals',
	    'template': 'partials/company/customer-portals/list.html',
	    'icon': 'laptop'
	  },
	  {
	    'title': 'form-app-submit-group',
	    'template': 'partials/company/form-app-submit-group/list.html',
	    'icon': 'mobile'
	  },{
	    'title': 'publication.customer-portals',
	    'template': 'partials/company/customer-portals/customers-connected.html',
	    'icon': 'users'
	  }];
	
	  if ($stateParams.tab && $stateParams.tab === 'form-app') {
	    $scope.activeTab = 1;
	  } else {
	    $scope.activeTab = 0;
	  }
	  
	
	
	  $scope.searchPortals = function(filterText, customerConnected, page) {
	    $scope.page = page;
	    var filter = {};
	    filter.limit = 21;
	    filter.offset = (page|0) * 20;
	    filter.companyId = $stateParams.companyId;
	    if(filterText && filterText !== ''){
	      filter.q = filterText;
	    }
	    if(customerConnected){
	      filter.customerConnected = true;
	      if ($scope.customerSelectedCategory) {
	        filter.categoryId = $scope.customerSelectedCategory.id;
	      }
	      if ($scope.isCustomerMyPortals) {
	        filter.userId = $scope.currentUser.id;
	      }
	    }else{
	      filter.customerConnected = false;
	      if ($scope.selectedCategory) {
	        filter.categoryId = $scope.selectedCategory.id;
	      }
	      if ($scope.isMyPortals) {
	        filter.userId = $scope.currentUser.id;
	      }
	    }
	    filter.type = 'VISIBLE';
	    CompanyGroupService.query(filter).$promise.then(function(portals){
	      if(customerConnected){
	        $scope.customerPortals = portals;
	        if ($scope.customerPortals.length === 21) {
	          $scope.moreCustomers = true;
	          $scope.customerPortals.pop();
	        }else{
	          $scope.moreCustomers = false;
	        }
	      }else{
	        $scope.portals = portals;
	        if ($scope.portals.length === 21) {
	          $scope.more = true;
	          $scope.portals.pop();
	        }else{
	          $scope.more = false;
	        }
	      }
	    });
	  };
	
	  $scope.searchFormAppGroups = function(filterText, page) {
	    $scope.groupsPage = page;
	    var filter = {};
	    filter.limit = 21;
	    filter.offset = (page|0) * 20;
	    filter.companyId = $stateParams.companyId;
	    if ($scope.isMyFormAppGroups) {
	      filter.userId = $scope.currentUser.id;
	    }
	    if(filterText && filterText !== ''){
	      filter.q = filterText;
	    }
	    FormAppSubmitGroupService.query(filter).$promise.then(function(groups){
	      $scope.formAppGroups = groups;
	      if ($scope.formAppGroups.length === 21) {
	        $scope.moreGroups = true;
	        $scope.formAppGroups.pop();
	      }else{
	        $scope.moreGroups = false;
	      }
	    });
	  };
	}
	
	CompanyCustomerPortalsListCtrl.resolve = {
	  portals: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
	    var filter = {};
	    filter.limit = 21;
	    filter.offset = ($stateParams.page|0) * 20;
	    filter.companyId = $stateParams.companyId;
	    filter.customerConnected = false;
	    filter.type = 'VISIBLE';
	   return CompanyGroupService.query(filter).$promise;
	  }],
	  customerPortals: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
	    var filter = {};
	    filter.limit = 21;
	    filter.offset = ($stateParams.page|0) * 20;
	    filter.companyId = $stateParams.companyId;
	    filter.customerConnected = true;
	    filter.type = 'VISIBLE';
	    return CompanyGroupService.query(filter).$promise;
	  }],
	  formAppGroups: ['$stateParams', 'FormAppSubmitGroupService', function($stateParams, FormAppSubmitGroupService) {
	    var filter = {};
	    filter.limit = 21;
	    filter.offset = ($stateParams.page|0) * 20;
	    filter.companyId = $stateParams.companyId;
	    return FormAppSubmitGroupService.query(filter).$promise;
	  }]
	};
	module.exports = CompanyCustomerPortalsListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCustomerPortalsListCtrl', [
	    '$scope', 
	    '$filter', 
	    '$state', 
	    '$stateParams', 
	    'CompanyGroupService', 
	    'portals',
	    'formAppGroups', 
	    'customerPortals', 
	    'FormAppSubmitGroupService', 
	    '$translate', 
	    CompanyCustomerPortalsListCtrl]);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(7);
	__webpack_require__(14);
	__webpack_require__(18);
	__webpack_require__(5);
	__webpack_require__(40);
	__webpack_require__(26);
	
	function CompanyCustomerPortalsNewCtrl(
	  $scope,
	  translations,
	  $state,
	  $stateParams,
	  growl,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  FormAppSubmitGroupService,
	  FormAppSubmitGroupUserService,
	  CompanyService,
	  CurrentUserService,
	  CompanyPublicationService) {
	  $scope.customerPortal = {
	    name: [""],
	    type: 'VISIBLE'
	  };
	  $scope.isCreateFormApp = $stateParams.isCreateFormApp ? true : false;
	  $scope.isCreatePortal = $stateParams.isCreateFormApp ? false : true;
	  $scope.createType = 'SINGLE';
	
	  $scope.state = $state;
	
	  $scope.guestViews = [
	    {
	      "label": translations['customer-portal.template.default'],
	      "value": "DEFAULT"
	    },
	    {
	      "label": translations['customer-portal.template.my-page'],
	      "value": "MYPAGE"
	    }
	  ];
	  $scope.customerPortal.view = $scope.guestViews[0].value;
	
	  $scope.save = function() {
	    $scope.customerPortal.name.map(function(n){
	      var customerPortal = angular.copy($scope.customerPortal);
	      customerPortal.name = n;
	      if($scope.isCreateFormApp){
	        FormAppSubmitGroupService.save({companyId: $stateParams.companyId}, customerPortal, function(resp, headers) {
	          $scope.customerPortalForm.$setPristine();
	          var newId = headers('Location').split('/').pop();
	          if($scope.addCurrentUser) {
	            CurrentUserService.get().then(function(user) {
	              FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, user);
	            });
	          }
	          $state.go('root.company.customerPortals.list', {companyId: $stateParams.companyId});
	          growl.addSuccessMessage(translations['form-app.create-success']);
	        }, function(resp) {
	          if (resp.status === 400 && resp.data.error && resp.data.error.code === 1613) {
	            growl.addErrorMessage(translations['form-app.reached-your-limit']);
	          } else {
	            growl.addErrorMessage(translations['form-app.create-failure']);
	          }
	        });
	      }
	      if($scope.isCreatePortal){
	        CompanyGroupService.save({companyId: $stateParams.companyId, type: 'VISIBLE'}, customerPortal, function(resp, headers) {
	          $scope.customerPortalForm.$setPristine();
	          var newId = headers('Location').split('/').pop();
	          // Check option to add current user to this customer portal
	          if($scope.addCurrentUser) {
	            CurrentUserService.get().then(function(user) {
	              CompanyGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, {id: user.id});
	            });
	          }
	
	          if ($scope.addCurrentDocument && $stateParams.publicationId) {
	            CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function (publication) {
	              publication.groups.push(newId);
	              publication.$update({companyId: $stateParams.companyId}, function(){
	                if(publication.type !== 'FORM'){
	                  $state.go('root.company.publication.share-access', {companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, activeTab: 4}, {reload: true});
	                }
	              });
	            });
	          } else {
	            $state.go('root.company.customerPortals.list', {companyId: $stateParams.companyId});
	          }
	
	          growl.addSuccessMessage(translations['customer-portal.create-success']);
	        }, function() {
	          growl.addSuccessMessage(translations['customer-portal.create-failure']);
	        });
	      }
	    });
	  };
	  $scope.customerPortal.tags = [];
	  $scope.inputTags = angular.copy($scope.customerPortal.tags);
	  $scope.convertTags = function() {
	    var newTags = [];
	    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
	    angular.copy(newTags, $scope.customerPortal.tags);
	  };
	
	  $scope.loadTags = function() {
	    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
	  };
	
	  $scope.setGroupCategory = function(category) {
	    if (!category) {
	      $scope.customerPortal.category = null;
	    } else {
	      $scope.customerPortal.category = category;
	    }
	  };
	
	  $scope.toggleSingle = function() {
	    $scope.createType = 'SINGLE';
	    $scope.customerPortal.name.splice(1);
	  };
	
	  $scope.toggleBulk = function() {
	    $scope.createType = 'BULK';
	    $scope.bulkAddItem();
	  };
	
	  $scope.bulkAddItem = function() {
	    if ($scope.customerPortal.name.length < 20) {
	      $scope.customerPortal.name.push('');
	    }
	  };
	
	  $scope.bulkRemoveItem = function(item) {
	    if (item > 0) {
	      $scope.customerPortal.name.splice(item, 1);
	    }
	
	    if ($scope.customerPortal.name.length === 1) {
	      $scope.toggleSingle();
	    }
	  };
	
	}
	
	CompanyCustomerPortalsNewCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'customer-portal.create-success',
	      'customer-portal.create-failure',
	      'customer-portal.template.default',
	      'customer-portal.template.my-page',
	      'form-app.create-success',
	      'form-app.create-failure',
	      'form-app.reached-your-limit'
	    ]);
	  }]
	};
	module.exports = CompanyCustomerPortalsNewCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCustomerPortalsNewCtrl', [
	    '$scope',
	    'translations',
	    '$state',
	    '$stateParams',
	    'growl',
	    'CompanyGroupService',
	    'CompanyGroupUserService',
	    'FormAppSubmitGroupService',
	    'FormAppSubmitGroupUserService',
	    'CompanyService',
	    'CurrentUserService',
	    'CompanyPublicationService',
	    CompanyCustomerPortalsNewCtrl]);
	


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(333);
	var moment      = __webpack_require__(1);
	CompanyCustomerServiceListCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  'services',
	  'serviceTypes',
	  'info',
	  '$translate',
	  'CompanyCustomerServiceService',
	  'filterManager',
	  'CompanyUserService',
	  'growl'];
	var LIMIT = 20;
	
	function CompanyCustomerServiceListCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  services,
	  serviceTypes,
	  info,
	  $translate,
	  CompanyCustomerServiceService,
	  filterManager,
	  CompanyUserService,
	  growl) {
	
	  $scope.services = services;
	
	  $scope.serviceTypes = serviceTypes;
	  $scope.page = $stateParams.page|0;
	  $scope.info = info;
	
	  $scope.currentManager = filterManager;
	
	  if ($scope.services.length === (LIMIT + 1)) {
	    $scope.more = true;
	    $scope.services.pop();
	  }
	
	  $scope.currentServiceId = $stateParams.typeId || "";
	
	  $scope.delete = function(id, index) {
	    CompanyCustomerServiceService.delete({companyId: $stateParams.companyId, serviceTypeId: id}, function(){
	      $scope.services.splice(index, 1);
	      growl.addSuccessMessage($translate.instant('customer.service-type.delete-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('customer.service-type.delete-failure'));
	    });
	  };
	
	  $scope.filterName = $stateParams.name || "";
	
	  $scope.search = function() {
	    var params = {
	      name: $scope.filterName,
	      page: null
	    };
	    if ($scope.currentManager) {
	      params.manager = $scope.currentManager.id;
	    }
	    $state.go('root.company.customer-service.list', params);
	  };
	
	  $scope.queryManager = function(filter) {
	    CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users){
	        $scope.managers = users;
	    });
	  };
	}
	
	CompanyCustomerServiceListCtrl.resolve = {
	  services: [
	  '$stateParams',
	  'CompanyCustomerServiceService',
	  function($stateParams, CompanyCustomerServiceService) {
	    return CompanyCustomerServiceService.query({
	      companyId: $stateParams.companyId,
	      limit: (LIMIT + 1),
	      name: $stateParams.name ||  null,
	      typeId: $stateParams.typeId || null,
	      manager: $stateParams.manager || null,
	      offset: ($stateParams.page|0) * LIMIT}).$promise;
	  }],
	  serviceTypes: ['$stateParams', 'CompanyCustomerServiceTypeService', function($stateParams, CompanyCustomerServiceTypeService){
	    return CompanyCustomerServiceTypeService.query({
	      companyId: $stateParams.companyId,
	      limit: 1000
	    }).$promise;
	  }],
	  filterManager: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService) {
	    if ($stateParams.manager) {
	      return CompanyUserService.get({
	        companyId: $stateParams.companyId,
	        userId: $stateParams.manager
	      }).$promise;
	    }
	    return null;
	  }]
	};
	
	module.exports  = CompanyCustomerServiceListCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyCustomerServiceListCtrl", CompanyCustomerServiceListCtrl)
	  .filter('lastcontact', function() {
	    return function(input) {
	      if (input.lastContactDate && input.expiredContactDate) {
	        var expiredContactDate = moment(new Date(input.expiredContactDate)).format("YYYYMMDD");
	        var today = moment().format("YYYYMMDD");
	        if (expiredContactDate < today) {
	          return '#f26a5d';
	        }
	      }
	      return '';
	    };
	  });


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCustomerServiceService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/services', {}, {});
	}
	
	angular.module('dokiv')
	  .factory('CompanyCustomerServiceService', ['$resource', 'config', CompanyCustomerServiceService]);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(16);
	__webpack_require__(10);
	__webpack_require__(4);
	__webpack_require__(12);
	__webpack_require__(5);
	__webpack_require__(314);
	__webpack_require__(44);
	__webpack_require__(422);
	__webpack_require__(27);
	__webpack_require__(7);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(66);
	
	CompanyCustomerDetailCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$modal',
	  '$http',
	  '$sce',
	  '$filter',
	  'CompanyCustomersService',
	  'customer',
	  'checklists',
	  'addresses',
	  'currentUser',
	  'CompanyChecklistService',
	  'CompanyPublicationOrderService',
	  'CompanyPublicationService',
	  'files',
	  '$translate',
	  'config',
	  'info',
	  'UploadTracker',
	  'CompanyQueriesService',
	  'CompanyGroupService',
	  'CompanyCustomerService',
	  'CompanyTimestampsService',
	  'CompanyPublicationService',
	  'CompanySettingUnitsService',
	  'CompanyService',
	  'growl',
	  'services',
	  'priorities',
	  'customerUnits',
	  'objectSkills',
	  'priceLists'
	];
	
	function CompanyCustomerDetailCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $modal,
	  $http,
	  $sce,
	  $filter,
	  CompanyCustomersService,
	  customer,
	  checklists,
	  addresses,
	  currentUser,
	  checklistService,
	  orderService,
	  publicationService,
	  files,
	  $translate,
	  config,
	  info,
	  uploadTracker,
	  CompanyQueriesService,
	  CompanyGroupService,
	  CompanyCustomerService,
	  CompanyTimestampsService,
	  CompanyPublicationService,
	  CompanySettingUnitsService,
	  CompanyService,
	  growl,
	  services,
	  priorities,
	  customerUnits,
	  objectSkills,
	  priceLists
	) {
	
	  $scope.customer = customer;
	  $scope.origCustomer = angular.copy(customer);
	  $scope.files = files;
	  $scope.checklists = checklists;
	  $scope.services = services;
	  $scope.addresses = addresses;
	  $scope.priceLists = priceLists;
	  $scope.info = info;
	  $scope.customerUnits = customerUnits;
	  $scope.objectSkills = objectSkills;
	  $scope.limitCustomerCategories = 20;
	  $scope.newComment = {
	    text: ''
	  };
	  $scope.tabs = [
	    {
	      'title': 'information',
	      'content': '',
	      'template': 'partials/company/customers-dashboard/detail/information.html',
	      'icon': 'info-circle'
	    },
	    {
	      'title': 'more-info',
	      'content': '',
	      'template': 'partials/company/customers-dashboard/detail/more-info.html',
	      'icon': 'question-circle'
	    }
	  ];
	  if($scope.customer.extra.group){
	    $scope.tabs.push({
	      'title': 'customer-portal.customer-portal',
	      'content': '',
	      'template': 'partials/company/customers-dashboard/detail/portal.html',
	      'icon': 'laptop'
	    });
	    $scope.priorities  = priorities;
	
	    CompanyGroupService.get({
	      companyId: $stateParams.companyId,
	      groupId: $scope.customer.extra.group.id
	    }).$promise.then(function(customerPortal){
	      $scope.customerPortal = customerPortal;
	      CompanyPublicationService.query({
	        companyId: $stateParams.companyId,
	        groupId: $scope.customer.extra.group.id,
	        limit: customerPortal.numPublications
	      }, function(publications){
	        $scope.publications = publications;
	      });
	    });
	
	    $scope.removePublication = function(publication) {
	      if (publication.groups.indexOf($scope.customerPortal.id) > -1) {
	        publication.groups.splice(publication.groups.indexOf($scope.customerPortal.id), 1);
	      }
	      CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
	        growl.addSuccessMessage($translate.instant('customer-portals.remove-publication-success'));
	        $scope.publications.splice($scope.publications.indexOf(publication), 1);
	      }, function() {
	        growl.addErrorMessage($translate.instant('customer-portals.remove-publication-failure'));
	      });
	    };
	
	    $scope.setPriority = function(publication, priority) {
	      var indexPublication = $scope.publications.indexOf(publication);
	      if( ! priority) {
	        $scope.publications[indexPublication].priority = null;
	      } else {
	        $scope.publications[indexPublication].priority = priority;
	      }
	
	      return $scope.savePublication($scope.publications[indexPublication]);
	    };
	
	    $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
	      return v.stepNr > 0;
	    });
	
	    $scope.nextStatus = function(publication) {
	      var indexPublication = $scope.publications.indexOf(publication);
	      if ($scope.prioritiesSorted.length === 0) {
	        return;
	      }
	      if (!$scope.publications[indexPublication].priority) {
	        $scope.publications[indexPublication].priority = $scope.prioritiesSorted[0];
	        $scope.savePublication($scope.publications[indexPublication]);
	      } else {
	        var index = $scope.prioritiesSorted.findIndex(function(v){
	          return v.id === $scope.publications[indexPublication].priority.id;
	        });
	
	        if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
	          return;
	        }
	
	        $scope.publications[indexPublication].priority = $scope.prioritiesSorted[index + 1];
	        $scope.savePublication($scope.publications[indexPublication]);
	      }
	    };
	
	    $scope.publicationsMassEdit = [];
	    $scope.namePublications = [];
	    $scope.addPublicationsMassEdit = function(publication, publicationSelected){
	      if(publicationSelected){
	        $scope.publicationsMassEdit.push(publication.id);
	        $scope.namePublications.push(publication);
	      }else{
	        $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
	        $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
	      }
	    };
	
	    $scope.selectAllPublication = function(){
	      $scope.selectAll = !$scope.selectAll;
	      angular.forEach($scope.publications, function(publication){
	        if($scope.selectAll){
	          publication.selected = true;
	          $scope.publicationsMassEdit.push(publication.id);
	          $scope.namePublications.push(publication);
	        }else{
	          publication.selected = false;
	          $scope.publicationsMassEdit = [];
	          $scope.namePublications = [];
	        }
	      });
	    };
	
	    $scope.showModalMassEdit = function() {
	      $modal({
	        scope: $scope,
	        controller: 'CompanyPublicationMassEditCtrl',
	        templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
	        show: true,
	        resolve: {
	          priorities: function() {
	            return priorities;
	          },
	          groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	            return CompanyGroupService.query({
	              companyId: $stateParams.companyId,
	              all: true
	            }).$promise;
	          }],
	          categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	            return CompanyCategoryService.query({
	              companyId: $stateParams.companyId,
	              limit: 1000
	            }).$promise;
	          }]
	        }
	      });
	    };
	  }
	
	  $scope.showModalEditSkills = function() {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyObjectSkillsCtrl',
	      templateUrl: 'partials/company/object-skills/modal-object-skills.html',
	      show: true,
	      resolve: {
	        object: function() {
	          return customer;
	        },
	        objectType: function() {
	          return 'SKILL_CUSTOMER';
	        },
	        skills: ['$stateParams', 'CompanySkillsService', function ($stateParams, CompanySkillsService) {
	          return CompanySkillsService.query({
	            companyId: $stateParams.companyId,
	            limit: 1000
	          }).$promise;
	        }]
	      }
	    });
	  };
	
	  $scope.searchUnits = function(filter) {
	    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10}).$promise.then(function(units) {
	      return units.filter(function(item) {
	        return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && !$scope.customerUnits.some(function(i) {
	          return item.id === i.id;
	        });
	      });
	    }).then(function(nonUnits) {
	      $scope.units = nonUnits;
	    });
	  };
	
	  $scope.updateUnit = function(unit) {
	    CompanySettingUnitsService.update({
	      companyId: $stateParams.companyId,
	      unitId: unit.id
	    }, unit, function() {
	      growl.addSuccessMessage($translate.instant('units.saved-success'));
	      if(unit.customer === null){
	        $scope.customerUnits.splice($scope.customerUnits.indexOf(unit), 1);
	        if($scope.units){
	          $scope.units.push(unit);
	        }
	      }else{
	        if(unit.customer.id === $scope.customer.id){
	          $scope.customerUnits.push(unit);
	          $scope.units.splice($scope.units.indexOf(unit), 1);
	        }
	      }
	    }, function() {
	      growl.addErrorMessage($translate.instant('units.saved-failure'));
	    });
	  };
	
	  if ($scope.currentUserPermissions.CompanyServiceView && info.features.companyService) {
	    $scope.comments = [];
	    $scope.editFlags = [];
	    if ($scope.services.length > 0) {
	      angular.forEach($scope.services, function(v){
	        CompanyTimestampsService.query({
	          companyId: $stateParams.companyId,
	          objectId: v.id,
	          limit: 21,
	          offset: 0
	        }, function(resp){
	          v.timestamps = resp;
	          var timestampCurrent = resp.filter(function(item){
	            return item.status === 'IN_PROGRESS';
	          });
	          if(timestampCurrent.length > 0){
	            v.timestampCurrent = timestampCurrent[0];
	            v.monthTotal = 0;
	            CompanyTimestampsService.queryTotalTime({
	              companyId: $stateParams.companyId,
	              objectId: v.id,
	              sum: v.monthTotal
	            }, function(resp){
	              v.totalTime =  (new Date(timestampCurrent[0].startAt)) - (resp.total * 1000);
	            });
	          }else{
	            v.totalTime = 0;
	          }
	        });
	        $scope.tabs.push({
	          'title': v.name,
	          'content': '',
	          'template': 'partials/company/customers-dashboard/detail/service.html',
	          'icon': 'square',
	          'color': v.color
	        });
	
	        CompanyCustomerService.queryComments({
	          companyId: $stateParams.companyId,
	          customerId: $stateParams.customerId,
	          serviceId: v.id,
	          limit: 11,
	          offset: 0
	        }, function(resp){
	          var data = {page: 0, hasMore: false};
	          if (resp.length === 11) {
	            data.hasMore = true;
	            resp.pop();
	          }
	          data.comments = resp;
	
	          $scope.comments[v.id] = data;
	        });
	
	        $scope.editFlags[v.id] = {
	          showForm: false
	        };
	
	        checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: v.id
	        }, function(checklist){
	          v.serviceChecklist = checklist;
	        });
	
	      });
	    }
	
	    $scope.queryTotalTimeOption = function(service){
	      CompanyTimestampsService.queryTotalTime({
	        companyId: $stateParams.companyId,
	        objectId: service.id,
	        sum: service.monthTotal
	      }, function(resp){
	        $scope.services[$scope.services.indexOf(service)].totalTime =  (new Date(service.timestampCurrent.startAt)) - (resp.total * 1000);
	      });
	    };
	
	    $scope.commentPaging = function(service, resetPage) {
	      CompanyCustomerService.queryComments({
	        companyId: $stateParams.companyId,
	        customerId: $stateParams.customerId,
	        serviceId: service.id,
	        limit: 11,
	        offset: resetPage ? 0 : $scope.comments[service.id].page * 10
	      }, function(resp){
	        if (resp.length === 11) {
	          $scope.comments[service.id].hasMore = true;
	          resp.pop();
	        } else {
	          $scope.comments[service.id].hasMore = false;
	        }
	        $scope.comments[service.id].comments = resp;
	      });
	    };
	
	    if ($scope.currentUserPermissions.CompanyServiceCreate) {
	      $scope.tabs.push({
	        'content': '',
	        'template': 'partials/company/customers-dashboard/detail/service-new.html',
	        'icon': 'plus'
	      });
	
	      $scope.services.push({
	        name: '',
	        buttons: [],
	        fields: [],
	        color: 1666198,
	      });
	    }
	
	    $scope.updateService = function(service) {
	      if (service.hasOwnProperty('id')) {
	        service.$update({
	          companyId: $stateParams.companyId,
	          customerId: $stateParams.customerId,
	          serviceId: service.id
	        }, function(){
	          growl.addSuccessMessage($translate.instant('customer.service.save-success'));
	        });
	      } else {
	        if (!$scope.currentUserPermissions.CompanyServiceCreate) {
	          return;
	        }
	
	        service.customer = angular.copy(customer);
	        CompanyCustomerService.save({
	          companyId: $stateParams.companyId,
	          customerId: $stateParams.customerId
	        }, service, function(){
	          growl.addSuccessMessage($translate.instant('customer.service.create-success'));
	          $state.reload();
	        });
	      }
	    };
	
	    $scope.addComment = function(service, text, defaultCmt) {
	      if (!text) {
	        return;
	      }
	      CompanyCustomerService.createComment({
	        companyId: $stateParams.companyId,
	        customerId: $stateParams.customerId,
	        serviceId: service.id
	      }, {text: text, isButtonComment: defaultCmt}, function(resp){
	        $scope.comments[service.id].comments.unshift(resp);
	        $scope.newComment.text = '';
	        if($scope.comments[service.id].comments.length > 10) {
	          $scope.comments[service.id].comments = $scope.comments[service.id].comments.slice(0, 10);
	          $scope.comments[service.id].hasMore = true;
	        }
	      });
	    };
	
	    $scope.addCommentOnEnter = function(evt, service) {
	      if(evt.keyCode === 13) {
	        $scope.addComment(service, $scope.newComment.text, false);
	      }
	    };
	
	    $scope.deleteService = function(service) {
	      if (!$scope.currentUserPermissions.CompanyServiceDelete) {
	        return;
	      }
	
	      CompanyCustomerService.delete({
	        companyId: $stateParams.companyId,
	        customerId: $stateParams.customerId,
	        serviceId: service.id
	      }, function() {
	        growl.addSuccessMessage($translate.instant('customer.service.delete-success'));
	        $state.reload();
	      });
	    };
	
	    $scope.addDefaultComment = function(service) {
	      $scope.addComment(service, $translate.instant('customer.service.i-have-contact-customer'), true);
	    };
	
	    $scope.setCustomerServiceTimestamp = function(service, index){
	      var serviceObject = {
	        object: {
	          id: service.id,
	          name: service.name
	        },
	        objectType: 'CUSTOMER_SERVICE'
	      };
	      CompanyTimestampsService.save({
	        companyId: $stateParams.companyId
	      }, serviceObject, function(resp){
	        growl.addSuccessMessage($translate.instant('timestamp.started-timestamp-success'));
	        $scope.services[index].timestamps.push(resp);
	        $scope.services[index].timestampCurrent = resp;
	        $scope.services[index].monthTotal = 0;
	        CompanyTimestampsService.queryTotalTime({
	          companyId: $stateParams.companyId,
	          objectId: service.id,
	          sum: 0
	        }, function(respTotal){
	          $scope.services[index].totalTime =  (new Date(resp.startAt)) - (respTotal.total * 1000);
	        });
	      }, function(err){
	        if(err.status === 400){
	          growl.addErrorMessage(err.data);
	        }
	        if(err.status === 403){
	          growl.addErrorMessage(err.data.error.message);
	        }
	      });
	    };
	
	    $scope.$on('eventServiceTimestamp', function(event, data) {
	      $scope.$apply(function() {
	        var eventService = $scope.services.filter(function(service){
	          return service.id === data.timeStamp.object.id;
	        })[0];
	        var index = $scope.services.indexOf(eventService);
	        if(data.action === 'SERVICE_TIMESTAMP_STARTED'){
	          $scope.services[index].timestamps.push(data.timeStamp);
	          $scope.services[index].timestampCurrent = data.timeStamp;
	          $scope.services[index].monthTotal = 0;
	          CompanyTimestampsService.queryTotalTime({
	            companyId: $stateParams.companyId,
	            objectId: data.timeStamp.object.id,
	            sum: 0
	          }, function(respTotal){
	            $scope.services[index].totalTime =  (new Date(data.timeStamp.startAt)) - (respTotal.total * 1000);
	          });
	        }else{
	          $scope.services[index].timestampCurrent = null;
	          angular.forEach($scope.services[index].timestamps, function(value){
	            if(value.status === 'IN_PROGRESS'){
	              value.status = 'APPROVED';
	              value.endedAt = new Date();
	              return;
	            }
	          });
	        }
	      });
	    });
	
	    $scope.endCustomerServiceTimestamp = function(service, timestampId){
	      CompanyTimestampsService.update({
	        companyId: $stateParams.companyId,
	        timestampId: timestampId
	      }, {}, function(){
	        growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-success'));
	        $scope.services[$scope.services.indexOf(service)].timestampCurrent = null;
	        angular.forEach($scope.services[$scope.services.indexOf(service)].timestamps, function(value){
	          if(value.status === 'IN_PROGRESS'){
	            value.status = 'APPROVED';
	            value.endedAt = new Date();
	          }
	        });
	      }, function(){
	        growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-failure'));
	      });
	    };
	
	    $scope.showTimestampHistoryModal = function(service) {
	      var modal = $modal({
	        scope: $scope,
	        controller: 'CompanyCustomerTimestampsHistoryCtrl',
	        templateUrl: 'partials/company/customers-dashboard/detail/timestamp-history-modal.html',
	        show: false,
	        resolve: {
	          service: function() {
	            return service;
	          }
	        }
	      });
	      modal.$promise.then(modal.show);
	    };
	
	    $scope.viewReportAnalyticsPdf2Modal = function(viewId){
	      var content =
	        '<div class="reminder-detail__wrapper" tabindex="-1" role="dialog" aria-hidden="true">' +
	          '<div class="modal-dialog modal-dialog-loading">' +
	            '<div class="modal-content text-center">' +
	              '<i class="fa fa-spinner fa-spin fa-3x"></i>' +
	            '</div>' +
	          '</div>' +
	        '</div>';
	      jQuery.fancybox.open([{
	        type: 'iframe',
	        iframe: {
	          preload: false
	        },
	        padding: 0,
	        margin: 0,
	        content: content
	      }]);
	      CompanyService.createReportAnalyticsPdf2({companyId: $stateParams.companyId}, {viewId: viewId.toString(), customerName: $scope.customer.name}, function(resp) {
	        $http({
	          method: "GET",
	          url: config.apiBase + "/files/" + resp.id
	        }).then(function(response){
	          var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	          var url = '';
	          if (response.status === 200) {
	            url = config.apiBase + '/files/' + resp.id;
	          }
	          if (true === iOS) {
	            window.open(url, '_self');
	            return;
	          }
	          jQuery.fancybox.open([{
	            type: 'iframe',
	            iframe: {
	              preload: false
	            },
	            padding: 0,
	            margin: 0,
	            href: url
	          }]);
	        });
	      }, function(err){
	        jQuery.fancybox.close();
	        setTimeout(function(){
	          growl.addErrorMessage(err.data);
	        }, 500);
	      });
	    };
	  }
	
	  $scope.tabs.activeTab = 0;
	
	  if ($stateParams.tab) {
	    var index = $scope.services.findIndex(function(v){
	      return $stateParams.tab === v.id;
	    });
	
	    if (index > -1) {
	      $scope.tabs.activeTab = index + ($scope.customer.extra.group ? 3 : 2);
	    }
	  }
	
	  $scope.updateCustomer = function(customer) {
	    CompanyCustomersService.update({companyId: $stateParams.companyId, customerId: $stateParams.customerId}, customer, function(){
	      $scope.customer = customer;
	      $scope.origCustomer = angular.copy(customer);
	      growl.addSuccessMessage($translate.instant('customer.save-success'));
	      $state.go('^.list', {}, {reload: true});
	    }, function(){
	      growl.addErrorMessage($translate.instant('customer.save-failure'));
	      $scope.customer = angular.copy($scope.origCustomer);
	    });
	  };
	
	  $scope.cancel = function() {
	    $scope.customer = angular.copy($scope.origCustomer);
	  };
	
	  $scope.queryPublications = function(text, publications) {
	    return CompanyQueriesService.queryPublications(text, publications);
	  };
	
	  $scope.onFileSelect = function(files) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + '/companies/' + $stateParams.companyId + '/customers/' + $stateParams.customerId + '/files',
	        file: f,
	      };
	    })).then(function() {
	      CompanyCustomersService.queryFiles({
	        companyId: $stateParams.companyId,
	        customerId: $stateParams.customerId
	      }, function(resp){
	        $scope.files = resp;
	      });
	    });
	  };
	
	  $scope.removeFile = function(file, index) {
	    CompanyCustomersService.deleteFile({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId,
	      fileId: file
	    }, function(){
	      $scope.files.splice(index, 1);
	    });
	  };
	
	  $scope.addAddress = function() {
	    $scope.addresses.push(angular.copy($scope.defaultAddress));
	  };
	
	  $scope.saveAddress = function(address) {
	    CompanyCustomersService.updateAddress({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId
	    }, address, function(){
	      growl.addSuccessMessage($translate.instant('customer.save-address-success'));
	    });
	  };
	
	  $scope.deleteAddress = function(address, index) {
	    if (address.id !== undefined) {
	      CompanyCustomersService.deleteAddress({
	        companyId: $stateParams.companyId,
	        customerId: $stateParams.customerId,
	        addressId: address.id
	      }, function(){
	        $scope.addresses.splice(index, 1);
	        growl.addSuccessMessage($translate.instant('customer.delete-address-success'));
	      });
	    } else {
	      $scope.addresses.splice(index, 1);
	    }
	  };
	
	  $scope.addObject = function(object) {
	    CompanyCustomersService.addObject({
	      companyId: $stateParams.companyId,
	      customerId: $scope.customer.id
	    }, {
	      object: {
	        id: object.id,
	        name: object.name
	      }
	    }, function(){
	      $scope.addedPublication = null;
	      $scope.customer.objects.push(object);
	      growl.addSuccessMessage($translate.instant('customer.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('customer.save-failure'));
	    });
	  };
	
	  $scope.deleteConnectedObject = function(object, index) {
	    CompanyCustomersService.removeObject({
	      companyId: $stateParams.companyId,
	      customerId: $scope.customer.id,
	      objectId: object.id
	    }, function(){
	      $scope.customer.objects.splice(index, 1);
	      growl.addSuccessMessage($translate.instant('customer.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('customer.save-failure'));
	    });
	  };
	
	  $scope.checkCategory = function(id, selected) {
	    if(selected === true){
	      $scope.customer.categoryIds.push(id);
	    }else{
	      $scope.customer.categoryIds.splice($scope.customer.categoryIds.indexOf(id), 1);
	    }
	  };
	
	  $scope.inputTags = angular.copy($scope.customer.tags);
	  $scope.convertTags = function() {
	    var newTags = [];
	    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
	    angular.copy(newTags, $scope.customer.tags);
	  };
	
	  $scope.loadTags = function() {
	    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
	  };
	
	  $scope.createLinkPortal = function() {
	    var customerPortal = new CompanyGroupService({
	      type: 'VISIBLE',
	      name: customer.name,
	      extra: {
	        customer: {
	          id: $scope.customer.id,
	          name: $scope.customer.name
	        }
	      }
	    });
	    customerPortal.$save({companyId: $stateParams.companyId, type: 'VISIBLE'}, function(resp, headers) {
	      var newId = headers('Location').split('/').pop();
	      $state.go('root.company.customerPortals.detail', {companyId: $stateParams.companyId, customerPortalId: newId});
	      growl.addSuccessMessage($translate.instant('customer-portal.create-success'));
	    }, function(){
	      growl.addSuccessMessage($translate('customer-portal.create-failure'));
	    });
	  };
	
	  $scope.filePreview = function(file) {
	    CompanyCustomersService.fileToken({companyId: $stateParams.companyId, customerId: $scope.customer.id, fileId: file.id}, {}, function(response) {
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      var url = config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token;
	
	      var type;
	      switch(file.mimeType) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          type = 'image';
	          break;
	        case 'application/pdf':
	          if (true === iOS) {
	            window.open(url, '_self');
	            return;
	          }
	          type = 'iframe';
	          break;
	        default:
	          type = 'iframe';
	      }
	
	      jQuery.fancybox.open([{
	        type: type,
	        iframe: {
	          preload: false
	        },
	        padding: 0,
	        margin: 0,
	        href: url
	      }]);
	    });
	
	    return false;
	  };
	
	  $scope.downloadFile = function(file) {
	    CompanyCustomersService.fileToken({companyId: $stateParams.companyId, customerId: $scope.customer.id, fileId: file.id}, {}, function(response) {
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token + '&download=true', '_self');
	        return;
	      }
	
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadWindow');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	
	      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token + '&download=true');
	    });
	  };
	}
	
	CompanyCustomerDetailCtrl.resolve = {
	  customer: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService) {
	    return CompanyCustomersService.get({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId}).$promise;
	  }],
	  customerUnits: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
	    return CompanyCustomersService.queryUnits({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId, 
	      limit: 10
	    }).$promise;
	  }],
	  objectSkills: ['$stateParams', 'CompanyObjectSkillsService', function($stateParams, CompanyObjectSkillsService){
	    return CompanyObjectSkillsService.query({
	      companyId: $stateParams.companyId,
	      objectType: 'SKILL_CUSTOMER',
	      objectID: $stateParams.customerId, 
	      limit: 1000
	    }).$promise;
	  }],
	  files: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
	    return CompanyCustomersService.queryFiles({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId
	    }).$promise;
	  }],
	  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
	    return checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.customerId
	        }).$promise;
	  }],
	  addresses: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
	    return CompanyCustomersService.queryAddresses({
	      companyId: $stateParams.companyId,
	      customerId: $stateParams.customerId
	    }).$promise;
	  }],
	  services: ['$stateParams', 'CompanyCustomerService', 'customer', 'info', function($stateParams, CompanyCustomerService, customer, info){
	    if (!info.features.companyService) {
	      return false;
	    }
	    return CompanyCustomerService.query({
	      companyId: $stateParams.companyId,
	      customerId: customer.id
	    }).$promise;
	  }],
	  priceLists: ['$stateParams', 'CompanyProductsService', 'info', function($stateParams, CompanyProductsService, info) {
	    if (!info.features.products) {
	        return false;
	    }
	    return CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, limit: 1000}).$promise;
	  }]
	};
	
	module.exports  = CompanyCustomerDetailCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyCustomerDetailCtrl", CompanyCustomerDetailCtrl);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(4);
	__webpack_require__(16);
	__webpack_require__(336);
	__webpack_require__(337);
	CompanyCustomersDashboardCtrl.$inject = [
	  '$scope',
	  '$timeout',
	  '$stateParams',
	  '$state',
	  'customerStatuses',
	  'CompanyCustomersService',
	  'customerCategories',
	  'customerTypes',
	  'CompanyUserService',
	  'CompanyCustomerServiceTypeService'
	];
	function CompanyCustomersDashboardCtrl
	(
	  $scope,
	  $timeout,
	  $stateParams,
	  $state,
	  customerStatuses,
	  customersService,
	  customerCategories,
	  customerTypes,
	  CompanyUserService,
	  CompanyCustomerServiceTypeService) {
	  if (!$scope.info.features.customers || !$scope.info.features.extendCustomerManage || !$scope.currentUserPermissions.CompanyExtendCustomerList) {
	    $state.go('root.company.403', {}, { location: false });
	  }
	
	  $scope.customerCategories = customerCategories;
	  $scope.customerTypes = customerTypes;
	  $scope.serviceTypes = [];
	  if($scope.info.features.companyService){
	    CompanyCustomerServiceTypeService.query({companyId: $scope.currentCompany.id, limit: 1000}).$promise.then(function(serviceTypes){
	        $scope.serviceTypes = serviceTypes;
	    });
	  }
	
	  $scope.customerStatuses = [];
	
	  $scope.defaultAddress = {
	    streetAddress: "",
	    zipCode: "",
	    city: ""
	  };
	
	  for (var i = 0; i < customerStatuses.length; i++) {
	    if (customerStatuses[i].order > 0) {
	      $scope.customerStatuses.push(customerStatuses[i]);
	    }
	  }
	
	  $scope.queryManager = function(filter) {
	    CompanyUserService.query({companyId: $scope.currentCompany.id, q: filter, limit: 6}).$promise.then(function(users){
	        $scope.managers = users;
	    });
	  };
	}
	
	CompanyCustomersDashboardCtrl.resolve = {
	  customerStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryCustomerStatus({companyId: $stateParams.companyId}).$promise;
	  }],
	  customerCategories: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
	    return CompanyCustomerCategoriesService.query({
	      companyId: $stateParams.companyId,
	      type: 'CATEGORY',
	      limit: 1000
	    }).$promise;
	  }],
	  customerTypes: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
	    return CompanyCustomerCategoriesService.query({
	      companyId: $stateParams.companyId,
	      type: 'TYPE',
	      limit: 1000
	    }).$promise;
	  }]
	};
	
	module.exports = CompanyCustomersDashboardCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCustomersDashboardCtrl', CompanyCustomersDashboardCtrl);


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCustomerCategoriesService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/customers/categories/:categoryId', {}, {
	    'update':  {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyCustomerCategoriesService', ['$resource', 'config', CompanyCustomerCategoriesService]);


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyCustomerServiceTypeService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/service-types/:serviceTypeId', {}, {
	    'update':  {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyCustomerServiceTypeService', ['$resource', 'config', CompanyCustomerServiceTypeService]);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(39);
	
	CompanyDeviationWatcherEditCtrl.$inject = [
	  '$scope',
	  '$state',
	  '$stateParams',
	  '$translate',
	  'deviationWatcher',
	  'CompanyUserService',
	  'CompanyDeviationWatcherService',
	  'growl'
	];
	
	function CompanyDeviationWatcherEditCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  deviationWatcher,
	  CompanyUserService,
	  CompanyDeviationWatcherService,
	  growl) {
	
	  $scope.categories = [
	    'OLYCKA',
	    'FORBATTRINGAR',
	    'REKLAMATIONER',
	    'TILLBUD',
	    'AVVIKELSE',
	    'EKONOMI',
	    'KUND',
	    'LEVERANTOR',
	    'MILJO'
	  ];
	
	  $scope.deviationWatcher = deviationWatcher;
	
	  var nonWatchersPromise;
	  $scope.nonWatchers             = [];
	
	  $scope.updateNonWatchers = function(filter) {
	    var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !$scope.deviationWatcher.watcher.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    
	    nonWatchersPromise = p;
	  };
	
	  $scope.deleteWatcher = function(watcher) {
	    $scope.deviationWatcher.watcher.splice($scope.deviationWatcher.watcher.indexOf(watcher), 1);
	  };
	
	  $scope.save = function() {
	    CompanyDeviationWatcherService.update({companyId: $stateParams.companyId, deviationWatcherId: $stateParams.deviationWatcherId}, $scope.deviationWatcher, function() {
	      growl.addSuccessMessage($translate.instant('deviation.update-deviation-watcher-success'));
	      $state.go('^.list');
	    },
	    function() {
	      growl.addErrorMessage($translate.instant('deviation.update-deviation-watcher-failure'));
	    });
	  };
	
	}
	
	CompanyDeviationWatcherEditCtrl.resolve = {
	  deviationWatcher: ['CompanyDeviationWatcherService', '$stateParams', function(CompanyDeviationWatcherService, $stateParams) {
	    return CompanyDeviationWatcherService.get({companyId: $stateParams.companyId, deviationWatcherId: $stateParams.deviationWatcherId}).$promise;
	  }]
	};
	
	module.exports = CompanyDeviationWatcherEditCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyDeviationWatcherEditCtrl', CompanyDeviationWatcherEditCtrl);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(39);
	
	CompanyDeviationWatcherListCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'growl',
	  '$translate',
	  'deviationWatchers',
	  'CompanyDeviationWatcherService'
	];
	
	function CompanyDeviationWatcherListCtrl(
	  $scope,
	  $stateParams,
	  growl,
	  $translate,
	  deviationWatchers,
	  CompanyDeviationWatcherService
	) {
	  $scope.deviationWatchers = deviationWatchers;
	  $scope.more = false;
	  $scope.page = parseInt($stateParams.page, 10) || 1;
	  
	  if($scope.deviationWatchers.length === 21) {
	     $scope.more = true;
	     $scope.deviationWatchers.pop();
	   }
	
	  $scope.remove = function(deviationWatcher, index) {
	  	CompanyDeviationWatcherService.delete({companyId: $stateParams.companyId, deviationWatcherId: deviationWatcher.id}, function() {
	      growl.addSuccessMessage($translate.instant('deviation.remove-deviation-watcher-success'));
	      $scope.deviationWatchers.splice(index, 1);
	    },
	    function() {
	      growl.addErrorMessage($translate.instant('deviation.remove-deviation-watcher-failure'));
	    });
	  };
	}
	
	CompanyDeviationWatcherListCtrl.resolve = {
	  deviationWatchers: ['CompanyDeviationWatcherService', '$stateParams', function(CompanyDeviationWatcherService, $stateParams) {
	  	var page      = parseInt($stateParams.page, 10) || 1;
	    var filter    = {
	      companyId: $stateParams.companyId,
	      limit:     21,
	      offset:    (page - 1) * 20
	    };
	    return CompanyDeviationWatcherService.query(filter).$promise;
	  }]
	};
	
	module.exports = CompanyDeviationWatcherListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyDeviationWatcherListCtrl', CompanyDeviationWatcherListCtrl);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(39);
	
	CompanyDeviationWatcherNewCtrl.$inject = [
	  '$scope',
	  '$state',
	  '$stateParams',
	  '$translate',
	  'CompanyUserService',
	  'CompanyDeviationWatcherService',
	  'growl'
	];
	
	function CompanyDeviationWatcherNewCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  CompanyUserService,
	  CompanyDeviationWatcherService,
	  growl) {
	
	  $scope.categories = [
	    'OLYCKA',
	    'FORBATTRINGAR',
	    'REKLAMATIONER',
	    'TILLBUD',
	    'AVVIKELSE',
	    'EKONOMI',
	    'KUND',
	    'LEVERANTOR',
	    'MILJO'
	  ];
	
	  $scope.deviationWatcher = {
	    company: $stateParams.companyId,
	    watcher: [],
	    category: 'OLYCKA',
	    description: ''
	  };
	
	  var nonWatchersPromise;
	  $scope.nonWatchers             = [];
	
	  $scope.updateNonWatchers = function(filter) {
	    var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !$scope.deviationWatcher.watcher.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    
	    nonWatchersPromise = p;
	  };
	
	  $scope.deleteWatcher = function(watcher) {
	    $scope.deviationWatcher.watcher.splice($scope.deviationWatcher.watcher.indexOf(watcher), 1);
	  };
	
	  $scope.save = function() {
	    CompanyDeviationWatcherService.save({companyId: $stateParams.companyId}, $scope.deviationWatcher, function() {
	      growl.addSuccessMessage($translate.instant('deviation.create-deviation-watcher-success'));
	      $state.go('^.list');
	    },
	    function() {
	      growl.addErrorMessage($translate.instant('deviation.create-deviation-watcher-failure'));
	    });
	  };
	
	}
	
	
	angular.module('dokiv')
	  .controller('CompanyDeviationWatcherNewCtrl', CompanyDeviationWatcherNewCtrl);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	function EmailToObjectCtrl(
	  $scope,
	  groups,
	  CompanyUserService,
	  $stateParams) {
	  $scope.groups = groups;
	
	  var nonWatchersPromise;
	  $scope.nonWatchers             = [];
	  $scope.updateNonWatchers = function(filter, watchers) {   
	    var p = CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        q: filter,
	        limit: 10}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !watchers.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    
	    nonWatchersPromise = p;
	  };
	
	  $scope.addWatcher = function(item, watchers) {
	    watchers.push(item);
	    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(item), 1);
	  };
	}
	
	EmailToObjectCtrl.resolve = {
	  groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	    return CompanyGroupService.query({
	      companyId: $stateParams.companyId,
	      all: true
	    }).$promise;
	  }]
	};
	
	module.exports = EmailToObjectCtrl; 
	angular.module('dokiv')
	  .controller('EmailToObjectCtrl', [
	    '$scope',
	    'groups',
	    'CompanyUserService',
	    '$stateParams',
	    EmailToObjectCtrl]);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(59);
	
	function EmailToObjectEditCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  priorities,
	  categories,
	  flowVerifies,
	  growl,
	  recv
	  ) {
	  $scope.recv = recv;
	  $scope.priorities = priorities;
	  $scope.categories = categories;
	  $scope.flowVerifies = flowVerifies;
	  $scope.$parent.nonWatchers = [];
	  $scope.save = function() {
	    $scope.recv.$update({
	      companyId: $stateParams.companyId,
	      emailId: $scope.recv.id
	    }, function(){
	      growl.addSuccessMessage($translate.instant('email-to-object.save-success'));
	      $state.go('root.company.account.email.list');
	    }, function(){
	      growl.addErrorMessage($translate.instant('email-to-object.save-failure'));
	    });
	  };
	}
	
	EmailToObjectEditCtrl.resolve = {
	  recv: ['EmailToObjectService', '$stateParams', function(EmailToObjectService, $stateParams){
	    return EmailToObjectService.get({
	      companyId: $stateParams.companyId,
	      emailId: $stateParams.emailId
	    }).$promise;
	  }],
	  categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	    return CompanyCategoryService.query({
	      companyId: $stateParams.companyId,
	      limit: 100
	    }).$promise;
	  }],
	  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function ($stateParams, CompanyFlowVerifiesService) {
	    return CompanyFlowVerifiesService.query({
	      companyId: $stateParams.companyId,
	      limit: 100
	    }).$promise;
	  }]
	};
	
	module.exports = EmailToObjectEditCtrl;
	
	angular.module('dokiv')
	  .controller('EmailToObjectEditCtrl', [
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$translate',
	    'priorities',
	    'categories',
	    'flowVerifies',
	    'growl',
	    'recv',
	    EmailToObjectEditCtrl]);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(345);
	
	var LIMIT = 20;
	function EmailToObjectListCtrl(
	  $scope,
	  $stateParams,
	  $translate,
	  $state,
	  growl,
	  emails
	) {
	  $scope.emails = emails;
	  $scope.page = $stateParams.page|0;
	  if ($scope.emails.length === (LIMIT + 1)) {
	    $scope.more = true;
	    $scope.emails.pop();
	  }
	  $scope.delete = function(item) {
	    item.$delete({
	      companyId: $stateParams.companyId,
	      emailId: item.id
	    }, function() {
	      $scope.emails.splice($scope.emails.indexOf(item), 1);
	      growl.addSuccessMessage($translate.instant('email-to-object.delete-success'));
	    }, function() {
	      growl.addErrorMessage($translate.instant('email-to-object.delete-failure'));
	    });
	  };
	}
	
	EmailToObjectListCtrl.resolve = {
	  emails: ['EmailToObjectService', '$stateParams', function(EmailToObjectService, $stateParams){
	    return EmailToObjectService.query({
	      companyId: $stateParams.companyId,
	      limit: (LIMIT + 1),
	      offset: ($stateParams.page|0) * LIMIT
	    }).$promise;
	  }]
	};
	
	module.exports = EmailToObjectListCtrl;
	
	angular.module('dokiv')
	  .controller('EmailToObjectListCtrl', [
	    '$scope',
	    '$stateParams',
	    '$translate',
	    '$state',
	    'growl',
	    'emails',
	    EmailToObjectListCtrl]);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(59);
	
	function EmailToObjectNewCtrl(
	  $scope,
	  priorities,
	  $stateParams,
	  $state,
	  EmailToObjectService,
	  CompanyFlowVerifiesService,
	  growl,
	  $translate) {
	  $scope.priorities = priorities;
	  $scope.$parent.nonWatchers = [];
	  $scope.recv = new EmailToObjectService({groupIds: [], watchers: [], status: 'PUBLISHED'});
	
	  CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise.then(function(flowVerifies){
	    $scope.flowVerifies = flowVerifies;
	  });
	
	  $scope.save = function() {
	    $scope.recv.$save({
	      companyId: $stateParams.companyId
	    }, function(){
	      growl.addSuccessMessage($translate.instant('email-to-object.create-success'));
	      $state.go('root.company.account.email.list');
	    }, function(){
	      growl.addErrorMessage($translate.instant('email-to-object.create-failure'));
	    });
	  };
	}
	
	angular.module('dokiv')
	  .controller('EmailToObjectNewCtrl', [
	    '$scope',
	    'priorities',
	    '$stateParams',
	    '$state',
	    'EmailToObjectService',
	    'CompanyFlowVerifiesService',
	    'growl',
	    '$translate',
	    EmailToObjectNewCtrl]);

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	function EmailToObjectService(config, $resource) {
	  return $resource(config.apiBase + '/companies/:companyId/emails/:emailId', {}, {
	    "update": {
	      url: config.apiBase + '/companies/:companyId/emails/:emailId',
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('EmailToObjectService', ['config', '$resource', EmailToObjectService]);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	function EmailToTaskCtrl(
	  $scope,
	  $translate,
	  groups,
	  taskTypes,
	  CompanyUserService,
	  $stateParams) {
	  $scope.groups = groups;
	  $scope.importanceColors = [
	    {
	      'type': 'LOW',
	      'color': '#27b96b'
	    },
	    {
	      'type': 'NORMAL',
	      'color': '#27c2eb'
	    },
	    {
	      'type': 'HIGH',
	      'color': '#f29a25'
	    }
	  ];
	
	  $scope.visibilityColors = [
	    {
	      'public': true,
	      'color': '#23a45f'
	    },
	    {
	      'public': false,
	      'color': '#27c2eb'
	    },
	  ];
	
	  $scope.taskTypes = taskTypes;
	
	  var nonWatchersPromise;
	  $scope.nonWatchers             = [];
	  $scope.updateNonWatchers = function(filter, watchers) {   
	    var p = CompanyUserService.query({
	        companyId: $stateParams.companyId,
	        q: filter,
	        limit: 10}).$promise.then(function(users) {
	      return users.filter(function(item) {
	        return !watchers.some(function(watcher) {
	          return item.id === watcher.id;
	        });
	      });
	    }).then(function(nonWatchers) {
	      if(nonWatchersPromise === p) {
	        $scope.nonWatchers = nonWatchers;
	      }
	    });
	    
	    nonWatchersPromise = p;
	  };
	
	  $scope.addWatcher = function(item, watchers) {
	    watchers.push(item);
	    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(item), 1);
	  };
	}
	
	EmailToTaskCtrl.resolve = {
	  groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	    return CompanyGroupService.query({
	      companyId: $stateParams.companyId,
	      all: true
	    }).$promise;
	  }],
	  taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	
	module.exports = EmailToTaskCtrl; 
	angular.module('dokiv')
	  .controller('EmailToTaskCtrl', [
	    '$scope',
	    '$translate',
	    'groups',
	    'taskTypes',
	    'CompanyUserService',
	    '$stateParams',
	    EmailToTaskCtrl]);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	function EmailToTaskEditCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  categories,
	  growl,
	  emailToTask,
	  CompanySettingUnitsService
	  ) {
	  $scope.emailToTask = emailToTask;
	  $scope.categories = categories;
	  $scope.filterUnits = $scope.emailToTask.unit ? $scope.emailToTask.unit.name : "";
	  $scope.saveTask = function() {
	    $scope.emailToTask.$update({
	      companyId: $stateParams.companyId,
	      emailToTaskId: $stateParams.emailToTaskId
	    }, function(){
	      growl.addSuccessMessage($translate.instant('email-to-task.save-success'));
	      $state.go('root.company.account.email-to-task.list');
	    }, function(){
	      growl.addErrorMessage($translate.instant('email-to-task.save-failure'));
	    });
	  };
	
	  $scope.addAssignee = function(assignee) {
	    $scope.emailToTask.assignees.push(assignee);
	    angular.element('#filterAssignees').val('');
	  };
	
	  $scope.addedAssignees = function(assignee) {
	    return ($scope.emailToTask.assignees.indexOf(assignee) === -1);
	  };
	
	  $scope.removeAssignee = function(assignee) {
	    $scope.emailToTask.assignees.splice($scope.emailToTask.assignees.indexOf(assignee), 1);
	  };
	
	  $scope.searchUnits = function(filter) {
	    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10, q: filter}).$promise.then(function(units) {
	      return units.filter(function(item) {
	        return !$scope.emailToTask.unit || ($scope.emailToTask.unit && item.id !== $scope.emailToTask.unit.id);
	      });
	    }).then(function(nonUnits) {
	      $scope.units = nonUnits;
	    });
	  };
	}
	
	EmailToTaskEditCtrl.resolve = {
	  emailToTask: ['EmailToTaskService', '$stateParams', function(EmailToTaskService, $stateParams){
	    return EmailToTaskService.get({
	      companyId: $stateParams.companyId,
	      emailToTaskId: $stateParams.emailToTaskId
	    }).$promise;
	  }],
	  categories: ['$stateParams', 'CompanyTaskService', function ($stateParams, CompanyTaskService) {
	    return CompanyTaskService.queryCategories({
	      companyId: $stateParams.companyId,
	      all: true
	    }).$promise;
	  }]
	};
	
	module.exports = EmailToTaskEditCtrl;
	
	angular.module('dokiv')
	  .controller('EmailToTaskEditCtrl', [
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$translate',
	    'categories',
	    'growl',
	    'emailToTask',
	    'CompanySettingUnitsService',
	    EmailToTaskEditCtrl]);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(350);
	
	var LIMIT = 20;
	function EmailToTaskListCtrl(
	  $scope,
	  $stateParams,
	  $translate,
	  $state,
	  growl,
	  emails
	) {
	  $scope.emails = emails;
	  $scope.page = $stateParams.page|0;
	  if ($scope.emails.length === (LIMIT + 1)) {
	    $scope.more = true;
	    $scope.emails.pop();
	  }
	  $scope.delete = function(item) {
	    item.$delete({
	      companyId: $stateParams.companyId,
	      emailToTaskId: item.id
	    }, function() {
	      $scope.emails.splice($scope.emails.indexOf(item), 1);
	      growl.addSuccessMessage($translate.instant('email-to-task.delete-success'));
	    }, function() {
	      growl.addErrorMessage($translate.instant('email-to-task.delete-failure'));
	    });
	  };
	}
	
	EmailToTaskListCtrl.resolve = {
	  emails: ['EmailToTaskService', '$stateParams', function(EmailToTaskService, $stateParams){
	    return EmailToTaskService.query({
	      companyId: $stateParams.companyId,
	      limit: (LIMIT + 1),
	      offset: ($stateParams.page|0) * LIMIT
	    }).$promise;
	  }]
	};
	
	module.exports = EmailToTaskListCtrl;
	
	angular.module('dokiv')
	  .controller('EmailToTaskListCtrl', [
	    '$scope',
	    '$stateParams',
	    '$translate',
	    '$state',
	    'growl',
	    'emails',
	    EmailToTaskListCtrl]);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	
	  return false;
	}
	
	function EmailToTaskNewCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  EmailToTaskService,
	  CompanySettingUnitsService,
	  CompanyTaskService,
	  growl,
	  $translate) {
	  
	  function checkDueAt() {
	    if($scope.emailToTask.dueAt < $scope.emailToTask.startAt) {
	      $scope.emailToTask.dueAt = new Date($scope.emailToTask.startAt.getTime());
	      $scope.emailToTask.dueAt.setHours($scope.emailToTask.dueAt.getHours() + 1);
	    }
	  }
	
	  var nextDate = new Date();
	      nextDate.setHours(nextDate.getHours() + 1);
	
	  var DEFAULT_EMAIL_TO_TASK = {
	    startAt:    new Date(),
	    dueAt:      nextDate,
	    assignees:  [],
	    public:     true,
	    wholeDay:   false,
	    saveOnlyFile: false,
	    importance: 'NORMAL',
	    type: 'REMINDER',
	    createdBy: $scope.currentUser,
	    publication: null,
	    connectedCustomer: null,
	    reminderDates: [],
	    days: 0
	  };
	
	  DEFAULT_EMAIL_TO_TASK.assignees.push({
	    id:    $scope.currentUser.id,
	    name:  $scope.currentUser.name,
	    email: $scope.currentUser.email
	  });
	
	  $scope.emailToTask = new EmailToTaskService(angular.copy(DEFAULT_EMAIL_TO_TASK));
	
	  CompanyTaskService.queryCategories({companyId: $stateParams.companyId, all: true}).$promise.then(function(categories){
	    $scope.categories = categories;
	  });
	
	  $scope.$watch("[emailToTask.dueAt, emailToTask.startAt]", function(newValue, oldValue) {
	    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
	       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
	      checkDueAt();
	    }
	  }, true);
	
	  $scope.saveTask = function() {
	    $scope.emailToTask.$save({companyId: $stateParams.companyId}, function(){
	      growl.addSuccessMessage($translate.instant('email-to-task.save-success'));
	      $state.go("root.company.account.email-to-task.list");
	    }, function(){
	      growl.addErrorMessage($translate.instant('email-to-task.save-failure'));
	    });
	  };
	
	  $scope.addAssignee = function(assignee) {
	    $scope.emailToTask.assignees.push(assignee);
	    angular.element('#filterAssignees').val('');
	  };
	
	  $scope.addedAssignees = function(assignee) {
	    return ($scope.emailToTask.assignees.indexOf(assignee) === -1);
	  };
	
	  $scope.removeAssignee = function(assignee) {
	    $scope.emailToTask.assignees.splice($scope.emailToTask.assignees.indexOf(assignee), 1);
	  };
	
	  $scope.searchUnits = function(filter) {
	    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10, q: filter}).$promise.then(function(units) {
	      return units.filter(function(item) {
	        return !$scope.emailToTask.unit || ($scope.emailToTask.unit && item.id !== $scope.emailToTask.unit.id);
	      });
	    }).then(function(nonUnits) {
	      $scope.units = nonUnits;
	    });
	  };
	}
	
	angular.module('dokiv')
	  .controller('EmailToTaskNewCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    'EmailToTaskService',
	    'CompanySettingUnitsService',
	    'CompanyTaskService',
	    'growl',
	    '$translate',
	    EmailToTaskNewCtrl]);

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	function EmailToTaskService(config, $resource) {
	  return $resource(config.apiBase + '/companies/:companyId/task-emails/:emailToTaskId', {}, {
	    "update": {
	      url: config.apiBase + '/companies/:companyId/task-emails/:emailToTaskId',
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('EmailToTaskService', ['config', '$resource', EmailToTaskService]);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(11);
	__webpack_require__(40);
	__webpack_require__(26);
	__webpack_require__(29);
	__webpack_require__(46);
	__webpack_require__(353);
	
	function FormAppSubmitGroupDetailCtrl(
	  $scope,
	  FormAppGroup,
	  publications,
	  members,
	  translations,
	  $state,
	  $stateParams,
	  $sce,
	  $window,
	  $filter,
	  FormAppSubmitGroupService,
	  FormAppSubmitGroupUserService,
	  CompanyService,
	  growl
	) {
	
	  $scope.FormAppGroup = FormAppGroup;
	  $scope.publications = publications;
	  $scope.members = members;
	  $scope.tabs = [
	    {
	      'title': $sce.trustAsHtml('customer-portals.documents'),
	      'content': '',
	      'template': 'partials/company/form-app-submit-group/detail/documents.html',
	      'icon': 'file-o'
	    },
	    {
	      'title': $sce.trustAsHtml('customer-portals.info'),
	      'content': '',
	      'template': 'partials/company/form-app-submit-group/detail/info.html',
	      'icon': 'info-circle'
	    },
	    {
	      'title': $sce.trustAsHtml('form-app.start-page'),
	      'content': '',
	      'template': 'partials/company/form-app-submit-group/detail/popup-text.html',
	      'icon': 'bell'
	    }
	  ];
	
	  $scope.tabs.push(
	    {
	      'title': $sce.trustAsHtml('customer-portals.members'),
	      'content': '',
	      'template': 'partials/company/form-app-submit-group/detail/members.html',
	      'icon': 'users'
	    }
	  );
	
	  $scope.tabs.activeTab = 0;
	
	  $scope.save = function() {
	    FormAppSubmitGroupService.update({companyId: $stateParams.companyId, groupId: $scope.FormAppGroup.id}, $scope.FormAppGroup, function() {
	      angular.element('#filterRole').val('');
	      growl.addSuccessMessage(translations['form-app.saved-success']);
	    }, function() {
	      growl.addErrorMessage(translations['form-app.saved-failure']);
	    });
	  };
	
	  $scope.delete = function(id) {
	    FormAppSubmitGroupService.delete({companyId: $stateParams.companyId, groupId: id}, function() {
	      growl.addSuccessMessage(translations['form-app.removed-success']);
	      $state.go('^.list');
	    }, function() {
	      growl.addErrorMessage(translations['form-app.removed-failure']);
	    });
	  };
	
	
	  $scope.removeMember = function(userId) {
	    FormAppSubmitGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.groupId, userId: userId}, function() {
	      $scope.members = $scope.members.filter(function(item) {
	        return item.id !== userId;
	      });
	
	      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
	    }, function() {
	      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
	    });
	  };
	
	  $scope.removePublication = function(publication, index) {
	    if ($scope.FormAppGroup.publicationIds.indexOf(publication.id) > -1) {
	      $scope.FormAppGroup.publicationIds.splice($scope.FormAppGroup.publicationIds.indexOf(publication.id), 1);
	    }
	    
	    $scope.FormAppGroup.$update({companyId: $stateParams.companyId, groupId: $stateParams.groupId}, function() {
	      $scope.publications.splice(index, 1);
	      growl.addSuccessMessage(translations['form-app.remove-publication-success']);
	    }, function() {
	      growl.addErrorMessage(translations['form-app.remove-publication-failure']);
	    });
	  };
	
	  $scope.searchUsers = function(filterUsers){
	    $scope.members = members.filter(function(item){
	      return item.name.toLowerCase().indexOf(filterUsers.toLowerCase()) > -1;
	    });
	  };
	
	}
	
	FormAppSubmitGroupDetailCtrl.resolve = {
	  FormAppGroup: ['$stateParams', 'FormAppSubmitGroupService', function($stateParams, FormAppSubmitGroupService) {
	    return FormAppSubmitGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}).$promise;
	  }],
	  members: ['$stateParams', 'FormAppSubmitGroupUserService', function($stateParams, FormAppSubmitGroupUserService) {
	    return FormAppSubmitGroupUserService.query({
	      companyId: $stateParams.companyId,
	      groupId: $stateParams.groupId,
	      limit: 200}).$promise;
	  }],
	  publications: ['$stateParams', 'FormAppSubmitGroupObjectService', function($stateParams, FormAppSubmitGroupObjectService){
	    return FormAppSubmitGroupObjectService.query({
	      companyId: $stateParams.companyId,
	      groupId: $stateParams.groupId,
	      all: true
	    });
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'form-app.saved-success',
	      'form-app.saved-failure',
	      'form-app.removed-success',
	      'form-app.removed-failure',
	      'customer-portals.add-member-success',
	      'customer-portals.add-member-failure',
	      'customer-portals.remove-member-success',
	      'customer-portals.remove-member-failure',
	      'form-app.remove-publication-success',
	      'form-app.remove-publication-failure',
	      'customer-portals.documents',
	      'customer-portals.members',
	      'customer-portals.info',
	      'customer-portals.add-publication-success',
	      'customer-portals.add-publication-failure',
	      'customer-portal.template.default',
	      'customer-portal.template.my-page',
	      'form-app.start-page'
	    ]);
	  }]
	};
	module.exports = FormAppSubmitGroupDetailCtrl;
	
	angular.module('dokiv')
	  .controller('FormAppSubmitGroupDetailCtrl', [
	    '$scope',
	    'FormAppGroup',
	    'publications',
	    'members',
	    'translations',
	    '$state',
	    '$stateParams',
	    '$sce',
	    '$window',
	    '$filter',
	    'FormAppSubmitGroupService',
	    'FormAppSubmitGroupUserService',
	    'CompanyService',
	    'growl',
	    FormAppSubmitGroupDetailCtrl
	  ]);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(40);
	__webpack_require__(26);
	
	
	function FormAppSubmitGroupNewCtrl(
	  $scope,
	  translations,
	  $state,
	  $stateParams,
	  growl,
	  FormAppSubmitGroupService,
	  CurrentUserService,
	  FormAppSubmitGroupUserService) {
	  $scope.formAppGroup = new FormAppSubmitGroupService({});
	  $scope.state = $state;
	
	  $scope.save = function() {
	    $scope.formAppGroup.$save({companyId: $stateParams.companyId}, function(resp, headers) {
	      $scope.formAppGroupForm.$setPristine();
	      var newId = headers('Location').split('/').pop();
	      if($scope.addCurrentUser) {
	        CurrentUserService.get().then(function(user) {
	          FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, user);
	        });
	      }
	    $state.go('root.company.formAppGroups.detail', {companyId: $stateParams.companyId, groupId: newId});
	    growl.addSuccessMessage(translations['form-app.create-success']);
	    }, function(resp) {
	      if (resp.status === 400 && resp.data.error && resp.data.error.code === 1613) {
	        growl.addErrorMessage(translations['form-app.reached-your-limit']);
	      } else {
	        growl.addErrorMessage(translations['form-app.create-failure']);
	      }
	    });
	  };
	}
	
	FormAppSubmitGroupNewCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'form-app.create-success',
	      'form-app.create-failure',
	      'form-app.reached-your-limit'
	    ]);
	  }]
	};
	module.exports = FormAppSubmitGroupNewCtrl;
	
	angular.module('dokiv')
	  .controller('FormAppSubmitGroupNewCtrl', [
	    '$scope',
	    'translations',
	    '$state',
	    '$stateParams',
	    'growl',
	    'FormAppSubmitGroupService',
	    'CurrentUserService',
	    'FormAppSubmitGroupUserService',
	    FormAppSubmitGroupNewCtrl]);
	


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	'use strict';
	
	function FormAppSubmitGroupObjectService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId/publications');
	}
	
	angular.module('dokiv')
	  .factory('FormAppSubmitGroupObjectService', ['$resource', 'config', FormAppSubmitGroupObjectService]);
	


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	function viewQuestionDetailsDirective() {
	  return {
	    restrict: 'A',
	    scope: {
	      answers: '&openQuestionDetails',
	      question: '=questionData'
	    },
	
	    link: function(scope, elem) {
	      elem.on('click', function(e) {
	        e.preventDefault();
	
	        var q = scope.question;
	
	        var content =
	          '<div class="answer-details__wrap">' +
	            '<p class="answer-details__label">' + 'Displaying details for:' + '</p>' +
	            '<h4 class="answer-details__header">' + q.title + '</h4>' +
	            '<div class="row"><p class="question__description">' + q.description + '</p></div>' +
	
	            '<ol class="answer-details__list">' +
	              '<li class="answer-details__answer">' + scope.answers().filter(function(a) {
	                return !!a.value;
	              }).map(function(a) {
	                return a.value;
	              }).join('</li><li class="answer-details__answer">') + '</li>' +
	            '</ol>' +
	          '</div>';
	
	        jQuery.fancybox.open({
	          type: 'iframe',
	          iframe: {
	            preload: false
	          },
	          padding: 0,
	          margin: [15, 5, 0, 5],
	          content: content
	        });
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('openQuestionDetails', viewQuestionDetailsDirective);


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyGdprContactEditCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  'CompanyGdprContactsService',
	  '$translate',
	  'gdprContact',
	  'growl'];
	
	function CompanyGdprContactEditCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  CompanyGdprContactsService,
	  $translate,
	  gdprContact,
	  growl) {
	  $scope.gdprContact = gdprContact;
	
	  $scope.save = function(gdprContact) {
	    CompanyGdprContactsService.update({companyId: $stateParams.companyId, contactId: $stateParams.contactId}, gdprContact, function() {
	      growl.addSuccessMessage($translate.instant('gdpr.contact.save-success'));
	      $state.go('root.company.account.gdpr-contacts.list');
	    }, function(){
	      growl.addErrorMessage($translate.instant('gdpr.contact.save-failure'));
	    });
	  };
	
	}
	
	CompanyGdprContactEditCtrl.resolve = {
	  gdprContact: ['$stateParams', 'CompanyGdprContactsService', function($stateParams, CompanyGdprContactsService) {
	    return CompanyGdprContactsService.get({companyId: $stateParams.companyId, contactId: $stateParams.contactId}).$promise;
	  }]
	};
	
	module.exports  = CompanyGdprContactEditCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyGdprContactEditCtrl", CompanyGdprContactEditCtrl);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(358);
	var LIMIT = 20;
	CompanyGdprContactListCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'growl',
	  '$translate',
	  'CompanyGdprContactsService',
	  'gdprContacts'];
	
	function CompanyGdprContactListCtrl(
	  $scope,
	  $stateParams,
	  growl,
	  $translate,
	  CompanyGdprContactsService,
	  gdprContacts) {
	
	  $scope.gdprContacts = gdprContacts;
	
	  $scope.delete = function(gdprContact) {
	    CompanyGdprContactsService.delete({companyId: $stateParams.companyId, contactId: gdprContact.id}, function() {
	      growl.addSuccessMessage($translate.instant('gdpr.contact.delete-success'));
	      $scope.gdprContacts.splice($scope.gdprContacts.indexOf(gdprContact), 1);
	    }, function(){
	      growl.addErrorMessage($translate.instant('gdpr.contact.delete-failure'));
	    });
	  };
	}
	
	CompanyGdprContactListCtrl.resolve = {
	  gdprContacts: ['$stateParams', 'CompanyGdprContactsService', function($stateParams, CompanyGdprContactsService) {
	    return CompanyGdprContactsService.query({
	      companyId: $stateParams.companyId,
	      limit: (LIMIT + 1), offset: ($stateParams.page|0) * LIMIT
	    }).$promise;
	  }]
	};
	
	module.exports  = CompanyGdprContactListCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyGdprContactListCtrl", CompanyGdprContactListCtrl);


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	CompanyGdprContactNewCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  'CompanyGdprContactsService',
	  '$translate',
	  'growl'];
	
	function CompanyGdprContactNewCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  CompanyGdprContactsService,
	  $translate,
	  growl) {
	  $scope.save = function(gdprContact) {
	    CompanyGdprContactsService.save({companyId: $stateParams.companyId}, gdprContact, function() {
	      growl.addSuccessMessage($translate.instant('gdpr.contact.save-success'));
	      $state.go('root.company.account.gdpr-contacts.list');
	    }, function(){
	      growl.addErrorMessage($translate.instant('gdpr.contact.save-failure'));
	    });
	  };
	}
	
	angular.module("dokiv")
	  .controller("CompanyGdprContactNewCtrl", CompanyGdprContactNewCtrl);


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGdprContactsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/gdpr-contacts/:contactId', {}, {
	    'update':  {
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyGdprContactsService', ['$resource', 'config', CompanyGdprContactsService]);


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyGroupPublicationService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId/publications/:publicationId', {}, {
	    'update': { method: 'PUT' }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyGroupPublicationService', ['$resource', 'config', CompanyGroupPublicationService]);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(361);
	
	CompanyInvestigationListCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  'investigationList'
	];
	
	function CompanyInvestigationListCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  investigationList
	) {
	  $scope.investigationList = investigationList;
	  $scope.more = false;
	  $scope.page = $stateParams.page|0;
	  if($scope.investigationList.length >= 20) {
	    $scope.more = true;
	  }
	
	  $scope.paramStatus = $stateParams.status || "OPEN";
	  $scope.checkOpenInvestigation = ($scope.paramStatus === 'OPEN' ? true : false);
	  $scope.filterName = $stateParams.qInves;
	  $scope.filterStep = $stateParams.step ? parseInt($stateParams.step) : "";
	
	  $scope.searchInvestigationList = function() {
	    $state.go('.', {
	      status: ($scope.checkOpenInvestigation ? 'OPEN' : 'DONE'),
	      qInves: $scope.filterName,
	      step: $scope.filterStep
	    });
	  };
	}
	
	CompanyInvestigationListCtrl.resolve = {
	  investigationList: ['$stateParams', 'CompanyInvestigationListService', function($stateParams, CompanyInvestigationListService) {
	    return CompanyInvestigationListService.query({
	      companyId: $stateParams.companyId,
	      offset: ($stateParams.page|0) * 20,
	      limit:  21,
	      status: $stateParams.status || "OPEN",
	      step: $stateParams.step,
	      q: $stateParams.qInves
	      }).$promise;
	  }]
	};
	
	module.exports  = CompanyInvestigationListCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyInvestigationListCtrl", CompanyInvestigationListCtrl);


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyInvestigationListService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/investigations', {}, {
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyInvestigationListService', ['$resource', 'config', CompanyInvestigationListService]);


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyNoteService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/notes/:noteId', {}, {
	    "update": {
	      method: "PUT"
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyNoteService', [
	    '$resource',
	    'config',
	    CompanyNoteService
	  ]);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';
	__webpack_require__(41);
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	
	  return false;
	}
	
	CompanyNoticeDetailCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$translate',
	  'noticeCategories',
	  'CompanyNoticeService',
	  'notice',
	  'growl'];
	function CompanyNoticeDetailCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $translate,
	  noticeCategories,
	  CompanyNoticeService,
	  notice,
	  growl) {
	    $scope.noticeCategories = noticeCategories;
	    $scope.notice = notice;
	
	    $scope.notice.enddate   = new Date($scope.notice.enddate);
	    $scope.notice.reminderAt     = new Date($scope.notice.reminderAt);
	
	    $scope.isEdited = false;
	    $scope.selectedMonth = null;
	    
	    $scope.setNoticePeriod = function(m) {
	      $scope.selectedMonth = m;
	      $scope.notice.reminderAt = moment($scope.notice.enddate).subtract(m, (m === 1 ? 'month' : 'months'));
	      if (m === 1) {
	        $scope.notice.noticePeriod = $translate.instant('task.1-month');
	      } else if(m === 2) {
	        $scope.notice.noticePeriod = $translate.instant('task.2-months');
	      } else if(m === 3) {
	        $scope.notice.noticePeriod = $translate.instant('task.3-months');
	      } else if(m === 6) {
	        $scope.notice.noticePeriod = $translate.instant('task.6-months');
	      } else if (m === 9) {
	        $scope.notice.noticePeriod = $translate.instant('task.9-months');
	      } else if (m === 12) {
	        $scope.notice.noticePeriod = $translate.instant('task.12-months');
	      }
	    };
	
	    $scope.checkReminderDate = function() {
	      if($scope.notice.reminderAt >= $scope.notice.enddate) {
	        $scope.setNoticePeriod(1);
	      }
	    };
	
	    $scope.$watch("[notice.enddate,notice.reminderAt]", function(newValue, oldValue) {
	      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
	         newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
	        $scope.checkReminderDate();
	      }
	      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])){
	        $scope.setNoticePeriod($scope.selectedMonth);
	      }
	    }, true);
	 
	    $scope.saveNotice = function() {
	      var r  = angular.copy($scope.notice);
	      r.$update({companyId: $stateParams.companyId, noticeId: r.id}, function(){
	        growl.addSuccessMessage($translate.instant('notices.update-success'));
	        $scope.isEdited = true;
	      }, function(){
	        growl.addErrorMessage($translate.instant('notices.update-failure'));
	      });
	    };
	
	    $scope.setCompleted = function() {
	      if ($scope.notice.status) {
	        $scope.notice.status = false;
	      }else{
	        $scope.notice.status = true;
	      }
	      $scope.saveNotice();
	      $scope.hide(true);
	    };
	
	    $scope.hide = function(isEdited) {
	      if ($state.current.name !== 'root.company.notices.detail') {
	        $scope.$hide();
	      } else {
	        if ($scope.isEdited === true || angular.isDefined(isEdited)) {
	          $state.go('.^', {}, {reload: true});
	        } else {
	          $state.go('.^');
	        }
	      }
	    };
	
	    $scope.deleteReminder = function(reminder) {
	      CompanyNoticeService.delete({companyId: $stateParams.companyId, noticeId: reminder.id}, function(){
	        growl.addSuccessMessage($translate.instant('notices.delete-success'));
	      }, function(){
	        growl.addErrorMessage($translate.instant('notices.delete-failure'));
	      })
	    }
	}
	
	CompanyNoticeDetailCtrl.resolve = {
	  notice: ['$stateParams', 'CompanyNoticeService', function($stateParams, CompanyNoticeService) {
	    return CompanyNoticeService.get({
	      companyId: $stateParams.companyId,
	      noticeId: $stateParams.noticeId
	    }).$promise;
	  }],
	  noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
	    return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
	  }]
	};
	
	module.exports = CompanyNoticeDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyNoticeDetailCtrl', CompanyNoticeDetailCtrl);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(41);
	var moment = __webpack_require__(1);
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	  return false;
	}
	
	CompanyNoticeNewCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$translate',
	  'noticeCategories',
	  'CompanyNoticeService',
	  'growl'];
	function CompanyNoticeNewCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $translate,
	  noticeCategories,
	  CompanyNoticeService,
	  growl) {
	    $scope.noticeCategories = noticeCategories;
	    var endDateDefault = new Date();
	        endDateDefault = moment(endDateDefault).add(1, 'year');
	
	    var reminderAtDefault = new Date();
	        reminderAtDefault.setDate(reminderAtDefault.getDate() + 30);
	
	    var DEFAULT_NOTICE = {
	      assignees:  [],
	      createdAt: reminderAtDefault,
	      enddate: endDateDefault,
	      title: $scope.publication.name,
	      createdBy: $scope.currentUser,
	      description: '',
	      reminderAt: reminderAtDefault,
	      noticePeriod: $translate.instant('task.1-month'),
	      publication: $scope.publication
	    };
	    
	
	    DEFAULT_NOTICE.assignees.push({
	      id:    $scope.currentUser.id,
	      name:  $scope.currentUser.name,
	      email: $scope.currentUser.email
	    });
	
	    $scope.notice = new CompanyNoticeService(angular.copy(DEFAULT_NOTICE));
	    $scope.selectedMonth = 1;
	 
	    $scope.setNoticePeriod = function(m) {
	      $scope.selectedMonth = m;
	      $scope.notice.reminderAt = moment($scope.notice.enddate).subtract(m, (m === 1 ? 'month' : 'months'));
	      if (m === 1) {
	        $scope.notice.noticePeriod = $translate.instant('task.1-month');
	      } else if(m === 2) {
	        $scope.notice.noticePeriod = $translate.instant('task.2-months');
	      } else if(m === 3) {
	        $scope.notice.noticePeriod = $translate.instant('task.3-months');
	      } else if(m === 6) {
	        $scope.notice.noticePeriod = $translate.instant('task.6-months');
	      } else if (m === 9) {
	        $scope.notice.noticePeriod = $translate.instant('task.9-months');
	      } else if (m === 12) {
	        $scope.notice.noticePeriod = $translate.instant('task.12-months');
	      }
	    };
	
	    $scope.checkReminderDate = function() {
	      if($scope.notice.reminderAt >= $scope.notice.enddate) {
	        $scope.setNoticePeriod(1);
	      }
	    };
	
	    $scope.$watch("[notice.enddate,notice.reminderAt]", function(newValue, oldValue) {
	      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
	        newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
	        $scope.checkReminderDate();
	      }
	      if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])){
	        $scope.setNoticePeriod($scope.selectedMonth);
	      }
	    }, true);
	
	    $scope.saveNotice = function() {
	      $scope.notice.$save({companyId: $stateParams.companyId}, function(){
	        growl.addSuccessMessage($translate.instant('notices.update-success'));
	        $state.reload();
	      }, function(){
	        growl.addErrorMessage($translate.instant('notices.update-failure'));
	      });
	    };
	}
	
	angular.module('dokiv')
	  .controller('CompanyNoticeNewCtrl', CompanyNoticeNewCtrl);


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyNotificationsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/notifications/:notificationId', {}, {
	    'query': {
	      isArray: false
	    },
	    'queryNotificationsUser': {
	    	url: config.apiBase + '/users/:userId/notifications',
	    	method: 'GET',
	      isArray: false
	    },
	    'update': {
				method: 'PUT'
	    },
	    'updateNotificationsUser': {
	      url: config.apiBase + '/users/:userId/notifications',
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyNotificationsService', ['$resource', 'config', CompanyNotificationsService]);


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(66);
	
	CompanyObjectSkillsCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$q',
	  'growl',
	  '$translate',
	  'CompanyObjectSkillsService',
	  'object',
	  'objectType',
	  'skills'
	];
	
	function CompanyObjectSkillsCtrl(
	  $scope,
	  $stateParams,
	  $q,
	  growl,
	  $translate,
	  CompanyObjectSkillsService,
	  object,
	  objectType,
	  skills) {
	
	  $scope.skills = skills;
	  angular.forEach($scope.skills, function(skill){
	    var objectSkillC = $scope.objectSkills.filter(function(item){
	      return skill.id === item.skill.id;
	    })[0];
	    if(objectSkillC){
	      skill.selected = true;
	      skill.endDate = objectSkillC.endDate;
	    }
	  });
	
	  $scope.saveObjectSkills = function() {
	    $q.all(
	      angular.forEach($scope.skills, function(skill){
	        var objectSkill = $scope.objectSkills.filter(function(item){
	          return skill.id === item.skill.id;
	        })[0];
	        if(skill.selected){
	          if(!objectSkill){
	            CompanyObjectSkillsService.save({companyId: $scope.companyId}, {
	              skill: {id: skill.id, name: skill.name},
	              endDate: skill.endDate,
	              object: {id: object.id, name: object.name},
	              objectType: objectType
	            }, function(res){
	              $scope.objectSkills.push(res);
	            });
	          }else{
	            CompanyObjectSkillsService.update({companyId: $scope.companyId, objectSkillId: objectSkill.id}, {
	              skill: {id: skill.id, name: skill.name},
	              endDate: skill.endDate,
	              object: {id: object.id, name: object.name},
	              objectType: objectType,
	              id: objectSkill.id
	            });
	            $scope.objectSkills[$scope.objectSkills.indexOf(objectSkill)].endDate = skill.endDate;
	          }
	        }
	        if(!skill.selected && objectSkill){
	          CompanyObjectSkillsService.delete({companyId: $scope.companyId, objectSkillId: objectSkill.id}, function(){
	            $scope.objectSkills.splice($scope.objectSkills.indexOf(objectSkill), 1);
	          });
	        }
	      })
	    ).then(function(){
	        growl.addSuccessMessage($translate.instant('skills.save-success'));
	        $scope.$hide();
	    }, function(){
	      growl.addErrorMessage($translate.instant('skills.save-failure'));
	    });
	  };
	
	}
	
	angular.module('dokiv')
	  .controller('CompanyObjectSkillsCtrl', CompanyObjectSkillsCtrl);

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyObjectSkillsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/object-skills/:objectSkillId', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'delete': {
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyObjectSkillsService', ['$resource', 'config', CompanyObjectSkillsService]);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyOrderTypeService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/order-types/:orderTypeId', {}, {
	    'update':  {
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyOrderTypeService', ['$resource', 'config', CompanyOrderTypeService]);


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	CompanyAddContactsCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'contacts',
	  'CompanyAddressBookService'];
	function CompanyAddContactsCtrl(
	  $scope,
	  $stateParams,
	  contacts,
	  CompanyAddressBookService) {
	  var nonContactsAddedPromise = contacts;
	  if($scope.projectEdit && $scope.projectEdit.contacts.length){
	    nonContactsAddedPromise = contacts.filter(function(v) {
	      return !$scope.projectEdit.contacts.some(function (u) {
	        return v.id === u.id;
	      });
	    });
	  }
	  $scope.nonContactsAdded = nonContactsAddedPromise;
	
	  $scope.newContact = {
	    contactName: "",
	    contactPhone: "",
	    contactEmail: "",
	    contactWeb: ""
	  };
	
	  $scope.changeNewContact = function(contact){
	    if($scope.newContact && $scope.newContact.id && $scope.newContact.id === contact.id){
	      $scope.newContact = {
	        contactName: "",
	        contactPhone: "",
	        contactEmail: "",
	        contactWeb: ""
	      };
	      angular.forEach($scope.nonContactsAdded, function(c){
	        c.selected = false;
	      });
	    }else{
	      $scope.newContact = contact;
	      angular.forEach($scope.nonContactsAdded, function(c){
	        if(c.id === $scope.newContact.id){
	          c.selected = true;
	        }else{
	          c.selected = false;
	        }
	      });
	    }
	  };
	
	  $scope.saveContact = function(contact) {
	    if(!contact.id){
	      CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function(resp){
	        $scope.nonContactsAdded.push(resp);
	        $scope.newContact = {
	          contactName: "",
	          contactPhone: "",
	          contactEmail: "",
	          contactWeb: ""
	        };
	      });
	    }else{
	      CompanyAddressBookService.update({companyId: $stateParams.companyId, contactId: contact.id}, contact);
	    }
	  };
	
	  $scope.queryContacts = function(filter) {
	    CompanyAddressBookService.query({companyId: $stateParams.companyId, limit: 20, q: filter}).$promise.then(function(resp){
	      $scope.nonContactsAdded = resp;
	    });
	  };
	
	  $scope.addCustomerContacts = function() {
	    if($scope.newContact.id){
	      if($scope.projectEdit && $scope.projectEdit.contacts){
	        $scope.projectEdit.contacts.push($scope.newContact);
	        $scope.newContact = {
	          contactName: "",
	          contactPhone: "",
	          contactEmail: "",
	          contactWeb: ""
	        };
	      }else{
	        $scope.addContact($scope.newContact);
	      }
	    }
	  };
	
	  $scope.removeContact = function(contact) {
	    if(contact.id){
	      CompanyAddressBookService.delete({companyId: $stateParams.companyId, contactId: contact.id}).$promise.then(function(){
	        $scope.nonContactsAdded.splice($scope.nonContactsAdded.indexOf(contact), 1);
	        $scope.newContact = {
	          contactName: "",
	          contactPhone: "",
	          contactEmail: "",
	          contactWeb: ""
	        };
	      });
	    }
	  };
	
	}
	
	angular.module('dokiv')
	  .controller('CompanyAddContactsCtrl', CompanyAddContactsCtrl);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyProjectService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/projects/:projectId', {}, {
	    'update':  {
	      method: 'PUT'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyProjectService', ['$resource', 'config', CompanyProjectService]);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var PAGESIZE = 20;
	
	__webpack_require__(6);
	__webpack_require__(42);
	
	function EsignActivity(CompanyPublicationActivity, CompanyPublicationActivityTranslator, $stateParams) {
	  return {
	    restrict:    "A",
	    templateUrl: "partials/company/publications/esign-activity.html",
	    scope: {
	      source:   "=esignActivity",
	      user:     "=user"
	    },
	    link: function($scope) {
	      $scope.loading    = false;
	      $scope.page       = 0;
	      $scope.activity   = [];
	      $scope.PAGESIZE   = PAGESIZE;
	      
	      $scope.loadData = function loadData() {
	        $scope.loading = true;
	        $scope.page    = $scope.page > 0 ? $scope.page : 0;
	
	        /* TODO: That toUpperCase() should be removed
	         * and all constants should be uppercase instead.
	         */
	        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, ['AUDITLOG']).then(function(activity) {
	          $scope.hasNextPage = activity.length > PAGESIZE;
	          $scope.loading     = false;
	          $scope.activity    = activity.map(CompanyPublicationActivityTranslator).sort(function(a, b) {
	            if (a.user && a.user.name === "A L L") {
	              return -1;
	            }
	            return 0;
	          });
	        });
	      };
	      
	      if( ! $scope.types) {
	        $scope.types = [];
	      }
	
	      $scope.$on('notification', function(){
	        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	        $scope.page = 0;
	        $scope.loading = true;
	        $scope.loadData();
	      });
	      
	      $scope.loadData();
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("esignActivity", ["CompanyPublicationActivity", "CompanyPublicationActivityTranslator", "$stateParams", EsignActivity]);


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyPublicationCertifyDocCtrl.$inject = [
	  "$scope",
	  "$state",
	  "$stateParams",
	  "$translate",
	  "growl",
	  "CompanyPublicationService"
	];
	
	function CompanyPublicationCertifyDocCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  growl,
	  CompanyPublicationService
	) {
	  $scope.certify = {
	    password: '',
	    sign: ''
	  };
	  $scope.saveCertifyDoc = function(){
	    CompanyPublicationService.updateCertifyDoc({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, $scope.certify).$promise.then(function(res) {
	      growl.addSuccessMessage($translate.instant('publication.save-certificate-document-success'));
	      if (!$scope.$parent.$parent.publication.extra.flowCertificates){
	        $scope.$parent.$parent.publication.extra.flowCertificates = [{flowId: res.flowId, signDone : false, certificates:[]}];
	      }
	        var currentFlowCertificates = $scope.$parent.$parent.publication.extra.flowCertificates.filter(function(item){
	          return item.signDone === false;
	        });
	        $scope.$parent.$parent.publication.extra.flowCertificates[
	            $scope.$parent.$parent.publication.extra.flowCertificates.indexOf(currentFlowCertificates[0])
	        ].certificates.push(res.certificate);
	        if (res.certificate.signDone){
	            $scope.$parent.$parent.publication.extra.flowCertificates[
	                $scope.$parent.$parent.publication.extra.flowCertificates.indexOf(currentFlowCertificates[0])
	            ].signDone = true;
	        }
	
	    }, function(err) {
	      if(err.status === 400){
	        growl.addErrorMessage(err.data);
	      }else{
	        growl.addErrorMessage($translate.instant('publication.save-certificate-document-failure'));
	      }
	    });
	  };
	
	  $scope.hide = function() {
	    $scope.$hide();
	  };
	}
	
	angular.module("dokiv")
	  .controller("CompanyPublicationCertifyDocCtrl", CompanyPublicationCertifyDocCtrl);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(33);
	__webpack_require__(5);
	
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(28);
	__webpack_require__(371);
	__webpack_require__(391);
	__webpack_require__(30);
	__webpack_require__(417);
	__webpack_require__(376);
	__webpack_require__(369);
	__webpack_require__(362);
	__webpack_require__(368);
	var moment = __webpack_require__(1);
	
	CompanyPublicationCtrl.$inject = [
	  '$scope',
	  '$rootScope',
	  '$stateParams',
	  '$filter',
	  '$modal',
	  '$translate',
	  'publication',
	  'investigation',
	  'children',
	  'priorities',
	  'notes',
	  'activityService',
	  'CompanyPublicationFileService',
	  'CompanyPublicationService',
	  'CompanyPublicationCompanyOrderService',
	  'CompanyProjectService',
	  'CompanyOrderTypeService',
	  'CompanySettingUnitsService',
	  'CompanyPublicationCompanyOrderSubcriptionService',
	  'CompanyPublicationCompanyInvestigationService',
	  'CompanyPublicationEsignService',
	  'CompanyNoteService',
	  'growl',
	  'translations',
	  'config',
	  '$http',
	  '$q',
	  '$state',
	  'initialActivity'/* Here to wait for it this to load */
	];
	
	function CompanyPublicationCtrl(
	  $scope,
	  $rootScope,
	  $stateParams,
	  $filter,
	  $modal,
	  $translate,
	  publication,
	  investigation,
	  children,
	  priorities,
	  notes,
	  activityService,
	  CompanyPublicationFileService,
	  CompanyPublicationService,
	  publicationCompanyOrderService,
	  CompanyProjectService,
	  CompanyOrderTypeService,
	  CompanySettingUnitsService,
	  publicationCompanyOrderSubcriptionService,
	  CompanyPublicationCompanyInvestigationService,
	  CompanyPublicationEsignService,
	  CompanyNoteService,
	  growl,
	  translations,
	  config,
	  $http,
	  $q,
	  $state) {
	  $scope.showPortalTab          = true;
	  $scope.showChildrentab        = false;
	  $scope.showVersionsTab        = $scope.currentUserPermissions.CompanySeeFileVersion ? (publication.versionNumber > 1 ? true : false) : false;
	  $scope.showShareTab           = $scope.info.features.shareObject;
	  $scope.activityService        = activityService;
	  $scope.showOrderReport        = false;
	  $scope.showPlantReport        = false;
	  $scope.notes                  = notes;
	  $rootScope.investigationInfors = [];
	
	  if(publication.type === 'FORM'){
	    if (
	      publication.features.formActived === "false" ||
	      !!publication.features.formActived === false
	    ) {
	      window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
	    }else{
	      window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
	    }
	  }
	  if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
	    window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
	  }
	  if(publication.type === 'COMPANY_ORDER'){
	    window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
	  }
	  if(publication.type === 'ORDER_SUBCRIPTION'){
	    window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
	  }
	
	  if(publication.type === 'DEFAULT' && $scope.info.features.esign){
	    $scope.newEsign = {
	      publication: publication,
	      active: true,
	      deadline: moment(new Date()).add(30, 'day'),
	      extra: {
	        emails: []
	      }
	    };
	    $scope.toggleCreateEsign = false;
	    CompanyPublicationEsignService.query({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: 1
	    }).$promise.then(function(esigns){
	      if(esigns.length){
	        $scope.newEsign = esigns[0];
	        $scope.toggleCreateEsign = true;
	      }
	    });
	
	    $scope.newUser = {
	      name: '',
	      email: '',
	      phone: '',
	      company: ''
	    };
	
	    $scope.addEsignEmail = function(){
	      $scope.newEsign.extra.emails.push($scope.newUser); 
	      $scope.newUser = {
	        name: '',
	        email: '',
	        phone: '',
	        company: ''
	      };
	    };
	
	    $scope.fillMyInfo = function(){
	      $scope.newUser = {
	        name: $scope.currentUser.name,
	        email: $scope.currentUser.email,
	        phone: $scope.currentUser.contacts.mobilePhone,
	        company: $scope.info.Name
	      };
	    };
	
	    $scope.addContact = function(newContact){
	      $scope.newUser = {
	        name: newContact.contactName,
	        email: newContact.contactEmail,
	        phone: newContact.contactPhone,
	        company: newContact.contactWeb
	      };
	    };
	
	    $scope.showModalAddContacts = function(){
	      var modal = $modal({
	        scope: $scope,
	        controller: 'CompanyAddContactsCtrl',
	        templateUrl: 'partials/company/projects/modal-add-contacts.html',
	        show: false,
	        resolve: {
	          contacts: ['$stateParams', 'CompanyAddressBookService', function($stateParams, CompanyAddressBookService) {
	            return CompanyAddressBookService.query({companyId: $stateParams.companyId, limit: 20}).$promise;
	          }]
	        }
	      });
	
	      modal.$promise.then(function(){
	        modal.show();
	      });
	    }
	
	    $scope.resend = function(){
	      CompanyPublicationEsignService.update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, eSignId: $scope.newEsign.ID}, $scope.newEsign, function() {
	        growl.addSuccessMessage($translate.instant('publication.resent-esign-success'));
	      }, function() {
	        growl.addErrorMessage($translate.instant('publication.resent-esign-failure'));
	      });
	    };
	
	    $scope.createEsign = function(){
	      if(!$scope.newEsign.ID){
	        $scope.newEsign.sharedBy = $scope.currentUser;
	        CompanyPublicationEsignService.save({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.newEsign, function(res) {
	          $scope.newEsign = res;
	          growl.addSuccessMessage($translate.instant('publication.created-esign-success'));
	        }, function() {
	          growl.addErrorMessage($translate.instant('publication.created-esign-failure'));
	        });
	      }else{
	        CompanyPublicationEsignService.update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.newEsign, function() {
	          growl.addSuccessMessage($translate.instant('publication.canceled-esign-success'));
	        }, function() {
	          growl.addErrorMessage($translate.instant('publication.canceled-esign-failure'));
	        });
	      }
	    };
	  }
	
	  $scope.order = false;
	  if(publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION'){
	    $scope.paymentTypes = [
	      {
	        'name': translations['order.payment.cash-on-delivery'],
	        'value': 'CASH_ON_DELIVERY'
	      }, {
	        'name': translations['order.payment.10-days'],
	        'value': '10_DAYS'
	      }, {
	        'name': translations['order.payment.20-days'],
	        'value': '20_DAYS'
	      }, {
	        'name': translations['order.payment.30-days'],
	        'value': '30_DAYS'
	      }
	    ];
	
	    CompanySettingUnitsService.query({
	      companyId: $stateParams.companyId,
	      limit: 1000
	    }, function(resp){
	      $scope.units = resp;
	    });
	
	    CompanyOrderTypeService.query({
	      companyId: $stateParams.companyId,
	      limit: 1000
	    }, function(orderTypes){
	      $scope.orderTypes = orderTypes;
	    });
	
	    $q.all(CompanyProjectService.query({
	      companyId: $stateParams.companyId,
	      limit: 1000
	    }, function(resp){
	      $scope.projects = resp;
	    })).then(function(){
	      if (publication.features.currentCompanyOrderId) {
	        var order, dataOrder;
	        if(publication.type === 'COMPANY_ORDER'){
	          order = angular.copy(publicationCompanyOrderService);
	          dataOrder = {
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            orderId: publication.features.currentCompanyOrderId
	          };
	        }else{
	          order = angular.copy(publicationCompanyOrderSubcriptionService);
	          dataOrder = {
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            subcriptionId: publication.features.currentCompanyOrderId
	          };
	        }
	        order.get(dataOrder).$promise.then(function(order){
	          $scope.order = order;
	          $scope.showCustomerInfo = true;
	          if(publication.type === 'ORDER_SUBCRIPTION'){
	            var subcription            = $scope.order.interval.split(' ');
	            $scope.order.subcriptionNumber   = parseInt(subcription[0]);
	            $scope.order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
	            if(!$scope.order.lastGenAt){
	              $scope.order.lastGenAt = $scope.order.createdAt;
	            }
	            if($scope.order.startAt >= $scope.order.lastGenAt){
	              $scope.order.nextCreatedOrder = moment($scope.order.startAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	            }else{
	              $scope.order.nextCreatedOrder = moment($scope.order.lastGenAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	            }
	          }
	
	          updateTotal();
	          $scope.filterPriceListName();
	        });
	      }else{
	        $scope.filterPriceListName();
	      }
	    });
	
	    $scope.filterPriceListName = function() {
	      if($scope.order && $scope.order.customer && $scope.order.customer.priceList !== null){
	        $scope.currentProject = $scope.order.customer.priceList;
	      }else{
	        if ($scope.order.project && $scope.order.project.id && $scope.projects) {
	          var currentProject = $scope.projects.filter(function(project){
	            return project.id === $scope.order.project.id;
	          });
	
	          if (currentProject.length > 0) {
	            $scope.currentProject = currentProject[0].price_list;
	          }
	        }
	      }
	    };
	
	    $scope.setDefautPricelist = function(order) {
	      $scope.order = order;
	      $scope.filterPriceListName();
	      if (($scope.order.project && $scope.order.project.id) || ($scope.order.customer && $scope.order.customer.priceList !== null)) {
	        angular.forEach($scope.order.items ,function(v){
	          if (v.price.priceListId !== $scope.currentProject.id) {
	            angular.forEach(v.product.pricelist, function(p){
	              if ($scope.currentProject.id === p.priceListId) {
	                v.price = angular.copy(p);
	                v.price.soldPrice = v.price.price;
	                if($scope.publication.type === 'ORDER_SUBCRIPTION'){
	                  publicationCompanyOrderSubcriptionService.updateItem({
	                    companyId: $stateParams.companyId,
	                    publicationId: $stateParams.publicationId,
	                    subcriptionId: $scope.order.id,
	                    itemId: v.id
	                  }, v);
	                }else{
	                  publicationCompanyOrderService.updateItem({
	                    companyId: $stateParams.companyId,
	                    publicationId: $stateParams.publicationId,
	                    orderId: $scope.order.id,
	                    itemId: v.id
	                  }, v);
	                }
	              }
	            });
	          }
	        });
	      }
	      updateTotal();
	      $scope.$broadcast('orderChanged', $scope.order);
	    };
	
	    var totalOrder = function(includeTax) {
	      var total = 0;
	      if ($scope.order) {
	        angular.forEach($scope.order.items, function(v){
	          if (includeTax) {
	            total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
	          } else {
	            total += v.price.soldPrice * v.amount;
	          }
	        });
	      }
	
	      return total;
	    };
	
	    var updateTotal =  function() {
	      $scope.totalExcludeTax = totalOrder();
	      $scope.totalIncludeTax = totalOrder(true);
	      $scope.totalTax        = totalOrder(true) - totalOrder();
	    };
	
	    $scope.updateTotal = updateTotal;
	
	    $scope.update = function(order) {
	      var o = angular.copy(order);
	      if(o.customerOrderNr === ''){
	        o.customerOrderNr = null;
	      }
	      if(publication.type === 'ORDER_SUBCRIPTION'){
	        o.interval = o.subcriptionNumber + ' ' + o.optionSubcription + (o.subcriptionNumber > 1 ? 's' : '');
	      }
	      o.$update({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId
	      }, function(){
	        growl.addSuccessMessage(translations['order.update-success']);
	        if(publication.type === 'ORDER_SUBCRIPTION'){
	          var subcription            = o.interval.split(' ');
	          o.subcriptionNumber   = parseInt(subcription[0]);
	          o.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
	          if(!o.lastGenAt){
	            o.lastGenAt = o.createdAt;
	          }
	          if(o.startAt >= o.lastGenAt){
	            o.nextCreatedOrder = moment(o.startAt).add(parseInt(o.subcriptionNumber), o.optionSubcription+(o.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	          }else{
	            o.nextCreatedOrder = moment(o.lastGenAt).add(parseInt(o.subcriptionNumber), o.optionSubcription+(o.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	          }
	        }
	        $scope.$broadcast('orderChanged', o);
	      }, function(){
	        growl.addErrorMessage(translations['order.update-failure']);
	      });
	    };
	
	    $scope.createNextOrder = function(){
	      publicationCompanyOrderSubcriptionService.createNextOrder({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        subcriptionId: $scope.order.id
	      }, {}, function(){
	        growl.addSuccessMessage(translations['order.create-next-order-success']);
	      }, function(){
	        growl.addErrorMessage(translations['order.create-next-order-failure']);
	      });
	    };
	
	    $scope.createAllCopies = function(orderCopies){
	      publicationCompanyOrderService.copyOrder({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: $scope.order.id
	      }, orderCopies, function(){
	        growl.addSuccessMessage(translations['order.create-all-copies-success']);
	        angular.element('.filterDate').val('');
	      }, function(){
	        growl.addErrorMessage(translations['order.create-all-copies-failure']);
	      });
	    };
	  }
	
	  if(publication.type === 'INVESTIGATION'){
	    $scope.activeTab = 0;
	    $scope.investigation = investigation;
	    $scope.investigationSteps = [{
	      name: translations['investigation.parter-and-information'],
	      template: 'partials/company/publications/investigation/parter-information.html',
	      success: false
	    },{
	      name: translations['investigation.statement'],
	      template: 'partials/company/publications/investigation/statement.html',
	      success: false
	    },{
	      name: translations['investigation.summary'],
	      template: 'partials/company/publications/investigation/summary.html',
	      success: false
	    },{
	      name: translations['investigation.decision'],
	      template: 'partials/company/publications/investigation/decision.html',
	      success: false
	    }];
	
	    var queryFiles =  function() {
	      return CompanyPublicationFileService.query({
	        companyId:     $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        limit:         21,
	        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	        offset:        ($stateParams.page|0) * 20
	      }).$promise.then(function(files) {
	        $scope.$emit('publicationSaved');
	        $scope.files   = files.slice(0, 20);
	        $scope.hasMore = files.length > 20;
	      });
	    };
	
	    CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         22,
	      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	      offset:        ($stateParams.page|0) * 21,
	      q:             $stateParams.searchFile || "",
	      searchAble: true
	    }).$promise.then(function(files){
	      $scope.files = files;
	      $scope.hasMore = files.length > 21;
	      $scope.$on("files-uploaded", queryFiles);
	    });
	
	    $scope.setReminderDate = function(investigationAtgardInfor){
	      var indexInvesAtgardInfor = $scope.investigationAtgardInfors.indexOf(investigationAtgardInfor);
	      var varnadNumber = investigationAtgardInfor.periodUp.split(' ');
	      $scope.investigationAtgardInfors[indexInvesAtgardInfor].lastDate = moment(investigationAtgardInfor.varnadDate).add(parseInt(varnadNumber[0]), ((varnadNumber[1] === 'mon' || varnadNumber[1] === 'mons') ? 'months' : varnadNumber[1])).format('YYYY-MM-DD');
	      $scope.investigationAtgardInfors[indexInvesAtgardInfor].reminderDate = moment($scope.investigationAtgardInfors[indexInvesAtgardInfor].lastDate).subtract(3, 'days').format('YYYY-MM-DD');
	    };
	
	    CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit: 100,
	      offset: 0,
	      type: 'ATGARD'
	    }).$promise.then(function(investigationAtgardInfors){
	      $scope.investigationAtgardInfors = investigationAtgardInfors;
	      if(investigationAtgardInfors.length === 0){
	        $scope.createNewInvestigationAtGardInfor();
	      }else{
	        angular.forEach(investigationAtgardInfors, function(value, key){
	          $scope.investigationSteps.push({
	            name: translations['investigation.action-and-follow-up'],
	            template: 'partials/company/publications/investigation/action-and-follow-up.html',
	            success: (key < investigationAtgardInfors.length-1 ? true : (investigation.status === 'DONE' ? ((value.followUpDate && value.followUpContent) ? true : false) : false))
	          });
	          if(value.followUpDate && value.followUpContent){
	            $scope.investigationAtgardInfors[key].savedFollowUp = true;
	          }else{
	            $scope.investigationAtgardInfors[key].savedFollowUp = false;
	          }
	          $scope.setReminderDate(value);
	        });
	      }
	    });
	
	    $scope.beslutSigned = false;
	    if($scope.investigation.beslutSign && $scope.investigation.beslutSign !== ''){
	      $scope.investigationSteps[3].success = true;
	    }
	    $scope.drawSign = function(){
	      if($scope.investigation.beslutSign && $scope.investigation.beslutSign !== ''){
	        var c = document.getElementById("beslutSign");
	        var ctx = c.getContext("2d");
	        var imageObj = new Image();
	        imageObj.onload = function() {
	          ctx.drawImage(this, 0, 0);
	        };
	        imageObj.src = $scope.investigation.beslutSign;
	        $scope.beslutSigned = true;
	      }
	    };
	
	    $scope.nextStepInvestigation = function(activeTab){
	      var isMarked = true;
	      var activeTabLength = activeTab < 4 ? activeTab : 4;
	      for(var i=0; i<activeTabLength;i++){
	        if($scope.investigationSteps[i].success === false){
	          isMarked = false;
	          break;
	        }
	      }
	      if(isMarked || activeTab === $scope.investigationSteps.length){
	        $scope.activeTab = activeTab;
	      }
	      if(activeTab >= 4){
	        if(!$scope.investigationAtgardInfors[activeTab-4].content){
	          $scope.publicationActionFollowUpToggle = true;
	        }else{
	          $scope.publicationActionFollowUpToggle = false;
	        }
	      }
	      if(activeTab === 3){
	        if(!$scope.investigation.beslutSign){
	          $scope.publicationDecisionToggle = true;
	        }
	        setTimeout(function(){
	          $scope.drawSign();
	        }, 1);
	      }
	      if(activeTab === 1 && !$rootScope.investigationInfors.length){
	        $scope.publicationAccountToggle = true;
	        $scope.newInvestigationInfor = {
	          type: 'REDOGO',
	          partner: '',
	          periodUp: '14 days',
	          telephoneMode: false,
	          personlightMode: false,
	          varnadDate: new Date(),
	          content: '',
	          extra: {
	            selectdPart1: [],
	            selectdPart2: []
	          }
	        };
	      }
	    };
	
	    $scope.createNewInvestigationAtGardInfor = function(){
	      var investigationInfor = {
	        type: 'ATGARD',
	        content: '',
	        varnadDate: new Date(),
	        periodUp: '14 days',
	        partner: 'default',
	        extra: {
	          selectdPart1: [],
	          selectdPart2: []
	        }
	      };
	      CompanyPublicationCompanyInvestigationService.addInvestigationInfor({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId
	      }, investigationInfor, function(resp){
	        growl.addSuccessMessage(translations['investigation.save-investigation-infor-success']);
	        $scope.investigationAtgardInfors.push(resp);
	        $scope.investigationSteps.push({
	          name: translations['investigation.action-and-follow-up'],
	          template: 'partials/company/publications/investigation/action-and-follow-up.html',
	          success: false
	        });
	        if($scope.investigationAtgardInfors.length > 1){
	          $scope.activeTab = $scope.investigationSteps.length-1;
	          $scope.publicationActionFollowUpToggle = true;
	          $scope.investigationSteps[$scope.investigationSteps.length-2].success = true;
	        }
	        $scope.setReminderDate(resp);
	      }, function(){
	        growl.addErrorMessage(translations['investigation.save-investigation-infor-failure']);
	      });
	    };
	  }
	
	  $scope.openModalCreateNote = function(note){
	    $rootScope.loading = true;
	    var modal = $modal({
	      scope: $scope,
	      templateUrl: 'partials/company/publications/modal-update-note.html',
	      show: false,
	      controller: ['$scope', '$stateParams', function($scope, $stateParams){
	        if(note){
	          $scope.note = note;
	        }else{
	          $scope.note = {
	            note: "",
	            visible: true,
	            color: 0,
	            objectRelativeType: "PUBLICATION",
	            objectRelativeId: $stateParams.publicationId,
	            companyId: $stateParams.companyId
	          };
	        }
	
	        $scope.saveNote = function(){
	          CompanyNoteService.update({companyId: $stateParams.companyId}, $scope.note, function(resp) {
	            if(!note){
	              $scope.notes.push(resp);
	            }else{
	              var noteIndex = $scope.notes.filter(function(n){
	                return n.id === $scope.note.id;
	              });
	              $scope.notes[$scope.notes.indexOf(noteIndex[0])] = resp;
	            }
	            growl.addSuccessMessage($translate.instant('save-note-success'));
	          }, function() {
	            growl.addErrorMessage($translate.instant('save-note-failure'));
	          });
	        };
	
	        $scope.deleteNote = function(){
	          CompanyNoteService.delete({companyId: $stateParams.companyId, noteId: $scope.note.id}, function() {
	            var noteIndex = $scope.notes.findIndex(function(n){
	              return n.id === $scope.note.id;
	            });
	            $scope.notes.splice(noteIndex, 1);
	            growl.addSuccessMessage($translate.instant('delete-note-success'));
	          }, function() {
	            growl.addErrorMessage($translate.instant('delete-note-failure'));
	          });
	        };
	      }]
	    });
	    modal.$promise.then(function(){
	      modal.show();
	      $rootScope.loading = false;
	    });
	  };
	
	  switch(publication.type) {
	    case 'ALBUM':
	      $scope.showVersionsTab = false;
	      break;
	
	    case 'FOLDER':
	      $scope.showVersionsTab = false;
	      break;
	
	    case 'NOTE':
	      $scope.showVersionsTab  = false;
	      break;
	
	    case 'KEYPASS':
	      $scope.showShareTab = false;
	      break;
	
	    case 'MASTERFILE':
	      $scope.showShareTab = false;
	      $scope.showVersionsTab = false;
	      break;
	
	    case 'WALL':
	      $scope.showShareTab = false;
	      $scope.showVersionsTab = false;
	      break;
	
	    case 'ORDER':
	      $scope.showOrderReport = publication.features.currentOrderId;
	      $scope.showVersionsTab = false;
	      $scope.showShareTab = false;
	      break;
	
	    case 'CUSTOMER_ADAPTION':
	      $scope.showVersionsTab = false;
	      break;
	
	    case 'PUBLICATION_GROUP':
	      break;
	
	    case 'PLANT':
	      $scope.showPlantReport = publication.features.currentPlantId;
	      break;
	    case 'COMPANY_ORDER':
	    case 'ORDER_SUBCRIPTION':
	      $scope.showShareTab = false;
	      $scope.showVersionsTab = false;
	      break;
	    case 'BLOG':
	      $scope.showShareTab = false;
	      $scope.showVersionsTab = false;
	      break;
	    case 'INVESTIGATION':
	      $scope.showShareTab = false;
	      $scope.showVersionsTab = false;
	      break;
	    case 'SK3_FOLDER':
	      $scope.showVersionsTab = false;
	      break;
	  }
	
	  if(children.length > 0) {
	    $scope.showChildrenTab = true;
	  }
	
	
	  $scope.onFileSelect = function($files) {
	    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id || ($scope.publication.type === 'MASTERFILE' && $scope.currentUserPermissions.CompanyPublicationMasterFileAllowedToOverride)) {
	      var i = 0;
	      function queue(){
	        var uploadDeferred = $q.defer();
	        var filesDeferred = $q.defer();
	        var uploadFiles = [];
	        var start = i;
	        for(var j=start; j<(start+1); j++){
	          if(i < $files.length){
	            uploadFiles.push($files[j]);
	            i++;
	          }
	          filesDeferred.resolve();
	        }
	        filesDeferred.promise.then(function(){
	          $scope.uploadFilesForPublication(uploadFiles, $stateParams.publicationId).then(function(files) {
	            publication.versionNumber += files.length;
	
	            if(['FORM', 'NOTE', 'ALBUM', 'CUSTOMER_ADAPTION', 'MASTERFILE', 'FOLDER', 'SK3_FOLDER'].indexOf(publication.type) === -1) {
	              $scope.showVersionsTab = $scope.currentUserPermissions.CompanySeeFileVersion ? (publication.versionNumber > 1 ? true : false) : false;
	            }
	            uploadDeferred.resolve();
	          });
	        });
	        uploadDeferred.promise.then(function(){
	          if(i < $files.length){
	            queue();
	          }else{
	            $scope.$broadcast("files-uploaded");
	            return true;
	          }
	        });
	      }
	      queue();
	    } else {
	      growl.addErrorMessage(translations['publication.file-upload-locked']);
	      return false;
	    }
	  };
	
	  $scope.setActivity = function(file){
	    CompanyPublicationFileService.getShowFile({companyId: $stateParams.companyId, fileId: file.id});
	  };
	
	  $scope.openPreview = function(file, publicationId) {
	    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
	        return $scope.download(file, publicationId);
	      }
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;
	
	      var type;
	      switch(file.mimeType) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          type = 'image';
	          break;
	        case 'application/pdf':
	          if (true === iOS) {
	            window.open(url, '_self');
	            return;
	          }
	          type = 'iframe';
	          break;
	        default:
	          type = 'iframe';
	      }
	
	      jQuery.fancybox.open([{
	        type: type,
	        iframe: {
	          preload: false
	        },
	        padding: 0,
	        margin: 0,
	        href: url
	      }]);
	    });
	
	    return false;
	  };
	
	  $scope.download = function(file, publicationId) {
	    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      var additionParams = "";
	      var checkoutInfo = [];
	      additionParams = '&currentUserId=' + $scope.currentUser.id;
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadWindow');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	
	      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);
	
	      if ($scope.publication.type === 'MASTERFILE') {
	        var data = {};
	        data.userId = $scope.currentUser.id;
	        data.time = (new Date()).toISOString();
	        checkoutInfo.push(data);
	        $scope.publication.features.fileCheckout = JSON.stringify(checkoutInfo);
	        $scope.savePublication($scope.publication).then(function(){
	          CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
	            $scope.publication = resp;
	            $scope.$$childHead.publication = resp;
	          });
	        });
	      }
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
	        return;
	      }
	    });
	  };
	
	  $scope.rotateImage = function(file, rotate) {
	    var params = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      fileId: file.id,
	      manipulate: 'rotate',
	      rotate:     rotate
	    };
	    CompanyPublicationFileService.rotateImage(params, {}).$promise.then(function(){
	      $scope.$broadcast("files-uploaded");
	    });
	  };
	
	  $scope.deletePublication = function(publication) {
	    $http({
	      method: 'DELETE',
	      url: config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + publication.id
	    }).then(function() {
	
	        growl.addSuccessMessage(translations['publication.remove-success']);
	
	        if (publication.status === 'DRAFT') {
	          $state.go('root.company.publications-listDrafts');
	        }
	
	        else if (publication.status === 'ARCHIVED') {
	          $state.go('root.company.publications-listArchived');
	        }
	
	        else {
	          $state.go('root.company.publications-list');
	        }
	
	    }, function() {
	      growl.addErrorMessage(translations['publication.remove-failure']);
	    });
	  };
	
	  $scope.dateFormat = function(d){
	    return $filter('date')(d, "dd MMMM yyyy HH:mm");
	  };
	
	  $scope.unsetParent = function() {
	    $scope.publication.parent = null;
	
	    $scope.savePublication($scope.publication);
	  };
	
	  $scope.setParent = function(publication) {
	    $scope.publication.parent = {
	      id:   publication.id,
	      name: publication.name
	    };
	
	    $scope.savePublication($scope.publication);
	  };
	
	  /* Aside: */
	  $scope.publication = publication;
	
	  if(!$scope.publication.extra.viewerPages){
	    $scope.publication.extra.viewerPages = [];
	    $scope.publication.extra.viewerPages.push({
	      name: 'Start page',
	      isStartPage: true,
	      isEndPage: false,
	      index: 0,
	      content: ''
	    });
	    $scope.publication.extra.viewerPages.push({
	      name: 'End page',
	      isStartPage: false,
	      isEndPage: true,
	      index: 0,
	      content: ''
	    });
	  }
	
	  $scope.$on('publicationSaved', function(){
	    $scope.publication.updatedAt = new Date();
	  });
	  $scope.priorities  = priorities;
	}
	
	CompanyPublicationCtrl.resolve = {
	  /* For pretty much all of these we need to load company before actually
	     sending an XHR to make sure we have permission (guest or normal user).
	     This is because company will redicet if it is a guest. */
	  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, fromPortal: $stateParams.fromPortal}).$promise;
	  }],
	  investigation: ['$stateParams', 'CompanyPublicationCompanyInvestigationService', function($stateParams, CompanyPublicationCompanyInvestigationService) {
	    return CompanyPublicationCompanyInvestigationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 6}).$promise;
	  }],
	  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
	    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
	  }],
	  initialActivity: ['activityService', function(activityService) {
	    return activityService.next(0, 20, ["COMMENT"]);
	  }],
	  notes: ['$stateParams', 'CompanyNoteService', function($stateParams, CompanyNoteService) {
	    return CompanyNoteService.query({
	      companyId: $stateParams.companyId, 
	      visible: true, 
	      objectType: 'PUBLICATION', 
	      objectID: $stateParams.publicationId,
	      limit: 100
	    }).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.file-upload-locked',
	      'publication.lock-file-upload-success',
	      'publication.lock-file-upload-failure',
	      'order.payment.cash-on-delivery',
	      'order.payment.10-days',
	      'order.payment.20-days',
	      'order.payment.30-days',
	      'order.update-success',
	      'order.update-failure',
	      'order.create-all-copies-success',
	      'order.create-all-copies-failure',
	      'order.create-next-order-success',
	      'order.create-next-order-failure',
	      'investigation.parter-and-information',
	      'investigation.statement',
	      'investigation.summary',
	      'investigation.decision',
	      'investigation.action-and-follow-up',
	      'investigation.save-investigation-infor-success',
	      'investigation.save-investigation-infor-failure'
	    ]);
	  }]
	};
	module.exports = CompanyPublicationCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationCtrl', CompanyPublicationCtrl);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	__webpack_require__(13);
	__webpack_require__(390);
	__webpack_require__(379);
	__webpack_require__(404);
	__webpack_require__(402);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(400);
	__webpack_require__(12);
	__webpack_require__(393);
	__webpack_require__(10);
	__webpack_require__(20);
	__webpack_require__(16);
	__webpack_require__(30);
	__webpack_require__(65);
	__webpack_require__(401);
	__webpack_require__(399);
	__webpack_require__(398);
	__webpack_require__(64);
	__webpack_require__(394);
	__webpack_require__(375);
	__webpack_require__(364);
	__webpack_require__(363);
	__webpack_require__(41);
	__webpack_require__(410);
	__webpack_require__(409);
	__webpack_require__(36);
	__webpack_require__(372);
	var moment = __webpack_require__(1);
	
	CompanyPublicationDetailCtrl.$inject = [
	  "$scope",
	  "$state",
	  "$window",
	  "$interval",
	  "$stateParams",
	  "$translate",
	  "translations",
	  "$q",
	  "config",
	  "publication",
	  "growl",
	  "data",
	  "UploadTracker",
	  "currentUser",
	  "CompanyNoticeService",
	  "CompanyPublicationFileService",
	  "CompanyCategoryService",
	  "CompanyPublicationService",
	  "CompanyUserService",
	  "CompanyChecklistService",
	  "CompanyCustomersService",
	  "CompanyPublicationOrderService",
	  "CompanyPublicationCompanyOrderService",
	  "CompanyPublicationCompanyOrderSubcriptionService",
	  "CompanyPublicationCompanyInvestigationService",
	  "CompanyFlowVerifiesService",
	  "$modal",
	  "$rootScope"
	];
	function CompanyPublicationDetailCtrl (
	  $scope,
	  $state,
	  $window,
	  $interval,
	  $stateParams,
	  $translate,
	  translations,
	  $q,
	  config,
	  publication,
	  growl,
	  data,
	  uploadTracker,
	  currentUser,
	  CompanyNoticeService,
	  CompanyPublicationFileService,
	  CompanyCategoryService,
	  CompanyPublicationService,
	  CompanyUserService,
	  checklistService,
	  customersService,
	  orderService,
	  publicationCompanyOrderService,
	  publicationCompanyOrderSubcriptionService,
	  CompanyPublicationCompanyInvestigationService,
	  CompanyFlowVerifiesService,
	  $modal,
	  $rootScope
	) {
	  $scope.publication  = publication;
	  $scope.currentUser  = currentUser;
	  $scope.showFileDrop = false;
	  $scope.isEdited = false;
	
	  delete $rootScope.tinymceOptions.file_picker_callback;
	
	  $rootScope.tinymceOptions.images_upload_handler = function (blobInfo, success, failure) {
	    var files = [blobInfo.blob()];
	    if(files && files.length > 0){
	      uploadTracker(files.map(function(f) {
	        return {
	          url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
	          file: f
	        };
	      })).then(function(headers){
	        var newId = headers[0].split('/').pop();
	        var imageUrl = config.apiBase + '/files/' + newId;
	        success(imageUrl)
	      });
	    }
	  };
	          
	  $rootScope.tinymceOptions.file_picker_callback = function(callback, value, meta) {  
	    if (meta.filetype === 'image') {
	      $('#upload').trigger('click');
	      $('#upload').on('change', function() {
	        var files = new Array(this.files);
	        if(files && files.length > 0){
	          uploadTracker(files.map(function(f) {
	            return {
	              url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
	              file: f[0],
	            };
	          })).then(function(headers){
	            var newId = headers[0].split('/').pop();
	            var imageUrl = config.apiBase + '/files/' + newId;
	            callback(imageUrl, {
	              alt: ''
	            });
	          });
	        }
	      });
	    }
	  };
	
	  $scope.downloadZip = function() {
	    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	    if (true === iOS) {
	      window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language, '_self');
	      return;
	    }
	
	    var elm = angular.element(document.querySelector('body'));
	    var iFrame = elm.find('#downloadWindow');
	    if (!(iFrame && iFrame.length > 0)) {
	      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	      elm.append(iFrame);
	    }
	
	    iFrame.attr(
	      'src',
	      config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language
	    );
	  };
	
	  $scope.showNoticeModal = function() {
	    var modal = $modal({
	      scope: $scope,
	      controller: 'CompanyNoticeNewCtrl',
	      templateUrl: 'partials/company/notices/modal-new.html',
	      resolve: {
	        noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
	          return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
	        }]
	      },
	      show: false
	    });
	    modal.$promise.then(modal.show);
	  };
	
	  var modalList;
	  $scope.showNoticeListModal = function() {
	    $rootScope.loading = true;
	    modalList = $modal({
	      scope: $scope,
	      templateUrl: 'partials/company/notices/modal-list.html',
	      show: false,
	      controller: ['notices', '$scope', '$stateParams', function(notices, $scope, $stateParams){
	        $scope.notices = notices;
	        $scope.filterCompleted = false;
	        $scope.searchNotices = function(){
	          CompanyNoticeService.query({
	            companyId: $stateParams.companyId, 
	            publicationId: $stateParams.publicationId, 
	            completed: $scope.filterCompleted, 
	            limit: 1000
	          }).$promise.then(function(notices){
	            $scope.notices = notices;
	          });
	        };
	      }],
	      prefixEvent: 'noticListModal',
	      resolve: {
	        notices: function() {
	          return CompanyNoticeService.query({
	            companyId: $stateParams.companyId, 
	            publicationId: $stateParams.publicationId, 
	            completed: false, 
	            limit: 1000
	          }).$promise;
	        }
	      }
	    });
	    modalList.$promise.then(function(){
	      modalList.show();
	      $rootScope.loading = false;
	    });
	  };
	
	  var noticeDetailModal;
	  $scope.showNoticeDetailModal = function(notice) {
	    $rootScope.loading = true;
	    if (typeof modalList === 'object') {
	      modalList.$promise.then(modalList.hide);
	    }
	
	    noticeDetailModal = $modal({
	      scope: $scope,
	      controller: 'CompanyNoticeDetailCtrl',
	      templateUrl: 'partials/company/notices/modal-detail.html',
	      show: false,
	      prefixEvent: 'noticeDetailModal',
	      resolve: {
	        notice: function() {
	          return notice;
	        },
	        noticeCategories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
	          return CompanyCategoryService.query({companyId: $stateParams.companyId, type: 'REMINDER_CATEGORY'}).$promise;
	        }]
	      }
	    });
	
	    noticeDetailModal.$promise.then(function(){
	      $rootScope.loading = false;
	      noticeDetailModal.show();
	    });
	  };
	
	  $scope.$on('noticeDetailModal', function(){
	    if (typeof noticeDetailModal === 'object') {
	      noticeDetailModal.destroy();
	      noticeDetailModal = null;
	    }
	  });
	
	  $scope.$on('prefixEvent.hide', function(){
	    if (typeof modalList === 'object') {
	      modalList.destroy();
	      modalList = null;
	    }
	  });
	
	  $scope.showCertifyDocModal = function() {
	    var modal = $modal({
	      scope: $scope,
	      controller: 'CompanyPublicationCertifyDocCtrl',
	      templateUrl: 'partials/company/publications/detail/certify-doc.html',
	      show: false
	    });
	    modal.$promise.then(modal.show);
	  };
	
	  function string2array(str) {
	    if(typeof str !== "string") {
	      return [];
	    }
	
	    var data = JSON.parse(str);
	
	    return angular.isArray(data) ? data : [];
	  }
	
	  var setFileVisibility = function(file, visibility) {
	    CompanyPublicationFileService.update({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      fileId:        file.id
	    }, {
	      visible: visibility
	    }).$promise.then(function() {
	      file.visible = visibility;
	
	      var idx = $scope.files.indexOf(file);
	
	      if(idx !== -1) {
	        $scope.files.splice(idx, 1);
	      }
	
	      $scope.$broadcast("files-uploaded");
	    }, function() {
	      growl.addErrorMessage();
	    });
	  };
	
	  var queryFiles =  function() {
	    return CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         21,
	      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	      offset:        ($stateParams.page|0) * 20
	    }).$promise.then(function(files) {
	      $scope.$emit('publicationSaved');
	      $scope.files   = files.slice(0, 20);
	      $scope.hasMore = files.length > 20;
	    });
	  };
	
	
	
	  var queryAllFiles =  function() {
	    return CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         21,
	      offset:        ($stateParams.page|0) * 20
	    }).$promise.then(function(files) {
	      $scope.$emit('publicationSaved');
	      $scope.files   = files.slice(0, 20);
	      $scope.hasMore = files.length > 20;
	    });
	  };
	
	  var queryPublicationsChildren = function(text) {
	      return CompanyPublicationService.query({
	        companyId: $stateParams.companyId,
	        q:         text,
	        limit:     10
	      }).$promise.then(function(p) {
	        return p.filter(function(p) {
	          return !$scope.children.some(function(publication) {
	            return publication.id === p.id;
	          });
	        });
	      });
	    };
	
	  var addChildrenConnected = function(object){
	    var children = new CompanyPublicationService(object);
	
	    children.parent = {
	      id:   $scope.publication.id,
	      name: $scope.publication.name
	    };
	
	    children.$update({
	      companyId: $stateParams.companyId,
	      publicationId: children.id
	    }, function(){
	      $scope.children = $scope.children.concat(object);
	    });
	
	  };
	
	  $scope.deleteFileInDraftMode = function(file, publicationId) {
	    CompanyPublicationFileService.delete(
	      {
	        companyId: $stateParams.companyId,
	        publicationId: publicationId,
	        fileId: file.id
	      },
	      function(){
	        $scope.currentFile = false;
	        growl.addSuccessMessage(translations['publication.delete-file-success']);
	      },
	      function(){
	        growl.addErrorMessage(translations['publication.delete-file-failure']);
	      });
	  };
	
	  // Add customer to publication
	  $scope.queryCustomers = function(text) {
	    return customersService.query({
	      companyId: $stateParams.companyId,
	      q:         text,
	      limit:     10
	    }).$promise.then(function(p) {
	      return p.filter(function(p) {
	        if (!$scope.order) {
	          return true;
	        }
	        return ![$scope.order.customer].some(function(publication) {
	          return publication.id === p.id;
	        });
	      });
	    });
	  };
	
	  $scope.$on('orderChanged', function (event, data) {
	    $scope.order = data;
	  });
	
	  $scope.addCustomer = function(customer) {
	
	    var customerDeferred = $q.defer();
	    if ($scope.publication.features.currentCustomerId) {
	      customersService.removeObject({
	        companyId: $stateParams.companyId,
	        objectId: $scope.publication.id,
	        customerId: customer.id
	      }, function(){
	        customerDeferred.resolve();
	      }, function(){
	        customerDeferred.resolve();
	      });
	    } else {
	      customerDeferred.resolve();
	    }
	
	    customerDeferred.promise.then(function(){
	      customersService.addObject({
	        companyId: $stateParams.companyId,
	        customerId: customer.id
	      }, {
	        object: {
	          id: publication.id,
	          name: publication.name
	        }
	      }, function(){
	        $scope.publication.features.currentCustomerId = customer.id;
	        $scope.savePublication($scope.publication);
	        customersService.get({
	          companyId: $stateParams.companyId,
	          publicationId: $scope.publication.id,
	          customerId: customer.id
	        }, function(resp){
	          $scope.connectedCustomer = angular.copy(resp);
	        });
	      });
	    });
	
	
	    if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION' || publication.type === 'ORDER') {
	      var data = {
	        customer: customer
	      };
	
	      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
	        data.publication = {
	          name: $scope.publication.name,
	          id: $scope.publication.id
	        };
	      } else {
	        data.publicationId = $scope.publication.id;
	      }
	
	      if ($scope.order) {
	        data = angular.copy($scope.order);
	        data.customer = customer;
	      }
	
	      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
	        if ($scope.order) {
	          data.status = $scope.order.status;
	        } else {
	          data.status = 'CART';
	        }
	        if(publication.type === 'COMPANY_ORDER'){
	          publicationCompanyOrderService.update({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId
	          }, data).$promise.then(function(order){
	            $scope.order = angular.copy(order);
	            $scope.$parent.order = $scope.order;
	            $scope.$broadcast('customerChanged');
	            $scope.$broadcast('showCustomerInfo');
	            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
	            $scope.savePublication($scope.publication);
	          }).then(function(){
	            growl.addSuccessMessage($translate.instant('order.customer.add-success'));
	          }, function(){
	            growl.addErrorMessage($translate.instant('order.customer.add-failure'));
	          });
	        }else{
	          publicationCompanyOrderSubcriptionService.update({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId
	          }, data).$promise.then(function(order){
	            $scope.order = angular.copy(order);
	            var subcription            = $scope.order.interval.split(' ');
	            $scope.order.subcriptionNumber   = parseInt(subcription[0]);
	            $scope.order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
	            if(!$scope.order.lastGenAt){
	              $scope.order.lastGenAt = $scope.order.createdAt;
	            }
	            if($scope.order.startAt >= $scope.order.lastGenAt){
	              $scope.order.nextCreatedOrder = moment($scope.order.startAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY MM DD');
	            }else{
	              $scope.order.nextCreatedOrder = moment($scope.order.lastGenAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY MM DD');
	            }
	            $scope.$parent.order = $scope.order;
	            $scope.$broadcast('customerChanged');
	            $scope.$broadcast('showCustomerInfo');
	            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
	            $scope.savePublication($scope.publication);
	          }).then(function(){
	            growl.addSuccessMessage($translate.instant('order.customer.add-success'));
	          }, function(){
	            growl.addErrorMessage($translate.instant('order.customer.add-failure'));
	          });
	        }
	      } else if (publication.type === 'ORDER') {
	        orderService.update({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId
	        }, data).$promise.then(function(order){
	          $scope.order = angular.copy(order);
	          $scope.publication.features.currentOrderId = $scope.order.id;
	          $scope.savePublication($scope.publication);
	        }).then(function() {
	          growl.addSuccessMessage($translate.instant('order.customer.add-success'));
	        },
	        function() {
	          growl.addErrorMessage($translate.instant('order.customer.add-failure'));
	        });
	      }
	    }
	  };
	
	  $scope.editting = false;
	  $scope.dataEdit = null;
	  $scope.$on('edittingObject', function(e, data){
	    $scope.$apply(function(){
	      if(data.name === 'EDITTING' && currentUser.id !== data.user.id && publication.id === data.object.id){
	        $scope.editting = true;
	        $scope.dataEdit = data;
	      }else{
	        $scope.editting = false;
	        $scope.dataEdit = null;
	      }
	    });
	  });
	
	  $scope.$on('customerOrder100', function(evt, data){
	    $scope.addCustomer(data);
	  });
	
	  $scope.searchFileStr = $stateParams.searchFile || "";
	
	  $scope.changeDes = function(){
	    if($scope.publication.type === 'DEFAULT'){
	        $window.localStorage.editPublicationDefault = JSON.stringify($scope.publication);
	      }else{
	        if($scope.publication.type === 'BLOG'){
	          $scope.publication.posts = $scope.posts;
	          $window.localStorage.editPublicationBlog = JSON.stringify($scope.publication);
	        }else{
	          if($scope.publication.type === 'ALBUM'){
	            $window.localStorage.editPublicationAlbum = JSON.stringify($scope.publication);
	          }else{
	            if($scope.publication.type === 'NOTE'){
	              $window.localStorage.editPublicationNote = JSON.stringify($scope.publication);
	            }else{
	              if($scope.publication.type === 'SK3_FOLDER'){
	                $window.localStorage.editPublicationSK3 = JSON.stringify($scope.publication);
	              }
	            }
	          }
	        }
	      }
	  };
	  $scope.setStorageDescription = function(){
	    if($scope.publication.type === 'DEFAULT'){
	      delete $window.localStorage.editPublicationDefault;
	    }else{
	      if($scope.publication.type === 'BLOG'){
	        delete $window.localStorage.editPublicationBlog;
	      }else{
	        if($scope.publication.type === 'ALBUM'){
	          delete $window.localStorage.editPublicationAlbum;
	        }else{
	          if($scope.publication.type === 'NOTE'){
	            delete $window.localStorage.editPublicationNote;
	          }else{
	            if($scope.publication.type === 'SK3_FOLDER'){
	              delete $window.localStorage.editPublicationSK3;
	            }
	          }
	        }
	      }
	    }
	  };
	
	  switch(publication.type) {
	    case 'ALBUM':
	      if($window.localStorage.editPublicationAlbum){
	        var editPublicationAlbum = JSON.parse($window.localStorage.editPublicationAlbum);
	        if(editPublicationAlbum.id === $scope.publication.id){
	          $scope.publication.description = editPublicationAlbum.description;
	          $scope.togglePublicationForm = true;
	        }
	      }
	    case 'CUSTOMER_ADAPTION':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/' + publication.type.toLowerCase() + '.html';
	      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
	        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
	          $scope.notices = notices;
	        });
	      }
	      $scope.files               = data.files.slice(0, 21);
	      $scope.checklists          = data.checklists;
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.files.length > 21;
	      $scope.setFileVisibility   = setFileVisibility;
	      $scope.$on("files-uploaded", queryFiles);
	      break;
	
	    case 'FOLDER':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/folder.html';
	      $scope.children            = data.children;
	      $scope.checklists          = data.checklists;
	      $scope.files               = data.files.slice(0, 21);
	      $scope.connectedCustomer   = data.customer;
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.files.length > 21;
	      $scope.setFileVisibility = setFileVisibility;
	      $scope.addChildrenConnected = addChildrenConnected;
	      $scope.queryPublicationsChildren = queryPublicationsChildren;
	      $scope.$on("files-uploaded", queryFiles);
	      break;
	
	    case 'PUBLICATION_GROUP':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/publication-group.html';
	      $scope.children            = data.children;
	      $scope.currentFile         = data.currentFile;
	      $scope.connectedCustomer   = data.customer;
	      $scope.showFileDrop        = true;
	
	      $scope.addChildrenConnected = addChildrenConnected;
	
	      $scope.queryPublicationsChildren = queryPublicationsChildren;
	
	      $scope.$on("files-uploaded", function() {
	        CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          $scope.currentFile = files[0] || false;
	          if ($scope.currentFile) {
	            $scope.$broadcast('fileProcessed', $scope.currentFile);
	            $scope.$emit('publicationSaved');
	          }
	        });
	      });
	      break;
	
	    case 'NOTE':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/notes.html';
	
	      $scope.editForm = false;
	      $scope.masterPublicationDescription = angular.copy($scope.publication.description);
	      $scope.masterPublicationTitle = angular.copy($scope.publication.name);
	      $scope.logoPdf = data.logoPdf;
	      if($window.localStorage.editPublicationNote){
	        var editPublicationNote = JSON.parse($window.localStorage.editPublicationNote);
	        if(editPublicationNote.id === $scope.publication.id){
	          $scope.publication.description = editPublicationNote.description;
	          $scope.togglePublicationForm = true;
	        }
	      }
	
	      $rootScope.tinymceOptions.file_picker_types = 'image';
	
	      $scope.createCard = function(publicationType) {
	        $scope.cardCreating = true;
	        CompanyPublicationService.createCard({
	          companyId: $stateParams.companyId,
	          id: $stateParams.publicationId,
	          target: publicationType ? publicationType : 'CARD'
	        }, function(response, headers) {
	          var id = headers('Location').split('/').pop();
	          var url = "/companies/" + $stateParams.companyId + "/publications/" + id;
	          growl.addErrorMessage($translate.instant('publication.create-card.create-success'), null, url);
	          $scope.cardCreating  = false;
	          // window.location.href = "/companies/" + $stateParams.companyId + "/publications/" + id
	        }, function() {
	          $scope.cardCreating  = false;
	          growl.addErrorMessage($translate.instant('publication.create-card.create-failure'));
	
	        })
	      }
	
	      $scope.copyPublication = function(){
	        CompanyPublicationService.copyObject({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId
	        }, {}, function(resp, headers){
	          growl.addSuccessMessage($translate.instant('order.create-all-copies-success'));
	          var newId = headers('Location').split('/').pop();
	          $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: newId});
	        }, function(){
	          growl.addErrorMessage($translate.instant('order.create-all-copies-failure'));
	        });
	      };
	
	      $scope.savePublicationNote = function() {
	        if ($scope.publication.name === '') {
	          $scope.publication.name = $scope.masterPublicationTitle;
	        }
	        if ($scope.publication.description === '') {
	          $scope.publication.description = $scope.masterPublicationDescription;
	        }
	        $scope.editFormWaiting = true;
	        $scope.savePublication($scope.publication).then(function() {
	          $scope.editForm = false;
	          $scope.editFormWaiting = false;
	          $scope.$$childHead.publicationForm.$setPristine();
	          $scope.masterPublicationDescription = angular.copy($scope.publication.description);
	          $scope.masterPublicationTitle = angular.copy($scope.publication.name);
	          $scope.stopAutoSave();
	        },function(data){
	          $scope.editFormWaiting = false;
	          $scope.stopAutoSave();
	          if (data.status === 304) {
	            $scope.editForm = false;
	          }
	        });
	      };
	
	
	      $scope.cancelEditNote = function() {
	        $scope.publication.description = $scope.masterPublicationDescription;
	        $scope.publication.name = $scope.masterPublicationTitle;
	        $scope.stopAutoSave();
	      };
	
	      $scope.children            = data.children;
	      $scope.checklists          = data.checklists;
	      var stopSave;
	      $scope.autoSave = function() {
	        stopSave = $interval(function(){
	          if ($scope.$$childHead.publicationForm.$dirty) {
	            $scope.savePublication($scope.publication).then(function(){
	              $scope.masterPublicationDescription = $scope.publication.description;
	              $scope.masterPublicationTitle = $scope.publication.name;
	              $scope.$$childHead.publicationForm.$setPristine();
	            });
	          }
	        }, 300000);
	      };
	
	      $scope.stopAutoSave = function() {
	        if (angular.isDefined(stopSave)) {
	            $interval.cancel(stopSave);
	            stopSave = undefined;
	          }
	      };
	
	      $scope.$on('$destroy', function() {
	        $scope.stopAutoSave();
	      });
	
	      $scope.$watch("editForm", function(newData, oldData){
	        if (newData === true && newData !== oldData) {
	          $scope.autoSave();
	        }
	      }, true);
	
	      break;
	    case 'KEYPASS':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/keypass.html';
	      break;
	    case 'MASTERFILE':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/masterfile.html';
	      $scope.currentFile         = data.files;
	      $scope.showFileDrop        = true;
	
	      $scope.$watch("publication", function(data){
	        $scope.fileCheckout = string2array(data.features.fileCheckout);
	        if ($scope.fileCheckout.length > 0) {
	          CompanyUserService.get({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            userId: $scope.fileCheckout[0].userId})
	          .$promise.then(function(resp){
	            $scope.userCheckout = resp.name;
	          });
	        }
	      });
	      $scope.$on("files-uploaded", function() {
	        CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          $scope.currentFile = files[0] || false;
	          if ($scope.currentFile) {
	            CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
	              $scope.$parent.publication = resp;
	              $scope.publication = resp;
	            });
	            $scope.$broadcast('fileProcessed', $scope.currentFile);
	            $scope.$emit('publicationSaved');
	          }
	        });
	      });
	      break;
	    case 'WALL':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/wall.html';
	      $scope.showFileDrop = false;
	      break;
	
	    case 'PLANT':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/plant.html';
	      $scope.showFileDrop = true;
	      $scope.currentFile         = data.currentFile;
	      $scope.plant = data.plant;
	
	      $scope.$on("files-uploaded", function() {
	        CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          $scope.currentFile = files[0] || false;
	          if ($scope.currentFile) {
	            $scope.$broadcast('fileProcessed', $scope.currentFile);
	            $scope.$emit('publicationSaved');
	          }
	        });
	      });
	      break;
	
	    case 'ORDER':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/order.html';
	      $scope.showFileDrop = false;
	      $scope.order = data;
	      break;
	
	    case 'ENGINE_MODEL':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/engine-model.html';
	      $scope.currentFile         = data;
	      $scope.showFileDrop        = true;
	
	      $scope.$on("files-uploaded", function() {
	        CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          $scope.currentFile = files[0] || false;
	          if ($scope.currentFile) {
	            $scope.$broadcast('fileProcessed', $scope.currentFile);
	            $scope.$emit('publicationSaved');
	          }
	        });
	      });
	
	      break;
	
	    case 'COMPANY_ORDER':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/company-order.html';
	      $scope.files               = data.files.slice(0, 21);
	      $scope.checklists          = data.checklists;
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.files.length > 21;
	      $scope.setFileVisibility   = setFileVisibility;
	      $scope.$on("files-uploaded", queryFiles);
	      break;
	    case 'ORDER_SUBCRIPTION':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/order-subscription.html';
	      $scope.files               = data.files.slice(0, 21);
	      $scope.checklists          = data.checklists;
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.files.length > 21;
	      $scope.setFileVisibility   = setFileVisibility;
	      $scope.children = data.children;
	      $scope.$on("files-uploaded", queryFiles);
	      break;
	    case 'BLOG':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/blog.html';
	      $scope.posts               = data.slice(0, 21);
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.length > 21;
	      $scope.showFileDrop        = true;
	      if($window.localStorage.editPublicationBlog){
	        var editPublicationBlog = JSON.parse($window.localStorage.editPublicationBlog);
	        if(editPublicationBlog.id === $scope.publication.id){
	          $scope.posts = editPublicationBlog.posts;
	          $scope.togglePublicationForm = true;
	        }
	      }
	      break;
	    case 'INVESTIGATION':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/investigation.html';
	
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.setFileVisibility   = setFileVisibility;
	      if(!$scope.investigation.publicationIds){
	        $scope.investigation.publicationIds = [];
	      }
	
	      $scope.updateInvestigation = function(start, step, decision) {
	        if($scope.investigation.id){
	          CompanyPublicationCompanyInvestigationService.update({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            start: start ? true : null,
	            step: step ? step : null,
	            decision: decision ? decision : null
	          }, $scope.investigation, function(){
	            growl.addSuccessMessage($translate.instant('investigation.update-success'));
	          }, function(){
	            growl.addErrorMessage($translate.instant('investigation.update-failure'));
	          });
	        }else{
	          CompanyPublicationCompanyInvestigationService.save({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            start: start ? true : null,
	            step: step ? step : null,
	            decision: decision ? decision : null
	          }, $scope.investigation, function(investigation){
	            growl.addSuccessMessage($translate.instant('investigation.update-success'));
	            $scope.investigation = investigation;
	            $scope.investigation.status = 'OPEN';
	          }, function(){
	            growl.addErrorMessage($translate.instant('investigation.update-failure'));
	          });
	        }
	        if($scope.invesUsers[2].users.length > 0 && $scope.invesUsers[3].users.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
	          $scope.investigationSteps[0].success = true;
	        }
	      };
	
	      $scope.invesUsers = [{
	        name: $translate.instant('investigation.deferred-to-incident'),
	        users: data.invesUsersUtsatt,
	        type: 'UTSATT',
	        relativeType: '',
	        checklists: null
	      },{
	        name: $translate.instant('investigation.suspected-involvement'),
	        users: data.invesUsersMissTankt,
	        type: 'MISS_TANKT',
	        relativeType: '',
	        checklists: null
	      },{
	        name: $translate.instant('investigation.responsible-investigator'),
	        users: data.invesUsersAnvarig,
	        type: 'ANVARIG',
	        relativeType: 'INVESTIGATON_ANVARIG',
	        checklists: data.anvarigChecklists
	      },{
	        name: $translate.instant('investigation.engaged-personnel'),
	        users: data.invesUsersEngagerad,
	        type: 'ENGAGERAD',
	        relativeType: 'INVESTIGATON_ENGAGERAD',
	        checklists: data.engageradChecklists
	      }];
	      $scope.invesUsersBetslut = data.invesUsersBetslut;
	
	      $rootScope.investigationInfors = data.investigationInfors;
	      $scope.investigationSanmanInfors = data.investigationSanmanInfors;
	      if(data.investigationBetslutInfors.length > 0){
	        $scope.investigationBetslutInfors = data.investigationBetslutInfors[0];
	      }else{
	        $scope.investigationBetslutInfors = {
	          type: 'BETSLUT',
	          partner: 'default',
	          periodUp: '14 days',
	          telephoneMode: false,
	          personlightMode: false,
	          varnadDate: new Date(),
	          content: '',
	          extra: {
	            selectdPart1: [],
	            selectdPart2: []
	          },
	          template: null
	        };
	      }
	      $scope.portals = data.portals;
	
	      $scope.part1Users = data.invesUsersUtsatt.concat(data.invesUsersMissTankt);
	      $scope.part2Users = data.invesUsersAnvarig.concat(data.invesUsersEngagerad);
	
	      if(data.invesUsersEngagerad.length > 0 && data.invesUsersAnvarig.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
	        $scope.investigationSteps[0].success = true;
	      }
	
	      if(data.investigationInfors.length > 0){
	        $scope.investigationSteps[1].success = true;
	      }
	      if(data.investigationSanmanInfors.length > 0){
	        $scope.investigationSteps[2].success = true;
	      }
	
	      $scope.investigationUsers = data.investigationUsers;
	      $scope.investigationTemplates = data.investigationTemplates;
	      $scope.investigationPages = data.investigationPages;
	
	      break;
	    case 'SK3_FOLDER':
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/sk3-folder.html';
	      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/list.html';
	      if($window.localStorage.editPublicationSK3){
	        var editPublicationSK3 = JSON.parse($window.localStorage.editPublicationSK3);
	        if(editPublicationSK3.id === $scope.publication.id){
	          $scope.publication.description = editPublicationSK3.description;
	          $scope.togglePublicationForm = true;
	        }
	      }
	      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
	        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
	          $scope.notices = notices;
	        });
	      }
	      $scope.files               = data.files.slice(0, 21);
	      $scope.checklists          = data.checklists;
	      $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
	      $scope.showFileDrop        = !$scope.showInvisibleFiles;
	      $scope.currentPage         = $stateParams.page|0;
	      $scope.hasMore             = data.files.length > 21;
	      $scope.setFileVisibility   = setFileVisibility;
	      $scope.$on("files-uploaded", queryAllFiles);
	      break;
	
	    default:
	      $scope.detailsViewTemplate = 'partials/company/publications/detail/latest/default.html';
	      if($scope.info.features.documentReminder && $scope.currentUserPermissions.DocumentReminderList){
	        CompanyNoticeService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 2, offset: 0}).$promise.then(function(notices){
	          $scope.notices = notices;
	        });
	      }
	
	
	      $scope.currentFile         = data.files;
	      $scope.checklists          = data.checklists;
	      $scope.showFileDrop        = true;
	      $scope.currentUser         = currentUser;
	      if($window.localStorage.editPublicationDefault){
	        var editPublicationDefault = JSON.parse($window.localStorage.editPublicationDefault);
	        if(editPublicationDefault.id === $scope.publication.id){
	          $scope.publication.description = editPublicationDefault.description;
	          $scope.togglePublicationForm = true;
	        }
	      }
	
	      CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise.then(function(flowVerifies){
	        $scope.flowVerifies = flowVerifies;
	      });
	
	      $scope.publicationFlowVerify = {flow: null};
	      if ( !$scope.publication.features.currentCertifyID){
	          $scope.publication.features.currentCertifyID =  $scope.publication.features.certifyID;
	      }
	      if($scope.publication.features.currentCertifyID){
	          CompanyPublicationService.getFlowVerify({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, publicationsVerifyId: $scope.publication.features.currentCertifyID}).$promise.then(function(publicationFlowVerify){
	            $scope.publicationFlowVerify = publicationFlowVerify;
	          });
	      }
	
	      $scope.savePublicationFlowVerify = function(){
	        CompanyPublicationService.createFlowVerify({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.publicationFlowVerify).$promise.then(function(publicationFlowVerify) {
	          $scope.publicationFlowVerify = publicationFlowVerify;
	          if(!$scope.publication.extra.flowCertificates){
	            $scope.publication.extra.flowCertificates = [];
	          }
	          $scope.publication.extra.flowCertificates.push({
	            flowId: publicationFlowVerify.id,
	            certificates : [],
	            signDone : false
	          });
	          if(!$scope.publication.features.certifyID){
	            $scope.publication.features.certifyID = publicationFlowVerify.id;
	          }else{
	            $scope.publication.features.certifyID += ', ' + publicationFlowVerify.id;
	          }
	          $scope.publication.features.currentCertifyID = publicationFlowVerify.id;
	          $scope.savePublication($scope.publication);
	          growl.addSuccessMessage($translate.instant('flow.set-certify-flow-to-object-success'));
	        }, function(err) {
	          if(err.status === 400){
	            growl.addErrorMessage(err.data);
	          }else{
	            growl.addErrorMessage($translate.instant('flow.set-certify-flow-to-object-failure'));
	          }
	        });
	      };
	
	      $scope.$on("files-uploaded", function() {
	        CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          $scope.currentFile = files[0] || false;
	          if ($scope.currentFile) {
	            $scope.$broadcast('fileProcessed', $scope.currentFile);
	            $scope.$emit('publicationSaved');
	          }
	        });
	      });
	
	      break;
	  }
	}
	
	CompanyPublicationDetailCtrl.resolve = {
	  data: [
	  '$q',
	  '$stateParams',
	  'publication',
	  'company',
	  'CompanyPublicationFileService',
	  'CompanyPublicationService',
	  'CompanyPublicationPlantService',
	  'CompanyProductsService',
	  'CompanyCustomersService',
	  'CompanyPublicationOrderService',
	  'CompanyChecklistService',
	  'CompanyGroupService',
	  'CompanyPublicationCompanyOrderService',
	  'CompanyPublicationCompanyOrderSubcriptionService',
	  'CompanyPublicationCompanyInvestigationService',
	  'CompanySettingInvestigationUsersService',
	  'CompanySettingInvestigationTemplatesService',
	  'CompanyInvestigationPagesService',
	  'CompanyPublicationBlogService',
	  'CompanyLogoService',
	  function($q,
	    $stateParams,
	    publication,
	    company,
	    CompanyPublicationFileService,
	    CompanyPublicationService,
	    CompanyPublicationPlantService,
	    CompanyProductsService,
	    CompanyCustomersService,
	    orderService,
	    checklistService,
	    CompanyGroupService,
	    publicationCompanyOrderService,
	    publicationCompanyOrderSubcriptionService,
	    CompanyPublicationCompanyInvestigationService,
	    CompanySettingInvestigationUsersService,
	    CompanySettingInvestigationTemplatesService,
	    CompanyInvestigationPagesService,
	    CompanyPublicationBlogService,
	    CompanyLogoService) {
	    var order = false;
	    switch(publication.type) {
	      case 'CUSTOMER_ADAPTION':
	      case 'SK3_FOLDER':
	      var checklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId
	        }).$promise;
	
	      var files = CompanyPublicationFileService.query({
	        companyId:     $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        limit:         22,
	        offset:        ($stateParams.page|0) * 21,
	        q:             $stateParams.searchFile || "",
	        searchAble: true
	      }).$promise;
	
	      return $q.all([checklists, files]).then(function(data) {
	        return {
	          checklists : data[0],
	          files      : data[1]
	        };
	      });
	      case 'ALBUM':
	      var checklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId
	        }).$promise;
	
	      var files = CompanyPublicationFileService.query({
	        companyId:     $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        limit:         22,
	        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	        offset:        ($stateParams.page|0) * 21,
	        q:             $stateParams.searchFile || "",
	        searchAble: true
	      }).$promise;
	
	      return $q.all([checklists, files]).then(function(data) {
	        return {
	          checklists : data[0],
	          files      : data[1]
	        };
	      });
	
	      case 'PUBLICATION_GROUP':
	        var currentFile = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          return files[0] || false;
	        });
	        var children    = CompanyPublicationService.query({
	          companyId: $stateParams.companyId,
	          parentId:  $stateParams.publicationId,
	          limit:     200
	        }).$promise;
	
	        var customer = false;
	        if (publication.features.currentCustomerId) {
	          customer = CompanyCustomersService.get({
	            companyId: $stateParams.companyId,
	            publication: $stateParams.publicationId,
	            customerId: publication.features.currentCustomerId
	          }).$promise;
	        }
	
	        return $q.all([currentFile, children, customer]).then(function(data) {
	          return {
	            currentFile: data[0],
	            children:    data[1],
	            customer:    data[2]
	          };
	        });
	
	      case 'FOLDER':
	        checklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId
	        }).$promise;
	
	        children = CompanyPublicationService.query({
	          companyId: $stateParams.companyId,
	          parentId:  $stateParams.publicationId,
	          limit:     200
	        }).$promise;
	
	        files = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         22,
	          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	          offset:        ($stateParams.page|0) * 21,
	          q:             $stateParams.searchFile || "",
	          searchAble: true
	        }).$promise;
	
	        if (publication.features.currentCustomerId) {
	          customer = CompanyCustomersService.get({
	            companyId: $stateParams.companyId,
	            publication: $stateParams.publicationId,
	            customerId: publication.features.currentCustomerId
	          }).$promise;
	        }
	
	        return $q.all([files, children, checklists, customer]).then(function(data){
	          return {
	            files: data[0],
	            children: data[1],
	            checklists: data[2],
	            customer: data[3]
	          };
	        });
	
	      case 'NOTE':
	        checklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId
	        }).$promise;
	
	        children = CompanyPublicationService.query({
	          companyId: $stateParams.companyId,
	          parentId:  $stateParams.publicationId,
	          limit:     200
	        }).$promise;
	
	        var logoPdf = CompanyLogoService.get({
	          companyId: $stateParams.companyId,
	          type:  'pdf'
	        }).$promise;
	
	        return $q.all([checklists, children, logoPdf]).then(function(data){
	          return {
	            checklists: data[0],
	            children: data[1],
	            logoPdf: data[2]
	          };
	        });
	      case 'KEYPASS':
	        break;
	      case 'WALL':
	        break;
	
	      case 'ENGINE_MODEL':
	        var file = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1,
	          visible:       "true"
	        }).$promise.then(function(files) {
	          return files[0] || false;
	        });
	        return file;
	
	      case 'PLANT':
	        var plantData = false;
	        if (publication.features.currentPlantId) {
	          plantData = CompanyPublicationPlantService.get({companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            plantId: publication.features.currentPlantId
	          }).$promise;
	        }
	
	        file = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          return files[0] || false;
	        });
	
	        return $q.all([file, plantData]).then(function(resp){
	          return {
	            currentFile: resp[0],
	            plant: resp[1]
	          };
	        });
	
	      case 'ORDER':
	        var deferred = $q.defer();
	        if (publication.features.currentOrderId) {
	            orderService.get({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId
	          }).$promise.then(function(resp){
	            deferred.resolve(resp);
	          }, function(){
	            deferred.resolve(false);
	          });
	        } else {
	          deferred.resolve(false);
	        }
	
	        return deferred.promise;
	
	      case 'COMPANY_ORDER':
	        files = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         22,
	          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	          offset:        ($stateParams.page|0) * 21,
	          q:             $stateParams.searchFile || "",
	          searchAble: true
	        }).$promise;
	
	        if (publication.features.currentCompanyOrderId) {
	          order =  false;
	        }
	
	        return $q.all([files, order]).then(function(data) {
	          return {
	            files: data[0],
	            order: data[1]
	          };
	        });
	      case 'ORDER_SUBCRIPTION':
	        files = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         22,
	          visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	          offset:        ($stateParams.page|0) * 21,
	          q:             $stateParams.searchFile || "",
	          searchAble: true
	        }).$promise;
	
	        children = CompanyPublicationService.query({
	          companyId: $stateParams.companyId,
	          parentId:  $stateParams.publicationId,
	          type: 'ORDER_SUBCRIPTION',
	          limit:     200
	        }).$promise;
	
	        if (publication.features.currentCompanyOrderId) {
	          order =  false;
	        }
	
	        return $q.all([files, order, children]).then(function(data) {
	          return {
	            files: data[0],
	            order: data[1],
	            children: data[2]
	          };
	        });
	      case 'BLOG':
	        return CompanyPublicationBlogService.query({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         22,
	          offset:        ($stateParams.page|0) * 21
	        }).$promise;
	
	      case 'INVESTIGATION':
	        var invesUsersUtsatt = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'UTSATT'
	        }).$promise;
	
	        var invesUsersMissTankt = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'MISS_TANKT'
	        }).$promise;
	
	        var invesUsersEngagerad = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'ENGAGERAD'
	        }).$promise;
	
	        var invesUsersAnvarig = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'ANVARIG'
	        }).$promise;
	
	        var invesUsersBetslut = CompanyPublicationCompanyInvestigationService.queryUsersInvestigation({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'BETSLUT'
	        }).$promise;
	
	        var investigationInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'REDOGO'
	        }).$promise;
	
	        var investigationSanmanInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 100,
	          offset: 0,
	          type: 'SANMAN'
	        }).$promise;
	
	        var investigationBetslutInfors = CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit: 1,
	          offset: 0,
	          type: 'BETSLUT'
	        }).$promise;
	
	        var engageradChecklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId,
	          relativeType: 'INVESTIGATON_ENGAGERAD'
	        }).$promise;
	
	        var anvarigChecklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId,
	          relativeType: 'INVESTIGATON_ANVARIG'
	        }).$promise;
	
	        var portals = CompanyGroupService.query({
	          companyId: $stateParams.companyId, 
	          all: true, 
	          type: 'VISIBLE'}).$promise;
	
	        var investigationUsers = CompanySettingInvestigationUsersService.query({
	          companyId: $stateParams.companyId, 
	          limit: 1000}).$promise;
	
	        var investigationTemplates = CompanySettingInvestigationTemplatesService.query({
	          companyId: $stateParams.companyId, 
	          limit: 1000}).$promise;
	
	        var investigationPages = CompanyInvestigationPagesService.query({
	          type: 'STEP', 
	          blog_type: 'INVESTIGATION',
	          offset: 0,
	          lang: window.localStorage.language,
	          limit: 9}).$promise;
	
	        return $q.all([invesUsersUtsatt, invesUsersMissTankt, invesUsersEngagerad, invesUsersAnvarig, investigationInfors, investigationSanmanInfors, investigationBetslutInfors, 
	                      engageradChecklists, anvarigChecklists, invesUsersBetslut, portals, investigationUsers, investigationTemplates, investigationPages]).then(function(data) {
	          return {
	            invesUsersUtsatt: data[0],
	            invesUsersMissTankt: data[1],
	            invesUsersEngagerad: data[2],
	            invesUsersAnvarig: data[3],
	            investigationInfors: data[4],
	            investigationSanmanInfors: data[5],
	            investigationBetslutInfors: data[6],
	            engageradChecklists: data[7],
	            anvarigChecklists: data[8],
	            invesUsersBetslut: data[9],
	            portals: data[10],
	            investigationUsers: data[11],
	            investigationTemplates: data[12],
	            investigationPages: data[13]
	          };
	        });
	
	      default:
	        checklists = checklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.publicationId
	        }).$promise;
	
	        files = CompanyPublicationFileService.query({
	          companyId:     $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          limit:         1
	        }).$promise.then(function(files) {
	          return files[0] || false;
	        });
	
	        return $q.all([checklists, files]).then(function(data){
	          return  {
	            checklists: data[0],
	            files: data[1]
	          };
	        });
	    }
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.delete-file-failure',
	      'publication.delete-file-success',
	      'form.product-list.all'
	    ]);
	  }]
	};
	
	module.exports = CompanyPublicationDetailCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyPublicationDetailCtrl", CompanyPublicationDetailCtrl);
	
	function isTypeImage() {
	  return function(mimetype) {
	    switch(mimetype) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          return true;
	        default:
	          return false;
	      }
	  };
	}
	
	angular.module('dokiv')
	  .filter('isTypeImage', isTypeImage);


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationEditFileContentDirective(
	  CompanyPublicationFileService,
	  $stateParams,
	  $translate,
	  config,
	  growl) {
	  return {
	    restrict: 'AE',
	    scope: {
	      currentFile: '='
	    },
	    link: function(scope) {
	      scope.formDisabled = true;
	      scope.contentLoading = false;
	      scope.toggleEdit = function() {
	        scope.contentLoading = true;
	        CompanyPublicationFileService.fileContent({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          fileId: scope.currentFile.id
	        }, function(resp){
	          scope.formDisabled = !scope.formDisabled;
	          scope.contentLoading = true;
	          scope.origContent = angular.copy(resp);
	          scope.fileContent = angular.copy(resp);
	        });
	      };
	
	      scope.save = function() {
	        scope.contentLoading = false;
	        scope.fileContent.$updateFileContent({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          fileId: scope.currentFile.id
	        }, function(){
	          growl.addSuccessMessage($translate.instant('publication.file-content.update-success'));
	          scope.origContent = angular.copy(scope.fileContent);
	          scope.currentFile.originalFilename = scope.fileContent.originalFilename;
	          scope.formDisabled = true;
	        }, function(){
	          growl.addErrorMessage($translate.instant('publication.file-content.update-failure'));
	        });
	      };
	
	      scope.cancel = function() {
	        scope.contentLoading = false;
	        scope.fileContent = angular.copy(scope.origContent);
	        scope.currentFile.originalFilename = scope.origContent.originalFilename;
	      };
	
	      scope.toggleActive = function() {
	        scope.currentFile.searchAble = !scope.currentFile.searchAble;
	        CompanyPublicationFileService.updateSearchable({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          fileId: scope.currentFile.id
	        }, {searchAble: scope.currentFile.searchAble}, function(){
	          growl.addSuccessMessage($translate.instant('publication.file-content.update-success'));
	        }, function(){
	          growl.addErrorMessage($translate.instant('publication.file-content.update-failure'));
	        });
	      };
	
	      scope.download = function(file) {
	        CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, fileId: file.id}, {}, function(response) {
	          var additionParams = "";
	          // additionParams = '&currentUserId=' + $scope.currentUser.id;
	          var elm = angular.element(document.querySelector('body'));
	          var iFrame = elm.find('#downloadWindow');
	          if (!(iFrame && iFrame.length > 0)) {
	            iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	            elm.append(iFrame);
	          }
	
	          iFrame.attr('src', config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + $stateParams.publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);
	          var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	          if (true === iOS) {
	            window.open(config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + $stateParams.publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
	            return;
	          }
	        });
	      };
	    },
	    templateUrl: 'partials/company/publications/detail/edit-file-content.html'
	  };
	
	}
	
	angular.module('dokiv')
	  .directive('publicationEditFileContent', [
	    'CompanyPublicationFileService',
	    '$stateParams',
	    '$translate',
	    'config',
	    'growl',
	    CompanyPublicationEditFileContentDirective]);

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationEsignService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/shares/e-signs/:eSignId', {}, {
	    'update': { method:'PUT' }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationEsignService', ['$resource', 'config', CompanyPublicationEsignService]);
	


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationFilePreviewDirective(
	  CompanyPublicationFileService,
	  PublicationCollabrationService,
	  $interval) {
	  return {
	    scope: {
	      filePreview: '=',
	      isCollabration: '='
	    },
	    restrict: 'A',
	    require: "ngModel",
	    link: function($scope, elem, attrs, model) {
	      model.$render = function() {
	        $scope.file = model.$viewValue;
	        previewHandler();
	      };
	      $scope.$watch("file", function(newData, oldData) {
	        if(angular.equals(newData, oldData) || angular.equals(newData, model.$viewValue)) {
	          return;
	        }
	        model.$setViewValue(newData);
	        model.$render();
	      }, true);
	
	      var getPreview = function() {
	        if ($scope.isCollabration) {
	          PublicationCollabrationService.getPreview({
	            publicationId: $scope.filePreview.publicationId,
	            fileId: $scope.file.id
	          }, function(data) {
	            elem.attr('src', 'data:' + data.dataUrl);
	          });
	        } else {
	          CompanyPublicationFileService.getPreview({
	            companyId: $scope.filePreview.companyId,
	            publicationId: $scope.filePreview.publicationId,
	            fileId: $scope.file.id
	          }, function(data) {
	            elem.attr('src', 'data:' + data.dataUrl);
	          });
	        }
	      };
	
	      var previewHandler = function() {
	        if ($scope.file.previewStatus === 'PROCESSED') {
	          getPreview();
	        } else {
	          if ($scope.file.previewStatus === 'QUEUED') {
	            var intervalPromise = $interval(function(){
	              CompanyPublicationFileService.get({
	                companyId: $scope.filePreview.companyId,
	                publicationId: $scope.filePreview.publicationId,
	                fileId: $scope.file.id
	              }, function(data){
	                $scope.file = data;
	                if ($scope.file.previewStatus !== 'QUEUED') {
	                  $interval.cancel(intervalPromise);
	                }
	              });
	            }, 2000, 5);
	          }
	        }
	      };
	
	      $scope.$on('fileProcessed', function(e, data){
	        $scope.file = data;
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('filePreview', [
	    'CompanyPublicationFileService',
	    'PublicationCollabrationService',
	    '$interval', CompanyPublicationFilePreviewDirective]);


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyPublicationIndexCtrl.$inject = [
	  "$scope",
	  "$stateParams",
	  "CompanyPublicationFileService",
	  "files"
	];
	function CompanyPublicationIndexCtrl(
	  $scope,
	  $stateParams,
	  CompanyPublicationFileService,
	  files) {
	  $scope.files   = files.slice(0, 20);
	  $scope.hasMore = files.length > 20;
	  $scope.page = $stateParams.page|0;
	}
	
	CompanyPublicationIndexCtrl.resolve = {
	  files: ['CompanyPublicationFileService', '$stateParams', function(CompanyPublicationFileService, $stateParams){
	    return CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         22,
	      visible:       true,
	      offset:        ($stateParams.page|0) * 21
	    }).$promise;
	  }]
	};
	
	module.exports = CompanyPublicationIndexCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyPublicationIndexCtrl", CompanyPublicationIndexCtrl);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(61);
	var moment = __webpack_require__(1);
	
	function uuidV4() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	    var r = Math.random()*16|0;
	    var v = c === 'x' ? r : (r&0x3|0x8);
	
	    return v.toString(16);
	  });
	}
	
	var DEFAULT_KEYPASS = {
	 "information": []
	};
	
	var DEFAULT_INFO = {
	  "name": "",
	  "url": "",
	  "username": "",
	  "password": "",
	  "additional_information": "",
	  "isNew": true,
	  "isEdit": true
	};
	
	CompanyPublicationKeypassCtrl.$inject = ["$scope", "$stateParams", "$translate", "growl", "clipboard", "CompanyPublicationKeypassService", "$filter", "$modal"];
	function CompanyPublicationKeypassCtrl($scope, $stateParams, $translate, growl, clipboard, CompanyPublicationKeypassService, $filter, $modal) {
	
	  $scope.informations = []; 
	  $scope.keypass = angular.copy(new CompanyPublicationKeypassService(DEFAULT_KEYPASS));
	  CompanyPublicationKeypassService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(resp) {
	    if (angular.isDefined(resp.id)) {
	      $scope.keypass = resp;     
	      $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
	    }
	    if ($scope.keypass.information === null) {
	      $scope.keypass.information = [];
	    }
	    angular.forEach($scope.keypass.information, function(value, key){
	      var reminderTime = moment(value.last_change_at).add(parseInt($scope.info.extra.passwordChangeNr), 'day'+($scope.info.extra.passwordChangeNr > 1 ? 's':''));
	      if(reminderTime < (new Date())){
	        $scope.keypass.information[key].reminder = true;
	      }
	    });
	  });
	
	  $scope.updateInfo = function() {
	    $scope.keypass.$update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(resp){
	      $scope.keypass = resp;
	      $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
	      angular.forEach($scope.keypass.information, function(value, key){
	        var reminderTimeUpdate = moment(value.last_change_at).add(parseInt($scope.info.extra.passwordChangeNr), 'day'+($scope.info.extra.passwordChangeNr > 1 ? 's':''));
	        if(reminderTimeUpdate < (new Date())){
	          $scope.keypass.information[key].reminder = true;
	        }
	      });
	      growl.addSuccessMessage($translate.instant('keypass.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('keypass.save-failure'));
	    });
	  };
	
	  $scope.addInfo = function() {
	    DEFAULT_INFO.id = uuidV4();
	    $scope.keypass.information.push(angular.copy(DEFAULT_INFO));
	    $scope.keypass.information = $filter('orderBy')($scope.keypass.information, 'name');
	  };
	
	  $scope.supported = true;
	  if (!clipboard.supported) {
	      $scope.supported = false;
	  }
	
	  $scope.success = function () {
	      growl.addSuccessMessage($translate.instant('keypass.copied'));
	  };
	
	  $scope.fail = function (err) {
	      growl.addSuccessMessage($translate.instant(err));
	  };
	
	  $scope.removeInfo = function(index) {
	    $scope.keypass.information.splice(index, 1);
	  };
	
	  var angularModal;
	  $scope.showModalDeleteKeypass = function(index) {
	     angularModal = $modal({
	      scope: $scope,
	      prefixEvent: "modalKeypass",
	      controller: ['$scope', function($scope) {
	        $scope.confirmName = $translate.instant('keypass.confirm-delete');
	        $scope.activeDelete = function() {
	          $scope.removeInfo(index);
	          $scope.updateInfo();
	        };
	      }],
	      templateUrl: 'partials/company/publications/detail/latest/confirm-delete.html',
	      show: true,
	    });
	  };
	
	  $scope.$on('modalKeypass.hide', function(){
	    angularModal.destroy();
	    angularModal = null;
	  });
	}
	
	angular.module("dokiv")
	  .controller("CompanyPublicationKeypassCtrl", CompanyPublicationKeypassCtrl);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(56);
	__webpack_require__(381);
	__webpack_require__(16);
	__webpack_require__(30);
	__webpack_require__(65);
	__webpack_require__(12);
	
	CompanyPublicationShareAccessCtrl.$inject = [
	  '$scope',
	  '$state',
	  '$stateParams',
	  'config',
	  '$window',
	  'lastFile',
	  'publication',
	  'shares',
	  'groups',
	  'customerPortals',
	  'children',
	  'growl',
	  '$q',
	  'CompanyGroupService',
	  'CompanyPublicationShareService',
	  'CompanyAddressBookService',
	  'CompanyCustomersService',
	  'CompanyPublicationCompanyOrderService',
	  'CompanyPublicationCompanyOrderSubcriptionService',
	  'CompanyPublicationOrderService',
	  'translations'];
	function CompanyPublicationShareAccessCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  config,
	  $window,
	  lastFile,
	  publication,
	  shares,
	  groups,
	  customerPortals,
	  children,
	  growl,
	  $q,
	  CompanyGroupService,
	  CompanyPublicationShareService,
	  CompanyAddressBookService,
	  customersService,
	  publicationCompanyOrderService,
	  publicationCompanyOrderSubcriptionService,
	  orderService,
	  translations) {
	  $scope.publication = publication;
	  $scope.shares = shares;
	  $scope.lastFile = lastFile;
	  $scope.customerPortals = customerPortals;
	  $scope.groups = groups;
	  $scope.children    = children.slice(0, 20);
	  $scope.hasMore     = children.length > 20;
	  $scope.currentPage = $stateParams.page|0;
	  $scope.tabActive = 4;
	
	  for(var i = 0; i < $scope.groups.length; i++) {
	    /* All groups are HIDDEN already */
	    if($scope.publication.groups.indexOf($scope.groups[i].id) !== -1) {
	      $scope.selectedGroup = $scope.groups[i];
	      break;
	    }
	  }
	      
	  function openAdditionalOptions() {
	    $scope.additionalOptionsOpen = true;
	  }
	  
	  function closeAdditionalOptions() {
	    $scope.additionalOptionsOpen = false;
	  }
	  
	  function toggleAdditionalOptions() {
	    if($scope.additionalOptionsOpen) {
	      closeAdditionalOptions();
	    }
	    else {
	      openAdditionalOptions();
	    }
	  }
	
	  $scope.toggleAdditionalOptions = toggleAdditionalOptions;
	  $scope.closeAdditionalOptions = closeAdditionalOptions;
	
	  // Customer portals
	  $scope.toggleCustomerPortal = function(customerPortalId) {
	    var i = $scope.publication.groups.indexOf(customerPortalId);
	    if(-1 !== i) {
	      $scope.publication.groups.splice(i, 1);
	    } else {
	      $scope.publication.groups.push(customerPortalId);
	    }
	  };
	
	  $scope.setGroup = function(group) {
	    for(var i = 0; i < $scope.groups.length; i++) {
	      var idx = $scope.publication.groups.indexOf($scope.groups[i].id);
	      
	      if(idx !== -1) {
	        $scope.publication.groups.splice(idx, 1);
	      }
	    }
	    
	    if(group) {
	      $scope.publication.groups.push(group.id);
	    }
	    
	    return $scope.savePublication($scope.publication).then(function() {
	      $scope.selectedGroup = group;
	    });
	  };
	
	  $scope.searchPortals = function(togglePortals, filterPortals) {
	    var filter = {
	      companyId: $stateParams.companyId, 
	      userId: $window.localStorage.userId, 
	      type: 'VISIBLE', 
	      q: filterPortals,
	      all: true
	    };
	    if(togglePortals === 1){
	      filter.customerConnected = false;
	    }
	    if(togglePortals === 2){
	      filter.customerConnected = true;
	    }
	    CompanyGroupService.query(filter).$promise.then(function(portals){
	      $scope.customerPortals = portals;
	    });
	  };
	
	  function checkExpiredShare() {
	    var today = new Date();
	    angular.forEach($scope.shares, function(v){
	      v.expired = false;
	      if ((new Date(v.deadline) < today) && v.deadline !==  null) {
	        v.expired = true;
	      }
	    });
	  }
	
	  checkExpiredShare();
	
	  $scope.shareFormCollapse = true;
	  if(publication.status === 'ARCHIVED'){
	    $scope.shareFormCollapse = false;
	  }
	  $scope.newShare = new CompanyPublicationShareService();
	  $scope.newShare.features = {};
	  if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
	    $scope.newShare.features.type = 'normal';
	  }
	  $scope.newShare.email = '';
	
	  $scope.newCreateShare = new CompanyPublicationShareService();
	  $scope.newCreateShare.features = {};
	  $scope.newCreateShare.subject = translations['publication.share.default-subject'];
	  if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
	    $scope.newCreateShare.features.type = 'normal';
	  }
	  $scope.newCreateShare.email = $scope.currentUser.email;
	
	  $scope.shareURLBase  = config.shareURLBase;
	  $scope.apiBase  = config.apiBase;
	
	  $scope.supported = false;
	
	  CompanyAddressBookService.query({companyId: $stateParams.companyId}).$promise.then(function(c) {
	    $scope.allContacts = angular.copy(c);
	    $scope.contacts    = angular.copy(c);
	    $scope.newContacts = [];
	  });
	
	  function saveShare(share, hasSendEmail) {
	    CompanyPublicationShareService.save({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, share, function(data) {
	      share.visits = 0;
	      share.createdAt = new Date();
	      share.id = data.id;
	      share.secretKey = data.secret;
	      $scope.shares.push(share);
	      growl.addSuccessMessage('Created share: ' + share.email + ' successfully!');
	      if(hasSendEmail){
	        if($scope.publication.type === 'FORM'){
	          $scope.publication.features.viewerLink = config.shareURLBase + 'forms/' + data.id + '?token=' + data.secret;
	        }else{
	          $scope.publication.features.viewerLink = config.shareURLBase + data.id + '?token=' + data.secret;
	        }
	        $scope.newShare = new CompanyPublicationShareService();
	        $scope.newShare.features = {};
	        if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
	          $scope.newShare.features.type = 'normal';
	        }  
	        $scope.newShare.email = '';
	      }else{
	        if($scope.publication.type === 'FORM'){
	          $scope.publication.features.viewerLink = config.shareURLBase + 'forms/' + data.id + '?token=' + data.secret;
	          $scope.haveShared = data;
	        }else{
	          $scope.publication.features.viewerLink = config.shareURLBase + data.id + '?token=' + data.secret;
	          $scope.haveShared = data;
	        }
	        $scope.newCreateShare = new CompanyPublicationShareService();
	        $scope.newCreateShare.features = {};
	        if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
	          $scope.newCreateShare.features.type = 'normal';
	        }  
	        $scope.newCreateShare.email = $scope.currentUser.email;
	      }
	      $scope.savePublication($scope.publication);
	
	    }, function() {
	      growl.addErrorMessage('Could not create share: ' + share.email);
	    });
	  }
	
	  $scope.addContact = function(contact, hasSendEmail) {
	    $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
	    if(hasSendEmail){
	      if (!$scope.newShare.email) {
	        $scope.newShare.email = contact.contactEmail;
	      }
	      else {
	        $scope.newShare.email += (', ' + contact.contactEmail);
	      }
	    }else{
	      if (!$scope.newCreateShare.email) {
	        $scope.newCreateShare.email = contact.contactEmail;
	      }
	      else {
	        $scope.newCreateShare.email += (', ' + contact.contactEmail);
	      }
	    }
	
	    $scope.suggestionsModalOpen = false;
	  };
	
	
	  function findNewAddresses(hasSendEmail) {
	    var array = [];
	    if(hasSendEmail){
	      array = $scope.newShare.email.split(', ');
	    }else{
	      array = $scope.newCreateShare.email.split(', ');
	    }
	
	    for (var i = array.length - 1; i >= 0; i--) {
	      for (var x = $scope.allContacts.length - 1; x >= 0; x--) {
	        if ($scope.allContacts[x].contactEmail === array[i]) {
	          array.splice(array[i], 1);
	        }
	      }
	    }
	
	    return array;
	  }
	
	
	  // Shares
	  $scope.saveShare = function(hasSendEmail) {
	    if(hasSendEmail){
	      var i;
	      var emails = $scope.newShare.email.split(',').map(function(item) {
	        return item.trim();
	      });
	
	      for(i = 0; i < emails.length; i++) {
	        var tmpShare = angular.copy($scope.newShare);
	        tmpShare.email = emails[i];
	        saveShare(tmpShare, hasSendEmail);
	      }
	
	      if ($scope.newShare.addToAddressBook) {
	        var newAddresses = findNewAddresses(true);
	        var contact;
	
	        for (i = newAddresses.length - 1; i >= 0; i--) {
	          contact = {
	            contactName:  newAddresses[i],
	            contactEmail: newAddresses[i]
	          };
	
	          CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function() {
	            $scope.contacts.push(contact);
	          });
	        }
	      }
	    }else{
	      var i;
	      var emails = $scope.newCreateShare.email.split(',').map(function(item) {
	        return item.trim();
	      });
	
	      for(i = 0; i < emails.length; i++) {
	        var tmpShare = angular.copy($scope.newCreateShare);
	        tmpShare.email = emails[i];
	        saveShare(tmpShare);
	      }
	      if ($scope.newCreateShare.addToAddressBook) {
	        var newAddresses = findNewAddresses();
	        var contact;
	
	        for (i = newAddresses.length - 1; i >= 0; i--) {
	          contact = {
	            contactName:  newAddresses[i],
	            contactEmail: newAddresses[i]
	          };
	
	          CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function() {
	            $scope.contacts.push(contact);
	          });
	        }
	      }
	    }
	
	  };
	
	  $scope.setNewDate = function(days, hasSendEmail) {
	    var newDate = new Date();
	    newDate.setDate(newDate.getDate() + days);
	
	    if(hasSendEmail){
	      $scope.newShare.deadline = newDate.toISOString();
	    }else{
	      $scope.newCreateShare.deadline = newDate.toISOString();
	    }
	  };
	
	  // set default date
	  $scope.setNewDate(14, true);
	  $scope.setNewDate(14);
	
	
	  $scope.deleteShareLink = function(share) {
	    share.updating = true;
	    CompanyPublicationShareService.delete({
	      companyId: $scope.publication.companyId,
	      publicationId: $scope.publication.id,
	      shareId: share.id
	    }, function(){
	      angular.forEach($scope.shares, function(v){
	        if (v.id === share.id) {
	          v.deadline = new Date();
	          v.expired = true;
	        }
	      });
	      share.updating = false;
	    }, function(){
	      share.updating = false;
	    });
	  };
	
	  $scope.sendEmail = function(share) {
	    CompanyPublicationShareService.sendEmailAgain({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      shareId: share.id
	    }, function(){
	      growl.addSuccessMessage(translations['publication.share.send-email-success']);
	    }, function(){
	      growl.addErrorMessage(translations['publication.share.send-email-failure']);
	    });
	  };
	
	  $scope.copySuccess = function() {
	    growl.addSuccessMessage(translations['publication.share.share-link-copy-success']);
	  };
	
	  $scope.copyFail = function() {
	    growl.addErrorMessage(translations['publication.share.share-link-copy-failure']);
	  };
	
	  $scope.queryCustomers = function(text) {
	    return customersService.query({
	      companyId: $stateParams.companyId,
	      q:         text,
	      limit:     10
	    }).$promise.then(function(p) {
	      return p.filter(function(p) {
	        if (!$scope.order) {
	          return true;
	        }
	        return ![$scope.order.customer].some(function(publication) {
	          return publication.id === p.id;
	        });
	      });
	    });
	  };
	
	  $scope.addCustomer = function(customer) {
	
	    var customerDeferred = $q.defer();
	    if ($scope.publication.features.currentCustomerId) {
	      customersService.removeObject({
	        companyId: $stateParams.companyId,
	        objectId: $scope.publication.id,
	        customerId: customer.id
	      }, function(){
	        customerDeferred.resolve();
	      }, function(){
	        customerDeferred.resolve();
	      });
	    } else {
	      customerDeferred.resolve();
	    }
	
	    customerDeferred.promise.then(function(){
	      customersService.addObject({
	        companyId: $stateParams.companyId,
	        customerId: customer.id
	      }, {
	        object: {
	          id: publication.id,
	          name: publication.name
	        }
	      }, function(){
	        $scope.publication.features.currentCustomerId = customer.id;
	        $scope.savePublication($scope.publication);
	        customersService.get({
	          companyId: $stateParams.companyId,
	          publicationId: $scope.publication.id,
	          customerId: customer.id
	        }, function(resp){
	          $scope.connectedCustomer = angular.copy(resp);
	        });
	      });
	    });
	    
	
	    if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION' || publication.type === 'ORDER') {
	      var data = {
	        customer: customer
	      };
	
	      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
	        data.publication = {
	          name: $scope.publication.name,
	          id: $scope.publication.id
	        };
	      } else {
	        data.publicationId = $scope.publication.id;
	      }
	
	      if ($scope.order) {
	        data = angular.copy($scope.order);
	        data.customer = customer;
	      }
	
	      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
	        if ($scope.order) {
	          data.status = $scope.order.status;
	        } else {
	          data.status = 'CART';
	        }
	        if(publication.type === 'COMPANY_ORDER'){
	          publicationCompanyOrderService.update({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId
	          }, data).$promise.then(function(order){
	            $scope.order = angular.copy(order);
	            $scope.$broadcast('customerChanged');
	            $scope.$broadcast('showCustomerInfo');
	            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
	            $scope.savePublication($scope.publication);
	          }).then(function(){
	            growl.addSuccessMessage(translations['order.customer.add-success']);
	          }, function(){
	            growl.addErrorMessage(translations['order.customer.add-failure']);
	          });
	        }else{
	          publicationCompanyOrderSubcriptionService.update({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId
	          }, data).$promise.then(function(order){
	            $scope.order = angular.copy(order);
	            $scope.$broadcast('customerChanged');
	            $scope.$broadcast('showCustomerInfo');
	            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
	            $scope.savePublication($scope.publication);
	          }).then(function(){
	            growl.addSuccessMessage(translations['order.customer.add-success']);
	          }, function(){
	            growl.addErrorMessage(translations['order.customer.add-failure']);
	          });
	        }
	      } else if (publication.type === 'ORDER') {
	        orderService.update({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId
	        }, data).$promise.then(function(order){
	          $scope.order = angular.copy(order);
	          $scope.publication.features.currentOrderId = $scope.order.id;
	          $scope.savePublication($scope.publication);
	        }).then(function() {
	          growl.addSuccessMessage(translations['order.customer.add-success']);
	        },
	        function() {
	          growl.addErrorMessage(translations['order.customer.add-failure']);
	        });
	      }
	    }
	  };
	
	  $scope.connectedCustomer = false;
	  if (publication.features.currentCustomerId) {
	    $scope.connectedCustomer = customersService.get({
	      companyId: $stateParams.companyId,
	      publication: $stateParams.publicationId,
	      customerId: publication.features.currentCustomerId
	    }, function(resp){
	      $scope.connectedCustomer = angular.copy(resp);
	    });
	  }
	}
	
	CompanyPublicationShareAccessCtrl.resolve = {
	  shares: ['$stateParams', 'CompanyPublicationShareService', 'info', function($stateParams, CompanyPublicationShareService, info) {
	    if(info.features.shareObject){
	      return CompanyPublicationShareService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 1000}).$promise;
	    }
	    return false;
	  }],
	  groups: ['CompanyGroupService', '$stateParams', '$window', function(CompanyGroupService, $stateParams, $window){
	    return CompanyGroupService.query({
	      companyId: $stateParams.companyId,
	      userId: $window.localStorage.userId,
	      all: true}).$promise;
	  }],
	  lastFile: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.getLastFile({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
	  }],
	  children: ['$stateParams', 'CompanyPublicationService', 'company', function($stateParams, CompanyPublicationService) {
	    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 21, offset: ($stateParams.page|0) * 20}).$promise;
	  }],
	  translations: ["$translate", function($translate){
	    return $translate([
	        'publication.share.default-subject',
	        'publication.share.share-link-copy-success',
	        'publication.share.share-link-copy-failure',
	        'publication.share.send-email-success',
	        'publication.share.send-email-failure',
	        'order.customer.add-success',
	        'order.customer.add-failure',
	        "publication.share.default-subject"
	      ]);
	  }]
	};
	
	module.exports = CompanyPublicationShareAccessCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationShareAccessCtrl', CompanyPublicationShareAccessCtrl);

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationShareService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/shares/:shareId', {companyId: '@companyId', publicationId: '@publicationId', shareId: '@shareId'}, {
	  	'sendEmailAgain': {
	      method: 'POST',
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/shares/send-email/:shareId'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationShareService', ['$resource', 'config', CompanyPublicationShareService]);
	


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	"use strict";
	
	CompanyPublicationVersionsCtrl.$inject = ['$scope', '$stateParams', 'publication', 'files'];
	function CompanyPublicationVersionsCtrl($scope, $stateParams, publication, files) {
	  $scope.publication = publication;
	  $scope.files       = files.slice(0, 20);
	  $scope.currentPage = $stateParams.page|0;
	  $scope.hasNext     = files.length > 20;
	}
	
	CompanyPublicationVersionsCtrl.resolve = {
	  files: ['$stateParams', 'CompanyPublicationFileService', 'company', function($stateParams, CompanyPublicationFileService) {
	    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 21, offset: ($stateParams.page|0) * 20 + 1}).$promise;
	  }]
	};
	
	module.exports = CompanyPublicationVersionsCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyPublicationVersionsCtrl", CompanyPublicationVersionsCtrl);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	
	function CompanyPublicationsFlowVerifiesCtrl(
	  $scope,
	  $translate,
	  growl,
	  publicationsFlowVerifies,
	  CompanyPublicationService,
	  $stateParams,
	  $state
	) {
	
	  $scope.publicationsFlowVerifies = publicationsFlowVerifies;
	  $scope.more = false;
	  $scope.page = parseInt($stateParams.page, 10) || 1;
	  
	  if($scope.publicationsFlowVerifies.length === 21) {
	    $scope.more = true;
	    $scope.publicationsFlowVerifies.pop();
	  }
	  $scope.filter = {
	    manager: null,
	    status: null
	  };
	
	  if ($stateParams.manager) {
	    $scope.filter.manager = $stateParams.manager;
	  }
	
	  if ($stateParams.status) {
	    $scope.filter.status = $stateParams.status;
	  }
	
	  $scope.cancelVerify = function(publicationsFlowVerify){
	    publicationsFlowVerify.status = 'CANCEL';
	    CompanyPublicationService.updateFlowVerify({publicationId: publicationsFlowVerify.publication.id, publicationsVerifyId: publicationsFlowVerify.id}, publicationsFlowVerify).$promise.then(function(){
	      growl.addSuccessMessage($translate.instant('flow.cancel-certify-flow-success'));
	      $scope.publicationsFlowVerifies.splice($scope.publicationsFlowVerifies.indexOf(publicationsFlowVerify), 1);
	    }, function(err) {
	      if(err.status === 400){
	        growl.addErrorMessage(err.data);
	      }else{
	        growl.addErrorMessage($translate.instant('flow.cancel-certify-flow-failure'));
	      }
	    });
	  };
	
	  $scope.searchNotices = function() {
	    $state.go('root.company.publications-flowVerifies', {manager: $scope.filter.manager, status: $scope.filter.status, page: null});
	  };
	}
	
	CompanyPublicationsFlowVerifiesCtrl.resolve = {
	  publicationsFlowVerifies: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    var page      = parseInt($stateParams.page, 10) || 1;
	    var filter    = {
	      companyId: $stateParams.companyId,
	      manager: $stateParams.manager || null,
	      status: $stateParams.status || null,
	      limit:     21,
	      offset:    (page - 1) * 20
	    };
	
	    return CompanyPublicationService.queryFlowVerifies(filter).$promise;
	  }]
	};
	
	module.exports = CompanyPublicationsFlowVerifiesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsFlowVerifiesCtrl', [
	    '$scope',
	    '$translate',
	    'growl',
	    'publicationsFlowVerifies',
	    'CompanyPublicationService',
	    '$stateParams',
	    '$state',
	    CompanyPublicationsFlowVerifiesCtrl
	  ]);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	__webpack_require__(27);
	
	function CompanyPublicationsListArchivedCtrl($scope, $stateParams, $state, publications, priorities, translations, CompanyPublicationService, growl, $modal) {
	  $scope.publications = publications.map(function(item) {
	    // TODO: Should this be configurable?
	    if(item.category) {
	      item.category.color = 4291809231; // Light gray (#cfcfcf);
	    } else {
	      item.category = {
	        color: 4291809231
	      };
	    }
	    return item;
	  });
	  $scope.$state = $state;
	  $scope.priorityId = $stateParams.priorityId || null;
	  $scope.more = false;
	  $scope.title = translations['publication.archived'];
	  $scope.listArchived = true;
	
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  $scope.filter = {};
	  if ($stateParams.queryArchived) {
	    $scope.filter.q = $stateParams.queryArchived;
	  }
	
	  $scope.showPublicationForm = false;
	  $scope.publicationsMassEdit = [];
	  $scope.namePublications = [];
	  $scope.goToPublicationDetail = function(publication){
	    if(publication.type !== 'FORM' && publication.type !== 'PUBLICATION_SPREAD_SHEET' && publication.type !== 'COMPANY_ORDER' && publication.type !== 'ORDER_SUBCRIPTION'){
	      $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: publication.id});
	    }else{
	      if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
	        window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
	      }
	      if(publication.type === 'FORM'){
	        if (
	          publication.features.formActived === "false" ||
	          !!publication.features.formActived === false
	        ) {
	          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
	        }else{
	          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
	        }
	      }
	      if(publication.type === 'COMPANY_ORDER'){
	        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
	      }
	      if(publication.type === 'ORDER_SUBCRIPTION'){
	        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
	      }
	    }
	  };
	 
	  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
	    if(publicationSelected){
	      $scope.publicationsMassEdit.push(publication.id);
	      $scope.namePublications.push(publication);
	    }else{
	      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
	      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
	    }
	  };
	
	  $scope.selectAllPublication = function(){
	    $scope.selectAll = !$scope.selectAll;
	    angular.forEach($scope.publications, function(publication){
	      if($scope.selectAll){
	        publication.selected = true;
	        $scope.publicationsMassEdit.push(publication.id);
	        $scope.namePublications.push(publication);
	      }else{
	        publication.selected = false;
	        $scope.publicationsMassEdit = [];
	        $scope.namePublications = [];
	      }
	    });
	  };
	 
	  $scope.showModalMassEdit = function() {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyPublicationMassEditCtrl',
	      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
	      show: true,
	      resolve: {
	        priorities: function() {
	          return priorities;
	        },
	        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	          return CompanyGroupService.query({
	            companyId: $stateParams.companyId,
	            all: true
	          }).$promise;
	        }],
	        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	          return CompanyCategoryService.query({
	            companyId: $stateParams.companyId,
	            limit: 1000
	          }).$promise;
	        }]
	      }
	    });
	  };
	
	  $scope.searchPublications = function() {
	    $state.go('.', {
	      companyId: $stateParams.companyId,
	      queryArchived: $scope.filter.q
	    });
	  };
	  
	  $scope.$on('$select.select', function(ev, priorityId) {
	    $scope.priorityId = priorityId;
	    if(!$scope.priorityId) {
	      $scope.priorityId = null;
	    }
	    var filter = {
	      priorityId: $scope.priorityId,
	      page: null
	    };
	    $state.go('root.company.publications-listArchived', filter);
	  });
	
	
	  $scope.page = $stateParams.page|0;
	  $scope.companyId = $stateParams.companyId;
	
	  $scope.deleteAllArchives = function() {
	    CompanyPublicationService.deleteArchives({companyId: $stateParams.companyId}, function(){
	      $scope.publications = [];
	      growl.addSuccessMessage(translations['company.delete-all-archived-objects-success']);
	    }, function(){
	      growl.addErrorMessage(translations['company.delete-all-archived-objects-failure']);
	    });
	  };
	
	}
	
	CompanyPublicationsListArchivedCtrl.resolve = {
	  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    var filter = {
	      companyId: $stateParams.companyId,
	      offset:    ($stateParams.page|0) * 20,
	      limit:     21,
	      archived:  true,
	      q: $stateParams.queryArchived || ""
	    };
	
	    if ('' !== $stateParams.priorityId) {
	      filter.priorityId = $stateParams.priorityId;
	    }
	
	    return CompanyPublicationService.query(filter).$promise;
	  }],
	  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate(['publication.list-drafts', 'publication.archived', 'company.delete-all-archived-objects-success', 'company.delete-all-archived-objects-failure']);
	  }]
	};
	module.exports = CompanyPublicationsListArchivedCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsListArchivedCtrl', ['$scope', '$stateParams', '$state', 'publications', 'priorities', 'translations', 'CompanyPublicationService', 'growl', '$modal', CompanyPublicationsListArchivedCtrl]);


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	__webpack_require__(7);
	__webpack_require__(57);
	__webpack_require__(5);
	__webpack_require__(13);
	__webpack_require__(52);
	__webpack_require__(43);
	__webpack_require__(421);
	__webpack_require__(27);
	
	function CompanyPublicationsListCtrl(
	  $scope,
	  $stateParams,
	  stateSnapshot,
	  $state,
	  $modal,
	  $timeout,
	  $controller,
	  publications,
	  categories,
	  currentCategory,
	  priorities,
	  userInformation,
	  translations,
	  CompanyGroupService,
	  CompanyMessageService,
	  CompanyCommentsService,
	  CompanyPublicationService,
	  growl,
	  reloadUserRoleDashboard,
	  CompanyTaskService, 
	  CompanyUserService,
	  $window
	) {
	  $scope.publications = publications;
	  $scope.$state = $state;
	  $scope.priorityId = $stateParams.priorityId || null;
	  $scope.selectedPriority = null;
	  $scope.posts = [];
	  $scope.comments = [];
	  $scope.latestTasks = [];
	  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));
	  $scope.showPublicationForm = false;
	  $scope.publicationsMassEdit = [];
	  $scope.namePublications = [];
	
	  $scope.selectedCustomerPortal = null;
	  $scope.selectedCategory = null;
	  $scope.more = false;
	  $scope.moreCat = false;
	  $scope.title = translations['all-cards'];
	  $scope.currentCategory = currentCategory;
	  $scope.currentType = $stateParams.type;
	  $scope.showAll = $stateParams.showAll || "";
	  $scope.filterTags = $stateParams.tags;
	  $scope.filterqType = $stateParams.qType || 'GENERAL';
	  $scope.toggleFilter = $stateParams.q || $scope.currentCategory || $scope.currentType || $scope.filterTags || $state.params.groupId || $state.params.ordeby || $state.params.from || $state.params.to || $state.params.priorityId ? false : true;
	
	  $scope.categories = categories;
	
	  if (!$stateParams.tags) {
	    $scope.activeTags = [];
	  } else {
	    $scope.activeTags = $stateParams.tags.split(',');
	    if (!Array.isArray($scope.activeTags)) {
	      $scope.activeTags = [$scope.activeTags];
	    }
	  }
	
	  if (!$stateParams.categoryId) {
	    $scope.activeCategory = null;
	  } else {
	    categories.forEach(function(c) {
	      if (c.id === $stateParams.categoryId) {
	        $scope.activeCategory = c.name;
	      }
	    });
	  }
	
	  $scope.activeType = $stateParams.type || null;
	
	  $scope.activeGroup = null;
	  if ($stateParams.groupId) {
	    CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}, function(resp){
	      $scope.activeGroup = resp;
	    });
	  }
	
	
	  if ($stateParams.priorityId) {
	    priorities.forEach(function(p) {
	      if (p.id === $stateParams.priorityId) {
	        $scope.activePriority = p.name;
	      }
	    });
	  }
	
	  if (currentCategory && currentCategory.name) {
	    $scope.title = currentCategory.name;
	  }
	
	  if ($scope.publications.length === 61) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  $scope.priorities = priorities;
	  priorities.$promise.then(function () {
	    for (var i = 0; i < priorities.length; i++) {
	      if (priorities[i].id === $scope.priorityId) {
	        $scope.selectedPriority = priorities[i];
	      }
	      $scope.priorities[priorities[i].id] = priorities[i];
	    }
	  });
	
	  if ($scope.role !==  null && !$stateParams.type && !$scope.showAll) {
	    setTimeout(function(){
	      $scope.showMoreMenu();
	    }, 50);
	
	    setTimeout(function(){
	      var options = {
	        alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
	        disableOneColumnMode: true
	      };
	      jQuery('.grid-stack').gridstack(options);
	    }, 10);
	
	    angular.element($window).on('resize', function () {
	      var widthWindowH = angular.element($window).width();
	      var grid = jQuery('.grid-stack').data('gridstack');
	      if(widthWindowH < 1016 && widthWindowH > 825){
	        angular.forEach($scope.role.template.data, function(value, key){
	          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), (value.chartData.gsX === "0" ? 0 : 6), value.chartData.gsY, 6, value.chartData.gsHeigth);
	        });
	      }else{
	        if(widthWindowH >= 1016){
	          angular.forEach($scope.role.template.data, function(value, key){
	            grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), parseInt(value.chartData.gsX), parseInt(value.chartData.gsY), parseInt(value.chartData.gsWidth), parseInt(value.chartData.gsHeigth));
	          });
	        }else{
	          angular.forEach($scope.role.template.data, function(value, key){
	            grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), 0, parseInt(value.chartData.gsY), 12, parseInt(value.chartData.gsHeigth));
	          });
	        }
	      }
	    });
	  }
	
	  $scope.updateUserInfo = function(user){
	    CompanyUserService.update({companyId: $stateParams.companyId, userId: user.id}, user, function(){
	      $state.go('.', {}, {reload: true})
	    });
	  };
	
	  $scope.toggleShowPublicationForm = function(isShow){
	    $scope.showPublicationForm = isShow;
	  };
	
	  $scope.changeToggleFilter = function(){
	    $state.go('root.company.publications-list', {
	      qType: $stateParams.qType || "GENERAL",
	      qTypeObject: $stateParams.qTypeObject || "OBJECT",
	      togFilter: true
	    });
	  };
	
	  $scope.filterByCreatedOrUpdated = function(v, asc) {
	    $state.go('root.company.publications-list', {orderby: v, asc: asc});
	  };
	
	  function getBlogLastest(data){
	    if(data.columnType === 'BLOG' && (data.columnData.object || data.columnData.blogId)){
	      var index = $scope.role.template.data.indexOf(data);
	      CompanyPublicationService.getPostLastest({
	        companyId: $stateParams.companyId,
	        publicationId: (data.columnData.object ? data.columnData.object.id : data.columnData.blogId),
	        only: data.columnData.only,
	        limit: (data.columnData.showThreePosts ? 3 : 1)
	      }, function(resp){
	        $scope.role.template.data[index].blogLastest = resp;
	      });
	    }
	  }
	
	  $scope.goToPublicationDetail = function(publication){
	    if(publication.type !== 'FORM' && publication.type !== 'PUBLICATION_SPREAD_SHEET' && publication.type !== 'COMPANY_ORDER' && publication.type !== 'ORDER_SUBCRIPTION'){
	      $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: publication.id});
	    }else{
	      if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
	        window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
	      }
	      if(publication.type === 'FORM'){
	        if (
	          publication.features.formActived === "false" ||
	          !!publication.features.formActived === false
	        ) {
	          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
	        }else{
	          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
	        }
	      }
	      if(publication.type === 'COMPANY_ORDER'){
	        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
	      }
	      if(publication.type === 'ORDER_SUBCRIPTION'){
	        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
	      }
	    }
	  };
	
	  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
	    if(publicationSelected){
	      $scope.publicationsMassEdit.push(publication.id);
	      $scope.namePublications.push(publication);
	    }else{
	      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
	      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
	    }
	  };
	
	  $scope.selectAllPublication = function(){
	    $scope.selectAll = !$scope.selectAll;
	    angular.forEach($scope.publications, function(publication){
	      if($scope.selectAll){
	        publication.selected = true;
	        $scope.publicationsMassEdit.push(publication.id);
	        $scope.namePublications.push(publication);
	      }else{
	        publication.selected = false;
	        $scope.publicationsMassEdit = [];
	        $scope.namePublications = [];
	      }
	    });
	  };
	
	  $scope.showModalMassEdit = function() {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyPublicationMassEditCtrl',
	      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
	      show: true,
	      resolve: {
	        priorities: function() {
	          return priorities;
	        },
	        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
	          return CompanyGroupService.query({
	            companyId: $stateParams.companyId,
	            all: true
	          }).$promise;
	        }],
	        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	          return CompanyCategoryService.query({
	            companyId: $stateParams.companyId,
	            limit: 1000
	          }).$promise;
	        }]
	      }
	    });
	  };
	
	  $scope.showModalUserLink = function(link, index) {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyUserLinksCtrl',
	      templateUrl: 'partials/company/publications/lists/user-link.html',
	      show: true,
	      prefixEvent: 'userLinkModal',
	      resolve: {
	        link: function() {
	          return link || false;
	        },
	        index: function() {
	          return (angular.isUndefined(index) ? -1 : index);
	        }
	      }
	    });
	  };
	
	  $scope.selectedPublicationType = $stateParams.type || null;
	  $scope.selectedOrderBy = $stateParams.orderby || 'updated';
	  $scope.selectedAsc = $stateParams.asc === "true" ? true : false;
	
	  var startDate = Date.parse($stateParams.from);
	  var endDate   = Date.parse($stateParams.to);
	
	  $scope.filterDataSpan  = {
	    from: startDate ? new Date(startDate) : null,
	    to:   endDate   ? new Date(endDate)   : null
	  };
	
	  if ($scope.role !==  null && !$stateParams.type && !$scope.showAll) {
	    if ($scope.role.template && ($scope.role.template.id === '1' || $scope.role.template.id === '2' || $scope.role.template.id === '5' || $scope.role.template.id === '6')) {
	      var yMax = 0;
	      var heigthMax = 4;
	      if($scope.role.template.data){
	        angular.forEach($scope.role.template.data, function(value, key){
	          value.chartData = value.chartData ? value.chartData : {};
	          value.chartData.gsX = angular.isDefined(value.chartData.gsX) ? value.chartData.gsX : (key%3===0 ? 0 : (key%3===1 ? 4 : 8));
	          value.chartData.gsY = angular.isDefined(value.chartData.gsY) ? value.chartData.gsY : 0;
	          value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth) ? value.chartData.gsWidth : 4;
	          value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth) ? value.chartData.gsHeigth : 7;
	          if(!value.isChart && value.columnType === 'BLOG'){
	            getBlogLastest(value);
	          }
	          if(parseInt(value.chartData.gsY) > yMax){
	            yMax = parseInt(value.chartData.gsY);
	            heigthMax = parseInt(value.chartData.gsHeigth);
	          }
	        });
	      }
	      var boxMessage = $scope.role.template.data.filter(function(d){ return d.columnType === 'MESSAGE'; });
	      if ($scope.info.features.blogs && $scope.role.showMessage) {
	        CompanyMessageService.query({
	          companyId: $stateParams.companyId,
	          limit: 4,
	          showInList: false
	        }, function(resp){
	          $scope.posts = resp;
	          if(!boxMessage[0]){
	            if($scope.posts.length > 0){
	              $scope.role.template.data.push({
	                isChart: false,
	                centralInformation: false,
	                columnType: 'MESSAGE',
	                isFullBox: false,
	                chartData: {
	                  gsX: 0,
	                  gsY: yMax+heigthMax,
	                  gsWidth: 4,
	                  gsHeigth: 4,
	                }
	              });
	            }
	          }else{
	            if($scope.posts.length === 0){
	              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	            }
	          }
	        }, function(){
	          if(boxMessage[0]){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	          }
	        });
	      }else{
	        if(boxMessage[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
	        }
	      }
	      var boxComment = $scope.role.template.data.filter(function(d){ return d.columnType === 'COMMENT'; });
	      if ($scope.role.showComment) {
	        CompanyCommentsService.queryComments({
	          companyId: $stateParams.companyId,
	          limit: 4
	        }, function(resp){
	          $scope.comments = resp;
	          if(!boxComment[0]){
	            if($scope.comments.length > 0){
	              $scope.role.template.data.push({
	                isChart: false,
	                centralInformation: false,
	                columnType: 'COMMENT',
	                isFullBox: false,
	                chartData: {
	                  gsX: 0,
	                  gsY: yMax+heigthMax,
	                  gsWidth: 4,
	                  gsHeigth: 4,
	                }
	              });
	            }
	          }else{
	            if($scope.comments.length === 0){
	              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	            }
	          }
	        }, function(){
	          if(boxComment[0]){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	          }
	        });
	
	        $scope.$on('notification', function(e, data) {
	          if (data.type === 'COMMENT') {
	            var c = {
	              id: data.message.id,
	              text: data.message.text,
	              createdAt: (new Date()).toISOString(),
	              createdBy: data.sourceUser,
	              objectRelative: data.publication
	            };
	            $scope.$apply(function(){
	              if(data.message.parentID === 'undefined'){
	                if ($scope.comments.length === 4) {
	                  $scope.comments.splice($scope.comments.length - 1, 1);
	                }
	                $scope.comments.unshift(c);
	              }else{
	                angular.forEach($scope.comments, function(item){
	                  if(item.id === data.message.parentID){
	                    if(!item.commentChild){
	                      item.commentChild = [];
	                    }
	                    item.commentChild.push(c);
	                  }
	                });
	              }
	            });
	          }
	        });
	      }else{
	        if(boxComment[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
	        }
	      }
	      
	      var boxReminder = $scope.role.template.data.filter(function(d){ return d.columnType === 'REMINDER'; });
	      if ($scope.info.features.reminders && $scope.role.showReminder && !$scope.showAll) {
	        CompanyTaskService.query({companyId: $stateParams.companyId, status: 'INCOMPLETE', limit: 4}).$promise.then(function(resp){
	          $scope.latestTasks = resp;
	          if(!boxReminder[0]){
	            if($scope.latestTasks.length > 0){
	              $scope.role.template.data.push({
	                isChart: false,
	                centralInformation: false,
	                columnType: 'REMINDER',
	                isFullBox: false,
	                chartData: {
	                  gsX: 0,
	                  gsY: yMax+heigthMax,
	                  gsWidth: 4,
	                  gsHeigth: 4,
	                }
	              });
	              setTimeout(function(){
	                var grid = jQuery('.grid-stack').data('gridstack');
	                grid.addWidget(jQuery('.grid-stack-item:last-child'), 0, yMax+heigthMax, 4, 4, true);
	              }, 1000);
	            }
	          }else{
	            if($scope.latestTasks.length === 0){
	              $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	            }
	          }
	        }, function(){
	          if(boxReminder[0]){
	            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	          }
	        });
	      }else{
	        if(boxReminder[0]){
	          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
	        }
	      }
	
	      $scope.checkColors = function(xAxesDisplay){
	        if($scope.role.template && $scope.role.template.id){
	          angular.forEach($scope.role.template.data, function(v, k){
	            if(v.isChart && v.chartData){
	              if(v.chartData.type === 'line-bar'){
	                $scope.role.template.data[k].options = {
	                  legend: { 
	                    display: true , 
	                    position: 'bottom'
	                  },
	                  scales: {
	                    xAxes: [{
	                      ticks: {
	                        display: true
	                      }
	                    }],
	                    yAxes: []
	                  }
	                };
	                if(xAxesDisplay <= 483){
	                  $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                }else{
	                  if(xAxesDisplay < 999){
	                    if(xAxesDisplay > 807){
	                      if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
	                        if(k === 0){
	                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                        }else{
	                          if($scope.role.template.id === '6'){
	                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                          }else{
	                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                          }
	                        }
	                      }else{
	                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                      }
	                    }else{
	                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                    }
	                  }else{
	                    if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
	                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                    }
	                  }
	                }
	              }else{
	                $scope.role.template.data[k].options = { 
	                  legend: { 
	                    display: true, 
	                    position: 'bottom'
	                  }
	                };
	                if(v.chartData.type === 'bar' || v.chartData.type === 'line'){
	                  $scope.role.template.data[k].options = { 
	                    legend: { 
	                      display: true, 
	                      position: 'bottom'
	                    },
	                    scales: {
	                      xAxes: [{
	                        ticks: {
	                          display: true
	                        }
	                      }]
	                    } 
	                  };
	                  if(xAxesDisplay <= 483){
	                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                  }else{
	                    if(xAxesDisplay < 999){
	                      if(xAxesDisplay > 807){
	                        if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
	                          if(k === 0){
	                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                          }else{
	                            if($scope.role.template.id === '6'){
	                              $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                            }else{
	                              $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                            }
	                          }
	                        }else{
	                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                        }
	                      }else{
	                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
	                      }
	                    }else{
	                      if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
	                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
	                      }
	                    }
	                  }
	                }
	              }
	              if(v.chartData.type !== 'doughnut' && v.chartData.type !== 'pie'){
	                $scope.role.template.data[k].datasetOverride = [];
	                angular.forEach(v.chartData.colors, function(value, key){
	                  if(v.chartData.type === 'line-bar'){
	                    $scope.role.template.data[k].datasetOverride.push({
	                      yAxisID: 'y-axis-'+(key+1),
	                      borderWidth: key === 0 ? 2 : 1,
	                      backgroundColor: key === 0 ? 'transparent' : value,
	                      pointBackgroundColor: key === 0 ? 'transparent' : value,
	                      borderColor: value,
	                      pointBorderColor: value,
	                      type: key === 0 ? 'line' : 'bar'
	                    });
	                    $scope.role.template.data[k].options.scales.yAxes.push({
	                      id: 'y-axis-'+(key+1),
	                      display: true,
	                      position: key === 0 ? 'left' : 'right'
	                    });
	                  }else{
	                    $scope.role.template.data[k].datasetOverride.push({
	                      borderWidth: v.chartData.type === 'line' ? 2 : 1,
	                      backgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
	                      pointBackgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
	                      borderColor: value,
	                      pointBorderColor: value
	                    });
	                  }
	                });
	              }
	            }
	          });
	        }
	      };
	
	      var widthWindow = angular.element($window).width();
	      $scope.checkColors(widthWindow);
	      angular.element($window).on('resize', function () {
	        widthWindow = angular.element($window).width();
	        $scope.$apply(function(){
	          $scope.checkColors(widthWindow);
	        });
	      });
	    }
	    
	    if($scope.role && $scope.role.template !== null) {
	      $scope.userLinks = angular.isDefined($scope.userInfo.features.userLinks) ? $scope.userInfo.features.userLinks : [];
	    }
	  }
	
	  if(window.localStorage && window.localStorage.needToFetchDashboard === 'true') {
	    if(stateSnapshot.previous.state.name === 'root.company.publications-list'){
	      window.localStorage.needToFetchDashboard = false;
	      $state.go(stateSnapshot.previous.state.name, stateSnapshot.previous.params, {reload: true});
	    }else{
	      if($state.current.name === 'root.company.publications-list'){
	        window.localStorage.needToFetchDashboard = false;
	        $state.reload();
	      }
	    }
	  }
	
	
	  if($stateParams.q !== ''){
	     $window.scrollTo(0,0);
	  }
	
	  $scope.removeTag = function (tag) {
	    $scope.activeTags.splice($scope.activeTags.indexOf(tag), 1);
	    var tagQuery = null;
	    if ($scope.activeTags.length > 0) {
	      tagQuery = $scope.activeTags.join(',');
	    }
	    $state.go($state.current.name, {tags: tagQuery});
	  };
	
	  $scope.removeCategoryFilter = function() {
	    $state.go($state.current.name, {categoryId: null});
	  };
	
	  $scope.removeTypeFilter = function() {
	    $state.go($state.current.name, {type: null});
	  };
	
	  $scope.removeGroupFilter = function() {
	    $state.go($state.current.name, {groupId: null});
	  };
	
	  $scope.removePriorityFilter = function() {
	    $state.go($state.current.name, {priorityId: null});
	  };
	
	  $scope.removeDateFilter = function(t) {
	    if (t === 'from') {
	      $state.go($state.current.name, {from: null});
	    }
	    if (t === 'to') {
	      $state.go($state.current.name, {to: null});
	    }
	  };
	
	  $scope.page = $stateParams.page|0;
	  $scope.companyId = $stateParams.companyId;
	
	  $scope.getHiddenGroupName = function (publicationGroups) {
	    for (var length = publicationGroups.length, i = 0; i < length; i++) {
	      for (var groupLength = $scope.groups.length, j = 0; j < groupLength; j++) {
	        if ($scope.groups[j].id === publicationGroups[i]) {
	          return $scope.groups[j].name;
	        }
	      }
	    }
	
	    return '';
	  };
	
	  $scope.uploadFile = function(publication, $files) {
	    if (publication.type === 'NOTE') {
	      growl.addErrorMessage(translations['publication.file-upload-impossible']);
	      return false;
	    }
	    if (publication.uploadLock) {
	      growl.addErrorMessage(translations['publication.file-upload-locked']);
	      return false;
	    }
	    else {
	      $scope.uploadFilesForPublication($files, publication.id);
	    }
	  };
	
	  $scope.checkUploadLock = function(publication) {
	    if (publication.type === 'NOTE') {
	      return 'upload--forbidden';
	    }
	    else if (publication.uploadLock) {
	      return 'upload--locked';
	    }
	    else {
	      return 'upload--possible';
	    }
	  };
	
	
	  // Paging for categories
	  $scope.pageCat = parseInt($stateParams.pageCat, 10) || 1;
	  if ($scope.categories.length === 21) {
	    $scope.moreCat = true;
	  }
	}
	
	CompanyPublicationsListCtrl.resolve = {
	  publications: ['$stateParams', 'CompanyPublicationService', function ($stateParams, CompanyPublicationService) {
	    var companyId = $stateParams.companyId,
	      filter = {};
	
	    filter.companyId = companyId;
	
	    if ($stateParams.type !== '') {
	      filter.type = $stateParams.type;
	    }
	
	    if ($stateParams.q !== '') {
	      filter.q     = $stateParams.q;
	      filter.qType = $stateParams.qType || 'GENERAL';
	      if (filter.qType === 'REFERENCE' || filter.qType === 'KEYPASS') {
	        if (filter.qType === 'REFERENCE') {
	          filter.reference = filter.q;
	        } else if (filter.qType === 'KEYPASS') {
	          filter.keypass = filter.q;
	          filter.type = 'KEYPASS';
	        }
	        filter.q = '';
	        filter.qType = '';
	      }
	    }
	
	    if ($stateParams.categoryId !== '') {
	      filter.categoryId = $stateParams.categoryId;
	    }
	
	    if ($stateParams.priorityId !== '') {
	      filter.priorityId = $stateParams.priorityId;
	    }
	
	    if ($stateParams.tags !== '') {
	      if (Array.isArray($stateParams.tags)) {
	        filter.tags = $stateParams.tags.join(',');
	      } else {
	        filter.tags = $stateParams.tags;
	      }
	    }
	
	    if ($stateParams.groupId !== '') {
	      filter.groupId = $stateParams.groupId;
	    }
	
	    if ($stateParams.year && $stateParams.year !== '') {
	      filter.year = $stateParams.year;
	    }
	
	    if ($stateParams.month && $stateParams.month !== '') {
	      filter.month = $stateParams.month;
	    }
	
	    if ($stateParams.from) {
	      filter.from = $stateParams.from;
	    }
	
	    if ($stateParams.to) {
	      filter.to = $stateParams.to;
	    }
	
	    filter.orderby = 'updated';
	    if ($stateParams.orderby) {
	      filter.orderby = $stateParams.orderby;
	    }
	    if ($stateParams.asc) {
	      filter.asc = $stateParams.asc;
	    }
	    if ($stateParams.qTypeObject && $stateParams.qTypeObject === 'ARCHIVED') {
	      filter.archived = true;
	    }
	    // Fetch 21 for pagination, but the offset should be using 20
	    filter.limit = 61;
	    filter.offset = ($stateParams.page|0) * 60;
	
	    return CompanyPublicationService.query(filter).$promise;
	  }],
	  currentCategory: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	    if ($stateParams.categoryId) {
	      return CompanyCategoryService.get({
	        companyId: $stateParams.companyId,
	        categoryId: $stateParams.categoryId
	      }).$promise;
	    }
	  }],
	  translations: ['$translate', function ($translate) {
	    return $translate([
	      'list',
	      'all-cards',
	      'publication.file-upload-locked',
	      'publication.file-upload-impossible'
	    ]);
	  }]
	};
	module.exports = CompanyPublicationsListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsListCtrl', [
	    '$scope',
	    '$stateParams',
	    'stateSnapshot',
	    '$state',
	    '$modal',
	    '$timeout',
	    '$controller',
	    'publications',
	    'categories',
	    'currentCategory',
	    'priorities',
	    'userInformation',
	    'translations',
	    'CompanyGroupService',
	    'CompanyMessageService',
	    'CompanyCommentsService',
	    'CompanyPublicationService',
	    'growl',
	    'reloadUserRoleDashboard',
	    'CompanyTaskService', 
	    'CompanyUserService',
	    '$window',
	    CompanyPublicationsListCtrl
	]);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	
	function CompanyPublicationsListDraftsCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  publications,
	  currentCategory,
	  priorities,
	  translations
	) {
	  var i;
	  $scope.publications = publications;
	  $scope.$state = $state;
	  $scope.priorityId = $stateParams.priorityId || null;
	  $scope.selectedPriority = null;
	  $scope.more = false;
	  $scope.currentCategory = currentCategory;
	  $scope.title = translations['publication.drafts'];
	
	  if (currentCategory && currentCategory.name) {
	    $scope.title = currentCategory.name;
	  }
	
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  $scope.priorities = priorities;
	
	  priorities.$promise.then(function() {
	    for (i = 0; i < priorities.length; i++) {
	      if(priorities[i].id === $scope.priorityId) {
	        $scope.selectedPriority = priorities[i];
	      }
	      $scope.priorities[priorities[i].id] = priorities[i];
	    }
	  });
	
	  $scope.page = $stateParams.page|0;
	  $scope.companyId = $stateParams.companyId;
	  $scope.listDrafts = true;
	
	}
	
	CompanyPublicationsListDraftsCtrl.resolve = {
	  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    var companyId = $stateParams.companyId,
	    filter = {};
	
	    if ('' !== $stateParams.priorityId) {
	      filter.priorityId = $stateParams.priorityId;
	    }
	    filter.companyId = companyId;
	    // Fetch 21 for pagination, but the offset should be using 20
	    filter.limit = 21;
	    filter.offset = ($stateParams.page|0) * 20;
	
	    return CompanyPublicationService.queryDrafts(filter).$promise;
	  }],
	  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
	  }],
	  currentCategory: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
	    if ($stateParams.categoryId) {
	      return CompanyCategoryService.get({
	        companyId: $stateParams.companyId,
	        categoryId: $stateParams.categoryId
	      }).$promise;
	    }
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.all-status',
	      'publication.list-drafts',
	      'publication.drafts'
	    ]);
	  }]
	};
	module.exports = CompanyPublicationsListDraftsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsListDraftsCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    'publications',
	    'currentCategory',
	    'priorities',
	    'translations',
	    CompanyPublicationsListDraftsCtrl
	  ]);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	
	function CompanyPublicationsListStarredCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  publications,
	  translations
	) {
	  $scope.publications = publications;
	  $scope.$state = $state;
	  $scope.more = false;
	  $scope.title = translations['publication.starred'];
	
	  if($scope.publications.length === 21) {
	    $scope.more = true;
	    $scope.publications.pop();
	  }
	
	  $scope.page = $stateParams.page|0;
	  $scope.companyId = $stateParams.companyId;
	  $scope.listStarred = true;
	
	  $scope.filter = {};
	  if ($stateParams.queryStarred) {
	    $scope.filter.q = $stateParams.queryStarred;
	  }
	
	  $scope.searchPublications = function() {
	    $state.go('.', {
	      companyId: $stateParams.companyId,
	      queryStarred: $scope.filter.q
	    });
	  };
	
	}
	
	CompanyPublicationsListStarredCtrl.resolve = {
	  publications: ['$stateParams', 'CurrentUserService', 'CompanyUserStarService', function($stateParams, CurrentUserService, CompanyUserStarService) {
	    return CurrentUserService.get().then(function(user) {
	      var companyId = $stateParams.companyId,
	      filter = {};
	
	      filter.companyId = companyId;
	      filter.userId = user.id;
	      // Fetch 21 for pagination, but the offset should be using 20
	      filter.limit = 21;
	      filter.offset = ($stateParams.page|0) * 20;
	      filter.q = $stateParams.queryStarred || null;
	
	      return CompanyUserStarService.query(filter).$promise;
	    });
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.list-starred',
	      'publication.starred'
	    ]);
	  }]
	};
	module.exports = CompanyPublicationsListStarredCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsListStarredCtrl', [
	    '$scope',
	    '$stateParams',
	    '$state',
	    'publications',
	    'translations',
	    CompanyPublicationsListStarredCtrl
	  ]);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(5);
	
	function CompanyPublicationsListWatchedCtrl($scope, $state, $stateParams, publications, translations) {
	  $scope.more         = publications.length > 20;
	  $scope.publications = publications.slice(0, 20);
	  $scope.page         = $stateParams.page|0;
	  $scope.title        = translations["publication.your-watched-publications"];
	  $scope.listWatching = true;
	
	  $scope.filter = {};
	  if ($stateParams.queryWatched) {
	    $scope.filter.q = $stateParams.queryWatched;
	  }
	
	  $scope.searchPublications = function() {
	    $state.go('.', {
	      companyId: $stateParams.companyId,
	      queryWatched: $scope.filter.q
	    });
	  };
	}
	
	module.exports = {
	  resolve: {
	    publications: ["$stateParams", "CurrentUserService", "CompanyPublicationService", function($stateParams, currentUser, publications) {
	      return currentUser.get().then(function(u) {
	        var filter = {
	          userId:    u.id,
	          companyId: $stateParams.companyId,
	          limit:     21,
	          offset:    ($stateParams.page|0) * 20,
	          q: $stateParams.queryWatched || null
	        };
	
	        return publications.queryWatched(filter).$promise;
	      });
	    }],
	    translations: ["$translate", function($translate) {
	      return $translate(["publication.your-watched-publications"]);
	    }]
	  }
	};
	
	angular.module("dokiv")
	  .controller("CompanyPublicationsListWatchedCtrl", ["$scope", "$state", "$stateParams", "publications", "translations", CompanyPublicationsListWatchedCtrl]);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(14);
	__webpack_require__(62);
	__webpack_require__(31);
	
	function CompanyPublicationsNewCtrl(
	  $scope,
	  $q,
	  groups,
	  allPortals,
	  priorities,
	  categories,
	  pubCopy,
	  watchersCopy,
	  translations,
	  $stateParams,
	  $state,
	  $filter,
	  growl,
	  currentUser,
	  CompanyPublicationService,
	  CompanyUserService,
	  CompanyPublicationWatcherService,
	  CompanyGroupUserService,
	  publicationCompanyOrderService,
	  publicationCompanyOrderSubcriptionService,
	  CompanyPublicationCompanyInvestigationService,
	  customersService,
	  CompanyPublicationPlantService
	) {
	  $scope.groups         = groups;
	  $scope.allPortals     = allPortals;
	  $scope.categories     = categories;
	  $scope.typeahead      = {};
	  $scope.priorities     = priorities;
	  $scope.createType     = "SINGLE";
	  $scope.users          = new CompanyUserService.query({companyId: $stateParams.companyId});
	  $scope.pubCopy = pubCopy;
	
	  $scope.activeTab = $stateParams.activeTab || "";
	  $scope.availableTypes = $scope.types.filter(function(t) {
	    return $scope.currentCompany.enabledFeatures.publicationTypes.indexOf(t) !== -1;
	  });
	
	  $scope.publication = new CompanyPublicationService({
	    name:     [""],
	    status:   "DRAFT",
	    type:     $stateParams.activeTab && $scope.availableTypes.indexOf($stateParams.activeTab) !== -1 ? $stateParams.activeTab : $scope.availableTypes[0],
	    tags:     [],
	    groups:   []
	  });
	
	  $scope.toggleSelectPortal = function(id) {
	    var i = $scope.publication.groups.indexOf(id);
	    if(-1 !== i) {
	      $scope.publication.groups.splice(i, 1);
	    } else {
	      $scope.publication.groups.push(id);
	    }
	  };
	
	  $scope.watchers = [];
	  $scope.saving   = false;
	  $scope.keys     = function(arg) {
	    return Object.keys(arg);
	  };
	
	  $scope.$on('$typeahead.select', function() {
	    if($scope.typeahead.publicationParent) {
	      $scope.publication.parent = {
	        id:   $scope.typeahead.publicationParent.id,
	        name: $scope.typeahead.publicationParent.name
	      };
	
	      $scope.typeahead.publicationParent = '';
	    }
	  });
	
	  $scope.setPublicationType = function(type) {
	    $scope.publication.type = type;
	
	    if ($scope.createType === 'BULK') {
	      $scope.toggleSingle();
	    }
	  };
	
	
	  // bulk
	  $scope.toggleSingle = function() {
	    $scope.createType = 'SINGLE';
	    $scope.publication.name.splice(1);
	  };
	
	  $scope.toggleBulk = function() {
	    $scope.createType = 'BULK';
	    $scope.bulkAddItem();
	  };
	
	  $scope.bulkAddItem = function() {
	    if ($scope.publication.name.length < 20) {
	      $scope.publication.name.push('');
	    }
	  };
	
	  $scope.bulkRemoveItem = function(item) {
	    if (item > 0) {
	      $scope.publication.name.splice(item, 1);
	    }
	
	    if ($scope.publication.name.length === 1) {
	      $scope.toggleSingle();
	    }
	  };
	
	
	  // settings
	  $scope.setPriority = function(priority) {
	    if (!priority) {
	      $scope.publication.priority = null;
	    } else {
	      $scope.publication.priority = priority;
	    }
	  };
	
	  $scope.setCategory = function(category) {
	    if (!category) {
	      $scope.publication.category = null;
	    } else {
	      $scope.publication.category = category;
	    }
	  };
	
	  $scope.setGroup = function(group) {
	    if (!group) {
	      $scope.publication.groups = [];
	      $scope.selectedGroup = null;
	      $scope.members = [];
	    }
	
	    else {
	      $scope.publication.groups.push(group.id);
	      $scope.selectedGroup = group;
	
	      CompanyGroupUserService.query({companyId: $stateParams.companyId, groupId: group.id}).$promise.then(function(members) {
	        $scope.members = members;
	      });
	    }
	  };
	
	
	  // tags
	  $scope.setTag = function(tag) {
	    $scope.publication.tags.push(tag);
	
	    angular.element('#filterTags').val('');
	  };
	
	  $scope.removeTag = function(tag) {
	    $scope.publication.tags.splice($scope.publication.tags.indexOf(tag), 1);
	  };
	
	  $scope.addedTags = function(item) {
	    return $scope.publication.tags.indexOf(item) === -1;
	  };
	
	
	  // watchers
	  $scope.addWatcher = function(watcher) {
	    $scope.watchers.push(watcher);
	
	    angular.element('#filterWatchers').val('');
	  };
	
	  $scope.deleteWatcher = function(watcher) {
	    $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
	  };
	
	  $scope.addedWatchers = function(watcher) {
	    return $scope.watchers.indexOf(watcher) === -1;
	  };
	
	  // save
	  $scope.saveAndContinueCreating = function() {
	    if ($scope.group) {
	      $scope.publication.groups.push($scope.group);
	    }
	
	    if($scope.publication.addedCustomer && $scope.publication.addedCustomer.extra.group && $scope.publication.groups.indexOf($scope.publication.addedCustomer.extra.group.id) === -1){
	      $scope.publication.groups.push($scope.publication.addedCustomer.extra.group.id);
	    }
	
	    var saving = $scope.publication.name.map(function(name) {
	      var p   = $q.defer();
	      var pub = angular.copy($scope.publication);
	
	      $scope.saving = true;
	
	      pub.name = name;
	      
	      pub.$save({companyId: $stateParams.companyId}, function(resp, headers) {
	        var newId    = headers('Location').split('/').pop();
	        var watchers = $scope.watchers.map(function(w) {
	          return new CompanyPublicationWatcherService({
	            id: w.id
	          }).$save({companyId: $stateParams.companyId, publicationId: newId});
	        });
	
	        if (pub.type === 'PLANT') {
	          var createPlant = CompanyPublicationPlantService.update({
	            companyId: $stateParams.companyId,
	            publicationId: newId
	          }, $scope.plant).$promise;
	          watchers.push(createPlant);
	        }
	
	        if(pub.type === 'INVESTIGATION'){
	          var newUser = {
	            email: currentUser.email,
	            name: currentUser.name,
	            publication: resp,
	            type: 'ANVARIG',
	            user: currentUser
	          };
	          CompanyPublicationCompanyInvestigationService.addUsersInvestigation({
	            companyId: $stateParams.companyId,
	            publicationId: newId
	          }, newUser);
	        }
	
	        $q.all(watchers).then(function() {
	          pub.id = newId;
	
	          p.resolve(pub);
	        }, function(error) {
	          p.reject(error);
	        });
	      }, function(error) {
	        if (error.status === 400 && error.data.error && error.data.error.code === 1614) {
	          growl.addErrorMessage(translations['publication.reached-your-limit']);  
	        } else {
	          growl.addErrorMessage(translations['publication.create-failure']);
	        }
	        p.reject(error);
	      });
	
	      return p.promise;
	    });
	
	    return $q.all(saving).then(function(publications) {
	      $scope.saving                  = false;
	      $scope.publication.name        = [""];
	      $scope.publication.description = [""];
	
	      growl.addSuccessMessage(translations['publication.create-success']);
	
	      if(publications.length > 0) {
	        return publications[publications.length - 1];
	      }
	      else {
	        return null;
	      }
	    });
	  };
	
	  $scope.queryCustomers = function(text) {
	    return customersService.query({
	      companyId: $stateParams.companyId,
	      q:         text,
	      limit:     10
	    }).$promise;
	  };
	
	  function addCustomer() {
	    var customerDeferred = $q.defer();
	    customerDeferred.resolve();
	    customerDeferred.promise.then(function(){
	      customersService.addObject({
	        companyId: $stateParams.companyId,
	        customerId: $scope.publication.addedCustomer.id
	      }, {
	        object: {
	          id: $scope.publication.id,
	          name: $scope.publication.name
	        }
	      });
	    });
	
	    var data = {
	      customer: $scope.publication.addedCustomer
	    };
	
	    data.publication = {
	      name: $scope.publication.name,
	      id: $scope.publication.id
	    };
	
	    if($scope.publication.type === 'COMPANY_ORDER'){
	      publicationCompanyOrderService.update({
	        companyId: $stateParams.companyId,
	        publicationId: $scope.publication.id
	      }, data).$promise.then(function(order){
	        $scope.publication.features = {
	          currentCustomerId: $scope.publication.addedCustomer.id,
	          currentCompanyOrderId: order.id
	        };
	        $scope.savePublication($scope.publication);
	        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+$scope.publication.id;
	      }).then(function(){
	        growl.addSuccessMessage(translations['order.customer.add-success']);
	      }, function(){
	        growl.addErrorMessage(translations['order.customer.add-failure']);
	      });
	    }else{
	      publicationCompanyOrderSubcriptionService.update({
	        companyId: $stateParams.companyId,
	        publicationId: $scope.publication.id
	      }, data).$promise.then(function(order){
	        $scope.publication.features = {
	          currentCustomerId: $scope.publication.addedCustomer.id,
	          currentCompanyOrderId: order.id
	        };
	        $scope.savePublication($scope.publication);
	        $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: $scope.publication.id});
	        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+$scope.publication.id;
	      }).then(function(){
	        growl.addSuccessMessage(translations['order.customer.add-success']);
	      }, function(){
	        growl.addErrorMessage(translations['order.customer.add-failure']);
	      });
	    }
	  }
	
	  $scope.save = function() {
	    $scope.saveAndContinueCreating().then(function(p) {
	      if( ! p) {
	        $state.go('root.company.publications-list', {companyId: $stateParams.companyId});
	
	        return;
	      }
	      if(p.type === 'COMPANY_ORDER' || p.type === 'ORDER_SUBCRIPTION'){
	        if($scope.publication.addedCustomer.id){
	          var addedCustomer = $scope.publication.addedCustomer;
	          $scope.publication = p;
	          $scope.publication.addedCustomer = addedCustomer;
	          addCustomer(p);
	        }else{
	          if(p.type === 'COMPANY_ORDER'){
	            window.location.href = '/order/'+$stateParams.companyId+'/detail/'+p.id;
	          }
	          if(p.type === 'ORDER_SUBCRIPTION'){
	            window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+p.id;
	          }
	        }
	      }else{
	        if(p.type !== 'FORM' && p.type !== 'PUBLICATION_SPREAD_SHEET'){
	          $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: p.id});
	        }else{
	          if(p.type === 'PUBLICATION_SPREAD_SHEET'){
	            window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+p.id;
	          }
	          if(p.type === 'FORM'){
	            if (
	              p.features.formActived === "false" ||
	              !!p.features.formActived === false
	            ) {
	              window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+p.id+'/detail';
	            }else{
	              window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+p.id+'/form-submit';
	            }
	          }
	        }
	      }
	    });
	  };
	
	  if ($scope.pubCopy) {
	    $scope.publication.name[0] = $scope.pubCopy.name || "";
	    $scope.publication.description = $scope.pubCopy.description || "";
	    $scope.publication.tags = $scope.pubCopy.tags || [];
	
	    if ($scope.pubCopy.groups.length > 0) {
	      angular.forEach($scope.pubCopy.groups, function(g){
	        $scope.setGroup({
	          id: g
	        });
	      });
	    }
	
	    if ($scope.pubCopy.category) {
	      $scope.setCategory($scope.pubCopy.category);
	    }
	
	    var parent = {
	      id: pubCopy.id,
	      name: pubCopy.name
	    };
	    $scope.publication.parent = parent;
	
	    if ($scope.pubCopy.priority) {
	      $scope.setPriority($scope.pubCopy.priority);
	    }
	
	    if (watchersCopy.length > 0) {
	      $scope.watchers = watchersCopy;
	    }
	  }
	
	}
	
	CompanyPublicationsNewCtrl.resolve = {
	  pubCopy: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
	    if ($stateParams.pubCopyId) {
	      return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.pubCopyId}).$promise;
	    }
	    return null;
	  }],
	  watchersCopy: ['$stateParams', 'CompanyPublicationWatcherService', function($stateParams, CompanyPublicationWatcherService){
	    if ($stateParams.pubCopyId) {
	      return CompanyPublicationWatcherService.query({companyId: $stateParams.companyId, publicationId: $stateParams.pubCopyId}).$promise;
	    }
	    return [];
	  }],
	  categories: ['$stateParams', 'CompanyCategoryService', 'company', function($stateParams, CompanyCategoryService) {
	    return CompanyCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
	  }],
	  groups: ['$stateParams', '$window', 'CompanyGroupService', 'company', function($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, all: true}).$promise;
	  }],
	  allPortals: ['$stateParams', '$window', 'CompanyGroupService', 'company', function($stateParams, $window, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, all: true, type: 'VISIBLE'}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate(['new', 'publication.create-success', 'publication.create-failure', 'publication.reached-your-limit', 'order.customer.add-success', 'order.customer.add-failure']);
	  }]
	};
	module.exports = CompanyPublicationsNewCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyPublicationsNewCtrl', [
	    '$scope',
	    '$q',
	    'groups',
	    'allPortals',
	    'priorities',
	    'categories',
	    'pubCopy',
	    'watchersCopy',
	    'translations',
	    '$stateParams',
	    '$state',
	    '$filter',
	    'growl',
	    'currentUser',
	    'CompanyPublicationService',
	    'CompanyUserService',
	    'CompanyPublicationWatcherService',
	    'CompanyGroupUserService',
	    'CompanyPublicationCompanyOrderService',
	    'CompanyPublicationCompanyOrderSubcriptionService',
	    'CompanyPublicationCompanyInvestigationService',
	    'CompanyCustomersService',
	    'CompanyPublicationPlantService',
	    CompanyPublicationsNewCtrl
	  ]);


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(10);
	
	function uuidV4() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	    var r = Math.random()*16|0;
	    var v = c === 'x' ? r : (r&0x3|0x8);
	
	    return v.toString(16);
	  });
	}
	
	function PublicationChecklistCheckboxDirective() {
	  return {
	    restrict: "A",
	    templateUrl: "partials/company/publications/checklist/checklist-checkbox.html",
	    scope: {
	      c: "=publicationChecklistCheckbox",
	      remove: "&onRemove",
	      readOnly: "=",
	      checkOnly: "=",
	      editOnly: "="
	    },
	    link: function($scope, elem) {
	      $scope.detailsVisible = false;
	      $scope.showDetails = function() {
	        if (!$scope.readOnly && !$scope.checkOnly) {
	          $scope.detailsVisible = true;
	          $scope.textCopy       = $scope.c.text;
	        }
	      };
	      $scope.isUrlValid = function(url) {
	        var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
	        return regex.test(url);
	      };
	      $scope.getUrlName = function(url){
	        var indexProtocol = url.indexOf('http://');
	        var result, index;
	        if(indexProtocol > -1){
	          result = url.substring(indexProtocol+7, url.length);
	          index = result.indexOf(' ');
	          return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
	        }else{
	          indexProtocol = url.indexOf('https://');
	          if(indexProtocol > -1){
	            result = url.substring(indexProtocol+8, url.length);
	            index = result.indexOf(' ');
	            return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
	          }else{
	            indexProtocol = url.indexOf('www.');
	            if(indexProtocol > -1){
	              result = url.substring(indexProtocol, url.length);
	              index = result.indexOf(' ');
	              return url.substring(0, indexProtocol)+'<a class="checklist__link">'+result.substring(0, index > -1 ? index : result.length)+'</a>'+(index > -1 ? result.substring(index, result.length) : '');
	            }else{
	              return url;
	            }
	          }
	        }
	      };
	      $scope.getUrl = function(url){
	        var indexProtocol = url.indexOf('http://');
	        var result, index;
	        if(indexProtocol > -1){
	          result = url.substring(indexProtocol, url.length);
	          index = result.indexOf(' ');
	          return result.substring(0, index > -1 ? index : result.length);
	        }else{
	          indexProtocol = url.indexOf('https://');
	          if(indexProtocol > -1){
	            result = url.substring(indexProtocol, url.length);
	            index = result.indexOf(' ');
	            return result.substring(0, index > -1 ? index : result.length);
	          }else{
	            indexProtocol = url.indexOf('www.');
	            if(indexProtocol > -1){
	              result = url.substring(indexProtocol, url.length);
	              index = result.indexOf(' ');
	              return 'http://'+result.substring(0, index > -1 ? index : result.length);
	            }else{
	              return url;
	            }
	          }
	        }
	      };
	      $scope.abort = function() {
	        $scope.textCopy       = "";
	        $scope.detailsVisible = false;
	      };
	      $scope.save = function() {
	        if ($scope.readOnly || $scope.checklist) {
	          return;
	        }
	        if ($scope.textCopy !== "") {
	          $scope.c.text = $scope.textCopy;
	          $scope.$emit('checklistUpdating');
	        }
	        $scope.abort();
	      };
	
	      $scope.toggleItemChecklist = function() {
	        if ($scope.readOnly || $scope.editOnly) {
	          return;
	        }
	
	        $scope.c.checked = !$scope.c.checked;
	        $scope.$emit('checklistUpdating');
	        
	      };
	
	      var inputElm = elem.find('input');
	      inputElm.on("keydown keypress", function (event) {
	        //The checklist will be saved if user press Enter key
	        if(event.which === 13) {
	          if ($scope.textCopy) {
	            $scope.$apply(function (){
	                  $scope.save();
	            });
	          }
	          event.preventDefault();
	        }
	      });
	    }
	  };
	}
	
	function PublicationChecklistDirective(CompanyChecklistService, $stateParams, $window, $rootScope, $modal, CompanyUserService) {
	  return {
	    restrict: "EA",
	    templateUrl: function (element, attrs) {
	      if (attrs.type && attrs.type === 'admin') {
	        return 'partials/company/checklist/checklist-directive.html';
	      } else if (attrs.type && attrs.type === 'guest'){
	        return 'partials/company-guest/checklist/checklist.html';
	      } else {
	        return 'partials/company/publications/checklist/checklist.html';
	      }
	    },
	    scope: {
	      disabled: "=checklistDisabled",
	      delete: "&onDelete",
	      readOnly: "=",
	      checkOnly: "=",
	      editOnly: "=",
	      showCheckbox: "=",
	      userPermissions: "="
	    },
	    require: "ngModel",
	    link: function($scope, elem, attrs, model) {
	
	      $scope.sortableOptions = {
	        handle: '.dnd-handle'
	      };
	      var widthWindow;
	      if(!$scope.readOnly && !$scope.checkOnly){
	        widthWindow = angular.element($window).width();
	        setTimeout(function(){
	          if(widthWindow <= 807){
	            angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
	          }else{
	            angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
	          }
	        }, 1);
	        angular.element($window).on('resize', function () {
	          widthWindow = angular.element($window).width();
	          if(widthWindow <= 807){
	            angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
	          }else{
	            angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
	          }
	        });
	      }
	
	      model.$render = function() {
	        $scope.checklist = model.$viewValue;
	        $scope.oldChecklist = angular.copy($scope.checklist);
	        if ($scope.checklist.focus) {
	          $scope.autoFocus = true;
	        }
	      };
	
	      $scope.$watch("checklist", function(newData, oldData) {
	        calcPercent();
	        if(angular.equals(newData, oldData)) {
	          return;
	        }
	        if (newData.data.length !== oldData.data.length) {
	            $scope.$emit('checklistUpdating');
	        }
	      }, true);
	
	      function calcPercent() {
	        var count = 0;
	        angular.forEach($scope.checklist.data, function(v){
	          if (v.checked === true) {
	            count++;
	          }
	        });
	        $scope.progress = Math.round(count/$scope.checklist.data.length*100);
	      }
	
	      var inputElm = elem.find('.media__body input.checklist__input');
	      inputElm.on("keydown keypress", function (event) {
	        //The checklist will be saved if user press Enter key
	        if(event.which === 13) {
	          if ($scope.newText) {
	            $scope.$apply(function (){
	                  $scope.addCheckbox('', $scope.newText);
	                  $scope.newText = '';
	            });
	          }
	          event.preventDefault();
	        }
	      });
	
	      $scope.saveChecklist = function() {
	        return CompanyChecklistService.update({
	          companyId: $stateParams.companyId
	        }, $scope.checklist).$promise.then(function(){
	          $scope.oldChecklist = angular.copy($scope.checklist);
	        }, function(){
	          $scope.checklist = angular.copy($scope.oldChecklist);
	        });
	      };
	
	      $scope.$on("checklistUpdating", function() {
	        if ($scope.readOnly) {
	          return;
	        }
	
	        $scope.saveChecklist();
	      }, true);
	
	      $scope.addCheckbox = function(before, text) {
	        var idx = $scope.checklist.data.indexOf(before);
	        $scope.checklist.data.splice(idx < 0 ? $scope.checklist.data.length : idx, 0, {
	          checked: false,
	          id: uuidV4(),
	          text:    typeof text === "string" ? text : "",
	          order: $scope.checklist.data.length
	        });
	        if(!$scope.readOnly && !$scope.checkOnly){
	          setTimeout(function(){
	            widthWindow = angular.element($window).width();
	            if(widthWindow <= 807){
	              angular.element(elem).find('.checkbox-item').removeClass('dnd-handle');
	            }else{
	              angular.element(elem).find('.checkbox-item').addClass('dnd-handle');
	            }
	          }, 1);
	        }
	      };
	
	      $scope.removeCheckbox = function(checkbox) {
	        var idx = $scope.checklist.data.indexOf(checkbox);
	
	        if(idx > -1) {
	          $scope.checklist.data.splice(idx, 1);
	        }
	      };
	
	      $scope.editingHeader = function() {
	        if (!$scope.readOnly && !$scope.checkOnly) {
	          $scope.headerCopy       = $scope.checklist.header;
	          $scope.formVisible = true;
	        }
	      };
	
	      $scope.abortHeader = function() {
	        $scope.formVisible = false;
	      };
	
	      $scope.saveHeader = function() {
	        $scope.checklist.header = $scope.headerCopy;
	        $scope.abortHeader();
	        $scope.$emit('checklistUpdating');
	      };
	
	      $scope.ndnMovedCallback = function() {
	        $scope.$emit('checklistUpdating');
	      };
	
	      inputElm = elem.find('header input');
	      inputElm.on("keydown keypress", function (event) {
	        //The checklist will be saved if user press Enter key
	        if(event.which === 13) {
	          if ($scope.headerCopy) {
	            $scope.$apply(function (){
	              $scope.saveHeader();
	            });
	          }
	          event.preventDefault();
	        }
	      });
	
	      var modal;
	      $scope.showConnectedModal = function() {
	        $rootScope.loading = true;
	        modal = $modal({
	          scope: $scope,
	          controller: ['$scope', 'connectedObjects', function($scope, connectedObjects){
	            $scope.connectedObjects = connectedObjects;
	          }],
	          templateUrl: 'partials/company/publications/checklist/connected.html',
	          show: false,
	          resolve: {
	            connectedObjects: ['CompanyChecklistService', '$stateParams', function(CompanyChecklistService, $stateParams) {
	              return CompanyChecklistService.queryConnected({
	                companyId: $stateParams.companyId,
	                checklistID: $scope.checklist.id
	              }).$promise;
	            }]
	          }
	        });
	
	        modal.$promise.then(function(){
	          modal.show();
	          $rootScope.loading = false;
	        }, function() {
	          $rootScope.loading = false;
	        });
	      };
	
	      var nonWatchersPromise;
	      $scope.nonWatchers = [];
	      $scope.updateNonWatchers = function(filter) {      
	        var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
	          return users.filter(function(item) {
	            return !$scope.checklist.watchers.some(function(watcher) {
	              return item.id === watcher.id;
	            });
	          });
	        }).then(function(nonWatchers) {
	          if(nonWatchersPromise === p) {
	            $scope.nonWatchers = nonWatchers;
	          }
	        });
	        
	        nonWatchersPromise = p;
	      };
	    }
	  };
	}
	
	function ChecklistInitDirective(CompanyChecklistService, $stateParams, $popover) {
	  return {
	    restrict: "EA",
	    require: "ngModel",
	    scope: {
	      objectRelativeType: "=?",
	      objectRelativeId: "=?",
	      access: "="
	    },
	    replace: true,
	    link: function(scope, elem, attrs, model) {
	      if (attrs.hasOwnProperty("wrapperClass")) {
	        elem.addClass(attrs.wrapperClass);
	      }
	
	      if (!scope.objectRelativeType) {
	        scope.objectRelativeType = 'PUBLICATION';
	      }
	
	      if (!scope.objectRelativeId) {
	        scope.objectRelativeId = $stateParams.publicationId;
	      }
	
	      model.$render = function() {
	        scope.checklists = model.$viewValue;
	      };
	
	      var DEFAULT_CHECKLIST = {
	        object_relative_id: scope.objectRelativeId,
	        header: "",
	        data: [],
	        object_relative_type: scope.objectRelativeType,
	        focus: true
	      };
	
	      scope.checklist = angular.copy(DEFAULT_CHECKLIST);
	
	      scope.autoFocus = false;
	
	      scope.filter = {};
	
	      var popover;
	      scope.createChecklist = function() {
	        scope.checklist.order = scope.checklists.length + 1;
	        CompanyChecklistService.update({
	          companyId: $stateParams.companyId
	        }, scope.checklist, function(c){
	          c.focus = true;
	          scope.checklists.push(c);
	          scope.checklist = angular.copy(DEFAULT_CHECKLIST);
	          scope.filter.header = null;
	          scope.checklistClone = null;
	        });
	        if (popover) {
	          popover.$promise.then(popover.hide);
	        }
	      };
	
	      scope.search = function() {
	        scope.checklistClone = null;
	        CompanyChecklistService.query({
	          companyId: $stateParams.companyId,
	          relativeID: $stateParams.companyId,
	          header: scope.filter.header
	        }).$promise.then(function(resp){
	          scope.itemQuery = resp;
	        });
	      };
	
	      scope.addChecklist = function(checklist) {
	        scope.checklist.header = checklist.header;
	        scope.filter.header = checklist.header;
	        scope.checklistClone = checklist;
	      };
	
	      scope.cloneChecklist = function() {
	        scope.checklist = angular.copy(scope.checklistClone);
	        scope.checklist.object_relative_id = scope.objectRelativeId;
	        scope.checklist.object_relative_type = scope.objectRelativeType;
	        scope.checklist.parent_id = scope.checklist.id;
	        delete scope.checklist.id;
	        scope.createChecklist();
	      };
	
	      scope.popov = function(el){
	        scope.itemQuery = [];
	        if (!popover) {
	          popover = $popover(angular.element(el.target), {
	            placement: 'bottom',
	            templateUrl: 'partials/company/publications/checklist/popover.html',
	            autoClose: 1,
	            scope: scope
	          });
	          popover.$promise.then(popover.show);
	        } else {
	          popover.$promise.then(popover.hide);
	        }
	      };
	    },
	    templateUrl: 'partials/company/publications/checklist/checklist-form.html'
	  };
	}
	
	function CompanyChecklistDirective(checklistService, $stateParams, $modal, $translate) {
	  return {
	    restrict: "EA",
	    require: "ngModel",
	    scope: {
	      accessType: "=",
	      readOnly: "=",
	      editOnly: "=",
	      showCheckbox: "=",
	      userPermissions: "="
	    },
	    replace: true,
	    link: function($scope, elem, attrs, model) {
	      $scope.sortableOptions = {
	        handle: ' .dnd-handle'
	      };
	
	      model.$render = function() {
	        $scope.checklists = model.$modelValue;
	      };
	
	      $scope.deleteChecklist = function(index, checklist) {
	        checklistService.delete({
	          companyId: $stateParams.companyId,
	          checklistID: checklist.id
	        }).$promise.then(function(){
	          $scope.checklists.splice(index, 1);
	        });
	      };
	
	      $scope.ndnMovedCallback = function() {
	        setTimeout(function() {
	          angular.forEach($scope.checklists, function(value, key){
	            if ($scope.checklists[key].order !== key) {
	              $scope.checklists[key].order = key;
	              checklistService.update({
	                companyId: $stateParams.companyId
	              }, $scope.checklists[key]);
	            }
	          });
	        }, 1);
	      };
	
	      var angularModal;
	      $scope.showModalDeleteChecklist = function(index, checklist) {
	         angularModal = $modal({
	          scope: $scope,
	          prefixEvent: "modalChecklist",
	          controller: ['$scope', function($scope) {
	            $scope.confirmName = $translate.instant('checklist.confirm-delete');
	            $scope.activeDelete = function() {
	              $scope.deleteChecklist(index, checklist);
	            };
	          }],
	          templateUrl: 'partials/company/publications/detail/latest/confirm-delete.html',
	          show: true,
	        });
	      };
	
	      $scope.$on('modalChecklist.hide', function(){
	        angularModal.destroy();
	        angularModal = null;
	      });
	    },
	    templateUrl: "partials/company/publications/checklist/checklists.html"
	  };
	}
	
	angular.module("dokiv")
	  .directive("publicationChecklist", ["CompanyChecklistService", "$stateParams", "$window", "$rootScope", "$modal", "CompanyUserService", PublicationChecklistDirective])
	  .directive("checklistInitDirective", ["CompanyChecklistService", "$stateParams", "$popover", ChecklistInitDirective])
	  .directive("publicationChecklistCheckbox", PublicationChecklistCheckboxDirective)
	  .directive("companyChecklist", ["CompanyChecklistService", "$stateParams", "$modal", "$translate", CompanyChecklistDirective]);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(62);
	
	PublicationSettingsDirective.$inject = [
	  "$q",
	  "$window",
	  "$http",
	  "$state",
	  "$translate",
	  "CompanyCategoryService",
	  "CompanyGroupService",
	  "CompanyPublicationWatcherService",
	  "CompanyUserService",
	  "growl",
	  "config",
	  "$filter"];
	function PublicationSettingsDirective(
	  $q,
	  $window,
	  $http,
	  $state,
	  $translate,
	  CompanyCategoryService,
	  CompanyGroupService,
	  CompanyPublicationWatcherService,
	  CompanyUserService,
	  growl,
	  config,
	  $filter) {
	  return {
	    restrict: "A",
	    templateUrl: "partials/company/publications/aside.html",
	    /* Expected scope variables from parent:
	     *  * publication:     current publication
	     *  * currentCompany:  current company
	     *  * savePublication: function to save a given publication
	     */
	    link: function($scope, el) {
	      var data;
	      var nonWatchersPromise;
	
	      $scope.nonWatchers             = [];
	      $scope.additionalOptionsOpen   = false;
	      $scope.additionalOptionsLoaded = false;
	      $scope.selectedGroup           = null;
	      
	      function loadData() {
	        if( ! data) {
	          var categories = CompanyCategoryService.query({companyId: $scope.currentCompany.id, limit: 100}).$promise;
	          var watchers   = CompanyPublicationWatcherService.query({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id}).$promise;
	          
	          data = $q.all([categories, watchers]).then(function(r) {
	            $scope.additionalOptionsLoaded = true;
	
	            $scope.categories = r[0];
	            $scope.watchers   = r[1];
	          });
	        }
	        
	        return data;
	      }
	      
	      function updateNonWatchers(filter) {
	        if( ! $scope.additionalOptionsLoaded) {
	          return;
	        }
	        
	        var p = CompanyUserService.query({companyId: $scope.currentCompany.id, q: filter, limit: 6}).$promise.then(function(users) {
	          return users.filter(function(item) {
	            return !$scope.watchers.some(function(watcher) {
	              return item.id === watcher.id;
	            });
	          });
	        }).then(function(nonWatchers) {
	          if(nonWatchersPromise === p) {
	            /* Correct promise, update */
	            $scope.nonWatchers = nonWatchers;
	          }
	        });
	        
	        nonWatchersPromise = p;
	      }
	      
	      function openAdditionalOptions() {
	        el.addClass("open");
	        
	        $scope.additionalOptionsOpen = true;
	        
	        loadData();
	      }
	      
	      function closeAdditionalOptions() {
	        el.removeClass("open");
	        
	        $scope.additionalOptionsOpen = false;
	      }
	      
	      function toggleAdditionalOptions() {
	        if($scope.additionalOptionsOpen) {
	          closeAdditionalOptions();
	        }
	        else {
	          openAdditionalOptions();
	        }
	      }
	      
	      function setPriority(priority) {
	        if( ! priority) {
	          $scope.publication.priority = null;
	        }
	        else {
	          $scope.publication.priority = priority;
	        }
	
	        return $scope.savePublication($scope.publication);
	      }
	
	      /* FIXME: Move to service */
	      function deletePublication(publication) {
	        $http({
	          method: 'DELETE',
	          url: config.apiBase + '/companies/' + $scope.currentCompany.id + '/publications/' + $scope.publication.id
	        }).then(function() {
	            growl.addSuccessMessage($translate.instant('publication.remove-success'));
	
	            if (publication.status === 'DRAFT') {
	              $state.go('root.company.publications-listDrafts');
	            }
	
	            else if (publication.status === 'ARCHIVED') {
	              $state.go('root.company.publications-listArchived');
	            }
	
	            else {
	              $state.go('root.company.publications-list');
	            }
	
	        }, function() {
	          growl.addErrorMessage($translate.instant('publication.remove-failure'));
	        });
	      }
	      
	      function unsetParent() {
	        $scope.publication.parent = null;
	
	        $scope.savePublication($scope.publication);
	      }
	
	      function setParent(publication) {
	        $scope.publication.parent = {
	          id:   publication.id,
	          name: publication.name
	        };
	
	        $scope.savePublication($scope.publication);
	      }
	
	      function setCategory(category) {
	        if( ! category) {
	          $scope.publication.category = null;
	        }
	
	        $scope.publication.category = category;
	
	        return $scope.savePublication($scope.publication);
	      }
	
	      $scope.addedTags = function(item) {
	        return $scope.publication.tags.indexOf(item) === -1;
	      };
	
	      /* FIXME: Move to directive */
	      $scope.addWatcher = function(watcher) {
	        var newWatcher = new CompanyPublicationWatcherService({
	          id: watcher.id
	        });
	
	        newWatcher.$save({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id}, function() {
	          growl.addSuccessMessage($translate.instant('publication.add-watcher-success'));
	          $scope.watchers.push(watcher);
	          angular.element('#filterWatchers').val(''); // Clear typeahead input
	          $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
	        }, function() {
	          growl.addErrorMessage($translate.instant('publication.add-watcher-failure'));
	        });
	      };
	
	      $scope.deleteWatcher = function(watcher) {
	        CompanyPublicationWatcherService.delete({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id, watcherId: watcher.id}, function() {
	          growl.addSuccessMessage($translate.instant('publication.remove-watcher-success'));
	          $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
	        }, function() {
	          growl.addErrorMessage($translate.instant('publication.remove-watcher-failure'));
	        });
	      };
	
	      $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
	        return v.stepNr > 0;
	      });
	      
	      $scope.nextStatus = function() {
	        if ($scope.prioritiesSorted.length === 0) {
	          return;
	        }
	        if (!$scope.publication.priority) {
	          $scope.publication.priority = $scope.prioritiesSorted[0];
	          $scope.savePublication($scope.publication);
	        } else {
	          var index = $scope.prioritiesSorted.findIndex(function(v){
	            return v.id === $scope.publication.priority.id;
	          });
	
	          if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
	            return;
	          }
	
	          $scope.publication.priority = $scope.prioritiesSorted[index + 1];
	          $scope.savePublication($scope.publication);
	        }
	      };
	
	      $scope.closeAdditionalOptions  = closeAdditionalOptions;
	      $scope.toggleAdditionalOptions = toggleAdditionalOptions;
	      $scope.updateNonWatchers       = updateNonWatchers;
	      $scope.setPriority             = setPriority;
	      $scope.deletePublication       = deletePublication;
	      $scope.unsetParent             = unsetParent;
	      $scope.setParent               = setParent;
	      $scope.setCategory             = setCategory;
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("publicationSettings", PublicationSettingsDirective);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(45);
	__webpack_require__(18);
	
	function PublicationStarDirective(CompanyUserStarService, CurrentUserService, $stateParams, $translate, $q, growl) {
	  return {
	    restrict: 'A',
	    scope: {
	      publication: '=publicationStar',
	    },
	    link: function($scope, elm) {
	      var currentUser;
	
	      $scope.toggleStar = function() {
	        if ($scope.publication.starred) {
	          CompanyUserStarService.delete({companyId: $stateParams.companyId, userId: currentUser.id, publicationId: $scope.publication.id}, {}, function() {
	            growl.addSuccessMessage($translate.instant('publication.star.remove-success'));
	            $scope.publication.starred = false;
	          }, function() {
	            growl.addErrorMessage($translate.instant('publication.star.remove-failure'));
	          });
	        } else {
	          CompanyUserStarService.add({companyId: $stateParams.companyId, userId: currentUser.id, publicationId: $scope.publication.id}, {}, function() {
	            growl.addSuccessMessage($translate.instant('publication.star.add-success'));
	            $scope.publication.starred = true;
	          }, function() {
	            growl.addErrorMessage($translate.instant('publication.star.add-failure'));
	          });
	        }
	      };
	
	      CurrentUserService.get().then(function(user) {
	        currentUser = user;
	        elm.bind('click', $scope.toggleStar);
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('publicationStar', ['CompanyUserStarService', 'CurrentUserService', '$stateParams', '$translate', '$q', 'growl', PublicationStarDirective]);
	
	


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	function albumViewDirective() {
	  return {
	    replace: true,
	    template: '<div class="line-component--omega album__view">' +
	                '<div class="cf">' +
	                  '<button ng-repeat="v in views"' +
	                           'type="button"' +
	                           'ng-click="switchView(v)"' +
	                           'class="icon-only line--component"' +
	                           'ng-class="{\'active\': albumTemplate == v.template}">' +
	                      '<i class="fa fa-2x" ng-class="v.icon"></i>' +
	                  '</button>' +
	                '</div>' +
	              '</div>',
	    link: function(scope, elm, attrs) {
	      scope.isCollabration = false;
	      if (attrs && attrs.isCollabration) {
	        scope.isCollabration = true;
	      }
	      scope.views = [{
	        name: 'Grid',
	        template: 'partials/company/publications/detail/latest/album-view/grid.html',
	        icon: 'fa-th-large '
	      }, {
	        name: 'List',
	        template: 'partials/company/publications/detail/latest/album-view/list.html',
	        icon: 'fa-list'
	      }];
	    },
	    controller: ['$scope', '$window', '$stateParams', function($scope, $window, $stateParams) {
	      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/grid.html';
	      if ($window.localStorage["albumView" + $stateParams.publicationId]) {
	        $scope.albumTemplate = JSON.parse($window.localStorage["albumView" + $stateParams.publicationId]);
	      }
	
	      $scope.switchView = function(view) {
	        $scope.albumTemplate = view.template;
	        $window.localStorage["albumView" + $stateParams.publicationId] = JSON.stringify(view.template);
	      };
	    }]
	  };
	}
	
	angular.module('dokiv')
	  .directive('albumView', [albumViewDirective]);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(64);
	__webpack_require__(395);
	function CompanyPublicationBlogCtrl(
	  $scope,
	  $sce,
	  $rootScope,
	  $stateParams,
	  $translate,
	  $state,
	  uploadTracker,
	  CompanyPublicationBlogService,
	  CompanyPublicationFileService,
	  config,
	  growl) {
	
	  $scope.showFormNewPost = false;
	  $scope.newPost = {
	    title: '',
	    content: ''
	  };
	  
	  $rootScope.tinymceOptions.file_picker_types = 'image';
	
	  $rootScope.tinymceOptions.file_picker_callback = function(callback, value, meta) {
	    if (meta.filetype === 'image') {
	      $('#upload').trigger('click');
	      $('#upload').on('change', function() {
	        var files = new Array(this.files);
	        if(files && files.length > 0){
	          uploadTracker(files.map(function(f) {
	            return {
	              url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
	              file: f[0],
	            };
	          })).then(function(headers){
	            var newId = headers[0].split('/').pop();
	            var imageUrl = config.apiBase + '/files/' + newId;
	            callback(imageUrl, {
	              alt: ''
	            });
	          });
	        }
	      });
	    }
	  };
	
	  $scope.updatePost = function(post) {
	    if (!(!$scope.publication.uploadLock && $scope.currentUserPermissions.CompanyPublicationEdit)) {
	      return;
	    }
	    CompanyPublicationBlogService.updatePost({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      postId: post.id
	    }, post, function(){
	      growl.addSuccessMessage($translate.instant('publication.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('publication.save-failure'));
	    });
	  };
	
	  $scope.trustAsHtml = function(string) {
	    return $sce.trustAsHtml(string);
	  };
	 
	  $scope.publishPost = function() {
	    CompanyPublicationBlogService.save({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, $scope.newPost, function(){
	      growl.addSuccessMessage($translate.instant('publication.save-success'));
	      $state.reload();
	    }, function(){
	      growl.addErrorMessage($translate.instant('publication.save-failure'));
	    });
	  };
	
	  $scope.$on('files-uploaded', function(){
	    CompanyPublicationFileService.query({
	      companyId:     $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      limit:         1000
	    }).$promise.then(function(files) {
	      if (files.length > 0) {
	        $scope.newPost.content = $scope.newPost.content + '\n' + '![]('+ config.apiBase + '/files/' + files[0].id +')';
	      }
	    });
	  });
	}
	
	angular.module('dokiv')
	  .controller('CompanyPublicationBlogCtrl', [
	    '$scope',
	    '$sce',
	    '$rootScope',
	    '$stateParams',
	    '$translate',
	    '$state',
	    'UploadTracker',
	    'CompanyPublicationBlogService',
	    'CompanyPublicationFileService',
	    'config',
	    'growl',
	    CompanyPublicationBlogCtrl]);


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	"use strict";
	
	function EditPostDirective(
	  $stateParams,
	  config,
	  growl,
	  $sce,
	  $translate) {
	  return {
	    restrict: 'A',
	    scope: {
	      post: '=',
	      allowEdit: '='
	
	    },
	    link: function(scope) {
	      scope.oldPost = angular.copy(scope.post);
	      scope.updatePost = function() {
	        if (!scope.allowEdit) {
	          return;
	        }
	        scope.post.$updatePost({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          postId: scope.post.id
	        }, function(){
	          growl.addSuccessMessage($translate.instant('publication.save-success'));
	          scope.showFormEditPost = false;
	        }, function(){
	          growl.addErrorMessage($translate.instant('publication.save-failure'));
	        });
	      };
	
	      scope.trustAsHtml = function(string) {
	        return $sce.trustAsHtml(string);
	      };
	    },
	    templateUrl: 'partials/company/publications/detail/edit-blog.html'
	  };
	}
	
	angular.module('dokiv')
	  .directive('toggleEditPost', [
	    '$stateParams',
	    'config',
	    'growl',
	    '$sce',
	    '$translate',
	    EditPostDirective]);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(33);
	__webpack_require__(20);
	__webpack_require__(16);
	__webpack_require__(4);
	var moment = __webpack_require__(1);
	
	function CompanyPublicationCompanyOrderCtrl(
	  $scope,
	  $state,
	  $stateParams,
	  $translate,
	  config,
	  $q,
	  $http,
	  $modal,
	  $filter,
	  growl,
	  CompanyProductsService,
	  CompanyCustomersService,
	  CompanyPublicationService,
	  CompanyPublicationCompanyOrderService,
	  CompanyPublicationCompanyOrderSubcriptionService,
	  CompanyService) {
	
	  $scope.nonProductsAdded = [];
	  var nonProdcutAddedPromise;
	  $scope.newAddress = null;
	
	  angular.forEach($scope.children, function(value, key){
	    if(value.features.currentCompanyOrderId){
	      CompanyPublicationCompanyOrderSubcriptionService.get({
	        companyId: $stateParams.companyId,
	        publicationId: value.id,
	        subcriptionId: value.features.currentCompanyOrderId
	      }).$promise.then(function(order){
	        $scope.children[key].order = order;
	        var subcription            = $scope.children[key].order.interval.split(' ');
	        $scope.children[key].order.subcriptionNumber   = parseInt(subcription[0]);
	        $scope.children[key].order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
	        if(!$scope.children[key].order.lastGenAt){
	          $scope.children[key].order.lastGenAt = $scope.children[key].order.createdAt;
	        }
	        if($scope.children[key].order.startAt >= $scope.children[key].order.lastGenAt){
	          $scope.children[key].order.nextCreatedOrder = moment($scope.children[key].order.startAt).add(parseInt($scope.children[key].order.subcriptionNumber), $scope.children[key].order.optionSubcription+($scope.children[key].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	        }else{
	          $scope.children[key].order.nextCreatedOrder = moment($scope.children[key].order.lastGenAt).add(parseInt($scope.children[key].order.subcriptionNumber), $scope.children[key].order.optionSubcription+($scope.children[key].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	        }
	        
	        updateTotalOrderChild($scope.children[key]);
	        $scope.filterPriceListName();
	      });
	    }else{
	      $scope.children[key].order = false;
	    }
	  });
	
	  $scope.$on('orderChanged', function (event, data) {
	    $scope.order = data;
	  });
	
	  setTimeout(function(){
	    angular.element('div[g-places-autocomplete-drawer]').css('position', 'initial');
	  },1);
	
	  var totalOrderChild = function(publication, includeTax) {
	    var total = 0;
	    if (publication.order) {
	      angular.forEach(publication.order.items, function(v){
	        if (includeTax) {
	          total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
	        } else {
	          total += v.price.soldPrice * v.amount;
	        }
	      });
	    }
	
	    return total;
	  };
	
	  var updateTotalOrderChild =  function(publication) {
	    var indexOrder = $scope.children.indexOf(publication);
	    $scope.children[indexOrder].totalExcludeTax = totalOrderChild(publication);
	    $scope.children[indexOrder].totalIncludeTax = totalOrderChild(publication, true);
	    $scope.children[indexOrder].totalTax        = totalOrderChild(publication, true) - totalOrderChild(publication);
	  };
	
	  $scope.createNewInterval = function(){
	    var publicationSubscription = angular.copy($scope.publication);
	    delete publicationSubscription.id;
	    delete publicationSubscription.objectNumber;
	    publicationSubscription.parent = $scope.publication;
	    CompanyPublicationService.save({companyId: $stateParams.companyId}, publicationSubscription, function(resp, headers) {
	      var child = resp;
	      child.id= headers('Location').split('/').pop();
	      
	      var data = angular.copy($scope.order);
	      data.publication = child;
	      delete data.id;
	      delete data.items;
	
	      CompanyPublicationCompanyOrderSubcriptionService.update({
	        companyId: $stateParams.companyId,
	        publicationId: child.id
	      }, data).$promise.then(function(order){
	        child.features.currentCompanyOrderId = order.id;
	        $scope.savePublication(child);
	        child.order = order;
	        angular.forEach($scope.order.items, function(value){
	          $scope.updateCompanyOrderChild(value.product, child);
	        });
	        $state.reload();
	      });
	    }, function(error) {
	      if (error.status === 400 && error.data.error && error.data.error.code === 1614) {
	        growl.addErrorMessage($translate.instant('publication.reached-your-limit'));  
	      } else {
	        growl.addErrorMessage($translate.instant('publication.create-failure'));
	      }
	    });
	  };
	
	  $scope.addOrderAddress = function(){
	    if($scope.newAddress){
	      if(!$scope.order.extra.addresses){
	        $scope.order.extra.addresses = [];
	      }
	      if($scope.newAddress.formatted_address){
	        $scope.order.extra.addresses.push({name: $scope.newAddress.formatted_address, url: $scope.newAddress.url});
	      }else{
	        $scope.order.extra.addresses.push({name: $scope.newAddress, url: false});
	      }
	      $scope.update($scope.order, $scope.publication);
	      $scope.newAddress = null;
	    }
	  };
	
	  $scope.goToMap = function(address){
	    window.open(address.url, '_blank');
	  };
	
	  var queryOrderStatuses = function() {
	    return CompanyService.queryOrderStatuses({
	      companyId: $stateParams.companyId
	    }).$promise;
	  };
	
	  queryOrderStatuses().then(function(resp){
	    $scope.orderStatuses = resp;
	    $scope.orderStatusesSorted = ($filter('orderBy')($scope.orderStatuses, 'stepNr')).filter(function(v){
	      return v.stepNr > 0;
	    });
	  });
	
	  $scope.$on('showCustomerInfo', function() {
	    $scope.showCustomerInfo = true;
	  });
	
	  $scope.addProduct = function(product) {
	    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
	    angular.element('#filterProduct').val('');
	    $scope.updateCompanyOrder(product).then(function(resp){
	      var index = $scope.order.items.push(resp);
	      $scope.order.items[index-1].price = angular.copy(product.pricelist[0]);
	      $scope.order.items[index-1].price.soldPrice = $scope.order.items[index-1].price.price;
	      $scope.setDefautPricelist($scope.order);
	      $scope.showModalEditItem($scope.order.items[index-1], index-1, true);
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  $scope.addProductOrderChild = function(product, publication) {
	    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
	    angular.element('#filterProduct').val('');
	    $scope.updateCompanyOrderChild(product, publication).then(function(resp){
	      var indexOrder = $scope.children.indexOf(publication);
	      var index = $scope.children[indexOrder].order.items.push(resp);
	      $scope.children[indexOrder].order.items[index-1].price = angular.copy(product.pricelist[0]);
	      $scope.children[indexOrder].order.items[index-1].price.soldPrice = $scope.children[indexOrder].order.items[index-1].price.price;
	      $scope.showModalEditItem($scope.children[indexOrder].order.items[index-1], index-1, false, $scope.children[indexOrder]);
	      updateTotalOrderChild($scope.children[indexOrder]);
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  $scope.setDefautPricelistOrderChild = function(publication) {
	    $scope.filterPriceListName();
	    if ((publication.order.project && publication.order.project.id) || (publication.order.customer && publication.order.customer.priceList !== null)) {
	      angular.forEach(publication.order.items ,function(v){
	        if (v.price.priceListId !== $scope.currentProject.id) {
	          angular.forEach(v.product.pricelist, function(p){
	            if ($scope.currentProject.id === p.priceListId) {
	              v.price = angular.copy(p);
	              v.price.soldPrice = v.price.price;
	              CompanyPublicationCompanyOrderSubcriptionService.updateItem({
	                companyId: $stateParams.companyId,
	                publicationId: publication.id,
	                subcriptionId: publication.order.id,
	                itemId: v.id
	              }, v);
	            }
	          });
	        }
	      });
	    }
	    updateTotalOrderChild(publication);
	  };
	
	  $scope.urlBaseImage = config.apiBase + "/files/";
	  $scope.checkImageProduct = function(item) {
	    item.product.images = item.product.images.filter(function(item){
	      return item.status === true;
	    }); 
	    if(item.product.images.length > 0){
	      item.product.image = config.apiBase + "/files/" + item.product.images[0].id;
	    }else{
	      item.product.image = "images/no-image.jpg";
	    }
	    return item;
	  };
	
	  $scope.removeProduct = function(index) {
	    if($scope.publication.type === 'ORDER_SUBCRIPTION'){
	      CompanyPublicationCompanyOrderSubcriptionService.deleteItem({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        subcriptionId: $scope.order.id,
	        itemId: $scope.order.items[index].id
	      }, function(){
	        $scope.order.items.splice(index, 1);
	        $scope.updateTotal();
	      });
	    }else{
	      CompanyPublicationCompanyOrderService.deleteItem({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: $scope.order.id,
	        itemId: $scope.order.items[index].id
	      }, function(){
	        $scope.order.items.splice(index, 1);
	        $scope.updateTotal();
	      });
	    }
	  };
	
	  $scope.removeProductOrderChild = function(index, publication) {
	    CompanyPublicationCompanyOrderSubcriptionService.deleteItem({
	      companyId: $stateParams.companyId,
	      publicationId: publication.id,
	      subcriptionId: publication.order.id,
	      itemId: publication.order.items[index].id
	    }, function(){
	      $scope.children[$scope.children.indexOf(publication)].order.items.splice(index, 1);
	      updateTotalOrderChild(publication);
	    });
	  };
	
	  $scope.updateNonProductsAdded = function(filter) {
	    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
	          return products.filter(function(item) {
	            return !$scope.order.items.some(function(i) {
	              return item.id === i.product.id;
	            });
	          });
	        }).then(function(nonProducts) {
	          if(nonProdcutAddedPromise === p) {
	            $scope.nonProductsAdded = nonProducts;
	          }
	        });
	        nonProdcutAddedPromise = p;
	  };
	
	  $scope.updateProducts = function(filter) {
	    CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
	      if($scope.currentProject){
	        nonProdcutAddedPromise = products.filter(function(v){
	          return v.pricelist.filter(function(item){
	            return $scope.currentProject.id === item.priceListId;
	          })[0];
	        });
	      }else{
	        nonProdcutAddedPromise = products;
	      }
	      $scope.nonProductsAdded = nonProdcutAddedPromise;
	    });
	  };
	
	  $scope.updateCompanyOrder = function(product) {
	    var item = {
	      product: product,
	      amount: 1,
	      price: {
	        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
	        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
	      }
	    };
	    if($scope.publication.type === 'ORDER_SUBCRIPTION'){
	      return CompanyPublicationCompanyOrderSubcriptionService.updateItems({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        subcriptionId: $scope.order.id
	      }, item).$promise;
	    }else{
	      return CompanyPublicationCompanyOrderService.updateItems({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        orderId: $scope.order.id
	      }, item).$promise;
	    }
	  };
	
	  $scope.updateCompanyOrderChild = function(product, publication) {
	    var item = {
	      product: product,
	      amount: 1,
	      price: {
	        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
	        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
	      }
	    };
	    return CompanyPublicationCompanyOrderSubcriptionService.updateItems({
	      companyId: $stateParams.companyId,
	      publicationId: publication.id,
	      subcriptionId: publication.order.id
	    }, item).$promise;
	  };
	
	  $scope.addRowText = function(RowTextNew){
	    if(!$scope.order.extra.rowText){
	      $scope.order.extra.rowText = [];
	    }
	    $scope.order.extra.rowText.push(RowTextNew);
	  };  
	
	  $scope.addRowTextOrderChild = function(RowTextNew, publication){
	    var indexOrder = $scope.children.indexOf(publication);
	    if(!$scope.children[indexOrder].order.extra.rowText){
	      $scope.children[indexOrder].order.extra.rowText = [];
	    }
	    $scope.children[indexOrder].order.extra.rowText.push(RowTextNew);
	  };  
	
	  $scope.createNextOrderChild = function(publication){
	    CompanyPublicationCompanyOrderSubcriptionService.createNextOrder({
	      companyId: $stateParams.companyId,
	      publicationId: publication.id,
	      subcriptionId: publication.order.id
	    }, {}, function(){
	      growl.addSuccessMessage($translate.instant('order.create-next-order-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.create-next-order-failure'));
	    });
	  };
	
	  $scope.showModalEditItem = function(item, index, isMain, publicationChild) {
	    $modal({
	      scope: $scope,
	      controller: 'CompanyPublicationCompanyOrderEditCtrl',
	      templateUrl: 'partials/company/publications/company-order/edit.html',
	      show: true,
	      resolve: {
	        item: function() {
	          return item || false;
	        },
	        index: function() {
	          return (angular.isUndefined(index) ? -1 : index);
	        },
	        isMain: function() {
	          return isMain;
	        },
	        publicationChild: function() {
	          return publicationChild;
	        }
	      }
	    });
	  };
	
	  $scope.updateOrderChild = function(publication) {
	    var o = angular.copy(publication.order);
	    if(o.customerOrderNr === ''){
	      o.customerOrderNr = null;
	    }
	    if(publication.type === 'ORDER_SUBCRIPTION'){
	      o.interval = o.subcriptionNumber + ' ' + o.optionSubcription + (o.subcriptionNumber > 1 ? 's' : '');
	    }
	    o.$update({
	      companyId: $stateParams.companyId,
	      publicationId: publication.id
	    }, function(){
	      growl.addSuccessMessage($translate.instant('order.update-success'));
	      var indexOrder = $scope.children.indexOf(publication);
	      var subcription            = o.interval.split(' ');
	      $scope.children[indexOrder].order.subcriptionNumber   = parseInt(subcription[0]);
	      $scope.children[indexOrder].order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
	      if(!$scope.children[indexOrder].order.lastGenAt){
	        $scope.children[indexOrder].order.lastGenAt = $scope.children[indexOrder].order.createdAt;
	      }
	      if(o.startAt >= o.lastGenAt){
	        $scope.children[indexOrder].order.nextCreatedOrder = moment($scope.children[indexOrder].order.startAt).add(parseInt($scope.children[indexOrder].order.subcriptionNumber), $scope.children[indexOrder].order.optionSubcription+($scope.children[indexOrder].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	      }else{
	        $scope.children[indexOrder].order.nextCreatedOrder = moment($scope.children[indexOrder].order.lastGenAt).add(parseInt($scope.children[indexOrder].order.subcriptionNumber), $scope.children[indexOrder].order.optionSubcription+($scope.children[indexOrder].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
	      }
	    }, function(){
	      growl.addErrorMessage($translate.instant('order.update-failure'));
	    });
	  };
	
	  $scope.nextStatus = function() {
	    if ($scope.orderStatusesSorted.length === 0) {
	      return;
	    }
	    if (!$scope.order.orderStatus) {
	      $scope.order.orderStatus = $scope.orderStatusesSorted[0].id;
	      $scope.update($scope.order, $scope.publication);
	    } else {
	      var index = $scope.orderStatusesSorted.findIndex(function(v){
	        return v.id === $scope.order.orderStatus;
	      });
	
	      if (index >= ($scope.orderStatusesSorted.length - 1) || index < 0) {
	        return;
	      }
	
	      $scope.order.orderStatus = $scope.orderStatusesSorted[index + 1].id;
	      $scope.update($scope.order, $scope.publication);
	    }
	  };
	
	  $scope.showApproveDocModal = function() {
	    var modalApprove = $modal({
	      scope: $scope,
	      controller: ['$scope', function($scope){
	        $scope.approvedSign = {
	          comment: '',
	          sign: ''
	        };
	      }],
	      templateUrl: 'partials/company/publications/detail/approve-doc.html',
	      show: false
	    });
	    modalApprove.$promise.then(modalApprove.show);
	  };
	
	  $scope.submitOrder = function(createQuote, createOrder, approveOrder, approvedSign) {
	    var orderDeferred = $q.defer();
	    var sendEmail = false;
	    var emailTo = $scope.order.customer.invoiceEmailTo;
	    if($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder){
	       $modal({
	        scope: $scope,
	        controller: ['$scope', function($scope){
	          $scope.sendEmail = false;
	          $scope.emailTo = $scope.order.customer.invoiceEmailTo;
	          $scope.sendInvoiceEmail = function(){
	            sendEmail = $scope.sendEmail;
	            emailTo   = $scope.emailTo;
	            orderDeferred.resolve();
	          };
	        }],
	        templateUrl: 'partials/company/publications/company-order/send-mail-modal.html',
	        show: true
	      });
	    }else{
	      if(approveOrder && approvedSign){
	        $scope.order.extra.approvedSign = approvedSign;
	      }
	      orderDeferred.resolve();
	    }
	    orderDeferred.promise.then(function(){
	      if(!createQuote && !createOrder && !approveOrder){
	        $scope.order.status = 'ACTIVE';
	        $scope.order.submitedAt = new Date();
	      }
	      $scope.order.$update({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        createQuote: (createQuote ? createQuote : null),
	        createOrder: (createOrder ? createOrder: null),
	        approved: (approveOrder ? true : null),
	        sendEmail: (($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder) ? sendEmail: null),
	        emailTo: (($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder) ? emailTo : null)
	      }, function(publication){
	        growl.addSuccessMessage($translate.instant('order.submit-success'));
	        if(!createQuote && !createOrder && !approveOrder){
	          window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
	        }else{
	          CompanyPublicationCompanyOrderService.get({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            orderId: $scope.order.id
	          }).$promise.then(function(resp){
	            $scope.order = resp;
	          });
	        }
	      }, function(){
	        if(!createQuote && !createOrder && !approveOrder){
	          $scope.order.status = 'CART';
	        }
	        growl.addErrorMessage($translate.instant('order.order-failure'));
	      });
	    });
	  };
	
	  $scope.productPreview = function(product) {
	    jQuery.fancybox.open([{
	      type: 'image',
	      padding: 0,
	      margin: 0,
	      href: product ? config.apiBase + '/files/' + product.id : ''
	    }]);
	    return false;
	  };
	}
	
	angular.module('dokiv')
	  .controller('CompanyPublicationCompanyOrderCtrl', ['$scope',
	    '$state',
	    '$stateParams',
	    '$translate',
	    'config',
	    '$q',
	    '$http',
	    '$modal',
	    '$filter',
	    'growl',
	    'CompanyProductsService',
	    'CompanyCustomersService',
	    'CompanyPublicationService',
	    'CompanyPublicationCompanyOrderService',
	    'CompanyPublicationCompanyOrderSubcriptionService',
	    'CompanyService',
	    CompanyPublicationCompanyOrderCtrl]);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(20);
	function CompanyPublicationCompanyOrderEditCtrl(
	  $scope,
	  $stateParams,
	  $translate,
	  $timeout,
	  CompanyPublicationCompanyOrderService,
	  CompanyPublicationCompanyOrderSubcriptionService,
	  publicationChild,
	  isMain,
	  item,
	  index) {
	    $scope.item = item;
	    $scope.matched = false;
	    function checkMatchPricelist() {
	      if ($scope.currentProject && ($scope.order.project || $scope.order.customer.priceList !== null)) {
	        $scope.matched = $scope.item.product.pricelist.some(function(v){
	          return $scope.currentProject.id === v.priceListId;
	        });
	      }
	    }
	    
	    checkMatchPricelist();
	    $scope.save = function() {
	      if($scope.item.productName === ''){
	        $scope.item.productName = null;
	      }
	      if($scope.publication.type === 'ORDER_SUBCRIPTION'){
	        CompanyPublicationCompanyOrderSubcriptionService.updateItem({
	          companyId: $stateParams.companyId,
	          publicationId: isMain ? $stateParams.publicationId : publicationChild.id,
	          subcriptionId: isMain ? $scope.order.id : publicationChild.order.id,
	          itemId: $scope.item.id
	        }, $scope.item, function(resp){
	          if(isMain){
	            $scope.order.items[index] = resp;
	          }else{
	            $scope.children[$scope.children.indexOf(publicationChild)].order.items[index] = resp;
	          }
	          $timeout(function(){
	            angular.element('.footable').trigger('footable_redraw');
	          }, 0);
	          $scope.$hide();
	          $scope.updateTotal();
	        });
	      }else{
	        CompanyPublicationCompanyOrderService.updateItem({
	          companyId: $stateParams.companyId,
	          publicationId: $stateParams.publicationId,
	          orderId: $scope.order.id,
	          itemId: $scope.item.id
	        }, $scope.item, function(resp){
	          $scope.order.items[index] = resp;
	          $timeout(function(){
	            angular.element('.footable').trigger('footable_redraw');
	          }, 0);
	          $scope.$hide();
	          $scope.updateTotal();
	        });
	      }
	    };
	 }
	
	angular.module('dokiv')
	  .controller('CompanyPublicationCompanyOrderEditCtrl', ['$scope',
	    '$stateParams',
	    '$translate',
	    '$timeout',
	    'CompanyPublicationCompanyOrderService',
	    'CompanyPublicationCompanyOrderSubcriptionService',
	    'publicationChild',
	    'isMain',
	    'item',
	    'index',
	    CompanyPublicationCompanyOrderEditCtrl]);


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	function internalMessageDirective($sce) {
	return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      "publication": "=internalMessage",
	      "saveAction": "&"
	    },
	    link: function(scope) {
	      scope.trustAsHtml = function(string) {
	        return $sce.trustAsHtml(string);
	      };
	    },
	    templateUrl: "partials/company/publications/internal-message.html"
	  };
	}
	
	angular.module('dokiv')
	  .directive('internalMessage', ['$sce', internalMessageDirective]);

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyInvestigationPagesService($resource, config) {
	  return $resource(config.apiBase + '/companies/gdpr-pages/:gdprPageId', {}, {});
	}
	
	angular.module('dokiv')
	  .factory('CompanyInvestigationPagesService', ['$resource', 'config', CompanyInvestigationPagesService]);


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationCompanyInvestigationCtrl(
	  $scope,
	  $stateParams,
	  $filter,
	  $translate,
	  growl,
	  config,
	  $modal,
	  CompanyGroupService,
	  CompanyPublicationCompanyInvestigationService,
	  CompanyUserService) {
	
	  $scope.editInvestigationInfor = function(investigationInfor){
	    $scope.publicationAccountToggle = false;
	    if(investigationInfor){
	      $scope.newInvestigationInfor = investigationInfor;
	    }else{
	      $scope.newInvestigationInfor = {
	        type: 'REDOGO',
	        partner: '',
	        periodUp: '14 days',
	        telephoneMode: false,
	        personlightMode: false,
	        varnadDate: new Date(),
	        content: '',
	        extra: {
	          selectdPart1: [],
	          selectdPart2: []
	        }
	      };
	    }
	    if(!$scope.newInvestigationInfor.opened){
	      if(!$scope.newInvestigationInfor.extra.listUserPart1){
	        $scope.newInvestigationInfor.extra.listUserPart1 = [];
	      }
	      $scope.newInvestigationInfor.extra.listUserPart1 = $scope.part1Users.concat($scope.newInvestigationInfor.extra.listUserPart1);
	    }
	    $scope.newInvestigationInfor.opened = true;
	    setTimeout(function(){
	      $scope.$apply(function(){
	        $scope.publicationAccountToggle = true;
	      });
	    }, 1);
	  };
	
	  $scope.editInvestigationSanmanInfor = function(investigationInfor){
	    $scope.publicationSummaryToggle = false;
	    if(investigationInfor){
	      $scope.newInvestigationSanmanInfor = investigationInfor;
	    }else{
	      $scope.newInvestigationSanmanInfor = {
	        type: 'SANMAN',
	        partner: '',
	        periodUp: '14 days',
	        telephoneMode: false,
	        personlightMode: false,
	        varnadDate: new Date(),
	        content: '',
	        extra: {
	          selectdPart1: []
	        }
	      };
	    }
	    setTimeout(function(){
	      $scope.$apply(function(){
	        $scope.publicationSummaryToggle = true;
	      });
	    }, 1);
	  };
	
	  $scope.closeInvestigationInfor = function(){
	    $scope.publicationAccountToggle = false;
	  };
	
	  $scope.closeInvestigationSanmanInfor = function(){
	    $scope.publicationSummaryToggle = false;
	  };
	
	  $scope.doneSign = function(investigation){
	    $scope.investigation.beslutSign = investigation.signModal;
	  };
	
	  $scope.onOpenModal = function(investigationO){
	    var modalSign = $modal({
	      scope: $scope,
	      controller: ['$scope', function($scope){
	        $scope.doneSignature = function(investigation){
	          $scope.doneSign(investigation);
	          $scope.toggleSignModal = false;
	        };
	        $scope.toggleSignModal = true;
	        $scope.investigation.signModal = investigationO.beslutSign;
	      }],
	      templateUrl: 'partials/company/publications/detail/latest/investigation-tab/signature-modal.html',
	      show: false
	    });
	    modalSign.$promise.then(modalSign.show);
	  };
	
	  $scope.addInvesUser = function(invesUser){
	    invesUser.newUser.publication = $scope.publication;
	    CompanyPublicationCompanyInvestigationService.addUsersInvestigation({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, invesUser.newUser, function(resp){
	      growl.addSuccessMessage($translate.instant('investigation.added-user-success'));
	      if(invesUser.newUser.type !== 'BETSLUT'){
	        $scope.invesUsers[$scope.invesUsers.indexOf(invesUser)].users.push(resp);
	        $scope.invesUsers[$scope.invesUsers.indexOf(invesUser)].newUser = {};
	        if($scope.invesUsers[2].users.length > 0 && $scope.invesUsers[3].users.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
	          $scope.investigationSteps[0].success = true;
	        }
	        var inCurrentUser = $scope.invesUsers[2].users.filter(function(item){
	          return item.email === $scope.currentUser.email;
	        })[0];
	        if($scope.investigationInfors.length > 0 && inCurrentUser){
	          $scope.investigationSteps[1].success = true;
	        }
	      }else{
	        $scope.invesUsersBetslut.push(resp);
	      }
	
	      var tempUsers = $scope.invesUsers[0].users.concat($scope.invesUsers[1].users);
	      $scope.part1Users = tempUsers.filter(function(elem, index, self) {
	        var item = tempUsers.filter(function(user){
	          return user.email === elem.email;
	        })[0];
	        return index === self.indexOf(item);
	      });
	
	      var temp2Users = $scope.invesUsers[2].users.concat($scope.invesUsers[3].users);
	      $scope.part2Users = temp2Users.filter(function(elem, index, self) {
	        var item = temp2Users.filter(function(user){
	          return user.email === elem.email;
	        })[0];
	        return index === self.indexOf(item);
	      });
	    }, function(){
	      growl.addErrorMessage($translate.instant('investigation.added-user-failure'));
	    });
	  };
	
	  $scope.addSelectedPart = function(user, part){
	    if(part === 1){
	      $scope.newInvestigationInfor.extra.selectdPart1 = [];
	      $scope.newInvestigationInfor.extra.selectdPart1.push(user);
	    }
	    if(part === 2){
	      $scope.newInvestigationInfor.extra.selectdPart2 = [];
	      $scope.newInvestigationInfor.extra.selectdPart2.push(user);
	    }
	  };
	
	  $scope.addSelectedPartSanman = function(user){
	    if(!$scope.newInvestigationSanmanInfor.extra || ($scope.newInvestigationSanmanInfor.extra && !$scope.newInvestigationSanmanInfor.extra.selectdPart1)){
	      $scope.newInvestigationSanmanInfor.extra.selectdPart1 = [];
	    }
	    var part1 = $scope.newInvestigationSanmanInfor.extra.selectdPart1.filter(function(item){
	      return item.email === user.email;
	    })[0];
	    if($scope.newInvestigationSanmanInfor.extra.selectdPart1.indexOf(part1) === -1){
	      $scope.newInvestigationSanmanInfor.extra.selectdPart1.push(user);
	    }else{
	      $scope.newInvestigationSanmanInfor.extra.selectdPart1.splice($scope.newInvestigationSanmanInfor.extra.selectdPart1.indexOf(part1), 1);
	    }
	  };
	
	  $scope.addSelectedPartAction = function(user, index){
	    var part1 = $scope.investigationAtgardInfors[index].extra.selectdPart1.filter(function(item){
	      return item.email === user.email;
	    })[0];
	    if($scope.investigationAtgardInfors[index].extra.selectdPart1.indexOf(part1) === -1){
	      $scope.investigationAtgardInfors[index].extra.selectdPart1.push(user);
	    }
	    $scope.nonInvestigationUsers.splice($scope.nonInvestigationUsers.indexOf(user), 1);
	  };
	
	  $scope.removeSelectedPartAction = function(user, index){
	    $scope.investigationAtgardInfors[index].extra.selectdPart1.splice($scope.investigationAtgardInfors[index].extra.selectdPart1.indexOf(user), 1);
	  };
	
	  $scope.nonInvestigationUsers = [];
	  $scope.queryUsers = function(text, index) {
	    if(!$scope.investigationAtgardInfors[index].extra.selectdPart1){
	      $scope.investigationAtgardInfors[index].extra.selectdPart1 = [];
	    }
	    CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      q: text,
	      limit: 10
	    }).$promise.then(function(u){
	      $scope.nonInvestigationUsers = u.filter(function(u){
	        return !$scope.investigationAtgardInfors[index].extra.selectdPart1.some(function(investigationUser){
	          return investigationUser.id === u.id;
	        });
	      });
	    });
	  };
	
	  $scope.deleteInvesUser = function(invesUser, user){
	    if(user.type  !== 'BETSLUT'){
	      var indexInvesUser = $scope.invesUsers.indexOf(invesUser);
	    }
	    CompanyPublicationCompanyInvestigationService.deleteUsersInvestigation({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      invesUserId: user.id
	    }, function(){
	      growl.addSuccessMessage($translate.instant('customer-portals.remove-member-success'));
	      if(user.type  !== 'BETSLUT'){
	        $scope.invesUsers[indexInvesUser].users.splice($scope.invesUsers[indexInvesUser].users.indexOf(user), 1);
	        if($scope.invesUsers[2].users.length === 0 || $scope.invesUsers[3].users.length === 0){
	          $scope.investigationSteps[0].success = false;
	        }
	        var inCurrentUser = $scope.invesUsers[2].users.filter(function(item){
	          return item.email === $scope.currentUser.email;
	        })[0];
	        if($scope.investigationInfors.length === 0 || !inCurrentUser){
	          $scope.investigationSteps[1].success = false;
	        }
	      }else{
	        $scope.invesUsersBetslut.splice($scope.invesUsersBetslut.indexOf(user), 1);
	      }
	    }, function(){
	      growl.addErrorMessage($translate.instant('customer-portals.remove-member-failure'));
	    });
	  };
	
	  $scope.searchUsers = function(filter) {
	    CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(users) {
	      $scope.users = users;
	    });
	  };
	
	  $scope.saveInvestigationInfor = function(investigationInfor){
	    if(!investigationInfor.id){
	      CompanyPublicationCompanyInvestigationService.addInvestigationInfor({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId
	      }, investigationInfor, function(resp){
	        growl.addSuccessMessage($translate.instant('investigation.save-investigation-infor-success'));
	        resp.createdBy.email = $scope.currentUser.email;
	        if(investigationInfor.type === 'REDOGO'){
	          $scope.investigationInfors.push(resp);
	          $scope.investigationSteps[1].success = true;
	        }else{
	          if(investigationInfor.type === 'SANMAN'){
	            $scope.investigationSanmanInfors.push(resp);
	            $scope.investigationSteps[2].success = true;
	          }else{
	            if(investigationInfor.type === 'BETSLUT'){
	              $scope.investigationBetslutInfors = resp;
	            }else{
	              $scope.investigationAtgardInfors.push(resp);
	            }
	          }
	        }
	      }, function(){
	        growl.addErrorMessage($translate.instant('investigation.save-investigation-infor-failure'));
	      });
	    }else{
	      CompanyPublicationCompanyInvestigationService.updateInvestigationInfor({
	        companyId: $stateParams.companyId,
	        publicationId: $stateParams.publicationId,
	        investigationInforId: investigationInfor.id
	      }, investigationInfor, function(){
	        growl.addSuccessMessage($translate.instant('investigation.save-investigation-infor-success'));
	        if(investigationInfor.type === 'ATGARD'){
	          if(investigationInfor.followUpDate && investigationInfor.followUpContent){
	            $scope.investigationAtgardInfors[$scope.investigationAtgardInfors.indexOf(investigationInfor)].savedFollowUp = true;
	          }else{
	            $scope.investigationAtgardInfors[$scope.investigationAtgardInfors.indexOf(investigationInfor)].savedFollowUp = false;
	          }
	        }
	      }, function(){
	        growl.addErrorMessage($translate.instant('investigation.save-investigation-infor-failure'));
	      });
	    }
	  };
	
	  $scope.deleteInvestigationInfor = function(investigationInfor){
	    CompanyPublicationCompanyInvestigationService.deleteInvestigationInfor({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      investigationInforId: investigationInfor.id
	    }, function(){
	      growl.addSuccessMessage($translate.instant('investigation.remove-investigation-infor-success'));
	      if(investigationInfor.type === 'REDOGO'){
	          $scope.investigationInfors.splice($scope.investigationInfors.indexOf(investigationInfor), 1);
	          if($scope.investigationInfors.length === 0){
	            $scope.investigationSteps[1].success = false;
	          }
	        }else{
	          $scope.investigationSanmanInfors.splice($scope.investigationSanmanInfors.indexOf(investigationInfor), 1);
	          if($scope.investigationSanmanInfors.length === 0){
	            $scope.investigationSteps[2].success = false;
	          }
	        }
	    }, function(){
	      growl.addErrorMessage($translate.instant('investigation.remove-investigation-infor-failure'));
	    });
	  };
	
	  $scope.downloadInvestigation = function() {
	    CompanyPublicationCompanyInvestigationService.decisionPdf({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, {}, function() {
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadWindow');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	
	      iFrame.attr('src', config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision.pdf');
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision.pdf', '_self');
	        return;
	      }
	    });
	  };
	
	  $scope.downloadDecisionDone = function() {
	    CompanyPublicationCompanyInvestigationService.decisionDonePdf({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }, {}, function() {
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadDecisionDone');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadDecisionDone' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	
	      iFrame.attr('src', config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision-done.pdf');
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision-done.pdf', '_self');
	        return;
	      }
	    });
	  };
	
	  if (!$scope.publication.groups) {
	    $scope.publication.groups = [];
	  }
	
	  CompanyGroupService.query({companyId: $stateParams.companyId, all: true, type: 'VISIBLE'}).$promise.then(function(groups) {
	    $scope.searchResult = groups;
	  });
	
	  $scope.add = function(group) {
	    if($scope.publication.groups.indexOf(group.id) > -1){
	      $scope.publication.groups.splice($scope.publication.groups.indexOf(group.id), 1);
	    }else{
	      $scope.publication.groups.push(group.id);
	    }
	  };
	
	  $scope.remove = function(index) {
	    $scope.publication.groups.splice(index, 1);
	  };
	}
	
	angular.module('dokiv')
	  .controller('CompanyPublicationCompanyInvestigationCtrl', [
	    '$scope',
	    '$stateParams',
	    '$filter',
	    '$translate',
	    'growl',
	    'config',
	    '$modal',
	    'CompanyGroupService',
	    'CompanyPublicationCompanyInvestigationService',
	    'CompanyUserService',
	    CompanyPublicationCompanyInvestigationCtrl]);


/***/ }),
/* 401 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyPublicationCompanyInvestigationService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/investigation', {}, {
	    'update': {
	      method: 'PUT'
	    },
	    'queryUsersInvestigation':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users',
	      method: 'GET',
	      isArray: true
	    },
	    'addUsersInvestigation':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users',
	      method: 'POST'
	    },
	    'deleteUsersInvestigation':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/users/:invesUserId',
	      method: 'DELETE'
	    },
	    'queryInvestigationInfors':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors',
	      method: 'GET',
	      isArray: true
	    },
	    'addInvestigationInfor':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors',
	      method: 'POST'
	    },
	    'updateInvestigationInfor':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors/:investigationInforId',
	      method: 'PUT'
	    },
	    'deleteInvestigationInfor':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/infors/:investigationInforId',
	      method: 'DELETE'
	    },
	    'decisionPdf':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/decision-pdf',
	      method: 'POST'
	    },
	    'decisionDonePdf':  {
	      url: config.apiBase + '/companies/:companyId/publications/:publicationId/investigation/decision-done-pdf',
	      method: 'POST'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyPublicationCompanyInvestigationService', ['$resource', 'config', CompanyPublicationCompanyInvestigationService]);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(5);
	__webpack_require__(12);
	__webpack_require__(31);
	__webpack_require__(11);
	__webpack_require__(370);
	
	CompanyPublicationOrderCtrl.$inject = ['$scope',
	                                      '$stateParams',
	                                      '$state',
	                                      '$q',
	                                      'CompanyPublicationService',
	                                      'CompanyPublicationOrderService',
	                                      'CompanyPublicationPlantService',
	                                      'CompanyUserService',
	                                      'CompanyProjectService',
	                                      '$translate',
	                                      'growl'];
	function CompanyPublicationOrderCtrl($scope,
	                                    $stateParams,
	                                    $state,
	                                    $q,
	                                    publicationService,
	                                    orderService,
	                                    plantService,
	                                    userService,
	                                    projectService,
	                                    $translate,
	                                    growl) {
	
	  $scope.orderPlants = [];
	  $scope.orderUsers = [];
	  $scope.orderProjects = [];
	
	  if ($scope.order) {
	    var params = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: $scope.order.id
	    };
	
	    var orderPlants = orderService.queryPlants(params).$promise;
	    var orderUsers = orderService.queryUsers(params).$promise;
	    var orderProjects = orderService.queryProjects(params).$promise;
	
	    $q.all([orderPlants, orderUsers, orderProjects]).then(function(data){
	      $scope.orderPlants = data[0];
	      $scope.orderUsers = data[1];
	      $scope.orderProjects = data[2];
	    });
	  }
	
	  $scope.queryObjects = function(text, type) {
	    switch (type) {
	      case 'plant':
	        return publicationService.query({
	            companyId: $stateParams.companyId,
	            q:         text,
	            type: 'PLANT',
	            limit:     10
	          }).$promise.then(function(pubs) {
	            return pubs.filter(function(p) {
	              return !$scope.orderPlants.some(function(plant) {
	                return plant.id === p.features.currentPlantId;
	              });
	            });
	          });
	      case 'user':
	        return userService.query({
	          companyId: $stateParams.companyId,
	          limit: 10,
	          email: text
	        }).$promise.then(function(users){
	          return users.filter(function(u){
	            return !$scope.orderUsers.some(function(user){
	              return user.id === u.id;
	            });
	          });
	        });
	      case 'project':
	        return projectService.query({
	          companyId: $stateParams.companyId,
	          name: text,
	          limit: 10
	        }).$promise.then(function(projects){
	          return projects.filter(function(project){
	            return !$scope.orderProjects.some(function(p){
	              return project.id === p.id;
	            });
	          });
	        });
	    }
	  };
	
	  $scope.addObject = function(obj, type) {
	    var params = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: $scope.order.id
	    };
	    switch (type) {
	      case 'plant':
	        orderService.addPlant(
	          params,
	          {'id': obj.features.currentPlantId}, function(resp) {
	          plantService.get({
	            companyId: $stateParams.companyId,
	            publicationId: obj.id,
	            plantId: resp.id
	          }).$promise.then(function(resp){
	            resp.publication = {
	              name: obj.name,
	              id: obj.id
	            };
	
	            $scope.orderPlants.push(resp);
	            growl.addSuccessMessage($translate.instant('order.plant.add-success'));
	          });
	        }, function(){
	          growl.addErrorMessage($translate.instant('order.plant.add-failure'));
	        });
	        break;
	      case 'user':
	        orderService.addUser(
	          params,
	          {'id': obj.id})
	        .$promise
	        .then(function(){
	          $scope.orderUsers.push(obj);
	          growl.addSuccessMessage($translate.instant('order.user.add-success'));
	        }, function(){
	          growl.addErrorMessage($translate.instant('order.user.add-failure'));
	        });
	        break;
	      case 'project':
	        orderService.addProject(
	          params,
	          {'id': obj.id})
	        .$promise
	        .then(function(){
	          $scope.orderProjects.push(obj);
	          growl.addSuccessMessage($translate.instant('order.project.add-success'));
	        }, function(){
	          growl.addErrorMessage($translate.instant('order.project.add-failure'));
	        });
	        break;
	    }
	  };
	
	  $scope.removeObject = function(id, index, type){
	    var params = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: $scope.order.id,
	      id: id
	    };
	
	    switch (type) {
	      case 'plant':
	        orderService.removePlant(params)
	                    .$promise
	                    .then(function(){
	                      $scope.orderPlants.splice(index, 1);
	                      growl.addSuccessMessage($translate.instant('order.plant.remove-success'));
	                    }, function(){
	                      growl.addErrorMessage($translate.instant('order.plant.remove-failure'));
	                    });
	        break;
	      case 'user':
	        orderService.removeUser(params)
	                    .$promise
	                    .then(function(){
	                      $scope.orderUsers.splice(index, 1);
	                      growl.addSuccessMessage($translate.instant('order.user.remove-success'));
	                    }, function(){
	                      growl.addErrorMessage($translate.instant('order.user.remove-failure'));
	                    });
	        break;
	      case 'project':
	        orderService.removeProject(params)
	                    .$promise
	                    .then(function(){
	                      $scope.orderProjects.splice(index, 1);
	                      growl.addSuccessMessage($translate.instant('order.project.remove-success'));
	                    }, function(){
	                      growl.addErrorMessage($translate.instant('order.project.remove-failure'));
	                    });
	        break;
	    }
	  };
	}
	
	angular.module("dokiv")
	  .controller("CompanyPublicationOrderCtrl", CompanyPublicationOrderCtrl);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(12);
	__webpack_require__(20);
	var LIMIT = 20;
	
	CompanyPublicationOrderReportCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$modal',
	  '$state',
	  '$filter',
	  'CompanyPublicationOrderService',
	  'order',
	  'config',
	  'deliveries'];
	function CompanyPublicationOrderReportCtrl(
	  $scope,
	  $stateParams,
	  $modal,
	  $state,
	  $filter,
	  orderService,
	  order,
	  config,
	  deliveries) {
	
	  $scope.order = order;
	  $scope.deliveries = deliveries;
	  $scope.currentPage   = $stateParams.page|0;
	
	  $scope.orderDataQuery = $stateParams.t || "";
	  var startDate = Date.parse($stateParams.from);
	  var endDate   = Date.parse($stateParams.to);
	
	  $scope.orderDataSpan  = {
	    from: startDate ? new Date(startDate) : null,
	    to:   endDate   ? new Date(endDate)   : null
	  };
	
	  var angularModal;
	  $scope.showModalActiveOrder = function(d) {
	     angularModal = $modal({
	      scope: $scope,
	      prefixEvent: "modalOrder",
	      controller: ['$scope', 'delivery', function($scope, delivery) {
	        $scope.delivery = delivery;
	        $scope.activeOrder = function() {
	          orderService.updateDelivery({
	            companyId: $stateParams.companyId,
	            publicationId: $stateParams.publicationId,
	            massoptimeringId: $scope.order.id,
	            deliveryId: $scope.delivery.id
	          }, {}, function(){
	            d.active = !d.active;
	          });
	        };
	      }],
	      templateUrl: 'partials/company/publications/order-report/confirm-delete.html',
	      show: true,
	      resolve: {
	        delivery: function() {
	          return d;
	        }
	      }
	    });
	  };
	
	  $scope.$on('modalOrder.hide', function(){
	    angularModal.destroy();
	    angularModal = null;
	  });
	
	
	  $scope.toggleActiveOrder = function(d) {
	    orderService.updateDelivery({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: $scope.order.id,
	      deliveryId: d.id
	    }, {}, function(){
	      d.active = !d.active;
	    });
	  };
	
	  $scope.search = function(event) {
	    event.preventDefault();
	
	    var query = {
	      page: 0,
	      t: $scope.orderDataQuery
	    };
	
	    if ($scope.orderDataSpan.from) {
	      query.from = $filter('date')($scope.orderDataSpan.from, "yyyy-MM-dd");
	    }
	
	    if ($scope.orderDataSpan.to) {
	      query.to = $filter('date')($scope.orderDataSpan.to, "yyyy-MM-dd");
	    }
	
	    $state.go("root.company.publication.order-report", query, { location: "replace" });
	  };
	
	  $scope.downloadExcel = function() {
	    var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/export-deliveries?all=true&type=order&id=' + $scope.order.id + '&lang=' + window.localStorage.language;
	    if ($scope.orderDataSpan.from) {
	      url = url.concat('&from=', $filter('date')($scope.orderDataSpan.from, "yyyy-MM-dd"));
	    }
	
	    if ($scope.orderDataSpan.to) {
	      url = url.concat('&to=', $filter('date')($scope.orderDataSpan.to, "yyyy-MM-dd"));
	    }
	
	    if ($scope.orderDataQuery) {
	      url = url.concat('&t=', $scope.orderDataQuery);
	    }
	
	    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	    if (true === iOS) {
	      window.open(url, '_self');
	      return;
	    }
	
	    var elm = angular.element(document.querySelector('body'));
	    var iFrame = elm.find('#downloadWindow');
	    if (!(iFrame && iFrame.length > 0)) {
	      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	      elm.append(iFrame);
	    }
	
	    iFrame.attr('src',url);
	  };
	}
	
	CompanyPublicationOrderReportCtrl.resolve = {
	  order: ['CompanyPublicationOrderService', '$stateParams', function(orderService, $stateParams){
	    return orderService.get({
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId
	    }).$promise;
	  }],
	
	  deliveries: [
	    'CompanyPublicationOrderService',
	    '$stateParams',
	    'order',
	    function(orderService, $stateParams, order){
	    var filter = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      massoptimeringId: order.id,
	      offset: ($stateParams.page|0) * LIMIT,
	      limit:  LIMIT + 1
	    };
	
	    if ($stateParams.from) {
	      filter.from = $stateParams.from;
	    }
	
	    if ($stateParams.to) {
	      filter.to = $stateParams.to;
	    }
	
	    if($stateParams.t) {
	      filter.t = $stateParams.t;
	    }
	    return orderService.queryDeliveries(filter).$promise;
	  }]
	};
	
	module.exports = CompanyPublicationOrderReportCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyPublicationOrderReportCtrl", CompanyPublicationOrderReportCtrl);
	
	
	


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(20);
	function CompanyPublicationPlantCtrl($scope,
	  $stateParams,
	  $translate,
	  $modal,
	  CompanyProductsService,
	  growl) {
	  $scope.nonProductsAdded = [];
	  var nonProdcutAddedPromise;
	
	  CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, all: true}).$promise.then(function(priceLists){
	    var sortPriceLists = priceLists;
	    var priceListStandard = priceLists.filter(function(cp){
	      return cp.isStandard;
	    });
	    if(priceListStandard[0]){
	      var indexStandard = priceLists.indexOf(priceListStandard[0]);
	      sortPriceLists.splice(indexStandard, 1);
	      sortPriceLists.unshift(priceListStandard[0]);
	    }
	    $scope.priceLists = sortPriceLists;
	    angular.forEach($scope.plant.products, function(product){
	      var copyProduct = angular.copy(product);
	      product.pricelist = [];
	      angular.forEach(sortPriceLists, function(priceL){
	        var price = copyProduct.pricelist.filter(function(item){
	          return (item.price_list_id === priceL.id || item.priceListId === priceL.id) && item.plant && item.plant.id === $scope.plant.id && !item.unitCategory;
	        });
	        if(price[0]){
	          price[0].name = priceL.name;
	          price[0].discountPercentage = priceL.discountPercentage;
	          price[0].useFixedPrice = priceL.useFixedPrice;
	          price[0].isStandard = priceL.isStandard;
	          product.pricelist.push(price[0]);
	        }else{
	          product.pricelist.push({
	            priceListId: priceL.id,
	            name: priceL.name,
	            discountPercentage: priceL.discountPercentage,
	            useFixedPrice: priceL.useFixedPrice,
	            isStandard: priceL.isStandard,
	            useDefault: false,
	            unitCategory: null,
	            plant: {id: $scope.plant.id},
	            price: null
	          });
	        }
	      });
	    });
	  });
	
	  $scope.modalEditPriceList = function(product){
	    var modal = $modal({
	      scope: $scope,
	      controller: ['$scope', function($scope){
	        $scope.productPriceLists = product.pricelist;
	        $scope.updateProductPriceList = function(){
	          var productP = product;
	          productP.pricelist = $scope.productPriceLists;
	          var productFilter = $scope.plant.products.filter(function(p){
	            p.id === productP.id;
	          });
	          if(productFilter[0]){
	            $scope.plant.products[$scope.plant.products.indexOf(productFilter[0])] = productP
	          }
	          $scope.updateProduct(productP);
	          $scope.updatePlant();
	        };
	      }],
	      templateUrl: 'partials/company/publications/modal-pricelist.html',
	      show: false 
	    });
	    modal.$promise.then(modal.show);
	  };
	
	  $scope.calcProductPrice = function(product, priceList){
	    if(priceList.isStandard){
	      angular.forEach(product.pricelist, function(priceL){
	        if(!priceL.isStandard){
	          if(!priceL.useFixedPrice){
	            if(priceL.discountPercentage){
	              priceL.price = priceList.price - priceList.price*priceL.discountPercentage/100;
	            }
	          }else{
	            priceL.price = priceList.price;
	          }
	        }
	      });
	    }
	  };
	
	  $scope.addProduct = function(product) {
	    var copyProduct = angular.copy(product);
	    product.avPriceCost = copyProduct.AvPriceCost;
	    product.pricelist = [];
	    angular.forEach($scope.priceLists, function(priceL){
	      var price = copyProduct.pricelist.filter(function(item){
	        return (item.price_list_id === priceL.id || item.priceListId === priceL.id) && item.plant && item.plant.id === $scope.plant.id && !item.unitCategory;
	      });
	      if(price[0]){
	        price[0].discountPercentage = priceL.discountPercentage,
	        price[0].useFixedPrice = priceL.useFixedPrice,
	        price[0].isStandard = priceL.isStandard,
	        product.pricelist.push(price[0]);
	      }else{
	        product.pricelist.push({
	          priceListId: priceL.id,
	          name: priceL.name,
	          discountPercentage: priceL.discountPercentage,
	          useFixedPrice: priceL.useFixedPrice,
	          isStandard: priceL.isStandard,
	          useDefault: false,
	          unitCategory: null,
	          plant: {id: $scope.plant.id},
	          price: null
	        });
	      }
	    });
	    $scope.plant.products.push(product);
	    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
	    angular.element('#filterProduct').val('');
	    $scope.updatePlant();
	  };
	
	  $scope.removeProduct = function(index) {
	    $scope.plant.products.splice(index, 1);
	    $scope.updatePlant();
	  };
	
	  $scope.updateNonProductsAdded = function(filter, plantType) {
	    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, type: 'PLANT', plant_type: plantType, limit: 10}).$promise.then(function(products) {
	          return products.filter(function(item) {
	            return !$scope.plant.products.some(function(product) {
	              return item.id === product.id;
	            });
	          });
	        }).then(function(nonProducts) {
	          if(nonProdcutAddedPromise === p) {
	            $scope.nonProductsAdded = nonProducts;
	          }
	        });
	        nonProdcutAddedPromise = p;
	  };
	
	  $scope.updatePlant = function() {
	    $scope.plant.$update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(){
	      $scope.addedProduct = null;
	      growl.addSuccessMessage($translate.instant('plant.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('plant.save-failure'));
	    });
	  };
	
	  $scope.updateProduct = function(product) {
	    angular.forEach(product.pricelist, function(priceL){
	      if(priceL.price){
	        if(!priceL.priceListId){
	          priceL.priceListId = priceL.price_list_id;
	        }
	        CompanyProductsService.updatePrice({companyId: $stateParams.companyId, productId: product.id}, priceL, function(){
	          growl.addSuccessMessage($translate.instant('product.price-lists.save-success'));
	        }, function(){
	          growl.addErrorMessage($translate.instant('product.price-lists.save-failure'));
	        });
	      }
	    });
	    CompanyProductsService.update({companyId: $stateParams.companyId, productId: product.id}, product, function(){
	      growl.addSuccessMessage($translate.instant('product.save-success'));
	    }, function(){
	      growl.addErrorMessage($translate.instant('product.save-failure'));
	    });
	  };
	
	  $scope.showModalProductList = function(plantType) {
	    var modal = $modal({
	      scope: $scope,
	      controller: ['CompanyProductsService', '$scope', function(CompanyProductsService, $scope){
	        var p = CompanyProductsService.query({companyId: $stateParams.companyId, type: 'PLANT', plant_type: plantType, all: true}).$promise.then(function(products) {
	          return products.filter(function(item) {
	            return !$scope.plant.products.some(function(product) {
	              return item.id === product.id;
	            });
	          });
	        }).then(function(nonProducts) {
	          if(nonProdcutAddedPromise === p) {
	            $scope.products = nonProducts;
	          }
	        });
	        nonProdcutAddedPromise = p;
	
	        $scope.listProducts = [];
	        $scope.addProducts = function(){
	          angular.forEach($scope.listProducts, function(product){
	            $scope.addProduct(product);
	          });
	        };
	      }],
	      templateUrl: 'partials/company/publications/modal-product-list.html',
	      show: false
	    });
	    modal.$promise.then(modal.show);
	  };
	
	}
	
	angular.module('dokiv')
	  .controller('CompanyPublicationPlantCtrl', ['$scope',
	    '$stateParams',
	    '$translate',
	    '$modal',
	    'CompanyProductsService',
	    'growl',
	    CompanyPublicationPlantCtrl]);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(31);
	var LIMIT = 20;
	
	CompanyPublicationPlantReportCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$filter',
	  'config',
	  'CompanyPublicationPlantService',
	  'deliveries'];
	function CompanyPublicationPlantReportCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $filter,
	  config,
	  plantService,
	  deliveries) {
	  $scope.deliveries = deliveries;
	  $scope.currentPage   = $stateParams.page|0;
	
	  $scope.plantDataQuery = $stateParams.t || "";
	  var startDate = Date.parse($stateParams.from);
	  var endDate   = Date.parse($stateParams.to);
	
	  $scope.plantDataSpan  = {
	    from: startDate ? new Date(startDate) : null,
	    to:   endDate   ? new Date(endDate)   : null
	  };
	
	  $scope.search = function(event) {
	    event.preventDefault();
	
	    var query = {
	      page: 0,
	      t: $scope.plantDataQuery
	    };
	
	    if ($scope.plantDataSpan.from) {
	      query.from = $filter('date')($scope.plantDataSpan.from, "yyyy-MM-dd");
	    }
	
	    if ($scope.plantDataSpan.to) {
	      query.to = $filter('date')($scope.plantDataSpan.to, "yyyy-MM-dd");
	    }
	
	    $state.go("root.company.publication.plant-report", query, { location: "replace" });
	  };
	
	  $scope.downloadExcel = function() {
	    var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/export-deliveries?all=true&type=plant&id=' + $stateParams.plantId + '&lang=' + window.localStorage.language;
	    if ($scope.plantDataSpan.from) {
	      url = url.concat('&from=', $filter('date')($scope.plantDataSpan.from, "yyyy-MM-dd"));
	    }
	
	    if ($scope.plantDataSpan.to) {
	      url = url.concat('&to=', $filter('date')($scope.plantDataSpan.to, "yyyy-MM-dd"));
	    }
	
	    if ($scope.plantDataQuery) {
	      url = url.concat('&t=', $scope.plantDataQuery);
	    }
	
	    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	    if (true === iOS) {
	      window.open(url, '_self');
	      return;
	    }
	
	    var elm = angular.element(document.querySelector('body'));
	    var iFrame = elm.find('#downloadWindow');
	    if (!(iFrame && iFrame.length > 0)) {
	      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	      elm.append(iFrame);
	    }
	
	    iFrame.attr('src',url);
	  };
	}
	
	CompanyPublicationPlantReportCtrl.resolve = {
	  deliveries: [
	    'CompanyPublicationPlantService',
	    '$stateParams',
	    function(plantService, $stateParams){
	    var filter = {
	      companyId: $stateParams.companyId,
	      publicationId: $stateParams.publicationId,
	      plantId: $stateParams.plantId,
	      offset: ($stateParams.page|0) * LIMIT,
	      limit:  LIMIT + 1
	    };
	
	    if ($stateParams.from) {
	      filter.from = $stateParams.from;
	    }
	
	    if ($stateParams.to) {
	      filter.to = $stateParams.to;
	    }
	
	    if($stateParams.t) {
	      filter.t = $stateParams.t;
	    }
	
	    return plantService.queryDeliveries(filter).$promise;
	  }]
	};
	
	module.exports = CompanyPublicationPlantReportCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyPublicationPlantReportCtrl", CompanyPublicationPlantReportCtrl);
	
	
	


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(13);
	
	function CompanySettingCategoriesCtrl(
	  $scope,
	  categories,
	  priorities,
	  translations,
	  $stateParams,
	  $state,
	  $q,
	  CompanyCategoryService,
	  growl
	) {
	  var origCategories = [];
	
	  $scope.categories = categories;
	  $scope.translations = translations;
	  $scope.priorities = priorities;
	
	  // Save each category object to a new array for comparison later
	  $scope.categories.$promise.then(function() {
	    for(var i = 0; i < $scope.categories.length; i++) {
	      origCategories.push(angular.copy($scope.categories[i]));
	    }
	  });
	
	  function saveCategory(category) {
	    if( ! category.id) {
	      return category.$save({companyId: $stateParams.companyId}, function(category, headers) {
	        category.id = headers("location").split("/").pop();
	
	        growl.addSuccessMessage(translations['settings.create-category-success'] + ': ' + category.name);
	
	        return category;
	      });
	    }
	
	    for(var i = 0; i < origCategories.length; i++) {
	      if(origCategories[i].id === category.id) {
	        if(angular.equals(origCategories[i], category)) {
	          return $scope.createQ(function(resolve) {
	            resolve(category);
	          });
	        }
	        else {
	          return category.$update({companyId: $stateParams.companyId});
	        }
	      }
	    }
	
	    return category.$update({companyId: $stateParams.companyId});
	  }
	
	  $scope.saveCategories = function() {
	    return $q.all($scope.categories.map(saveCategory)).then(function(categories) {
	      $scope.categories = categories;
	
	      origCategories = angular.copy($scope.categories);
	
	      $state.reload();
	
	      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
	    }, function() {
	      growl.addErrorMessage(translations['settings.create-category-failure']);
	    });
	  };
	
	  $scope.addCategory = function() {
	    $scope.categories.push(new CompanyCategoryService({
	      name: '',
	      color: 4279856278, // #196c96
	      favourite: false
	    }));
	
	    $scope.lastItem = $scope.categories.length - 1;
	  };
	
	  $scope.deleteCategory = function(category) {
	    category.$delete({companyId: $stateParams.companyId, categoryId: category.id}, function() {
	      function categoryFilter(c) {
	        return c.id !== category.id;
	      }
	
	      $scope.categories = $scope.categories.filter(categoryFilter);
	      origCategories    = $scope.categories.filter(categoryFilter);
	
	      growl.addSuccessMessage(translations['settings.remove-category-success']);
	      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
	    },
	    function(response) {
	      if (response.status === 403 && response.data.error.code === 3007) {
	        growl.addErrorMessage(translations['settings.remove-category-failure-3007']);
	      } else {
	        growl.addErrorMessage(translations['settings.remove-category-failure']);
	      }
	    });
	  };
	
	  $scope.searchStatuses = function(filter){
	    $scope.priorities = priorities.filter(function(p){
	      return p.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	    });
	  }
	
	  $scope.checkAllCategories = function(selectedAll, index){
	    $scope.categories[index].priorities = [];
	    if(selectedAll){
	      priorities.forEach(function(p) {
	        $scope.categories[index].priorities.push(p);
	      });
	    }
	  };
	
	  $scope.checkedCategory = function(category, priority){
	    var indexCategory = $scope.categories.findIndex(function(c){
	                          return c.id === category.id;
	                        });
	    if(indexCategory > -1 && $scope.categories[indexCategory].priorities){
	      return $scope.categories[indexCategory].priorities.findIndex(function(p){
	              return p.id === priority.id;
	            });
	    }else{
	      return -1;
	    }
	  };
	}
	
	CompanySettingCategoriesCtrl.resolve = {
	  categories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
	    return CompanyCategoryService.query({companyId: $stateParams.companyId, limit: 100, type: 'OBJECT_CATEGORY'}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.create-category-success',
	      'settings.create-category-failure',
	      'settings.remove-category-success',
	      'settings.remove-category-failure',
	      'settings.remove-category-failure-3007'
	    ]);
	  }]
	};
	module.exports = CompanySettingCategoriesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingCategoriesCtrl', [
	  '$scope',
	  'categories',
	  'priorities',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$q',
	  'CompanyCategoryService',
	  'growl',
	  CompanySettingCategoriesCtrl
	]);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(60);
	
	function CompanySettingCategoryGroupsCtrl(
	  $scope,
	  $q,
	  groupCategories,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyGroupCategoryService,
	  growl
	) {
	  var origGroupCategories = [];
	
	  $scope.translations = translations;
	  $scope.groupCategories = groupCategories;
	
	  function saveGroupCategory(groupCategory) {
	    if( !groupCategory.id) {
	      return groupCategory.$save({companyId: $stateParams.companyId}, function(groupCategory, headers) {
	        groupCategory.id = headers("location").split("/").pop();
	
	        growl.addSuccessMessage(translations['settings.create-group-category-success'] + ': ' + groupCategory.name);
	
	        return groupCategory;
	      });
	    }
	
	    for(var i = 0; i < origGroupCategories.length; i++) {
	      if(origGroupCategories[i].id === groupCategory.id) {
	        if(angular.equals(origGroupCategories[i], groupCategory)) {
	          return $scope.createQ(function(resolve) {
	            resolve(groupCategory);
	          });
	        }
	        else {
	          return groupCategory.$update({companyId: $stateParams.companyId});
	        }
	      }
	    }
	
	    return groupCategory.$update({companyId: $stateParams.companyId});
	  }
	
	  $scope.saveGroupCategories = function(){
	    return $q.all($scope.groupCategories.map(saveGroupCategory)).then(function(groupCategories) {
	      $scope.groupCategories = groupCategories;
	
	      origGroupCategories = angular.copy($scope.groupCategories);
	
	      $window.location.reload();
	
	      growl.addSuccessMessage(translations['settings.create-group-category-success']);
	    }, function(error) {
	      if(error.status===304){
	        growl.addSuccessMessage(translations['settings.create-group-category-success']);
	      }else{
	        growl.addErrorMessage(translations['settings.create-group-category-failure']);
	      }
	    });
	  };
	
	  $scope.addGroupCategory = function() {
	    $scope.groupCategories.push(new CompanyGroupCategoryService());
	
	    $scope.lastItem = $scope.groupCategories.length - 1;
	  };
	
	  $scope.deleteGroupCategory = function(groupCategory) {
	    groupCategory.$delete({companyId: $stateParams.companyId, categoryId: groupCategory.id}, function() {
	      function groupCategoryFilter(c) {
	        return c.id !== groupCategory.id;
	      }
	
	      $scope.groupCategories = $scope.groupCategories.filter(groupCategoryFilter);
	      origGroupCategories    = $scope.groupCategories.filter(groupCategoryFilter);
	
	      growl.addSuccessMessage(translations['settings.remove-group-category-success']);
	    },
	    function() {
	        growl.addErrorMessage(translations['settings.remove-group-category-failure']);
	    });
	  };
	}
	
	CompanySettingCategoryGroupsCtrl.resolve = {
	  groupCategories: ['$stateParams', 'CompanyGroupCategoryService', function($stateParams, CompanyGroupCategoryService) {
	    return CompanyGroupCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.create-group-category-success',
	      'settings.create-group-category-failure',
	      'settings.remove-group-category-success',
	      'settings.remove-group-category-failure'
	    ]);
	  }]
	};
	module.exports = CompanySettingCategoryGroupsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingCategoryGroupsCtrl', [
	  '$scope',
	  '$q',
	  'groupCategories',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyGroupCategoryService',
	  'growl',
	  CompanySettingCategoryGroupsCtrl
	]);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(7);
	__webpack_require__(14);
	
	function CompanySettingGroupsCtrl(
	  $scope,
	  $q,
	  groups,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyCategoryService,
	  CompanyGroupService,
	  CompanyGroupUserService,
	  growl
	) {
	  var origGroups = [];
	  $scope.groups = groups;
	  $scope.translations = translations;
	
	  // Save each group object to a new array for comparison later
	  $scope.groups.$promise.then(function() {
	    for(var i = 0; i < $scope.groups.length; i++) {
	      origGroups.push(angular.copy($scope.groups[i]));
	    }
	  });
	
	  function saveGroup(group) {
	    if( ! group.id) {
	      return group.$save({companyId: $stateParams.companyId}, function(group, headers) {
	        group.id = headers("location").split("/").pop();
	        group.numPublications = 0;
	        group.numUsers = 0;
	
	        growl.addSuccessMessage(translations['settings.create-group-success'] + ': ' + group.name);
	
	        if (group.addCurrentUser) {
	          CompanyGroupUserService.save({
	            companyId: $stateParams.companyId,
	            groupId:   group.id
	          }, $scope.currentUser, function() {
	            group.numUsers = 1;
	          });
	        }
	
	        return group;
	      });
	    }
	
	    for(var i = 0; i < origGroups.length; i++) {
	      if(origGroups[i].id === group.id) {
	        if(angular.equals(origGroups[i], group)) {
	          return $scope.createQ(function(resolve) {
	            resolve(group);
	          });
	        }
	        else {
	          return group.$update({companyId: $stateParams.companyId, groupId: group.id});
	        }
	      }
	    }
	
	    return group.$update({companyId: $stateParams.companyId, groupId: group.id});
	  }
	
	  $scope.saveGroups = function() {
	    return $q.all($scope.groups.map(saveGroup)).then(function(groups) {
	      $scope.groups = groups;
	
	      origGroups = angular.copy($scope.groups);
	
	      $window.location.reload();
	
	      growl.addSuccessMessage(translations['settings.create-group-success']);
	    }, function() {
	      growl.addErrorMessage(translations['settings.create-group-failure']);
	    });
	  };
	
	  $scope.addGroup = function() {
	    $scope.groups.push(new CompanyGroupService());
	
	    $scope.lastItem = $scope.groups.length - 1;
	  };
	
	  $scope.deleteGroup = function(group) {
	    group.$delete({companyId: $stateParams.companyId, groupId: group.id}, function() {
	      function groupFilter(g) {
	        return g.id !== group.id;
	      }
	
	      $scope.groups = $scope.groups.filter(groupFilter);
	      origGroups    = origGroups.filter(groupFilter);
	
	      growl.addSuccessMessage(translations['settings.remove-group-success']);
	    }, function() {
	      growl.addErrorMessage(translations['settings.remove-group-failure']);
	    });
	  };
	
	}
	
	CompanySettingGroupsCtrl.resolve = {
	  groups: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
	    return CompanyGroupService.query({companyId: $stateParams.companyId, all: true}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.create-group-category-success',
	      'settings.create-group-category-failure',
	      'settings.remove-group-category-success',
	      'settings.remove-group-category-failure',
	      'user.save-permissions-success',
	      'user.save-permissions-failure'
	    ]);
	  }]
	};
	module.exports = CompanySettingGroupsCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingGroupsCtrl', [
	  '$scope',
	  '$q',
	  'groups',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyCategoryService',
	  'CompanyGroupService',
	  'CompanyGroupUserService',
	  'growl',
	  CompanySettingGroupsCtrl
	]);


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanySettingInvestigationTemplatesService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/investigation-templates/:investigationTemplatesId', {}, {
	    'update': {method: 'PUT'}
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanySettingInvestigationTemplatesService', ['$resource', 'config', CompanySettingInvestigationTemplatesService]);


/***/ }),
/* 410 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanySettingInvestigationUsersService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/investigation-users/:investigationUserId', {}, {});
	}
	
	angular.module('dokiv')
	  .factory('CompanySettingInvestigationUsersService', ['$resource', 'config', CompanySettingInvestigationUsersService]);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(13);
	
	function CompanySettingNoticeCategoriesCtrl(
	  $scope,
	  categories,
	  priorities,
	  translations,
	  $stateParams,
	  $state,
	  $q,
	  CompanyCategoryService,
	  growl
	) {
	  var origCategories = [];
	
	  $scope.categories = categories;
	  $scope.translations = translations;
	  $scope.priorities = priorities;
	
	  // Save each category object to a new array for comparison later
	  $scope.categories.$promise.then(function() {
	    for(var i = 0; i < $scope.categories.length; i++) {
	      origCategories.push(angular.copy($scope.categories[i]));
	    }
	  });
	
	  function saveCategory(category) {
	    if( ! category.id) {
	      return category.$save({companyId: $stateParams.companyId}, function(category, headers) {
	        category.id = headers("location").split("/").pop();
	
	        growl.addSuccessMessage(translations['settings.create-category-success'] + ': ' + category.name);
	
	        return category;
	      });
	    }
	
	    for(var i = 0; i < origCategories.length; i++) {
	      if(origCategories[i].id === category.id) {
	        if(angular.equals(origCategories[i], category)) {
	          return $scope.createQ(function(resolve) {
	            resolve(category);
	          });
	        }
	        else {
	          return category.$update({companyId: $stateParams.companyId});
	        }
	      }
	    }
	
	    return category.$update({companyId: $stateParams.companyId});
	  }
	
	  $scope.saveCategories = function() {
	    return $q.all($scope.categories.map(saveCategory)).then(function(categories) {
	      $scope.categories = categories;
	
	      origCategories = angular.copy($scope.categories);
	
	      $state.reload();
	
	      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
	    }, function() {
	      growl.addErrorMessage(translations['settings.create-category-failure']);
	    });
	  };
	
	  $scope.addCategory = function() {
	    $scope.categories.push(new CompanyCategoryService({
	      name: '',
	      color: 4279856278, // #196c96
	      favourite: false,
	      type: 'REMINDER_CATEGORY'
	    }));
	
	    $scope.lastItem = $scope.categories.length - 1;
	  };
	
	  $scope.deleteCategory = function(category) {
	    category.$delete({companyId: $stateParams.companyId, categoryId: category.id}, function() {
	      function categoryFilter(c) {
	        return c.id !== category.id;
	      }
	
	      $scope.categories = $scope.categories.filter(categoryFilter);
	      origCategories    = $scope.categories.filter(categoryFilter);
	
	      growl.addSuccessMessage(translations['settings.remove-category-success']);
	      $scope.$emit('categoriesChanged', angular.copy($scope.categories));
	    },
	    function(response) {
	      if (response.status === 403 && response.data.error.code === 3007) {
	        growl.addErrorMessage(translations['settings.remove-category-failure-3007']);
	      } else {
	        growl.addErrorMessage(translations['settings.remove-category-failure']);
	      }
	    });
	  };
	
	  $scope.searchStatuses = function(filter){
	    $scope.priorities = priorities.filter(function(p){
	      return p.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	    });
	  }
	
	  $scope.checkAllCategories = function(selectedAll, index){
	    $scope.categories[index].priorities = [];
	    if(selectedAll){
	      priorities.forEach(function(p) {
	        $scope.categories[index].priorities.push(p);
	      });
	    }
	  };
	
	  $scope.checkedCategory = function(category, priority){
	    var indexCategory = $scope.categories.findIndex(function(c){
	                          return c.id === category.id;
	                        });
	    if(indexCategory > -1 && $scope.categories[indexCategory].priorities){
	      return $scope.categories[indexCategory].priorities.findIndex(function(p){
	              return p.id === priority.id;
	            });
	    }else{
	      return -1;
	    }
	  };
	}
	
	CompanySettingNoticeCategoriesCtrl.resolve = {
	  categories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService) {
	    return CompanyCategoryService.query({companyId: $stateParams.companyId, limit: 100, type: 'REMINDER_CATEGORY'}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.create-category-success',
	      'settings.create-category-failure',
	      'settings.remove-category-success',
	      'settings.remove-category-failure',
	      'settings.remove-category-failure-3007'
	    ]);
	  }]
	};
	module.exports = CompanySettingNoticeCategoriesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingNoticeCategoriesCtrl', [
	  '$scope',
	  'categories',
	  'priorities',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$q',
	  'CompanyCategoryService',
	  'growl',
	  CompanySettingNoticeCategoriesCtrl
	]);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	
	function CompanySettingStatusesCtrl(
	  $scope,
	  priorities,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyService,
	  growl
	) {
	  $scope.priorities = priorities;
	  $scope.translations = translations;
	
	
	  $scope.addPriority = function() {
	    $scope.priorities.push({
	      name: '',
	      color: 4279856278, // #196c96
	    });
	
	    $scope.lastItem = $scope.priorities.length - 1;
	  };
	
	  $scope.savePriorities = function() {
	    CompanyService.updatePriorities({companyId: $stateParams.companyId}, $scope.priorities, function() {
	      $window.location.reload();
	      growl.addSuccessMessage(translations['settings.save-priorities-success']);
	    });
	  };
	}
	
	CompanySettingStatusesCtrl.resolve = {
	  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryPriorities({companyId: $stateParams.companyId, name: 'klar'}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.save-priorities-success'
	    ]);
	  }]
	};
	module.exports = CompanySettingStatusesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingStatusesCtrl', [
	  '$scope',
	  'priorities',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyService',
	  'growl',
	  CompanySettingStatusesCtrl
	]);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(418);
	
	function CompanySettingTaskCategoriesCtrl(
	  $scope,
	  $translate,
	  taskCategories,
	  $stateParams,
	  $state,
	  $window,
	  CompanyTaskService,
	  growl
	) {
	  $scope.taskCategories = taskCategories;
	
	
	  $scope.addTaskCategory = function() {
	    $scope.taskCategories.push({
	      name: '',
	      color: 4279856278, // #196c96
	    });
	
	    $scope.lastItem = $scope.taskCategories.length - 1;
	  };
	
	  $scope.saveTaskCategories = function() {
	    CompanyTaskService.updateCategories({companyId: $stateParams.companyId}, $scope.taskCategories, function() {
	      $window.location.reload();
	      growl.addSuccessMessage($translate.instant('settings.save-task-categories-success'));
	    });
	  };
	}
	
	CompanySettingTaskCategoriesCtrl.resolve = {
	  taskCategories: ['$stateParams', 'CompanyTaskService', function($stateParams, CompanyTaskService) {
	    return CompanyTaskService.queryCategories({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	module.exports = CompanySettingTaskCategoriesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingTaskCategoriesCtrl', [
	  '$scope',
	  '$translate',
	  'taskCategories',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyTaskService',
	  'growl',
	  CompanySettingTaskCategoriesCtrl
	]);


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	
	function CompanySettingTaskStatusesCtrl(
	  $scope,
	  taskStatuses,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyService,
	  growl
	) {
	  // Task statuses
	  $scope.taskStatuses = taskStatuses;
	  $scope.addTaskStatus = function() {
	    $scope.taskStatuses.push({
	      name: '',
	      color: 4279856278,
	      type: 'CUSTOME'
	    });
	
	    $scope.lastItemTaskStatuses = $scope.taskStatuses.length - 1;
	  };
	
	  $scope.saveTaskStatuses = function() {
	    angular.forEach($scope.taskStatuses, function(taskStatus){
	      if(!taskStatus.id){
	        taskStatus.code = taskStatus.name;
	      }
	    });
	    CompanyService.updateTaskStatuses({companyId: $stateParams.companyId}, $scope.taskStatuses, function() {
	      $state.reload();
	      growl.addSuccessMessage(translations['settings.save-status-tasks-success']);
	    });
	  };
	}
	
	CompanySettingTaskStatusesCtrl.resolve = {
	  taskStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryTaskStatuses({companyId: $stateParams.companyId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	     'settings.save-status-tasks-success'
	    ]);
	  }]
	};
	module.exports = CompanySettingTaskStatusesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingTaskStatusesCtrl', [
	  '$scope',
	  'taskStatuses',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyService',
	  'growl',
	  CompanySettingTaskStatusesCtrl
	]);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	
	function CompanySettingTaskTypesCtrl(
	  $scope,
	  taskTypes,
	  translations,
	  $stateParams,
	  $state,
	  $window,
	  CompanyService,
	  growl
	) {
	  // Task statuses
	  $scope.taskTypes = taskTypes;
	  $scope.addTaskType = function() {
	    $scope.taskTypes.push({
	      name: '',
	      color: 4279856278,
	      type: 'CUSTOME'
	    });
	
	    $scope.lastItemTaskTypes = $scope.taskTypes.length - 1;
	  };
	
	  $scope.saveTaskTypes = function() {
	    angular.forEach($scope.taskTypes, function(taskType){
	      if(!taskType.id){
	        taskType.code = taskType.name;
	      }
	    });
	    CompanyService.updateTaskTypes({companyId: $stateParams.companyId}, $scope.taskTypes, function() {
	      $state.reload();
	      growl.addSuccessMessage(translations['settings.save-task-types-success']);
	    });
	  };
	}
	
	CompanySettingTaskTypesCtrl.resolve = {
	  taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
	    return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	     'settings.save-task-types-success'
	    ]);
	  }]
	};
	module.exports = CompanySettingTaskTypesCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingTaskTypesCtrl', [
	  '$scope',
	  'taskTypes',
	  'translations',
	  '$stateParams',
	  '$state',
	  '$window',
	  'CompanyService',
	  'growl',
	  CompanySettingTaskTypesCtrl
	]);


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	
	function CompanySettingThreeLoginCtrl(
	  $scope,
	  $q,
	  $stateParams,
	  growl,
	  translations,
	  reportLogins,
	  CompanyService
	) {
	
	  $scope.reportLogins = reportLogins.filter(function(l) {
	    return l.loginType === "GOOGLE";
	  });
	
	  $scope.loginAnalytics = function(){
	    auth2.grantOfflineAccess({
	      'approval_prompt': 'force',
	    }).then(signInCallback);
	  };
	
	  function signInCallback(authResult) {
	    if (authResult['code']) {
	      var userName = '';
	      var userNameDeferred = $q.defer();
	      window.gapi.auth2.getAuthInstance().currentUser.listen(function(user){
	        if(userName === ''){
	          userName = user.w3.U3;
	          userNameDeferred.resolve();
	        }
	      });
	      
	      userNameDeferred.promise.then(function(){
	        CompanyService.loginAnalytic({companyId: $stateParams.companyId}, {code: authResult['code'], email: userName}, function(resp) {
	          growl.addSuccessMessage(translations['settings.login-analytics-success']);
	          var reportLogin = $scope.reportLogins.filter(function(item){
	            return item.username === userName;
	          });
	          if(reportLogin[0]){
	            $scope.reportLogins[$scope.reportLogins.indexOf(reportLogin[0])].accessToken = resp.accessToken;
	          }else{
	            $scope.reportLogins.push(resp);
	          }
	        }, function() {
	          growl.addErrorMessage(translations['settings.login-analytics-failure']);
	        });
	      });
	    } else {
	      growl.addErrorMessage(translations['settings.login-analytics-failure']);
	    }
	  }
	
	  $scope.deleteLoginAnalytic = function(login){
	    CompanyService.deleteLoginAnalytic({companyId: $stateParams.companyId, loginId: login.id}, function() {
	      growl.addSuccessMessage(translations['settings.delete-login-success']);
	      $scope.reportLogins.splice($scope.reportLogins.indexOf(login), 1);
	    }, function() {
	      growl.addErrorMessage(translations['settings.delete-login-failure']);
	    });
	  };
	
	  $scope.saveViewIds = function(login, isDelete){
	    if(!isDelete){
	      var newViewId = login.newViewId.toString();
	      var isExitsLogin = $scope.reportLogins.filter(function(reportLogin){
	        return reportLogin.viewIds.indexOf(newViewId) > -1;
	      });
	      if(!isExitsLogin[0]){
	        login.viewIds.push(newViewId);
	      }else{
	        growl.addErrorMessage(translations['settings.this-view-id-exists']);
	        return false;
	      }
	    }
	    CompanyService.updateAnalytic({companyId: $stateParams.companyId, loginId: login.id}, login, function() {
	      growl.addSuccessMessage(translations['settings.save-view-id-success']);
	    }, function() {
	      growl.addErrorMessage(translations['settings.save-view-id-failure']);
	    });
	  };
	}
	
	CompanySettingThreeLoginCtrl.resolve = {
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'settings.login-analytics-success',
	      'settings.login-analytics-failure',
	      'settings.delete-login-success',
	      'settings.delete-login-failure',
	      'settings.save-view-id-success',
	      'settings.save-view-id-failure',
	      'settings.this-view-id-exists'
	    ]);
	  }],
	  reportLogins: ['CompanyService', '$stateParams', function(CompanyService, $stateParams){
	    return CompanyService.getLoginAnalytics({companyId: $stateParams.companyId}).$promise;
	  }]
	};
	module.exports = CompanySettingThreeLoginCtrl;
	
	angular.module('dokiv')
	  .controller('CompanySettingThreeLoginCtrl', [
	  '$scope',
	  '$q',
	  '$stateParams',
	  'growl',
	  'translations',
	  'reportLogins',
	  'CompanyService',
	  CompanySettingThreeLoginCtrl
	]);


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanySettingUnitsService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/units/:unitId', {}, {
	    'update': {method: 'PUT'},
	    'queryMembers': {
	      url: config.apiBase + '/companies/:companyId/units/:unitId/users',
	      method: 'GET',
	      isArray: true
	    },
	    'addMembers': {
	      url: config.apiBase + '/companies/:companyId/units/:unitId/users',
	      method: 'POST'
	    },
	    'deleteMember':  {
	      url: config.apiBase + '/companies/:companyId/units/:unitId/users/:userId',
	      method: 'DELETE'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanySettingUnitsService', ['$resource', 'config', CompanySettingUnitsService]);


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	function CompanyTaskCategoryService($resource, config) {
	  return $resource(config.apiBase + '/companies/:companyId/reminders/categories', {}, {
	    "update": {
	      method: "PUT"
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('CompanyTaskCategoryService', [
	    '$resource',
	    'config',
	    CompanyTaskCategoryService
	  ]);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(43);
	__webpack_require__(10);
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	
	  return false;
	}
	
	CompanyTaskDetailCtrl.$inject = [
	  '$scope',
	  '$controller',
	  '$translate',
	  '$state',
	  '$filter',
	  '$stateParams',
	  'checklists',
	  'taskTypes',
	  'CompanyChecklistService',
	  'CompanyUserService',
	  'CompanyTaskService',
	  'task',
	  'growl'];
	function CompanyTaskDetailCtrl(
	  $scope,
	  $controller,
	  $translate,
	  $state,
	  $filter,
	  $stateParams,
	  checklists,
	  taskTypes,
	  checklistService,
	  CompanyUserService,
	  CompanyTaskService,
	  task,
	  growl) {
	  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));
	  $scope.isEdited = false;
	  $scope.task = task;
	  $scope.checklists = checklists;
	  $scope.taskTypes = taskTypes;
	
	  $scope.task.startAt   = new Date($scope.task.startAt);
	  $scope.task.dueAt     = new Date($scope.task.dueAt);
	  if ($scope.task.repeatEnd) {
	    $scope.task.repeatEnd = new Date($scope.task.repeatEnd);
	  }
	
	  if ($scope.task.wholeDay) {
	    $scope.dateFormat = $scope.dateWithoutTime;
	  } else {
	    $scope.dateFormat = $scope.dateWithTime;
	  }
	
	  function checkDueAt() {
	    if($scope.task.dueAt <= $scope.task.startAt) {
	      $scope.task.dueAt = new Date($scope.task.startAt.getTime());
	      $scope.task.dueAt.setHours($scope.task.dueAt.getHours() + 1);
	    }
	  }
	
	  $scope.$watch('[task.startAt, task.dueAt]', function(newValue, oldValue) {
	    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
	       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
	      checkDueAt();
	    }
	  }, true);
	  
	
	  $scope.saveTask = function() {
	    $scope.formShow = false;
	    var r  = angular.copy($scope.task);
	    if (r.repeatEnd) {
	      r.repeatEnd = new Date(r.repeatEnd.setDate(r.repeatEnd.getDate()+1));
	    }
	    r.$update({companyId: $stateParams.companyId, taskId: r.id},
	      function(){
	        growl.addSuccessMessage($translate.instant('task.update-success'));
	        $scope.isEdited = true;
	      },
	      function(){
	        growl.addErrorMessage($translate.instant('task.update-failure'));
	      });
	  };
	
	  $scope.setCompleted = function() {
	    if ($scope.task.completedAt) {
	      return;
	    }
	
	    var completedAt = new Date();
	    $scope.task.completedAt = completedAt;
	    $scope.task.completedBy = $scope.currentUser;
	    $scope.saveTask();
	    $scope.hide(true);
	  };
	
	  function calcSpentTime() {
	    var current = new Date(), spentTime;
	    if ($scope.task.completedAt) {
	      spentTime = current - new Date($scope.task.completedAt);
	    } else {
	      spentTime = current - new Date($scope.task.startAt);
	    }
	
	    return $filter('number')(spentTime/3600000, 1);
	  }
	
	  $scope.spentTime = calcSpentTime();
	
	  $scope.hide = function(isEdited) {
	    if ($state.current.name !== 'root.company.tasks.detail') {
	      $scope.$hide();
	    } else {
	      if ($scope.isEdited === true || angular.isDefined(isEdited)) {
	        $state.go('.^', {}, {reload: true});
	      } else {
	        $state.go('.^');
	      }
	    }
	  };
	}
	
	module.exports = CompanyTaskDetailCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyTaskDetailCtrl', CompanyTaskDetailCtrl);


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(43);
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	
	  return false;
	}
	
	CompanyTaskNewCtrl.$inject = [
	  '$scope',
	  '$rootScope',
	  '$controller',
	  '$stateParams',
	  '$state',
	  '$translate',
	  'publication',
	  'taskTypes',
	  'data',
	  'CompanyUserService',
	  'CompanyTaskService',
	  'growl'];
	function CompanyTaskNewCtrl(
	  $scope,
	  $rootScope,
	  $controller,
	  $stateParams,
	  $state,
	  $translate,
	  publication,
	  taskTypes,
	  data,
	  CompanyUserService,
	  CompanyTaskService,
	  growl) {
	
	  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));
	
	  $scope.publication = publication;
	  $scope.taskTypes = taskTypes;
	  
	  function checkDueAt() {
	    if($scope.task.dueAt < $scope.task.startAt) {
	      $scope.task.dueAt = new Date($scope.task.startAt.getTime());
	      $scope.task.dueAt.setHours($scope.task.dueAt.getHours() + 1);
	    }
	  }
	
	  var nextDate = new Date();
	      nextDate.setHours(nextDate.getHours() + 1);
	
	  var DEFAULT_TASK = {
	    startAt:    new Date(),
	    dueAt:      nextDate,
	    assignees:  [],
	    public:     true,
	    wholeDay:   false,
	    importance: 'NORMAL',
	    type: taskTypes.length ? taskTypes[0] : null,
	    createdBy: $scope.currentUser
	  };
	  
	  if(typeof data === "object") {
	    if(data.startAt) {
	      DEFAULT_TASK.startAt = new Date(data.startAt);
	    }
	    if(data.dueAt) {
	      DEFAULT_TASK.dueAt = new Date(data.dueAt);
	    }
	    if(data.wholeDay) {
	      DEFAULT_TASK.wholeDay = !!data.wholeDay;
	    }
	  }
	
	  if ($stateParams.customerId) {
	    DEFAULT_TASK.connectedCustomer = {
	      id: $stateParams.customerId
	    };
	  }
	
	  DEFAULT_TASK.assignees.push({
	    id:    $scope.currentUser.id,
	    name:  $scope.currentUser.name,
	    email: $scope.currentUser.email
	  });
	
	  $scope.task = new CompanyTaskService(angular.copy(DEFAULT_TASK));
	  if ($scope.task.repeatEnd) {
	    $scope.task.repeatEnd = new Date($scope.task.repeatEnd);
	  }
	
	  $scope.$watch("[task.dueAt, task.startAt]", function(newValue, oldValue) {
	    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
	       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
	      checkDueAt();
	    }
	  }, true);
	  
	  if(false !== $scope.publication) {
	    $scope.task.publication = $scope.publication;
	  }
	
	  CompanyUserService.query({companyId: $stateParams.companyId, type: 'DEFAULT'}).$promise.then(function(users){
	      return users.filter(function(item){
	        return item.id !== $scope.currentUser.id;
	      });
	  }).then(function(users) {
	    $scope.users = users;
	  });
	
	  $scope.saveTask = function() {
	    $scope.task.$save({companyId: $stateParams.companyId}, function(resp){
	      growl.addSuccessMessage($translate.instant('task.update-success'));
	      if ($state.current.name === 'root.company.calendar') {
	        $rootScope.$emit('taskCreated', resp);
	      } else if($state.current.name === 'root.company.tasks') {
	        $state.reload();
	      }
	    }, function(){
	      growl.addErrorMessage($translate.instant('task.update-failure'));
	    });
	  };
	
	  $scope.addAssignee = function(assignee) {
	    $scope.task.assignees.push(assignee);
	    angular.element('#filterAssignees').val('');
	  };
	
	  $scope.addedAssignees = function(assignee) {
	    return ($scope.task.assignees.indexOf(assignee) === -1);
	  };
	
	}
	
	angular.module('dokiv')
	  .controller('CompanyTaskNewCtrl', CompanyTaskNewCtrl);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(16);
	
	TaskQueryUserDirective.$inject = ['CompanyUserService', '$stateParams'];
	function TaskQueryUserDirective(CompanyUserService, $stateParams) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    replace: true,
	    scope: {
	      saveTask: "&",
	      editDisabled: "="
	    },
	    link: function(scope, elem, attrs, ngModel) {
	      ngModel.$render = function() {
	        scope.items = ngModel.$modelValue;
	      };
	
	      scope.updateNonAssignees = function(filter) {
	        CompanyUserService.query({companyId: $stateParams.companyId, q: filter, type: 'DEFAULT', limit: 6}).$promise.then(function(users) {
	          if (attrs.type && attrs.type === 'assignee') {
	            return users.filter(function(item) {
	              return !scope.items.some(function(assignee) {
	                return item.id === assignee.id;
	              });
	            });
	          }
	          return users.filter(function(item) {
	            if (scope.items === null || typeof scope.items === 'undefined') {
	              return true;
	            } else {
	              return item.id !== scope.items.id;
	            }
	          });
	          
	        }).then(function(nonAssignees) {
	          scope.nonAssignees = nonAssignees;
	        });
	      };
	
	      scope.addAssignees = function(assignee) {
	        if (attrs.type && attrs.type === 'assignee') {
	          scope.items.push(assignee);
	        } else {
	          scope.items = assignee;
	        }
	        ngModel.$setViewValue(scope.items);
	        if (typeof scope.saveTask === 'function') {
	          scope.saveTask();
	        }
	        scope.nonAssignees.splice(scope.nonAssignees.indexOf(assignee), 1);
	        if (attrs.type && attrs.type === 'assignee') {
	          angular.element('#filterAssignees').val('');
	        } else {
	          angular.element('#filterManager').val('');
	        }
	      };
	
	      scope.removeAssignee = function(assignee) {
	        if (attrs.type && attrs.type === 'assignee') {
	          scope.items.splice(scope.items.indexOf(assignee), 1);
	        } else {
	          scope.items = null;
	        }
	        ngModel.$setViewValue(scope.items);
	        if (typeof scope.saveTask === 'function') {
	          scope.saveTask();
	        }
	      };
	    },
	    templateUrl: function (element, attrs) {
	      if (attrs.type && attrs.type === 'assignee') {
	          return 'partials/company/tasks/assignees-directive.html';
	      } else {
	        return 'partials/company/tasks/manager-directive.html';
	      }
	    }
	  };
	}
	
	angular.module("dokiv")
	  .directive("taskQueryUser", TaskQueryUserDirective);
	
	TaskQueryCustomerDirective.$inject = ['CompanyCustomersService', '$stateParams'];
	function TaskQueryCustomerDirective(CompanyCustomersService, $stateParams) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    scope: {
	      saveTask: "&"
	    },
	    replace: true,
	    link: function(scope, elem, attrs, ngModel) {
	      ngModel.$render = function() {
	        scope.currentCustomer = ngModel.$modelValue;
	      };
	
	      scope.queryCustomers = function(query) {
	        return CompanyCustomersService.query({
	          companyId: $stateParams.companyId,
	          q: query,
	          limit: 10
	        }).$promise.then(function(customers) {
	          if (scope.currentCustomer) {
	            return customers.filter(function(c) {
	              return c.id !== scope.currentCustomer.id;
	            }); 
	          }
	          return customers;
	          
	        });
	      };
	
	      scope.addConnectedCustomer = function(c) {
	        scope.currentCustomer = angular.copy(c);
	        ngModel.$setViewValue(c);
	        if (typeof scope.saveTask === 'function') {
	          scope.saveTask();
	        }
	      };
	    },
	    templateUrl: 'partials/company/tasks/connected-customer-directive.html'
	  };
	}
	
	angular.module("dokiv")
	    .directive("taskQueryCustomer", TaskQueryCustomerDirective);
	
	CompanyTasksCtrl.$inject = ['$scope'];
	function CompanyTasksCtrl($scope) {
	  $scope.onSelectEvent = function(task) {
	    $scope.showTaskDetailModal(task);
	  };
	
	  $scope.expiredColor = "#f26a5d";
	  $scope.importanceColors = [
	    {
	      'type': 'LOW',
	      'color': '#27b96b'
	    },
	    {
	      'type': 'NORMAL',
	      'color': '#27c2eb'
	    },
	    {
	      'type': 'HIGH',
	      'color': '#f29a25'
	    }
	  ];
	
	  $scope.visibilityColors = [
	    {
	      'public': true,
	      'color': '#23a45f'
	    },
	    {
	      'public': false,
	      'color': '#27c2eb'
	    },
	  ];
	}
	
	
	angular.module('dokiv')
	  .controller('CompanyTasksCtrl', CompanyTasksCtrl);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(44);
	
	CompanyCustomerTimestampsHistoryCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  'CompanyTimestampsService',
	  'service'];
	function CompanyCustomerTimestampsHistoryCtrl(
	  $scope,
	  $stateParams,
	  CompanyTimestampsService,
	  service) {
	
	    $scope.timestamps = service.timestamps;
	    $scope.more = false;
	    $scope.page = 0;
	    
	    if($scope.timestamps.length > 20) {
	      $scope.more = true;
	    }
	
	    $scope.getTimestampHistory = function(page){
	      CompanyTimestampsService.query({
	        companyId: $stateParams.companyId,
	        objectId: service.id,
	        limit: 21,
	        offset: page * 20
	      }, function(resp){
	        $scope.timestamps = resp;
	        if($scope.timestamps.length > 20) {
	          $scope.more = true;
	          if(page !== 0){
	            $scope.timestamps.pop();
	          }
	        }else{
	          $scope.more = false;
	        }
	        $scope.page = page;
	      });
	    };
	}
	
	module.exports = CompanyCustomerTimestampsHistoryCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyCustomerTimestampsHistoryCtrl', CompanyCustomerTimestampsHistoryCtrl);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(44);
	
	function dateIsEqual(a, b) {
	  if(a instanceof Date && b instanceof Date) {
	    return a.getTime() === b.getTime();
	  }
	
	  return false;
	}
	
	CompanyTimestampDetailCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$state',
	  '$filter',
	  'info',
	  'CompanyTimestampsService',
	  'CompanyUserService',
	  'CompanyCustomersService',
	  'CompanyCustomerService',
	  'CompanyCustomerServiceService',
	  '$translate',
	  'timestamps',
	  'growl'];
	
	function CompanyTimestampDetailCtrl(
	  $scope,
	  $stateParams,
	  $state,
	  $filter,
	  info,
	  CompanyTimestampsService,
	  CompanyUserService,
	  CompanyCustomersService,
	  CompanyCustomerService,
	  CompanyCustomerServiceService,
	  $translate,
	  timestamps,
	  growl) {
	  $scope.timestamps = timestamps;
	  $scope.users = [];
	  $scope.info = info;
	
	  $scope.filterCustomer = '';
	  $scope.startAt = '';
	  $scope.endedAt = '';
	  $scope.reportTime = {
	    objectType: 'CUSTOMER_SERVICE',
	    status: 'APPROVED',
	    isWorkTime: false,
	    isTimeBack: false,
	    endedByClock: false
	  };
	
	  $scope.reportPage = 0;
	  $scope.filterReport = {
	    companyId: $stateParams.companyId,
	    userId: null,
	    isWorkTime: false,
	    endedByClock: false,
	    startTime: null,
	    endTime: null,
	    limit: 21,
	    offset: 0
	  };
	  $scope.filterTime = {
	    startTime: null,
	    endTime: null
	  };
	  
	  $scope.tabs = [];
	
	  if($scope.currentUserPermissions.TimestampHistory){
	    $scope.tabs.push({
	      'title': 'timestamp.active-timestamp',
	      'template': 'partials/company/timestamps/active-timestamp.html'
	    });
	  }
	  if($scope.currentUserPermissions.ManualReport){
	    $scope.tabs.push({
	      'title': 'timestamp.manual-report',
	      'template': 'partials/company/timestamps/manual-report.html'
	    });
	  }
	  $scope.tabs.push({
	    'title': 'form.report',
	    'template': 'partials/company/timestamps/report.html'
	  });
	  $scope.tabs.push({
	    'title': 'settings.settings',
	    'template': 'partials/company/timestamps/settings.html'
	  });
	
	  $scope.activeTab = 0;
	  if($stateParams.manual){
	    $scope.activeTab = 1;
	  }
	
	  $scope.endTimestamp = function(timestamp){
	    CompanyTimestampsService.update({
	      companyId: $stateParams.companyId,
	      timestampId: timestamp.id
	    }, {}, function(){
	      growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-success'));
	      $scope.timestamps.splice($scope.timestamps.indexOf(timestamp), 1);
	    }, function(){
	      growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-failure'));
	    });
	  };
	
	  $scope.checkTypeTimeTrack = function(track){
	    if(!$scope.info.extra.timestamp){
	      $scope.info.extra.timestamp = {typeTimeTrack: []};
	    }else{
	      if(!$scope.info.extra.timestamp.typeTimeTrack){
	        $scope.info.extra.timestamp.typeTimeTrack = [];
	      }
	    }
	    var index = $scope.info.extra.timestamp.typeTimeTrack.indexOf(track);
	    if(index > -1){
	      $scope.info.extra.timestamp.typeTimeTrack.splice(index, 1);
	    }else{
	      $scope.info.extra.timestamp.typeTimeTrack.push(track);
	    }
	  };
	
	  $scope.searchUsers = function(filter) {
	    CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(users) {
	      $scope.users = users;
	    });
	  };
	
	  $scope.searchCustomers = function(filter) {
	    CompanyCustomersService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(customers) {
	      $scope.customers = customers;
	    });
	  };
	
	  $scope.searchServices = function(customer) {
	    CompanyCustomerService.query({companyId: $scope.companyId, customerId: customer.id, limit: 50}).$promise.then(function(services) {
	      $scope.services = services;
	      $scope.reportTime.object = services[0];
	    });
	  };
	
	  $scope.setCustomerServiceTimestamp = function(workdate, hourStartAt, minuteStartAt, hourEndedAt, minuteEndedAt){
	    var workdateR = new Date(workdate);
	    $scope.reportTime.startAt = new Date(workdateR.getFullYear() + '-' + (workdateR.getMonth()+1) + '-' + workdateR.getDate() + ' ' + hourStartAt + ':' + minuteStartAt + ':00');
	    $scope.reportTime.endedAt = new Date(workdateR.getFullYear() + '-' + (workdateR.getMonth()+1) + '-' + workdateR.getDate() + ' ' + hourEndedAt + ':' + minuteEndedAt + ':00');
	    if($scope.reportTime.isWorkTime){
	      $scope.reportTime.object = null;
	    }
	    CompanyTimestampsService.save({
	      companyId: $stateParams.companyId
	    }, $scope.reportTime, function(){
	      growl.addSuccessMessage($translate.instant('timestamp.started-timestamp-success'));
	      $scope.reportTime = {
	        objectType: 'CUSTOMER_SERVICE',
	        status: 'APPROVED',
	        isWorkTime: false,
	        isTimeBack: false,
	        endedByClock: false
	      };
	      $scope.services = [];
	    }, function(err){
	      if(err.status === 400){
	        growl.addErrorMessage(err.data);
	      }
	      if(err.status === 403){
	        growl.addErrorMessage(err.data.error.message);
	      }
	    });
	  };
	
	  $scope.$watch("[filterTime.startTime, filterTime.endTime]", function(newValue, oldValue) {
	    if($scope.filterTime.startTime !== null){
	      $scope.filterTime.startTime = new Date($scope.filterTime.startTime);
	    }
	    if($scope.filterTime.endTime !== null){
	      $scope.filterTime.endTime = new Date($scope.filterTime.endTime);
	    }
	    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])) {
	      if($scope.filterTime.endTime !== null && $scope.filterTime.startTime >= $scope.filterTime.endTime){
	        $scope.filterTime.endTime = $scope.filterTime.startTime;
	      }
	    }
	    if(newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])){
	      if($scope.filterTime.startTime !== null && $scope.filterTime.startTime >= $scope.filterTime.endTime){
	        $scope.filterTime.startTime = $scope.filterTime.endTime;
	      }
	    }
	  }, true);
	
	  $scope.showReport = function(reportPage){
	    if($scope.filterTime.startTime !== null){
	      $scope.filterReport.startTime = $filter('date')($scope.filterTime.startTime, "yyyy-MM-dd");
	    }
	    if($scope.filterTime.endTime !== null){
	      $scope.filterReport.endTime = $filter('date')($scope.filterTime.endTime, "yyyy-MM-dd");
	    }
	    $scope.reportPage = reportPage;
	    $scope.filterReport.offset = reportPage * 20;
	    if($scope.filterReport.isWorkTime){ 
	      $scope.filterReport.objectId = null;
	      CompanyTimestampsService.queryWorkTime($scope.filterReport).$promise.then(function(reportTimes) {
	        $scope.reportTimes = reportTimes;
	        if(reportTimes.length > 20){
	          $scope.reportMore = true;
	          $scope.reportTimes.pop();
	        }else{
	          $scope.reportMore = false;
	        }
	      });
	    }else{
	      CompanyTimestampsService.query($scope.filterReport).$promise.then(function(reportTimes) {
	        $scope.reportTimes = reportTimes;
	        if(reportTimes.length > 20){
	          $scope.reportMore = true;
	          $scope.reportTimes.pop();
	        }else{
	          $scope.reportMore = false;
	        }
	      });
	    }
	  };
	
	  $scope.clearAll = function(){
	    $scope.filterReport = {
	      companyId: $stateParams.companyId,
	      userId: null,
	      isWorkTime: false,
	      endedByClock: false,
	      startTime: null,
	      endTime: null,
	      limit: 21,
	      offset: 0
	    };
	    $scope.filterTime = {
	      startTime: null,
	      endTime: null
	    };
	    $scope.customers = [];
	    $scope.services = [];
	    $scope.reportTimes = [];
	    $scope.reportPage = 0;
	    $scope.reportMore = false;
	    angular.element('.filterTime').val('');
	  };
	}
	
	CompanyTimestampDetailCtrl.resolve = {
	  timestamps: ['$stateParams', 'CompanyTimestampsService', function($stateParams, CompanyTimestampsService) {
	    return CompanyTimestampsService.query({
	      companyId: $stateParams.companyId,
	      status: 'IN_PROGRESS',
	      limit: 21,
	      offset: 0}).$promise;
	  }]
	};
	
	module.exports  = CompanyTimestampDetailCtrl;
	
	angular.module("dokiv")
	  .controller("CompanyTimestampDetailCtrl", CompanyTimestampDetailCtrl);


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	"use strict";
	
	AddGroupToLinkDirective.$inject = ['CompanyGroupService', '$stateParams'];
	function AddGroupToLinkDirective(CompanyGroupService, $stateParams) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope:  {
	      "roleLink": "="
	    },
	    templateUrl:'partials/company/user-roles/link-permission.html',
	    link: function(scope, element) {
	      if (!scope.roleLink.groups) {
	        scope.roleLink.groups = [];
	      }
	      scope.queryGroups = function(filter) {
	        CompanyGroupService.query({companyId: $stateParams.companyId, q: filter, limit: 6, type: null}).$promise.then(function(groups) {
	          scope.searchResult = groups.filter(function(g) {
	            return !scope.roleLink.groups.some(function(g1) {
	              return g1.id === g.id;
	            });
	          });
	        });
	      };
	
	      scope.add = function(group, index) {
	        scope.roleLink.groups.push({id: group.id, name: group.name});
	        scope.searchResult.splice(index, 1);
	        angular.element(element).find('input').val('');
	      };
	
	      scope.remove = function(index) {
	        scope.roleLink.groups.splice(index, 1);
	      };
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('addGroupToLink', AddGroupToLinkDirective);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(11);
	__webpack_require__(424);
	
	CompanyUserRoleCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$q',
	  'CompanyUserService'
	];
	
	function CompanyUserRoleCtrl(
	  $scope,
	  $stateParams,
	  $q,
	  CompanyUserService
	) {
	
	  $scope.templates = [{
	    label: 'user-role.template-one',
	    value: '1'
	  }, {
	    label: 'user-role.template-two',
	    value: '2'
	  }, {
	    label: 'user-role.template-three',
	    value: '5'
	  }, {
	    label: 'user-role.template-four',
	    value: '6'
	  }];
	
	  $scope.addLink = function(userRole, isMenu) {
	    if (isMenu) {
	      userRole.menus.push({
	        id: userRole.menus.length + 1,
	        text: "",
	        link: "#",
	        parentId: null
	      });
	    } else {
	      userRole.links.push({
	        text: "",
	        link: ""
	      });
	    }
	  };
	
	  $scope.removeLink = function(userRole, index, isMenu) {
	    if (isMenu) {
	      $scope.checkMenu(index, userRole).then(function(){
	        userRole.menus.splice(index, 1);
	      });
	
	    } else {
	      userRole.links.splice(index, 1);
	    }
	  };
	
	  $scope.checkMenu = function(index, userRole) {
	    var deferred = $q.defer();
	    if (angular.isUndefined(userRole.menus[index].parentId) || userRole.menus[index].parentId === null) {
	      userRole.menus = userRole.menus.map(function(r){
	        if (r.parentId === userRole.menus[index].id) {
	          r.parentId = null;
	        }
	        return r;
	      });
	    }
	    deferred.resolve();
	    return deferred.promise;
	  };
	
	  $scope.queryUsers = function(text, users) {
	    return CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      email: text,
	      limit: 10
	    }).$promise.then(function(resp) {
	      return resp.filter(function(u) {
	        return !users.some(function(user) {
	          return user.id === u.id;
	        });
	      });
	    });
	  };
	}
	
	CompanyUserRoleCtrl.resolve = {
	};
	
	module.exports = CompanyUserRoleCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyUserRoleCtrl', CompanyUserRoleCtrl);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(17);
	__webpack_require__(11);
	// require("./CompanyEditTextBoxCtrl.js");
	
	CompanyUserRoleEditCtrl.$inject = [
	  "$scope",
	  "$rootScope",
	  "$state",
	  "$q",
	  "$filter",
	  "$modal",
	  "$window",
	  "$stateParams",
	  "$translate",
	  "CompanyUserRoleService",
	  "CompanyUserService",
	  "CompanyPublicationService",
	  "CompanyMessageService",
	  "CompanyCommentsService",
	  "CompanyTaskService",
	  "role",
	  "members",
	  "config",
	  "UploadTracker",
	  "uiSortableMultiSelectionMethods",
	  "growl",
	  "userRoles",
	];
	
	function CompanyUserRoleEditCtrl(
	  $scope,
	  $rootScope,
	  $state,
	  $q,
	  $filter,
	  $modal,
	  $window,
	  $stateParams,
	  $translate,
	  CompanyUserRoleService,
	  CompanyUserService,
	  CompanyPublicationService,
	  CompanyMessageService,
	  CompanyCommentsService,
	  CompanyTaskService,
	  role,
	  members,
	  config,
	  uploadTracker,
	  uiSortableMultiSelectionMethods,
	  growl,
	  userRoles
	) {
	  $scope.role = role;
	  $scope.companyId = $stateParams.companyId;
	  $scope.search = "";
	
	  function getNestedChildren(menu, parent) {
	    var arr = menu;
	    var out = [];
	    for (var i in arr) {
	      if (arr[i].parentId === parent) {
	        var children = getNestedChildren(arr, arr[i].id);
	        if (children.length) {
	          arr[i].children = children;
	        }
	        out.push(arr[i]);
	      }
	    }
	    return sortMenu(out);
	  }
	
	  function sortMenu(menu) {
	    menu.sort(function(a, b) {
	      if (a.order === b.order) {
	        return 0;
	      } else if (a.order === 0) {
	        return 1;
	      } else if (b.order === 0) {
	        return -1;
	      }
	      return a.order < b.order ? -1 : 1;
	    });
	
	    menu.forEach(function(v, i) {
	      if (v.children && v.children.length > 1) {
	        v.children.sort(function(a, b) {
	          if (a.order === b.order) {
	            return 0;
	          } else if (a.order === 0) {
	            return 1;
	          } else if (b.order === 0) {
	            return -1;
	          }
	          return a.order < b.order ? -1 : 1;
	        });
	      }
	    });
	
	    return menu;
	  }
	
	  $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	  $scope.$on(
	    "menuChange",
	    function(e, data) {
	      delete data.children;
	      var index = $scope.role.menus.findIndex(function(m) {
	        return data.id === m.id;
	      });
	      if (index > -1) {
	        var oldMenu = JSON.parse(JSON.stringify($scope.role.menus[index]));
	        $scope.role.menus[index] = data;
	        if (oldMenu.parentId !== data.parentId) {
	          $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	        }
	      }
	    },
	    true
	  );
	
	  $scope.addMenu = function() {
	    $scope.role.menus.push({
	      id:
	        $scope.role.menus.length > 0
	          ? Math.max.apply(
	              Math,
	              $scope.role.menus.map(function(o) {
	                return o.id + 1;
	              })
	            )
	          : 1,
	      text: "",
	      link: "#",
	      parentId: null,
	      order: 0,
	    });
	    $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	  };
	
	  $scope.toggleMenu = function(menu) {
	    // var $parent = jQuery("#" + id).parent();
	    // if ($parent.hasClass("show-child")) {
	    //   $parent.removeClass("show-child");
	    //   $parent.find(".user-role__main-toggle > i").removeClass("fa-compress");
	    //   $parent.find(".user-role__main-toggle > i").addClass("fa-expand");
	    // } else {
	    //   $parent.find(".user-role__main-toggle > i").removeClass("fa-expand");
	    //   $parent.find(".user-role__main-toggle > i").addClass("fa-compress");
	    //   $parent.addClass("show-child");
	    // }
	    $scope.role.menus = $scope.role.menus.map(function(v, i) {
	      if (v.id === menu.id) {
	        v.show = !v.show;
	      }
	      return v;
	    });
	     $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	
	  };
	
	  $scope.remove = function(item) {
	    $scope.role.menus = $scope.role.menus.filter(function(v, i) {
	      return v.id !== item.id;
	    });
	    $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	  };
	
	  $scope.$on("removeMenuItem", function(event, item) {
	    $scope.remove(item);
	  });
	
	  $rootScope.$emit("currentUserRole", $scope.role.id);
	  if ($scope.role.template !== null && !$scope.role.template.data) {
	    $scope.role.template.data = [];
	  }
	
	  $scope.userRoles = userRoles.filter(function(item) {
	    return (
	      item.id !== role.id &&
	      (item.template.id === "1" ||
	        item.template.id === "2" ||
	        item.template.id === "5" ||
	        item.template.id === "6")
	    );
	  });
	
	  // function getBlogLastest(data) {
	  //   if (
	  //     data.columnType === "BLOG" &&
	  //     (data.columnData.object || data.columnData.blogId)
	  //   ) {
	  //     CompanyPublicationService.getPostLastest(
	  //       {
	  //         companyId: $stateParams.companyId,
	  //         publicationId: data.columnData.object
	  //           ? data.columnData.object.id
	  //           : data.columnData.blogId,
	  //         only: data.columnData.only,
	  //         limit: data.columnData.showThreePosts ? 3 : 1,
	  //       },
	  //       function(resp) {
	  //         $scope.role.template.data[
	  //           $scope.role.template.data.indexOf(data)
	  //         ].blogLastest = resp;
	  //       }
	  //     );
	  //   }
	  // }
	  // setTimeout(function() {
	  //   var options = {
	  //     alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
	  //       navigator.userAgent
	  //     ),
	  //     disableOneColumnMode: true,
	  //   };
	  //   jQuery(".grid-stack").gridstack(options);
	  //   jQuery(".grid-stack").on("dragstop", function() {
	  //     setTimeout(function() {
	  //       jQuery(".grid-stack-item.ui-draggable").each(function() {
	  //         var item = jQuery(this);
	  //         var index = item.attr("index");
	  //         $scope.role.template.data[index].chartData.gsX = item.attr(
	  //           "data-gs-x"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsY = item.attr(
	  //           "data-gs-y"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsWidth = item.attr(
	  //           "data-gs-width"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsHeigth = item.attr(
	  //           "data-gs-height"
	  //         );
	  //       });
	  //     }, 1000);
	  //   });
	  //   jQuery(".grid-stack").on("resizestop", function() {
	  //     setTimeout(function() {
	  //       jQuery(".grid-stack-item.ui-draggable").each(function() {
	  //         var item = jQuery(this);
	  //         var index = item.attr("index");
	  //         $scope.role.template.data[index].chartData.gsX = item.attr(
	  //           "data-gs-x"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsY = item.attr(
	  //           "data-gs-y"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsWidth = item.attr(
	  //           "data-gs-width"
	  //         );
	  //         $scope.role.template.data[index].chartData.gsHeigth = item.attr(
	  //           "data-gs-height"
	  //         );
	  //       });
	  //     }, 1000);
	  //   });
	  // }, 10);
	
	  // angular.element($window).on("resize", function() {
	  //   var widthWindowH = angular.element($window).width();
	  //   var grid = jQuery(".grid-stack").data("gridstack");
	  //   if (widthWindowH < 1016 && widthWindowH > 825) {
	  //     angular.forEach($scope.role.template.data, function(value, key) {
	  //       grid.update(
	  //         jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
	  //         value.chartData.gsX === "0" ? 0 : 6,
	  //         value.chartData.gsY,
	  //         6,
	  //         value.chartData.gsHeigth
	  //       );
	  //     });
	  //   } else {
	  //     if (widthWindowH >= 1016) {
	  //       angular.forEach($scope.role.template.data, function(value, key) {
	  //         grid.update(
	  //           jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
	  //           parseInt(value.chartData.gsX),
	  //           parseInt(value.chartData.gsY),
	  //           parseInt(value.chartData.gsWidth),
	  //           parseInt(value.chartData.gsHeigth)
	  //         );
	  //       });
	  //     } else {
	  //       angular.forEach($scope.role.template.data, function(value, key) {
	  //         grid.update(
	  //           jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
	  //           0,
	  //           parseInt(value.chartData.gsY),
	  //           12,
	  //           parseInt(value.chartData.gsHeigth)
	  //         );
	  //       });
	  //     }
	  //   }
	  // });
	
	  // $scope.chartTypeList = [
	  //   {
	  //     value: "doughnut",
	  //     name: "Chart Doughnut",
	  //   },
	  //   {
	  //     value: "pie",
	  //     name: "Chart Pie",
	  //   },
	  //   {
	  //     value: "bar",
	  //     name: "Chart Bar",
	  //   },
	  //   {
	  //     value: "line-bar",
	  //     name: "Chart Line & Bar",
	  //   },
	  //   {
	  //     value: "line",
	  //     name: "Chart Line",
	  //   },
	  //   {
	  //     value: "horizontal-bar",
	  //     name: "Chart H Bar",
	  //   },
	  // ];
	
	  // if ($scope.role.template !== null) {
	  //   var templateData = [];
	  //   var yMax = 0;
	  //   var heigthMax = 4;
	  //   angular.forEach(role.template.data, function(value, key) {
	  //     if ($scope.userRoles.length > 0) {
	  //       var userRoleParams = $scope.userRoles.filter(function(item) {
	  //         return item.id === value.reference.userRoleID;
	  //       })[0];
	  //       value.userRoleCurrent = userRoleParams
	  //         ? userRoleParams
	  //         : $scope.userRoles[0];
	  //       value.reference.userRoleID = value.userRoleCurrent.id;
	  //       value.referenceCentralInformation = value.userRoleCurrent.template.data
	  //         ? value.userRoleCurrent.template.data.filter(function(item) {
	  //             return item.centralInformation === false;
	  //           })
	  //         : [];
	  //       var textBoxParams = value.referenceCentralInformation.filter(function(
	  //         item
	  //       ) {
	  //         return item.id === value.reference.boxID;
	  //       })[0];
	  //       value.reference.boxID = textBoxParams
	  //         ? textBoxParams.id
	  //         : value.referenceCentralInformation.length > 0
	  //         ? value.referenceCentralInformation[0].id
	  //         : value.reference.boxID;
	  //       value.currentIndex = textBoxParams
	  //         ? value.userRoleCurrent.template.data.indexOf(textBoxParams) + 1
	  //         : value.referenceCentralInformation.length > 0
	  //         ? value.userRoleCurrent.template.data.indexOf(
	  //             value.referenceCentralInformation[0]
	  //           ) + 1
	  //         : 0;
	  //     }
	  //     value.chartData = value.chartData ? value.chartData : {};
	  //     value.chartData.gsX = angular.isDefined(value.chartData.gsX)
	  //       ? value.chartData.gsX
	  //       : key % 3 === 0
	  //       ? 0
	  //       : key % 3 === 1
	  //       ? 4
	  //       : 8;
	  //     value.chartData.gsY = angular.isDefined(value.chartData.gsY)
	  //       ? value.chartData.gsY
	  //       : 0;
	  //     value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth)
	  //       ? value.chartData.gsWidth
	  //       : 4;
	  //     value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth)
	  //       ? value.chartData.gsHeigth
	  //       : 7;
	  //     if (!value.isChart && value.columnType === "BLOG") {
	  //       getBlogLastest(value);
	  //     }
	  //     templateData.push(value);
	  //     if (parseInt(value.chartData.gsY) > yMax) {
	  //       yMax = parseInt(value.chartData.gsY);
	  //       heigthMax = parseInt(value.chartData.gsHeigth);
	  //     }
	  //   });
	  //   $scope.role.template.data = templateData;
	
	  //   angular.element($window).on("scroll", function() {
	  //     if (angular.element($window).scrollTop() >= 80) {
	  //       angular
	  //         .element(".templates__dashboard-settings")
	  //         .addClass("setting-scroll");
	  //     } else {
	  //       angular
	  //         .element(".templates__dashboard-settings")
	  //         .removeClass("setting-scroll");
	  //     }
	  //   });
	
	    function checkPermissionGroup(group) {
	      if (!group) {
	        group = [];
	      }
	      if (group.length === 0) {
	        return true;
	      }
	
	      var matched = false;
	      angular.forEach(group, function(val) {
	        if (!matched) {
	          matched = $scope.customerPortals.some(function(g) {
	            return g.id === val.id;
	          });
	        }
	      });
	      return matched;
	    }
	
	    if ($scope.role && $scope.role.template !== null) {
	      angular.forEach($scope.role.links, function(v) {
	        v.show = true;
	        if (v.link.indexOf(config.appBase) !== -1) {
	          if (!angular.isArray(v.groups)) {
	            v.group = [];
	          }
	          var fullUserUrlRegex = /companies\/(.*)/i;
	          if (
	            !fullUserUrlRegex.test(v.link) ||
	            !checkPermissionGroup(v.groups)
	          ) {
	            v.show = false;
	          }
	        }
	      });
	    }
	
	    if ($scope.role.template !== null) {
	      $scope.userLinks = angular.isDefined($scope.userInfo.features.userLinks)
	        ? $scope.userInfo.features.userLinks
	        : [];
	    }
	
	    // function removeBulkColumn(data) {
	    //   $scope.role.template.data.splice(
	    //     $scope.role.template.data.indexOf(data),
	    //     1
	    //   );
	    //   $scope.save();
	    // }
	
	    // var angularModal;
	    // $scope.showModalDeleteTextBox = function(data) {
	    //   angularModal = $modal({
	    //     scope: $scope,
	    //     prefixEvent: "modalTextBox",
	    //     controller: [
	    //       "$scope",
	    //       function($scope) {
	    //         $scope.confirmName = $translate.instant("user-role.confirm-delete");
	    //         $scope.activeDelete = function() {
	    //           removeBulkColumn(data);
	    //         };
	    //       },
	    //     ],
	    //     templateUrl:
	    //       "partials/company/publications/detail/latest/confirm-delete.html",
	    //     show: true,
	    //   });
	    // };
	
	    // $scope.$on("modalTextBox.hide", function() {
	    //   angularModal.destroy();
	    //   angularModal = null;
	    // });
	
	    var lastTemplateData = angular.copy(role);
	    // $scope.posts = [];
	    // $scope.comments = [];
	    // $scope.latestTasks = [];
	
	    // if (
	    //   $scope.role.template &&
	    //   ($scope.role.template.id === "1" ||
	    //     $scope.role.template.id === "2" ||
	    //     $scope.role.template.id === "5" ||
	    //     $scope.role.template.id === "6")
	    // ) {
	    //   var boxMessage = $scope.role.template.data.filter(function(d) {
	    //     return d.columnType === "MESSAGE";
	    //   });
	    //   if ($scope.info.features.blogs && $scope.role.showMessage) {
	    //     CompanyMessageService.query(
	    //       {
	    //         companyId: $stateParams.companyId,
	    //         limit: 4,
	    //         showInList: false,
	    //       },
	    //       function(resp) {
	    //         $scope.posts = resp;
	    //         if (!boxMessage[0]) {
	    //           if ($scope.posts.length > 0) {
	    //             $scope.role.template.data.push({
	    //               isChart: false,
	    //               centralInformation: false,
	    //               columnType: "MESSAGE",
	    //               isFullBox: false,
	    //               chartData: {
	    //                 gsX: 0,
	    //                 gsY: yMax + heigthMax,
	    //                 gsWidth: 4,
	    //                 gsHeigth: 4,
	    //               },
	    //             });
	    //           }
	    //         } else {
	    //           if ($scope.posts.length === 0) {
	    //             $scope.role.template.data.splice(
	    //               $scope.role.template.data.indexOf(boxMessage[0]),
	    //               1
	    //             );
	    //           }
	    //         }
	    //       },
	    //       function() {
	    //         if (boxMessage[0]) {
	    //           $scope.role.template.data.splice(
	    //             $scope.role.template.data.indexOf(boxMessage[0]),
	    //             1
	    //           );
	    //         }
	    //       }
	    //     );
	    //   } else {
	    //     if (boxMessage[0]) {
	    //       $scope.role.template.data.splice(
	    //         $scope.role.template.data.indexOf(boxMessage[0]),
	    //         1
	    //       );
	    //     }
	    //   }
	
	    //   var boxComment = $scope.role.template.data.filter(function(d) {
	    //     return d.columnType === "COMMENT";
	    //   });
	    //   if ($scope.role.showComment) {
	    //     CompanyCommentsService.queryComments(
	    //       {
	    //         companyId: $stateParams.companyId,
	    //         limit: 4,
	    //       },
	    //       function(resp) {
	    //         $scope.comments = resp;
	    //         if (!boxComment[0]) {
	    //           if ($scope.comments.length > 0) {
	    //             $scope.role.template.data.push({
	    //               isChart: false,
	    //               centralInformation: false,
	    //               columnType: "COMMENT",
	    //               isFullBox: false,
	    //               chartData: {
	    //                 gsX: 0,
	    //                 gsY: yMax + heigthMax,
	    //                 gsWidth: 4,
	    //                 gsHeigth: 4,
	    //               },
	    //             });
	    //           }
	    //         } else {
	    //           if ($scope.comments.length === 0) {
	    //             $scope.role.template.data.splice(
	    //               $scope.role.template.data.indexOf(boxComment[0]),
	    //               1
	    //             );
	    //           }
	    //         }
	    //       },
	    //       function() {
	    //         if (boxComment[0]) {
	    //           $scope.role.template.data.splice(
	    //             $scope.role.template.data.indexOf(boxComment[0]),
	    //             1
	    //           );
	    //         }
	    //       }
	    //     );
	
	    //     $scope.$on("notification", function(e, data) {
	    //       if (data.type === "COMMENT") {
	    //         var c = {
	    //           id: data.message.id,
	    //           text: data.message.text,
	    //           createdAt: new Date().toISOString(),
	    //           createdBy: data.sourceUser,
	    //           objectRelative: data.publication,
	    //         };
	    //         $scope.$apply(function() {
	    //           if (data.message.parentID === "undefined") {
	    //             if ($scope.comments.length === 4) {
	    //               $scope.comments.splice($scope.comments.length - 1, 1);
	    //             }
	    //             $scope.comments.unshift(c);
	    //           } else {
	    //             angular.forEach($scope.comments, function(item) {
	    //               if (item.id === data.message.parentID) {
	    //                 if (!item.commentChild) {
	    //                   item.commentChild = [];
	    //                 }
	    //                 item.commentChild.push(c);
	    //               }
	    //             });
	    //           }
	    //         });
	    //       }
	    //     });
	    //   } else {
	    //     if (boxComment[0]) {
	    //       $scope.role.template.data.splice(
	    //         $scope.role.template.data.indexOf(boxComment[0]),
	    //         1
	    //       );
	    //     }
	    //   }
	    //   var boxReminder = $scope.role.template.data.filter(function(d) {
	    //     return d.columnType === "REMINDER";
	    //   });
	    //   if ($scope.info.features.reminders && $scope.role.showReminder) {
	    //     $scope.expiredColor = "#f26a5d";
	    //     $scope.importanceColors = [
	    //       {
	    //         type: "LOW",
	    //         color: "#27b96b",
	    //       },
	    //       {
	    //         type: "NORMAL",
	    //         color: "#27c2eb",
	    //       },
	    //       {
	    //         type: "HIGH",
	    //         color: "#f29a25",
	    //       },
	    //     ];
	    //     CompanyTaskService.query({
	    //       companyId: $stateParams.companyId,
	    //       status: "INCOMPLETE",
	    //       limit: 4,
	    //     }).$promise.then(
	    //       function(resp) {
	    //         $scope.latestTasks = resp;
	    //         if (!boxReminder[0]) {
	    //           if ($scope.latestTasks.length > 0) {
	    //             $scope.role.template.data.push({
	    //               isChart: false,
	    //               centralInformation: false,
	    //               columnType: "REMINDER",
	    //               isFullBox: false,
	    //               chartData: {
	    //                 gsX: 0,
	    //                 gsY: yMax + heigthMax,
	    //                 gsWidth: 4,
	    //                 gsHeigth: 4,
	    //               },
	    //             });
	    //             setTimeout(function() {
	    //               var grid = jQuery(".grid-stack").data("gridstack");
	    //               grid.addWidget(
	    //                 jQuery(".grid-stack-item:last-child"),
	    //                 0,
	    //                 yMax + heigthMax,
	    //                 4,
	    //                 4,
	    //                 true
	    //               );
	    //             }, 1000);
	    //           }
	    //         } else {
	    //           if ($scope.latestTasks.length === 0) {
	    //             $scope.role.template.data.splice(
	    //               $scope.role.template.data.indexOf(boxReminder[0]),
	    //               1
	    //             );
	    //           }
	    //         }
	    //       },
	    //       function() {
	    //         if (boxReminder[0]) {
	    //           $scope.role.template.data.splice(
	    //             $scope.role.template.data.indexOf(boxReminder[0]),
	    //             1
	    //           );
	    //         }
	    //       }
	    //     );
	    //   } else {
	    //     if (boxReminder[0]) {
	    //       $scope.role.template.data.splice(
	    //         $scope.role.template.data.indexOf(boxReminder[0]),
	    //         1
	    //       );
	    //     }
	    //   }
	    // }
	  // }
	
	  angular.forEach($scope.role.menus, function(v, i) {
	    if (angular.isUndefined(v.id)) {
	      v.id = i + 1;
	    }
	  });
	
	  $scope.members = members;
	  $scope.apiBase = config.apiBase;
	
	  var isCurrentUserRole = $scope.members.some(function(v) {
	    return v.id === $scope.currentUser.id;
	  });
	
	  $scope.showModalUserLink = function(link, index) {
	    $modal({
	      scope: $scope,
	      controller: "CompanyUserLinksCtrl",
	      templateUrl: "partials/company/publications/lists/user-link.html",
	      show: true,
	      prefixEvent: "userLinkModal",
	      resolve: {
	        link: function() {
	          return link || false;
	        },
	        index: function() {
	          return angular.isUndefined(index) ? -1 : index;
	        },
	      },
	    });
	  };
	
	  $scope.showModalLink = function(isMenu) {
	    $modal({
	      scope: $scope,
	      controller: [
	        "$scope",
	        function($scope) {
	          $scope.newLink = {
	            text: "",
	            link: "",
	          };
	          if (isMenu) {
	            $scope.newLink.id = $scope.role.menus.length + 1;
	          }
	          $scope.isMenu = isMenu;
	
	          $scope.saveLink = function() {
	            $scope.newLink.show = true;
	            if ($scope.newLink.link.indexOf(config.appBase) !== -1) {
	              if (!angular.isArray($scope.newLink.groups)) {
	                $scope.newLink.group = [];
	              }
	              var fullUserUrlRegex = /companies\/(.*)/i;
	              if (
	                !fullUserUrlRegex.test($scope.newLink.link) ||
	                !checkPermissionGroup($scope.newLink.groups)
	              ) {
	                $scope.newLink.show = false;
	              }
	            }
	            if (isMenu) {
	              $scope.role.menus.push($scope.newLink);
	            } else {
	              $scope.role.links.push($scope.newLink);
	            }
	            $scope.save();
	            $scope.$hide();
	          };
	        },
	      ],
	      templateUrl: "partials/company/user-roles/modal-create-link.html",
	      show: true,
	    });
	  };
	
	  $scope.save = function() {
	    $scope.saving = true;
	    if ($scope.role.template) {
	      $scope.role.template.id = $scope.role.template.id.toString();
	    }
	    var rolesNotId = [];
	    if ($scope.role.template && $scope.role.template.data) {
	      rolesNotId = $scope.role.template.data.filter(function(value) {
	        return !value.id;
	      });
	    }
	    var roleDeferred = $q.defer();
	    if (rolesNotId.length === 0) {
	      roleDeferred.resolve();
	    } else {
	      var number = 0;
	      angular.forEach(rolesNotId, function(value) {
	        var textBox = {
	          text: value.text,
	          id: value.id,
	          isFullBox: value.isFullBox,
	          boxID: value.reference ? value.reference.boxID : null,
	          userRoleID: value.reference ? value.reference.userRoleID : null,
	          centralInformation: value.centralInformation,
	          imgTarget : value.imgTarget,
	          headerText: value.headerText,
	          removeBox: value.removeBox,
	          removeBackground: value.removeBackground,
	          isChart: value.isChart,
	          chartData: JSON.stringify(value.chartData),
	          columnType: value.columnType,
	          columnData: JSON.stringify(value.columnData),
	        };
	        CompanyUserRoleService.saveTextbox(
	          {
	            companyId: $stateParams.companyId,
	            roleId: $stateParams.roleId,
	          },
	          textBox,
	          function(res) {
	            $scope.role.template.data[
	              $scope.role.template.data.indexOf(value)
	            ].id = res.id;
	            if (number === rolesNotId.length - 1) {
	              roleDeferred.resolve();
	            }
	            number++;
	          },
	          function(err) {
	            if (err.status === 400) {
	              growl.addErrorMessage(err.data.error.message);
	            } else {
	              growl.addErrorMessage(
	                $translate.instant("user-role.save-failure")
	              );
	            }
	            if (number === rolesNotId.length - 1) {
	              roleDeferred.resolve();
	            }
	            number++;
	          }
	        );
	      });
	    }
	    roleDeferred.promise.then(function() {
	      $scope.role.$update(
	        {
	          companyId: $stateParams.companyId,
	          roleId: $stateParams.roleId,
	        },
	        function() {
	          if (isCurrentUserRole) {
	            $scope.$emit("roleChanged", $scope.role);
	          }
	          lastTemplateData = $scope.role;
	          growl.addSuccessMessage($translate.instant("user-role.save-success"));
	          $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
	          $scope.saving = false;
	        },
	        function() {
	          $scope.saving = false;
	          growl.addErrorMessage($translate.instant("user-role.save-failure"));
	        }
	      );
	    });
	  };
	
	  // $scope.saveTextbox = function(id, data) {
	  //   var dataTemplate =
	  //     $scope.role.template.data[$scope.role.template.data.indexOf(data)];
	  //   var textBox = {
	  //     text: dataTemplate.text,
	  //     id: id,
	  //     isFullBox: dataTemplate.isFullBox,
	  //     boxID: dataTemplate.reference ? dataTemplate.reference.boxID : null,
	  //     userRoleID: dataTemplate.reference
	  //       ? dataTemplate.reference.userRoleID
	  //       : null,
	  //     centralInformation: dataTemplate.centralInformation,
	  //     imgTarget : dataTemplate.imgTarget,
	  //     headerText: dataTemplate.headerText,
	  //     removeBox: dataTemplate.removeBox,
	  //     removeBackground: dataTemplate.removeBackground,
	  //     isChart: dataTemplate.isChart,
	  //     chartData: JSON.stringify(dataTemplate.chartData),
	  //     columnType: dataTemplate.columnType,
	  //     columnData: JSON.stringify(dataTemplate.columnData),
	  //   };
	  //   CompanyUserRoleService.saveTextbox(
	  //     {
	  //       companyId: $stateParams.companyId,
	  //       roleId: $stateParams.roleId,
	  //     },
	  //     textBox,
	  //     function() {
	  //       if (isCurrentUserRole) {
	  //         $scope.$emit("roleChanged", $scope.role);
	  //       }
	  //       modalEdit.$promise.then(modalEdit.hide);
	  //       $state.reload();
	  //     },
	  //     function(err) {
	  //       if (err.status === 400) {
	  //         growl.addErrorMessage(err.data.error.message);
	  //       } else {
	  //         growl.addErrorMessage($translate.instant("user-role.save-failure"));
	  //       }
	  //     }
	  //   );
	  // };
	  // $scope.useDashboard = function(templateId) {
	  //   if (!$scope.role.template) {
	  //     $scope.role.template = { id: templateId };
	  //   } else {
	  //     $scope.role.template.id = templateId;
	  //   }
	  //   setTimeout(function() {
	  //     var options = {};
	  //     jQuery(".grid-stack").gridstack(options);
	  //   }, 1000);
	  // };
	
	  // $scope.checkColors = function(xAxesDisplay) {
	  //   if (
	  //     $scope.role.template &&
	  //     $scope.role.template.data &&
	  //     $scope.role.template.id
	  //   ) {
	  //     angular.forEach($scope.role.template.data, function(v, k) {
	  //       if (v.isChart && v.chartData) {
	  //         if (v.chartData.type === "line-bar") {
	  //           $scope.role.template.data[k].options = {
	  //             legend: {
	  //               display: true,
	  //               position: "bottom",
	  //             },
	  //             scales: {
	  //               xAxes: [
	  //                 {
	  //                   ticks: {
	  //                     display: true,
	  //                   },
	  //                 },
	  //               ],
	  //               yAxes: [],
	  //             },
	  //           };
	  //           if (xAxesDisplay <= 483) {
	  //             $scope.role.template.data[
	  //               k
	  //             ].options.scales.xAxes[0].ticks.display = false;
	  //           } else {
	  //             if (xAxesDisplay < 999) {
	  //               if (xAxesDisplay > 807) {
	  //                 if (
	  //                   $scope.role.template.id === "5" ||
	  //                   $scope.role.template.id === "6"
	  //                 ) {
	  //                   if (k === 0) {
	  //                     $scope.role.template.data[
	  //                       k
	  //                     ].options.scales.xAxes[0].ticks.display = false;
	  //                   } else {
	  //                     if ($scope.role.template.id === "6") {
	  //                       $scope.role.template.data[
	  //                         k
	  //                       ].options.scales.xAxes[0].ticks.display = false;
	  //                     } else {
	  //                       $scope.role.template.data[
	  //                         k
	  //                       ].options.scales.xAxes[0].ticks.display = true;
	  //                     }
	  //                   }
	  //                 } else {
	  //                   $scope.role.template.data[
	  //                     k
	  //                   ].options.scales.xAxes[0].ticks.display = true;
	  //                 }
	  //               } else {
	  //                 $scope.role.template.data[
	  //                   k
	  //                 ].options.scales.xAxes[0].ticks.display = true;
	  //               }
	  //             } else {
	  //               if (
	  //                 (($scope.role.template.id === "5" ||
	  //                   $scope.role.template.id === "6") &&
	  //                   k === 0) ||
	  //                 !v.isFullBox
	  //               ) {
	  //                 $scope.role.template.data[
	  //                   k
	  //                 ].options.scales.xAxes[0].ticks.display = false;
	  //               }
	  //             }
	  //           }
	  //         } else {
	  //           $scope.role.template.data[k].options = {
	  //             legend: {
	  //               display: true,
	  //               position: "bottom",
	  //             },
	  //           };
	  //           if (v.chartData.type === "bar" || v.chartData.type === "line") {
	  //             $scope.role.template.data[k].options = {
	  //               legend: {
	  //                 display: true,
	  //                 position: "bottom",
	  //               },
	  //               scales: {
	  //                 xAxes: [
	  //                   {
	  //                     ticks: {
	  //                       display: true,
	  //                     },
	  //                   },
	  //                 ],
	  //               },
	  //             };
	  //             if (xAxesDisplay <= 483) {
	  //               $scope.role.template.data[
	  //                 k
	  //               ].options.scales.xAxes[0].ticks.display = false;
	  //             } else {
	  //               if (xAxesDisplay < 999) {
	  //                 if (xAxesDisplay > 807) {
	  //                   if (
	  //                     $scope.role.template.id === "5" ||
	  //                     $scope.role.template.id === "6"
	  //                   ) {
	  //                     if (k === 0) {
	  //                       $scope.role.template.data[
	  //                         k
	  //                       ].options.scales.xAxes[0].ticks.display = false;
	  //                     } else {
	  //                       if ($scope.role.template.id === "6") {
	  //                         $scope.role.template.data[
	  //                           k
	  //                         ].options.scales.xAxes[0].ticks.display = false;
	  //                       } else {
	  //                         $scope.role.template.data[
	  //                           k
	  //                         ].options.scales.xAxes[0].ticks.display = true;
	  //                       }
	  //                     }
	  //                   } else {
	  //                     $scope.role.template.data[
	  //                       k
	  //                     ].options.scales.xAxes[0].ticks.display = true;
	  //                   }
	  //                 } else {
	  //                   $scope.role.template.data[
	  //                     k
	  //                   ].options.scales.xAxes[0].ticks.display = true;
	  //                 }
	  //               } else {
	  //                 if (
	  //                   (($scope.role.template.id === "5" ||
	  //                     $scope.role.template.id === "6") &&
	  //                     k === 0) ||
	  //                   !v.isFullBox
	  //                 ) {
	  //                   $scope.role.template.data[
	  //                     k
	  //                   ].options.scales.xAxes[0].ticks.display = false;
	  //                 }
	  //               }
	  //             }
	  //           }
	  //         }
	  //         if (v.chartData.type !== "doughnut" && v.chartData.type !== "pie") {
	  //           $scope.role.template.data[k].datasetOverride = [];
	  //           angular.forEach(v.chartData.colors, function(value, key) {
	  //             if (v.chartData.type === "line-bar") {
	  //               $scope.role.template.data[k].datasetOverride.push({
	  //                 yAxisID: "y-axis-" + (key + 1),
	  //                 borderWidth: key === 0 ? 2 : 1,
	  //                 backgroundColor: key === 0 ? "transparent" : value,
	  //                 pointBackgroundColor: key === 0 ? "transparent" : value,
	  //                 borderColor: value,
	  //                 pointBorderColor: value,
	  //                 type: key === 0 ? "line" : "bar",
	  //               });
	  //               $scope.role.template.data[k].options.scales.yAxes.push({
	  //                 id: "y-axis-" + (key + 1),
	  //                 display: true,
	  //                 position: key === 0 ? "left" : "right",
	  //               });
	  //             } else {
	  //               $scope.role.template.data[k].datasetOverride.push({
	  //                 borderWidth: v.chartData.type === "line" ? 2 : 1,
	  //                 backgroundColor:
	  //                   v.chartData.type === "line" ? "transparent" : value,
	  //                 pointBackgroundColor:
	  //                   v.chartData.type === "line" ? "transparent" : value,
	  //                 borderColor: value,
	  //                 pointBorderColor: value,
	  //               });
	  //             }
	  //           });
	  //         }
	  //       }
	  //     });
	  //   }
	  // };
	
	  // var widthWindow = angular.element($window).width();
	  // $scope.checkColors(widthWindow);
	  // angular.element($window).on("resize", function() {
	  //   widthWindow = angular.element($window).width();
	  //   $scope.$apply(function() {
	  //     $scope.checkColors(widthWindow);
	  //   });
	  // });
	
	  // $scope.loadBlogs = function(filter) {
	  //   CompanyPublicationService.query({
	  //     companyId: $stateParams.companyId,
	  //     limit: 20,
	  //     orderby: "created",
	  //     qType: "GENERAL",
	  //     type: "BLOG",
	  //     q: filter,
	  //   }).$promise.then(function(blogs) {
	  //     $scope.blogs = blogs;
	  //   });
	  // };
	
	  // $scope.addBulkColumn = function(columnType) {
	  //   $scope.role.template.data = angular.isArray($scope.role.template.data)
	  //     ? $scope.role.template.data
	  //     : [];
	  //   var gsYMax = 0;
	  //   var gsHeigthMax = 4;
	  //   angular.forEach($scope.role.template.data, function(d) {
	  //     if (parseInt(d.chartData.gsY) > gsYMax) {
	  //       gsYMax = parseInt(d.chartData.gsY);
	  //       gsHeigthMax = parseInt(d.chartData.gsHeigth);
	  //     }
	  //   });
	  //   var newTextBox = {};
	  //   if (columnType === "CHART") {
	  //     newTextBox = {
	  //       isChart: true,
	  //       columnType: "CHART",
	  //       chartData: {
	  //         title: "",
	  //         type: "bar",
	  //         gsX: 0,
	  //         gsY: gsYMax + gsHeigthMax,
	  //         gsWidth: 4,
	  //         gsHeigth: 4,
	  //       },
	  //     };
	  //   } else {
	  //     if (columnType === "BLOG") {
	  //       newTextBox = {
	  //         isChart: false,
	  //         columnType: "BLOG",
	  //         columnData: {
	  //           blogId: null,
	  //           only: "NONE",
	  //         },
	  //         chartData: {
	  //           gsX: 0,
	  //           gsY: gsYMax + gsHeigthMax,
	  //           gsWidth: 4,
	  //           gsHeigth: 4,
	  //         },
	  //       };
	  //     } else {
	  //       if (columnType === "INFO") {
	  //         newTextBox = {
	  //           isChart: false,
	  //           columnType: "INFO",
	  //           columnData: {},
	  //           chartData: {
	  //             fontColor: 4293813849,
	  //             backgroundColor: 4278190080,
	  //             gsX: 0,
	  //             gsY: gsYMax + gsHeigthMax,
	  //             gsWidth: 4,
	  //             gsHeigth: 4,
	  //           },
	  //         };
	  //       } else {
	  //         if ($scope.userRoles.length > 0) {
	  //           $scope.userRoles[0].template.data = angular.isArray(
	  //             $scope.userRoles[0].template.data
	  //           )
	  //             ? $scope.userRoles[0].template.data
	  //             : [];
	  //           var referenceCentralInformation = $scope.userRoles[0].template.data.filter(
	  //             function(item) {
	  //               return item.centralInformation === false;
	  //             }
	  //           );
	  //           newTextBox = {
	  //             text: "",
	  //             img: "",
	  //             columnType: "DEFAULT",
	  //             isChart: false,
	  //             centralInformation: false,
	  //             userRoleCurrent: $scope.userRoles[0],
	  //             referenceCentralInformation: referenceCentralInformation,
	  //             currentIndex:
	  //               $scope.userRoles[0].template.data.indexOf(
	  //                 referenceCentralInformation[0]
	  //               ) + 1,
	  //             reference: {
	  //               boxID:
	  //                 $scope.userRoles[0].template.data[0] !== undefined
	  //                   ? $scope.userRoles[0].template.data[0].id
	  //                   : null,
	  //               userRoleID:
	  //                 $scope.userRoles[0] !== undefined
	  //                   ? $scope.userRoles[0].id
	  //                   : null,
	  //             },
	  //             chartData: {
	  //               gsX: 0,
	  //               gsY: gsYMax + gsHeigthMax,
	  //               gsWidth: 4,
	  //               gsHeigth: 4,
	  //             },
	  //           };
	  //         } else {
	  //           newTextBox = {
	  //             isChart: false,
	  //             columnType: "DEFAULT",
	  //             text: "",
	  //             img: "",
	  //             chartData: {
	  //               gsX: 0,
	  //               gsY: gsYMax + gsHeigthMax,
	  //               gsWidth: 4,
	  //               gsHeigth: 4,
	  //             },
	  //           };
	  //         }
	  //       }
	  //     }
	  //   }
	  //   $scope.role.template.data.push(newTextBox);
	  //   setTimeout(function() {
	  //     var grid = jQuery(".grid-stack").data("gridstack");
	  //     grid.addWidget(
	  //       jQuery(".grid-stack-item:last-child"),
	  //       newTextBox.chartData.gsX,
	  //       newTextBox.chartData.gsY,
	  //       newTextBox.chartData.gsWidth,
	  //       newTextBox.chartData.gsHeigth,
	  //       true
	  //     );
	  //   }, 1000);
	  // };
	
	  // var modalEdit;
	  // $scope.showModalEditTextBox = function(data) {
	  //   modalEdit = $modal({
	  //     scope: $scope,
	  //     controller: "CompanyEditTextBoxCtrl",
	  //     resolve: {
	  //       data: function() {
	  //         return data || [];
	  //       },
	  //     },
	  //     templateUrl: "partials/company/user-roles/modal-edit-textbox.html",
	  //     show: false,
	  //   });
	  //   modalEdit.$promise.then(modalEdit.show);
	  // };
	
	  // $scope.onFileSelect = function(
	  //   files,
	  //   text,
	  //   id,
	  //   boxID,
	  //   userRoleID,
	  //   centralInformation
	  // ) {
	  //   if (!Array.isArray(files)) {
	  //     return;
	  //   }
	
	  //   return uploadTracker(
	  //     files.map(function(f) {
	  //       return {
	  //         url:
	  //           config.apiBase +
	  //           "/companies/" +
	  //           $stateParams.companyId +
	  //           "/user-roles/" +
	  //           $stateParams.roleId,
	  //         file: f,
	  //         fields: {
	  //           text: text,
	  //           id: id,
	  //           boxID: boxID,
	  //           userRoleID: userRoleID,
	  //           centralInformation: centralInformation,
	  //           columnType: "DEFAULT",
	  //         },
	  //       };
	  //     })
	  //   ).then(function(files) {
	  //     var indexData = $scope.role.template.data.filter(function(item) {
	  //       return item.id === id;
	  //     })[0];
	  //     if (
	  //       $scope.role.template.data[$scope.role.template.data.indexOf(indexData)]
	  //         .img === ""
	  //     ) {
	  //       $scope.role.template.data[
	  //         $scope.role.template.data.indexOf(indexData)
	  //       ].img = files[0];
	  //     }
	  //     if (!id) {
	  //       $scope.role.template.data[
	  //         $scope.role.template.data.indexOf(indexData)
	  //       ].id = files[0];
	  //     }
	  //     $scope.$broadcast("imageChanged");
	  //     if (isCurrentUserRole) {
	  //       $scope.$emit("roleChanged", $scope.role);
	  //     }
	  //   });
	  // };
	
	  $scope.addMember = function(member) {
	    CompanyUserRoleService.addMember(
	      { companyId: $stateParams.companyId, roleId: $stateParams.roleId },
	      { user: member },
	      function() {
	        $scope.members.push(member);
	        if (isCurrentUserRole) {
	          $scope.$emit("roleChanged", $scope.role);
	        }
	        growl.addSuccessMessage(
	          $translate.instant("user-role.add-member-success")
	        );
	        $scope.addedUser = "";
	        $scope.nonMembers.splice($scope.nonMembers.indexOf(member), 1);
	      },
	      function() {
	        growl.addErrorMessage(
	          $translate.instant("user-role.add-member-failure")
	        );
	      }
	    );
	  };
	
	  $scope.deleteWatcher = function(member) {
	    CompanyUserRoleService.removeMember(
	      {
	        companyId: $stateParams.companyId,
	        roleId: $stateParams.roleId,
	        userId: member.id,
	      },
	      function() {
	        if (isCurrentUserRole) {
	          $scope.$emit("roleChanged", $scope.role);
	        }
	        growl.addSuccessMessage(
	          $translate.instant("customer-portals.remove-member-success")
	        );
	        $scope.members.splice($scope.members.indexOf(member), 1);
	      },
	      function() {
	        growl.addErrorMessage(
	          $translate.instant("customer-portals.remove-member-failure")
	        );
	      }
	    );
	  };
	
	  $scope.nonMembers = [];
	  $scope.queryUsers = function(text) {
	    CompanyUserService.query({
	      companyId: $stateParams.companyId,
	      q: text,
	      limit: 10,
	    }).$promise.then(function(u) {
	      $scope.nonMembers = u.filter(function(u) {
	        return !$scope.members.some(function(member) {
	          return member.id === u.id;
	        });
	      });
	    });
	  };
	
	  $scope.removeImage = function(i) {
	    var oldImg = role.template.data[i].img;
	    role.template.data[i].img = "";
	    $scope.role.$update(
	      {
	        companyId: $stateParams.companyId,
	        roleId: $stateParams.roleId,
	      },
	      function() {
	        if (isCurrentUserRole) {
	          $scope.$emit("roleChanged", $scope.role);
	        }
	        growl.addSuccessMessage($translate.instant("user-role.save-success"));
	      },
	      function() {
	        role.template.data[i].img = oldImg;
	        growl.addErrorMessage($translate.instant("user-role.save-failure"));
	      }
	    );
	  };
	}
	
	CompanyUserRoleEditCtrl.resolve = {
	  role: [
	    "CompanyUserRoleService",
	    "$stateParams",
	    function(userRoleService, $stateParams) {
	      return userRoleService.get({
	        companyId: $stateParams.companyId,
	        roleId: $stateParams.roleId,
	      }).$promise;
	    },
	  ],
	  userRoles: [
	    "CompanyUserRoleService",
	    "$stateParams",
	    function(userRoleService, $stateParams) {
	      return userRoleService.query({
	        companyId: $stateParams.companyId,
	        limit: 100,
	      }).$promise;
	    },
	  ],
	  members: [
	    "CompanyUserRoleService",
	    "$stateParams",
	    function(userRoleService, $stateParams) {
	      return userRoleService.queryUsers({
	        companyId: $stateParams.companyId,
	        roleId: $stateParams.roleId,
	        all: true,
	      }).$promise;
	    },
	  ],
	};
	
	module.exports = CompanyUserRoleEditCtrl;
	
	angular
	  .module("dokiv")
	  .controller("CompanyUserRoleEditCtrl", CompanyUserRoleEditCtrl)
	  .directive("menuEdit", [
	    "CompanyPublicationService",
	    "config",
	    "$timeout",
	    EditMenuDirective,
	  ])
	
	function EditMenuDirective(CompanyPublicationService, config, $timeout) {
	  return {
	    restrict: "A",
	    replace: true,
	    scope: {
	      currentMenu: "=",
	      nestedMenu: "=",
	      role: "=",
	      remove: "&onRemove",
	      companyId: "=",
	    },
	
	    link: function($scope, elem) {
	      if (!$scope.currentMenu.hasOwnProperty("isPortalLink")) {
	        $scope.currentMenu.isPortalLink = false;
	      }
	      $scope.toggle = false;
	      $scope.toggleDropdownMenu = false;
	      $scope.$watch(
	        "currentMenu",
	        function(newVal, oldVal) {
	          $scope.$emit("menuChange", JSON.parse(JSON.stringify(newVal)));
	          if (!newVal.text) {
	            $scope.toggle = true;
	          }
	        },
	        true
	      );
	
	      $scope.changeParent = function(parentId) {
	        if ($scope.currentMenu.id !== parentId) {
	          $scope.currentMenu.parentId = parentId;
	          $scope.toggleDropdownMenu = false;
	        }
	      };
	
	      $scope.remove = function() {
	        $scope.$emit("removeMenuItem", $scope.currentMenu);
	      };
	
	      $scope.isDokivLink = function(link) {
	        var regex = /http[s]?:\/\/?(?:portal|app).+?\.?dokiv\.com+\/([^\/\s]+\/).*/;
	        return regex.test(link);
	      };
	
	      $scope.toggleLink = function(link) {
	        if (isDokivLink) {
	          var portalRegex = /http[s]?:\/\/?portal.+?\.?dokiv\.com+\/([^\/\s]+)\/.*/;
	          var appRegex = /http[s]?:\/\/?app.+?\.?dokiv\.com+\/([^\/\s]+)\/.*/;
	        }
	
	        return link;
	      };
	
	      $scope.setLink = function(publication) {
	        if (
	          $scope.currentMenu.isPortalLink &&
	          (publication.type === "FORM" ||
	            publication.type === "ALBUM" ||
	            publication.type === "DEFAULT" ||
	            publication.type === "NOTE")
	        ) {
	          $scope.currentMenu.link =
	            config.portalUrl +
	            "/app/companies/" +
	            $scope.companyId +
	            "/publications/" +
	            publication.id +
	            "/" +
	            publication.type.toLowerCase();
	        } else {
	          if (
	            publication.type !== "FORM" &&
	            publication.type !== "PUBLICATION_SPREAD_SHEET" &&
	            publication.type !== "COMPANY_ORDER" &&
	            publication.type !== "ORDER_SUBCRIPTION"
	          ) {
	            $scope.currentMenu.link =
	              config.appBase +
	              "/companies/" +
	              $scope.companyId +
	              "/publications/" +
	              publication.id;
	          } else {
	            if (publication.type === "PUBLICATION_SPREAD_SHEET") {
	              $scope.currentMenu.link =
	                config.appBase +
	                "/spreadsheet/" +
	                $scope.companyId +
	                "/publications/" +
	                publication.id;
	            }
	            if (publication.type === "FORM") {
	              if (
	                publication.features.formActived === "false" ||
	                !!publication.features.formActived === false
	              ) {
	                $scope.currentMenu.link =
	                  config.appBase +
	                  "/forms/companies/" +
	                  $scope.companyId +
	                  "/publications/" +
	                  publication.id +
	                  "/detail";
	              } else {
	                $scope.currentMenu.link =
	                  config.appBase +
	                  "/forms/companies/" +
	                  $scope.companyId +
	                  "/publications/" +
	                  publication.id +
	                  "/form-submit";
	              }
	            }
	            if (publication.type === "COMPANY_ORDER") {
	              $scope.currentMenu.link =
	                config.appBase +
	                "/order/" +
	                $scope.companyId +
	                "/detail/" +
	                publication.id;
	            }
	            if (publication.type === "ORDER_SUBCRIPTION") {
	              $scope.currentMenu.link =
	                config.appBase +
	                "/order/" +
	                $scope.companyId +
	                "/subcription-detail/" +
	                publication.id;
	            }
	          }
	        }
	
	        $scope.toggleSearch = false;
	        $scope.search = "";
	        $scope.objects = [];
	      };
	
	      var searchTimeout;
	      $scope.query = function(search) {
	        if (searchTimeout) {
	          $timeout.cancel(searchTimeout);
	          searchTimeout = null;
	        }
	        searchTimeout = $timeout(function() {
	          CompanyPublicationService.query({
	            companyId: $scope.companyId,
	            q: search,
	            limit: 50,
	          }).$promise.then(function(publications) {
	            $scope.objects = $scope.currentMenu.isPortalLink
	              ? publications.filter(function(p) {
	                  return (
	                    p.type === "DEFAULT" ||
	                    p.type === "FORM" ||
	                    p.type === "NOTE" ||
	                    p.type === "ALBUM"
	                  );
	                })
	              : publications;
	          });
	        }, 200);
	      };
	    },
	
	    templateUrl: "partials/company/user-roles/menu-edit.html",
	  };
	}
	
	EditMenuDirective.$inject = ["CompanyPublicationService", "config", "$timeout"];


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(17);
	var LIMIT = 20;
	CompanyUserRoleListCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'growl',
	'$modal',
	'$translate',
	'$stateParams',
	'CompanyUserRoleService',
	'userRoles',
	];
	
	function CompanyUserRoleListCtrl(
	$scope,
	$state,
	$q,
	growl,
	$modal,
	$translate,
	$stateParams,
	CompanyUserRoleService,
	userRoles) {
	
	  $scope.userRoles = userRoles;
	  $scope.page = $stateParams.page | 0;
	  if ($scope.userRoles.length > LIMIT) {
	    $scope.more = true;
	    $scope.userRoles.pop();
	  }
	
	  var memberPromises = [];
	  angular.forEach($scope.userRoles, function(v){
	    memberPromises.push(CompanyUserRoleService.queryUsers({
	      companyId: $stateParams.companyId,
	      roleId: v.id
	    }).$promise);
	  });
	
	  $q.all(memberPromises).then(function(m){
	    angular.forEach(m, function(v, k){
	      $scope.userRoles[k].members = angular.copy(v);
	    });
	  });
	
	  $scope.showModalDeleteUserRole = function(userRole, index) {
	    var angularModal = $modal({
	      scope: $scope,
	      prefixEvent: "modalTextBox",
	      controller: [
	        "$scope",
	        function($scope) {
	          $scope.confirmName = $translate.instant("user-role.confirm-delete-dashboard");
	          $scope.activeDelete = function() {
	            $scope.remove(userRole, index);
	          };
	        },
	      ],
	      templateUrl:
	        "partials/company/publications/detail/latest/confirm-delete.html",
	      show: true,
	    });
	  };
	
	  $scope.remove = function(role, index) {
	    CompanyUserRoleService.delete({
	      companyId: $stateParams.companyId,
	      roleId: role.id
	    }, function(){
	      $scope.userRoles.splice(index, 1);
	    });
	  };
	
	  $scope.copyUserRole = function(role) {
	    CompanyUserRoleService.copyUserRole({
	      companyId: $stateParams.companyId,
	      roleId: role.id
	    }, {}, function(){
	      growl.addSuccessMessage($translate.instant("user-role.copy-success"));
	      $state.reload();
	    }, function() {
	      growl.addErrorMessage($translate.instant("user-role.copy-failure"));
	    });
	  };
	}
	
	CompanyUserRoleListCtrl.resolve = {
	  userRoles: ['CompanyUserRoleService', '$stateParams', function(userRoleService, $stateParams) {
	    return userRoleService.query({companyId: $stateParams.companyId, limit: LIMIT + 1, offset: ($stateParams.page|0) * LIMIT}).$promise;
	  }]
	};
	
	module.exports = CompanyUserRoleListCtrl;
	
	angular.module('dokiv')
	  .controller('CompanyUserRoleListCtrl', CompanyUserRoleListCtrl);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(17);
	
	CompanyUserRoleNewCtrl.$inject = [
	  "$scope",
	  "$state",
	  "$modal",
	  "$stateParams",
	  "$translate",
	  "CompanyUserRoleService",
	  "growl",
	];
	
	function CompanyUserRoleNewCtrl(
	  $scope,
	  $state,
	  $modal,
	  $stateParams,
	  $translate,
	  CompanyUserRoleService,
	  growl
	) {
	  $scope.users = [];
	  $scope.userRole = {
	    template: {
	      id: "6",
	    },
	    links: [],
	    menus: [],
	  };
	
	  $scope.save = function() {
	    CompanyUserRoleService.save(
	      { companyId: $stateParams.companyId },
	      $scope.userRole,
	      function(resp, headers) {
	        growl.addSuccessMessage(
	          $translate.instant("user-role.create-role-success")
	        );
	        // if (headers("Location")) {
	        //   var newId = headers("Location")
	        //     .split("/")
	        //     .pop();
	
	        //   $state.go("root.company.edit-dashboard", {
	        //     roleId: newId,
	        //   });
	        // } else {
	          $state.go("^.list");
	        // }
	      },
	      function() {
	        growl.addErrorMessage(
	          $translate.instant("user-role.create-role-failure")
	        );
	      }
	    );
	  };
	
	  $scope.useDashboard = function(templateId) {
	    if (!$scope.role.template) {
	      $scope.role.template = { id: templateId };
	    } else {
	      $scope.role.template.id = templateId;
	    }
	  };
	}
	
	angular
	  .module("dokiv")
	  .controller("CompanyUserRoleNewCtrl", CompanyUserRoleNewCtrl);


/***/ }),
/* 429 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * angular-growl - v0.4.0 - 2013-11-19
	 * https://github.com/marcorinck/angular-growl
	 * Copyright (c) 2013 Marco Rinck; Licensed MIT
	 */
	angular.module('angular-growl', []);
	angular.module('angular-growl').directive('growl', [
	  '$rootScope',
	  function ($rootScope) {
	    return {
	      restrict: 'A',
	      template: '<section class="growl-item alert notification-banner__banner" ng-repeat="message in messages" ng-class="computeClasses(message)"><i class="fa fa-info notification-banner__icon"></i><div ng-switch="message.enableHtml" class="notification-banner__message"><div ng-switch-when="true" ng-bind-html="message.text"></div><div ng-switch-default ng-bind="message.text"></div></div><button type="button" class="notification-banner__close icon-only" ng-click="deleteMessage(message)"><i class="fa fa-close"></i></button><a ng-if="message.url" target="_self" href="{{message.url}}" class="notification-banner__link">Goto new object</a></section>',
	      replace: false,
	      scope: true,
	      controller: [
	        '$scope',
	        '$timeout',
	        'growl',
	        function ($scope, $timeout, growl) {
	          var onlyUnique = growl.onlyUnique();
	          $scope.messages = [];
	          function addMessage(message) {
	            $scope.messages.push(message);
	            if (message.ttl && message.ttl !== -1) {
	              $timeout(function () {
	                $scope.deleteMessage(message);
	              }, message.ttl);
	            }
	            if(message.url){
	
	            }
	          }
	          $rootScope.$on('growlMessage', function (event, message) {
	            var found;
	            if (onlyUnique) {
	              angular.forEach($scope.messages, function (msg) {
	                if (message.text === msg.text && message.severity === msg.severity) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                addMessage(message);
	              }
	            } else {
	              addMessage(message);
	            }
	          });
	          $scope.deleteMessage = function (message) {
	            var index = $scope.messages.indexOf(message);
	            if (index > -1) {
	              $scope.messages.splice(index, 1);
	            }
	          };
	          $scope.computeClasses = function (message) {
	            return {
	              'notification-banner__banner--success': message.severity === 'success',
	              'notification-banner__banner--warning': message.severity === 'error',
	              'notification-banner__banner--system':  message.severity === 'info',
	            };
	          };
	        }
	      ]
	    };
	  }
	]);
	
	angular.module('angular-growl').provider('growl', function () {
	  var _ttl = null, _enableHtml = false, _messagesKey = 'messages', _messageTextKey = 'text', _messageSeverityKey = 'severity', _onlyUniqueMessages = true;
	  this.globalTimeToLive = function (ttl) {
	    _ttl = ttl;
	  };
	  this.globalEnableHtml = function (enableHtml) {
	    _enableHtml = enableHtml;
	  };
	  this.messagesKey = function (messagesKey) {
	    _messagesKey = messagesKey;
	  };
	  this.messageTextKey = function (messageTextKey) {
	    _messageTextKey = messageTextKey;
	  };
	  this.messageSeverityKey = function (messageSeverityKey) {
	    _messageSeverityKey = messageSeverityKey;
	  };
	  this.onlyUniqueMessages = function (onlyUniqueMessages) {
	    _onlyUniqueMessages = onlyUniqueMessages;
	  };
	  this.serverMessagesInterceptor = [
	    '$q',
	    'growl',
	    function ($q, growl) {
	      function checkResponse(response) {
	        if (response.data[_messagesKey] && response.data[_messagesKey].length > 0) {
	          growl.addServerMessages(response.data[_messagesKey]);
	        }
	      }
	      function success(response) {
	        checkResponse(response);
	        return response;
	      }
	      function error(response) {
	        checkResponse(response);
	        return $q.reject(response);
	      }
	      return function (promise) {
	        return promise.then(success, error);
	      };
	    }
	  ];
	  this.$get = [
	    '$rootScope',
	    '$filter',
	    function ($rootScope, $filter) {
	      var translate;
	      try {
	        translate = $filter('translate');
	      } catch (e) {
	      }
	      function broadcastMessage(message) {
	        if (translate) {
	          message.text = translate(message.text);
	        }
	        $rootScope.$broadcast('growlMessage', message);
	      }
	      function sendMessage(text, config, severity, url) {
	        var _config = config || {}, message;
	        message = {
	          text: text,
	          severity: severity,
	          ttl: _config.ttl || _ttl,
	          enableHtml: _config.enableHtml || _enableHtml
	        };
	        if(url){
	          message.url = url;
	        }
	        broadcastMessage(message);
	      }
	      function addWarnMessage(text, config) {
	        sendMessage(text, config, 'warn');
	      }
	      function addErrorMessage(text, config, url) {
	        sendMessage(text, config, 'error', url);
	      }
	      function addInfoMessage(text, config) {
	        sendMessage(text, config, 'info');
	      }
	      function addSuccessMessage(text, config) {
	        sendMessage(text, config, 'success');
	      }
	      function addServerMessages(messages) {
	        var i, message, severity, length;
	        length = messages.length;
	        for (i = 0; i < length; i++) {
	          message = messages[i];
	          if (message[_messageTextKey] && message[_messageSeverityKey]) {
	            switch (message[_messageSeverityKey]) {
	            case 'warn':
	              severity = 'warn';
	              break;
	            case 'success':
	              severity = 'success';
	              break;
	            case 'info':
	              severity = 'info';
	              break;
	            case 'error':
	              severity = 'error';
	              break;
	            }
	            sendMessage(message[_messageTextKey], undefined, severity);
	          }
	        }
	      }
	      function onlyUnique() {
	        return _onlyUniqueMessages;
	      }
	      return {
	        addWarnMessage:    addWarnMessage,
	        addErrorMessage:   addErrorMessage,
	        addInfoMessage:    addInfoMessage,
	        addSuccessMessage: addSuccessMessage,
	        addServerMessages: addServerMessages,
	        onlyUnique:        onlyUnique
	      };
	    }
	  ];
	});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(33);
	__webpack_require__(432);
	
	
	
	PublicationCollabrationCtrl.$inject = [
	  '$scope',
	  '$stateParams',
	  '$filter',
	  'publication',
	  'CompanyPublicationFileService',
	  'PublicationCollabrationService',
	  'growl',
	  'translations',
	  'UploadTracker',
	  'config'
	];
	function PublicationCollabrationCtrl(
	  $scope,
	  $stateParams,
	  $filter,
	  publication,
	  CompanyPublicationFileService,
	  PublicationCollabrationService,
	  growl,
	  translations,
	  uploadTracker,
	  config) {
	  $scope.companyId = publication.company.id;
	  $scope.publication = publication;
	
	  function openAdditionalOptions() {
	    $scope.additionalOptionsOpen = true;
	  }
	  
	  $scope.closeAdditionalOptions = function() {
	    $scope.additionalOptionsOpen = false;
	  };
	  
	  $scope.toggleAdditionalOptions = function() {
	    if($scope.additionalOptionsOpen) {
	      $scope.closeAdditionalOptions();
	    }
	    else {
	      openAdditionalOptions();
	    }
	  };
	
	  $scope.uploadFilesForPublication = function(files, publicationId) {
	    return uploadTracker(files.map(function(f) {
	      return {
	        url:  config.apiBase + "/companies/" + $scope.companyId + "/publications/" + publicationId + "/files",
	        file: f,
	      };
	    }));
	  };
	
	  $scope.onFileSelect = function($files) {
	      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
	        publication.versionNumber += files.length;
	          $scope.showVersionsTab = publication.versionNumber > 1;
	        $scope.$broadcast("collabration-uploaded");
	      });
	  };
	
	  $scope.openPreview = function(file, publicationId) {
	    PublicationCollabrationService.getFileToken({companyId: $scope.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
	        return $scope.download(file, publicationId);
	      }
	
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;
	
	      var type;
	      switch(file.mimeType) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          type = 'image';
	          break;
	        case 'application/pdf':
	          if (true === iOS) {
	            window.open(url, '_self');
	            return;
	          }
	          type = 'iframe';
	          break;
	        default:
	          type = 'iframe';
	      }
	
	      jQuery.fancybox.open([{
	        type: type,
	        padding: 0,
	        margin: 0,
	        href: url
	      }]);
	    });
	
	    return false;
	  };
	
	  $scope.download = function(file, publicationId) {
	    PublicationCollabrationService.getFileToken({companyId: $scope.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
	      var additionParams = "";
	      var elm = angular.element(document.querySelector('body'));
	      var iFrame = elm.find('#downloadWindow');
	      if (!(iFrame && iFrame.length > 0)) {
	        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	        elm.append(iFrame);
	      }
	      
	      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);
	      
	      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	      if (true === iOS) {
	        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
	        return;
	      }
	    });
	  };
	
	  $scope.rotateImage = function(file) {
	    var params = {
	      companyId: $scope.companyId,
	      publicationId: $stateParams.publicationId,
	      fileId: file.id,
	      manipulate: 'rotate',
	      rotate:     -90
	    };
	    CompanyPublicationFileService.rotateImage(params, {}).$promise.then(function(){
	      $scope.$broadcast("files-uploaded");
	    });
	  };
	
	}
	
	PublicationCollabrationCtrl.resolve = {
	  publication: ['$stateParams', 'PublicationCollabrationService', function($stateParams, PublicationCollabrationService) {
	    return PublicationCollabrationService.get({publicationId: $stateParams.publicationId}).$promise;
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.file-upload-locked',
	      'publication.lock-file-upload-success',
	      'publication.lock-file-upload-failure'
	    ]);
	  }]
	};
	module.exports = PublicationCollabrationCtrl;
	
	angular.module('dokiv')
	  .controller('PublicationCollabrationCtrl', PublicationCollabrationCtrl);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(9);
	
	PublicationCollabrationDetailCtrl.$inject = [
	  "$scope",
	  "$interval",
	  "$stateParams",
	  "$translate",
	  "translations",
	  "$q",
	  "config",
	  "publication",
	  "growl",
	  "data",
	  "PublicationCollabrationService"
	];
	function PublicationCollabrationDetailCtrl (
	  $scope,
	  $interval,
	  $stateParams,
	  $translate,
	  translations,
	  $q,
	  config,
	  publication,
	  growl,
	  data,
	  PublicationCollabrationService
	) {
	  $scope.publication  = publication;
	  $scope.showFileDrop = false;
	  publication.type    = 'ALBUM';
	
	  $scope.downloadZip = function() {
	    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	    if (true === iOS) {
	      window.open(config.apiBase + '/companies/' + publication.company.id + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language, '_self');
	      return;
	    }
	    
	    var elm = angular.element(document.querySelector('body'));
	    var iFrame = elm.find('#downloadWindow');
	    if (!(iFrame && iFrame.length > 0)) {
	      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
	      elm.append(iFrame);
	    }
	
	    iFrame.attr(
	      'src',
	      config.apiBase + '/companies/' + publication.company.id + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language
	    );
	  };
	  
	  var queryFiles =  function() {
	    return PublicationCollabrationService.queryFiles({
	      companyId:     publication.company.id,
	      publicationId: $stateParams.publicationId,
	      limit:         21,
	      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	      offset:        ($stateParams.page|0) * 20
	    }).$promise.then(function(files) {
	      $scope.files   = files.slice(0, 20);
	      $scope.hasMore = files.length > 20;
	    });
	  };
	
	  $scope.$on('collabration-uploaded', function() {
	    queryFiles();
	  });
	
	  $scope.searchFileStr = $stateParams.searchFile || "";
	  $scope.currentPage         = $stateParams.page|0;
	  $scope.files         = data.files.slice(0, 21);
	  $scope.hasMore       = data.files.length > 21;
	}
	
	PublicationCollabrationDetailCtrl.resolve = {
	  data: [
	  '$q',
	  '$stateParams',
	  'publication',
	  'CompanyPublicationFileService',
	  'PublicationCollabrationService',
	  function(
	    $q,
	    $stateParams,
	    publication,
	    CompanyPublicationFileService,
	    PublicationCollabrationService
	    ) {
	
	      var files = PublicationCollabrationService.queryFiles({
	        companyId:     publication.company.id,
	        publicationId: $stateParams.publicationId,
	        limit:         22,
	        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
	        offset:        ($stateParams.page|0) * 21,
	        q:             $stateParams.searchFile || "",
	        searchAble: true
	      }).$promise;
	
	      return $q.all([files]).then(function(data) {
	        return {
	          files      : data[0]
	        };
	      });
	  }],
	  translations: ['$translate', function($translate) {
	    return $translate([
	      'publication.delete-file-failure',
	      'publication.delete-file-success',
	      'form.product-list.all'
	    ]);
	  }]
	};
	
	module.exports = PublicationCollabrationDetailCtrl;
	
	angular.module("dokiv")
	  .controller("PublicationCollabrationDetailCtrl", PublicationCollabrationDetailCtrl);
	
	function isTypeImage() {
	  return function(mimetype) {
	    switch(mimetype) {
	        case 'image/jpeg':
	        case 'image/png':
	        case 'image/gif':
	        case 'image/bmp':
	        case 'image/svg+xml':
	        case 'image/webp':
	          return true;
	        default:
	          return false;
	      }
	  };
	}
	
	angular.module('dokiv')
	  .filter('isTypeImage', isTypeImage);

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	function PublicationCollabrationService($resource, config) {
	  return $resource(config.apiBase + '/publication-collabrations/:publicationId', {}, {
	    'update': { method:'PUT' },
	    'queryFiles': {
	    	url: config.apiBase + '/publication-collabrations/:publicationId/files',
	    	method: 'GET',
	    	isArray: true
	    },
	    'getFileToken': {
	      method: 'POST',
	      url: config.apiBase + '/publication-collabrations/:publicationId/files/:fileId/tokens'
	    },
	    'getPreview': {
	      method: 'GET',
	      url: config.apiBase + '/publication-collabrations/:publicationId/files/:fileId/preview'
	    }
	  });
	}
	
	angular.module('dokiv')
	  .factory('PublicationCollabrationService', ['$resource', 'config', PublicationCollabrationService]);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var RootCtrl = __webpack_require__(250);
	var ErrorCtrl = __webpack_require__(241);
	__webpack_require__(278);
	var ResetPasswordCtrl = __webpack_require__(277);
	var UsersResetPasswordCtrl = __webpack_require__(279);
	
	
	// How it works
	__webpack_require__(69);
	var HowToCtrl = __webpack_require__(69);
	
	// User profile
	__webpack_require__(435);
	
	// Companies
	var CompanyCtrl = __webpack_require__(57);
	var CompanyNavCtrl = __webpack_require__(313);
	var CompanyMenuTopCtrl = __webpack_require__(312);
	__webpack_require__(316);
	var CompanySettingThreeLoginCtrl = __webpack_require__(416);
	var CompanySettingCategoriesCtrl = __webpack_require__(406);
	var CompanySettingCategoryGroupsCtrl = __webpack_require__(407);
	var CompanySettingTaskStatusesCtrl = __webpack_require__(414);
	var CompanySettingTaskTypesCtrl = __webpack_require__(415);
	var CompanySettingGroupsCtrl = __webpack_require__(408);
	var CompanySettingStatusesCtrl= __webpack_require__(412);
	var CompanySettingTaskCategoriesCtrl= __webpack_require__(413);
	var CompanySettingNoticeCategoriesCtrl= __webpack_require__(411);
	
	var CompanySettingsClassesCtrl = __webpack_require__(315);
	var CompanyDefaultGroupCtrl = __webpack_require__(310);
	var CompanyAccountCtrl = __webpack_require__(307);
	var CompanyDetailCtrl = __webpack_require__(317);
	__webpack_require__(318);
	var CompanyTagSuggestionCtrl = __webpack_require__(320);
	var CompanyFlowVerifyDetailCtrl = __webpack_require__(319);
	
	// Companies - Publications
	var CompanyPublicationCtrl = __webpack_require__(373);
	var PublicationCollabrationCtrl = __webpack_require__(430);
	var CompanyPublicationsListCtrl = __webpack_require__(385);
	var CompanyPublicationsListDraftsCtrl = __webpack_require__(386);
	var CompanyPublicationsListArchivedCtrl = __webpack_require__(384);
	var CompanyPublicationsListStarredCtrl = __webpack_require__(387);
	var CompanyPublicationsListWatchedCtrl = __webpack_require__(388);
	var CompanyPublicationsFlowVerifiesCtrl = __webpack_require__(383);
	var CompanyPublicationDetailCtrl = __webpack_require__(374);
	var PublicationCollabrationDetailCtrl = __webpack_require__(431);
	var CompanyPublicationShareAccessCtrl = __webpack_require__(380);
	var CompanyPublicationVersionsCtrl = __webpack_require__(382);
	var CompanyPublicationIndexCtrl = __webpack_require__(378);
	var CompanyPublicationsNewCtrl = __webpack_require__(389);
	
	// Companies - Customer portals
	var CompanyCustomerPortalsCtrl = __webpack_require__(328);
	var CompanyCustomerPortalsListCtrl = __webpack_require__(330);
	var CompanyCustomerPortalsNewCtrl = __webpack_require__(331);
	var CompanyCustomerPortalsDetailCtrl = __webpack_require__(329);
	
	// Form app submit group
	var FormAppSubmitGroupNewCtrl = __webpack_require__(352);
	var FormAppSubmitGroupDetailCtrl = __webpack_require__(351);
	// Companies - Guest
	var CompanyGuestCtrl = __webpack_require__(280);
	var CompanyGuestNavCtrl = __webpack_require__(281);
	
	// Companies - Comments
	var CompanyGuestCommentsCtrl = __webpack_require__(286);
	// Companies - Guest - Publications
	var CompanyGuestPublicationsCtrl = __webpack_require__(299);
	var CompanyGuestPublicationsListCtrl = __webpack_require__(301);
	var CompanyGuestPublicationsListStarredCtrl = __webpack_require__(302);
	var CompanyGuestPublicationsDetailCtrl = __webpack_require__(300);
	
	var CompanyGuestUsersListCtrl = __webpack_require__(303);
	var CompanyGuestUsersProfileCtrl = __webpack_require__(304);
	
	// Companies - Guest - Albums
	var CompanyGuestAlbumsCtrl = __webpack_require__(283);
	var CompanyGuestAlbumsDetailCtrl = __webpack_require__(284);
	
	// Companies - Guest - Notes
	__webpack_require__(294);
	var CompanyGuestNotesDetailCtrl = __webpack_require__(295);
	
	// Companies - Guest - Folders
	__webpack_require__(290);
	var CompanyGuestFoldersDetailCtrl = __webpack_require__(291);
	
	// Companies - Guest - Keypasses
	__webpack_require__(292);
	var CompanyGuestKeypassesDetailCtrl = __webpack_require__(293);
	
	 //Companies - Guest - Wall
	var CompanyGuestWallDetailCtrl = __webpack_require__(305);
	
	//Companies - Guest - Plant
	var CompanyGuestPlantDetailCtrl = __webpack_require__(297);
	
	//Companies - Guest - Customer Adaption
	var CompanyGuestCustomerAdaptionDetailCtrl = __webpack_require__(288);
	
	//companies - Guest - Engine model
	var CompanyGuestEngineModelDetailCtrl = __webpack_require__(289);
	
	//Companies - Guest - Publication group
	var CompanyGuestPublicationGroupDetailCtrl = __webpack_require__(298);
	
	var CompanyGuestCompanyOrderDetailCtrl = __webpack_require__(287);
	
	var CompanyGuestPublicationOrderDetailCtrl = __webpack_require__(296);
	
	var CompanyGuestPublicationBlogDetailCtrl = __webpack_require__(285);
	
	// Address book
	__webpack_require__(55);
	var AddressBookCtrl = __webpack_require__(55);
	var CompanyAddressBookCtrl = __webpack_require__(308);
	
	//Comments
	__webpack_require__(322);
	__webpack_require__(325);
	var CompanyCommentsCtrl = __webpack_require__(323);
	var CompanyMessageDetailCtrl = __webpack_require__(37);
	var CompanyShareLinksCtrl = __webpack_require__(326);
	
	//Customers dashboard
	var CompanyCustomersDashboardCtrl = __webpack_require__(335);
	var CompanyCustomerDetailCtrl = __webpack_require__(334);
	
	var CompanyCustomerServiceListCtrl = __webpack_require__(332);
	
	var CompanyTimestampDetailCtrl = __webpack_require__(423);
	
	var CompanyGdprContactListCtrl = __webpack_require__(356);
	var CompanyGdprContactNewCtrl = __webpack_require__(357);
	var CompanyGdprContactEditCtrl = __webpack_require__(355);
	
	//Publication Order Report
	var CompanyPublicationOrderReportCtrl = __webpack_require__(403);
	
	//Publication Plant Report
	var CompanyPublicationPlantReportCtrl = __webpack_require__(405);
	
	//Company Investigation List View
	var CompanyInvestigationListCtrl = __webpack_require__(360);
	
	//Company Checklist
	var CompanyChecklistCtrl = __webpack_require__(321);
	
	// Company User roles
	var CompanyUserRoleCtrl = __webpack_require__(425);
	var CompanyUserRoleListCtrl = __webpack_require__(427);
	var CompanyUserRoleEditCtrl = __webpack_require__(426);
	__webpack_require__(428);
	
	// Company deviation watchers
	var CompanyDeviationWatcherListCtrl = __webpack_require__(339);
	var CompanyDeviationWatcherNewCtrl = __webpack_require__(340);
	var CompanyDeviationWatcherEditCtrl = __webpack_require__(338);
	
	// Email to Object
	var EmailToObjectCtrl = __webpack_require__(341);
	var EmailToObjectListCtrl = __webpack_require__(343);
	var EmailToObjectEditCtrl = __webpack_require__(342);
	__webpack_require__(344);
	
	// Email to task
	var EmailToTaskCtrl = __webpack_require__(346);
	var EmailToTaskListCtrl = __webpack_require__(348);
	var EmailToTaskEditCtrl = __webpack_require__(347);
	__webpack_require__(349);
	
	function config(
	  $stateProvider,
	  $urlRouterProvider,
	  $locationProvider
	) {
	  $locationProvider.html5Mode(true);
	  $locationProvider.hashPrefix('!');
	
	  $stateProvider
	    .state('reset', {
	      url: '/reset-password',
	      templateUrl: 'partials/reset-password.html',
	      controller: 'ResetPasswordCtrl',
	      resolve: ResetPasswordCtrl.resolve,
	      data: {
	        class: "login__body",
	        tab: "reset"
	      }
	    })
	    .state('user-reset-password', {
	      url: '/users/:userId/reset-password?code',
	      templateUrl: 'partials/user-reset-password.html',
	      controller: 'UsersResetPasswordCtrl',
	      resolve: UsersResetPasswordCtrl.resolve
	    })
	    .state('activate', {
	      url: '/users/activate?code&email&company',
	      templateUrl: 'partials/signup.html',
	      controller: 'UserActivateCtrl',
	      data: {
	        class: "login__body"
	      }
	    })
	    // Activate alias
	    .state('activate-alias', {
	      url: '/users/activate-alias?code&email',
	      controller: 'UserActivateAliasCtrl'
	    })
	
	
	    // Error pages
	    .state('403', {
	      url: "/403",
	      templateUrl: 'partials/errors/403.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve,
	      data: {
	        class: "error__body"
	      }
	    })
	    .state('404', {
	      url: "/404",
	      templateUrl: 'partials/errors/404.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve,
	      data: {
	        class: "error__body"
	      }
	    })
	    .state('error', {
	      url: "/error",
	      templateUrl: 'partials/errors/error.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve
	    })
	
	    .state('root', {
	      views: {
	        "": {
	          templateUrl: 'partials/main.html',
	          controller: 'RootCtrl',
	          resolve: RootCtrl.resolve
	        },
	        'header@root': {
	          templateUrl: "partials/header.html"
	        }
	      },
	      resolve: RootCtrl.resolve
	    })
	    .state('root.publication-collabration', {
	      url: '/publication-collabrations/:publicationId?showInvisible&page&searchFile',
	      abstract: true,
	      templateUrl: 'partials/publication-collabrations/main.html',
	      controller: 'PublicationCollabrationCtrl',
	      resolve: PublicationCollabrationCtrl.resolve
	    })
	    .state('root.publication-collabration.detail', {
	      url: '',
	      templateUrl: 'partials/publication-collabrations/detail.html',
	      controller: 'PublicationCollabrationDetailCtrl',
	      resolve: PublicationCollabrationDetailCtrl.resolve
	    })
	
	    // How it works
	    .state('root.markdown', {
	      url: '/markdown-help',
	      templateUrl: 'partials/how-it-works/how-it-works.html',
	      controller: 'HowToCtrl',
	      resolve: HowToCtrl.resolve
	    })
	
	    // Company
	    .state('root.company', {
	      url: '/companies/:companyId?userType&pageCat&showAll&type',
	      abstract: true,
	      views: {
	        'header@root': {
	          templateUrl: 'partials/company/header.html',
	          controller: 'CompanyNavCtrl',
	          resolve: CompanyNavCtrl.resolve
	        },
	        '': {
	          templateUrl: 'partials/company/main.html',
	          controller: 'CompanyCtrl',
	        }
	      },
	      resolve: CompanyCtrl.resolve
	    })
	
	    // Menu
	    .state('root.company.menu', {
	      url: '/menu',
	      templateUrl: 'partials/company/menu-top.html',
	      controller: 'CompanyMenuTopCtrl',
	      resolve: CompanyMenuTopCtrl.resolve
	    })
	
	    // Company guests
	    .state('root.company-guest', {
	      url: '/companies/:companyId/guest',
	      views: {
	        'header@root': {
	          templateUrl: 'partials/company-guest/header.html',
	          controller: 'CompanyGuestNavCtrl',
	          resolve: CompanyGuestNavCtrl.resolve
	        },
	        '': {
	          templateUrl: 'partials/company-guest/main.html',
	          controller: 'CompanyGuestCtrl',
	          resolve: CompanyGuestCtrl.resolve
	        }
	      },
	      resolve: CompanyGuestCtrl.resolve
	    })
	
	    .state('root.company-guest.comments', {
	      url: '/comments?query&page&orderBy&type',
	      templateUrl: 'partials/company-guest/comments/main.html',
	      controller: 'CompanyGuestCommentsCtrl',
	      resolve: CompanyGuestCommentsCtrl.resolve
	    })
	
	    // Company guests publication
	    .state('root.company-guest.publications', {
	      url: '/publications',
	      templateUrl: 'partials/company-guest/publications/main.html',
	      controller: 'CompanyGuestPublicationsCtrl',
	      resolve: CompanyGuestPublicationsCtrl.resolve
	    })
	    .state('root.company-guest.publications.list', {
	      url: '/?q&qType&page&groupId&categoryId&reference&keypass&type',
	      templateUrl: 'partials/company-guest/publications/list.html',
	      controller: 'CompanyGuestPublicationsListCtrl',
	      resolve: CompanyGuestPublicationsListCtrl.resolve
	    })
	    .state('root.company-guest.publications.listStarred', {
	      url: '/starred?page',
	      templateUrl: 'partials/company-guest/publications/list.html',
	      controller: 'CompanyGuestPublicationsListStarredCtrl',
	      resolve: CompanyGuestPublicationsListStarredCtrl.resolve
	    })
	    .state('root.company-guest.publications.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestPublicationsDetailCtrl',
	      resolve: CompanyGuestPublicationsDetailCtrl.resolve
	    })
	    .state('root.company-guest.profiles', {
	      url: '/profiles?page&emailPrefix&type',
	      templateUrl: 'partials/company-guest/profiles/list.html',
	      controller: 'CompanyGuestUsersListCtrl',
	      resolve: CompanyGuestUsersListCtrl.resolve
	    })
	    .state('root.company-guest.profile', {
	      url: '/profiles/:userId',
	      templateUrl: 'partials/company-guest/profiles/profile.html',
	      controller: 'CompanyGuestUsersProfileCtrl',
	      resolve: CompanyGuestUsersProfileCtrl.resolve
	    })
	
	    // Company guest folders:
	    .state('root.company-guest.folder', {
	      url: '/folder',
	      templateUrl: 'partials/company-guest/folders/main.html',
	      controller: 'CompanyGuestFoldersCtrl'
	    })
	    .state('root.company-guest.folder.detail', {
	      url: '/:publicationId?page&searchFile',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestFoldersDetailCtrl',
	      resolve: CompanyGuestFoldersDetailCtrl.resolve
	    })
	
	    // Company guest albums:
	    .state('root.company-guest.album', {
	      url: '/album/:publicationId',
	      templateUrl: 'partials/company-guest/albums/main.html',
	      abstract: true,
	      controller: 'CompanyGuestAlbumsCtrl',
	      resolve: CompanyGuestAlbumsCtrl.resolve
	    })
	    .state('root.company-guest.album.detail', {
	      url: '?showInvisible&page&searchFile',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestAlbumsDetailCtrl',
	      resolve: CompanyGuestAlbumsDetailCtrl.resolve
	    })
	
	    // Company guest sk3 folder:
	    .state('root.company-guest.sk3-folder', {
	      url: '/sk3-folder/:publicationId',
	      templateUrl: 'partials/company-guest/sk3-folder/main.html',
	      abstract: true,
	      controller: 'CompanyGuestAlbumsCtrl',
	      resolve: CompanyGuestAlbumsCtrl.resolve
	    })
	    .state('root.company-guest.sk3-folder.detail', {
	      url: '?showInvisible&page&searchFile',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestAlbumsDetailCtrl',
	      resolve: CompanyGuestAlbumsDetailCtrl.resolve
	    })
	
	    // Company guest notes:
	    .state('root.company-guest.note', {
	      url: '/note',
	      templateUrl: 'partials/company-guest/notes/main.html',
	      controller: 'CompanyGuestNotesCtrl'
	    })
	    .state('root.company-guest.note.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestNotesDetailCtrl',
	      resolve: CompanyGuestNotesDetailCtrl.resolve
	    })
	
	    // Company guest keypass:
	    .state('root.company-guest.keypass', {
	      url: '/keypass',
	      templateUrl: 'partials/company-guest/keypasses/main.html',
	      controller: 'CompanyGuestKeypassesCtrl'
	    })
	
	    .state('root.company-guest.keypass.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestKeypassesDetailCtrl',
	      resolve: CompanyGuestKeypassesDetailCtrl.resolve
	    })
	
	    // Company guest Wall:
	    .state('root.company-guest.wall', {
	      url: '/wall',
	      templateUrl: 'partials/company-guest/wall/main.html'
	    })
	
	    .state('root.company-guest.wall.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestWallDetailCtrl',
	      resolve: CompanyGuestWallDetailCtrl.resolve
	    })
	
	    // Company guest Plant:
	    .state('root.company-guest.plant', {
	      url: '/plant',
	      templateUrl: 'partials/company-guest/plants/main.html'
	    })
	
	    .state('root.company-guest.plant.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestPlantDetailCtrl',
	      resolve: CompanyGuestPlantDetailCtrl.resolve
	    })
	
	    // Company guest customer adaption
	    .state('root.company-guest.customer-adaption', {
	      url: '/customer_adaption',
	      templateUrl: 'partials/company-guest/customer-adaption/main.html'
	    })
	
	    .state('root.company-guest.customer-adaption.detail', {
	      url: '/:publicationId?page&searchFile',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestCustomerAdaptionDetailCtrl',
	      resolve: CompanyGuestCustomerAdaptionDetailCtrl.resolve
	    })
	
	    // Company guest engine model
	    .state('root.company-guest.engine-model', {
	      url: '/engine_model',
	      templateUrl: 'partials/company-guest/engine-model/main.html'
	    })
	
	    .state('root.company-guest.engine-model.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestEngineModelDetailCtrl',
	      resolve: CompanyGuestEngineModelDetailCtrl.resolve
	    })
	
	    // Company guest publication group
	    .state('root.company-guest.publication-group', {
	      url: '/publication_group',
	      templateUrl: 'partials/company-guest/publication-group/main.html'
	    })
	
	    .state('root.company-guest.publication-group.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestPublicationGroupDetailCtrl',
	      resolve: CompanyGuestPublicationGroupDetailCtrl.resolve
	    })
	
	    // Company guest company order
	    .state('root.company-guest.company-order', {
	      url: '/company_order',
	      templateUrl: 'partials/company-guest/company-order/main.html'
	    })
	
	    .state('root.company-guest.company-order.detail', {
	      url: '/:publicationId?page&searchFile',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestCompanyOrderDetailCtrl',
	      resolve: CompanyGuestCompanyOrderDetailCtrl.resolve
	    })
	
	    // Company guest company order
	    .state('root.company-guest.order', {
	      url: '/order',
	      templateUrl: 'partials/company-guest/order/main.html'
	    })
	
	    .state('root.company-guest.order.detail', {
	      url: '/:publicationId',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestPublicationOrderDetailCtrl',
	      resolve: CompanyGuestPublicationOrderDetailCtrl.resolve
	    })
	
	    // Company guest blog
	    .state('root.company-guest.blog', {
	      url: '/blog',
	      templateUrl: 'partials/company-guest/blog/main.html'
	    })
	
	    .state('root.company-guest.blog.detail', {
	      url: '/:publicationId?page',
	      templateUrl: 'partials/company-guest/publications/detail.html',
	      controller: 'CompanyGuestPublicationBlogDetailCtrl',
	      resolve: CompanyGuestPublicationBlogDetailCtrl.resolve
	    })
	
	    // Company settings
	    .state('root.company.account.settings', {
	      url: '/settings',
	      templateUrl: 'partials/company/settings/settings.html',
	      controller: 'CompanySettingsCtrl',
	      data: {
	        ext_class: 'company-account__moving-top'
	      }
	    })
	    .state('root.company.account.settings.three-login', {
	      url: '/three-login',
	      views: {
	        "settings": {
	            templateUrl: 'partials/company/settings/three-login.html',
	            controller: 'CompanySettingThreeLoginCtrl',
	            resolve: CompanySettingThreeLoginCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.statuses', {
	      url: '/statuses',
	      views: {
	        "settings": {
	            templateUrl: 'partials/company/settings/statuses.html',
	            controller: 'CompanySettingStatusesCtrl',
	            resolve: CompanySettingStatusesCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.taskCategories', {
	      url: '/task-categories',
	      views: {
	        "settings": {
	            templateUrl: 'partials/company/settings/task-categories.html',
	            controller: 'CompanySettingTaskCategoriesCtrl',
	            resolve: CompanySettingTaskCategoriesCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.noticeCategories', {
	      url: '/notice-categories',
	      views: {
	        "settings": {
	            templateUrl: 'partials/company/settings/notice-categories.html',
	            controller: 'CompanySettingNoticeCategoriesCtrl',
	            resolve: CompanySettingNoticeCategoriesCtrl.resolve 
	        }
	      }
	    })
	
	    .state('root.company.account.settings.categories', {
	      url: '/categories',
	      views: {
	        "settings": {
	          templateUrl: 'partials/company/settings/categories.html',
	          controller: 'CompanySettingCategoriesCtrl',
	          resolve: CompanySettingCategoriesCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.portal-categories', {
	      url: '/portal-categories',
	      views: {
	        "settings": {
	          templateUrl: 'partials/company/settings/portal-categories.html',
	          controller: 'CompanySettingCategoryGroupsCtrl',
	          resolve: CompanySettingCategoryGroupsCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.task-statuses', {
	      url: '/task-statuses',
	      views: {
	        "settings": {
	          templateUrl: 'partials/company/settings/task-statuses.html',
	          controller: 'CompanySettingTaskStatusesCtrl',
	          resolve: CompanySettingTaskStatusesCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.task-types', {
	      url: '/task-types',
	      views: {
	        "settings": {
	          templateUrl: 'partials/company/settings/task-types.html',
	          controller: 'CompanySettingTaskTypesCtrl',
	          resolve: CompanySettingTaskTypesCtrl.resolve
	        }
	      }
	    })
	
	    .state('root.company.account.settings.classes', {
	      url: '/classes',
	      views: {
	        "settings": {
	          templateUrl: 'partials/company/settings/classes.html',
	          controller: 'CompanySettingGroupsCtrl',
	          resolve: CompanySettingGroupsCtrl.resolve
	        }
	      }
	    })
	    .state('root.company.account.settings.classes-detail', {
	      url: '/classes/:groupId',
	      templateUrl: 'partials/company/settings/classes/edit.html',
	      controller: 'CompanySettingsClassesCtrl',
	      resolve: CompanySettingsClassesCtrl.resolve,
	      data: {
	        ext_class: ''
	      }
	    })
	
	    // Company default group
	    .state('root.company.account.settings.default-group', {
	      url: '/default-group',
	      templateUrl: 'partials/company/settings/default-group/default-group.html',
	      controller: 'CompanyDefaultGroupCtrl',
	      resolve: CompanyDefaultGroupCtrl.resolve,
	      data: {
	        ext_class: ''
	      }
	    })
	
	    // Company account
	    .state('root.company.account', {
	      abstract: true,
	      url: '/account?uType',
	      templateUrl: 'partials/company/account/account.html',
	      controller: 'CompanyAccountCtrl',
	      resolve: CompanyAccountCtrl.resolve
	    })
	
	    .state('root.company.account.detail', {
	      url: '/detail',
	      templateUrl: 'partials/company/account/detail/details.html',
	      controller: 'CompanyDetailCtrl',
	      resolve: CompanyDetailCtrl.resolve
	    })
	
	    .state('root.company.account.information', {
	      url: '/information',
	      templateUrl: 'partials/company/account/detail/presentation.html'
	    })
	
	    .state('root.company.account.embed', {
	      url: '/embed',
	      templateUrl: 'partials/company/account/detail/embed.html',
	      controller: 'CompanyEmbedCtrl'
	    })
	
	    .state('root.company.account.tagSuggestion', {
	      url: '/tag-suggestion',
	      templateUrl: 'partials/company/account/detail/smartphone.html',
	      controller: 'CompanyTagSuggestionCtrl',
	      resolve: CompanyTagSuggestionCtrl.resolve
	    })
	
	    .state('root.company.account.flow-verify', {
	      url: '/flow-verify/:flowVerifyID',
	      templateUrl: 'partials/company/account/detail/flow-verify-detail.html',
	      controller: 'CompanyFlowVerifyDetailCtrl',
	      resolve: CompanyFlowVerifyDetailCtrl.resolve
	    })
	    .state('root.company.account.checklist', {
	      url: '/checklist',
	      templateUrl: 'partials/company/checklist/list.html',
	      controller: 'CompanyChecklistCtrl',
	      resolve: CompanyChecklistCtrl.resolve
	    })
	
	    .state('root.company.investigation-list', {
	      url: '/investigation-list?page&status&qInves&step',
	      templateUrl: 'partials/company/investigation-list/main.html',
	      controller: 'CompanyInvestigationListCtrl',
	      resolve: CompanyInvestigationListCtrl.resolve
	    })
	
	    // Company publications
	    .state('root.company.publications-list', {
	      url: '/?q&qType&qTypeObject&categoryId&priorityId&groupId&tags&page&pageCat&reference&keypass&from&to&orderby&openSearchSidebar&edit&asc&togFilter&year&month',
	      templateUrl: 'partials/company/publications/list.html',
	      controller: 'CompanyPublicationsListCtrl',
	      resolve: CompanyPublicationsListCtrl.resolve
	    })
	
	    //publications list
	    .state('root.company.publications-listDrafts', {
	      url: '/drafts?page&priorityId',
	      templateUrl: 'partials/company/publications/another-list.html',
	      controller: 'CompanyPublicationsListDraftsCtrl',
	      resolve: CompanyPublicationsListDraftsCtrl.resolve
	    })
	    .state('root.company.publications-listArchived', {
	      url: '/archived?q&qType&qTypeObject&page&priorityId&queryArchived',
	      templateUrl: 'partials/company/publications/another-list.html',
	      controller: 'CompanyPublicationsListArchivedCtrl',
	      resolve: CompanyPublicationsListArchivedCtrl.resolve
	    })
	    .state('root.company.publications-listStarred', {
	      url: '/starred?page&priorityId&queryStarred',
	      templateUrl: 'partials/company/publications/another-list.html',
	      controller: 'CompanyPublicationsListStarredCtrl',
	      resolve: CompanyPublicationsListStarredCtrl.resolve
	    })
	    .state('root.company.publications-listWatched', {
	      url: '/watched?page&queryWatched',
	      templateUrl: 'partials/company/publications/another-list.html',
	      controller: 'CompanyPublicationsListWatchedCtrl',
	      resolve: CompanyPublicationsListWatchedCtrl.resolve
	    })
	    .state('root.company.publications-flowVerifies', {
	      url: '/flow-verifies?page&manager&status',
	      templateUrl: 'partials/company/publications/flow-verify-list.html',
	      controller: 'CompanyPublicationsFlowVerifiesCtrl',
	      resolve: CompanyPublicationsFlowVerifiesCtrl.resolve
	    })
	    .state('root.company.publication-new', {
	      url: '/new?activeTab&pubCopyId',
	      templateUrl: 'partials/company/publications/create/view.html',
	      controller: 'CompanyPublicationsNewCtrl',
	      resolve: CompanyPublicationsNewCtrl.resolve
	    })
	    .state('root.company.publication', {
	      url: '/publications/:publicationId?fromPortal',
	      templateUrl: 'partials/company/publications/main.html',
	      abstract: true,
	      controller: 'CompanyPublicationCtrl',
	      resolve: CompanyPublicationCtrl.resolve
	    })
	    .state('root.company.publication.detail', {
	      url: '?showInvisible&page&searchFile',
	      templateUrl: 'partials/company/publications/detail/latest.html',
	      controller: 'CompanyPublicationDetailCtrl',
	      resolve: CompanyPublicationDetailCtrl.resolve
	    })
	    .state('root.company.publication.share-access', {
	      url: '/share-access?page',
	      templateUrl: 'partials/company/publications/detail/share-access.html',
	      controller: 'CompanyPublicationShareAccessCtrl',
	      resolve: CompanyPublicationShareAccessCtrl.resolve
	    })
	    .state('root.company.publication.versions', {
	      url: '/versions?page',
	      templateUrl: 'partials/company/publications/detail/versions.html',
	      controller: 'CompanyPublicationVersionsCtrl',
	      resolve: CompanyPublicationVersionsCtrl.resolve
	    })
	    .state('root.company.publication.index', {
	      url: '/index?page',
	      templateUrl: 'partials/company/publications/detail/index.html',
	      controller: 'CompanyPublicationIndexCtrl',
	      resolve: CompanyPublicationIndexCtrl.resolve
	    })
	    .state('root.company.publication.pdf-viewer', {
	      url: '/pdf-viewer',
	      templateUrl: 'partials/company/publications/detail/pdf-viewer.html'
	    })
	    .state('root.company.publication.order-report', {
	      url: '/order-report?page&from&to&t',
	      templateUrl: 'partials/company/publications/order-report/main.html',
	      controller: 'CompanyPublicationOrderReportCtrl',
	      resolve: CompanyPublicationOrderReportCtrl.resolve
	    })
	
	    .state('root.company.publication.plant-report', {
	      url: '/plant-report/:plantId?page&from&to&t',
	      templateUrl: 'partials/company/publications/plant-report/main.html',
	      controller: 'CompanyPublicationPlantReportCtrl',
	      resolve: CompanyPublicationPlantReportCtrl.resolve
	    })
	
	    // Company customer portals
	    .state('root.company.customerPortals', {
	      url: '/customer-portals',
	      templateUrl: 'partials/company/customer-portals/main.html',
	      controller: 'CompanyCustomerPortalsCtrl',
	      resolve: CompanyCustomerPortalsCtrl.resolve
	    })
	    .state('root.company.customerPortals.list', {
	      url: '/?page&userId&query&categoryId&tab',
	      templateUrl: 'partials/company/customer-portals/tab-main.html',
	      controller: 'CompanyCustomerPortalsListCtrl',
	      resolve: CompanyCustomerPortalsListCtrl.resolve
	    })
	    .state('root.company.customerPortals.new', {
	      url: '/new?publicationId&isCreateFormApp',
	      templateUrl: 'partials/company/customer-portals/form.html',
	      controller: 'CompanyCustomerPortalsNewCtrl',
	      resolve: CompanyCustomerPortalsNewCtrl.resolve
	    })
	    .state('root.company.customerPortals.detail', {
	      url: '/:customerPortalId?year&month&priorityId',
	      templateUrl: 'partials/company/customer-portals/detail.html',
	      controller: 'CompanyCustomerPortalsDetailCtrl',
	      resolve: CompanyCustomerPortalsDetailCtrl.resolve
	    })
	
	    // Form app submit group
	    .state('root.company.formAppGroups', {
	      url: '/form-app-groups',
	      templateUrl: 'partials/company/form-app-submit-group/main.html'
	    })
	    .state('root.company.formAppGroups.new', {
	      url: '/new',
	      templateUrl: 'partials/company/form-app-submit-group/form.html',
	      controller: 'FormAppSubmitGroupNewCtrl',
	      resolve: FormAppSubmitGroupNewCtrl.resolve
	    })
	    .state('root.company.formAppGroups.detail', {
	      url: '/:groupId',
	      templateUrl: 'partials/company/form-app-submit-group/detail.html',
	      controller: 'FormAppSubmitGroupDetailCtrl',
	      resolve: FormAppSubmitGroupDetailCtrl.resolve
	    })
	
	    // Address book:
	    .state('root.address-book', {
	      url: '/address-book',
	      templateUrl: 'partials/company/address-book.html',
	      controller: 'AddressBookCtrl',
	      resolve: AddressBookCtrl.resolve
	    })
	
	    // Address book:
	    .state('root.company.contacts', {
	      url: '/contacts',
	      templateUrl: 'partials/company/contacts.html',
	      controller: 'CompanyAddressBookCtrl',
	      resolve: CompanyAddressBookCtrl.resolve
	    })
	
	    .state('root.company.comments', {
	      url: '?query&page&orderBy&type',
	      templateUrl: 'partials/company/comments/main.html',
	      controller: 'CompanyCommentsCtrl',
	      resolve: CompanyCommentsCtrl.resolve
	    })
	
	    .state('root.company.comments.list', {
	      url: '/comments',
	      templateUrl: 'partials/company/comments/comments.html'
	    })
	
	    .state('root.company.comments.activities', {
	      url: '/activities',
	      templateUrl: 'partials/company/comments/audit-logs.html',
	      controller: 'CompanyActivitiesCtrl'
	    })
	
	    .state('root.company.comments.notifications', {
	      url: '/notifications',
	      templateUrl: 'partials/company/comments/notifications.html',
	      controller: 'CompanyNotificationsCtrl'
	    })
	
	    .state('root.company.comments.share-links', {
	      url: '/share-links?filter&active',
	      templateUrl: 'partials/company/comments/share-links.html',
	      controller: 'CompanyShareLinksCtrl',
	      resolve: CompanyShareLinksCtrl.resolve
	    })
	
	    .state('root.company.comments.messages', {
	      url: '/messages',
	      templateUrl: 'partials/company/comments/comments.html'
	    })
	
	    .state('root.company.message-new', {
	      url: '/messages/new',
	      templateUrl: 'partials/company/blogs/new.html',
	      controller: 'CompanyMessageDetailCtrl',
	      resolve: CompanyMessageDetailCtrl.resolve
	    })
	
	    .state('root.company.message-detail', {
	      url: '/messages/:messageId',
	      templateUrl: 'partials/company/blogs/detail.html',
	      controller: 'CompanyMessageDetailCtrl',
	      resolve: CompanyMessageDetailCtrl.resolve
	    })
	
	    .state('root.company.timestamps', {
	      url: '/timestamps',
	      templateUrl: 'partials/company/timestamps/main.html'
	    })
	
	    .state('root.company.timestamps.detail', {
	      url: '/?manual',
	      templateUrl: 'partials/company/timestamps/detail.html',
	      controller: 'CompanyTimestampDetailCtrl',
	      resolve: CompanyTimestampDetailCtrl.resolve
	    })
	
	    .state('root.company.customers-dashboard', {
	      url: '/customers-dashboard',
	      templateUrl: 'partials/company/customers-dashboard/main.html',
	      controller: 'CompanyCustomersDashboardCtrl',
	      resolve: CompanyCustomersDashboardCtrl.resolve
	    })
	
	    .state('root.company.customers-dashboard.detail', {
	      url: '/:customerId?tab',
	      templateUrl: 'partials/company/customers-dashboard/detail.html',
	      controller: 'CompanyCustomerDetailCtrl',
	      resolve: CompanyCustomerDetailCtrl.resolve
	    })
	
	    .state('root.company.customer-service', {
	      url: '/customer-service',
	      templateUrl: 'partials/company/customer-service/main.html',
	    })
	
	    .state('root.company.customer-service.list', {
	      url: '/?page&typeId?name?manager',
	      templateUrl: 'partials/company/customer-service/list.html',
	      controller: 'CompanyCustomerServiceListCtrl',
	      resolve: CompanyCustomerServiceListCtrl.resolve
	    })
	    // .state('root.company.edit-dashboard', {
	    //   url: '/user-roles/:roleId/dashboard',
	    //   templateUrl: 'partials/company/user-roles/edit-dashboard.html',
	    //   controller: 'CompanyUserRoleEditCtrl',
	    //   resolve: CompanyUserRoleEditCtrl.resolve
	    // })
	
	    // gdpr contacts
	    .state('root.company.account.gdpr-contacts', {
	      abstract: true,
	      url: '/gdpr-contacts',
	      templateUrl: 'partials/company/gdpr/contacts/main.html',
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	    .state('root.company.account.gdpr-contacts.list', {
	      url: '/?page',
	      templateUrl: 'partials/company/gdpr/contacts/list.html',
	      controller: 'CompanyGdprContactListCtrl',
	      resolve: CompanyGdprContactListCtrl.resolve
	    })
	
	    .state('root.company.account.gdpr-contacts.new', {
	      url: '/new',
	      templateUrl: 'partials/company/gdpr/contacts/new.html',
	      controller: 'CompanyGdprContactNewCtrl',
	      resolve: CompanyGdprContactNewCtrl.resolve
	    })
	
	    .state('root.company.account.gdpr-contacts.edit', {
	      url: '/:contactId',
	      templateUrl: 'partials/company/gdpr/contacts/edit.html',
	      controller: 'CompanyGdprContactEditCtrl',
	      resolve: CompanyGdprContactEditCtrl.resolve
	    })
	
	    .state('root.company.account.user-roles', {
	      abstract: true,
	      url: '/user-roles',
	      templateUrl: 'partials/company/user-roles/main.html',
	      controller: 'CompanyUserRoleCtrl',
	      resolve: CompanyUserRoleCtrl.resolve
	    })
	    .state('root.company.account.user-roles.list', {
	      url: '/list?page',
	      templateUrl: 'partials/company/user-roles/list.html',
	      controller: 'CompanyUserRoleListCtrl',
	      resolve: CompanyUserRoleListCtrl.resolve,
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	    .state('root.company.account.user-roles.new', {
	      url: '/new',
	      templateUrl: 'partials/company/user-roles/new.html',
	      controller: 'CompanyUserRoleNewCtrl',
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	    .state('root.company.account.user-roles.edit', {
	      url: '/:roleId',
	      templateUrl: 'partials/company/user-roles/edit.html',
	      controller: 'CompanyUserRoleEditCtrl',
	      resolve: CompanyUserRoleEditCtrl.resolve,
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	
	    .state('root.company.account.deviation-settings', {
	      url: '/deviation-settings',
	      templateUrl: 'partials/company/settings/deviation-settings.html'
	    })
	
	    .state('root.company.account.deviation-watchers', {
	      abstract: true,
	      url: '/deviation-watchers',
	      templateUrl: 'partials/company/deviation-watchers/main.html'
	    })
	    .state('root.company.account.deviation-watchers.list', {
	      url: '/list?page',
	      templateUrl: 'partials/company/deviation-watchers/list.html',
	      controller: 'CompanyDeviationWatcherListCtrl',
	      resolve: CompanyDeviationWatcherListCtrl.resolve,
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	    .state('root.company.account.deviation-watchers.new', {
	      url: '/new',
	      templateUrl: 'partials/company/deviation-watchers/new.html',
	      controller: 'CompanyDeviationWatcherNewCtrl',
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	    .state('root.company.account.deviation-watchers.edit', {
	      url: '/:deviationWatcherId',
	      templateUrl: 'partials/company/deviation-watchers/edit.html',
	      controller: 'CompanyDeviationWatcherEditCtrl',
	      resolve: CompanyDeviationWatcherEditCtrl.resolve,
	      data: {
	        ext_class: "company-account__moving-top"
	      }
	    })
	
	    .state('root.company.account.email', {
	      url: '/emails',
	      controller: 'EmailToObjectCtrl',
	      templateUrl: 'partials/company/email-to-object/main.html',
	      resolve: EmailToObjectCtrl.resolve
	    })
	
	    .state('root.company.account.email.list', {
	      url: '/list?page',
	      templateUrl: 'partials/company/email-to-object/list.html',
	      controller: 'EmailToObjectListCtrl',
	      resolve: EmailToObjectListCtrl.resolve,
	    })
	
	    .state('root.company.account.email.new', {
	      url: '/new',
	      templateUrl: 'partials/company/email-to-object/new.html',
	      controller: 'EmailToObjectNewCtrl'
	    })
	
	    .state('root.company.account.email.edit', {
	      url: '/:emailId',
	      templateUrl: 'partials/company/email-to-object/edit.html',
	      controller: 'EmailToObjectEditCtrl',
	      resolve: EmailToObjectEditCtrl.resolve
	    })
	
	    // email to task
	    .state('root.company.account.email-to-task', {
	      url: '/email-to-task',
	      controller: 'EmailToTaskCtrl',
	      templateUrl: 'partials/company/email-to-task/main.html',
	      resolve: EmailToTaskCtrl.resolve
	    })
	
	    .state('root.company.account.email-to-task.list', {
	      url: '/list?page',
	      templateUrl: 'partials/company/email-to-task/list.html',
	      controller: 'EmailToTaskListCtrl',
	      resolve: EmailToTaskListCtrl.resolve,
	    })
	
	    .state('root.company.account.email-to-task.new', {
	      url: '/new',
	      templateUrl: 'partials/company/email-to-task/new.html',
	      controller: 'EmailToTaskNewCtrl'
	    })
	
	    .state('root.company.account.email-to-task.edit', {
	      url: '/:emailToTaskId',
	      templateUrl: 'partials/company/email-to-task/edit.html',
	      controller: 'EmailToTaskEditCtrl',
	      resolve: EmailToTaskEditCtrl.resolve
	    })
	
	    // Company error pages
	    .state('root.company.403', {
	      templateUrl: 'partials/errors/403.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve
	    })
	    .state('root.company.error', {
	      templateUrl: 'partials/errors/error.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve
	    })
	    .state('root.company.404', {
	      templateUrl: 'partials/errors/404.html',
	      controller: 'ErrorCtrl',
	      resolve: ErrorCtrl.resolve
	    });
	}
	
	angular.module('dokiv')
	  .config([
	    '$stateProvider',
	    '$urlRouterProvider',
	    '$locationProvider',
	    config
	  ]);


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	function PwCheckDirective() {
	  return {
	    require: 'ngModel',
	    link: function($scope, elem, attrs, ctrl) {
	      var firstPassword = '#' + attrs.pwCheck;
	      elem.add(firstPassword).on('keyup', function () {
	        $scope.$apply(function () {
	          var v = elem.val() === $(firstPassword).val();
	          ctrl.$setValidity('pwmatch', v);
	        });
	      });
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('pwCheck', [PwCheckDirective]);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(21);
	
	function UserActivateAliasCtrl(
	  UserService,
	  $state,
	  $stateParams) {
	  UserService.getActivateAlias({code: decodeURIComponent($stateParams.code), email: decodeURIComponent($stateParams.email)}).$promise.then(function() {
	    $state.go("login", {}, { inherit: false });
	  }, function() {
	    $state.go("404");
	  });
	}
	
	angular.module('dokiv')
	  .controller('UserActivateAliasCtrl', [
	    'UserService',
	    '$state',
	    '$stateParams', UserActivateAliasCtrl]);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(437);
	
	var DEFAULT_INITIALS = ["U"];
	
	function firstChar(n) {
	  return n.substr(0, 1);
	}
	
	function upperCase(c) {
	  return c.toUpperCase();
	}
	
	function getParts(user) {
	  if(typeof user.name === "string" && user.name.trim().length > 0) {
	    return user.name.split(' ');
	  }
	  else if(typeof user.email === "string" && user.email.trim().length > 0) {
	    return user.email.split(/[^a-z0-9_]/i);
	  }
	  else {
	    return DEFAULT_INITIALS;
	  }
	}
	
	function getInitials(user) {
	  return getParts(user).map(firstChar).map(upperCase).join("").substr(0, 3);
	}
	
	function UserAvatarDirective(config) {
	  return {
	    restrict: 'A',
	    replace:  true,
	    template: '<div class="user-avatar"></div>',
	    scope: {
	      user: '=userAvatar'
	    },
	    link: function($scope, $elem) {
	      var $initial = angular.element('<div class="user-avatar__initials">');
	      var $text    = angular.element('<span>');
	
	      $text.text(getInitials($scope.user));
	
	      $initial.append($text);
	      $elem.append($initial);
	
	      function updateAvatar() {
	        if( ! $scope.user.id) {
	          return;
	        }
	
	        var $img = angular.element('<img />');
	
	        $img.on("load", function() {
	          $initial.remove();
	          $elem.append($img);
	        });
	
	        $img.attr('src', config.apiBase + '/users/' + $scope.user.id + '/avatar');
	      }
	
	      $scope.$on('avatarChanged', updateAvatar);
	
	      updateAvatar();
	    }
	  };
	}
	
	angular.module('dokiv')
	  .directive('userAvatar', ['config', UserAvatarDirective]);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	'use strict';
	
	function UserAvatarService($resource, config) {
	  return $resource(config.apiBase + '/users/:userId/avatar');
	}
	
	angular.module('dokiv')
	  .factory('UserAvatarService', ['$resource', 'config', UserAvatarService]);
	
	


/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.20
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/* jshint maxlen: false */
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for JavaScript, CSS3 transition and CSS3 keyframe animation hooks within existing core and custom directives.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 *
	 * To see animations in action, all that is required is to define the appropriate CSS classes
	 * or to register a JavaScript animation via the `myModule.animation()` function. The directives that support animation automatically are:
	 * `ngRepeat`, `ngInclude`, `ngIf`, `ngSwitch`, `ngShow`, `ngHide`, `ngView` and `ngClass`. Custom directives can take advantage of animation
	 * by using the `$animate` service.
	 *
	 * Below is a more detailed breakdown of the supported animation events provided by pre-existing ng directives:
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * You can find out more information about animations upon visiting each directive page.
	 *
	 * Below is an example of how to apply animations to a directive that supports animation hooks:
	 *
	 * ```html
	 * <style type="text/css">
	 * .slide.ng-enter, .slide.ng-leave {
	 *   -webkit-transition:0.5s linear all;
	 *   transition:0.5s linear all;
	 * }
	 *
	 * .slide.ng-enter { }        /&#42; starting animations for enter &#42;/
	 * .slide.ng-enter.ng-enter-active { } /&#42; terminal animations for enter &#42;/
	 * .slide.ng-leave { }        /&#42; starting animations for leave &#42;/
	 * .slide.ng-leave.ng-leave-active { } /&#42; terminal animations for leave &#42;/
	 * </style>
	 *
	 * <!--
	 * the animate service will automatically add .ng-enter and .ng-leave to the element
	 * to trigger the CSS transition/animations
	 * -->
	 * <ANY class="slide" ng-include="..."></ANY>
	 * ```
	 *
	 * Keep in mind that, by default, if an animation is running, any child elements cannot be animated
	 * until the parent element's animation has completed. This blocking feature can be overridden by
	 * placing the `ng-animate-children` attribute on a parent container tag.
	 *
	 * ```html
	 * <div class="slide-animation" ng-if="on" ng-animate-children>
	 *   <div class="fade-animation" ng-if="on">
	 *     <div class="explode-animation" ng-if="on">
	 *        ...
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * When the `on` expression value changes and an animation is triggered then each of the elements within
	 * will all animate without the block being applied to child elements.
	 *
	 * ## Are animations run when the application starts?
	 * No they are not. When an application is bootstrapped Angular will disable animations from running to avoid
	 * a frenzy of animations from being triggered as soon as the browser has rendered the screen. For this to work,
	 * Angular will wait for two digest cycles until enabling animations. From there on, any animation-triggering
	 * layout changes in the application will trigger animations as normal.
	 *
	 * In addition, upon bootstrap, if the routing system or any directives or load remote data (via $http) then Angular
	 * will automatically extend the wait time to enable animations once **all** of the outbound HTTP requests
	 * are complete.
	 *
	 * ## CSS-defined Animations
	 * The animate service will automatically apply two CSS classes to the animated element and these two CSS classes
	 * are designed to contain the start and end CSS styling. Both CSS transitions and keyframe animations are supported
	 * and can be used to play along with this naming structure.
	 *
	 * The following code below demonstrates how to perform animations using **CSS transitions** with Angular:
	 *
	 * ```html
	 * <style type="text/css">
	 * /&#42;
	 *  The animate class is apart of the element and the ng-enter class
	 *  is attached to the element once the enter animation event is triggered
	 * &#42;/
	 * .reveal-animation.ng-enter {
	 *  -webkit-transition: 1s linear all; /&#42; Safari/Chrome &#42;/
	 *  transition: 1s linear all; /&#42; All other modern browsers and IE10+ &#42;/
	 *
	 *  /&#42; The animation preparation code &#42;/
	 *  opacity: 0;
	 * }
	 *
	 * /&#42;
	 *  Keep in mind that you want to combine both CSS
	 *  classes together to avoid any CSS-specificity
	 *  conflicts
	 * &#42;/
	 * .reveal-animation.ng-enter.ng-enter-active {
	 *  /&#42; The animation code itself &#42;/
	 *  opacity: 1;
	 * }
	 * </style>
	 *
	 * <div class="view-container">
	 *   <div ng-view class="reveal-animation"></div>
	 * </div>
	 * ```
	 *
	 * The following code below demonstrates how to perform animations using **CSS animations** with Angular:
	 *
	 * ```html
	 * <style type="text/css">
	 * .reveal-animation.ng-enter {
	 *   -webkit-animation: enter_sequence 1s linear; /&#42; Safari/Chrome &#42;/
	 *   animation: enter_sequence 1s linear; /&#42; IE10+ and Future Browsers &#42;/
	 * }
	 * @-webkit-keyframes enter_sequence {
	 *   from { opacity:0; }
	 *   to { opacity:1; }
	 * }
	 * @keyframes enter_sequence {
	 *   from { opacity:0; }
	 *   to { opacity:1; }
	 * }
	 * </style>
	 *
	 * <div class="view-container">
	 *   <div ng-view class="reveal-animation"></div>
	 * </div>
	 * ```
	 *
	 * Both CSS3 animations and transitions can be used together and the animate service will figure out the correct duration and delay timing.
	 *
	 * Upon DOM mutation, the event class is added first (something like `ng-enter`), then the browser prepares itself to add
	 * the active class (in this case `ng-enter-active`) which then triggers the animation. The animation module will automatically
	 * detect the CSS code to determine when the animation ends. Once the animation is over then both CSS classes will be
	 * removed from the DOM. If a browser does not support CSS transitions or CSS animations then the animation will start and end
	 * immediately resulting in a DOM element that is at its final state. This final state is when the DOM element
	 * has no CSS transition/animation classes applied to it.
	 *
	 * ### Structural transition animations
	 *
	 * Structural transitions (such as enter, leave and move) will always apply a `0s none` transition
	 * value to force the browser into rendering the styles defined in the setup (`.ng-enter`, `.ng-leave`
	 * or `.ng-move`) class. This means that any active transition animations operating on the element
	 * will be cut off to make way for the enter, leave or move animation.
	 *
	 * ### Class-based transition animations
	 *
	 * Class-based transitions refer to transition animations that are triggered when a CSS class is
	 * added to or removed from the element (via `$animate.addClass`, `$animate.removeClass`,
	 * `$animate.setClass`, or by directives such as `ngClass`, `ngModel` and `form`).
	 * They are different when compared to structural animations since they **do not cancel existing
	 * animations** nor do they **block successive transitions** from rendering on the same element.
	 * This distinction allows for **multiple class-based transitions** to be performed on the same element.
	 *
	 * In addition to ngAnimate supporting the default (natural) functionality of class-based transition
	 * animations, ngAnimate also decorates the element with starting and ending CSS classes to aid the
	 * developer in further styling the element throughout the transition animation. Earlier versions
	 * of ngAnimate may have caused natural CSS transitions to break and not render properly due to
	 * $animate temporarily blocking transitions using `0s none` in order to allow the setup CSS class
	 * (the `-add` or `-remove` class) to be applied without triggering an animation. However, as of
	 * **version 1.3**, this workaround has been removed with ngAnimate and all non-ngAnimate CSS
	 * class transitions are compatible with ngAnimate.
	 *
	 * There is, however, one special case when dealing with class-based transitions in ngAnimate.
	 * When rendering class-based transitions that make use of the setup and active CSS classes
	 * (e.g. `.fade-add` and `.fade-add-active` for when `.fade` is added) be sure to define
	 * the transition value **on the active CSS class** and not the setup class.
	 *
	 * ```css
	 * .fade-add {
	 *   /&#42; remember to place a 0s transition here
	 *      to ensure that the styles are applied instantly
	 *      even if the element already has a transition style &#42;/
	 *   transition:0s linear all;
	 *
	 *   /&#42; starting CSS styles &#42;/
	 *   opacity:1;
	 * }
	 * .fade-add.fade-add-active {
	 *   /&#42; this will be the length of the animation &#42;/
	 *   transition:1s linear all;
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * The setup CSS class (in this case `.fade-add`) also has a transition style property, however, it
	 * has a duration of zero. This may not be required, however, incase the browser is unable to render
	 * the styling present in this CSS class instantly then it could be that the browser is attempting
	 * to perform an unnecessary transition.
	 *
	 * This workaround, however, does not apply to  standard class-based transitions that are rendered
	 * when a CSS class containing a transition is applied to an element:
	 *
	 * ```css
	 * /&#42; this works as expected &#42;/
	 * .fade {
	 *   transition:1s linear all;
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * Please keep this in mind when coding the CSS markup that will be used within class-based transitions.
	 * Also, try not to mix the two class-based animation flavors together since the CSS code may become
	 * overly complex.
	 *
	 *
	 * ### Preventing Collisions With Third Party Libraries
	 *
	 * Some third-party frameworks place animation duration defaults across many element or className
	 * selectors in order to make their code small and reuseable. This can lead to issues with ngAnimate, which
	 * is expecting actual animations on these elements and has to wait for their completion.
	 *
	 * You can prevent this unwanted behavior by using a prefix on all your animation classes:
	 *
	 * ```css
	 * /&#42; prefixed with animate- &#42;/
	 * .animate-fade-add.animate-fade-add-active {
	 *   transition:1s linear all;
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * You then configure `$animate` to enforce this prefix:
	 *
	 * ```js
	 * $animateProvider.classNameFilter(/animate-/);
	 * ```
	 * </div>
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   -webkit-transition: 1s linear all;
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   -webkit-transition-delay: 0.1s;
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; in case the stagger doesn't work then these two values
	 *    must be set to 0 to avoid an accidental CSS inheritance &#42;/
	 *   -webkit-transition-duration: 0s;
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if more than 10ms has passed after the last animation has been fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * $timeout(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 * }, 100, false);
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ## JavaScript-defined Animations
	 * In the event that you do not want to use CSS3 transitions or CSS3 animations or if you wish to offer animations on browsers that do not
	 * yet support CSS transitions/animations, then you can make use of JavaScript animations defined inside of your AngularJS module.
	 *
	 * ```js
	 * //!annotate="YourApp" Your AngularJS Module|Replace this or ngModule with the module that you used to define your application.
	 * var ngModule = angular.module('YourApp', ['ngAnimate']);
	 * ngModule.animation('.my-crazy-animation', function() {
	 *   return {
	 *     enter: function(element, done) {
	 *       //run the animation here and call done when the animation is complete
	 *       return function(cancelled) {
	 *         //this (optional) function will be called when the animation
	 *         //completes or when the animation is cancelled (the cancelled
	 *         //flag will be set to true if cancelled).
	 *       };
	 *     },
	 *     leave: function(element, done) { },
	 *     move: function(element, done) { },
	 *
	 *     //animation that can be triggered before the class is added
	 *     beforeAddClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered after the class is added
	 *     addClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered before the class is removed
	 *     beforeRemoveClass: function(element, className, done) { },
	 *
	 *     //animation that can be triggered after the class is removed
	 *     removeClass: function(element, className, done) { }
	 *   };
	 * });
	 * ```
	 *
	 * JavaScript-defined animations are created with a CSS-like class selector and a collection of events which are set to run
	 * a javascript callback function. When an animation is triggered, $animate will look for a matching animation which fits
	 * the element's CSS class attribute value and then run the matching animation event function (if found).
	 * In other words, if the CSS classes present on the animated element match any of the JavaScript animations then the callback function will
	 * be executed. It should be also noted that only simple, single class selectors are allowed (compound class selectors are not supported).
	 *
	 * Within a JavaScript animation, an object containing various event callback animation functions is expected to be returned.
	 * As explained above, these callbacks are triggered based on the animation event. Therefore if an enter animation is run,
	 * and the JavaScript animation is found, then the enter callback will handle that animation (in addition to the CSS keyframe animation
	 * or transition code that is defined via a stylesheet).
	 *
	 *
	 * ### Applying Directive-specific Styles to an Animation
	 * In some cases a directive or service may want to provide `$animate` with extra details that the animation will
	 * include into its animation. Let's say for example we wanted to render an animation that animates an element
	 * towards the mouse coordinates as to where the user clicked last. By collecting the X/Y coordinates of the click
	 * (via the event parameter) we can set the `top` and `left` styles into an object and pass that into our function
	 * call to `$animate.addClass`.
	 *
	 * ```js
	 * canvas.on('click', function(e) {
	 *   $animate.addClass(element, 'on', {
	 *     to: {
	 *       left : e.client.x + 'px',
	 *       top : e.client.y + 'px'
	 *     }
	 *   }):
	 * });
	 * ```
	 *
	 * Now when the animation runs, and a transition or keyframe animation is picked up, then the animation itself will
	 * also include and transition the styling of the `left` and `top` properties into its running animation. If we want
	 * to provide some starting animation values then we can do so by placing the starting animations styles into an object
	 * called `from` in the same object as the `to` animations.
	 *
	 * ```js
	 * canvas.on('click', function(e) {
	 *   $animate.addClass(element, 'on', {
	 *     from: {
	 *        position: 'absolute',
	 *        left: '0px',
	 *        top: '0px'
	 *     },
	 *     to: {
	 *       left : e.client.x + 'px',
	 *       top : e.client.y + 'px'
	 *     }
	 *   }):
	 * });
	 * ```
	 *
	 * Once the animation is complete or cancelled then the union of both the before and after styles are applied to the
	 * element. If `ngAnimate` is not present then the styles will be applied immediately.
	 *
	 */
	
	angular.module('ngAnimate', ['ng'])
	
	  /**
	   * @ngdoc provider
	   * @name $animateProvider
	   * @description
	   *
	   * The `$animateProvider` allows developers to register JavaScript animation event handlers directly inside of a module.
	   * When an animation is triggered, the $animate service will query the $animate service to find any animations that match
	   * the provided name value.
	   *
	   * Requires the {@link ngAnimate `ngAnimate`} module to be installed.
	   *
	   * Please visit the {@link ngAnimate `ngAnimate`} module overview page learn more about how to use animations in your application.
	   *
	   */
	  .directive('ngAnimateChildren', function() {
	    var NG_ANIMATE_CHILDREN = '$$ngAnimateChildren';
	    return function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (angular.isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN, true);
	      } else {
	        scope.$watch(val, function(value) {
	          element.data(NG_ANIMATE_CHILDREN, !!value);
	        });
	      }
	    };
	  })
	
	  //this private service is only used within CSS-enabled animations
	  //IE8 + IE9 do not support rAF natively, but that is fine since they
	  //also don't support transitions and keyframes which means that the code
	  //below will never be used by the two browsers.
	  .factory('$$animateReflow', ['$$rAF', '$document', function($$rAF, $document) {
	    var bod = $document[0].body;
	    return function(fn) {
	      //the returned function acts as the cancellation function
	      return $$rAF(function() {
	        //the line below will force the browser to perform a repaint
	        //so that all the animated elements within the animation frame
	        //will be properly updated and drawn on screen. This is
	        //required to perform multi-class CSS based animations with
	        //Firefox. DO NOT REMOVE THIS LINE. DO NOT OPTIMIZE THIS LINE.
	        //THE MINIFIER WILL REMOVE IT OTHERWISE WHICH WILL RESULT IN AN
	        //UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND WILL
	        //TAKE YEARS AWAY FROM YOUR LIFE!
	        fn(bod.offsetWidth);
	      });
	    };
	  }])
	
	  .config(['$provide', '$animateProvider', function($provide, $animateProvider) {
	    var noop = angular.noop;
	    var forEach = angular.forEach;
	    var selectors = $animateProvider.$$selectors;
	    var isArray = angular.isArray;
	    var isString = angular.isString;
	    var isObject = angular.isObject;
	
	    var ELEMENT_NODE = 1;
	    var NG_ANIMATE_STATE = '$$ngAnimateState';
	    var NG_ANIMATE_CHILDREN = '$$ngAnimateChildren';
	    var NG_ANIMATE_CLASS_NAME = 'ng-animate';
	    var rootAnimateState = {running: true};
	
	    function extractElementNode(element) {
	      for (var i = 0; i < element.length; i++) {
	        var elm = element[i];
	        if (elm.nodeType == ELEMENT_NODE) {
	          return elm;
	        }
	      }
	    }
	
	    function prepareElement(element) {
	      return element && angular.element(element);
	    }
	
	    function stripCommentsFromElement(element) {
	      return angular.element(extractElementNode(element));
	    }
	
	    function isMatchingElement(elm1, elm2) {
	      return extractElementNode(elm1) == extractElementNode(elm2);
	    }
	    var $$jqLite;
	    $provide.decorator('$animate',
	        ['$delegate', '$$q', '$injector', '$sniffer', '$rootElement', '$$asyncCallback', '$rootScope', '$document', '$templateRequest', '$$jqLite',
	 function($delegate,   $$q,   $injector,   $sniffer,   $rootElement,   $$asyncCallback,   $rootScope,   $document,   $templateRequest,   $$$jqLite) {
	
	      $$jqLite = $$$jqLite;
	      $rootElement.data(NG_ANIMATE_STATE, rootAnimateState);
	
	      // Wait until all directive and route-related templates are downloaded and
	      // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	      // all of the remote templates being currently downloaded. If there are no
	      // templates currently downloading then the watcher will still fire anyway.
	      var deregisterWatch = $rootScope.$watch(
	        function() { return $templateRequest.totalPendingRequests; },
	        function(val, oldVal) {
	          if (val !== 0) return;
	          deregisterWatch();
	
	          // Now that all templates have been downloaded, $animate will wait until
	          // the post digest queue is empty before enabling animations. By having two
	          // calls to $postDigest calls we can ensure that the flag is enabled at the
	          // very end of the post digest queue. Since all of the animations in $animate
	          // use $postDigest, it's important that the code below executes at the end.
	          // This basically means that the page is fully downloaded and compiled before
	          // any animations are triggered.
	          $rootScope.$$postDigest(function() {
	            $rootScope.$$postDigest(function() {
	              rootAnimateState.running = false;
	            });
	          });
	        }
	      );
	
	      var globalAnimationCounter = 0;
	      var classNameFilter = $animateProvider.classNameFilter();
	      var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	      function classBasedAnimationsBlocked(element, setter) {
	        var data = element.data(NG_ANIMATE_STATE) || {};
	        if (setter) {
	          data.running = true;
	          data.structural = true;
	          element.data(NG_ANIMATE_STATE, data);
	        }
	        return data.disabled || (data.running && data.structural);
	      }
	
	      function runAnimationPostDigest(fn) {
	        var cancelFn, defer = $$q.defer();
	        defer.promise.$$cancelFn = function() {
	          cancelFn && cancelFn();
	        };
	        $rootScope.$$postDigest(function() {
	          cancelFn = fn(function() {
	            defer.resolve();
	          });
	        });
	        return defer.promise;
	      }
	
	      function parseAnimateOptions(options) {
	        // some plugin code may still be passing in the callback
	        // function as the last param for the $animate methods so
	        // it's best to only allow string or array values for now
	        if (isObject(options)) {
	          if (options.tempClasses && isString(options.tempClasses)) {
	            options.tempClasses = options.tempClasses.split(/\s+/);
	          }
	          return options;
	        }
	      }
	
	      function resolveElementClasses(element, cache, runningAnimations) {
	        runningAnimations = runningAnimations || {};
	
	        var lookup = {};
	        forEach(runningAnimations, function(data, selector) {
	          forEach(selector.split(' '), function(s) {
	            lookup[s]=data;
	          });
	        });
	
	        var hasClasses = Object.create(null);
	        forEach((element.attr('class') || '').split(/\s+/), function(className) {
	          hasClasses[className] = true;
	        });
	
	        var toAdd = [], toRemove = [];
	        forEach((cache && cache.classes) || [], function(status, className) {
	          var hasClass = hasClasses[className];
	          var matchingAnimation = lookup[className] || {};
	
	          // When addClass and removeClass is called then $animate will check to
	          // see if addClass and removeClass cancel each other out. When there are
	          // more calls to removeClass than addClass then the count falls below 0
	          // and then the removeClass animation will be allowed. Otherwise if the
	          // count is above 0 then that means an addClass animation will commence.
	          // Once an animation is allowed then the code will also check to see if
	          // there exists any on-going animation that is already adding or remvoing
	          // the matching CSS class.
	          if (status === false) {
	            //does it have the class or will it have the class
	            if (hasClass || matchingAnimation.event == 'addClass') {
	              toRemove.push(className);
	            }
	          } else if (status === true) {
	            //is the class missing or will it be removed?
	            if (!hasClass || matchingAnimation.event == 'removeClass') {
	              toAdd.push(className);
	            }
	          }
	        });
	
	        return (toAdd.length + toRemove.length) > 0 && [toAdd.join(' '), toRemove.join(' ')];
	      }
	
	      function lookup(name) {
	        if (name) {
	          var matches = [],
	              flagMap = {},
	              classes = name.substr(1).split('.');
	
	          //the empty string value is the default animation
	          //operation which performs CSS transition and keyframe
	          //animations sniffing. This is always included for each
	          //element animation procedure if the browser supports
	          //transitions and/or keyframe animations. The default
	          //animation is added to the top of the list to prevent
	          //any previous animations from affecting the element styling
	          //prior to the element being animated.
	          if ($sniffer.transitions || $sniffer.animations) {
	            matches.push($injector.get(selectors['']));
	          }
	
	          for (var i=0; i < classes.length; i++) {
	            var klass = classes[i],
	                selectorFactoryName = selectors[klass];
	            if (selectorFactoryName && !flagMap[klass]) {
	              matches.push($injector.get(selectorFactoryName));
	              flagMap[klass] = true;
	            }
	          }
	          return matches;
	        }
	      }
	
	      function animationRunner(element, animationEvent, className, options) {
	        //transcluded directives may sometimes fire an animation using only comment nodes
	        //best to catch this early on to prevent any animation operations from occurring
	        var node = element[0];
	        if (!node) {
	          return;
	        }
	
	        if (options) {
	          options.to = options.to || {};
	          options.from = options.from || {};
	        }
	
	        var classNameAdd;
	        var classNameRemove;
	        if (isArray(className)) {
	          classNameAdd = className[0];
	          classNameRemove = className[1];
	          if (!classNameAdd) {
	            className = classNameRemove;
	            animationEvent = 'removeClass';
	          } else if (!classNameRemove) {
	            className = classNameAdd;
	            animationEvent = 'addClass';
	          } else {
	            className = classNameAdd + ' ' + classNameRemove;
	          }
	        }
	
	        var isSetClassOperation = animationEvent == 'setClass';
	        var isClassBased = isSetClassOperation
	                           || animationEvent == 'addClass'
	                           || animationEvent == 'removeClass'
	                           || animationEvent == 'animate';
	
	        var currentClassName = element.attr('class');
	        var classes = currentClassName + ' ' + className;
	        if (!isAnimatableClassName(classes)) {
	          return;
	        }
	
	        var beforeComplete = noop,
	            beforeCancel = [],
	            before = [],
	            afterComplete = noop,
	            afterCancel = [],
	            after = [];
	
	        var animationLookup = (' ' + classes).replace(/\s+/g,'.');
	        forEach(lookup(animationLookup), function(animationFactory) {
	          var created = registerAnimation(animationFactory, animationEvent);
	          if (!created && isSetClassOperation) {
	            registerAnimation(animationFactory, 'addClass');
	            registerAnimation(animationFactory, 'removeClass');
	          }
	        });
	
	        function registerAnimation(animationFactory, event) {
	          var afterFn = animationFactory[event];
	          var beforeFn = animationFactory['before' + event.charAt(0).toUpperCase() + event.substr(1)];
	          if (afterFn || beforeFn) {
	            if (event == 'leave') {
	              beforeFn = afterFn;
	              //when set as null then animation knows to skip this phase
	              afterFn = null;
	            }
	            after.push({
	              event: event, fn: afterFn
	            });
	            before.push({
	              event: event, fn: beforeFn
	            });
	            return true;
	          }
	        }
	
	        function run(fns, cancellations, allCompleteFn) {
	          var animations = [];
	          forEach(fns, function(animation) {
	            animation.fn && animations.push(animation);
	          });
	
	          var count = 0;
	          function afterAnimationComplete(index) {
	            if (cancellations) {
	              (cancellations[index] || noop)();
	              if (++count < animations.length) return;
	              cancellations = null;
	            }
	            allCompleteFn();
	          }
	
	          //The code below adds directly to the array in order to work with
	          //both sync and async animations. Sync animations are when the done()
	          //operation is called right away. DO NOT REFACTOR!
	          forEach(animations, function(animation, index) {
	            var progress = function() {
	              afterAnimationComplete(index);
	            };
	            switch (animation.event) {
	              case 'setClass':
	                cancellations.push(animation.fn(element, classNameAdd, classNameRemove, progress, options));
	                break;
	              case 'animate':
	                cancellations.push(animation.fn(element, className, options.from, options.to, progress));
	                break;
	              case 'addClass':
	                cancellations.push(animation.fn(element, classNameAdd || className,     progress, options));
	                break;
	              case 'removeClass':
	                cancellations.push(animation.fn(element, classNameRemove || className,  progress, options));
	                break;
	              default:
	                cancellations.push(animation.fn(element, progress, options));
	                break;
	            }
	          });
	
	          if (cancellations && cancellations.length === 0) {
	            allCompleteFn();
	          }
	        }
	
	        return {
	          node: node,
	          event: animationEvent,
	          className: className,
	          isClassBased: isClassBased,
	          isSetClassOperation: isSetClassOperation,
	          applyStyles: function() {
	            if (options) {
	              element.css(angular.extend(options.from || {}, options.to || {}));
	            }
	          },
	          before: function(allCompleteFn) {
	            beforeComplete = allCompleteFn;
	            run(before, beforeCancel, function() {
	              beforeComplete = noop;
	              allCompleteFn();
	            });
	          },
	          after: function(allCompleteFn) {
	            afterComplete = allCompleteFn;
	            run(after, afterCancel, function() {
	              afterComplete = noop;
	              allCompleteFn();
	            });
	          },
	          cancel: function() {
	            if (beforeCancel) {
	              forEach(beforeCancel, function(cancelFn) {
	                (cancelFn || noop)(true);
	              });
	              beforeComplete(true);
	            }
	            if (afterCancel) {
	              forEach(afterCancel, function(cancelFn) {
	                (cancelFn || noop)(true);
	              });
	              afterComplete(true);
	            }
	          }
	        };
	      }
	
	      /**
	       * @ngdoc service
	       * @name $animate
	       * @kind object
	       *
	       * @description
	       * The `$animate` service provides animation detection support while performing DOM operations (enter, leave and move) as well as during addClass and removeClass operations.
	       * When any of these operations are run, the $animate service
	       * will examine any JavaScript-defined animations (which are defined by using the $animateProvider provider object)
	       * as well as any CSS-defined animations against the CSS classes present on the element once the DOM operation is run.
	       *
	       * The `$animate` service is used behind the scenes with pre-existing directives and animation with these directives
	       * will work out of the box without any extra configuration.
	       *
	       * Requires the {@link ngAnimate `ngAnimate`} module to be installed.
	       *
	       * Please visit the {@link ngAnimate `ngAnimate`} module overview page learn more about how to use animations in your application.
	       * ## Callback Promises
	       * With AngularJS 1.3, each of the animation methods, on the `$animate` service, return a promise when called. The
	       * promise itself is then resolved once the animation has completed itself, has been cancelled or has been
	       * skipped due to animations being disabled. (Note that even if the animation is cancelled it will still
	       * call the resolve function of the animation.)
	       *
	       * ```js
	       * $animate.enter(element, container).then(function() {
	       *   //...this is called once the animation is complete...
	       * });
	       * ```
	       *
	       * Also note that, due to the nature of the callback promise, if any Angular-specific code (like changing the scope,
	       * location of the page, etc...) is executed within the callback promise then be sure to wrap the code using
	       * `$scope.$apply(...)`;
	       *
	       * ```js
	       * $animate.leave(element).then(function() {
	       *   $scope.$apply(function() {
	       *     $location.path('/new-page');
	       *   });
	       * });
	       * ```
	       *
	       * An animation can also be cancelled by calling the `$animate.cancel(promise)` method with the provided
	       * promise that was returned when the animation was started.
	       *
	       * ```js
	       * var promise = $animate.addClass(element, 'super-long-animation');
	       * promise.then(function() {
	       *   //this will still be called even if cancelled
	       * });
	       *
	       * element.on('click', function() {
	       *   //tooo lazy to wait for the animation to end
	       *   $animate.cancel(promise);
	       * });
	       * ```
	       *
	       * (Keep in mind that the promise cancellation is unique to `$animate` since promises in
	       * general cannot be cancelled.)
	       *
	       */
	      return {
	        /**
	         * @ngdoc method
	         * @name $animate#animate
	         * @kind function
	         *
	         * @description
	         * Performs an inline animation on the element which applies the provided `to` and `from` CSS styles to the element.
	         * If any detected CSS transition, keyframe or JavaScript matches the provided `className` value then the animation
	         * will take on the provided styles. For example, if a transition animation is set for the given className then the
	         * provided `from` and `to` styles will be applied alongside the given transition. If a JavaScript animation is
	         * detected then the provided styles will be given in as function paramters.
	         *
	         * ```js
	         * ngModule.animation('.my-inline-animation', function() {
	         *   return {
	         *     animate : function(element, className, from, to, done) {
	         *       //styles
	         *     }
	         *   }
	         * });
	         * ```
	         *
	         * Below is a breakdown of each step that occurs during the `animate` animation:
	         *
	         * | Animation Step                                                                                                        | What the element class attribute looks like                  |
	         * |-----------------------------------------------------------------------------------------------------------------------|--------------------------------------------------------------|
	         * | 1. `$animate.animate(...)` is called                                                                                  | `class="my-animation"`                                       |
	         * | 2. `$animate` waits for the next digest to start the animation                                                        | `class="my-animation ng-animate"`                            |
	         * | 3. `$animate` runs the JavaScript-defined animations detected on the element                                          | `class="my-animation ng-animate"`                            |
	         * | 4. the `className` class value is added to the element                                                                | `class="my-animation ng-animate className"`                  |
	         * | 5. `$animate` scans the element styles to get the CSS transition/animation duration and delay                         | `class="my-animation ng-animate className"`                  |
	         * | 6. `$animate` blocks all CSS transitions on the element to ensure the `.className` class styling is applied right away| `class="my-animation ng-animate className"`                  |
	         * | 7. `$animate` applies the provided collection of `from` CSS styles to the element                                     | `class="my-animation ng-animate className"`                  |
	         * | 8. `$animate` waits for a single animation frame (this performs a reflow)                                             | `class="my-animation ng-animate className"`                  |
	         * | 9. `$animate` removes the CSS transition block placed on the element                                                  | `class="my-animation ng-animate className"`                  |
	         * | 10. the `className-active` class is added (this triggers the CSS transition/animation)                                | `class="my-animation ng-animate className className-active"` |
	         * | 11. `$animate` applies the collection of `to` CSS styles to the element which are then handled by the transition      | `class="my-animation ng-animate className className-active"` |
	         * | 12. `$animate` waits for the animation to complete (via events and timeout)                                           | `class="my-animation ng-animate className className-active"` |
	         * | 13. The animation ends and all generated CSS classes are removed from the element                                     | `class="my-animation"`                                       |
	         * | 14. The returned promise is resolved.                                                                                 | `class="my-animation"`                                       |
	         *
	         * @param {DOMElement} element the element that will be the focus of the enter animation
	         * @param {object} from a collection of CSS styles that will be applied to the element at the start of the animation
	         * @param {object} to a collection of CSS styles that the element will animate towards
	         * @param {string=} className an optional CSS class that will be added to the element for the duration of the animation (the default class is `ng-inline-animate`)
	         * @param {object=} options an optional collection of options that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        animate: function(element, from, to, className, options) {
	          className = className || 'ng-inline-animate';
	          options = parseAnimateOptions(options) || {};
	          options.from = to ? from : null;
	          options.to   = to ? to : from;
	
	          return runAnimationPostDigest(function(done) {
	            return performAnimation('animate', className, stripCommentsFromElement(element), null, null, noop, options, done);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#enter
	         * @kind function
	         *
	         * @description
	         * Appends the element to the parentElement element that resides in the document and then runs the enter animation. Once
	         * the animation is started, the following CSS classes will be present on the element for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during enter animation:
	         *
	         * | Animation Step                                                                                                        | What the element class attribute looks like                |
	         * |-----------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------|
	         * | 1. `$animate.enter(...)` is called                                                                                    | `class="my-animation"`                                     |
	         * | 2. element is inserted into the `parentElement` element or beside the `afterElement` element                          | `class="my-animation"`                                     |
	         * | 3. `$animate` waits for the next digest to start the animation                                                        | `class="my-animation ng-animate"`                          |
	         * | 4. `$animate` runs the JavaScript-defined animations detected on the element                                          | `class="my-animation ng-animate"`                          |
	         * | 5. the `.ng-enter` class is added to the element                                                                      | `class="my-animation ng-animate ng-enter"`                 |
	         * | 6. `$animate` scans the element styles to get the CSS transition/animation duration and delay                         | `class="my-animation ng-animate ng-enter"`                 |
	         * | 7. `$animate` blocks all CSS transitions on the element to ensure the `.ng-enter` class styling is applied right away | `class="my-animation ng-animate ng-enter"`                 |
	         * | 8. `$animate` waits for a single animation frame (this performs a reflow)                                             | `class="my-animation ng-animate ng-enter"`                 |
	         * | 9. `$animate` removes the CSS transition block placed on the element                                                  | `class="my-animation ng-animate ng-enter"`                 |
	         * | 10. the `.ng-enter-active` class is added (this triggers the CSS transition/animation)                                | `class="my-animation ng-animate ng-enter ng-enter-active"` |
	         * | 11. `$animate` waits for the animation to complete (via events and timeout)                                           | `class="my-animation ng-animate ng-enter ng-enter-active"` |
	         * | 12. The animation ends and all generated CSS classes are removed from the element                                     | `class="my-animation"`                                     |
	         * | 13. The returned promise is resolved.                                                                                 | `class="my-animation"`                                     |
	         *
	         * @param {DOMElement} element the element that will be the focus of the enter animation
	         * @param {DOMElement} parentElement the parent element of the element that will be the focus of the enter animation
	         * @param {DOMElement} afterElement the sibling element (which is the previous element) of the element that will be the focus of the enter animation
	         * @param {object=} options an optional collection of options that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        enter: function(element, parentElement, afterElement, options) {
	          options = parseAnimateOptions(options);
	          element = angular.element(element);
	          parentElement = prepareElement(parentElement);
	          afterElement = prepareElement(afterElement);
	
	          classBasedAnimationsBlocked(element, true);
	          $delegate.enter(element, parentElement, afterElement);
	          return runAnimationPostDigest(function(done) {
	            return performAnimation('enter', 'ng-enter', stripCommentsFromElement(element), parentElement, afterElement, noop, options, done);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#leave
	         * @kind function
	         *
	         * @description
	         * Runs the leave animation operation and, upon completion, removes the element from the DOM. Once
	         * the animation is started, the following CSS classes will be added for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during leave animation:
	         *
	         * | Animation Step                                                                                                        | What the element class attribute looks like                |
	         * |-----------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------|
	         * | 1. `$animate.leave(...)` is called                                                                                    | `class="my-animation"`                                     |
	         * | 2. `$animate` runs the JavaScript-defined animations detected on the element                                          | `class="my-animation ng-animate"`                          |
	         * | 3. `$animate` waits for the next digest to start the animation                                                        | `class="my-animation ng-animate"`                          |
	         * | 4. the `.ng-leave` class is added to the element                                                                      | `class="my-animation ng-animate ng-leave"`                 |
	         * | 5. `$animate` scans the element styles to get the CSS transition/animation duration and delay                         | `class="my-animation ng-animate ng-leave"`                 |
	         * | 6. `$animate` blocks all CSS transitions on the element to ensure the `.ng-leave` class styling is applied right away | `class="my-animation ng-animate ng-leave"`                 |
	         * | 7. `$animate` waits for a single animation frame (this performs a reflow)                                             | `class="my-animation ng-animate ng-leave"`                 |
	         * | 8. `$animate` removes the CSS transition block placed on the element                                                  | `class="my-animation ng-animate ng-leave"`                 |
	         * | 9. the `.ng-leave-active` class is added (this triggers the CSS transition/animation)                                 | `class="my-animation ng-animate ng-leave ng-leave-active"` |
	         * | 10. `$animate` waits for the animation to complete (via events and timeout)                                           | `class="my-animation ng-animate ng-leave ng-leave-active"` |
	         * | 11. The animation ends and all generated CSS classes are removed from the element                                     | `class="my-animation"`                                     |
	         * | 12. The element is removed from the DOM                                                                               | ...                                                        |
	         * | 13. The returned promise is resolved.                                                                                 | ...                                                        |
	         *
	         * @param {DOMElement} element the element that will be the focus of the leave animation
	         * @param {object=} options an optional collection of styles that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        leave: function(element, options) {
	          options = parseAnimateOptions(options);
	          element = angular.element(element);
	
	          cancelChildAnimations(element);
	          classBasedAnimationsBlocked(element, true);
	          return runAnimationPostDigest(function(done) {
	            return performAnimation('leave', 'ng-leave', stripCommentsFromElement(element), null, null, function() {
	              $delegate.leave(element);
	            }, options, done);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#move
	         * @kind function
	         *
	         * @description
	         * Fires the move DOM operation. Just before the animation starts, the animate service will either append it into the parentElement container or
	         * add the element directly after the afterElement element if present. Then the move animation will be run. Once
	         * the animation is started, the following CSS classes will be added for the duration of the animation:
	         *
	         * Below is a breakdown of each step that occurs during move animation:
	         *
	         * | Animation Step                                                                                                       | What the element class attribute looks like              |
	         * |----------------------------------------------------------------------------------------------------------------------|----------------------------------------------------------|
	         * | 1. `$animate.move(...)` is called                                                                                    | `class="my-animation"`                                   |
	         * | 2. element is moved into the parentElement element or beside the afterElement element                                | `class="my-animation"`                                   |
	         * | 3. `$animate` waits for the next digest to start the animation                                                       | `class="my-animation ng-animate"`                        |
	         * | 4. `$animate` runs the JavaScript-defined animations detected on the element                                         | `class="my-animation ng-animate"`                        |
	         * | 5. the `.ng-move` class is added to the element                                                                      | `class="my-animation ng-animate ng-move"`                |
	         * | 6. `$animate` scans the element styles to get the CSS transition/animation duration and delay                        | `class="my-animation ng-animate ng-move"`                |
	         * | 7. `$animate` blocks all CSS transitions on the element to ensure the `.ng-move` class styling is applied right away | `class="my-animation ng-animate ng-move"`                |
	         * | 8. `$animate` waits for a single animation frame (this performs a reflow)                                            | `class="my-animation ng-animate ng-move"`                |
	         * | 9. `$animate` removes the CSS transition block placed on the element                                                 | `class="my-animation ng-animate ng-move"`                |
	         * | 10. the `.ng-move-active` class is added (this triggers the CSS transition/animation)                                | `class="my-animation ng-animate ng-move ng-move-active"` |
	         * | 11. `$animate` waits for the animation to complete (via events and timeout)                                          | `class="my-animation ng-animate ng-move ng-move-active"` |
	         * | 12. The animation ends and all generated CSS classes are removed from the element                                    | `class="my-animation"`                                   |
	         * | 13. The returned promise is resolved.                                                                                | `class="my-animation"`                                   |
	         *
	         * @param {DOMElement} element the element that will be the focus of the move animation
	         * @param {DOMElement} parentElement the parentElement element of the element that will be the focus of the move animation
	         * @param {DOMElement} afterElement the sibling element (which is the previous element) of the element that will be the focus of the move animation
	         * @param {object=} options an optional collection of styles that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        move: function(element, parentElement, afterElement, options) {
	          options = parseAnimateOptions(options);
	          element = angular.element(element);
	          parentElement = prepareElement(parentElement);
	          afterElement = prepareElement(afterElement);
	
	          cancelChildAnimations(element);
	          classBasedAnimationsBlocked(element, true);
	          $delegate.move(element, parentElement, afterElement);
	          return runAnimationPostDigest(function(done) {
	            return performAnimation('move', 'ng-move', stripCommentsFromElement(element), parentElement, afterElement, noop, options, done);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#addClass
	         *
	         * @description
	         * Triggers a custom animation event based off the className variable and then attaches the className value to the element as a CSS class.
	         * Unlike the other animation methods, the animate service will suffix the className value with {@type -add} in order to provide
	         * the animate service the setup and active CSS classes in order to trigger the animation (this will be skipped if no CSS transitions
	         * or keyframes are defined on the -add-active or base CSS class).
	         *
	         * Below is a breakdown of each step that occurs during addClass animation:
	         *
	         * | Animation Step                                                                                         | What the element class attribute looks like                        |
	         * |--------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------|
	         * | 1. `$animate.addClass(element, 'super')` is called                                                     | `class="my-animation"`                                             |
	         * | 2. `$animate` runs the JavaScript-defined animations detected on the element                           | `class="my-animation ng-animate"`                                  |
	         * | 3. the `.super-add` class is added to the element                                                      | `class="my-animation ng-animate super-add"`                        |
	         * | 4. `$animate` waits for a single animation frame (this performs a reflow)                              | `class="my-animation ng-animate super-add"`                        |
	         * | 5. the `.super` and `.super-add-active` classes are added (this triggers the CSS transition/animation) | `class="my-animation ng-animate super super-add super-add-active"` |
	         * | 6. `$animate` scans the element styles to get the CSS transition/animation duration and delay          | `class="my-animation ng-animate super super-add super-add-active"` |
	         * | 7. `$animate` waits for the animation to complete (via events and timeout)                             | `class="my-animation ng-animate super super-add super-add-active"` |
	         * | 8. The animation ends and all generated CSS classes are removed from the element                       | `class="my-animation super"`                                       |
	         * | 9. The super class is kept on the element                                                              | `class="my-animation super"`                                       |
	         * | 10. The returned promise is resolved.                                                                  | `class="my-animation super"`                                       |
	         *
	         * @param {DOMElement} element the element that will be animated
	         * @param {string} className the CSS class that will be added to the element and then animated
	         * @param {object=} options an optional collection of styles that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        addClass: function(element, className, options) {
	          return this.setClass(element, className, [], options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#removeClass
	         *
	         * @description
	         * Triggers a custom animation event based off the className variable and then removes the CSS class provided by the className value
	         * from the element. Unlike the other animation methods, the animate service will suffix the className value with {@type -remove} in
	         * order to provide the animate service the setup and active CSS classes in order to trigger the animation (this will be skipped if
	         * no CSS transitions or keyframes are defined on the -remove or base CSS classes).
	         *
	         * Below is a breakdown of each step that occurs during removeClass animation:
	         *
	         * | Animation Step                                                                                                       | What the element class attribute looks like                        |
	         * |----------------------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------|
	         * | 1. `$animate.removeClass(element, 'super')` is called                                                                | `class="my-animation super"`                                       |
	         * | 2. `$animate` runs the JavaScript-defined animations detected on the element                                         | `class="my-animation super ng-animate"`                            |
	         * | 3. the `.super-remove` class is added to the element                                                                 | `class="my-animation super ng-animate super-remove"`               |
	         * | 4. `$animate` waits for a single animation frame (this performs a reflow)                                            | `class="my-animation super ng-animate super-remove"`               |
	         * | 5. the `.super-remove-active` classes are added and `.super` is removed (this triggers the CSS transition/animation) | `class="my-animation ng-animate super-remove super-remove-active"` |
	         * | 6. `$animate` scans the element styles to get the CSS transition/animation duration and delay                        | `class="my-animation ng-animate super-remove super-remove-active"` |
	         * | 7. `$animate` waits for the animation to complete (via events and timeout)                                           | `class="my-animation ng-animate super-remove super-remove-active"` |
	         * | 8. The animation ends and all generated CSS classes are removed from the element                                     | `class="my-animation"`                                             |
	         * | 9. The returned promise is resolved.                                                                                 | `class="my-animation"`                                             |
	         *
	         *
	         * @param {DOMElement} element the element that will be animated
	         * @param {string} className the CSS class that will be animated and then removed from the element
	         * @param {object=} options an optional collection of styles that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	        */
	        removeClass: function(element, className, options) {
	          return this.setClass(element, [], className, options);
	        },
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#setClass
	         *
	         * @description Adds and/or removes the given CSS classes to and from the element.
	         * Once complete, the `done()` callback will be fired (if provided).
	         *
	         * | Animation Step                                                                                                                               | What the element class attribute looks like                                            |
	         * |----------------------------------------------------------------------------------------------------------------------------------------------|----------------------------------------------------------------------------------------|
	         * | 1. `$animate.setClass(element, 'on', 'off')` is called                                                                                       | `class="my-animation off"`                                                             |
	         * | 2. `$animate` runs the JavaScript-defined animations detected on the element                                                                 | `class="my-animation ng-animate off"`                                                  |
	         * | 3. the `.on-add` and `.off-remove` classes are added to the element                                                                          | `class="my-animation ng-animate on-add off-remove off"`                                |
	         * | 4. `$animate` waits for a single animation frame (this performs a reflow)                                                                    | `class="my-animation ng-animate on-add off-remove off"`                                |
	         * | 5. the `.on`, `.on-add-active` and `.off-remove-active` classes are added and `.off` is removed (this triggers the CSS transition/animation) | `class="my-animation ng-animate on on-add on-add-active off-remove off-remove-active"` |
	         * | 6. `$animate` scans the element styles to get the CSS transition/animation duration and delay                                                | `class="my-animation ng-animate on on-add on-add-active off-remove off-remove-active"` |
	         * | 7. `$animate` waits for the animation to complete (via events and timeout)                                                                   | `class="my-animation ng-animate on on-add on-add-active off-remove off-remove-active"` |
	         * | 8. The animation ends and all generated CSS classes are removed from the element                                                             | `class="my-animation on"`                                                              |
	         * | 9. The returned promise is resolved.                                                                                                         | `class="my-animation on"`                                                              |
	         *
	         * @param {DOMElement} element the element which will have its CSS classes changed
	         *   removed from it
	         * @param {string} add the CSS classes which will be added to the element
	         * @param {string} remove the CSS class which will be removed from the element
	         *   CSS classes have been set on the element
	         * @param {object=} options an optional collection of styles that will be picked up by the CSS transition/animation
	         * @return {Promise} the animation callback promise
	         */
	        setClass: function(element, add, remove, options) {
	          options = parseAnimateOptions(options);
	
	          var STORAGE_KEY = '$$animateClasses';
	          element = angular.element(element);
	          element = stripCommentsFromElement(element);
	
	          if (classBasedAnimationsBlocked(element)) {
	            return $delegate.$$setClassImmediately(element, add, remove, options);
	          }
	
	          // we're using a combined array for both the add and remove
	          // operations since the ORDER OF addClass and removeClass matters
	          var classes, cache = element.data(STORAGE_KEY);
	          var hasCache = !!cache;
	          if (!cache) {
	            cache = {};
	            cache.classes = {};
	          }
	          classes = cache.classes;
	
	          add = isArray(add) ? add : add.split(' ');
	          forEach(add, function(c) {
	            if (c && c.length) {
	              classes[c] = true;
	            }
	          });
	
	          remove = isArray(remove) ? remove : remove.split(' ');
	          forEach(remove, function(c) {
	            if (c && c.length) {
	              classes[c] = false;
	            }
	          });
	
	          if (hasCache) {
	            if (options && cache.options) {
	              cache.options = angular.extend(cache.options || {}, options);
	            }
	
	            //the digest cycle will combine all the animations into one function
	            return cache.promise;
	          } else {
	            element.data(STORAGE_KEY, cache = {
	              classes: classes,
	              options: options
	            });
	          }
	
	          return cache.promise = runAnimationPostDigest(function(done) {
	            var cache, parentNode, parentElement, elementNode = extractElementNode(element);
	            if (elementNode) {
	              cache = element.data(STORAGE_KEY);
	              element.removeData(STORAGE_KEY);
	
	              parentElement = element.parent();
	              parentNode = elementNode.parentNode;
	            }
	
	            // TODO(matsko): move this code into the animationsDisabled() function once #8092 is fixed
	            if (!parentNode || parentNode['$$NG_REMOVED'] || elementNode['$$NG_REMOVED']) {
	              done();
	              return;
	            }
	
	            var state = element.data(NG_ANIMATE_STATE) || {};
	            var classes = resolveElementClasses(element, cache, state.active);
	            return !classes
	              ? done()
	              : performAnimation('setClass', classes, element, parentElement, null, function() {
	                  if (classes[0]) $delegate.$$addClassImmediately(element, classes[0]);
	                  if (classes[1]) $delegate.$$removeClassImmediately(element, classes[1]);
	                }, cache.options, done);
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#cancel
	         * @kind function
	         *
	         * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	         *
	         * @description
	         * Cancels the provided animation.
	        */
	        cancel: function(promise) {
	          promise.$$cancelFn();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#enabled
	         * @kind function
	         *
	         * @param {boolean=} value If provided then set the animation on or off.
	         * @param {DOMElement=} element If provided then the element will be used to represent the enable/disable operation
	         * @return {boolean} Current animation state.
	         *
	         * @description
	         * Globally enables/disables animations.
	         *
	        */
	        enabled: function(value, element) {
	          switch (arguments.length) {
	            case 2:
	              if (value) {
	                cleanup(element);
	              } else {
	                var data = element.data(NG_ANIMATE_STATE) || {};
	                data.disabled = true;
	                element.data(NG_ANIMATE_STATE, data);
	              }
	            break;
	
	            case 1:
	              rootAnimateState.disabled = !value;
	            break;
	
	            default:
	              value = !rootAnimateState.disabled;
	            break;
	          }
	          return !!value;
	         }
	      };
	
	      /*
	        all animations call this shared animation triggering function internally.
	        The animationEvent variable refers to the JavaScript animation event that will be triggered
	        and the className value is the name of the animation that will be applied within the
	        CSS code. Element, `parentElement` and `afterElement` are provided DOM elements for the animation
	        and the onComplete callback will be fired once the animation is fully complete.
	      */
	      function performAnimation(animationEvent, className, element, parentElement, afterElement, domOperation, options, doneCallback) {
	        var noopCancel = noop;
	        var runner = animationRunner(element, animationEvent, className, options);
	        if (!runner) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          closeAnimation();
	          return noopCancel;
	        }
	
	        animationEvent = runner.event;
	        className = runner.className;
	        var elementEvents = angular.element._data(runner.node);
	        elementEvents = elementEvents && elementEvents.events;
	
	        if (!parentElement) {
	          parentElement = afterElement ? afterElement.parent() : element.parent();
	        }
	
	        //skip the animation if animations are disabled, a parent is already being animated,
	        //the element is not currently attached to the document body or then completely close
	        //the animation if any matching animations are not found at all.
	        //NOTE: IE8 + IE9 should close properly (run closeAnimation()) in case an animation was found.
	        if (animationsDisabled(element, parentElement)) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          closeAnimation();
	          return noopCancel;
	        }
	
	        var ngAnimateState  = element.data(NG_ANIMATE_STATE) || {};
	        var runningAnimations     = ngAnimateState.active || {};
	        var totalActiveAnimations = ngAnimateState.totalActive || 0;
	        var lastAnimation         = ngAnimateState.last;
	        var skipAnimation = false;
	
	        if (totalActiveAnimations > 0) {
	          var animationsToCancel = [];
	          if (!runner.isClassBased) {
	            if (animationEvent == 'leave' && runningAnimations['ng-leave']) {
	              skipAnimation = true;
	            } else {
	              //cancel all animations when a structural animation takes place
	              for (var klass in runningAnimations) {
	                animationsToCancel.push(runningAnimations[klass]);
	              }
	              ngAnimateState = {};
	              cleanup(element, true);
	            }
	          } else if (lastAnimation.event == 'setClass') {
	            animationsToCancel.push(lastAnimation);
	            cleanup(element, className);
	          } else if (runningAnimations[className]) {
	            var current = runningAnimations[className];
	            if (current.event == animationEvent) {
	              skipAnimation = true;
	            } else {
	              animationsToCancel.push(current);
	              cleanup(element, className);
	            }
	          }
	
	          if (animationsToCancel.length > 0) {
	            forEach(animationsToCancel, function(operation) {
	              operation.cancel();
	            });
	          }
	        }
	
	        if (runner.isClassBased
	            && !runner.isSetClassOperation
	            && animationEvent != 'animate'
	            && !skipAnimation) {
	          skipAnimation = (animationEvent == 'addClass') == element.hasClass(className); //opposite of XOR
	        }
	
	        if (skipAnimation) {
	          fireDOMOperation();
	          fireBeforeCallbackAsync();
	          fireAfterCallbackAsync();
	          fireDoneCallbackAsync();
	          return noopCancel;
	        }
	
	        runningAnimations     = ngAnimateState.active || {};
	        totalActiveAnimations = ngAnimateState.totalActive || 0;
	
	        if (animationEvent == 'leave') {
	          //there's no need to ever remove the listener since the element
	          //will be removed (destroyed) after the leave animation ends or
	          //is cancelled midway
	          element.one('$destroy', function(e) {
	            var element = angular.element(this);
	            var state = element.data(NG_ANIMATE_STATE);
	            if (state) {
	              var activeLeaveAnimation = state.active['ng-leave'];
	              if (activeLeaveAnimation) {
	                activeLeaveAnimation.cancel();
	                cleanup(element, 'ng-leave');
	              }
	            }
	          });
	        }
	
	        //the ng-animate class does nothing, but it's here to allow for
	        //parent animations to find and cancel child animations when needed
	        $$jqLite.addClass(element, NG_ANIMATE_CLASS_NAME);
	        if (options && options.tempClasses) {
	          forEach(options.tempClasses, function(className) {
	            $$jqLite.addClass(element, className);
	          });
	        }
	
	        var localAnimationCount = globalAnimationCounter++;
	        totalActiveAnimations++;
	        runningAnimations[className] = runner;
	
	        element.data(NG_ANIMATE_STATE, {
	          last: runner,
	          active: runningAnimations,
	          index: localAnimationCount,
	          totalActive: totalActiveAnimations
	        });
	
	        //first we run the before animations and when all of those are complete
	        //then we perform the DOM operation and run the next set of animations
	        fireBeforeCallbackAsync();
	        runner.before(function(cancelled) {
	          var data = element.data(NG_ANIMATE_STATE);
	          cancelled = cancelled ||
	                        !data || !data.active[className] ||
	                        (runner.isClassBased && data.active[className].event != animationEvent);
	
	          fireDOMOperation();
	          if (cancelled === true) {
	            closeAnimation();
	          } else {
	            fireAfterCallbackAsync();
	            runner.after(closeAnimation);
	          }
	        });
	
	        return runner.cancel;
	
	        function fireDOMCallback(animationPhase) {
	          var eventName = '$animate:' + animationPhase;
	          if (elementEvents && elementEvents[eventName] && elementEvents[eventName].length > 0) {
	            $$asyncCallback(function() {
	              element.triggerHandler(eventName, {
	                event: animationEvent,
	                className: className
	              });
	            });
	          }
	        }
	
	        function fireBeforeCallbackAsync() {
	          fireDOMCallback('before');
	        }
	
	        function fireAfterCallbackAsync() {
	          fireDOMCallback('after');
	        }
	
	        function fireDoneCallbackAsync() {
	          fireDOMCallback('close');
	          doneCallback();
	        }
	
	        //it is less complicated to use a flag than managing and canceling
	        //timeouts containing multiple callbacks.
	        function fireDOMOperation() {
	          if (!fireDOMOperation.hasBeenRun) {
	            fireDOMOperation.hasBeenRun = true;
	            domOperation();
	          }
	        }
	
	        function closeAnimation() {
	          if (!closeAnimation.hasBeenRun) {
	            if (runner) { //the runner doesn't exist if it fails to instantiate
	              runner.applyStyles();
	            }
	
	            closeAnimation.hasBeenRun = true;
	            if (options && options.tempClasses) {
	              forEach(options.tempClasses, function(className) {
	                $$jqLite.removeClass(element, className);
	              });
	            }
	
	            var data = element.data(NG_ANIMATE_STATE);
	            if (data) {
	
	              /* only structural animations wait for reflow before removing an
	                 animation, but class-based animations don't. An example of this
	                 failing would be when a parent HTML tag has a ng-class attribute
	                 causing ALL directives below to skip animations during the digest */
	              if (runner && runner.isClassBased) {
	                cleanup(element, className);
	              } else {
	                $$asyncCallback(function() {
	                  var data = element.data(NG_ANIMATE_STATE) || {};
	                  if (localAnimationCount == data.index) {
	                    cleanup(element, className, animationEvent);
	                  }
	                });
	                element.data(NG_ANIMATE_STATE, data);
	              }
	            }
	            fireDoneCallbackAsync();
	          }
	        }
	      }
	
	      function cancelChildAnimations(element) {
	        var node = extractElementNode(element);
	        if (node) {
	          var nodes = angular.isFunction(node.getElementsByClassName) ?
	            node.getElementsByClassName(NG_ANIMATE_CLASS_NAME) :
	            node.querySelectorAll('.' + NG_ANIMATE_CLASS_NAME);
	          forEach(nodes, function(element) {
	            element = angular.element(element);
	            var data = element.data(NG_ANIMATE_STATE);
	            if (data && data.active) {
	              forEach(data.active, function(runner) {
	                runner.cancel();
	              });
	            }
	          });
	        }
	      }
	
	      function cleanup(element, className) {
	        if (isMatchingElement(element, $rootElement)) {
	          if (!rootAnimateState.disabled) {
	            rootAnimateState.running = false;
	            rootAnimateState.structural = false;
	          }
	        } else if (className) {
	          var data = element.data(NG_ANIMATE_STATE) || {};
	
	          var removeAnimations = className === true;
	          if (!removeAnimations && data.active && data.active[className]) {
	            data.totalActive--;
	            delete data.active[className];
	          }
	
	          if (removeAnimations || !data.totalActive) {
	            $$jqLite.removeClass(element, NG_ANIMATE_CLASS_NAME);
	            element.removeData(NG_ANIMATE_STATE);
	          }
	        }
	      }
	
	      function animationsDisabled(element, parentElement) {
	        if (rootAnimateState.disabled) {
	          return true;
	        }
	
	        if (isMatchingElement(element, $rootElement)) {
	          return rootAnimateState.running;
	        }
	
	        var allowChildAnimations, parentRunningAnimation, hasParent;
	        do {
	          //the element did not reach the root element which means that it
	          //is not apart of the DOM. Therefore there is no reason to do
	          //any animations on it
	          if (parentElement.length === 0) break;
	
	          var isRoot = isMatchingElement(parentElement, $rootElement);
	          var state = isRoot ? rootAnimateState : (parentElement.data(NG_ANIMATE_STATE) || {});
	          if (state.disabled) {
	            return true;
	          }
	
	          //no matter what, for an animation to work it must reach the root element
	          //this implies that the element is attached to the DOM when the animation is run
	          if (isRoot) {
	            hasParent = true;
	          }
	
	          //once a flag is found that is strictly false then everything before
	          //it will be discarded and all child animations will be restricted
	          if (allowChildAnimations !== false) {
	            var animateChildrenFlag = parentElement.data(NG_ANIMATE_CHILDREN);
	            if (angular.isDefined(animateChildrenFlag)) {
	              allowChildAnimations = animateChildrenFlag;
	            }
	          }
	
	          parentRunningAnimation = parentRunningAnimation ||
	                                   state.running ||
	                                   (state.last && !state.last.isClassBased);
	        }
	        while (parentElement = parentElement.parent());
	
	        return !hasParent || (!allowChildAnimations && parentRunningAnimation);
	      }
	    }]);
	
	    $animateProvider.register('', ['$window', '$sniffer', '$timeout', '$$animateReflow',
	                           function($window,   $sniffer,   $timeout,   $$animateReflow) {
	      // Detect proper transitionend/animationend event names.
	      var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	      // If unprefixed events are not supported but webkit-prefixed are, use the latter.
	      // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	      // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	      // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	      // Register both events in case `window.onanimationend` is not supported because of that,
	      // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	      // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	      // therefore there is no reason to test anymore for other vendor prefixes: http://caniuse.com/#search=transition
	      if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
	        CSS_PREFIX = '-webkit-';
	        TRANSITION_PROP = 'WebkitTransition';
	        TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	      } else {
	        TRANSITION_PROP = 'transition';
	        TRANSITIONEND_EVENT = 'transitionend';
	      }
	
	      if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
	        CSS_PREFIX = '-webkit-';
	        ANIMATION_PROP = 'WebkitAnimation';
	        ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	      } else {
	        ANIMATION_PROP = 'animation';
	        ANIMATIONEND_EVENT = 'animationend';
	      }
	
	      var DURATION_KEY = 'Duration';
	      var PROPERTY_KEY = 'Property';
	      var DELAY_KEY = 'Delay';
	      var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	      var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	      var NG_ANIMATE_PARENT_KEY = '$$ngAnimateKey';
	      var NG_ANIMATE_CSS_DATA_KEY = '$$ngAnimateCSS3Data';
	      var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	      var CLOSING_TIME_BUFFER = 1.5;
	      var ONE_SECOND = 1000;
	
	      var lookupCache = {};
	      var parentCounter = 0;
	      var animationReflowQueue = [];
	      var cancelAnimationReflow;
	      function clearCacheAfterReflow() {
	        if (!cancelAnimationReflow) {
	          cancelAnimationReflow = $$animateReflow(function() {
	            animationReflowQueue = [];
	            cancelAnimationReflow = null;
	            lookupCache = {};
	          });
	        }
	      }
	
	      function afterReflow(element, callback) {
	        if (cancelAnimationReflow) {
	          cancelAnimationReflow();
	        }
	        animationReflowQueue.push(callback);
	        cancelAnimationReflow = $$animateReflow(function() {
	          forEach(animationReflowQueue, function(fn) {
	            fn();
	          });
	
	          animationReflowQueue = [];
	          cancelAnimationReflow = null;
	          lookupCache = {};
	        });
	      }
	
	      var closingTimer = null;
	      var closingTimestamp = 0;
	      var animationElementQueue = [];
	      function animationCloseHandler(element, totalTime) {
	        var node = extractElementNode(element);
	        element = angular.element(node);
	
	        //this item will be garbage collected by the closing
	        //animation timeout
	        animationElementQueue.push(element);
	
	        //but it may not need to cancel out the existing timeout
	        //if the timestamp is less than the previous one
	        var futureTimestamp = Date.now() + totalTime;
	        if (futureTimestamp <= closingTimestamp) {
	          return;
	        }
	
	        $timeout.cancel(closingTimer);
	
	        closingTimestamp = futureTimestamp;
	        closingTimer = $timeout(function() {
	          closeAllAnimations(animationElementQueue);
	          animationElementQueue = [];
	        }, totalTime, false);
	      }
	
	      function closeAllAnimations(elements) {
	        forEach(elements, function(element) {
	          var elementData = element.data(NG_ANIMATE_CSS_DATA_KEY);
	          if (elementData) {
	            forEach(elementData.closeAnimationFns, function(fn) {
	              fn();
	            });
	          }
	        });
	      }
	
	      function getElementAnimationDetails(element, cacheKey) {
	        var data = cacheKey ? lookupCache[cacheKey] : null;
	        if (!data) {
	          var transitionDuration = 0;
	          var transitionDelay = 0;
	          var animationDuration = 0;
	          var animationDelay = 0;
	
	          //we want all the styles defined before and after
	          forEach(element, function(element) {
	            if (element.nodeType == ELEMENT_NODE) {
	              var elementStyles = $window.getComputedStyle(element) || {};
	
	              var transitionDurationStyle = elementStyles[TRANSITION_PROP + DURATION_KEY];
	              transitionDuration = Math.max(parseMaxTime(transitionDurationStyle), transitionDuration);
	
	              var transitionDelayStyle = elementStyles[TRANSITION_PROP + DELAY_KEY];
	              transitionDelay  = Math.max(parseMaxTime(transitionDelayStyle), transitionDelay);
	
	              var animationDelayStyle = elementStyles[ANIMATION_PROP + DELAY_KEY];
	              animationDelay   = Math.max(parseMaxTime(elementStyles[ANIMATION_PROP + DELAY_KEY]), animationDelay);
	
	              var aDuration  = parseMaxTime(elementStyles[ANIMATION_PROP + DURATION_KEY]);
	
	              if (aDuration > 0) {
	                aDuration *= parseInt(elementStyles[ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY], 10) || 1;
	              }
	              animationDuration = Math.max(aDuration, animationDuration);
	            }
	          });
	          data = {
	            total: 0,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            animationDelay: animationDelay,
	            animationDuration: animationDuration
	          };
	          if (cacheKey) {
	            lookupCache[cacheKey] = data;
	          }
	        }
	        return data;
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = isString(str) ?
	          str.split(/\s*,\s*/) :
	          [];
	        forEach(values, function(value) {
	          maxValue = Math.max(parseFloat(value) || 0, maxValue);
	        });
	        return maxValue;
	      }
	
	      function getCacheKey(element) {
	        var parentElement = element.parent();
	        var parentID = parentElement.data(NG_ANIMATE_PARENT_KEY);
	        if (!parentID) {
	          parentElement.data(NG_ANIMATE_PARENT_KEY, ++parentCounter);
	          parentID = parentCounter;
	        }
	        return parentID + '-' + extractElementNode(element).getAttribute('class');
	      }
	
	      function animateSetup(animationEvent, element, className, styles) {
	        var structural = ['ng-enter','ng-leave','ng-move'].indexOf(className) >= 0;
	
	        var cacheKey = getCacheKey(element);
	        var eventCacheKey = cacheKey + ' ' + className;
	        var itemIndex = lookupCache[eventCacheKey] ? ++lookupCache[eventCacheKey].total : 0;
	
	        var stagger = {};
	        if (itemIndex > 0) {
	          var staggerClassName = className + '-stagger';
	          var staggerCacheKey = cacheKey + ' ' + staggerClassName;
	          var applyClasses = !lookupCache[staggerCacheKey];
	
	          applyClasses && $$jqLite.addClass(element, staggerClassName);
	
	          stagger = getElementAnimationDetails(element, staggerCacheKey);
	
	          applyClasses && $$jqLite.removeClass(element, staggerClassName);
	        }
	
	        $$jqLite.addClass(element, className);
	
	        var formerData = element.data(NG_ANIMATE_CSS_DATA_KEY) || {};
	        var timings = getElementAnimationDetails(element, eventCacheKey);
	        var transitionDuration = timings.transitionDuration;
	        var animationDuration = timings.animationDuration;
	
	        if (structural && transitionDuration === 0 && animationDuration === 0) {
	          $$jqLite.removeClass(element, className);
	          return false;
	        }
	
	        var blockTransition = styles || (structural && transitionDuration > 0);
	        var blockAnimation = animationDuration > 0 &&
	                             stagger.animationDelay > 0 &&
	                             stagger.animationDuration === 0;
	
	        var closeAnimationFns = formerData.closeAnimationFns || [];
	        element.data(NG_ANIMATE_CSS_DATA_KEY, {
	          stagger: stagger,
	          cacheKey: eventCacheKey,
	          running: formerData.running || 0,
	          itemIndex: itemIndex,
	          blockTransition: blockTransition,
	          closeAnimationFns: closeAnimationFns
	        });
	
	        var node = extractElementNode(element);
	
	        if (blockTransition) {
	          blockTransitions(node, true);
	          if (styles) {
	            element.css(styles);
	          }
	        }
	
	        if (blockAnimation) {
	          blockAnimations(node, true);
	        }
	
	        return true;
	      }
	
	      function animateRun(animationEvent, element, className, activeAnimationComplete, styles) {
	        var node = extractElementNode(element);
	        var elementData = element.data(NG_ANIMATE_CSS_DATA_KEY);
	        if (node.getAttribute('class').indexOf(className) == -1 || !elementData) {
	          activeAnimationComplete();
	          return;
	        }
	
	        var activeClassName = '';
	        var pendingClassName = '';
	        forEach(className.split(' '), function(klass, i) {
	          var prefix = (i > 0 ? ' ' : '') + klass;
	          activeClassName += prefix + '-active';
	          pendingClassName += prefix + '-pending';
	        });
	
	        var style = '';
	        var appliedStyles = [];
	        var itemIndex = elementData.itemIndex;
	        var stagger = elementData.stagger;
	        var staggerTime = 0;
	        if (itemIndex > 0) {
	          var transitionStaggerDelay = 0;
	          if (stagger.transitionDelay > 0 && stagger.transitionDuration === 0) {
	            transitionStaggerDelay = stagger.transitionDelay * itemIndex;
	          }
	
	          var animationStaggerDelay = 0;
	          if (stagger.animationDelay > 0 && stagger.animationDuration === 0) {
	            animationStaggerDelay = stagger.animationDelay * itemIndex;
	            appliedStyles.push(CSS_PREFIX + 'animation-play-state');
	          }
	
	          staggerTime = Math.round(Math.max(transitionStaggerDelay, animationStaggerDelay) * 100) / 100;
	        }
	
	        if (!staggerTime) {
	          $$jqLite.addClass(element, activeClassName);
	          if (elementData.blockTransition) {
	            blockTransitions(node, false);
	          }
	        }
	
	        var eventCacheKey = elementData.cacheKey + ' ' + activeClassName;
	        var timings = getElementAnimationDetails(element, eventCacheKey);
	        var maxDuration = Math.max(timings.transitionDuration, timings.animationDuration);
	        if (maxDuration === 0) {
	          $$jqLite.removeClass(element, activeClassName);
	          animateClose(element, className);
	          activeAnimationComplete();
	          return;
	        }
	
	        if (!staggerTime && styles && Object.keys(styles).length > 0) {
	          if (!timings.transitionDuration) {
	            element.css('transition', timings.animationDuration + 's linear all');
	            appliedStyles.push('transition');
	          }
	          element.css(styles);
	        }
	
	        var maxDelay = Math.max(timings.transitionDelay, timings.animationDelay);
	        var maxDelayTime = maxDelay * ONE_SECOND;
	
	        if (appliedStyles.length > 0) {
	          //the element being animated may sometimes contain comment nodes in
	          //the jqLite object, so we're safe to use a single variable to house
	          //the styles since there is always only one element being animated
	          var oldStyle = node.getAttribute('style') || '';
	          if (oldStyle.charAt(oldStyle.length - 1) !== ';') {
	            oldStyle += ';';
	          }
	          node.setAttribute('style', oldStyle + ' ' + style);
	        }
	
	        var startTime = Date.now();
	        var css3AnimationEvents = ANIMATIONEND_EVENT + ' ' + TRANSITIONEND_EVENT;
	        var animationTime     = (maxDelay + maxDuration) * CLOSING_TIME_BUFFER;
	        var totalTime         = (staggerTime + animationTime) * ONE_SECOND;
	
	        var staggerTimeout;
	        if (staggerTime > 0) {
	          $$jqLite.addClass(element, pendingClassName);
	          staggerTimeout = $timeout(function() {
	            staggerTimeout = null;
	
	            if (timings.transitionDuration > 0) {
	              blockTransitions(node, false);
	            }
	            if (timings.animationDuration > 0) {
	              blockAnimations(node, false);
	            }
	
	            $$jqLite.addClass(element, activeClassName);
	            $$jqLite.removeClass(element, pendingClassName);
	
	            if (styles) {
	              if (timings.transitionDuration === 0) {
	                element.css('transition', timings.animationDuration + 's linear all');
	              }
	              element.css(styles);
	              appliedStyles.push('transition');
	            }
	          }, staggerTime * ONE_SECOND, false);
	        }
	
	        element.on(css3AnimationEvents, onAnimationProgress);
	        elementData.closeAnimationFns.push(function() {
	          onEnd();
	          activeAnimationComplete();
	        });
	
	        elementData.running++;
	        animationCloseHandler(element, totalTime);
	        return onEnd;
	
	        // This will automatically be called by $animate so
	        // there is no need to attach this internally to the
	        // timeout done method.
	        function onEnd() {
	          element.off(css3AnimationEvents, onAnimationProgress);
	          $$jqLite.removeClass(element, activeClassName);
	          $$jqLite.removeClass(element, pendingClassName);
	          if (staggerTimeout) {
	            $timeout.cancel(staggerTimeout);
	          }
	          animateClose(element, className);
	          var node = extractElementNode(element);
	          for (var i in appliedStyles) {
	            node.style.removeProperty(appliedStyles[i]);
	          }
	        }
	
	        function onAnimationProgress(event) {
	          event.stopPropagation();
	          var ev = event.originalEvent || event;
	          var timeStamp = ev.$manualTimeStamp || ev.timeStamp || Date.now();
	
	          /* Firefox (or possibly just Gecko) likes to not round values up
	           * when a ms measurement is used for the animation */
	          var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	          /* $manualTimeStamp is a mocked timeStamp value which is set
	           * within browserTrigger(). This is only here so that tests can
	           * mock animations properly. Real events fallback to event.timeStamp,
	           * or, if they don't, then a timeStamp is automatically created for them.
	           * We're checking to see if the timeStamp surpasses the expected delay,
	           * but we're using elapsedTime instead of the timeStamp on the 2nd
	           * pre-condition since animations sometimes close off early */
	          if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	            activeAnimationComplete();
	          }
	        }
	      }
	
	      function blockTransitions(node, bool) {
	        node.style[TRANSITION_PROP + PROPERTY_KEY] = bool ? 'none' : '';
	      }
	
	      function blockAnimations(node, bool) {
	        node.style[ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY] = bool ? 'paused' : '';
	      }
	
	      function animateBefore(animationEvent, element, className, styles) {
	        if (animateSetup(animationEvent, element, className, styles)) {
	          return function(cancelled) {
	            cancelled && animateClose(element, className);
	          };
	        }
	      }
	
	      function animateAfter(animationEvent, element, className, afterAnimationComplete, styles) {
	        if (element.data(NG_ANIMATE_CSS_DATA_KEY)) {
	          return animateRun(animationEvent, element, className, afterAnimationComplete, styles);
	        } else {
	          animateClose(element, className);
	          afterAnimationComplete();
	        }
	      }
	
	      function animate(animationEvent, element, className, animationComplete, options) {
	        //If the animateSetup function doesn't bother returning a
	        //cancellation function then it means that there is no animation
	        //to perform at all
	        var preReflowCancellation = animateBefore(animationEvent, element, className, options.from);
	        if (!preReflowCancellation) {
	          clearCacheAfterReflow();
	          animationComplete();
	          return;
	        }
	
	        //There are two cancellation functions: one is before the first
	        //reflow animation and the second is during the active state
	        //animation. The first function will take care of removing the
	        //data from the element which will not make the 2nd animation
	        //happen in the first place
	        var cancel = preReflowCancellation;
	        afterReflow(element, function() {
	          //once the reflow is complete then we point cancel to
	          //the new cancellation function which will remove all of the
	          //animation properties from the active animation
	          cancel = animateAfter(animationEvent, element, className, animationComplete, options.to);
	        });
	
	        return function(cancelled) {
	          (cancel || noop)(cancelled);
	        };
	      }
	
	      function animateClose(element, className) {
	        $$jqLite.removeClass(element, className);
	        var data = element.data(NG_ANIMATE_CSS_DATA_KEY);
	        if (data) {
	          if (data.running) {
	            data.running--;
	          }
	          if (!data.running || data.running === 0) {
	            element.removeData(NG_ANIMATE_CSS_DATA_KEY);
	          }
	        }
	      }
	
	      return {
	        animate: function(element, className, from, to, animationCompleted, options) {
	          options = options || {};
	          options.from = from;
	          options.to = to;
	          return animate('animate', element, className, animationCompleted, options);
	        },
	
	        enter: function(element, animationCompleted, options) {
	          options = options || {};
	          return animate('enter', element, 'ng-enter', animationCompleted, options);
	        },
	
	        leave: function(element, animationCompleted, options) {
	          options = options || {};
	          return animate('leave', element, 'ng-leave', animationCompleted, options);
	        },
	
	        move: function(element, animationCompleted, options) {
	          options = options || {};
	          return animate('move', element, 'ng-move', animationCompleted, options);
	        },
	
	        beforeSetClass: function(element, add, remove, animationCompleted, options) {
	          options = options || {};
	          var className = suffixClasses(remove, '-remove') + ' ' +
	                          suffixClasses(add, '-add');
	          var cancellationMethod = animateBefore('setClass', element, className, options.from);
	          if (cancellationMethod) {
	            afterReflow(element, animationCompleted);
	            return cancellationMethod;
	          }
	          clearCacheAfterReflow();
	          animationCompleted();
	        },
	
	        beforeAddClass: function(element, className, animationCompleted, options) {
	          options = options || {};
	          var cancellationMethod = animateBefore('addClass', element, suffixClasses(className, '-add'), options.from);
	          if (cancellationMethod) {
	            afterReflow(element, animationCompleted);
	            return cancellationMethod;
	          }
	          clearCacheAfterReflow();
	          animationCompleted();
	        },
	
	        beforeRemoveClass: function(element, className, animationCompleted, options) {
	          options = options || {};
	          var cancellationMethod = animateBefore('removeClass', element, suffixClasses(className, '-remove'), options.from);
	          if (cancellationMethod) {
	            afterReflow(element, animationCompleted);
	            return cancellationMethod;
	          }
	          clearCacheAfterReflow();
	          animationCompleted();
	        },
	
	        setClass: function(element, add, remove, animationCompleted, options) {
	          options = options || {};
	          remove = suffixClasses(remove, '-remove');
	          add = suffixClasses(add, '-add');
	          var className = remove + ' ' + add;
	          return animateAfter('setClass', element, className, animationCompleted, options.to);
	        },
	
	        addClass: function(element, className, animationCompleted, options) {
	          options = options || {};
	          return animateAfter('addClass', element, suffixClasses(className, '-add'), animationCompleted, options.to);
	        },
	
	        removeClass: function(element, className, animationCompleted, options) {
	          options = options || {};
	          return animateAfter('removeClass', element, suffixClasses(className, '-remove'), animationCompleted, options.to);
	        }
	      };
	
	      function suffixClasses(classes, suffix) {
	        var className = '';
	        classes = isArray(classes) ? classes : classes.split(/\s+/);
	        forEach(classes, function(klass, i) {
	          if (klass && klass.length > 0) {
	            className += (i > 0 ? ' ' : '') + klass + suffix;
	          }
	        });
	        return className;
	      }
	    }]);
	  }]);
	
	
	})(window, window.angular);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(438);
	module.exports = 'ngAnimate';


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	angular.module('colorpicker.module', [])
	    .factory('Helper', function () {
	      'use strict';
	      return {
	        closestSlider: function (elem) {
	          var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	          if (matchesSelector.bind(elem)('I')) {
	            return elem.parentNode;
	          }
	          return elem;
	        },
	        getOffset: function (elem, fixedPosition) {
	          var
	            scrollX = 0,
	            scrollY = 0,
	            rect = elem.getBoundingClientRect();
	          while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
	            if (!fixedPosition && elem.tagName === 'BODY') {
	              scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
	              scrollY += document.documentElement.scrollTop || elem.scrollTop;
	            } else {
	              scrollX += elem.scrollLeft;
	              scrollY += elem.scrollTop;
	            }
	            elem = elem.offsetParent;
	          }
	          return {
	            top: rect.top + window.pageYOffset,
	            left: rect.left + window.pageXOffset,
	            scrollX: scrollX,
	            scrollY: scrollY
	          };
	        },
	        // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
	        stringParsers: [
	          {
	            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	            parse: function (execResult) {
	              return [
	                execResult[1],
	                execResult[2],
	                execResult[3],
	                execResult[4]
	              ];
	            }
	          },
	          {
	            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	            parse: function (execResult) {
	              return [
	                2.55 * execResult[1],
	                2.55 * execResult[2],
	                2.55 * execResult[3],
	                execResult[4]
	              ];
	            }
	          },
	          {
	            re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
	            parse: function (execResult) {
	              return [
	                parseInt(execResult[1], 16),
	                parseInt(execResult[2], 16),
	                parseInt(execResult[3], 16)
	              ];
	            }
	          },
	          {
	            re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
	            parse: function (execResult) {
	              return [
	                parseInt(execResult[1] + execResult[1], 16),
	                parseInt(execResult[2] + execResult[2], 16),
	                parseInt(execResult[3] + execResult[3], 16)
	              ];
	            }
	          }
	        ]
	      };
	    })
	    .factory('Color', ['Helper', function (Helper) {
	      'use strict';
	      return {
	        value: {
	          h: 1,
	          s: 1,
	          b: 1,
	          a: 1
	        },
	        // translate a format from Color object to a string
	        'rgb': function () {
	          var rgb = this.toRGB();
	          return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
	        },
	        'rgba': function () {
	          var rgb = this.toRGB();
	          return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
	        },
	        'hex': function () {
	          return  this.toHex();
	        },
	
	        // HSBtoRGB from RaphaelJS
	        RGBtoHSB: function (r, g, b, a) {
	          r /= 255;
	          g /= 255;
	          b /= 255;
	
	          var H, S, V, C;
	          V = Math.max(r, g, b);
	          C = V - Math.min(r, g, b);
	          H = (C === 0 ? null :
	              V === r ? (g - b) / C :
	                  V === g ? (b - r) / C + 2 :
	                      (r - g) / C + 4
	              );
	          H = ((H + 360) % 6) * 60 / 360;
	          S = C === 0 ? 0 : C / V;
	          return {h: H || 1, s: S, b: V, a: a || 1};
	        },
	
	        //parse a string to HSB
	        setColor: function (val) {
	          val = (val) ? val.toLowerCase() : val;
	          for (var key in Helper.stringParsers) {
	            if (Helper.stringParsers.hasOwnProperty(key)) {
	              var parser = Helper.stringParsers[key];
	              var match = parser.re.exec(val),
	                  values = match && parser.parse(match);
	              if (values) {
	                this.value = this.RGBtoHSB.apply(null, values);
	                return false;
	              }
	            }
	          }
	        },
	
	        setHue: function (h) {
	          this.value.h = 1 - h;
	        },
	
	        setSaturation: function (s) {
	          this.value.s = s;
	        },
	
	        setLightness: function (b) {
	          this.value.b = 1 - b;
	        },
	
	        setAlpha: function (a) {
	          this.value.a = parseInt((1 - a) * 100, 10) / 100;
	        },
	
	        // HSBtoRGB from RaphaelJS
	        // https://github.com/DmitryBaranovskiy/raphael/
	        toRGB: function (h, s, b, a) {
	          if (!h) {
	            h = this.value.h;
	            s = this.value.s;
	            b = this.value.b;
	          }
	          h *= 360;
	          var R, G, B, X, C;
	          h = (h % 360) / 60;
	          C = b * s;
	          X = C * (1 - Math.abs(h % 2 - 1));
	          R = G = B = b - C;
	
	          h = ~~h;
	          R += [C, X, 0, 0, X, C][h];
	          G += [X, C, C, X, 0, 0][h];
	          B += [0, 0, X, C, C, X][h];
	          return {
	            r: Math.round(R * 255),
	            g: Math.round(G * 255),
	            b: Math.round(B * 255),
	            a: a || this.value.a
	          };
	        },
	
	        toHex: function (h, s, b, a) {
	          var rgb = this.toRGB(h, s, b, a);
	          return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
	        }
	      };
	    }])
	    .factory('Slider', ['Helper', function (Helper) {
	      'use strict';
	      var
	          slider = {
	            maxLeft: 0,
	            maxTop: 0,
	            callLeft: null,
	            callTop: null,
	            knob: {
	              top: 0,
	              left: 0
	            }
	          },
	          pointer = {};
	
	      return {
	        getSlider: function() {
	          return slider;
	        },
	        getLeftPosition: function(event) {
	          return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
	        },
	        getTopPosition: function(event) {
	          return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
	        },
	        setSlider: function (event, fixedPosition) {
	          var
	            target = Helper.closestSlider(event.target),
	            targetOffset = Helper.getOffset(target, fixedPosition),
	            rect = target.getBoundingClientRect(),
	            offsetX = event.clientX - rect.left,
	            offsetY = event.clientY - rect.top;
	
	          slider.knob = target.children[0].style;
	          slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
	          slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;
	
	          pointer = {
	            left: event.pageX - (offsetX - slider.left),
	            top: event.pageY - (offsetY - slider.top)
	          };
	        },
	        setSaturation: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: componentSize,
	            maxTop: componentSize,
	            callLeft: 'setSaturation',
	            callTop: 'setLightness'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setHue: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: 0,
	            maxTop: componentSize,
	            callLeft: false,
	            callTop: 'setHue'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setAlpha: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: 0,
	            maxTop: componentSize,
	            callLeft: false,
	            callTop: 'setAlpha'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setKnob: function(top, left) {
	          slider.knob.top = top + 'px';
	          slider.knob.left = left + 'px';
	        }
	      };
	    }])
	    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
	      'use strict';
	      return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function ($scope, elem, attrs, ngModel) {
	          var
	              thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
	              position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
	              inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
	              fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
	              target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
	              withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
	              componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
	              componentSizePx = componentSize + 'px',
	              inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
	              closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
	              template =
	                  '<div class="colorpicker dropdown">' +
	                      '<div class="dropdown-menu">' +
	                      '<colorpicker-saturation><i></i></colorpicker-saturation>' +
	                      '<colorpicker-hue><i></i></colorpicker-hue>' +
	                      '<colorpicker-alpha><i></i></colorpicker-alpha>' +
	                      '<colorpicker-preview></colorpicker-preview>' +
	                      inputTemplate +
	                      closeButton +
	                      '</div>' +
	                      '</div>',
	              colorpickerTemplate = angular.element(template),
	              pickerColor = Color,
	              colorpickerValue = {
	                h: 1,
	                s: 0,
	                b: 1,
	                a: 1
	              },
	              sliderAlpha,
	              sliderHue = colorpickerTemplate.find('colorpicker-hue'),
	              sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
	              colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
	              pickerColorPointers = colorpickerTemplate.find('i'),
	              componentWidthWithToolbars = parseInt(componentSize) + 29 + (thisFormat === 'rgba' ? 15 : 0),
	              componentHeightWithToolbars = parseInt(componentSize) + 55;
	
	          $compile(colorpickerTemplate)($scope);
	          colorpickerTemplate.css('min-width', componentWidthWithToolbars + 'px');
	          sliderSaturation.css({
	            'width' : componentSizePx,
	            'height' : componentSizePx
	          });
	          sliderHue.css('height', componentSizePx);
	
	          if (withInput) {
	            var pickerColorInput = colorpickerTemplate.find('input');
	            pickerColorInput.css('width', componentSizePx);
	            pickerColorInput
	                .on('mousedown', function(event) {
	                  event.stopPropagation();
	                })
	              .on('keyup', function() {
	                var newColor = this.value;
	                elem.val(newColor);
	                if (ngModel && ngModel.$modelValue !== newColor) {
	                  $scope.$apply(ngModel.$setViewValue(newColor));
	                  update(true);
	                }
	              });
	          }
	
	          function bindMouseEvents() {
	            $document.on('mousemove', mousemove);
	            $document.on('mouseup', mouseup);
	          }
	
	          if (thisFormat === 'rgba') {
	            colorpickerTemplate.addClass('alpha');
	            sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
	            sliderAlpha.css('height', componentSizePx);
	            sliderAlpha
	                .on('click', function(event) {
	                  Slider.setAlpha(event, fixedPosition, componentSize);
	                  mousemove(event);
	                })
	                .on('mousedown', function(event) {
	                  Slider.setAlpha(event, fixedPosition, componentSize);
	                  bindMouseEvents();
	                })
	                .on('mouseup', function(event){
	                  emitEvent('colorpicker-selected-alpha');
	                });
	          }
	
	          sliderHue
	              .on('click', function(event) {
	                Slider.setHue(event, fixedPosition, componentSize);
	                mousemove(event);
	              })
	              .on('mousedown', function(event) {
	                Slider.setHue(event, fixedPosition, componentSize);
	                bindMouseEvents();
	              })
	              .on('mouseup', function(event){
	                emitEvent('colorpicker-selected-hue');
	              });
	
	          sliderSaturation
	              .on('click', function(event) {
	                Slider.setSaturation(event, fixedPosition, componentSize);
	                mousemove(event);
	                if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
	                  hideColorpickerTemplate();
	                }
	              })
	              .on('mousedown', function(event) {
	                Slider.setSaturation(event, fixedPosition, componentSize);
	                bindMouseEvents();
	              })
	              .on('mouseup', function(event){
	                emitEvent('colorpicker-selected-saturation');
	              });
	
	          if (fixedPosition) {
	            colorpickerTemplate.addClass('colorpicker-fixed-position');
	          }
	
	          colorpickerTemplate.addClass('colorpicker-position-' + position);
	          if (inline === 'true') {
	            colorpickerTemplate.addClass('colorpicker-inline');
	          }
	
	          target.append(colorpickerTemplate);
	
	          if (ngModel) {
	            ngModel.$render = function () {
	              elem.val(ngModel.$viewValue);
	
	              update();
	            };
	          }
	
	          elem.on('blur keyup change', function() {
	            update();
	          });
	
	          elem.on('$destroy', function() {
	            colorpickerTemplate.remove();
	          });
	
	          function previewColor() {
	            try {
	              colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
	            } catch (e) {
	              colorpickerPreview.css('backgroundColor', pickerColor.toHex());
	            }
	            sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
	            if (thisFormat === 'rgba') {
	              sliderAlpha.css.backgroundColor = pickerColor.toHex();
	            }
	          }
	
	          function mousemove(event) {
	            var
	                left = Slider.getLeftPosition(event),
	                top = Slider.getTopPosition(event),
	                slider = Slider.getSlider();
	
	            Slider.setKnob(top, left);
	
	            if (slider.callLeft) {
	              pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
	            }
	            if (slider.callTop) {
	              pickerColor[slider.callTop].call(pickerColor, top / componentSize);
	            }
	            previewColor();
	            var newColor = pickerColor[thisFormat]();
	            elem.val(newColor);
	            if (ngModel) {
	              $scope.$apply(ngModel.$setViewValue(newColor));
	            }
	            if (withInput) {
	              pickerColorInput.val(newColor);
	            }
	            return false;
	          }
	
	          function mouseup() {
	            emitEvent('colorpicker-selected');
	            $document.off('mousemove', mousemove);
	            $document.off('mouseup', mouseup);
	          }
	
	          function update(omitInnerInput) {
	            pickerColor.value = colorpickerValue;
	            pickerColor.setColor(elem.val());
	            if (withInput && !omitInnerInput) {
	              pickerColorInput.val(elem.val());
	            }
	            pickerColorPointers.eq(0).css({
	              left: pickerColor.value.s * componentSize + 'px',
	              top: componentSize - pickerColor.value.b * componentSize + 'px'
	            });
	            pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
	            pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
	            colorpickerValue = pickerColor.value;
	            previewColor();
	          }
	
	          function getColorpickerTemplatePosition() {
	            var
	                positionValue,
	                positionOffset = Helper.getOffset(elem[0]),
	                additionalSpaceBetweenElements = 2;
	
	            if(angular.isDefined(attrs.colorpickerParent)) {
	              positionOffset.left = 0;
	              positionOffset.top = 0;
	            }
	
	            if (position === 'top') {
	              positionValue =  {
	                'top': positionOffset.top - componentHeightWithToolbars - additionalSpaceBetweenElements,
	                'left': positionOffset.left
	              };
	            } else if (position === 'right') {
	              positionValue = {
	                'top': positionOffset.top,
	                'left': positionOffset.left + elem[0].offsetWidth + additionalSpaceBetweenElements
	              };
	            } else if (position === 'bottom') {
	              positionValue = {
	                'top': positionOffset.top + elem[0].offsetHeight + additionalSpaceBetweenElements,
	                'left': positionOffset.left
	              };
	            } else if (position === 'left') {
	              positionValue = {
	                'top': positionOffset.top,
	                'left': positionOffset.left - componentWidthWithToolbars - additionalSpaceBetweenElements
	              };
	            }
	            return {
	              'top': positionValue.top + 'px',
	              'left': positionValue.left + 'px'
	            };
	          }
	
	          function documentMousedownHandler() {
	            hideColorpickerTemplate();
	          }
	
	          function showColorpickerTemplate() {
	
	            if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
	              update();
	              colorpickerTemplate
	                .addClass('colorpicker-visible')
	                .css(getColorpickerTemplatePosition());
	              emitEvent('colorpicker-shown');
	
	              if (inline === false) {
	                // register global mousedown event to hide the colorpicker
	                $document.on('mousedown', documentMousedownHandler);
	              }
	
	              if (attrs.colorpickerIsOpen) {
	                $scope[attrs.colorpickerIsOpen] = true;
	                if (!$scope.$$phase || !$scope.$root.$$phase) {
	                  $scope.$digest(); //trigger the watcher to fire
	                }
	              }
	            }
	          }
	
	          if (inline === false) {
	            elem.on('click', showColorpickerTemplate);
	          } else {
	            showColorpickerTemplate();
	          }
	
	          colorpickerTemplate.on('mousedown', function (event) {
	            event.stopPropagation();
	            event.preventDefault();
	          });
	
	          function emitEvent(name) {
	            if (ngModel) {
	              $scope.$emit(name, {
	                name: attrs.ngModel,
	                value: ngModel.$modelValue
	              });
	            }
	          }
	
	          function hideColorpickerTemplate() {
	            if (colorpickerTemplate.hasClass('colorpicker-visible')) {
	              colorpickerTemplate.removeClass('colorpicker-visible');
	              emitEvent('colorpicker-closed');
	              // unregister the global mousedown event
	              $document.off('mousedown', documentMousedownHandler);
	
	              if (attrs.colorpickerIsOpen) {
	                $scope[attrs.colorpickerIsOpen] = false;
	                if (!$scope.$$phase || !$scope.$root.$$phase) {
	                  $scope.$digest(); //trigger the watcher to fire
	                }
	              }
	            }
	          }
	
	          colorpickerTemplate.find('button').on('click', function () {
	            hideColorpickerTemplate();
	          });
	
	          if (attrs.colorpickerIsOpen) {
	            $scope.$watch(attrs.colorpickerIsOpen, function(shouldBeOpen) {
	
	              if (shouldBeOpen === true) {
	                showColorpickerTemplate();
	              } else if (shouldBeOpen === false) {
	                hideColorpickerTemplate();
	              }
	
	            });
	          }
	        }
	      };
	    }]);


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory(require('angular'));
	    } else {
	        root.angularClipboard = factory(root.angular);
	  }
	}(this, function (angular) {
	
	return angular.module('angular-clipboard', [])
	    .factory('clipboard', ['$document', '$window', function ($document, $window) {
	        function createNode(text, context) {
	            var node = $document[0].createElement('textarea');
	            node.style.position = 'absolute';
	            node.textContent = text;
	            node.style.left = '-10000px';
	            node.style.top = ($window.pageYOffset || $document[0].documentElement.scrollTop) + 'px';
	            return node;
	        }
	
	        function copyNode(node) {
	            try {
	                // Set inline style to override css styles
	                $document[0].body.style.webkitUserSelect = 'initial';
	
	                var selection = $document[0].getSelection();
	                selection.removeAllRanges();
	                node.select();
	
	                if(!$document[0].execCommand('copy')) {
	                    throw('failure copy');
	                }
	                selection.removeAllRanges();
	            } finally {
	                // Reset inline style
	                $document[0].body.style.webkitUserSelect = '';
	            }
	        }
	
	        function copyText(text, context) {
	            var node = createNode(text, context);
	            $document[0].body.appendChild(node);
	            copyNode(node);
	            $document[0].body.removeChild(node);
	        }
	
	        return {
	            copyText: copyText,
	            supported: 'queryCommandSupported' in $document[0] && $document[0].queryCommandSupported('copy')
	        };
	    }])
	    .directive('clipboard', ['clipboard', function (clipboard) {
	        return {
	            restrict: 'A',
	            scope: {
	                onCopied: '&',
	                onError: '&',
	                text: '=',
	                supported: '=?'
	            },
	            link: function (scope, element) {
	                scope.supported = clipboard.supported;
	
	                element.on('click', function (event) {
	                    try {
	                        clipboard.copyText(scope.text, element[0]);
	                        if (angular.isFunction(scope.onCopied)) {
	                            scope.$evalAsync(scope.onCopied());
	                        }
	                    } catch (err) {
	                        if (angular.isFunction(scope.onError)) {
	                            scope.$evalAsync(scope.onError({err: err}));
	                        }
	                    }
	                });
	            }
	        };
	    }]);
	
	}));


/***/ }),
/* 442 */
/***/ (function(module, exports) {

	/*
	 * angular-elastic v2.5.1
	 * (c) 2014 Monospaced http://monospaced.com
	 * License: MIT
	 */
	
	if (typeof module !== 'undefined' &&
	    typeof exports !== 'undefined' &&
	    module.exports === exports){
	  module.exports = 'monospaced.elastic';
	}
	
	angular.module('monospaced.elastic', [])
	
	  .constant('msdElasticConfig', {
	    append: ''
	  })
	
	  .directive('msdElastic', [
	    '$timeout', '$window', 'msdElasticConfig',
	    function($timeout, $window, config) {
	      'use strict';
	
	      return {
	        require: 'ngModel',
	        restrict: 'A, C',
	        link: function(scope, element, attrs, ngModel) {
	
	          // cache a reference to the DOM element
	          var ta = element[0],
	              $ta = element;
	
	          // ensure the element is a textarea, and browser is capable
	          if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
	            return;
	          }
	
	          // set these properties before measuring dimensions
	          $ta.css({
	            'overflow': 'hidden',
	            'overflow-y': 'hidden',
	            'word-wrap': 'break-word'
	          });
	
	          // force text reflow
	          var text = ta.value;
	          ta.value = '';
	          ta.value = text;
	
	          var append = attrs.msdElastic ? attrs.msdElastic.replace(/\\n/g, '\n') : config.append,
	              $win = angular.element($window),
	              mirrorInitStyle = 'position: absolute; top: -999px; right: auto; bottom: auto;' +
	                                'left: 0; overflow: hidden; -webkit-box-sizing: content-box;' +
	                                '-moz-box-sizing: content-box; box-sizing: content-box;' +
	                                'min-height: 0 !important; height: 0 !important; padding: 0;' +
	                                'word-wrap: break-word; border: 0;',
	              $mirror = angular.element('<textarea aria-hidden="true" tabindex="-1" ' +
	                                        'style="' + mirrorInitStyle + '"/>').data('elastic', true),
	              mirror = $mirror[0],
	              taStyle = getComputedStyle(ta),
	              resize = taStyle.getPropertyValue('resize'),
	              borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
	                          taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
	                          taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box',
	              boxOuter = !borderBox ? {width: 0, height: 0} : {
	                            width:  parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-right'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-left'), 10) +
	                                    parseInt(taStyle.getPropertyValue('border-left-width'), 10),
	                            height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-top'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
	                                    parseInt(taStyle.getPropertyValue('border-bottom-width'), 10)
	                          },
	              minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10),
	              heightValue = parseInt(taStyle.getPropertyValue('height'), 10),
	              minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height,
	              maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10),
	              mirrored,
	              active,
	              copyStyle = ['font-family',
	                           'font-size',
	                           'font-weight',
	                           'font-style',
	                           'letter-spacing',
	                           'line-height',
	                           'text-transform',
	                           'word-spacing',
	                           'text-indent'];
	
	          // exit if elastic already applied (or is the mirror element)
	          if ($ta.data('elastic')) {
	            return;
	          }
	
	          // Opera returns max-height of -1 if not set
	          maxHeight = maxHeight && maxHeight > 0 ? maxHeight : 9e4;
	
	          // append mirror to the DOM
	          if (mirror.parentNode !== document.body) {
	            angular.element(document.body).append(mirror);
	          }
	
	          // set resize and apply elastic
	          $ta.css({
	            'resize': (resize === 'none' || resize === 'vertical') ? 'none' : 'horizontal'
	          }).data('elastic', true);
	
	          /*
	           * methods
	           */
	
	          function initMirror() {
	            var mirrorStyle = mirrorInitStyle;
	
	            mirrored = ta;
	            // copy the essential styles from the textarea to the mirror
	            taStyle = getComputedStyle(ta);
	            angular.forEach(copyStyle, function(val) {
	              mirrorStyle += val + ':' + taStyle.getPropertyValue(val) + ';';
	            });
	            mirror.setAttribute('style', mirrorStyle);
	          }
	
	          function adjust() {
	            var taHeight,
	                taComputedStyleWidth,
	                mirrorHeight,
	                width,
	                overflow;
	
	            if (mirrored !== ta) {
	              initMirror();
	            }
	
	            // active flag prevents actions in function from calling adjust again
	            if (!active) {
	              active = true;
	
	              mirror.value = ta.value + append; // optional whitespace to improve animation
	              mirror.style.overflowY = ta.style.overflowY;
	
	              taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);
	
	              taComputedStyleWidth = getComputedStyle(ta).getPropertyValue('width');
	
	              // ensure getComputedStyle has returned a readable 'used value' pixel width
	              if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
	                // update mirror width in case the textarea width has changed
	                width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
	                mirror.style.width = width + 'px';
	              }
	
	              mirrorHeight = mirror.scrollHeight;
	
	              if (mirrorHeight > maxHeight) {
	                mirrorHeight = maxHeight;
	                overflow = 'scroll';
	              } else if (mirrorHeight < minHeight) {
	                mirrorHeight = minHeight;
	              }
	              mirrorHeight += boxOuter.height;
	              ta.style.overflowY = overflow || 'hidden';
	
	              if (taHeight !== mirrorHeight) {
	                scope.$emit('elastic:resize', $ta, taHeight, mirrorHeight);
	                ta.style.height = mirrorHeight + 'px';
	              }
	
	              // small delay to prevent an infinite loop
	              $timeout(function() {
	                active = false;
	              }, 1, false);
	
	            }
	          }
	
	          function forceAdjust() {
	            active = false;
	            adjust();
	          }
	
	          /*
	           * initialise
	           */
	
	          // listen
	          if ('onpropertychange' in ta && 'oninput' in ta) {
	            // IE9
	            ta['oninput'] = ta.onkeyup = adjust;
	          } else {
	            ta['oninput'] = adjust;
	          }
	
	          $win.bind('resize', forceAdjust);
	
	          scope.$watch(function() {
	            return ngModel.$modelValue;
	          }, function(newValue) {
	            forceAdjust();
	          });
	
	          scope.$on('elastic:adjust', function() {
	            initMirror();
	            forceAdjust();
	          });
	
	          $timeout(adjust, 0, false);
	
	          /*
	           * destroy
	           */
	
	          scope.$on('$destroy', function() {
	            $mirror.remove();
	            $win.unbind('resize', forceAdjust);
	          });
	        }
	      };
	    }
	  ]);


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	"use strict";angular.module("google.places",[]).factory("googlePlacesApi",["$window",function(a){if(!a.google)throw"Global `google` var missing. Did you forget to include the places API script?";return a.google}]).directive("gPlacesAutocomplete",["$parse","$compile","$timeout","$document","googlePlacesApi",function(a,b,c,d,e){return{restrict:"A",require:"^ngModel",scope:{model:"=ngModel",options:"=?",forceSelection:"=?",customPlaces:"=?"},controller:["$scope",function(a){}],link:function(a,f,g,h){function i(){f.bind("keydown",l),f.bind("blur",m),f.bind("submit",m),a.$watch("selected",n)}function j(){var c,e=angular.element("<div g-places-autocomplete-drawer></div>"),f=angular.element(d[0].body);e.attr({input:"input",query:"query",predictions:"predictions",active:"active",selected:"selected"}),c=b(e)(a),f.append(c),a.$on("$destroy",function(){c.remove()})}function k(){h.$parsers.push(o),h.$formatters.push(p),h.$render=q}function l(b){0!==a.predictions.length&&-1!==w(A,b.which)&&(b.preventDefault(),b.which===z.down?(a.active=(a.active+1)%a.predictions.length,a.$digest()):b.which===z.up?(a.active=(a.active?a.active:a.predictions.length)-1,a.$digest()):13===b.which||9===b.which?(a.forceSelection&&(a.active=-1===a.active?0:a.active),a.$apply(function(){a.selected=a.active,-1===a.selected&&r()})):27===b.which&&a.$apply(function(){b.stopPropagation(),r()}))}function m(b){0!==a.predictions.length&&(a.forceSelection&&(a.selected=-1===a.selected?0:a.selected),a.$digest(),a.$apply(function(){-1===a.selected&&r()}))}function n(){var b;b=a.predictions[a.selected],b&&(b.is_custom?a.$apply(function(){a.model=b.place,a.$emit("g-places-autocomplete:select",b.place),c(function(){h.$viewChangeListeners.forEach(function(a){a()})})}):C.getDetails({placeId:b.place_id},function(b,d){d==e.maps.places.PlacesServiceStatus.OK&&a.$apply(function(){a.model=b,a.$emit("g-places-autocomplete:select",b),c(function(){h.$viewChangeListeners.forEach(function(a){a()})})})}),r())}function o(b){var c;return b&&u(b)?(a.query=b,c=angular.extend({input:b},a.options),B.getPlacePredictions(c,function(b,c){a.$apply(function(){var d;r(),a.customPlaces&&(d=s(a.query),a.predictions.push.apply(a.predictions,d)),c==e.maps.places.PlacesServiceStatus.OK&&a.predictions.push.apply(a.predictions,b),a.predictions.length>5&&(a.predictions.length=5)})}),a.forceSelection?h.$modelValue:b):b}function p(a){var b="";return u(a)?b=a:v(a)&&(b=a.formatted_address),b}function q(){return f.val(h.$viewValue)}function r(){a.active=-1,a.selected=-1,a.predictions=[]}function s(b){var c,d,e,f=[];for(e=0;e<a.customPlaces.length;e++)c=a.customPlaces[e],d=t(b,c),d.matched_substrings.length>0&&f.push({is_custom:!0,custom_prediction_label:c.custom_prediction_label||"(Custom Non-Google Result)",description:c.formatted_address,place:c,matched_substrings:d.matched_substrings,terms:d.terms});return f}function t(a,b){var c,d,e,f=a+"",g=[],h=[];for(d=b.formatted_address.split(","),e=0;e<d.length;e++)c=d[e].trim(),f.length>0&&(c.length>=f.length?(x(c,f)&&h.push({length:f.length,offset:e}),f=""):x(f,c)?(h.push({length:c.length,offset:e}),f=f.replace(c,"").trim()):f=""),g.push({value:c,offset:b.formatted_address.indexOf(c)});return{matched_substrings:h,terms:g}}function u(a){return"[object String]"==Object.prototype.toString.call(a)}function v(a){return"[object Object]"==Object.prototype.toString.call(a)}function w(a,b){var c,d;if(null==a)return-1;for(d=a.length,c=0;d>c;c++)if(a[c]===b)return c;return-1}function x(a,b){return 0===y(a).lastIndexOf(y(b),0)}function y(a){return null==a?"":a.toLowerCase()}var z={tab:9,enter:13,esc:27,up:38,down:40},A=[z.tab,z.enter,z.esc,z.up,z.down],B=new e.maps.places.AutocompleteService,C=new e.maps.places.PlacesService(f[0]);!function(){a.query="",a.predictions=[],a.input=f,a.options=a.options||{},j(),i(),k()}()}}}]).directive("gPlacesAutocompleteDrawer",["$window","$document",function(a,b){var c=['<div class="pac-container" ng-if="isOpen()" ng-style="{top: position.top+\'px\', left: position.left+\'px\', width: position.width+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">','  <div class="pac-item" g-places-autocomplete-prediction index="$index" prediction="prediction" query="query"','       ng-repeat="prediction in predictions track by $index" ng-class="{\'pac-item-selected\': isActive($index) }"','       ng-mouseenter="selectActive($index)" ng-click="selectPrediction($index)" role="option" id="{{prediction.id}}">',"  </div>","</div>"];return{restrict:"A",scope:{input:"=",query:"=",predictions:"=",active:"=",selected:"="},template:c.join(""),link:function(c,d){function e(c){var d=c[0],e=d.getBoundingClientRect(),f=b[0].documentElement,g=b[0].body,h=a.pageYOffset||f.scrollTop||g.scrollTop,i=a.pageXOffset||f.scrollLeft||g.scrollLeft;return{width:e.width,height:e.height,top:e.top+e.height+h,left:e.left+i}}d.bind("mousedown",function(a){a.preventDefault()}),a.onresize=function(){c.$apply(function(){c.position=e(c.input)})},c.isOpen=function(){return c.predictions.length>0},c.isActive=function(a){return c.active===a},c.selectActive=function(a){c.active=a},c.selectPrediction=function(a){c.selected=a},c.$watch("predictions",function(){c.position=e(c.input)},!0)}}}]).directive("gPlacesAutocompletePrediction",[function(){var a=['<span class="pac-icon pac-icon-marker"></span>','<span class="pac-item-query" ng-bind-html="prediction | highlightMatched"></span>','<span ng-repeat="term in prediction.terms | unmatchedTermsOnly:prediction">{{term.value | trailingComma:!$last}}&nbsp;</span>','<span class="custom-prediction-label" ng-if="prediction.is_custom">&nbsp;{{prediction.custom_prediction_label}}</span>'];return{restrict:"A",scope:{index:"=",prediction:"=",query:"="},template:a.join("")}}]).filter("highlightMatched",["$sce",function(a){return function(b){var c,d="",e="";return b.matched_substrings.length>0&&b.terms.length>0&&(c=b.matched_substrings[0],d=b.terms[0].value.substr(c.offset,c.length),e=b.terms[0].value.substr(c.offset+c.length)),a.trustAsHtml('<span class="pac-matched">'+d+"</span>"+e)}}]).filter("unmatchedTermsOnly",[function(){return function(a,b){var c,d,e=[];for(c=0;c<a.length;c++)d=a[c],b.matched_substrings.length>0&&d.offset>b.matched_substrings[0].length&&e.push(d);return e}}]).filter("trailingComma",[function(){return function(a,b){return b?a+",":a}}]);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(443);
	module.exports = 'google.places';

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/**
	 * angular-growl-v2 - v0.7.5 - 2015-06-17
	 * http://janstevens.github.io/angular-growl-2
	 * Copyright (c) 2015 Marco Rinck,Jan Stevens; Licensed MIT
	 */
	angular.module("angular-growl",[]),angular.module("angular-growl").directive("growl",[function(){"use strict";return{restrict:"A",templateUrl:"templates/growl/growl.html",replace:!1,scope:{reference:"@",inline:"=",limitMessages:"="},controller:["$scope","$timeout","growl","growlMessages",function(a,b,c,d){a.referenceId=a.reference||0,d.initDirective(a.referenceId,a.limitMessages),a.growlMessages=d,a.inlineMessage=angular.isDefined(a.inline)?a.inline:c.inlineMessages(),a.$watch("limitMessages",function(b){var c=d.directives[a.referenceId];angular.isUndefined(b)||angular.isUndefined(c)||(c.limitMessages=b)}),a.stopTimeoutClose=function(a){a.clickToClose||(angular.forEach(a.promises,function(a){b.cancel(a)}),a.close?d.deleteMessage(a):a.close=!0)},a.alertClasses=function(a){return{"alert-success":"success"===a.severity,"alert-error":"error"===a.severity,"alert-danger":"error"===a.severity,"alert-info":"info"===a.severity,"alert-warning":"warning"===a.severity,icon:a.disableIcons===!1,"alert-dismissable":!a.disableCloseButton}},a.showCountDown=function(a){return!a.disableCountDown&&a.ttl>0},a.wrapperClasses=function(){var b={};return b["growl-fixed"]=!a.inlineMessage,b[c.position()]=!0,b},a.computeTitle=function(a){var b={success:"Success",error:"Error",info:"Information",warn:"Warning"};return b[a.severity]}}]}}]),angular.module("angular-growl").run(["$templateCache",function(a){"use strict";void 0===a.get("templates/growl/growl.html")&&a.put("templates/growl/growl.html",'<div class="growl-container" ng-class="wrapperClasses()"><div class="growl-item alert" ng-repeat="message in growlMessages.directives[referenceId].messages" ng-class="alertClasses(message)" ng-click="stopTimeoutClose(message)"><button type="button" class="close" data-dismiss="alert" aria-hidden="true" ng-click="growlMessages.deleteMessage(message)" ng-show="!message.disableCloseButton">&times;</button><button type="button" class="close" aria-hidden="true" ng-show="showCountDown(message)">{{message.countdown}}</button><h4 class="growl-title" ng-show="message.title" ng-bind="message.title"></h4><div class="growl-message" ng-bind-html="message.text"></div></div></div>')}]),angular.module("angular-growl").provider("growl",function(){"use strict";var a={success:null,error:null,warning:null,info:null},b="messages",c="text",d="title",e="severity",f=!0,g="variables",h=0,i=!1,j="top-right",k=!1,l=!1,m=!1,n=!1,o=!0;this.globalTimeToLive=function(b){if("object"==typeof b)for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c]);else for(var d in a)a.hasOwnProperty(d)&&(a[d]=b);return this},this.globalTranslateMessages=function(a){return o=a,this},this.globalDisableCloseButton=function(a){return k=a,this},this.globalDisableIcons=function(a){return l=a,this},this.globalReversedOrder=function(a){return m=a,this},this.globalDisableCountDown=function(a){return n=a,this},this.messageVariableKey=function(a){return g=a,this},this.globalInlineMessages=function(a){return i=a,this},this.globalPosition=function(a){return j=a,this},this.messagesKey=function(a){return b=a,this},this.messageTextKey=function(a){return c=a,this},this.messageTitleKey=function(a){return d=a,this},this.messageSeverityKey=function(a){return e=a,this},this.onlyUniqueMessages=function(a){return f=a,this},this.serverMessagesInterceptor=["$q","growl",function(a,c){function d(a){void 0!==a&&a.data&&a.data[b]&&a.data[b].length>0&&c.addServerMessages(a.data[b])}return{response:function(a){return d(a),a},responseError:function(b){return d(b),a.reject(b)}}}],this.$get=["$rootScope","$interpolate","$sce","$filter","$timeout","growlMessages",function(b,p,q,r,s,t){function u(a){if(G&&a.translateMessage)a.text=G(a.text,a.variables)||a.text,a.title=G(a.title)||a.title;else{var c=p(a.text);a.text=c(a.variables)}var d=t.addMessage(a);return b.$broadcast("growlMessage",a),s(function(){},0),d}function v(b,c,d){var e,f=c||{};return e={text:b,title:f.title,severity:d,ttl:f.ttl||a[d],variables:f.variables||{},disableCloseButton:void 0===f.disableCloseButton?k:f.disableCloseButton,disableIcons:void 0===f.disableIcons?l:f.disableIcons,disableCountDown:void 0===f.disableCountDown?n:f.disableCountDown,position:f.position||j,referenceId:f.referenceId||h,translateMessage:void 0===f.translateMessage?o:f.translateMessage,destroy:function(){t.deleteMessage(e)},setText:function(a){e.text=q.trustAsHtml(String(a))},onclose:f.onclose,onopen:f.onopen},u(e)}function w(a,b){return v(a,b,"warning")}function x(a,b){return v(a,b,"error")}function y(a,b){return v(a,b,"info")}function z(a,b){return v(a,b,"success")}function A(a,b,c){return c=(c||"error").toLowerCase(),v(a,b,c)}function B(a){if(a&&a.length){var b,f,h,i;for(i=a.length,b=0;i>b;b++)if(f=a[b],f[c]){h=(f[e]||"error").toLowerCase();var j={};j.variables=f[g]||{},j.title=f[d],v(f[c],j,h)}}}function C(){return f}function D(){return m}function E(){return i}function F(){return j}var G;t.onlyUnique=f,t.reverseOrder=m;try{G=r("translate")}catch(H){}return{warning:w,error:x,info:y,success:z,general:A,addServerMessages:B,onlyUnique:C,reverseOrder:D,inlineMessages:E,position:F}}]}),angular.module("angular-growl").service("growlMessages",["$sce","$timeout",function(a,b){"use strict";function c(a){var b;return b=f[a]?f[a]:f[a]={messages:[]}}function d(a){var b=a||0;return e.directives[b]||f[b]}var e=this;this.directives={};var f={};this.initDirective=function(a,b){return f[a]?(this.directives[a]=f[a],this.directives[a].limitMessages=b):this.directives[a]={messages:[],limitMessages:b},this.directives[a]},this.getAllMessages=function(a){a=a||0;var b;return b=d(a)?d(a).messages:[]},this.destroyAllMessages=function(a){for(var b=this.getAllMessages(a),c=b.length-1;c>=0;c--)b[c].destroy();var e=d(a);e&&(e.messages=[])},this.addMessage=function(d){var e,f,g,h;if(e=this.directives[d.referenceId]?this.directives[d.referenceId]:c(d.referenceId),f=e.messages,!this.onlyUnique||(angular.forEach(f,function(b){h=a.getTrustedHtml(b.text),d.text===h&&d.severity===b.severity&&d.title===b.title&&(g=!0)}),!g)){if(d.text=a.trustAsHtml(String(d.text)),d.ttl&&-1!==d.ttl&&(d.countdown=d.ttl/1e3,d.promises=[],d.close=!1,d.countdownFunction=function(){d.countdown>1?(d.countdown--,d.promises.push(b(d.countdownFunction,1e3))):d.countdown--}),angular.isDefined(e.limitMessages)){var i=f.length-(e.limitMessages-1);i>0&&f.splice(e.limitMessages-1,i)}if(this.reverseOrder?f.unshift(d):f.push(d),"function"==typeof d.onopen&&d.onopen(),d.ttl&&-1!==d.ttl){var j=this;d.promises.push(b(angular.bind(this,function(){j.deleteMessage(d)}),d.ttl)),d.promises.push(b(d.countdownFunction,1e3))}return d}},this.deleteMessage=function(a){var b=this.getAllMessages(a.referenceId),c=b.indexOf(a);c>-1&&(b[c].close=!0,b.splice(c,1)),"function"==typeof a.onclose&&a.onclose()}}]);

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	(function(angular) {
	  "use strict";
	
	  /** @const */
	  var KEY_ARROW_DOWN = 40;
	  /** @const */
	  var KEY_ARROW_UP   = 38;
	  /** @const */
	  var KEY_ENTER      = 13;
	  /** @const */
	  var KEY_ESC        = 27;
	  
	  /** @const */
	  var CONFIG_DEFAULTS = {
	    activeClass:   "mw-typeahead__item--active",
	    dropdownClass: "mw-typeahead__dropdown",
	    elementClass:  "mw-typeahead",
	    inputClass:    "mw-typeahead__input",
	    placeholder:   "",
	    caseSensitive: true,
	    itemMax:       10,
	    debounce:      100
	  };
	
	  function identity(a) {
	    return a;
	  }
	
	  function contains(str) {
	    return function(a) {
	      return a.indexOf(str) === 0;
	    };
	  }
	
	  /**
	   * Function attempting to parse a boolean from a string.
	   * 
	   * @param  {*}
	   * @param  {*=}
	   * @return {boolean|*}  Boolean or the value set as defaultValue
	   */
	  function fromBool(maybeStr, defaultValue) {
	    switch(typeof maybeStr === "string" ? maybeStr.toLowerCase().trim() : "") {
	      case "true":
	        return true;
	      case "false":
	        return false;
	      default:
	        return defaultValue;
	    }
	  }
	
	  /**
	   * Provider for global configuration of defaults.
	   * 
	   * @constructor
	   */
	  function MwTypeaheadConfigProvider() {
	    this._config = angular.extend({}, CONFIG_DEFAULTS);
	    this.$get    = function() {
	      return this._config;
	    };
	    
	    /**
	     * Sets the default element class name for the surrounding div.
	     * 
	     * @param {string}
	     */
	    this.setElementClass = function(klass) {
	      this._config.elementClass = klass;
	    };
	    /**
	     * Sets the default input element class name.
	     * 
	     * @param {string}
	     */
	    this.setInputClass = function(klass) {
	      this._config.inputClass = klass;
	    };
	    /**
	     * Sets the default class-name which will be applied to highlighted
	     * items in the suggestion-list.
	     * 
	     * @param {string}
	     */
	    this.setActiveClass = function(klass) {
	      this._config.activeClass = klass;
	    };
	    /**
	     * Sets the default class-name which will be applied to the dropdown
	     * ul-element.
	     * 
	     * @param {string}
	     */
	    this.setDropdownClass = function(klass) {
	      this._config.dropdownClass = klass;
	    };
	    /**
	     * Sets the default placeholder text for the input element.
	     * 
	     * @param {string}
	     */
	    this.setPlaceholder = function(text) {
	      this._config.placeholder = text;
	    };
	    /**
	     * Sets the default case-sensitivity setting for local matching
	     * of item texts and input value.
	     * 
	     * @param {boolean}
	     */
	    this.setCaseSensitive = function(value) {
	      this._config.caseSensitive = value;
	    };
	    /**
	     * Sets the default expected maximum number of items returned from
	     * the item-query expression.
	     * 
	     * @param {number}
	     */
	    this.setItemMax = function(value) {
	      this._config.maxItems = value;
	    };
	    /**
	     * Sets the default debounce timeout.
	     * 
	     * @param {number}
	     */
	    this.setDebounceTimeout = function(value) {
	      this._config.debounce = value;
	    };
	  }
	
	  /**
	   * Flexible typeahead directive.
	   * 
	   * Required attributes:
	   *  * ng-model:
	   *      The model instance to put the selected value in, standard
	   *      angularjs directive.
	   *  * item-query:
	   *      The expression to evaluate to retrieve additional items,
	   *      can return a populated array or a promise of one. In the expression
	   *      the parameter ``prefix`` will be set to the user-typed string in the
	   *      expression.
	   *  * item-text:
	   *      The expression evaluated for each item when performing offline
	   *      filtering, matching against entered text and filling the input when
	   *      the model is selected.
	   * 
	   * Optional attributes:
	   *  * item-max:
	   *      The expected maximum number of items in the response from the
	   *      item-query expression. If the number of items returned is less than
	   *      this the typeahead directive will exclusively use offline filtering
	   *      against the evaluated item-text expressions.
	   *      
	   *      Default: 10
	   *      
	   *  * active-class:
	   *      The class name applied to the highlighted item in the typeahead
	   *      suggestion-list.
	   *      
	   *      Default: "mw-typeahead__item--active"
	   *      
	   *  * case-sensitive:
	   *      If the matching on item-text should be case-sensitive or not.
	   *      
	   *      Default: true
	   *      
	   *  * debounce:
	   *      The timeout in milliseconds before text-changes issues queries
	   *      and updates the suggestion list. This timeout does not apply
	   *      when the user enters the first character or empties the input,
	   *      those events will fire the queries immediately.
	   *      
	   *      Default: 100
	   *      
	   *  * placeholder:
	   *      The placeholder text for the input element. Will be set as the
	   *      placeholder attribute.
	   *      
	   *      Default: ""
	   *      
	   *  * dropdown-class:
	   *      The class(es) applied to the dropdown ul-element.
	   *      
	   *      Default: "mw-typeahead__dropdown"
	   *      
	   *  * element-class:
	   *      The class added to the surrounding div.
	   *      
	   *      Default: "mw-typeahead"
	   *      
	   *  * input-class:
	   *      The class added to the input element.
	   *      
	   *      Default: "mw-typeahead__input"
	   *
	   * All of the defaults of the optional attributes can be changed via the
	   * mwTypeaheadConfig provider.
	   * 
	   * Example:
	   * <code>
	   *   <mw-typeahead item-query="listUsers(prefix)"
	   *                 item-text="item.email"
	   *                 ng-model="selectedUser"
	   *                 ng-required="true">
	   *      <li>{{::item.email}}</li>
	   *   </mw-typeahead>
	   * </code>
	   */
	  mwTypeahead.$inject = ["mwTypeaheadConfig", "$animate", "$timeout"];
	  function mwTypeahead(config, $animate, $timeout) {
	    return {
	      restrict:   "E",
	      replace:    true,
	      require:    "^ngModel",
	      transclude: true,
	      scope:      {
	        /* Expression to be evaluated with the parameter 'prefix'.
	           Should return a list of items or a promise of a list of items for the given prefix. */
	        itemQuery:   "&itemQuery",
	        /* Expression to be evaluated with the parameter 'item'.
	           Should return a string representation of the item suitable for the
	           typeahead */
	        itemText:    "&itemText",
	      },
	      template: "<div>" +
	        "<input type=\"text\" ng-model=\"text\" />" +
	        "<ul ng-show=\"showList\"></ul>" +
	      "</div>",
	      link: function($scope, elem, attrs, ngModel, $transclude) {
	        var elItemList     = elem.find("ul");
	        var elInput        = elem.find("input");
	        /* The latest issued call to elem-query */
	        var currentPromise = null;
	        /* Promise for debounce of text-changes, used for debounce */
	        var debounceText   = null;
	        /* Placeholder text for input element */
	        var placeholder    = attrs.hasOwnProperty("placeholder") ? attrs.placeholder : config.placeholder;
	        /* If the internal matching and filtering should be case-sensitive */
	        var caseSensitive  = fromBool(attrs.caseSensitive, config.caseSensitive);
	        /* Cut off for internal filtering */
	        var itemMax        = attrs.hasOwnProperty("itemMax") ? parseInt(attrs.itemMax, 10) : config.itemMax;
	        /* Class added to active item */
	        var activeClass    = attrs.activeClass || config.activeClass;
	        /* Debounce timeout for changes not going to/from empty string */
	        var debounce       = attrs.hasOwnProperty("debouce") ? parseInt(attrs.debounce, 10) : config.debounce;
	        /* By default just passthrough as we're case-sensitive by default */
	        var normalize      = identity;
	        /**
	         * List of items in the suggestion-list.
	         * 
	         * @type {Array<{el: JQLite, data: *}>}
	         */
	        var itemNodes      = [];
	
	        $scope.text        = null;
	        $scope.active      = null;
	        $scope.showList    = false;
	
	        elInput.addClass(   attrs.hasOwnProperty("inputClass")    ? attrs.inputClass    : config.inputClass);
	        elItemList.addClass(attrs.hasOwnProperty("dropdownClass") ? attrs.dropdownClass : config.dropdownClass);
	        elem.addClass(      attrs.hasOwnProperty("elementClass")  ? attrs.elementClass  : config.elementClass);
	
	        if(placeholder.length > 0) {
	          elInput.attr("placeholder", placeholder);
	        }
	
	        function toText(e) {
	          return $scope.itemText({item: e});
	        }
	
	        if( ! caseSensitive) {
	          normalize = function(str) {
	            return str.toLowerCase();
	          };
	        }
	
	        /**
	         * Selects a given item.
	         * 
	         * @param item
	         * @param cont  If to still show the list, default false
	         */
	        function select(item, showList) {
	          $scope.active = item;
	
	          if( ! item) {
	            $scope.text = "";
	            /* Stop receiving data from promises when the list has been reset */
	            currentPromise = false;
	
	            updateItemNodes([]);
	          }
	          else {
	            $scope.text     = toText(item);
	            $scope.showList = showList ? itemNodes.length > 0 : false;
	          }
	
	          ngModel.$setViewValue(item);
	        }
	        
	        function itemNodeData(n) {
	          return n.data;
	        }
	
	        function selectFromText(text) {
	          if( ! text) {
	            return select(null);
	          }
	
	          var itemTexts = itemNodes.map(itemNodeData).map(toText).map(normalize);
	          var matches   = itemTexts.filter(contains(normalize(text)));
	
	          if(matches.length === 1) {
	            /* Only one potential match, select it */
	            var idx = itemTexts.indexOf(text);
	
	            if(idx !== -1) {
	              /* Let the user continue to choose */
	              select(itemNodes[idx].data, true);
	            }
	          }
	        }
	
	        /**
	         * updateItemNodes() updates the itemNodes list to match the supplied newItems array.
	         * 
	         * It does an incremental update, only removing the nodes which are not
	         * present in newItems and adding the ones which are lacking in
	         * itemNodes.
	         * 
	         * It is assumed that the order is the same between the input
	         * and the itemNodes array.
	         * 
	         * @param {Array<Object>}
	         */
	        function updateItemNodes(newItems) {
	          function addItem(item, prev) {
	            return $transclude(function(elItem, itemScope) {
	              itemScope.item   = item;
	              itemScope.select = select;
	
	              mwTypeaheadElemLink(elItem, itemScope, $scope, activeClass);
	
	              $animate.enter(elItem, elItemList, prev);
	            });
	          }
	          
	          var i    = 0;
	          var j    = 0;
	          var nLen = newItems.length;
	          
	          while(i < nLen || j < itemNodes.length) {
	            if(itemNodes[j] && ! newItems[i]) {
	              /* debug("Removing", JSON.stringify(itemNodes[j].data), "at", j); */
	              $animate.leave(itemNodes[j].el);
	              
	              itemNodes.splice(j, 1);
	              
	              j--;
	            }
	            else if(newItems[i] && ! itemNodes[j]) {
	              /* debug("Adding", JSON.stringify(newItems[i]), "at", j); */
	              itemNodes.splice(j, 0, {
	                data: newItems[i],
	                el:   addItem(newItems[i], itemNodes[j - 1] ? itemNodes[j - 1].el : null)
	              });
	            }
	            else if( ! angular.equals(newItems[i], itemNodes[j].data)) {
	              /* debug("Adding", JSON.stringify(newItems[i]), "at", j, "before", JSON.stringify(itemNodes[j].data)); */
	              itemNodes.splice(j, 0, {
	                data: newItems[i],
	                el:   addItem(newItems[i], itemNodes[j - 1] ? itemNodes[j - 1].el : null)
	              });
	            }
	            /* else {
	              debug("Keeping", JSON.stringify(newItems[i]));
	            } */
	            
	            i++;
	            j++;
	          }
	          
	          $scope.active   = newItems[0] || null;
	          $scope.showList = newItems.length > 0;
	        }
	        
	        function setText(newValue, oldValue) {
	          /* If the value hasn't changed, or if we already have
	             it selected, then do not issue any queries */
	          if(newValue === oldValue || newValue === toText(ngModel.$viewValue)) {
	            return;
	          }
	
	          /* Local copy of the promise, to use inside promise
	             resolution code to determine if the result is still
	             applicable.  */
	          var p      = null;
	          var update = function(items) {
	            /* Only populate items if it was the most current issued promise. */
	            if(currentPromise === p) {
	              updateItemNodes(items);
	
	              selectFromText($scope.text);
	            }
	          };
	
	          if(newValue && oldValue &&
	             itemNodes.length < itemMax && currentPromise &&
	             newValue.indexOf(oldValue) === 0) {
	            /* Skip query as we can filter locally */
	            var needle = normalize(newValue);
	
	            p = (currentPromise = itemNodes.filter(function(i) {
	              return normalize(toText(i.data)).indexOf(needle) === 0;
	            }).map(itemNodeData));
	          }
	          else {
	            p = (currentPromise = $scope.itemQuery({prefix: newValue}));
	          }
	
	          if (p) {
	            if(typeof p.then === "function") {
	              p.then(update);
	            }
	            else {
	              update(p);
	            }
	          }
	        }
	
	        $scope.$watch("text", function(newValue, oldValue) {
	          $timeout.cancel(debounceText);
	
	          /* Only apply debounce if both values are non-empty,
	             we do not want to delay the immediate population
	             of the suggestion-list */
	          debounceText = $timeout(function() {
	            setText(newValue, oldValue);
	          }, newValue && oldValue ? debounce : 0);
	        });
	
	        ngModel.$render = function() {
	          select(ngModel.$viewValue);
	        };
	
	        elem.on("keydown", function(e) {
	          if( ! $scope.showList) {
	            /* Ignore keyboard events if the list is not shown */
	            return;
	          }
	
	          if(e.keyCode === KEY_ENTER && $scope.active !== ngModel.$viewValue) {
	            /* Only handle enter click if the user has not already selected something */
	            e.preventDefault();
	
	            $scope.$apply(function() {
	              select($scope.active);
	            });
	          }
	          else if(e.keyCode === KEY_ARROW_DOWN) {
	            e.preventDefault();
	
	            $scope.$apply(function() {
	              $scope.active = itemNodes[(itemNodes.map(itemNodeData).indexOf($scope.active) + 1) % itemNodes.length].data;
	            });
	          }
	          else if(e.keyCode === KEY_ARROW_UP) {
	            e.preventDefault();
	
	            $scope.$apply(function(){
	              var idx = itemNodes.map(itemNodeData).indexOf($scope.active) - 1;
	
	              $scope.active = itemNodes[idx < 0 ? itemNodes.length - 1 : idx].data;
	            });
	          }
	          else if(e.keyCode === KEY_ESC) {
	            $scope.$apply(function() {
	              $scope.showList = false;
	            });
	          }
	        });
	
	        elInput.on("focus", function() {
	          $scope.$apply(function() {
	            $scope.showList = itemNodes.length > 0;
	          });
	        });
	
	        elInput.on("blur", function() {
	          $scope.$apply(function() {
	            $scope.showList = false;
	          });
	        });
	      }
	    };
	  }
	
	  function mwTypeaheadElemLink(elem, $scope, $parent, activeClass) {
	    elem.on("click", function() {
	      $scope.$apply(function() {
	        $scope.select($scope.item);
	      });
	    });
	
	    var destroy = $parent.$watch("active", function() {
	      if($parent.active === $scope.item) {
	        elem.addClass(activeClass);
	      }
	      else {
	        elem.removeClass(activeClass);
	      }
	    });
	    
	    elem.on("$destroy", function() {
	      destroy();
	    });
	  }
	
	  angular.module("mw-typeahead", [])
	    .provider("mwTypeaheadConfig", MwTypeaheadConfigProvider)
	    .directive("mwTypeahead", mwTypeahead);
	})(angular);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.20
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$][0-9a-zA-Z_$]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && obj !== undefined; i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * # ngResource
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 *
	 * <div doc-module-components="ngResource"></div>
	 *
	 * See {@link ngResource.$resource `$resource`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parametrized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If any of the parameter value is a function, it will be executed every time
	 *   when a param value needs to be obtained for a request (unless the param was overridden).
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@` then the value for that parameter will be extracted
	 *   from the corresponding property on the `data` object (provided when calling an action method).  For
	 *   example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of `someParam`
	 *   will be `data.someProp`.
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
	 *   the default set of resource actions. The declaration should be created in the format of {@link
	 *   ng.$http#usage $http.config}:
	 *
	 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *        ...}
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be executed every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden).
	 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes to using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     response body and headers and returns its transformed (typically deserialized) version.
	 *     By default, transformResponse will contain one function that checks if the response looks like
	 *     a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior, set
	 *     `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	 *     GET request, otherwise if a cache instance built with
	 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	 *     caching.
	 *   - **`timeout`** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise} that
	 *     should abort the request when resolved.
	 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
	 *     for more information.
	 *   - **`responseType`** - `{string}` - see
	 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
	 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
	 *     with `http response` object. See {@link ng.$http $http interceptors}.
	 *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The only supported option is
	 *
	 *   Where:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   { 'get':    {method:'GET'},
	 *     'save':   {method:'POST'},
	 *     'query':  {method:'GET', isArray:true},
	 *     'remove': {method:'DELETE'},
	 *     'delete': {method:'DELETE'} };
	 *   ```
	 *
	 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
	 *   destination and parameters. When the data is returned from the server then the object is an
	 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
	 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
	 *   read, update, delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId:'@id'});
	 *   var user = User.get({userId:123}, function() {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a $resource object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
	 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
	 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   Success callback is called with (value, responseHeaders) arguments. Error callback is called
	 *   with (httpResponse) argument.
	 *
	 *   Class actions return empty instance (with additional properties below).
	 *   Instance actions return promise of the action.
	 *
	 *   The Resource instances and collection have these additional properties:
	 *
	 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in
	 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is resolved with the {@link ng.$http http response} object, without
	 *     the `resource` property.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the interceptor.
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding.
	 *
	 * @example
	 *
	 * # Credit card resource
	 *
	 * ```js
	     // Define CreditCard class
	     var CreditCard = $resource('/user/:userId/card/:cardId',
	      {userId:123, cardId:'@id'}, {
	       charge: {method:'POST', params:{charge:true}}
	      });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query(function() {
	       // GET: /user/123/card
	       // server returns: [ {id:456, number:'1234', name:'Smith'} ];
	
	       var card = cards[0];
	       // each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	       card.name = "J. Smith";
	       // non GET methods are mapped onto the instances
	       card.$save();
	       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
	       // server returns: {id:456, number:'1234', name: 'J. Smith'};
	
	       // our custom method is mapped as well.
	       card.$charge({amount:9.99});
	       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
	     });
	
	     // we can create an instance as well
	     var newCard = new CreditCard({number:'0123'});
	     newCard.name = "Mike Smith";
	     newCard.$save();
	     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
	     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
	     expect(newCard.id).toEqual(789);
	 * ```
	 *
	 * The object returned from this function execution is a resource "class" which has "static" method
	 * for each action in the definition.
	 *
	 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
	 * `headers`.
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
	 * in the response that came from the server as well as $http header getter function, so one
	 * could rewrite the above example and get access to http headers as:
	 *
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(u, getResponseHeaders){
	       u.abc = true;
	       u.$save(function(u, putResponseHeaders) {
	         //u => saved user object
	         //putResponseHeaders => $http header getter
	       });
	     });
	   ```
	 *
	 * You can also access the raw `$http` promise via the `$promise` property on the object returned
	 *
	   ```
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123})
	         .$promise.then(function(user) {
	           $scope.user = user;
	         });
	   ```
	
	 * # Creating a custom 'PUT' request
	 * In this example we create a custom method on our resource to make a PUT request
	 * ```js
	 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
	 *
	 *    // Some APIs expect a PUT request in the format URL/object/ID
	 *    // Here we are creating an 'update' method
	 *    app.factory('Notes', ['$resource', function($resource) {
	 *    return $resource('/notes/:id', null,
	 *        {
	 *            'update': { method:'PUT' }
	 *        });
	 *    }]);
	 *
	 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
	 *    // We pass in $routeParams and our Notes factory along with $scope
	 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
	                                      function($scope, $routeParams, Notes) {
	 *    // First get a note object from the factory
	 *    var note = Notes.get({ id:$routeParams.id });
	 *    $id = note.id;
	 *
	 *    // Now call update passing in the ID first then the object you are updating
	 *    Notes.update({ id:$id }, note);
	 *
	 *    // This will PUT /notes/ID with the note object in the request payload
	 *    }]);
	 * ```
	 */
	angular.module('ngResource', ['ng']).
	  provider('$resource', function() {
	    var provider = this;
	
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$q', function($http, $q) {
	
	      var noop = angular.noop,
	        forEach = angular.forEach,
	        extend = angular.extend,
	        copy = angular.copy,
	        isFunction = angular.isFunction;
	
	      /**
	       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
	       * (pchar) allowed in path segments:
	       *    segment       = *pchar
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriSegment(val) {
	        return encodeUriQuery(val, true).
	          replace(/%26/gi, '&').
	          replace(/%3D/gi, '=').
	          replace(/%2B/gi, '+');
	      }
	
	
	      /**
	       * This method is intended for encoding *key* or *value* parts of query component. We need a
	       * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
	       * have to be encoded per http://tools.ietf.org/html/rfc3986:
	       *    query       = *( pchar / "/" / "?" )
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriQuery(val, pctEncodeSpaces) {
	        return encodeURIComponent(val).
	          replace(/%40/gi, '@').
	          replace(/%3A/gi, ':').
	          replace(/%24/g, '$').
	          replace(/%2C/gi, ',').
	          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	      }
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal;
	
	          var urlParams = self.urlParams = {};
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', "hasOwnProperty is not a valid parameter name.");
	            }
	            if (!(new RegExp("^\\d+$").test(param)) && param &&
	              (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
	              urlParams[param] = true;
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	
	          params = params || {};
	          forEach(self.urlParams, function(_, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (angular.isDefined(val) && val !== null) {
	              encodedVal = encodeUriSegment(val);
	              url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp("(\/?):" + urlParam + "(\\W|$)", "g"), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) == '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // then replace collapse `/.` if found in the last URL path segment before the query
	          // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // replace escaped `/\.` with `/.`
	          config.url = url.replace(/\/\\\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(); }
	            ids[key] = value && value.charAt && value.charAt(0) == '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, success, error;
	
	            /* jshint -W086 */ /* (purposefully fall through case statements) */
	            switch (arguments.length) {
	              case 4:
	                error = a4;
	                success = a3;
	              //fallthrough
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    success = a1;
	                    error = a2;
	                    break;
	                  }
	
	                  success = a2;
	                  error = a3;
	                  //fallthrough
	                } else {
	                  params = a1;
	                  data = a2;
	                  success = a3;
	                  break;
	                }
	              case 1:
	                if (isFunction(a1)) success = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  "Expected up to 4 arguments [params, data, success, error], got {0} arguments",
	                  arguments.length);
	            }
	            /* jshint +W086 */ /* (purposefully fall through case statements) */
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              undefined;
	
	            forEach(action, function(value, key) {
	              if (key != 'params' && key != 'isArray' && key != 'interceptor') {
	                httpConfig[key] = copy(value);
	              }
	            });
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            var promise = $http(httpConfig).then(function(response) {
	              var data = response.data,
	                promise = value.$promise;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                // jshint -W018
	                if (angular.isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2}', name, action.isArray ? 'array' : 'object',
	                    angular.isArray(data) ? 'array' : 'object');
	                }
	                // jshint +W018
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === "object") {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;
	                }
	              }
	
	              value.$resolved = true;
	
	              response.resource = value;
	
	              return response;
	            }, function(response) {
	              value.$resolved = true;
	
	              (error || noop)(response);
	
	              return $q.reject(response);
	            });
	
	            promise = promise.then(
	              function(response) {
	                var value = responseInterceptor(response);
	                (success || noop)(value, response.headers);
	                return value;
	              },
	              responseErrorInterceptor);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        Resource.bind = function(additionalParamDefaults) {
	          return resourceFactory(url, extend({}, paramDefaults, additionalParamDefaults), actions);
	        };
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(447);
	module.exports = 'ngResource';


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.20
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," +
	        "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," +
	        "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," +
	        "stop,svg,switch,text,title,tspan,use");
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements,
	                                   svgElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' +
	    'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' +
	    'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' +
	    'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' +
	    'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' +
	    'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' +
	    'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' +
	    'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' +
	    'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' +
	    'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' +
	    'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' +
	    'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' +
	    'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' +
	    'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' +
	    'zoomAndPan');
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) obj[items[i]] = true;
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[stack.length - 1]; };
	
	  while (html) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if (!stack.last() || !specialElements[stack.last()]) {
	
	      // Comment
	      if (html.indexOf("<!--") === 0) {
	        // comments containing -- are not allowed unless they terminate the comment
	        index = html.indexOf("--", 4);
	
	        if (index >= 0 && html.lastIndexOf("-->", index) === index) {
	          if (handler.comment) handler.comment(html.substring(4, index));
	          html = html.substring(index + 3);
	          chars = false;
	        }
	      // DOCTYPE
	      } else if (DOCTYPE_REGEXP.test(html)) {
	        match = html.match(DOCTYPE_REGEXP);
	
	        if (match) {
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	        match = html.match(END_TAG_REGEXP);
	
	        if (match) {
	          html = html.substring(match[0].length);
	          match[0].replace(END_TAG_REGEXP, parseEndTag);
	          chars = false;
	        }
	
	      // start tag
	      } else if (BEGIN_TAG_REGEXP.test(html)) {
	        match = html.match(START_TAG_REGEXP);
	
	        if (match) {
	          // We only have a valid start-tag if there is a '>'.
	          if (match[4]) {
	            html = html.substring(match[0].length);
	            match[0].replace(START_TAG_REGEXP, parseStartTag);
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if (chars) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring(0, index);
	        html = index < 0 ? "" : html.substring(index);
	
	        if (handler.chars) handler.chars(decodeEntities(text));
	      }
	
	    } else {
	      // IE versions 9 and 10 do not understand the regex '[^]', so using a workaround with [\W\w].
	      html = html.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	      });
	
	      parseEndTag("", stack.last());
	    }
	
	    if (html == last) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag(tag, tagName, rest, unary) {
	    tagName = angular.lowercase(tagName);
	    if (blockElements[tagName]) {
	      while (stack.last() && inlineElements[stack.last()]) {
	        parseEndTag("", stack.last());
	      }
	    }
	
	    if (optionalEndTagElements[tagName] && stack.last() == tagName) {
	      parseEndTag("", tagName);
	    }
	
	    unary = voidElements[tagName] || !!unary;
	
	    if (!unary)
	      stack.push(tagName);
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start(tagName, attrs, unary);
	  }
	
	  function parseEndTag(tag, tagName) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if (tagName)
	      // Find the closest opened tag of the same type
	      for (pos = stack.length - 1; pos >= 0; pos--)
	        if (stack[pos] == tagName)
	          break;
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (i = stack.length - 1; i >= pos; i--)
	        if (handler.end) handler.end(stack[i]);
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  hiddenPre.innerHTML = value.replace(/</g,"&lt;");
	  // innerText depends on styling as it doesn't display hidden elements.
	  // Therefore, it's better to use textContent not to cause unnecessary reflows.
	  return hiddenPre.textContent;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary) {
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    end: function(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars) {
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(449);
	module.exports = 'ngSanitize';


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, document, undefined) {
	  'use strict';
	  bsCompilerService.$inject = [ '$q', '$http', '$injector', '$compile', '$controller', '$templateCache' ];
	  angular.module('mgcrea.ngStrap.typeahead', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$typeahead', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'typeahead',
	      prefixEvent: '$typeahead',
	      placement: 'bottom-left',
	      templateUrl: 'typeahead/typeahead.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      minLength: 1,
	      filter: 'bsAsyncFilter',
	      limit: 6,
	      autoSelect: false,
	      comparator: '',
	      trimValue: true
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$$rAF', '$timeout', function($window, $rootScope, $tooltip, $$rAF, $timeout) {
	      function TypeaheadFactory(element, controller, config) {
	        var $typeahead = {};
	        var options = angular.extend({}, defaults, config);
	        $typeahead = $tooltip(element, options);
	        var parentScope = config.scope;
	        var scope = $typeahead.$scope;
	        scope.$resetMatches = function() {
	          scope.$matches = [];
	          scope.$activeIndex = options.autoSelect ? 0 : -1;
	        };
	        scope.$resetMatches();
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $typeahead.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $typeahead.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $typeahead.$isVisible();
	        };
	        $typeahead.update = function(matches) {
	          scope.$matches = matches;
	          if (scope.$activeIndex >= matches.length) {
	            scope.$activeIndex = options.autoSelect ? 0 : -1;
	          }
	          safeDigest(scope);
	          $$rAF($typeahead.$applyPlacement);
	        };
	        $typeahead.activate = function(index) {
	          scope.$activeIndex = index;
	        };
	        $typeahead.select = function(index) {
	          if (index === -1) return;
	          var value = scope.$matches[index].value;
	          controller.$setViewValue(value);
	          controller.$render();
	          scope.$resetMatches();
	          if (parentScope) parentScope.$digest();
	          scope.$emit(options.prefixEvent + '.select', value, index, $typeahead);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $typeahead);
	          }
	        };
	        $typeahead.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return !!scope.$matches.length;
	          }
	          return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
	        };
	        $typeahead.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $typeahead.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	        };
	        $typeahead.$$updateScrollTop = function(container, index) {
	          if (index > -1 && index < container.children.length) {
	            var active = container.children[index];
	            var clientTop = active.offsetTop;
	            var clientBottom = active.offsetTop + active.clientHeight;
	            var highWatermark = container.scrollTop;
	            var lowWatermark = container.scrollTop + container.clientHeight;
	            if (clientBottom >= highWatermark && clientTop < highWatermark) {
	              container.scrollTop = Math.max(0, container.scrollTop - container.clientHeight);
	            } else if (clientBottom > lowWatermark) {
	              container.scrollTop = clientTop;
	            }
	          }
	        };
	        $typeahead.$onKeyDown = function(evt) {
	          if (!/(38|40|13)/.test(evt.keyCode)) return;
	          if ($typeahead.$isVisible() && !(evt.keyCode === 13 && scope.$activeIndex === -1)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (evt.keyCode === 13 && scope.$matches.length) {
	            $typeahead.select(scope.$activeIndex);
	          } else if (evt.keyCode === 38 && scope.$activeIndex > 0) {
	            scope.$activeIndex--;
	          } else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) {
	            scope.$activeIndex++;
	          } else if (angular.isUndefined(scope.$activeIndex)) {
	            scope.$activeIndex = 0;
	          }
	          $typeahead.$$updateScrollTop($typeahead.$element[0], scope.$activeIndex);
	          scope.$digest();
	        };
	        var show = $typeahead.show;
	        $typeahead.show = function() {
	          show();
	          $timeout(function() {
	            if ($typeahead.$element) {
	              $typeahead.$element.on('mousedown', $typeahead.$onMouseDown);
	              if (options.keyboard) {
	                if (element) element.on('keydown', $typeahead.$onKeyDown);
	              }
	            }
	          }, 0, false);
	        };
	        var hide = $typeahead.hide;
	        $typeahead.hide = function() {
	          if ($typeahead.$element) $typeahead.$element.off('mousedown', $typeahead.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $typeahead.$onKeyDown);
	          }
	          if (!options.autoSelect) {
	            $typeahead.activate(-1);
	          }
	          hide();
	        };
	        return $typeahead;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      TypeaheadFactory.defaults = defaults;
	      return TypeaheadFactory;
	    } ];
	  }).filter('bsAsyncFilter', [ '$filter', function($filter) {
	    return function(array, expression, comparator) {
	      if (array && angular.isFunction(array.then)) {
	        return array.then(function(results) {
	          return $filter('filter')(results, expression, comparator);
	        });
	      }
	      return $filter('filter')(array, expression, comparator);
	    };
	  } ]).directive('bsTypeahead', [ '$window', '$parse', '$q', '$typeahead', '$parseOptions', function($window, $parse, $q, $typeahead, $parseOptions) {
	    var defaults = $typeahead.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        element.off('change');
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'autoSelect', 'comparator', 'id', 'prefixEvent', 'prefixClass' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'trimValue', 'filter' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!element.attr('autocomplete')) element.attr('autocomplete', 'off');
	        var filter = angular.isDefined(options.filter) ? options.filter : defaults.filter;
	        var limit = options.limit || defaults.limit;
	        var comparator = options.comparator || defaults.comparator;
	        var bsOptions = attr.bsOptions;
	        if (filter) {
	          bsOptions += ' | ' + filter + ':$viewValue';
	          if (comparator) bsOptions += ':' + comparator;
	        }
	        if (limit) bsOptions += ' | limitTo:' + limit;
	        var parsedOptions = $parseOptions(bsOptions);
	        var typeahead = $typeahead(element, controller, options);
	        if (options.watchOptions) {
	          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
	          scope.$watchCollection(watchedOptions, function(newValue, oldValue) {
	            parsedOptions.valuesFn(scope, controller).then(function(values) {
	              typeahead.update(values);
	              controller.$render();
	            });
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          scope.$modelValue = newValue;
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            if (options.selectMode && !values.length && newValue.length > 0) {
	              controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
	              return;
	            }
	            if (values.length > limit) values = values.slice(0, limit);
	            typeahead.update(values);
	            controller.$render();
	          });
	        });
	        controller.$formatters.push(function(modelValue) {
	          var displayValue = parsedOptions.displayValue(modelValue);
	          if (displayValue) {
	            return displayValue;
	          }
	          if (angular.isDefined(modelValue) && typeof modelValue !== 'object') {
	            return modelValue;
	          }
	          return '';
	        });
	        controller.$render = function() {
	          if (controller.$isEmpty(controller.$viewValue)) {
	            return element.val('');
	          }
	          var index = typeahead.$getIndex(controller.$modelValue);
	          var selected = index !== -1 ? typeahead.$scope.$matches[index].label : controller.$viewValue;
	          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
	          var value = selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '') : '';
	          var ss = element[0].selectionStart;
	          var sd = element[0].selectionEnd;
	          element.val(options.trimValue === false ? value : value.trim());
	          element[0].setSelectionRange(ss, sd);
	        };
	        scope.$on('$destroy', function() {
	          if (typeahead) typeahead.destroy();
	          options = null;
	          typeahead = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tooltip', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$tooltip', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      prefixClass: 'tooltip',
	      prefixEvent: 'tooltip',
	      container: false,
	      target: false,
	      placement: 'top',
	      templateUrl: 'tooltip/tooltip.tpl.html',
	      template: '',
	      titleTemplate: false,
	      trigger: 'hover focus',
	      keyboard: false,
	      html: false,
	      show: false,
	      title: '',
	      type: '',
	      delay: 0,
	      autoClose: false,
	      bsEnabled: true,
	      mouseDownPreventDefault: true,
	      mouseDownStopPropagation: true,
	      viewport: {
	        selector: 'body',
	        padding: 0
	      }
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$q', '$templateCache', '$http', '$animate', '$sce', 'dimensions', '$$rAF', '$timeout', function($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      var $body = angular.element($window.document);
	      function TooltipFactory(element, config) {
	        var $tooltip = {};
	        var options = $tooltip.$options = angular.extend({}, defaults, config);
	        var promise = $tooltip.$promise = $bsCompiler.compile(options);
	        var scope = $tooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        var nodeName = element[0].nodeName.toLowerCase();
	        if (options.delay && angular.isString(options.delay)) {
	          var split = options.delay.split(',').map(parseFloat);
	          options.delay = split.length > 1 ? {
	            show: split[0],
	            hide: split[1]
	          } : split[0];
	        }
	        $tooltip.$id = options.id || element.attr('id') || '';
	        if (options.title) {
	          scope.title = $sce.trustAsHtml(options.title);
	        }
	        scope.$setEnabled = function(isEnabled) {
	          scope.$$postDigest(function() {
	            $tooltip.setEnabled(isEnabled);
	          });
	        };
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $tooltip.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $tooltip.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $tooltip.toggle();
	          });
	        };
	        $tooltip.$isShown = scope.$isShown = false;
	        var timeout;
	        var hoverState;
	        var compileData;
	        var tipElement;
	        var tipContainer;
	        var tipScope;
	        promise.then(function(data) {
	          compileData = data;
	          $tooltip.init();
	        });
	        $tooltip.init = function() {
	          if (options.delay && angular.isNumber(options.delay)) {
	            options.delay = {
	              show: options.delay,
	              hide: options.delay
	            };
	          }
	          if (options.container === 'self') {
	            tipContainer = element;
	          } else if (angular.isElement(options.container)) {
	            tipContainer = options.container;
	          } else if (options.container) {
	            tipContainer = findElement(options.container);
	          }
	          bindTriggerEvents();
	          if (options.target) {
	            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
	          }
	          if (options.show) {
	            scope.$$postDigest(function() {
	              if (options.trigger === 'focus') {
	                element[0].focus();
	              } else {
	                $tooltip.show();
	              }
	            });
	          }
	        };
	        $tooltip.destroy = function() {
	          unbindTriggerEvents();
	          destroyTipElement();
	          scope.$destroy();
	        };
	        $tooltip.enter = function() {
	          clearTimeout(timeout);
	          hoverState = 'in';
	          if (!options.delay || !options.delay.show) {
	            return $tooltip.show();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'in') $tooltip.show();
	          }, options.delay.show);
	        };
	        $tooltip.show = function() {
	          if (!options.bsEnabled || $tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.show.before', $tooltip);
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($tooltip);
	          }
	          var parent;
	          var after;
	          if (options.container) {
	            parent = tipContainer;
	            if (tipContainer[0].lastChild) {
	              after = angular.element(tipContainer[0].lastChild);
	            } else {
	              after = null;
	            }
	          } else {
	            parent = null;
	            after = element;
	          }
	          if (tipElement) destroyTipElement();
	          tipScope = $tooltip.$scope.$new();
	          tipElement = $tooltip.$element = compileData.link(tipScope, function(clonedElement, scope) {});
	          tipElement.css({
	            top: '-9999px',
	            left: '-9999px',
	            right: 'auto',
	            display: 'block',
	            visibility: 'hidden'
	          });
	          if (options.animation) tipElement.addClass(options.animation);
	          if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
	          if (options.customClass) tipElement.addClass(options.customClass);
	          if (after) {
	            after.after(tipElement);
	          } else {
	            parent.prepend(tipElement);
	          }
	          $tooltip.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          $tooltip.$applyPlacement();
	          if (angular.version.minor <= 2) {
	            $animate.enter(tipElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
	          }
	          safeDigest(scope);
	          $$rAF(function() {
	            if (tipElement) tipElement.css({
	              visibility: 'visible'
	            });
	            if (options.keyboard) {
	              if (options.trigger !== 'focus') {
	                $tooltip.focus();
	              }
	              bindKeyboardEvents();
	            }
	          });
	          if (options.autoClose) {
	            bindAutoCloseEvents();
	          }
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $tooltip);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($tooltip);
	          }
	        }
	        $tooltip.leave = function() {
	          clearTimeout(timeout);
	          hoverState = 'out';
	          if (!options.delay || !options.delay.hide) {
	            return $tooltip.hide();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'out') {
	              $tooltip.hide();
	            }
	          }, options.delay.hide);
	        };
	        var _blur;
	        var _tipToHide;
	        $tooltip.hide = function(blur) {
	          if (!$tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.hide.before', $tooltip);
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($tooltip);
	          }
	          _blur = blur;
	          _tipToHide = tipElement;
	          if (tipElement !== null) {
	            if (angular.version.minor <= 2) {
	              $animate.leave(tipElement, leaveAnimateCallback);
	            } else {
	              $animate.leave(tipElement).then(leaveAnimateCallback);
	            }
	          }
	          $tooltip.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          if (options.keyboard && tipElement !== null) {
	            unbindKeyboardEvents();
	          }
	          if (options.autoClose && tipElement !== null) {
	            unbindAutoCloseEvents();
	          }
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $tooltip);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($tooltip);
	          }
	          if (tipElement === _tipToHide) {
	            if (_blur && options.trigger === 'focus') {
	              return element[0].blur();
	            }
	            destroyTipElement();
	          }
	        }
	        $tooltip.toggle = function(evt) {
	          if (evt) {
	            evt.preventDefault();
	          }
	          if ($tooltip.$isShown) {
	            $tooltip.leave();
	          } else {
	            $tooltip.enter();
	          }
	        };
	        $tooltip.focus = function() {
	          tipElement[0].focus();
	        };
	        $tooltip.setEnabled = function(isEnabled) {
	          options.bsEnabled = isEnabled;
	        };
	        $tooltip.setViewport = function(viewport) {
	          options.viewport = viewport;
	        };
	        $tooltip.$applyPlacement = function() {
	          if (!tipElement) return;
	          var placement = options.placement;
	          var autoToken = /\s?auto?\s?/i;
	          var autoPlace = autoToken.test(placement);
	          if (autoPlace) {
	            placement = placement.replace(autoToken, '') || defaults.placement;
	          }
	          tipElement.addClass(options.placement);
	          var elementPosition = getPosition();
	          var tipWidth = tipElement.prop('offsetWidth');
	          var tipHeight = tipElement.prop('offsetHeight');
	          $tooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);
	          if (autoPlace) {
	            var originalPlacement = placement;
	            var viewportPosition = getPosition($tooltip.$viewport);
	            if (/bottom/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
	              placement = originalPlacement.replace('bottom', 'top');
	            } else if (/top/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
	              placement = originalPlacement.replace('top', 'bottom');
	            }
	            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
	              placement = placement.replace('left', 'right');
	            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
	              placement = placement.replace('right', 'left');
	            }
	            tipElement.removeClass(originalPlacement).addClass(placement);
	          }
	          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
	          applyPlacement(tipPosition, placement);
	        };
	        $tooltip.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $tooltip.$isShown) {
	            $tooltip.hide();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusKeyUp = function(evt) {
	          if (evt.which === 27) {
	            element[0].blur();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusElementMouseDown = function(evt) {
	          if (options.mouseDownPreventDefault) {
	            evt.preventDefault();
	          }
	          if (options.mouseDownStopPropagation) {
	            evt.stopPropagation();
	          }
	          if ($tooltip.$isShown) {
	            element[0].blur();
	          } else {
	            element[0].focus();
	          }
	        };
	        function bindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          angular.forEach(triggers, function(trigger) {
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.on(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.on(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          });
	        }
	        function unbindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          for (var i = triggers.length; i--; ) {
	            var trigger = triggers[i];
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.off(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.off(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.on('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.on('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.off('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.off('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        var _autoCloseEventsBinded = false;
	        function bindAutoCloseEvents() {
	          $timeout(function() {
	            tipElement.on('click', stopEventPropagation);
	            $body.on('click', $tooltip.hide);
	            _autoCloseEventsBinded = true;
	          }, 0, false);
	        }
	        function unbindAutoCloseEvents() {
	          if (_autoCloseEventsBinded) {
	            tipElement.off('click', stopEventPropagation);
	            $body.off('click', $tooltip.hide);
	            _autoCloseEventsBinded = false;
	          }
	        }
	        function stopEventPropagation(event) {
	          event.stopPropagation();
	        }
	        function getPosition($element) {
	          $element = $element || (options.target || element);
	          var el = $element[0];
	          var isBody = el.tagName === 'BODY';
	          var elRect = el.getBoundingClientRect();
	          var rect = {};
	          for (var p in elRect) {
	            rect[p] = elRect[p];
	          }
	          if (rect.width === null) {
	            rect = angular.extend({}, rect, {
	              width: elRect.right - elRect.left,
	              height: elRect.bottom - elRect.top
	            });
	          }
	          var elOffset = isBody ? {
	            top: 0,
	            left: 0
	          } : dimensions.offset(el);
	          var scroll = {
	            scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0
	          };
	          var outerDims = isBody ? {
	            width: document.documentElement.clientWidth,
	            height: $window.innerHeight
	          } : null;
	          return angular.extend({}, rect, scroll, outerDims, elOffset);
	        }
	        function getCalculatedOffset(placement, position, actualWidth, actualHeight) {
	          var offset;
	          var split = placement.split('-');
	          switch (split[0]) {
	           case 'right':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left + position.width
	            };
	            break;
	
	           case 'bottom':
	            offset = {
	              top: position.top + position.height,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	
	           case 'left':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left - actualWidth
	            };
	            break;
	
	           default:
	            offset = {
	              top: position.top - actualHeight,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	          }
	          if (!split[1]) {
	            return offset;
	          }
	          if (split[0] === 'top' || split[0] === 'bottom') {
	            switch (split[1]) {
	             case 'left':
	              offset.left = position.left;
	              break;
	
	             case 'right':
	              offset.left = position.left + position.width - actualWidth;
	              break;
	
	             default:
	              break;
	            }
	          } else if (split[0] === 'left' || split[0] === 'right') {
	            switch (split[1]) {
	             case 'top':
	              offset.top = position.top - actualHeight + position.height;
	              break;
	
	             case 'bottom':
	              offset.top = position.top;
	              break;
	
	             default:
	              break;
	            }
	          }
	          return offset;
	        }
	        function applyPlacement(offset, placement) {
	          var tip = tipElement[0];
	          var width = tip.offsetWidth;
	          var height = tip.offsetHeight;
	          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10);
	          var marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);
	          if (isNaN(marginTop)) marginTop = 0;
	          if (isNaN(marginLeft)) marginLeft = 0;
	          offset.top = offset.top + marginTop;
	          offset.left = offset.left + marginLeft;
	          dimensions.setOffset(tip, angular.extend({
	            using: function(props) {
	              tipElement.css({
	                top: Math.round(props.top) + 'px',
	                left: Math.round(props.left) + 'px',
	                right: ''
	              });
	            }
	          }, offset), 0);
	          var actualWidth = tip.offsetWidth;
	          var actualHeight = tip.offsetHeight;
	          if (placement === 'top' && actualHeight !== height) {
	            offset.top = offset.top + height - actualHeight;
	          }
	          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;
	          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	          if (delta.left) {
	            offset.left += delta.left;
	          } else {
	            offset.top += delta.top;
	          }
	          dimensions.setOffset(tip, offset);
	          if (/top|right|bottom|left/.test(placement)) {
	            var isVertical = /top|bottom/.test(placement);
	            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
	          }
	        }
	        function getViewportAdjustedDelta(placement, position, actualWidth, actualHeight) {
	          var delta = {
	            top: 0,
	            left: 0
	          };
	          if (!$tooltip.$viewport) return delta;
	          var viewportPadding = options.viewport && options.viewport.padding || 0;
	          var viewportDimensions = getPosition($tooltip.$viewport);
	          if (/right|left/.test(placement)) {
	            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
	            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	            if (topEdgeOffset < viewportDimensions.top) {
	              delta.top = viewportDimensions.top - topEdgeOffset;
	            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	            }
	          } else {
	            var leftEdgeOffset = position.left - viewportPadding;
	            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
	            if (leftEdgeOffset < viewportDimensions.left) {
	              delta.left = viewportDimensions.left - leftEdgeOffset;
	            } else if (rightEdgeOffset > viewportDimensions.right) {
	              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	            }
	          }
	          return delta;
	        }
	        function replaceArrow(delta, dimension, isHorizontal) {
	          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);
	          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isHorizontal ? 'top' : 'left', '');
	        }
	        function destroyTipElement() {
	          clearTimeout(timeout);
	          if ($tooltip.$isShown && tipElement !== null) {
	            if (options.autoClose) {
	              unbindAutoCloseEvents();
	            }
	            if (options.keyboard) {
	              unbindKeyboardEvents();
	            }
	          }
	          if (tipScope) {
	            tipScope.$destroy();
	            tipScope = null;
	          }
	          if (tipElement) {
	            tipElement.remove();
	            tipElement = $tooltip.$element = null;
	          }
	        }
	        return $tooltip;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return TooltipFactory;
	    } ];
	  }).directive('bsTooltip', [ '$window', '$location', '$sce', '$parse', '$tooltip', '$$rAF', function($window, $location, $sce, $parse, $tooltip, $$rAF) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var tooltip;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'titleTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        attr.$observe('title', function(newValue) {
	          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
	            var oldValue = scope.title;
	            scope.title = $sce.trustAsHtml(newValue);
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }
	        });
	        attr.$observe('disabled', function(newValue) {
	          if (newValue && tooltip.$isShown) {
	            tooltip.hide();
	          }
	        });
	        if (attr.bsTooltip) {
	          scope.$watch(attr.bsTooltip, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.title = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
	            if (newValue === true) {
	              tooltip.show();
	            } else {
	              tooltip.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
	            if (newValue === false) {
	              tooltip.setEnabled(false);
	            } else {
	              tooltip.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            tooltip.setViewport(newValue);
	          });
	        }
	        tooltip = $tooltip(element, options);
	        scope.$on('$destroy', function() {
	          if (tooltip) tooltip.destroy();
	          options = null;
	          tooltip = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.timepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$timepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      defaultDate: 'auto',
	      prefixClass: 'timepicker',
	      placement: 'bottom-left',
	      templateUrl: 'timepicker/timepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: true,
	      timeType: 'date',
	      timeFormat: 'shortTime',
	      timezone: null,
	      modelTimeFormat: null,
	      autoclose: false,
	      minTime: -Infinity,
	      maxTime: +Infinity,
	      length: 5,
	      hourStep: 1,
	      minuteStep: 5,
	      secondStep: 5,
	      roundDisplay: false,
	      iconUp: 'glyphicon glyphicon-chevron-up',
	      iconDown: 'glyphicon glyphicon-chevron-down',
	      arrowBehavior: 'pager'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) {
	        defaults.lang = $dateFormatter.getDefaultLocale();
	      }
	      function timepickerFactory(element, controller, config) {
	        var $timepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $timepicker.$options;
	        var scope = $timepicker.$scope;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        function floorMinutes(time) {
	          var coeff = 1e3 * 60 * options.minuteStep;
	          return new Date(Math.floor(time.getTime() / coeff) * coeff);
	        }
	        var selectedIndex = 0;
	        var defaultDate = options.roundDisplay ? floorMinutes(new Date()) : new Date();
	        var startDate = controller.$dateValue || defaultDate;
	        var viewDate = {
	          hour: startDate.getHours(),
	          meridian: startDate.getHours() < 12,
	          minute: startDate.getMinutes(),
	          second: startDate.getSeconds(),
	          millisecond: startDate.getMilliseconds()
	        };
	        var format = $dateFormatter.getDatetimeFormat(options.timeFormat, lang);
	        var hoursFormat = $dateFormatter.hoursFormat(format);
	        var timeSeparator = $dateFormatter.timeSeparator(format);
	        var minutesFormat = $dateFormatter.minutesFormat(format);
	        var secondsFormat = $dateFormatter.secondsFormat(format);
	        var showSeconds = $dateFormatter.showSeconds(format);
	        var showAM = $dateFormatter.showAM(format);
	        scope.$iconUp = options.iconUp;
	        scope.$iconDown = options.iconDown;
	        scope.$select = function(date, index) {
	          $timepicker.select(date, index);
	        };
	        scope.$moveIndex = function(value, index) {
	          $timepicker.$moveIndex(value, index);
	        };
	        scope.$switchMeridian = function(date) {
	          $timepicker.switchMeridian(date);
	        };
	        $timepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $timepicker.$date = date;
	            angular.extend(viewDate, {
	              hour: date.getHours(),
	              minute: date.getMinutes(),
	              second: date.getSeconds(),
	              millisecond: date.getMilliseconds()
	            });
	            $timepicker.$build();
	          } else if (!$timepicker.$isBuilt) {
	            $timepicker.$build();
	          }
	        };
	        $timepicker.select = function(date, index, keep) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            controller.$dateValue = options.defaultDate === 'today' ? new Date() : new Date(1970, 0, 1);
	          }
	          if (!angular.isDate(date)) date = new Date(date);
	          if (index === 0) controller.$dateValue.setHours(date.getHours()); else if (index === 1) controller.$dateValue.setMinutes(date.getMinutes()); else if (index === 2) controller.$dateValue.setSeconds(date.getSeconds());
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	          if (options.autoclose && !keep) {
	            $timeout(function() {
	              $timepicker.hide(true);
	            });
	          }
	        };
	        $timepicker.switchMeridian = function(date) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            return;
	          }
	          var hours = (date || controller.$dateValue).getHours();
	          controller.$dateValue.setHours(hours < 12 ? hours + 12 : hours - 12);
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	        };
	        $timepicker.$build = function() {
	          var i;
	          var midIndex = scope.midIndex = parseInt(options.length / 2, 10);
	          var hours = [];
	          var hour;
	          for (i = 0; i < options.length; i++) {
	            hour = new Date(1970, 0, 1, viewDate.hour - (midIndex - i) * options.hourStep);
	            hours.push({
	              date: hour,
	              label: formatDate(hour, hoursFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(hour, 0),
	              disabled: $timepicker.$isDisabled(hour, 0)
	            });
	          }
	          var minutes = [];
	          var minute;
	          for (i = 0; i < options.length; i++) {
	            minute = new Date(1970, 0, 1, 0, viewDate.minute - (midIndex - i) * options.minuteStep);
	            minutes.push({
	              date: minute,
	              label: formatDate(minute, minutesFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(minute, 1),
	              disabled: $timepicker.$isDisabled(minute, 1)
	            });
	          }
	          var seconds = [];
	          var second;
	          for (i = 0; i < options.length; i++) {
	            second = new Date(1970, 0, 1, 0, 0, viewDate.second - (midIndex - i) * options.secondStep);
	            seconds.push({
	              date: second,
	              label: formatDate(second, secondsFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(second, 2),
	              disabled: $timepicker.$isDisabled(second, 2)
	            });
	          }
	          var rows = [];
	          for (i = 0; i < options.length; i++) {
	            if (showSeconds) {
	              rows.push([ hours[i], minutes[i], seconds[i] ]);
	            } else {
	              rows.push([ hours[i], minutes[i] ]);
	            }
	          }
	          scope.rows = rows;
	          scope.showSeconds = showSeconds;
	          scope.showAM = showAM;
	          scope.isAM = ($timepicker.$date || hours[midIndex].date).getHours() < 12;
	          scope.timeSeparator = timeSeparator;
	          $timepicker.$isBuilt = true;
	        };
	        $timepicker.$isSelected = function(date, index) {
	          if (!$timepicker.$date) return false; else if (index === 0) {
	            return date.getHours() === $timepicker.$date.getHours();
	          } else if (index === 1) {
	            return date.getMinutes() === $timepicker.$date.getMinutes();
	          } else if (index === 2) {
	            return date.getSeconds() === $timepicker.$date.getSeconds();
	          }
	        };
	        $timepicker.$isDisabled = function(date, index) {
	          var selectedTime;
	          if (index === 0) {
	            selectedTime = date.getTime() + viewDate.minute * 6e4 + viewDate.second * 1e3;
	          } else if (index === 1) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.second * 1e3;
	          } else if (index === 2) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.minute * 6e4;
	          }
	          return selectedTime < options.minTime * 1 || selectedTime > options.maxTime * 1;
	        };
	        scope.$arrowAction = function(value, index) {
	          if (options.arrowBehavior === 'picker') {
	            $timepicker.$setTimeByStep(value, index);
	          } else {
	            $timepicker.$moveIndex(value, index);
	          }
	        };
	        $timepicker.$setTimeByStep = function(value, index) {
	          var newDate = new Date($timepicker.$date || startDate);
	          var hours = newDate.getHours();
	          var minutes = newDate.getMinutes();
	          var seconds = newDate.getSeconds();
	          if (index === 0) {
	            newDate.setHours(hours - parseInt(options.hourStep, 10) * value);
	          } else if (index === 1) {
	            newDate.setMinutes(minutes - parseInt(options.minuteStep, 10) * value);
	          } else if (index === 2) {
	            newDate.setSeconds(seconds - parseInt(options.secondStep, 10) * value);
	          }
	          $timepicker.select(newDate, index, true);
	        };
	        $timepicker.$moveIndex = function(value, index) {
	          var targetDate;
	          if (index === 0) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour + value * options.length, viewDate.minute, viewDate.second);
	            angular.extend(viewDate, {
	              hour: targetDate.getHours()
	            });
	          } else if (index === 1) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute + value * options.length * options.minuteStep, viewDate.second);
	            angular.extend(viewDate, {
	              minute: targetDate.getMinutes()
	            });
	          } else if (index === 2) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute, viewDate.second + value * options.length * options.secondStep);
	            angular.extend(viewDate, {
	              second: targetDate.getSeconds()
	            });
	          }
	          $timepicker.$build();
	        };
	        $timepicker.$onMouseDown = function(evt) {
	          if (evt.target.nodeName.toLowerCase() !== 'input') evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $timepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            $timepicker.hide(true);
	            return;
	          }
	          var newDate = new Date($timepicker.$date);
	          var hours = newDate.getHours();
	          var hoursLength = formatDate(newDate, hoursFormat).length;
	          var minutes = newDate.getMinutes();
	          var minutesLength = formatDate(newDate, minutesFormat).length;
	          var seconds = newDate.getSeconds();
	          var secondsLength = formatDate(newDate, secondsFormat).length;
	          var sepLength = 1;
	          var lateralMove = /(37|39)/.test(evt.keyCode);
	          var count = 2 + showSeconds * 1 + showAM * 1;
	          if (lateralMove) {
	            if (evt.keyCode === 37) selectedIndex = selectedIndex < 1 ? count - 1 : selectedIndex - 1; else if (evt.keyCode === 39) selectedIndex = selectedIndex < count - 1 ? selectedIndex + 1 : 0;
	          }
	          var selectRange = [ 0, hoursLength ];
	          var incr = 0;
	          if (evt.keyCode === 38) incr = -1;
	          if (evt.keyCode === 40) incr = +1;
	          var isSeconds = selectedIndex === 2 && showSeconds;
	          var isMeridian = selectedIndex === 2 && !showSeconds || selectedIndex === 3 && showSeconds;
	          if (selectedIndex === 0) {
	            newDate.setHours(hours + incr * parseInt(options.hourStep, 10));
	            hoursLength = formatDate(newDate, hoursFormat).length;
	            selectRange = [ 0, hoursLength ];
	          } else if (selectedIndex === 1) {
	            newDate.setMinutes(minutes + incr * parseInt(options.minuteStep, 10));
	            minutesLength = formatDate(newDate, minutesFormat).length;
	            selectRange = [ hoursLength + sepLength, minutesLength ];
	          } else if (isSeconds) {
	            newDate.setSeconds(seconds + incr * parseInt(options.secondStep, 10));
	            secondsLength = formatDate(newDate, secondsFormat).length;
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength, secondsLength ];
	          } else if (isMeridian) {
	            if (!lateralMove) $timepicker.switchMeridian();
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength + (secondsLength + sepLength) * showSeconds, 2 ];
	          }
	          $timepicker.select(newDate, selectedIndex, true);
	          createSelection(selectRange[0], selectRange[1]);
	          parentScope.$digest();
	        };
	        function createSelection(start, length) {
	          var end = start + length;
	          if (element[0].createTextRange) {
	            var selRange = element[0].createTextRange();
	            selRange.collapse(true);
	            selRange.moveStart('character', start);
	            selRange.moveEnd('character', end);
	            selRange.select();
	          } else if (element[0].setSelectionRange) {
	            element[0].setSelectionRange(start, end);
	          } else if (angular.isUndefined(element[0].selectionStart)) {
	            element[0].selectionStart = start;
	            element[0].selectionEnd = end;
	          }
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $timepicker.init;
	        $timepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'time');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $timepicker.destroy;
	        $timepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $timepicker.show;
	        $timepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if ($timepicker.$element) $timepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	            if (options.keyboard) {
	              if (element) element.on('keydown', $timepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $timepicker.hide;
	        $timepicker.hide = function(blur) {
	          if (!$timepicker.$isShown) return;
	          if ($timepicker.$element) $timepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $timepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $timepicker;
	      }
	      timepickerFactory.defaults = defaults;
	      return timepickerFactory;
	    } ];
	  }).directive('bsTimepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$timepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $timepicker) {
	    var defaults = $timepicker.defaults;
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'autoclose', 'timeType', 'timeFormat', 'timezone', 'modelTimeFormat', 'useNative', 'hourStep', 'minuteStep', 'secondStep', 'length', 'arrowBehavior', 'iconUp', 'iconDown', 'roundDisplay', 'id', 'prefixClass', 'prefixEvent', 'defaultDate' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'roundDisplay' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (isNative && (options.useNative || defaults.useNative)) options.timeFormat = 'HH:mm';
	        var timepicker = $timepicker(element, controller, options);
	        options = timepicker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!timepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(timepicker),?/i);
	            if (newValue === true) {
	              timepicker.show();
	            } else {
	              timepicker.hide();
	            }
	          });
	        }
	        var dateParser = $dateParser({
	          format: options.timeFormat,
	          lang: lang
	        });
	        angular.forEach([ 'minTime', 'maxTime' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              timepicker.$options[key] = dateParser.getTimeForAttribute(key, newValue);
	              if (!isNaN(timepicker.$options[key])) timepicker.$build();
	              validateAgainstMinMaxTime(controller.$dateValue);
	            });
	          }
	        });
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          timepicker.update(controller.$dateValue);
	        }, true);
	        function validateAgainstMinMaxTime(parsedTime) {
	          if (!angular.isDate(parsedTime)) return;
	          var isMinValid = isNaN(options.minTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) >= options.minTime;
	          var isMaxValid = isNaN(options.maxTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) <= options.maxTime;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (!isValid) {
	            return;
	          }
	          controller.$dateValue = parsedTime;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedTime = angular.isDate(viewValue) ? viewValue : dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedTime || isNaN(parsedTime.getTime())) {
	            controller.$setValidity('date', false);
	            return undefined;
	          }
	          validateAgainstMinMaxTime(parsedTime);
	          if (options.timeType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedTime, options.timezone, true);
	            return formatDate(date, options.modelTimeFormat || options.timeFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.timeType === 'number') {
	            return date.getTime();
	          } else if (options.timeType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.timeType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.timeType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelTimeFormat);
	          } else if (options.timeType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getTimeFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getTimeFormattedString());
	        };
	        function getTimeFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.timeFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (timepicker) timepicker.destroy();
	          options = null;
	          timepicker = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tab', []).provider('$tab', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      template: 'tab/tab.tpl.html',
	      navClass: 'nav-tabs',
	      activeClass: 'active'
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'navClass', 'activeClass' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      $scope.$navClass = self.$options.navClass;
	      $scope.$activeClass = self.$options.activeClass;
	      self.$panes = $scope.$panes = [];
	      self.$activePaneChangeListeners = self.$viewChangeListeners = [];
	      self.$push = function(pane) {
	        if (angular.isUndefined(self.$panes.$active)) {
	          $scope.$setActive(pane.name || 0);
	        }
	        self.$panes.push(pane);
	      };
	      self.$remove = function(pane) {
	        var index = self.$panes.indexOf(pane);
	        var active = self.$panes.$active;
	        var activeIndex;
	        if (angular.isString(active)) {
	          activeIndex = self.$panes.map(function(pane) {
	            return pane.name;
	          }).indexOf(active);
	        } else {
	          activeIndex = self.$panes.$active;
	        }
	        self.$panes.splice(index, 1);
	        if (index < activeIndex) {
	          activeIndex--;
	        } else if (index === activeIndex && activeIndex === self.$panes.length) {
	          activeIndex--;
	        }
	        if (activeIndex >= 0 && activeIndex < self.$panes.length) {
	          self.$setActive(self.$panes[activeIndex].name || activeIndex);
	        } else {
	          self.$setActive();
	        }
	      };
	      self.$setActive = $scope.$setActive = function(value) {
	        self.$panes.$active = value;
	        self.$activePaneChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$isActive = $scope.$isActive = function($pane, $index) {
	        return self.$panes.$active === $pane.name || self.$panes.$active === $index;
	      };
	    };
	    this.$get = function() {
	      var $tab = {};
	      $tab.defaults = defaults;
	      $tab.controller = controller;
	      return $tab;
	    };
	  }).directive('bsTabs', [ '$window', '$animate', '$tab', '$parse', function($window, $animate, $tab, $parse) {
	    var defaults = $tab.defaults;
	    return {
	      require: [ '?ngModel', 'bsTabs' ],
	      transclude: true,
	      scope: true,
	      controller: [ '$scope', '$element', '$attrs', $tab.controller ],
	      templateUrl: function(element, attr) {
	        return attr.template || defaults.template;
	      },
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsTabsCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsTabsCtrl.$panes.$active);
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            bsTabsCtrl.$setActive(modelValue);
	            return modelValue;
	          });
	        }
	        if (attrs.bsActivePane) {
	          var parsedBsActivePane = $parse(attrs.bsActivePane);
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            parsedBsActivePane.assign(scope, bsTabsCtrl.$panes.$active);
	          });
	          scope.$watch(attrs.bsActivePane, function(newValue, oldValue) {
	            bsTabsCtrl.$setActive(newValue);
	          }, true);
	        }
	      }
	    };
	  } ]).directive('bsPane', [ '$window', '$animate', '$sce', function($window, $animate, $sce) {
	    return {
	      require: [ '^?ngModel', '^bsTabs' ],
	      scope: true,
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsTabsCtrl = controllers[1];
	        element.addClass('tab-pane');
	        attrs.$observe('title', function(newValue, oldValue) {
	          scope.title = $sce.trustAsHtml(newValue);
	        });
	        scope.name = attrs.name;
	        if (bsTabsCtrl.$options.animation) {
	          element.addClass(bsTabsCtrl.$options.animation);
	        }
	        attrs.$observe('disabled', function(newValue, oldValue) {
	          scope.disabled = scope.$eval(newValue);
	        });
	        bsTabsCtrl.$push(scope);
	        scope.$on('$destroy', function() {
	          bsTabsCtrl.$remove(scope);
	        });
	        function render() {
	          var index = bsTabsCtrl.$panes.indexOf(scope);
	          $animate[bsTabsCtrl.$isActive(scope, index) ? 'addClass' : 'removeClass'](element, bsTabsCtrl.$options.activeClass);
	        }
	        bsTabsCtrl.$activePaneChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.select', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$select', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'select',
	      prefixEvent: '$select',
	      placement: 'bottom-left',
	      templateUrl: 'select/select.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      multiple: false,
	      allNoneButtons: false,
	      sort: true,
	      caretHtml: '&nbsp;<span class="caret"></span>',
	      placeholder: 'Choose among the following...',
	      allText: 'All',
	      noneText: 'None',
	      maxLength: 3,
	      maxLengthHtml: 'selected',
	      iconCheckmark: 'glyphicon glyphicon-ok',
	      toggle: false
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$tooltip', '$timeout', function($window, $document, $rootScope, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      function SelectFactory(element, controller, config) {
	        var $select = {};
	        var options = angular.extend({}, defaults, config);
	        $select = $tooltip(element, options);
	        var scope = $select.$scope;
	        scope.$matches = [];
	        if (options.multiple) {
	          scope.$activeIndex = [];
	        } else {
	          scope.$activeIndex = -1;
	        }
	        scope.$isMultiple = options.multiple;
	        scope.$showAllNoneButtons = options.allNoneButtons && options.multiple;
	        scope.$iconCheckmark = options.iconCheckmark;
	        scope.$allText = options.allText;
	        scope.$noneText = options.noneText;
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $select.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $select.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $select.$isVisible();
	        };
	        scope.$isActive = function(index) {
	          return $select.$isActive(index);
	        };
	        scope.$selectAll = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (!scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        scope.$selectNone = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        $select.update = function(matches) {
	          scope.$matches = matches;
	          $select.$updateActiveIndex();
	        };
	        $select.activate = function(index) {
	          if (options.multiple) {
	            if ($select.$isActive(index)) {
	              scope.$activeIndex.splice(scope.$activeIndex.indexOf(index), 1);
	            } else {
	              scope.$activeIndex.push(index);
	            }
	            if (options.sort) scope.$activeIndex.sort(function(a, b) {
	              return a - b;
	            });
	          } else {
	            scope.$activeIndex = index;
	          }
	          return scope.$activeIndex;
	        };
	        $select.select = function(index) {
	          if (angular.isUndefined(index) || index < 0 || index >= scope.$matches.length) {
	            return;
	          }
	          var value = scope.$matches[index].value;
	          scope.$apply(function() {
	            $select.activate(index);
	            if (options.multiple) {
	              controller.$setViewValue(scope.$activeIndex.map(function(index) {
	                if (angular.isUndefined(scope.$matches[index])) {
	                  return null;
	                }
	                return scope.$matches[index].value;
	              }));
	            } else {
	              if (options.toggle) {
	                controller.$setViewValue(value === controller.$modelValue ? undefined : value);
	              } else {
	                controller.$setViewValue(value);
	              }
	              $select.hide();
	            }
	          });
	          scope.$emit(options.prefixEvent + '.select', value, index, $select);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $select);
	          }
	        };
	        $select.$updateActiveIndex = function() {
	          if (options.multiple) {
	            if (angular.isArray(controller.$modelValue)) {
	              scope.$activeIndex = controller.$modelValue.map(function(value) {
	                return $select.$getIndex(value);
	              });
	            } else {
	              scope.$activeIndex = [];
	            }
	          } else {
	            if (angular.isDefined(controller.$modelValue) && scope.$matches.length) {
	              scope.$activeIndex = $select.$getIndex(controller.$modelValue);
	            } else {
	              scope.$activeIndex = -1;
	            }
	          }
	        };
	        $select.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return scope.$matches.length;
	          }
	          return scope.$matches.length && controller.$viewValue.length >= options.minLength;
	        };
	        $select.$isActive = function(index) {
	          if (options.multiple) {
	            return scope.$activeIndex.indexOf(index) !== -1;
	          }
	          return scope.$activeIndex === index;
	        };
	        $select.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $select.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            var anchor;
	            if (evt.target.nodeName !== 'A') {
	              var anchorCandidate = targetEl.parent();
	              while (!anchor && anchorCandidate.length > 0) {
	                if (anchorCandidate[0].nodeName === 'A') {
	                  anchor = anchorCandidate;
	                }
	                anchorCandidate = anchorCandidate.parent();
	              }
	            }
	            if (anchor) {
	              angular.element(anchor).triggerHandler('click');
	            } else {
	              targetEl.triggerHandler('click');
	            }
	          }
	        };
	        $select.$onKeyDown = function(evt) {
	          if (!/(9|13|38|40)/.test(evt.keyCode)) return;
	          if (evt.keyCode !== 9) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (options.multiple && evt.keyCode === 9) {
	            return $select.hide();
	          }
	          if (!options.multiple && (evt.keyCode === 13 || evt.keyCode === 9)) {
	            return $select.select(scope.$activeIndex);
	          }
	          if (!options.multiple) {
	            if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; else if (evt.keyCode === 38 && scope.$activeIndex < 0) scope.$activeIndex = scope.$matches.length - 1; else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++; else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
	            scope.$digest();
	          }
	        };
	        $select.$isIE = function() {
	          var ua = $window.navigator.userAgent;
	          return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
	        };
	        $select.$selectScrollFix = function(e) {
	          if ($document[0].activeElement.tagName === 'UL') {
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            e.target.focus();
	          }
	        };
	        var _show = $select.show;
	        $select.show = function() {
	          _show();
	          if (options.multiple) {
	            $select.$element.addClass('select-multiple');
	          }
	          $timeout(function() {
	            $select.$element.on(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $select.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $select.hide;
	        $select.hide = function() {
	          if (!options.multiple && angular.isUndefined(controller.$modelValue)) {
	            scope.$activeIndex = -1;
	          }
	          $select.$element.off(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $select.$onKeyDown);
	          }
	          _hide(true);
	        };
	        return $select;
	      }
	      SelectFactory.defaults = defaults;
	      return SelectFactory;
	    } ];
	  }).directive('bsSelect', [ '$window', '$parse', '$q', '$select', '$parseOptions', function($window, $parse, $q, $select, $parseOptions) {
	    var defaults = $select.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope,
	          placeholder: defaults.placeholder
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'placeholder', 'allNoneButtons', 'maxLength', 'maxLengthHtml', 'allText', 'noneText', 'iconCheckmark', 'autoClose', 'id', 'sort', 'caretHtml', 'prefixClass', 'prefixEvent', 'toggle' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'allNoneButtons', 'sort' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataMultiple = element.attr('data-multiple');
	        if (angular.isDefined(dataMultiple)) {
	          if (falseValueRegExp.test(dataMultiple)) {
	            options.multiple = false;
	          } else {
	            options.multiple = dataMultiple;
	          }
	        }
	        if (element[0].nodeName.toLowerCase() === 'select') {
	          var inputEl = element;
	          inputEl.css('display', 'none');
	          element = angular.element('<button type="button" class="btn btn-default"></button>');
	          inputEl.after(element);
	        }
	        var parsedOptions = $parseOptions(attr.bsOptions);
	        var select = $select(element, controller, options);
	        if (select.$isIE()) {
	          element[0].addEventListener('blur', select.$selectScrollFix);
	        }
	        var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').trim();
	        scope.$watch(watchedOptions, function(newValue, oldValue) {
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            select.update(values);
	            controller.$render();
	          });
	        }, true);
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          select.$updateActiveIndex();
	          controller.$render();
	        }, true);
	        controller.$render = function() {
	          var selected;
	          var index;
	          if (options.multiple && angular.isArray(controller.$modelValue)) {
	            selected = controller.$modelValue.map(function(value) {
	              index = select.$getIndex(value);
	              return index !== -1 ? select.$scope.$matches[index].label : false;
	            }).filter(angular.isDefined);
	            if (selected.length > (options.maxLength || defaults.maxLength)) {
	              selected = selected.length + ' ' + (options.maxLengthHtml || defaults.maxLengthHtml);
	            } else {
	              selected = selected.join(', ');
	            }
	          } else {
	            index = select.$getIndex(controller.$modelValue);
	            selected = index !== -1 ? select.$scope.$matches[index].label : false;
	          }
	          element.html((selected || options.placeholder) + (options.caretHtml || defaults.caretHtml));
	        };
	        if (options.multiple) {
	          controller.$isEmpty = function(value) {
	            return !value || value.length === 0;
	          };
	        }
	        scope.$on('$destroy', function() {
	          if (select) select.destroy();
	          options = null;
	          select = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.scrollspy', [ 'mgcrea.ngStrap.helpers.debounce', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$scrollspy', function() {
	    var spies = this.$$spies = {};
	    var defaults = this.defaults = {
	      debounce: 150,
	      throttle: 100,
	      offset: 100
	    };
	    this.$get = [ '$window', '$document', '$rootScope', 'dimensions', 'debounce', 'throttle', function($window, $document, $rootScope, dimensions, debounce, throttle) {
	      var windowEl = angular.element($window);
	      var docEl = angular.element($document.prop('documentElement'));
	      var bodyEl = angular.element($window.document.body);
	      function nodeName(element, name) {
	        return element[0].nodeName && element[0].nodeName.toLowerCase() === name.toLowerCase();
	      }
	      function ScrollSpyFactory(config) {
	        var options = angular.extend({}, defaults, config);
	        if (!options.element) options.element = bodyEl;
	        var isWindowSpy = nodeName(options.element, 'body');
	        var scrollEl = isWindowSpy ? windowEl : options.element;
	        var scrollId = isWindowSpy ? 'window' : options.id;
	        if (spies[scrollId]) {
	          spies[scrollId].$$count++;
	          return spies[scrollId];
	        }
	        var $scrollspy = {};
	        var unbindViewContentLoaded;
	        var unbindIncludeContentLoaded;
	        var trackedElements = $scrollspy.$trackedElements = [];
	        var sortedElements = [];
	        var activeTarget;
	        var debouncedCheckPosition;
	        var throttledCheckPosition;
	        var debouncedCheckOffsets;
	        var viewportHeight;
	        var scrollTop;
	        $scrollspy.init = function() {
	          this.$$count = 1;
	          debouncedCheckPosition = debounce(this.checkPosition, options.debounce);
	          throttledCheckPosition = throttle(this.checkPosition, options.throttle);
	          scrollEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', debouncedCheckPosition);
	          scrollEl.on('scroll', throttledCheckPosition);
	          debouncedCheckOffsets = debounce(this.checkOffsets, options.debounce);
	          unbindViewContentLoaded = $rootScope.$on('$viewContentLoaded', debouncedCheckOffsets);
	          unbindIncludeContentLoaded = $rootScope.$on('$includeContentLoaded', debouncedCheckOffsets);
	          debouncedCheckOffsets();
	          if (scrollId) {
	            spies[scrollId] = $scrollspy;
	          }
	        };
	        $scrollspy.destroy = function() {
	          this.$$count--;
	          if (this.$$count > 0) {
	            return;
	          }
	          scrollEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', debouncedCheckPosition);
	          scrollEl.off('scroll', throttledCheckPosition);
	          unbindViewContentLoaded();
	          unbindIncludeContentLoaded();
	          if (scrollId) {
	            delete spies[scrollId];
	          }
	        };
	        $scrollspy.checkPosition = function() {
	          if (!sortedElements.length) return;
	          scrollTop = (isWindowSpy ? $window.pageYOffset : scrollEl.prop('scrollTop')) || 0;
	          viewportHeight = Math.max($window.innerHeight, docEl.prop('clientHeight'));
	          if (scrollTop < sortedElements[0].offsetTop && activeTarget !== sortedElements[0].target) {
	            return $scrollspy.$activateElement(sortedElements[0]);
	          }
	          for (var i = sortedElements.length; i--; ) {
	            if (angular.isUndefined(sortedElements[i].offsetTop) || sortedElements[i].offsetTop === null) continue;
	            if (activeTarget === sortedElements[i].target) continue;
	            if (scrollTop < sortedElements[i].offsetTop) continue;
	            if (sortedElements[i + 1] && scrollTop > sortedElements[i + 1].offsetTop) continue;
	            return $scrollspy.$activateElement(sortedElements[i]);
	          }
	        };
	        $scrollspy.checkPositionWithEventLoop = function() {
	          setTimeout($scrollspy.checkPosition, 1);
	        };
	        $scrollspy.$activateElement = function(element) {
	          if (activeTarget) {
	            var activeElement = $scrollspy.$getTrackedElement(activeTarget);
	            if (activeElement) {
	              activeElement.source.removeClass('active');
	              if (nodeName(activeElement.source, 'li') && nodeName(activeElement.source.parent().parent(), 'li')) {
	                activeElement.source.parent().parent().removeClass('active');
	              }
	            }
	          }
	          activeTarget = element.target;
	          element.source.addClass('active');
	          if (nodeName(element.source, 'li') && nodeName(element.source.parent().parent(), 'li')) {
	            element.source.parent().parent().addClass('active');
	          }
	        };
	        $scrollspy.$getTrackedElement = function(target) {
	          return trackedElements.filter(function(obj) {
	            return obj.target === target;
	          })[0];
	        };
	        $scrollspy.checkOffsets = function() {
	          angular.forEach(trackedElements, function(trackedElement) {
	            var targetElement = document.querySelector(trackedElement.target);
	            trackedElement.offsetTop = targetElement ? dimensions.offset(targetElement).top : null;
	            if (options.offset && trackedElement.offsetTop !== null) trackedElement.offsetTop -= options.offset * 1;
	          });
	          sortedElements = trackedElements.filter(function(el) {
	            return el.offsetTop !== null;
	          }).sort(function(a, b) {
	            return a.offsetTop - b.offsetTop;
	          });
	          debouncedCheckPosition();
	        };
	        $scrollspy.trackElement = function(target, source) {
	          trackedElements.push({
	            target: target,
	            source: source
	          });
	        };
	        $scrollspy.untrackElement = function(target, source) {
	          var toDelete;
	          for (var i = trackedElements.length; i--; ) {
	            if (trackedElements[i].target === target && trackedElements[i].source === source) {
	              toDelete = i;
	              break;
	            }
	          }
	          trackedElements.splice(toDelete, 1);
	        };
	        $scrollspy.activate = function(i) {
	          trackedElements[i].addClass('active');
	        };
	        $scrollspy.init();
	        return $scrollspy;
	      }
	      return ScrollSpyFactory;
	    } ];
	  }).directive('bsScrollspy', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'EAC',
	      link: function postLink(scope, element, attr) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'offset', 'target' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var scrollspy = $scrollspy(options);
	        scrollspy.trackElement(options.target, element);
	        scope.$on('$destroy', function() {
	          if (scrollspy) {
	            scrollspy.untrackElement(options.target, element);
	            scrollspy.destroy();
	          }
	          options = null;
	          scrollspy = null;
	        });
	      }
	    };
	  } ]).directive('bsScrollspyList', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'A',
	      compile: function postLink(element, attr) {
	        var children = element[0].querySelectorAll('li > a[href]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.parent().attr('bs-scrollspy', '').attr('data-target', childEl.attr('href'));
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.popover', [ 'mgcrea.ngStrap.tooltip' ]).provider('$popover', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      container: false,
	      target: false,
	      placement: 'right',
	      templateUrl: 'popover/popover.tpl.html',
	      contentTemplate: false,
	      trigger: 'click',
	      keyboard: true,
	      html: false,
	      title: '',
	      content: '',
	      delay: 0,
	      autoClose: false
	    };
	    this.$get = [ '$tooltip', function($tooltip) {
	      function PopoverFactory(element, config) {
	        var options = angular.extend({}, defaults, config);
	        var $popover = $tooltip(element, options);
	        if (options.content) {
	          $popover.$scope.content = options.content;
	        }
	        return $popover;
	      }
	      return PopoverFactory;
	    } ];
	  }).directive('bsPopover', [ '$window', '$sce', '$popover', function($window, $sce, $popover) {
	    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr) {
	        var popover;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'customClass', 'autoClose', 'id', 'prefixClass', 'prefixEvent', 'bsEnabled' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoClose' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	              if (angular.isDefined(oldValue)) {
	                requestAnimationFrame(function() {
	                  if (popover) popover.$applyPlacement();
	                });
	              }
	            });
	          }
	        });
	        if (attr.bsPopover) {
	          scope.$watch(attr.bsPopover, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              requestAnimationFrame(function() {
	                if (popover) popover.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(popover),?/i);
	            if (newValue === true) {
	              popover.show();
	            } else {
	              popover.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(popover),?/i);
	            if (newValue === false) {
	              popover.setEnabled(false);
	            } else {
	              popover.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            popover.setViewport(newValue);
	          });
	        }
	        popover = $popover(element, options);
	        scope.$on('$destroy', function() {
	          if (popover) popover.destroy();
	          options = null;
	          popover = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.navbar', []).provider('$navbar', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      routeAttr: 'data-match-route',
	      strict: false
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsNavbar', [ '$window', '$location', '$navbar', function($window, $location, $navbar) {
	    var defaults = $navbar.defaults;
	    return {
	      restrict: 'A',
	      link: function postLink(scope, element, attr, controller) {
	        var options = angular.copy(defaults);
	        angular.forEach(Object.keys(defaults), function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        scope.$watch(function() {
	          return $location.path();
	        }, function(newValue, oldValue) {
	          var liElements = element[0].querySelectorAll('li[' + options.routeAttr + ']');
	          angular.forEach(liElements, function(li) {
	            var liElement = angular.element(li);
	            var pattern = liElement.attr(options.routeAttr).replace('/', '\\/');
	            if (options.strict) {
	              pattern = '^' + pattern + '$';
	            }
	            var regexp = new RegExp(pattern, 'i');
	            if (regexp.test(newValue)) {
	              liElement.addClass(options.activeClass);
	            } else {
	              liElement.removeClass(options.activeClass);
	            }
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.modal', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$modal', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      backdropAnimation: 'am-fade',
	      customClass: '',
	      prefixClass: 'modal',
	      prefixEvent: 'modal',
	      placement: 'top',
	      templateUrl: 'modal/modal.tpl.html',
	      template: '',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true,
	      size: null,
	      zIndex: null
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$animate', '$timeout', '$sce', 'dimensions', function($window, $rootScope, $bsCompiler, $animate, $timeout, $sce, dimensions) {
	      var forEach = angular.forEach;
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	      var bodyElement = angular.element($window.document.body);
	      var backdropCount = 0;
	      var dialogBaseZindex = 1050;
	      var backdropBaseZindex = 1040;
	      var validSizes = {
	        lg: 'modal-lg',
	        sm: 'modal-sm'
	      };
	      function ModalFactory(config) {
	        var $modal = {};
	        var options = $modal.$options = angular.extend({}, defaults, config);
	        var promise = $modal.$promise = $bsCompiler.compile(options);
	        var scope = $modal.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        if (!options.element && !options.container) {
	          options.container = 'body';
	        }
	        if (options.zIndex) {
	          dialogBaseZindex = parseInt(options.zIndex, 10);
	          backdropBaseZindex = dialogBaseZindex - 10;
	        }
	        $modal.$id = options.id || options.element && options.element.attr('id') || '';
	        forEach([ 'title', 'content' ], function(key) {
	          if (options[key]) scope[key] = $sce.trustAsHtml(options[key]);
	        });
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $modal.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $modal.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $modal.toggle();
	          });
	        };
	        $modal.$isShown = scope.$isShown = false;
	        var compileData;
	        var modalElement;
	        var modalScope;
	        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
	        backdropElement.css({
	          position: 'fixed',
	          top: '0px',
	          left: '0px',
	          bottom: '0px',
	          right: '0px'
	        });
	        promise.then(function(data) {
	          compileData = data;
	          $modal.init();
	        });
	        $modal.init = function() {
	          if (options.show) {
	            scope.$$postDigest(function() {
	              $modal.show();
	            });
	          }
	        };
	        $modal.destroy = function() {
	          destroyModalElement();
	          if (backdropElement) {
	            backdropElement.remove();
	            backdropElement = null;
	          }
	          scope.$destroy();
	        };
	        $modal.show = function() {
	          if ($modal.$isShown) return;
	          var parent;
	          var after;
	          if (angular.isElement(options.container)) {
	            parent = options.container;
	            after = options.container[0].lastChild ? angular.element(options.container[0].lastChild) : null;
	          } else {
	            if (options.container) {
	              parent = findElement(options.container);
	              after = parent[0] && parent[0].lastChild ? angular.element(parent[0].lastChild) : null;
	            } else {
	              parent = null;
	              after = options.element;
	            }
	          }
	          if (modalElement) destroyModalElement();
	          modalScope = $modal.$scope.$new();
	          modalElement = $modal.$element = compileData.link(modalScope, function(clonedElement, scope) {});
	          if (options.backdrop) {
	            modalElement.css({
	              'z-index': dialogBaseZindex + backdropCount * 20
	            });
	            backdropElement.css({
	              'z-index': backdropBaseZindex + backdropCount * 20
	            });
	            backdropCount++;
	          }
	          if (scope.$emit(options.prefixEvent + '.show.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($modal);
	          }
	          modalElement.css({
	            display: 'block'
	          }).addClass(options.placement);
	          if (options.customClass) {
	            modalElement.addClass(options.customClass);
	          }
	          if (options.size && validSizes[options.size]) {
	            angular.element(findElement('.modal-dialog', modalElement[0])).addClass(validSizes[options.size]);
	          }
	          if (options.animation) {
	            if (options.backdrop) {
	              backdropElement.addClass(options.backdropAnimation);
	            }
	            modalElement.addClass(options.animation);
	          }
	          if (options.backdrop) {
	            $animate.enter(backdropElement, bodyElement, null);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.enter(modalElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(modalElement, parent, after).then(enterAnimateCallback);
	          }
	          $modal.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          var el = modalElement[0];
	          requestAnimationFrame(function() {
	            el.focus();
	          });
	          bodyElement.addClass(options.prefixClass + '-open');
	          if (options.animation) {
	            bodyElement.addClass(options.prefixClass + '-with-' + options.animation);
	          }
	          bindBackdropEvents();
	          bindKeyboardEvents();
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $modal);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($modal);
	          }
	        }
	        $modal.hide = function() {
	          if (!$modal.$isShown) return;
	          if (scope.$emit(options.prefixEvent + '.hide.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($modal);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.leave(modalElement, leaveAnimateCallback);
	          } else {
	            $animate.leave(modalElement).then(leaveAnimateCallback);
	          }
	          if (options.backdrop) {
	            backdropCount--;
	            $animate.leave(backdropElement);
	          }
	          $modal.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          unbindBackdropEvents();
	          unbindKeyboardEvents();
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $modal);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($modal);
	          }
	          if (findElement('.modal').length <= 0) {
	            bodyElement.removeClass(options.prefixClass + '-open');
	          }
	          if (options.animation) {
	            bodyElement.removeClass(options.prefixClass + '-with-' + options.animation);
	          }
	        }
	        $modal.toggle = function() {
	          if ($modal.$isShown) {
	            $modal.hide();
	          } else {
	            $modal.show();
	          }
	        };
	        $modal.focus = function() {
	          modalElement[0].focus();
	        };
	        $modal.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $modal.$isShown) {
	            $modal.hide();
	            evt.stopPropagation();
	          }
	        };
	        function bindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.on('click', hideOnBackdropClick);
	            backdropElement.on('click', hideOnBackdropClick);
	            backdropElement.on('wheel', preventEventDefault);
	          }
	        }
	        function unbindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.off('click', hideOnBackdropClick);
	            backdropElement.off('click', hideOnBackdropClick);
	            backdropElement.off('wheel', preventEventDefault);
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.on('keyup', $modal.$onKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.off('keyup', $modal.$onKeyUp);
	          }
	        }
	        function hideOnBackdropClick(evt) {
	          if (evt.target !== evt.currentTarget) return;
	          if (options.backdrop === 'static') {
	            $modal.focus();
	          } else {
	            $modal.hide();
	          }
	        }
	        function preventEventDefault(evt) {
	          evt.preventDefault();
	        }
	        function destroyModalElement() {
	          if ($modal.$isShown && modalElement !== null) {
	            unbindBackdropEvents();
	            unbindKeyboardEvents();
	          }
	          if (modalScope) {
	            modalScope.$destroy();
	            modalScope = null;
	          }
	          if (modalElement) {
	            modalElement.remove();
	            modalElement = $modal.$element = null;
	          }
	        }
	        return $modal;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return ModalFactory;
	    } ];
	  }).directive('bsModal', [ '$window', '$sce', '$parse', '$modal', function($window, $sce, $parse, $modal) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation', 'backdropAnimation', 'id', 'prefixEvent', 'prefixClass', 'customClass', 'modalClass', 'size', 'zIndex' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        if (options.modalClass) {
	          options.customClass = options.modalClass;
	        }
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsModal) {
	          scope.$watch(attr.bsModal, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var modal = $modal(options);
	        element.on(attr.trigger || 'click', modal.toggle);
	        scope.$on('$destroy', function() {
	          if (modal) modal.destroy();
	          options = null;
	          modal = null;
	        });
	      }
	    };
	  } ]);
	  if (angular.version.minor < 3 && angular.version.dot < 14) {
	    angular.module('ng').factory('$$rAF', [ '$window', '$timeout', function($window, $timeout) {
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;
	      var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.mozCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
	      var rafSupported = !!requestAnimationFrame;
	      var raf = rafSupported ? function(fn) {
	        var id = requestAnimationFrame(fn);
	        return function() {
	          cancelAnimationFrame(id);
	        };
	      } : function(fn) {
	        var timer = $timeout(fn, 16.66, false);
	        return function() {
	          $timeout.cancel(timer);
	        };
	      };
	      raf.supported = rafSupported;
	      return raf;
	    } ]);
	  }
	  angular.module('mgcrea.ngStrap.helpers.parseOptions', []).provider('$parseOptions', function() {
	    var defaults = this.defaults = {
	      regexp: /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/
	    };
	    this.$get = [ '$parse', '$q', function($parse, $q) {
	      function ParseOptionsFactory(attr, config) {
	        var $parseOptions = {};
	        var options = angular.extend({}, defaults, config);
	        $parseOptions.$values = [];
	        var match;
	        var displayFn;
	        var valueName;
	        var keyName;
	        var groupByFn;
	        var valueFn;
	        var valuesFn;
	        $parseOptions.init = function() {
	          $parseOptions.$match = match = attr.match(options.regexp);
	          displayFn = $parse(match[2] || match[1]);
	          valueName = match[4] || match[6];
	          keyName = match[5];
	          groupByFn = $parse(match[3] || '');
	          valueFn = $parse(match[2] ? match[1] : valueName);
	          valuesFn = $parse(match[7]);
	        };
	        $parseOptions.valuesFn = function(scope, controller) {
	          return $q.when(valuesFn(scope, controller)).then(function(values) {
	            if (!angular.isArray(values)) {
	              values = [];
	            }
	            $parseOptions.$values = values.length ? parseValues(values, scope) : [];
	            return $parseOptions.$values;
	          });
	        };
	        $parseOptions.displayValue = function(modelValue) {
	          var scope = {};
	          scope[valueName] = modelValue;
	          return displayFn(scope);
	        };
	        function parseValues(values, scope) {
	          return values.map(function(match, index) {
	            var locals = {};
	            var label;
	            var value;
	            locals[valueName] = match;
	            label = displayFn(scope, locals);
	            value = valueFn(scope, locals);
	            return {
	              label: label,
	              value: value,
	              index: index
	            };
	          });
	        }
	        $parseOptions.init();
	        return $parseOptions;
	      }
	      return ParseOptionsFactory;
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.helpers.dimensions', []).factory('dimensions', function() {
	    var fn = {};
	    var nodeName = fn.nodeName = function(element, name) {
	      return element.nodeName && element.nodeName.toLowerCase() === name.toLowerCase();
	    };
	    fn.css = function(element, prop, extra) {
	      var value;
	      if (element.currentStyle) {
	        value = element.currentStyle[prop];
	      } else if (window.getComputedStyle) {
	        value = window.getComputedStyle(element)[prop];
	      } else {
	        value = element.style[prop];
	      }
	      return extra === true ? parseFloat(value) || 0 : value;
	    };
	    fn.offset = function(element) {
	      var boxRect = element.getBoundingClientRect();
	      var docElement = element.ownerDocument;
	      return {
	        width: boxRect.width || element.offsetWidth,
	        height: boxRect.height || element.offsetHeight,
	        top: boxRect.top + (window.pageYOffset || docElement.documentElement.scrollTop) - (docElement.documentElement.clientTop || 0),
	        left: boxRect.left + (window.pageXOffset || docElement.documentElement.scrollLeft) - (docElement.documentElement.clientLeft || 0)
	      };
	    };
	    fn.setOffset = function(element, options, i) {
	      var curPosition;
	      var curLeft;
	      var curCSSTop;
	      var curTop;
	      var curOffset;
	      var curCSSLeft;
	      var calculatePosition;
	      var position = fn.css(element, 'position');
	      var curElem = angular.element(element);
	      var props = {};
	      if (position === 'static') {
	        element.style.position = 'relative';
	      }
	      curOffset = fn.offset(element);
	      curCSSTop = fn.css(element, 'top');
	      curCSSLeft = fn.css(element, 'left');
	      calculatePosition = (position === 'absolute' || position === 'fixed') && (curCSSTop + curCSSLeft).indexOf('auto') > -1;
	      if (calculatePosition) {
	        curPosition = fn.position(element);
	        curTop = curPosition.top;
	        curLeft = curPosition.left;
	      } else {
	        curTop = parseFloat(curCSSTop) || 0;
	        curLeft = parseFloat(curCSSLeft) || 0;
	      }
	      if (angular.isFunction(options)) {
	        options = options.call(element, i, curOffset);
	      }
	      if (options.top !== null) {
	        props.top = options.top - curOffset.top + curTop;
	      }
	      if (options.left !== null) {
	        props.left = options.left - curOffset.left + curLeft;
	      }
	      if ('using' in options) {
	        options.using.call(curElem, props);
	      } else {
	        curElem.css({
	          top: props.top + 'px',
	          left: props.left + 'px'
	        });
	      }
	    };
	    fn.position = function(element) {
	      var offsetParentRect = {
	        top: 0,
	        left: 0
	      };
	      var offsetParentEl;
	      var offset;
	      if (fn.css(element, 'position') === 'fixed') {
	        offset = element.getBoundingClientRect();
	      } else {
	        offsetParentEl = offsetParentElement(element);
	        offset = fn.offset(element);
	        if (!nodeName(offsetParentEl, 'html')) {
	          offsetParentRect = fn.offset(offsetParentEl);
	        }
	        offsetParentRect.top += fn.css(offsetParentEl, 'borderTopWidth', true);
	        offsetParentRect.left += fn.css(offsetParentEl, 'borderLeftWidth', true);
	      }
	      return {
	        width: element.offsetWidth,
	        height: element.offsetHeight,
	        top: offset.top - offsetParentRect.top - fn.css(element, 'marginTop', true),
	        left: offset.left - offsetParentRect.left - fn.css(element, 'marginLeft', true)
	      };
	    };
	    function offsetParentElement(element) {
	      var docElement = element.ownerDocument;
	      var offsetParent = element.offsetParent || docElement;
	      if (nodeName(offsetParent, '#document')) return docElement.documentElement;
	      while (offsetParent && !nodeName(offsetParent, 'html') && fn.css(offsetParent, 'position') === 'static') {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docElement.documentElement;
	    }
	    fn.height = function(element, outer) {
	      var value = element.offsetHeight;
	      if (outer) {
	        value += fn.css(element, 'marginTop', true) + fn.css(element, 'marginBottom', true);
	      } else {
	        value -= fn.css(element, 'paddingTop', true) + fn.css(element, 'paddingBottom', true) + fn.css(element, 'borderTopWidth', true) + fn.css(element, 'borderBottomWidth', true);
	      }
	      return value;
	    };
	    fn.width = function(element, outer) {
	      var value = element.offsetWidth;
	      if (outer) {
	        value += fn.css(element, 'marginLeft', true) + fn.css(element, 'marginRight', true);
	      } else {
	        value -= fn.css(element, 'paddingLeft', true) + fn.css(element, 'paddingRight', true) + fn.css(element, 'borderLeftWidth', true) + fn.css(element, 'borderRightWidth', true);
	      }
	      return value;
	    };
	    return fn;
	  });
	  angular.module('mgcrea.ngStrap.helpers.debounce', []).factory('debounce', [ '$timeout', function($timeout) {
	    return function(func, wait, immediate) {
	      var timeout = null;
	      return function() {
	        var context = this;
	        var args = arguments;
	        var callNow = immediate && !timeout;
	        if (timeout) {
	          $timeout.cancel(timeout);
	        }
	        timeout = $timeout(function later() {
	          timeout = null;
	          if (!immediate) {
	            func.apply(context, args);
	          }
	        }, wait, false);
	        if (callNow) {
	          func.apply(context, args);
	        }
	        return timeout;
	      };
	    };
	  } ]).factory('throttle', [ '$timeout', function($timeout) {
	    return function(func, wait, options) {
	      var timeout = null;
	      if (!options) options = {};
	      return function() {
	        var context = this;
	        var args = arguments;
	        if (!timeout) {
	          if (options.leading !== false) {
	            func.apply(context, args);
	          }
	          timeout = $timeout(function later() {
	            timeout = null;
	            if (options.trailing !== false) {
	              func.apply(context, args);
	            }
	          }, wait, false);
	        }
	      };
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateParser', []).provider('$dateParser', [ '$localeProvider', function($localeProvider) {
	    function ParseDate() {
	      this.year = 1970;
	      this.month = 0;
	      this.day = 1;
	      this.hours = 0;
	      this.minutes = 0;
	      this.seconds = 0;
	      this.milliseconds = 0;
	    }
	    ParseDate.prototype.setMilliseconds = function(value) {
	      this.milliseconds = value;
	    };
	    ParseDate.prototype.setSeconds = function(value) {
	      this.seconds = value;
	    };
	    ParseDate.prototype.setMinutes = function(value) {
	      this.minutes = value;
	    };
	    ParseDate.prototype.setHours = function(value) {
	      this.hours = value;
	    };
	    ParseDate.prototype.getHours = function() {
	      return this.hours;
	    };
	    ParseDate.prototype.setDate = function(value) {
	      this.day = value;
	    };
	    ParseDate.prototype.setMonth = function(value) {
	      this.month = value;
	    };
	    ParseDate.prototype.setFullYear = function(value) {
	      this.year = value;
	    };
	    ParseDate.prototype.fromDate = function(value) {
	      this.year = value.getFullYear();
	      this.month = value.getMonth();
	      this.day = value.getDate();
	      this.hours = value.getHours();
	      this.minutes = value.getMinutes();
	      this.seconds = value.getSeconds();
	      this.milliseconds = value.getMilliseconds();
	      return this;
	    };
	    ParseDate.prototype.toDate = function() {
	      return new Date(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
	    };
	    var proto = ParseDate.prototype;
	    function noop() {}
	    function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	    function indexOfCaseInsensitive(array, value) {
	      var len = array.length;
	      var str = value.toString().toLowerCase();
	      for (var i = 0; i < len; i++) {
	        if (array[i].toLowerCase() === str) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    var defaults = this.defaults = {
	      format: 'shortDate',
	      strict: false
	    };
	    this.$get = [ '$locale', 'dateFilter', function($locale, dateFilter) {
	      var DateParserFactory = function(config) {
	        var options = angular.extend({}, defaults, config);
	        var $dateParser = {};
	        var regExpMap = {
	          sss: '[0-9]{3}',
	          ss: '[0-5][0-9]',
	          s: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          mm: '[0-5][0-9]',
	          m: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          HH: '[01][0-9]|2[0-3]',
	          H: options.strict ? '1?[0-9]|2[0-3]' : '[01]?[0-9]|2[0-3]',
	          hh: '[0][1-9]|[1][012]',
	          h: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          a: 'AM|PM',
	          EEEE: $locale.DATETIME_FORMATS.DAY.join('|'),
	          EEE: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	          dd: '0[1-9]|[12][0-9]|3[01]',
	          d: options.strict ? '[1-9]|[1-2][0-9]|3[01]' : '0?[1-9]|[1-2][0-9]|3[01]',
	          MMMM: $locale.DATETIME_FORMATS.MONTH.join('|'),
	          MMM: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	          MM: '0[1-9]|1[012]',
	          M: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          yyyy: '[1]{1}[0-9]{3}|[2]{1}[0-9]{3}',
	          yy: '[0-9]{2}',
	          y: options.strict ? '-?(0|[1-9][0-9]{0,3})' : '-?0*[0-9]{1,4}'
	        };
	        var setFnMap = {
	          sss: proto.setMilliseconds,
	          ss: proto.setSeconds,
	          s: proto.setSeconds,
	          mm: proto.setMinutes,
	          m: proto.setMinutes,
	          HH: proto.setHours,
	          H: proto.setHours,
	          hh: proto.setHours,
	          h: proto.setHours,
	          EEEE: noop,
	          EEE: noop,
	          dd: proto.setDate,
	          d: proto.setDate,
	          a: function(value) {
	            var hours = this.getHours() % 12;
	            return this.setHours(value.match(/pm/i) ? hours + 12 : hours);
	          },
	          MMMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.MONTH, value));
	          },
	          MMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.SHORTMONTH, value));
	          },
	          MM: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          M: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          yyyy: proto.setFullYear,
	          yy: function(value) {
	            return this.setFullYear(2e3 + 1 * value);
	          },
	          y: function(value) {
	            return 1 * value <= 50 && value.length === 2 ? this.setFullYear(2e3 + 1 * value) : this.setFullYear(1 * value);
	          }
	        };
	        var regex;
	        var setMap;
	        $dateParser.init = function() {
	          $dateParser.$format = $locale.DATETIME_FORMATS[options.format] || options.format;
	          regex = regExpForFormat($dateParser.$format);
	          setMap = setMapForFormat($dateParser.$format);
	        };
	        $dateParser.isValid = function(date) {
	          if (angular.isDate(date)) return !isNaN(date.getTime());
	          return regex.test(date);
	        };
	        $dateParser.parse = function(value, baseDate, format, timezone) {
	          if (format) format = $locale.DATETIME_FORMATS[format] || format;
	          if (angular.isDate(value)) value = dateFilter(value, format || $dateParser.$format, timezone);
	          var formatRegex = format ? regExpForFormat(format) : regex;
	          var formatSetMap = format ? setMapForFormat(format) : setMap;
	          var matches = formatRegex.exec(value);
	          if (!matches) return false;
	          var date = baseDate && !isNaN(baseDate.getTime()) ? new ParseDate().fromDate(baseDate) : new ParseDate().fromDate(new Date(1970, 0, 1, 0));
	          for (var i = 0; i < matches.length - 1; i++) {
	            if (formatSetMap[i]) formatSetMap[i].call(date, matches[i + 1]);
	          }
	          var newDate = date.toDate();
	          if (parseInt(date.day, 10) !== newDate.getDate()) {
	            return false;
	          }
	          return newDate;
	        };
	        $dateParser.getDateForAttribute = function(key, value) {
	          var date;
	          if (value === 'today') {
	            var today = new Date();
	            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (key === 'maxDate' ? 1 : 0), 0, 0, 0, key === 'minDate' ? 0 : -1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            date = new Date(value.substr(1, value.length - 2));
	          } else if (isNumeric(value)) {
	            date = new Date(parseInt(value, 10));
	          } else if (angular.isString(value) && value.length === 0) {
	            date = key === 'minDate' ? -Infinity : +Infinity;
	          } else {
	            date = new Date(value);
	          }
	          return date;
	        };
	        $dateParser.getTimeForAttribute = function(key, value) {
	          var time;
	          if (value === 'now') {
	            time = new Date().setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            time = new Date(value.substr(1, value.length - 2)).setFullYear(1970, 0, 1);
	          } else if (isNumeric(value)) {
	            time = new Date(parseInt(value, 10)).setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.length === 0) {
	            time = key === 'minTime' ? -Infinity : +Infinity;
	          } else {
	            time = $dateParser.parse(value, new Date(1970, 0, 1, 0));
	          }
	          return time;
	        };
	        $dateParser.daylightSavingAdjust = function(date) {
	          if (!date) {
	            return null;
	          }
	          date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
	          return date;
	        };
	        $dateParser.timezoneOffsetAdjust = function(date, timezone, undo) {
	          if (!date) {
	            return null;
	          }
	          if (timezone && timezone === 'UTC') {
	            date = new Date(date.getTime());
	            date.setMinutes(date.getMinutes() + (undo ? -1 : 1) * date.getTimezoneOffset());
	          }
	          return date;
	        };
	        function regExpForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseRegex(re);
	        }
	        function buildDateAbstractRegex(format) {
	          var escapedFormat = escapeReservedSymbols(format);
	          var escapedLiteralFormat = escapedFormat.replace(/''/g, '\\\'');
	          var literalRegex = /('(?:\\'|.)*?')/;
	          var formatParts = escapedLiteralFormat.split(literalRegex);
	          var dateElements = Object.keys(regExpMap);
	          var dateRegexParts = [];
	          angular.forEach(formatParts, function(part) {
	            if (isFormatStringLiteral(part)) {
	              part = trimLiteralEscapeChars(part);
	            } else {
	              for (var i = 0; i < dateElements.length; i++) {
	                part = part.split(dateElements[i]).join('${' + i + '}');
	              }
	            }
	            dateRegexParts.push(part);
	          });
	          return dateRegexParts.join('');
	        }
	        function escapeReservedSymbols(text) {
	          return text.replace(/\\/g, '[\\\\]').replace(/-/g, '[-]').replace(/\./g, '[.]').replace(/\*/g, '[*]').replace(/\+/g, '[+]').replace(/\?/g, '[?]').replace(/\$/g, '[$]').replace(/\^/g, '[^]').replace(/\//g, '[/]').replace(/\\s/g, '[\\s]');
	        }
	        function isFormatStringLiteral(text) {
	          return /^'.*'$/.test(text);
	        }
	        function trimLiteralEscapeChars(text) {
	          return text.replace(/^'(.*)'$/, '$1');
	        }
	        function buildDateParseRegex(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var re = abstractRegex;
	          for (var i = 0; i < dateElements.length; i++) {
	            re = re.split('${' + i + '}').join('(' + regExpMap[dateElements[i]] + ')');
	          }
	          return new RegExp('^' + re + '$', [ 'i' ]);
	        }
	        function setMapForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseValuesMap(re);
	        }
	        function buildDateParseValuesMap(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var valuesRegex = new RegExp('\\${(\\d+)}', 'g');
	          var valuesMatch;
	          var keyIndex;
	          var valueKey;
	          var valueFunction;
	          var valuesFunctionMap = [];
	          while ((valuesMatch = valuesRegex.exec(abstractRegex)) !== null) {
	            keyIndex = valuesMatch[1];
	            valueKey = dateElements[keyIndex];
	            valueFunction = setFnMap[valueKey];
	            valuesFunctionMap.push(valueFunction);
	          }
	          return valuesFunctionMap;
	        }
	        $dateParser.init();
	        return $dateParser;
	      };
	      return DateParserFactory;
	    } ];
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateFormatter', []).service('$dateFormatter', [ '$locale', 'dateFilter', function($locale, dateFilter) {
	    this.getDefaultLocale = function() {
	      return $locale.id;
	    };
	    this.getDatetimeFormat = function(format, lang) {
	      return $locale.DATETIME_FORMATS[format] || format;
	    };
	    this.weekdaysShort = function(lang) {
	      return $locale.DATETIME_FORMATS.SHORTDAY;
	    };
	    function splitTimeFormat(format) {
	      return /(h+)([:\.])?(m+)([:\.])?(s*)[ ]?(a?)/i.exec(format).slice(1);
	    }
	    this.hoursFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[0];
	    };
	    this.minutesFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[2];
	    };
	    this.secondsFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[4];
	    };
	    this.timeSeparator = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[1];
	    };
	    this.showSeconds = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[4];
	    };
	    this.showAM = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[5];
	    };
	    this.formatDate = function(date, format, lang, timezone) {
	      return dateFilter(date, format, timezone);
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.core', []).service('$bsCompiler', bsCompilerService);
	  function bsCompilerService($q, $http, $injector, $compile, $controller, $templateCache) {
	    this.compile = function(options) {
	      if (options.template && /\.html$/.test(options.template)) {
	        console.warn('Deprecated use of `template` option to pass a file. Please use the `templateUrl` option instead.');
	        options.templateUrl = options.template;
	        options.template = '';
	      }
	      var templateUrl = options.templateUrl;
	      var template = options.template || '';
	      var controller = options.controller;
	      var controllerAs = options.controllerAs;
	      var resolve = options.resolve || {};
	      var locals = options.locals || {};
	      var transformTemplate = options.transformTemplate || angular.identity;
	      var bindToController = options.bindToController;
	      angular.forEach(resolve, function(value, key) {
	        if (angular.isString(value)) {
	          resolve[key] = $injector.get(value);
	        } else {
	          resolve[key] = $injector.invoke(value);
	        }
	      });
	      angular.extend(resolve, locals);
	      if (template) {
	        resolve.$template = $q.when(template);
	      } else if (templateUrl) {
	        resolve.$template = fetchTemplate(templateUrl);
	      } else {
	        throw new Error('Missing `template` / `templateUrl` option.');
	      }
	      if (options.titleTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.titleTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          findElement('[ng-bind="title"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          return templateEl[0].outerHTML;
	        });
	      }
	      if (options.contentTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.contentTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          var contentEl = findElement('[ng-bind="content"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          if (!options.templateUrl) contentEl.next().remove();
	          return templateEl[0].outerHTML;
	        });
	      }
	      return $q.all(resolve).then(function(locals) {
	        var template = transformTemplate(locals.$template);
	        if (options.html) {
	          template = template.replace(/ng-bind="/gi, 'ng-bind-html="');
	        }
	        var element = angular.element('<div>').html(template.trim()).contents();
	        var linkFn = $compile(element);
	        return {
	          locals: locals,
	          element: element,
	          link: function link(scope) {
	            locals.$scope = scope;
	            if (controller) {
	              var invokeCtrl = $controller(controller, locals, true);
	              if (bindToController) {
	                angular.extend(invokeCtrl.instance, locals);
	              }
	              var ctrl = angular.isObject(invokeCtrl) ? invokeCtrl : invokeCtrl();
	              element.data('$ngControllerController', ctrl);
	              element.children().data('$ngControllerController', ctrl);
	              if (controllerAs) {
	                scope[controllerAs] = ctrl;
	              }
	            }
	            return linkFn.apply(null, arguments);
	          }
	        };
	      });
	    };
	    function findElement(query, element) {
	      return angular.element((element || document).querySelectorAll(query));
	    }
	    var fetchPromises = {};
	    function fetchTemplate(template) {
	      if (fetchPromises[template]) return fetchPromises[template];
	      return fetchPromises[template] = $http.get(template, {
	        cache: $templateCache
	      }).then(function(res) {
	        return res.data;
	      });
	    }
	  }
	  angular.module('mgcrea.ngStrap.dropdown', [ 'mgcrea.ngStrap.tooltip' ]).provider('$dropdown', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'dropdown',
	      prefixEvent: 'dropdown',
	      placement: 'bottom-left',
	      templateUrl: 'dropdown/dropdown.tpl.html',
	      trigger: 'click',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$timeout', function($window, $rootScope, $tooltip, $timeout) {
	      var bodyEl = angular.element($window.document.body);
	      var matchesSelector = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector;
	      function DropdownFactory(element, config) {
	        var $dropdown = {};
	        var options = angular.extend({}, defaults, config);
	        $dropdown.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        $dropdown = $tooltip(element, options);
	        var parentEl = element.parent();
	        $dropdown.$onKeyDown = function(evt) {
	          if (!/(38|40)/.test(evt.keyCode)) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          var items = angular.element($dropdown.$element[0].querySelectorAll('li:not(.divider) a'));
	          if (!items.length) return;
	          var index;
	          angular.forEach(items, function(el, i) {
	            if (matchesSelector && matchesSelector.call(el, ':focus')) index = i;
	          });
	          if (evt.keyCode === 38 && index > 0) index--; else if (evt.keyCode === 40 && index < items.length - 1) index++; else if (angular.isUndefined(index)) index = 0;
	          items.eq(index)[0].focus();
	        };
	        var show = $dropdown.show;
	        $dropdown.show = function() {
	          show();
	          $timeout(function() {
	            if (options.keyboard && $dropdown.$element) $dropdown.$element.on('keydown', $dropdown.$onKeyDown);
	            bodyEl.on('click', onBodyClick);
	          }, 0, false);
	          if (parentEl.hasClass('dropdown')) parentEl.addClass('open');
	        };
	        var hide = $dropdown.hide;
	        $dropdown.hide = function() {
	          if (!$dropdown.$isShown) return;
	          if (options.keyboard && $dropdown.$element) $dropdown.$element.off('keydown', $dropdown.$onKeyDown);
	          bodyEl.off('click', onBodyClick);
	          if (parentEl.hasClass('dropdown')) parentEl.removeClass('open');
	          hide();
	        };
	        var destroy = $dropdown.destroy;
	        $dropdown.destroy = function() {
	          bodyEl.off('click', onBodyClick);
	          destroy();
	        };
	        function onBodyClick(evt) {
	          if (evt.target === element[0]) return;
	          return evt.target !== element[0] && $dropdown.hide();
	        }
	        return $dropdown;
	      }
	      return DropdownFactory;
	    } ];
	  }).directive('bsDropdown', [ '$window', '$sce', '$dropdown', function($window, $sce, $dropdown) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      compile: function(tElement, tAttrs) {
	        if (!tAttrs.bsDropdown) {
	          var nextSibling = tElement[0].nextSibling;
	          while (nextSibling && nextSibling.nodeType !== 1) {
	            nextSibling = nextSibling.nextSibling;
	          }
	          if (nextSibling && nextSibling.className.split(' ').indexOf('dropdown-menu') >= 0) {
	            tAttrs.template = nextSibling.outerHTML;
	            tAttrs.templateUrl = undefined;
	            nextSibling.parentNode.removeChild(nextSibling);
	          }
	        }
	        return function postLink(scope, element, attr) {
	          var options = {
	            scope: scope
	          };
	          angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'id', 'autoClose' ], function(key) {
	            if (angular.isDefined(tAttrs[key])) options[key] = tAttrs[key];
	          });
	          var falseValueRegExp = /^(false|0|)$/i;
	          angular.forEach([ 'html', 'container' ], function(key) {
	            if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	          });
	          angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	            var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	            if (angular.isDefined(attr[bsKey])) {
	              options[key] = scope.$eval(attr[bsKey]);
	            }
	          });
	          if (attr.bsDropdown) {
	            scope.$watch(attr.bsDropdown, function(newValue, oldValue) {
	              scope.content = newValue;
	            }, true);
	          }
	          var dropdown = $dropdown(element, options);
	          if (attr.bsShow) {
	            scope.$watch(attr.bsShow, function(newValue, oldValue) {
	              if (!dropdown || !angular.isDefined(newValue)) return;
	              if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(dropdown),?/i);
	              if (newValue === true) {
	                dropdown.show();
	              } else {
	                dropdown.hide();
	              }
	            });
	          }
	          scope.$on('$destroy', function() {
	            if (dropdown) dropdown.destroy();
	            options = null;
	            dropdown = null;
	          });
	        };
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.button', []).provider('$button', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      toggleEvent: 'click'
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsCheckboxGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="checkbox"]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.attr('bs-checkbox', '');
	          childEl.attr('ng-model', attr.ngModel + '.' + childEl.attr('value'));
	        });
	      }
	    };
	  }).directive('bsCheckbox', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var trueValue = angular.isDefined(attr.trueValue) ? attr.trueValue : true;
	        if (constantValueRegExp.test(attr.trueValue)) {
	          trueValue = scope.$eval(attr.trueValue);
	        }
	        var falseValue = angular.isDefined(attr.falseValue) ? attr.falseValue : false;
	        if (constantValueRegExp.test(attr.falseValue)) {
	          falseValue = scope.$eval(attr.falseValue);
	        }
	        var hasExoticValues = typeof trueValue !== 'boolean' || typeof falseValue !== 'boolean';
	        if (hasExoticValues) {
	          controller.$parsers.push(function(viewValue) {
	            return viewValue ? trueValue : falseValue;
	          });
	          controller.$formatters.push(function(modelValue) {
	            return angular.equals(modelValue, trueValue);
	          });
	        }
	        controller.$render = function() {
	          var isActive = !!controller.$viewValue;
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            if (!isInput) {
	              controller.$setViewValue(!activeElement.hasClass('active'));
	            }
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]).directive('bsRadioGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="radio"]');
	        angular.forEach(children, function(child) {
	          angular.element(child).attr('bs-radio', '');
	          angular.element(child).attr('ng-model', attr.ngModel);
	        });
	      }
	    };
	  }).directive('bsRadio', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var value;
	        attr.$observe('value', function(v) {
	          if (typeof v !== 'boolean' && constantValueRegExp.test(v)) {
	            value = scope.$eval(v);
	          } else {
	            value = v;
	          }
	          controller.$render();
	        });
	        controller.$render = function() {
	          var isActive = angular.equals(controller.$viewValue, value);
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            controller.$setViewValue(value);
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.datepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$datepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'datepicker',
	      placement: 'bottom-left',
	      templateUrl: 'datepicker/datepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: false,
	      dateType: 'date',
	      dateFormat: 'shortDate',
	      timezone: null,
	      modelDateFormat: null,
	      dayFormat: 'dd',
	      monthFormat: 'MMM',
	      yearFormat: 'yyyy',
	      monthTitleFormat: 'MMMM yyyy',
	      yearTitleFormat: 'yyyy',
	      strictFormat: false,
	      autoclose: false,
	      minDate: -Infinity,
	      maxDate: +Infinity,
	      startView: 0,
	      minView: 0,
	      startWeek: 0,
	      daysOfWeekDisabled: '',
	      hasToday: false,
	      hasClear: false,
	      iconLeft: 'glyphicon glyphicon-chevron-left',
	      iconRight: 'glyphicon glyphicon-chevron-right'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', 'datepickerViews', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, datepickerViews, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) defaults.lang = $dateFormatter.getDefaultLocale();
	      function DatepickerFactory(element, controller, config) {
	        var $datepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $datepicker.$options;
	        var scope = $datepicker.$scope;
	        if (options.startView) options.startView -= options.minView;
	        var pickerViews = datepickerViews($datepicker);
	        $datepicker.$views = pickerViews.views;
	        var viewDate = pickerViews.viewDate;
	        scope.$mode = options.startView;
	        scope.$iconLeft = options.iconLeft;
	        scope.$iconRight = options.iconRight;
	        scope.$hasToday = options.hasToday;
	        scope.$hasClear = options.hasClear;
	        var $picker = $datepicker.$views[scope.$mode];
	        scope.$select = function(date, disabled) {
	          if (disabled) return;
	          $datepicker.select(date);
	        };
	        scope.$selectPane = function(value) {
	          $datepicker.$selectPane(value);
	        };
	        scope.$toggleMode = function() {
	          $datepicker.setMode((scope.$mode + 1) % $datepicker.$views.length);
	        };
	        scope.$setToday = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(new Date());
	          } else {
	            $datepicker.select(new Date(), true);
	          }
	        };
	        scope.$clear = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(null);
	          } else {
	            $datepicker.select(null, true);
	          }
	        };
	        $datepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $datepicker.$date = date;
	            $picker.update.call($picker, date);
	          }
	          $datepicker.$build(true);
	        };
	        $datepicker.updateDisabledDates = function(dateRanges) {
	          options.disabledDateRanges = dateRanges;
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], $datepicker.$setDisabledEl);
	          }
	        };
	        $datepicker.select = function(date, keep) {
	          if (angular.isDate(date)) {
	            if (!angular.isDate(controller.$dateValue) || isNaN(controller.$dateValue.getTime())) {
	              controller.$dateValue = new Date(date);
	            }
	          } else {
	            controller.$dateValue = null;
	          }
	          if (!scope.$mode || keep) {
	            controller.$setViewValue(angular.copy(date));
	            controller.$render();
	            if (options.autoclose && !keep) {
	              $timeout(function() {
	                $datepicker.hide(true);
	              });
	            }
	          } else {
	            angular.extend(viewDate, {
	              year: date.getFullYear(),
	              month: date.getMonth(),
	              date: date.getDate()
	            });
	            $datepicker.setMode(scope.$mode - 1);
	            $datepicker.$build();
	          }
	        };
	        $datepicker.setMode = function(mode) {
	          scope.$mode = mode;
	          $picker = $datepicker.$views[scope.$mode];
	          $datepicker.$build();
	        };
	        $datepicker.$build = function(pristine) {
	          if (pristine === true && $picker.built) return;
	          if (pristine === false && !$picker.built) return;
	          $picker.build.call($picker);
	        };
	        $datepicker.$updateSelected = function() {
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], updateSelected);
	          }
	        };
	        $datepicker.$isSelected = function(date) {
	          return $picker.isSelected(date);
	        };
	        $datepicker.$setDisabledEl = function(el) {
	          el.disabled = $picker.isDisabled(el.date);
	        };
	        $datepicker.$selectPane = function(value) {
	          var steps = $picker.steps;
	          var targetDate = new Date(Date.UTC(viewDate.year + (steps.year || 0) * value, viewDate.month + (steps.month || 0) * value, 1));
	          angular.extend(viewDate, {
	            year: targetDate.getUTCFullYear(),
	            month: targetDate.getUTCMonth(),
	            date: targetDate.getUTCDate()
	          });
	          $datepicker.$build();
	        };
	        $datepicker.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $datepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            if (!scope.$mode) {
	              $datepicker.hide(true);
	            } else {
	              scope.$apply(function() {
	                $datepicker.setMode(scope.$mode - 1);
	              });
	            }
	            return;
	          }
	          $picker.onKeyDown(evt);
	          parentScope.$digest();
	        };
	        function updateSelected(el) {
	          el.selected = $datepicker.$isSelected(el.date);
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $datepicker.init;
	        $datepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'date');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $datepicker.destroy;
	        $datepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $datepicker.show;
	        $datepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if (!$datepicker.$isShown) return;
	            $datepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $datepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $datepicker.hide;
	        $datepicker.hide = function(blur) {
	          if (!$datepicker.$isShown) return;
	          $datepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $datepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $datepicker;
	      }
	      DatepickerFactory.defaults = defaults;
	      return DatepickerFactory;
	    } ];
	  }).directive('bsDatepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$datepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $datepicker) {
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'autoclose', 'dateType', 'dateFormat', 'timezone', 'modelDateFormat', 'dayFormat', 'strictFormat', 'startWeek', 'startDate', 'useNative', 'lang', 'startView', 'minView', 'iconLeft', 'iconRight', 'daysOfWeekDisabled', 'id', 'prefixClass', 'prefixEvent', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var datepicker = $datepicker(element, controller, options);
	        options = datepicker.$options;
	        if (isNative && options.useNative) options.dateFormat = 'yyyy-MM-dd';
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!datepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(datepicker),?/i);
	            if (newValue === true) {
	              datepicker.show();
	            } else {
	              datepicker.hide();
	            }
	          });
	        }
	        angular.forEach([ 'minDate', 'maxDate' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              datepicker.$options[key] = dateParser.getDateForAttribute(key, newValue);
	              if (!isNaN(datepicker.$options[key])) datepicker.$build(false);
	              validateAgainstMinMaxDate(controller.$dateValue);
	            });
	          }
	        });
	        if (angular.isDefined(attr.dateFormat)) {
	          attr.$observe('dateFormat', function(newValue) {
	            datepicker.$options.dateFormat = newValue;
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          datepicker.update(controller.$dateValue);
	        }, true);
	        function normalizeDateRanges(ranges) {
	          if (!ranges || !ranges.length) return null;
	          return ranges;
	        }
	        if (angular.isDefined(attr.disabledDates)) {
	          scope.$watch(attr.disabledDates, function(disabledRanges, previousValue) {
	            disabledRanges = normalizeDateRanges(disabledRanges);
	            previousValue = normalizeDateRanges(previousValue);
	            if (disabledRanges) {
	              datepicker.updateDisabledDates(disabledRanges);
	            }
	          });
	        }
	        function validateAgainstMinMaxDate(parsedDate) {
	          if (!angular.isDate(parsedDate)) return;
	          var isMinValid = isNaN(datepicker.$options.minDate) || parsedDate.getTime() >= datepicker.$options.minDate;
	          var isMaxValid = isNaN(datepicker.$options.maxDate) || parsedDate.getTime() <= datepicker.$options.maxDate;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (isValid) controller.$dateValue = parsedDate;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedDate = dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedDate || isNaN(parsedDate.getTime())) {
	            controller.$setValidity('date', false);
	            return;
	          }
	          validateAgainstMinMaxDate(parsedDate);
	          if (options.dateType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedDate, options.timezone, true);
	            return formatDate(date, options.modelDateFormat || options.dateFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.dateType === 'number') {
	            return date.getTime();
	          } else if (options.dateType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.dateType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.dateType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelDateFormat);
	          } else if (options.dateType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getDateFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getDateFormattedString());
	        };
	        function getDateFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.dateFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (datepicker) datepicker.destroy();
	          options = null;
	          datepicker = null;
	        });
	      }
	    };
	  } ]).provider('datepickerViews', function() {
	    function split(arr, size) {
	      var arrays = [];
	      while (arr.length > 0) {
	        arrays.push(arr.splice(0, size));
	      }
	      return arrays;
	    }
	    function mod(n, m) {
	      return (n % m + m) % m;
	    }
	    this.$get = [ '$dateFormatter', '$dateParser', '$sce', function($dateFormatter, $dateParser, $sce) {
	      return function(picker) {
	        var scope = picker.$scope;
	        var options = picker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        var weekDaysMin = $dateFormatter.weekdaysShort(lang);
	        var weekDaysLabels = weekDaysMin.slice(options.startWeek).concat(weekDaysMin.slice(0, options.startWeek));
	        var weekDaysLabelsHtml = $sce.trustAsHtml('<th class="dow text-center">' + weekDaysLabels.join('</th><th class="dow text-center">') + '</th>');
	        var startDate = picker.$date || (options.startDate ? dateParser.getDateForAttribute('startDate', options.startDate) : new Date());
	        var viewDate = {
	          year: startDate.getFullYear(),
	          month: startDate.getMonth(),
	          date: startDate.getDate()
	        };
	        var views = [ {
	          format: options.dayFormat,
	          split: 7,
	          steps: {
	            month: 1
	          },
	          update: function(date, force) {
	            if (!this.built || force || date.getFullYear() !== viewDate.year || date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getDate() !== viewDate.date || date.getDate() === 1) {
	              viewDate.date = picker.$date.getDate();
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstDayOfMonth = new Date(viewDate.year, viewDate.month, 1);
	            var firstDayOfMonthOffset = firstDayOfMonth.getTimezoneOffset();
	            var firstDate = new Date(+firstDayOfMonth - mod(firstDayOfMonth.getDay() - options.startWeek, 7) * 864e5);
	            var firstDateOffset = firstDate.getTimezoneOffset();
	            var today = dateParser.timezoneOffsetAdjust(new Date(), options.timezone).toDateString();
	            if (firstDateOffset !== firstDayOfMonthOffset) firstDate = new Date(+firstDate + (firstDateOffset - firstDayOfMonthOffset) * 6e4);
	            var days = [];
	            var day;
	            for (var i = 0; i < 42; i++) {
	              day = dateParser.daylightSavingAdjust(new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + i));
	              days.push({
	                date: day,
	                isToday: day.toDateString() === today,
	                label: formatDate(day, this.format),
	                selected: picker.$date && this.isSelected(day),
	                muted: day.getMonth() !== viewDate.month,
	                disabled: this.isDisabled(day)
	              });
	            }
	            scope.title = formatDate(firstDayOfMonth, options.monthTitleFormat);
	            scope.showLabels = true;
	            scope.labels = weekDaysLabelsHtml;
	            scope.rows = split(days, this.split);
	            scope.isTodayDisabled = this.isDisabled(new Date());
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth() && date.getDate() === picker.$date.getDate();
	          },
	          isDisabled: function(date) {
	            var time = date.getTime();
	            if (time < options.minDate || time > options.maxDate) return true;
	            if (options.daysOfWeekDisabled.indexOf(date.getDay()) !== -1) return true;
	            if (options.disabledDateRanges) {
	              for (var i = 0; i < options.disabledDateRanges.length; i++) {
	                if (time >= options.disabledDateRanges[i].start && time <= options.disabledDateRanges[i].end) {
	                  return true;
	                }
	              }
	            }
	            return false;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualTime = picker.$date.getTime();
	            var newDate;
	            if (evt.keyCode === 37) newDate = new Date(actualTime - 1 * 864e5); else if (evt.keyCode === 38) newDate = new Date(actualTime - 7 * 864e5); else if (evt.keyCode === 39) newDate = new Date(actualTime + 1 * 864e5); else if (evt.keyCode === 40) newDate = new Date(actualTime + 7 * 864e5);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'month',
	          format: options.monthFormat,
	          split: 4,
	          steps: {
	            year: 1
	          },
	          update: function(date, force) {
	            if (!this.built || date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var months = [];
	            var month;
	            for (var i = 0; i < 12; i++) {
	              month = new Date(viewDate.year, i, 1);
	              months.push({
	                date: month,
	                label: formatDate(month, this.format),
	                selected: picker.$isSelected(month),
	                disabled: this.isDisabled(month)
	              });
	            }
	            scope.title = formatDate(month, options.yearTitleFormat);
	            scope.showLabels = false;
	            scope.rows = split(months, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear(), date.getMonth() + 1, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualMonth = picker.$date.getMonth();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setMonth(actualMonth - 1); else if (evt.keyCode === 38) newDate.setMonth(actualMonth - 4); else if (evt.keyCode === 39) newDate.setMonth(actualMonth + 1); else if (evt.keyCode === 40) newDate.setMonth(actualMonth + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'year',
	          format: options.yearFormat,
	          split: 4,
	          steps: {
	            year: 12
	          },
	          update: function(date, force) {
	            if (!this.built || force || parseInt(date.getFullYear() / 20, 10) !== parseInt(viewDate.year / 20, 10)) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstYear = viewDate.year - viewDate.year % (this.split * 3);
	            var years = [];
	            var year;
	            for (var i = 0; i < 12; i++) {
	              year = new Date(firstYear + i, 0, 1);
	              years.push({
	                date: year,
	                label: formatDate(year, this.format),
	                selected: picker.$isSelected(year),
	                disabled: this.isDisabled(year)
	              });
	            }
	            scope.title = years[0].label + '-' + years[years.length - 1].label;
	            scope.showLabels = false;
	            scope.rows = split(years, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear() + 1, 0, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualYear = picker.$date.getFullYear();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setYear(actualYear - 1); else if (evt.keyCode === 38) newDate.setYear(actualYear - 4); else if (evt.keyCode === 39) newDate.setYear(actualYear + 1); else if (evt.keyCode === 40) newDate.setYear(actualYear + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        } ];
	        return {
	          views: options.minView ? Array.prototype.slice.call(views, options.minView) : views,
	          viewDate: viewDate
	        };
	      };
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.collapse', []).provider('$collapse', function() {
	    var defaults = this.defaults = {
	      animation: 'am-collapse',
	      disallowToggle: false,
	      activeClass: 'in',
	      startCollapsed: false,
	      allowMultiple: false
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'disallowToggle', 'activeClass', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      var falseValueRegExp = /^(false|0|)$/i;
	      angular.forEach([ 'disallowToggle', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key]) && falseValueRegExp.test($attrs[key])) {
	          self.$options[key] = false;
	        }
	      });
	      self.$toggles = [];
	      self.$targets = [];
	      self.$viewChangeListeners = [];
	      self.$registerToggle = function(element) {
	        self.$toggles.push(element);
	      };
	      self.$registerTarget = function(element) {
	        self.$targets.push(element);
	      };
	      self.$unregisterToggle = function(element) {
	        var index = self.$toggles.indexOf(element);
	        self.$toggles.splice(index, 1);
	      };
	      self.$unregisterTarget = function(element) {
	        var index = self.$targets.indexOf(element);
	        self.$targets.splice(index, 1);
	        if (self.$options.allowMultiple) {
	          deactivateItem(element);
	        }
	        fixActiveItemIndexes(index);
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$targets.$active = !self.$options.startCollapsed ? [ 0 ] : [];
	      self.$setActive = $scope.$setActive = function(value) {
	        if (angular.isArray(value)) {
	          self.$targets.$active = value;
	        } else if (!self.$options.disallowToggle && isActive(value)) {
	          deactivateItem(value);
	        } else {
	          activateItem(value);
	        }
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$activeIndexes = function() {
	        if (self.$options.allowMultiple) {
	          return self.$targets.$active;
	        }
	        return self.$targets.$active.length === 1 ? self.$targets.$active[0] : -1;
	      };
	      function fixActiveItemIndexes(index) {
	        var activeIndexes = self.$targets.$active;
	        for (var i = 0; i < activeIndexes.length; i++) {
	          if (index < activeIndexes[i]) {
	            activeIndexes[i] = activeIndexes[i] - 1;
	          }
	          if (activeIndexes[i] === self.$targets.length) {
	            activeIndexes[i] = self.$targets.length - 1;
	          }
	        }
	      }
	      function isActive(value) {
	        var activeItems = self.$targets.$active;
	        return activeItems.indexOf(value) !== -1;
	      }
	      function deactivateItem(value) {
	        var index = self.$targets.$active.indexOf(value);
	        if (index !== -1) {
	          self.$targets.$active.splice(index, 1);
	        }
	      }
	      function activateItem(value) {
	        if (!self.$options.allowMultiple) {
	          self.$targets.$active.splice(0, 1);
	        }
	        if (self.$targets.$active.indexOf(value) === -1) {
	          self.$targets.$active.push(value);
	        }
	      }
	    };
	    this.$get = function() {
	      var $collapse = {};
	      $collapse.defaults = defaults;
	      $collapse.controller = controller;
	      return $collapse;
	    };
	  }).directive('bsCollapse', [ '$window', '$animate', '$collapse', function($window, $animate, $collapse) {
	    return {
	      require: [ '?ngModel', 'bsCollapse' ],
	      controller: [ '$scope', '$element', '$attrs', $collapse.controller ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsCollapseCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsCollapseCtrl.$viewChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsCollapseCtrl.$activeIndexes());
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            if (angular.isArray(modelValue)) {
	              bsCollapseCtrl.$setActive(modelValue);
	            } else {
	              var activeIndexes = bsCollapseCtrl.$activeIndexes();
	              if (angular.isArray(activeIndexes)) {
	                if (activeIndexes.indexOf(modelValue * 1) === -1) {
	                  bsCollapseCtrl.$setActive(modelValue * 1);
	                }
	              } else if (activeIndexes !== modelValue * 1) {
	                bsCollapseCtrl.$setActive(modelValue * 1);
	              }
	            }
	            return modelValue;
	          });
	        }
	      }
	    };
	  } ]).directive('bsCollapseToggle', function() {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.attr('data-toggle', 'collapse');
	        bsCollapseCtrl.$registerToggle(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterToggle(element);
	        });
	        element.on('click', function() {
	          if (!attrs.disabled) {
	            var index = attrs.bsCollapseToggle && attrs.bsCollapseToggle !== 'bs-collapse-toggle' ? attrs.bsCollapseToggle : bsCollapseCtrl.$toggles.indexOf(element);
	            bsCollapseCtrl.$setActive(index * 1);
	            scope.$apply();
	          }
	        });
	      }
	    };
	  }).directive('bsCollapseTarget', [ '$animate', function($animate) {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.addClass('collapse');
	        if (bsCollapseCtrl.$options.animation) {
	          element.addClass(bsCollapseCtrl.$options.animation);
	        }
	        bsCollapseCtrl.$registerTarget(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterTarget(element);
	        });
	        function render() {
	          var index = bsCollapseCtrl.$targets.indexOf(element);
	          var active = bsCollapseCtrl.$activeIndexes();
	          var action = 'removeClass';
	          if (angular.isArray(active)) {
	            if (active.indexOf(index) !== -1) {
	              action = 'addClass';
	            }
	          } else if (index === active) {
	            action = 'addClass';
	          }
	          $animate[action](element, bsCollapseCtrl.$options.activeClass);
	        }
	        bsCollapseCtrl.$viewChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.aside', [ 'mgcrea.ngStrap.modal' ]).provider('$aside', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade-and-slide-right',
	      prefixClass: 'aside',
	      prefixEvent: 'aside',
	      placement: 'right',
	      templateUrl: 'aside/aside.tpl.html',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true
	    };
	    this.$get = [ '$modal', function($modal) {
	      function AsideFactory(config) {
	        var $aside = {};
	        var options = angular.extend({}, defaults, config);
	        $aside = $modal(options);
	        return $aside;
	      }
	      return AsideFactory;
	    } ];
	  }).directive('bsAside', [ '$window', '$sce', '$aside', function($window, $sce, $aside) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAside) {
	          scope.$watch(attr.bsAside, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var aside = $aside(options);
	        element.on(attr.trigger || 'click', aside.toggle);
	        scope.$on('$destroy', function() {
	          if (aside) aside.destroy();
	          options = null;
	          aside = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.alert', [ 'mgcrea.ngStrap.modal' ]).provider('$alert', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'alert',
	      prefixEvent: 'alert',
	      placement: null,
	      templateUrl: 'alert/alert.tpl.html',
	      container: false,
	      element: null,
	      backdrop: false,
	      keyboard: true,
	      show: true,
	      duration: false,
	      type: false,
	      dismissable: true
	    };
	    this.$get = [ '$modal', '$timeout', function($modal, $timeout) {
	      function AlertFactory(config) {
	        var $alert = {};
	        var options = angular.extend({}, defaults, config);
	        $alert = $modal(options);
	        $alert.$scope.dismissable = !!options.dismissable;
	        if (options.type) {
	          $alert.$scope.type = options.type;
	        }
	        var show = $alert.show;
	        if (options.duration) {
	          $alert.show = function() {
	            show();
	            $timeout(function() {
	              $alert.hide();
	            }, options.duration * 1e3);
	          };
	        }
	        return $alert;
	      }
	      return AlertFactory;
	    } ];
	  }).directive('bsAlert', [ '$window', '$sce', '$alert', function($window, $sce, $alert) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'keyboard', 'html', 'container', 'animation', 'duration', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'keyboard', 'html', 'container', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        angular.forEach([ 'title', 'content', 'type' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAlert) {
	          scope.$watch(attr.bsAlert, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var alert = $alert(options);
	        element.on(attr.trigger || 'click', alert.toggle);
	        scope.$on('$destroy', function() {
	          if (alert) alert.destroy();
	          options = null;
	          alert = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.affix', [ 'mgcrea.ngStrap.helpers.dimensions', 'mgcrea.ngStrap.helpers.debounce' ]).provider('$affix', function() {
	    var defaults = this.defaults = {
	      offsetTop: 'auto',
	      inlineStyles: true,
	      setWidth: true
	    };
	    this.$get = [ '$window', 'debounce', 'dimensions', function($window, debounce, dimensions) {
	      var bodyEl = angular.element($window.document.body);
	      var windowEl = angular.element($window);
	      function AffixFactory(element, config) {
	        var $affix = {};
	        var options = angular.extend({}, defaults, config);
	        var targetEl = options.target;
	        var reset = 'affix affix-top affix-bottom';
	        var setWidth = false;
	        var initialAffixTop = 0;
	        var initialOffsetTop = 0;
	        var offsetTop = 0;
	        var offsetBottom = 0;
	        var affixed = null;
	        var unpin = null;
	        var parent = element.parent();
	        if (options.offsetParent) {
	          if (options.offsetParent.match(/^\d+$/)) {
	            for (var i = 0; i < options.offsetParent * 1 - 1; i++) {
	              parent = parent.parent();
	            }
	          } else {
	            parent = angular.element(options.offsetParent);
	          }
	        }
	        $affix.init = function() {
	          this.$parseOffsets();
	          initialOffsetTop = dimensions.offset(element[0]).top + initialAffixTop;
	          setWidth = options.setWidth && !element[0].style.width;
	          targetEl.on('scroll', this.checkPosition);
	          targetEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', this.$debouncedOnResize);
	          this.checkPosition();
	          this.checkPositionWithEventLoop();
	        };
	        $affix.destroy = function() {
	          targetEl.off('scroll', this.checkPosition);
	          targetEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', this.$debouncedOnResize);
	        };
	        $affix.checkPositionWithEventLoop = function() {
	          setTimeout($affix.checkPosition, 1);
	        };
	        $affix.checkPosition = function() {
	          var scrollTop = getScrollTop();
	          var position = dimensions.offset(element[0]);
	          var elementHeight = dimensions.height(element[0]);
	          var affix = getRequiredAffixClass(unpin, position, elementHeight);
	          if (affixed === affix) return;
	          affixed = affix;
	          if (affix === 'top') {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', '');
	            }
	          } else if (affix === 'bottom') {
	            if (options.offsetUnpin) {
	              unpin = -(options.offsetUnpin * 1);
	            } else {
	              unpin = position.top - scrollTop;
	            }
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', options.offsetParent ? '' : bodyEl[0].offsetHeight - offsetBottom - elementHeight - initialOffsetTop + 'px');
	            }
	          } else {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', element[0].offsetWidth + 'px');
	            }
	            if (options.inlineStyles) {
	              element.css('position', 'fixed');
	              element.css('top', initialAffixTop + 'px');
	            }
	          }
	          element.removeClass(reset).addClass('affix' + (affix !== 'middle' ? '-' + affix : ''));
	        };
	        $affix.$onResize = function() {
	          $affix.$parseOffsets();
	          $affix.checkPosition();
	        };
	        $affix.$debouncedOnResize = debounce($affix.$onResize, 50);
	        $affix.$parseOffsets = function() {
	          var initialPosition = element[0].style.position;
	          var initialTop = element[0].style.top;
	          if (options.inlineStyles) {
	            element.css('position', options.offsetParent ? '' : 'relative');
	            element.css('top', '');
	          }
	          if (options.offsetTop) {
	            if (options.offsetTop === 'auto') {
	              options.offsetTop = '+0';
	            }
	            if (options.offsetTop.match(/^[-+]\d+$/)) {
	              initialAffixTop = -options.offsetTop * 1;
	              if (options.offsetParent) {
	                offsetTop = dimensions.offset(parent[0]).top + options.offsetTop * 1;
	              } else {
	                offsetTop = dimensions.offset(element[0]).top - dimensions.css(element[0], 'marginTop', true) + options.offsetTop * 1;
	              }
	            } else {
	              offsetTop = options.offsetTop * 1;
	            }
	          }
	          if (options.offsetBottom) {
	            if (options.offsetParent && options.offsetBottom.match(/^[-+]\d+$/)) {
	              offsetBottom = getScrollHeight() - (dimensions.offset(parent[0]).top + dimensions.height(parent[0])) + options.offsetBottom * 1 + 1;
	            } else {
	              offsetBottom = options.offsetBottom * 1;
	            }
	          }
	          if (options.inlineStyles) {
	            element.css('position', initialPosition);
	            element.css('top', initialTop);
	          }
	        };
	        function getRequiredAffixClass(_unpin, position, elementHeight) {
	          var scrollTop = getScrollTop();
	          var scrollHeight = getScrollHeight();
	          if (scrollTop <= offsetTop) {
	            return 'top';
	          } else if (_unpin !== null) {
	            return scrollTop + _unpin <= position.top ? 'middle' : 'bottom';
	          } else if (offsetBottom !== null && position.top + elementHeight + initialAffixTop >= scrollHeight - offsetBottom) {
	            return 'bottom';
	          }
	          return 'middle';
	        }
	        function getScrollTop() {
	          return targetEl[0] === $window ? $window.pageYOffset : targetEl[0].scrollTop;
	        }
	        function getScrollHeight() {
	          return targetEl[0] === $window ? $window.document.body.scrollHeight : targetEl[0].scrollHeight;
	        }
	        $affix.init();
	        return $affix;
	      }
	      return AffixFactory;
	    } ];
	  }).directive('bsAffix', [ '$affix', '$window', '$timeout', function($affix, $window, $timeout) {
	    return {
	      restrict: 'EAC',
	      require: '^?bsAffixTarget',
	      link: function postLink(scope, element, attr, affixTarget) {
	        var options = {
	          scope: scope,
	          target: affixTarget ? affixTarget.$element : angular.element($window)
	        };
	        angular.forEach([ 'offsetTop', 'offsetBottom', 'offsetParent', 'offsetUnpin', 'inlineStyles', 'setWidth' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            var option = attr[key];
	            if (/true/i.test(option)) option = true;
	            if (/false/i.test(option)) option = false;
	            options[key] = option;
	          }
	        });
	        var affix;
	        $timeout(function() {
	          affix = $affix(element, options);
	        });
	        scope.$on('$destroy', function() {
	          if (affix) affix.destroy();
	          options = null;
	          affix = null;
	        });
	      }
	    };
	  } ]).directive('bsAffixTarget', function() {
	    return {
	      controller: [ '$element', function($element) {
	        this.$element = $element;
	      } ]
	    };
	  });
	  angular.module('mgcrea.ngStrap', [ 'mgcrea.ngStrap.modal', 'mgcrea.ngStrap.aside', 'mgcrea.ngStrap.alert', 'mgcrea.ngStrap.button', 'mgcrea.ngStrap.select', 'mgcrea.ngStrap.datepicker', 'mgcrea.ngStrap.timepicker', 'mgcrea.ngStrap.navbar', 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.popover', 'mgcrea.ngStrap.dropdown', 'mgcrea.ngStrap.typeahead', 'mgcrea.ngStrap.scrollspy', 'mgcrea.ngStrap.affix', 'mgcrea.ngStrap.tab', 'mgcrea.ngStrap.collapse' ]);
	})(window, document);

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	!function(t,e,n){'use strict';angular.module('mgcrea.ngStrap.alert').run(['$templateCache',function(t){t.put('alert/alert.tpl.html','<div class="alert" ng-class="[type ? \'alert-\' + type : null]"><button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button> <span ng-if="title"><strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span> </span><span ng-if="!title" ng-bind-html="content"></span></div>')}]),angular.module('mgcrea.ngStrap.aside').run(['$templateCache',function(t){t.put('aside/aside.tpl.html','<div class="aside" tabindex="-1" role="dialog"><div class="aside-dialog"><div class="aside-content"><div class="aside-header" ng-show="title"><button type="button" class="close" ng-click="$hide()">&times;</button><h4 class="aside-title" ng-bind="title"></h4></div><div class="aside-body" ng-bind="content"></div><div class="aside-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.datepicker').run(['$templateCache',function(t){t.put('datepicker/datepicker.tpl.html','<div class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px"><table style="table-layout: fixed; height: 100%; width: 100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)"><i class="{{$iconLeft}}"></i></button></th><th colspan="{{ rows[0].length - 2 }}"><button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()"><strong style="text-transform: capitalize" ng-bind="title"></strong></button></th><th><button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)"><i class="{{$iconRight}}"></i></button></th></tr><tr ng-if="showLabels" ng-bind-html="labels"></tr></thead><tbody><tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%"><td class="text-center" ng-repeat="(j, el) in row"><button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date, el.disabled)" ng-disabled="el.disabled"><span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span></button></td></tr></tbody><tfoot><tr><td colspan="{{ rows[0].length }}"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group" ng-if="$hasToday"><button type="button" class="btn btn-default today" ng-click="$setToday()" ng-disabled="isTodayDisabled"><strong style="text-transform: capitalize">Today</strong></button></div><div class="btn-group" role="group" ng-if="$hasClear"><button type="button" class="btn btn-default clear" ng-click="$clear()"><strong style="text-transform: capitalize">Clear</strong></button></div></div></td></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.dropdown').run(['$templateCache',function(t){t.put('dropdown/dropdown.tpl.html','<ul tabindex="-1" class="dropdown-menu" role="menu" ng-show="content && content.length"><li role="presentation" ng-class="{divider: item.divider, active: item.active}" ng-repeat="item in content"><a role="menuitem" tabindex="-1" ng-href="{{item.href}}" ng-if="!item.divider && item.href" target="{{item.target || \'\'}}" ng-bind="item.text"></a> <a role="menuitem" tabindex="-1" href="javascript:void(0)" ng-if="!item.divider && item.click" ng-click="$eval(item.click);$hide()" ng-bind="item.text"></a></li></ul>')}]),angular.module('mgcrea.ngStrap.modal').run(['$templateCache',function(t){t.put('modal/modal.tpl.html','<div class="modal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header" ng-show="title"><button type="button" class="close" aria-label="Close" ng-click="$hide()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" ng-bind="title"></h4></div><div class="modal-body" ng-bind="content"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.popover').run(['$templateCache',function(t){t.put('popover/popover.tpl.html','<div class="popover" tabindex="-1"><div class="arrow"></div><h3 class="popover-title" ng-bind="title" ng-show="title"></h3><div class="popover-content" ng-bind="content"></div></div>')}]),angular.module('mgcrea.ngStrap.select').run(['$templateCache',function(t){t.put('select/select.tpl.html','<ul tabindex="-1" class="select dropdown-menu" ng-show="$isVisible()" role="select"><li ng-if="$showAllNoneButtons"><div class="btn-group" style="margin-bottom: 5px; margin-left: 5px"><button type="button" class="btn btn-default btn-xs" ng-click="$selectAll()">{{$allText}}</button> <button type="button" class="btn btn-default btn-xs" ng-click="$selectNone()">{{$noneText}}</button></div></li><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $isActive($index)}"><a style="cursor: default" role="menuitem" tabindex="-1" ng-click="$select($index, $event)"><i class="{{$iconCheckmark}} pull-right" ng-if="$isMultiple && $isActive($index)"></i> <span ng-bind="match.label"></span></a></li></ul>')}]),angular.module('mgcrea.ngStrap.tab').run(['$templateCache',function(t){t.put('tab/tab.tpl.html','<ul class="nav" ng-class="$navClass" role="tablist"><li role="presentation" ng-repeat="$pane in $panes track by $index" ng-class="[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' ]"><a role="tab" data-toggle="tab" ng-click="!$pane.disabled && $setActive($pane.name || $index)" data-index="{{ $index }}" ng-bind-html="$pane.title" aria-controls="$pane.title" href=""></a></li></ul><div ng-transclude class="tab-content"></div>')}]),angular.module('mgcrea.ngStrap.timepicker').run(['$templateCache',function(t){t.put('timepicker/timepicker.tpl.html','<div class="dropdown-menu timepicker" style="min-width: 0px;width: auto"><table height="100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 0)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 1)"><i class="{{ $iconUp }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 2)"><i class="{{ $iconUp }}"></i></button></th></tr></thead><tbody><tr ng-repeat="(i, row) in rows"><td class="text-center"><button tabindex="-1" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[0].selected}" ng-click="$select(row[0].date, 0)" ng-disabled="row[0].disabled"><span ng-class="{\'text-muted\': row[0].muted}" ng-bind="row[0].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="row[1].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[1].selected}" ng-click="$select(row[1].date, 1)" ng-disabled="row[1].disabled"><span ng-class="{\'text-muted\': row[1].muted}" ng-bind="row[1].label"></span></button></td><td ng-if="showSeconds"><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td ng-if="showSeconds" class="text-center"><button tabindex="-1" ng-if="row[2].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[2].selected}" ng-click="$select(row[2].date, 2)" ng-disabled="row[2].disabled"><span ng-class="{\'text-muted\': row[2].muted}" ng-bind="row[2].label"></span></button></td><td ng-if="showAM">&nbsp;</td><td ng-if="showAM"><button tabindex="-1" ng-show="i == midIndex - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !!isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">AM</button> <button tabindex="-1" ng-show="i == midIndex + 1 - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">PM</button></td></tr></tbody><tfoot><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 0)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 1)"><i class="{{ $iconDown }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 2)"><i class="{{ $iconDown }}"></i></button></th></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.tooltip').run(['$templateCache',function(t){t.put('tooltip/tooltip.tpl.html','<div class="tooltip in" ng-show="title"><div class="tooltip-arrow"></div><div class="tooltip-inner" ng-bind="title"></div></div>')}]),angular.module('mgcrea.ngStrap.typeahead').run(['$templateCache',function(t){t.put('typeahead/typeahead.tpl.html','<ul tabindex="-1" class="typeahead dropdown-menu" ng-show="$isVisible()" role="select"><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $index == $activeIndex}"><a role="menuitem" tabindex="-1" ng-click="$select($index, $event)" ng-bind="match.label"></a></li></ul>')}])}(window,document);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(451);
	__webpack_require__(452);
	module.exports = 'mgcrea.ngStrap';


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, humanizeDuration) {/**
	 * angular-timer - v1.3.5 - 2017-03-09 2:18 PM
	 * https://github.com/siddii/angular-timer
	 *
	 * Copyright (c) 2017 Adrian Wardell
	 * Licensed MIT <https://github.com/siddii/angular-timer/blob/master/LICENSE.txt>
	 */
	var timerModule = angular.module('timer', [])
	  .directive('timer', ['$compile', function ($compile) {
	    return  {
	      restrict: 'EA',
	      replace: false,
	      scope: {
	        interval: '=interval',
	        startTimeAttr: '=startTime',
	        endTimeAttr: '=endTime',
	        countdownattr: '=countdown',
	        finishCallback: '&finishCallback',
	        autoStart: '&autoStart',
	        language: '@?',
	        fallback: '@?',
	        maxTimeUnit: '=',
	        seconds: '=?',
	        minutes: '=?',
	        hours: '=?',
	        days: '=?',
	        months: '=?',
	        years: '=?',
	        secondsS: '=?',
	        minutesS: '=?',
	        hoursS: '=?',
	        daysS: '=?',
	        monthsS: '=?',
	        yearsS: '=?'
	      },
	      controller: ['$scope', '$element', '$attrs', '$timeout', 'I18nService', '$interpolate', 'progressBarService', function ($scope, $element, $attrs, $timeout, I18nService, $interpolate, progressBarService) {
	
	        // Checking for trim function since IE8 doesn't have it
	        // If not a function, create tirm with RegEx to mimic native trim
	        if (typeof String.prototype.trim !== 'function') {
	          String.prototype.trim = function () {
	            return this.replace(/^\s+|\s+$/g, '');
	          };
	        }
	
	        //angular 1.2 doesn't support attributes ending in "-start", so we're
	        //supporting both "autostart" and "auto-start" as a solution for
	        //backward and forward compatibility.
	        $scope.autoStart = $attrs.autoStart || $attrs.autostart;
	
	
	        $scope.language = $scope.language || 'en';
	        $scope.fallback = $scope.fallback || 'en';
	
	        //allow to change the language of the directive while already launched
	        $scope.$watch('language', function(newVal, oldVal) {
	          if(newVal !== undefined) {
	            i18nService.init(newVal, $scope.fallback);
	          }
	        });
	
	        //init momentJS i18n, default english
	        var i18nService = new I18nService();
	        i18nService.init($scope.language, $scope.fallback);
	
	        //progress bar
	        $scope.displayProgressBar = 0;
	        $scope.displayProgressActive = 'active'; //Bootstrap active effect for progress bar
	
	        if ($element.html().trim().length === 0) {
	          $element.append($compile('<span>' + $interpolate.startSymbol() + 'millis' + $interpolate.endSymbol() + '</span>')($scope));
	        } else {
	          $element.append($compile($element.contents())($scope));
	        }
	
	        $scope.startTime = null;
	        $scope.endTime = null;
	        $scope.timeoutId = null;
	        $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) >= 0 ? parseInt($scope.countdownattr, 10) : undefined;
	        $scope.isRunning = false;
	
	        $scope.$on('timer-start', function () {
	          $scope.start();
	        });
	
	        $scope.$on('timer-resume', function () {
	          $scope.resume();
	        });
	
	        $scope.$on('timer-stop', function () {
	          $scope.stop();
	        });
	
	        $scope.$on('timer-clear', function () {
	          $scope.clear();
	        });
	
	        $scope.$on('timer-reset', function () {
	          $scope.reset();
	        });
	
	        $scope.$on('timer-set-countdown', function (e, countdown) {
	          $scope.countdown = countdown;
	        });
	
	        function resetTimeout() {
	          if ($scope.timeoutId) {
	            clearTimeout($scope.timeoutId);
	          }
	        }
	
	        $scope.$watch('startTimeAttr', function(newValue, oldValue) {
	          if (newValue !== oldValue && $scope.isRunning) {
	            $scope.start();
	          }
	        });
	
	        $scope.$watch('endTimeAttr', function(newValue, oldValue) {
	          if (newValue !== oldValue && $scope.isRunning) {
	            $scope.start();
	          }
	        });
	
	        $scope.start = function () {
	          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
	          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
	          if (!angular.isNumber($scope.countdown)) {
	            $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
	          }
	          resetTimeout();
	          tick();
	          $scope.isRunning = true;
	          $scope.$emit('timer-started', {
	            timeoutId: $scope.timeoutId,
	            millis: $scope.millis,
	            seconds: $scope.seconds,
	            minutes: $scope.minutes,
	            hours: $scope.hours,
	            days: $scope.days
	          });
	        };
	
	        $scope.resume = function () {
	          resetTimeout();
	          if ($scope.countdownattr) {
	            $scope.countdown += 1;
	          }
	          $scope.startTime = moment().diff((moment($scope.stoppedTime).diff(moment($scope.startTime))));
	          tick();
	          $scope.isRunning = true;
	          $scope.$emit('timer-started', {
	            timeoutId: $scope.timeoutId,
	            millis: $scope.millis,
	            seconds: $scope.seconds,
	            minutes: $scope.minutes,
	            hours: $scope.hours,
	            days: $scope.days
	          });
	        };
	
	        $scope.stop = $scope.pause = function () {
	          var timeoutId = $scope.timeoutId;
	          $scope.clear();
	          $scope.$emit('timer-stopped', {
	            timeoutId: timeoutId,
	            millis: $scope.millis,
	            seconds: $scope.seconds,
	            minutes: $scope.minutes,
	            hours: $scope.hours,
	            days: $scope.days
	          });
	        };
	
	        $scope.clear = function () {
	          // same as stop but without the event being triggered
	          $scope.stoppedTime = moment();
	          resetTimeout();
	          $scope.timeoutId = null;
	          $scope.isRunning = false;
	        };
	
	        $scope.reset = function () {
	          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
	          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
	          $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
	          resetTimeout();
	          tick();
	          $scope.isRunning = false;
	          $scope.clear();
	          $scope.$emit('timer-reset', {
	            timeoutId: timeoutId,
	            millis: $scope.millis,
	            seconds: $scope.seconds,
	            minutes: $scope.minutes,
	            hours: $scope.hours,
	            days: $scope.days
	          });
	        };
	
	        $element.bind('$destroy', function () {
	          resetTimeout();
	          $scope.isRunning = false;
	        });
	
	
	        function calculateTimeUnits() {
	          var timeUnits = {}; //will contains time with units
	
	          if ($attrs.startTime !== undefined){
	            $scope.millis = moment().diff(moment($scope.startTimeAttr));
	          }
	
	          timeUnits = i18nService.getTimeUnits($scope.millis);
	
	          // compute time values based on maxTimeUnit specification
	          if (!$scope.maxTimeUnit || $scope.maxTimeUnit === 'day') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24));
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'second') {
	            $scope.seconds = Math.floor($scope.millis / 1000);
	            $scope.minutes = 0;
	            $scope.hours = 0;
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'minute') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor($scope.millis / 60000);
	            $scope.hours = 0;
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'hour') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor($scope.millis / 3600000);
	            $scope.days = 0;
	            $scope.months = 0;
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'month') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
	            $scope.months = Math.floor((($scope.millis / (3600000)) / 24) / 30);
	            $scope.years = 0;
	          } else if ($scope.maxTimeUnit === 'year') {
	            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
	            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
	            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
	            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
	            $scope.months = Math.floor((($scope.millis / (3600000)) / 24 / 30) % 12);
	            $scope.years = Math.floor(($scope.millis / (3600000)) / 24 / 365);
	          }
	          // plural - singular unit decision (old syntax, for backwards compatibility and English only, could be deprecated!)
	          $scope.secondsS = ($scope.seconds === 1) ? '' : 's';
	          $scope.minutesS = ($scope.minutes === 1) ? '' : 's';
	          $scope.hoursS = ($scope.hours === 1) ? '' : 's';
	          $scope.daysS = ($scope.days === 1)? '' : 's';
	          $scope.monthsS = ($scope.months === 1)? '' : 's';
	          $scope.yearsS = ($scope.years === 1)? '' : 's';
	
	
	          // new plural-singular unit decision functions (for custom units and multilingual support)
	          $scope.secondUnit = timeUnits.seconds;
	          $scope.minuteUnit = timeUnits.minutes;
	          $scope.hourUnit = timeUnits.hours;
	          $scope.dayUnit = timeUnits.days;
	          $scope.monthUnit = timeUnits.months;
	          $scope.yearUnit = timeUnits.years;
	
	          //add leading zero if number is smaller than 10
	          $scope.sseconds = $scope.seconds < 10 ? '0' + $scope.seconds : $scope.seconds;
	          $scope.mminutes = $scope.minutes < 10 ? '0' + $scope.minutes : $scope.minutes;
	          $scope.hhours = $scope.hours < 10 ? '0' + $scope.hours : $scope.hours;
	          $scope.ddays = $scope.days < 10 ? '0' + $scope.days : $scope.days;
	          $scope.mmonths = $scope.months < 10 ? '0' + $scope.months : $scope.months;
	          $scope.yyears = $scope.years < 10 ? '0' + $scope.years : $scope.years;
	
	        }
	
	        //determine initial values of time units and add AddSeconds functionality
	        if ($scope.countdownattr) {
	          $scope.millis = $scope.countdownattr * 1000;
	
	          $scope.addCDSeconds = function (extraSeconds) {
	            $scope.countdown += extraSeconds;
	            if (!$scope.isRunning) {
	              $scope.start();
	            }
	          };
	
	          $scope.$on('timer-add-cd-seconds', function (e, extraSeconds) {
	             $scope.addCDSeconds(extraSeconds);
	          });
	
	          $scope.$on('timer-set-countdown-seconds', function (e, countdownSeconds) {
	            if (!$scope.isRunning) {
	              $scope.clear();
	            }
	
	            $scope.countdown = countdownSeconds;
	            $scope.millis = countdownSeconds * 1000;
	            calculateTimeUnits();
	          });
	        } else {
	          $scope.millis = 0;
	        }
	        calculateTimeUnits();
	
	        var tick = function tick() {
	          var typeTimer = null; // countdown or endTimeAttr
	          $scope.millis = moment().diff($scope.startTime);
	          var adjustment = $scope.millis % 1000;
	
	          if ($scope.endTimeAttr) {
	            typeTimer = $scope.endTimeAttr;
	            $scope.millis = moment($scope.endTime).diff(moment());
	            adjustment = $scope.interval - $scope.millis % 1000;
	          }
	
	          if ($scope.countdownattr) {
	            typeTimer = $scope.countdownattr;
	            $scope.millis = $scope.countdown * 1000;
	          }
	
	          if ($scope.millis < 0) {
	            $scope.stop();
	            $scope.millis = 0;
	            calculateTimeUnits();
	            if($scope.finishCallback) {
	              $scope.$eval($scope.finishCallback);
	            }
	            return;
	          }
	          calculateTimeUnits();
	
	          //We are not using $timeout for a reason. Please read here - https://github.com/siddii/angular-timer/pull/5
	          $scope.timeoutId = setTimeout(function () {
	              tick();
	              // since you choose not to use $timeout, at least preserve angular cycle two way data binding
	              // by calling $scope.$apply() instead of $scope.$digest()
	              $scope.$apply();
	          }, $scope.interval - adjustment);
	
	          $scope.$emit('timer-tick', {
	            timeoutId: $scope.timeoutId,
	            millis: $scope.millis,
	            seconds: $scope.seconds,
	            minutes: $scope.minutes,
	            hours: $scope.hours,
	            days: $scope.days
	          });
	
	          if ($scope.countdown > 0) {
	            $scope.countdown--;
	          }
	          else if ($scope.countdown <= 0) {
	            $scope.stop();
	            if($scope.finishCallback) {
	              $scope.$eval($scope.finishCallback);
	            }
	          }
	
	          if(typeTimer !== null){
	            //calculate progress bar
	            $scope.progressBar = progressBarService.calculateProgressBar($scope.startTime, $scope.millis, $scope.endTime, $scope.countdownattr);
	
	            if($scope.progressBar === 100){
	              $scope.displayProgressActive = ''; //No more Bootstrap active effect
	            }
	          }
	        };
	
	        if ($scope.autoStart === undefined || $scope.autoStart === true) {
	          $scope.start();
	        }
	      }]
	    };
	  }])
	  .directive('timerControls', function() {
	    return {
	      restrict: 'EA',
	      scope: true,
	      controller: ['$scope', function($scope) {
	        $scope.timerStatus = "reset";
	        $scope.$on('timer-started', function() {
	          $scope.timerStatus = "started";
	        });
	        $scope.$on('timer-stopped', function() {
	          $scope.timerStatus = "stopped";
	        });
	        $scope.$on('timer-reset', function() {
	          $scope.timerStatus = "reset";
	        });
	        $scope.timerStart = function() {
	          $scope.$broadcast('timer-start');
	        };
	        $scope.timerStop = function() {
	          $scope.$broadcast('timer-stop');
	        };
	        $scope.timerResume = function() {
	          $scope.$broadcast('timer-resume');
	        };
	        $scope.timerToggle = function() {
	          switch ($scope.timerStatus) {
	            case "started":
	              $scope.timerStop();
	              break;
	            case "stopped":
	              $scope.timerResume();
	              break;
	            case "reset":
	              $scope.timerStart();
	              break;
	          }
	        };
	        $scope.timerAddCDSeconds = function(extraSeconds) {
	          $scope.$broadcast('timer-add-cd-seconds', extraSeconds);
	        };
	      }]
	    };
	  });
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = timerModule;
	}
	
	var app = angular.module('timer');
	
	app.factory('I18nService', function() {
	
	    var I18nService = function() {};
	
	    I18nService.prototype.language = 'en';
	    I18nService.prototype.fallback = 'en';
	    I18nService.prototype.timeHumanizer = {};
	
	    I18nService.prototype.init = function init(lang, fallback) {
	        var supported_languages = humanizeDuration.getSupportedLanguages();
	
	        this.fallback = (fallback !== undefined) ? fallback : 'en';
	        if (supported_languages.indexOf(fallback) === -1) {
	            this.fallback = 'en';
	        }
	
	        this.language = lang;
	        if (supported_languages.indexOf(lang) === -1) {
	            this.language = this.fallback;
	        }
	
	        // It should be handle by the user's application itself, and not inside the directive
	        // moment init
	        // moment.locale(this.language);
	
	        //human duration init, using it because momentjs does not allow accurate time (
	        // momentJS: a few moment ago, human duration : 4 seconds ago
	        this.timeHumanizer = humanizeDuration.humanizer({
	            language: this.language,
	            halfUnit:false
	        });
	    };
	
	    /**
	     * get time with units from momentJS i18n
	     * @param {int} millis
	     * @returns {{millis: string, seconds: string, minutes: string, hours: string, days: string, months: string, years: string}}
	     */
	    I18nService.prototype.getTimeUnits = function getTimeUnits(millis) {
	        var diffFromAlarm = Math.round(millis/1000) * 1000; //time in milliseconds, get rid of the last 3 ms value to avoid 2.12 seconds display
	
	        var time = {};
	
	        if (typeof this.timeHumanizer != 'undefined'){
	            time = {
	                'millis' : this.timeHumanizer(diffFromAlarm, { units: ["ms"] }),
	                'seconds' : this.timeHumanizer(diffFromAlarm, { units: ["s"] }),
	                'minutes' : this.timeHumanizer(diffFromAlarm, { units: ["m", "s"] }) ,
	                'hours' : this.timeHumanizer(diffFromAlarm, { units: ["h", "m", "s"] }) ,
	                'days' : this.timeHumanizer(diffFromAlarm, { units: ["d", "h", "m", "s"] }) ,
	                'months' : this.timeHumanizer(diffFromAlarm, { units: ["mo", "d", "h", "m", "s"] }) ,
	                'years' : this.timeHumanizer(diffFromAlarm, { units: ["y", "mo", "d", "h", "m", "s"] })
	            };
	        }
	        else {
	            console.error('i18nService has not been initialized. You must call i18nService.init("en") for example');
	        }
	
	        return time;
	    };
	
	    return I18nService;
	});
	
	var app = angular.module('timer');
	
	app.factory('progressBarService', function() {
	
	  var ProgressBarService = function() {};
	
	  /**
	   * calculate the remaining time in a progress bar in percentage
	   * @param {momentjs} startValue in seconds
	   * @param {integer} currentCountdown, where are we in the countdown
	   * @param {integer} remainingTime, remaining milliseconds
	   * @param {integer} endTime, end time, can be undefined
	   * @param {integer} coutdown, original coutdown value, can be undefined
	   *
	   * joke : https://www.youtube.com/watch?v=gENVB6tjq_M
	   * @return {float} 0 --> 100
	   */
	  ProgressBarService.prototype.calculateProgressBar = function calculateProgressBar(startValue, remainingTime, endTimeAttr, coutdown) {
	    var displayProgressBar = 0,
	      endTimeValue,
	      initialCountdown;
	
	    remainingTime = remainingTime / 1000; //seconds
	
	
	    if(endTimeAttr !== null){
	      endTimeValue = moment(endTimeAttr);
	      initialCountdown = endTimeValue.diff(startValue, 'seconds');
	      displayProgressBar = remainingTime * 100 / initialCountdown;
	    }
	    else {
	      displayProgressBar = remainingTime * 100 / coutdown;
	    }
	
	    displayProgressBar = 100 - displayProgressBar; //To have 0 to 100 and not 100 to 0
	    displayProgressBar = Math.round(displayProgressBar * 10) / 10; //learn more why : http://stackoverflow.com/questions/588004/is-floating-point-math-broken
	
	    if(displayProgressBar > 100){ //security
	      displayProgressBar = 100;
	    }
	
	    return displayProgressBar;
	  };
	
	  return new ProgressBarService();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(516)))

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.1 - 2024-01-21
	 * 
	 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $allowNamespaces = true,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.19.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#allowNamespaces
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Let's you disable namespaces, if you don't need nested translation
	   * object files. Disabling namespaces can improve performance.
	   *
	   * Default value is `true`. Namespaces are enabled by default.
	   *
	   * @param {boolean} namespacesEnabled - namespaces are enabled or not
	   */
	  this.allowNamespaces = function (namespacesEnabled) {
	    if (namespacesEnabled === undefined) {
	      return $allowNamespaces;
	    }
	    $allowNamespaces = namespacesEnabled;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    if (!$allowNamespaces) {
	      return data;
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#allowNamespaces
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns if namespaces are enabled
	     *
	     * @return {boolean} allowNamespaces value
	     */
	    $translate.allowNamespaces = function () {
	      return $allowNamespaces;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.13
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  angular.forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will caues `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 * 
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon 
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 * 
	 * Examples:
	 * 
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when 
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\]-]+)|\{([\w\[\]-]+)(?:\:((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+(-+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')'];   break;
	      case true:  surroundPattern = ['?(', ')?']; break;
	      default:    surroundPattern = ['(' + squash + "|", ')?'];  break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	    type        = $$UMFP.type(regexp || "string") || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp) });
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    var param = this.params[paramName];
	    var paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 * 
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validate
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	  return new ArrayType(this, mode);
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$arrayMode = mode;
	  }
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  function valToString(val) { return val != null ? val.toString().replace(/\//g, "%2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/%2F/g, "/") : val; }
	//  TODO: in 1.0, make string .is() return false if value is undefined by default.
	//  function regexpMatches(val) { /*jshint validthis:true */ return isDefined(val) && this.pattern.test(val); }
	  function regexpMatches(val) { /*jshint validthis:true */ return this.pattern.test(val); }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    string: {
	      encode: valToString,
	      decode: valFromString,
	      is: regexpMatches,
	      pattern: /[^/]*/
	    },
	    int: {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    bool: {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    date: {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    json: {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    any: { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      is: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	      return config.type instanceof Type ? config.type : new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      return injector.invoke(config.$$fn);
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return isDefined(value) ? self.type.decode(value) : $$getDefaultValue();
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var result = true, isOptional, val, param, self = this;
	
	      forEach(this.$$keys(), function(key) {
	        param = self[key];
	        val = paramValues[key];
	        isOptional = !val && param.isOptional;
	        result = result && (isOptional || !!param.type.is(val));
	      });
	      return result;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {object} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. if handle is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|object} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser'];
	  function $get(   $location,   $rootScope,   $injector,   $browser) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	        $location.url(urlMatcher.format(params || {}));
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = extend({}, state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), state.ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "'' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"</pre>
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explictly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explictly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved, events are not re-fired, 
	     * and controllers reinstantiated (bug with controllers reinstantiating right now, fixing soon).
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload() {
	      return $state.transitionTo($state.current, $stateParams, { reload: true, inherit: false, notify: true });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldTriggerReload(to, from, locals, options)) {
	        if (to.self.reloadOnSearch !== false) $urlRouter.update();
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams).defaultPrevented) {
	          $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys(), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      // Resolve template and dependencies for all views.
	      forEach(state.views, function (view, name) {
	        var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	        injectables.$template = [ function () {
	          return $view.load(name, { view: view, locals: locals, params: $stateParams, notify: options.notify }) || '';
	        }];
	
	        promises.push($resolve.resolve(injectables, locals, dst.resolve, state).then(function (result) {
	          // References to the controller (only instantiated at link time)
	          if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	            var injectLocals = angular.extend({}, injectables, locals);
	            result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	          } else {
	            result.$$controller = view.controller;
	          }
	          // Provide access to the state itself for internal use
	          result.$$state = state;
	          result.$$controllerAs = view.controllerAs;
	          dst[name] = result;
	        }));
	      });
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldTriggerReload(to, from, locals, options) {
	    if (to === from && ((locals === from.locals && !options.reload) || (to.self.reloadOnSearch === false))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .value('$stateParams', {})
	  .provider('$state', $StateProvider);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        if (result && options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$viewContentLoading
	         * @eventOf ui.router.state.$view
	         * @eventType broadcast on root scope
	         * @description
	         *
	         * Fired once the view **begins loading**, *before* the DOM is rendered.
	         *
	         * @param {Object} event Event object.
	         * @param {Object} viewConfig The view config properties (template, controller, etc).
	         *
	         * @example
	         *
	         * <pre>
	         * $scope.$on('$viewContentLoading',
	         * function(event, viewConfig){
	         *     // Access to all the view config properties.
	         *     // and one special property 'targetView'
	         *     // viewConfig.targetView
	         * });
	         * </pre>
	         */
	          $rootScope.$broadcast('$viewContentLoading', options);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          var promise = $animate.enter(element, null, target, cb);
	          if (promise && promise.then) promise.then(cb);
	        },
	        leave: function(element, cb) {
	          var promise = $animate.leave(element, cb);
	          if (promise && promise.then) promise.then(cb);
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope);
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	        scope.$on('$viewContentLoading', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            renderer.leave(currentEl, function() {
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          var clone = $transclude(newScope, function(clone) {
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description           *
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           */
	          currentScope.$emit('$viewContentLoaded');
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	          }
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var inherited = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated 
	 * URL, the directive will automatically generate & update the `href` attribute via 
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking 
	 * the link will trigger a state transition with optional parameters. 
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be 
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative 
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the 
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the 
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 * 
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 * 
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 * 
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  var allowedOptions = ['location', 'inherit', 'reload'];
	
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref = parseStateRef(attrs.uiSref, $state.current.name);
	      var params = null, url = null, base = stateContext(element) || $state.$current;
	      var newHref = null, isAnchor = element.prop("tagName") === "A";
	      var isForm = element[0].nodeName === "FORM";
	      var attr = isForm ? "action" : "href", nav = true;
	
	      var options = { relative: base, inherit: true };
	      var optionsOverride = scope.$eval(attrs.uiSrefOpts) || {};
	
	      angular.forEach(allowedOptions, function(option) {
	        if (option in optionsOverride) {
	          options[option] = optionsOverride[option];
	        }
	      });
	
	      var update = function(newVal) {
	        if (newVal) params = angular.copy(newVal);
	        if (!nav) return;
	
	        newHref = $state.href(ref.state, params, options);
	
	        var activeDirective = uiSrefActive[1] || uiSrefActive[0];
	        if (activeDirective) {
	          activeDirective.$$setStateInfo(ref.state, params);
	        }
	        if (newHref === null) {
	          nav = false;
	          return false;
	        }
	        attrs.$set(attr, newHref);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(newVal, oldVal) {
	          if (newVal !== params) update(newVal);
	        }, true);
	        params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (isForm) return;
	
	      element.bind("click", function(e) {
	        var button = e.which || e.button;
	        if ( !(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || element.attr('target')) ) {
	          // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	          var transition = $timeout(function() {
	            $state.go(ref.state, params, options);
	          });
	          e.preventDefault();
	
	          // if the state has no URL, ignore one preventDefault from the <a> directive.
	          var ignorePreventDefaultCount = isAnchor && !newHref ? 1: 0;
	          e.preventDefault = function() {
	            if (ignorePreventDefaultCount-- <= 0)
	              $timeout.cancel(transition);
	          };
	        }
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
	      var state, params, activeClass;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeClass = $interpolate($attrs.uiSrefActiveEq || $attrs.uiSrefActive || '', false)($scope);
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$setStateInfo = function (newState, newParams) {
	        state = $state.get(newState, stateContext($element));
	        params = newParams;
	        update();
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      // Update route state
	      function update() {
	        if (isMatch()) {
	          $element.addClass(activeClass);
	        } else {
	          $element.removeClass(activeClass);
	        }
	      }
	
	      function isMatch() {
	        if (typeof $attrs.uiSrefActiveEq !== 'undefined') {
	          return state && $state.is(state.name, params);
	        } else {
	          return state && $state.includes(state.name, params);
	        }
	      }
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state) {
	    return $state.is(state);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state) {
	    return $state.includes(state);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	angular.module('ui.sortable.multiselection', [])
	  .constant('uiSortableMultiSelectionClass', 'ui-sortable-selected')
	  .directive('uiSortableSelectable', [
	    'uiSortableMultiSelectionClass',
	    function(selectedItemClass) {
	      return {
	        link: function(scope, element/*, attrs*/) {
	          element.on('click', function (e) {
	            var $this = angular.element(this);
	
	            var $parent = $this.parent();
	
	            var multiSelectOnClick = $parent.sortable('option', 'multiSelectOnClick') || false;
	
	            var isDisabled = $parent.sortable('option', 'disabled');
	
	            if (isDisabled){
	              return;
	            }
	            var jquerySortableCancelOption = $parent.sortable('option', 'cancel');
	            var jquerySortableHandleOption = $parent.sortable('option', 'handle');
	
	            // Respect jQuery UI Sortable's cancel property by testing if element matches selector
	            if (jquerySortableCancelOption !== undefined && $this.is(jquerySortableCancelOption)) {
	              return;
	            }
	
	            // Mimic jQuery UI Sortable's handle property when determining if an item is selected
	            if (jquerySortableHandleOption) {
	              var validHandle = false;
	
	              $parent.find(jquerySortableHandleOption).find('*').addBack().each(function () {
	                if (this === e.target) {
	                  validHandle = true;
	                }
	              });
	
	              if (!validHandle) {
	                return;
	              }
	            }
	
	            var sortableMultiSelectState = $parent.data('uiSortableMultiSelectionState') || {};
	
	            var lastIndex = sortableMultiSelectState.lastIndex;
	            var index = $this.index();
	
	            if (e.ctrlKey || e.metaKey || multiSelectOnClick) {
	              $this.toggleClass(selectedItemClass);
	            } else if (e.shiftKey && lastIndex !== undefined && lastIndex >= 0) {
	              if (index > lastIndex) {
	                $parent.children().slice(lastIndex, index + 1).addClass(selectedItemClass);
	              } else if(index < lastIndex) {
	                $parent.children().slice(index, lastIndex).addClass(selectedItemClass);
	              }
	            } else {
	              $parent.children('.'+selectedItemClass).not($this).removeClass(selectedItemClass);
	              $this.toggleClass(selectedItemClass);
	            }
	            sortableMultiSelectState.lastIndex = index;
	            $parent.data('uiSortableMultiSelectionState', sortableMultiSelectState);
	
	            $parent.trigger('ui-sortable-selectionschanged');
	          });
	
	          element.parent().on('$destroy', function() {
	            element.parent().removeData('uiSortableMultiSelectionState');
	          });
	        }
	      };
	    }
	  ])
	  .factory('uiSortableMultiSelectionMethods', [
	    'uiSortableMultiSelectionClass',
	    function (selectedItemClass) {
	      var uiSelectionCount;
	
	      function fixIndex (oldPosition, newPosition, x) {
	        if (oldPosition < x && (newPosition === undefined || (oldPosition < newPosition && x <= newPosition))) {
	          return x - 1;
	        } else if (x < oldPosition && newPosition !== undefined && newPosition < oldPosition && newPosition <= x) {
	          return x + 1;
	        }
	        return x;
	      }
	
	      function groupIndexes (indexes, oldPosition, newPosition) {
	        var above = [],
	            below = [];
	
	        for (var i = 0; i < indexes.length; i++) {
	          var x = indexes[i];
	          if (x < oldPosition) {
	            above.push(fixIndex(oldPosition, newPosition, x));
	          } else if (oldPosition < x) {
	            below.push(fixIndex(oldPosition, newPosition, x));
	          }
	        }
	
	        return {
	          above: above,
	          below: below
	        };
	      }
	
	      function extractModelsFromIndexes (ngModel, indexes) {
	        var result = [];
	        for (var i = indexes.length - 1; i >= 0; i--) {
	          result.push(ngModel.splice(indexes[i], 1)[0]);
	        }
	        result.reverse();
	        return result;
	      }
	
	      function extractGroupedModelsFromIndexes (ngModel, aboveIndexes, belowIndexes) {
	        var models = {
	          below: extractModelsFromIndexes(ngModel, belowIndexes),
	          above: extractModelsFromIndexes(ngModel, aboveIndexes)
	        };
	        return models;
	      }
	
	      function combineCallbacks(first,second){
	        if(second && (typeof second === 'function')) {
	          return function() {
	            first.apply(this, arguments);
	            second.apply(this, arguments);
	          };
	        }
	        return first;
	      }
	
	      return {
	        extendOptions: function (sortableOptions) {
	          sortableOptions = sortableOptions || {};
	          var result = angular.extend({}, this, sortableOptions);
	
	          for (var prop in sortableOptions) {
	            if (sortableOptions.hasOwnProperty(prop)) {
	              if (this[prop]) {
	                if (prop === 'helper') {
	                  result.helper = this.helper;
	                } else {
	                  result[prop] = combineCallbacks(this[prop], sortableOptions[prop]);
	                }
	              }
	            }
	          }
	          uiSelectionCount = result['ui-selection-count'];
	          return result;
	        },
	        helper: function (e, item) {
	          // when starting to sort an unhighlighted item ,
	          // deselect any existing highlighted items
	          if (!item.hasClass(selectedItemClass)) {
	              item.addClass(selectedItemClass)
	                .siblings()
	                .removeClass(selectedItemClass);
	          }
	
	          var selectedElements = item.parent().children('.' + selectedItemClass);
	          var selectedSiblings = item.siblings('.' + selectedItemClass);
	
	          var selectedIndexes = angular.element.map(selectedElements, function (element) {
	            return angular.element(element).index();
	          });
	
	          // indexes of the selected siblings
	          var indexes = angular.element.map(selectedSiblings, function (element) {
	            return angular.element(element).index();
	          });
	
	          item.sortableMultiSelect = {
	            indexes: indexes,
	            selectedIndexes: selectedIndexes
	          };
	
	          //Calculate the selectionCount number and initialize the selectionCount attributes if dragging multiple elements
	          var selectionCount = selectedIndexes ? selectedIndexes.length : 0;
	
	          // Clone the selected items and to put them inside the helper
	          var elements = selectedElements.clone();
	
	          // like `helper: 'clone'` does, hide the dragged elements
	          selectedSiblings.hide();
	
	          // Create the helper to act as a bucket for the cloned elements
	          var helperTag = item[0].tagName;
	          var helper = angular.element('<' + helperTag + '/>');
	          if (uiSelectionCount && selectionCount > 1) {
	            helper.addClass('ui-selection-count').attr('data-ui-selection-count',  selectionCount);
	          }
	          return helper.append(elements);
	        },
	        start: function(e, ui) {
	          ui.item.sortableMultiSelect.sourceElement = ui.item.parent();
	
	          var sourceModel = ui.item.sortable.sourceModel;
	          var indexes = ui.item.sortableMultiSelect.indexes;
	          var selectedIndexes = ui.item.sortableMultiSelect.selectedIndexes;
	          var models = [];
	          var selectedModels = [];
	          for (var i = 0, len = selectedIndexes.length; i < len; i++) {
	            var index = selectedIndexes[i];
	            selectedModels.push(sourceModel[index]);
	            if (indexes.indexOf(index) >= 0) {
	              models.push(sourceModel[index]);
	            }
	          }
	          ui.item.sortableMultiSelect.models = models;
	          ui.item.sortableMultiSelect.selectedModels = selectedModels;
	        },
	        update: function(e, ui) {
	          if (ui.item.sortable.received) {
	            if (!ui.item.sortable.isCanceled()) {
	              var ngModel = ui.item.sortable.droptargetModel,
	                  newPosition = ui.item.sortable.dropindex,
	                  models = ui.item.sortableMultiSelect.moved;
	
	              // add the models to the target list
	              Array.prototype.splice.apply(
	                ngModel,
	                [newPosition+ 1, 0]
	                .concat(models.below));
	
	              Array.prototype.splice.apply(
	                ngModel,
	                [newPosition, 0]
	                .concat(models.above));
	            } else {
	              ui.item.sortableMultiSelect.sourceElement.find('> .' + selectedItemClass).show();
	            }
	          }
	        },
	        remove: function(e, ui) {
	          if (!ui.item.sortable.isCanceled()) {
	            var ngModel = ui.item.sortable.sourceModel,
	                oldPosition = ui.item.sortable.index;
	
	            var indexes = groupIndexes(ui.item.sortableMultiSelect.indexes, oldPosition);
	
	            // get the models and remove them from the original list
	            // the code should run in reverse order,
	            // so that the indexes will not break
	            ui.item.sortableMultiSelect.moved = extractGroupedModelsFromIndexes(ngModel, indexes.above, indexes.below);
	          } else {
	            ui.item.sortableMultiSelect.sourceElement.find('> .' + selectedItemClass).show();
	          }
	        },
	        stop: function (e, ui) {
	          var sourceElement = ui.item.sortableMultiSelect.sourceElement || ui.item.parent();
	          if (!ui.item.sortable.received &&
	             // ('dropindex' in ui.item.sortable) &&
	             !ui.item.sortable.isCanceled()) {
	            var ngModel = ui.item.sortable.sourceModel,
	                oldPosition = ui.item.sortable.index,
	                newPosition = ui.item.sortable.dropindex;
	
	            var draggedElementIndexes = ui.item.sortableMultiSelect.indexes;
	            if (!draggedElementIndexes.length) {
	              ui.item.removeClass('' + selectedItemClass);
	              return;
	            }
	
	            if (newPosition === undefined) {
	              newPosition = oldPosition;
	            }
	
	            var indexes = groupIndexes(draggedElementIndexes, oldPosition, newPosition);
	
	            // get the model of the dragged item
	            // so that we can locate its position
	            // after we remove the co-dragged elements
	            var draggedModel = ngModel[newPosition];
	
	            // get the models and remove them from the list
	            // the code should run in reverse order,
	            // so that the indexes will not break
	            var models = extractGroupedModelsFromIndexes(ngModel, indexes.above, indexes.below);
	
	            // add the models to the list
	            Array.prototype.splice.apply(
	              ngModel,
	              [ngModel.indexOf(draggedModel) + 1, 0]
	              .concat(models.below));
	
	            Array.prototype.splice.apply(
	              ngModel,
	              [ngModel.indexOf(draggedModel), 0]
	              .concat(models.above));
	
	            ui.item.parent().find('> .' + selectedItemClass).removeClass('' + selectedItemClass).show();
	          } else if (ui.item.sortable.isCanceled()) {
	            sourceElement.find('> .' + selectedItemClass).show();
	          }
	        }
	      };
	    }]);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	/*
	 jQuery UI Sortable plugin wrapper
	
	 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
	 */
	angular.module('ui.sortable', [])
	  .value('uiSortableConfig',{
	    // the default for jquery-ui sortable is "> *", we need to restrict this to
	    // ng-repeat items
	    // if the user uses
	    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
	  })
	  .directive('uiSortable', [
	    'uiSortableConfig', '$timeout', '$log',
	    function(uiSortableConfig, $timeout, $log) {
	      return {
	        require:'?ngModel',
	        scope: {
	          ngModel:'=',
	          uiSortable:'=',
	          ////Expression bindings from html.
	          create:'&uiSortableCreate',
	          // helper:'&uiSortableHelper',
	          start:'&uiSortableStart',
	          activate:'&uiSortableActivate',
	          // sort:'&uiSortableSort',
	          // change:'&uiSortableChange',
	          // over:'&uiSortableOver',
	          // out:'&uiSortableOut',
	          beforeStop:'&uiSortableBeforeStop',
	          update:'&uiSortableUpdate',
	          remove:'&uiSortableRemove',
	          receive:'&uiSortableReceive',
	          deactivate:'&uiSortableDeactivate',
	          stop:'&uiSortableStop'
	        },
	        link: function(scope, element, attrs, ngModel) {
	          var savedNodes;
	          var helper;
	
	          function combineCallbacks(first, second){
	            var firstIsFunc = typeof first === 'function';
	            var secondIsFunc = typeof second === 'function';
	            if(firstIsFunc && secondIsFunc) {
	              return function() {
	                first.apply(this, arguments);
	                second.apply(this, arguments);
	              };
	            } else if (secondIsFunc) {
	              return second;
	            }
	            return first;
	          }
	
	          function getSortableWidgetInstance(element) {
	            // this is a fix to support jquery-ui prior to v1.11.x
	            // otherwise we should be using `element.sortable('instance')`
	            var data = element.data('ui-sortable');
	            if (data && typeof data === 'object' && data.widgetFullName === 'ui-sortable') {
	              return data;
	            }
	            return null;
	          }
	
	          function setItemChildrenWidth(item) {
	            item.children().each(function() {
	              var $el = angular.element(this);
	
	              // Preserve the with of the element
	              $el.width($el.width());
	            });
	          }
	
	          function dummyHelper(e, item) {
	            return item;
	          }
	
	          function patchSortableOption(key, value) {
	            if (callbacks[key]) {
	              if( key === 'stop' ){
	                // call apply after stop
	                value = combineCallbacks(
	                  value, function() { scope.$apply(); });
	
	                value = combineCallbacks(value, afterStop);
	              }
	              // wrap the callback
	              value = combineCallbacks(callbacks[key], value);
	            } else if (wrappers[key]) {
	              value = wrappers[key](value);
	            }
	
	            // patch the options that need to have values set
	            if (!value && (key === 'items' || key === 'ui-model-items')) {
	              value = uiSortableConfig.items;
	            }
	
	            return value;
	          }
	
	          function patchUISortableOptions(newOpts, oldOpts, sortableWidgetInstance) {
	
	            function addDummyOptionKey(value, key) {
	              if (!(key in opts)) {
	                // add the key in the opts object so that
	                // the patch function detects and handles it
	                opts[key] = null;
	              }
	            }
	            // for this directive to work we have to attach some callbacks
	            angular.forEach(callbacks, addDummyOptionKey);
	
	            // only initialize it in case we have to
	            // update some options of the sortable
	            var optsDiff = null;
	
	            if (oldOpts) {
	              // reset deleted options to default
	              var defaultOptions;
	              angular.forEach(oldOpts, function(oldValue, key) {
	                if (!newOpts || !(key in newOpts)) {
	                  if (key in directiveOpts) {
	                    if (key === 'ui-floating') {
	                      opts[key] = 'auto';
	                    } else {
	                      opts[key] = patchSortableOption(key, undefined);
	                    }
	                    return;
	                  }
	
	                  if (!defaultOptions) {
	                    defaultOptions = angular.element.ui.sortable().options;
	                  }
	                  var defaultValue = defaultOptions[key];
	                  defaultValue = patchSortableOption(key, defaultValue);
	
	                  if (!optsDiff) {
	                    optsDiff = {};
	                  }
	                  optsDiff[key] = defaultValue;
	                  opts[key] = defaultValue;
	                }
	              });
	            }
	
	            newOpts = angular.extend({}, newOpts);
	            // update changed options
	            // handle the custom option of the directive first
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                if (key === 'ui-floating' && (value === false || value === true) && sortableWidgetInstance) {
	                  sortableWidgetInstance.floating = value;
	                }
	
	                if (key === 'ui-preserve-size' && (value === false || value === true)) {
	                  var userProvidedHelper = opts.helper;
	                  newOpts.helper = function(e, item) {
	                    if (opts['ui-preserve-size'] === true) {
	                      setItemChildrenWidth(item);
	                    }
	                    return (userProvidedHelper || dummyHelper).apply(this, arguments);
	                  };
	                }
	
	                opts[key] = patchSortableOption(key, value);
	              }
	            });
	
	            // handle the normal option of the directive
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                // the custom option of the directive are already handled
	                return;
	              }
	
	              value = patchSortableOption(key, value);
	
	              if (!optsDiff) {
	                optsDiff = {};
	              }
	              optsDiff[key] = value;
	              opts[key] = value;
	            });
	
	            return optsDiff;
	          }
	
	          function getPlaceholderElement (element) {
	            var placeholder = element.sortable('option','placeholder');
	
	            // placeholder.element will be a function if the placeholder, has
	            // been created (placeholder will be an object).  If it hasn't
	            // been created, either placeholder will be false if no
	            // placeholder class was given or placeholder.element will be
	            // undefined if a class was given (placeholder will be a string)
	            if (placeholder && placeholder.element && typeof placeholder.element === 'function') {
	              var result = placeholder.element();
	              // workaround for jquery ui 1.9.x,
	              // not returning jquery collection
	              result = angular.element(result);
	              return result;
	            }
	            return null;
	          }
	
	          function getPlaceholderExcludesludes (element, placeholder) {
	            // exact match with the placeholder's class attribute to handle
	            // the case that multiple connected sortables exist and
	            // the placeholder option equals the class of sortable items
	            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
	            var excludes = element.find('[class="' + placeholder.attr('class') + '"]:not(' + notCssSelector + ')');
	            return excludes;
	          }
	
	          function hasSortingHelper (element, ui) {
	            var helperOption = element.sortable('option','helper');
	            return helperOption === 'clone' || (typeof helperOption === 'function' && ui.item.sortable.isCustomHelperUsed());
	          }
	
	          function getSortingHelper (element, ui/*, savedNodes*/) {
	            var result = null;
	            if (hasSortingHelper(element, ui) &&
	                element.sortable( 'option', 'appendTo' ) === 'parent') {
	              // The .ui-sortable-helper element (that's the default class name)
	              result = helper;
	            }
	            return result;
	          }
	
	          // thanks jquery-ui
	          function isFloating(item) {
	            return (/left|right/).test(item.css('float')) || (/inline|table-cell/).test(item.css('display'));
	          }
	
	          function getElementContext(elementScopes, element) {
	            for (var i = 0; i < elementScopes.length; i++) {
	              var c = elementScopes[i];
	              if (c.element[0] === element[0]) {
	                return c;
	              }
	            }
	          }
	
	          function afterStop(e, ui) {
	            ui.item.sortable._destroy();
	          }
	
	          // return the index of ui.item among the items
	          // we can't just do ui.item.index() because there it might have siblings
	          // which are not items
	          function getItemIndex(item) {
	            return item.parent()
	              .find(opts['ui-model-items'])
	              .index(item);
	          }
	
	          var opts = {};
	
	          // directive specific options
	          var directiveOpts = {
	            'ui-floating': undefined,
	            'ui-model-items': uiSortableConfig.items,
	            'ui-preserve-size': undefined
	          };
	
	          var callbacks = {
	            create: null,
	            start: null,
	            activate: null,
	            // sort: null,
	            // change: null,
	            // over: null,
	            // out: null,
	            beforeStop: null,
	            update: null,
	            remove: null,
	            receive: null,
	            deactivate: null,
	            stop: null
	          };
	
	          var wrappers = {
	            helper: null
	          };
	
	          angular.extend(opts, directiveOpts, uiSortableConfig, scope.uiSortable);
	
	          if (!angular.element.fn || !angular.element.fn.jquery) {
	            $log.error('ui.sortable: jQuery should be included before AngularJS!');
	            return;
	          }
	
	          function wireUp () {
	            // When we add or remove elements, we need the sortable to 'refresh'
	            // so it can find the new/removed elements.
	            scope.$watchCollection('ngModel', function() {
	              // Timeout to let ng-repeat modify the DOM
	              $timeout(function() {
	                // ensure that the jquery-ui-sortable widget instance
	                // is still bound to the directive's element
	                if (!!getSortableWidgetInstance(element)) {
	                  element.sortable('refresh');
	                }
	              }, 0, false);
	            });
	
	            callbacks.start = function(e, ui) {
	              if (opts['ui-floating'] === 'auto') {
	                // since the drag has started, the element will be
	                // absolutely positioned, so we check its siblings
	                var siblings = ui.item.siblings();
	                var sortableWidgetInstance = getSortableWidgetInstance(angular.element(e.target));
	                sortableWidgetInstance.floating = isFloating(siblings);
	              }
	
	              // Save the starting position of dragged item
	              var index = getItemIndex(ui.item);
	              ui.item.sortable = {
	                model: ngModel.$modelValue[index],
	                index: index,
	                source: element,
	                sourceList: ui.item.parent(),
	                sourceModel: ngModel.$modelValue,
	                cancel: function () {
	                  ui.item.sortable._isCanceled = true;
	                },
	                isCanceled: function () {
	                  return ui.item.sortable._isCanceled;
	                },
	                isCustomHelperUsed: function () {
	                  return !!ui.item.sortable._isCustomHelperUsed;
	                },
	                _isCanceled: false,
	                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
	                _destroy: function () {
	                  angular.forEach(ui.item.sortable, function(value, key) {
	                    ui.item.sortable[key] = undefined;
	                  });
	                },
	                _connectedSortables: [],
	                _getElementContext: function (element) {
	                  return getElementContext(this._connectedSortables, element);
	                }
	              };
	            };
	
	            callbacks.activate = function(e, ui) {
	              var isSourceContext = ui.item.sortable.source === element;
	              var savedNodesOrigin = isSourceContext ?
	                                     ui.item.sortable.sourceList :
	                                     element;
	              var elementContext = {
	                element: element,
	                scope: scope,
	                isSourceContext: isSourceContext,
	                savedNodesOrigin: savedNodesOrigin
	              };
	              // save the directive's scope so that it is accessible from ui.item.sortable
	              ui.item.sortable._connectedSortables.push(elementContext);
	
	              // We need to make a copy of the current element's contents so
	              // we can restore it after sortable has messed it up.
	              // This is inside activate (instead of start) in order to save
	              // both lists when dragging between connected lists.
	              savedNodes = savedNodesOrigin.contents();
	              helper = ui.helper;
	
	              // If this list has a placeholder (the connected lists won't),
	              // don't inlcude it in saved nodes.
	              var placeholder = getPlaceholderElement(element);
	              if (placeholder && placeholder.length) {
	                var excludes = getPlaceholderExcludesludes(element, placeholder);
	                savedNodes = savedNodes.not(excludes);
	              }
	            };
	
	            callbacks.update = function(e, ui) {
	              // Save current drop position but only if this is not a second
	              // update that happens when moving between lists because then
	              // the value will be overwritten with the old value
	              if (!ui.item.sortable.received) {
	                ui.item.sortable.dropindex = getItemIndex(ui.item);
	                var droptarget = ui.item.parent().closest('[ui-sortable], [data-ui-sortable], [x-ui-sortable]');
	                ui.item.sortable.droptarget = droptarget;
	                ui.item.sortable.droptargetList = ui.item.parent();
	
	                var droptargetContext = ui.item.sortable._getElementContext(droptarget);
	                ui.item.sortable.droptargetModel = droptargetContext.scope.ngModel;
	
	                // Cancel the sort (let ng-repeat do the sort for us)
	                // Don't cancel if this is the received list because it has
	                // already been canceled in the other list, and trying to cancel
	                // here will mess up the DOM.
	                element.sortable('cancel');
	              }
	
	              // Put the nodes back exactly the way they started (this is very
	              // important because ng-repeat uses comment elements to delineate
	              // the start and stop of repeat sections and sortable doesn't
	              // respect their order (even if we cancel, the order of the
	              // comments are still messed up).
	              var sortingHelper = !ui.item.sortable.received && getSortingHelper(element, ui, savedNodes);
	              if (sortingHelper && sortingHelper.length) {
	                // Restore all the savedNodes except from the sorting helper element.
	                // That way it will be garbage collected.
	                savedNodes = savedNodes.not(sortingHelper);
	              }
	              var elementContext = ui.item.sortable._getElementContext(element);
	              savedNodes.appendTo(elementContext.savedNodesOrigin);
	
	              // If this is the target connected list then
	              // it's safe to clear the restored nodes since:
	              // update is currently running and
	              // stop is not called for the target list.
	              if (ui.item.sortable.received) {
	                savedNodes = null;
	              }
	
	              // If received is true (an item was dropped in from another list)
	              // then we add the new item to this list otherwise wait until the
	              // stop event where we will know if it was a sort or item was
	              // moved here from another list
	              if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
	                scope.$apply(function () {
	                  ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0,
	                                             ui.item.sortable.moved);
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              }
	            };
	
	            callbacks.stop = function(e, ui) {
	              // If the received flag hasn't be set on the item, this is a
	              // normal sort, if dropindex is set, the item was moved, so move
	              // the items in the list.
	              var wasMoved = ('dropindex' in ui.item.sortable) &&
	                              !ui.item.sortable.isCanceled();
	
	              if (wasMoved && !ui.item.sortable.received) {
	
	                scope.$apply(function () {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex, 0,
	                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]);
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              } else if (!wasMoved &&
	                         !angular.equals(element.contents().toArray(), savedNodes.toArray())) {
	                // if the item was not moved
	                // and the DOM element order has changed,
	                // then restore the elements
	                // so that the ngRepeat's comment are correct.
	
	                var sortingHelper = getSortingHelper(element, ui, savedNodes);
	                if (sortingHelper && sortingHelper.length) {
	                  // Restore all the savedNodes except from the sorting helper element.
	                  // That way it will be garbage collected.
	                  savedNodes = savedNodes.not(sortingHelper);
	                }
	                var elementContext = ui.item.sortable._getElementContext(element);
	                savedNodes.appendTo(elementContext.savedNodesOrigin);
	              }
	
	              // It's now safe to clear the savedNodes and helper
	              // since stop is the last callback.
	              savedNodes = null;
	              helper = null;
	            };
	
	            callbacks.receive = function(e, ui) {
	              // An item was dropped here from another list, set a flag on the
	              // item.
	              ui.item.sortable.received = true;
	            };
	
	            callbacks.remove = function(e, ui) {
	              // Workaround for a problem observed in nested connected lists.
	              // There should be an 'update' event before 'remove' when moving
	              // elements. If the event did not fire, cancel sorting.
	              if (!('dropindex' in ui.item.sortable)) {
	                element.sortable('cancel');
	                ui.item.sortable.cancel();
	              }
	
	              // Remove the item from this list's model and copy data into item,
	              // so the next list can retrive it
	              if (!ui.item.sortable.isCanceled()) {
	                scope.$apply(function () {
	                  ui.item.sortable.moved = ngModel.$modelValue.splice(
	                    ui.item.sortable.index, 1)[0];
	                });
	              }
	            };
	
	            // setup attribute handlers
	            angular.forEach(callbacks, function(value, key) {
	              callbacks[key] = combineCallbacks(callbacks[key],
	                function () {
	                  var attrHandler = scope[key];
	                  var attrHandlerFn;
	                  if (typeof attrHandler === 'function' &&
	                      ('uiSortable' + key.substring(0,1).toUpperCase() + key.substring(1)).length &&
	                      typeof (attrHandlerFn = attrHandler()) === 'function') {
	                    attrHandlerFn.apply(this, arguments);
	                  }
	                });
	            });
	
	
	            wrappers.helper = function (inner) {
	              if (inner && typeof inner === 'function') {
	                return function (e, item) {
	                  var oldItemSortable = item.sortable;
	                  var index = getItemIndex(item);
	
	                  item.sortable = {
	                    model: ngModel.$modelValue[index],
	                    index: index,
	                    source: element,
	                    sourceList: item.parent(),
	                    sourceModel: ngModel.$modelValue,
	                    _restore: function () {
	                      angular.forEach(item.sortable, function(value, key) {
	                        item.sortable[key] = undefined;
	                      });
	
	                      item.sortable = oldItemSortable;
	                    }
	                  };
	
	                  var innerResult = inner.apply(this, arguments);
	                  item.sortable._restore();
	                  item.sortable._isCustomHelperUsed = item !== innerResult;
	                  return innerResult;
	                };
	              }
	              return inner;
	            };
	
	            scope.$watchCollection('uiSortable', function(newOpts, oldOpts) {
	              // ensure that the jquery-ui-sortable widget instance
	              // is still bound to the directive's element
	              var sortableWidgetInstance = getSortableWidgetInstance(element);
	              if (!!sortableWidgetInstance) {
	                var optsDiff = patchUISortableOptions(newOpts, oldOpts, sortableWidgetInstance);
	
	                if (optsDiff) {
	                  element.sortable('option', optsDiff);
	                }
	              }
	            }, true);
	
	            patchUISortableOptions(opts);
	          }
	
	          function init () {
	            if (ngModel) {
	              wireUp();
	            } else {
	              $log.info('ui.sortable: ngModel not provided!', element);
	            }
	
	            // Create sortable
	            element.sortable(opts);
	          }
	
	          function initIfEnabled () {
	            if (scope.uiSortable && scope.uiSortable.disabled) {
	              return false;
	            }
	
	            init();
	
	            // Stop Watcher
	            initIfEnabled.cancelWatcher();
	            initIfEnabled.cancelWatcher = angular.noop;
	
	            return true;
	          }
	
	          initIfEnabled.cancelWatcher = angular.noop;
	
	          if (!initIfEnabled()) {
	            initIfEnabled.cancelWatcher = scope.$watch('uiSortable.disabled', initIfEnabled);
	          }
	        }
	      };
	    }
	  ]);


/***/ }),
/* 459 */
/***/ (function(module, exports) {

	/**
	 * Binds a TinyMCE widget to <textarea> elements.
	 */
	angular.module('ui.tinymce', [])
	  .value('uiTinymceConfig', {})
	  .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
	    uiTinymceConfig = uiTinymceConfig || {};
	
	    if (uiTinymceConfig.baseUrl) {
	      tinymce.baseURL = uiTinymceConfig.baseUrl;
	    }
	
	    return {
	      require: ['ngModel', '^?form'],
	      priority: 599,
	      link: function(scope, element, attrs, ctrls) {
	        if (!$window.tinymce) {
	          return;
	        }
	
	        var ngModel = ctrls[0],
	          form = ctrls[1] || null;
	
	        var expression, options = {
	          debounce: true
	        }, tinyInstance,
	          updateView = function(editor) {
	            var content = editor.getContent({format: options.format}).trim();
	            content = $sce.trustAsHtml(content);
	
	            ngModel.$setViewValue(content);
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          };
	
	        function toggleDisable(disabled) {
	          if (disabled) {
	            ensureInstance();
	
	            if (tinyInstance) {
	              tinyInstance.getBody().setAttribute('contenteditable', false);
	            }
	          } else {
	            ensureInstance();
	
	            if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
	              tinyInstance.getBody().setAttribute('contenteditable', true);
	            }
	          }
	        }
	
	        // fetch a unique ID from the service
	        var uniqueId = uiTinymceService.getUniqueId();
	        attrs.$set('id', uniqueId);
	
	        expression = {};
	
	        angular.extend(expression, scope.$eval(attrs.uiTinymce));
	
	        //Debounce update and save action
	        var debouncedUpdate = (function(debouncedUpdateDelay) {
	          var debouncedUpdateTimer;
	          return function(ed) {
		        $timeout.cancel(debouncedUpdateTimer);
		         debouncedUpdateTimer = $timeout(function() {
	              return (function(ed) {
	                if (ed.isDirty()) {
	                  ed.save();
	                  updateView(ed);
	                }
	              })(ed);
	            }, debouncedUpdateDelay);
	          };
	        })(400);
	
	        var setupOptions = {
	          // Update model when calling setContent
	          // (such as from the source editor popup)
	          setup: function(ed) {
	            ed.on('init', function() {
	              ngModel.$render();
	              ngModel.$setPristine();
	                ngModel.$setUntouched();
	              if (form) {
	                form.$setPristine();
	              }
	            });
	
	            // Update model when:
	            // - a button has been clicked [ExecCommand]
	            // - the editor content has been modified [change]
	            // - the node has changed [NodeChange]
	            // - an object has been resized (table, image) [ObjectResized]
	            ed.on('ExecCommand change NodeChange ObjectResized', function() {
	              if (!options.debounce) {
	                ed.save();
	                updateView(ed);
	              	return;
	              }
	              debouncedUpdate(ed);
	            });
	
	            ed.on('blur', function() {
	              element[0].blur();
	              ngModel.$setTouched();
	              if (!$rootScope.$$phase) {
	                scope.$digest();
	              }
	            });
	
	            ed.on('remove', function() {
	              element.remove();
	            });
	
	            if (uiTinymceConfig.setup) {
	              uiTinymceConfig.setup(ed, {
	                updateView: updateView
	              });
	            }
	
	            if (expression.setup) {
	              expression.setup(ed, {
	                updateView: updateView
	              });
	            }
	          },
	          format: expression.format || 'html',
	          selector: '#' + attrs.id
	        };
	        // extend options with initial uiTinymceConfig and
	        // options from directive attribute value
	        angular.extend(options, uiTinymceConfig, expression, setupOptions);
	        // Wrapped in $timeout due to $tinymce:refresh implementation, requires
	        // element to be present in DOM before instantiating editor when
	        // re-rendering directive
	        $timeout(function() {
	          if (options.baseURL){
	            tinymce.baseURL = options.baseURL;
	          }
	          var maybeInitPromise = tinymce.init(options);
	          if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
	            maybeInitPromise.then(function() {
	              toggleDisable(scope.$eval(attrs.ngDisabled));
	            });
	          } else {
	            toggleDisable(scope.$eval(attrs.ngDisabled));
	          }
	        });
	
	        ngModel.$formatters.unshift(function(modelValue) {
	          return modelValue ? $sce.trustAsHtml(modelValue) : '';
	        });
	
	        ngModel.$parsers.unshift(function(viewValue) {
	          return viewValue ? $sce.getTrustedHtml(viewValue) : '';
	        });
	
	        ngModel.$render = function() {
	          ensureInstance();
	
	          var viewValue = ngModel.$viewValue ?
	            $sce.getTrustedHtml(ngModel.$viewValue) : '';
	
	          // instance.getDoc() check is a guard against null value
	          // when destruction & recreation of instances happen
	          if (tinyInstance &&
	            tinyInstance.getDoc()
	          ) {
	            tinyInstance.setContent(viewValue);
	            // Triggering change event due to TinyMCE not firing event &
	            // becoming out of sync for change callbacks
	            tinyInstance.fire('change');
	          }
	        };
	
	        attrs.$observe('disabled', toggleDisable);
	
	        // This block is because of TinyMCE not playing well with removal and
	        // recreation of instances, requiring instances to have different
	        // selectors in order to render new instances properly
	        var unbindEventListener = scope.$on('$tinymce:refresh', function(e, id) {
	          var eid = attrs.id;
	          if (angular.isUndefined(id) || id === eid) {
	            var parentElement = element.parent();
	            var clonedElement = element.clone();
	            clonedElement.removeAttr('id');
	            clonedElement.removeAttr('style');
	            clonedElement.removeAttr('aria-hidden');
	            tinymce.execCommand('mceRemoveEditor', false, eid);
	            parentElement.append($compile(clonedElement)(scope));
	            unbindEventListener();
	          }
	        });
	
	        scope.$on('$destroy', function() {
	          ensureInstance();
	
	          if (tinyInstance) {
	            tinyInstance.remove();
	            tinyInstance = null;
	          }
	        });
	
	        function ensureInstance() {
	          if (!tinyInstance) {
	            tinyInstance = tinymce.get(attrs.id);
	          }
	        }
	      }
	    };
	  }])
	  .service('uiTinymceService', [
	    /**
	     * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
	     */
	    function() {
	      var UITinymceService = function() {
	   	    var ID_ATTR = 'ui-tinymce';
	    	// uniqueId keeps track of the latest assigned ID
	    	var uniqueId = 0;
	        // getUniqueId returns a unique ID
	    	var getUniqueId = function() {
	          uniqueId ++;
	          return ID_ATTR + '-' + uniqueId;
	        };
	        // return the function as a public method of the service
	        return {
	        	getUniqueId: getUniqueId
	        };
	      };
	      // return a new instance of the service
	      return new UITinymceService();
	    }
	  ]);


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {/*!
	angular-xeditable - 0.1.12
	Edit-in-place for angular.js
	Build date: 2016-04-14 
	*/
	/**
	 * Angular-xeditable module 
	 *
	 */
	angular.module('xeditable', [])
	
	
	/**
	 * Default options. 
	 *
	 * @namespace editable-options
	 */
	//todo: maybe better have editableDefaults, not options...
	.value('editableOptions', {
	  /**
	   * Theme. Possible values `bs3`, `bs2`, `default`.
	   * 
	   * @var {string} theme
	   * @memberOf editable-options
	   */  
	  theme: 'default',
	  /**
	   * Icon Set. Possible values `font-awesome`, `default`.
	   * 
	   * @var {string} icon set
	   * @memberOf editable-options
	   */  
	  icon_set: 'default',
	  /**
	   * Whether to show buttons for single editalbe element.  
	   * Possible values `right` (default), `no`.
	   * 
	   * @var {string} buttons
	   * @memberOf editable-options
	   */    
	  buttons: 'right',
	  /**
	   * Default value for `blur` attribute of single editable element.  
	   * Can be `cancel|submit|ignore`.
	   * 
	   * @var {string} blurElem
	   * @memberOf editable-options
	   */
	  blurElem: 'cancel',
	  /**
	   * Default value for `blur` attribute of editable form.  
	   * Can be `cancel|submit|ignore`.
	   * 
	   * @var {string} blurForm
	   * @memberOf editable-options
	   */
	  blurForm: 'ignore',
	  /**
	   * How input elements get activated. Possible values: `focus|select|none`.
	   *
	   * @var {string} activate
	   * @memberOf editable-options
	   */
	  activate: 'focus',
	  /**
	   * Whether to disable x-editable. Can be overloaded on each element.
	   *
	   * @var {boolean} isDisabled
	   * @memberOf editable-options
	   */
	   isDisabled: false,
	  
	  /**
	   * Event, on which the edit mode gets activated. 
	   * Can be any event.
	   *
	   * @var {string} activationEvent
	   * @memberOf editable-options
	   */
	  activationEvent: 'click'
	
	});
	
	/*
	 Angular-ui bootstrap datepicker
	 http://angular-ui.github.io/bootstrap/#/datepicker
	 */
	angular.module('xeditable').directive('editableBsdate', ['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	            directiveName: 'editableBsdate',
	            inputTpl: '<div></div>',
	            render: function() {
	                /** This basically renders a datepicker as in the example shown in
	                 **  http://angular-ui.github.io/bootstrap/#/datepicker
	                 **  The attributes are all the same as in the bootstrap-ui datepicker with e- as prefix
	                 **/
	                this.parent.render.call(this);
	
	                var inputDatePicker = angular.element('<input type="text" class="form-control" ng-model="$data"/>');
	                var buttonDatePicker = angular.element('<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>');
	                var buttonWrapper = angular.element('<span class="input-group-btn"></span>');
	
	                inputDatePicker.attr('uib-datepicker-popup', this.attrs.eDatepickerPopupXEditable || 'yyyy/MM/dd' );
	                inputDatePicker.attr('is-open', this.attrs.eIsOpen);
	                inputDatePicker.attr('date-disabled', this.attrs.eDateDisabled);
	                inputDatePicker.attr('uib-datepicker-popup', this.attrs.eDatepickerPopup);
	                inputDatePicker.attr('min-date', this.attrs.eMinDate);
	                inputDatePicker.attr('max-date', this.attrs.eMaxDate);
	                inputDatePicker.attr('year-range', this.attrs.eYearRange || 20);
	                inputDatePicker.attr('show-button-bar', this.attrs.eShowButtonBar || true);
	                inputDatePicker.attr('current-text', this.attrs.eCurrentText || 'Today');
	                inputDatePicker.attr('clear-text', this.attrs.eClearText || 'Clear');
	                inputDatePicker.attr('close-text', this.attrs.eCloseText || 'Done');
	                inputDatePicker.attr('close-on-date-selection', this.attrs.eCloseOnDateSelection || true);
	                inputDatePicker.attr('datepicker-append-to-body', this.attrs.eDatePickerAppendToBody || false);
	                inputDatePicker.attr('date-disabled', this.attrs.eDateDisabled);
	                inputDatePicker.attr('name', this.attrs.eName);
	
	                this.scope.dateOptions = {
	                    formatDay:  this.attrs.eFormatDay || 'dd',
	                    formatMonth: this.attrs.eFormatMonth || 'MMMM',
	                    formatYear: this.attrs.eFormatYear || 'yyyy',
	                    formatDayHeader: this.attrs.eFormatDayHeader || 'EEE',
	                    formatDayTitle: this.attrs.eFormatDayTitle || 'MMMM yyyy',
	                    formatMonthTitle: this.attrs.eFormatMonthTitle || 'yyyy',
	                    showWeeks: this.attrs.eShowWeeks ? this.attrs.eShowWeeks.toLowerCase() === 'true' : true,
	                    startingDay: this.attrs.eStartingDay || 0,
	                    minMode: this.attrs.eMinMode || 'day',
	                    maxMode: this.attrs.eMaxMode || 'year',
	                    initDate: this.attrs.eInitDate || new Date(),
	                    datepickerMode: this.attrs.eDatepickerMode || 'day'
	                };
	
	                inputDatePicker.attr('datepicker-options', "dateOptions");
	
	                buttonDatePicker.attr('ng-click',this.attrs.eNgClick);
	
	                buttonWrapper.append(buttonDatePicker);
	                this.inputEl.prepend(inputDatePicker);
	                this.inputEl.append(buttonWrapper);
	
	                this.inputEl.removeAttr('class');
	                this.inputEl.removeAttr('ng-click');
	                this.inputEl.removeAttr('is-open');
	                this.inputEl.removeAttr('init-date');
	                this.inputEl.removeAttr('datepicker-popup');
	                this.inputEl.removeAttr('required');
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.removeAttr('date-picker-append-to-body');
	                this.inputEl.removeAttr('name');
	                this.inputEl.attr('class','input-group');
	            }
		});
	}]);
	/*
	Angular-ui bootstrap editable timepicker
	http://angular-ui.github.io/bootstrap/#/timepicker
	*/
	angular.module('xeditable').directive('editableBstime', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableBstime',
	      inputTpl: '<uib-timepicker></uib-timepicker>',
	      render: function() {
	        this.parent.render.call(this);
	
	        // timepicker can't update model when ng-model set directly to it
	        // see: https://github.com/angular-ui/bootstrap/issues/1141
	        // so we wrap it into DIV
	        var div = angular.element('<div class="well well-small" style="display:inline-block;"></div>');
	
	        // move ng-model to wrapping div
	        div.attr('ng-model', this.inputEl.attr('ng-model'));
	        this.inputEl.removeAttr('ng-model');
	
	        // move ng-change to wrapping div
	        if(this.attrs.eNgChange) {
	          div.attr('ng-change', this.inputEl.attr('ng-change'));
	          this.inputEl.removeAttr('ng-change');
	        }
	
	        // wrap
	        this.inputEl.wrap(div);
	      }
	    });
	}]);
	//checkbox
	angular.module('xeditable').directive('editableCheckbox', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCheckbox',
	      inputTpl: '<input type="checkbox">',
	      render: function() {
	        this.parent.render.call(this);
	        if(this.attrs.eTitle) {
	          this.inputEl.wrap('<label></label>');
	          this.inputEl.parent().append(this.attrs.eTitle);
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	// checklist
	angular.module('xeditable').directive('editableChecklist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  function(editableDirectiveFactory, editableNgOptionsParser) {
	    return editableDirectiveFactory({
	      directiveName: 'editableChecklist',
	      inputTpl: '<span></span>',
	      useCopy: true,
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        var html = '<label ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="checkbox" checklist-model="$parent.$data" checklist-value="'+parsed.locals.valueFn+'">'+
	          '<span ng-bind="'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.html(html);
	      }
	    });
	}]);
	
	angular.module('xeditable').directive('editableCombodate', ['editableDirectiveFactory', 'editableCombodate',
	  function(editableDirectiveFactory, editableCombodate) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCombodate',
	      inputTpl: '<input type="text">',
	      render: function() {
	        this.parent.render.call(this);
	
	        var options = {
	          value: new Date(this.scope.$data)
	        };
	        var self = this;
	        angular.forEach(["format", "template", "minYear", "maxYear", "yearDescending", "minuteStep", "secondStep", "firstItem", "errorClass", "customClass", "roundTime", "smartDays"], function(name) {
	
	          var attrName = "e" + name.charAt(0).toUpperCase() + name.slice(1);
	          if (attrName in self.attrs) {
	            options[name] = self.attrs[attrName];
	          }
	        });
	
	        var combodate = editableCombodate.getInstance(this.inputEl, options);
	        combodate.$widget.find('select').bind('change', function(e) {
	          self.scope.$data = (new Date(combodate.getValue())).toISOString();
	        });
	      }
	    });
	  }
	]);
	
	/*
	Input types: text|email|tel|number|url|search|color|date|datetime|time|month|week
	*/
	
	(function() {
	
	  var types = 'text|password|email|tel|number|url|search|color|date|datetime|time|month|week|file'.split('|');
	
	  //todo: datalist
	  
	  // generate directives
	  angular.forEach(types, function(type) {
	    var directiveName = 'editable'+type.charAt(0).toUpperCase() + type.slice(1);
	    angular.module('xeditable').directive(directiveName, ['editableDirectiveFactory',
	      function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	          directiveName: directiveName,
	          inputTpl: '<input type="'+type+'">'
	        });
	    }]);
	  });
	
	  //`range` is bit specific
	  angular.module('xeditable').directive('editableRange', ['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	      return editableDirectiveFactory({
	        directiveName: 'editableRange',
	        inputTpl: '<input type="range" id="range" name="range">',
	        render: function() {
	          this.parent.render.call(this);
	          this.inputEl.after('<output>{{$data}}</output>');
	        }        
	      });
	  }]);
	
	}());
	
	
	// radiolist
	angular.module('xeditable').directive('editableRadiolist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  function(editableDirectiveFactory, editableNgOptionsParser) {
	    return editableDirectiveFactory({
	      directiveName: 'editableRadiolist',
	      inputTpl: '<span></span>',
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        var html = '<label ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="radio" ng-disabled="' + this.attrs.eNgDisabled + '" ng-model="$parent.$data" value="{{'+parsed.locals.valueFn+'}}">'+
	          '<span ng-bind="'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.html(html);
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	//select
	angular.module('xeditable').directive('editableSelect', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableSelect',
	      inputTpl: '<select></select>',
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          self.scope.$apply(function() {
	            self.scope.$form.$submit();
	          });
	        });
	      }
	    });
	}]);
	//textarea
	angular.module('xeditable').directive('editableTextarea', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableTextarea',
	      inputTpl: '<textarea></textarea>',
	      addListeners: function() {
	        var self = this;
	        self.parent.addListeners.call(self);
	        // submit textarea by ctrl+enter even with buttons
	        if (self.single && self.buttons !== 'no') {
	          self.autosubmit();
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('keydown', function(e) {
	          if ((e.ctrlKey || e.metaKey) && (e.keyCode === 13)) {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }
	        });
	      }
	    });
	}]);
	
	/*
	 AngularJS-native version of Select2 and Selectize
	 https://github.com/angular-ui/ui-select
	 */
	angular.module('xeditable').directive('editableUiSelect',['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	        var rename = function (tag, el) {
	            var newEl = angular.element('<' + tag + '/>');
	            newEl.html(el.html());
	            var attrs = el[0].attributes;
	            for (var i = 0; i < attrs.length; ++i) {
	                newEl.attr(attrs.item(i).nodeName, attrs.item(i).value);
	            }
	            return newEl;
	        };
	
	        var match = null;
	        var choices = null;
	        var dir = editableDirectiveFactory({
	            directiveName: 'editableUiSelect',
	            inputTpl: '<ui-select></ui-select>',
	            render: function () {
	                this.parent.render.call(this);
	                this.inputEl.append(rename('ui-select-match', match));
	                this.inputEl.append(rename('ui-select-choices', choices));
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.attr('ng-model', '$parent.$data');
	            }
	        });
	
	        var linkOrg = dir.link;
	
	        dir.link = function (scope, el, attrs, ctrl) {
	            var matchEl = el.find('editable-ui-select-match');
	            var choicesEl = el.find('editable-ui-select-choices');
	
	            match = matchEl.clone();
	            choices = choicesEl.clone();
	
	            matchEl.remove();
	            choicesEl.remove();
	
	            return linkOrg(scope, el, attrs, ctrl);
	        };
	
	        return dir;
	    }]);
	/**
	 * EditableController class. 
	 * Attached to element with `editable-xxx` directive.
	 *
	 * @namespace editable-element
	 */
	/*
	TODO: this file should be refactored to work more clear without closures!
	*/
	angular.module('xeditable').factory('editableController', 
	  ['$q', 'editableUtils',
	  function($q, editableUtils) {
	
	  //EditableController function
	  EditableController.$inject = ['$scope', '$attrs', '$element', '$parse', 'editableThemes', 'editableIcons', 'editableOptions', '$rootScope', '$compile', '$q'];
	  function EditableController($scope, $attrs, $element, $parse, editableThemes, editableIcons, editableOptions, $rootScope, $compile, $q) {
	    var valueGetter;
	
	    //if control is disabled - it does not participate in waiting process
	    var inWaiting;
	
	    var self = this;
	
	    self.scope = $scope;
	    self.elem = $element;
	    self.attrs = $attrs;
	    self.inputEl = null;
	    self.editorEl = null;
	    self.single = true;
	    self.error = '';
	    self.theme =  editableThemes[editableOptions.theme] || editableThemes['default'];
	    self.parent = {};
	
	    //will be undefined if icon_set is default and theme is default
	    self.icon_set = editableOptions.icon_set === 'default' ? editableIcons.default[editableOptions.theme] : editableIcons.external[editableOptions.icon_set];
	
	    //to be overwritten by directive
	    self.inputTpl = '';
	    self.directiveName = '';
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.useCopy = false;
	
	    //runtime (defaults)
	    self.single = null;
	
	    /**
	     * Attributes defined with `e-*` prefix automatically transfered from original element to
	     * control.  
	     * For example, if you set `<span editable-text="user.name" e-style="width: 100px"`>
	     * then input will appear as `<input style="width: 100px">`.  
	     * See [demo](#text-customize).
	     * 
	     * @var {any|attribute} e-*
	     * @memberOf editable-element
	     */ 
	
	    /**
	     * Whether to show ok/cancel buttons. Values: `right|no`.
	     * If set to `no` control automatically submitted when value changed.  
	     * If control is part of form buttons will never be shown. 
	     * 
	     * @var {string|attribute} buttons
	     * @memberOf editable-element
	     */    
	    self.buttons = 'right'; 
	    /**
	     * Action when control losses focus. Values: `cancel|submit|ignore`.
	     * Has sense only for single editable element.
	     * Otherwise, if control is part of form - you should set `blur` of form, not of individual element.
	     * 
	     * @var {string|attribute} blur
	     * @memberOf editable-element
	     */     
	    // no real `blur` property as it is transfered to editable form
	
	    //init
	    self.init = function(single) {
	      self.single = single;
	
	      self.name = $attrs.eName || $attrs[self.directiveName];
	      /*
	      if(!$attrs[directiveName] && !$attrs.eNgModel && ($attrs.eValue === undefined)) {
	        throw 'You should provide value for `'+directiveName+'` or `e-value` in editable element!';
	      }
	      */
	      if($attrs[self.directiveName]) {
	        valueGetter = $parse($attrs[self.directiveName]);
	      } else {
	        throw 'You should provide value for `'+self.directiveName+'` in editable element!';
	      }
	
	      // settings for single and non-single
	      if (!self.single) {
	        // hide buttons for non-single
	        self.buttons = 'no';
	      } else {
	        self.buttons = self.attrs.buttons || editableOptions.buttons;
	      }
	
	      //if name defined --> watch changes and update $data in form
	      if($attrs.eName) {
	        self.scope.$watch('$data', function(newVal){
	          self.scope.$form.$data[$attrs.eName] = newVal;
	        });
	      }
	
	      /**
	       * Called when control is shown.  
	       * See [demo](#select-remote).
	       * 
	       * @var {method|attribute} onshow
	       * @memberOf editable-element
	       */
	      if($attrs.onshow) {
	        self.onshow = function() {
	          return self.catchError($parse($attrs.onshow)($scope));
	        };
	      }
	
	      /**
	       * Called when control is hidden after both save or cancel.  
	       * 
	       * @var {method|attribute} onhide
	       * @memberOf editable-element
	       */
	      if($attrs.onhide) {
	        self.onhide = function() {
	          return $parse($attrs.onhide)($scope);
	        };
	      }
	
	      /**
	       * Called when control is cancelled.  
	       * 
	       * @var {method|attribute} oncancel
	       * @memberOf editable-element
	       */
	      if($attrs.oncancel) {
	        self.oncancel = function() {
	          return $parse($attrs.oncancel)($scope);
	        };
	      }          
	
	      /**
	       * Called during submit before value is saved to model.  
	       * See [demo](#onbeforesave).
	       * 
	       * @var {method|attribute} onbeforesave
	       * @memberOf editable-element
	       */
	      if ($attrs.onbeforesave) {
	        self.onbeforesave = function() {
	          return self.catchError($parse($attrs.onbeforesave)($scope));
	        };
	      }
	
	      /**
	       * Called during submit after value is saved to model.  
	       * See [demo](#onaftersave).
	       * 
	       * @var {method|attribute} onaftersave
	       * @memberOf editable-element
	       */
	      if ($attrs.onaftersave) {
	        self.onaftersave = function() {
	          return self.catchError($parse($attrs.onaftersave)($scope));
	        };
	      }
	
	      // watch change of model to update editable element
	      // now only add/remove `editable-empty` class.
	      // Initially this method called with newVal = undefined, oldVal = undefined
	      // so no need initially call handleEmpty() explicitly
	      $scope.$parent.$watch($attrs[self.directiveName], function(newVal, oldVal) {
	        self.setLocalValue();
	        self.handleEmpty();
	      });
	    };
	
	    self.render = function() {
	      var theme = self.theme;
	
	      //build input
	      self.inputEl = angular.element(self.inputTpl);
	
	      //build controls
	      self.controlsEl = angular.element(theme.controlsTpl);
	      self.controlsEl.append(self.inputEl);
	
	      //build buttons
	      if(self.buttons !== 'no') {
	        self.buttonsEl = angular.element(theme.buttonsTpl);
	        self.submitEl = angular.element(theme.submitTpl);
	        self.cancelEl = angular.element(theme.cancelTpl);
	        if(self.icon_set) {
	          self.submitEl.find('span').addClass(self.icon_set.ok);
	          self.cancelEl.find('span').addClass(self.icon_set.cancel);
	        }
	        self.buttonsEl.append(self.submitEl).append(self.cancelEl);
	        self.controlsEl.append(self.buttonsEl);
	        
	        self.inputEl.addClass('editable-has-buttons');
	      }
	
	      //build error
	      self.errorEl = angular.element(theme.errorTpl);
	      self.controlsEl.append(self.errorEl);
	
	      //build editor
	      self.editorEl = angular.element(self.single ? theme.formTpl : theme.noformTpl);
	      self.editorEl.append(self.controlsEl);
	
	      // transfer `e-*|data-e-*|x-e-*` attributes
	      for(var k in $attrs.$attr) {
	        if(k.length <= 1) {
	          continue;
	        }
	        var transferAttr = false;
	        var nextLetter = k.substring(1, 2);
	
	        // if starts with `e` + uppercase letter
	        if(k.substring(0, 1) === 'e' && nextLetter === nextLetter.toUpperCase()) {
	          transferAttr = k.substring(1); // cut `e`
	        } else {
	          continue;
	        }
	        
	        // exclude `form` and `ng-submit`, 
	        if(transferAttr === 'Form' || transferAttr === 'NgSubmit') {
	          continue;
	        }
	
	        // convert back to lowercase style
	        transferAttr = transferAttr.substring(0, 1).toLowerCase() + editableUtils.camelToDash(transferAttr.substring(1));  
	
	        // workaround for attributes without value (e.g. `multiple = "multiple"`)
	        // except for 'e-value'
	        var attrValue = (transferAttr !== 'value' && $attrs[k] === '') ? transferAttr : $attrs[k];
	
	        // set attributes to input
	        self.inputEl.attr(transferAttr, attrValue);
	      }
	
	      self.inputEl.addClass('editable-input');
	      self.inputEl.attr('ng-model', '$data');
	
	      // add directiveName class to editor, e.g. `editable-text`
	      self.editorEl.addClass(editableUtils.camelToDash(self.directiveName));
	
	      if(self.single) {
	        self.editorEl.attr('editable-form', '$form');
	        // transfer `blur` to form
	        self.editorEl.attr('blur', self.attrs.blur || (self.buttons === 'no' ? 'cancel' : editableOptions.blurElem));
	      }
	
	      //apply `postrender` method of theme
	      if(angular.isFunction(theme.postrender)) {
	        theme.postrender.call(self);
	      }
	
	    };
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.setLocalValue = function() {
	      self.scope.$data = self.useCopy ? 
	        angular.copy(valueGetter($scope.$parent)) : 
	        valueGetter($scope.$parent);
	    };
	
	    //show
	    self.show = function() {
	      // set value of scope.$data
	      self.setLocalValue();
	
	      /*
	      Originally render() was inside init() method, but some directives polluting editorEl,
	      so it is broken on second openning.
	      Cloning is not a solution as jqLite can not clone with event handler's.
	      */
	      self.render();
	
	      // insert into DOM
	      $element.after(self.editorEl);
	
	      // compile (needed to attach ng-* events from markup)
	      $compile(self.editorEl)($scope);
	
	      // attach listeners (`escape`, autosubmit, etc)
	      self.addListeners();
	
	      // hide element
	      $element.addClass('editable-hide');
	
	      // onshow
	      return self.onshow();
	    };
	
	    //hide
	    self.hide = function() {
	      
	      self.editorEl.remove();
	      $element.removeClass('editable-hide');
	
	      // onhide
	      return self.onhide();
	    };
	
	    // cancel
	    self.cancel = function() {
	      // oncancel
	      self.oncancel();
	      // don't call hide() here as it called in form's code
	    };
	
	    /*
	    Called after show to attach listeners
	    */
	    self.addListeners = function() {
	      // bind keyup for `escape`
	      self.inputEl.bind('keyup', function(e) {
	          if(!self.single) {
	            return;
	          }
	
	          // todo: move this to editable-form!
	          switch(e.keyCode) {
	            // hide on `escape` press
	            case 27:
	              self.scope.$apply(function() {
	                self.scope.$form.$cancel();
	              });
	            break;
	          }
	      });
	
	      // autosubmit when `no buttons`
	      if (self.single && self.buttons === 'no') {
	        self.autosubmit();
	      }
	
	      // click - mark element as clicked to exclude in document click handler
	      self.editorEl.bind('click', function(e) {
	        // ignore right/middle button click
	        if (e.which && e.which !== 1) {
	          return;
	        }
	
	        if (self.scope.$form.$visible) {
	          self.scope.$form._clicked = true;
	        }
	      });
	    };
	
	    // setWaiting
	    self.setWaiting = function(value) {
	      if (value) {
	        // participate in waiting only if not disabled
	        inWaiting = !self.inputEl.attr('disabled') &&
	                    !self.inputEl.attr('ng-disabled') &&
	                    !self.inputEl.attr('ng-enabled');
	        if (inWaiting) {
	          self.inputEl.attr('disabled', 'disabled');
	          if(self.buttonsEl) {
	            self.buttonsEl.find('button').attr('disabled', 'disabled');
	          }
	        }
	      } else {
	        if (inWaiting) {
	          self.inputEl.removeAttr('disabled');
	          if (self.buttonsEl) {
	            self.buttonsEl.find('button').removeAttr('disabled');
	          }
	        }
	      }
	    };
	
	    self.activate = function(start, end) {
	      setTimeout(function() {
	        var el = self.inputEl[0];
	        if (editableOptions.activate === 'focus' && el.focus) {
	          if(start){
	            end = end || start;
	            el.onfocus = function(){
	              var that = this;
	              setTimeout(function(){
	                that.setSelectionRange(start,end);
	              });
	            };
	          }
	          el.focus();
	        }
	        if (editableOptions.activate === 'select' && el.select) {
	          el.select();
	        }
	      }, 0);
	    };
	
	    self.setError = function(msg) {
	      if(!angular.isObject(msg)) {
	        $scope.$error = msg;
	        self.error = msg;
	      }
	    };
	
	    /*
	    Checks that result is string or promise returned string and shows it as error message
	    Applied to onshow, onbeforesave, onaftersave
	    */
	    self.catchError = function(result, noPromise) {
	      if (angular.isObject(result) && noPromise !== true) {
	        $q.when(result).then(
	          //success and fail handlers are equal
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          }),
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          })
	        );
	      //check $http error
	      } else if (noPromise && angular.isObject(result) && result.status &&
	        (result.status !== 200) && result.data && angular.isString(result.data)) {
	        this.setError(result.data);
	        //set result to string: to let form know that there was error
	        result = result.data;
	      } else if (angular.isString(result)) {
	        this.setError(result);
	      }
	      return result;
	    };
	
	    self.save = function() {
	      valueGetter.assign($scope.$parent,
	          self.useCopy ? angular.copy(self.scope.$data) : self.scope.$data);
	
	      // no need to call handleEmpty here as we are watching change of model value
	      // self.handleEmpty();
	    };
	
	    /*
	    attach/detach `editable-empty` class to element
	    */
	    self.handleEmpty = function() {
	      var val = valueGetter($scope.$parent);
	      var isEmpty = val === null || val === undefined || val === "" || (angular.isArray(val) && val.length === 0); 
	      $element.toggleClass('editable-empty', isEmpty);
	    };
	
	    /*
	    Called when `buttons = "no"` to submit automatically
	    */
	    self.autosubmit = angular.noop;
	
	    self.onshow = angular.noop;
	    self.onhide = angular.noop;
	    self.oncancel = angular.noop;
	    self.onbeforesave = angular.noop;
	    self.onaftersave = angular.noop;
	  }
	
	  return EditableController;
	}]);
	
	/*
	editableFactory is used to generate editable directives (see `/directives` folder)
	Inside it does several things:
	- detect form for editable element. Form may be one of three types:
	  1. autogenerated form (for single editable elements)
	  2. wrapper form (element wrapped by <form> tag)
	  3. linked form (element has `e-form` attribute pointing to existing form)
	
	- attach editableController to element
	
	Depends on: editableController, editableFormFactory
	*/
	angular.module('xeditable').factory('editableDirectiveFactory',
	['$parse', '$compile', 'editableThemes', '$rootScope', '$document', 'editableController', 'editableFormController', 'editableOptions',
	function($parse, $compile, editableThemes, $rootScope, $document, editableController, editableFormController, editableOptions) {
	
	  //directive object
	  return function(overwrites) {
	    return {
	      restrict: 'A',
	      scope: true,
	      require: [overwrites.directiveName, '?^form'],
	      controller: editableController,
	      link: function(scope, elem, attrs, ctrl) {
	        // editable controller
	        var eCtrl = ctrl[0];
	
	        // form controller
	        var eFormCtrl;
	
	        // this variable indicates is element is bound to some existing form, 
	        // or it's single element who's form will be generated automatically
	        // By default consider single element without any linked form.ß
	        var hasForm = false;
	     
	        // element wrapped by form
	        if(ctrl[1]) {
	          eFormCtrl = ctrl[1];
	          hasForm = attrs.eSingle === undefined;
	        } else if(attrs.eForm) { // element not wrapped by <form>, but we hane `e-form` attr
	          var getter = $parse(attrs.eForm)(scope);
	          if(getter) { // form exists in scope (above), e.g. editable column
	            eFormCtrl = getter;
	            hasForm = true;
	          } else { // form exists below or not exist at all: check document.forms
	            for(var i=0; i<$document[0].forms.length;i++){
	              if($document[0].forms[i].name === attrs.eForm) {
	                // form is below and not processed yet
	                eFormCtrl = null;
	                hasForm = true;
	                break;
	              }
	            }
	          }
	        }
	
	        /*
	        if(hasForm && !attrs.eName) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        //check for `editable-form` attr in form
	        /*
	        if(eFormCtrl && ) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        // store original props to `parent` before merge
	        angular.forEach(overwrites, function(v, k) {
	          if(eCtrl[k] !== undefined) {
	            eCtrl.parent[k] = eCtrl[k];
	          }
	        });
	
	        // merge overwrites to base editable controller
	        angular.extend(eCtrl, overwrites);
	
	        // x-editable can be disabled using editableOption or edit-disabled attribute
	        var disabled = angular.isDefined(attrs.editDisabled) ?
	          scope.$eval(attrs.editDisabled) :
	          editableOptions.isDisabled;
	
	        if (disabled) {
	          return;
	        }
	        
	        // init editable ctrl
	        eCtrl.init(!hasForm);
	
	        // publich editable controller as `$editable` to be referenced in html
	        scope.$editable = eCtrl;
	
	        // add `editable` class to element
	        elem.addClass('editable');
	
	        // hasForm
	        if(hasForm) {
	          if(eFormCtrl) {
	            scope.$form = eFormCtrl;
	            if(!scope.$form.$addEditable) {
	              throw 'Form with editable elements should have `editable-form` attribute.';
	            }
	            scope.$form.$addEditable(eCtrl);
	          } else {
	            // future form (below): add editable controller to buffer and add to form later
	            $rootScope.$$editableBuffer = $rootScope.$$editableBuffer || {};
	            $rootScope.$$editableBuffer[attrs.eForm] = $rootScope.$$editableBuffer[attrs.eForm] || [];
	            $rootScope.$$editableBuffer[attrs.eForm].push(eCtrl);
	            scope.$form = null; //will be re-assigned later
	          }
	        // !hasForm
	        } else {
	          // create editableform controller
	          scope.$form = editableFormController();
	          // add self to editable controller
	          scope.$form.$addEditable(eCtrl);
	
	          // if `e-form` provided, publish local $form in scope
	          if(attrs.eForm) {
	            scope.$parent[attrs.eForm] = scope.$form;
	          }
	
	          // bind click - if no external form defined
	          if(!attrs.eForm || attrs.eClickable) {
	            elem.addClass('editable-click');
	            elem.bind(editableOptions.activationEvent, function(e) {
	              e.preventDefault();
	              e.editable = eCtrl;
	              scope.$apply(function(){
	                scope.$form.$show();
	              });
	            });
	          }
	        }
	
	      }
	    };
	  };
	}]);
	
	/*
	Returns editableForm controller
	*/
	angular.module('xeditable').factory('editableFormController', 
	  ['$parse', '$document', '$rootScope', 'editablePromiseCollection', 'editableUtils',
	  function($parse, $document, $rootScope, editablePromiseCollection, editableUtils) {
	
	  // array of opened editable forms
	  var shown = [];
	
	  //Check if the child element correspond or is a descendant of the parent element
	  var isSelfOrDescendant = function (parent, child) {
	    if (child == parent) {
	      return true;
	    }
	
	    var node = child.parentNode;
	    while (node !== null) {
	      if (node == parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  };
	  
	  //Check if it is a real blur : if the click event appear on a shown editable elem, this is not a blur.
	  var isBlur = function(shown, event) {
	    var isBlur = true;
	
	    var editables = shown.$editables;
	    angular.forEach(editables, function(v){
	      var element = v.editorEl[0];
	      if (isSelfOrDescendant(element, event.target))
	        isBlur = false;
	      
	    });
	    return isBlur;
	  };
	  
	  // bind click to body: cancel|submit|ignore forms
	  $document.bind('click', function(e) {
	    // ignore right/middle button click
	    if (e.which && e.which !== 1) {
	      return;
	    }
	
	    var toCancel = [];
	    var toSubmit = [];
	    for (var i=0; i<shown.length; i++) {
	
	      // exclude clicked
	      if (shown[i]._clicked) {
	        shown[i]._clicked = false;
	        continue;
	      }
	
	      // exclude waiting
	      if (shown[i].$waiting) {
	        continue;
	      }
	
	      if (shown[i]._blur === 'cancel' && isBlur(shown[i], e)) {
	        toCancel.push(shown[i]);
	      }
	
	      if (shown[i]._blur === 'submit' && isBlur(shown[i], e)) {
	        toSubmit.push(shown[i]);
	      }
	    }
	
	    if (toCancel.length || toSubmit.length) {
	      $rootScope.$apply(function() {
	        angular.forEach(toCancel, function(v){ v.$cancel(); });
	        angular.forEach(toSubmit, function(v){ v.$submit(); });
	      });
	    }
	  });
	 
	  $rootScope.$on('closeEdit', function() {
	    for(var i=0; i < shown.length; i++) {
	      shown[i].$hide();
	    }
	  }); 
	
	  var base = {
	    $addEditable: function(editable) {
	      //console.log('add editable', editable.elem, editable.elem.bind);
	      this.$editables.push(editable);
	
	      //'on' is not supported in angular 1.0.8
	      editable.elem.bind('$destroy', angular.bind(this, this.$removeEditable, editable));
	
	      //bind editable's local $form to self (if not bound yet, below form) 
	      if (!editable.scope.$form) {
	        editable.scope.$form = this;
	      }
	
	      //if form already shown - call show() of new editable
	      if (this.$visible) {
	        editable.catchError(editable.show());
	      }
	      editable.catchError(editable.setWaiting(this.$waiting));
	    },
	
	    $removeEditable: function(editable) {
	      //arrayRemove
	      for(var i=0; i < this.$editables.length; i++) {
	        if(this.$editables[i] === editable) {
	          this.$editables.splice(i, 1);
	          return;
	        }
	      }
	    },
	
	    /**
	     * Shows form with editable controls.
	     * 
	     * @method $show()
	     * @memberOf editable-form
	     */
	    $show: function() {
	      if (this.$visible) {
	        return;
	      }
	
	      this.$visible = true;
	
	      var pc = editablePromiseCollection();
	
	      //own show
	      pc.when(this.$onshow());
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children show
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.show());
	      });
	
	      //wait promises and activate
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, this.$activate), 
	        onFalse: angular.bind(this, this.$activate), 
	        onString: angular.bind(this, this.$activate)
	      });
	
	      // add to internal list of shown forms
	      // setTimeout needed to prevent closing right after opening (e.g. when trigger by button)
	      setTimeout(angular.bind(this, function() {
	        // clear `clicked` to get ready for clicks on visible form
	        this._clicked = false;
	        if(editableUtils.indexOf(shown, this) === -1) {
	          shown.push(this);
	        }
	      }), 0);      
	    },
	
	    /**
	     * Sets focus on form field specified by `name`.
	     * 
	     * @method $activate(name)
	     * @param {string} name name of field
	     * @memberOf editable-form
	     */
	    $activate: function(name) {
	      var i;
	      if (this.$editables.length) {
	        //activate by name
	        if (angular.isString(name)) {
	          for(i=0; i<this.$editables.length; i++) {
	            if (this.$editables[i].name === name) {
	              this.$editables[i].activate();
	              return;
	            }
	          }
	        }
	
	        //try activate error field
	        for(i=0; i<this.$editables.length; i++) {
	          if (this.$editables[i].error) {
	            this.$editables[i].activate();
	            return;
	          }
	        }
	
	        //by default activate first field
	        this.$editables[0].activate(this.$editables[0].elem[0].selectionStart, this.$editables[0].elem[0].selectionEnd);
	      }
	    },
	
	    /**
	     * Hides form with editable controls without saving.
	     * 
	     * @method $hide()
	     * @memberOf editable-form
	     */
	    $hide: function() {
	      if (!this.$visible) {
	        return;
	      }      
	      this.$visible = false;
	      // self hide
	      this.$onhide();
	      // children's hide
	      angular.forEach(this.$editables, function(editable) {
	        editable.hide();
	      });
	
	      // remove from internal list of shown forms
	      editableUtils.arrayRemove(shown, this);
	    },
	
	    /**
	     * Triggers `oncancel` event and calls `$hide()`.
	     * 
	     * @method $cancel()
	     * @memberOf editable-form
	     */
	    $cancel: function() {
	      if (!this.$visible) {
	        return;
	      }      
	      // self cancel
	      this.$oncancel();
	      // children's cancel      
	      angular.forEach(this.$editables, function(editable) {
	        editable.cancel();
	      });
	      // self hide
	      this.$hide();
	    },    
	
	    $setWaiting: function(value) {
	      this.$waiting = !!value;
	      // we can't just set $waiting variable and use it via ng-disabled in children
	      // because in editable-row form is not accessible
	      angular.forEach(this.$editables, function(editable) {
	        editable.setWaiting(!!value);
	      });
	    },
	
	    /**
	     * Shows error message for particular field.
	     * 
	     * @method $setError(name, msg)
	     * @param {string} name name of field
	     * @param {string} msg error message
	     * @memberOf editable-form
	     */
	    $setError: function(name, msg) {
	      angular.forEach(this.$editables, function(editable) {
	        if(!name || editable.name === name) {
	          editable.setError(msg);
	        }
	      });
	    },
	
	    $submit: function() {
	      if (this.$waiting) {
	        return;
	      } 
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children onbeforesave
	      var pc = editablePromiseCollection();
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onbeforesave());
	      });
	
	      /*
	      onbeforesave result:
	      - true/undefined: save data and close form
	      - false: close form without saving
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, checkSelf, true), 
	        onFalse: angular.bind(this, checkSelf, false), 
	        onString: angular.bind(this, this.$activate)
	      });
	
	      //save
	      function checkSelf(childrenTrue){
	        var pc = editablePromiseCollection();
	        pc.when(this.$onbeforesave());
	        pc.then({
	          onWait: angular.bind(this, this.$setWaiting), 
	          onTrue: childrenTrue ? angular.bind(this, this.$save) : angular.bind(this, this.$hide), 
	          onFalse: angular.bind(this, this.$hide), 
	          onString: angular.bind(this, this.$activate)
	        });
	      }
	    },
	
	    $save: function() {
	      // write model for each editable
	      angular.forEach(this.$editables, function(editable) {
	        editable.save();
	      });
	
	      //call onaftersave of self and children
	      var pc = editablePromiseCollection();
	      pc.when(this.$onaftersave());
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onaftersave());
	      });
	
	      /*
	      onaftersave result:
	      - true/undefined/false: just close form
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, this.$hide), 
	        onFalse: angular.bind(this, this.$hide), 
	        onString: angular.bind(this, this.$activate)
	      });
	    },
	
	    $onshow: angular.noop,
	    $oncancel: angular.noop,
	    $onhide: angular.noop,
	    $onbeforesave: angular.noop,
	    $onaftersave: angular.noop
	  };
	
	  return function() {
	    return angular.extend({
	      $editables: [],
	      /**
	       * Form visibility flag.
	       * 
	       * @var {bool} $visible
	       * @memberOf editable-form
	       */
	      $visible: false,
	      /**
	       * Form waiting flag. It becomes `true` when form is loading or saving data.
	       * 
	       * @var {bool} $waiting
	       * @memberOf editable-form
	       */
	      $waiting: false,
	      $data: {},
	      _clicked: false,
	      _blur: null
	    }, base);
	  };
	}]);
	
	/**
	 * EditableForm directive. Should be defined in <form> containing editable controls.  
	 * It add some usefull methods to form variable exposed to scope by `name="myform"` attribute.
	 *
	 * @namespace editable-form
	 */
	angular.module('xeditable').directive('editableForm',
	  ['$rootScope', '$parse', 'editableFormController', 'editableOptions',
	  function($rootScope, $parse, editableFormController, editableOptions) {
	    return {
	      restrict: 'A',
	      require: ['form'],
	      //require: ['form', 'editableForm'],
	      //controller: EditableFormController,
	      compile: function() {
	        return {
	          pre: function(scope, elem, attrs, ctrl) {
	            var form = ctrl[0];
	            var eForm;
	
	            //if `editableForm` has value - publish smartly under this value
	            //this is required only for single editor form that is created and removed
	            if(attrs.editableForm) {
	              if(scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	                eForm = scope[attrs.editableForm];
	                angular.extend(form, eForm);
	              } else {
	                eForm = editableFormController();
	                scope[attrs.editableForm] = eForm;
	                angular.extend(eForm, form);
	              }
	            } else { //just merge to form and publish if form has name
	              eForm = editableFormController();
	              angular.extend(form, eForm);
	            }
	
	            //read editables from buffer (that appeared before FORM tag)
	            var buf = $rootScope.$$editableBuffer;
	            var name = form.$name;
	            if(name && buf && buf[name]) {
	              angular.forEach(buf[name], function(editable) {
	                eForm.$addEditable(editable);
	              });
	              delete buf[name];
	            }
	          },
	          post: function(scope, elem, attrs, ctrl) {
	            var eForm;
	
	            if(attrs.editableForm && scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	              eForm = scope[attrs.editableForm];
	            } else {
	              eForm = ctrl[0];
	            }
	
	            /**
	             * Called when form is shown.
	             * 
	             * @var {method|attribute} onshow 
	             * @memberOf editable-form
	             */
	            if(attrs.onshow) {
	              eForm.$onshow = angular.bind(eForm, $parse(attrs.onshow), scope);
	            }
	
	            /**
	             * Called when form hides after both save or cancel.
	             * 
	             * @var {method|attribute} onhide 
	             * @memberOf editable-form
	             */
	            if(attrs.onhide) {
	              eForm.$onhide = angular.bind(eForm, $parse(attrs.onhide), scope);
	            }
	
	            /**
	             * Called when form is cancelled.
	             * 
	             * @var {method|attribute} oncancel
	             * @memberOf editable-form
	             */
	            if(attrs.oncancel) {
	              eForm.$oncancel = angular.bind(eForm, $parse(attrs.oncancel), scope);
	            }
	
	            /**
	             * Whether form initially rendered in shown state.
	             *
	             * @var {bool|attribute} shown
	             * @memberOf editable-form
	             */
	            if(attrs.shown && $parse(attrs.shown)(scope)) {
	              eForm.$show();
	            }
	
	            /**
	             * Action when form losses focus. Values: `cancel|submit|ignore`.
	             * Default is `ignore`.
	             * 
	             * @var {string|attribute} blur
	             * @memberOf editable-form
	             */
	            eForm._blur = attrs.blur || editableOptions.blurForm;
	
	            // onbeforesave, onaftersave
	            if(!attrs.ngSubmit && !attrs.submit) {
	              /**
	               * Called after all children `onbeforesave` callbacks but before saving form values
	               * to model.  
	               * If at least one children callback returns `non-string` - it will not not be called.  
	               * See [editable-form demo](#editable-form) for details.
	               * 
	               * @var {method|attribute} onbeforesave
	               * @memberOf editable-form
	               * 
	               */
	              if(attrs.onbeforesave) {
	                eForm.$onbeforesave = function() {
	                  return $parse(attrs.onbeforesave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              /**
	               * Called when form values are saved to model.  
	               * See [editable-form demo](#editable-form) for details.
	               * 
	               * @var {method|attribute} onaftersave 
	               * @memberOf editable-form
	               * 
	               */
	              if(attrs.onaftersave) {
	                eForm.$onaftersave = function() {
	                  return $parse(attrs.onaftersave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              elem.bind('submit', function(event) {
	                event.preventDefault();
	                scope.$apply(function() {
	                  eForm.$submit();
	                });
	              });
	            }
	
	
	            // click - mark form as clicked to exclude in document click handler
	            elem.bind('click', function(e) {
	              // ignore right/middle button click
	              if (e.which && e.which !== 1) {
	                return;
	              }
	
	              if (eForm.$visible) {
	                eForm._clicked = true;
	              }
	            });   
	
	          }
	        };
	      }
	    };
	}]);
	/**
	 * editablePromiseCollection
	 *  
	 * Collect results of function calls. Shows waiting if there are promises. 
	 * Finally, applies callbacks if:
	 * - onTrue(): all results are true and all promises resolved to true
	 * - onFalse(): at least one result is false or promise resolved to false
	 * - onString(): at least one result is string or promise rejected or promise resolved to string
	 */
	
	angular.module('xeditable').factory('editablePromiseCollection', ['$q', function($q) { 
	
	  function promiseCollection() {
	    return {
	      promises: [],
	      hasFalse: false,
	      hasString: false,
	      when: function(result, noPromise) {
	        if (result === false) {
	          this.hasFalse = true;
	        } else if (!noPromise && angular.isObject(result)) {
	          this.promises.push($q.when(result));
	        } else if (angular.isString(result)){
	          this.hasString = true;
	        } else { //result === true || result === undefined || result === null
	          return;
	        }
	      },
	      //callbacks: onTrue, onFalse, onString
	      then: function(callbacks) {
	        callbacks = callbacks || {};
	        var onTrue = callbacks.onTrue || angular.noop;
	        var onFalse = callbacks.onFalse || angular.noop;
	        var onString = callbacks.onString || angular.noop;
	        var onWait = callbacks.onWait || angular.noop;
	
	        var self = this;
	
	        if (this.promises.length) {
	          onWait(true);
	          $q.all(this.promises).then(
	            //all resolved       
	            function(results) {
	              onWait(false);
	              //check all results via same `when` method (without checking promises)
	              angular.forEach(results, function(result) {
	                self.when(result, true);  
	              });
	              applyCallback();
	            },
	            //some rejected
	            function(error) { 
	              onWait(false);
	              onString();
	            }
	            );
	        } else {
	          applyCallback();
	        }
	
	        function applyCallback() {
	          if (!self.hasString && !self.hasFalse) {
	            onTrue();
	          } else if (!self.hasString && self.hasFalse) {
	            onFalse();
	          } else {
	            onString();
	          }
	        }
	
	      }
	    };
	  }
	
	  return promiseCollection;
	
	}]);
	
	/**
	 * editableUtils
	 */
	 angular.module('xeditable').factory('editableUtils', [function() {
	  return {
	    indexOf: function (array, obj) {
	      if (array.indexOf) return array.indexOf(obj);
	
	      for ( var i = 0; i < array.length; i++) {
	        if (obj === array[i]) return i;
	      }
	      return -1;
	    },
	
	    arrayRemove: function (array, value) {
	      var index = this.indexOf(array, value);
	      if (index >= 0) {
	        array.splice(index, 1);
	      }
	      return value;
	    },
	
	    // copy from https://github.com/angular/angular.js/blob/master/src/Angular.js
	    camelToDash: function(str) {
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	      return str.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	        return (pos ? '-' : '') + letter.toLowerCase();
	      });
	    },
	
	    dashToCamel: function(str) {
	      var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	      var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	      return str.
	      replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	        return offset ? letter.toUpperCase() : letter;
	      }).
	      replace(MOZ_HACK_REGEXP, 'Moz$1');
	    }
	  };
	}]);
	
	/**
	 * editableNgOptionsParser
	 *
	 * see: https://github.com/angular/angular.js/blob/master/src/ng/directive/select.js#L131
	 */
	 angular.module('xeditable').factory('editableNgOptionsParser', [function() {
	  //0000111110000000000022220000000000000000000000333300000000000000444444444444444000000000555555555555555000000066666666666666600000000000000007777000000000000000000088888
	  var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
	
	  function parser(optionsExp) {
	    var match;
	
	    if (! (match = optionsExp.match(NG_OPTIONS_REGEXP))) {
	      throw 'ng-options parse error';
	    }
	
	    var 
	    displayFn = match[2] || match[1],
	    valueName = match[4] || match[6],
	    keyName = match[5],
	    groupByFn = match[3] || '',
	    valueFn = match[2] ? match[1] : valueName,
	    valuesFn = match[7],
	    track = match[8],
	    trackFn = track ? match[8] : null;
	
	    var ngRepeat;
	    if (keyName === undefined) { // array
	      ngRepeat = valueName + ' in ' + valuesFn;
	      if (track !== undefined) {
	        ngRepeat += ' track by '+trackFn;
	      }
	    } else { // object
	      ngRepeat = '('+keyName+', '+valueName+') in '+valuesFn;
	    }
	    
	    // group not supported yet
	    return {
	      ngRepeat: ngRepeat,
	      locals: {
	        valueName: valueName,
	        keyName: keyName,
	        valueFn: valueFn,
	        displayFn: displayFn
	      }
	    };
	  }
	
	  return parser;
	}]);
	
	/**
	 * editableCombodate
	 *
	 * angular version of https://github.com/vitalets/combodate
	 */
	angular.module('xeditable').factory('editableCombodate', [function() {
	  function Combodate(element, options) {
	    this.$element = angular.element(element);
	
	    if(this.$element[0].nodeName != 'INPUT') {
	      throw 'Combodate should be applied to INPUT element';
	    }
	
	    var currentYear = new Date().getFullYear();
	    this.defaults = {
	      //in this format value stored in original input
	      format: 'YYYY-MM-DD HH:mm',
	      //in this format items in dropdowns are displayed
	      template: 'D / MMM / YYYY   H : mm',
	      //initial value, can be `new Date()`
	      value: null,
	      minYear: 1970,
	      maxYear: currentYear,
	      yearDescending: true,
	      minuteStep: 5,
	      secondStep: 1,
	      firstItem: 'empty', //'name', 'empty', 'none'
	      errorClass: null,
	      customClass: '',
	      roundTime: true, // whether to round minutes and seconds if step > 1
	      smartDays: true // whether days in combo depend on selected month: 31, 30, 28
	    };
	
	    this.options = angular.extend({}, this.defaults, options);
	    this.init();
	  }
	
	  Combodate.prototype = {
	    constructor: Combodate,
	    init: function () {
	      this.map = {
	        //key   regexp    moment.method
	        day:    ['D',    'date'], 
	        month:  ['M',    'month'], 
	        year:   ['Y',    'year'], 
	        hour:   ['[Hh]', 'hours'],
	        minute: ['m',    'minutes'], 
	        second: ['s',    'seconds'],
	        ampm:   ['[Aa]', ''] 
	      };
	      
	      this.$widget = angular.element('<span class="combodate"></span>').html(this.getTemplate());
	      
	      this.initCombos();
	      
	      if (this.options.smartDays) {
	        var combo = this;
	        this.$widget.find('select').bind('change', function(e) {
	          // update days count if month or year changes
	          if (angular.element(e.target).hasClass('month') || angular.element(e.target).hasClass('year')) {
	            combo.fillCombo('day');
	          }
	        });        
	      }
	
	      this.$widget.find('select').css('width', 'auto');
	
	      // hide original input and insert widget                                       
	      this.$element.css('display', 'none').after(this.$widget);
	      
	      // set initial value
	      this.setValue(this.$element.val() || this.options.value);
	    },
	    
	    /*
	     Replace tokens in template with <select> elements 
	     */         
	     getTemplate: function() {
	      var tpl = this.options.template;
	      var customClass = this.options.customClass;
	
	      //first pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0]; 
	        var r = new RegExp(v+'+');
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	        
	        tpl = tpl.replace(r, '{'+token+'}');
	      });
	
	      //replace spaces with &nbsp;
	      tpl = tpl.replace(/ /g, '&nbsp;');
	
	      //second pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0];
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	
	        tpl = tpl.replace('{'+token+'}', '<select class="'+k+' '+customClass+'"></select>');
	      });   
	
	      return tpl;
	    },
	    
	    /*
	     Initialize combos that presents in template 
	     */        
	     initCombos: function() {
	      for (var k in this.map) {
	        var c = this.$widget[0].querySelectorAll('.'+k);
	        // set properties like this.$day, this.$month etc.
	        this['$'+k] = c.length ? angular.element(c) : null;
	        // fill with items
	        this.fillCombo(k);
	      }
	    },
	
	    /*
	     Fill combo with items 
	     */        
	     fillCombo: function(k) {
	      var $combo = this['$'+k];
	      if (!$combo) {
	        return;
	      }
	
	      // define method name to fill items, e.g `fillDays`
	      var f = 'fill' + k.charAt(0).toUpperCase() + k.slice(1); 
	      var items = this[f]();
	      var value = $combo.val();
	
	      $combo.html('');
	      for(var i=0; i<items.length; i++) {
	        $combo.append('<option value="'+items[i][0]+'">'+items[i][1]+'</option>');
	      }
	
	      $combo.val(value);
	    },
	
	    /*
	     Initialize items of combos. Handles `firstItem` option 
	     */
	     fillCommon: function(key) {
	      var values = [], relTime;
	
	      if(this.options.firstItem === 'name') {
	        //need both to support moment ver < 2 and  >= 2
	        relTime = moment.relativeTime || moment.langData()._relativeTime; 
	        var header = typeof relTime[key] === 'function' ? relTime[key](1, true, key, false) : relTime[key];
	        //take last entry (see momentjs lang files structure) 
	        header = header.split(' ').reverse()[0];                
	        values.push(['', header]);
	      } else if(this.options.firstItem === 'empty') {
	        values.push(['', '']);
	      }
	      return values;
	    },  
	
	
	    /*
	    fill day
	    */
	    fillDay: function() {
	      var items = this.fillCommon('d'), name, i,
	      twoDigit = this.options.template.indexOf('DD') !== -1,
	      daysCount = 31;
	
	      // detect days count (depends on month and year)
	      // originally https://github.com/vitalets/combodate/pull/7
	      if (this.options.smartDays && this.$month && this.$year) {
	        var month = parseInt(this.$month.val(), 10);
	        var year = parseInt(this.$year.val(), 10);
	
	        if (!isNaN(month) && !isNaN(year)) {
	          daysCount = moment([year, month]).daysInMonth();
	        }
	      }
	
	      for (i = 1; i <= daysCount; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	    
	    /*
	    fill month
	    */
	    fillMonth: function() {
	      var items = this.fillCommon('M'), name, i, 
	      longNames = this.options.template.indexOf('MMMM') !== -1,
	      shortNames = this.options.template.indexOf('MMM') !== -1,
	      twoDigit = this.options.template.indexOf('MM') !== -1;
	
	      for(i=0; i<=11; i++) {
	        if(longNames) {
	          //see https://github.com/timrwood/momentjs.com/pull/36
	          name = moment().date(1).month(i).format('MMMM');
	        } else if(shortNames) {
	          name = moment().date(1).month(i).format('MMM');
	        } else if(twoDigit) {
	          name = this.leadZero(i+1);
	        } else {
	          name = i+1;
	        }
	        items.push([i, name]);
	      } 
	      return items;
	    },
	    
	    /*
	    fill year
	    */
	    fillYear: function() {
	      var items = [], name, i, 
	      longNames = this.options.template.indexOf('YYYY') !== -1;
	
	      for(i=this.options.maxYear; i>=this.options.minYear; i--) {
	        name = longNames ? i : (i+'').substring(2);
	        items[this.options.yearDescending ? 'push' : 'unshift']([i, name]);
	      }
	      
	      items = this.fillCommon('y').concat(items);
	      
	      return items;
	    },
	    
	    /*
	    fill hour
	    */
	    fillHour: function() {
	      var items = this.fillCommon('h'), name, i,
	      h12 = this.options.template.indexOf('h') !== -1,
	      h24 = this.options.template.indexOf('H') !== -1,
	      twoDigit = this.options.template.toLowerCase().indexOf('hh') !== -1,
	      min = h12 ? 1 : 0, 
	      max = h12 ? 12 : 23;
	
	      for(i=min; i<=max; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      } 
	      return items;
	    },
	
	    /*
	    fill minute
	    */
	    fillMinute: function() {
	      var items = this.fillCommon('m'), name, i,
	      twoDigit = this.options.template.indexOf('mm') !== -1;
	
	      for(i=0; i<=59; i+= this.options.minuteStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	    
	    /*
	    fill second
	    */
	    fillSecond: function() {
	      var items = this.fillCommon('s'), name, i,
	      twoDigit = this.options.template.indexOf('ss') !== -1;
	
	      for(i=0; i<=59; i+= this.options.secondStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }    
	      return items;
	    },
	    
	    /*
	    fill ampm
	    */
	    fillAmpm: function() {
	      var ampmL = this.options.template.indexOf('a') !== -1,
	      ampmU = this.options.template.indexOf('A') !== -1,            
	      items = [
	      ['am', ampmL ? 'am' : 'AM'],
	      ['pm', ampmL ? 'pm' : 'PM']
	      ];
	      return items;
	    },
	
	    /*
	     Returns current date value from combos. 
	     If format not specified - `options.format` used.
	     If format = `null` - Moment object returned.
	     */
	     getValue: function(format) {
	      var dt, values = {}, 
	      that = this,
	      notSelected = false;
	
	      //getting selected values    
	      angular.forEach(this.map, function(v, k) {
	        if(k === 'ampm') {
	          return;
	        }
	        var def = k === 'day' ? 1 : 0;
	
	        values[k] = that['$'+k] ? parseInt(that['$'+k].val(), 10) : def; 
	        
	        if(isNaN(values[k])) {
	         notSelected = true;
	         return false; 
	       }
	     });
	      
	      //if at least one visible combo not selected - return empty string
	      if(notSelected) {
	       return '';
	     }
	
	      //convert hours 12h --> 24h 
	      if(this.$ampm) {
	        //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	        if(values.hour === 12) {
	          values.hour = this.$ampm.val() === 'am' ? 0 : 12;                    
	        } else {
	          values.hour = this.$ampm.val() === 'am' ? values.hour : values.hour+12;
	        }
	      }
	      
	      dt = moment([values.year, values.month, values.day, values.hour, values.minute, values.second]);
	      
	      //highlight invalid date
	      this.highlight(dt);
	
	      format = format === undefined ? this.options.format : format;
	      if(format === null) {
	       return dt.isValid() ? dt : null; 
	     } else {
	       return dt.isValid() ? dt.format(format) : ''; 
	     }
	   },
	
	   setValue: function(value) {
	    if(!value) {
	      return;
	    }
	
	      // parse in strict mode (third param `true`)
	      var dt = typeof value === 'string' ? moment(value, this.options.format, true) : moment(value),
	      that = this,
	      values = {};
	      
	      //function to find nearest value in select options
	      function getNearest($select, value) {
	        var delta = {};
	        angular.forEach($select.children('option'), function(opt, i){
	          var optValue = angular.element(opt).attr('value');
	
	          if(optValue === '') return;
	          var distance = Math.abs(optValue - value); 
	          if(typeof delta.distance === 'undefined' || distance < delta.distance) {
	            delta = {value: optValue, distance: distance};
	          } 
	        }); 
	        return delta.value;
	      }
	      
	      if(dt.isValid()) {
	        //read values from date object
	        angular.forEach(this.map, function(v, k) {
	          if(k === 'ampm') {
	            return; 
	          }
	          values[k] = dt[v[1]]();
	        });
	
	        if(this.$ampm) {
	          //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	          if(values.hour >= 12) {
	            values.ampm = 'pm';
	            if(values.hour > 12) {
	              values.hour -= 12;
	            }
	          } else {
	            values.ampm = 'am';
	            if(values.hour === 0) {
	              values.hour = 12;
	            }
	          }
	        }
	
	        angular.forEach(values, function(v, k) {
	          //call val() for each existing combo, e.g. this.$hour.val()
	          if(that['$'+k]) {
	
	            if(k === 'minute' && that.options.minuteStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }
	           
	           if(k === 'second' && that.options.secondStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }                       
	           
	           that['$'+k].val(v);
	         }
	       });
	
	        // update days count
	        if (this.options.smartDays) {
	          this.fillCombo('day');
	        }
	
	        this.$element.val(dt.format(this.options.format)).triggerHandler('change');
	      }
	    },
	    
	    /*
	     highlight combos if date is invalid
	     */
	     highlight: function(dt) {
	      if(!dt.isValid()) {
	        if(this.options.errorClass) {
	          this.$widget.addClass(this.options.errorClass);
	        } else {
	          //store original border color
	          if(!this.borderColor) {
	            this.borderColor = this.$widget.find('select').css('border-color'); 
	          }
	          this.$widget.find('select').css('border-color', 'red');
	        }
	      } else {
	        if(this.options.errorClass) {
	          this.$widget.removeClass(this.options.errorClass);
	        } else {
	          this.$widget.find('select').css('border-color', this.borderColor);
	        }  
	      }
	    },
	    
	    leadZero: function(v) {
	      return v <= 9 ? '0' + v : v; 
	    },
	    
	    destroy: function() {
	      this.$widget.remove();
	      this.$element.removeData('combodate').show();
	    }
	
	  };
	
	  return {
	    getInstance: function(element, options) {
	      return new Combodate(element, options);
	    }
	  };
	}]);
	
	/*
	Editable icons:
	- default
	- font-awesome
	
	*/
	angular.module('xeditable').factory('editableIcons', function() {
	
	  var icons = {
	    //Icon-set to use, defaults to bootstrap icons
	    default: {
	      'bs2': {
	        ok: 'icon-ok icon-white',
	        cancel: 'icon-remove'
	      },
	      'bs3': {
	        ok: 'glyphicon glyphicon-ok',
	        cancel: 'glyphicon glyphicon-remove'
	      }
	    },
	    external: {
	      'font-awesome': {
	        ok: 'fa fa-check',
	        cancel: 'fa fa-times'
	      }
	    }
	  };
	
	  return icons;
	});
	
	/*
	Editable themes:
	- default
	- bootstrap 2
	- bootstrap 3
	- semantic-ui
	
	Note: in postrender() `this` is instance of editableController
	*/
	angular.module('xeditable').factory('editableThemes', function() {
	  var themes = {
	    //default
	    'default': {
	      formTpl:      '<form class="editable-wrap"></form>',
	      noformTpl:    '<span class="editable-wrap"></span>',
	      controlsTpl:  '<span class="editable-controls"></span>',
	      inputTpl:     '',
	      errorTpl:     '<div class="editable-error" ng-show="$error" ng-bind="$error"></div>',
	      buttonsTpl:   '<span class="editable-buttons"></span>',
	      submitTpl:    '<button type="submit">save</button>',
	      cancelTpl:    '<button type="button" ng-click="$form.$cancel()">cancel</button>'
	    },
	
	    //bs2
	    'bs2': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls controls control-group" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" ng-show="$error" ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn" ng-click="$form.$cancel()">'+
	                      '<span></span>'+
	                   '</button>'
	
	    },
	
	    //bs3
	    'bs3': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls form-group" ng-class="{\'has-error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" ng-show="$error" ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn btn-default" ng-click="$form.$cancel()">'+
	                     '<span></span>'+
	                   '</button>',
	
	      //bs3 specific prop to change buttons class: btn-sm, btn-lg
	      buttonsClass: '',
	      //bs3 specific prop to change standard inputs class: input-sm, input-lg
	      inputClass: '',
	      postrender: function() {
	        //apply `form-control` class to std inputs
	        switch(this.directiveName) {
	          case 'editableText':
	          case 'editableSelect':
	          case 'editableTextarea':
	          case 'editableEmail':
	          case 'editableTel':
	          case 'editableNumber':
	          case 'editableUrl':
	          case 'editableSearch':
	          case 'editableDate':
	          case 'editableDatetime':
	          case 'editableBsdate':
	          case 'editableTime':
	          case 'editableMonth':
	          case 'editableWeek':
	          case 'editablePassword':
	            this.inputEl.addClass('form-control');
	            if(this.theme.inputClass) {
	              // don`t apply `input-sm` and `input-lg` to select multiple
	              // should be fixed in bs itself!
	              if(this.inputEl.attr('multiple') &&
	                (this.theme.inputClass === 'input-sm' || this.theme.inputClass === 'input-lg')) {
	                  break;
	              }
	              this.inputEl.addClass(this.theme.inputClass);
	            }
	          break;
	          case 'editableCheckbox':
	              this.editorEl.addClass('checkbox');
	        }
	
	        //apply buttonsClass (bs3 specific!)
	        if(this.buttonsEl && this.theme.buttonsClass) {
	          this.buttonsEl.find('button').addClass(this.theme.buttonsClass);
	        }
	      }
	    },
	    
	    //semantic-ui
	    'semantic': {
	      formTpl:     '<form class="editable-wrap ui form" ng-class="{\'error\': $error}" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls ui fluid input" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error ui error message" ng-show="$error" ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="mini ui buttons"></span>',
	      submitTpl:   '<button type="submit" class="ui primary button"><i class="ui check icon"></i></button>',
	      cancelTpl:   '<button type="button" class="ui button" ng-click="$form.$cancel()">'+
	                      '<i class="ui cancel icon"></i>'+
	                   '</button>'
	    }
	  };
	
	  return themes;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/**
	 * @license AngularJS v1.3.20
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, document, undefined) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      prefix = '[' + (module ? module + ':' : '') + code + '] ',
	      template = arguments[1],
	      templateArgs = arguments,
	
	      message, i;
	
	    message = prefix + template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1), arg;
	
	      if (index + 2 < templateArgs.length) {
	        return toDebugString(templateArgs[index + 2]);
	      }
	      return match;
	    });
	
	    message = message + '\nhttp://errors.angularjs.org/1.3.20/' +
	      (module ? module + '/' : '') + code;
	    for (i = 2; i < arguments.length; i++) {
	      message = message + (i == 2 ? '?' : '&') + 'p' + (i - 2) + '=' +
	        encodeURIComponent(toDebugString(arguments[i]));
	    }
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  sortedKeys: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  int: true,
	  inherit: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  shallowCopy: true,
	  equals: true,
	  csp: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives.
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	  if (obj == null || isWindow(obj)) {
	    return false;
	  }
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  if (obj.nodeType === NODE_TYPE_ELEMENT && length) {
	    return true;
	  }
	
	  return isString(obj) || isArray(obj) || length === 0 ||
	         typeof length === 'number' && length > 0 && (length - 1) in obj;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * Providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else {
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function sortedKeys(obj) {
	  return Object.keys(obj).sort();
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = sortedKeys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) { iteratorFn(key, value); };
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 * Note: Keep in mind that `angular.extend` does not support recursive merge (deep copy).
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  var h = dst.$$hashKey;
	
	  for (var i = 1, ii = arguments.length; i < ii; i++) {
	    var obj = arguments[i];
	    if (obj) {
	      var keys = Object.keys(obj);
	      for (var j = 0, jj = keys.length; j < jj; j++) {
	        var key = keys[j];
	        dst[key] = obj[key];
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	function int(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	     function transformer(transformationFn, value) {
	       return (transformationFn || angular.identity)(value);
	     };
	   ```
	  * @param {*} value to be returned.
	  * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function() {return value;};}
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // we are a direct element
	    || (node.prop && node.attr && node.find)));  // we have an on and find method part of jQuery API
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(","), i;
	  for (i = 0; i < items.length; i++)
	    obj[items[i]] = true;
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0)
	    array.splice(index, 1);
	  return value;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to 'destination' an exception will be thrown.
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	 <example module="copyExample">
	 <file name="index.html">
	 <div ng-controller="ExampleController">
	 <form novalidate class="simple-form">
	 Name: <input type="text" ng-model="user.name" /><br />
	 E-mail: <input type="email" ng-model="user.email" /><br />
	 Gender: <input type="radio" ng-model="user.gender" value="male" />male
	 <input type="radio" ng-model="user.gender" value="female" />female<br />
	 <button ng-click="reset()">RESET</button>
	 <button ng-click="update(user)">SAVE</button>
	 </form>
	 <pre>form = {{user | json}}</pre>
	 <pre>master = {{master | json}}</pre>
	 </div>
	
	 <script>
	  angular.module('copyExample', [])
	    .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	 </script>
	 </file>
	 </example>
	 */
	function copy(source, destination, stackSource, stackDest) {
	  if (isWindow(source) || isScope(source)) {
	    throw ngMinErr('cpws',
	      "Can't copy! Making copies of Window or Scope instances is not supported.");
	  }
	
	  if (!destination) {
	    destination = source;
	    if (source) {
	      if (isArray(source)) {
	        destination = copy(source, [], stackSource, stackDest);
	      } else if (isDate(source)) {
	        destination = new Date(source.getTime());
	      } else if (isRegExp(source)) {
	        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        destination.lastIndex = source.lastIndex;
	      } else if (isObject(source)) {
	        var emptyObject = Object.create(Object.getPrototypeOf(source));
	        destination = copy(source, emptyObject, stackSource, stackDest);
	      }
	    }
	  } else {
	    if (source === destination) throw ngMinErr('cpi',
	      "Can't copy! Source and destination are identical.");
	
	    stackSource = stackSource || [];
	    stackDest = stackDest || [];
	
	    if (isObject(source)) {
	      var index = stackSource.indexOf(source);
	      if (index !== -1) return stackDest[index];
	
	      stackSource.push(source);
	      stackDest.push(destination);
	    }
	
	    var result;
	    if (isArray(source)) {
	      destination.length = 0;
	      for (var i = 0; i < source.length; i++) {
	        result = copy(source[i], null, stackSource, stackDest);
	        if (isObject(source[i])) {
	          stackSource.push(source[i]);
	          stackDest.push(result);
	        }
	        destination.push(result);
	      }
	    } else {
	      var h = destination.$$hashKey;
	      if (isArray(destination)) {
	        destination.length = 0;
	      } else {
	        forEach(destination, function(value, key) {
	          delete destination[key];
	        });
	      }
	      for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	          result = copy(source[key], null, stackSource, stackDest);
	          if (isObject(source[key])) {
	            stackSource.push(source[key]);
	            stackDest.push(result);
	          }
	          destination[key] = result;
	        }
	      }
	      setHashKey(destination,h);
	    }
	
	  }
	  return destination;
	}
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2) {
	    if (t1 == 'object') {
	      if (isArray(o1)) {
	        if (!isArray(o2)) return false;
	        if ((length = o1.length) == o2.length) {
	          for (key = 0; key < length; key++) {
	            if (!equals(o1[key], o2[key])) return false;
	          }
	          return true;
	        }
	      } else if (isDate(o1)) {
	        if (!isDate(o2)) return false;
	        return equals(o1.getTime(), o2.getTime());
	      } else if (isRegExp(o1)) {
	        return isRegExp(o2) ? o1.toString() == o2.toString() : false;
	      } else {
	        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	          isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	        keySet = {};
	        for (key in o1) {
	          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	          if (!equals(o1[key], o2[key])) return false;
	          keySet[key] = true;
	        }
	        for (key in o2) {
	          if (!keySet.hasOwnProperty(key) &&
	              key.charAt(0) !== '$' &&
	              o2[key] !== undefined &&
	              !isFunction(o2[key])) return false;
	        }
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (isDefined(csp.isActive_)) return csp.isActive_;
	
	  var active = !!(document.querySelector('[ng-csp]') ||
	                  document.querySelector('[data-ng-csp]'));
	
	  if (!active) {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	    } catch (e) {
	      active = true;
	    }
	  }
	
	  return (csp.isActive_ = active);
	};
	
	
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // in IE, native methods are not functions so they cannot be bound (note: they don't need to be)
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 */
	function toJson(obj, pretty) {
	  if (typeof obj === 'undefined') return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) { return '<' + lowercase(nodeName); });
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {}, key_value, key;
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    if (keyValue) {
	      key_value = keyValue.replace(/\+/g,'%20').split('=');
	      key = tryDecodeURIComponent(key_value[0]);
	      if (isDefined(key)) {
	        var val = isDefined(key_value[1]) ? tryDecodeURIComponent(key_value[1]) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  element = jqLite(element);
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.attr(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * Only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 * found in the document will be used to define the root element to auto-bootstrap as an
	 * application. To run multiple applications in an HTML document you must manually bootstrap them using
	 * {@link angular.bootstrap} instead. AngularJS applications cannot be nested within each other.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * See: {@link guide/bootstrap Bootstrap}
	 *
	 * Note that Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === document) ? 'document' : startingTag(element);
	      //Encode angle brackets to prevent input from being sanitized to empty string #8683
	      throw ngMinErr(
	          'btstrpd',
	          "App Already Bootstrapped with this Element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	var skipDestroyOnNextJQueryCleanData;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  jQuery = window.jQuery;
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      if (!skipDestroyOnNextJQueryCleanData) {
	        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	          events = jQuery._data(elem, "events");
	          if (events && events.$destroy) {
	            jQuery(elem).triggerHandler('$destroy');
	          }
	        }
	      } else {
	        skipDestroyOnNextJQueryCleanData = false;
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {jqLite} jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
	  //             collection, otherwise update the original collection.
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes = [node];
	
	  do {
	    node = node.nextSibling;
	    if (!node) break;
	    blockNodes.push(node);
	  } while (node !== endNode);
	
	  return jqLite(blockNodes);
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * When passed two or more arguments, a new module is created.  If passed only one argument, an
	     * existing module (the name passed as the first argument to `module`) is retrieved.
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLater('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLater('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLater('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constant are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link ngAnimate.$animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLater('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLater('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLater('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLater('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global: toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '<<already seen>>';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (typeof obj === 'undefined') {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $LocaleProvider,
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCspDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpBackendProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $$AsyncCallbackProvider,
	  $WindowProvider,
	  $$jqLiteProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version. This object has the
	 * following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.3.20',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 3,
	  dot: 20,
	  codeName: 'shallow-translucence'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	  try {
	    angularModule('ngLocale');
	  } catch (e) {
	    angularModule('ngLocale', []).provider('$locale', $LocaleProvider);
	  }
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpBackend: $HttpBackendProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$asyncCallback: $$AsyncCallbackProvider,
	        $$jqLite: $$jqLiteProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or "jqLite."
	 *
	 * <div class="alert alert-success">jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. **jqLite** implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.</div>
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file.
	 *
	 * <div class="alert">**Note:** all element references in Angular are always wrapped with jQuery or
	 * jqLite; they are never raw DOM references.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/)
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`. As a setter, does not convert numbers to strings or append 'px'.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces or selectors
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/)
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/)
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers.
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = tmp || fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	    forEach(type.split(' '), function(type) {
	      if (isDefined(fn)) {
	        var listenerFns = events[type];
	        arrayRemove(listenerFns || [], fn);
	        if (listenerFns && listenerFns.length > 0) {
	          return;
	        }
	      }
	
	      removeEventListenerFn(element, type, handle);
	      delete events[type];
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if ((value = jqLite.data(element, names[i])) !== undefined) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behaviour
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (document.readyState === 'complete') {
	      setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(element, name) {
	  var nodeName = element.nodeName;
	  return (nodeName === 'INPUT' || nodeName === 'TEXTAREA') && ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2) === undefined)) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (value === undefined) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        eventFns[i].call(element, event);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    while (i--) {
	      type = types[i];
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        events[type] = [];
	
	        if (type === 'mouseenter' || type === 'mouseleave') {
	          // Refer to jQuery's implementation of mouseenter & mouseleave
	          // Read about mouseenter and mouseleave:
	          // http://www.quirksmode.org/js/events_mouse.html#link8
	
	          jqLiteOn(element, MOUSE_EVENT_MAP[type], function(event) {
	            var target = this, related = event.relatedTarget;
	            // For mousenter/leave call the handler if related is outside the target.
	            // NB: No relatedTarget if the mouse left/entered the browser window
	            if (!related || (related !== target && !target.contains(related))) {
	              handle(event, type);
	            }
	          });
	
	        } else {
	          if (type !== '$destroy') {
	            addEventListenerFn(element, type, handle);
	          }
	        }
	        eventFns = events[type];
	      }
	      eventFns.push(fn);
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT)
	        children.push(element);
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    wrapNode = jqLite(wrapNode).eq(0).clone()[0];
	    var parent = element.parentNode;
	    if (parent) {
	      parent.replaceChild(wrapNode, element);
	    }
	    wrapNode.appendChild(element);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var FN_ARGS = /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var fnText = fn.toString().replace(STRIP_COMMENTS, ''),
	      args = fnText.match(FN_ARGS);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      fnText,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        fnText = fn.toString().replace(STRIP_COMMENTS, '');
	        argDecl = fnText.match(FN_ARGS);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(fn)} - registers a service **factory function**, `fn`,
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(class)} - registers a **constructor function**, `class`
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is the service
	 * constructor function that will be used to instantiate the service instance.
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function.  This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular
	 * {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service**, such as a string, a number, an array, an object or a function,
	 * with the {@link auto.$injector $injector}. Unlike {@link auto.$provide#value value} it can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **service decorator** with the {@link auto.$injector $injector}. A service decorator
	 * intercepts the creation of a service, allowing it to override or modify the behaviour of the
	 * service. The object returned by the decorator may be the original service, or a new service
	 * object which replaces or wraps and delegates to the original service.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    instantiated and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      instanceInjector = (instanceCache.$injector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
	          }));
	
	
	  forEach(loadModules(modulesToLoad), function(fn) { instanceInjector.invoke(fn || noop); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName),
	          length, i,
	          key;
	
	      for (i = 0, length = $inject.length; i < length; i++) {
	        key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(
	          locals && locals.hasOwnProperty(key)
	          ? locals[key]
	          : getService(key, serviceName)
	        );
	      }
	      if (isArray(fn)) {
	        fn = fn[length];
	      }
	
	      // http://jsperf.com/angularjs-invoke-apply-vs-switch
	      // #5388
	      return fn.apply(self, args);
	    }
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      // Object creation: http://jsperf.com/create-constructor/2
	      var instance = Object.create((isArray(Type) ? Type[Type.length - 1] : Type).prototype || null);
	      var returnedValue = invoke(Type, instance, locals, serviceName);
	
	      return isObject(returnedValue) || isFunction(returnedValue) ? returnedValue : instance;
	    }
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it checks the current value of {@link ng.$location#hash $location.hash()} and
	   * scrolls to the related element, according to the rules specified in the
	   * [Html5 spec](http://dev.w3.org/html5/spec/Overview.html#the-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll() {
	      var hash = $location.hash(), elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM
	 * updates and calls done() callbacks.
	 *
	 * In order to enable animations the ngAnimate module has to be loaded.
	 *
	 * To see the functional implementation check out src/ngAnimate/animate.js
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	
	
	  this.$$selectors = {};
	
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(Element, doneFunction)` The element to animate, the `doneFunction`
	   *   must be called once the element animation is complete. If a function is returned then the
	   *   animation service will use this function to cancel the animation whenever a cancel event is
	   *   triggered.
	   *
	   *
	   * ```js
	   *   return {
	     *     eventFn : function(element, done) {
	     *       //code to run the animation
	     *       //once complete, then run done()
	     *       return function cancellationFunction() {
	     *         //code to cancel the animation
	     *       }
	     *     }
	     *   }
	   * ```
	   *
	   * @param {string} name The name of the animation.
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    var key = name + '-animation';
	    if (name && name.charAt(0) != '.') throw $animateMinErr('notcsel',
	        "Expecting class selector starting with '.' got '{0}'.", name);
	    this.$$selectors[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element.
	   * When setting the classNameFilter value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$q', '$$asyncCallback', '$rootScope', function($$q, $$asyncCallback, $rootScope) {
	
	    var currentDefer;
	
	    function runAnimationPostDigest(fn) {
	      var cancelFn, defer = $$q.defer();
	      defer.promise.$$cancelFn = function ngAnimateMaybeCancel() {
	        cancelFn && cancelFn();
	      };
	
	      $rootScope.$$postDigest(function ngAnimatePostDigest() {
	        cancelFn = fn(function ngAnimateNotifyComplete() {
	          defer.resolve();
	        });
	      });
	
	      return defer.promise;
	    }
	
	    function resolveElementClasses(element, classes) {
	      var toAdd = [], toRemove = [];
	
	      var hasClasses = createMap();
	      forEach((element.attr('class') || '').split(/\s+/), function(className) {
	        hasClasses[className] = true;
	      });
	
	      forEach(classes, function(status, className) {
	        var hasClass = hasClasses[className];
	
	        // If the most recent class manipulation (via $animate) was to remove the class, and the
	        // element currently has the class, the class is scheduled for removal. Otherwise, if
	        // the most recent class manipulation (via $animate) was to add the class, and the
	        // element does not currently have the class, the class is scheduled to be added.
	        if (status === false && hasClass) {
	          toRemove.push(className);
	        } else if (status === true && !hasClass) {
	          toAdd.push(className);
	        }
	      });
	
	      return (toAdd.length + toRemove.length) > 0 &&
	        [toAdd.length ? toAdd : null, toRemove.length ? toRemove : null];
	    }
	
	    function cachedClassManipulation(cache, classes, op) {
	      for (var i=0, ii = classes.length; i < ii; ++i) {
	        var className = classes[i];
	        cache[className] = op;
	      }
	    }
	
	    function asyncPromise() {
	      // only serve one instance of a promise in order to save CPU cycles
	      if (!currentDefer) {
	        currentDefer = $$q.defer();
	        $$asyncCallback(function() {
	          currentDefer.resolve();
	          currentDefer = null;
	        });
	      }
	      return currentDefer.promise;
	    }
	
	    function applyStyles(element, options) {
	      if (angular.isObject(options)) {
	        var styles = extend(options.from || {}, options.to || {});
	        element.css(styles);
	      }
	    }
	
	    /**
	     *
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service provides rudimentary DOM manipulation functions to
	     * insert, remove and move elements within the DOM, as well as adding and removing classes.
	     * This service is the core service used by the ngAnimate $animator service which provides
	     * high-level animation hooks for CSS and JavaScript.
	     *
	     * $animate is available in the AngularJS core, however, the ngAnimate module must be included
	     * to enable full out animation support. Otherwise, $animate will only perform simple DOM
	     * manipulation operations.
	     *
	     * To learn more about enabling animation support, click here to visit the {@link ngAnimate
	     * ngAnimate module page} as well as the {@link ngAnimate.$animate ngAnimate $animate service
	     * page}.
	     */
	    return {
	      animate: function(element, from, to) {
	        applyStyles(element, { from: from, to: to });
	        return asyncPromise();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element or
	       * as the first child within the `parent` element. When the function is called a promise
	       * is returned that will be resolved at a later time.
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (if the after element is not present)
	       * @param {DOMElement} after the sibling element which will append the element
	       *   after itself
	       * @param {object=} options an optional collection of styles that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        applyStyles(element, options);
	        after ? after.after(element)
	              : parent.prepend(element);
	        return asyncPromise();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Removes the element from the DOM. When the function is called a promise
	       * is returned that will be resolved at a later time.
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        applyStyles(element, options);
	        element.remove();
	        return asyncPromise();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Moves the position of the provided element within the DOM to be placed
	       * either after the `after` element or inside of the `parent` element. When the function
	       * is called a promise is returned that will be resolved at a later time.
	       *
	       * @param {DOMElement} element the element which will be moved around within the
	       *   DOM
	       * @param {DOMElement} parent the parent element where the element will be
	       *   inserted into (if the after element is not present)
	       * @param {DOMElement} after the sibling element where the element will be
	       *   positioned next to
	       * @param {object=} options an optional collection of options that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        // Do not remove element before insert. Removing will cause data associated with the
	        // element to be dropped. Insert will implicitly do the remove.
	        return this.enter(element, parent, after, options);
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       * @description Adds the provided className CSS class value to the provided element.
	       * When the function is called a promise is returned that will be resolved at a later time.
	       * @param {DOMElement} element the element which will have the className value
	       *   added to it
	       * @param {string} className the CSS class which will be added to the element
	       * @param {object=} options an optional collection of options that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        return this.setClass(element, className, [], options);
	      },
	
	      $$addClassImmediately: function(element, className, options) {
	        element = jqLite(element);
	        className = !isString(className)
	                        ? (isArray(className) ? className.join(' ') : '')
	                        : className;
	        forEach(element, function(element) {
	          jqLiteAddClass(element, className);
	        });
	        applyStyles(element, options);
	        return asyncPromise();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       * @description Removes the provided className CSS class value from the provided element.
	       * When the function is called a promise is returned that will be resolved at a later time.
	       * @param {DOMElement} element the element which will have the className value
	       *   removed from it
	       * @param {string} className the CSS class which will be removed from the element
	       * @param {object=} options an optional collection of options that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        return this.setClass(element, [], className, options);
	      },
	
	      $$removeClassImmediately: function(element, className, options) {
	        element = jqLite(element);
	        className = !isString(className)
	                        ? (isArray(className) ? className.join(' ') : '')
	                        : className;
	        forEach(element, function(element) {
	          jqLiteRemoveClass(element, className);
	        });
	        applyStyles(element, options);
	        return asyncPromise();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       * @description Adds and/or removes the given CSS classes to and from the element.
	       * When the function is called a promise is returned that will be resolved at a later time.
	       * @param {DOMElement} element the element which will have its CSS classes changed
	       *   removed from it
	       * @param {string} add the CSS classes which will be added to the element
	       * @param {string} remove the CSS class which will be removed from the element
	       * @param {object=} options an optional collection of options that will be applied to the element.
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        var self = this;
	        var STORAGE_KEY = '$$animateClasses';
	        var createdCache = false;
	        element = jqLite(element);
	
	        var cache = element.data(STORAGE_KEY);
	        if (!cache) {
	          cache = {
	            classes: {},
	            options: options
	          };
	          createdCache = true;
	        } else if (options && cache.options) {
	          cache.options = angular.extend(cache.options || {}, options);
	        }
	
	        var classes = cache.classes;
	
	        add = isArray(add) ? add : add.split(' ');
	        remove = isArray(remove) ? remove : remove.split(' ');
	        cachedClassManipulation(classes, add, true);
	        cachedClassManipulation(classes, remove, false);
	
	        if (createdCache) {
	          cache.promise = runAnimationPostDigest(function(done) {
	            var cache = element.data(STORAGE_KEY);
	            element.removeData(STORAGE_KEY);
	
	            // in the event that the element is removed before postDigest
	            // is run then the cache will be undefined and there will be
	            // no need anymore to add or remove and of the element classes
	            if (cache) {
	              var classes = resolveElementClasses(element, cache.classes);
	              if (classes) {
	                self.$$setClassImmediately(element, classes[0], classes[1], cache.options);
	              }
	            }
	
	            done();
	          });
	          element.data(STORAGE_KEY, cache);
	        }
	
	        return cache.promise;
	      },
	
	      $$setClassImmediately: function(element, add, remove, options) {
	        add && this.$$addClassImmediately(element, add);
	        remove && this.$$removeClassImmediately(element, remove);
	        applyStyles(element, options);
	        return asyncPromise();
	      },
	
	      enabled: noop,
	      cancel: noop
	    };
	  }];
	}];
	
	function $$AsyncCallbackProvider() {
	  this.$get = ['$$rAF', '$timeout', function($$rAF, $timeout) {
	    return $$rAF.supported
	      ? function(fn) { return $$rAF(fn); }
	      : function(fn) {
	        return $timeout(fn, 0, false);
	      };
	  }];
	}
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      rawDocument = document[0],
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    // force browser to execute all pollFns - this is needed so that cookies and other pollers fire
	    // at some deterministic time in respect to the test runner's actions. Leaving things up to the
	    // regular poller would result in flaky tests.
	    forEach(pollFns, function(pollFn) { pollFn(); });
	
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // Poll Watcher API
	  //////////////////////////////////////////////////////////////
	  var pollFns = [],
	      pollTimeout;
	
	  /**
	   * @name $browser#addPollFn
	   *
	   * @param {function()} fn Poll function to add
	   *
	   * @description
	   * Adds a function to the list of functions that poller periodically executes,
	   * and starts polling if not started yet.
	   *
	   * @returns {function()} the added function
	   */
	  self.addPollFn = function(fn) {
	    if (isUndefined(pollTimeout)) startPoller(100, setTimeout);
	    pollFns.push(fn);
	    return fn;
	  };
	
	  /**
	   * @param {number} interval How often should browser call poll functions (ms)
	   * @param {function()} setTimeout Reference to a real or fake `setTimeout` function.
	   *
	   * @description
	   * Configures the poller to run in the specified intervals, using the specified
	   * setTimeout fn and kicks it off.
	   */
	  function startPoller(interval, setTimeout) {
	    (function check() {
	      forEach(pollFns, function(pollFn) { pollFn(); });
	      pollTimeout = setTimeout(check, interval);
	    })();
	  }
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      reloadLocation = null;
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase || reloadLocation) {
	          reloadLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	      }
	      return self;
	    // getter
	    } else {
	      // - reloadLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened.
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return reloadLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    cacheState();
	    fireUrlChange();
	  }
	
	  function getCurrentState() {
	    try {
	      return history.state;
	    } catch (e) {
	      // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	    }
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  //////////////////////////////////////////////////////////////
	  // Cookies API
	  //////////////////////////////////////////////////////////////
	  var lastCookies = {};
	  var lastCookieString = '';
	  var cookiePath = self.baseHref();
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  /**
	   * @name $browser#cookies
	   *
	   * @param {string=} name Cookie name
	   * @param {string=} value Cookie value
	   *
	   * @description
	   * The cookies method provides a 'private' low level access to browser cookies.
	   * It is not meant to be used directly, use the $cookie service instead.
	   *
	   * The return values vary depending on the arguments that the method was called with as follows:
	   *
	   * - cookies() -> hash of all cookies, this is NOT a copy of the internal state, so do not modify
	   *   it
	   * - cookies(name, value) -> set name to value, if value is undefined delete the cookie
	   * - cookies(name) -> the same as (name, undefined) == DELETES (no one calls it right now that
	   *   way)
	   *
	   * @returns {Object} Hash of all cookies (if called without any parameter)
	   */
	  self.cookies = function(name, value) {
	    var cookieLength, cookieArray, cookie, i, index;
	
	    if (name) {
	      if (value === undefined) {
	        rawDocument.cookie = encodeURIComponent(name) + "=;path=" + cookiePath +
	                                ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
	      } else {
	        if (isString(value)) {
	          cookieLength = (rawDocument.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
	                                ';path=' + cookiePath).length + 1;
	
	          // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	          // - 300 cookies
	          // - 20 cookies per unique domain
	          // - 4096 bytes per cookie
	          if (cookieLength > 4096) {
	            $log.warn("Cookie '" + name +
	              "' possibly not set or overflowed because it was too large (" +
	              cookieLength + " > 4096 bytes)!");
	          }
	        }
	      }
	    } else {
	      if (rawDocument.cookie !== lastCookieString) {
	        lastCookieString = rawDocument.cookie;
	        cookieArray = lastCookieString.split("; ");
	        lastCookies = {};
	
	        for (i = 0; i < cookieArray.length; i++) {
	          cookie = cookieArray[i];
	          index = cookie.indexOf('=');
	          if (index > 0) { //ignore nameless cookies
	            name = safeDecodeURIComponent(cookie.substring(0, index));
	            // the first value that is seen for a cookie is the most
	            // specific one.  values for the same cookie name that
	            // follow are for less specific paths.
	            if (lastCookies[name] === undefined) {
	              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	            }
	          }
	        }
	      }
	      return lastCookies;
	    }
	  };
	
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if ($scope.cache.get(key) === undefined) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, value === undefined ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = {},
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = {},
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (isUndefined(value)) return;
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = {};
	          size = 0;
	          lruHash = {};
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	 * or just the `postLink` function (all other properties will have the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioural (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * **If set to `true`,** then a new scope will be created for this directive. If multiple directives on the
	 * same element request a new scope, only one new scope is created. The new scope rule does not
	 * apply for the root of the template since the root of the template always gets a new scope.
	 *
	 * **If set to `{}` (object hash),** then a new "isolate" scope is created. The 'isolate' scope differs from
	 * normal scope in that it does not prototypically inherit from the parent scope. This is useful
	 * when creating reusable components, which should not accidentally read or modify data in the
	 * parent scope.
	 *
	 * The 'isolate' scope takes an object hash which defines a set of local scope properties
	 * derived from the parent scope. These local properties are useful for aliasing values for
	 * templates. Locals definition is a hash of local scope property to its source:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified  then the
	 *   attribute name is assumed to be the same as the local name.
	 *   Given `<widget my-attr="hello {{name}}">` and widget definition
	 *   of `scope: { localName:'@myAttr' }`, then widget scope property `localName` will reflect
	 *   the interpolated value of `hello {{name}}`. As the `name` attribute changes so will the
	 *   `localName` property on the widget scope. The `name` is read from the parent scope (not
	 *   component scope).
	 *
	 * * `=` or `=attr` - set up bi-directional binding between a local scope property and the
	 *   parent scope property of name defined via the value of the `attr` attribute. If no `attr`
	 *   name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<widget my-attr="parentModel">` and widget definition of
	 *   `scope: { localModel:'=myAttr' }`, then widget scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel` and any changes in `localModel` will reflect in `parentModel`. If the parent
	 *   scope property doesn't exist, it will throw a NON_ASSIGNABLE_MODEL_EXPRESSION exception. You
	 *   can avoid this behavior using `=?` or `=?attr` in order to flag the property as optional. If
	 *   you want to shallow watch for changes (i.e. $watchCollection instead of $watch) you can use
	 *   `=*` or `=*attr` (`=*?` or `=*?attr` if the property is optional).
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. Given `<widget my-attr="count = count + value">` and widget definition of
	 *   `scope: { localFn:'&myAttr' }`, then isolate scope property `localFn` will point to
	 *   a function wrapper for the `count = count + value` expression. Often it's desirable to
	 *   pass data from the isolated scope via an expression to the parent scope, this can be
	 *   done by passing a map of local variable names and values into the expression wrapper fn.
	 *   For example, if the expression is `increment(amount)` then we can specify the amount value
	 *   by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 *
	 * #### `bindToController`
	 * When an isolate scope is used for a component (see above), and `controllerAs` is used, `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope. When the controller
	 * is instantiated, the initial values of the isolate scope bindings are already available.
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and it is shared with other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement)`.
	 *    * `scope`: optional argument to override the scope.
	 *    * `cloneLinkingFn`: optional argument to create clones of the original transcluded content.
	 *    * `futureParentElement`:
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` takes a string name (or array of strings) of the directive(s) to pass in. If an array is used, the
	 * injected argument will be an array in corresponding order. If no such directive can be
	 * found, or if the directive does not have a controller, then an error is raised (unless no link function
	 * is specified, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Controller alias at the directive scope. An alias for the controller so it
	 * can be referenced at the directive template. The directive needs to define a scope for this
	 * configuration to be used. Useful in the case when directive is used as component.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 * There are two kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element or the entire element:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and a
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-error">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *       * no controller(s) required: `undefined`
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude`
	 *     parameter of directive controllers, see there for details.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a translude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	 * ```
	 * - $rootScope
	 *   - isolate
	 *     - transclusion
	 * ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	 * ```
	 * - $rootScope
	 *   - transclusion
	 * - isolate
	 * ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * accessing *Normalized attribute names:*
	 * Directives like 'ngBind' can be expressed in many ways: 'ng:bind', `data-ng-bind`, or 'x-ng-bind'.
	 * the attributes object allows for normalized access to
	 *   the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br>
	      <textarea ng-model="html"></textarea> <br>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-error">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to controller instances; if given, it will make the controllers
	 *        available to directives.
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	
	  function parseIsolateBindings(scope, directiveName) {
	    var LOCAL_REGEXP = /^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = {};
	
	    forEach(scope, function(definition, scopeName) {
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid isolate scope definition for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition);
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	    });
	
	    return bindings;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See
	   *    {@link guide/directive} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	   this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = directive.require || (directive.controller && directive.name);
	                directive.restrict = directive.restrict || 'EA';
	                if (isObject(directive.scope)) {
	                  directive.$$isolateBindings = parseIsolateBindings(directive.scope, directive.name);
	                }
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$document', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $document,   $sce,   $animate,   $$sanitizeUri) {
	
	    var Attributes = function(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    };
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(node, key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && key === 'href') ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset') {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || value === undefined) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            this.$$element.attr(attrName, value);
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/directive#text-and-attribute-bindings Directives} guide for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key)) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' || endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      forEach($compileNodes, function(node, index) {
	        if (node.nodeType == NODE_TYPE_TEXT && node.nodeValue.match(/\S+/) /* non-empty */ ) {
	          $compileNodes[index] = jqLite(node).wrap('<span></span>').parent()[0];
	        }
	      });
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && node.toString().match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn,
	                  nodeLinkFn.elementTranscludeOnThisElement);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn, elementTransclusion) {
	
	      var boundTranscludeFn = function(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      };
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var directiveNName = ngAttrName.replace(/(Start|End)$/, '');
	            if (directiveIsMultiElement(directiveNName)) {
	              if (ngAttrName === directiveNName + 'Start') {
	                attrStartName = name;
	                attrEndName = name.substr(0, name.length - 5) + 'end';
	                name = name.substr(0, name.length - 6);
	              }
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          try {
	            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	            if (match) {
	              nName = directiveNormalize(match[1]);
	              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[2]);
	              }
	            }
	          } catch (e) {
	            // turns out that under some circumstances IE9 throws errors when one attempts to read
	            // comment's node value.
	            // Just ignore it and continue. (Can't seem to reproduce in test case.)
	          }
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          controllers,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || {};
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(document.createComment(' ' + directiveName + ': ' +
	                                              templateAttrs[directiveName] + ' '));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compile($template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compile($template, transcludeFn);
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective) {
	              markDirectivesAsIsolate(templateDirectives);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            if (isFunction(linkFn)) {
	              addLinkFns(null, linkFn, attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(linkFn.pre, linkFn.post, attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.elementTranscludeOnThisElement = hasElementTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	
	      function getControllers(directiveName, require, $element, elementControllers) {
	        var value, retrievalMethod = 'data', optional = false;
	        var $searchElement = $element;
	        var match;
	        if (isString(require)) {
	          match = require.match(REQUIRE_PREFIX_REGEXP);
	          require = require.substring(match[0].length);
	
	          if (match[3]) {
	            if (match[1]) match[3] = null;
	            else match[1] = match[3];
	          }
	          if (match[1] === '^') {
	            retrievalMethod = 'inheritedData';
	          } else if (match[1] === '^^') {
	            retrievalMethod = 'inheritedData';
	            $searchElement = $element.parent();
	          }
	          if (match[2] === '?') {
	            optional = true;
	          }
	
	          value = null;
	
	          if (elementControllers && retrievalMethod === 'data') {
	            if (value = elementControllers[require]) {
	              value = value.instance;
	            }
	          }
	          value = value || $searchElement[retrievalMethod]('$' + require + 'Controller');
	
	          if (!value && !optional) {
	            throw $compileMinErr('ctreq',
	                "Controller '{0}', required by directive '{1}', can't be found!",
	                require, directiveName);
	          }
	          return value || null;
	        } else if (isArray(require)) {
	          value = [];
	          forEach(require, function(require) {
	            value.push(getControllers(directiveName, require, $element, elementControllers));
	          });
	        }
	        return value;
	      }
	
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, controller, isolateScope, elementControllers, transcludeFn, $element,
	            attrs;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	        }
	
	        if (controllerDirectives) {
	          // TODO: merge `controllers` and `elementControllers` into single object.
	          controllers = {};
	          elementControllers = {};
	          forEach(controllerDirectives, function(directive) {
	            var locals = {
	              $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	              $element: $element,
	              $attrs: attrs,
	              $transclude: transcludeFn
	            }, controllerInstance;
	
	            controller = directive.controller;
	            if (controller == '@') {
	              controller = attrs[directive.name];
	            }
	
	            controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	            // For directives with element transclusion the element is a comment,
	            // but jQuery .data doesn't support attaching data to comment nodes as it's hard to
	            // clean up (http://bugs.jquery.com/ticket/8335).
	            // Instead, we save the controllers for the element in a local hash and attach to .data
	            // later, once we have the actual element.
	            elementControllers[directive.name] = controllerInstance;
	            if (!hasElementTranscludeDirective) {
	              $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	            }
	
	            controllers[directive.name] = controllerInstance;
	          });
	        }
	
	        if (newIsolateScopeDirective) {
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	
	          var isolateScopeController = controllers && controllers[newIsolateScopeDirective.name];
	          var isolateBindingContext = isolateScope;
	          if (isolateScopeController && isolateScopeController.identifier &&
	              newIsolateScopeDirective.bindToController === true) {
	            isolateBindingContext = isolateScopeController.instance;
	          }
	
	          forEach(isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings, function(definition, scopeName) {
	            var attrName = definition.attrName,
	                optional = definition.optional,
	                mode = definition.mode, // @, =, or &
	                lastValue,
	                parentGet, parentSet, compare;
	
	            switch (mode) {
	
	              case '@':
	                attrs.$observe(attrName, function(value) {
	                  isolateBindingContext[scopeName] = value;
	                });
	                attrs.$$observers[attrName].$$scope = scope;
	                if (attrs[attrName]) {
	                  // If the attribute has been provided then we trigger an interpolation to ensure
	                  // the value is there for use in the link fn
	                  isolateBindingContext[scopeName] = $interpolate(attrs[attrName])(scope);
	                }
	                break;
	
	              case '=':
	                if (optional && !attrs[attrName]) {
	                  return;
	                }
	                parentGet = $parse(attrs[attrName]);
	                if (parentGet.literal) {
	                  compare = equals;
	                } else {
	                  compare = function(a, b) { return a === b || (a !== a && b !== b); };
	                }
	                parentSet = parentGet.assign || function() {
	                  // reset the change, or we will throw this exception on every $digest
	                  lastValue = isolateBindingContext[scopeName] = parentGet(scope);
	                  throw $compileMinErr('nonassign',
	                      "Expression '{0}' used with directive '{1}' is non-assignable!",
	                      attrs[attrName], newIsolateScopeDirective.name);
	                };
	                lastValue = isolateBindingContext[scopeName] = parentGet(scope);
	                var parentValueWatch = function parentValueWatch(parentValue) {
	                  if (!compare(parentValue, isolateBindingContext[scopeName])) {
	                    // we are out of sync and need to copy
	                    if (!compare(parentValue, lastValue)) {
	                      // parent changed and it has precedence
	                      isolateBindingContext[scopeName] = parentValue;
	                    } else {
	                      // if the parent can be assigned then do so
	                      parentSet(scope, parentValue = isolateBindingContext[scopeName]);
	                    }
	                  }
	                  return lastValue = parentValue;
	                };
	                parentValueWatch.$stateful = true;
	                var unwatch;
	                if (definition.collection) {
	                  unwatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	                } else {
	                  unwatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	                }
	                isolateScope.$on('$destroy', unwatch);
	                break;
	
	              case '&':
	                parentGet = $parse(attrs[attrName]);
	                isolateBindingContext[scopeName] = function(locals) {
	                  return parentGet(scope, locals);
	                };
	                break;
	            }
	          });
	        }
	        if (controllers) {
	          forEach(controllers, function(controller) {
	            controller();
	          });
	          controllers = null;
	        }
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement) {
	          var transcludeControllers;
	
	          // No scope passed in:
	          if (!isScope(scope)) {
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	        }
	      }
	    }
	
	    function markDirectivesAsIsolate(directives) {
	      // mark all directives as needing isolate scope.
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: true});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((maxPriority === undefined || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        if (key == 'class') {
	          safeAddClass($element, value);
	          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
	        } else if (key == 'style') {
	          $element.attr('style', $element.attr('style') + ';' + value);
	          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
	          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	          // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
	          dst[key] = value;
	          dstAttr[key] = srcAttr[key];
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              markDirectivesAsIsolate(templateDirectives);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}, {1}] asking for {2} on: {3}',
	            previousDirective.name, directive.name, what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = {}));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // TODO(perf): what's this document fragment for? is it needed? can we at least reuse it?
	      var fragment = document.createDocumentFragment();
	      fragment.appendChild(firstElementToRemove);
	
	      // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	      // data here because there's no public interface in jQuery to do that and copying over
	      // event listeners (which is the main use of private data) wouldn't work anyway.
	      jqLite(newNode).data(jqLite(firstElementToRemove).data());
	
	      // Remove data of the replaced element. We cannot just call .remove()
	      // on the element it since that would deallocate scope that is needed
	      // for the new node. Instead, remove the data "manually".
	      if (!jQuery) {
	        delete jqLite.cache[firstElementToRemove[jqLite.expando]];
	      } else {
	        // jQuery 2.x doesn't expose the data storage. Use jQuery.cleanData to clean up after
	        // the replaced element. The cleanData version monkey-patched by Angular would cause
	        // the scope to be trashed and we do need the very same scope to work with the new
	        // element. However, we cannot just cache the non-patched version and use it here as
	        // that would break if another library patches the method after Angular does (one
	        // example is jQuery UI). Instead, set a flag indicating scope destroying should be
	        // skipped this one time.
	        skipDestroyOnNextJQueryCleanData = true;
	        jQuery.cleanData([firstElementToRemove]);
	      }
	
	      for (var k = 1, kk = elementsToRemove.length; k < kk; k++) {
	        var element = elementsToRemove[k];
	        jqLite(element).remove(); // must do this way to clean up expando
	        fragment.appendChild(element);
	        delete elementsToRemove[k];
	      }
	
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	  }];
	}
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false,
	      CNTRL_REG = /^(\S+)(\s+as\s+(\w+))?$/;
	
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function() {
	          $injector.invoke(expression, instance, locals, constructor);
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * ```js
	 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	 * ```
	 *
	 * This example will override the normal action of `$exceptionHandler`, to make angular
	 * exceptions fail hard when they happen, instead of just logging to the console.
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), key, val, i;
	
	  if (!headers) return parsed;
	
	  forEach(headers.split('\n'), function(line) {
	    i = line.indexOf(':');
	    key = lowercase(trim(line.substr(0, i)));
	    val = trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj = isObject(headers) ? headers : undefined;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns))
	    return fns(data, headers, status);
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {Object} - an object built with {@link ng.$cacheFactory `$cacheFactory`}
	   * that will provide the cache for all requests who set their `cache` property to `true`.
	   * If you set the `default.cache = false` then only requests that specify their own custom
	   * cache object will be cached. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specifed, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$browser', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $browser, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a configuration object —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}
	     * with two $http specific methods: `success` and `error`.
	     *
	     * ```js
	     *   // Simple GET request example :
	     *   $http.get('/someUrl').
	     *     success(function(data, status, headers, config) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }).
	     *     error(function(data, status, headers, config) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * ```js
	     *   // Simple POST request example (passing data) :
	     *   $http.post('/someUrl', {msg:'hello word!'}).
	     *     success(function(data, status, headers, config) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }).
	     *     error(function(data, status, headers, config) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * Since the returned value of calling the $http function is a `promise`, you can also use
	     * the `then` method to register callbacks, and these callbacks will receive a single argument –
	     * an object representing the response. See the API signature and type info below for more
	     * details.
	     *
	     * A response status code between 200 and 299 is considered a success status and
	     * will result in the success callback being called. Note that if the response is a redirect,
	     * XMLHttpRequest will transparently follow it, meaning that the error callback will not be
	     * called for such responses.
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests.
	     *
	     * ```js
	     *   $http.get('/someUrl').success(successCallback);
	     *   $http.post('/someUrl', data).success(successCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w'
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).success(function(){...}).error(function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * To enable caching, set the request configuration `cache` property to `true` (to use default
	     * cache) or to a custom cache object (built with {@link ng.$cacheFactory `$cacheFactory`}).
	     * When the cache is enabled, `$http` stores the response from the server in the specified
	     * cache. The next time the same request is made, the response is served from the cache without
	     * sending a request to the server.
	     *
	     * Note that even if the response is served from cache, delivery of the data is asynchronous in
	     * the same way that real requests are.
	     *
	     * If there are multiple GET requests for the same URL that should be cached using the same
	     * cache, but the cache is not populated yet, only one request to the server will be made and
	     * the remaining requests will be fulfilled using the response from the first request.
	     *
	     * You can change the default cache to a new object (built with
	     * {@link ng.$cacheFactory `$cacheFactory`}) by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property. All requests who set
	     * their `cache` property to `true` will now use this cache object.
	     *
	     * If you set the default cache to `false` then only requests that specify their own custom
	     * cache object will be cached.
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http `config` object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is a technique by which
	     * an unauthorized site can gain your user's private data. Angular provides a mechanism
	     * to counter XSRF. When performing XHR requests, the $http service reads a token from a cookie
	     * (by default, `XSRF-TOKEN`) and sets it as an HTTP header (`X-XSRF-TOKEN`). Since only
	     * JavaScript that runs on your domain could read the cookie, your server can be assured that
	     * the XHR came from JavaScript running on your domain. The header will not be set for
	     * cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be turned
	     *      to `?key1=value1&key2=value2` after the url. If the value is not a string, it will be
	     *      JSONified.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **cache** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	     *      GET request, otherwise if a cache instance built with
	     *      {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	     *      caching.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q promise} object with the
	     *   standard `then` method and two http specific methods: `success` and `error`. The `then`
	     *   method takes two arguments a success and an error callback which will be called with a
	     *   response object. The `success` and `error` methods take a single argument - a function that
	     *   will be called when the request succeeds or fails respectively. The arguments passed into
	     *   these functions are destructured representation of the response object passed into the
	     *   `then` method. The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80"/>
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            success(function(data, status) {
	              $scope.status = status;
	              $scope.data = data;
	            }).
	            error(function(data, status) {
	              $scope.data = data || "Request failed";
	              $scope.status = status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!angular.isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	
	      var serverRequest = function(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	                delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      };
	
	      var chain = [serverRequest, undefined];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          chain.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          chain.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      while (chain.length) {
	        var thenFn = chain.shift();
	        var rejectFn = chain.shift();
	
	        promise = promise.then(thenFn, rejectFn);
	      }
	
	      promise.success = function(fn) {
	        assertArgFn(fn, 'fn');
	
	        promise.then(function(response) {
	          fn(response.data, response.status, response.headers, config);
	        });
	        return promise;
	      };
	
	      promise.error = function(fn) {
	        assertArgFn(fn, 'fn');
	
	        promise.then(null, function(response) {
	          fn(response.data, response.status, response.headers, config);
	        });
	        return promise;
	      };
	
	      return promise;
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        if (!response.data) {
	          resp.data = response.data;
	        } else {
	          resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
	        }
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	
	      function executeHeaderFns(headers) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn();
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend(config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend(config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.params);
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $browser.cookies()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType);
	      }
	
	      return promise;
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, params) {
	      if (!params) return url;
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (!isArray(value)) value = [value];
	
	        forEach(value, function(v) {
	          if (isObject(v)) {
	            if (isDate(v)) {
	              v = v.toISOString();
	            } else {
	              v = toJson(v);
	            }
	          }
	          parts.push(encodeUriQuery(key) + '=' +
	                     encodeUriQuery(v));
	        });
	      });
	      if (parts.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + parts.join('&');
	      }
	      return url;
	    }
	  }];
	}
	
	function createXhr() {
	    return new window.XMLHttpRequest();
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $window
	 * @requires $document
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$window', '$document', function($browser, $window, $document) {
	    return createHttpBackend($browser, createXhr, $browser.defer, $window.angular.callbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) == 'jsonp') {
	      var callbackId = '_' + (callbacks.counter++).toString(36);
	      callbacks[callbackId] = function(data) {
	        callbacks[callbackId].data = data;
	        callbacks[callbackId].called = true;
	      };
	
	      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
	          callbackId, function(status, text) {
	        completeRequest(callback, status, callbacks[callbackId].data, "", text);
	        callbacks[callbackId] = noop;
	      });
	    } else {
	
	      var xhr = createXhr();
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(post || null);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (timeoutId !== undefined) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackId, done) {
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks[callbackId].called) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = minErr('$interpolate');
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * @example
	<example module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-app="App" ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'}).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * ####Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          throw $interpolateMinErr('noconcat',
	              "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	              "interpolations that concatenate multiple expressions when a trusted value is " +
	              "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        var stringify = function(value) {
	          if (value == null) { // null || undefined
	            return '';
	          }
	          switch (typeof value) {
	            case 'string':
	              break;
	            case 'number':
	              value = '' + value;
	              break;
	            default:
	              value = toJson(value);
	          }
	
	          return value;
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              var newErr = $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text,
	                  err.toString());
	              $exceptionHandler(newErr);
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener, objectEquality) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            }, objectEquality);
	          }
	        });
	      }
	
	      function unescapeText(text) {
	        return text.replace(escapedStartRegexp, startSymbol).
	          replace(escapedEndRegexp, endSymbol);
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          var newErr = $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text,
	            err.toString());
	          $exceptionHandler(newErr);
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q',
	       function($rootScope,   $window,   $q,   $$q) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       Date format: <input ng-model="format"> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.then(null, null, fn);
	
	      promise.$$intervalId = setInterval(function tick() {
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {promise} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	function $LocaleProvider() {
	  this.$get = function() {
	    return {
	      id: 'en-us',
	
	      NUMBER_FORMATS: {
	        DECIMAL_SEP: '.',
	        GROUP_SEP: ',',
	        PATTERNS: [
	          { // Decimal Pattern
	            minInt: 1,
	            minFrac: 0,
	            maxFrac: 3,
	            posPre: '',
	            posSuf: '',
	            negPre: '-',
	            negSuf: '',
	            gSize: 3,
	            lgSize: 3
	          },{ //Currency Pattern
	            minInt: 1,
	            minFrac: 2,
	            maxFrac: 2,
	            posPre: '\u00A4',
	            posSuf: '',
	            negPre: '(\u00A4',
	            negSuf: ')',
	            gSize: 3,
	            lgSize: 3
	          }
	        ],
	        CURRENCY_SYM: '$'
	      },
	
	      DATETIME_FORMATS: {
	        MONTH:
	            'January,February,March,April,May,June,July,August,September,October,November,December'
	            .split(','),
	        SHORTMONTH:  'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(','),
	        DAY: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday'.split(','),
	        SHORTDAY: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
	        AMPMS: ['AM','PM'],
	        medium: 'MMM d, y h:mm:ss a',
	        'short': 'M/d/yy h:mm a',
	        fullDate: 'EEEE, MMMM d, y',
	        longDate: 'MMMM d, y',
	        mediumDate: 'MMM d, y',
	        shortDate: 'M/d/yy',
	        mediumTime: 'h:mm:ss a',
	        shortTime: 'h:mm a',
	        ERANAMES: [
	          "Before Christ",
	          "Anno Domini"
	        ],
	        ERAS: [
	          "BC",
	          "AD"
	        ]
	      },
	
	      pluralCat: function(num) {
	        if (num === 1) {
	          return 'one';
	        }
	        return 'other';
	      }
	    };
	  };
	}
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = int(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	
	/**
	 *
	 * @param {string} begin
	 * @param {string} whole
	 * @returns {string} returns text from whole after begin or undefined if it does not begin with
	 *                   expected string.
	 */
	function beginsWith(begin, whole) {
	  if (whole.indexOf(begin) === 0) {
	    return whole.substr(begin.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = beginsWith(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if ((appUrl = beginsWith(appBase, url)) !== undefined) {
	      prevAppUrl = appUrl;
	      if ((appUrl = beginsWith(basePrefix, appUrl)) !== undefined) {
	        rewrittenUrl = appBaseNoFile + (beginsWith('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if ((appUrl = beginsWith(appBaseNoFile, url)) !== undefined) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = beginsWith(appBase, url) || beginsWith(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = beginsWith(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (url.indexOf(base) === 0) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = beginsWith(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url))
	      return this.$$url;
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {string} path
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return hash fragment when called without any parameter.
	   *
	   * Change hash fragment when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during current `$digest` will be replacing current history
	   * record, instead of adding new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length)
	      return this.$$state;
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value))
	      return this[property];
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(beginsWith(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         Message:
	         <input type="text" ng-model="message"/>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name, fullExpression) {
	  // From the JavaScript docs:
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use,
	  // we cast it to a string, if possible.
	  // Doing `name + ''` can cause a repl error if the result to `toString` is not a string,
	  // this is, this will handle objects that misbehave.
	  name = name + '';
	  if (!isString(name)) {
	    throw $parseMinErr('iseccst',
	        'Cannot convert object to primitive value! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	//Keyword constants
	var CONSTANTS = createMap();
	forEach({
	  'null': function() { return null; },
	  'true': function() { return true; },
	  'false': function() { return false; },
	  'undefined': function() {}
	}, function(constantGetter, name) {
	  constantGetter.constant = constantGetter.literal = constantGetter.sharedGetter = true;
	  CONSTANTS[name] = constantGetter;
	});
	
	//Not quite a constant, but can be lex/parsed the same
	CONSTANTS['this'] = function(self) { return self; };
	CONSTANTS['this'].sharedGetter = true;
	
	
	//Operators - will be wrapped by binaryFn/unaryFn/assignment/filter
	var OPERATORS = extend(createMap(), {
	    '+':function(self, locals, a, b) {
	      a=a(self, locals); b=b(self, locals);
	      if (isDefined(a)) {
	        if (isDefined(b)) {
	          return a + b;
	        }
	        return a;
	      }
	      return isDefined(b) ? b : undefined;},
	    '-':function(self, locals, a, b) {
	          a=a(self, locals); b=b(self, locals);
	          return (isDefined(a) ? a : 0) - (isDefined(b) ? b : 0);
	        },
	    '*':function(self, locals, a, b) {return a(self, locals) * b(self, locals);},
	    '/':function(self, locals, a, b) {return a(self, locals) / b(self, locals);},
	    '%':function(self, locals, a, b) {return a(self, locals) % b(self, locals);},
	    '===':function(self, locals, a, b) {return a(self, locals) === b(self, locals);},
	    '!==':function(self, locals, a, b) {return a(self, locals) !== b(self, locals);},
	    '==':function(self, locals, a, b) {return a(self, locals) == b(self, locals);},
	    '!=':function(self, locals, a, b) {return a(self, locals) != b(self, locals);},
	    '<':function(self, locals, a, b) {return a(self, locals) < b(self, locals);},
	    '>':function(self, locals, a, b) {return a(self, locals) > b(self, locals);},
	    '<=':function(self, locals, a, b) {return a(self, locals) <= b(self, locals);},
	    '>=':function(self, locals, a, b) {return a(self, locals) >= b(self, locals);},
	    '&&':function(self, locals, a, b) {return a(self, locals) && b(self, locals);},
	    '||':function(self, locals, a, b) {return a(self, locals) || b(self, locals);},
	    '!':function(self, locals, a) {return !a(self, locals);},
	
	    //Tokenized as operators but parsed as assignment/filters
	    '=':true,
	    '|':true
	});
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdent(ch)) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdent: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (!(this.isIdent(ch) || this.isNumber(ch))) {
	        break;
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i))
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	
	function isConstant(exp) {
	  return exp.constant;
	}
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	};
	
	Parser.ZERO = extend(function() {
	  return 0;
	}, {
	  sharedGetter: true,
	  constant: true
	});
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.statements();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    value.literal = !!value.literal;
	    value.constant = !!value.constant;
	
	    return value;
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.peek().identifier && this.peek().text in CONSTANTS) {
	      primary = CONSTANTS[this.consume().text];
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next, context;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = this.functionCall(primary, context);
	        context = null;
	      } else if (next.text === '[') {
	        context = primary;
	        primary = this.objectIndex(primary);
	      } else if (next.text === '.') {
	        context = primary;
	        primary = this.fieldAccess(primary);
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0)
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  unaryFn: function(op, right) {
	    var fn = OPERATORS[op];
	    return extend(function $parseUnaryFn(self, locals) {
	      return fn(self, locals, right);
	    }, {
	      constant:right.constant,
	      inputs: [right]
	    });
	  },
	
	  binaryFn: function(left, op, right, isBranching) {
	    var fn = OPERATORS[op];
	    return extend(function $parseBinaryFn(self, locals) {
	      return fn(self, locals, left, right);
	    }, {
	      constant: left.constant && right.constant,
	      inputs: !isBranching && [left, right]
	    });
	  },
	
	  identifier: function() {
	    var id = this.consume().text;
	
	    //Continue reading each `.identifier` unless it is a method invocation
	    while (this.peek('.') && this.peekAhead(1).identifier && !this.peekAhead(2, '(')) {
	      id += this.consume().text + this.consume().text;
	    }
	
	    return getterFn(id, this.options, this.text);
	  },
	
	  constant: function() {
	    var value = this.consume().value;
	
	    return extend(function $parseConstant() {
	      return value;
	    }, {
	      constant: true,
	      literal: true
	    });
	  },
	
	  statements: function() {
	    var statements = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        statements.push(this.filterChain());
	      if (!this.expect(';')) {
	        // optimize for the common case where there is only one statement.
	        // TODO(size): maybe we should not support multiple statements?
	        return (statements.length === 1)
	            ? statements[0]
	            : function $parseStatements(self, locals) {
	                var value;
	                for (var i = 0, ii = statements.length; i < ii; i++) {
	                  value = statements[i](self, locals);
	                }
	                return value;
	              };
	      }
	    }
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  filter: function(inputFn) {
	    var fn = this.$filter(this.consume().text);
	    var argsFn;
	    var args;
	
	    if (this.peek(':')) {
	      argsFn = [];
	      args = []; // we can safely reuse the array
	      while (this.expect(':')) {
	        argsFn.push(this.expression());
	      }
	    }
	
	    var inputs = [inputFn].concat(argsFn || []);
	
	    return extend(function $parseFilter(self, locals) {
	      var input = inputFn(self, locals);
	      if (args) {
	        args[0] = input;
	
	        var i = argsFn.length;
	        while (i--) {
	          args[i + 1] = argsFn[i](self, locals);
	        }
	
	        return fn.apply(undefined, args);
	      }
	
	      return fn(input);
	    }, {
	      constant: !fn.$stateful && inputs.every(isConstant),
	      inputs: !fn.$stateful && inputs
	    });
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var left = this.ternary();
	    var right;
	    var token;
	    if ((token = this.expect('='))) {
	      if (!left.assign) {
	        this.throwError('implies assignment but [' +
	            this.text.substring(0, token.index) + '] can not be assigned to', token);
	      }
	      right = this.ternary();
	      return extend(function $parseAssignment(scope, locals) {
	        return left.assign(scope, right(scope, locals), locals);
	      }, {
	        inputs: [left, right]
	      });
	    }
	    return left;
	  },
	
	  ternary: function() {
	    var left = this.logicalOR();
	    var middle;
	    var token;
	    if ((token = this.expect('?'))) {
	      middle = this.assignment();
	      if (this.consume(':')) {
	        var right = this.assignment();
	
	        return extend(function $parseTernary(self, locals) {
	          return left(self, locals) ? middle(self, locals) : right(self, locals);
	        }, {
	          constant: left.constant && middle.constant && right.constant
	        });
	      }
	    }
	
	    return left;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    var token;
	    while ((token = this.expect('||'))) {
	      left = this.binaryFn(left, token.text, this.logicalAND(), true);
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    var token;
	    while ((token = this.expect('&&'))) {
	      left = this.binaryFn(left, token.text, this.equality(), true);
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = this.binaryFn(left, token.text, this.relational());
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = this.binaryFn(left, token.text, this.additive());
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = this.binaryFn(left, token.text, this.multiplicative());
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = this.binaryFn(left, token.text, this.unary());
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if (this.expect('+')) {
	      return this.primary();
	    } else if ((token = this.expect('-'))) {
	      return this.binaryFn(Parser.ZERO, token.text, this.unary());
	    } else if ((token = this.expect('!'))) {
	      return this.unaryFn(token.text, this.unary());
	    } else {
	      return this.primary();
	    }
	  },
	
	  fieldAccess: function(object) {
	    var getter = this.identifier();
	
	    return extend(function $parseFieldAccess(scope, locals, self) {
	      var o = self || object(scope, locals);
	      return (o == null) ? undefined : getter(o);
	    }, {
	      assign: function(scope, value, locals) {
	        var o = object(scope, locals);
	        if (!o) object.assign(scope, o = {}, locals);
	        return getter.assign(o, value);
	      }
	    });
	  },
	
	  objectIndex: function(obj) {
	    var expression = this.text;
	
	    var indexFn = this.expression();
	    this.consume(']');
	
	    return extend(function $parseObjectIndex(self, locals) {
	      var o = obj(self, locals),
	          i = getStringValue(indexFn(self, locals), expression),
	          v;
	
	      ensureSafeMemberName(i, expression);
	      if (!o) return undefined;
	      v = ensureSafeObject(o[i], expression);
	      return v;
	    }, {
	      assign: function(self, value, locals) {
	        var key = ensureSafeMemberName(getStringValue(indexFn(self, locals), expression), expression);
	        // prevent overwriting of Function.constructor which would break ensureSafeObject check
	        var o = ensureSafeObject(obj(self, locals), expression);
	        if (!o) obj.assign(self, o = {}, locals);
	        return o[key] = value;
	      }
	    });
	  },
	
	  functionCall: function(fnGetter, contextGetter) {
	    var argsFn = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        argsFn.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(')');
	
	    var expressionText = this.text;
	    // we can safely reuse the array across invocations
	    var args = argsFn.length ? [] : null;
	
	    return function $parseFunctionCall(scope, locals) {
	      var context = contextGetter ? contextGetter(scope, locals) : isDefined(contextGetter) ? undefined : scope;
	      var fn = fnGetter(scope, locals, context) || noop;
	
	      if (args) {
	        var i = argsFn.length;
	        while (i--) {
	          args[i] = ensureSafeObject(argsFn[i](scope, locals), expressionText);
	        }
	      }
	
	      ensureSafeObject(context, expressionText);
	      ensureSafeFunction(fn, expressionText);
	
	      // IE doesn't have apply for some native functions
	      var v = fn.apply
	            ? fn.apply(context, args)
	            : fn(args[0], args[1], args[2], args[3], args[4]);
	
	      if (args) {
	        // Free-up the memory (arguments of the last function call).
	        args.length = 0;
	      }
	
	      return ensureSafeObject(v, expressionText);
	      };
	  },
	
	  // This is used with json array declaration
	  arrayDeclaration: function() {
	    var elementFns = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elementFns.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return extend(function $parseArrayLiteral(self, locals) {
	      var array = [];
	      for (var i = 0, ii = elementFns.length; i < ii; i++) {
	        array.push(elementFns[i](self, locals));
	      }
	      return array;
	    }, {
	      literal: true,
	      constant: elementFns.every(isConstant),
	      inputs: elementFns
	    });
	  },
	
	  object: function() {
	    var keys = [], valueFns = [];
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        var token = this.consume();
	        if (token.constant) {
	          keys.push(token.value);
	        } else if (token.identifier) {
	          keys.push(token.text);
	        } else {
	          this.throwError("invalid key", token);
	        }
	        this.consume(':');
	        valueFns.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return extend(function $parseObjectLiteral(self, locals) {
	      var object = {};
	      for (var i = 0, ii = valueFns.length; i < ii; i++) {
	        object[keys[i]] = valueFns[i](self, locals);
	      }
	      return object;
	    }, {
	      literal: true,
	      constant: valueFns.every(isConstant),
	      inputs: valueFns
	    });
	  }
	};
	
	
	//////////////////////////////////////////////////
	// Parser helper functions
	//////////////////////////////////////////////////
	
	function setter(obj, locals, path, setValue, fullExp) {
	  ensureSafeObject(obj, fullExp);
	  ensureSafeObject(locals, fullExp);
	
	  var element = path.split('.'), key;
	  for (var i = 0; element.length > 1; i++) {
	    key = ensureSafeMemberName(element.shift(), fullExp);
	    var propertyObj = (i === 0 && locals && locals[key]) || obj[key];
	    if (!propertyObj) {
	      propertyObj = {};
	      obj[key] = propertyObj;
	    }
	    obj = ensureSafeObject(propertyObj, fullExp);
	  }
	  key = ensureSafeMemberName(element.shift(), fullExp);
	  ensureSafeObject(obj[key], fullExp);
	  obj[key] = setValue;
	  return setValue;
	}
	
	var getterFnCacheDefault = createMap();
	var getterFnCacheExpensive = createMap();
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	/**
	 * Implementation of the "Black Hole" variant from:
	 * - http://jsperf.com/angularjs-parse-getter/4
	 * - http://jsperf.com/path-evaluation-simplified/7
	 */
	function cspSafeGetterFn(key0, key1, key2, key3, key4, fullExp, expensiveChecks) {
	  ensureSafeMemberName(key0, fullExp);
	  ensureSafeMemberName(key1, fullExp);
	  ensureSafeMemberName(key2, fullExp);
	  ensureSafeMemberName(key3, fullExp);
	  ensureSafeMemberName(key4, fullExp);
	  var eso = function(o) {
	    return ensureSafeObject(o, fullExp);
	  };
	  var eso0 = (expensiveChecks || isPossiblyDangerousMemberName(key0)) ? eso : identity;
	  var eso1 = (expensiveChecks || isPossiblyDangerousMemberName(key1)) ? eso : identity;
	  var eso2 = (expensiveChecks || isPossiblyDangerousMemberName(key2)) ? eso : identity;
	  var eso3 = (expensiveChecks || isPossiblyDangerousMemberName(key3)) ? eso : identity;
	  var eso4 = (expensiveChecks || isPossiblyDangerousMemberName(key4)) ? eso : identity;
	
	  return function cspSafeGetter(scope, locals) {
	    var pathVal = (locals && locals.hasOwnProperty(key0)) ? locals : scope;
	
	    if (pathVal == null) return pathVal;
	    pathVal = eso0(pathVal[key0]);
	
	    if (!key1) return pathVal;
	    if (pathVal == null) return undefined;
	    pathVal = eso1(pathVal[key1]);
	
	    if (!key2) return pathVal;
	    if (pathVal == null) return undefined;
	    pathVal = eso2(pathVal[key2]);
	
	    if (!key3) return pathVal;
	    if (pathVal == null) return undefined;
	    pathVal = eso3(pathVal[key3]);
	
	    if (!key4) return pathVal;
	    if (pathVal == null) return undefined;
	    pathVal = eso4(pathVal[key4]);
	
	    return pathVal;
	  };
	}
	
	function getterFnWithEnsureSafeObject(fn, fullExpression) {
	  return function(s, l) {
	    return fn(s, l, ensureSafeObject, fullExpression);
	  };
	}
	
	function getterFn(path, options, fullExp) {
	  var expensiveChecks = options.expensiveChecks;
	  var getterFnCache = (expensiveChecks ? getterFnCacheExpensive : getterFnCacheDefault);
	  var fn = getterFnCache[path];
	  if (fn) return fn;
	
	
	  var pathKeys = path.split('.'),
	      pathKeysLength = pathKeys.length;
	
	  // http://jsperf.com/angularjs-parse-getter/6
	  if (options.csp) {
	    if (pathKeysLength < 6) {
	      fn = cspSafeGetterFn(pathKeys[0], pathKeys[1], pathKeys[2], pathKeys[3], pathKeys[4], fullExp, expensiveChecks);
	    } else {
	      fn = function cspSafeGetter(scope, locals) {
	        var i = 0, val;
	        do {
	          val = cspSafeGetterFn(pathKeys[i++], pathKeys[i++], pathKeys[i++], pathKeys[i++],
	                                pathKeys[i++], fullExp, expensiveChecks)(scope, locals);
	
	          locals = undefined; // clear after first iteration
	          scope = val;
	        } while (i < pathKeysLength);
	        return val;
	      };
	    }
	  } else {
	    var code = '';
	    if (expensiveChecks) {
	      code += 's = eso(s, fe);\nl = eso(l, fe);\n';
	    }
	    var needsEnsureSafeObject = expensiveChecks;
	    forEach(pathKeys, function(key, index) {
	      ensureSafeMemberName(key, fullExp);
	      var lookupJs = (index
	                      // we simply dereference 's' on any .dot notation
	                      ? 's'
	                      // but if we are first then we check locals first, and if so read it first
	                      : '((l&&l.hasOwnProperty("' + key + '"))?l:s)') + '.' + key;
	      if (expensiveChecks || isPossiblyDangerousMemberName(key)) {
	        lookupJs = 'eso(' + lookupJs + ', fe)';
	        needsEnsureSafeObject = true;
	      }
	      code += 'if(s == null) return undefined;\n' +
	              's=' + lookupJs + ';\n';
	    });
	    code += 'return s;';
	
	    /* jshint -W054 */
	    var evaledFnGetter = new Function('s', 'l', 'eso', 'fe', code); // s=scope, l=locals, eso=ensureSafeObject
	    /* jshint +W054 */
	    evaledFnGetter.toString = valueFn(code);
	    if (needsEnsureSafeObject) {
	      evaledFnGetter = getterFnWithEnsureSafeObject(evaledFnGetter, fullExp);
	    }
	    fn = evaledFnGetter;
	  }
	
	  fn.sharedGetter = true;
	  fn.assign = function(self, value, locals) {
	    return setter(self, locals, path, value, path);
	  };
	  getterFnCache[path] = fn;
	  return fn;
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	
	
	
	  this.$get = ['$filter', '$sniffer', function($filter, $sniffer) {
	    var $parseOptions = {
	          csp: $sniffer.csp,
	          expensiveChecks: false
	        },
	        $parseOptionsExpensive = {
	          csp: $sniffer.csp,
	          expensiveChecks: true
	        };
	
	    function wrapSharedExpression(exp) {
	      var wrapped = exp;
	
	      if (exp.sharedGetter) {
	        wrapped = function $parseWrapper(self, locals) {
	          return exp(self, locals);
	        };
	        wrapped.literal = exp.literal;
	        wrapped.constant = exp.constant;
	        wrapped.assign = exp.assign;
	      }
	
	      return wrapped;
	    }
	
	    return function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          cacheKey = exp = exp.trim();
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              //oneTime is not part of the exp passed to the Parser so we may have to
	              //wrap the parsedExpression before adding a $$watchDelegate
	              parsedExpression = wrapSharedExpression(parsedExpression);
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    };
	
	    function collectExpressionInputs(inputs, list) {
	      for (var i = 0, ii = inputs.length; i < ii; i++) {
	        var input = inputs[i];
	        if (!input.constant) {
	          if (input.inputs) {
	            collectExpressionInputs(input.inputs, list);
	          } else if (list.indexOf(input) === -1) { // TODO(perf) can we do better?
	            list.push(input);
	          }
	        }
	      }
	
	      return list;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var inputExpressions = parsedExpression.$$inputs ||
	                    (parsedExpression.$$inputs = collectExpressionInputs(parsedExpression.inputs, []));
	
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValue = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValue)) {
	            lastResult = parsedExpression(scope);
	            oldInputValue = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality);
	      }
	
	      var oldInputValueOfValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope);
	        }
	
	        return lastResult;
	      }, listener, objectEquality);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        return parsedExpression(scope);
	      }, function constantListener(value, old, scope) {
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        unwatch();
	      }, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals) {
	        var value = parsedExpression(scope, locals);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals) {
	        var value = parsedExpression(scope, locals);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6 Harmony,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 Harmony promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback`. It also notifies via the return value of the
	 *   `notifyCallback` method. The promise cannot be resolved or rejected from the notifyCallback
	 *   method.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 *  # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	  function callOnce(self, resolveFn, rejectFn) {
	    var called = false;
	    function wrap(fn) {
	      return function(value) {
	        if (called) return;
	        called = true;
	        fn.call(self, value);
	      };
	    }
	
	    return [wrap(resolveFn), wrap(rejectFn)];
	  }
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    return new Deferred();
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  Promise.prototype = {
	    then: function(onFulfilled, onRejected, progressBack) {
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  };
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      promise = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          promise.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          promise.resolve(state.value);
	        } else {
	          promise.reject(state.value);
	        }
	      } catch (e) {
	        promise.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	    //Necessary to support unbound execution :/
	    this.resolve = simpleBind(this, this.resolve);
	    this.reject = simpleBind(this, this.reject);
	    this.notify = simpleBind(this, this.notify);
	  }
	
	  Deferred.prototype = {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then, fns;
	
	      fns = callOnce(this, this.$$resolve, this.$$reject);
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, fns[0], fns[1], this.notify);
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        fns[1](e);
	        exceptionHandler(e);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    if (!(this instanceof Q)) {
	      // More useful when $Q is the Promise itself.
	      return new Q(resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.all = all;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var rafFn = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    queueFn.supported = rafSupported;
	
	    var cancelLastRAF;
	    var taskCount = 0;
	    var taskQueue = [];
	    return queueFn;
	
	    function flush() {
	      for (var i = 0; i < taskQueue.length; i++) {
	        var task = taskQueue[i];
	        if (task) {
	          taskQueue[i] = null;
	          task();
	        }
	      }
	      taskCount = taskQueue.length = 0;
	    }
	
	    function queueFn(asyncFn) {
	      var index = taskQueue.length;
	
	      taskCount++;
	      taskQueue.push(asyncFn);
	
	      if (index === 0) {
	        cancelLastRAF = rafFn(flush);
	      }
	
	      return function cancelQueueFn() {
	        if (index >= 0) {
	          taskQueue[index] = null;
	          index = null;
	
	          if (--taskCount === 0 && cancelLastRAF) {
	            cancelLastRAF();
	            cancelLastRAF = null;
	            taskQueue.length = 0;
	          }
	        }
	      };
	    }
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - this means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in middle are expensive so we use linked list
	 *
	 * There are few watches then a lot of observers. This is why you don't want the observer to be
	 * implemented in the same way as watch. Watch requires return of initialization function which
	 * are expensive to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide an event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$injector', '$exceptionHandler', '$parse', '$browser',
	      function($injector, $exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (Since
	       *   {@link ng.$rootScope.Scope#$digest $digest()} reruns when it detects changes the
	       *   `watchExpression` can execute multiple times per
	       *   {@link ng.$rootScope.Scope#$digest $digest()} and should be idempotent.)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} objectEquality Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	
	        return function deregisterWatch() {
	          arrayRemove(array, watcher);
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (newValue.hasOwnProperty(key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!newValue.hasOwnProperty(key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, logMsg, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          while (asyncQueue.length) {
	            try {
	              asyncTask = asyncQueue.shift();
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    if ((value = watch.get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      watch.fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = (current.$$childHead ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        while (postDigestQueue.length) {
	          try {
	            postDigestQueue.shift()();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // we can't destroy the root scope or a scope that has been already destroyed
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	        if (this === $rootScope) return;
	
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // All of the code below is bogus code that works around V8's memory leak via optimized code
	        // and inline caches.
	        //
	        // see:
	        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	        this.$parent = this.$$nextSibling = this.$$prevSibling = this.$$childHead =
	            this.$$childTail = this.$root = this.$$watchers = null;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: expr, locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          return this.$eval(expr);
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          clearPhase();
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   *     Note: **an empty whitelist array will block all URLs**!
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || trustedValue === undefined || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || maybeTrusted === undefined || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and ';'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resource_url, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        android =
	          int((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix.substr(0, 1).toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(document.body.style.webkitTransition);
	        animations = isString(document.body.style.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!($window.history && $window.history.pushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $compileMinErr = minErr('$compile');
	
	/**
	 * @ngdoc service
	 * @name $templateRequest
	 *
	 * @description
	 * The `$templateRequest` service runs security checks then downloads the provided template using
	 * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	 * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	 * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	 * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	 * when `tpl` is of type string and `$templateCache` has the matching entry.
	 *
	 * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	 * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	 *
	 * @return {Promise} the HTTP Promise for the given.
	 *
	 * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	 */
	function $TemplateRequestProvider() {
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || !$templateCache.get(tpl)) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      var httpOptions = {
	        cache: $templateCache,
	        transformResponse: transformResponse
	      };
	
	      return $http.get(tpl, httpOptions)
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $compileMinErr('tpload', 'Failed to load template: {0}', tpl);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of registering a timeout function is a promise, which will be resolved when
	      * the timeout is reached and the timeout function is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * @param {function()} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The value this
	      *   promise will be resolved with is the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      var skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn());
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	 *     property of the object or its nested object properties. That's equivalent to the simple
	 *     substring match with a `string` as described above. The predicate can be negated by prefixing
	 *     the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index)`: A predicate function can be used to write arbitrary filters. The
	 *     function is called for each element of `array`. The final result is an array of those
	 *     elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       Search: <input ng-model="searchText">
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       Any: <input ng-model="search.$"> <br>
	       Name only <input ng-model="search.name"><br>
	       Phone only <input ng-model="search.phone"><br>
	       Equality <input type="checkbox" ng-model="strict"><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	function filterFilter() {
	  return function(array, expression, comparator) {
	    if (!isArray(array)) return array;
	
	    var expressionType = (expression !== null) ? typeof expression : 'null';
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return array.filter(predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(actual) || isObject(expected)) {
	        // Prevent an object to be considered equal to a string like `'[object'`
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression.$, comparator, false);
	    }
	    return deepCompare(item, expression, comparator, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = (actual !== null) ? typeof actual : 'null';
	  var expectedType = (expected !== null) ? typeof expected : 'null';
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === '$';
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('($1,234.00)');
	         expect(element(by.id('currency-custom')).getText()).toBe('(USD$1,234.00)');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('(USD$1,234)');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity/-Infinity) the Infinity symbol '∞' is returned.
	 * If the input is not a number an empty string is returned.
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to decimalPlaces and places a “,” after each third digit.
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         Enter number: <input ng-model='val'><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	
	
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	var DECIMAL_SEP = '.';
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	  if (!isFinite(number) || isObject(number)) return '';
	
	  var isNegative = number < 0;
	  number = Math.abs(number);
	  var numStr = number + '',
	      formatedText = '',
	      parts = [];
	
	  var hasExponent = false;
	  if (numStr.indexOf('e') !== -1) {
	    var match = numStr.match(/([\d\.]+)e(-?)(\d+)/);
	    if (match && match[2] == '-' && match[3] > fractionSize + 1) {
	      number = 0;
	    } else {
	      formatedText = numStr;
	      hasExponent = true;
	    }
	  }
	
	  if (!hasExponent) {
	    var fractionLen = (numStr.split(DECIMAL_SEP)[1] || '').length;
	
	    // determine fractionSize if it is not specified
	    if (isUndefined(fractionSize)) {
	      fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac);
	    }
	
	    // safely round numbers in JS without hitting imprecisions of floating-point arithmetics
	    // inspired by:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
	    number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize);
	
	    var fraction = ('' + number).split(DECIMAL_SEP);
	    var whole = fraction[0];
	    fraction = fraction[1] || '';
	
	    var i, pos = 0,
	        lgroup = pattern.lgSize,
	        group = pattern.gSize;
	
	    if (whole.length >= (lgroup + group)) {
	      pos = whole.length - lgroup;
	      for (i = 0; i < pos; i++) {
	        if ((pos - i) % group === 0 && i !== 0) {
	          formatedText += groupSep;
	        }
	        formatedText += whole.charAt(i);
	      }
	    }
	
	    for (i = pos; i < whole.length; i++) {
	      if ((whole.length - i) % lgroup === 0 && i !== 0) {
	        formatedText += groupSep;
	      }
	      formatedText += whole.charAt(i);
	    }
	
	    // format fraction part.
	    while (fraction.length < fractionSize) {
	      fraction += '0';
	    }
	
	    if (fractionSize && fractionSize !== "0") formatedText += decimalSep + fraction.substr(0, fractionSize);
	  } else {
	    if (fractionSize > 0 && number < 1) {
	      formatedText = number.toFixed(fractionSize);
	      number = parseFloat(formatedText);
	    }
	  }
	
	  if (number === 0) {
	    isNegative = false;
	  }
	
	  parts.push(isNegative ? pattern.negPre : pattern.posPre,
	             formatedText,
	             isNegative ? pattern.negSuf : pattern.posSuf);
	  return parts.join('');
	}
	
	function padNumber(num, digits, trim) {
	  var neg = '';
	  if (num < 0) {
	    neg =  '-';
	    num = -num;
	  }
	  num = '' + num;
	  while (num.length < digits) num = '0' + num;
	  if (trim)
	    num = num.substr(num.length - digits);
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset)
	      value += offset;
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim);
	  };
	}
	
	function dateStrGetter(name, shortForm) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var get = uppercase(shortForm ? ('SHORT' + name) : name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date) {
	  var zone = -1 * date.getTimezoneOffset();
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4),
	    yy: dateGetter('FullYear', 2, 0, true),
	     y: dateGetter('FullYear', 1),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. Right now, only `'UTC'` is supported.
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = int(match[9] + match[10]);
	        tzMin = int(match[9] + match[11]);
	      }
	      dateSetter.call(date, int(match[1]), int(match[2]) - 1, int(match[3]));
	      var h = int(match[4] || 0) - tzHour;
	      var m = int(match[5] || 0) - tzMin;
	      var s = int(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? int(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date)) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    if (timezone && timezone === 'UTC') {
	      date = new Date(date.getTime());
	      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS)
	                 : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements
	 * are taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	 * converted to a string.
	 *
	 * @param {Array|string|number} input Source array, string or number to be limited.
	 * @param {string|number} limit The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	 *     had less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         Limit {{numbers}} to: <input type="number" step="1" ng-model="numLimit">
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         Limit {{letters}} to: <input type="number" step="1" ng-model="letterLimit">
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         Limit {{longNumber}} to: <input type="number" step="1" ng-model="longNumberLimit">
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit) {
	    if (isNumber(input)) input = input.toString();
	    if (!isArray(input) && !isString(input)) return input;
	
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = int(limit);
	    }
	
	    //NaN check on limit
	    if (limit) {
	      return limit > 0 ? input.slice(0, limit) : input.slice(limit);
	    } else {
	      return isString(input) ? "" : [];
	    }
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	 * correctly, make sure they are actually being saved as numbers and not strings.
	 *
	 * @param {Array} array The array to sort.
	 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	 *    used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `function`: Getter function. The result of this function will be sorted using the
	 *      `<`, `===`, `>` operator.
	 *    - `string`: An Angular expression. The result of this expression is used to compare elements
	 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	 *      3 first characters of a property called `name`). The result of a constant expression
	 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	 *      to sort object by the value of their `special name` property). An expression can be
	 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	 *      element itself is used to compare where sorting.
	 *    - `Array`: An array of function or string predicates. The first predicate in the array
	 *      is used for sorting, but when two items are equivalent, the next predicate is used.
	 *
	 *    If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse Reverse the order of the array.
	 * @returns {Array} Sorted copy of the source array.
	 *
	 *
	 * @example
	 * The example below demonstrates a simple ngRepeat, where the data is sorted
	 * by age in descending order (predicate is set to `'-age'`).
	 * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	     <file name="index.html">
	       <script>
	         angular.module('orderByExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.friends =
	                 [{name:'John', phone:'555-1212', age:10},
	                  {name:'Mary', phone:'555-9876', age:19},
	                  {name:'Mike', phone:'555-4321', age:21},
	                  {name:'Adam', phone:'555-5678', age:35},
	                  {name:'Julie', phone:'555-8765', age:29}];
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <table class="friend">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	   </example>
	 *
	 * The predicate and reverse parameters can be controlled dynamically through scope properties,
	 * as shown in the next example.
	 * @example
	   <example module="orderByExample">
	     <file name="index.html">
	       <script>
	         angular.module('orderByExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.friends =
	                 [{name:'John', phone:'555-1212', age:10},
	                  {name:'Mary', phone:'555-9876', age:19},
	                  {name:'Mike', phone:'555-4321', age:21},
	                  {name:'Adam', phone:'555-5678', age:35},
	                  {name:'Julie', phone:'555-8765', age:29}];
	             $scope.predicate = '-age';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	         <hr/>
	         [ <a href="" ng-click="predicate=''">unsorted</a> ]
	         <table class="friend">
	           <tr>
	             <th><a href="" ng-click="predicate = 'name'; reverse=false">Name</a>
	                 (<a href="" ng-click="predicate = '-name'; reverse=false">^</a>)</th>
	             <th><a href="" ng-click="predicate = 'phone'; reverse=!reverse">Phone Number</a></th>
	             <th><a href="" ng-click="predicate = 'age'; reverse=!reverse">Age</a></th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	   </example>
	 *
	 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	 * desired parameters.
	 *
	 * Example:
	 *
	 * @example
	  <example module="orderByExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <table class="friend">
	          <tr>
	            <th><a href="" ng-click="reverse=false;order('name', false)">Name</a>
	              (<a href="" ng-click="order('-name',false)">^</a>)</th>
	            <th><a href="" ng-click="reverse=!reverse;order('phone', reverse)">Phone Number</a></th>
	            <th><a href="" ng-click="reverse=!reverse;order('age',reverse)">Age</a></th>
	          </tr>
	          <tr ng-repeat="friend in friends">
	            <td>{{friend.name}}</td>
	            <td>{{friend.phone}}</td>
	            <td>{{friend.age}}</td>
	          </tr>
	        </table>
	      </div>
	    </file>
	
	    <file name="script.js">
	      angular.module('orderByExample', [])
	        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate, reverse) {
	            $scope.friends = orderBy($scope.friends, predicate, reverse);
	          };
	          $scope.order('-age',false);
	        }]);
	    </file>
	</example>
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder) {
	    if (!(isArrayLike(array))) return array;
	    sortPredicate = isArray(sortPredicate) ? sortPredicate : [sortPredicate];
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	    sortPredicate = sortPredicate.map(function(predicate) {
	      var descending = false, get = predicate || identity;
	      if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-';
	          predicate = predicate.substring(1);
	        }
	        if (predicate === '') {
	          // Effectively no predicate was passed so we compare identity
	          return reverseComparator(compare, descending);
	        }
	        get = $parse(predicate);
	        if (get.constant) {
	          var key = get();
	          return reverseComparator(function(a, b) {
	            return compare(a[key], b[key]);
	          }, descending);
	        }
	      }
	      return reverseComparator(function(a, b) {
	        return compare(get(a),get(b));
	      }, descending);
	    });
	    return slice.call(array).sort(reverseComparator(comparator, reverseOrder));
	
	    function comparator(o1, o2) {
	      for (var i = 0; i < sortPredicate.length; i++) {
	        var comp = sortPredicate[i](o1, o2);
	        if (comp !== 0) return comp;
	      }
	      return 0;
	    }
	    function reverseComparator(comp, descending) {
	      return descending
	          ? function(a, b) {return comp(b,a);}
	          : comp;
	    }
	
	    function isPrimitive(value) {
	      switch (typeof value) {
	        case 'number': /* falls through */
	        case 'boolean': /* falls through */
	        case 'string':
	          return true;
	        default:
	          return false;
	      }
	    }
	
	    function objectToString(value) {
	      if (value === null) return 'null';
	      if (typeof value.valueOf === 'function') {
	        value = value.valueOf();
	        if (isPrimitive(value)) return value;
	      }
	      if (typeof value.toString === 'function') {
	        value = value.toString();
	        if (isPrimitive(value)) return value;
	      }
	      return '';
	    }
	
	    function compare(v1, v2) {
	      var t1 = typeof v1;
	      var t2 = typeof v2;
	      if (t1 === t2 && t1 === "object") {
	        v1 = objectToString(v1);
	        v2 = objectToString(v2);
	      }
	      if (t1 === t2) {
	        if (t1 === "string") {
	           v1 = v1.toLowerCase();
	           v2 = v2.toLowerCase();
	        }
	        if (v1 === v2) return 0;
	        return v1 < v2 ? -1 : 1;
	      } else {
	        return t1 < t2 ? -1 : 1;
	      }
	    }
	  };
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref && !attr.name) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        xit('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}"/>
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x"/>
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute.  The following example would make the button enabled on Chrome/Firefox
	 * but not on older IEs:
	 *
	 * ```html
	 * <!-- See below for an example of ng-disabled being used correctly -->
	 * <div ng-init="isDisabled = false">
	 *  <button disabled="{{isDisabled}}">Disabled</button>
	 * </div>
	 * ```
	 *
	 * This is because the HTML specification does not require browsers to preserve the values of
	 * boolean attributes such as `disabled` (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        Click me to toggle: <input type="checkbox" ng-model="checked"><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as checked. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngChecked` directive solves this problem for the `checked` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	    <example>
	      <file name="index.html">
	        Check me to check both: <input type="checkbox" ng-model="master"><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then special attribute "checked" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as readonly. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngReadonly` directive solves this problem for the `readonly` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	    <example>
	      <file name="index.html">
	        Check me to make text readonly: <input type="checkbox" ng-model="checked"><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular"/>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as selected. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngSelected` directive solves this problem for the `selected` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        Check me to select: <input type="checkbox" ng-model="selected"><br/>
	        <select>
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as open. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngOpen` directive solves this problem for the `open` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	     <example>
	       <file name="index.html">
	         Check me check multiple: <input type="checkbox" ng-model="open"><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: function(scope, element, attr) {
	        scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	          attr.$set(attrName, !!value);
	        });
	      }
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  var parentForm = form.$$parentForm = element.parent().controller('form') || nullFormCtrl;
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	
	  parentForm.$addControl(form);
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   *
	   * @description
	   * Register a control with the form.
	   *
	   * Input elements using ngModelController do this automatically when they are linked.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    parentForm: parentForm,
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive which behaves identically to
	 * `<form>` but can be nested.  This allows you to have nested forms, which is very useful when
	 * using Angular validation directives in forms that are dynamically generated using the
	 * {@link ng.directive:ngRepeat `ngRepeat`} directive. Since you cannot dynamically generate the `name`
	 * attribute of input elements using interpolation, you have to wrap each set of repeated inputs in an
	 * `ngForm` directive and nest these in an outer `form` element.
	 *
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          -webkit-transition:all linear 0.5s;
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', function($timeout) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, controller) {
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = controller.$$parentForm;
	
	            if (nameAttr) {
	              setter(scope, null, controller.$name, controller, controller.$name);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, null, controller.$name, undefined, controller.$name);
	                parentFormCtrl.$$renameControl(controller, newValue);
	                setter(scope, null, controller.$name, controller, controller.$name);
	              });
	            }
	            formElement.on('$destroy', function() {
	              parentFormCtrl.$removeControl(controller);
	              if (nameAttr) {
	                setter(scope, null, attr[nameAttr], undefined, controller.$name);
	              }
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code is obtained from SO: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
	var URL_REGEXP = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
	var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/;
	var DATE_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object then this is used directly.
	   *    If the expression is a string then it will be converted to a RegExp after wrapping it in `^` and `$`
	   *    characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           Single word: <input type="text" name="input" ng-model="example.text"
	                               ng-pattern="example.word" required ng-trim="false">
	           <span class="error" ng-show="myForm.input.$error.required">
	             Required!</span>
	           <span class="error" ng-show="myForm.input.$error.pattern">
	             Single word only!</span>
	
	           <tt>text = {{example.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     * valid ISO date string (yyyy-MM-dd).
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     * a valid ISO date string (yyyy-MM-dd).
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          Pick a date in 2013:
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.date">
	              Not a valid date!</span>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	    * valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	    * a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        Pick a date between in 2013:
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	        <span class="error" ng-show="myForm.input.$error.datetimelocal">
	            Not a valid date!</span>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	   * valid ISO time format (HH:mm:ss).
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be a
	   * valid ISO time format (HH:mm:ss).
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        Pick a between 8am and 5pm:
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	        <span class="error" ng-show="myForm.input.$error.time">
	            Not a valid date!</span>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	    * valid ISO week format (yyyy-W##).
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	    * a valid ISO week format (yyyy-W##).
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        Pick a date between in 2013:
	        <input id="exampleInput" type="week" name="input" ng-model="example.value"
	            placeholder="YYYY-W##" min="2012-W32" max="2013-W52" required />
	        <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	        <span class="error" ng-show="myForm.input.$error.week">
	            Not a valid date!</span>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be
	   * a valid ISO month format (yyyy-MM).
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must
	   * be a valid ISO month format (yyyy-MM).
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       Pick a month in 2013:
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <span class="error" ng-show="myForm.input.$error.required">
	          Required!</span>
	       <span class="error" ng-show="myForm.input.$error.month">
	          Not a valid month!</span>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object then this is used directly.
	   *    If the expression is a string then it will be converted to a RegExp after wrapping it in `^` and `$`
	   *    characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           Number: <input type="number" name="input" ng-model="example.value"
	                          min="0" max="99" required>
	           <span class="error" ng-show="myForm.input.$error.required">
	             Required!</span>
	           <span class="error" ng-show="myForm.input.$error.number">
	             Not valid number!</span>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object then this is used directly.
	   *    If the expression is a string then it will be converted to a RegExp after wrapping it in `^` and `$`
	   *    characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           URL: <input type="url" name="input" ng-model="url.text" required>
	           <span class="error" ng-show="myForm.input.$error.required">
	             Required!</span>
	           <span class="error" ng-show="myForm.input.$error.url">
	             Not valid url!</span>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object then this is used directly.
	   *    If the expression is a string then it will be converted to a RegExp after wrapping it in `^` and `$`
	   *    characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             Email: <input type="email" name="input" ng-model="email.text" required>
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.email">
	               Not valid email!</span>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the expression should be set when selected.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression which sets the value to which the expression should
	   *    be set when selected.
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <input type="radio" ng-model="color.name" value="red">  Red <br/>
	           <input type="radio" ng-model="color.name" ng-value="specialValue"> Green <br/>
	           <input type="radio" ng-model="color.name" value="blue"> Blue <br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           Value1: <input type="checkbox" ng-model="checkboxModel.value1"> <br/>
	           Value2: <input type="checkbox" ng-model="checkboxModel.value2"
	                          ng-true-value="'YES'" ng-false-value="'NO'"> <br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function(data) {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var timeout;
	
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element.val(ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue);
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone === 'UTC') {
	          parsedDate.setMinutes(parsedDate.getMinutes() - parsedDate.getTimezoneOffset());
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone === 'UTC') {
	          var timezoneOffset = 60000 * previousDate.getTimezoneOffset();
	          previousDate = new Date(previousDate.getTime() + timezoneOffset);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) ? (isDate(val) ? val : parseDate(val)) : undefined;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      // Detect bug in FF35 for input[email] (https://bugzilla.mozilla.org/show_bug.cgi?id=1064430):
	      // - also sets validity.badInput (should only be validity.typeMismatch).
	      // - see http://www.whatwg.org/specs/web-apps/current-work/multipage/forms.html#e-mail-state-(type=email)
	      // - can ignore this case as we can still read out the erroneous email...
	      return validity.badInput && !validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
	 *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
	 *    patterns defined as scope expressions.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
	 *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
	 *    patterns defined as scope expressions.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           User name: <input type="text" name="userName" ng-model="user.name" required>
	           <span class="error" ng-show="myForm.userName.$error.required">
	             Required!</span><br>
	           Last name: <input type="text" name="lastName" ng-model="user.last"
	             ng-minlength="3" ng-maxlength="10">
	           <span class="error" ng-show="myForm.lastName.$error.minlength">
	             Too short!</span>
	           <span class="error" ng-show="myForm.lastName.$error.maxlength">
	             Too long!</span><br>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         Enter name: <input type="text" ng-model="name"><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = value === undefined ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        Salutation: <input type="text" ng-model="salutation"><br>
	        Name: <input type="text" ng-model="name"><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = value === undefined ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function getStringValue(value) {
	        return (value || '').toString();
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // we re-evaluate the expr because we want a TrustedValueHolderType
	          // for $sce, not a string
	          element.html($sce.getTrustedHtml(ngBindHtmlGetter(scope)) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          var classCounts = element.data('$classCounts') || {};
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          if (selector === true || scope.$index % 2 === selector) {
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          oldVal = shallowCopy(newVal);
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      if (isArray(classVal)) {
	        return classVal;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        var classes = [];
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an array, each element of the array should be a string that is
	 * one or more space-delimited class names.
	 *
	 * 3. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then the
	 * new classes are added.
	 *
	 * @animations
	 * **add** - happens just before the class is applied to the elements
	 *
	 * **remove** - happens just before the class is removed from the element
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, red: error}">Map Syntax Example</p>
	       <input type="checkbox" ng-model="deleted"> deleted (apply "strike" class)<br>
	       <input type="checkbox" ng-model="important"> important (apply "bold" class)<br>
	       <input type="checkbox" ng-model="error"> error (apply "red" class)
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style" placeholder="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1" placeholder="Type: bold, strike or red"><br>
	       <input ng-model="style2" placeholder="Type: bold, strike or red"><br>
	       <input ng-model="style3" placeholder="Type: bold, strike or red"><br>
	     </file>
	     <file name="style.css">
	       .strike {
	         text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/red/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/red/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.last().getAttribute('class')).toBe('bold strike red');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link ng.$animate#addClass $animate.addClass} and
	   {@link ng.$animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      Name: <input type="text" ng-model="settings.name"/>
	 *      [ <a href="" ng-click="settings.greet()">greet</a> ]<br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value"/>
	 *          [ <a href="" ng-click="settings.clearContact(contact)">clear</a>
	 *          | <a href="" ng-click="settings.removeContact(contact)">X</a> ]
	 *        </li>
	 *        <li>[ <a href="" ng-click="settings.addContact()">add</a> ]</li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.linkText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.linkText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     Name: <input type="text" ng-model="name"/>
	 *     [ <a href="" ng-click="greet()">greet</a> ]<br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value"/>
	 *         [ <a href="" ng-click="clearContact(contact)">clear</a>
	 *         | <a href="" ng-click="removeContact(contact)">X</a> ]
	 *       </li>
	 *       <li>[ <a href="" ng-click="addContact()">add</a> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.linkText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.linkText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 * Enables [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) support.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 * CSP forbids apps to use `eval` or `Function(string)` generated functions (among other things).
	 * For Angular to be CSP compatible there are only two things that we need to do differently:
	 *
	 * - don't use `Function` constructor to generate optimized value getters
	 * - don't inject custom stylesheet into the document
	 *
	 * AngularJS uses `Function(string)` generated functions as a speed optimization. Applying the `ngCsp`
	 * directive will cause Angular to use CSP compatibility mode. When this mode is on AngularJS will
	 * evaluate all expressions up to 30% slower than in non-CSP mode, but no security violations will
	 * be raised.
	 *
	 * CSP forbids JavaScript to inline stylesheet rules. In non CSP mode Angular automatically
	 * includes some CSS rules (e.g. {@link ng.directive:ngCloak ngCloak}).
	 * To make those directives work in CSP mode, include the `angular-csp.css` manually.
	 *
	 * Angular tries to autodetect if CSP is active and automatically turn on the CSP-safe mode. This
	 * autodetection however triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on the root element of the application or on the `angular.js` script tag, whichever
	 * appears first in the html document.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp.isActive() fn that looks for ng-csp attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * enter - happens just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container
	 * leave - happens just before the `ngIf` contents are removed from the DOM
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', function($animate) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = document.createComment(' end ngIf: ' + $attr.ngIf + ' ');
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * enter - animation is used to bring new content into the browser.
	 * leave - animation is used to animate existing content away.
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (/SVG/.test($element[0].toString())) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-error">
	 * The only appropriate use of `ngInit` is for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below. Besides this case, you
	 * should use {@link guide/controller controllers} rather than `ngInit`
	 * to initialize values on a scope.
	 * </div>
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with {@link ng.$filter `$filter`}, make
	 * sure you have parenthesis for correct precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = (data | orderBy:'name')"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      List: <input name="namesInput" ng-model="names" ng-list required>
	 *      <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on whitespace
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {string} $viewValue Actual string value in the view.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: ctrl.$modelValue});
	        } else {
	          parsedNgModelAssign($scope, ctrl.$modelValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different to last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different to their previous value. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different to the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  var parentForm = $element.inheritedData('$formController') || nullFormCtrl,
	      currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    parentForm: parentForm,
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced events or events such
	   * as blur you can have a situation where there is a period when the `$viewValue`
	   * is out of synch with the ngModel's `$modelValue`.
	   *
	   * In this case, you can run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.resetWithCancel = function(e) {
	   *         if (e.keyCode == 27) {
	   *           $scope.myForm.myInput1.$rollbackViewValue();
	   *           $scope.myValue = '';
	   *         }
	   *       };
	   *       $scope.resetWithoutCancel = function(e) {
	   *         if (e.keyCode == 27) {
	   *           $scope.myValue = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Try typing something in each input.  See that the model only updates when you
	   *          blur off the input.
	   *        </p>
	   *        <p>Now see what happens if you start typing then press the Escape key</p>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <p>With $rollbackViewValue()</p>
	   *         <input name="myInput1" ng-model="myValue" ng-keydown="resetWithCancel($event)"><br/>
	   *         myValue: "{{ myValue }}"
	   *
	   *         <p>Without $rollbackViewValue()</p>
	   *         <input name="myInput2" ng-model="myValue" ng-keydown="resetWithoutCancel($event)"><br/>
	   *         myValue: "{{ myValue }}"
	   *       </form>
	   *     </div>
	   *   </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (parserValid === undefined) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr("$asyncValidators",
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function(error) {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when an input directive want to change the view value; typically,
	   * this is done from within a DOM event handler.
	   *
	   * For example {@link ng.directive:input input} calls it when the value of the input changes and
	   * {@link ng.directive:select select} calls it when an option is selected.
	   *
	   * If the new `value` is an object (rather than a string or a number), we should make a copy of the
	   * object before passing it to `$setViewValue`.  This is because `ngModel` does not perform a deep
	   * watch of objects, it only looks for a change of identity. If you only change the property of
	   * the object then ngModel will not realise that the object has changed and will not invoke the
	   * `$parsers` and `$validators` pipelines.
	   *
	   * For this reason, you should not change properties of the copy once it has been passed to
	   * `$setViewValue`. Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * When this method is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute.
	   *
	   * Lastly, all the registered change listeners, in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   *
	   * Note that calling this function does not trigger a `$digest`.
	   *
	   * @param {string} value Value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`, `ng-untouched`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes are: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           -webkit-transition:all linear 0.5s;
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       Update input to see transitions when valid/invalid.
	       Integer is a valid value.
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different than what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           Name:
	           <input type="text" name="userName"
	                  ng-model="user.name"
	                  ng-model-options="{ getterSetter: true }" />
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || nullFormCtrl;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              formCtrl.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            formCtrl.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function(ev) {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different than the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: {'default': 500, 'blur': 0} }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . Right now, the only supported value is `'UTC'`,
	 *     otherwise the default timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          Name:
	          <input type="text" name="userName"
	                 ng-model="user.name"
	                 ng-model-options="{ updateOn: 'blur' }"
	                 ng-keyup="cancel($event)" /><br />
	
	          Other data:
	          <input type="text" ng-model="user.data" /><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'say', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' hello');
	        input.click();
	        expect(model.getText()).toEqual('say');
	        other.click();
	        expect(model.getText()).toEqual('say hello');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' hello');
	        expect(input.getAttribute('value')).toEqual('say hello');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('say');
	        other.click();
	        expect(model.getText()).toEqual('say');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          Name:
	          <input type="text" name="userName"
	                 ng-model="user.name"
	                 ng-model-options="{ debounce: 1000 }" />
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'say' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          Name:
	          <input type="text" name="userName"
	                 ng-model="user.name"
	                 ng-model-options="{ getterSetter: true }" />
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = $scope.$eval($attrs.ngModelOptions);
	      // Allow adding/overriding bound events
	      if (this.$options.updateOn !== undefined) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      parentForm = context.parentForm,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (state === undefined) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          Person 1:<input type="text" ng-model="person1" value="Igor" /><br/>
	          Person 2:<input type="text" ng-model="person2" value="Misko" /><br/>
	          Number of People:<input type="text" ng-model="personCount" value="1" /><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', function($locale, $interpolate) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    restrict: 'EA',
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to exlicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNaN(lastCount))) {
	          watchRemover();
	          watchRemover = scope.$watch(whensExpFns[count], updateElementText);
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 * This may be useful when, for instance, nesting ngRepeats.
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * You need to be aware that the JavaScript specification does not define what order
	 * it will return the keys for an object. In order to have a guaranteed deterministic order
	 * for the keys, Angular versions up to and including 1.3 **sort the keys alphabetically**.
	 *
	 * If this is not desired, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`.  You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 * In version 1.4 we will remove the sorting, since it seems that browsers generally follow the
	 * strategy of providing keys in the order in which they were defined, although there are exceptions
	 * when keys are deleted and reinstated.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * When the contents of the collection change, `ngRepeat` makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * By default, `ngRepeat` does not allow duplicate items in arrays. This is because when
	 * there are duplicates, it is not possible to maintain a one-to-one mapping between collection
	 * items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * If you are working with objects that have an identifier property, you can track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones:
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * **.enter** - when a new item is added to the list or when an item is revealed after a filter
	 *
	 * **.leave** - when an item is removed from the list or when an item is filtered out
	 *
	 * **.move** - when an adjacent item is filtered out causing a reorder or when the item contents are reordered
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)  If filters are used in the expression, they should be
	 *     applied before the tracking expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 * @example
	 * This example initializes the scope to a list of names and
	 * then uses `ngRepeat` to display every person:
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-init="friends = [
	        {name:'John', age:25, gender:'boy'},
	        {name:'Jessie', age:30, gender:'girl'},
	        {name:'Johanna', age:28, gender:'girl'},
	        {name:'Joy', age:15, gender:'girl'},
	        {name:'Mary', age:28, gender:'girl'},
	        {name:'Peter', age:95, gender:'boy'},
	        {name:'Sebastian', age:50, gender:'boy'},
	        {name:'Erika', age:27, gender:'girl'},
	        {name:'Patrick', age:40, gender:'boy'},
	        {name:'Samantha', age:60, gender:'girl'}
	      ]">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:40px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        -webkit-transition:all linear 0.5s;
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:40px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', function($parse, $animate) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = document.createComment(' end ngRepeat: ' + expression + ' ');
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, sort them and use to determine order of iteration over obj props
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (collection.hasOwnProperty(itemKey) && itemKey.charAt(0) != '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	            collectionKeys.sort();
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, jqLite(previousNode));
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                // TODO(perf): support naked previousNode in `enter` to avoid creation of jqLite wrapper?
	                $animate.enter(clone, null, jqLite(previousNode));
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * addClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a truthy value and the just before contents are set to visible
	 * removeClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add.ng-hide-add-active,
	      .animate-show.ng-hide-remove.ng-hide-remove-active {
	        -webkit-transition: all linear 0.5s;
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * removeClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden
	 * addClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a non truthy value and just before the contents are set to visible
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        -webkit-transition: all linear 0.5s;
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * enter - happens after the ngSwitch contents change and the matched child element is placed inside the container
	 * leave - happens just after the ngSwitch contents change and just before the former contents are removed from the DOM
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'EA',
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = document.createComment(' end ngSwitchWhen: ');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * Any existing content of the element that this directive is placed on will be removed before the transcluded content is inserted.
	 *
	 * @element ANY
	 *
	 * @example
	   <example module="transcludeExample">
	     <file name="index.html">
	       <script>
	         angular.module('transcludeExample', [])
	          .directive('pane', function(){
	             return {
	               restrict: 'E',
	               transclude: true,
	               scope: { title:'@' },
	               template: '<div style="border: 1px solid black;">' +
	                           '<div style="background-color: gray">{{title}}</div>' +
	                           '<ng-transclude></ng-transclude>' +
	                         '</div>'
	             };
	         })
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.title = 'Lorem Ipsum';
	           $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	         }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input ng-model="title"> <br/>
	         <textarea ng-model="text"></textarea> <br/>
	         <pane title="{{title}}">{{text}}</pane>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	        it('should have transcluded', function() {
	          var titleElement = element(by.model('title'));
	          titleElement.clear();
	          titleElement.sendKeys('TITLE');
	          var textElement = element(by.model('text'));
	          textElement.clear();
	          textElement.sendKeys('TEXT');
	          expect(element(by.binding('title')).getText()).toEqual('TITLE');
	          expect(element(by.binding('text')).getText()).toEqual('TEXT');
	        });
	     </file>
	   </example>
	 *
	 */
	var ngTranscludeDirective = ngDirective({
	  restrict: 'EAC',
	  link: function($scope, $element, $attrs, controller, $transclude) {
	    if (!$transclude) {
	      throw minErr('ngTransclude')('orphan',
	       'Illegal use of ngTransclude directive in the template! ' +
	       'No parent directive that requires a transclusion found. ' +
	       'Element: {0}',
	       startingTag($element));
	    }
	
	    $transclude(function(clone) {
	      $element.empty();
	      $element.append(clone);
	    });
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var ngOptionsMinErr = minErr('ngOptions');
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * # `ngOptions`
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `ngModel` compares by reference, not value. This is important when binding to an
	 * array of objects. See an example [in this jsfiddle](http://jsfiddle.net/qWzTb/).
	 * </div>
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Do not use `select` **`as`** and **`track by`** in the same expression. They are not designed to work together.
	 * </div>
	 *
	 * Consider the following example:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in values track by item.id" ng-model="selected">
	 * ```
	 *
	 * ```js
	 * $scope.values = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 *
	 * $scope.selected = { name: 'aSubItem' };
	 * ```
	 *
	 * With the purpose of preserving the selection, the **`track by`** expression is always applied to the element
	 * of the data source (to `item` in this example). To calculate whether an element is selected, we do the
	 * following:
	 *
	 * 1. Apply **`track by`** to the elements in the array. In the example: `[1, 2]`
	 * 2. Apply **`track by`** to the already selected value in `ngModel`.
	 *    In the example: this is not possible as **`track by`** refers to `item.id`, but the selected
	 *    value from `ngModel` is `{name: 'aSubItem'}`, so the **`track by`** expression is applied to
	 *    a wrong object, the selected element can't be found, `<select>` is always reset to the "not
	 *    selected" option.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light'},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark'},
	              {name:'yellow', shade:'light'}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              Name: <input ng-model="color.name">
	              [<a href ng-click="colors.splice($index, 1)">X</a>]
	            </li>
	            <li>
	              [<a href ng-click="colors.push({})">add</a>]
	            </li>
	          </ul>
	          <hr/>
	          Color (null not allowed):
	          <select ng-model="myColor" ng-options="color.name for color in colors"></select><br>
	
	          Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span><br/>
	
	          Color grouped by shade:
	          <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	          </select><br/>
	
	
	          Select <a href ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</a>.<br>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	var ngOptionsDirective = valueFn({
	  restrict: 'A',
	  terminal: true
	});
	
	// jshint maxlen: false
	var selectDirective = ['$compile', '$parse', function($compile,   $parse) {
	                         //000011111111110000000000022222222220000000000000000000003333333333000000000000004444444444444440000000005555555555555550000000666666666666666000000000000000777777777700000000000000000008888888888
	  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/,
	      nullModelCtrl = {$setViewValue: noop};
	// jshint maxlen: 100
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
	      var self = this,
	          optionsMap = {},
	          ngModelCtrl = nullModelCtrl,
	          nullOption,
	          unknownOption;
	
	
	      self.databound = $attrs.ngModel;
	
	
	      self.init = function(ngModelCtrl_, nullOption_, unknownOption_) {
	        ngModelCtrl = ngModelCtrl_;
	        nullOption = nullOption_;
	        unknownOption = unknownOption_;
	      };
	
	
	      self.addOption = function(value, element) {
	        assertNotHasOwnProperty(value, '"option value"');
	        optionsMap[value] = true;
	
	        if (ngModelCtrl.$viewValue == value) {
	          $element.val(value);
	          if (unknownOption.parent()) unknownOption.remove();
	        }
	        // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	        // Adding an <option selected="selected"> element to a <select required="required"> should
	        // automatically select the new element
	        if (element && element[0].hasAttribute('selected')) {
	          element[0].selected = true;
	        }
	      };
	
	
	      self.removeOption = function(value) {
	        if (this.hasOption(value)) {
	          delete optionsMap[value];
	          if (ngModelCtrl.$viewValue === value) {
	            this.renderUnknownOption(value);
	          }
	        }
	      };
	
	
	      self.renderUnknownOption = function(val) {
	        var unknownVal = '? ' + hashKey(val) + ' ?';
	        unknownOption.val(unknownVal);
	        $element.prepend(unknownOption);
	        $element.val(unknownVal);
	        unknownOption.prop('selected', true); // needed for IE
	      };
	
	
	      self.hasOption = function(value) {
	        return optionsMap.hasOwnProperty(value);
	      };
	
	      $scope.$on('$destroy', function() {
	        // disable unknown option so that we don't do work when the whole select is being destroyed
	        self.renderUnknownOption = noop;
	      });
	    }],
	
	    link: function(scope, element, attr, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      if (!ctrls[1]) return;
	
	      var selectCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1],
	          multiple = attr.multiple,
	          optionsExp = attr.ngOptions,
	          nullOption = false, // if false, user will not be able to select it (used by ngOptions)
	          emptyOption,
	          renderScheduled = false,
	          // we can't just jqLite('<option>') since jqLite is not smart enough
	          // to create it in <select> and IE barfs otherwise.
	          optionTemplate = jqLite(document.createElement('option')),
	          optGroupTemplate =jqLite(document.createElement('optgroup')),
	          unknownOption = optionTemplate.clone();
	
	      // find "null" option
	      for (var i = 0, children = element.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = nullOption = children.eq(i);
	          break;
	        }
	      }
	
	      selectCtrl.init(ngModelCtrl, nullOption, unknownOption);
	
	      // required validator
	      if (multiple) {
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      }
	
	      if (optionsExp) setupAsOptions(scope, element, ngModelCtrl);
	      else if (multiple) setupAsMultiple(scope, element, ngModelCtrl);
	      else setupAsSingle(scope, element, ngModelCtrl, selectCtrl);
	
	
	      ////////////////////////////
	
	
	
	      function setupAsSingle(scope, selectElement, ngModelCtrl, selectCtrl) {
	        ngModelCtrl.$render = function() {
	          var viewValue = ngModelCtrl.$viewValue;
	
	          if (selectCtrl.hasOption(viewValue)) {
	            if (unknownOption.parent()) unknownOption.remove();
	            selectElement.val(viewValue);
	            if (viewValue === '') emptyOption.prop('selected', true); // to make IE9 happy
	          } else {
	            if (viewValue == null && emptyOption) {
	              selectElement.val('');
	            } else {
	              selectCtrl.renderUnknownOption(viewValue);
	            }
	          }
	        };
	
	        selectElement.on('change', function() {
	          scope.$apply(function() {
	            if (unknownOption.parent()) unknownOption.remove();
	            ngModelCtrl.$setViewValue(selectElement.val());
	          });
	        });
	      }
	
	      function setupAsMultiple(scope, selectElement, ctrl) {
	        var lastView;
	        ctrl.$render = function() {
	          var items = new HashMap(ctrl.$viewValue);
	          forEach(selectElement.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        scope.$watch(function selectMultipleWatch() {
	          if (!equals(lastView, ctrl.$viewValue)) {
	            lastView = shallowCopy(ctrl.$viewValue);
	            ctrl.$render();
	          }
	        });
	
	        selectElement.on('change', function() {
	          scope.$apply(function() {
	            var array = [];
	            forEach(selectElement.find('option'), function(option) {
	              if (option.selected) {
	                array.push(option.value);
	              }
	            });
	            ctrl.$setViewValue(array);
	          });
	        });
	      }
	
	      function setupAsOptions(scope, selectElement, ctrl) {
	        var match;
	
	        if (!(match = optionsExp.match(NG_OPTIONS_REGEXP))) {
	          throw ngOptionsMinErr('iexp',
	            "Expected expression in form of " +
	            "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	            " but got '{0}'. Element: {1}",
	            optionsExp, startingTag(selectElement));
	        }
	
	        var displayFn = $parse(match[2] || match[1]),
	            valueName = match[4] || match[6],
	            selectAs = / as /.test(match[0]) && match[1],
	            selectAsFn = selectAs ? $parse(selectAs) : null,
	            keyName = match[5],
	            groupByFn = $parse(match[3] || ''),
	            valueFn = $parse(match[2] ? match[1] : valueName),
	            valuesFn = $parse(match[7]),
	            track = match[8],
	            trackFn = track ? $parse(match[8]) : null,
	            trackKeysCache = {},
	            // This is an array of array of existing option groups in DOM.
	            // We try to reuse these if possible
	            // - optionGroupsCache[0] is the options with no option group
	            // - optionGroupsCache[?][0] is the parent: either the SELECT or OPTGROUP element
	            optionGroupsCache = [[{element: selectElement, label:''}]],
	            //re-usable object to represent option's locals
	            locals = {};
	
	        if (nullOption) {
	          // compile the element since there might be bindings in it
	          $compile(nullOption)(scope);
	
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          nullOption.removeClass('ng-scope');
	
	          // we need to remove it before calling selectElement.empty() because otherwise IE will
	          // remove the label from the element. wtf?
	          nullOption.remove();
	        }
	
	        // clear contents, we'll add what's needed based on the model
	        selectElement.empty();
	
	        selectElement.on('change', selectionChanged);
	
	        ctrl.$render = render;
	
	        scope.$watchCollection(valuesFn, scheduleRendering);
	        scope.$watchCollection(getLabels, scheduleRendering);
	
	        if (multiple) {
	          scope.$watchCollection(function() { return ctrl.$modelValue; }, scheduleRendering);
	        }
	
	        // ------------------------------------------------------------------ //
	
	        function callExpression(exprFn, key, value) {
	          locals[valueName] = value;
	          if (keyName) locals[keyName] = key;
	          return exprFn(scope, locals);
	        }
	
	        function selectionChanged() {
	          scope.$apply(function() {
	            var collection = valuesFn(scope) || [];
	            var viewValue;
	            if (multiple) {
	              viewValue = [];
	              forEach(selectElement.val(), function(selectedKey) {
	                  selectedKey = trackFn ? trackKeysCache[selectedKey] : selectedKey;
	                viewValue.push(getViewValue(selectedKey, collection[selectedKey]));
	              });
	            } else {
	              var selectedKey = trackFn ? trackKeysCache[selectElement.val()] : selectElement.val();
	              viewValue = getViewValue(selectedKey, collection[selectedKey]);
	            }
	            ctrl.$setViewValue(viewValue);
	            render();
	          });
	        }
	
	        function getViewValue(key, value) {
	          if (key === '?') {
	            return undefined;
	          } else if (key === '') {
	            return null;
	          } else {
	            var viewValueFn = selectAsFn ? selectAsFn : valueFn;
	            return callExpression(viewValueFn, key, value);
	          }
	        }
	
	        function getLabels() {
	          var values = valuesFn(scope);
	          var toDisplay;
	          if (values && isArray(values)) {
	            toDisplay = new Array(values.length);
	            for (var i = 0, ii = values.length; i < ii; i++) {
	              toDisplay[i] = callExpression(displayFn, i, values[i]);
	            }
	            return toDisplay;
	          } else if (values) {
	            // TODO: Add a test for this case
	            toDisplay = {};
	            for (var prop in values) {
	              if (values.hasOwnProperty(prop)) {
	                toDisplay[prop] = callExpression(displayFn, prop, values[prop]);
	              }
	            }
	          }
	          return toDisplay;
	        }
	
	        function createIsSelectedFn(viewValue) {
	          var selectedSet;
	          if (multiple) {
	            if (trackFn && isArray(viewValue)) {
	
	              selectedSet = new HashMap([]);
	              for (var trackIndex = 0; trackIndex < viewValue.length; trackIndex++) {
	                // tracking by key
	                selectedSet.put(callExpression(trackFn, null, viewValue[trackIndex]), true);
	              }
	            } else {
	              selectedSet = new HashMap(viewValue);
	            }
	          } else if (trackFn) {
	            viewValue = callExpression(trackFn, null, viewValue);
	          }
	
	          return function isSelected(key, value) {
	            var compareValueFn;
	            if (trackFn) {
	              compareValueFn = trackFn;
	            } else if (selectAsFn) {
	              compareValueFn = selectAsFn;
	            } else {
	              compareValueFn = valueFn;
	            }
	
	            if (multiple) {
	              return isDefined(selectedSet.remove(callExpression(compareValueFn, key, value)));
	            } else {
	              return viewValue === callExpression(compareValueFn, key, value);
	            }
	          };
	        }
	
	        function scheduleRendering() {
	          if (!renderScheduled) {
	            scope.$$postDigest(render);
	            renderScheduled = true;
	          }
	        }
	
	        /**
	         * A new labelMap is created with each render.
	         * This function is called for each existing option with added=false,
	         * and each new option with added=true.
	         * - Labels that are passed to this method twice,
	         * (once with added=true and once with added=false) will end up with a value of 0, and
	         * will cause no change to happen to the corresponding option.
	         * - Labels that are passed to this method only once with added=false will end up with a
	         * value of -1 and will eventually be passed to selectCtrl.removeOption()
	         * - Labels that are passed to this method only once with added=true will end up with a
	         * value of 1 and will eventually be passed to selectCtrl.addOption()
	        */
	        function updateLabelMap(labelMap, label, added) {
	          labelMap[label] = labelMap[label] || 0;
	          labelMap[label] += (added ? 1 : -1);
	        }
	
	        function render() {
	          renderScheduled = false;
	
	          // Temporary location for the option groups before we render them
	          var optionGroups = {'':[]},
	              optionGroupNames = [''],
	              optionGroupName,
	              optionGroup,
	              option,
	              existingParent, existingOptions, existingOption,
	              viewValue = ctrl.$viewValue,
	              values = valuesFn(scope) || [],
	              keys = keyName ? sortedKeys(values) : values,
	              key,
	              value,
	              groupLength, length,
	              groupIndex, index,
	              labelMap = {},
	              selected,
	              isSelected = createIsSelectedFn(viewValue),
	              anySelected = false,
	              lastElement,
	              element,
	              label,
	              optionId;
	
	          trackKeysCache = {};
	
	          // We now build up the list of options we need (we merge later)
	          for (index = 0; length = keys.length, index < length; index++) {
	            key = index;
	            if (keyName) {
	              key = keys[index];
	              if (key.charAt(0) === '$') continue;
	            }
	            value = values[key];
	
	            optionGroupName = callExpression(groupByFn, key, value) || '';
	            if (!(optionGroup = optionGroups[optionGroupName])) {
	              optionGroup = optionGroups[optionGroupName] = [];
	              optionGroupNames.push(optionGroupName);
	            }
	
	            selected = isSelected(key, value);
	            anySelected = anySelected || selected;
	
	            label = callExpression(displayFn, key, value); // what will be seen by the user
	
	            // doing displayFn(scope, locals) || '' overwrites zero values
	            label = isDefined(label) ? label : '';
	            optionId = trackFn ? trackFn(scope, locals) : (keyName ? keys[index] : index);
	            if (trackFn) {
	              trackKeysCache[optionId] = key;
	            }
	
	            optionGroup.push({
	              // either the index into array or key from object
	              id: optionId,
	              label: label,
	              selected: selected                   // determine if we should be selected
	            });
	          }
	          if (!multiple) {
	            if (nullOption || viewValue === null) {
	              // insert null option if we have a placeholder, or the model is null
	              optionGroups[''].unshift({id:'', label:'', selected:!anySelected});
	            } else if (!anySelected) {
	              // option could not be found, we have to insert the undefined item
	              optionGroups[''].unshift({id:'?', label:'', selected:true});
	            }
	          }
	
	          // Now we need to update the list of DOM nodes to match the optionGroups we computed above
	          for (groupIndex = 0, groupLength = optionGroupNames.length;
	               groupIndex < groupLength;
	               groupIndex++) {
	            // current option group name or '' if no group
	            optionGroupName = optionGroupNames[groupIndex];
	
	            // list of options for that group. (first item has the parent)
	            optionGroup = optionGroups[optionGroupName];
	
	            if (optionGroupsCache.length <= groupIndex) {
	              // we need to grow the optionGroups
	              existingParent = {
	                element: optGroupTemplate.clone().attr('label', optionGroupName),
	                label: optionGroup.label
	              };
	              existingOptions = [existingParent];
	              optionGroupsCache.push(existingOptions);
	              selectElement.append(existingParent.element);
	            } else {
	              existingOptions = optionGroupsCache[groupIndex];
	              existingParent = existingOptions[0];  // either SELECT (no group) or OPTGROUP element
	
	              // update the OPTGROUP label if not the same.
	              if (existingParent.label != optionGroupName) {
	                existingParent.element.attr('label', existingParent.label = optionGroupName);
	              }
	            }
	
	            lastElement = null;  // start at the beginning
	            for (index = 0, length = optionGroup.length; index < length; index++) {
	              option = optionGroup[index];
	              if ((existingOption = existingOptions[index + 1])) {
	                // reuse elements
	                lastElement = existingOption.element;
	                if (existingOption.label !== option.label) {
	                  updateLabelMap(labelMap, existingOption.label, false);
	                  updateLabelMap(labelMap, option.label, true);
	                  lastElement.text(existingOption.label = option.label);
	                  lastElement.prop('label', existingOption.label);
	                }
	                if (existingOption.id !== option.id) {
	                  lastElement.val(existingOption.id = option.id);
	                }
	                // lastElement.prop('selected') provided by jQuery has side-effects
	                if (lastElement[0].selected !== option.selected) {
	                  lastElement.prop('selected', (existingOption.selected = option.selected));
	                  if (msie) {
	                    // See #7692
	                    // The selected item wouldn't visually update on IE without this.
	                    // Tested on Win7: IE9, IE10 and IE11. Future IEs should be tested as well
	                    lastElement.prop('selected', existingOption.selected);
	                  }
	                }
	              } else {
	                // grow elements
	
	                // if it's a null option
	                if (option.id === '' && nullOption) {
	                  // put back the pre-compiled element
	                  element = nullOption;
	                } else {
	                  // jQuery(v1.4.2) Bug: We should be able to chain the method calls, but
	                  // in this version of jQuery on some browser the .text() returns a string
	                  // rather then the element.
	                  (element = optionTemplate.clone())
	                      .val(option.id)
	                      .prop('selected', option.selected)
	                      .attr('selected', option.selected)
	                      .prop('label', option.label)
	                      .text(option.label);
	                }
	
	                existingOptions.push(existingOption = {
	                    element: element,
	                    label: option.label,
	                    id: option.id,
	                    selected: option.selected
	                });
	                updateLabelMap(labelMap, option.label, true);
	                if (lastElement) {
	                  lastElement.after(element);
	                } else {
	                  existingParent.element.append(element);
	                }
	                lastElement = element;
	              }
	            }
	            // remove any excessive OPTIONs in a group
	            index++; // increment since the existingOptions[0] is parent element not OPTION
	            while (existingOptions.length > index) {
	              option = existingOptions.pop();
	              updateLabelMap(labelMap, option.label, false);
	              option.element.remove();
	            }
	          }
	          // remove any excessive OPTGROUPs from select
	          while (optionGroupsCache.length > groupIndex) {
	            // remove all the labels in the option group
	            optionGroup = optionGroupsCache.pop();
	            for (index = 1; index < optionGroup.length; ++index) {
	              updateLabelMap(labelMap, optionGroup[index].label, false);
	            }
	            optionGroup[0].element.remove();
	          }
	          forEach(labelMap, function(count, label) {
	            if (count > 0) {
	              selectCtrl.addOption(label);
	            } else if (count < 0) {
	              selectCtrl.removeOption(label);
	            }
	          });
	        }
	      }
	    }
	  };
	}];
	
	var optionDirective = ['$interpolate', function($interpolate) {
	  var nullSelectCtrl = {
	    addOption: noop,
	    removeOption: noop
	  };
	
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isUndefined(attr.value)) {
	        var interpolateFn = $interpolate(element.text(), true);
	        if (!interpolateFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (!selectCtrl || !selectCtrl.databound) {
	          selectCtrl = nullSelectCtrl;
	        }
	
	        if (interpolateFn) {
	          scope.$watch(interpolateFn, function interpolateWatchAction(newVal, oldVal) {
	            attr.$set('value', newVal);
	            if (oldVal !== newVal) {
	              selectCtrl.removeOption(oldVal);
	            }
	            selectCtrl.addOption(newVal, element);
	          });
	        } else {
	          selectCtrl.addOption(attr.value, element);
	        }
	
	        element.on('$destroy', function() {
	          selectCtrl.removeOption(attr.value);
	        });
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = int(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = int(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	  if (window.angular.bootstrap) {
	    //AngularJS is already loaded, so we can return here...
	    console.log('WARNING: Tried to load angular more than once.');
	    return;
	  }
	
	  //try to bind to jquery now so that one can write jqLite(document).ready()
	  //but we will rebind on bootstrap again.
	  bindJQuery();
	
	  publishExternalAPI(angular);
	
	  jqLite(document).ready(function() {
	    angularInit(document, bootstrap);
	  });
	
	})(window, document);
	
	!window.angular.$$csp() && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}</style>');

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(22);
	
	var callBind = __webpack_require__(70);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(483)();
	
	__webpack_require__(482)(Chart);
	__webpack_require__(478)(Chart);
	__webpack_require__(481)(Chart);
	__webpack_require__(477)(Chart);
	__webpack_require__(479)(Chart);
	__webpack_require__(480)(Chart);
	__webpack_require__(484)(Chart);
	__webpack_require__(488)(Chart);
	__webpack_require__(486)(Chart);
	__webpack_require__(487)(Chart);
	__webpack_require__(489)(Chart);
	__webpack_require__(485)(Chart);
	__webpack_require__(490)(Chart);
	
	__webpack_require__(491)(Chart);
	__webpack_require__(492)(Chart);
	__webpack_require__(493)(Chart);
	__webpack_require__(494)(Chart);
	
	__webpack_require__(497)(Chart);
	__webpack_require__(495)(Chart);
	__webpack_require__(496)(Chart);
	__webpack_require__(498)(Chart);
	__webpack_require__(499)(Chart);
	__webpack_require__(500)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(471)(Chart);
	__webpack_require__(472)(Chart);
	__webpack_require__(473)(Chart);
	__webpack_require__(474)(Chart);
	__webpack_require__(475)(Chart);
	__webpack_require__(476)(Chart);
	
	__webpack_require__(464)(Chart);
	__webpack_require__(465)(Chart);
	__webpack_require__(466)(Chart);
	__webpack_require__(467)(Chart);
	__webpack_require__(468)(Chart);
	__webpack_require__(469)(Chart);
	__webpack_require__(470)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.options = Chart.helpers.configMerge({aspectRatio: 1}, config.options);
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				// Use this to indicate that this is a bar dataset.
				this.getMeta().bar = true;
			},
	
			// Get the number of datasets that display bars. We use this to correctly calculate the bar width
			getBarCount: function() {
				var me = this;
				var barCount = 0;
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var meta = me.chart.getDatasetMeta(datasetIndex);
					if (meta.bar && me.chart.isDatasetVisible(datasetIndex)) {
						++barCount;
					}
				}, me);
				return barCount;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: me.calculateBarX(index, me.index),
						y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						width: me.calculateBarWidth(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					}
				});
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = 0;
	
				if (yScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var datasetCount = me.getBarCount();
	
				var tickWidth;
	
				if (xScale.options.type === 'category') {
					tickWidth = xScale.getPixelForTick(index + 1) - xScale.getPixelForTick(index);
				} else {
					// Average width
					tickWidth = xScale.width / xScale.ticks.length;
				}
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / datasetCount;
	
				if (xScale.ticks.length !== me.chart.data.labels.length) {
					var perc = xScale.ticks.length / me.chart.data.labels.length;
					fullBarWidth = fullBarWidth * perc;
				}
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(index) {
				var xScale = this.getScaleForId(this.getMeta().xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				var ruler = this.getRuler(index);
				return xScale.options.stacked ? ruler.categoryWidth : ruler.barWidth;
			},
	
			// Get bar index from the given dataset index accounting for the fact that not all bars are visible
			getBarIndex: function(datasetIndex) {
				var barIndex = 0;
				var meta, j;
	
				for (j = 0; j < datasetIndex; ++j) {
					meta = this.chart.getDatasetMeta(j);
					if (meta.bar && this.chart.isDatasetVisible(j)) {
						++barIndex;
					}
				}
	
				return barIndex;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				if (xScale.options.stacked) {
					return leftTick + (ruler.categoryWidth / 2) + ruler.categorySpacing;
				}
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					var d = me.getDataset().data[index];
					if (d !== null && d !== undefined && !isNaN(d)) {
						rectangle.transition(easingDecimal).draw();
					}
				}, me);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? scaleBase : me.calculateBarX(index, me.index),
						y: me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						height: me.calculateBarHeight(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					},
	
					draw: function() {
						var ctx = this._chart.ctx;
						var vm = this._view;
	
						var halfHeight = vm.height / 2,
							topY = vm.y - halfHeight,
							bottomY = vm.y + halfHeight,
							right = vm.base - (vm.base - vm.x),
							halfStroke = vm.borderWidth / 2;
	
						// Canvas doesn't allow us to stroke inside the width so we can
						// adjust the sizes to fit if we're setting a stroke on the line
						if (vm.borderWidth) {
							topY += halfStroke;
							bottomY -= halfStroke;
							right += halfStroke;
						}
	
						ctx.beginPath();
	
						ctx.fillStyle = vm.backgroundColor;
						ctx.strokeStyle = vm.borderColor;
						ctx.lineWidth = vm.borderWidth;
	
						// Corner points, from bottom-left to bottom-right clockwise
						// | 1 2 |
						// | 0 3 |
						var corners = [
							[vm.base, bottomY],
							[vm.base, topY],
							[right, topY],
							[right, bottomY]
						];
	
						// Find first (starting) corner with fallback to 'bottom'
						var borders = ['bottom', 'left', 'top', 'right'];
						var startCorner = borders.indexOf(vm.borderSkipped, 0);
						if (startCorner === -1) {
							startCorner = 0;
						}
	
						function cornerAt(cornerIndex) {
							return corners[(startCorner + cornerIndex) % 4];
						}
	
						// Draw rectangle from 'startCorner'
						ctx.moveTo.apply(ctx, cornerAt(0));
						for (var i = 1; i < 4; i++) {
							ctx.lineTo.apply(ctx, cornerAt(i));
						}
	
						ctx.fill();
						if (vm.borderWidth) {
							ctx.stroke();
						}
					},
	
					inRange: function(mouseX, mouseY) {
						var vm = this._view;
						var inRange = false;
	
						if (vm) {
							if (vm.x < vm.base) {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.x && mouseX <= vm.base);
							} else {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.base && mouseX <= vm.x);
							}
						}
	
						return inRange;
					}
				});
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = 0;
	
				if (xScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var datasetCount = me.getBarCount();
	
				var tickHeight;
				if (yScale.options.type === 'category') {
					tickHeight = yScale.getPixelForTick(index + 1) - yScale.getPixelForTick(index);
				} else {
					// Average width
					tickHeight = yScale.width / yScale.ticks.length;
				}
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / datasetCount;
	
				if (yScale.ticks.length !== me.chart.data.labels.length) {
					var perc = yScale.ticks.length / me.chart.data.labels.length;
					fullBarHeight = fullBarHeight * perc;
				}
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(index) {
				var me = this;
				var yScale = me.getScaleForId(me.getMeta().yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				var ruler = me.getRuler(index);
				return yScale.options.stacked ? ruler.categoryHeight : ruler.barHeight;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				if (yScale.options.stacked) {
					return topTick + (ruler.categoryHeight / 2) + ruler.categorySpacing;
				}
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			}
		});
	};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + dataPoint.x + ', ' + dataPoint.y + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			addElementAndReset: function(index) {
				var me = this;
				var options = me.chart.options;
				var meta = me.getMeta();
	
				Chart.DatasetController.prototype.addElementAndReset.call(me, index);
	
				// Make sure bezier control points are updated
				if (lineEnabled(me.getDataset(), options) && meta.dataset._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives linse the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderWidth) {
					borderWidth = custom.borderWidth;
				} else if (dataset.pointBorderWidth) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (dataset.borderWidth) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw();
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '">');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</span></li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			addElementAndReset: function(index) {
				Chart.DatasetController.prototype.addElementAndReset.call(this, index);
	
				// Make sure bezier control points are updated
				this.updateBezierControlPoints();
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.tension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(instance) {
	
			this.chart = instance;
			this.config = instance.config;
			this.options = this.config.options = helpers.configMerge(Chart.defaults.global, Chart.defaults[this.config.type], this.config.options || {});
			this.id = helpers.uid();
	
			Object.defineProperty(this, 'data', {
				get: function() {
					return this.config.data;
				}
			});
	
			// Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			if (this.options.responsive) {
				// Silent resize before chart draws
				this.resize(true);
			}
	
			this.initialize();
	
			return this;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller */ {
	
			initialize: function() {
				var me = this;
				// Before init plugin notification
				Chart.plugins.notify('beforeInit', [me]);
	
				me.bindEvents();
	
				// Make sure controllers are built first so that each dataset is bound to an axis before the scales
				// are built
				me.ensureScalesHaveIDs();
				me.buildOrUpdateControllers();
				me.buildScales();
				me.updateLayout();
				me.resetElements();
				me.initToolTip();
				me.update();
	
				// After init plugin notification
				Chart.plugins.notify('afterInit', [me]);
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occuring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var canvas = chart.canvas;
				var newWidth = helpers.getMaximumWidth(canvas);
				var aspectRatio = chart.aspectRatio;
				var newHeight = (me.options.maintainAspectRatio && isNaN(aspectRatio) === false && isFinite(aspectRatio) && aspectRatio !== 0) ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas);
	
				var sizeChanged = chart.width !== newWidth || chart.height !== newHeight;
	
				if (!sizeChanged) {
					return me;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
	
				helpers.retinaScale(chart);
	
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				Chart.plugins.notify('resize', [me, newSize]);
	
				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}
	
				if (!silent) {
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
	
				return me;
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			updateLayout: function() {
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeUpdate', [me]);
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				Chart.layoutService.update(me, me.chart.width, me.chart.height);
	
				// Apply changes to the dataets that require the scales to have been calculated i.e BorderColor chages
				Chart.plugins.notify('afterScaleUpdate', [me]);
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				Chart.plugins.notify('afterUpdate', [me]);
	
				me.render(animationDuration, lazy);
			},
	
			/**
			 * @method beforeDatasetsUpdate
			 * @description Called before all datasets are updated. If a plugin returns false,
			 * the datasets update will be cancelled until another chart update is triggered.
			 * @param {Object} instance the chart instance being updated.
			 * @returns {Boolean} false to cancel the datasets update.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * @method afterDatasetsUpdate
			 * @description Called after all datasets have been updated. Note that this
			 * extension will not be called if the datasets update has been cancelled.
			 * @param {Object} instance the chart instance being updated.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * Updates all datasets unless a plugin returns false to the beforeDatasetsUpdate
			 * extension, in which case no datasets will be updated and the afterDatasetsUpdate
			 * notification will be skipped.
			 * @protected
			 * @instance
			 */
			updateDatasets: function() {
				var me = this;
				var i, ilen;
	
				if (Chart.plugins.notify('beforeDatasetsUpdate', [me])) {
					for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
						me.getDatasetMeta(i).controller.update();
					}
	
					Chart.plugins.notify('afterDatasetsUpdate', [me]);
				}
			},
	
			render: function(duration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeRender', [me]);
	
				var animationOptions = me.options.animation;
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = animationOptions.onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					if (animationOptions && animationOptions.onComplete && animationOptions.onComplete.call) {
						animationOptions.onComplete.call(me);
					}
				}
				return me;
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				me.clear();
	
				Chart.plugins.notify('beforeDraw', [me, easingDecimal]);
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
				if (me.scale) {
					me.scale.draw();
				}
	
				Chart.plugins.notify('beforeDatasetsDraw', [me, easingDecimal]);
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(ease);
					}
				}, me, true);
	
				Chart.plugins.notify('afterDatasetsDraw', [me, easingDecimal]);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingDecimal).draw();
	
				Chart.plugins.notify('afterDraw', [me, easingDecimal]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						helpers.each(meta.data, function(element) {
							if (element.inRange(eventPosition.x, eventPosition.y)) {
								elementsArray.push(element);
								return elementsArray;
							}
						});
					}
				});
	
				return elementsArray.slice(0, 1);
			},
	
			getElementsAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex),
							element = meta.data[found._index];
						if (element && !element._view.skip) {
							elementsArray.push(element);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtXAxis: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inLabelRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						var index = helpers.findIndex(meta.data, function(it) {
							return found._model.x === it._model.x;
						});
						if (index !== -1 && !meta.data[index]._view.skip) {
							elementsArray.push(meta.data[index]);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtEventForMode: function(e, mode) {
				var me = this;
				switch (mode) {
				case 'single':
					return me.getElementAtEvent(e);
				case 'label':
					return me.getElementsAtEvent(e);
				case 'dataset':
					return me.getDatasetAtEvent(e);
				case 'x-axis':
					return me.getElementsAtXAxis(e);
				default:
					return e;
				}
			},
	
			getDatasetAtEvent: function(e) {
				var elementsArray = this.getElementAtEvent(e);
	
				if (elementsArray.length > 0) {
					elementsArray = this.getDatasetMeta(elementsArray[0]._datasetIndex).data;
				}
	
				return elementsArray;
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				me.stop();
				me.clear();
				helpers.unbindEvents(me, me.events);
				helpers.removeResizeListener(me.chart.canvas.parentNode);
	
				// Reset canvas height/width attributes
				var canvas = me.chart.canvas;
				canvas.width = me.chart.width;
				canvas.height = me.chart.height;
	
				// if we scaled the canvas in response to a devicePixelRatio !== 1, we need to undo that transform here
				if (me.chart.originalDevicePixelRatio !== undefined) {
					me.chart.ctx.scale(1 / me.chart.originalDevicePixelRatio, 1 / me.chart.originalDevicePixelRatio);
				}
	
				// Reset to the old style since it may have been changed by the device pixel ratio changes
				canvas.style.width = me.chart.originalCanvasStyleWidth;
				canvas.style.height = me.chart.originalCanvasStyleHeight;
	
				Chart.plugins.notify('destroy', [me]);
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			bindEvents: function() {
				var me = this;
				helpers.bindEvents(me, me.options.events, function(evt) {
					me.eventHandler(evt);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				switch (mode) {
				case 'single':
					elements = [elements[0]];
					break;
				case 'label':
				case 'dataset':
				case 'x-axis':
					// elements = elements;
					break;
				default:
					// unsupported mode
					return;
				}
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var tooltipsOptions = options.tooltips;
	
				me.lastActive = me.lastActive || [];
				me.lastTooltipActive = me.lastTooltipActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
					me.tooltipActive = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode);
					me.tooltipActive = me.getElementsAtEventForMode(e, tooltipsOptions.mode);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					hoverOptions.onHover.call(me, me.active);
				}
	
				if (me.legend && me.legend.handleEvent) {
					me.legend.handleEvent(e);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						options.onClick.call(me, e, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				// Built in Tooltips
				if (tooltipsOptions.enabled || tooltipsOptions.custom) {
					tooltip.initialize();
					tooltip._active = me.tooltipActive;
					tooltip.update(true);
				}
	
				// Hover animations
				tooltip.pivot();
	
				if (!me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					if (!helpers.arrayEquals(me.active, me.lastActive) ||
						!helpers.arrayEquals(me.tooltipActive, me.lastTooltipActive)) {
	
						me.stop();
	
						if (tooltipsOptions.enabled || tooltipsOptions.custom) {
							tooltip.update(true);
						}
	
						// We only need to render at this point. Updating will cause scales to be
						// recomputed generating flicker & using more memory than necessary.
						me.render(hoverOptions.animationDuration, true);
					}
				}
	
				// Remember Last Actives
				me.lastActive = me.active;
				me.lastTooltipActive = me.tooltipActive;
				return me;
			}
		});
	};


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(meta, i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var me = this;
				var element = me.createMetaData(index);
				me.getMeta().data.splice(index, 0, element);
				me.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				// Handle the number of data points changing
				var meta = this.getMeta(),
					md = meta.data,
					numData = this.getDataset().data.length,
					numMetaData = md.length;
	
				// Make sure that we handle number of datapoints changing
				if (numData < numMetaData) {
					// Remove excess bars for data points that have been removed
					md.splice(numData, numMetaData - numData);
				} else if (numData > numMetaData) {
					// Add new elements
					for (var index = numMetaData; index < numData; ++index) {
						this.addElementAndReset(index);
					}
				}
			},
	
			update: noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(element) {
					element.transition(easingDecimal).draw();
				});
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			}
	
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(502);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					if (key === 'scales') {
						// Scale config merging is complex. Add out own function here for that
						base[key] = helpers.scaleMerge(base.hasOwnProperty(key) ? base[key] : {}, value);
	
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(base.hasOwnProperty(key) ? base[key] : {}, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (base.hasOwnProperty(key) && helpers.isArray(base[key]) && helpers.isArray(value)) {
						// In this case we have an array of objects replacing another array. Rather than doing a strict replace,
						// merge. This allows easy scale option merging
						var baseArray = base[key];
	
						helpers.each(value, function(valueObj, index) {
	
							if (index < baseArray.length) {
								if (typeof baseArray[index] === 'object' && baseArray[index] !== null && typeof valueObj === 'object' && valueObj !== null) {
									// Two objects are coming together. Do a merge of them.
									baseArray[index] = helpers.configMerge(baseArray[index], valueObj);
								} else {
									// Just overwrite in this case since there is nothing to merge
									baseArray[index] = valueObj;
								}
							} else {
								baseArray.push(valueObj); // nothing to merge
							}
						});
	
					} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(base[key], value);
	
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					pointCurrent.deltaK = (pointAfter.model.y - pointCurrent.model.y) / (pointAfter.model.x - pointCurrent.model.x);
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		helpers.cancelAnimFrame = (function() {
			return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function(callback) {
					return window.clearTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
		helpers.bindEvents = function(chartInstance, arrayOfEvents, handler) {
			// Create the events object if it's not already present
			var events = chartInstance.events = chartInstance.events || {};
	
			helpers.each(arrayOfEvents, function(eventName) {
				events[eventName] = function() {
					handler.apply(chartInstance, arguments);
				};
				helpers.addEvent(chartInstance.chart.canvas, eventName, events[eventName]);
			});
		};
		helpers.unbindEvents = function(chartInstance, arrayOfEvents) {
			var canvas = chartInstance.chart.canvas;
			helpers.each(arrayOfEvents, function(handler, eventName) {
				helpers.removeEvent(canvas, eventName, handler);
			});
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var ctx = chart.ctx;
			var canvas = chart.canvas;
			var width = canvas.width;
			var height = canvas.height;
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
	
			if (pixelRatio !== 1) {
				canvas.height = height * pixelRatio;
				canvas.width = width * pixelRatio;
				ctx.scale(pixelRatio, pixelRatio);
	
				// Store the device pixel ratio so that we can go backwards in `destroy`.
				// The devicePixelRatio changes with zoom, so there are no guarantees that it is the same
				// when destroy is called
				chart.originalDevicePixelRatio = chart.originalDevicePixelRatio || pixelRatio;
			}
	
			canvas.style.width = width + 'px';
			canvas.style.height = height + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.addResizeListener = function(node, callback) {
			// Hide an iframe before the node
			var hiddenIframe = document.createElement('iframe');
			var hiddenIframeClass = 'chartjs-hidden-iframe';
	
			if (hiddenIframe.classlist) {
				// can use classlist
				hiddenIframe.classlist.add(hiddenIframeClass);
			} else {
				hiddenIframe.setAttribute('class', hiddenIframeClass);
			}
	
			// Set the style
			hiddenIframe.tabIndex = -1;
			var style = hiddenIframe.style;
			style.width = '100%';
			style.display = 'block';
			style.border = 0;
			style.height = 0;
			style.margin = 0;
			style.position = 'absolute';
			style.left = 0;
			style.right = 0;
			style.top = 0;
			style.bottom = 0;
	
			// Insert the iframe so that contentWindow is available
			node.insertBefore(hiddenIframe, node.firstChild);
	
			(hiddenIframe.contentWindow || hiddenIframe).onresize = function() {
				if (callback) {
					return callback();
				}
			};
		};
		helpers.removeResizeListener = function(node) {
			var hiddenIframe = node.querySelector('.chartjs-hidden-iframe');
	
			// Remove the resize detect iframe
			if (hiddenIframe) {
				hiddenIframe.parentNode.removeChild(hiddenIframe);
			}
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context, config) {
			var me = this;
			var helpers = Chart.helpers;
			me.config = config || {
				data: {
					datasets: []
				}
			};
	
			// Support a jQuery'd canvas element
			if (context.length && context[0].getContext) {
				context = context[0];
			}
	
			// Support a canvas domnode
			if (context.getContext) {
				context = context.getContext('2d');
			}
	
			me.ctx = context;
			me.canvas = context.canvas;
	
			context.canvas.style.display = context.canvas.style.display || 'block';
	
			// Figure out what the size of the chart will be.
			// If the canvas has a specified width and height, we use those else
			// we look to see if the canvas node has a CSS width and height.
			// If there is still no height, fill the parent container
			me.width = context.canvas.width || parseInt(helpers.getStyle(context.canvas, 'width'), 10) || helpers.getMaximumWidth(context.canvas);
			me.height = context.canvas.height || parseInt(helpers.getStyle(context.canvas, 'height'), 10) || helpers.getMaximumHeight(context.canvas);
	
			me.aspectRatio = me.width / me.height;
	
			if (isNaN(me.aspectRatio) || isFinite(me.aspectRatio) === false) {
				// If the canvas has no size, try and figure out what the aspect ratio will be.
				// Some charts prefer square canvases (pie, radar, etc). If that is specified, use that
				// else use the canvas default ratio of 2
				me.aspectRatio = config.aspectRatio !== undefined ? config.aspectRatio : 2;
			}
	
			// Store the original style of the element so we can set it back
			me.originalCanvasStyleWidth = context.canvas.style.width;
			me.originalCanvasStyleHeight = context.canvas.style.height;
	
			// High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			helpers.retinaScale(me);
			me.controller = new Chart.Controller(me);
	
			// Always bind this so that if the responsive state changes we still work
			helpers.addResizeListener(context.canvas.parentNode, function() {
				if (me.controller && me.controller.config.options.responsive) {
					me.controller.resize();
				}
			});
	
			return me.controller ? me.controller : me;
	
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'single',
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	
	};


/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var xPadding = 0;
				var yPadding = 0;
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - (2 * xPadding);
				var chartHeight = height - (2 * yPadding);
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
	
				// Steps 5 & 6
				var totalLeftBoxesWidth = xPadding;
				var totalRightBoxesWidth = xPadding;
				var totalTopBoxesHeight = yPadding;
				var totalBottomBoxesHeight = yPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: totalLeftBoxesWidth,
								right: totalRightBoxesWidth,
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = xPadding;
				totalRightBoxesWidth = xPadding;
				totalTopBoxesHeight = yPadding;
				totalBottomBoxesHeight = yPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = xPadding;
				var top = yPadding;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? xPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - xPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				me.legendItems = me.options.labels.generateLabels.call(me, me.chart);
				if (me.options.reverse) {
					me.legendItems.reverse();
				}
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = labelOpts.usePointStyle ?
								fontSize * Math.sqrt(2) :
								labelOpts.boxWidth;
	
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							// If usePointStyle is set, multiple boxWidth by 2 since it represents
							// the radius and not truly the width
							var boxWidth = labelOpts.usePointStyle ? 2 * labelOpts.boxWidth : labelOpts.boxWidth;
	
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actualy draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = labelOpts.boxWidth,
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalulate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = labelOpts.usePointStyle ?
								fontSize + (fontSize / 2) + textWidth :
								boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			// Handle an event
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				var position = helpers.getRelativePosition(e, me.chart.chart),
					x = position.x,
					y = position.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								opts.onClick.call(me, e, me.legendItems[i]);
								break;
							} else if (type === 'mousemove') {
								opts.onHover.call(me, e, me.legendItems[i]);
								break;
							}
						}
					}
				}
			}
		});
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var legendOpts = opts.legend;
	
				if (legendOpts) {
					chartInstance.legend = new Chart.Legend({
						ctx: chartInstance.chart.ctx,
						options: legendOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.legend);
				}
			}
		});
	};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var noop = Chart.helpers.noop;
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			_plugins: [],
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
			},
	
			/**
			 * Remove all registered p^lugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin intances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls registered plugins on the specified extension, with the given args. This
			 * method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {String} extension the name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] extra arguments to apply to the extension call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(extension, args) {
				var plugins = this._plugins;
				var ilen = plugins.length;
				var i, plugin;
	
				for (i=0; i<ilen; ++i) {
					plugin = plugins[i];
					if (typeof plugin[extension] === 'function') {
						if (plugin[extension].apply(plugin, args || []) === false) {
							return false;
						}
					}
				}
	
				return true;
			}
		};
	
		/**
		 * Plugin extension methods.
		 * @interface Chart.PluginBase
		 * @since 2.1.0
		 */
		Chart.PluginBase = Chart.Element.extend({
			// Called at start of chart init
			beforeInit: noop,
	
			// Called at end of chart init
			afterInit: noop,
	
			// Called at start of update
			beforeUpdate: noop,
	
			// Called at end of update
			afterUpdate: noop,
	
			// Called at start of draw
			beforeDraw: noop,
	
			// Called at end of draw
			afterDraw: noop,
	
			// Called during destroy
			destroy: noop
		});
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove me at version 3
		 */
		Chart.pluginService = Chart.plugins;
	};


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 10,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				}
			}
		};
	
		Chart.Scale = Chart.Element.extend({
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				me.ticks = me.ticks.map(function(numericalTick, index, ticks) {
					if (me.options.ticks.userCallback) {
						return me.options.ticks.userCallback(numericalTick, index, ticks);
					}
					return me.options.ticks.callback(numericalTick, index, ticks);
				},
				me);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				context.font = tickLabelFont;
	
				var firstWidth = context.measureText(me.ticks[0]).width;
				var lastWidth = context.measureText(me.ticks[me.ticks.length - 1]).width;
				var firstRotated;
	
				me.labelRotation = optionTicks.minRotation || 0;
				me.paddingRight = 0;
				me.paddingLeft = 0;
	
				if (me.options.display) {
					if (me.isHorizontal()) {
						me.paddingRight = lastWidth / 2 + 3;
						me.paddingLeft = firstWidth / 2 + 3;
	
						if (!me.longestTextCache) {
							me.longestTextCache = {};
						}
						var originalLabelWidth = helpers.longestText(context, tickLabelFont, me.ticks, me.longestTextCache);
						var labelWidth = originalLabelWidth;
						var cosRotation;
						var sinRotation;
	
						// Allow 3 pixels x2 padding either side for label readability
						// only the index matters for a dataset scale, but we want a consistent interface between scales
						var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
						// Max label rotation can be set or default to 90 - also act as a loop counter
						while (labelWidth > tickWidth && me.labelRotation < optionTicks.maxRotation) {
							cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
							sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
	
							firstRotated = cosRotation * firstWidth;
	
							// We're right aligning the text now.
							if (firstRotated + tickFontSize / 2 > me.yLabelWidth) {
								me.paddingLeft = firstRotated + tickFontSize / 2;
							}
	
							me.paddingRight = tickFontSize / 2;
	
							if (sinRotation * originalLabelWidth > me.maxHeight) {
								// go back one step
								me.labelRotation--;
								break;
							}
	
							me.labelRotation++;
							labelWidth = cosRotation * originalLabelWidth;
						}
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				}
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var globalDefaults = Chart.defaults.global;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabelOpts.fontSize, globalDefaults.defaultFontSize);
	
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += (scaleLabelFontSize * 1.5);
					} else {
						minSize.width += (scaleLabelFontSize * 1.5);
					}
				}
	
				if (tickOpts.display && display) {
					// Don't bother fitting the ticks if we are not showing them
					if (!me.longestTextCache) {
						me.longestTextCache = {};
					}
	
					var largestTextWidth = helpers.longestText(me.ctx, tickLabelFont, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFontSize * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						// TODO - improve this calculation
						var labelHeight = (Math.sin(helpers.toRadians(me.labelRotation)) * me.longestLabelWidth) + (tickFontSize * tallestLabelHeightInLines) + (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickLabelFont;
	
						var firstLabelWidth = me.ctx.measureText(me.ticks[0]).width;
						var lastLabelWidth = me.ctx.measureText(me.ticks[me.ticks.length - 1]).width;
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						var cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
						var sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
						me.paddingLeft = me.labelRotation !== 0 ? (cosRotation * firstLabelWidth) + 3 : firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = me.labelRotation !== 0 ? (sinRotation * (tickFontSize / 2)) + 3 : lastLabelWidth / 2 + 3; // when rotated
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						var maxLabelWidth = me.maxWidth - minSize.width;
	
						// Account for padding
						var mirror = tickOpts.mirror;
						if (!mirror) {
							largestTextWidth += me.options.ticks.padding;
						} else {
							// If mirrored text is on the inside so don't expand
							largestTextWidth = 0;
						}
	
						if (largestTextWidth < maxLabelWidth) {
							// We don't need all the room
							minSize.width += largestTextWidth;
						} else {
							// Expand to max size
							minSize.width = me.maxWidth;
						}
	
						me.paddingTop = tickFontSize / 2;
						me.paddingBottom = tickFontSize / 2;
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number
				if (typeof(rawValue) === 'number' && isNaN(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPixelForValue(
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			// Actualy draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				var tl = gridLines.tickMarkLength;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabel.fontSize, globalDefaults.defaultFontSize);
				var scaleLabelFontStyle = helpers.getValueOrDefault(scaleLabel.fontStyle, globalDefaults.defaultFontStyle);
				var scaleLabelFontFamily = helpers.getValueOrDefault(scaleLabel.fontFamily, globalDefaults.defaultFontFamily);
				var scaleLabelFont = helpers.fontString(scaleLabelFontSize, scaleLabelFontStyle, scaleLabelFontFamily);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
						if (!isRotated) {
							textBaseline = options.position === 'top' ? 'bottom' : 'top';
						}
	
						textAlign = isRotated ? 'right' : 'center';
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
						labelY = (isRotated) ? me.top + 12 : options.position === 'top' ? me.bottom - tl : me.top + tl;
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						if (options.position === 'left') {
							if (optionTicks.mirror) {
								labelX = me.right + optionTicks.padding;
								textAlign = 'left';
							} else {
								labelX = me.right - optionTicks.padding;
								textAlign = 'right';
							}
						// right side
						} else if (optionTicks.mirror) {
							labelX = me.left - optionTicks.padding;
							textAlign = 'right';
						} else {
							labelX = me.left + optionTicks.padding;
							textAlign = 'left';
						}
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickLabelFont;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = -(label.length - 1)*tickFontSize*0.75; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFontSize * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFontSize / 2) : me.top + (scaleLabelFontSize / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFontSize / 2) : me.right - (scaleLabelFontSize / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
				me.options = helpers.configMerge(Chart.defaults.global.title, config.options);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
	
			beforeUpdate: function() {
				var chartOpts = this.chart.options;
				if (chartOpts && chartOpts.title) {
					this.options = helpers.configMerge(Chart.defaults.global.title, chartOpts.title);
				}
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actualy draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0);
					ctx.restore();
				}
			}
		});
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var titleOpts = opts.title;
	
				if (titleOpts) {
					chartInstance.titleBlock = new Chart.Title({
						ctx: chartInstance.chart.ctx,
						options: titleOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.titleBlock);
				}
			}
		});
	};


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'single',
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			yAlign: 'center',
			xAlign: 'center',
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		function getAveragePosition(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var xPositions = [];
			var yPositions = [];
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					xPositions.push(pos.x);
					yPositions.push(pos.y);
				}
			}
	
			var x = 0,
				y = 0;
			for (i = 0; i < xPositions.length; ++i) {
				if (xPositions[i]) {
					x += xPositions[i];
					y += yPositions[i];
				}
			}
	
			return {
				x: Math.round(x / xPositions.length),
				y: Math.round(y / xPositions.length)
			};
		}
	
		// Private helper to create a tooltip iteam model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				var me = this;
				var globalDefaults = Chart.defaults.global;
				var tooltipOpts = me._options;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				helpers.extend(me, {
					_model: {
						// Positioning
						xPadding: tooltipOpts.xPadding,
						yPadding: tooltipOpts.yPadding,
						xAlign: tooltipOpts.xAlign,
						yAlign: tooltipOpts.yAlign,
	
						// Body
						bodyFontColor: tooltipOpts.bodyFontColor,
						_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
						_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
						_bodyAlign: tooltipOpts.bodyAlign,
						bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
						bodySpacing: tooltipOpts.bodySpacing,
	
						// Title
						titleFontColor: tooltipOpts.titleFontColor,
						_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
						_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
						titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
						_titleAlign: tooltipOpts.titleAlign,
						titleSpacing: tooltipOpts.titleSpacing,
						titleMarginBottom: tooltipOpts.titleMarginBottom,
	
						// Footer
						footerFontColor: tooltipOpts.footerFontColor,
						_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
						_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
						footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
						_footerAlign: tooltipOpts.footerAlign,
						footerSpacing: tooltipOpts.footerSpacing,
						footerMarginTop: tooltipOpts.footerMarginTop,
	
						// Appearance
						caretSize: tooltipOpts.caretSize,
						cornerRadius: tooltipOpts.cornerRadius,
						backgroundColor: tooltipOpts.backgroundColor,
						opacity: 0,
						legendColorBackground: tooltipOpts.multiKeyBackground
					}
				});
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
				var model = me._model;
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [],
						tooltipPosition = getAveragePosition(active);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// If there is more than one item, show color items
					if (active.length > 1) {
						helpers.each(tooltipItems, function(tooltipItem) {
							labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
						});
					}
	
					// Build the Text Lines
					helpers.extend(model, {
						title: me.getTitle(tooltipItems, data),
						beforeBody: me.getBeforeBody(tooltipItems, data),
						body: me.getBody(tooltipItems, data),
						afterBody: me.getAfterBody(tooltipItems, data),
						footer: me.getFooter(tooltipItems, data),
						x: Math.round(tooltipPosition.x),
						y: Math.round(tooltipPosition.y),
						caretPadding: helpers.getValueOrDefault(tooltipPosition.padding, 2),
						labelColors: labelColors
					});
	
					// We need to determine alignment of
					var tooltipSize = me.getTooltipSize(model);
					me.determineAlignment(tooltipSize); // Smart Tooltip placement to stay on the canvas
	
					helpers.extend(model, me.getBackgroundPoint(model, tooltipSize));
				} else {
					me._model.opacity = 0;
				}
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			getTooltipSize: function(vm) {
				var ctx = this._chart.ctx;
	
				var size = {
					height: vm.yPadding * 2, // Tooltip Padding
					width: 0
				};
	
				// Count of all lines in the body
				var body = vm.body;
				var combinedBodyLength = body.reduce(function(count, bodyItem) {
					return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
				}, 0);
				combinedBodyLength += vm.beforeBody.length + vm.afterBody.length;
	
				var titleLineCount = vm.title.length;
				var footerLineCount = vm.footer.length;
				var titleFontSize = vm.titleFontSize,
					bodyFontSize = vm.bodyFontSize,
					footerFontSize = vm.footerFontSize;
	
				size.height += titleLineCount * titleFontSize; // Title Lines
				size.height += (titleLineCount - 1) * vm.titleSpacing; // Title Line Spacing
				size.height += titleLineCount ? vm.titleMarginBottom : 0; // Title's bottom Margin
				size.height += combinedBodyLength * bodyFontSize; // Body Lines
				size.height += combinedBodyLength ? (combinedBodyLength - 1) * vm.bodySpacing : 0; // Body Line Spacing
				size.height += footerLineCount ? vm.footerMarginTop : 0; // Footer Margin
				size.height += footerLineCount * (footerFontSize); // Footer Lines
				size.height += footerLineCount ? (footerLineCount - 1) * vm.footerSpacing : 0; // Footer Line Spacing
	
				// Title width
				var widthPadding = 0;
				var maxLineWidth = function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width + widthPadding);
				};
	
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
				helpers.each(vm.title, maxLineWidth);
	
				// Body width
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
				helpers.each(vm.beforeBody.concat(vm.afterBody), maxLineWidth);
	
				// Body lines may include some extra width due to the color box
				widthPadding = body.length > 1 ? (bodyFontSize + 2) : 0;
				helpers.each(body, function(bodyItem) {
					helpers.each(bodyItem.before, maxLineWidth);
					helpers.each(bodyItem.lines, maxLineWidth);
					helpers.each(bodyItem.after, maxLineWidth);
				});
	
				// Reset back to 0
				widthPadding = 0;
	
				// Footer width
				ctx.font = helpers.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
				helpers.each(vm.footer, maxLineWidth);
	
				// Add padding
				size.width += 2 * vm.xPadding;
	
				return size;
			},
			determineAlignment: function(size) {
				var me = this;
				var model = me._model;
				var chart = me._chart;
				var chartArea = me._chartInstance.chartArea;
	
				if (model.y < size.height) {
					model.yAlign = 'top';
				} else if (model.y > (chart.height - size.height)) {
					model.yAlign = 'bottom';
				}
	
				var lf, rf; // functions to determine left, right alignment
				var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
				var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
				var midX = (chartArea.left + chartArea.right) / 2;
				var midY = (chartArea.top + chartArea.bottom) / 2;
	
				if (model.yAlign === 'center') {
					lf = function(x) {
						return x <= midX;
					};
					rf = function(x) {
						return x > midX;
					};
				} else {
					lf = function(x) {
						return x <= (size.width / 2);
					};
					rf = function(x) {
						return x >= (chart.width - (size.width / 2));
					};
				}
	
				olf = function(x) {
					return x + size.width > chart.width;
				};
				orf = function(x) {
					return x - size.width < 0;
				};
				yf = function(y) {
					return y <= midY ? 'top' : 'bottom';
				};
	
				if (lf(model.x)) {
					model.xAlign = 'left';
	
					// Is tooltip too wide and goes over the right side of the chart.?
					if (olf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				} else if (rf(model.x)) {
					model.xAlign = 'right';
	
					// Is tooltip too wide and goes outside left edge of canvas?
					if (orf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				}
			},
			getBackgroundPoint: function(vm, size) {
				// Background Position
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				var caretSize = vm.caretSize,
					caretPadding = vm.caretPadding,
					cornerRadius = vm.cornerRadius,
					xAlign = vm.xAlign,
					yAlign = vm.yAlign,
					paddingAndSize = caretSize + caretPadding,
					radiusAndPadding = cornerRadius + caretPadding;
	
				if (xAlign === 'right') {
					pt.x -= size.width;
				} else if (xAlign === 'center') {
					pt.x -= (size.width / 2);
				}
	
				if (yAlign === 'top') {
					pt.y += paddingAndSize;
				} else if (yAlign === 'bottom') {
					pt.y -= size.height + paddingAndSize;
				} else {
					pt.y -= (size.height / 2);
				}
	
				if (yAlign === 'center') {
					if (xAlign === 'left') {
						pt.x += paddingAndSize;
					} else if (xAlign === 'right') {
						pt.x -= paddingAndSize;
					}
				} else if (xAlign === 'left') {
					pt.x -= radiusAndPadding;
				} else if (xAlign === 'right') {
					pt.x += radiusAndPadding;
				}
	
				return pt;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				var bgColor = helpers.color(vm.backgroundColor);
				ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					var titleFontColor = helpers.color(vm.titleFontColor);
					ctx.fillStyle = titleFontColor.alpha(opacity * titleFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var bodyFontColor = helpers.color(vm.bodyFontColor);
				var textColor = bodyFontColor.alpha(opacity * bodyFontColor.alpha()).rgbString();
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = body.length > 1;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = helpers.color(vm.legendColorBackground).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = helpers.color(vm.labelColors[i].borderColor).alpha(opacity).rgbaString();
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = helpers.color(vm.labelColors[i].backgroundColor).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					var footerFontColor = helpers.color(vm.footerFontColor);
					ctx.fillStyle = footerFontColor.alpha(opacity * footerFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = this.getTooltipSize(vm);
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					var bgColor = helpers.color(vm.backgroundColor);
					ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
					helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
					ctx.fill();
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			}
		});
	};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var scaleZero = vm.scaleZero;
				var loop = me._loop;
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(scaleZero.x, scaleZero.y);
							} else {
								ctx.moveTo(currentVM.x, scaleZero);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(scaleZero.x, scaleZero.y);
									} else {
										ctx.lineTo(previous._view.x, scaleZero);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, scaleZero);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, scaleZero);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function() {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				var halfWidth = vm.width / 2,
					leftX = vm.x - halfWidth,
					rightX = vm.x + halfWidth,
					top = vm.base - (vm.base - vm.y),
					halfStroke = vm.borderWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (vm.borderWidth) {
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[leftX, vm.base],
					[leftX, top],
					[rightX, top],
					[rightX, vm.base]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(vm.borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				ctx.moveTo.apply(ctx, cornerAt(0));
				for (var i = 1; i < 4; i++) {
					ctx.lineTo.apply(ctx, cornerAt(i));
				}
	
				ctx.fill();
				if (vm.borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ?
						(vm.y < vm.base ?
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.y && mouseY <= vm.base) :
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.base && mouseY <= vm.y)) :
						false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use tose
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if ((data.xLabels && isHorizontal) || (data.yLabels && !isHorizontal)) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueWidth = innerWidth / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex)) + me.paddingLeft;
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				var valueHeight = innerHeight / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex)) + me.paddingTop;
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var innerDimension = horz ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var valueDimension = innerDimension / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
				pixel -= horz ? me.paddingLeft : me.paddingTop;
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				}
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (valuesPerType[meta.type] === undefined) {
							valuesPerType[meta.type] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerType[meta.type].positiveValues;
						var negativeValues = valuesPerType[meta.type].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var innerDimension;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (paddingLeft + me.paddingRight);
					pixel = me.left + (innerDimension / range * (rightValue - start));
					return Math.round(pixel + paddingLeft);
				}
				innerDimension = me.height - (me.paddingTop + paddingBottom);
				pixel = (me.bottom - paddingBottom) - (innerDimension / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var innerDimension = isHorizontal ? me.width - (paddingLeft + me.paddingRight) : me.height - (me.paddingTop + paddingBottom);
				var offset = (isHorizontal ? pixel - me.left - paddingLeft : me.bottom - paddingBottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the botttom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var ticks = me.ticks = [];
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var maxTicks = me.getTickLimit();
	
				// Make sure we always have at least 2 ticks
				maxTicks = Math.max(2, maxTicks);
	
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				var fixedStepSizeSet = (tickOpts.fixedStepSize && tickOpts.fixedStepSize > 0) || (tickOpts.stepSize && tickOpts.stepSize > 0);
				if (fixedStepSizeSet) {
					spacing = getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize);
				} else {
					var niceRange = helpers.niceNum(me.max - me.min, false);
					spacing = helpers.niceNum(niceRange / (maxTicks - 1), true);
				}
				var niceMin = Math.floor(me.min / spacing) * spacing;
				var niceMax = Math.ceil(me.max / spacing) * spacing;
				var numSpaces = (niceMax - niceMin) / spacing;
	
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(tickOpts.min !== undefined ? tickOpts.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(tickOpts.max !== undefined ? tickOpts.max : niceMax);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: function(value, index, arr) {
					var remain = value / (Math.pow(10, Math.floor(helpers.log10(value))));
	
					if (value === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === arr.length - 1) {
						return value.toExponential();
					}
					return '';
				}
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerType[meta.type] === undefined) {
								valuesPerType[meta.type] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerType[meta.type];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Reset the ticks array. Later on, we will draw a grid line at these positions
				// The array simply contains the numerical value of the spots where ticks will be
				var ticks = me.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var tickVal = getValueOrDefault(tickOpts.min, Math.pow(10, Math.floor(helpers.log10(me.min))));
	
				while (tickVal < me.max) {
					ticks.push(tickVal);
	
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(me.minNotZero));
						significand = Math.round(me.minNotZero / Math.pow(10, exp));
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp)) + 1;
					}
	
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				}
	
				var lastTick = getValueOrDefault(tickOpts.max, tickVal);
				ticks.push(lastTick);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var paddingTop = me.paddingTop;
				var paddingBottom = me.paddingBottom;
				var paddingLeft = me.paddingLeft;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left + paddingLeft;
					} else {
						innerDimension = me.width - (paddingLeft + me.paddingRight);
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
						pixel += paddingLeft;
					}
				} else {
					// Bottom - top since pixels increase downard on a screen
					innerDimension = me.height - (paddingTop + paddingBottom);
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom - paddingBottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top + paddingTop;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + paddingTop + innerDimension * 0.02;
						} else {
							pixel = me.top + paddingTop + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height - (paddingTop + paddingBottom);
						pixel = (me.bottom - paddingBottom) - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (me.paddingLeft + me.paddingRight);
					value = me.start * Math.pow(10, (pixel - me.left - me.paddingLeft) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height - (me.paddingTop + me.paddingBottom);
					value = Math.pow(10, (me.bottom - me.paddingBottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			getValueCount: function() {
				return this.chart.data.labels.length;
			},
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				me.min = null;
				me.max = null;
	
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}
	
							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
				var pointLabels = this.options.pointLabels;
				var pointLabelFontSize = helpers.getValueOrDefault(pointLabels.fontSize, globalDefaults.defaultFontSize);
				var pointLabeFontStyle = helpers.getValueOrDefault(pointLabels.fontStyle, globalDefaults.defaultFontStyle);
				var pointLabeFontFamily = helpers.getValueOrDefault(pointLabels.fontFamily, globalDefaults.defaultFontFamily);
				var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = helpers.min([(this.height / 2 - pointLabelFontSize - 5), this.width / 2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft;
				this.ctx.font = pointLabeFont;
	
				for (i = 0; i < this.getValueCount(); i++) {
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(this.pointLabels[i] ? this.pointLabels[i] : '').width + 5;
	
					// Add quarter circle to make degree 0 mean top of circle
					var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
					var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
					if (angle === 0 || angle === 180) {
						// At angle 0 and 180, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth / 2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					} else if (angle < 180) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					// More than half the values means we'll right align the text
					} else if (pointPosition.x - textWidth < furthestLeft) {
						furthestLeft = pointPosition.x - textWidth;
						furthestLeftIndex = i;
					}
				}
	
				xProtrusionLeft = furthestLeft;
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI / 2);
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI / 2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (helpers.isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (helpers.isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2);
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
			},
			setCenterPoint: function(leftMovement, rightMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				// Always vertically in the centre as the text height doesn't change
				me.yCenter = Math.round((me.height / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / this.getValueCount();
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier - (Math.PI / 2) + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var angleLineOpts = opts.angleLines;
				var pointLabelOpts = opts.pointLabels;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
								ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
								if (opts.lineArc) {
									// Draw circular arcs between the points
									ctx.beginPath();
									ctx.arc(me.xCenter, me.yCenter, yCenterOffset, 0, Math.PI * 2);
									ctx.closePath();
									ctx.stroke();
								} else {
									// Draw straight lines connecting each index
									ctx.beginPath();
									for (var i = 0; i < me.getValueCount(); i++) {
										var pointPosition = me.getPointPosition(i, yCenterOffset);
										if (i === 0) {
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						ctx.lineWidth = angleLineOpts.lineWidth;
						ctx.strokeStyle = angleLineOpts.color;
	
						var outerDistance = me.getDistanceFromCenterForValue(opts.reverse ? me.min : me.max);
	
						// Point Label Font
						var pointLabelFontSize = getValueOrDefault(pointLabelOpts.fontSize, globalDefaults.defaultFontSize);
						var pointLabeFontStyle = getValueOrDefault(pointLabelOpts.fontStyle, globalDefaults.defaultFontStyle);
						var pointLabeFontFamily = getValueOrDefault(pointLabelOpts.fontFamily, globalDefaults.defaultFontFamily);
						var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
						for (var i = me.getValueCount() - 1; i >= 0; i--) {
							if (angleLineOpts.display) {
								var outerPosition = me.getPointPosition(i, outerDistance);
								ctx.beginPath();
								ctx.moveTo(me.xCenter, me.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = me.getPointPosition(i, outerDistance + 5);
	
							// Keep this in loop since we may support array properties here
							var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = pointLabeFont;
							ctx.fillStyle = pointLabelFontColor;
	
							var pointLabels = me.pointLabels;
	
							// Add quarter circle to make degree 0 mean top of circle
							var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
							var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
							if (angle === 0 || angle === 180) {
								ctx.textAlign = 'center';
							} else if (angle < 180) {
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (angle === 90 || angle === 270) {
								ctx.textBaseline = 'middle';
							} else if (angle > 270 || angle < 90) {
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(pointLabels[i] ? pointLabels[i] : '', pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(1);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the prefedined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = 1; i <= me.scaleSizeInUnits; ++i) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					if (i % me.unitScale === 0) {
						me.ticks.push(newTick);
					}
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
	
				if (typeof me.chart.data.datasets[datasetIndex].data[0] === 'object') {
					label = me.getRightValue(me.chart.data.datasets[datasetIndex].data[index]);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
						var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
						return me.left + Math.round(valueOffset);
					}
					var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
					var heightOffset = (innerHeight * decimal) + me.paddingTop;
	
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var offset = (pixel - (me.isHorizontal() ? me.left + me.paddingLeft : me.top + me.paddingTop)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(72);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(503);
	var string = __webpack_require__(501);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(71);
	var route = __webpack_require__(504);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(71);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ }),
/* 506 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, process) {/*!
	 * https://github.com/paulmillr/es6-shim
	 * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
	 *   and contributors,  MIT License
	 * es6-shim: v0.35.4
	 * see https://github.com/paulmillr/es6-shim/blob/0.35.3/LICENSE
	 * Details and documentation:
	 * https://github.com/paulmillr/es6-shim/
	 */
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/returnExports.js
	(function (root, factory) {
	  /*global define */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory();
	  }
	}(this, function () {
	  'use strict';
	
	  var _apply = Function.call.bind(Function.apply);
	  var _call = Function.call.bind(Function.call);
	  var isArray = Array.isArray;
	  var keys = Object.keys;
	
	  var not = function notThunker(func) {
	    return function notThunk() {
	      return !_apply(func, this, arguments);
	    };
	  };
	  var throwsError = function (func) {
	    try {
	      func();
	      return false;
	    } catch (e) {
	      return true;
	    }
	  };
	  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
	    try {
	      return func();
	    } catch (e) {
	      return false;
	    }
	  };
	
	  var isCallableWithoutNew = not(throwsError);
	  var arePropertyDescriptorsSupported = function () {
	    // if Object.defineProperty exists but throws, it's IE 8
	    return !throwsError(function () {
	      return Object.defineProperty({}, 'x', { get: function () { } }); // eslint-disable-line getter-return
	    });
	  };
	  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
	  var functionsHaveNames = (function foo() {}).name === 'foo';
	
	  var _forEach = Function.call.bind(Array.prototype.forEach);
	  var _reduce = Function.call.bind(Array.prototype.reduce);
	  var _filter = Function.call.bind(Array.prototype.filter);
	  var _some = Function.call.bind(Array.prototype.some);
	
	  var defineProperty = function (object, name, value, force) {
	    if (!force && name in object) { return; }
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	
	  // Define configurable, writable and non-enumerable props
	  // if they don’t exist.
	  var defineProperties = function (object, map, forceOverride) {
	    _forEach(keys(map), function (name) {
	      var method = map[name];
	      defineProperty(object, name, method, !!forceOverride);
	    });
	  };
	
	  var _toString = Function.call.bind(Object.prototype.toString);
	  var isCallable =  false ? function IsCallableSlow(x) {
	    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
	    return typeof x === 'function' && _toString(x) === '[object Function]';
	  } : function IsCallableFast(x) { return typeof x === 'function'; };
	
	  var Value = {
	    getter: function (object, name, getter) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        get: getter
	      });
	    },
	    proxy: function (originalObject, key, targetObject) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
	      Object.defineProperty(targetObject, key, {
	        configurable: originalDescriptor.configurable,
	        enumerable: originalDescriptor.enumerable,
	        get: function getKey() { return originalObject[key]; },
	        set: function setKey(value) { originalObject[key] = value; }
	      });
	    },
	    redefine: function (object, property, newValue) {
	      if (supportsDescriptors) {
	        var descriptor = Object.getOwnPropertyDescriptor(object, property);
	        descriptor.value = newValue;
	        Object.defineProperty(object, property, descriptor);
	      } else {
	        object[property] = newValue;
	      }
	    },
	    defineByDescriptor: function (object, property, descriptor) {
	      if (supportsDescriptors) {
	        Object.defineProperty(object, property, descriptor);
	      } else if ('value' in descriptor) {
	        object[property] = descriptor.value;
	      }
	    },
	    preserveToString: function (target, source) {
	      if (source && isCallable(source.toString)) {
	        defineProperty(target, 'toString', source.toString.bind(source), true);
	      }
	    }
	  };
	
	  // Simple shim for Object.create on ES3 browsers
	  // (unlike real shim, no attempt to support `prototype === null`)
	  var create = Object.create || function (prototype, properties) {
	    var Prototype = function Prototype() {};
	    Prototype.prototype = prototype;
	    var object = new Prototype();
	    if (typeof properties !== 'undefined') {
	      keys(properties).forEach(function (key) {
	        Value.defineByDescriptor(object, key, properties[key]);
	      });
	    }
	    return object;
	  };
	
	  var supportsSubclassing = function (C, f) {
	    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
	    return valueOrFalseIfThrows(function () {
	      var Sub = function Subclass(arg) {
	        var o = new C(arg);
	        Object.setPrototypeOf(o, Subclass.prototype);
	        return o;
	      };
	      Object.setPrototypeOf(Sub, C);
	      Sub.prototype = create(C.prototype, {
	        constructor: { value: Sub }
	      });
	      return f(Sub);
	    });
	  };
	
	  var getGlobal = function () {
	    /* global self, window */
	    // the only reliable means to get the global object is
	    // `Function('return this')()`
	    // However, this causes CSP violations in Chrome apps.
	    if (typeof self !== 'undefined') { return self; }
	    if (typeof window !== 'undefined') { return window; }
	    if (typeof global !== 'undefined') { return global; }
	    throw new Error('unable to locate global object');
	  };
	
	  var globals = getGlobal();
	  var globalIsFinite = globals.isFinite;
	  var _indexOf = Function.call.bind(String.prototype.indexOf);
	  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
	  var _concat = Function.call.bind(Array.prototype.concat);
	  // var _sort = Function.call.bind(Array.prototype.sort);
	  var _strSlice = Function.call.bind(String.prototype.slice);
	  var _push = Function.call.bind(Array.prototype.push);
	  var _pushApply = Function.apply.bind(Array.prototype.push);
	  var _join = Function.call.bind(Array.prototype.join);
	  var _shift = Function.call.bind(Array.prototype.shift);
	  var _max = Math.max;
	  var _min = Math.min;
	  var _floor = Math.floor;
	  var _abs = Math.abs;
	  var _exp = Math.exp;
	  var _log = Math.log;
	  var _sqrt = Math.sqrt;
	  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	  var ArrayIterator; // make our implementation private
	  var noop = function () {};
	
	  var OrigMap = globals.Map;
	  var origMapDelete = OrigMap && OrigMap.prototype['delete'];
	  var origMapGet = OrigMap && OrigMap.prototype.get;
	  var origMapHas = OrigMap && OrigMap.prototype.has;
	  var origMapSet = OrigMap && OrigMap.prototype.set;
	
	  var Symbol = globals.Symbol || {};
	  var symbolSpecies = Symbol.species || '@@species';
	
	  var numberIsNaN = Number.isNaN || function isNaN(value) {
	    // NaN !== NaN, but they are identical.
	    // NaNs are the only non-reflexive value, i.e., if x !== x,
	    // then x is NaN.
	    // isNaN is broken: it converts its argument to number, so
	    // isNaN('foo') => true
	    return value !== value;
	  };
	  var numberIsFinite = Number.isFinite || function isFinite(value) {
	    return typeof value === 'number' && globalIsFinite(value);
	  };
	  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
	    var number = Number(value);
	    if (number === 0) { return number; }
	    if (numberIsNaN(number)) { return number; }
	    return number < 0 ? -1 : 1;
	  };
	  var _log1p = function log1p(value) {
	    var x = Number(value);
	    if (x < -1 || numberIsNaN(x)) { return NaN; }
	    if (x === 0 || x === Infinity) { return x; }
	    if (x === -1) { return -Infinity; }
	
	    return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
	  };
	
	  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	  // can be replaced with require('is-arguments') if we ever use a build process instead
	  var isStandardArguments = function isArguments(value) {
	    return _toString(value) === '[object Arguments]';
	  };
	  var isLegacyArguments = function isArguments(value) {
	    return value !== null
	      && typeof value === 'object'
	      && typeof value.length === 'number'
	      && value.length >= 0
	      && _toString(value) !== '[object Array]'
	      && _toString(value.callee) === '[object Function]';
	  };
	  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;
	
	  var Type = {
	    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
	    string: function (x) { return _toString(x) === '[object String]'; },
	    regex: function (x) { return _toString(x) === '[object RegExp]'; },
	    symbol: function (x) {
	      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
	    }
	  };
	
	  var overrideNative = function overrideNative(object, property, replacement) {
	    var original = object[property];
	    defineProperty(object, property, replacement, true);
	    Value.preserveToString(object[property], original);
	  };
	
	  // eslint-disable-next-line no-restricted-properties
	  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());
	
	  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
	  // we're going to use an arbitrary _-prefixed name to make our shims
	  // work properly with each other, even though we don't have full Iterator
	  // support.  That is, `Array.from(map.keys())` will work, but we don't
	  // pretend to export a "real" Iterator interface.
	  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
	  // Firefox ships a partial implementation using the name @@iterator.
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
	  // So use that name if we detect it.
	  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
	    $iterator$ = '@@iterator';
	  }
	
	  // Reflect
	  if (!globals.Reflect) {
	    defineProperty(globals, 'Reflect', {}, true);
	  }
	  var Reflect = globals.Reflect;
	
	  var $String = String;
	
	  /* global document */
	  var domAll = (typeof document === 'undefined' || !document) ? null : document.all;
	  var isNullOrUndefined = domAll == null ? function isNullOrUndefined(x) {
	    return x == null;
	  } : function isNullOrUndefinedAndNotDocumentAll(x) {
	    return x == null && x !== domAll;
	  };
	
	  var ES = {
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
	    Call: function Call(F, V) {
	      var args = arguments.length > 2 ? arguments[2] : [];
	      if (!ES.IsCallable(F)) {
	        throw new TypeError(F + ' is not a function');
	      }
	      return _apply(F, V, args);
	    },
	
	    RequireObjectCoercible: function (x, optMessage) {
	      if (isNullOrUndefined(x)) {
	        throw new TypeError(optMessage || 'Cannot call method on ' + x);
	      }
	      return x;
	    },
	
	    // This might miss the "(non-standard exotic and does not implement
	    // [[Call]])" case from
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
	    // but we can't find any evidence these objects exist in practice.
	    // If we find some in the future, you could test `Object(x) === x`,
	    // which is reliable according to
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
	    // but is not well optimized by runtimes and creates an object
	    // whenever it returns false, and thus is very slow.
	    TypeIsObject: function (x) {
	      if (x === void 0 || x === null || x === true || x === false) {
	        return false;
	      }
	      return typeof x === 'function' || typeof x === 'object' || x === domAll;
	    },
	
	    ToObject: function (o, optMessage) {
	      return Object(ES.RequireObjectCoercible(o, optMessage));
	    },
	
	    IsCallable: isCallable,
	
	    IsConstructor: function (x) {
	      // We can't tell callables from constructors in ES5
	      return ES.IsCallable(x);
	    },
	
	    ToInt32: function (x) {
	      return ES.ToNumber(x) >> 0;
	    },
	
	    ToUint32: function (x) {
	      return ES.ToNumber(x) >>> 0;
	    },
	
	    ToNumber: function (value) {
	      if (hasSymbols && _toString(value) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return +value;
	    },
	
	    ToInteger: function (value) {
	      var number = ES.ToNumber(value);
	      if (numberIsNaN(number)) { return 0; }
	      if (number === 0 || !numberIsFinite(number)) { return number; }
	      return (number > 0 ? 1 : -1) * _floor(_abs(number));
	    },
	
	    ToLength: function (value) {
	      var len = ES.ToInteger(value);
	      if (len <= 0) { return 0; } // includes converting -0 to +0
	      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
	      return len;
	    },
	
	    SameValue: function (a, b) {
	      if (a === b) {
	        // 0 === -0, but they are not identical.
	        if (a === 0) { return 1 / a === 1 / b; }
	        return true;
	      }
	      return numberIsNaN(a) && numberIsNaN(b);
	    },
	
	    SameValueZero: function (a, b) {
	      // same as SameValue except for SameValueZero(+0, -0) == true
	      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
	    },
	
	    GetIterator: function (o) {
	      if (isArguments(o)) {
	        // special case support for `arguments`
	        return new ArrayIterator(o, 'value');
	      }
	      var itFn = ES.GetMethod(o, $iterator$);
	      if (!ES.IsCallable(itFn)) {
	        // Better diagnostics if itFn is null or undefined
	        throw new TypeError('value is not an iterable');
	      }
	      var it = ES.Call(itFn, o);
	      if (!ES.TypeIsObject(it)) {
	        throw new TypeError('bad iterator');
	      }
	      return it;
	    },
	
	    GetMethod: function (o, p) {
	      var func = ES.ToObject(o)[p];
	      if (isNullOrUndefined(func)) {
	        return void 0;
	      }
	      if (!ES.IsCallable(func)) {
	        throw new TypeError('Method not callable: ' + p);
	      }
	      return func;
	    },
	
	    IteratorComplete: function (iterResult) {
	      return !!iterResult.done;
	    },
	
	    IteratorClose: function (iterator, completionIsThrow) {
	      var returnMethod = ES.GetMethod(iterator, 'return');
	      if (returnMethod === void 0) {
	        return;
	      }
	      var innerResult, innerException;
	      try {
	        innerResult = ES.Call(returnMethod, iterator);
	      } catch (e) {
	        innerException = e;
	      }
	      if (completionIsThrow) {
	        return;
	      }
	      if (innerException) {
	        throw innerException;
	      }
	      if (!ES.TypeIsObject(innerResult)) {
	        throw new TypeError("Iterator's return method returned a non-object.");
	      }
	    },
	
	    IteratorNext: function (it) {
	      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
	      if (!ES.TypeIsObject(result)) {
	        throw new TypeError('bad iterator');
	      }
	      return result;
	    },
	
	    IteratorStep: function (it) {
	      var result = ES.IteratorNext(it);
	      var done = ES.IteratorComplete(result);
	      return done ? false : result;
	    },
	
	    Construct: function (C, args, newTarget, isES6internal) {
	      var target = typeof newTarget === 'undefined' ? C : newTarget;
	
	      if (!isES6internal && Reflect.construct) {
	        // Try to use Reflect.construct if available
	        return Reflect.construct(C, args, target);
	      }
	      // OK, we have to fake it.  This will only work if the
	      // C.[[ConstructorKind]] == "base" -- but that's the only
	      // kind we can make in ES5 code anyway.
	
	      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
	      var proto = target.prototype;
	      if (!ES.TypeIsObject(proto)) {
	        proto = Object.prototype;
	      }
	      var obj = create(proto);
	      // Call the constructor.
	      var result = ES.Call(C, obj, args);
	      return ES.TypeIsObject(result) ? result : obj;
	    },
	
	    SpeciesConstructor: function (O, defaultConstructor) {
	      var C = O.constructor;
	      if (C === void 0) {
	        return defaultConstructor;
	      }
	      if (!ES.TypeIsObject(C)) {
	        throw new TypeError('Bad constructor');
	      }
	      var S = C[symbolSpecies];
	      if (isNullOrUndefined(S)) {
	        return defaultConstructor;
	      }
	      if (!ES.IsConstructor(S)) {
	        throw new TypeError('Bad @@species');
	      }
	      return S;
	    },
	
	    CreateHTML: function (string, tag, attribute, value) {
	      var S = ES.ToString(string);
	      var p1 = '<' + tag;
	      if (attribute !== '') {
	        var V = ES.ToString(value);
	        var escapedV = V.replace(/"/g, '&quot;');
	        p1 += ' ' + attribute + '="' + escapedV + '"';
	      }
	      var p2 = p1 + '>';
	      var p3 = p2 + S;
	      return p3 + '</' + tag + '>';
	    },
	
	    IsRegExp: function IsRegExp(argument) {
	      if (!ES.TypeIsObject(argument)) {
	        return false;
	      }
	      var isRegExp = argument[Symbol.match];
	      if (typeof isRegExp !== 'undefined') {
	        return !!isRegExp;
	      }
	      return Type.regex(argument);
	    },
	
	    ToString: function ToString(string) {
	      if (hasSymbols && _toString(string) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return $String(string);
	    }
	  };
	
	  // Well-known Symbol shims
	  if (supportsDescriptors && hasSymbols) {
	    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
	      if (Type.symbol(Symbol[name])) {
	        return Symbol[name];
	      }
	      // eslint-disable-next-line no-restricted-properties
	      var sym = Symbol['for']('Symbol.' + name);
	      Object.defineProperty(Symbol, name, {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: sym
	      });
	      return sym;
	    };
	    if (!Type.symbol(Symbol.search)) {
	      var symbolSearch = defineWellKnownSymbol('search');
	      var originalSearch = String.prototype.search;
	      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
	        return ES.Call(originalSearch, string, [this]);
	      });
	      var searchShim = function search(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var searcher = ES.GetMethod(regexp, symbolSearch);
	          if (typeof searcher !== 'undefined') {
	            return ES.Call(searcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'search', searchShim);
	    }
	    if (!Type.symbol(Symbol.replace)) {
	      var symbolReplace = defineWellKnownSymbol('replace');
	      var originalReplace = String.prototype.replace;
	      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
	        return ES.Call(originalReplace, string, [this, replaceValue]);
	      });
	      var replaceShim = function replace(searchValue, replaceValue) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(searchValue)) {
	          var replacer = ES.GetMethod(searchValue, symbolReplace);
	          if (typeof replacer !== 'undefined') {
	            return ES.Call(replacer, searchValue, [O, replaceValue]);
	          }
	        }
	        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
	      };
	      overrideNative(String.prototype, 'replace', replaceShim);
	    }
	    if (!Type.symbol(Symbol.split)) {
	      var symbolSplit = defineWellKnownSymbol('split');
	      var originalSplit = String.prototype.split;
	      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
	        return ES.Call(originalSplit, string, [this, limit]);
	      });
	      var splitShim = function split(separator, limit) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(separator)) {
	          var splitter = ES.GetMethod(separator, symbolSplit);
	          if (typeof splitter !== 'undefined') {
	            return ES.Call(splitter, separator, [O, limit]);
	          }
	        }
	        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
	      };
	      overrideNative(String.prototype, 'split', splitShim);
	    }
	    var symbolMatchExists = Type.symbol(Symbol.match);
	    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
	      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
	      // Firefox 40 and below have Symbol.match but String#match works fine.
	      var o = {};
	      o[Symbol.match] = function () { return 42; };
	      return 'a'.match(o) !== 42;
	    }());
	    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
	      var symbolMatch = defineWellKnownSymbol('match');
	
	      var originalMatch = String.prototype.match;
	      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
	        return ES.Call(originalMatch, string, [this]);
	      });
	
	      var matchShim = function match(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var matcher = ES.GetMethod(regexp, symbolMatch);
	          if (typeof matcher !== 'undefined') {
	            return ES.Call(matcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'match', matchShim);
	    }
	  }
	
	  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
	    Value.preserveToString(replacement, original);
	    if (Object.setPrototypeOf) {
	      // sets up proper prototype chain where possible
	      Object.setPrototypeOf(original, replacement);
	    }
	    if (supportsDescriptors) {
	      _forEach(Object.getOwnPropertyNames(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        Value.proxy(original, key, replacement);
	      });
	    } else {
	      _forEach(Object.keys(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        replacement[key] = original[key];
	      });
	    }
	    replacement.prototype = original.prototype;
	    Value.redefine(original.prototype, 'constructor', replacement);
	  };
	
	  var defaultSpeciesGetter = function () { return this; };
	  var addDefaultSpecies = function (C) {
	    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
	      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
	    }
	  };
	
	  var addIterator = function (prototype, impl) {
	    var implementation = impl || function iterator() { return this; };
	    defineProperty(prototype, $iterator$, implementation);
	    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
	      // implementations are buggy when $iterator$ is a Symbol
	      prototype[$iterator$] = implementation;
	    }
	  };
	
	  var createDataProperty = function createDataProperty(object, name, value) {
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
	    createDataProperty(object, name, value);
	    if (!ES.SameValue(object[name], value)) {
	      throw new TypeError('property is nonconfigurable');
	    }
	  };
	
	  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
	    // This is an es5 approximation to es6 construct semantics.  in es6,
	    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
	    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
	    // to Foo and then returns Foo().
	
	    // Many ES6 object then have constructors of the form:
	    // 1. If NewTarget is undefined, throw a TypeError exception
	    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)
	
	    // So we're going to emulate those first two steps.
	    if (!ES.TypeIsObject(o)) {
	      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
	    }
	    var proto = defaultNewTarget.prototype;
	    if (!ES.TypeIsObject(proto)) {
	      proto = defaultProto;
	    }
	    var obj = create(proto);
	    for (var name in slots) {
	      if (_hasOwnProperty(slots, name)) {
	        var value = slots[name];
	        defineProperty(obj, name, value, true);
	      }
	    }
	    return obj;
	  };
	
	  // Firefox 31 reports this function's length as 0
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
	  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
	    var originalFromCodePoint = String.fromCodePoint;
	    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
	      return ES.Call(originalFromCodePoint, this, arguments);
	    });
	  }
	
	  var StringShims = {
	    fromCodePoint: function fromCodePoint(codePoints) {
	      var result = [];
	      var next;
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        next = Number(arguments[i]);
	        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
	          throw new RangeError('Invalid code point ' + next);
	        }
	
	        if (next < 0x10000) {
	          _push(result, String.fromCharCode(next));
	        } else {
	          next -= 0x10000;
	          _push(result, String.fromCharCode((next >> 10) + 0xD800));
	          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
	        }
	      }
	      return _join(result, '');
	    },
	
	    raw: function raw(template) {
	      var numberOfSubstitutions = arguments.length - 1;
	      var cooked = ES.ToObject(template, 'bad template');
	      var raw = ES.ToObject(cooked.raw, 'bad raw value');
	      var len = raw.length;
	      var literalSegments = ES.ToLength(len);
	      if (literalSegments <= 0) {
	        return '';
	      }
	
	      var stringElements = [];
	      var nextIndex = 0;
	      var nextKey, next, nextSeg, nextSub;
	      while (nextIndex < literalSegments) {
	        nextKey = ES.ToString(nextIndex);
	        nextSeg = ES.ToString(raw[nextKey]);
	        _push(stringElements, nextSeg);
	        if (nextIndex + 1 >= literalSegments) {
	          break;
	        }
	        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
	        nextSub = ES.ToString(next);
	        _push(stringElements, nextSub);
	        nextIndex += 1;
	      }
	      return _join(stringElements, '');
	    }
	  };
	  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
	    // IE 11 TP has a broken String.raw implementation
	    overrideNative(String, 'raw', StringShims.raw);
	  }
	  defineProperties(String, StringShims);
	
	  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
	  // Perf: http://jsperf.com/string-repeat2/2
	  var stringRepeat = function repeat(s, times) {
	    if (times < 1) { return ''; }
	    if (times % 2) { return repeat(s, times - 1) + s; }
	    var half = repeat(s, times / 2);
	    return half + half;
	  };
	  var stringMaxLength = Infinity;
	
	  var StringPrototypeShims = {
	    repeat: function repeat(times) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var numTimes = ES.ToInteger(times);
	      if (numTimes < 0 || numTimes >= stringMaxLength) {
	        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
	      }
	      return stringRepeat(thisStr, numTimes);
	    },
	
	    startsWith: function startsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "startsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      var start = _max(ES.ToInteger(position), 0);
	      return _strSlice(S, start, start + searchStr.length) === searchStr;
	    },
	
	    endsWith: function endsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "endsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var len = S.length;
	      var endPosition;
	      if (arguments.length > 1) {
	        endPosition = arguments[1];
	      }
	      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
	      var end = _min(_max(pos, 0), len);
	      return _strSlice(S, end - searchStr.length, end) === searchStr;
	    },
	
	    includes: function includes(searchString) {
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('"includes" does not accept a RegExp');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      // Somehow this trick makes method 100% compat with the spec.
	      return _indexOf(this, searchStr, position) !== -1;
	    },
	
	    codePointAt: function codePointAt(pos) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var position = ES.ToInteger(pos);
	      var length = thisStr.length;
	      if (position >= 0 && position < length) {
	        var first = thisStr.charCodeAt(position);
	        var isEnd = position + 1 === length;
	        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
	        var second = thisStr.charCodeAt(position + 1);
	        if (second < 0xDC00 || second > 0xDFFF) { return first; }
	        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
	      }
	    }
	  };
	  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
	    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	  }
	
	  if (String.prototype.startsWith && String.prototype.endsWith) {
	    var startsWithRejectsRegex = throwsError(function () {
	      /* throws if spec-compliant */
	      return '/a/'.startsWith(/a/);
	    });
	    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
	      return 'abc'.startsWith('a', Infinity) === false;
	    });
	    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
	      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	  }
	  if (hasSymbols) {
	    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.startsWith(re);
	    });
	    if (!startsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	    }
	    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.endsWith(re);
	    });
	    if (!endsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.includes(re);
	    });
	    if (!includesSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	    }
	  }
	
	  defineProperties(String.prototype, StringPrototypeShims);
	
	  // whitespace from: http://es5.github.io/#x15.5.4.20
	  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	  var ws = [
	    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	    '\u2029\uFEFF'
	  ].join('');
	  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	  var trimShim = function trim() {
	    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
	  };
	  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	  var isBadHexRegex = /^[-+]0x[0-9a-f]+$/i;
	  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
	  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);
	
	  // Given an argument x, it will return an IteratorResult object,
	  // with value set to x and done to false.
	  // Given no arguments, it will return an iterator completion object.
	  var iteratorResult = function (x) {
	    return { value: x, done: arguments.length === 0 };
	  };
	
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
	  var StringIterator = function (s) {
	    ES.RequireObjectCoercible(s);
	    defineProperty(this, '_s', ES.ToString(s));
	    defineProperty(this, '_i', 0);
	  };
	  StringIterator.prototype.next = function () {
	    var s = this._s;
	    var i = this._i;
	    if (typeof s === 'undefined' || i >= s.length) {
	      this._s = void 0;
	      return iteratorResult();
	    }
	    var first = s.charCodeAt(i);
	    var second, len;
	    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
	      len = 1;
	    } else {
	      second = s.charCodeAt(i + 1);
	      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
	    }
	    this._i = i + len;
	    return iteratorResult(s.substr(i, len));
	  };
	  addIterator(StringIterator.prototype);
	  addIterator(String.prototype, function () {
	    return new StringIterator(this);
	  });
	
	  var ArrayShims = {
	    from: function from(items) {
	      var C = this;
	      var mapFn;
	      if (arguments.length > 1) {
	        mapFn = arguments[1];
	      }
	      var mapping, T;
	      if (typeof mapFn === 'undefined') {
	        mapping = false;
	      } else {
	        if (!ES.IsCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	        mapping = true;
	      }
	
	      // Note that that Arrays will use ArrayIterator:
	      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
	      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';
	
	      var length, result, i;
	      if (usingIterator) {
	        result = ES.IsConstructor(C) ? Object(new C()) : [];
	        var iterator = ES.GetIterator(items);
	        var next, nextValue;
	
	        i = 0;
	        while (true) {
	          next = ES.IteratorStep(iterator);
	          if (next === false) {
	            break;
	          }
	          nextValue = next.value;
	          try {
	            if (mapping) {
	              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
	            }
	            result[i] = nextValue;
	          } catch (e) {
	            ES.IteratorClose(iterator, true);
	            throw e;
	          }
	          i += 1;
	        }
	        length = i;
	      } else {
	        var arrayLike = ES.ToObject(items);
	        length = ES.ToLength(arrayLike.length);
	        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
	        var value;
	        for (i = 0; i < length; ++i) {
	          value = arrayLike[i];
	          if (mapping) {
	            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
	          }
	          createDataPropertyOrThrow(result, i, value);
	        }
	      }
	
	      result.length = length;
	      return result;
	    },
	
	    of: function of() {
	      var len = arguments.length;
	      var C = this;
	      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
	      for (var k = 0; k < len; ++k) {
	        createDataPropertyOrThrow(A, k, arguments[k]);
	      }
	      A.length = len;
	      return A;
	    }
	  };
	  defineProperties(Array, ArrayShims);
	  addDefaultSpecies(Array);
	
	  // Our ArrayIterator is private; see
	  // https://github.com/paulmillr/es6-shim/issues/252
	  ArrayIterator = function (array, kind) {
	    defineProperty(this, 'i', 0);
	    defineProperty(this, 'array', array);
	    defineProperty(this, 'kind', kind);
	  };
	
	  defineProperties(ArrayIterator.prototype, {
	    next: function () {
	      var i = this.i;
	      var array = this.array;
	      if (!(this instanceof ArrayIterator)) {
	        throw new TypeError('Not an ArrayIterator');
	      }
	      if (typeof array !== 'undefined') {
	        var len = ES.ToLength(array.length);
	        if (i < len) {
	        //for (; i < len; i++) {
	          var kind = this.kind;
	          var retval;
	          if (kind === 'key') {
	            retval = i;
	          } else if (kind === 'value') {
	            retval = array[i];
	          } else if (kind === 'entry') {
	            retval = [i, array[i]];
	          }
	          this.i = i + 1;
	          return iteratorResult(retval);
	        }
	      }
	      this.array = void 0;
	      return iteratorResult();
	    }
	  });
	  addIterator(ArrayIterator.prototype);
	
	  /*
	  var orderKeys = function orderKeys(a, b) {
	    var aNumeric = String(ES.ToInteger(a)) === a;
	    var bNumeric = String(ES.ToInteger(b)) === b;
	    if (aNumeric && bNumeric) {
	      return b - a;
	    } else if (aNumeric && !bNumeric) {
	      return -1;
	    } else if (!aNumeric && bNumeric) {
	      return 1;
	    } else {
	      return a.localeCompare(b);
	    }
	  };
	
	  var getAllKeys = function getAllKeys(object) {
	    var ownKeys = [];
	    var keys = [];
	
	    for (var key in object) {
	      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
	    }
	    _sort(ownKeys, orderKeys);
	    _sort(keys, orderKeys);
	
	    return _concat(ownKeys, keys);
	  };
	  */
	
	  // note: this is positioned here because it depends on ArrayIterator
	  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
	    // Detects a bug in Webkit nightly r181886
	    var Foo = function Foo(len) { this.length = len; };
	    Foo.prototype = [];
	    var fooArr = Array.of.apply(Foo, [1, 2]);
	    return fooArr instanceof Foo && fooArr.length === 2;
	  }());
	  if (!arrayOfSupportsSubclassing) {
	    overrideNative(Array, 'of', ArrayShims.of);
	  }
	
	  var ArrayPrototypeShims = {
	    copyWithin: function copyWithin(target, start) {
	      var o = ES.ToObject(this);
	      var len = ES.ToLength(o.length);
	      var relativeTarget = ES.ToInteger(target);
	      var relativeStart = ES.ToInteger(start);
	      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
	      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
	      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
	      var count = _min(finalItem - from, len - to);
	      var direction = 1;
	      if (from < to && to < (from + count)) {
	        direction = -1;
	        from += count - 1;
	        to += count - 1;
	      }
	      while (count > 0) {
	        if (from in o) {
	          o[to] = o[from];
	        } else {
	          delete o[to];
	        }
	        from += direction;
	        to += direction;
	        count -= 1;
	      }
	      return o;
	    },
	
	    fill: function fill(value) {
	      var start;
	      if (arguments.length > 1) {
	        start = arguments[1];
	      }
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var O = ES.ToObject(this);
	      var len = ES.ToLength(O.length);
	      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
	      end = ES.ToInteger(typeof end === 'undefined' ? len : end);
	
	      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
	      var relativeEnd = end < 0 ? len + end : end;
	
	      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
	        O[i] = value;
	      }
	      return O;
	    },
	
	    find: function find(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#find: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0, value; i < length; i++) {
	        value = list[i];
	        if (thisArg) {
	          if (_call(predicate, thisArg, value, i, list)) {
	            return value;
	          }
	        } else if (predicate(value, i, list)) {
	          return value;
	        }
	      }
	    },
	
	    findIndex: function findIndex(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#findIndex: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0; i < length; i++) {
	        if (thisArg) {
	          if (_call(predicate, thisArg, list[i], i, list)) {
	            return i;
	          }
	        } else if (predicate(list[i], i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    },
	
	    keys: function keys() {
	      return new ArrayIterator(this, 'key');
	    },
	
	    values: function values() {
	      return new ArrayIterator(this, 'value');
	    },
	
	    entries: function entries() {
	      return new ArrayIterator(this, 'entry');
	    }
	  };
	  // Safari 7.1 defines Array#keys and Array#entries natively,
	  // but the resulting ArrayIterator objects don't have a "next" method.
	  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
	    delete Array.prototype.keys;
	  }
	  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
	    delete Array.prototype.entries;
	  }
	
	  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
	  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
	    defineProperties(Array.prototype, {
	      values: Array.prototype[$iterator$]
	    });
	    if (Type.symbol(Symbol.unscopables)) {
	      Array.prototype[Symbol.unscopables].values = true;
	    }
	  }
	  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
	  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
	    var originalArrayPrototypeValues = Array.prototype.values;
	    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
	    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
	  }
	  defineProperties(Array.prototype, ArrayPrototypeShims);
	
	  if (1 / [true].indexOf(true, -0) < 0) {
	    // indexOf when given a position arg of -0 should return +0.
	    // https://github.com/tc39/ecma262/pull/316
	    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
	      var value = _arrayIndexOfApply(this, arguments);
	      if (value === 0 && (1 / value) < 0) {
	        return 0;
	      }
	      return value;
	    }, true);
	  }
	
	  addIterator(Array.prototype, function () { return this.values(); });
	  // Chrome defines keys/values/entries on Array, but doesn't give us
	  // any way to identify its iterator.  So add our own shimmed field.
	  if (Object.getPrototypeOf) {
	    var ChromeArrayIterator = Object.getPrototypeOf([].values());
	    if (ChromeArrayIterator) { // in WSH, this is `undefined`
	      addIterator(ChromeArrayIterator);
	    }
	  }
	
	  // note: this is positioned here because it relies on Array#entries
	  var arrayFromSwallowsNegativeLengths = (function () {
	    // Detects a Firefox bug in v32
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
	    return valueOrFalseIfThrows(function () {
	      return Array.from({ length: -1 }).length === 0;
	    });
	  }());
	  var arrayFromHandlesIterables = (function () {
	    // Detects a bug in Webkit nightly r181886
	    var arr = Array.from([0].entries());
	    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
	  }());
	  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
	    overrideNative(Array, 'from', ArrayShims.from);
	  }
	  var arrayFromHandlesUndefinedMapFunction = (function () {
	    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
	    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
	    return valueOrFalseIfThrows(function () {
	      return Array.from([0], void 0);
	    });
	  }());
	  if (!arrayFromHandlesUndefinedMapFunction) {
	    var origArrayFrom = Array.from;
	    overrideNative(Array, 'from', function from(items) {
	      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
	        return ES.Call(origArrayFrom, this, arguments);
	      }
	      return _call(origArrayFrom, this, items);
	
	    });
	  }
	
	  var int32sAsOne = -(Math.pow(2, 32) - 1);
	  var toLengthsCorrectly = function (method, reversed) {
	    var obj = { length: int32sAsOne };
	    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
	    return valueOrFalseIfThrows(function () {
	      _call(method, obj, function () {
	        // note: in nonconforming browsers, this will be called
	        // -1 >>> 0 times, which is 4294967295, so the throw matters.
	        throw new RangeError('should not reach here');
	      }, []);
	      return true;
	    });
	  };
	  if (!toLengthsCorrectly(Array.prototype.forEach)) {
	    var originalForEach = Array.prototype.forEach;
	    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
	      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.map)) {
	    var originalMap = Array.prototype.map;
	    overrideNative(Array.prototype, 'map', function map(callbackFn) {
	      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.filter)) {
	    var originalFilter = Array.prototype.filter;
	    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
	      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.some)) {
	    var originalSome = Array.prototype.some;
	    overrideNative(Array.prototype, 'some', function some(callbackFn) {
	      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.every)) {
	    var originalEvery = Array.prototype.every;
	    overrideNative(Array.prototype, 'every', function every(callbackFn) {
	      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduce)) {
	    var originalReduce = Array.prototype.reduce;
	    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
	      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
	    var originalReduceRight = Array.prototype.reduceRight;
	    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
	      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
	    });
	  }
	
	  var lacksOctalSupport = Number('0o10') !== 8;
	  var lacksBinarySupport = Number('0b10') !== 2;
	  var trimsNonWhitespace = _some(nonWS, function (c) {
	    return Number(c + 0 + c) === 0;
	  });
	  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
	    var OrigNumber = Number;
	    var binaryRegex = /^0b[01]+$/i;
	    var octalRegex = /^0o[0-7]+$/i;
	    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
	    var isBinary = binaryRegex.test.bind(binaryRegex);
	    var isOctal = octalRegex.test.bind(octalRegex);
	    var toPrimitive = function (O, hint) { // need to replace this with `es-to-primitive/es6`
	      var result;
	      if (typeof O.valueOf === 'function') {
	        result = O.valueOf();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      if (typeof O.toString === 'function') {
	        result = O.toString();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      throw new TypeError('No default value');
	    };
	    var hasNonWS = nonWSregex.test.bind(nonWSregex);
	    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
	    var NumberShim = (function () {
	      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
	      var NumberShim = function Number(value) {
	        var primValue;
	        if (arguments.length > 0) {
	          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
	        } else {
	          primValue = 0;
	        }
	        if (typeof primValue === 'string') {
	          primValue = ES.Call(trimShim, primValue);
	          if (isBinary(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 2);
	          } else if (isOctal(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 8);
	          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
	            primValue = NaN;
	          }
	        }
	        var receiver = this;
	        var valueOfSucceeds = valueOrFalseIfThrows(function () {
	          OrigNumber.prototype.valueOf.call(receiver);
	          return true;
	        });
	        if (receiver instanceof NumberShim && !valueOfSucceeds) {
	          return new OrigNumber(primValue);
	        }
	        return OrigNumber(primValue);
	      };
	      return NumberShim;
	    }());
	    wrapConstructor(OrigNumber, NumberShim, {});
	    // this is necessary for ES3 browsers, where these properties are non-enumerable.
	    defineProperties(NumberShim, {
	      NaN: OrigNumber.NaN,
	      MAX_VALUE: OrigNumber.MAX_VALUE,
	      MIN_VALUE: OrigNumber.MIN_VALUE,
	      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
	      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
	    });
	    Number = NumberShim; // eslint-disable-line no-global-assign
	    Value.redefine(globals, 'Number', NumberShim);
	  }
	
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	  defineProperties(Number, {
	    MAX_SAFE_INTEGER: maxSafeInteger,
	    MIN_SAFE_INTEGER: -maxSafeInteger,
	    EPSILON: 2.220446049250313e-16,
	
	    parseInt: globals.parseInt,
	    parseFloat: globals.parseFloat,
	
	    isFinite: numberIsFinite,
	
	    isInteger: function isInteger(value) {
	      return numberIsFinite(value) && ES.ToInteger(value) === value;
	    },
	
	    isSafeInteger: function isSafeInteger(value) {
	      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
	    },
	
	    isNaN: numberIsNaN
	  });
	  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
	  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);
	
	  // Work around bugs in Array#find and Array#findIndex -- early
	  // implementations skipped holes in sparse arrays. (Note that the
	  // implementations of find/findIndex indirectly use shimmed
	  // methods of Number, so this test has to happen down here.)
	  /* eslint-disable no-sparse-arrays */
	  if ([, 1].find(function () { return true; }) === 1) {
	    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
	  }
	  if ([, 1].findIndex(function () { return true; }) !== 0) {
	    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
	  }
	  /* eslint-enable no-sparse-arrays */
	
	  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
	  var ensureEnumerable = function ensureEnumerable(obj, prop) {
	    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
	      Object.defineProperty(obj, prop, { enumerable: false });
	    }
	  };
	  var sliceArgs = function sliceArgs() {
	    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
	    var initial = Number(this);
	    var len = arguments.length;
	    var desiredArgCount = len - initial;
	    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
	    for (var i = initial; i < len; ++i) {
	      args[i - initial] = arguments[i];
	    }
	    return args;
	  };
	  var assignTo = function assignTo(source) {
	    return function assignToSource(target, key) {
	      target[key] = source[key];
	      return target;
	    };
	  };
	  var assignReducer = function (target, source) {
	    var sourceKeys = keys(Object(source));
	    var symbols;
	    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
	    }
	    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
	  };
	
	  var ObjectShims = {
	    // 19.1.3.1
	    assign: function (target, source) {
	      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
	      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
	    },
	
	    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
	    is: function is(a, b) {
	      return ES.SameValue(a, b);
	    }
	  };
	  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
	    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	    // which is 72% slower than our shim, and Firefox 40's native implementation.
	    var thrower = Object.preventExtensions({ 1: 2 });
	    try {
	      Object.assign(thrower, 'xy');
	    } catch (e) {
	      return thrower[1] === 'y';
	    }
	  }());
	  if (assignHasPendingExceptions) {
	    overrideNative(Object, 'assign', ObjectShims.assign);
	  }
	  defineProperties(Object, ObjectShims);
	
	  if (supportsDescriptors) {
	    var ES5ObjectShims = {
	      // 19.1.3.9
	      // shim from https://gist.github.com/WebReflection/5593554
	      setPrototypeOf: (function (Object) {
	        var set;
	
	        var checkArgs = function (O, proto) {
	          if (!ES.TypeIsObject(O)) {
	            throw new TypeError('cannot set prototype on a non-object');
	          }
	          if (!(proto === null || ES.TypeIsObject(proto))) {
	            throw new TypeError('can only set prototype to an object or null' + proto);
	          }
	        };
	
	        var setPrototypeOf = function (O, proto) {
	          checkArgs(O, proto);
	          _call(set, O, proto);
	          return O;
	        };
	
	        try {
	          // this works already in Firefox and Safari
	          set = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	          _call(set, {}, null);
	        } catch (e) {
	          if (Object.prototype !== ({}).__proto__) { // eslint-disable-line no-proto
	            // IE < 11 cannot be shimmed
	            return;
	          }
	          // probably Chrome or some old Mobile stock browser
	          set = function (proto) {
	            this.__proto__ = proto; // eslint-disable-line no-proto
	          };
	          // please note that this will **not** work
	          // in those browsers that do not inherit
	          // __proto__ by mistake from Object.prototype
	          // in these cases we should probably throw an error
	          // or at least be informed about the issue
	          setPrototypeOf.polyfill = setPrototypeOf(
	            setPrototypeOf({}, null),
	            Object.prototype
	          ) instanceof Object;
	          // setPrototypeOf.polyfill === true means it works as meant
	          // setPrototypeOf.polyfill === false means it's not 100% reliable
	          // setPrototypeOf.polyfill === undefined
	          // or
	          // setPrototypeOf.polyfill ==  null means it's not a polyfill
	          // which means it works as expected
	          // we can even delete Object.prototype.__proto__;
	        }
	        return setPrototypeOf;
	      }(Object))
	    };
	
	    defineProperties(Object, ES5ObjectShims);
	  }
	
	  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
	  // but Object.create(null) does.
	  if (
	    Object.setPrototypeOf
	    && Object.getPrototypeOf
	    && Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null
	    && Object.getPrototypeOf(Object.create(null)) === null
	  ) {
	    (function () {
	      var FAKENULL = Object.create(null);
	      var gpo = Object.getPrototypeOf;
	      var spo = Object.setPrototypeOf;
	      Object.getPrototypeOf = function (o) {
	        var result = gpo(o);
	        return result === FAKENULL ? null : result;
	      };
	      Object.setPrototypeOf = function (o, p) {
	        var proto = p === null ? FAKENULL : p;
	        return spo(o, proto);
	      };
	      Object.setPrototypeOf.polyfill = false;
	    }());
	  }
	
	  var objectKeysAcceptsPrimitives = !throwsError(function () { return Object.keys('foo'); });
	  if (!objectKeysAcceptsPrimitives) {
	    var originalObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      return originalObjectKeys(ES.ToObject(value));
	    });
	    keys = Object.keys;
	  }
	  var objectKeysRejectsRegex = throwsError(function () { return Object.keys(/a/g); });
	  if (objectKeysRejectsRegex) {
	    var regexRejectingObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      if (Type.regex(value)) {
	        var regexKeys = [];
	        for (var k in value) {
	          if (_hasOwnProperty(value, k)) {
	            _push(regexKeys, k);
	          }
	        }
	        return regexKeys;
	      }
	      return regexRejectingObjectKeys(value);
	    });
	    keys = Object.keys;
	  }
	
	  if (Object.getOwnPropertyNames) {
	    var objectGOPNAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyNames('foo'); });
	    if (!objectGOPNAcceptsPrimitives) {
	      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
	      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
	      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
	        var val = ES.ToObject(value);
	        if (_toString(val) === '[object Window]') {
	          try {
	            return originalObjectGetOwnPropertyNames(val);
	          } catch (e) {
	            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
	            return _concat([], cachedWindowNames);
	          }
	        }
	        return originalObjectGetOwnPropertyNames(val);
	      });
	    }
	  }
	  if (Object.getOwnPropertyDescriptor) {
	    var objectGOPDAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyDescriptor('foo', 'bar'); });
	    if (!objectGOPDAcceptsPrimitives) {
	      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
	        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
	      });
	    }
	  }
	  if (Object.seal) {
	    var objectSealAcceptsPrimitives = !throwsError(function () { return Object.seal('foo'); });
	    if (!objectSealAcceptsPrimitives) {
	      var originalObjectSeal = Object.seal;
	      overrideNative(Object, 'seal', function seal(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectSeal(value);
	      });
	    }
	  }
	  if (Object.isSealed) {
	    var objectIsSealedAcceptsPrimitives = !throwsError(function () { return Object.isSealed('foo'); });
	    if (!objectIsSealedAcceptsPrimitives) {
	      var originalObjectIsSealed = Object.isSealed;
	      overrideNative(Object, 'isSealed', function isSealed(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsSealed(value);
	      });
	    }
	  }
	  if (Object.freeze) {
	    var objectFreezeAcceptsPrimitives = !throwsError(function () { return Object.freeze('foo'); });
	    if (!objectFreezeAcceptsPrimitives) {
	      var originalObjectFreeze = Object.freeze;
	      overrideNative(Object, 'freeze', function freeze(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectFreeze(value);
	      });
	    }
	  }
	  if (Object.isFrozen) {
	    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { return Object.isFrozen('foo'); });
	    if (!objectIsFrozenAcceptsPrimitives) {
	      var originalObjectIsFrozen = Object.isFrozen;
	      overrideNative(Object, 'isFrozen', function isFrozen(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsFrozen(value);
	      });
	    }
	  }
	  if (Object.preventExtensions) {
	    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { return Object.preventExtensions('foo'); });
	    if (!objectPreventExtensionsAcceptsPrimitives) {
	      var originalObjectPreventExtensions = Object.preventExtensions;
	      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectPreventExtensions(value);
	      });
	    }
	  }
	  if (Object.isExtensible) {
	    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { return Object.isExtensible('foo'); });
	    if (!objectIsExtensibleAcceptsPrimitives) {
	      var originalObjectIsExtensible = Object.isExtensible;
	      overrideNative(Object, 'isExtensible', function isExtensible(value) {
	        if (!ES.TypeIsObject(value)) { return false; }
	        return originalObjectIsExtensible(value);
	      });
	    }
	  }
	  if (Object.getPrototypeOf) {
	    var objectGetProtoAcceptsPrimitives = !throwsError(function () { return Object.getPrototypeOf('foo'); });
	    if (!objectGetProtoAcceptsPrimitives) {
	      var originalGetProto = Object.getPrototypeOf;
	      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
	        return originalGetProto(ES.ToObject(value));
	      });
	    }
	  }
	
	  var hasFlags = supportsDescriptors && (function () {
	    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
	    return desc && ES.IsCallable(desc.get);
	  }());
	  if (supportsDescriptors && !hasFlags) {
	    var regExpFlagsGetter = function flags() {
	      if (!ES.TypeIsObject(this)) {
	        throw new TypeError('Method called on incompatible type: must be an object.');
	      }
	      var result = '';
	      if (this.global) {
	        result += 'g';
	      }
	      if (this.ignoreCase) {
	        result += 'i';
	      }
	      if (this.multiline) {
	        result += 'm';
	      }
	      if (this.unicode) {
	        result += 'u';
	      }
	      if (this.sticky) {
	        result += 'y';
	      }
	      return result;
	    };
	
	    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
	  }
	
	  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
	    return String(new RegExp(/a/g, 'i')) === '/a/i';
	  });
	  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
	    // Edge 0.12 supports flags fully, but does not support Symbol.match
	    var regex = /./;
	    regex[Symbol.match] = false;
	    return RegExp(regex) === regex;
	  }());
	
	  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
	  });
	  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
	  });
	  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
	    var origRegExpToString = RegExp.prototype.toString;
	    defineProperty(RegExp.prototype, 'toString', function toString() {
	      var R = ES.RequireObjectCoercible(this);
	      if (Type.regex(R)) {
	        return _call(origRegExpToString, R);
	      }
	      var pattern = $String(R.source);
	      var flags = $String(R.flags);
	      return '/' + pattern + '/' + flags;
	    }, true);
	    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
	    RegExp.prototype.toString.prototype = void 0;
	  }
	
	  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
	    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
	    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
	    var legacySourceGetter = function () {
	      // prior to it being a getter, it's own + nonconfigurable
	      return this.source;
	    };
	    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;
	
	    var OrigRegExp = RegExp;
	    var RegExpShim = (function () {
	      return function RegExp(pattern, flags) {
	        var patternIsRegExp = ES.IsRegExp(pattern);
	        var calledWithNew = this instanceof RegExp;
	        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
	          return pattern;
	        }
	
	        var P = pattern;
	        var F = flags;
	        if (Type.regex(pattern)) {
	          P = ES.Call(sourceGetter, pattern);
	          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
	          return new RegExp(P, F);
	        } else if (patternIsRegExp) {
	          P = pattern.source;
	          F = typeof flags === 'undefined' ? pattern.flags : flags;
	        }
	        return new OrigRegExp(pattern, flags);
	      };
	    }());
	    wrapConstructor(OrigRegExp, RegExpShim, {
	      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
	    });
	    RegExp = RegExpShim; // eslint-disable-line no-global-assign
	    Value.redefine(globals, 'RegExp', RegExpShim);
	  }
	
	  if (supportsDescriptors) {
	    var regexGlobals = {
	      input: '$_',
	      lastMatch: '$&',
	      lastParen: '$+',
	      leftContext: '$`',
	      rightContext: '$\''
	    };
	    _forEach(keys(regexGlobals), function (prop) {
	      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
	        Value.getter(RegExp, regexGlobals[prop], function get() {
	          return RegExp[prop];
	        });
	      }
	    });
	  }
	  addDefaultSpecies(RegExp);
	
	  var inverseEpsilon = 1 / Number.EPSILON;
	  var roundTiesToEven = function roundTiesToEven(n) {
	    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
	    return (n + inverseEpsilon) - inverseEpsilon;
	  };
	  var BINARY_32_EPSILON = Math.pow(2, -23);
	  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
	  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
	  var E = Math.E;
	  var LOG2E = Math.LOG2E;
	  var LOG10E = Math.LOG10E;
	  var numberCLZ = Number.prototype.clz;
	  delete Number.prototype.clz; // Safari 8 has Number#clz
	
	  var MathShims = {
	    acosh: function acosh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || value < 1) { return NaN; }
	      if (x === 1) { return 0; }
	      if (x === Infinity) { return x; }
	
	      var xInvSquared = 1 / (x * x);
	      if (x < 2) {
	        return _log1p(x - 1 + (_sqrt(1 - xInvSquared) * x));
	      }
	      var halfX = x / 2;
	      return _log1p(halfX + (_sqrt(1 - xInvSquared) * halfX) - 1) + (1 / LOG2E);
	    },
	
	    asinh: function asinh(value) {
	      var x = Number(value);
	      if (x === 0 || !globalIsFinite(x)) {
	        return x;
	      }
	
	      var a = _abs(x);
	      var aSquared = a * a;
	      var s = _sign(x);
	      if (a < 1) {
	        return s * _log1p(a + (aSquared / (_sqrt(aSquared + 1) + 1)));
	      }
	      return s * (_log1p((a / 2) + (_sqrt(1 + (1 / aSquared)) * a / 2) - 1) + (1 / LOG2E));
	    },
	
	    atanh: function atanh(value) {
	      var x = Number(value);
	
	      if (x === 0) { return x; }
	      if (x === -1) { return -Infinity; }
	      if (x === 1) { return Infinity; }
	      if (numberIsNaN(x) || x < -1 || x > 1) {
	        return NaN;
	      }
	
	      var a = _abs(x);
	      return _sign(x) * _log1p(2 * a / (1 - a)) / 2;
	    },
	
	    cbrt: function cbrt(value) {
	      var x = Number(value);
	      if (x === 0) { return x; }
	      var negate = x < 0;
	      var result;
	      if (negate) { x = -x; }
	      if (x === Infinity) {
	        result = Infinity;
	      } else {
	        result = _exp(_log(x) / 3);
	        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
	        result = ((x / (result * result)) + (2 * result)) / 3;
	      }
	      return negate ? -result : result;
	    },
	
	    clz32: function clz32(value) {
	      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
	      var x = Number(value);
	      var number = ES.ToUint32(x);
	      if (number === 0) {
	        return 32;
	      }
	      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
	    },
	
	    cosh: function cosh(value) {
	      var x = Number(value);
	      if (x === 0) { return 1; } // +0 or -0
	      if (numberIsNaN(x)) { return NaN; }
	      if (!globalIsFinite(x)) { return Infinity; }
	
	      var t = _exp(_abs(x) - 1);
	      return (t + (1 / (t * E * E))) * (E / 2);
	    },
	
	    expm1: function expm1(value) {
	      var x = Number(value);
	      if (x === -Infinity) { return -1; }
	      if (!globalIsFinite(x) || x === 0) { return x; }
	      if (_abs(x) > 0.5) {
	        return _exp(x) - 1;
	      }
	      // A more precise approximation using Taylor series expansion
	      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
	      var t = x;
	      var sum = 0;
	      var n = 1;
	      while (sum + t !== sum) {
	        sum += t;
	        n += 1;
	        t *= x / n;
	      }
	      return sum;
	    },
	
	    hypot: function hypot(x, y) {
	      var result = 0;
	      var largest = 0;
	      for (var i = 0; i < arguments.length; ++i) {
	        var value = _abs(Number(arguments[i]));
	        if (largest < value) {
	          result *= (largest / value) * (largest / value);
	          result += 1;
	          largest = value;
	        } else {
	          result += value > 0 ? (value / largest) * (value / largest) : value;
	        }
	      }
	      return largest === Infinity ? Infinity : largest * _sqrt(result);
	    },
	
	    log2: function log2(value) {
	      return _log(value) * LOG2E;
	    },
	
	    log10: function log10(value) {
	      return _log(value) * LOG10E;
	    },
	
	    log1p: _log1p,
	
	    sign: _sign,
	
	    sinh: function sinh(value) {
	      var x = Number(value);
	      if (!globalIsFinite(x) || x === 0) { return x; }
	
	      var a = _abs(x);
	      if (a < 1) {
	        var u = Math.expm1(a);
	        return _sign(x) * u * (1 + (1 / (u + 1))) / 2;
	      }
	      var t = _exp(a - 1);
	      return _sign(x) * (t - (1 / (t * E * E))) * (E / 2);
	    },
	
	    tanh: function tanh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || x === 0) { return x; }
	      // can exit early at +-20 as JS loses precision for true value at this integer
	      if (x >= 20) { return 1; }
	      if (x <= -20) { return -1; }
	
	      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
	    },
	
	    trunc: function trunc(value) {
	      var x = Number(value);
	      return x < 0 ? -_floor(-x) : _floor(x);
	    },
	
	    imul: function imul(x, y) {
	      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
	      var a = ES.ToUint32(x);
	      var b = ES.ToUint32(y);
	      var ah = (a >>> 16) & 0xffff;
	      var al = a & 0xffff;
	      var bh = (b >>> 16) & 0xffff;
	      var bl = b & 0xffff;
	      // the shift by 0 fixes the sign on the high part
	      // the final |0 converts the unsigned value into a signed value
	      return (al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0) | 0;
	    },
	
	    fround: function fround(x) {
	      var v = Number(x);
	      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
	        return v;
	      }
	      var sign = _sign(v);
	      var abs = _abs(v);
	      if (abs < BINARY_32_MIN_VALUE) {
	        return sign * roundTiesToEven(abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
	      }
	      // Veltkamp's splitting (?)
	      var a = (1 + (BINARY_32_EPSILON / Number.EPSILON)) * abs;
	      var result = a - (a - abs);
	      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
	        return sign * Infinity;
	      }
	      return sign * result;
	    }
	  };
	
	  var withinULPDistance = function withinULPDistance(result, expected, distance) {
	    return _abs(1 - (result / expected)) / Number.EPSILON < (distance || 8);
	  };
	
	  defineProperties(Math, MathShims);
	  // Chrome < 40 sinh returns ∞ for large numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(710) === Infinity);
	  // Chrome < 40 cosh returns ∞ for large numbers
	  defineProperty(Math, 'cosh', MathShims.cosh, Math.cosh(710) === Infinity);
	  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
	  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
	  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
	  // Chrome < 54 asinh returns ∞ for large numbers and should not
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(1e+300) === Infinity);
	  // Chrome < 54 atanh incorrectly returns 0 for large numbers
	  defineProperty(Math, 'atanh', MathShims.atanh, Math.atanh(1e-300) === 0);
	  // Chrome 40 has an imprecise Math.tanh with very small numbers
	  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
	  // Chrome 40 loses Math.acosh precision with high numbers
	  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
	  // Chrome < 54 has an inaccurate acosh for EPSILON deltas
	  defineProperty(Math, 'acosh', MathShims.acosh, !withinULPDistance(Math.acosh(1 + Number.EPSILON), Math.sqrt(2 * Number.EPSILON)));
	  // Firefox 38 on Windows
	  defineProperty(Math, 'cbrt', MathShims.cbrt, !withinULPDistance(Math.cbrt(1e-300), 1e-100));
	  // node 0.11 has an imprecise Math.sinh with very small numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
	  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
	  var expm1OfTen = Math.expm1(10);
	  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);
	  // node v12.11 - v12.15 report NaN
	  defineProperty(Math, 'hypot', MathShims.hypot, Math.hypot(Infinity, NaN) !== Infinity);
	
	  var origMathRound = Math.round;
	  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
	  var roundHandlesBoundaryConditions = Math.round(0.5 - (Number.EPSILON / 4)) === 0
	    && Math.round(-0.5 + (Number.EPSILON / 3.99)) === 1;
	
	  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
	  // This behavior should be governed by "round to nearest, ties to even mode"
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
	  // These are the boundary cases where it breaks.
	  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
	  var largestPositiveNumberWhereRoundBreaks = (2 * inverseEpsilon) - 1;
	  var roundDoesNotIncreaseIntegers = [
	    smallestPositiveNumberWhereRoundBreaks,
	    largestPositiveNumberWhereRoundBreaks
	  ].every(function (num) {
	    return Math.round(num) === num;
	  });
	  defineProperty(Math, 'round', function round(x) {
	    var floor = _floor(x);
	    var ceil = floor === -1 ? -0 : floor + 1;
	    return x - floor < 0.5 ? floor : ceil;
	  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
	  Value.preserveToString(Math.round, origMathRound);
	
	  var origImul = Math.imul;
	  if (Math.imul(0xffffffff, 5) !== -5) {
	    // Safari 6.1, at least, reports "0" for this value
	    Math.imul = MathShims.imul;
	    Value.preserveToString(Math.imul, origImul);
	  }
	  if (Math.imul.length !== 2) {
	    // Safari 8.0.4 has a length of 1
	    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
	    overrideNative(Math, 'imul', function imul(x, y) {
	      return ES.Call(origImul, Math, arguments);
	    });
	  }
	
	  // Promises
	  // Simplest possible implementation; use a 3rd-party library if you
	  // want the best possible speed and/or long stack traces.
	  var PromiseShim = (function () {
	    var setTimeout = globals.setTimeout;
	    // some environments don't have setTimeout - no way to shim here.
	    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }
	
	    ES.IsPromise = function (promise) {
	      if (!ES.TypeIsObject(promise)) {
	        return false;
	      }
	      if (typeof promise._promise === 'undefined') {
	        return false; // uninitialized, or missing our hidden field.
	      }
	      return true;
	    };
	
	    // "PromiseCapability" in the spec is what most promise implementations
	    // call a "deferred".
	    var PromiseCapability = function (C) {
	      if (!ES.IsConstructor(C)) {
	        throw new TypeError('Bad promise constructor');
	      }
	      var capability = this;
	      var resolver = function (resolve, reject) {
	        if (capability.resolve !== void 0 || capability.reject !== void 0) {
	          throw new TypeError('Bad Promise implementation!');
	        }
	        capability.resolve = resolve;
	        capability.reject = reject;
	      };
	      // Initialize fields to inform optimizers about the object shape.
	      capability.resolve = void 0;
	      capability.reject = void 0;
	      capability.promise = new C(resolver);
	      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
	        throw new TypeError('Bad promise constructor');
	      }
	    };
	
	    // find an appropriate setImmediate-alike
	    var makeZeroTimeout;
	    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
	      makeZeroTimeout = function () {
	        // from http://dbaron.org/log/20100309-faster-timeouts
	        var timeouts = [];
	        var messageName = 'zero-timeout-message';
	        var setZeroTimeout = function (fn) {
	          _push(timeouts, fn);
	          window.postMessage(messageName, '*');
	        };
	        var handleMessage = function (event) {
	          if (event.source === window && event.data === messageName) {
	            event.stopPropagation();
	            if (timeouts.length === 0) { return; }
	            var fn = _shift(timeouts);
	            fn();
	          }
	        };
	        window.addEventListener('message', handleMessage, true);
	        return setZeroTimeout;
	      };
	    }
	    var makePromiseAsap = function () {
	      // An efficient task-scheduler based on a pre-existing Promise
	      // implementation, which we can use even if we override the
	      // global Promise below (in order to workaround bugs)
	      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
	      var P = globals.Promise;
	      var pr = P && P.resolve && P.resolve();
	      return pr && function (task) {
	        return pr.then(task);
	      };
	    };
	    var enqueue = ES.IsCallable(globals.setImmediate)
	      ? globals.setImmediate
	      : (
	        typeof process === 'object' && process.nextTick
	          ? process.nextTick
	          : makePromiseAsap() || (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() : function (task) { setTimeout(task, 0); })
	      ); // fallback
	
	    // Constants for Promise implementation
	    var PROMISE_IDENTITY = function (x) { return x; };
	    var PROMISE_THROWER = function (e) { throw e; };
	    var PROMISE_PENDING = 0;
	    var PROMISE_FULFILLED = 1;
	    var PROMISE_REJECTED = 2;
	    // We store fulfill/reject handlers and capabilities in a single array.
	    var PROMISE_FULFILL_OFFSET = 0;
	    var PROMISE_REJECT_OFFSET = 1;
	    var PROMISE_CAPABILITY_OFFSET = 2;
	    // This is used in an optimization for chaining promises via then.
	    var PROMISE_FAKE_CAPABILITY = {};
	
	    var enqueuePromiseReactionJob = function (handler, capability, argument) {
	      enqueue(function () {
	        promiseReactionJob(handler, capability, argument);
	      });
	    };
	
	    var promiseReactionJob = function (handler, promiseCapability, argument) {
	      var handlerResult, f;
	      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
	        // Fast case, when we don't actually need to chain through to a
	        // (real) promiseCapability.
	        return handler(argument);
	      }
	      try {
	        handlerResult = handler(argument);
	        f = promiseCapability.resolve;
	      } catch (e) {
	        handlerResult = e;
	        f = promiseCapability.reject;
	      }
	      f(handlerResult);
	    };
	
	    var fulfillPromise = function (promise, value) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.fulfillReactionHandler0,
	          _promise.reactionCapability0,
	          value
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_FULFILL_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              value
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = value;
	      _promise.state = PROMISE_FULFILLED;
	      _promise.reactionLength = 0;
	    };
	
	    var rejectPromise = function (promise, reason) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.rejectReactionHandler0,
	          _promise.reactionCapability0,
	          reason
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_REJECT_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              reason
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = reason;
	      _promise.state = PROMISE_REJECTED;
	      _promise.reactionLength = 0;
	    };
	
	    var createResolvingFunctions = function (promise) {
	      var alreadyResolved = false;
	      var resolve = function (resolution) {
	        var then;
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        if (resolution === promise) {
	          return rejectPromise(promise, new TypeError('Self resolution'));
	        }
	        if (!ES.TypeIsObject(resolution)) {
	          return fulfillPromise(promise, resolution);
	        }
	        try {
	          then = resolution.then;
	        } catch (e) {
	          return rejectPromise(promise, e);
	        }
	        if (!ES.IsCallable(then)) {
	          return fulfillPromise(promise, resolution);
	        }
	        enqueue(function () {
	          promiseResolveThenableJob(promise, resolution, then);
	        });
	      };
	      var reject = function (reason) {
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        return rejectPromise(promise, reason);
	      };
	      return { resolve: resolve, reject: reject };
	    };
	
	    var optimizedThen = function (then, thenable, resolve, reject) {
	      // Optimization: since we discard the result, we can pass our
	      // own then implementation a special hint to let it know it
	      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
	      // object is local to this implementation and unforgeable outside.)
	      if (then === Promise$prototype$then) {
	        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
	      } else {
	        _call(then, thenable, resolve, reject);
	      }
	    };
	    var promiseResolveThenableJob = function (promise, thenable, then) {
	      var resolvingFunctions = createResolvingFunctions(promise);
	      var resolve = resolvingFunctions.resolve;
	      var reject = resolvingFunctions.reject;
	      try {
	        optimizedThen(then, thenable, resolve, reject);
	      } catch (e) {
	        reject(e);
	      }
	    };
	
	    var Promise$prototype, Promise$prototype$then;
	    var Promise = (function () {
	      var PromiseShim = function Promise(resolver) {
	        if (!(this instanceof PromiseShim)) {
	          throw new TypeError('Constructor Promise requires "new"');
	        }
	        if (this && this._promise) {
	          throw new TypeError('Bad construction');
	        }
	        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
	        if (!ES.IsCallable(resolver)) {
	          throw new TypeError('not a valid resolver');
	        }
	        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
	          _promise: {
	            result: void 0,
	            state: PROMISE_PENDING,
	            // The first member of the "reactions" array is inlined here,
	            // since most promises only have one reaction.
	            // We've also exploded the 'reaction' object to inline the
	            // "handler" and "capability" fields, since both fulfill and
	            // reject reactions share the same capability.
	            reactionLength: 0,
	            fulfillReactionHandler0: void 0,
	            rejectReactionHandler0: void 0,
	            reactionCapability0: void 0
	          }
	        });
	        var resolvingFunctions = createResolvingFunctions(promise);
	        var reject = resolvingFunctions.reject;
	        try {
	          resolver(resolvingFunctions.resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        return promise;
	      };
	      return PromiseShim;
	    }());
	    Promise$prototype = Promise.prototype;
	
	    var _promiseAllResolver = function (index, values, capability, remaining) {
	      var alreadyCalled = false;
	      return function (x) {
	        if (alreadyCalled) { return; }
	        alreadyCalled = true;
	        values[index] = x;
	        if ((--remaining.count) === 0) {
	          var resolve = capability.resolve;
	          resolve(values); // call w/ this===undefined
	        }
	      };
	    };
	
	    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var values = [];
	      var remaining = { count: 1 };
	      var next, nextValue;
	      var index = 0;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        values[index] = void 0;
	        var nextPromise = C.resolve(nextValue);
	        var resolveElement = _promiseAllResolver(
	          index,
	          values,
	          resultCapability,
	          remaining
	        );
	        remaining.count += 1;
	        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
	        index += 1;
	      }
	      if ((--remaining.count) === 0) {
	        var resolve = resultCapability.resolve;
	        resolve(values); // call w/ this===undefined
	      }
	      return resultCapability.promise;
	    };
	
	    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var next, nextValue, nextPromise;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            // NOTE: If iterable has no items, resulting promise will never
	            // resolve; see:
	            // https://github.com/domenic/promises-unwrapping/issues/75
	            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        nextPromise = C.resolve(nextValue);
	        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
	      }
	      return resultCapability.promise;
	    };
	
	    defineProperties(Promise, {
	      all: function all(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseAll(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      race: function race(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseRace(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      reject: function reject(reason) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        var capability = new PromiseCapability(C);
	        var rejectFunc = capability.reject;
	        rejectFunc(reason); // call with this===undefined
	        return capability.promise;
	      },
	
	      resolve: function resolve(v) {
	        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        if (ES.IsPromise(v)) {
	          var constructor = v.constructor;
	          if (constructor === C) {
	            return v;
	          }
	        }
	        var capability = new PromiseCapability(C);
	        var resolveFunc = capability.resolve;
	        resolveFunc(v); // call with this===undefined
	        return capability.promise;
	      }
	    });
	
	    defineProperties(Promise$prototype, {
	      'catch': function (onRejected) {
	        return this.then(null, onRejected);
	      },
	
	      then: function then(onFulfilled, onRejected) {
	        var promise = this;
	        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
	        var C = ES.SpeciesConstructor(promise, Promise);
	        var resultCapability;
	        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
	        if (returnValueIsIgnored && C === Promise) {
	          resultCapability = PROMISE_FAKE_CAPABILITY;
	        } else {
	          resultCapability = new PromiseCapability(C);
	        }
	        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
	        // Note that we've split the 'reaction' object into its two
	        // components, "capabilities" and "handler"
	        // "capabilities" is always equal to `resultCapability`
	        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
	        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
	        var _promise = promise._promise;
	        var value;
	        if (_promise.state === PROMISE_PENDING) {
	          if (_promise.reactionLength === 0) {
	            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
	            _promise.rejectReactionHandler0 = rejectReactionHandler;
	            _promise.reactionCapability0 = resultCapability;
	          } else {
	            var idx = 3 * (_promise.reactionLength - 1);
	            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
	            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
	            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
	          }
	          _promise.reactionLength += 1;
	        } else if (_promise.state === PROMISE_FULFILLED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            fulfillReactionHandler,
	            resultCapability,
	            value
	          );
	        } else if (_promise.state === PROMISE_REJECTED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            rejectReactionHandler,
	            resultCapability,
	            value
	          );
	        } else {
	          throw new TypeError('unexpected Promise state');
	        }
	        return resultCapability.promise;
	      }
	    });
	    // This helps the optimizer by ensuring that methods which take
	    // capabilities aren't polymorphic.
	    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
	    Promise$prototype$then = Promise$prototype.then;
	
	    return Promise;
	  }());
	
	  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
	  if (globals.Promise) {
	    delete globals.Promise.accept;
	    delete globals.Promise.defer;
	    delete globals.Promise.prototype.chain;
	  }
	
	  if (typeof PromiseShim === 'function') {
	    // export the Promise constructor.
	    defineProperties(globals, { Promise: PromiseShim });
	    // In Chrome 33 (and thereabouts) Promise is defined, but the
	    // implementation is buggy in a number of ways.  Let's check subclassing
	    // support to see if we have a buggy implementation.
	    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
	      return S.resolve(42).then(function () {}) instanceof S;
	    });
	    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () {
	      return globals.Promise.reject(42).then(null, 5).then(null, noop);
	    });
	    var promiseRequiresObjectContext = throwsError(function () { return globals.Promise.call(3, noop); });
	    // Promise.resolve() was errata'ed late in the ES6 process.
	    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
	    //      https://code.google.com/p/v8/issues/detail?id=4161
	    // It serves as a proxy for a number of other bugs in early Promise
	    // implementations.
	    var promiseResolveBroken = (function (Promise) {
	      var p = Promise.resolve(5);
	      p.constructor = {};
	      var p2 = Promise.resolve(p);
	      try {
	        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
	      } catch (e) {
	        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
	      }
	      return p === p2; // This *should* be false!
	    }(globals.Promise));
	
	    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
	    var getsThenSynchronously = supportsDescriptors && (function () {
	      var count = 0;
	      // eslint-disable-next-line getter-return
	      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
	      Promise.resolve(thenable);
	      return count === 1;
	    }());
	
	    var BadResolverPromise = function BadResolverPromise(executor) {
	      var p = new Promise(executor);
	      executor(3, function () {});
	      this.then = p.then;
	      this.constructor = BadResolverPromise;
	    };
	    BadResolverPromise.prototype = Promise.prototype;
	    BadResolverPromise.all = Promise.all;
	    // Chrome Canary 49 (probably older too) has some implementation bugs
	    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
	      return !!BadResolverPromise.all([1, 2]);
	    });
	
	    if (
	      !promiseSupportsSubclassing
	      || !promiseIgnoresNonFunctionThenCallbacks
	      || !promiseRequiresObjectContext
	      || promiseResolveBroken
	      || !getsThenSynchronously
	      || hasBadResolverPromise
	    ) {
	      Promise = PromiseShim; // eslint-disable-line no-global-assign
	      overrideNative(globals, 'Promise', PromiseShim);
	    }
	    if (Promise.all.length !== 1) {
	      var origAll = Promise.all;
	      overrideNative(Promise, 'all', function all(iterable) {
	        return ES.Call(origAll, this, arguments);
	      });
	    }
	    if (Promise.race.length !== 1) {
	      var origRace = Promise.race;
	      overrideNative(Promise, 'race', function race(iterable) {
	        return ES.Call(origRace, this, arguments);
	      });
	    }
	    if (Promise.resolve.length !== 1) {
	      var origResolve = Promise.resolve;
	      overrideNative(Promise, 'resolve', function resolve(x) {
	        return ES.Call(origResolve, this, arguments);
	      });
	    }
	    if (Promise.reject.length !== 1) {
	      var origReject = Promise.reject;
	      overrideNative(Promise, 'reject', function reject(r) {
	        return ES.Call(origReject, this, arguments);
	      });
	    }
	    ensureEnumerable(Promise, 'all');
	    ensureEnumerable(Promise, 'race');
	    ensureEnumerable(Promise, 'resolve');
	    ensureEnumerable(Promise, 'reject');
	    addDefaultSpecies(Promise);
	  }
	
	  // Map and Set require a true ES5 environment
	  // Their fast path also requires that the environment preserve
	  // property insertion order, which is not guaranteed by the spec.
	  var testOrder = function (a) {
	    var b = keys(_reduce(a, function (o, k) {
	      o[k] = true;
	      return o;
	    }, {}));
	    return a.join(':') === b.join(':');
	  };
	  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
	  // some engines (eg, Chrome) only preserve insertion order for string keys
	  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);
	
	  if (supportsDescriptors) {
	
	    var fastkey = function fastkey(key, skipInsertionOrderCheck) {
	      if (!skipInsertionOrderCheck && !preservesInsertionOrder) {
	        return null;
	      }
	      if (isNullOrUndefined(key)) {
	        return '^' + ES.ToString(key);
	      } else if (typeof key === 'string') {
	        return '$' + key;
	      } else if (typeof key === 'number') {
	        // note that -0 will get coerced to "0" when used as a property key
	        if (!preservesNumericInsertionOrder) {
	          return 'n' + key;
	        }
	        return key;
	      } else if (typeof key === 'boolean') {
	        return 'b' + key;
	      }
	      return null;
	    };
	
	    var emptyObject = function emptyObject() {
	      // accomodate some older not-quite-ES5 browsers
	      return Object.create ? Object.create(null) : {};
	    };
	
	    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (entry) {
	          if (!ES.TypeIsObject(entry)) {
	            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
	          }
	          map.set(entry[0], entry[1]);
	        });
	      } else if (iterable instanceof MapConstructor) {
	        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
	          map.set(key, value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = map.set;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextItem = next.value;
	            try {
	              if (!ES.TypeIsObject(nextItem)) {
	                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
	              }
	              _call(adder, map, nextItem[0], nextItem[1]);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (value) {
	          set.add(value);
	        });
	      } else if (iterable instanceof SetConstructor) {
	        _call(SetConstructor.prototype.forEach, iterable, function (value) {
	          set.add(value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = set.add;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextValue = next.value;
	            try {
	              _call(adder, set, nextValue);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	
	    var collectionShims = {
	      Map: (function () {
	
	        var empty = {};
	
	        var MapEntry = function MapEntry(key, value) {
	          this.key = key;
	          this.value = value;
	          this.next = null;
	          this.prev = null;
	        };
	
	        MapEntry.prototype.isRemoved = function isRemoved() {
	          return this.key === empty;
	        };
	
	        var isMap = function isMap(map) {
	          return !!map._es6map;
	        };
	
	        var requireMapSlot = function requireMapSlot(map, method) {
	          if (!ES.TypeIsObject(map) || !isMap(map)) {
	            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
	          }
	        };
	
	        var MapIterator = function MapIterator(map, kind) {
	          requireMapSlot(map, '[[MapIterator]]');
	          defineProperty(this, 'head', map._head);
	          defineProperty(this, 'i', this.head);
	          defineProperty(this, 'kind', kind);
	        };
	
	        MapIterator.prototype = {
	          isMapIterator: true,
	          next: function next() {
	            if (!this.isMapIterator) {
	              throw new TypeError('Not a MapIterator');
	            }
	            var i = this.i;
	            var kind = this.kind;
	            var head = this.head;
	            if (typeof this.i === 'undefined') {
	              return iteratorResult();
	            }
	            while (i.isRemoved() && i !== head) {
	              // back up off of removed entries
	              i = i.prev;
	            }
	            // advance to next unreturned element.
	            var result;
	            while (i.next !== head) {
	              i = i.next;
	              if (!i.isRemoved()) {
	                if (kind === 'key') {
	                  result = i.key;
	                } else if (kind === 'value') {
	                  result = i.value;
	                } else {
	                  result = [i.key, i.value];
	                }
	                this.i = i;
	                return iteratorResult(result);
	              }
	            }
	            // once the iterator is done, it is done forever.
	            this.i = void 0;
	            return iteratorResult();
	          }
	        };
	        addIterator(MapIterator.prototype);
	
	        var Map$prototype;
	        var MapShim = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          if (this && this._es6map) {
	            throw new TypeError('Bad construction');
	          }
	          var map = emulateES6construct(this, Map, Map$prototype, {
	            _es6map: true,
	            _head: null,
	            _map: OrigMap ? new OrigMap() : null,
	            _size: 0,
	            _storage: emptyObject()
	          });
	
	          var head = new MapEntry(null, null);
	          // circular doubly-linked list.
	          /* eslint no-multi-assign: 1 */
	          head.next = head.prev = head;
	          map._head = head;
	
	          // Optionally initialize map from iterable
	          if (arguments.length > 0) {
	            addIterableToMap(Map, map, arguments[0]);
	          }
	          return map;
	        };
	        Map$prototype = MapShim.prototype;
	
	        Value.getter(Map$prototype, 'size', function () {
	          if (typeof this._size === 'undefined') {
	            throw new TypeError('size method called on incompatible Map');
	          }
	          return this._size;
	        });
	
	        defineProperties(Map$prototype, {
	          get: function get(key) {
	            requireMapSlot(this, 'get');
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              entry = this._storage[fkey];
	              if (entry) {
	                return entry.value;
	              }
	              return;
	
	            }
	            if (this._map) {
	              // fast object key path
	              entry = origMapGet.call(this._map, key);
	              if (entry) {
	                return entry.value;
	              }
	              return;
	
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return i.value;
	              }
	            }
	          },
	
	          has: function has(key) {
	            requireMapSlot(this, 'has');
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              return typeof this._storage[fkey] !== 'undefined';
	            }
	            if (this._map) {
	              // fast object key path
	              return origMapHas.call(this._map, key);
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return true;
	              }
	            }
	            return false;
	          },
	
	          set: function set(key, value) {
	            requireMapSlot(this, 'set');
	            var head = this._head;
	            var i = head;
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] !== 'undefined') {
	                this._storage[fkey].value = value;
	                return this;
	              }
	              entry = this._storage[fkey] = new MapEntry(key, value); /* eslint no-multi-assign: 1 */
	              i = head.prev;
	              // fall through
	
	            } else if (this._map) {
	              // fast object key path
	              if (origMapHas.call(this._map, key)) {
	                origMapGet.call(this._map, key).value = value;
	              } else {
	                entry = new MapEntry(key, value);
	                origMapSet.call(this._map, key, entry);
	                i = head.prev;
	                // fall through
	              }
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.value = value;
	                return this;
	              }
	            }
	            entry = entry || new MapEntry(key, value);
	            if (ES.SameValue(-0, key)) {
	              entry.key = +0; // coerce -0 to +0 in entry
	            }
	            entry.next = this._head;
	            entry.prev = this._head.prev;
	            entry.prev.next = entry;
	            entry.next.prev = entry;
	            this._size += 1;
	            return this;
	          },
	
	          'delete': function (key) {
	            requireMapSlot(this, 'delete');
	            var head = this._head;
	            var i = head;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] === 'undefined') {
	                return false;
	              }
	              i = this._storage[fkey].prev;
	              delete this._storage[fkey];
	              // fall through
	            } else if (this._map) {
	              // fast object key path
	              if (!origMapHas.call(this._map, key)) {
	                return false;
	              }
	              i = origMapGet.call(this._map, key).prev;
	              origMapDelete.call(this._map, key);
	              // fall through
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.key = empty;
	                i.value = empty;
	                i.prev.next = i.next;
	                i.next.prev = i.prev;
	                this._size -= 1;
	                return true;
	              }
	            }
	            return false;
	          },
	
	          clear: function clear() {
	            /* eslint no-multi-assign: 1 */
	            requireMapSlot(this, 'clear');
	            this._map = OrigMap ? new OrigMap() : null;
	            this._size = 0;
	            this._storage = emptyObject();
	            var head = this._head;
	            var i = head;
	            var p = i.next;
	            while ((i = p) !== head) {
	              i.key = empty;
	              i.value = empty;
	              p = i.next;
	              i.next = i.prev = head;
	            }
	            head.next = head.prev = head;
	          },
	
	          keys: function keys() {
	            requireMapSlot(this, 'keys');
	            return new MapIterator(this, 'key');
	          },
	
	          values: function values() {
	            requireMapSlot(this, 'values');
	            return new MapIterator(this, 'value');
	          },
	
	          entries: function entries() {
	            requireMapSlot(this, 'entries');
	            return new MapIterator(this, 'key+value');
	          },
	
	          forEach: function forEach(callback) {
	            requireMapSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var it = this.entries();
	            for (var entry = it.next(); !entry.done; entry = it.next()) {
	              if (context) {
	                _call(callback, context, entry.value[1], entry.value[0], this);
	              } else {
	                callback(entry.value[1], entry.value[0], this);
	              }
	            }
	          }
	        });
	        addIterator(Map$prototype, Map$prototype.entries);
	
	        return MapShim;
	      }()),
	
	      Set: (function () {
	        var isSet = function isSet(set) {
	          return set._es6set && typeof set._storage !== 'undefined';
	        };
	        var requireSetSlot = function requireSetSlot(set, method) {
	          if (!ES.TypeIsObject(set) || !isSet(set)) {
	            // https://github.com/paulmillr/es6-shim/issues/176
	            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
	          }
	        };
	
	        // Creating a Map is expensive.  To speed up the common case of
	        // Sets containing only string or numeric keys, we use an object
	        // as backing storage and lazily create a full Map only when
	        // required.
	        var Set$prototype;
	        var SetShim = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          if (this && this._es6set) {
	            throw new TypeError('Bad construction');
	          }
	          var set = emulateES6construct(this, Set, Set$prototype, {
	            _es6set: true,
	            '[[SetData]]': null,
	            _storage: emptyObject()
	          });
	          if (!set._es6set) {
	            throw new TypeError('bad set');
	          }
	
	          // Optionally initialize Set from iterable
	          if (arguments.length > 0) {
	            addIterableToSet(Set, set, arguments[0]);
	          }
	          return set;
	        };
	        Set$prototype = SetShim.prototype;
	
	        var decodeKey = function (key) {
	          var k = key;
	          if (k === '^null') {
	            return null;
	          } else if (k === '^undefined') {
	            return void 0;
	          }
	          var first = k.charAt(0);
	          if (first === '$') {
	            return _strSlice(k, 1);
	          } else if (first === 'n') {
	            return +_strSlice(k, 1);
	          } else if (first === 'b') {
	            return k === 'btrue';
	          }
	
	          return +k;
	        };
	        // Switch from the object backing storage to a full Map.
	        var ensureMap = function ensureMap(set) {
	          if (!set['[[SetData]]']) {
	            var m = new collectionShims.Map();
	            set['[[SetData]]'] = m;
	            _forEach(keys(set._storage), function (key) {
	              var k = decodeKey(key);
	              m.set(k, k);
	            });
	            set['[[SetData]]'] = m;
	          }
	          set._storage = null; // free old backing storage
	        };
	
	        Value.getter(SetShim.prototype, 'size', function () {
	          requireSetSlot(this, 'size');
	          if (this._storage) {
	            return keys(this._storage).length;
	          }
	          ensureMap(this);
	          return this['[[SetData]]'].size;
	        });
	
	        defineProperties(SetShim.prototype, {
	          has: function has(key) {
	            requireSetSlot(this, 'has');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              return !!this._storage[fkey];
	            }
	            ensureMap(this);
	            return this['[[SetData]]'].has(key);
	          },
	
	          add: function add(key) {
	            requireSetSlot(this, 'add');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              this._storage[fkey] = true;
	              return this;
	            }
	            ensureMap(this);
	            this['[[SetData]]'].set(key, key);
	            return this;
	          },
	
	          'delete': function (key) {
	            requireSetSlot(this, 'delete');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              var hasFKey = _hasOwnProperty(this._storage, fkey);
	              return (delete this._storage[fkey]) && hasFKey;
	            }
	            ensureMap(this);
	            return this['[[SetData]]']['delete'](key);
	          },
	
	          clear: function clear() {
	            requireSetSlot(this, 'clear');
	            if (this._storage) {
	              this._storage = emptyObject();
	            }
	            if (this['[[SetData]]']) {
	              this['[[SetData]]'].clear();
	            }
	          },
	
	          values: function values() {
	            requireSetSlot(this, 'values');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].values());
	          },
	
	          entries: function entries() {
	            requireSetSlot(this, 'entries');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].entries());
	          },
	
	          forEach: function forEach(callback) {
	            requireSetSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var entireSet = this;
	            ensureMap(entireSet);
	            this['[[SetData]]'].forEach(function (value, key) {
	              if (context) {
	                _call(callback, context, key, key, entireSet);
	              } else {
	                callback(key, key, entireSet);
	              }
	            });
	          }
	        });
	        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
	        addIterator(SetShim.prototype, SetShim.prototype.values);
	
	        var SetIterator = function SetIterator(it) {
	          defineProperty(this, 'it', it);
	        };
	        SetIterator.prototype = {
	          isSetIterator: true,
	          next: function next() {
	            if (!this.isSetIterator) {
	              throw new TypeError('Not a SetIterator');
	            }
	            return this.it.next();
	          }
	        };
	        addIterator(SetIterator.prototype);
	
	        return SetShim;
	      }())
	    };
	
	    var isGoogleTranslate = globals.Set && !Set.prototype['delete'] && Set.prototype.remove && Set.prototype.items && Set.prototype.map && Array.isArray(new Set().keys);
	    if (isGoogleTranslate) {
	      // special-case force removal of wildly invalid Set implementation in Google Translate iframes
	      // see https://github.com/paulmillr/es6-shim/issues/438 / https://twitter.com/ljharb/status/849335573114363904
	      globals.Set = collectionShims.Set;
	    }
	    if (globals.Map || globals.Set) {
	      // Safari 8, for example, doesn't accept an iterable.
	      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
	      if (!mapAcceptsArguments) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, globals.Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = create(OrigMap.prototype);
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var testMap = new Map();
	      var mapUsesSameValueZero = (function () {
	        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
	        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
	        m.set(-0, m);
	        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
	      }());
	      var mapSupportsChaining = testMap.set(1, 2) === testMap;
	      if (!mapUsesSameValueZero || !mapSupportsChaining) {
	        overrideNative(Map.prototype, 'set', function set(k, v) {
	          _call(origMapSet, this, k === 0 ? 0 : k, v);
	          return this;
	        });
	      }
	      if (!mapUsesSameValueZero) {
	        defineProperties(Map.prototype, {
	          get: function get(k) {
	            return _call(origMapGet, this, k === 0 ? 0 : k);
	          },
	          has: function has(k) {
	            return _call(origMapHas, this, k === 0 ? 0 : k);
	          }
	        }, true);
	        Value.preserveToString(Map.prototype.get, origMapGet);
	        Value.preserveToString(Map.prototype.has, origMapHas);
	      }
	      var testSet = new Set();
	      var setUsesSameValueZero = Set.prototype['delete'] && Set.prototype.add && Set.prototype.has && (function (s) {
	        s['delete'](0);
	        s.add(-0);
	        return !s.has(0);
	      }(testSet));
	      var setSupportsChaining = testSet.add(1) === testSet;
	      if (!setUsesSameValueZero || !setSupportsChaining) {
	        var origSetAdd = Set.prototype.add;
	        Set.prototype.add = function add(v) {
	          _call(origSetAdd, this, v === 0 ? 0 : v);
	          return this;
	        };
	        Value.preserveToString(Set.prototype.add, origSetAdd);
	      }
	      if (!setUsesSameValueZero) {
	        var origSetHas = Set.prototype.has;
	        Set.prototype.has = function has(v) {
	          return _call(origSetHas, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype.has, origSetHas);
	        var origSetDel = Set.prototype['delete'];
	        Set.prototype['delete'] = function SetDelete(v) {
	          return _call(origSetDel, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype['delete'], origSetDel);
	      }
	      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
	        var m = new M([]);
	        // Firefox 32 is ok with the instantiating the subclass but will
	        // throw when the map is used.
	        m.set(42, 42);
	        return m instanceof M;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing;
	      var mapRequiresNew = (function () {
	        try {
	          return !(globals.Map() instanceof globals.Map);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = OrigMap.prototype;
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
	        var s = new S([]);
	        s.add(42, 42);
	        return s instanceof S;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing;
	      var setRequiresNew = (function () {
	        try {
	          return !(globals.Set() instanceof globals.Set);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
	        var OrigSet = globals.Set;
	        globals.Set = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          var s = new OrigSet();
	          if (arguments.length > 0) {
	            addIterableToSet(Set, s, arguments[0]);
	          }
	          delete s.constructor;
	          Object.setPrototypeOf(s, Set.prototype);
	          return s;
	        };
	        globals.Set.prototype = OrigSet.prototype;
	        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
	        Value.preserveToString(globals.Set, OrigSet);
	      }
	      var newMap = new globals.Map();
	      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
	        return newMap.keys().next().done;
	      });
	      /*
	        - In Firefox < 23, Map#size is a function.
	        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
	        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
	        - In Firefox 24, Map and Set do not implement forEach
	        - In Firefox 25 at least, Map and Set are callable without "new"
	      */
	      if (
	        typeof globals.Map.prototype.clear !== 'function'
	        || new globals.Set().size !== 0
	        || newMap.size !== 0
	        || typeof globals.Map.prototype.keys !== 'function'
	        || typeof globals.Set.prototype.keys !== 'function'
	        || typeof globals.Map.prototype.forEach !== 'function'
	        || typeof globals.Set.prototype.forEach !== 'function'
	        || isCallableWithoutNew(globals.Map)
	        || isCallableWithoutNew(globals.Set)
	        || typeof newMap.keys().next !== 'function' // Safari 8
	        || mapIterationThrowsStopIterator // Firefox 25
	        || !mapSupportsSubclassing
	      ) {
	        defineProperties(globals, {
	          Map: collectionShims.Map,
	          Set: collectionShims.Set
	        }, true);
	      }
	
	      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
	        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
	        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
	      }
	
	      // Shim incomplete iterator implementations.
	      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
	      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));
	
	      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
	        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
	        var anonymousSetHas = globals.Set.prototype.has;
	        overrideNative(globals.Set.prototype, 'has', function has(key) {
	          return _call(anonymousSetHas, this, key);
	        });
	      }
	    }
	    defineProperties(globals, collectionShims);
	    addDefaultSpecies(globals.Map);
	    addDefaultSpecies(globals.Set);
	  }
	
	  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
	    if (!ES.TypeIsObject(target)) {
	      throw new TypeError('target must be an object');
	    }
	  };
	
	  // Some Reflect methods are basically the same as
	  // those on the Object global, except that a TypeError is thrown if
	  // target isn't an object. As well as returning a boolean indicating
	  // the success of the operation.
	  var ReflectShims = {
	    // Apply method in a functional form.
	    apply: function apply() {
	      return ES.Call(ES.Call, null, arguments);
	    },
	
	    // New operator in a functional form.
	    construct: function construct(constructor, args) {
	      if (!ES.IsConstructor(constructor)) {
	        throw new TypeError('First argument must be a constructor.');
	      }
	      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
	      if (!ES.IsConstructor(newTarget)) {
	        throw new TypeError('new.target must be a constructor.');
	      }
	      return ES.Construct(constructor, args, newTarget, 'internal');
	    },
	
	    // When deleting a non-existent or configurable property,
	    // true is returned.
	    // When attempting to delete a non-configurable property,
	    // it will return false.
	    deleteProperty: function deleteProperty(target, key) {
	      throwUnlessTargetIsObject(target);
	      if (supportsDescriptors) {
	        var desc = Object.getOwnPropertyDescriptor(target, key);
	
	        if (desc && !desc.configurable) {
	          return false;
	        }
	      }
	
	      // Will return true.
	      return delete target[key];
	    },
	
	    has: function has(target, key) {
	      throwUnlessTargetIsObject(target);
	      return key in target;
	    }
	  };
	
	  if (Object.getOwnPropertyNames) {
	    Object.assign(ReflectShims, {
	      // Basically the result of calling the internal [[OwnPropertyKeys]].
	      // Concatenating propertyNames and propertySymbols should do the trick.
	      // This should continue to work together with a Symbol shim
	      // which overrides Object.getOwnPropertyNames and implements
	      // Object.getOwnPropertySymbols.
	      ownKeys: function ownKeys(target) {
	        throwUnlessTargetIsObject(target);
	        var keys = Object.getOwnPropertyNames(target);
	
	        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	          _pushApply(keys, Object.getOwnPropertySymbols(target));
	        }
	
	        return keys;
	      }
	    });
	  }
	
	  var callAndCatchException = function ConvertExceptionToBoolean(func) {
	    return !throwsError(func);
	  };
	
	  if (Object.preventExtensions) {
	    Object.assign(ReflectShims, {
	      isExtensible: function isExtensible(target) {
	        throwUnlessTargetIsObject(target);
	        return Object.isExtensible(target);
	      },
	      preventExtensions: function preventExtensions(target) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.preventExtensions(target);
	        });
	      }
	    });
	  }
	
	  if (supportsDescriptors) {
	    var internalGet = function get(target, key, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent === null) {
	          return void 0;
	        }
	
	        return internalGet(parent, key, receiver);
	      }
	
	      if ('value' in desc) {
	        return desc.value;
	      }
	
	      if (desc.get) {
	        return ES.Call(desc.get, receiver);
	      }
	
	      return void 0;
	    };
	
	    var internalSet = function set(target, key, value, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent !== null) {
	          return internalSet(parent, key, value, receiver);
	        }
	
	        desc = {
	          value: void 0,
	          writable: true,
	          enumerable: true,
	          configurable: true
	        };
	      }
	
	      if ('value' in desc) {
	        if (!desc.writable) {
	          return false;
	        }
	
	        if (!ES.TypeIsObject(receiver)) {
	          return false;
	        }
	
	        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);
	
	        if (existingDesc) {
	          return Reflect.defineProperty(receiver, key, {
	            value: value
	          });
	        }
	        return Reflect.defineProperty(receiver, key, {
	          value: value,
	          writable: true,
	          enumerable: true,
	          configurable: true
	        });
	
	      }
	
	      if (desc.set) {
	        _call(desc.set, receiver, value);
	        return true;
	      }
	
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      defineProperty: function defineProperty(target, propertyKey, attributes) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.defineProperty(target, propertyKey, attributes);
	        });
	      },
	
	      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	        throwUnlessTargetIsObject(target);
	        return Object.getOwnPropertyDescriptor(target, propertyKey);
	      },
	
	      // Syntax in a functional form.
	      get: function get(target, key) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 2 ? arguments[2] : target;
	
	        return internalGet(target, key, receiver);
	      },
	
	      set: function set(target, key, value) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 3 ? arguments[3] : target;
	
	        return internalSet(target, key, value, receiver);
	      }
	    });
	  }
	
	  if (Object.getPrototypeOf) {
	    var objectDotGetPrototypeOf = Object.getPrototypeOf;
	    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
	      throwUnlessTargetIsObject(target);
	      return objectDotGetPrototypeOf(target);
	    };
	  }
	
	  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
	    var willCreateCircularPrototype = function (object, lastProto) {
	      var proto = lastProto;
	      while (proto) {
	        if (object === proto) {
	          return true;
	        }
	        proto = ReflectShims.getPrototypeOf(proto);
	      }
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      // Sets the prototype of the given object.
	      // Returns true on success, otherwise false.
	      setPrototypeOf: function setPrototypeOf(object, proto) {
	        throwUnlessTargetIsObject(object);
	        if (proto !== null && !ES.TypeIsObject(proto)) {
	          throw new TypeError('proto must be an object or null');
	        }
	
	        // If they already are the same, we're done.
	        if (proto === Reflect.getPrototypeOf(object)) {
	          return true;
	        }
	
	        // Cannot alter prototype if object not extensible.
	        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
	          return false;
	        }
	
	        // Ensure that we do not create a circular prototype chain.
	        if (willCreateCircularPrototype(object, proto)) {
	          return false;
	        }
	
	        Object.setPrototypeOf(object, proto);
	
	        return true;
	      }
	    });
	  }
	  var defineOrOverrideReflectProperty = function (key, shim) {
	    if (!ES.IsCallable(globals.Reflect[key])) {
	      defineProperty(globals.Reflect, key, shim);
	    } else {
	      var acceptsPrimitives = valueOrFalseIfThrows(function () {
	        globals.Reflect[key](1);
	        globals.Reflect[key](NaN);
	        globals.Reflect[key](true);
	        return true;
	      });
	      if (acceptsPrimitives) {
	        overrideNative(globals.Reflect, key, shim);
	      }
	    }
	  };
	  Object.keys(ReflectShims).forEach(function (key) {
	    defineOrOverrideReflectProperty(key, ReflectShims[key]);
	  });
	  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
	  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
	    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
	      return _call(originalReflectGetProto, globals.Reflect, target);
	    });
	  }
	  if (globals.Reflect.setPrototypeOf) {
	    if (valueOrFalseIfThrows(function () {
	      globals.Reflect.setPrototypeOf(1, {});
	      return true;
	    })) {
	      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
	    }
	  }
	  if (globals.Reflect.defineProperty) {
	    if (!valueOrFalseIfThrows(function () {
	      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
	      // "extensible" fails on Edge 0.12
	      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
	      return basic && extensible;
	    })) {
	      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
	    }
	  }
	  if (globals.Reflect.construct) {
	    if (!valueOrFalseIfThrows(function () {
	      var F = function F() {};
	      return globals.Reflect.construct(function () {}, [], F) instanceof F;
	    })) {
	      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
	    }
	  }
	
	  if (String(new Date(NaN)) !== 'Invalid Date') {
	    var dateToString = Date.prototype.toString;
	    var shimmedDateToString = function toString() {
	      var valueOf = +this;
	      if (valueOf !== valueOf) {
	        return 'Invalid Date';
	      }
	      return ES.Call(dateToString, this);
	    };
	    overrideNative(Date.prototype, 'toString', shimmedDateToString);
	  }
	
	  // Annex B HTML methods
	  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
	  var stringHTMLshims = {
	    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
	    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
	    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
	    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
	    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
	    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
	    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
	    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
	    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
	    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
	    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
	    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
	    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
	  };
	  _forEach(Object.keys(stringHTMLshims), function (key) {
	    var method = String.prototype[key];
	    var shouldOverwrite = false;
	    if (ES.IsCallable(method)) {
	      var output = _call(method, '', ' " ');
	      var quotesCount = _concat([], output.match(/"/g)).length;
	      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
	    } else {
	      shouldOverwrite = true;
	    }
	    if (shouldOverwrite) {
	      overrideNative(String.prototype, key, stringHTMLshims[key]);
	    }
	  });
	
	  var JSONstringifiesSymbols = (function () {
	    // Microsoft Edge v0.12 stringifies Symbols incorrectly
	    if (!hasSymbols) { return false; } // Symbols are not supported
	    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
	    if (!stringify) { return false; } // JSON.stringify is not supported
	    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
	    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
	    var obj = { a: Symbol() };
	    obj[Symbol()] = true;
	    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
	    return false;
	  }());
	  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
	    // Chrome 45 throws on stringifying object symbols
	    if (!hasSymbols) { return true; } // Symbols are not supported
	    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
	  });
	  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
	    var origStringify = JSON.stringify;
	    overrideNative(JSON, 'stringify', function stringify(value) {
	      if (typeof value === 'symbol') { return; }
	      var replacer;
	      if (arguments.length > 1) {
	        replacer = arguments[1];
	      }
	      var args = [value];
	      if (!isArray(replacer)) {
	        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
	        var wrappedReplacer = function (key, val) {
	          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
	          if (typeof parsedValue !== 'symbol') {
	            if (Type.symbol(parsedValue)) {
	              return assignTo({})(parsedValue);
	            }
	            return parsedValue;
	
	          }
	        };
	        args.push(wrappedReplacer);
	      } else {
	        // create wrapped replacer that handles an array replacer?
	        args.push(replacer);
	      }
	      if (arguments.length > 2) {
	        args.push(arguments[2]);
	      }
	      return origStringify.apply(this, args);
	    });
	  }
	
	  return globals;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(51)))

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	/*!
	 * FooTable - Awesome Responsive Tables
	 * Version : 2.0.3
	 * http://fooplugins.com/plugins/footable-jquery/
	 *
	 * Requires jQuery - http://jquery.com/
	 *
	 * Copyright 2014 Steven Usher & Brad Vincent
	 * Released under the MIT license
	 * You are free to use FooTable in commercial projects as long as this copyright header is left intact.
	 *
	 * Date: 11 Nov 2014
	 */
	(function(e,t){function a(){var e=this;e.id=null,e.busy=!1,e.start=function(t,a){e.busy||(e.stop(),e.id=setTimeout(function(){t(),e.id=null,e.busy=!1},a),e.busy=!0)},e.stop=function(){null!==e.id&&(clearTimeout(e.id),e.id=null,e.busy=!1)}}function i(i,o,n){var r=this;r.id=n,r.table=i,r.options=o,r.breakpoints=[],r.breakpointNames="",r.columns={},r.plugins=t.footable.plugins.load(r);var l=r.options,d=l.classes,s=l.events,u=l.triggers,f=0;return r.timers={resize:new a,register:function(e){return r.timers[e]=new a,r.timers[e]}},r.init=function(){var a=e(t),i=e(r.table);if(t.footable.plugins.init(r),i.hasClass(d.loaded))return r.raise(s.alreadyInitialized),undefined;r.raise(s.initializing),i.addClass(d.loading),i.find(l.columnDataSelector).each(function(){var e=r.getColumnData(this);r.columns[e.index]=e});for(var o in l.breakpoints)r.breakpoints.push({name:o,width:l.breakpoints[o]}),r.breakpointNames+=o+" ";r.breakpoints.sort(function(e,t){return e.width-t.width}),i.unbind(u.initialize).bind(u.initialize,function(){i.removeData("footable_info"),i.data("breakpoint",""),i.trigger(u.resize),i.removeClass(d.loading),i.addClass(d.loaded).addClass(d.main),r.raise(s.initialized)}).unbind(u.redraw).bind(u.redraw,function(){r.redraw()}).unbind(u.resize).bind(u.resize,function(){r.resize()}).unbind(u.expandFirstRow).bind(u.expandFirstRow,function(){i.find(l.toggleSelector).first().not("."+d.detailShow).trigger(u.toggleRow)}).unbind(u.expandAll).bind(u.expandAll,function(){i.find(l.toggleSelector).not("."+d.detailShow).trigger(u.toggleRow)}).unbind(u.collapseAll).bind(u.collapseAll,function(){i.find("."+d.detailShow).trigger(u.toggleRow)}),i.trigger(u.initialize),a.bind("resize.footable",function(){r.timers.resize.stop(),r.timers.resize.start(function(){r.raise(u.resize)},l.delay)})},r.addRowToggle=function(){if(l.addRowToggle){var t=e(r.table),a=!1;t.find("span."+d.toggle).remove();for(var i in r.columns){var o=r.columns[i];if(o.toggle){a=!0;var n="> tbody > tr:not(."+d.detail+",."+d.disabled+") > td:nth-child("+(parseInt(o.index,10)+1)+"),"+"> tbody > tr:not(."+d.detail+",."+d.disabled+") > th:nth-child("+(parseInt(o.index,10)+1)+")";return t.find(n).not("."+d.detailCell).prepend(e(l.toggleHTMLElement).addClass(d.toggle)),undefined}}a||t.find("> tbody > tr:not(."+d.detail+",."+d.disabled+") > td:first-child").add("> tbody > tr:not(."+d.detail+",."+d.disabled+") > th:first-child").not("."+d.detailCell).prepend(e(l.toggleHTMLElement).addClass(d.toggle))}},r.setColumnClasses=function(){var t=e(r.table);for(var a in r.columns){var i=r.columns[a];if(null!==i.className){var o="",n=!0;e.each(i.matches,function(e,t){n||(o+=", "),o+="> tbody > tr:not(."+d.detail+") > td:nth-child("+(parseInt(t,10)+1)+")",n=!1}),t.find(o).not("."+d.detailCell).addClass(i.className)}}},r.bindToggleSelectors=function(){var t=e(r.table);r.hasAnyBreakpointColumn()&&(t.find(l.toggleSelector).unbind(u.toggleRow).bind(u.toggleRow,function(){var t=e(this).is("tr")?e(this):e(this).parents("tr:first");r.toggleDetail(t)}),t.find(l.toggleSelector).unbind("click.footable").bind("click.footable",function(a){t.is(".breakpoint")&&e(a.target).is("td,th,."+d.toggle)&&e(this).trigger(u.toggleRow)}))},r.parse=function(e,t){var a=l.parsers[t.type]||l.parsers.alpha;return a(e)},r.getColumnData=function(t){var a=e(t),i=a.data("hide"),o=a.index();i=i||"",i=jQuery.map(i.split(","),function(e){return jQuery.trim(e)});var n={index:o,hide:{},type:a.data("type")||"alpha",name:a.data("name")||e.trim(a.text()),ignore:a.data("ignore")||!1,toggle:a.data("toggle")||!1,className:a.data("class")||null,matches:[],names:{},group:a.data("group")||null,groupName:null,isEditable:a.data("editable")};if(null!==n.group){var d=e(r.table).find('> thead > tr.footable-group-row > th[data-group="'+n.group+'"], > thead > tr.footable-group-row > td[data-group="'+n.group+'"]').first();n.groupName=r.parse(d,{type:"alpha"})}var u=parseInt(a.prev().attr("colspan")||0,10);f+=u>1?u-1:0;var p=parseInt(a.attr("colspan")||0,10),c=n.index+f;if(p>1){var b=a.data("names");b=b||"",b=b.split(",");for(var g=0;p>g;g++)n.matches.push(g+c),b.length>g&&(n.names[g+c]=b[g])}else n.matches.push(c);n.hide["default"]="all"===a.data("hide")||e.inArray("default",i)>=0;var h=!1;for(var m in l.breakpoints)n.hide[m]="all"===a.data("hide")||e.inArray(m,i)>=0,h=h||n.hide[m];n.hasBreakpoint=h;var v=r.raise(s.columnData,{column:{data:n,th:t}});return v.column.data},r.getViewportWidth=function(){return window.innerWidth||(document.body?document.body.offsetWidth:0)},r.calculateWidth=function(e,t){return jQuery.isFunction(l.calculateWidthOverride)?l.calculateWidthOverride(e,t):(t.viewportWidth<t.width&&(t.width=t.viewportWidth),t.parentWidth<t.width&&(t.width=t.parentWidth),t)},r.hasBreakpointColumn=function(e){for(var t in r.columns)if(r.columns[t].hide[e]){if(r.columns[t].ignore)continue;return!0}return!1},r.hasAnyBreakpointColumn=function(){for(var e in r.columns)if(r.columns[e].hasBreakpoint)return!0;return!1},r.resize=function(){var t=e(r.table);if(t.is(":visible")){if(!r.hasAnyBreakpointColumn())return t.trigger(u.redraw),undefined;var a={width:t.width(),viewportWidth:r.getViewportWidth(),parentWidth:t.parent().width()};a=r.calculateWidth(t,a);var i=t.data("footable_info");if(t.data("footable_info",a),r.raise(s.resizing,{old:i,info:a}),!i||i&&i.width&&i.width!==a.width){for(var o,n=null,l=0;r.breakpoints.length>l;l++)if(o=r.breakpoints[l],o&&o.width&&a.width<=o.width){n=o;break}var d=null===n?"default":n.name,f=r.hasBreakpointColumn(d),p=t.data("breakpoint");t.data("breakpoint",d).removeClass("default breakpoint").removeClass(r.breakpointNames).addClass(d+(f?" breakpoint":"")),d!==p&&(t.trigger(u.redraw),r.raise(s.breakpoint,{breakpoint:d,info:a}))}r.raise(s.resized,{old:i,info:a})}},r.redraw=function(){r.addRowToggle(),r.bindToggleSelectors(),r.setColumnClasses();var t=e(r.table),a=t.data("breakpoint"),i=r.hasBreakpointColumn(a);t.find("> tbody > tr:not(."+d.detail+")").data("detail_created",!1).end().find("> thead > tr:last-child > th").each(function(){var i=r.columns[e(this).index()],o="",n=!0;e.each(i.matches,function(e,t){n||(o+=", ");var a=t+1;o+="> tbody > tr:not(."+d.detail+") > td:nth-child("+a+")",o+=", > tfoot > tr:not(."+d.detail+") > td:nth-child("+a+")",o+=", > colgroup > col:nth-child("+a+")",n=!1}),o+=', > thead > tr[data-group-row="true"] > th[data-group="'+i.group+'"]';var l=t.find(o).add(this);if(""!==a&&(i.hide[a]===!1?l.addClass("footable-visible").show():l.removeClass("footable-visible").hide()),1===t.find("> thead > tr.footable-group-row").length){var s=t.find('> thead > tr:last-child > th[data-group="'+i.group+'"]:visible, > thead > tr:last-child > th[data-group="'+i.group+'"]:visible'),u=t.find('> thead > tr.footable-group-row > th[data-group="'+i.group+'"], > thead > tr.footable-group-row > td[data-group="'+i.group+'"]'),f=0;e.each(s,function(){f+=parseInt(e(this).attr("colspan")||1,10)}),f>0?u.attr("colspan",f).show():u.hide()}}).end().find("> tbody > tr."+d.detailShow).each(function(){r.createOrUpdateDetailRow(this)}),t.find("[data-bind-name]").each(function(){r.toggleInput(this)}),t.find("> tbody > tr."+d.detailShow+":visible").each(function(){var t=e(this).next();t.hasClass(d.detail)&&(i?t.show():t.hide())}),t.find("> thead > tr > th.footable-last-column, > tbody > tr > td.footable-last-column").removeClass("footable-last-column"),t.find("> thead > tr > th.footable-first-column, > tbody > tr > td.footable-first-column").removeClass("footable-first-column"),t.find("> thead > tr, > tbody > tr").find("> th.footable-visible:last, > td.footable-visible:last").addClass("footable-last-column").end().find("> th.footable-visible:first, > td.footable-visible:first").addClass("footable-first-column"),r.raise(s.redrawn)},r.toggleDetail=function(t){var a=t.jquery?t:e(t),i=a.next();a.hasClass(d.detailShow)?(a.removeClass(d.detailShow),i.hasClass(d.detail)&&i.hide(),r.raise(s.rowCollapsed,{row:a[0]})):(r.createOrUpdateDetailRow(a[0]),a.addClass(d.detailShow).next().show(),r.raise(s.rowExpanded,{row:a[0]}))},r.removeRow=function(t){var a=t.jquery?t:e(t);a.hasClass(d.detail)&&(a=a.prev());var i=a.next();a.data("detail_created")===!0&&i.remove(),a.remove(),r.raise(s.rowRemoved)},r.appendRow=function(t){var a=t.jquery?t:e(t);e(r.table).find("tbody").append(a),r.redraw()},r.getColumnFromTdIndex=function(t){var a=null;for(var i in r.columns)if(e.inArray(t,r.columns[i].matches)>=0){a=r.columns[i];break}return a},r.createOrUpdateDetailRow=function(t){var a,i=e(t),o=i.next(),n=[];if(i.data("detail_created")===!0)return!0;if(i.is(":hidden"))return!1;if(r.raise(s.rowDetailUpdating,{row:i,detail:o}),i.find("> td:hidden").each(function(){var t=e(this).index(),a=r.getColumnFromTdIndex(t),i=a.name;if(a.ignore===!0)return!0;t in a.names&&(i=a.names[t]);var o=e(this).attr("data-bind-name");if(null!=o&&e(this).is(":empty")){var l=e("."+d.detailInnerValue+"["+'data-bind-value="'+o+'"]');e(this).html(e(l).contents().detach())}var s;return a.isEditable!==!1&&(a.isEditable||e(this).find(":input").length>0)&&(null==o&&(o="bind-"+e.now()+"-"+t,e(this).attr("data-bind-name",o)),s=e(this).contents().detach()),s||(s=e(this).contents().clone(!0,!0)),n.push({name:i,value:r.parse(this,a),display:s,group:a.group,groupName:a.groupName,bindName:o}),!0}),0===n.length)return!1;var u=i.find("> td:visible").length,f=o.hasClass(d.detail);return f||(o=e('<tr class="'+d.detail+'"><td class="'+d.detailCell+'"><div class="'+d.detailInner+'"></div></td></tr>'),i.after(o)),o.find("> td:first").attr("colspan",u),a=o.find("."+d.detailInner).empty(),l.createDetail(a,n,l.createGroupedDetail,l.detailSeparator,d),i.data("detail_created",!0),r.raise(s.rowDetailUpdated,{row:i,detail:o}),!f},r.raise=function(t,a){r.options.debug===!0&&e.isFunction(r.options.log)&&r.options.log(t,"event"),a=a||{};var i={ft:r};e.extend(!0,i,a);var o=e.Event(t,i);return o.ft||e.extend(!0,o,i),e(r.table).trigger(o),o},r.reset=function(){var t=e(r.table);t.removeData("footable_info").data("breakpoint","").removeClass(d.loading).removeClass(d.loaded),t.find(l.toggleSelector).unbind(u.toggleRow).unbind("click.footable"),t.find("> tbody > tr").removeClass(d.detailShow),t.find("> tbody > tr."+d.detail).remove(),r.raise(s.reset)},r.toggleInput=function(t){var a=e(t).attr("data-bind-name");if(null!=a){var i=e("."+d.detailInnerValue+"["+'data-bind-value="'+a+'"]');null!=i&&(e(t).is(":visible")?e(i).is(":empty")||e(t).html(e(i).contents().detach()):e(t).is(":empty")||e(i).html(e(t).contents().detach()))}},r.init(),r}t.footable={options:{delay:100,breakpoints:{phone:480,tablet:1024},parsers:{alpha:function(t){return e(t).data("value")||e.trim(e(t).text())},numeric:function(t){var a=e(t).data("value")||e(t).text().replace(/[^0-9.\-]/g,"");return a=parseFloat(a),isNaN(a)&&(a=0),a}},addRowToggle:!0,calculateWidthOverride:null,toggleSelector:" > tbody > tr:not(.footable-row-detail)",columnDataSelector:"> thead > tr:last-child > th, > thead > tr:last-child > td",detailSeparator:":",toggleHTMLElement:"<span />",createGroupedDetail:function(e){for(var t={_none:{name:null,data:[]}},a=0;e.length>a;a++){var i=e[a].group;null!==i?(i in t||(t[i]={name:e[a].groupName||e[a].group,data:[]}),t[i].data.push(e[a])):t._none.data.push(e[a])}return t},createDetail:function(t,a,i,o,n){var r=i(a);for(var l in r)if(0!==r[l].data.length){"_none"!==l&&t.append('<div class="'+n.detailInnerGroup+'">'+r[l].name+"</div>");for(var d=0;r[l].data.length>d;d++){var s=r[l].data[d].name?o:"";t.append(e("<div></div>").addClass(n.detailInnerRow).append(e("<div></div>").addClass(n.detailInnerName).append(r[l].data[d].name+s)).append(e("<div></div>").addClass(n.detailInnerValue).attr("data-bind-value",r[l].data[d].bindName).append(r[l].data[d].display)))}}},classes:{main:"footable",loading:"footable-loading",loaded:"footable-loaded",toggle:"footable-toggle",disabled:"footable-disabled",detail:"footable-row-detail",detailCell:"footable-row-detail-cell",detailInner:"footable-row-detail-inner",detailInnerRow:"footable-row-detail-row",detailInnerGroup:"footable-row-detail-group",detailInnerName:"footable-row-detail-name",detailInnerValue:"footable-row-detail-value",detailShow:"footable-detail-show"},triggers:{initialize:"footable_initialize",resize:"footable_resize",redraw:"footable_redraw",toggleRow:"footable_toggle_row",expandFirstRow:"footable_expand_first_row",expandAll:"footable_expand_all",collapseAll:"footable_collapse_all"},events:{alreadyInitialized:"footable_already_initialized",initializing:"footable_initializing",initialized:"footable_initialized",resizing:"footable_resizing",resized:"footable_resized",redrawn:"footable_redrawn",breakpoint:"footable_breakpoint",columnData:"footable_column_data",rowDetailUpdating:"footable_row_detail_updating",rowDetailUpdated:"footable_row_detail_updated",rowCollapsed:"footable_row_collapsed",rowExpanded:"footable_row_expanded",rowRemoved:"footable_row_removed",reset:"footable_reset"},debug:!1,log:null},version:{major:0,minor:5,toString:function(){return t.footable.version.major+"."+t.footable.version.minor},parse:function(e){var t=/(\d+)\.?(\d+)?\.?(\d+)?/.exec(e);return{major:parseInt(t[1],10)||0,minor:parseInt(t[2],10)||0,patch:parseInt(t[3],10)||0}}},plugins:{_validate:function(a){if(!e.isFunction(a))return t.footable.options.debug===!0&&console.error('Validation failed, expected type "function", received type "{0}".',typeof a),!1;var i=new a;return"string"!=typeof i.name?(t.footable.options.debug===!0&&console.error('Validation failed, plugin does not implement a string property called "name".',i),!1):e.isFunction(i.init)?(t.footable.options.debug===!0&&console.log('Validation succeeded for plugin "'+i.name+'".',i),!0):(t.footable.options.debug===!0&&console.error('Validation failed, plugin "'+i.name+'" does not implement a function called "init".',i),!1)},registered:[],register:function(a,i){t.footable.plugins._validate(a)&&(t.footable.plugins.registered.push(a),"object"==typeof i&&e.extend(!0,t.footable.options,i))},load:function(e){var a,i,o=[];for(i=0;t.footable.plugins.registered.length>i;i++)try{a=t.footable.plugins.registered[i],o.push(new a(e))}catch(n){t.footable.options.debug===!0&&console.error(n)}return o},init:function(e){for(var a=0;e.plugins.length>a;a++)try{e.plugins[a].init(e)}catch(i){t.footable.options.debug===!0&&console.error(i)}}}};var o=0;e.fn.footable=function(a){a=a||{};var n=e.extend(!0,{},t.footable.options,a);return this.each(function(){o++;var t=new i(this,n,o);e(this).data("footable",t)})}})(jQuery,window);

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	var test = {
		__proto__: null,
		foo: {}
	};
	
	var $Object = Object;
	
	/** @type {import('.')} */
	module.exports = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(80);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(49);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ
	
	// @ts-check
	
	/**
	 * @typedef {string | ((unitCount: number) => string)} Unit
	 */
	
	/**
	 * @typedef {("y" | "mo" | "w" | "d" | "h" | "m" | "s" | "ms")} UnitName
	 */
	
	/**
	 * @typedef {Object} UnitMeasures
	 * @prop {number} y
	 * @prop {number} mo
	 * @prop {number} w
	 * @prop {number} d
	 * @prop {number} h
	 * @prop {number} m
	 * @prop {number} s
	 * @prop {number} ms
	 */
	
	/**
	 * @typedef {Record<"0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9", string>} DigitReplacements
	 */
	
	/**
	 * @typedef {Object} Language
	 * @prop {Unit} y
	 * @prop {Unit} mo
	 * @prop {Unit} w
	 * @prop {Unit} d
	 * @prop {Unit} h
	 * @prop {Unit} m
	 * @prop {Unit} s
	 * @prop {Unit} ms
	 * @prop {string} [decimal]
	 * @prop {string} [delimiter]
	 * @prop {DigitReplacements} [_digitReplacements]
	 * @prop {boolean} [_numberFirst]
	 */
	
	/**
	 * @typedef {Object} Options
	 * @prop {string} [language]
	 * @prop {Record<string, Language>} [languages]
	 * @prop {string[]} [fallbacks]
	 * @prop {string} [delimiter]
	 * @prop {string} [spacer]
	 * @prop {boolean} [round]
	 * @prop {number} [largest]
	 * @prop {UnitName[]} [units]
	 * @prop {string} [decimal]
	 * @prop {string} [conjunction]
	 * @prop {number} [maxDecimalPoints]
	 * @prop {UnitMeasures} [unitMeasures]
	 * @prop {boolean} [serialComma]
	 * @prop {DigitReplacements} [digitReplacements]
	 */
	
	/**
	 * @typedef {Required<Options>} NormalizedOptions
	 */
	
	(function () {
	  // This has to be defined separately because of a bug: we want to alias
	  // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
	  // remove `gr` entirely.
	  // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
	  var GREEK = language(
	    function (c) {
	      return c === 1 ? "χρόνος" : "χρόνια";
	    },
	    function (c) {
	      return c === 1 ? "μήνας" : "μήνες";
	    },
	    function (c) {
	      return c === 1 ? "εβδομάδα" : "εβδομάδες";
	    },
	    function (c) {
	      return c === 1 ? "μέρα" : "μέρες";
	    },
	    function (c) {
	      return c === 1 ? "ώρα" : "ώρες";
	    },
	    function (c) {
	      return c === 1 ? "λεπτό" : "λεπτά";
	    },
	    function (c) {
	      return c === 1 ? "δευτερόλεπτο" : "δευτερόλεπτα";
	    },
	    function (c) {
	      return (c === 1 ? "χιλιοστό" : "χιλιοστά") + " του δευτερολέπτου";
	    },
	    ","
	  );
	
	  /** @type {Record<string, Language>} */
	  var LANGUAGES = {
	    af: language(
	      "jaar",
	      function (c) {
	        return "maand" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return c === 1 ? "week" : "weke";
	      },
	      function (c) {
	        return c === 1 ? "dag" : "dae";
	      },
	      function (c) {
	        return c === 1 ? "uur" : "ure";
	      },
	      function (c) {
	        return c === 1 ? "minuut" : "minute";
	      },
	      function (c) {
	        return "sekonde" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "millisekonde" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    ar: assign(
	      language(
	        function (c) {
	          return ["سنة", "سنتان", "سنوات"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["شهر", "شهران", "أشهر"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["أسبوع", "أسبوعين", "أسابيع"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["يوم", "يومين", "أيام"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["ساعة", "ساعتين", "ساعات"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["دقيقة", "دقيقتان", "دقائق"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["ثانية", "ثانيتان", "ثواني"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["جزء من الثانية", "جزآن من الثانية", "أجزاء من الثانية"][
	            getArabicForm(c)
	          ];
	        },
	        ","
	      ),
	      {
	        delimiter: " ﻭ ",
	        _digitReplacements: ["۰", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"]
	      }
	    ),
	    bg: language(
	      function (c) {
	        return ["години", "година", "години"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месеца", "месец", "месеца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["седмици", "седмица", "седмици"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дни", "ден", "дни"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["часа", "час", "часа"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минути", "минута", "минути"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунди", "секунда", "секунди"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["милисекунди", "милисекунда", "милисекунди"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    bn: language(
	      "বছর",
	      "মাস",
	      "সপ্তাহ",
	      "দিন",
	      "ঘন্টা",
	      "মিনিট",
	      "সেকেন্ড",
	      "মিলিসেকেন্ড"
	    ),
	    ca: language(
	      function (c) {
	        return "any" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "" : "os");
	      },
	      function (c) {
	        return "setman" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "di" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "hor" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segon" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milisegon" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    ckb: language(
	      "ساڵ",
	      "مانگ",
	      "هەفتە",
	      "ڕۆژ",
	      "کاژێر",
	      "خولەک",
	      "چرکە",
	      "میلی چرکە",
	      "."
	    ),
	    cs: language(
	      function (c) {
	        return ["rok", "roku", "roky", "let"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["měsíc", "měsíce", "měsíce", "měsíců"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["týden", "týdne", "týdny", "týdnů"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["den", "dne", "dny", "dní"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["hodina", "hodiny", "hodiny", "hodin"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["minuta", "minuty", "minuty", "minut"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekund"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      ","
	    ),
	    cy: language(
	      "flwyddyn",
	      "mis",
	      "wythnos",
	      "diwrnod",
	      "awr",
	      "munud",
	      "eiliad",
	      "milieiliad"
	    ),
	    da: language(
	      "år",
	      function (c) {
	        return "måned" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "uge" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "time" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "ter");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    de: language(
	      function (c) {
	        return "Jahr" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Monat" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Woche" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Tag" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Stunde" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Minute" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Sekunde" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Millisekunde" + (c === 1 ? "" : "n");
	      },
	      ","
	    ),
	    el: GREEK,
	    en: language(
	      function (c) {
	        return "year" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "month" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "week" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "day" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hour" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minute" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "second" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "millisecond" + (c === 1 ? "" : "s");
	      }
	    ),
	    eo: language(
	      function (c) {
	        return "jaro" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "monato" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "semajno" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "tago" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "horo" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "sekundo" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "milisekundo" + (c === 1 ? "" : "j");
	      },
	      ","
	    ),
	    es: language(
	      function (c) {
	        return "año" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "" : "es");
	      },
	      function (c) {
	        return "semana" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "día" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hora" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segundo" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milisegundo" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    et: language(
	      function (c) {
	        return "aasta" + (c === 1 ? "" : "t");
	      },
	      function (c) {
	        return "kuu" + (c === 1 ? "" : "d");
	      },
	      function (c) {
	        return "nädal" + (c === 1 ? "" : "at");
	      },
	      function (c) {
	        return "päev" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "tund" + (c === 1 ? "" : "i");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "it");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "it");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "it");
	      },
	      ","
	    ),
	    eu: language(
	      "urte",
	      "hilabete",
	      "aste",
	      "egun",
	      "ordu",
	      "minutu",
	      "segundo",
	      "milisegundo",
	      ","
	    ),
	    fa: language(
	      "سال",
	      "ماه",
	      "هفته",
	      "روز",
	      "ساعت",
	      "دقیقه",
	      "ثانیه",
	      "میلی ثانیه"
	    ),
	    fi: language(
	      function (c) {
	        return c === 1 ? "vuosi" : "vuotta";
	      },
	      function (c) {
	        return c === 1 ? "kuukausi" : "kuukautta";
	      },
	      function (c) {
	        return "viikko" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "päivä" + (c === 1 ? "" : "ä");
	      },
	      function (c) {
	        return "tunti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "minuutti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "sekunti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "millisekunti" + (c === 1 ? "" : "a");
	      },
	      ","
	    ),
	    fo: language(
	      "ár",
	      function (c) {
	        return c === 1 ? "mánaður" : "mánaðir";
	      },
	      function (c) {
	        return c === 1 ? "vika" : "vikur";
	      },
	      function (c) {
	        return c === 1 ? "dagur" : "dagar";
	      },
	      function (c) {
	        return c === 1 ? "tími" : "tímar";
	      },
	      function (c) {
	        return c === 1 ? "minuttur" : "minuttir";
	      },
	      "sekund",
	      "millisekund",
	      ","
	    ),
	    fr: language(
	      function (c) {
	        return "an" + (c >= 2 ? "s" : "");
	      },
	      "mois",
	      function (c) {
	        return "semaine" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "jour" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "heure" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "minute" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "seconde" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "milliseconde" + (c >= 2 ? "s" : "");
	      },
	      ","
	    ),
	    gr: GREEK,
	    he: language(
	      function (c) {
	        return c === 1 ? "שנה" : "שנים";
	      },
	      function (c) {
	        return c === 1 ? "חודש" : "חודשים";
	      },
	      function (c) {
	        return c === 1 ? "שבוע" : "שבועות";
	      },
	      function (c) {
	        return c === 1 ? "יום" : "ימים";
	      },
	      function (c) {
	        return c === 1 ? "שעה" : "שעות";
	      },
	      function (c) {
	        return c === 1 ? "דקה" : "דקות";
	      },
	      function (c) {
	        return c === 1 ? "שניה" : "שניות";
	      },
	      function (c) {
	        return c === 1 ? "מילישנייה" : "מילישניות";
	      }
	    ),
	    hr: language(
	      function (c) {
	        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
	          return "godine";
	        }
	        return "godina";
	      },
	      function (c) {
	        if (c === 1) {
	          return "mjesec";
	        } else if (c === 2 || c === 3 || c === 4) {
	          return "mjeseca";
	        }
	        return "mjeseci";
	      },
	      function (c) {
	        if (c % 10 === 1 && c !== 11) {
	          return "tjedan";
	        }
	        return "tjedna";
	      },
	      function (c) {
	        return c === 1 ? "dan" : "dana";
	      },
	      function (c) {
	        if (c === 1) {
	          return "sat";
	        } else if (c === 2 || c === 3 || c === 4) {
	          return "sata";
	        }
	        return "sati";
	      },
	      function (c) {
	        var mod10 = c % 10;
	        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
	          return "minute";
	        }
	        return "minuta";
	      },
	      function (c) {
	        var mod10 = c % 10;
	        if (mod10 === 5 || (Math.floor(c) === c && c >= 10 && c <= 19)) {
	          return "sekundi";
	        } else if (mod10 === 1) {
	          return "sekunda";
	        } else if (mod10 === 2 || mod10 === 3 || mod10 === 4) {
	          return "sekunde";
	        }
	        return "sekundi";
	      },
	      function (c) {
	        if (c === 1) {
	          return "milisekunda";
	        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
	          return "milisekunde";
	        }
	        return "milisekundi";
	      },
	      ","
	    ),
	    hi: language(
	      "साल",
	      function (c) {
	        return c === 1 ? "महीना" : "महीने";
	      },
	      function (c) {
	        return c === 1 ? "हफ़्ता" : "हफ्ते";
	      },
	      "दिन",
	      function (c) {
	        return c === 1 ? "घंटा" : "घंटे";
	      },
	      "मिनट",
	      "सेकंड",
	      "मिलीसेकंड"
	    ),
	    hu: language(
	      "év",
	      "hónap",
	      "hét",
	      "nap",
	      "óra",
	      "perc",
	      "másodperc",
	      "ezredmásodperc",
	      ","
	    ),
	    id: language(
	      "tahun",
	      "bulan",
	      "minggu",
	      "hari",
	      "jam",
	      "menit",
	      "detik",
	      "milidetik"
	    ),
	    is: language(
	      "ár",
	      function (c) {
	        return "mánuð" + (c === 1 ? "ur" : "ir");
	      },
	      function (c) {
	        return "vik" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "ur" : "ar");
	      },
	      function (c) {
	        return "klukkutím" + (c === 1 ? "i" : "ar");
	      },
	      function (c) {
	        return "mínút" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "sekúnd" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "millisekúnd" + (c === 1 ? "a" : "ur");
	      }
	    ),
	    it: language(
	      function (c) {
	        return "ann" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "e" : "i");
	      },
	      function (c) {
	        return "settiman" + (c === 1 ? "a" : "e");
	      },
	      function (c) {
	        return "giorn" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "or" + (c === 1 ? "a" : "e");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "second" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "millisecond" + (c === 1 ? "o" : "i");
	      },
	      ","
	    ),
	    ja: language("年", "ヶ月", "週", "日", "時間", "分", "秒", "ミリ秒"),
	    km: language(
	      "ឆ្នាំ",
	      "ខែ",
	      "សប្តាហ៍",
	      "ថ្ងៃ",
	      "ម៉ោង",
	      "នាទី",
	      "វិនាទី",
	      "មិល្លីវិនាទី"
	    ),
	    kn: language(
	      function (c) {
	        return c === 1 ? "ವರ್ಷ" : "ವರ್ಷಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ತಿಂಗಳು" : "ತಿಂಗಳುಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ವಾರ" : "ವಾರಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ದಿನ" : "ದಿನಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಗಂಟೆ" : "ಗಂಟೆಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ನಿಮಿಷ" : "ನಿಮಿಷಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಸೆಕೆಂಡ್" : "ಸೆಕೆಂಡುಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಮಿಲಿಸೆಕೆಂಡ್" : "ಮಿಲಿಸೆಕೆಂಡುಗಳು";
	      }
	    ),
	    ko: language("년", "개월", "주일", "일", "시간", "분", "초", "밀리 초"),
	    ku: language(
	      "sal",
	      "meh",
	      "hefte",
	      "roj",
	      "seet",
	      "deqe",
	      "saniye",
	      "mîlîçirk",
	      ","
	    ),
	    lo: language(
	      "ປີ",
	      "ເດືອນ",
	      "ອາທິດ",
	      "ມື້",
	      "ຊົ່ວໂມງ",
	      "ນາທີ",
	      "ວິນາທີ",
	      "ມິນລິວິນາທີ",
	      ","
	    ),
	    lt: language(
	      function (c) {
	        return c % 10 === 0 || (c % 100 >= 10 && c % 100 <= 20)
	          ? "metų"
	          : "metai";
	      },
	      function (c) {
	        return ["mėnuo", "mėnesiai", "mėnesių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["savaitė", "savaitės", "savaičių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["diena", "dienos", "dienų"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["valanda", "valandos", "valandų"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["minutė", "minutės", "minučių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["sekundė", "sekundės", "sekundžių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["milisekundė", "milisekundės", "milisekundžių"][
	          getLithuanianForm(c)
	        ];
	      },
	      ","
	    ),
	    lv: language(
	      function (c) {
	        return getLatvianForm(c) ? "gads" : "gadi";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "mēnesis" : "mēneši";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "nedēļa" : "nedēļas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "diena" : "dienas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "stunda" : "stundas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "minūte" : "minūtes";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "sekunde" : "sekundes";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "milisekunde" : "milisekundes";
	      },
	      ","
	    ),
	    mk: language(
	      function (c) {
	        return c === 1 ? "година" : "години";
	      },
	      function (c) {
	        return c === 1 ? "месец" : "месеци";
	      },
	      function (c) {
	        return c === 1 ? "недела" : "недели";
	      },
	      function (c) {
	        return c === 1 ? "ден" : "дена";
	      },
	      function (c) {
	        return c === 1 ? "час" : "часа";
	      },
	      function (c) {
	        return c === 1 ? "минута" : "минути";
	      },
	      function (c) {
	        return c === 1 ? "секунда" : "секунди";
	      },
	      function (c) {
	        return c === 1 ? "милисекунда" : "милисекунди";
	      },
	      ","
	    ),
	    mn: language(
	      "жил",
	      "сар",
	      "долоо хоног",
	      "өдөр",
	      "цаг",
	      "минут",
	      "секунд",
	      "миллисекунд"
	    ),
	    mr: language(
	      function (c) {
	        return c === 1 ? "वर्ष" : "वर्षे";
	      },
	      function (c) {
	        return c === 1 ? "महिना" : "महिने";
	      },
	      function (c) {
	        return c === 1 ? "आठवडा" : "आठवडे";
	      },
	      "दिवस",
	      "तास",
	      function (c) {
	        return c === 1 ? "मिनिट" : "मिनिटे";
	      },
	      "सेकंद",
	      "मिलिसेकंद"
	    ),
	    ms: language(
	      "tahun",
	      "bulan",
	      "minggu",
	      "hari",
	      "jam",
	      "minit",
	      "saat",
	      "milisaat"
	    ),
	    nl: language(
	      "jaar",
	      function (c) {
	        return c === 1 ? "maand" : "maanden";
	      },
	      function (c) {
	        return c === 1 ? "week" : "weken";
	      },
	      function (c) {
	        return c === 1 ? "dag" : "dagen";
	      },
	      "uur",
	      function (c) {
	        return c === 1 ? "minuut" : "minuten";
	      },
	      function (c) {
	        return c === 1 ? "seconde" : "seconden";
	      },
	      function (c) {
	        return c === 1 ? "milliseconde" : "milliseconden";
	      },
	      ","
	    ),
	    no: language(
	      "år",
	      function (c) {
	        return "måned" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "uke" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "time" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "minutt" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    pl: language(
	      function (c) {
	        return ["rok", "roku", "lata", "lat"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["miesiąc", "miesiąca", "miesiące", "miesięcy"][
	          getPolishForm(c)
	        ];
	      },
	      function (c) {
	        return ["tydzień", "tygodnia", "tygodnie", "tygodni"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["dzień", "dnia", "dni", "dni"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["godzina", "godziny", "godziny", "godzin"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["minuta", "minuty", "minuty", "minut"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekund"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
	          getPolishForm(c)
	        ];
	      },
	      ","
	    ),
	    pt: language(
	      function (c) {
	        return "ano" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return c === 1 ? "mês" : "meses";
	      },
	      function (c) {
	        return "semana" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "dia" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hora" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segundo" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milissegundo" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    ro: language(
	      function (c) {
	        return c === 1 ? "an" : "ani";
	      },
	      function (c) {
	        return c === 1 ? "lună" : "luni";
	      },
	      function (c) {
	        return c === 1 ? "săptămână" : "săptămâni";
	      },
	      function (c) {
	        return c === 1 ? "zi" : "zile";
	      },
	      function (c) {
	        return c === 1 ? "oră" : "ore";
	      },
	      function (c) {
	        return c === 1 ? "minut" : "minute";
	      },
	      function (c) {
	        return c === 1 ? "secundă" : "secunde";
	      },
	      function (c) {
	        return c === 1 ? "milisecundă" : "milisecunde";
	      },
	      ","
	    ),
	    ru: language(
	      function (c) {
	        return ["лет", "год", "года"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месяцев", "месяц", "месяца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["недель", "неделя", "недели"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дней", "день", "дня"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["часов", "час", "часа"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минут", "минута", "минуты"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунд", "секунда", "секунды"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["миллисекунд", "миллисекунда", "миллисекунды"][
	          getSlavicForm(c)
	        ];
	      },
	      ","
	    ),
	    sq: language(
	      function (c) {
	        return c === 1 ? "vit" : "vjet";
	      },
	      "muaj",
	      "javë",
	      "ditë",
	      "orë",
	      function (c) {
	        return "minut" + (c === 1 ? "ë" : "a");
	      },
	      function (c) {
	        return "sekond" + (c === 1 ? "ë" : "a");
	      },
	      function (c) {
	        return "milisekond" + (c === 1 ? "ë" : "a");
	      },
	      ","
	    ),
	    sr: language(
	      function (c) {
	        return ["години", "година", "године"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месеци", "месец", "месеца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["недељи", "недеља", "недеље"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дани", "дан", "дана"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["сати", "сат", "сата"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минута", "минут", "минута"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунди", "секунда", "секунде"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["милисекунди", "милисекунда", "милисекунде"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    ta: language(
	      function (c) {
	        return c === 1 ? "வருடம்" : "ஆண்டுகள்";
	      },
	      function (c) {
	        return c === 1 ? "மாதம்" : "மாதங்கள்";
	      },
	      function (c) {
	        return c === 1 ? "வாரம்" : "வாரங்கள்";
	      },
	      function (c) {
	        return c === 1 ? "நாள்" : "நாட்கள்";
	      },
	      function (c) {
	        return c === 1 ? "மணி" : "மணிநேரம்";
	      },
	      function (c) {
	        return "நிமிட" + (c === 1 ? "ம்" : "ங்கள்");
	      },
	      function (c) {
	        return "வினாடி" + (c === 1 ? "" : "கள்");
	      },
	      function (c) {
	        return "மில்லி விநாடி" + (c === 1 ? "" : "கள்");
	      }
	    ),
	    te: language(
	      function (c) {
	        return "సంవత్స" + (c === 1 ? "రం" : "రాల");
	      },
	      function (c) {
	        return "నెల" + (c === 1 ? "" : "ల");
	      },
	      function (c) {
	        return c === 1 ? "వారం" : "వారాలు";
	      },
	      function (c) {
	        return "రోజు" + (c === 1 ? "" : "లు");
	      },
	      function (c) {
	        return "గంట" + (c === 1 ? "" : "లు");
	      },
	      function (c) {
	        return c === 1 ? "నిమిషం" : "నిమిషాలు";
	      },
	      function (c) {
	        return c === 1 ? "సెకను" : "సెకన్లు";
	      },
	      function (c) {
	        return c === 1 ? "మిల్లీసెకన్" : "మిల్లీసెకన్లు";
	      }
	    ),
	    uk: language(
	      function (c) {
	        return ["років", "рік", "роки"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["місяців", "місяць", "місяці"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["тижнів", "тиждень", "тижні"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["днів", "день", "дні"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["годин", "година", "години"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["хвилин", "хвилина", "хвилини"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунд", "секунда", "секунди"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["мілісекунд", "мілісекунда", "мілісекунди"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    ur: language(
	      "سال",
	      function (c) {
	        return c === 1 ? "مہینہ" : "مہینے";
	      },
	      function (c) {
	        return c === 1 ? "ہفتہ" : "ہفتے";
	      },
	      "دن",
	      function (c) {
	        return c === 1 ? "گھنٹہ" : "گھنٹے";
	      },
	      "منٹ",
	      "سیکنڈ",
	      "ملی سیکنڈ"
	    ),
	    sk: language(
	      function (c) {
	        return ["rok", "roky", "roky", "rokov"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["mesiac", "mesiace", "mesiace", "mesiacov"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["týždeň", "týždne", "týždne", "týždňov"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["deň", "dni", "dni", "dní"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["hodina", "hodiny", "hodiny", "hodín"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["minúta", "minúty", "minúty", "minút"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekúnd"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekúnd"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      ","
	    ),
	    sl: language(
	      function (c) {
	        if (c % 10 === 1) {
	          return "leto";
	        } else if (c % 100 === 2) {
	          return "leti";
	        } else if (
	          c % 100 === 3 ||
	          c % 100 === 4 ||
	          (Math.floor(c) !== c && c % 100 <= 5)
	        ) {
	          return "leta";
	        } else {
	          return "let";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "mesec";
	        } else if (c % 100 === 2 || (Math.floor(c) !== c && c % 100 <= 5)) {
	          return "meseca";
	        } else if (c % 10 === 3 || c % 10 === 4) {
	          return "mesece";
	        } else {
	          return "mesecev";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "teden";
	        } else if (c % 10 === 2 || (Math.floor(c) !== c && c % 100 <= 4)) {
	          return "tedna";
	        } else if (c % 10 === 3 || c % 10 === 4) {
	          return "tedne";
	        } else {
	          return "tednov";
	        }
	      },
	      function (c) {
	        return c % 100 === 1 ? "dan" : "dni";
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "ura";
	        } else if (c % 100 === 2) {
	          return "uri";
	        } else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c) {
	          return "ure";
	        } else {
	          return "ur";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "minuta";
	        } else if (c % 10 === 2) {
	          return "minuti";
	        } else if (
	          c % 10 === 3 ||
	          c % 10 === 4 ||
	          (Math.floor(c) !== c && c % 100 <= 4)
	        ) {
	          return "minute";
	        } else {
	          return "minut";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "sekunda";
	        } else if (c % 100 === 2) {
	          return "sekundi";
	        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
	          return "sekunde";
	        } else {
	          return "sekund";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "milisekunda";
	        } else if (c % 100 === 2) {
	          return "milisekundi";
	        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
	          return "milisekunde";
	        } else {
	          return "milisekund";
	        }
	      },
	      ","
	    ),
	    sv: language(
	      "år",
	      function (c) {
	        return "månad" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "veck" + (c === 1 ? "a" : "or");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "ar");
	      },
	      function (c) {
	        return "timm" + (c === 1 ? "e" : "ar");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    sw: assign(
	      language(
	        function (c) {
	          return c === 1 ? "mwaka" : "miaka";
	        },
	        function (c) {
	          return c === 1 ? "mwezi" : "miezi";
	        },
	        "wiki",
	        function (c) {
	          return c === 1 ? "siku" : "masiku";
	        },
	        function (c) {
	          return c === 1 ? "saa" : "masaa";
	        },
	        "dakika",
	        "sekunde",
	        "milisekunde"
	      ),
	      { _numberFirst: true }
	    ),
	    tr: language(
	      "yıl",
	      "ay",
	      "hafta",
	      "gün",
	      "saat",
	      "dakika",
	      "saniye",
	      "milisaniye",
	      ","
	    ),
	    th: language(
	      "ปี",
	      "เดือน",
	      "สัปดาห์",
	      "วัน",
	      "ชั่วโมง",
	      "นาที",
	      "วินาที",
	      "มิลลิวินาที"
	    ),
	    uz: language(
	      "yil",
	      "oy",
	      "hafta",
	      "kun",
	      "soat",
	      "minut",
	      "sekund",
	      "millisekund"
	    ),
	    uz_CYR: language(
	      "йил",
	      "ой",
	      "ҳафта",
	      "кун",
	      "соат",
	      "минут",
	      "секунд",
	      "миллисекунд"
	    ),
	    vi: language(
	      "năm",
	      "tháng",
	      "tuần",
	      "ngày",
	      "giờ",
	      "phút",
	      "giây",
	      "mili giây",
	      ","
	    ),
	    zh_CN: language("年", "个月", "周", "天", "小时", "分钟", "秒", "毫秒"),
	    zh_TW: language("年", "個月", "周", "天", "小時", "分鐘", "秒", "毫秒")
	  };
	
	  /**
	   * Helper function for creating language definitions.
	   *
	   * @param {Unit} y
	   * @param {Unit} mo
	   * @param {Unit} w
	   * @param {Unit} d
	   * @param {Unit} h
	   * @param {Unit} m
	   * @param {Unit} s
	   * @param {Unit} ms
	   * @param {string} [decimal]
	   * @returns {Language}
	   */
	  function language(y, mo, w, d, h, m, s, ms, decimal) {
	    /** @type {Language} */
	    var result = { y: y, mo: mo, w: w, d: d, h: h, m: m, s: s, ms: ms };
	    if (typeof decimal !== "undefined") {
	      result.decimal = decimal;
	    }
	    return result;
	  }
	
	  /**
	   * Helper function for Arabic.
	   *
	   * @param {number} c
	   * @returns {0 | 1 | 2}
	   */
	  function getArabicForm(c) {
	    if (c === 2) {
	      return 1;
	    }
	    if (c > 2 && c < 11) {
	      return 2;
	    }
	    return 0;
	  }
	
	  /**
	   * Helper function for Polish.
	   *
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getPolishForm(c) {
	    if (c === 1) {
	      return 0;
	    }
	    if (Math.floor(c) !== c) {
	      return 1;
	    }
	    if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
	      return 2;
	    }
	    return 3;
	  }
	
	  /**
	   * Helper function for Slavic languages.
	   *
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getSlavicForm(c) {
	    if (Math.floor(c) !== c) {
	      return 2;
	    }
	    if (
	      (c % 100 >= 5 && c % 100 <= 20) ||
	      (c % 10 >= 5 && c % 10 <= 9) ||
	      c % 10 === 0
	    ) {
	      return 0;
	    }
	    if (c % 10 === 1) {
	      return 1;
	    }
	    if (c > 1) {
	      return 2;
	    }
	    return 0;
	  }
	
	  /**
	   * Helper function for Czech or Slovak.
	   *
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getCzechOrSlovakForm(c) {
	    if (c === 1) {
	      return 0;
	    }
	    if (Math.floor(c) !== c) {
	      return 1;
	    }
	    if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
	      return 2;
	    }
	    return 3;
	  }
	
	  /**
	   * Helper function for Lithuanian.
	   *
	   * @param {number} c
	   * @returns {0 | 1 | 2}
	   */
	  function getLithuanianForm(c) {
	    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
	      return 0;
	    }
	    if (
	      Math.floor(c) !== c ||
	      (c % 10 >= 2 && c % 100 > 20) ||
	      (c % 10 >= 2 && c % 100 < 10)
	    ) {
	      return 1;
	    }
	    return 2;
	  }
	
	  /**
	   * Helper function for Latvian.
	   *
	   * @param {number} c
	   * @returns {boolean}
	   */
	  function getLatvianForm(c) {
	    return c % 10 === 1 && c % 100 !== 11;
	  }
	
	  function assign(destination) {
	    var source;
	    for (var i = 1; i < arguments.length; i++) {
	      source = arguments[i];
	      for (var prop in source) {
	        if (has(source, prop)) {
	          destination[prop] = source[prop];
	        }
	      }
	    }
	    return destination;
	  }
	
	  // We need to make sure we support browsers that don't have
	  // `Array.isArray`, so we define a fallback here.
	  var isArray =
	    Array.isArray ||
	    function (arg) {
	      return Object.prototype.toString.call(arg) === "[object Array]";
	    };
	
	  function has(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	  }
	
	  /**
	   * @param {Pick<Required<Options>, "language" | "fallbacks" | "languages">} options
	   * @throws {Error} Throws an error if language is not found.
	   * @returns {Language}
	   */
	  function getLanguage(options) {
	    var possibleLanguages = [options.language];
	
	    if (has(options, "fallbacks")) {
	      if (isArray(options.fallbacks) && options.fallbacks.length) {
	        possibleLanguages = possibleLanguages.concat(options.fallbacks);
	      } else {
	        throw new Error("fallbacks must be an array with at least one element");
	      }
	    }
	
	    for (var i = 0; i < possibleLanguages.length; i++) {
	      var languageToTry = possibleLanguages[i];
	      if (has(options.languages, languageToTry)) {
	        return options.languages[languageToTry];
	      }
	      if (has(LANGUAGES, languageToTry)) {
	        return LANGUAGES[languageToTry];
	      }
	    }
	
	    throw new Error("No language found.");
	  }
	
	  /**
	   * @param {Piece} piece
	   * @param {Language} language
	   * @param {Pick<Required<Options>, "decimal" | "spacer" | "maxDecimalPoints" | "digitReplacements">} options
	   */
	  function renderPiece(piece, language, options) {
	    var unitName = piece.unitName;
	    var unitCount = piece.unitCount;
	
	    var spacer = options.spacer;
	    var maxDecimalPoints = options.maxDecimalPoints;
	
	    /** @type {string} */
	    var decimal;
	    if (has(options, "decimal")) {
	      decimal = options.decimal;
	    } else if (has(language, "decimal")) {
	      decimal = language.decimal;
	    } else {
	      decimal = ".";
	    }
	
	    /** @type {undefined | DigitReplacements} */
	    var digitReplacements;
	    if ("digitReplacements" in options) {
	      digitReplacements = options.digitReplacements;
	    } else if ("_digitReplacements" in language) {
	      digitReplacements = language._digitReplacements;
	    }
	
	    /** @type {string} */
	    var formattedCount;
	    var normalizedUnitCount =
	      maxDecimalPoints === void 0
	        ? unitCount
	        : Math.floor(unitCount * Math.pow(10, maxDecimalPoints)) /
	          Math.pow(10, maxDecimalPoints);
	    var countStr = normalizedUnitCount.toString();
	    if (digitReplacements) {
	      formattedCount = "";
	      for (var i = 0; i < countStr.length; i++) {
	        var char = countStr[i];
	        if (char === ".") {
	          formattedCount += decimal;
	        } else {
	          formattedCount += digitReplacements[char];
	        }
	      }
	    } else {
	      formattedCount = countStr.replace(".", decimal);
	    }
	
	    var languageWord = language[unitName];
	    var word;
	    if (typeof languageWord === "function") {
	      word = languageWord(unitCount);
	    } else {
	      word = languageWord;
	    }
	
	    if (language._numberFirst) {
	      return word + spacer + formattedCount;
	    }
	    return formattedCount + spacer + word;
	  }
	
	  /**
	   * @typedef {Object} Piece
	   * @prop {UnitName} unitName
	   * @prop {number} unitCount
	   */
	
	  /**
	   * @param {number} ms
	   * @param {Pick<Required<Options>, "units" | "unitMeasures" | "largest" | "round">} options
	   * @returns {Piece[]}
	   */
	  function getPieces(ms, options) {
	    /** @type {UnitName} */
	    var unitName;
	
	    /** @type {number} */
	    var i;
	
	    /** @type {number} */
	    var unitCount;
	
	    /** @type {number} */
	    var msRemaining;
	
	    var units = options.units;
	    var unitMeasures = options.unitMeasures;
	    var largest = "largest" in options ? options.largest : Infinity;
	
	    if (!units.length) return [];
	
	    // Get the counts for each unit. Doesn't round or truncate anything.
	    // For example, might create an object like `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`.
	    /** @type {Partial<Record<UnitName, number>>} */
	    var unitCounts = {};
	    msRemaining = ms;
	    for (i = 0; i < units.length; i++) {
	      unitName = units[i];
	      var unitMs = unitMeasures[unitName];
	
	      var isLast = i === units.length - 1;
	      unitCount = isLast
	        ? msRemaining / unitMs
	        : Math.floor(msRemaining / unitMs);
	      unitCounts[unitName] = unitCount;
	
	      msRemaining -= unitCount * unitMs;
	    }
	
	    if (options.round) {
	      // Update counts based on the `largest` option.
	      // For example, if `largest === 2` and `unitCount` is `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`,
	      // updates to something like `{ y: 7, m: 6.2 }`.
	      var unitsRemainingBeforeRound = largest;
	      for (i = 0; i < units.length; i++) {
	        unitName = units[i];
	        unitCount = unitCounts[unitName];
	
	        if (unitCount === 0) continue;
	
	        unitsRemainingBeforeRound--;
	
	        // "Take" the rest of the units into this one.
	        if (unitsRemainingBeforeRound === 0) {
	          for (var j = i + 1; j < units.length; j++) {
	            var smallerUnitName = units[j];
	            var smallerUnitCount = unitCounts[smallerUnitName];
	            unitCounts[unitName] +=
	              (smallerUnitCount * unitMeasures[smallerUnitName]) /
	              unitMeasures[unitName];
	            unitCounts[smallerUnitName] = 0;
	          }
	          break;
	        }
	      }
	
	      // Round the last piece (which should be the only non-integer).
	      //
	      // This can be a little tricky if the last piece "bubbles up" to a larger
	      // unit. For example, "3 days, 23.99 hours" should be rounded to "4 days".
	      // It can also require multiple passes. For example, "6 days, 23.99 hours"
	      // should become "1 week".
	      for (i = units.length - 1; i >= 0; i--) {
	        unitName = units[i];
	        unitCount = unitCounts[unitName];
	
	        if (unitCount === 0) continue;
	
	        var rounded = Math.round(unitCount);
	        unitCounts[unitName] = rounded;
	
	        if (i === 0) break;
	
	        var previousUnitName = units[i - 1];
	        var previousUnitMs = unitMeasures[previousUnitName];
	        var amountOfPreviousUnit = Math.floor(
	          (rounded * unitMeasures[unitName]) / previousUnitMs
	        );
	        if (amountOfPreviousUnit) {
	          unitCounts[previousUnitName] += amountOfPreviousUnit;
	          unitCounts[unitName] = 0;
	        } else {
	          break;
	        }
	      }
	    }
	
	    /** @type {Piece[]} */
	    var result = [];
	    for (i = 0; i < units.length && result.length < largest; i++) {
	      unitName = units[i];
	      unitCount = unitCounts[unitName];
	      if (unitCount) {
	        result.push({ unitName: unitName, unitCount: unitCount });
	      }
	    }
	    return result;
	  }
	
	  /**
	   * @param {Piece[]} pieces
	   * @param {Pick<Required<Options>, "units" | "language" | "languages" | "fallbacks" | "delimiter" | "spacer" | "decimal" | "conjunction" | "maxDecimalPoints" | "serialComma" | "digitReplacements">} options
	   * @returns {string}
	   */
	  function formatPieces(pieces, options) {
	    var language = getLanguage(options);
	
	    if (!pieces.length) {
	      var units = options.units;
	      var smallestUnitName = units[units.length - 1];
	      return renderPiece(
	        { unitName: smallestUnitName, unitCount: 0 },
	        language,
	        options
	      );
	    }
	
	    var conjunction = options.conjunction;
	    var serialComma = options.serialComma;
	
	    var delimiter;
	    if (has(options, "delimiter")) {
	      delimiter = options.delimiter;
	    } else if (has(language, "delimiter")) {
	      delimiter = language.delimiter;
	    } else {
	      delimiter = ", ";
	    }
	
	    /** @type {string[]} */
	    var renderedPieces = [];
	    for (var i = 0; i < pieces.length; i++) {
	      renderedPieces.push(renderPiece(pieces[i], language, options));
	    }
	
	    if (!conjunction || pieces.length === 1) {
	      return renderedPieces.join(delimiter);
	    }
	
	    if (pieces.length === 2) {
	      return renderedPieces.join(conjunction);
	    }
	
	    return (
	      renderedPieces.slice(0, -1).join(delimiter) +
	      (serialComma ? "," : "") +
	      conjunction +
	      renderedPieces.slice(-1)
	    );
	  }
	
	  /**
	   * Create a humanizer, which lets you change the default options.
	   */
	  function humanizer(passedOptions) {
	    var result = function humanizer(ms, humanizerOptions) {
	      // Make sure we have a positive number.
	      //
	      // Has the nice side-effect of converting things to numbers. For example,
	      // converts `"123"` and `Number(123)` to `123`.
	      ms = Math.abs(ms);
	
	      var options = assign({}, result, humanizerOptions || {});
	
	      var pieces = getPieces(ms, options);
	
	      return formatPieces(pieces, options);
	    };
	
	    return assign(
	      result,
	      {
	        language: "en",
	        spacer: " ",
	        conjunction: "",
	        serialComma: true,
	        units: ["y", "mo", "w", "d", "h", "m", "s"],
	        languages: {},
	        round: false,
	        unitMeasures: {
	          y: 31557600000,
	          mo: 2629800000,
	          w: 604800000,
	          d: 86400000,
	          h: 3600000,
	          m: 60000,
	          s: 1000,
	          ms: 1
	        }
	      },
	      passedOptions
	    );
	  }
	
	  /**
	   * Humanize a duration.
	   *
	   * This is a wrapper around the default humanizer.
	   */
	  var humanizeDuration = humanizer({});
	
	  humanizeDuration.getSupportedLanguages = function getSupportedLanguages() {
	    var result = [];
	    for (var language in LANGUAGES) {
	      if (has(LANGUAGES, language) && language !== "gr") {
	        result.push(language);
	      }
	    }
	    return result;
	  };
	
	  humanizeDuration.humanizer = humanizer;
	
	  // @ts-ignore
	  if (true) {
	    // @ts-ignore
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return humanizeDuration;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && module.exports) {
	    module.exports = humanizeDuration;
	  } else {
	    this.humanizeDuration = humanizeDuration;
	  }
	})();


/***/ }),
/* 517 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// Internal use only
	return $.ui.escapeSelector = ( function() {
		var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
		return function( selector ) {
			return selector.replace( selectorEscape, "\\$1" );
		};
	} )();
	
	} ) );


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// Support: IE8 Only
	// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
	// with a string, so we need to find the proper form.
	return $.fn.form = function() {
		return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
	};
	
	} ) );


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Support for jQuery core 1.7.x 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 */
	
	//>>label: jQuery 1.7 Support
	//>>group: Core
	//>>description: Support version 1.7.x of jQuery core
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	// Support: jQuery 1.7 only
	// Not a great way to check versions, but since we only support 1.7+ and only
	// need to detect <1.8, this is a simple check that should suffice. Checking
	// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
	// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
	// 1.7 anymore). See #11197 for why we're not using feature detection.
	if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {
	
		// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
		// Unlike jQuery Core 1.8+, these only support numeric values to set the
		// dimensions in pixels
		$.each( [ "Width", "Height" ], function( i, name ) {
			var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
				type = name.toLowerCase(),
				orig = {
					innerWidth: $.fn.innerWidth,
					innerHeight: $.fn.innerHeight,
					outerWidth: $.fn.outerWidth,
					outerHeight: $.fn.outerHeight
				};
	
			function reduce( elem, size, border, margin ) {
				$.each( side, function() {
					size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
					if ( border ) {
						size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
					}
					if ( margin ) {
						size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
					}
				} );
				return size;
			}
	
			$.fn[ "inner" + name ] = function( size ) {
				if ( size === undefined ) {
					return orig[ "inner" + name ].call( this );
				}
	
				return this.each( function() {
					$( this ).css( type, reduce( this, size ) + "px" );
				} );
			};
	
			$.fn[ "outer" + name ] = function( size, margin ) {
				if ( typeof size !== "number" ) {
					return orig[ "outer" + name ].call( this, size );
				}
	
				return this.each( function() {
					$( this ).css( type, reduce( this, size, true, margin ) + "px" );
				} );
			};
		} );
	
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	} ) );


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Keycode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Keycode
	//>>group: Core
	//>>description: Provide keycodes as keynames
	//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.keyCode = {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	};
	
	} ) );


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Labels 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: labels
	//>>group: Core
	//>>description: Find all the labels associated with a given input
	//>>docs: http://api.jqueryui.com/labels/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3), __webpack_require__(518) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.labels = function() {
		var ancestor, selector, id, labels, ancestors;
	
		// Check control.labels first
		if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
			return this.pushStack( this[ 0 ].labels );
		}
	
		// Support: IE <= 11, FF <= 37, Android <= 2.3 only
		// Above browsers do not support control.labels. Everything below is to support them
		// as well as document fragments. control.labels does not work on document fragments
		labels = this.eq( 0 ).parents( "label" );
	
		// Look for the label based on the id
		id = this.attr( "id" );
		if ( id ) {
	
			// We don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.eq( 0 ).parents().last();
	
			// Get a full set of top level ancestors
			ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );
	
			// Create a selector for the label based on the id
			selector = "label[for='" + $.ui.escapeSelector( id ) + "']";
	
			labels = labels.add( ancestors.find( selector ).addBack( selector ) );
	
		}
	
		// Return whatever we have found for labels
		return this.pushStack( labels );
	};
	
	} ) );


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Tabbable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :tabbable Selector
	//>>group: Core
	//>>description: Selects elements which can be tabbed to.
	//>>docs: http://api.jqueryui.com/tabbable-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3), __webpack_require__(83) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.extend( $.expr[ ":" ], {
		tabbable: function( element ) {
			var tabIndex = $.attr( element, "tabindex" ),
				hasTabindex = tabIndex != null;
			return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
		}
	} );
	
	} ) );


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Unique ID 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: uniqueId
	//>>group: Core
	//>>description: Functions to generate and remove uniqueId's
	//>>docs: http://api.jqueryui.com/uniqueId/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(2), __webpack_require__(3) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.extend( {
		uniqueId: ( function() {
			var uuid = 0;
	
			return function() {
				return this.each( function() {
					if ( !this.id ) {
						this.id = "ui-id-" + ( ++uuid );
					}
				} );
			};
		} )(),
	
		removeUniqueId: function() {
			return this.each( function() {
				if ( /^ui-id-\d+$/.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			} );
		}
	} );
	
	} ) );


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Droppable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Droppable
	//>>group: Interactions
	//>>description: Enables drop targets for draggable elements.
	//>>docs: http://api.jqueryui.com/droppable/
	//>>demos: http://jqueryui.com/droppable/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(88),
				__webpack_require__(34),
				__webpack_require__(3),
				__webpack_require__(23)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.droppable", {
		version: "1.12.1",
		widgetEventPrefix: "drop",
		options: {
			accept: "*",
			addClasses: true,
			greedy: false,
			scope: "default",
			tolerance: "intersect",
	
			// Callbacks
			activate: null,
			deactivate: null,
			drop: null,
			out: null,
			over: null
		},
		_create: function() {
	
			var proportions,
				o = this.options,
				accept = o.accept;
	
			this.isover = false;
			this.isout = true;
	
			this.accept = $.isFunction( accept ) ? accept : function( d ) {
				return d.is( accept );
			};
	
			this.proportions = function( /* valueToWrite */ ) {
				if ( arguments.length ) {
	
					// Store the droppable's proportions
					proportions = arguments[ 0 ];
				} else {
	
					// Retrieve or derive the droppable's proportions
					return proportions ?
						proportions :
						proportions = {
							width: this.element[ 0 ].offsetWidth,
							height: this.element[ 0 ].offsetHeight
						};
				}
			};
	
			this._addToManager( o.scope );
	
			o.addClasses && this._addClass( "ui-droppable" );
	
		},
	
		_addToManager: function( scope ) {
	
			// Add the reference and positions to the manager
			$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
			$.ui.ddmanager.droppables[ scope ].push( this );
		},
	
		_splice: function( drop ) {
			var i = 0;
			for ( ; i < drop.length; i++ ) {
				if ( drop[ i ] === this ) {
					drop.splice( i, 1 );
				}
			}
		},
	
		_destroy: function() {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
			this._splice( drop );
		},
	
		_setOption: function( key, value ) {
	
			if ( key === "accept" ) {
				this.accept = $.isFunction( value ) ? value : function( d ) {
					return d.is( value );
				};
			} else if ( key === "scope" ) {
				var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
				this._splice( drop );
				this._addToManager( value );
			}
	
			this._super( key, value );
		},
	
		_activate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._addActiveClass();
			if ( draggable ) {
				this._trigger( "activate", event, this.ui( draggable ) );
			}
		},
	
		_deactivate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._removeActiveClass();
			if ( draggable ) {
				this._trigger( "deactivate", event, this.ui( draggable ) );
			}
		},
	
		_over: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._addHoverClass();
				this._trigger( "over", event, this.ui( draggable ) );
			}
	
		},
	
		_out: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._removeHoverClass();
				this._trigger( "out", event, this.ui( draggable ) );
			}
	
		},
	
		_drop: function( event, custom ) {
	
			var draggable = custom || $.ui.ddmanager.current,
				childrenIntersection = false;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return false;
			}
	
			this.element
				.find( ":data(ui-droppable)" )
				.not( ".ui-draggable-dragging" )
				.each( function() {
					var inst = $( this ).droppable( "instance" );
					if (
						inst.options.greedy &&
						!inst.options.disabled &&
						inst.options.scope === draggable.options.scope &&
						inst.accept.call(
							inst.element[ 0 ], ( draggable.currentItem || draggable.element )
						) &&
						intersect(
							draggable,
							$.extend( inst, { offset: inst.element.offset() } ),
							inst.options.tolerance, event
						)
					) {
						childrenIntersection = true;
						return false; }
				} );
			if ( childrenIntersection ) {
				return false;
			}
	
			if ( this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this._removeActiveClass();
				this._removeHoverClass();
	
				this._trigger( "drop", event, this.ui( draggable ) );
				return this.element;
			}
	
			return false;
	
		},
	
		ui: function( c ) {
			return {
				draggable: ( c.currentItem || c.element ),
				helper: c.helper,
				position: c.position,
				offset: c.positionAbs
			};
		},
	
		// Extension points just to make backcompat sane and avoid duplicating logic
		// TODO: Remove in 1.13 along with call to it below
		_addHoverClass: function() {
			this._addClass( "ui-droppable-hover" );
		},
	
		_removeHoverClass: function() {
			this._removeClass( "ui-droppable-hover" );
		},
	
		_addActiveClass: function() {
			this._addClass( "ui-droppable-active" );
		},
	
		_removeActiveClass: function() {
			this._removeClass( "ui-droppable-active" );
		}
	} );
	
	var intersect = $.ui.intersect = ( function() {
		function isOverAxis( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		}
	
		return function( draggable, droppable, toleranceMode, event ) {
	
			if ( !droppable.offset ) {
				return false;
			}
	
			var x1 = ( draggable.positionAbs ||
					draggable.position.absolute ).left + draggable.margins.left,
				y1 = ( draggable.positionAbs ||
					draggable.position.absolute ).top + draggable.margins.top,
				x2 = x1 + draggable.helperProportions.width,
				y2 = y1 + draggable.helperProportions.height,
				l = droppable.offset.left,
				t = droppable.offset.top,
				r = l + droppable.proportions().width,
				b = t + droppable.proportions().height;
	
			switch ( toleranceMode ) {
			case "fit":
				return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
			case "intersect":
				return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
					x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
			case "pointer":
				return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
					isOverAxis( event.pageX, l, droppable.proportions().width );
			case "touch":
				return (
					( y1 >= t && y1 <= b ) || // Top edge touching
					( y2 >= t && y2 <= b ) || // Bottom edge touching
					( y1 < t && y2 > b ) // Surrounded vertically
				) && (
					( x1 >= l && x1 <= r ) || // Left edge touching
					( x2 >= l && x2 <= r ) || // Right edge touching
					( x1 < l && x2 > r ) // Surrounded horizontally
				);
			default:
				return false;
			}
		};
	} )();
	
	/*
		This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
		current: null,
		droppables: { "default": [] },
		prepareOffsets: function( t, event ) {
	
			var i, j,
				m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
				type = event ? event.type : null, // workaround for #2317
				list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();
	
			droppablesLoop: for ( i = 0; i < m.length; i++ ) {
	
				// No disabled and non-accepted
				if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
						( t.currentItem || t.element ) ) ) ) {
					continue;
				}
	
				// Filter out elements in the current dragged item
				for ( j = 0; j < list.length; j++ ) {
					if ( list[ j ] === m[ i ].element[ 0 ] ) {
						m[ i ].proportions().height = 0;
						continue droppablesLoop;
					}
				}
	
				m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
				if ( !m[ i ].visible ) {
					continue;
				}
	
				// Activate the droppable if used directly from draggables
				if ( type === "mousedown" ) {
					m[ i ]._activate.call( m[ i ], event );
				}
	
				m[ i ].offset = m[ i ].element.offset();
				m[ i ].proportions( {
					width: m[ i ].element[ 0 ].offsetWidth,
					height: m[ i ].element[ 0 ].offsetHeight
				} );
	
			}
	
		},
		drop: function( draggable, event ) {
	
			var dropped = false;
	
			// Create a copy of the droppables in case the list changes during the drop (#9116)
			$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {
	
				if ( !this.options ) {
					return;
				}
				if ( !this.options.disabled && this.visible &&
						intersect( draggable, this, this.options.tolerance, event ) ) {
					dropped = this._drop.call( this, event ) || dropped;
				}
	
				if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
						( draggable.currentItem || draggable.element ) ) ) {
					this.isout = true;
					this.isover = false;
					this._deactivate.call( this, event );
				}
	
			} );
			return dropped;
	
		},
		dragStart: function( draggable, event ) {
	
			// Listen for scrolling so that if the dragging causes scrolling the position of the
			// droppables can be recalculated (see #5003)
			draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
				if ( !draggable.options.refreshPositions ) {
					$.ui.ddmanager.prepareOffsets( draggable, event );
				}
			} );
		},
		drag: function( draggable, event ) {
	
			// If you have a highly dynamic page, you might try this option. It renders positions
			// every time you move the mouse.
			if ( draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
	
			// Run through all droppables and check their positions based on specific tolerance options
			$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {
	
				if ( this.options.disabled || this.greedyChild || !this.visible ) {
					return;
				}
	
				var parentInstance, scope, parent,
					intersects = intersect( draggable, this, this.options.tolerance, event ),
					c = !intersects && this.isover ?
						"isout" :
						( intersects && !this.isover ? "isover" : null );
				if ( !c ) {
					return;
				}
	
				if ( this.options.greedy ) {
	
					// find droppable parents with same scope
					scope = this.options.scope;
					parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
						return $( this ).droppable( "instance" ).options.scope === scope;
					} );
	
					if ( parent.length ) {
						parentInstance = $( parent[ 0 ] ).droppable( "instance" );
						parentInstance.greedyChild = ( c === "isover" );
					}
				}
	
				// We just moved into a greedy child
				if ( parentInstance && c === "isover" ) {
					parentInstance.isover = false;
					parentInstance.isout = true;
					parentInstance._out.call( parentInstance, event );
				}
	
				this[ c ] = true;
				this[ c === "isout" ? "isover" : "isout" ] = false;
				this[ c === "isover" ? "_over" : "_out" ].call( this, event );
	
				// We just moved out of a greedy child
				if ( parentInstance && c === "isout" ) {
					parentInstance.isout = false;
					parentInstance.isover = true;
					parentInstance._over.call( parentInstance, event );
				}
			} );
	
		},
		dragStop: function( draggable, event ) {
			draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );
	
			// Call prepareOffsets one final time since IE does not fire return scroll events when
			// overflow was caused by drag (see #5003)
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		}
	};
	
	// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for activeClass and hoverClass options
		$.widget( "ui.droppable", $.ui.droppable, {
			options: {
				hoverClass: false,
				activeClass: false
			},
			_addActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.addClass( this.options.activeClass );
				}
			},
			_removeActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.removeClass( this.options.activeClass );
				}
			},
			_addHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.addClass( this.options.hoverClass );
				}
			},
			_removeHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
			}
		} );
	}
	
	return $.ui.droppable;
	
	} ) );


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Resizable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Resizable
	//>>group: Interactions
	//>>description: Enables resize functionality for any element.
	//>>docs: http://api.jqueryui.com/resizable/
	//>>demos: http://jqueryui.com/resizable/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/resizable.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(2),
				__webpack_require__(34),
				__webpack_require__(82),
				__webpack_require__(50),
				__webpack_require__(3),
				__webpack_require__(23)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.resizable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "resize",
		options: {
			alsoResize: false,
			animate: false,
			animateDuration: "slow",
			animateEasing: "swing",
			aspectRatio: false,
			autoHide: false,
			classes: {
				"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
			},
			containment: false,
			ghost: false,
			grid: false,
			handles: "e,s,se",
			helper: false,
			maxHeight: null,
			maxWidth: null,
			minHeight: 10,
			minWidth: 10,
	
			// See #7960
			zIndex: 90,
	
			// Callbacks
			resize: null,
			start: null,
			stop: null
		},
	
		_num: function( value ) {
			return parseFloat( value ) || 0;
		},
	
		_isNumber: function( value ) {
			return !isNaN( parseFloat( value ) );
		},
	
		_hasScroll: function( el, a ) {
	
			if ( $( el ).css( "overflow" ) === "hidden" ) {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		},
	
		_create: function() {
	
			var margins,
				o = this.options,
				that = this;
			this._addClass( "ui-resizable" );
	
			$.extend( this, {
				_aspectRatio: !!( o.aspectRatio ),
				aspectRatio: o.aspectRatio,
				originalElement: this.element,
				_proportionallyResizeElements: [],
				_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
			} );
	
			// Wrap the element if it cannot hold child nodes
			if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {
	
				this.element.wrap(
					$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
						position: this.element.css( "position" ),
						width: this.element.outerWidth(),
						height: this.element.outerHeight(),
						top: this.element.css( "top" ),
						left: this.element.css( "left" )
					} )
				);
	
				this.element = this.element.parent().data(
					"ui-resizable", this.element.resizable( "instance" )
				);
	
				this.elementIsWrapper = true;
	
				margins = {
					marginTop: this.originalElement.css( "marginTop" ),
					marginRight: this.originalElement.css( "marginRight" ),
					marginBottom: this.originalElement.css( "marginBottom" ),
					marginLeft: this.originalElement.css( "marginLeft" )
				};
	
				this.element.css( margins );
				this.originalElement.css( "margin", 0 );
	
				// support: Safari
				// Prevent Safari textarea resize
				this.originalResizeStyle = this.originalElement.css( "resize" );
				this.originalElement.css( "resize", "none" );
	
				this._proportionallyResizeElements.push( this.originalElement.css( {
					position: "static",
					zoom: 1,
					display: "block"
				} ) );
	
				// Support: IE9
				// avoid IE jump (hard set the margin)
				this.originalElement.css( margins );
	
				this._proportionallyResize();
			}
	
			this._setupHandles();
	
			if ( o.autoHide ) {
				$( this.element )
					.on( "mouseenter", function() {
						if ( o.disabled ) {
							return;
						}
						that._removeClass( "ui-resizable-autohide" );
						that._handles.show();
					} )
					.on( "mouseleave", function() {
						if ( o.disabled ) {
							return;
						}
						if ( !that.resizing ) {
							that._addClass( "ui-resizable-autohide" );
							that._handles.hide();
						}
					} );
			}
	
			this._mouseInit();
		},
	
		_destroy: function() {
	
			this._mouseDestroy();
	
			var wrapper,
				_destroy = function( exp ) {
					$( exp )
						.removeData( "resizable" )
						.removeData( "ui-resizable" )
						.off( ".resizable" )
						.find( ".ui-resizable-handle" )
							.remove();
				};
	
			// TODO: Unwrap at same DOM position
			if ( this.elementIsWrapper ) {
				_destroy( this.element );
				wrapper = this.element;
				this.originalElement.css( {
					position: wrapper.css( "position" ),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css( "top" ),
					left: wrapper.css( "left" )
				} ).insertAfter( wrapper );
				wrapper.remove();
			}
	
			this.originalElement.css( "resize", this.originalResizeStyle );
			_destroy( this.originalElement );
	
			return this;
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			switch ( key ) {
			case "handles":
				this._removeHandles();
				this._setupHandles();
				break;
			default:
				break;
			}
		},
	
		_setupHandles: function() {
			var o = this.options, handle, i, n, hname, axis, that = this;
			this.handles = o.handles ||
				( !$( ".ui-resizable-handle", this.element ).length ?
					"e,s,se" : {
						n: ".ui-resizable-n",
						e: ".ui-resizable-e",
						s: ".ui-resizable-s",
						w: ".ui-resizable-w",
						se: ".ui-resizable-se",
						sw: ".ui-resizable-sw",
						ne: ".ui-resizable-ne",
						nw: ".ui-resizable-nw"
					} );
	
			this._handles = $();
			if ( this.handles.constructor === String ) {
	
				if ( this.handles === "all" ) {
					this.handles = "n,e,s,w,se,sw,ne,nw";
				}
	
				n = this.handles.split( "," );
				this.handles = {};
	
				for ( i = 0; i < n.length; i++ ) {
	
					handle = $.trim( n[ i ] );
					hname = "ui-resizable-" + handle;
					axis = $( "<div>" );
					this._addClass( axis, "ui-resizable-handle " + hname );
	
					axis.css( { zIndex: o.zIndex } );
	
					this.handles[ handle ] = ".ui-resizable-" + handle;
					this.element.append( axis );
				}
	
			}
	
			this._renderAxis = function( target ) {
	
				var i, axis, padPos, padWrapper;
	
				target = target || this.element;
	
				for ( i in this.handles ) {
	
					if ( this.handles[ i ].constructor === String ) {
						this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
					} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
						this.handles[ i ] = $( this.handles[ i ] );
						this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
					}
	
					if ( this.elementIsWrapper &&
							this.originalElement[ 0 ]
								.nodeName
								.match( /^(textarea|input|select|button)$/i ) ) {
						axis = $( this.handles[ i ], this.element );
	
						padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
							axis.outerHeight() :
							axis.outerWidth();
	
						padPos = [ "padding",
							/ne|nw|n/.test( i ) ? "Top" :
							/se|sw|s/.test( i ) ? "Bottom" :
							/^e$/.test( i ) ? "Right" : "Left" ].join( "" );
	
						target.css( padPos, padWrapper );
	
						this._proportionallyResize();
					}
	
					this._handles = this._handles.add( this.handles[ i ] );
				}
			};
	
			// TODO: make renderAxis a prototype function
			this._renderAxis( this.element );
	
			this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
			this._handles.disableSelection();
	
			this._handles.on( "mouseover", function() {
				if ( !that.resizing ) {
					if ( this.className ) {
						axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
					}
					that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
				}
			} );
	
			if ( o.autoHide ) {
				this._handles.hide();
				this._addClass( "ui-resizable-autohide" );
			}
		},
	
		_removeHandles: function() {
			this._handles.remove();
		},
	
		_mouseCapture: function( event ) {
			var i, handle,
				capture = false;
	
			for ( i in this.handles ) {
				handle = $( this.handles[ i ] )[ 0 ];
				if ( handle === event.target || $.contains( handle, event.target ) ) {
					capture = true;
				}
			}
	
			return !this.options.disabled && capture;
		},
	
		_mouseStart: function( event ) {
	
			var curleft, curtop, cursor,
				o = this.options,
				el = this.element;
	
			this.resizing = true;
	
			this._renderProxy();
	
			curleft = this._num( this.helper.css( "left" ) );
			curtop = this._num( this.helper.css( "top" ) );
	
			if ( o.containment ) {
				curleft += $( o.containment ).scrollLeft() || 0;
				curtop += $( o.containment ).scrollTop() || 0;
			}
	
			this.offset = this.helper.offset();
			this.position = { left: curleft, top: curtop };
	
			this.size = this._helper ? {
					width: this.helper.width(),
					height: this.helper.height()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.originalSize = this._helper ? {
					width: el.outerWidth(),
					height: el.outerHeight()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.sizeDiff = {
				width: el.outerWidth() - el.width(),
				height: el.outerHeight() - el.height()
			};
	
			this.originalPosition = { left: curleft, top: curtop };
			this.originalMousePosition = { left: event.pageX, top: event.pageY };
	
			this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
				o.aspectRatio :
				( ( this.originalSize.width / this.originalSize.height ) || 1 );
	
			cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
			$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );
	
			this._addClass( "ui-resizable-resizing" );
			this._propagate( "start", event );
			return true;
		},
	
		_mouseDrag: function( event ) {
	
			var data, props,
				smp = this.originalMousePosition,
				a = this.axis,
				dx = ( event.pageX - smp.left ) || 0,
				dy = ( event.pageY - smp.top ) || 0,
				trigger = this._change[ a ];
	
			this._updatePrevProperties();
	
			if ( !trigger ) {
				return false;
			}
	
			data = trigger.apply( this, [ event, dx, dy ] );
	
			this._updateVirtualBoundaries( event.shiftKey );
			if ( this._aspectRatio || event.shiftKey ) {
				data = this._updateRatio( data, event );
			}
	
			data = this._respectSize( data, event );
	
			this._updateCache( data );
	
			this._propagate( "resize", event );
	
			props = this._applyChanges();
	
			if ( !this._helper && this._proportionallyResizeElements.length ) {
				this._proportionallyResize();
			}
	
			if ( !$.isEmptyObject( props ) ) {
				this._updatePrevProperties();
				this._trigger( "resize", event, this.ui() );
				this._applyChanges();
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			this.resizing = false;
			var pr, ista, soffseth, soffsetw, s, left, top,
				o = this.options, that = this;
	
			if ( this._helper ) {
	
				pr = this._proportionallyResizeElements;
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
				soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
				soffsetw = ista ? 0 : that.sizeDiff.width;
	
				s = {
					width: ( that.helper.width()  - soffsetw ),
					height: ( that.helper.height() - soffseth )
				};
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null;
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
				if ( !o.animate ) {
					this.element.css( $.extend( s, { top: top, left: left } ) );
				}
	
				that.helper.height( that.size.height );
				that.helper.width( that.size.width );
	
				if ( this._helper && !o.animate ) {
					this._proportionallyResize();
				}
			}
	
			$( "body" ).css( "cursor", "auto" );
	
			this._removeClass( "ui-resizable-resizing" );
	
			this._propagate( "stop", event );
	
			if ( this._helper ) {
				this.helper.remove();
			}
	
			return false;
	
		},
	
		_updatePrevProperties: function() {
			this.prevPosition = {
				top: this.position.top,
				left: this.position.left
			};
			this.prevSize = {
				width: this.size.width,
				height: this.size.height
			};
		},
	
		_applyChanges: function() {
			var props = {};
	
			if ( this.position.top !== this.prevPosition.top ) {
				props.top = this.position.top + "px";
			}
			if ( this.position.left !== this.prevPosition.left ) {
				props.left = this.position.left + "px";
			}
			if ( this.size.width !== this.prevSize.width ) {
				props.width = this.size.width + "px";
			}
			if ( this.size.height !== this.prevSize.height ) {
				props.height = this.size.height + "px";
			}
	
			this.helper.css( props );
	
			return props;
		},
	
		_updateVirtualBoundaries: function( forceAspectRatio ) {
			var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
				o = this.options;
	
			b = {
				minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
				maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
				minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
				maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
			};
	
			if ( this._aspectRatio || forceAspectRatio ) {
				pMinWidth = b.minHeight * this.aspectRatio;
				pMinHeight = b.minWidth / this.aspectRatio;
				pMaxWidth = b.maxHeight * this.aspectRatio;
				pMaxHeight = b.maxWidth / this.aspectRatio;
	
				if ( pMinWidth > b.minWidth ) {
					b.minWidth = pMinWidth;
				}
				if ( pMinHeight > b.minHeight ) {
					b.minHeight = pMinHeight;
				}
				if ( pMaxWidth < b.maxWidth ) {
					b.maxWidth = pMaxWidth;
				}
				if ( pMaxHeight < b.maxHeight ) {
					b.maxHeight = pMaxHeight;
				}
			}
			this._vBoundaries = b;
		},
	
		_updateCache: function( data ) {
			this.offset = this.helper.offset();
			if ( this._isNumber( data.left ) ) {
				this.position.left = data.left;
			}
			if ( this._isNumber( data.top ) ) {
				this.position.top = data.top;
			}
			if ( this._isNumber( data.height ) ) {
				this.size.height = data.height;
			}
			if ( this._isNumber( data.width ) ) {
				this.size.width = data.width;
			}
		},
	
		_updateRatio: function( data ) {
	
			var cpos = this.position,
				csize = this.size,
				a = this.axis;
	
			if ( this._isNumber( data.height ) ) {
				data.width = ( data.height * this.aspectRatio );
			} else if ( this._isNumber( data.width ) ) {
				data.height = ( data.width / this.aspectRatio );
			}
	
			if ( a === "sw" ) {
				data.left = cpos.left + ( csize.width - data.width );
				data.top = null;
			}
			if ( a === "nw" ) {
				data.top = cpos.top + ( csize.height - data.height );
				data.left = cpos.left + ( csize.width - data.width );
			}
	
			return data;
		},
	
		_respectSize: function( data ) {
	
			var o = this._vBoundaries,
				a = this.axis,
				ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
				ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
				isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
				isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
				dw = this.originalPosition.left + this.originalSize.width,
				dh = this.originalPosition.top + this.originalSize.height,
				cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
			if ( isminw ) {
				data.width = o.minWidth;
			}
			if ( isminh ) {
				data.height = o.minHeight;
			}
			if ( ismaxw ) {
				data.width = o.maxWidth;
			}
			if ( ismaxh ) {
				data.height = o.maxHeight;
			}
	
			if ( isminw && cw ) {
				data.left = dw - o.minWidth;
			}
			if ( ismaxw && cw ) {
				data.left = dw - o.maxWidth;
			}
			if ( isminh && ch ) {
				data.top = dh - o.minHeight;
			}
			if ( ismaxh && ch ) {
				data.top = dh - o.maxHeight;
			}
	
			// Fixing jump error on top/left - bug #2330
			if ( !data.width && !data.height && !data.left && data.top ) {
				data.top = null;
			} else if ( !data.width && !data.height && !data.top && data.left ) {
				data.left = null;
			}
	
			return data;
		},
	
		_getPaddingPlusBorderDimensions: function( element ) {
			var i = 0,
				widths = [],
				borders = [
					element.css( "borderTopWidth" ),
					element.css( "borderRightWidth" ),
					element.css( "borderBottomWidth" ),
					element.css( "borderLeftWidth" )
				],
				paddings = [
					element.css( "paddingTop" ),
					element.css( "paddingRight" ),
					element.css( "paddingBottom" ),
					element.css( "paddingLeft" )
				];
	
			for ( ; i < 4; i++ ) {
				widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
				widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
			}
	
			return {
				height: widths[ 0 ] + widths[ 2 ],
				width: widths[ 1 ] + widths[ 3 ]
			};
		},
	
		_proportionallyResize: function() {
	
			if ( !this._proportionallyResizeElements.length ) {
				return;
			}
	
			var prel,
				i = 0,
				element = this.helper || this.element;
	
			for ( ; i < this._proportionallyResizeElements.length; i++ ) {
	
				prel = this._proportionallyResizeElements[ i ];
	
				// TODO: Seems like a bug to cache this.outerDimensions
				// considering that we are in a loop.
				if ( !this.outerDimensions ) {
					this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
				}
	
				prel.css( {
					height: ( element.height() - this.outerDimensions.height ) || 0,
					width: ( element.width() - this.outerDimensions.width ) || 0
				} );
	
			}
	
		},
	
		_renderProxy: function() {
	
			var el = this.element, o = this.options;
			this.elementOffset = el.offset();
	
			if ( this._helper ) {
	
				this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );
	
				this._addClass( this.helper, this._helper );
				this.helper.css( {
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					position: "absolute",
					left: this.elementOffset.left + "px",
					top: this.elementOffset.top + "px",
					zIndex: ++o.zIndex //TODO: Don't modify option
				} );
	
				this.helper
					.appendTo( "body" )
					.disableSelection();
	
			} else {
				this.helper = this.element;
			}
	
		},
	
		_change: {
			e: function( event, dx ) {
				return { width: this.originalSize.width + dx };
			},
			w: function( event, dx ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { left: sp.left + dx, width: cs.width - dx };
			},
			n: function( event, dx, dy ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { top: sp.top + dy, height: cs.height - dy };
			},
			s: function( event, dx, dy ) {
				return { height: this.originalSize.height + dy };
			},
			se: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			sw: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			},
			ne: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			nw: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			}
		},
	
		_propagate: function( n, event ) {
			$.ui.plugin.call( this, n, [ event, this.ui() ] );
			( n !== "resize" && this._trigger( n, event, this.ui() ) );
		},
	
		plugins: {},
	
		ui: function() {
			return {
				originalElement: this.originalElement,
				element: this.element,
				helper: this.helper,
				position: this.position,
				size: this.size,
				originalSize: this.originalSize,
				originalPosition: this.originalPosition
			};
		}
	
	} );
	
	/*
	 * Resizable Extensions
	 */
	
	$.ui.plugin.add( "resizable", "animate", {
	
		stop: function( event ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				pr = that._proportionallyResizeElements,
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
				soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
				soffsetw = ista ? 0 : that.sizeDiff.width,
				style = {
					width: ( that.size.width - soffsetw ),
					height: ( that.size.height - soffseth )
				},
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null,
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
			that.element.animate(
				$.extend( style, top && left ? { top: top, left: left } : {} ), {
					duration: o.animateDuration,
					easing: o.animateEasing,
					step: function() {
	
						var data = {
							width: parseFloat( that.element.css( "width" ) ),
							height: parseFloat( that.element.css( "height" ) ),
							top: parseFloat( that.element.css( "top" ) ),
							left: parseFloat( that.element.css( "left" ) )
						};
	
						if ( pr && pr.length ) {
							$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
						}
	
						// Propagating resize, and updating values for each animation step
						that._updateCache( data );
						that._propagate( "resize", event );
	
					}
				}
			);
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "containment", {
	
		start: function() {
			var element, p, co, ch, cw, width, height,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				el = that.element,
				oc = o.containment,
				ce = ( oc instanceof $ ) ?
					oc.get( 0 ) :
					( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;
	
			if ( !ce ) {
				return;
			}
	
			that.containerElement = $( ce );
	
			if ( /document/.test( oc ) || oc === document ) {
				that.containerOffset = {
					left: 0,
					top: 0
				};
				that.containerPosition = {
					left: 0,
					top: 0
				};
	
				that.parentData = {
					element: $( document ),
					left: 0,
					top: 0,
					width: $( document ).width(),
					height: $( document ).height() || document.body.parentNode.scrollHeight
				};
			} else {
				element = $( ce );
				p = [];
				$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
					p[ i ] = that._num( element.css( "padding" + name ) );
				} );
	
				that.containerOffset = element.offset();
				that.containerPosition = element.position();
				that.containerSize = {
					height: ( element.innerHeight() - p[ 3 ] ),
					width: ( element.innerWidth() - p[ 1 ] )
				};
	
				co = that.containerOffset;
				ch = that.containerSize.height;
				cw = that.containerSize.width;
				width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
				height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;
	
				that.parentData = {
					element: ce,
					left: co.left,
					top: co.top,
					width: width,
					height: height
				};
			}
		},
	
		resize: function( event ) {
			var woset, hoset, isParent, isOffsetRelative,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cp = that.position,
				pRatio = that._aspectRatio || event.shiftKey,
				cop = {
					top: 0,
					left: 0
				},
				ce = that.containerElement,
				continueResize = true;
	
			if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
				cop = co;
			}
	
			if ( cp.left < ( that._helper ? co.left : 0 ) ) {
				that.size.width = that.size.width +
					( that._helper ?
						( that.position.left - co.left ) :
						( that.position.left - cop.left ) );
	
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
				that.position.left = o.helper ? co.left : 0;
			}
	
			if ( cp.top < ( that._helper ? co.top : 0 ) ) {
				that.size.height = that.size.height +
					( that._helper ?
						( that.position.top - co.top ) :
						that.position.top );
	
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
				that.position.top = that._helper ? co.top : 0;
			}
	
			isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
			isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );
	
			if ( isParent && isOffsetRelative ) {
				that.offset.left = that.parentData.left + that.position.left;
				that.offset.top = that.parentData.top + that.position.top;
			} else {
				that.offset.left = that.element.offset().left;
				that.offset.top = that.element.offset().top;
			}
	
			woset = Math.abs( that.sizeDiff.width +
				( that._helper ?
					that.offset.left - cop.left :
					( that.offset.left - co.left ) ) );
	
			hoset = Math.abs( that.sizeDiff.height +
				( that._helper ?
					that.offset.top - cop.top :
					( that.offset.top - co.top ) ) );
	
			if ( woset + that.size.width >= that.parentData.width ) {
				that.size.width = that.parentData.width - woset;
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( hoset + that.size.height >= that.parentData.height ) {
				that.size.height = that.parentData.height - hoset;
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( !continueResize ) {
				that.position.left = that.prevPosition.left;
				that.position.top = that.prevPosition.top;
				that.size.width = that.prevSize.width;
				that.size.height = that.prevSize.height;
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cop = that.containerPosition,
				ce = that.containerElement,
				helper = $( that.helper ),
				ho = helper.offset(),
				w = helper.outerWidth() - that.sizeDiff.width,
				h = helper.outerHeight() - that.sizeDiff.height;
	
			if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
	
			if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
		}
	} );
	
	$.ui.plugin.add( "resizable", "alsoResize", {
	
		start: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options;
	
			$( o.alsoResize ).each( function() {
				var el = $( this );
				el.data( "ui-resizable-alsoresize", {
					width: parseFloat( el.width() ), height: parseFloat( el.height() ),
					left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
				} );
			} );
		},
	
		resize: function( event, ui ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				os = that.originalSize,
				op = that.originalPosition,
				delta = {
					height: ( that.size.height - os.height ) || 0,
					width: ( that.size.width - os.width ) || 0,
					top: ( that.position.top - op.top ) || 0,
					left: ( that.position.left - op.left ) || 0
				};
	
				$( o.alsoResize ).each( function() {
					var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
						css = el.parents( ui.originalElement[ 0 ] ).length ?
								[ "width", "height" ] :
								[ "width", "height", "top", "left" ];
	
					$.each( css, function( i, prop ) {
						var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
						if ( sum && sum >= 0 ) {
							style[ prop ] = sum || null;
						}
					} );
	
					el.css( style );
				} );
		},
	
		stop: function() {
			$( this ).removeData( "ui-resizable-alsoresize" );
		}
	} );
	
	$.ui.plugin.add( "resizable", "ghost", {
	
		start: function() {
	
			var that = $( this ).resizable( "instance" ), cs = that.size;
	
			that.ghost = that.originalElement.clone();
			that.ghost.css( {
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			} );
	
			that._addClass( that.ghost, "ui-resizable-ghost" );
	
			// DEPRECATED
			// TODO: remove after 1.12
			if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {
	
				// Ghost option
				that.ghost.addClass( this.options.ghost );
			}
	
			that.ghost.appendTo( that.helper );
	
		},
	
		resize: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost ) {
				that.ghost.css( {
					position: "relative",
					height: that.size.height,
					width: that.size.width
				} );
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost && that.helper ) {
				that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
			}
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "grid", {
	
		resize: function() {
			var outerDimensions,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				cs = that.size,
				os = that.originalSize,
				op = that.originalPosition,
				a = that.axis,
				grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
				gridX = ( grid[ 0 ] || 1 ),
				gridY = ( grid[ 1 ] || 1 ),
				ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
				oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
				newWidth = os.width + ox,
				newHeight = os.height + oy,
				isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
				isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
				isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
				isMinHeight = o.minHeight && ( o.minHeight > newHeight );
	
			o.grid = grid;
	
			if ( isMinWidth ) {
				newWidth += gridX;
			}
			if ( isMinHeight ) {
				newHeight += gridY;
			}
			if ( isMaxWidth ) {
				newWidth -= gridX;
			}
			if ( isMaxHeight ) {
				newHeight -= gridY;
			}
	
			if ( /^(se|s|e)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
			} else if ( /^(ne)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else if ( /^(sw)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.left = op.left - ox;
			} else {
				if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
					outerDimensions = that._getPaddingPlusBorderDimensions( this );
				}
	
				if ( newHeight - gridY > 0 ) {
					that.size.height = newHeight;
					that.position.top = op.top - oy;
				} else {
					newHeight = gridY - outerDimensions.height;
					that.size.height = newHeight;
					that.position.top = op.top + os.height - newHeight;
				}
				if ( newWidth - gridX > 0 ) {
					that.size.width = newWidth;
					that.position.left = op.left - ox;
				} else {
					newWidth = gridX - outerDimensions.width;
					that.size.width = newWidth;
					that.position.left = op.left + os.width - newWidth;
				}
			}
		}
	
	} );
	
	return $.ui.resizable;
	
	} ) );


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	// super simple module for the most common nodejs use case.
	exports.markdown = __webpack_require__(528);
	exports.parse = exports.markdown.toHTML;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// Released under MIT license
	// Copyright (c) 2009-2010 Dominic Baggott
	// Copyright (c) 2009-2010 Ash Berlin
	// Copyright (c) 2011 Christoph Dorn <christoph@christophdorn.com> (http://www.christophdorn.com)
	
	/*jshint browser:true, devel:true */
	
	(function( expose ) {
	
	/**
	 *  class Markdown
	 *
	 *  Markdown processing in Javascript done right. We have very particular views
	 *  on what constitutes 'right' which include:
	 *
	 *  - produces well-formed HTML (this means that em and strong nesting is
	 *    important)
	 *
	 *  - has an intermediate representation to allow processing of parsed data (We
	 *    in fact have two, both as [JsonML]: a markdown tree and an HTML tree).
	 *
	 *  - is easily extensible to add new dialects without having to rewrite the
	 *    entire parsing mechanics
	 *
	 *  - has a good test suite
	 *
	 *  This implementation fulfills all of these (except that the test suite could
	 *  do with expanding to automatically run all the fixtures from other Markdown
	 *  implementations.)
	 *
	 *  ##### Intermediate Representation
	 *
	 *  *TODO* Talk about this :) Its JsonML, but document the node names we use.
	 *
	 *  [JsonML]: http://jsonml.org/ "JSON Markup Language"
	 **/
	var Markdown = expose.Markdown = function(dialect) {
	  switch (typeof dialect) {
	    case "undefined":
	      this.dialect = Markdown.dialects.Gruber;
	      break;
	    case "object":
	      this.dialect = dialect;
	      break;
	    default:
	      if ( dialect in Markdown.dialects ) {
	        this.dialect = Markdown.dialects[dialect];
	      }
	      else {
	        throw new Error("Unknown Markdown dialect '" + String(dialect) + "'");
	      }
	      break;
	  }
	  this.em_state = [];
	  this.strong_state = [];
	  this.debug_indent = "";
	};
	
	/**
	 *  parse( markdown, [dialect] ) -> JsonML
	 *  - markdown (String): markdown string to parse
	 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
	 *
	 *  Parse `markdown` and return a markdown document as a Markdown.JsonML tree.
	 **/
	expose.parse = function( source, dialect ) {
	  // dialect will default if undefined
	  var md = new Markdown( dialect );
	  return md.toTree( source );
	};
	
	/**
	 *  toHTML( markdown, [dialect]  ) -> String
	 *  toHTML( md_tree ) -> String
	 *  - markdown (String): markdown string to parse
	 *  - md_tree (Markdown.JsonML): parsed markdown tree
	 *
	 *  Take markdown (either as a string or as a JsonML tree) and run it through
	 *  [[toHTMLTree]] then turn it into a well-formated HTML fragment.
	 **/
	expose.toHTML = function toHTML( source , dialect , options ) {
	  var input = expose.toHTMLTree( source , dialect , options );
	
	  return expose.renderJsonML( input );
	};
	
	/**
	 *  toHTMLTree( markdown, [dialect] ) -> JsonML
	 *  toHTMLTree( md_tree ) -> JsonML
	 *  - markdown (String): markdown string to parse
	 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
	 *  - md_tree (Markdown.JsonML): parsed markdown tree
	 *
	 *  Turn markdown into HTML, represented as a JsonML tree. If a string is given
	 *  to this function, it is first parsed into a markdown tree by calling
	 *  [[parse]].
	 **/
	expose.toHTMLTree = function toHTMLTree( input, dialect , options ) {
	  // convert string input to an MD tree
	  if ( typeof input ==="string" ) input = this.parse( input, dialect );
	
	  // Now convert the MD tree to an HTML tree
	
	  // remove references from the tree
	  var attrs = extract_attr( input ),
	      refs = {};
	
	  if ( attrs && attrs.references ) {
	    refs = attrs.references;
	  }
	
	  var html = convert_tree_to_html( input, refs , options );
	  merge_text_nodes( html );
	  return html;
	};
	
	// For Spidermonkey based engines
	function mk_block_toSource() {
	  return "Markdown.mk_block( " +
	          uneval(this.toString()) +
	          ", " +
	          uneval(this.trailing) +
	          ", " +
	          uneval(this.lineNumber) +
	          " )";
	}
	
	// node
	function mk_block_inspect() {
	  var util = __webpack_require__(562);
	  return "Markdown.mk_block( " +
	          util.inspect(this.toString()) +
	          ", " +
	          util.inspect(this.trailing) +
	          ", " +
	          util.inspect(this.lineNumber) +
	          " )";
	
	}
	
	var mk_block = Markdown.mk_block = function(block, trail, line) {
	  // Be helpful for default case in tests.
	  if ( arguments.length == 1 ) trail = "\n\n";
	
	  var s = new String(block);
	  s.trailing = trail;
	  // To make it clear its not just a string
	  s.inspect = mk_block_inspect;
	  s.toSource = mk_block_toSource;
	
	  if ( line != undefined )
	    s.lineNumber = line;
	
	  return s;
	};
	
	function count_lines( str ) {
	  var n = 0, i = -1;
	  while ( ( i = str.indexOf("\n", i + 1) ) !== -1 ) n++;
	  return n;
	}
	
	// Internal - split source into rough blocks
	Markdown.prototype.split_blocks = function splitBlocks( input, startLine ) {
	  input = input.replace(/(\r\n|\n|\r)/g, "\n");
	  // [\s\S] matches _anything_ (newline or space)
	  // [^] is equivalent but doesn't work in IEs.
	  var re = /([\s\S]+?)($|\n#|\n(?:\s*\n|$)+)/g,
	      blocks = [],
	      m;
	
	  var line_no = 1;
	
	  if ( ( m = /^(\s*\n)/.exec(input) ) != null ) {
	    // skip (but count) leading blank lines
	    line_no += count_lines( m[0] );
	    re.lastIndex = m[0].length;
	  }
	
	  while ( ( m = re.exec(input) ) !== null ) {
	    if (m[2] == "\n#") {
	      m[2] = "\n";
	      re.lastIndex--;
	    }
	    blocks.push( mk_block( m[1], m[2], line_no ) );
	    line_no += count_lines( m[0] );
	  }
	
	  return blocks;
	};
	
	/**
	 *  Markdown#processBlock( block, next ) -> undefined | [ JsonML, ... ]
	 *  - block (String): the block to process
	 *  - next (Array): the following blocks
	 *
	 * Process `block` and return an array of JsonML nodes representing `block`.
	 *
	 * It does this by asking each block level function in the dialect to process
	 * the block until one can. Succesful handling is indicated by returning an
	 * array (with zero or more JsonML nodes), failure by a false value.
	 *
	 * Blocks handlers are responsible for calling [[Markdown#processInline]]
	 * themselves as appropriate.
	 *
	 * If the blocks were split incorrectly or adjacent blocks need collapsing you
	 * can adjust `next` in place using shift/splice etc.
	 *
	 * If any of this default behaviour is not right for the dialect, you can
	 * define a `__call__` method on the dialect that will get invoked to handle
	 * the block processing.
	 */
	Markdown.prototype.processBlock = function processBlock( block, next ) {
	  var cbs = this.dialect.block,
	      ord = cbs.__order__;
	
	  if ( "__call__" in cbs ) {
	    return cbs.__call__.call(this, block, next);
	  }
	
	  for ( var i = 0; i < ord.length; i++ ) {
	    //D:this.debug( "Testing", ord[i] );
	    var res = cbs[ ord[i] ].call( this, block, next );
	    if ( res ) {
	      //D:this.debug("  matched");
	      if ( !isArray(res) || ( res.length > 0 && !( isArray(res[0]) ) ) )
	        this.debug(ord[i], "didn't return a proper array");
	      //D:this.debug( "" );
	      return res;
	    }
	  }
	
	  // Uhoh! no match! Should we throw an error?
	  return [];
	};
	
	Markdown.prototype.processInline = function processInline( block ) {
	  return this.dialect.inline.__call__.call( this, String( block ) );
	};
	
	/**
	 *  Markdown#toTree( source ) -> JsonML
	 *  - source (String): markdown source to parse
	 *
	 *  Parse `source` into a JsonML tree representing the markdown document.
	 **/
	// custom_tree means set this.tree to `custom_tree` and restore old value on return
	Markdown.prototype.toTree = function toTree( source, custom_root ) {
	  var blocks = source instanceof Array ? source : this.split_blocks( source );
	
	  // Make tree a member variable so its easier to mess with in extensions
	  var old_tree = this.tree;
	  try {
	    this.tree = custom_root || this.tree || [ "markdown" ];
	
	    blocks:
	    while ( blocks.length ) {
	      var b = this.processBlock( blocks.shift(), blocks );
	
	      // Reference blocks and the like won't return any content
	      if ( !b.length ) continue blocks;
	
	      this.tree.push.apply( this.tree, b );
	    }
	    return this.tree;
	  }
	  finally {
	    if ( custom_root ) {
	      this.tree = old_tree;
	    }
	  }
	};
	
	// Noop by default
	Markdown.prototype.debug = function () {
	  var args = Array.prototype.slice.call( arguments);
	  args.unshift(this.debug_indent);
	  if ( typeof print !== "undefined" )
	      print.apply( print, args );
	  if ( typeof console !== "undefined" && typeof console.log !== "undefined" )
	      console.log.apply( null, args );
	}
	
	Markdown.prototype.loop_re_over_block = function( re, block, cb ) {
	  // Dont use /g regexps with this
	  var m,
	      b = block.valueOf();
	
	  while ( b.length && (m = re.exec(b) ) != null ) {
	    b = b.substr( m[0].length );
	    cb.call(this, m);
	  }
	  return b;
	};
	
	/**
	 * Markdown.dialects
	 *
	 * Namespace of built-in dialects.
	 **/
	Markdown.dialects = {};
	
	/**
	 * Markdown.dialects.Gruber
	 *
	 * The default dialect that follows the rules set out by John Gruber's
	 * markdown.pl as closely as possible. Well actually we follow the behaviour of
	 * that script which in some places is not exactly what the syntax web page
	 * says.
	 **/
	Markdown.dialects.Gruber = {
	  block: {
	    atxHeader: function atxHeader( block, next ) {
	      var m = block.match( /^(#{1,6})\s*(.*?)\s*#*\s*(?:\n|$)/ );
	
	      if ( !m ) return undefined;
	
	      var header = [ "header", { level: m[ 1 ].length } ];
	      Array.prototype.push.apply(header, this.processInline(m[ 2 ]));
	
	      if ( m[0].length < block.length )
	        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );
	
	      return [ header ];
	    },
	
	    setextHeader: function setextHeader( block, next ) {
	      var m = block.match( /^(.*)\n([-=])\2\2+(?:\n|$)/ );
	
	      if ( !m ) return undefined;
	
	      var level = ( m[ 2 ] === "=" ) ? 1 : 2;
	      var header = [ "header", { level : level }, m[ 1 ] ];
	
	      if ( m[0].length < block.length )
	        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );
	
	      return [ header ];
	    },
	
	    code: function code( block, next ) {
	      // |    Foo
	      // |bar
	      // should be a code block followed by a paragraph. Fun
	      //
	      // There might also be adjacent code block to merge.
	
	      var ret = [],
	          re = /^(?: {0,3}\t| {4})(.*)\n?/,
	          lines;
	
	      // 4 spaces + content
	      if ( !block.match( re ) ) return undefined;
	
	      block_search:
	      do {
	        // Now pull out the rest of the lines
	        var b = this.loop_re_over_block(
	                  re, block.valueOf(), function( m ) { ret.push( m[1] ); } );
	
	        if ( b.length ) {
	          // Case alluded to in first comment. push it back on as a new block
	          next.unshift( mk_block(b, block.trailing) );
	          break block_search;
	        }
	        else if ( next.length ) {
	          // Check the next block - it might be code too
	          if ( !next[0].match( re ) ) break block_search;
	
	          // Pull how how many blanks lines follow - minus two to account for .join
	          ret.push ( block.trailing.replace(/[^\n]/g, "").substring(2) );
	
	          block = next.shift();
	        }
	        else {
	          break block_search;
	        }
	      } while ( true );
	
	      return [ [ "code_block", ret.join("\n") ] ];
	    },
	
	    horizRule: function horizRule( block, next ) {
	      // this needs to find any hr in the block to handle abutting blocks
	      var m = block.match( /^(?:([\s\S]*?)\n)?[ \t]*([-_*])(?:[ \t]*\2){2,}[ \t]*(?:\n([\s\S]*))?$/ );
	
	      if ( !m ) {
	        return undefined;
	      }
	
	      var jsonml = [ [ "hr" ] ];
	
	      // if there's a leading abutting block, process it
	      if ( m[ 1 ] ) {
	        jsonml.unshift.apply( jsonml, this.processBlock( m[ 1 ], [] ) );
	      }
	
	      // if there's a trailing abutting block, stick it into next
	      if ( m[ 3 ] ) {
	        next.unshift( mk_block( m[ 3 ] ) );
	      }
	
	      return jsonml;
	    },
	
	    // There are two types of lists. Tight and loose. Tight lists have no whitespace
	    // between the items (and result in text just in the <li>) and loose lists,
	    // which have an empty line between list items, resulting in (one or more)
	    // paragraphs inside the <li>.
	    //
	    // There are all sorts weird edge cases about the original markdown.pl's
	    // handling of lists:
	    //
	    // * Nested lists are supposed to be indented by four chars per level. But
	    //   if they aren't, you can get a nested list by indenting by less than
	    //   four so long as the indent doesn't match an indent of an existing list
	    //   item in the 'nest stack'.
	    //
	    // * The type of the list (bullet or number) is controlled just by the
	    //    first item at the indent. Subsequent changes are ignored unless they
	    //    are for nested lists
	    //
	    lists: (function( ) {
	      // Use a closure to hide a few variables.
	      var any_list = "[*+-]|\\d+\\.",
	          bullet_list = /[*+-]/,
	          number_list = /\d+\./,
	          // Capture leading indent as it matters for determining nested lists.
	          is_list_re = new RegExp( "^( {0,3})(" + any_list + ")[ \t]+" ),
	          indent_re = "(?: {0,3}\\t| {4})";
	
	      // TODO: Cache this regexp for certain depths.
	      // Create a regexp suitable for matching an li for a given stack depth
	      function regex_for_depth( depth ) {
	
	        return new RegExp(
	          // m[1] = indent, m[2] = list_type
	          "(?:^(" + indent_re + "{0," + depth + "} {0,3})(" + any_list + ")\\s+)|" +
	          // m[3] = cont
	          "(^" + indent_re + "{0," + (depth-1) + "}[ ]{0,4})"
	        );
	      }
	      function expand_tab( input ) {
	        return input.replace( / {0,3}\t/g, "    " );
	      }
	
	      // Add inline content `inline` to `li`. inline comes from processInline
	      // so is an array of content
	      function add(li, loose, inline, nl) {
	        if ( loose ) {
	          li.push( [ "para" ].concat(inline) );
	          return;
	        }
	        // Hmmm, should this be any block level element or just paras?
	        var add_to = li[li.length -1] instanceof Array && li[li.length - 1][0] == "para"
	                   ? li[li.length -1]
	                   : li;
	
	        // If there is already some content in this list, add the new line in
	        if ( nl && li.length > 1 ) inline.unshift(nl);
	
	        for ( var i = 0; i < inline.length; i++ ) {
	          var what = inline[i],
	              is_str = typeof what == "string";
	          if ( is_str && add_to.length > 1 && typeof add_to[add_to.length-1] == "string" ) {
	            add_to[ add_to.length-1 ] += what;
	          }
	          else {
	            add_to.push( what );
	          }
	        }
	      }
	
	      // contained means have an indent greater than the current one. On
	      // *every* line in the block
	      function get_contained_blocks( depth, blocks ) {
	
	        var re = new RegExp( "^(" + indent_re + "{" + depth + "}.*?\\n?)*$" ),
	            replace = new RegExp("^" + indent_re + "{" + depth + "}", "gm"),
	            ret = [];
	
	        while ( blocks.length > 0 ) {
	          if ( re.exec( blocks[0] ) ) {
	            var b = blocks.shift(),
	                // Now remove that indent
	                x = b.replace( replace, "");
	
	            ret.push( mk_block( x, b.trailing, b.lineNumber ) );
	          }
	          else {
	            break;
	          }
	        }
	        return ret;
	      }
	
	      // passed to stack.forEach to turn list items up the stack into paras
	      function paragraphify(s, i, stack) {
	        var list = s.list;
	        var last_li = list[list.length-1];
	
	        if ( last_li[1] instanceof Array && last_li[1][0] == "para" ) {
	          return;
	        }
	        if ( i + 1 == stack.length ) {
	          // Last stack frame
	          // Keep the same array, but replace the contents
	          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ) );
	        }
	        else {
	          var sublist = last_li.pop();
	          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ), sublist );
	        }
	      }
	
	      // The matcher function
	      return function( block, next ) {
	        var m = block.match( is_list_re );
	        if ( !m ) return undefined;
	
	        function make_list( m ) {
	          var list = bullet_list.exec( m[2] )
	                   ? ["bulletlist"]
	                   : ["numberlist"];
	
	          stack.push( { list: list, indent: m[1] } );
	          return list;
	        }
	
	
	        var stack = [], // Stack of lists for nesting.
	            list = make_list( m ),
	            last_li,
	            loose = false,
	            ret = [ stack[0].list ],
	            i;
	
	        // Loop to search over block looking for inner block elements and loose lists
	        loose_search:
	        while ( true ) {
	          // Split into lines preserving new lines at end of line
	          var lines = block.split( /(?=\n)/ );
	
	          // We have to grab all lines for a li and call processInline on them
	          // once as there are some inline things that can span lines.
	          var li_accumulate = "";
	
	          // Loop over the lines in this block looking for tight lists.
	          tight_search:
	          for ( var line_no = 0; line_no < lines.length; line_no++ ) {
	            var nl = "",
	                l = lines[line_no].replace(/^\n/, function(n) { nl = n; return ""; });
	
	            // TODO: really should cache this
	            var line_re = regex_for_depth( stack.length );
	
	            m = l.match( line_re );
	            //print( "line:", uneval(l), "\nline match:", uneval(m) );
	
	            // We have a list item
	            if ( m[1] !== undefined ) {
	              // Process the previous list item, if any
	              if ( li_accumulate.length ) {
	                add( last_li, loose, this.processInline( li_accumulate ), nl );
	                // Loose mode will have been dealt with. Reset it
	                loose = false;
	                li_accumulate = "";
	              }
	
	              m[1] = expand_tab( m[1] );
	              var wanted_depth = Math.floor(m[1].length/4)+1;
	              //print( "want:", wanted_depth, "stack:", stack.length);
	              if ( wanted_depth > stack.length ) {
	                // Deep enough for a nested list outright
	                //print ( "new nested list" );
	                list = make_list( m );
	                last_li.push( list );
	                last_li = list[1] = [ "listitem" ];
	              }
	              else {
	                // We aren't deep enough to be strictly a new level. This is
	                // where Md.pl goes nuts. If the indent matches a level in the
	                // stack, put it there, else put it one deeper then the
	                // wanted_depth deserves.
	                var found = false;
	                for ( i = 0; i < stack.length; i++ ) {
	                  if ( stack[ i ].indent != m[1] ) continue;
	                  list = stack[ i ].list;
	                  stack.splice( i+1, stack.length - (i+1) );
	                  found = true;
	                  break;
	                }
	
	                if (!found) {
	                  //print("not found. l:", uneval(l));
	                  wanted_depth++;
	                  if ( wanted_depth <= stack.length ) {
	                    stack.splice(wanted_depth, stack.length - wanted_depth);
	                    //print("Desired depth now", wanted_depth, "stack:", stack.length);
	                    list = stack[wanted_depth-1].list;
	                    //print("list:", uneval(list) );
	                  }
	                  else {
	                    //print ("made new stack for messy indent");
	                    list = make_list(m);
	                    last_li.push(list);
	                  }
	                }
	
	                //print( uneval(list), "last", list === stack[stack.length-1].list );
	                last_li = [ "listitem" ];
	                list.push(last_li);
	              } // end depth of shenegains
	              nl = "";
	            }
	
	            // Add content
	            if ( l.length > m[0].length ) {
	              li_accumulate += nl + l.substr( m[0].length );
	            }
	          } // tight_search
	
	          if ( li_accumulate.length ) {
	            add( last_li, loose, this.processInline( li_accumulate ), nl );
	            // Loose mode will have been dealt with. Reset it
	            loose = false;
	            li_accumulate = "";
	          }
	
	          // Look at the next block - we might have a loose list. Or an extra
	          // paragraph for the current li
	          var contained = get_contained_blocks( stack.length, next );
	
	          // Deal with code blocks or properly nested lists
	          if ( contained.length > 0 ) {
	            // Make sure all listitems up the stack are paragraphs
	            forEach( stack, paragraphify, this);
	
	            last_li.push.apply( last_li, this.toTree( contained, [] ) );
	          }
	
	          var next_block = next[0] && next[0].valueOf() || "";
	
	          if ( next_block.match(is_list_re) || next_block.match( /^ / ) ) {
	            block = next.shift();
	
	            // Check for an HR following a list: features/lists/hr_abutting
	            var hr = this.dialect.block.horizRule( block, next );
	
	            if ( hr ) {
	              ret.push.apply(ret, hr);
	              break;
	            }
	
	            // Make sure all listitems up the stack are paragraphs
	            forEach( stack, paragraphify, this);
	
	            loose = true;
	            continue loose_search;
	          }
	          break;
	        } // loose_search
	
	        return ret;
	      };
	    })(),
	
	    blockquote: function blockquote( block, next ) {
	      if ( !block.match( /^>/m ) )
	        return undefined;
	
	      var jsonml = [];
	
	      // separate out the leading abutting block, if any. I.e. in this case:
	      //
	      //  a
	      //  > b
	      //
	      if ( block[ 0 ] != ">" ) {
	        var lines = block.split( /\n/ ),
	            prev = [],
	            line_no = block.lineNumber;
	
	        // keep shifting lines until you find a crotchet
	        while ( lines.length && lines[ 0 ][ 0 ] != ">" ) {
	            prev.push( lines.shift() );
	            line_no++;
	        }
	
	        var abutting = mk_block( prev.join( "\n" ), "\n", block.lineNumber );
	        jsonml.push.apply( jsonml, this.processBlock( abutting, [] ) );
	        // reassemble new block of just block quotes!
	        block = mk_block( lines.join( "\n" ), block.trailing, line_no );
	      }
	
	
	      // if the next block is also a blockquote merge it in
	      while ( next.length && next[ 0 ][ 0 ] == ">" ) {
	        var b = next.shift();
	        block = mk_block( block + block.trailing + b, b.trailing, block.lineNumber );
	      }
	
	      // Strip off the leading "> " and re-process as a block.
	      var input = block.replace( /^> ?/gm, "" ),
	          old_tree = this.tree,
	          processedBlock = this.toTree( input, [ "blockquote" ] ),
	          attr = extract_attr( processedBlock );
	
	      // If any link references were found get rid of them
	      if ( attr && attr.references ) {
	        delete attr.references;
	        // And then remove the attribute object if it's empty
	        if ( isEmpty( attr ) ) {
	          processedBlock.splice( 1, 1 );
	        }
	      }
	
	      jsonml.push( processedBlock );
	      return jsonml;
	    },
	
	    referenceDefn: function referenceDefn( block, next) {
	      var re = /^\s*\[(.*?)\]:\s*(\S+)(?:\s+(?:(['"])(.*?)\3|\((.*?)\)))?\n?/;
	      // interesting matches are [ , ref_id, url, , title, title ]
	
	      if ( !block.match(re) )
	        return undefined;
	
	      // make an attribute node if it doesn't exist
	      if ( !extract_attr( this.tree ) ) {
	        this.tree.splice( 1, 0, {} );
	      }
	
	      var attrs = extract_attr( this.tree );
	
	      // make a references hash if it doesn't exist
	      if ( attrs.references === undefined ) {
	        attrs.references = {};
	      }
	
	      var b = this.loop_re_over_block(re, block, function( m ) {
	
	        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
	          m[2] = m[2].substring( 1, m[2].length - 1 );
	
	        var ref = attrs.references[ m[1].toLowerCase() ] = {
	          href: m[2]
	        };
	
	        if ( m[4] !== undefined )
	          ref.title = m[4];
	        else if ( m[5] !== undefined )
	          ref.title = m[5];
	
	      } );
	
	      if ( b.length )
	        next.unshift( mk_block( b, block.trailing ) );
	
	      return [];
	    },
	
	    para: function para( block, next ) {
	      // everything's a para!
	      return [ ["para"].concat( this.processInline( block ) ) ];
	    }
	  }
	};
	
	Markdown.dialects.Gruber.inline = {
	
	    __oneElement__: function oneElement( text, patterns_or_re, previous_nodes ) {
	      var m,
	          res,
	          lastIndex = 0;
	
	      patterns_or_re = patterns_or_re || this.dialect.inline.__patterns__;
	      var re = new RegExp( "([\\s\\S]*?)(" + (patterns_or_re.source || patterns_or_re) + ")" );
	
	      m = re.exec( text );
	      if (!m) {
	        // Just boring text
	        return [ text.length, text ];
	      }
	      else if ( m[1] ) {
	        // Some un-interesting text matched. Return that first
	        return [ m[1].length, m[1] ];
	      }
	
	      var res;
	      if ( m[2] in this.dialect.inline ) {
	        res = this.dialect.inline[ m[2] ].call(
	                  this,
	                  text.substr( m.index ), m, previous_nodes || [] );
	      }
	      // Default for now to make dev easier. just slurp special and output it.
	      res = res || [ m[2].length, m[2] ];
	      return res;
	    },
	
	    __call__: function inline( text, patterns ) {
	
	      var out = [],
	          res;
	
	      function add(x) {
	        //D:self.debug("  adding output", uneval(x));
	        if ( typeof x == "string" && typeof out[out.length-1] == "string" )
	          out[ out.length-1 ] += x;
	        else
	          out.push(x);
	      }
	
	      while ( text.length > 0 ) {
	        res = this.dialect.inline.__oneElement__.call(this, text, patterns, out );
	        text = text.substr( res.shift() );
	        forEach(res, add )
	      }
	
	      return out;
	    },
	
	    // These characters are intersting elsewhere, so have rules for them so that
	    // chunks of plain text blocks don't include them
	    "]": function () {},
	    "}": function () {},
	
	    __escape__ : /^\\[\\`\*_{}\[\]()#\+.!\-]/,
	
	    "\\": function escaped( text ) {
	      // [ length of input processed, node/children to add... ]
	      // Only esacape: \ ` * _ { } [ ] ( ) # * + - . !
	      if ( this.dialect.inline.__escape__.exec( text ) )
	        return [ 2, text.charAt( 1 ) ];
	      else
	        // Not an esacpe
	        return [ 1, "\\" ];
	    },
	
	    "![": function image( text ) {
	
	      // Unlike images, alt text is plain text only. no other elements are
	      // allowed in there
	
	      // ![Alt text](/path/to/img.jpg "Optional title")
	      //      1          2            3       4         <--- captures
	      var m = text.match( /^!\[(.*?)\][ \t]*\([ \t]*([^")]*?)(?:[ \t]+(["'])(.*?)\3)?[ \t]*\)/ );
	
	      if ( m ) {
	        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
	          m[2] = m[2].substring( 1, m[2].length - 1 );
	
	        m[2] = this.dialect.inline.__call__.call( this, m[2], /\\/ )[0];
	
	        var attrs = { alt: m[1], href: m[2] || "" };
	        if ( m[4] !== undefined)
	          attrs.title = m[4];
	
	        return [ m[0].length, [ "img", attrs ] ];
	      }
	
	      // ![Alt text][id]
	      m = text.match( /^!\[(.*?)\][ \t]*\[(.*?)\]/ );
	
	      if ( m ) {
	        // We can't check if the reference is known here as it likely wont be
	        // found till after. Check it in md tree->hmtl tree conversion
	        return [ m[0].length, [ "img_ref", { alt: m[1], ref: m[2].toLowerCase(), original: m[0] } ] ];
	      }
	
	      // Just consume the '!['
	      return [ 2, "![" ];
	    },
	
	    "[": function link( text ) {
	
	      var orig = String(text);
	      // Inline content is possible inside `link text`
	      var res = Markdown.DialectHelpers.inline_until_char.call( this, text.substr(1), "]" );
	
	      // No closing ']' found. Just consume the [
	      if ( !res ) return [ 1, "[" ];
	
	      var consumed = 1 + res[ 0 ],
	          children = res[ 1 ],
	          link,
	          attrs;
	
	      // At this point the first [...] has been parsed. See what follows to find
	      // out which kind of link we are (reference or direct url)
	      text = text.substr( consumed );
	
	      // [link text](/path/to/img.jpg "Optional title")
	      //                 1            2       3         <--- captures
	      // This will capture up to the last paren in the block. We then pull
	      // back based on if there a matching ones in the url
	      //    ([here](/url/(test))
	      // The parens have to be balanced
	      var m = text.match( /^\s*\([ \t]*([^"']*)(?:[ \t]+(["'])(.*?)\2)?[ \t]*\)/ );
	      if ( m ) {
	        var url = m[1];
	        consumed += m[0].length;
	
	        if ( url && url[0] == "<" && url[url.length-1] == ">" )
	          url = url.substring( 1, url.length - 1 );
	
	        // If there is a title we don't have to worry about parens in the url
	        if ( !m[3] ) {
	          var open_parens = 1; // One open that isn't in the capture
	          for ( var len = 0; len < url.length; len++ ) {
	            switch ( url[len] ) {
	            case "(":
	              open_parens++;
	              break;
	            case ")":
	              if ( --open_parens == 0) {
	                consumed -= url.length - len;
	                url = url.substring(0, len);
	              }
	              break;
	            }
	          }
	        }
	
	        // Process escapes only
	        url = this.dialect.inline.__call__.call( this, url, /\\/ )[0];
	
	        attrs = { href: url || "" };
	        if ( m[3] !== undefined)
	          attrs.title = m[3];
	
	        link = [ "link", attrs ].concat( children );
	        return [ consumed, link ];
	      }
	
	      // [Alt text][id]
	      // [Alt text] [id]
	      m = text.match( /^\s*\[(.*?)\]/ );
	
	      if ( m ) {
	
	        consumed += m[ 0 ].length;
	
	        // [links][] uses links as its reference
	        attrs = { ref: ( m[ 1 ] || String(children) ).toLowerCase(),  original: orig.substr( 0, consumed ) };
	
	        link = [ "link_ref", attrs ].concat( children );
	
	        // We can't check if the reference is known here as it likely wont be
	        // found till after. Check it in md tree->hmtl tree conversion.
	        // Store the original so that conversion can revert if the ref isn't found.
	        return [ consumed, link ];
	      }
	
	      // [id]
	      // Only if id is plain (no formatting.)
	      if ( children.length == 1 && typeof children[0] == "string" ) {
	
	        attrs = { ref: children[0].toLowerCase(),  original: orig.substr( 0, consumed ) };
	        link = [ "link_ref", attrs, children[0] ];
	        return [ consumed, link ];
	      }
	
	      // Just consume the "["
	      return [ 1, "[" ];
	    },
	
	
	    "<": function autoLink( text ) {
	      var m;
	
	      if ( ( m = text.match( /^<(?:((https?|ftp|mailto):[^>]+)|(.*?@.*?\.[a-zA-Z]+))>/ ) ) != null ) {
	        if ( m[3] ) {
	          return [ m[0].length, [ "link", { href: "mailto:" + m[3] }, m[3] ] ];
	
	        }
	        else if ( m[2] == "mailto" ) {
	          return [ m[0].length, [ "link", { href: m[1] }, m[1].substr("mailto:".length ) ] ];
	        }
	        else
	          return [ m[0].length, [ "link", { href: m[1] }, m[1] ] ];
	      }
	
	      return [ 1, "<" ];
	    },
	
	    "`": function inlineCode( text ) {
	      // Inline code block. as many backticks as you like to start it
	      // Always skip over the opening ticks.
	      var m = text.match( /(`+)(([\s\S]*?)\1)/ );
	
	      if ( m && m[2] )
	        return [ m[1].length + m[2].length, [ "inlinecode", m[3] ] ];
	      else {
	        // TODO: No matching end code found - warn!
	        return [ 1, "`" ];
	      }
	    },
	
	    "  \n": function lineBreak( text ) {
	      return [ 3, [ "linebreak" ] ];
	    }
	
	};
	
	// Meta Helper/generator method for em and strong handling
	function strong_em( tag, md ) {
	
	  var state_slot = tag + "_state",
	      other_slot = tag == "strong" ? "em_state" : "strong_state";
	
	  function CloseTag(len) {
	    this.len_after = len;
	    this.name = "close_" + md;
	  }
	
	  return function ( text, orig_match ) {
	
	    if ( this[state_slot][0] == md ) {
	      // Most recent em is of this type
	      //D:this.debug("closing", md);
	      this[state_slot].shift();
	
	      // "Consume" everything to go back to the recrusion in the else-block below
	      return[ text.length, new CloseTag(text.length-md.length) ];
	    }
	    else {
	      // Store a clone of the em/strong states
	      var other = this[other_slot].slice(),
	          state = this[state_slot].slice();
	
	      this[state_slot].unshift(md);
	
	      //D:this.debug_indent += "  ";
	
	      // Recurse
	      var res = this.processInline( text.substr( md.length ) );
	      //D:this.debug_indent = this.debug_indent.substr(2);
	
	      var last = res[res.length - 1];
	
	      //D:this.debug("processInline from", tag + ": ", uneval( res ) );
	
	      var check = this[state_slot].shift();
	      if ( last instanceof CloseTag ) {
	        res.pop();
	        // We matched! Huzzah.
	        var consumed = text.length - last.len_after;
	        return [ consumed, [ tag ].concat(res) ];
	      }
	      else {
	        // Restore the state of the other kind. We might have mistakenly closed it.
	        this[other_slot] = other;
	        this[state_slot] = state;
	
	        // We can't reuse the processed result as it could have wrong parsing contexts in it.
	        return [ md.length, md ];
	      }
	    }
	  }; // End returned function
	}
	
	Markdown.dialects.Gruber.inline["**"] = strong_em("strong", "**");
	Markdown.dialects.Gruber.inline["__"] = strong_em("strong", "__");
	Markdown.dialects.Gruber.inline["*"]  = strong_em("em", "*");
	Markdown.dialects.Gruber.inline["_"]  = strong_em("em", "_");
	
	
	// Build default order from insertion order.
	Markdown.buildBlockOrder = function(d) {
	  var ord = [];
	  for ( var i in d ) {
	    if ( i == "__order__" || i == "__call__" ) continue;
	    ord.push( i );
	  }
	  d.__order__ = ord;
	};
	
	// Build patterns for inline matcher
	Markdown.buildInlinePatterns = function(d) {
	  var patterns = [];
	
	  for ( var i in d ) {
	    // __foo__ is reserved and not a pattern
	    if ( i.match( /^__.*__$/) ) continue;
	    var l = i.replace( /([\\.*+?|()\[\]{}])/g, "\\$1" )
	             .replace( /\n/, "\\n" );
	    patterns.push( i.length == 1 ? l : "(?:" + l + ")" );
	  }
	
	  patterns = patterns.join("|");
	  d.__patterns__ = patterns;
	  //print("patterns:", uneval( patterns ) );
	
	  var fn = d.__call__;
	  d.__call__ = function(text, pattern) {
	    if ( pattern != undefined ) {
	      return fn.call(this, text, pattern);
	    }
	    else
	    {
	      return fn.call(this, text, patterns);
	    }
	  };
	};
	
	Markdown.DialectHelpers = {};
	Markdown.DialectHelpers.inline_until_char = function( text, want ) {
	  var consumed = 0,
	      nodes = [];
	
	  while ( true ) {
	    if ( text.charAt( consumed ) == want ) {
	      // Found the character we were looking for
	      consumed++;
	      return [ consumed, nodes ];
	    }
	
	    if ( consumed >= text.length ) {
	      // No closing char found. Abort.
	      return null;
	    }
	
	    var res = this.dialect.inline.__oneElement__.call(this, text.substr( consumed ) );
	    consumed += res[ 0 ];
	    // Add any returned nodes.
	    nodes.push.apply( nodes, res.slice( 1 ) );
	  }
	}
	
	// Helper function to make sub-classing a dialect easier
	Markdown.subclassDialect = function( d ) {
	  function Block() {}
	  Block.prototype = d.block;
	  function Inline() {}
	  Inline.prototype = d.inline;
	
	  return { block: new Block(), inline: new Inline() };
	};
	
	Markdown.buildBlockOrder ( Markdown.dialects.Gruber.block );
	Markdown.buildInlinePatterns( Markdown.dialects.Gruber.inline );
	
	Markdown.dialects.Maruku = Markdown.subclassDialect( Markdown.dialects.Gruber );
	
	Markdown.dialects.Maruku.processMetaHash = function processMetaHash( meta_string ) {
	  var meta = split_meta_hash( meta_string ),
	      attr = {};
	
	  for ( var i = 0; i < meta.length; ++i ) {
	    // id: #foo
	    if ( /^#/.test( meta[ i ] ) ) {
	      attr.id = meta[ i ].substring( 1 );
	    }
	    // class: .foo
	    else if ( /^\./.test( meta[ i ] ) ) {
	      // if class already exists, append the new one
	      if ( attr["class"] ) {
	        attr["class"] = attr["class"] + meta[ i ].replace( /./, " " );
	      }
	      else {
	        attr["class"] = meta[ i ].substring( 1 );
	      }
	    }
	    // attribute: foo=bar
	    else if ( /\=/.test( meta[ i ] ) ) {
	      var s = meta[ i ].split( /\=/ );
	      attr[ s[ 0 ] ] = s[ 1 ];
	    }
	  }
	
	  return attr;
	}
	
	function split_meta_hash( meta_string ) {
	  var meta = meta_string.split( "" ),
	      parts = [ "" ],
	      in_quotes = false;
	
	  while ( meta.length ) {
	    var letter = meta.shift();
	    switch ( letter ) {
	      case " " :
	        // if we're in a quoted section, keep it
	        if ( in_quotes ) {
	          parts[ parts.length - 1 ] += letter;
	        }
	        // otherwise make a new part
	        else {
	          parts.push( "" );
	        }
	        break;
	      case "'" :
	      case '"' :
	        // reverse the quotes and move straight on
	        in_quotes = !in_quotes;
	        break;
	      case "\\" :
	        // shift off the next letter to be used straight away.
	        // it was escaped so we'll keep it whatever it is
	        letter = meta.shift();
	      default :
	        parts[ parts.length - 1 ] += letter;
	        break;
	    }
	  }
	
	  return parts;
	}
	
	Markdown.dialects.Maruku.block.document_meta = function document_meta( block, next ) {
	  // we're only interested in the first block
	  if ( block.lineNumber > 1 ) return undefined;
	
	  // document_meta blocks consist of one or more lines of `Key: Value\n`
	  if ( ! block.match( /^(?:\w+:.*\n)*\w+:.*$/ ) ) return undefined;
	
	  // make an attribute node if it doesn't exist
	  if ( !extract_attr( this.tree ) ) {
	    this.tree.splice( 1, 0, {} );
	  }
	
	  var pairs = block.split( /\n/ );
	  for ( p in pairs ) {
	    var m = pairs[ p ].match( /(\w+):\s*(.*)$/ ),
	        key = m[ 1 ].toLowerCase(),
	        value = m[ 2 ];
	
	    this.tree[ 1 ][ key ] = value;
	  }
	
	  // document_meta produces no content!
	  return [];
	};
	
	Markdown.dialects.Maruku.block.block_meta = function block_meta( block, next ) {
	  // check if the last line of the block is an meta hash
	  var m = block.match( /(^|\n) {0,3}\{:\s*((?:\\\}|[^\}])*)\s*\}$/ );
	  if ( !m ) return undefined;
	
	  // process the meta hash
	  var attr = this.dialect.processMetaHash( m[ 2 ] );
	
	  var hash;
	
	  // if we matched ^ then we need to apply meta to the previous block
	  if ( m[ 1 ] === "" ) {
	    var node = this.tree[ this.tree.length - 1 ];
	    hash = extract_attr( node );
	
	    // if the node is a string (rather than JsonML), bail
	    if ( typeof node === "string" ) return undefined;
	
	    // create the attribute hash if it doesn't exist
	    if ( !hash ) {
	      hash = {};
	      node.splice( 1, 0, hash );
	    }
	
	    // add the attributes in
	    for ( a in attr ) {
	      hash[ a ] = attr[ a ];
	    }
	
	    // return nothing so the meta hash is removed
	    return [];
	  }
	
	  // pull the meta hash off the block and process what's left
	  var b = block.replace( /\n.*$/, "" ),
	      result = this.processBlock( b, [] );
	
	  // get or make the attributes hash
	  hash = extract_attr( result[ 0 ] );
	  if ( !hash ) {
	    hash = {};
	    result[ 0 ].splice( 1, 0, hash );
	  }
	
	  // attach the attributes to the block
	  for ( a in attr ) {
	    hash[ a ] = attr[ a ];
	  }
	
	  return result;
	};
	
	Markdown.dialects.Maruku.block.definition_list = function definition_list( block, next ) {
	  // one or more terms followed by one or more definitions, in a single block
	  var tight = /^((?:[^\s:].*\n)+):\s+([\s\S]+)$/,
	      list = [ "dl" ],
	      i, m;
	
	  // see if we're dealing with a tight or loose block
	  if ( ( m = block.match( tight ) ) ) {
	    // pull subsequent tight DL blocks out of `next`
	    var blocks = [ block ];
	    while ( next.length && tight.exec( next[ 0 ] ) ) {
	      blocks.push( next.shift() );
	    }
	
	    for ( var b = 0; b < blocks.length; ++b ) {
	      var m = blocks[ b ].match( tight ),
	          terms = m[ 1 ].replace( /\n$/, "" ).split( /\n/ ),
	          defns = m[ 2 ].split( /\n:\s+/ );
	
	      // print( uneval( m ) );
	
	      for ( i = 0; i < terms.length; ++i ) {
	        list.push( [ "dt", terms[ i ] ] );
	      }
	
	      for ( i = 0; i < defns.length; ++i ) {
	        // run inline processing over the definition
	        list.push( [ "dd" ].concat( this.processInline( defns[ i ].replace( /(\n)\s+/, "$1" ) ) ) );
	      }
	    }
	  }
	  else {
	    return undefined;
	  }
	
	  return [ list ];
	};
	
	// splits on unescaped instances of @ch. If @ch is not a character the result
	// can be unpredictable
	
	Markdown.dialects.Maruku.block.table = function table (block, next) {
	
	    var _split_on_unescaped = function(s, ch) {
	        ch = ch || '\\s';
	        if (ch.match(/^[\\|\[\]{}?*.+^$]$/)) { ch = '\\' + ch; }
	        var res = [ ],
	            r = new RegExp('^((?:\\\\.|[^\\\\' + ch + '])*)' + ch + '(.*)'),
	            m;
	        while(m = s.match(r)) {
	            res.push(m[1]);
	            s = m[2];
	        }
	        res.push(s);
	        return res;
	    }
	
	    var leading_pipe = /^ {0,3}\|(.+)\n {0,3}\|\s*([\-:]+[\-| :]*)\n((?:\s*\|.*(?:\n|$))*)(?=\n|$)/,
	        // find at least an unescaped pipe in each line
	        no_leading_pipe = /^ {0,3}(\S(?:\\.|[^\\|])*\|.*)\n {0,3}([\-:]+\s*\|[\-| :]*)\n((?:(?:\\.|[^\\|])*\|.*(?:\n|$))*)(?=\n|$)/,
	        i, m;
	    if (m = block.match(leading_pipe)) {
	        // remove leading pipes in contents
	        // (header and horizontal rule already have the leading pipe left out)
	        m[3] = m[3].replace(/^\s*\|/gm, '');
	    } else if (! ( m = block.match(no_leading_pipe))) {
	        return undefined;
	    }
	
	    var table = [ "table", [ "thead", [ "tr" ] ], [ "tbody" ] ];
	
	    // remove trailing pipes, then split on pipes
	    // (no escaped pipes are allowed in horizontal rule)
	    m[2] = m[2].replace(/\|\s*$/, '').split('|');
	
	    // process alignment
	    var html_attrs = [ ];
	    forEach (m[2], function (s) {
	        if (s.match(/^\s*-+:\s*$/))       html_attrs.push({align: "right"});
	        else if (s.match(/^\s*:-+\s*$/))  html_attrs.push({align: "left"});
	        else if (s.match(/^\s*:-+:\s*$/)) html_attrs.push({align: "center"});
	        else                              html_attrs.push({});
	    });
	
	    // now for the header, avoid escaped pipes
	    m[1] = _split_on_unescaped(m[1].replace(/\|\s*$/, ''), '|');
	    for (i = 0; i < m[1].length; i++) {
	        table[1][1].push(['th', html_attrs[i] || {}].concat(
	            this.processInline(m[1][i].trim())));
	    }
	
	    // now for body contents
	    forEach (m[3].replace(/\|\s*$/mg, '').split('\n'), function (row) {
	        var html_row = ['tr'];
	        row = _split_on_unescaped(row, '|');
	        for (i = 0; i < row.length; i++) {
	            html_row.push(['td', html_attrs[i] || {}].concat(this.processInline(row[i].trim())));
	        }
	        table[2].push(html_row);
	    }, this);
	
	    return [table];
	}
	
	Markdown.dialects.Maruku.inline[ "{:" ] = function inline_meta( text, matches, out ) {
	  if ( !out.length ) {
	    return [ 2, "{:" ];
	  }
	
	  // get the preceeding element
	  var before = out[ out.length - 1 ];
	
	  if ( typeof before === "string" ) {
	    return [ 2, "{:" ];
	  }
	
	  // match a meta hash
	  var m = text.match( /^\{:\s*((?:\\\}|[^\}])*)\s*\}/ );
	
	  // no match, false alarm
	  if ( !m ) {
	    return [ 2, "{:" ];
	  }
	
	  // attach the attributes to the preceeding element
	  var meta = this.dialect.processMetaHash( m[ 1 ] ),
	      attr = extract_attr( before );
	
	  if ( !attr ) {
	    attr = {};
	    before.splice( 1, 0, attr );
	  }
	
	  for ( var k in meta ) {
	    attr[ k ] = meta[ k ];
	  }
	
	  // cut out the string and replace it with nothing
	  return [ m[ 0 ].length, "" ];
	};
	
	Markdown.dialects.Maruku.inline.__escape__ = /^\\[\\`\*_{}\[\]()#\+.!\-|:]/;
	
	Markdown.buildBlockOrder ( Markdown.dialects.Maruku.block );
	Markdown.buildInlinePatterns( Markdown.dialects.Maruku.inline );
	
	var isArray = Array.isArray || function(obj) {
	  return Object.prototype.toString.call(obj) == "[object Array]";
	};
	
	var forEach;
	// Don't mess with Array.prototype. Its not friendly
	if ( Array.prototype.forEach ) {
	  forEach = function( arr, cb, thisp ) {
	    return arr.forEach( cb, thisp );
	  };
	}
	else {
	  forEach = function(arr, cb, thisp) {
	    for (var i = 0; i < arr.length; i++) {
	      cb.call(thisp || arr, arr[i], i, arr);
	    }
	  }
	}
	
	var isEmpty = function( obj ) {
	  for ( var key in obj ) {
	    if ( hasOwnProperty.call( obj, key ) ) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function extract_attr( jsonml ) {
	  return isArray(jsonml)
	      && jsonml.length > 1
	      && typeof jsonml[ 1 ] === "object"
	      && !( isArray(jsonml[ 1 ]) )
	      ? jsonml[ 1 ]
	      : undefined;
	}
	
	
	
	/**
	 *  renderJsonML( jsonml[, options] ) -> String
	 *  - jsonml (Array): JsonML array to render to XML
	 *  - options (Object): options
	 *
	 *  Converts the given JsonML into well-formed XML.
	 *
	 *  The options currently understood are:
	 *
	 *  - root (Boolean): wether or not the root node should be included in the
	 *    output, or just its children. The default `false` is to not include the
	 *    root itself.
	 */
	expose.renderJsonML = function( jsonml, options ) {
	  options = options || {};
	  // include the root element in the rendered output?
	  options.root = options.root || false;
	
	  var content = [];
	
	  if ( options.root ) {
	    content.push( render_tree( jsonml ) );
	  }
	  else {
	    jsonml.shift(); // get rid of the tag
	    if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
	      jsonml.shift(); // get rid of the attributes
	    }
	
	    while ( jsonml.length ) {
	      content.push( render_tree( jsonml.shift() ) );
	    }
	  }
	
	  return content.join( "\n\n" );
	};
	
	function escapeHTML( text ) {
	  return text.replace( /&/g, "&amp;" )
	             .replace( /</g, "&lt;" )
	             .replace( />/g, "&gt;" )
	             .replace( /"/g, "&quot;" )
	             .replace( /'/g, "&#39;" );
	}
	
	function render_tree( jsonml ) {
	  // basic case
	  if ( typeof jsonml === "string" ) {
	    return escapeHTML( jsonml );
	  }
	
	  var tag = jsonml.shift(),
	      attributes = {},
	      content = [];
	
	  if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
	    attributes = jsonml.shift();
	  }
	
	  while ( jsonml.length ) {
	    content.push( render_tree( jsonml.shift() ) );
	  }
	
	  var tag_attrs = "";
	  for ( var a in attributes ) {
	    tag_attrs += " " + a + '="' + escapeHTML( attributes[ a ] ) + '"';
	  }
	
	  // be careful about adding whitespace here for inline elements
	  if ( tag == "img" || tag == "br" || tag == "hr" ) {
	    return "<"+ tag + tag_attrs + "/>";
	  }
	  else {
	    return "<"+ tag + tag_attrs + ">" + content.join( "" ) + "</" + tag + ">";
	  }
	}
	
	function convert_tree_to_html( tree, references, options ) {
	  var i;
	  options = options || {};
	
	  // shallow clone
	  var jsonml = tree.slice( 0 );
	
	  if ( typeof options.preprocessTreeNode === "function" ) {
	      jsonml = options.preprocessTreeNode(jsonml, references);
	  }
	
	  // Clone attributes if they exist
	  var attrs = extract_attr( jsonml );
	  if ( attrs ) {
	    jsonml[ 1 ] = {};
	    for ( i in attrs ) {
	      jsonml[ 1 ][ i ] = attrs[ i ];
	    }
	    attrs = jsonml[ 1 ];
	  }
	
	  // basic case
	  if ( typeof jsonml === "string" ) {
	    return jsonml;
	  }
	
	  // convert this node
	  switch ( jsonml[ 0 ] ) {
	    case "header":
	      jsonml[ 0 ] = "h" + jsonml[ 1 ].level;
	      delete jsonml[ 1 ].level;
	      break;
	    case "bulletlist":
	      jsonml[ 0 ] = "ul";
	      break;
	    case "numberlist":
	      jsonml[ 0 ] = "ol";
	      break;
	    case "listitem":
	      jsonml[ 0 ] = "li";
	      break;
	    case "para":
	      jsonml[ 0 ] = "p";
	      break;
	    case "markdown":
	      jsonml[ 0 ] = "html";
	      if ( attrs ) delete attrs.references;
	      break;
	    case "code_block":
	      jsonml[ 0 ] = "pre";
	      i = attrs ? 2 : 1;
	      var code = [ "code" ];
	      code.push.apply( code, jsonml.splice( i, jsonml.length - i ) );
	      jsonml[ i ] = code;
	      break;
	    case "inlinecode":
	      jsonml[ 0 ] = "code";
	      break;
	    case "img":
	      jsonml[ 1 ].src = jsonml[ 1 ].href;
	      delete jsonml[ 1 ].href;
	      break;
	    case "linebreak":
	      jsonml[ 0 ] = "br";
	    break;
	    case "link":
	      jsonml[ 0 ] = "a";
	      break;
	    case "link_ref":
	      jsonml[ 0 ] = "a";
	
	      // grab this ref and clean up the attribute node
	      var ref = references[ attrs.ref ];
	
	      // if the reference exists, make the link
	      if ( ref ) {
	        delete attrs.ref;
	
	        // add in the href and title, if present
	        attrs.href = ref.href;
	        if ( ref.title ) {
	          attrs.title = ref.title;
	        }
	
	        // get rid of the unneeded original text
	        delete attrs.original;
	      }
	      // the reference doesn't exist, so revert to plain text
	      else {
	        return attrs.original;
	      }
	      break;
	    case "img_ref":
	      jsonml[ 0 ] = "img";
	
	      // grab this ref and clean up the attribute node
	      var ref = references[ attrs.ref ];
	
	      // if the reference exists, make the link
	      if ( ref ) {
	        delete attrs.ref;
	
	        // add in the href and title, if present
	        attrs.src = ref.href;
	        if ( ref.title ) {
	          attrs.title = ref.title;
	        }
	
	        // get rid of the unneeded original text
	        delete attrs.original;
	      }
	      // the reference doesn't exist, so revert to plain text
	      else {
	        return attrs.original;
	      }
	      break;
	  }
	
	  // convert all the children
	  i = 1;
	
	  // deal with the attribute node, if it exists
	  if ( attrs ) {
	    // if there are keys, skip over it
	    for ( var key in jsonml[ 1 ] ) {
	        i = 2;
	        break;
	    }
	    // if there aren't, remove it
	    if ( i === 1 ) {
	      jsonml.splice( i, 1 );
	    }
	  }
	
	  for ( ; i < jsonml.length; ++i ) {
	    jsonml[ i ] = convert_tree_to_html( jsonml[ i ], references, options );
	  }
	
	  return jsonml;
	}
	
	
	// merges adjacent text nodes into a single node
	function merge_text_nodes( jsonml ) {
	  // skip the tag name and attribute hash
	  var i = extract_attr( jsonml ) ? 2 : 1;
	
	  while ( i < jsonml.length ) {
	    // if it's a string check the next item too
	    if ( typeof jsonml[ i ] === "string" ) {
	      if ( i + 1 < jsonml.length && typeof jsonml[ i + 1 ] === "string" ) {
	        // merge the second string into the first and remove it
	        jsonml[ i ] += jsonml.splice( i + 1, 1 )[ 0 ];
	      }
	      else {
	        ++i;
	      }
	    }
	    // if it's not a string recurse
	    else {
	      merge_text_nodes( jsonml[ i ] );
	      ++i;
	    }
	  }
	}
	
	} )( (function() {
	  if ( false ) {
	    window.markdown = {};
	    return window.markdown;
	  }
	  else {
	    return exports;
	  }
	} )() );


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 90,
		"./af.js": 90,
		"./ar": 98,
		"./ar-dz": 91,
		"./ar-dz.js": 91,
		"./ar-kw": 92,
		"./ar-kw.js": 92,
		"./ar-ly": 93,
		"./ar-ly.js": 93,
		"./ar-ma": 94,
		"./ar-ma.js": 94,
		"./ar-ps": 95,
		"./ar-ps.js": 95,
		"./ar-sa": 96,
		"./ar-sa.js": 96,
		"./ar-tn": 97,
		"./ar-tn.js": 97,
		"./ar.js": 98,
		"./az": 99,
		"./az.js": 99,
		"./be": 100,
		"./be.js": 100,
		"./bg": 101,
		"./bg.js": 101,
		"./bm": 102,
		"./bm.js": 102,
		"./bn": 104,
		"./bn-bd": 103,
		"./bn-bd.js": 103,
		"./bn.js": 104,
		"./bo": 105,
		"./bo.js": 105,
		"./br": 106,
		"./br.js": 106,
		"./bs": 107,
		"./bs.js": 107,
		"./ca": 108,
		"./ca.js": 108,
		"./cs": 109,
		"./cs.js": 109,
		"./cv": 110,
		"./cv.js": 110,
		"./cy": 111,
		"./cy.js": 111,
		"./da": 112,
		"./da.js": 112,
		"./de": 115,
		"./de-at": 113,
		"./de-at.js": 113,
		"./de-ch": 114,
		"./de-ch.js": 114,
		"./de.js": 115,
		"./dv": 116,
		"./dv.js": 116,
		"./el": 117,
		"./el.js": 117,
		"./en-au": 118,
		"./en-au.js": 118,
		"./en-ca": 119,
		"./en-ca.js": 119,
		"./en-gb": 120,
		"./en-gb.js": 120,
		"./en-ie": 121,
		"./en-ie.js": 121,
		"./en-il": 122,
		"./en-il.js": 122,
		"./en-in": 123,
		"./en-in.js": 123,
		"./en-nz": 124,
		"./en-nz.js": 124,
		"./en-sg": 125,
		"./en-sg.js": 125,
		"./eo": 126,
		"./eo.js": 126,
		"./es": 130,
		"./es-do": 127,
		"./es-do.js": 127,
		"./es-mx": 128,
		"./es-mx.js": 128,
		"./es-us": 129,
		"./es-us.js": 129,
		"./es.js": 130,
		"./et": 131,
		"./et.js": 131,
		"./eu": 132,
		"./eu.js": 132,
		"./fa": 133,
		"./fa.js": 133,
		"./fi": 134,
		"./fi.js": 134,
		"./fil": 135,
		"./fil.js": 135,
		"./fo": 136,
		"./fo.js": 136,
		"./fr": 139,
		"./fr-ca": 137,
		"./fr-ca.js": 137,
		"./fr-ch": 138,
		"./fr-ch.js": 138,
		"./fr.js": 139,
		"./fy": 140,
		"./fy.js": 140,
		"./ga": 141,
		"./ga.js": 141,
		"./gd": 142,
		"./gd.js": 142,
		"./gl": 143,
		"./gl.js": 143,
		"./gom-deva": 144,
		"./gom-deva.js": 144,
		"./gom-latn": 145,
		"./gom-latn.js": 145,
		"./gu": 146,
		"./gu.js": 146,
		"./he": 147,
		"./he.js": 147,
		"./hi": 148,
		"./hi.js": 148,
		"./hr": 149,
		"./hr.js": 149,
		"./hu": 150,
		"./hu.js": 150,
		"./hy-am": 151,
		"./hy-am.js": 151,
		"./id": 152,
		"./id.js": 152,
		"./is": 153,
		"./is.js": 153,
		"./it": 155,
		"./it-ch": 154,
		"./it-ch.js": 154,
		"./it.js": 155,
		"./ja": 156,
		"./ja.js": 156,
		"./jv": 157,
		"./jv.js": 157,
		"./ka": 158,
		"./ka.js": 158,
		"./kk": 159,
		"./kk.js": 159,
		"./km": 160,
		"./km.js": 160,
		"./kn": 161,
		"./kn.js": 161,
		"./ko": 162,
		"./ko.js": 162,
		"./ku": 164,
		"./ku-kmr": 163,
		"./ku-kmr.js": 163,
		"./ku.js": 164,
		"./ky": 165,
		"./ky.js": 165,
		"./lb": 166,
		"./lb.js": 166,
		"./lo": 167,
		"./lo.js": 167,
		"./lt": 168,
		"./lt.js": 168,
		"./lv": 169,
		"./lv.js": 169,
		"./me": 170,
		"./me.js": 170,
		"./mi": 171,
		"./mi.js": 171,
		"./mk": 172,
		"./mk.js": 172,
		"./ml": 173,
		"./ml.js": 173,
		"./mn": 174,
		"./mn.js": 174,
		"./mr": 175,
		"./mr.js": 175,
		"./ms": 177,
		"./ms-my": 176,
		"./ms-my.js": 176,
		"./ms.js": 177,
		"./mt": 178,
		"./mt.js": 178,
		"./my": 179,
		"./my.js": 179,
		"./nb": 180,
		"./nb.js": 180,
		"./ne": 181,
		"./ne.js": 181,
		"./nl": 183,
		"./nl-be": 182,
		"./nl-be.js": 182,
		"./nl.js": 183,
		"./nn": 184,
		"./nn.js": 184,
		"./oc-lnc": 185,
		"./oc-lnc.js": 185,
		"./pa-in": 186,
		"./pa-in.js": 186,
		"./pl": 187,
		"./pl.js": 187,
		"./pt": 189,
		"./pt-br": 188,
		"./pt-br.js": 188,
		"./pt.js": 189,
		"./ro": 190,
		"./ro.js": 190,
		"./ru": 191,
		"./ru.js": 191,
		"./sd": 192,
		"./sd.js": 192,
		"./se": 193,
		"./se.js": 193,
		"./si": 194,
		"./si.js": 194,
		"./sk": 195,
		"./sk.js": 195,
		"./sl": 196,
		"./sl.js": 196,
		"./sq": 197,
		"./sq.js": 197,
		"./sr": 199,
		"./sr-cyrl": 198,
		"./sr-cyrl.js": 198,
		"./sr.js": 199,
		"./ss": 200,
		"./ss.js": 200,
		"./sv": 201,
		"./sv.js": 201,
		"./sw": 202,
		"./sw.js": 202,
		"./ta": 203,
		"./ta.js": 203,
		"./te": 204,
		"./te.js": 204,
		"./tet": 205,
		"./tet.js": 205,
		"./tg": 206,
		"./tg.js": 206,
		"./th": 207,
		"./th.js": 207,
		"./tk": 208,
		"./tk.js": 208,
		"./tl-ph": 209,
		"./tl-ph.js": 209,
		"./tlh": 210,
		"./tlh.js": 210,
		"./tr": 211,
		"./tr.js": 211,
		"./tzl": 212,
		"./tzl.js": 212,
		"./tzm": 214,
		"./tzm-latn": 213,
		"./tzm-latn.js": 213,
		"./tzm.js": 214,
		"./ug-cn": 215,
		"./ug-cn.js": 215,
		"./uk": 216,
		"./uk.js": 216,
		"./ur": 217,
		"./ur.js": 217,
		"./uz": 219,
		"./uz-latn": 218,
		"./uz-latn.js": 218,
		"./uz.js": 219,
		"./vi": 220,
		"./vi.js": 220,
		"./x-pseudo": 221,
		"./x-pseudo.js": 221,
		"./yo": 222,
		"./yo.js": 222,
		"./zh-cn": 223,
		"./zh-cn.js": 223,
		"./zh-hk": 224,
		"./zh-hk.js": 224,
		"./zh-mo": 225,
		"./zh-mo.js": 225,
		"./zh-tw": 226,
		"./zh-tw.js": 226
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 529;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload/drop directive and service with progress and abort
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 5.0.9
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  FileAPI.shouldLoad = (window.XMLHttpRequest && !window.FormData) || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	
	      FileAPI.hasFlash = hasFlash();
	    }
	
	    FileAPI.ngfFixIE = function (elem, createFileElemFn, bindAttr, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var makeFlashInput = function () {
	        if (elem.attr('disabled')) {
	          elem.$$ngfRefElem.removeClass('js-fileapi-wrapper');
	        } else {
	          var fileElem = elem.$$ngfRefElem;
	          if (!fileElem) {
	            fileElem = elem.$$ngfRefElem = createFileElemFn();
	            fileElem.addClass('js-fileapi-wrapper');
	            if (!isInputTypeFile(elem)) {
	//						if (fileElem.parent().css('position') === '' || fileElem.parent().css('position') === 'static') {
	//							fileElem.parent().css('position', 'relative');
	//						}
	//						elem.parent()[0].insertBefore(fileElem[0], elem[0]);
	//						elem.css('overflow', 'hidden');
	            }
	            setTimeout(function () {
	              fileElem.bind('mouseenter', makeFlashInput);
	            }, 10);
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	//						alert('change' +  evt);
	            });
	          } else {
	            bindAttr(elem.$$ngfRefElem);
	          }
	          if (!isInputTypeFile(elem)) {
	            fileElem.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', makeFlashInput);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsArrayBuffer = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsBinaryString = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload/drop directive and service with progress and abort
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 5.0.9
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '5.0.9';
	ngFileUpload.service('Upload', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = $q.defer();
	    var promise = deferred.promise;
	
	    config.headers.__setXHR_ = function () {
	      return function (xhr) {
	        if (!xhr) return;
	        config.__XHR = xhr;
	        if (config.xhrFn) config.xhrFn(xhr);
	        xhr.upload.addEventListener('progress', function (e) {
	          e.config = config;
	          if (deferred.notify) {
	            deferred.notify(e);
	          } else if (promise.progressFunc) {
	            $timeout(function () {
	              promise.progressFunc(e);
	            });
	          }
	        }, false);
	        //fix for firefox not firing upload progress end, also IE8-9
	        xhr.upload.addEventListener('load', function (e) {
	          if (e.lengthComputable) {
	            e.config = config;
	            if (deferred.notify) {
	              deferred.notify(e);
	            } else if (promise.progressFunc) {
	              $timeout(function () {
	                promise.progressFunc(e);
	              });
	            }
	          }
	        }, false);
	      };
	    };
	
	    $http(config).then(function (r) {
	      deferred.resolve(r);
	    }, function (e) {
	      deferred.reject(e);
	    }, function (n) {
	      deferred.notify(n);
	    });
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (update) {
	        fn(update);
	      });
	      return promise;
	    };
	    promise.abort = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    return promise;
	  }
	
	  this.upload = function (config) {
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (config.sendFieldsAs === 'form') {
	          if (angular.isObject(val)) {
	            for (var k in val) {
	              if (val.hasOwnProperty(k)) {
	                addFieldToFormData(formData, val[k], key + '[' + k + ']');
	              }
	            }
	          } else {
	            formData.append(key, val);
	          }
	        } else {
	          val = angular.isString(val) ? val : JSON.stringify(val);
	          if (config.sendFieldsAs === 'json-blob') {
	            formData.append(key, new Blob([val], {type: 'application/json'}));
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    config.headers = config.headers || {};
	    config.headers['Content-Type'] = undefined;
	    config.transformRequest = config.transformRequest ?
	      (angular.isArray(config.transformRequest) ?
	        config.transformRequest : [config.transformRequest]) : [];
	    config.transformRequest.push(function (data) {
	      var formData = new FormData();
	      var allFields = {};
	      var key;
	      for (key in config.fields) {
	        if (config.fields.hasOwnProperty(key)) {
	          allFields[key] = config.fields[key];
	        }
	      }
	      if (data) allFields.data = data;
	      for (key in allFields) {
	        if (allFields.hasOwnProperty(key)) {
	          var val = allFields[key];
	          if (config.formDataAppender) {
	            config.formDataAppender(formData, key, val);
	          } else {
	            addFieldToFormData(formData, val, key);
	          }
	        }
	      }
	
	      if (config.file != null) {
	        var fileFormName = config.fileFormDataName || 'file';
	
	        if (angular.isArray(config.file)) {
	          var isFileFormNameString = angular.isString(fileFormName);
	          for (var i = 0; i < config.file.length; i++) {
	            formData.append(isFileFormNameString ? fileFormName : fileFormName[i], config.file[i],
	              (config.fileName && config.fileName[i]) || config.file[i].name);
	          }
	        } else {
	          formData.append(fileFormName, config.file, config.fileName || config.file.name);
	        }
	      }
	      return formData;
	    });
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0](arguments);
	      };
	    return sendHttp(config);
	  };
	}
	
	]);
	
	(function () {
	    ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile',
	        function ($parse, $timeout, $compile) {
	            return {
	                restrict: 'AEC',
	                require: '?ngModel',
	                link: function (scope, elem, attr, ngModel) {
	                    linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile);
	                }
	            };
	        }]);
	
	    function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile) {
	        /** @namespace attr.ngfSelect */
	        /** @namespace attr.ngfChange */
	        /** @namespace attr.ngModel */
	        /** @namespace attr.ngModelRejected */
	        /** @namespace attr.ngfMultiple */
	        /** @namespace attr.ngfCapture */
	        /** @namespace attr.ngfAccept */
	        /** @namespace attr.ngfMaxSize */
	        /** @namespace attr.ngfMinSize */
	        /** @namespace attr.ngfResetOnClick */
	        /** @namespace attr.ngfResetModelOnClick */
	        /** @namespace attr.ngfKeep */
	        /** @namespace attr.ngfKeepDistinct */
	
	        if (elem.attr('__ngf_gen__')) {
	            return;
	        }
	
	        scope.$on('$destroy', function () {
	            if (elem.$$ngfRefElem) elem.$$ngfRefElem.remove();
	        });
	
	        var disabled = false;
	        if (attr.ngfSelect.search(/\W+$files\W+/) === -1) {
	            scope.$watch(attr.ngfSelect, function (val) {
	                disabled = val === false;
	            });
	        }
	        function isInputTypeFile() {
	            return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	        }
	
	        var isUpdating = false;
	
	        function changeFn(evt) {
	            if (!isUpdating) {
	                isUpdating = true;
	                try {
	                    var fileList = evt.__files_ || (evt.target && evt.target.files);
	                    var files = [], rejFiles = [];
	
	                    for (var i = 0; i < fileList.length; i++) {
	                        var file = fileList.item(i);
	                        if (validate(scope, $parse, attr, file, evt)) {
	                            files.push(file);
	                        } else {
	                            rejFiles.push(file);
	                        }
	                    }
	                    updateModel($parse, $timeout, scope, ngModel, attr, attr.ngfChange || attr.ngfSelect, files, rejFiles, evt);
	                    if (files.length === 0) evt.target.value = files;
	//                if (evt.target && evt.target.getAttribute('__ngf_gen__')) {
	//                    angular.element(evt.target).remove();
	//                }
	                } finally {
	                    isUpdating = false;
	                }
	            }
	        }
	
	        function bindAttrToFileInput(fileElem) {
	            if (attr.ngfMultiple) fileElem.attr('multiple', $parse(attr.ngfMultiple)(scope));
	            if (attr.ngfCapture) fileElem.attr('capture', $parse(attr.ngfCapture)(scope));
	            if (attr.accept) fileElem.attr('accept', attr.accept);
	            for (var i = 0; i < elem[0].attributes.length; i++) {
	                var attribute = elem[0].attributes[i];
	                if ((isInputTypeFile() && attribute.name !== 'type') ||
	                    (attribute.name !== 'type' && attribute.name !== 'class' &&
	                    attribute.name !== 'id' && attribute.name !== 'style')) {
	                    fileElem.attr(attribute.name, attribute.value);
	                }
	            }
	        }
	
	        function createFileInput(evt, resetOnClick) {
	            if (!resetOnClick && (evt || isInputTypeFile())) return elem.$$ngfRefElem || elem;
	
	            var fileElem = angular.element('<input type="file">');
	            bindAttrToFileInput(fileElem);
	
	            if (isInputTypeFile()) {
	                elem.replaceWith(fileElem);
	                elem = fileElem;
	                fileElem.attr('__ngf_gen__', true);
	                $compile(elem)(scope);
	            } else {
	                fileElem.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	                    .css('width', '0px').css('height', '0px').css('z-index', '-100000').css('border', 'none')
	                    .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	                if (elem.$$ngfRefElem) {
	                    elem.$$ngfRefElem.remove();
	                }
	                elem.$$ngfRefElem = fileElem;
	                document.body.appendChild(fileElem[0]);
	            }
	
	            return fileElem;
	        }
	
	        function resetModel(evt) {
	            updateModel($parse, $timeout, scope, ngModel, attr, attr.ngfChange || attr.ngfSelect, [], [], evt, true);
	        }
	
	        function clickHandler(evt) {
	            if (elem.attr('disabled') || disabled) return false;
	            if (evt != null) {
	                evt.preventDefault();
	                evt.stopPropagation();
	            }
	            var resetOnClick = $parse(attr.ngfResetOnClick)(scope) !== false;
	            var fileElem = createFileInput(evt, resetOnClick);
	
	            function clickAndAssign(evt) {
	                if (evt) {
	                    fileElem[0].click();
	                }
	                if (isInputTypeFile() || !evt) {
	                    elem.bind('click touchend', clickHandler);
	                }
	            }
	
	            if (fileElem) {
	                if (!evt || resetOnClick) fileElem.bind('change', changeFn);
	                if (evt && resetOnClick && $parse(attr.ngfResetModelOnClick)(scope) !== false) resetModel(evt);
	
	                // fix for android native browser < 4.4
	                if (shouldClickLater(navigator.userAgent)) {
	                    setTimeout(function () {
	                        clickAndAssign(evt);
	                    }, 0);
	                } else {
	                    clickAndAssign(evt);
	                }
	            }
	            return false;
	        }
	
	        if (window.FileAPI && window.FileAPI.ngfFixIE) {
	            window.FileAPI.ngfFixIE(elem, createFileInput, bindAttrToFileInput, changeFn);
	        } else {
	            clickHandler();
	            //if (!isInputTypeFile()) {
	            //  elem.bind('click touchend', clickHandler);
	            //}
	        }
	    }
	
	    function shouldClickLater(ua) {
	        // android below 4.4
	        var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	        if (m && m.length > 2) {
	            return parseInt(m[1]) < 4 || (parseInt(m[1]) === 4 && parseInt(m[2]) < 4);
	        }
	
	        // safari on windows
	        return /.*Windows.*Safari.*/.test(ua);
	    }
	
	    ngFileUpload.validate = function (scope, $parse, attr, file, evt) {
	        function globStringToRegex(str) {
	            if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	                return str.substring(1, str.length - 1);
	            }
	            var split = str.split(','), result = '';
	            if (split.length > 1) {
	                for (var i = 0; i < split.length; i++) {
	                    result += '(' + globStringToRegex(split[i]) + ')';
	                    if (i < split.length - 1) {
	                        result += '|';
	                    }
	                }
	            } else {
	                if (str.indexOf('.') === 0) {
	                    str = '*' + str;
	                }
	                result = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + '-]', 'g'), '\\$&') + '$';
	                result = result.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	            }
	            return result;
	        }
	
	        var accept = $parse(attr.ngfAccept)(scope, {$file: file, $event: evt});
	        var fileSizeMax = $parse(attr.ngfMaxSize)(scope, {$file: file, $event: evt}) || 9007199254740991;
	        var fileSizeMin = $parse(attr.ngfMinSize)(scope, {$file: file, $event: evt}) || -1;
	        if (accept != null && angular.isString(accept)) {
	            var regexp = new RegExp(globStringToRegex(accept), 'gi');
	            accept = (file.type != null && regexp.test(file.type.toLowerCase())) ||
	                (file.name != null && regexp.test(file.name.toLowerCase()));
	        }
	        return (accept == null || accept) && (file.size == null || (file.size < fileSizeMax && file.size > fileSizeMin));
	    };
	
	    ngFileUpload.updateModel = function ($parse, $timeout, scope, ngModel, attr, fileChange,
	                                         files, rejFiles, evt, noDelay) {
	        function update() {
	            if ($parse(attr.ngfKeep)(scope) === true) {
	                var prevFiles = (ngModel.$modelValue || []).slice(0);
	                if (!files || !files.length) {
	                    files = prevFiles;
	                } else if ($parse(attr.ngfKeepDistinct)(scope) === true) {
	                    var len = prevFiles.length;
	                    for (var i = 0; i < files.length; i++) {
	                        for (var j = 0; j < len; j++) {
	                            if (files[i].name === prevFiles[j].name) break;
	                        }
	                        if (j === len) {
	                            prevFiles.push(files[i]);
	                        }
	                    }
	                    files = prevFiles;
	                } else {
	                    files = prevFiles.concat(files);
	                }
	            }
	            if (ngModel) {
	                $parse(attr.ngModel).assign(scope, files);
	                $timeout(function () {
	                    if (ngModel) {
	                        ngModel.$setViewValue(files != null && files.length === 0 ? null : files);
	                    }
	                });
	            }
	            if (attr.ngModelRejected) {
	                $parse(attr.ngModelRejected).assign(scope, rejFiles);
	            }
	            if (fileChange) {
	                $parse(fileChange)(scope, {
	                    $files: files,
	                    $rejectedFiles: rejFiles,
	                    $event: evt
	                });
	            }
	        }
	
	        if (noDelay) {
	            update();
	        } else {
	            $timeout(function () {
	                update();
	            });
	        }
	    };
	
	    var validate = ngFileUpload.validate;
	    var updateModel = ngFileUpload.updateModel;
	
	})();
	
	(function () {
	  var validate = ngFileUpload.validate;
	  var updateModel = ngFileUpload.updateModel;
	
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$location', function ($parse, $timeout, $location) {
	    return {
	      restrict: 'AEC',
	      require: '?ngModel',
	      link: function (scope, elem, attr, ngModel) {
	        linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location);
	      }
	    };
	  }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', function ($parse, $timeout) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var fn = $parse(attr.ngfDropAvailable);
	        $timeout(function () {
	          fn(scope);
	          if (fn.assign) {
	            fn.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location) {
	    var available = dropAvailable();
	    if (attr.dropAvailable) {
	      $timeout(function () {
	        if (scope[attr.dropAvailable]) {
	          scope[attr.dropAvailable].value = available;
	        } else {
	          scope[attr.dropAvailable] = available;
	        }
	      });
	    }
	    if (!available) {
	      if ($parse(attr.ngfHideOnDropNotAvailable)(scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    var disabled = false;
	    if (attr.ngfDrop.search(/\W+$files\W+/) === -1) {
	      scope.$watch(attr.ngfDrop, function(val) {
	        disabled = val === false;
	      });
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attr.ngfStopPropagation);
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (elem.attr('disabled') || disabled) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!scope.actualDragOverClass) {
	        actualDragOverClass = calculateDragOverClass(scope, attr, evt);
	      }
	      elem.addClass(actualDragOverClass);
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (elem.attr('disabled') || disabled) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function () {
	      if (elem.attr('disabled') || disabled) return;
	      leaveTimeout = $timeout(function () {
	        elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	      }, dragOverDelay || 1);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (elem.attr('disabled') || disabled) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFiles(evt, function (files, rejFiles) {
	        updateModel($parse, $timeout, scope, ngModel, attr,
	          attr.ngfChange || attr.ngfDrop, files, rejFiles, evt);
	      }, $parse(attr.ngfAllowDir)(scope) !== false, attr.multiple || $parse(attr.ngfMultiple)(scope));
	    }, false);
	
	    function calculateDragOverClass(scope, attr, evt) {
	      var accepted = true;
	      var items = evt.dataTransfer.items;
	      if (items != null) {
	        for (var i = 0; i < items.length && accepted; i++) {
	          accepted = accepted &&
	            (items[i].kind === 'file' || items[i].kind === '') &&
	            validate(scope, $parse, attr, items[i], evt);
	        }
	      }
	      var clazz = $parse(attr.ngfDragOverClass)(scope, {$event: evt});
	      if (clazz) {
	        if (clazz.delay) dragOverDelay = clazz.delay;
	        if (clazz.accept) clazz = accepted ? clazz.accept : clazz.reject;
	      }
	      return clazz || attr.ngfDragOverClass || 'dragover';
	    }
	
	    function extractFiles(evt, callback, allowDir, multiple) {
	      var files = [], rejFiles = [], items = evt.dataTransfer.items, processing = 0;
	
	      function addFile(file) {
	        if (validate(scope, $parse, attr, file, evt)) {
	          files.push(file);
	        } else {
	          rejFiles.push(file);
	        }
	      }
	
	      function traverseFileTree(files, entry, path) {
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var filePath = (path || '') + entry.name;
	            addFile({name: entry.name, type: 'directory', path: filePath});
	            var dirReader = entry.createReader();
	            var entries = [];
	            processing++;
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    for (var i = 0; i < entries.length; i++) {
	                      traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
	                    }
	                    processing--;
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  processing--;
	                  console.error(e);
	                }
	              }, function () {
	                processing--;
	              });
	            };
	            readEntries();
	          } else {
	            processing++;
	            entry.file(function (file) {
	              try {
	                processing--;
	                file.path = (path ? path : '') + file.name;
	                addFile(file);
	              } catch (e) {
	                processing--;
	                console.error(e);
	              }
	            }, function () {
	              processing--;
	            });
	          }
	        }
	      }
	
	      if (items && items.length > 0 && $location.protocol() !== 'file') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              traverseFileTree(files, entry);
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) addFile(f);
	          }
	          if (!multiple && files.length > 0) break;
	        }
	      } else {
	        var fileList = evt.dataTransfer.files;
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            addFile(fileList.item(j));
	            if (!multiple && files.length > 0) {
	              break;
	            }
	          }
	        }
	      }
	      var delays = 0;
	      (function waitForProcess(delay) {
	        $timeout(function () {
	          if (!processing) {
	            if (!multiple && files.length > 1) {
	              i = 0;
	              while (files[i].type === 'directory') i++;
	              files = [files[i]];
	            }
	            callback(files, rejFiles);
	          } else {
	            if (delays++ * 10 < 20 * 1000) {
	              waitForProcess(10);
	            }
	          }
	        }, delay || 0);
	      })();
	    }
	  }
	
	  ngFileUpload.directive('ngfSrc', ['$parse', '$timeout', function ($parse, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        if (window.FileReader) {
	          scope.$watch(attr.ngfSrc, function (file) {
	            if (file &&
	              validate(scope, $parse, attr, file, null) &&
	              (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	              (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	              $timeout(function () {
	                //prefer URL.createObjectURL for handling refrences to files of all sizes
	                //since it doesn´t build a large string in memory
	                var URL = window.URL || window.webkitURL;
	                if (URL && URL.createObjectURL) {
	                  elem.attr('src', URL.createObjectURL(file));
	                } else {
	                  var fileReader = new FileReader();
	                  fileReader.readAsDataURL(file);
	                  fileReader.onload = function (e) {
	                    $timeout(function () {
	                      elem.attr('src', e.target.result);
	                    });
	                  };
	                }
	              });
	            } else {
	              elem.attr('src', attr.ngfDefaultSrc || '');
	            }
	          });
	        }
	      }
	    };
	  }]);
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div);
	  }
	
	})();


/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload/drop directive and service with progress and abort
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 5.0.9
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  FileAPI.shouldLoad = (window.XMLHttpRequest && !window.FormData) || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	
	      FileAPI.hasFlash = hasFlash();
	    }
	
	    FileAPI.ngfFixIE = function (elem, createFileElemFn, bindAttr, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var makeFlashInput = function () {
	        if (elem.attr('disabled')) {
	          elem.$$ngfRefElem.removeClass('js-fileapi-wrapper');
	        } else {
	          var fileElem = elem.$$ngfRefElem;
	          if (!fileElem) {
	            fileElem = elem.$$ngfRefElem = createFileElemFn();
	            fileElem.addClass('js-fileapi-wrapper');
	            if (!isInputTypeFile(elem)) {
	//						if (fileElem.parent().css('position') === '' || fileElem.parent().css('position') === 'static') {
	//							fileElem.parent().css('position', 'relative');
	//						}
	//						elem.parent()[0].insertBefore(fileElem[0], elem[0]);
	//						elem.css('overflow', 'hidden');
	            }
	            setTimeout(function () {
	              fileElem.bind('mouseenter', makeFlashInput);
	            }, 10);
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	//						alert('change' +  evt);
	            });
	          } else {
	            bindAttr(elem.$$ngfRefElem);
	          }
	          if (!isInputTypeFile(elem)) {
	            fileElem.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', makeFlashInput);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsArrayBuffer = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsBinaryString = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/*! ngTagsInput v2.3.0 License: MIT */!function(){"use strict";var a={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,left:37,right:39,"delete":46,comma:188},b=9007199254740991,c=["text","email","url"],d=angular.module("ngTagsInput",[]);d.directive("tagsInput",["$timeout","$document","$window","tagsInputConfig","tiUtil",function(d,e,f,g,h){function i(a,b,c,d){var e,f,g,i={};return e=function(b){return h.safeToString(b[a.displayProperty])},f=function(b,c){b[a.displayProperty]=c},g=function(b){var d=e(b);return d&&d.length>=a.minLength&&d.length<=a.maxLength&&a.allowedTagsPattern.test(d)&&!h.findInObjectArray(i.items,b,a.keyProperty||a.displayProperty)&&c({$tag:b})},i.items=[],i.addText=function(a){var b={};return f(b,a),i.add(b)},i.add=function(c){var d=e(c);return a.replaceSpacesWithDashes&&(d=h.replaceSpacesWithDashes(d)),f(c,d),g(c)?(i.items.push(c),b.trigger("tag-added",{$tag:c})):d&&b.trigger("invalid-tag",{$tag:c}),c},i.remove=function(a){var c=i.items[a];return d({$tag:c})?(i.items.splice(a,1),i.clearSelection(),b.trigger("tag-removed",{$tag:c}),c):void 0},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a]},i.selectPrior=function(){i.select(--i.index)},i.selectNext=function(){i.select(++i.index)},i.removeSelected=function(){return i.remove(i.index)},i.clearSelection=function(){i.selected=null,i.index=-1},i.clearSelection(),i}function j(a){return-1!==c.indexOf(a)}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",onTagAdding:"&",onTagAdded:"&",onInvalidTag:"&",onTagRemoving:"&",onTagRemoved:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function(a,c,d){a.events=h.simplePubSub(),g.load("tagsInput",a,c,{template:[String,"ngTagsInput/tag-item.html"],type:[String,"text",j],placeholder:[String,"Add a tag"],tabindex:[Number,null],removeTagSymbol:[String,String.fromCharCode(215)],replaceSpacesWithDashes:[Boolean,!0],minLength:[Number,3],maxLength:[Number,b],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],addOnPaste:[Boolean,!1],pasteSplitPattern:[RegExp,/,/],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number,0],maxTags:[Number,b],displayProperty:[String,"text"],keyProperty:[String,""],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1],spellcheck:[Boolean,!0]}),a.tagList=new i(a.options,a.events,h.handleUndefinedResult(a.onTagAdding,!0),h.handleUndefinedResult(a.onTagRemoving,!0)),this.registerAutocomplete=function(){var b=d.find("input");return{addTag:function(b){return a.tagList.add(b)},focusInput:function(){b[0].focus()},getTags:function(){return a.tags},getCurrentTagText:function(){return a.newTag.text},getOptions:function(){return a.options},on:function(b,c){return a.events.on(b,c),this}}},this.registerTagItem=function(){return{getOptions:function(){return a.options},removeTag:function(b){a.disabled||a.tagList.remove(b)}}}}],link:function(b,c,g,i){var j,k=[a.enter,a.comma,a.space,a.backspace,a["delete"],a.left,a.right],l=b.tagList,m=b.events,n=b.options,o=c.find("input"),p=["minTags","maxTags","allowLeftoverText"];j=function(){i.$setValidity("maxTags",b.tags.length<=n.maxTags),i.$setValidity("minTags",b.tags.length>=n.minTags),i.$setValidity("leftoverText",b.hasFocus||n.allowLeftoverText?!0:!b.newTag.text)},i.$isEmpty=function(a){return!a||!a.length},b.newTag={text:"",invalid:null,setText:function(a){this.text=a,m.trigger("input-change",a)}},b.track=function(a){return a[n.keyProperty||n.displayProperty]},b.$watch("tags",function(a){b.tags=h.makeObjectArray(a,n.displayProperty),l.items=b.tags}),b.$watch("tags.length",function(){j()}),g.$observe("disabled",function(a){b.disabled=a}),b.eventHandlers={input:{change:function(a){m.trigger("input-change",a)},keydown:function(a){m.trigger("input-keydown",a)},focus:function(){b.hasFocus||(b.hasFocus=!0,m.trigger("input-focus"))},blur:function(){d(function(){var a=e.prop("activeElement"),d=a===o[0],f=c[0].contains(a);(d||!f)&&(b.hasFocus=!1,m.trigger("input-blur"))})},paste:function(a){a.getTextData=function(){var b=a.clipboardData||a.originalEvent&&a.originalEvent.clipboardData;return b?b.getData("text/plain"):f.clipboardData.getData("Text")},m.trigger("input-paste",a)}},host:{click:function(){b.disabled||o[0].focus()}}},m.on("tag-added",b.onTagAdded).on("invalid-tag",b.onInvalidTag).on("tag-removed",b.onTagRemoved).on("tag-added",function(){b.newTag.setText("")}).on("tag-added tag-removed",function(){i.$setViewValue(b.tags)}).on("invalid-tag",function(){b.newTag.invalid=!0}).on("option-change",function(a){-1!==p.indexOf(a.name)&&j()}).on("input-change",function(){l.clearSelection(),b.newTag.invalid=null}).on("input-focus",function(){c.triggerHandler("focus"),i.$setValidity("leftoverText",!0)}).on("input-blur",function(){n.addOnBlur&&!n.addFromAutocompleteOnly&&l.addText(b.newTag.text),c.triggerHandler("blur"),j()}).on("input-keydown",function(c){var d,e,f,g,h=c.keyCode,i=c.shiftKey||c.altKey||c.ctrlKey||c.metaKey,j={};if(!i&&-1!==k.indexOf(h)){if(j[a.enter]=n.addOnEnter,j[a.comma]=n.addOnComma,j[a.space]=n.addOnSpace,d=!n.addFromAutocompleteOnly&&j[h],e=(h===a.backspace||h===a["delete"])&&l.selected,g=h===a.backspace&&0===b.newTag.text.length&&n.enableEditingLastTag,f=(h===a.backspace||h===a.left||h===a.right)&&0===b.newTag.text.length&&!n.enableEditingLastTag,d)l.addText(b.newTag.text);else if(g){var m;l.selectPrior(),m=l.removeSelected(),m&&b.newTag.setText(m[n.displayProperty])}else e?l.removeSelected():f&&(h===a.left||h===a.backspace?l.selectPrior():h===a.right&&l.selectNext());(d||f||e||g)&&c.preventDefault()}}).on("input-paste",function(a){if(n.addOnPaste){var b=a.getTextData(),c=b.split(n.pasteSplitPattern);c.length>1&&(c.forEach(function(a){l.addText(a)}),a.preventDefault())}})}}}]),d.directive("tiTagItem",["tiUtil",function(a){return{restrict:"E",require:"^tagsInput",template:'<ng-include src="$$template"></ng-include>',scope:{data:"="},link:function(b,c,d,e){var f=e.registerTagItem(),g=f.getOptions();b.$$template=g.template,b.$$removeTagSymbol=g.removeTagSymbol,b.$getDisplayText=function(){return a.safeToString(b.data[g.displayProperty])},b.$removeTag=function(){f.removeTag(b.$index)},b.$watch("$parent.$index",function(a){b.$index=a})}}}]),d.directive("autoComplete",["$document","$timeout","$sce","$q","tagsInputConfig","tiUtil",function(b,c,d,e,f,g){function h(a,b,c){var d,f,h,i={};return h=function(){return b.tagsInput.keyProperty||b.tagsInput.displayProperty},d=function(a,c){return a.filter(function(a){return!g.findInObjectArray(c,a,h(),function(a,c){return b.tagsInput.replaceSpacesWithDashes&&(a=g.replaceSpacesWithDashes(a),c=g.replaceSpacesWithDashes(c)),g.defaultComparer(a,c)})})},i.reset=function(){f=null,i.items=[],i.visible=!1,i.index=-1,i.selected=null,i.query=null},i.show=function(){b.selectFirstMatch?i.select(0):i.selected=null,i.visible=!0},i.load=g.debounce(function(c,j){i.query=c;var k=e.when(a({$query:c}));f=k,k.then(function(a){k===f&&(a=g.makeObjectArray(a.data||a,h()),a=d(a,j),i.items=a.slice(0,b.maxResultsToShow),i.items.length>0?i.show():i.reset())})},b.debounceDelay),i.selectNext=function(){i.select(++i.index)},i.selectPrior=function(){i.select(--i.index)},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a],c.trigger("suggestion-selected",a)},i.reset(),i}function i(a,b){var c=a.find("li").eq(b),d=c.parent(),e=c.prop("offsetTop"),f=c.prop("offsetHeight"),g=d.prop("clientHeight"),h=d.prop("scrollTop");h>e?d.prop("scrollTop",e):e+f>g+h&&d.prop("scrollTop",e+f-g)}return{restrict:"E",require:"^tagsInput",scope:{source:"&"},templateUrl:"ngTagsInput/auto-complete.html",controller:["$scope","$element","$attrs",function(a,b,c){a.events=g.simplePubSub(),f.load("autoComplete",a,c,{template:[String,"ngTagsInput/auto-complete-match.html"],debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],maxResultsToShow:[Number,10],loadOnDownArrow:[Boolean,!1],loadOnEmpty:[Boolean,!1],loadOnFocus:[Boolean,!1],selectFirstMatch:[Boolean,!0],displayProperty:[String,""]}),a.suggestionList=new h(a.source,a.options,a.events),this.registerAutocompleteMatch=function(){return{getOptions:function(){return a.options},getQuery:function(){return a.suggestionList.query}}}}],link:function(b,c,d,e){var f,g=[a.enter,a.tab,a.escape,a.up,a.down],h=b.suggestionList,j=e.registerAutocomplete(),k=b.options,l=b.events;k.tagsInput=j.getOptions(),f=function(a){return a&&a.length>=k.minLength||!a&&k.loadOnEmpty},b.addSuggestionByIndex=function(a){h.select(a),b.addSuggestion()},b.addSuggestion=function(){var a=!1;return h.selected&&(j.addTag(angular.copy(h.selected)),h.reset(),j.focusInput(),a=!0),a},b.track=function(a){return a[k.tagsInput.keyProperty||k.tagsInput.displayProperty]},j.on("tag-added invalid-tag input-blur",function(){h.reset()}).on("input-change",function(a){f(a)?h.load(a,j.getTags()):h.reset()}).on("input-focus",function(){var a=j.getCurrentTagText();k.loadOnFocus&&f(a)&&h.load(a,j.getTags())}).on("input-keydown",function(c){var d=c.keyCode,e=!1;if(-1!==g.indexOf(d))return h.visible?d===a.down?(h.selectNext(),e=!0):d===a.up?(h.selectPrior(),e=!0):d===a.escape?(h.reset(),e=!0):(d===a.enter||d===a.tab)&&(e=b.addSuggestion()):d===a.down&&b.options.loadOnDownArrow&&(h.load(j.getCurrentTagText(),j.getTags()),e=!0),e?(c.preventDefault(),c.stopImmediatePropagation(),!1):void 0}),l.on("suggestion-selected",function(a){i(c,a)})}}}]),d.directive("tiAutocompleteMatch",["$sce","tiUtil",function(a,b){return{restrict:"E",require:"^autoComplete",template:'<ng-include src="$$template"></ng-include>',scope:{data:"="},link:function(c,d,e,f){var g=f.registerAutocompleteMatch(),h=g.getOptions();c.$$template=h.template,c.$index=c.$parent.$index,c.$highlight=function(c){return h.highlightMatchedText&&(c=b.safeHighlight(c,g.getQuery())),a.trustAsHtml(c)},c.$getDisplayText=function(){return b.safeToString(c.data[h.displayProperty||h.tagsInput.displayProperty])}}}}]),d.directive("tiTranscludeAppend",function(){return function(a,b,c,d,e){e(function(a){b.append(a)})}}),d.directive("tiAutosize",["tagsInputConfig",function(a){return{restrict:"A",require:"ngModel",link:function(b,c,d,e){var f,g,h=a.getTextAutosizeThreshold();f=angular.element('<span class="input"></span>'),f.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),c.parent().append(f),g=function(a){var b,e=a;return angular.isString(e)&&0===e.length&&(e=d.placeholder),e&&(f.text(e),f.css("display",""),b=f.prop("offsetWidth"),f.css("display","none")),c.css("width",b?b+h+"px":""),a},e.$parsers.unshift(g),e.$formatters.unshift(g),d.$observe("placeholder",function(a){e.$modelValue||g(a)})}}}]),d.directive("tiBindAttrs",function(){return function(a,b,c){a.$watch(c.tiBindAttrs,function(a){angular.forEach(a,function(a,b){c.$set(b,a)})},!0)}}),d.provider("tagsInputConfig",function(){var a={},b={},c=3;this.setDefaults=function(b,c){return a[b]=c,this},this.setActiveInterpolation=function(a,c){return b[a]=c,this},this.setTextAutosizeThreshold=function(a){return c=a,this},this.$get=["$interpolate",function(d){var e={};return e[String]=function(a){return a},e[Number]=function(a){return parseInt(a,10)},e[Boolean]=function(a){return"true"===a.toLowerCase()},e[RegExp]=function(a){return new RegExp(a)},{load:function(c,f,g,h){var i=function(){return!0};f.options={},angular.forEach(h,function(h,j){var k,l,m,n,o,p;k=h[0],l=h[1],m=h[2]||i,n=e[k],o=function(){var b=a[c]&&a[c][j];return angular.isDefined(b)?b:l},p=function(a){f.options[j]=a&&m(a)?n(a):o()},b[c]&&b[c][j]?g.$observe(j,function(a){p(a),f.events.trigger("option-change",{name:j,newValue:a})}):p(g[j]&&d(g[j])(f.$parent))})},getTextAutosizeThreshold:function(){return c}}}]}),d.factory("tiUtil",["$timeout",function(a){var b={};return b.debounce=function(b,c){var d;return function(){var e=arguments;a.cancel(d),d=a(function(){b.apply(null,e)},c)}},b.makeObjectArray=function(a,b){return a=a||[],a.length>0&&!angular.isObject(a[0])&&a.forEach(function(c,d){a[d]={},a[d][b]=c}),a},b.findInObjectArray=function(a,c,d,e){var f=null;return e=e||b.defaultComparer,a.some(function(a){return e(a[d],c[d])?(f=a,!0):void 0}),f},b.defaultComparer=function(a,c){return b.safeToString(a).toLowerCase()===b.safeToString(c).toLowerCase()},b.safeHighlight=function(a,c){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}if(!c)return a;a=b.encodeHTML(a),c=b.encodeHTML(c);var e=new RegExp("&[^;]+;|"+d(c),"gi");return a.replace(e,function(a){return a.toLowerCase()===c.toLowerCase()?"<em>"+a+"</em>":a})},b.safeToString=function(a){return angular.isUndefined(a)||null==a?"":a.toString().trim()},b.encodeHTML=function(a){return b.safeToString(a).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},b.handleUndefinedResult=function(a,b){return function(){var c=a.apply(null,arguments);return angular.isUndefined(c)?b:c}},b.replaceSpacesWithDashes=function(a){return b.safeToString(a).replace(/\s/g,"-")},b.simplePubSub=function(){var a={};return{on:function(b,c){return b.split(" ").forEach(function(b){a[b]||(a[b]=[]),a[b].push(c)}),this},trigger:function(c,d){var e=a[c]||[];return e.every(function(a){return b.handleUndefinedResult(a,!0)(d)}),this}}},b}]),d.run(["$templateCache",function(a){a.put("ngTagsInput/tags-input.html",'<div class="host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append=""><div class="tags" ng-class="{focused: hasFocus}"><ul class="tag-list"><li class="tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="{ selected: tag == tagList.selected }"><ti-tag-item data="tag"></ti-tag-item></li></ul><input class="input" autocomplete="off" ng-model="newTag.text" ng-change="eventHandlers.input.change(newTag.text)" ng-keydown="eventHandlers.input.keydown($event)" ng-focus="eventHandlers.input.focus($event)" ng-blur="eventHandlers.input.blur($event)" ng-paste="eventHandlers.input.paste($event)" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ng-disabled="disabled" ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}" ti-autosize=""></div></div>'),a.put("ngTagsInput/tag-item.html",'<span ng-bind="$getDisplayText()"></span> <a class="remove-button" ng-click="$removeTag()" ng-bind="$$removeTagSymbol"></a>'),a.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-if="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="{selected: item == suggestionList.selected}" ng-click="addSuggestionByIndex($index)" ng-mouseenter="suggestionList.select($index)"><ti-autocomplete-match data="item"></ti-autocomplete-match></li></ul></div>'),a.put("ngTagsInput/auto-complete-match.html",'<span ng-bind-html="$highlight($getDisplayText())"></span>')}])}();

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(228); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(74);
	var callBind = __webpack_require__(70);
	
	var implementation = __webpack_require__(229);
	var getPolyfill = __webpack_require__(230);
	var shim = __webpack_require__(535);
	
	var polyfill = callBind.apply(getPolyfill());
	// eslint-disable-next-line no-unused-vars
	var bound = function assign(target, source1) {
		return polyfill(Object, arguments);
	};
	
	defineProperties(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = bound;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(74);
	var getPolyfill = __webpack_require__(230);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(22);
	var define = __webpack_require__(73);
	var hasDescriptors = __webpack_require__(79)();
	var gOPD = __webpack_require__(77);
	
	var $TypeError = __webpack_require__(32);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(51)))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(537);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "autolink" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/autolink')
	//   ES2015:
	//     import 'tinymce/plugins/autolink'
	__webpack_require__(540);

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	(function () {
	var autolink = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var getAutoLinkPattern = function (editor) {
	      return editor.getParam('autolink_pattern', /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.|(?:mailto:)?[A-Z0-9._%+\-]+@)(.+)$/i);
	    };
	    var getDefaultLinkTarget = function (editor) {
	      return editor.getParam('default_link_target', '');
	    };
	    var Settings = {
	      getAutoLinkPattern: getAutoLinkPattern,
	      getDefaultLinkTarget: getDefaultLinkTarget
	    };
	
	    var rangeEqualsDelimiterOrSpace = function (rangeString, delimiter) {
	      return rangeString === delimiter || rangeString === ' ' || rangeString.charCodeAt(0) === 160;
	    };
	    var handleEclipse = function (editor) {
	      parseCurrentLine(editor, -1, '(');
	    };
	    var handleSpacebar = function (editor) {
	      parseCurrentLine(editor, 0, '');
	    };
	    var handleEnter = function (editor) {
	      parseCurrentLine(editor, -1, '');
	    };
	    var scopeIndex = function (container, index) {
	      if (index < 0) {
	        index = 0;
	      }
	      if (container.nodeType === 3) {
	        var len = container.data.length;
	        if (index > len) {
	          index = len;
	        }
	      }
	      return index;
	    };
	    var setStart = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setStart(container, scopeIndex(container, offset));
	      } else {
	        rng.setStartBefore(container);
	      }
	    };
	    var setEnd = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setEnd(container, scopeIndex(container, offset));
	      } else {
	        rng.setEndAfter(container);
	      }
	    };
	    var parseCurrentLine = function (editor, endOffset, delimiter) {
	      var rng, end, start, endContainer, bookmark, text, matches, prev, len, rngText;
	      var autoLinkPattern = Settings.getAutoLinkPattern(editor);
	      var defaultLinkTarget = Settings.getDefaultLinkTarget(editor);
	      if (editor.selection.getNode().tagName === 'A') {
	        return;
	      }
	      rng = editor.selection.getRng(true).cloneRange();
	      if (rng.startOffset < 5) {
	        prev = rng.endContainer.previousSibling;
	        if (!prev) {
	          if (!rng.endContainer.firstChild || !rng.endContainer.firstChild.nextSibling) {
	            return;
	          }
	          prev = rng.endContainer.firstChild.nextSibling;
	        }
	        len = prev.length;
	        setStart(rng, prev, len);
	        setEnd(rng, prev, len);
	        if (rng.endOffset < 5) {
	          return;
	        }
	        end = rng.endOffset;
	        endContainer = prev;
	      } else {
	        endContainer = rng.endContainer;
	        if (endContainer.nodeType !== 3 && endContainer.firstChild) {
	          while (endContainer.nodeType !== 3 && endContainer.firstChild) {
	            endContainer = endContainer.firstChild;
	          }
	          if (endContainer.nodeType === 3) {
	            setStart(rng, endContainer, 0);
	            setEnd(rng, endContainer, endContainer.nodeValue.length);
	          }
	        }
	        if (rng.endOffset === 1) {
	          end = 2;
	        } else {
	          end = rng.endOffset - 1 - endOffset;
	        }
	      }
	      start = end;
	      do {
	        setStart(rng, endContainer, end >= 2 ? end - 2 : 0);
	        setEnd(rng, endContainer, end >= 1 ? end - 1 : 0);
	        end -= 1;
	        rngText = rng.toString();
	      } while (rngText !== ' ' && rngText !== '' && rngText.charCodeAt(0) !== 160 && end - 2 >= 0 && rngText !== delimiter);
	      if (rangeEqualsDelimiterOrSpace(rng.toString(), delimiter)) {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	        end += 1;
	      } else if (rng.startOffset === 0) {
	        setStart(rng, endContainer, 0);
	        setEnd(rng, endContainer, start);
	      } else {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	      }
	      text = rng.toString();
	      if (text.charAt(text.length - 1) === '.') {
	        setEnd(rng, endContainer, start - 1);
	      }
	      text = rng.toString().trim();
	      matches = text.match(autoLinkPattern);
	      if (matches) {
	        if (matches[1] === 'www.') {
	          matches[1] = 'http://www.';
	        } else if (/@$/.test(matches[1]) && !/^mailto:/.test(matches[1])) {
	          matches[1] = 'mailto:' + matches[1];
	        }
	        bookmark = editor.selection.getBookmark();
	        editor.selection.setRng(rng);
	        editor.execCommand('createlink', false, matches[1] + matches[2]);
	        if (defaultLinkTarget) {
	          editor.dom.setAttrib(editor.selection.getNode(), 'target', defaultLinkTarget);
	        }
	        editor.selection.moveToBookmark(bookmark);
	        editor.nodeChanged();
	      }
	    };
	    var setup = function (editor) {
	      var autoUrlDetectState;
	      editor.on('keydown', function (e) {
	        if (e.keyCode === 13) {
	          return handleEnter(editor);
	        }
	      });
	      if (global$1.ie) {
	        editor.on('focus', function () {
	          if (!autoUrlDetectState) {
	            autoUrlDetectState = true;
	            try {
	              editor.execCommand('AutoUrlDetect', false, true);
	            } catch (ex) {
	            }
	          }
	        });
	        return;
	      }
	      editor.on('keypress', function (e) {
	        if (e.keyCode === 41) {
	          return handleEclipse(editor);
	        }
	      });
	      editor.on('keyup', function (e) {
	        if (e.keyCode === 32) {
	          return handleSpacebar(editor);
	        }
	      });
	    };
	    var Keys = { setup: setup };
	
	    global.add('autolink', function (editor) {
	      Keys.setup(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "colorpicker" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/colorpicker')
	//   ES2015:
	//     import 'tinymce/plugins/colorpicker'
	__webpack_require__(542);

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	(function () {
	var colorpicker = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Color');
	
	    var showPreview = function (win, hexColor) {
	      win.find('#preview')[0].getEl().style.background = hexColor;
	    };
	    var setColor = function (win, value) {
	      var color = global$1(value), rgb = color.toRgb();
	      win.fromJSON({
	        r: rgb.r,
	        g: rgb.g,
	        b: rgb.b,
	        hex: color.toHex().substr(1)
	      });
	      showPreview(win, color.toHex());
	    };
	    var open = function (editor, callback, value) {
	      var win = editor.windowManager.open({
	        title: 'Color',
	        items: {
	          type: 'container',
	          layout: 'flex',
	          direction: 'row',
	          align: 'stretch',
	          padding: 5,
	          spacing: 10,
	          items: [
	            {
	              type: 'colorpicker',
	              value: value,
	              onchange: function () {
	                var rgb = this.rgb();
	                if (win) {
	                  win.find('#r').value(rgb.r);
	                  win.find('#g').value(rgb.g);
	                  win.find('#b').value(rgb.b);
	                  win.find('#hex').value(this.value().substr(1));
	                  showPreview(win, this.value());
	                }
	              }
	            },
	            {
	              type: 'form',
	              padding: 0,
	              labelGap: 5,
	              defaults: {
	                type: 'textbox',
	                size: 7,
	                value: '0',
	                flex: 1,
	                spellcheck: false,
	                onchange: function () {
	                  var colorPickerCtrl = win.find('colorpicker')[0];
	                  var name, value;
	                  name = this.name();
	                  value = this.value();
	                  if (name === 'hex') {
	                    value = '#' + value;
	                    setColor(win, value);
	                    colorPickerCtrl.value(value);
	                    return;
	                  }
	                  value = {
	                    r: win.find('#r').value(),
	                    g: win.find('#g').value(),
	                    b: win.find('#b').value()
	                  };
	                  colorPickerCtrl.value(value);
	                  setColor(win, value);
	                }
	              },
	              items: [
	                {
	                  name: 'r',
	                  label: 'R',
	                  autofocus: 1
	                },
	                {
	                  name: 'g',
	                  label: 'G'
	                },
	                {
	                  name: 'b',
	                  label: 'B'
	                },
	                {
	                  name: 'hex',
	                  label: '#',
	                  value: '000000'
	                },
	                {
	                  name: 'preview',
	                  type: 'container',
	                  border: 1
	                }
	              ]
	            }
	          ]
	        },
	        onSubmit: function () {
	          callback('#' + win.toJSON().hex);
	        }
	      });
	      setColor(win, value);
	    };
	    var Dialog = { open: open };
	
	    global.add('colorpicker', function (editor) {
	      if (!editor.settings.color_picker_callback) {
	        editor.settings.color_picker_callback = function (callback, value) {
	          Dialog.open(editor, callback, value);
	        };
	      }
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "hr" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/hr')
	//   ES2015:
	//     import 'tinymce/plugins/hr'
	__webpack_require__(544);

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	(function () {
	var hr = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var register = function (editor) {
	      editor.addCommand('InsertHorizontalRule', function () {
	        editor.execCommand('mceInsertContent', false, '<hr />');
	      });
	    };
	    var Commands = { register: register };
	
	    var register$1 = function (editor) {
	      editor.addButton('hr', {
	        icon: 'hr',
	        tooltip: 'Horizontal line',
	        cmd: 'InsertHorizontalRule'
	      });
	      editor.addMenuItem('hr', {
	        icon: 'hr',
	        text: 'Horizontal line',
	        cmd: 'InsertHorizontalRule',
	        context: 'insert'
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('hr', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "image" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/image')
	//   ES2015:
	//     import 'tinymce/plugins/image'
	__webpack_require__(546);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	(function () {
	var image = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasDimensions = function (editor) {
	      return editor.settings.image_dimensions === false ? false : true;
	    };
	    var hasAdvTab = function (editor) {
	      return editor.settings.image_advtab === true ? true : false;
	    };
	    var getPrependUrl = function (editor) {
	      return editor.getParam('image_prepend_url', '');
	    };
	    var getClassList = function (editor) {
	      return editor.getParam('image_class_list');
	    };
	    var hasDescription = function (editor) {
	      return editor.settings.image_description === false ? false : true;
	    };
	    var hasImageTitle = function (editor) {
	      return editor.settings.image_title === true ? true : false;
	    };
	    var hasImageCaption = function (editor) {
	      return editor.settings.image_caption === true ? true : false;
	    };
	    var getImageList = function (editor) {
	      return editor.getParam('image_list', false);
	    };
	    var hasUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', false);
	    };
	    var hasUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', false);
	    };
	    var getUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url');
	    };
	    var getUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler');
	    };
	    var getUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path');
	    };
	    var getUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials');
	    };
	    var Settings = {
	      hasDimensions: hasDimensions,
	      hasAdvTab: hasAdvTab,
	      getPrependUrl: getPrependUrl,
	      getClassList: getClassList,
	      hasDescription: hasDescription,
	      hasImageTitle: hasImageTitle,
	      hasImageCaption: hasImageCaption,
	      getImageList: getImageList,
	      hasUploadUrl: hasUploadUrl,
	      hasUploadHandler: hasUploadHandler,
	      getUploadUrl: getUploadUrl,
	      getUploadHandler: getUploadHandler,
	      getUploadBasePath: getUploadBasePath,
	      getUploadCredentials: getUploadCredentials
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    function FileReader () {
	      var f = Global$1.getOrDie('FileReader');
	      return new f();
	    }
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var parseIntAndGetMax = function (val1, val2) {
	      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
	    };
	    var getImageSize = function (url, callback) {
	      var img = domGlobals.document.createElement('img');
	      function done(width, height) {
	        if (img.parentNode) {
	          img.parentNode.removeChild(img);
	        }
	        callback({
	          width: width,
	          height: height
	        });
	      }
	      img.onload = function () {
	        var width = parseIntAndGetMax(img.width, img.clientWidth);
	        var height = parseIntAndGetMax(img.height, img.clientHeight);
	        done(width, height);
	      };
	      img.onerror = function () {
	        done(0, 0);
	      };
	      var style = img.style;
	      style.visibility = 'hidden';
	      style.position = 'fixed';
	      style.bottom = style.left = '0px';
	      style.width = style.height = 'auto';
	      domGlobals.document.body.appendChild(img);
	      img.src = url;
	    };
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      function appendItems(values, output) {
	        output = output || [];
	        global$2.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	            itemCallback(menuItem);
	          }
	          output.push(menuItem);
	        });
	        return output;
	      }
	      return appendItems(inputList, startItems || []);
	    };
	    var removePixelSuffix = function (value) {
	      if (value) {
	        value = value.replace(/px$/, '');
	      }
	      return value;
	    };
	    var addPixelSuffix = function (value) {
	      if (value.length > 0 && /^[0-9]+$/.test(value)) {
	        value += 'px';
	      }
	      return value;
	    };
	    var mergeMargins = function (css) {
	      if (css.margin) {
	        var splitMargin = css.margin.split(' ');
	        switch (splitMargin.length) {
	        case 1:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[0];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[0];
	          break;
	        case 2:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 3:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 4:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[3];
	        }
	        delete css.margin;
	      }
	      return css;
	    };
	    var createImageList = function (editor, callback) {
	      var imageList = Settings.getImageList(editor);
	      if (typeof imageList === 'string') {
	        global$3.send({
	          url: imageList,
	          success: function (text) {
	            callback(JSON.parse(text));
	          }
	        });
	      } else if (typeof imageList === 'function') {
	        imageList(callback);
	      } else {
	        callback(imageList);
	      }
	    };
	    var waitLoadImage = function (editor, data, imgElm) {
	      function selectImage() {
	        imgElm.onload = imgElm.onerror = null;
	        if (editor.selection) {
	          editor.selection.select(imgElm);
	          editor.nodeChanged();
	        }
	      }
	      imgElm.onload = function () {
	        if (!data.width && !data.height && Settings.hasDimensions(editor)) {
	          editor.dom.setAttribs(imgElm, {
	            width: imgElm.clientWidth,
	            height: imgElm.clientHeight
	          });
	        }
	        selectImage();
	      };
	      imgElm.onerror = selectImage;
	    };
	    var blobToDataUri = function (blob) {
	      return new global$1(function (resolve, reject) {
	        var reader = FileReader();
	        reader.onload = function () {
	          resolve(reader.result);
	        };
	        reader.onerror = function () {
	          reject(reader.error.message);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var Utils = {
	      getImageSize: getImageSize,
	      buildListItems: buildListItems,
	      removePixelSuffix: removePixelSuffix,
	      addPixelSuffix: addPixelSuffix,
	      mergeMargins: mergeMargins,
	      createImageList: createImageList,
	      waitLoadImage: waitLoadImage,
	      blobToDataUri: blobToDataUri
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var shallow = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow);
	
	    var DOM = global$4.DOM;
	    var getHspace = function (image) {
	      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
	        return Utils.removePixelSuffix(image.style.marginLeft);
	      } else {
	        return '';
	      }
	    };
	    var getVspace = function (image) {
	      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
	        return Utils.removePixelSuffix(image.style.marginTop);
	      } else {
	        return '';
	      }
	    };
	    var getBorder = function (image) {
	      if (image.style.borderWidth) {
	        return Utils.removePixelSuffix(image.style.borderWidth);
	      } else {
	        return '';
	      }
	    };
	    var getAttrib = function (image, name) {
	      if (image.hasAttribute(name)) {
	        return image.getAttribute(name);
	      } else {
	        return '';
	      }
	    };
	    var getStyle = function (image, name) {
	      return image.style[name] ? image.style[name] : '';
	    };
	    var hasCaption = function (image) {
	      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
	    };
	    var setAttrib = function (image, name, value) {
	      image.setAttribute(name, value);
	    };
	    var wrapInFigure = function (image) {
	      var figureElm = DOM.create('figure', { class: 'image' });
	      DOM.insertAfter(figureElm, image);
	      figureElm.appendChild(image);
	      figureElm.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
	      figureElm.contentEditable = 'false';
	    };
	    var removeFigure = function (image) {
	      var figureElm = image.parentNode;
	      DOM.insertAfter(image, figureElm);
	      DOM.remove(figureElm);
	    };
	    var toggleCaption = function (image) {
	      if (hasCaption(image)) {
	        removeFigure(image);
	      } else {
	        wrapInFigure(image);
	      }
	    };
	    var normalizeStyle = function (image, normalizeCss) {
	      var attrValue = image.getAttribute('style');
	      var value = normalizeCss(attrValue !== null ? attrValue : '');
	      if (value.length > 0) {
	        image.setAttribute('style', value);
	        image.setAttribute('data-mce-style', value);
	      } else {
	        image.removeAttribute('style');
	      }
	    };
	    var setSize = function (name, normalizeCss) {
	      return function (image, name, value) {
	        if (image.style[name]) {
	          image.style[name] = Utils.addPixelSuffix(value);
	          normalizeStyle(image, normalizeCss);
	        } else {
	          setAttrib(image, name, value);
	        }
	      };
	    };
	    var getSize = function (image, name) {
	      if (image.style[name]) {
	        return Utils.removePixelSuffix(image.style[name]);
	      } else {
	        return getAttrib(image, name);
	      }
	    };
	    var setHspace = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.marginLeft = pxValue;
	      image.style.marginRight = pxValue;
	    };
	    var setVspace = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.marginTop = pxValue;
	      image.style.marginBottom = pxValue;
	    };
	    var setBorder = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.borderWidth = pxValue;
	    };
	    var setBorderStyle = function (image, value) {
	      image.style.borderStyle = value;
	    };
	    var getBorderStyle = function (image) {
	      return getStyle(image, 'borderStyle');
	    };
	    var isFigure = function (elm) {
	      return elm.nodeName === 'FIGURE';
	    };
	    var defaultData = function () {
	      return {
	        src: '',
	        alt: '',
	        title: '',
	        width: '',
	        height: '',
	        class: '',
	        style: '',
	        caption: false,
	        hspace: '',
	        vspace: '',
	        border: '',
	        borderStyle: ''
	      };
	    };
	    var getStyleValue = function (normalizeCss, data) {
	      var image = domGlobals.document.createElement('img');
	      setAttrib(image, 'style', data.style);
	      if (getHspace(image) || data.hspace !== '') {
	        setHspace(image, data.hspace);
	      }
	      if (getVspace(image) || data.vspace !== '') {
	        setVspace(image, data.vspace);
	      }
	      if (getBorder(image) || data.border !== '') {
	        setBorder(image, data.border);
	      }
	      if (getBorderStyle(image) || data.borderStyle !== '') {
	        setBorderStyle(image, data.borderStyle);
	      }
	      return normalizeCss(image.getAttribute('style'));
	    };
	    var create = function (normalizeCss, data) {
	      var image = domGlobals.document.createElement('img');
	      write(normalizeCss, merge(data, { caption: false }), image);
	      setAttrib(image, 'alt', data.alt);
	      if (data.caption) {
	        var figure = DOM.create('figure', { class: 'image' });
	        figure.appendChild(image);
	        figure.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
	        figure.contentEditable = 'false';
	        return figure;
	      } else {
	        return image;
	      }
	    };
	    var read = function (normalizeCss, image) {
	      return {
	        src: getAttrib(image, 'src'),
	        alt: getAttrib(image, 'alt'),
	        title: getAttrib(image, 'title'),
	        width: getSize(image, 'width'),
	        height: getSize(image, 'height'),
	        class: getAttrib(image, 'class'),
	        style: normalizeCss(getAttrib(image, 'style')),
	        caption: hasCaption(image),
	        hspace: getHspace(image),
	        vspace: getVspace(image),
	        border: getBorder(image),
	        borderStyle: getStyle(image, 'borderStyle')
	      };
	    };
	    var updateProp = function (image, oldData, newData, name, set) {
	      if (newData[name] !== oldData[name]) {
	        set(image, name, newData[name]);
	      }
	    };
	    var normalized = function (set, normalizeCss) {
	      return function (image, name, value) {
	        set(image, value);
	        normalizeStyle(image, normalizeCss);
	      };
	    };
	    var write = function (normalizeCss, newData, image) {
	      var oldData = read(normalizeCss, image);
	      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
	        return toggleCaption(image);
	      });
	      updateProp(image, oldData, newData, 'src', setAttrib);
	      updateProp(image, oldData, newData, 'alt', setAttrib);
	      updateProp(image, oldData, newData, 'title', setAttrib);
	      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
	      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
	      updateProp(image, oldData, newData, 'class', setAttrib);
	      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
	        return setAttrib(image, 'style', value);
	      }, normalizeCss));
	      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
	      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
	      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
	      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
	    };
	
	    var normalizeCss = function (editor, cssText) {
	      var css = editor.dom.styles.parse(cssText);
	      var mergedCss = Utils.mergeMargins(css);
	      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
	      return editor.dom.styles.serialize(compressed);
	    };
	    var getSelectedImage = function (editor) {
	      var imgElm = editor.selection.getNode();
	      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
	      if (figureElm) {
	        return editor.dom.select('img', figureElm)[0];
	      }
	      if (imgElm && (imgElm.nodeName !== 'IMG' || imgElm.getAttribute('data-mce-object') || imgElm.getAttribute('data-mce-placeholder'))) {
	        return null;
	      }
	      return imgElm;
	    };
	    var splitTextBlock = function (editor, figure) {
	      var dom = editor.dom;
	      var textBlock = dom.getParent(figure.parentNode, function (node) {
	        return editor.schema.getTextBlockElements()[node.nodeName];
	      }, editor.getBody());
	      if (textBlock) {
	        return dom.split(textBlock, figure);
	      } else {
	        return figure;
	      }
	    };
	    var readImageDataFromSelection = function (editor) {
	      var image = getSelectedImage(editor);
	      return image ? read(function (css) {
	        return normalizeCss(editor, css);
	      }, image) : defaultData();
	    };
	    var insertImageAtCaret = function (editor, data) {
	      var elm = create(function (css) {
	        return normalizeCss(editor, css);
	      }, data);
	      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
	      editor.focus();
	      editor.selection.setContent(elm.outerHTML);
	      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
	      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
	      if (isFigure(insertedElm)) {
	        var figure = splitTextBlock(editor, insertedElm);
	        editor.selection.select(figure);
	      } else {
	        editor.selection.select(insertedElm);
	      }
	    };
	    var syncSrcAttr = function (editor, image) {
	      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
	    };
	    var deleteImage = function (editor, image) {
	      if (image) {
	        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
	        editor.dom.remove(elm);
	        editor.focus();
	        editor.nodeChanged();
	        if (editor.dom.isEmpty(editor.getBody())) {
	          editor.setContent('');
	          editor.selection.setCursorLocation();
	        }
	      }
	    };
	    var writeImageDataToSelection = function (editor, data) {
	      var image = getSelectedImage(editor);
	      write(function (css) {
	        return normalizeCss(editor, css);
	      }, data, image);
	      syncSrcAttr(editor, image);
	      if (isFigure(image.parentNode)) {
	        var figure = image.parentNode;
	        splitTextBlock(editor, figure);
	        editor.selection.select(image.parentNode);
	      } else {
	        editor.selection.select(image);
	        Utils.waitLoadImage(editor, data, image);
	      }
	    };
	    var insertOrUpdateImage = function (editor, data) {
	      var image = getSelectedImage(editor);
	      if (image) {
	        if (data.src) {
	          writeImageDataToSelection(editor, data);
	        } else {
	          deleteImage(editor, image);
	        }
	      } else if (data.src) {
	        insertImageAtCaret(editor, data);
	      }
	    };
	
	    var updateVSpaceHSpaceBorder = function (editor) {
	      return function (evt) {
	        var dom = editor.dom;
	        var rootControl = evt.control.rootControl;
	        if (!Settings.hasAdvTab(editor)) {
	          return;
	        }
	        var data = rootControl.toJSON();
	        var css = dom.parseStyle(data.style);
	        rootControl.find('#vspace').value('');
	        rootControl.find('#hspace').value('');
	        css = Utils.mergeMargins(css);
	        if (css['margin-top'] && css['margin-bottom'] || css['margin-right'] && css['margin-left']) {
	          if (css['margin-top'] === css['margin-bottom']) {
	            rootControl.find('#vspace').value(Utils.removePixelSuffix(css['margin-top']));
	          } else {
	            rootControl.find('#vspace').value('');
	          }
	          if (css['margin-right'] === css['margin-left']) {
	            rootControl.find('#hspace').value(Utils.removePixelSuffix(css['margin-right']));
	          } else {
	            rootControl.find('#hspace').value('');
	          }
	        }
	        if (css['border-width']) {
	          rootControl.find('#border').value(Utils.removePixelSuffix(css['border-width']));
	        } else {
	          rootControl.find('#border').value('');
	        }
	        if (css['border-style']) {
	          rootControl.find('#borderStyle').value(css['border-style']);
	        } else {
	          rootControl.find('#borderStyle').value('');
	        }
	        rootControl.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
	      };
	    };
	    var updateStyle = function (editor, win) {
	      win.find('#style').each(function (ctrl) {
	        var value = getStyleValue(function (css) {
	          return normalizeCss(editor, css);
	        }, merge(defaultData(), win.toJSON()));
	        ctrl.value(value);
	      });
	    };
	    var makeTab = function (editor) {
	      return {
	        title: 'Advanced',
	        type: 'form',
	        pack: 'start',
	        items: [
	          {
	            label: 'Style',
	            name: 'style',
	            type: 'textbox',
	            onchange: updateVSpaceHSpaceBorder(editor)
	          },
	          {
	            type: 'form',
	            layout: 'grid',
	            packV: 'start',
	            columns: 2,
	            padding: 0,
	            defaults: {
	              type: 'textbox',
	              maxWidth: 50,
	              onchange: function (evt) {
	                updateStyle(editor, evt.control.rootControl);
	              }
	            },
	            items: [
	              {
	                label: 'Vertical space',
	                name: 'vspace'
	              },
	              {
	                label: 'Border width',
	                name: 'border'
	              },
	              {
	                label: 'Horizontal space',
	                name: 'hspace'
	              },
	              {
	                label: 'Border style',
	                type: 'listbox',
	                name: 'borderStyle',
	                width: 90,
	                maxWidth: 90,
	                onselect: function (evt) {
	                  updateStyle(editor, evt.control.rootControl);
	                },
	                values: [
	                  {
	                    text: 'Select...',
	                    value: ''
	                  },
	                  {
	                    text: 'Solid',
	                    value: 'solid'
	                  },
	                  {
	                    text: 'Dotted',
	                    value: 'dotted'
	                  },
	                  {
	                    text: 'Dashed',
	                    value: 'dashed'
	                  },
	                  {
	                    text: 'Double',
	                    value: 'double'
	                  },
	                  {
	                    text: 'Groove',
	                    value: 'groove'
	                  },
	                  {
	                    text: 'Ridge',
	                    value: 'ridge'
	                  },
	                  {
	                    text: 'Inset',
	                    value: 'inset'
	                  },
	                  {
	                    text: 'Outset',
	                    value: 'outset'
	                  },
	                  {
	                    text: 'None',
	                    value: 'none'
	                  },
	                  {
	                    text: 'Hidden',
	                    value: 'hidden'
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      };
	    };
	    var AdvTab = { makeTab: makeTab };
	
	    var doSyncSize = function (widthCtrl, heightCtrl) {
	      widthCtrl.state.set('oldVal', widthCtrl.value());
	      heightCtrl.state.set('oldVal', heightCtrl.value());
	    };
	    var doSizeControls = function (win, f) {
	      var widthCtrl = win.find('#width')[0];
	      var heightCtrl = win.find('#height')[0];
	      var constrained = win.find('#constrain')[0];
	      if (widthCtrl && heightCtrl && constrained) {
	        f(widthCtrl, heightCtrl, constrained.checked());
	      }
	    };
	    var doUpdateSize = function (widthCtrl, heightCtrl, isContrained) {
	      var oldWidth = widthCtrl.state.get('oldVal');
	      var oldHeight = heightCtrl.state.get('oldVal');
	      var newWidth = widthCtrl.value();
	      var newHeight = heightCtrl.value();
	      if (isContrained && oldWidth && oldHeight && newWidth && newHeight) {
	        if (newWidth !== oldWidth) {
	          newHeight = Math.round(newWidth / oldWidth * newHeight);
	          if (!isNaN(newHeight)) {
	            heightCtrl.value(newHeight);
	          }
	        } else {
	          newWidth = Math.round(newHeight / oldHeight * newWidth);
	          if (!isNaN(newWidth)) {
	            widthCtrl.value(newWidth);
	          }
	        }
	      }
	      doSyncSize(widthCtrl, heightCtrl);
	    };
	    var syncSize = function (win) {
	      doSizeControls(win, doSyncSize);
	    };
	    var updateSize = function (win) {
	      doSizeControls(win, doUpdateSize);
	    };
	    var createUi = function () {
	      var recalcSize = function (evt) {
	        updateSize(evt.control.rootControl);
	      };
	      return {
	        type: 'container',
	        label: 'Dimensions',
	        layout: 'flex',
	        align: 'center',
	        spacing: 5,
	        items: [
	          {
	            name: 'width',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Width'
	          },
	          {
	            type: 'label',
	            text: 'x'
	          },
	          {
	            name: 'height',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Height'
	          },
	          {
	            name: 'constrain',
	            type: 'checkbox',
	            checked: true,
	            text: 'Constrain proportions'
	          }
	        ]
	      };
	    };
	    var SizeManager = {
	      createUi: createUi,
	      syncSize: syncSize,
	      updateSize: updateSize
	    };
	
	    var onSrcChange = function (evt, editor) {
	      var srcURL, prependURL, absoluteURLPattern;
	      var meta = evt.meta || {};
	      var control = evt.control;
	      var rootControl = control.rootControl;
	      var imageListCtrl = rootControl.find('#image-list')[0];
	      if (imageListCtrl) {
	        imageListCtrl.value(editor.convertURL(control.value(), 'src'));
	      }
	      global$2.each(meta, function (value, key) {
	        rootControl.find('#' + key).value(value);
	      });
	      if (!meta.width && !meta.height) {
	        srcURL = editor.convertURL(control.value(), 'src');
	        prependURL = Settings.getPrependUrl(editor);
	        absoluteURLPattern = new RegExp('^(?:[a-z]+:)?//', 'i');
	        if (prependURL && !absoluteURLPattern.test(srcURL) && srcURL.substring(0, prependURL.length) !== prependURL) {
	          srcURL = prependURL + srcURL;
	        }
	        control.value(srcURL);
	        Utils.getImageSize(editor.documentBaseURI.toAbsolute(control.value()), function (data) {
	          if (data.width && data.height && Settings.hasDimensions(editor)) {
	            rootControl.find('#width').value(data.width);
	            rootControl.find('#height').value(data.height);
	            SizeManager.syncSize(rootControl);
	          }
	        });
	      }
	    };
	    var onBeforeCall = function (evt) {
	      evt.meta = evt.control.rootControl.toJSON();
	    };
	    var getGeneralItems = function (editor, imageListCtrl) {
	      var generalFormItems = [
	        {
	          name: 'src',
	          type: 'filepicker',
	          filetype: 'image',
	          label: 'Source',
	          autofocus: true,
	          onchange: function (evt) {
	            onSrcChange(evt, editor);
	          },
	          onbeforecall: onBeforeCall
	        },
	        imageListCtrl
	      ];
	      if (Settings.hasDescription(editor)) {
	        generalFormItems.push({
	          name: 'alt',
	          type: 'textbox',
	          label: 'Image description'
	        });
	      }
	      if (Settings.hasImageTitle(editor)) {
	        generalFormItems.push({
	          name: 'title',
	          type: 'textbox',
	          label: 'Image Title'
	        });
	      }
	      if (Settings.hasDimensions(editor)) {
	        generalFormItems.push(SizeManager.createUi());
	      }
	      if (Settings.getClassList(editor)) {
	        generalFormItems.push({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: Utils.buildListItems(Settings.getClassList(editor), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  inline: 'img',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        });
	      }
	      if (Settings.hasImageCaption(editor)) {
	        generalFormItems.push({
	          name: 'caption',
	          type: 'checkbox',
	          label: 'Caption'
	        });
	      }
	      return generalFormItems;
	    };
	    var makeTab$1 = function (editor, imageListCtrl) {
	      return {
	        title: 'General',
	        type: 'form',
	        items: getGeneralItems(editor, imageListCtrl)
	      };
	    };
	    var MainTab = {
	      makeTab: makeTab$1,
	      getGeneralItems: getGeneralItems
	    };
	
	    var url = function () {
	      return Global$1.getOrDie('URL');
	    };
	    var createObjectURL = function (blob) {
	      return url().createObjectURL(blob);
	    };
	    var revokeObjectURL = function (u) {
	      url().revokeObjectURL(u);
	    };
	    var URL = {
	      createObjectURL: createObjectURL,
	      revokeObjectURL: revokeObjectURL
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.ui.Factory');
	
	    function XMLHttpRequest () {
	      var f = Global$1.getOrDie('XMLHttpRequest');
	      return new f();
	    }
	
	    var noop = function () {
	    };
	    var pathJoin = function (path1, path2) {
	      if (path1) {
	        return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	      }
	      return path2;
	    };
	    function Uploader (settings) {
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr, formData;
	        xhr = XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          var json;
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        formData = new domGlobals.FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var uploadBlob = function (blobInfo, handler) {
	        return new global$1(function (resolve, reject) {
	          try {
	            handler(blobInfo, resolve, reject, noop);
	          } catch (ex) {
	            reject(ex.message);
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var upload = function (blobInfo) {
	        return !settings.url && isDefaultHandler(settings.handler) ? global$1.reject('Upload url missing from the settings.') : uploadBlob(blobInfo, settings.handler);
	      };
	      settings = global$2.extend({
	        credentials: false,
	        handler: defaultHandler
	      }, settings);
	      return { upload: upload };
	    }
	
	    var onFileInput = function (editor) {
	      return function (evt) {
	        var Throbber = global$5.get('Throbber');
	        var rootControl = evt.control.rootControl;
	        var throbber = new Throbber(rootControl.getEl());
	        var file = evt.control.value();
	        var blobUri = URL.createObjectURL(file);
	        var uploader = Uploader({
	          url: Settings.getUploadUrl(editor),
	          basePath: Settings.getUploadBasePath(editor),
	          credentials: Settings.getUploadCredentials(editor),
	          handler: Settings.getUploadHandler(editor)
	        });
	        var finalize = function () {
	          throbber.hide();
	          URL.revokeObjectURL(blobUri);
	        };
	        throbber.show();
	        return Utils.blobToDataUri(file).then(function (dataUrl) {
	          var blobInfo = editor.editorUpload.blobCache.create({
	            blob: file,
	            blobUri: blobUri,
	            name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
	            base64: dataUrl.split(',')[1]
	          });
	          return uploader.upload(blobInfo).then(function (url) {
	            var src = rootControl.find('#src');
	            src.value(url);
	            rootControl.find('tabpanel')[0].activateTab(0);
	            src.fire('change');
	            finalize();
	            return url;
	          });
	        }).catch(function (err) {
	          editor.windowManager.alert(err);
	          finalize();
	        });
	      };
	    };
	    var acceptExts = '.jpg,.jpeg,.png,.gif';
	    var makeTab$2 = function (editor) {
	      return {
	        title: 'Upload',
	        type: 'form',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        padding: '20 20 20 20',
	        items: [
	          {
	            type: 'container',
	            layout: 'flex',
	            direction: 'column',
	            align: 'center',
	            spacing: 10,
	            items: [
	              {
	                text: 'Browse for an image',
	                type: 'browsebutton',
	                accept: acceptExts,
	                onchange: onFileInput(editor)
	              },
	              {
	                text: 'OR',
	                type: 'label'
	              }
	            ]
	          },
	          {
	            text: 'Drop an image here',
	            type: 'dropzone',
	            accept: acceptExts,
	            height: 100,
	            onchange: onFileInput(editor)
	          }
	        ]
	      };
	    };
	    var UploadTab = { makeTab: makeTab$2 };
	
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	
	    var submitForm = function (editor, evt) {
	      var win = evt.control.getRoot();
	      SizeManager.updateSize(win);
	      editor.undoManager.transact(function () {
	        var data = merge(readImageDataFromSelection(editor), win.toJSON());
	        insertOrUpdateImage(editor, data);
	      });
	      editor.editorUpload.uploadImagesAuto();
	    };
	    function Dialog (editor) {
	      function showDialog(imageList) {
	        var data = readImageDataFromSelection(editor);
	        var win, imageListCtrl;
	        if (imageList) {
	          imageListCtrl = {
	            type: 'listbox',
	            label: 'Image list',
	            name: 'image-list',
	            values: Utils.buildListItems(imageList, function (item) {
	              item.value = editor.convertURL(item.value || item.url, 'src');
	            }, [{
	                text: 'None',
	                value: ''
	              }]),
	            value: data.src && editor.convertURL(data.src, 'src'),
	            onselect: function (e) {
	              var altCtrl = win.find('#alt');
	              if (!altCtrl.value() || e.lastControl && altCtrl.value() === e.lastControl.text()) {
	                altCtrl.value(e.control.text());
	              }
	              win.find('#src').value(e.control.value()).fire('change');
	            },
	            onPostRender: function () {
	              imageListCtrl = this;
	            }
	          };
	        }
	        if (Settings.hasAdvTab(editor) || Settings.hasUploadUrl(editor) || Settings.hasUploadHandler(editor)) {
	          var body = [MainTab.makeTab(editor, imageListCtrl)];
	          if (Settings.hasAdvTab(editor)) {
	            body.push(AdvTab.makeTab(editor));
	          }
	          if (Settings.hasUploadUrl(editor) || Settings.hasUploadHandler(editor)) {
	            body.push(UploadTab.makeTab(editor));
	          }
	          win = editor.windowManager.open({
	            title: 'Insert/edit image',
	            data: data,
	            bodyType: 'tabpanel',
	            body: body,
	            onSubmit: curry(submitForm, editor)
	          });
	        } else {
	          win = editor.windowManager.open({
	            title: 'Insert/edit image',
	            data: data,
	            body: MainTab.getGeneralItems(editor, imageListCtrl),
	            onSubmit: curry(submitForm, editor)
	          });
	        }
	        SizeManager.syncSize(win);
	      }
	      function open() {
	        Utils.createImageList(editor, showDialog);
	      }
	      return { open: open };
	    }
	
	    var register = function (editor) {
	      editor.addCommand('mceImage', Dialog(editor).open);
	    };
	    var Commands = { register: register };
	
	    var hasImageClass = function (node) {
	      var className = node.attr('class');
	      return className && /\bimage\b/.test(className);
	    };
	    var toggleContentEditableState = function (state) {
	      return function (nodes) {
	        var i = nodes.length, node;
	        var toggleContentEditable = function (node) {
	          node.attr('contenteditable', state ? 'true' : null);
	        };
	        while (i--) {
	          node = nodes[i];
	          if (hasImageClass(node)) {
	            node.attr('contenteditable', state ? 'false' : null);
	            global$2.each(node.getAll('figcaption'), toggleContentEditable);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('preInit', function () {
	        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
	        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
	      });
	    };
	    var FilterContent = { setup: setup };
	
	    var register$1 = function (editor) {
	      editor.addButton('image', {
	        icon: 'image',
	        tooltip: 'Insert/edit image',
	        onclick: Dialog(editor).open,
	        stateSelector: 'img:not([data-mce-object],[data-mce-placeholder]),figure.image'
	      });
	      editor.addMenuItem('image', {
	        icon: 'image',
	        text: 'Image',
	        onclick: Dialog(editor).open,
	        context: 'insert',
	        prependToContext: true
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('image', function (editor) {
	      FilterContent.setup(editor);
	      Buttons.register(editor);
	      Commands.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "link" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/link')
	//   ES2015:
	//     import 'tinymce/plugins/link'
	__webpack_require__(548);

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	(function () {
	var link = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var assumeExternalTargets = function (editorSettings) {
	      return typeof editorSettings.link_assume_external_targets === 'boolean' ? editorSettings.link_assume_external_targets : false;
	    };
	    var hasContextToolbar = function (editorSettings) {
	      return typeof editorSettings.link_context_toolbar === 'boolean' ? editorSettings.link_context_toolbar : false;
	    };
	    var getLinkList = function (editorSettings) {
	      return editorSettings.link_list;
	    };
	    var hasDefaultLinkTarget = function (editorSettings) {
	      return typeof editorSettings.default_link_target === 'string';
	    };
	    var getDefaultLinkTarget = function (editorSettings) {
	      return editorSettings.default_link_target;
	    };
	    var getTargetList = function (editorSettings) {
	      return editorSettings.target_list;
	    };
	    var setTargetList = function (editor, list) {
	      editor.settings.target_list = list;
	    };
	    var shouldShowTargetList = function (editorSettings) {
	      return getTargetList(editorSettings) !== false;
	    };
	    var getRelList = function (editorSettings) {
	      return editorSettings.rel_list;
	    };
	    var hasRelList = function (editorSettings) {
	      return getRelList(editorSettings) !== undefined;
	    };
	    var getLinkClassList = function (editorSettings) {
	      return editorSettings.link_class_list;
	    };
	    var hasLinkClassList = function (editorSettings) {
	      return getLinkClassList(editorSettings) !== undefined;
	    };
	    var shouldShowLinkTitle = function (editorSettings) {
	      return editorSettings.link_title !== false;
	    };
	    var allowUnsafeLinkTarget = function (editorSettings) {
	      return typeof editorSettings.allow_unsafe_link_target === 'boolean' ? editorSettings.allow_unsafe_link_target : false;
	    };
	    var Settings = {
	      assumeExternalTargets: assumeExternalTargets,
	      hasContextToolbar: hasContextToolbar,
	      getLinkList: getLinkList,
	      hasDefaultLinkTarget: hasDefaultLinkTarget,
	      getDefaultLinkTarget: getDefaultLinkTarget,
	      getTargetList: getTargetList,
	      setTargetList: setTargetList,
	      shouldShowTargetList: shouldShowTargetList,
	      getRelList: getRelList,
	      hasRelList: hasRelList,
	      getLinkClassList: getLinkClassList,
	      hasLinkClassList: hasLinkClassList,
	      shouldShowLinkTitle: shouldShowLinkTitle,
	      allowUnsafeLinkTarget: allowUnsafeLinkTarget
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var appendClickRemove = function (link, evt) {
	      domGlobals.document.body.appendChild(link);
	      link.dispatchEvent(evt);
	      domGlobals.document.body.removeChild(link);
	    };
	    var open = function (url) {
	      if (!global$3.ie || global$3.ie > 10) {
	        var link = domGlobals.document.createElement('a');
	        link.target = '_blank';
	        link.href = url;
	        link.rel = 'noreferrer noopener';
	        var evt = domGlobals.document.createEvent('MouseEvents');
	        evt.initMouseEvent('click', true, true, domGlobals.window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	        appendClickRemove(link, evt);
	      } else {
	        var win = domGlobals.window.open('', '_blank');
	        if (win) {
	          win.opener = null;
	          var doc = win.document;
	          doc.open();
	          doc.write('<meta http-equiv="refresh" content="0; url=' + global$2.DOM.encode(url) + '">');
	          doc.close();
	        }
	      }
	    };
	    var OpenUrl = { open: open };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var toggleTargetRules = function (rel, isUnsafe) {
	      var rules = ['noopener'];
	      var newRel = rel ? rel.split(/\s+/) : [];
	      var toString = function (rel) {
	        return global$4.trim(rel.sort().join(' '));
	      };
	      var addTargetRules = function (rel) {
	        rel = removeTargetRules(rel);
	        return rel.length ? rel.concat(rules) : rules;
	      };
	      var removeTargetRules = function (rel) {
	        return rel.filter(function (val) {
	          return global$4.inArray(rules, val) === -1;
	        });
	      };
	      newRel = isUnsafe ? addTargetRules(newRel) : removeTargetRules(newRel);
	      return newRel.length ? toString(newRel) : null;
	    };
	    var trimCaretContainers = function (text) {
	      return text.replace(/\uFEFF/g, '');
	    };
	    var getAnchorElement = function (editor, selectedElm) {
	      selectedElm = selectedElm || editor.selection.getNode();
	      if (isImageFigure(selectedElm)) {
	        return editor.dom.select('a[href]', selectedElm)[0];
	      } else {
	        return editor.dom.getParent(selectedElm, 'a[href]');
	      }
	    };
	    var getAnchorText = function (selection, anchorElm) {
	      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
	      return trimCaretContainers(text);
	    };
	    var isLink = function (elm) {
	      return elm && elm.nodeName === 'A' && elm.href;
	    };
	    var hasLinks = function (elements) {
	      return global$4.grep(elements, isLink).length > 0;
	    };
	    var isOnlyTextSelected = function (html) {
	      if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') === -1)) {
	        return false;
	      }
	      return true;
	    };
	    var isImageFigure = function (node) {
	      return node && node.nodeName === 'FIGURE' && /\bimage\b/i.test(node.className);
	    };
	    var link = function (editor, attachState) {
	      return function (data) {
	        editor.undoManager.transact(function () {
	          var selectedElm = editor.selection.getNode();
	          var anchorElm = getAnchorElement(editor, selectedElm);
	          var linkAttrs = {
	            href: data.href,
	            target: data.target ? data.target : null,
	            rel: data.rel ? data.rel : null,
	            class: data.class ? data.class : null,
	            title: data.title ? data.title : null
	          };
	          if (!Settings.hasRelList(editor.settings) && Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	            linkAttrs.rel = toggleTargetRules(linkAttrs.rel, linkAttrs.target === '_blank');
	          }
	          if (data.href === attachState.href) {
	            attachState.attach();
	            attachState = {};
	          }
	          if (anchorElm) {
	            editor.focus();
	            if (data.hasOwnProperty('text')) {
	              if ('innerText' in anchorElm) {
	                anchorElm.innerText = data.text;
	              } else {
	                anchorElm.textContent = data.text;
	              }
	            }
	            editor.dom.setAttribs(anchorElm, linkAttrs);
	            editor.selection.select(anchorElm);
	            editor.undoManager.add();
	          } else {
	            if (isImageFigure(selectedElm)) {
	              linkImageFigure(editor, selectedElm, linkAttrs);
	            } else if (data.hasOwnProperty('text')) {
	              editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(data.text)));
	            } else {
	              editor.execCommand('mceInsertLink', false, linkAttrs);
	            }
	          }
	        });
	      };
	    };
	    var unlink = function (editor) {
	      return function () {
	        editor.undoManager.transact(function () {
	          var node = editor.selection.getNode();
	          if (isImageFigure(node)) {
	            unlinkImageFigure(editor, node);
	          } else {
	            editor.execCommand('unlink');
	          }
	        });
	      };
	    };
	    var unlinkImageFigure = function (editor, fig) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.getParents(img, 'a[href]', fig)[0];
	        if (a) {
	          a.parentNode.insertBefore(img, a);
	          editor.dom.remove(a);
	        }
	      }
	    };
	    var linkImageFigure = function (editor, fig, attrs) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.create('a', attrs);
	        img.parentNode.insertBefore(a, img);
	        a.appendChild(img);
	      }
	    };
	    var Utils = {
	      link: link,
	      unlink: unlink,
	      isLink: isLink,
	      hasLinks: hasLinks,
	      isOnlyTextSelected: isOnlyTextSelected,
	      getAnchorElement: getAnchorElement,
	      getAnchorText: getAnchorText,
	      toggleTargetRules: toggleTargetRules
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var attachState = {};
	    var createLinkList = function (editor, callback) {
	      var linkList = Settings.getLinkList(editor.settings);
	      if (typeof linkList === 'string') {
	        global$6.send({
	          url: linkList,
	          success: function (text) {
	            callback(editor, JSON.parse(text));
	          }
	        });
	      } else if (typeof linkList === 'function') {
	        linkList(function (list) {
	          callback(editor, list);
	        });
	      } else {
	        callback(editor, linkList);
	      }
	    };
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      var appendItems = function (values, output) {
	        output = output || [];
	        global$4.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	            if (itemCallback) {
	              itemCallback(menuItem);
	            }
	          }
	          output.push(menuItem);
	        });
	        return output;
	      };
	      return appendItems(inputList, startItems || []);
	    };
	    var delayedConfirm = function (editor, message, callback) {
	      var rng = editor.selection.getRng();
	      global$5.setEditorTimeout(editor, function () {
	        editor.windowManager.confirm(message, function (state) {
	          editor.selection.setRng(rng);
	          callback(state);
	        });
	      });
	    };
	    var showDialog = function (editor, linkList) {
	      var data = {};
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var anchorElm, initialText;
	      var win, onlyText, textListCtrl, linkListCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;
	      var linkListChangeHandler = function (e) {
	        var textCtrl = win.find('#text');
	        if (!textCtrl.value() || e.lastControl && textCtrl.value() === e.lastControl.text()) {
	          textCtrl.value(e.control.text());
	        }
	        win.find('#href').value(e.control.value());
	      };
	      var buildAnchorListControl = function (url) {
	        var anchorList = [];
	        global$4.each(editor.dom.select('a:not([href])'), function (anchor) {
	          var id = anchor.name || anchor.id;
	          if (id) {
	            anchorList.push({
	              text: id,
	              value: '#' + id,
	              selected: url.indexOf('#' + id) !== -1
	            });
	          }
	        });
	        if (anchorList.length) {
	          anchorList.unshift({
	            text: 'None',
	            value: ''
	          });
	          return {
	            name: 'anchor',
	            type: 'listbox',
	            label: 'Anchors',
	            values: anchorList,
	            onselect: linkListChangeHandler
	          };
	        }
	      };
	      var updateText = function () {
	        if (!initialText && onlyText && !data.text) {
	          this.parent().parent().find('#text')[0].value(this.value());
	        }
	      };
	      var urlChange = function (e) {
	        var meta = e.meta || {};
	        if (linkListCtrl) {
	          linkListCtrl.value(editor.convertURL(this.value(), 'href'));
	        }
	        global$4.each(e.meta, function (value, key) {
	          var inp = win.find('#' + key);
	          if (key === 'text') {
	            if (initialText.length === 0) {
	              inp.value(value);
	              data.text = value;
	            }
	          } else {
	            inp.value(value);
	          }
	        });
	        if (meta.attach) {
	          attachState = {
	            href: this.value(),
	            attach: meta.attach
	          };
	        }
	        if (!meta.text) {
	          updateText.call(this);
	        }
	      };
	      var onBeforeCall = function (e) {
	        e.meta = win.toJSON();
	      };
	      onlyText = Utils.isOnlyTextSelected(selection.getContent());
	      anchorElm = Utils.getAnchorElement(editor);
	      data.text = initialText = Utils.getAnchorText(editor.selection, anchorElm);
	      data.href = anchorElm ? dom.getAttrib(anchorElm, 'href') : '';
	      if (anchorElm) {
	        data.target = dom.getAttrib(anchorElm, 'target');
	      } else if (Settings.hasDefaultLinkTarget(editor.settings)) {
	        data.target = Settings.getDefaultLinkTarget(editor.settings);
	      }
	      if (value = dom.getAttrib(anchorElm, 'rel')) {
	        data.rel = value;
	      }
	      if (value = dom.getAttrib(anchorElm, 'class')) {
	        data.class = value;
	      }
	      if (value = dom.getAttrib(anchorElm, 'title')) {
	        data.title = value;
	      }
	      if (onlyText) {
	        textListCtrl = {
	          name: 'text',
	          type: 'textbox',
	          size: 40,
	          label: 'Text to display',
	          onchange: function () {
	            data.text = this.value();
	          }
	        };
	      }
	      if (linkList) {
	        linkListCtrl = {
	          type: 'listbox',
	          label: 'Link list',
	          values: buildListItems(linkList, function (item) {
	            item.value = editor.convertURL(item.value || item.url, 'href');
	          }, [{
	              text: 'None',
	              value: ''
	            }]),
	          onselect: linkListChangeHandler,
	          value: editor.convertURL(data.href, 'href'),
	          onPostRender: function () {
	            linkListCtrl = this;
	          }
	        };
	      }
	      if (Settings.shouldShowTargetList(editor.settings)) {
	        if (Settings.getTargetList(editor.settings) === undefined) {
	          Settings.setTargetList(editor, [
	            {
	              text: 'None',
	              value: ''
	            },
	            {
	              text: 'New window',
	              value: '_blank'
	            }
	          ]);
	        }
	        targetListCtrl = {
	          name: 'target',
	          type: 'listbox',
	          label: 'Target',
	          values: buildListItems(Settings.getTargetList(editor.settings))
	        };
	      }
	      if (Settings.hasRelList(editor.settings)) {
	        relListCtrl = {
	          name: 'rel',
	          type: 'listbox',
	          label: 'Rel',
	          values: buildListItems(Settings.getRelList(editor.settings), function (item) {
	            if (Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	              item.value = Utils.toggleTargetRules(item.value, data.target === '_blank');
	            }
	          })
	        };
	      }
	      if (Settings.hasLinkClassList(editor.settings)) {
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: buildListItems(Settings.getLinkClassList(editor.settings), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  inline: 'a',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        };
	      }
	      if (Settings.shouldShowLinkTitle(editor.settings)) {
	        linkTitleCtrl = {
	          name: 'title',
	          type: 'textbox',
	          label: 'Title',
	          value: data.title
	        };
	      }
	      win = editor.windowManager.open({
	        title: 'Insert link',
	        data: data,
	        body: [
	          {
	            name: 'href',
	            type: 'filepicker',
	            filetype: 'file',
	            size: 40,
	            autofocus: true,
	            label: 'Url',
	            onchange: urlChange,
	            onkeyup: updateText,
	            onpaste: updateText,
	            onbeforecall: onBeforeCall
	          },
	          textListCtrl,
	          linkTitleCtrl,
	          buildAnchorListControl(data.href),
	          linkListCtrl,
	          relListCtrl,
	          targetListCtrl,
	          classListCtrl
	        ],
	        onSubmit: function (e) {
	          var assumeExternalTargets = Settings.assumeExternalTargets(editor.settings);
	          var insertLink = Utils.link(editor, attachState);
	          var removeLink = Utils.unlink(editor);
	          var resultData = global$4.extend({}, data, e.data);
	          var href = resultData.href;
	          if (!href) {
	            removeLink();
	            return;
	          }
	          if (!onlyText || resultData.text === initialText) {
	            delete resultData.text;
	          }
	          if (href.indexOf('@') > 0 && href.indexOf('//') === -1 && href.indexOf('mailto:') === -1) {
	            delayedConfirm(editor, 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?', function (state) {
	              if (state) {
	                resultData.href = 'mailto:' + href;
	              }
	              insertLink(resultData);
	            });
	            return;
	          }
	          if (assumeExternalTargets === true && !/^\w+:/i.test(href) || assumeExternalTargets === false && /^\s*www[\.|\d\.]/i.test(href)) {
	            delayedConfirm(editor, 'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?', function (state) {
	              if (state) {
	                resultData.href = 'http://' + href;
	              }
	              insertLink(resultData);
	            });
	            return;
	          }
	          insertLink(resultData);
	        }
	      });
	    };
	    var open$1 = function (editor) {
	      createLinkList(editor, showDialog);
	    };
	    var Dialog = { open: open$1 };
	
	    var getLink = function (editor, elm) {
	      return editor.dom.getParent(elm, 'a[href]');
	    };
	    var getSelectedLink = function (editor) {
	      return getLink(editor, editor.selection.getStart());
	    };
	    var getHref = function (elm) {
	      var href = elm.getAttribute('data-mce-href');
	      return href ? href : elm.getAttribute('href');
	    };
	    var isContextMenuVisible = function (editor) {
	      var contextmenu = editor.plugins.contextmenu;
	      return contextmenu ? contextmenu.isContextMenuVisible() : false;
	    };
	    var hasOnlyAltModifier = function (e) {
	      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
	    };
	    var gotoLink = function (editor, a) {
	      if (a) {
	        var href = getHref(a);
	        if (/^#/.test(href)) {
	          var targetEl = editor.$(href);
	          if (targetEl.length) {
	            editor.selection.scrollIntoView(targetEl[0], true);
	          }
	        } else {
	          OpenUrl.open(a.href);
	        }
	      }
	    };
	    var openDialog = function (editor) {
	      return function () {
	        Dialog.open(editor);
	      };
	    };
	    var gotoSelectedLink = function (editor) {
	      return function () {
	        gotoLink(editor, getSelectedLink(editor));
	      };
	    };
	    var leftClickedOnAHref = function (editor) {
	      return function (elm) {
	        var sel, rng, node;
	        if (Settings.hasContextToolbar(editor.settings) && !isContextMenuVisible(editor) && Utils.isLink(elm)) {
	          sel = editor.selection;
	          rng = sel.getRng();
	          node = rng.startContainer;
	          if (node.nodeType === 3 && sel.isCollapsed() && rng.startOffset > 0 && rng.startOffset < node.data.length) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var setupGotoLinks = function (editor) {
	      editor.on('click', function (e) {
	        var link = getLink(editor, e.target);
	        if (link && global$1.metaKeyPressed(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	      editor.on('keydown', function (e) {
	        var link = getSelectedLink(editor);
	        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	    };
	    var toggleActiveState = function (editor) {
	      return function () {
	        var self = this;
	        editor.on('nodechange', function (e) {
	          self.active(!editor.readonly && !!Utils.getAnchorElement(editor, e.element));
	        });
	      };
	    };
	    var toggleViewLinkState = function (editor) {
	      return function () {
	        var self = this;
	        var toggleVisibility = function (e) {
	          if (Utils.hasLinks(e.parents)) {
	            self.show();
	          } else {
	            self.hide();
	          }
	        };
	        if (!Utils.hasLinks(editor.dom.getParents(editor.selection.getStart()))) {
	          self.hide();
	        }
	        editor.on('nodechange', toggleVisibility);
	        self.on('remove', function () {
	          editor.off('nodechange', toggleVisibility);
	        });
	      };
	    };
	    var Actions = {
	      openDialog: openDialog,
	      gotoSelectedLink: gotoSelectedLink,
	      leftClickedOnAHref: leftClickedOnAHref,
	      setupGotoLinks: setupGotoLinks,
	      toggleActiveState: toggleActiveState,
	      toggleViewLinkState: toggleViewLinkState
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceLink', Actions.openDialog(editor));
	    };
	    var Commands = { register: register };
	
	    var setup = function (editor) {
	      editor.addShortcut('Meta+K', '', Actions.openDialog(editor));
	    };
	    var Keyboard = { setup: setup };
	
	    var setupButtons = function (editor) {
	      editor.addButton('link', {
	        active: false,
	        icon: 'link',
	        tooltip: 'Insert/edit link',
	        onclick: Actions.openDialog(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	      editor.addButton('unlink', {
	        active: false,
	        icon: 'unlink',
	        tooltip: 'Remove link',
	        onclick: Utils.unlink(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	      if (editor.addContextToolbar) {
	        editor.addButton('openlink', {
	          icon: 'newtab',
	          tooltip: 'Open link',
	          onclick: Actions.gotoSelectedLink(editor)
	        });
	      }
	    };
	    var setupMenuItems = function (editor) {
	      editor.addMenuItem('openlink', {
	        text: 'Open link',
	        icon: 'newtab',
	        onclick: Actions.gotoSelectedLink(editor),
	        onPostRender: Actions.toggleViewLinkState(editor),
	        prependToContext: true
	      });
	      editor.addMenuItem('link', {
	        icon: 'link',
	        text: 'Link',
	        shortcut: 'Meta+K',
	        onclick: Actions.openDialog(editor),
	        stateSelector: 'a[href]',
	        context: 'insert',
	        prependToContext: true
	      });
	      editor.addMenuItem('unlink', {
	        icon: 'unlink',
	        text: 'Remove link',
	        onclick: Utils.unlink(editor),
	        stateSelector: 'a[href]'
	      });
	    };
	    var setupContextToolbars = function (editor) {
	      if (editor.addContextToolbar) {
	        editor.addContextToolbar(Actions.leftClickedOnAHref(editor), 'openlink | link unlink');
	      }
	    };
	    var Controls = {
	      setupButtons: setupButtons,
	      setupMenuItems: setupMenuItems,
	      setupContextToolbars: setupContextToolbars
	    };
	
	    global.add('link', function (editor) {
	      Controls.setupButtons(editor);
	      Controls.setupMenuItems(editor);
	      Controls.setupContextToolbars(editor);
	      Actions.setupGotoLinks(editor);
	      Commands.register(editor);
	      Keyboard.setup(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "lists" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/lists')
	//   ES2015:
	//     import 'tinymce/plugins/lists'
	__webpack_require__(550);

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	(function () {
	var lists = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.BookmarkManager');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var isTextNode = function (node) {
	      return node && node.nodeType === 3;
	    };
	    var isListNode = function (node) {
	      return node && /^(OL|UL|DL)$/.test(node.nodeName);
	    };
	    var isOlUlNode = function (node) {
	      return node && /^(OL|UL)$/.test(node.nodeName);
	    };
	    var isListItemNode = function (node) {
	      return node && /^(LI|DT|DD)$/.test(node.nodeName);
	    };
	    var isDlItemNode = function (node) {
	      return node && /^(DT|DD)$/.test(node.nodeName);
	    };
	    var isTableCellNode = function (node) {
	      return node && /^(TH|TD)$/.test(node.nodeName);
	    };
	    var isBr = function (node) {
	      return node && node.nodeName === 'BR';
	    };
	    var isFirstChild = function (node) {
	      return node.parentNode.firstChild === node;
	    };
	    var isLastChild = function (node) {
	      return node.parentNode.lastChild === node;
	    };
	    var isTextBlock = function (editor, node) {
	      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
	    };
	    var isBlock = function (node, blockElements) {
	      return node && node.nodeName in blockElements;
	    };
	    var isBogusBr = function (dom, node) {
	      if (!isBr(node)) {
	        return false;
	      }
	      if (dom.isBlock(node.nextSibling) && !isBr(node.previousSibling)) {
	        return true;
	      }
	      return false;
	    };
	    var isEmpty = function (dom, elm, keepBookmarks) {
	      var empty = dom.isEmpty(elm);
	      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
	        return false;
	      }
	      return empty;
	    };
	    var isChildOfBody = function (dom, elm) {
	      return dom.isChildOf(elm, dom.getRoot());
	    };
	    var NodeType = {
	      isTextNode: isTextNode,
	      isListNode: isListNode,
	      isOlUlNode: isOlUlNode,
	      isDlItemNode: isDlItemNode,
	      isListItemNode: isListItemNode,
	      isTableCellNode: isTableCellNode,
	      isBr: isBr,
	      isFirstChild: isFirstChild,
	      isLastChild: isLastChild,
	      isTextBlock: isTextBlock,
	      isBlock: isBlock,
	      isBogusBr: isBogusBr,
	      isEmpty: isEmpty,
	      isChildOfBody: isChildOfBody
	    };
	
	    var getNormalizedPoint = function (container, offset) {
	      if (NodeType.isTextNode(container)) {
	        return {
	          container: container,
	          offset: offset
	        };
	      }
	      var node = global$1.getNode(container, offset);
	      if (NodeType.isTextNode(node)) {
	        return {
	          container: node,
	          offset: offset >= container.childNodes.length ? node.data.length : 0
	        };
	      } else if (node.previousSibling && NodeType.isTextNode(node.previousSibling)) {
	        return {
	          container: node.previousSibling,
	          offset: node.previousSibling.data.length
	        };
	      } else if (node.nextSibling && NodeType.isTextNode(node.nextSibling)) {
	        return {
	          container: node.nextSibling,
	          offset: 0
	        };
	      }
	      return {
	        container: container,
	        offset: offset
	      };
	    };
	    var normalizeRange = function (rng) {
	      var outRng = rng.cloneRange();
	      var rangeStart = getNormalizedPoint(rng.startContainer, rng.startOffset);
	      outRng.setStart(rangeStart.container, rangeStart.offset);
	      var rangeEnd = getNormalizedPoint(rng.endContainer, rng.endOffset);
	      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
	      return outRng;
	    };
	    var Range = {
	      getNormalizedPoint: getNormalizedPoint,
	      normalizeRange: normalizeRange
	    };
	
	    var DOM = global$6.DOM;
	    var createBookmark = function (rng) {
	      var bookmark = {};
	      var setupEndPoint = function (start) {
	        var offsetNode, container, offset;
	        container = rng[start ? 'startContainer' : 'endContainer'];
	        offset = rng[start ? 'startOffset' : 'endOffset'];
	        if (container.nodeType === 1) {
	          offsetNode = DOM.create('span', { 'data-mce-type': 'bookmark' });
	          if (container.hasChildNodes()) {
	            offset = Math.min(offset, container.childNodes.length - 1);
	            if (start) {
	              container.insertBefore(offsetNode, container.childNodes[offset]);
	            } else {
	              DOM.insertAfter(offsetNode, container.childNodes[offset]);
	            }
	          } else {
	            container.appendChild(offsetNode);
	          }
	          container = offsetNode;
	          offset = 0;
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      };
	      setupEndPoint(true);
	      if (!rng.collapsed) {
	        setupEndPoint();
	      }
	      return bookmark;
	    };
	    var resolveBookmark = function (bookmark) {
	      function restoreEndPoint(start) {
	        var container, offset, node;
	        var nodeIndex = function (container) {
	          var node = container.parentNode.firstChild, idx = 0;
	          while (node) {
	            if (node === container) {
	              return idx;
	            }
	            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
	              idx++;
	            }
	            node = node.nextSibling;
	          }
	          return -1;
	        };
	        container = node = bookmark[start ? 'startContainer' : 'endContainer'];
	        offset = bookmark[start ? 'startOffset' : 'endOffset'];
	        if (!container) {
	          return;
	        }
	        if (container.nodeType === 1) {
	          offset = nodeIndex(container);
	          container = container.parentNode;
	          DOM.remove(node);
	          if (!container.hasChildNodes() && DOM.isBlock(container)) {
	            container.appendChild(DOM.create('br'));
	          }
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      }
	      restoreEndPoint(true);
	      restoreEndPoint();
	      var rng = DOM.createRng();
	      rng.setStart(bookmark.startContainer, bookmark.startOffset);
	      if (bookmark.endContainer) {
	        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
	      }
	      return Range.normalizeRange(rng);
	    };
	    var Bookmark = {
	      createBookmark: createBookmark,
	      resolveBookmark: resolveBookmark
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var not = function (f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return !f.apply(null, args);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isBoolean = isType('boolean');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]);
	        var r = [];
	        var group = [];
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var htmlElement = function (scope) {
	      return Global$1.getOrDie('HTMLElement', scope);
	    };
	    var isPrototypeOf = function (x) {
	      var scope = resolve('ownerDocument.defaultView', x);
	      return htmlElement(scope).prototype.isPrototypeOf(x);
	    };
	    var HTMLElement = { isPrototypeOf: isPrototypeOf };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var getParentList = function (editor) {
	      var selectionStart = editor.selection.getStart(true);
	      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
	    };
	    var isParentListSelected = function (parentList, selectedBlocks) {
	      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
	    };
	    var findSubLists = function (parentList) {
	      return global$5.grep(parentList.querySelectorAll('ol,ul,dl'), function (elm) {
	        return NodeType.isListNode(elm);
	      });
	    };
	    var getSelectedSubLists = function (editor) {
	      var parentList = getParentList(editor);
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      if (isParentListSelected(parentList, selectedBlocks)) {
	        return findSubLists(parentList);
	      } else {
	        return global$5.grep(selectedBlocks, function (elm) {
	          return NodeType.isListNode(elm) && parentList !== elm;
	        });
	      }
	    };
	    var findParentListItemsNodes = function (editor, elms) {
	      var listItemsElms = global$5.map(elms, function (elm) {
	        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
	        return parentLi ? parentLi : elm;
	      });
	      return global$7.unique(listItemsElms);
	    };
	    var getSelectedListItems = function (editor) {
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      return global$5.grep(findParentListItemsNodes(editor, selectedBlocks), function (block) {
	        return NodeType.isListItemNode(block);
	      });
	    };
	    var getSelectedDlItems = function (editor) {
	      return filter(getSelectedListItems(editor), NodeType.isDlItemNode);
	    };
	    var getClosestListRootElm = function (editor, elm) {
	      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
	      var root = parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
	      return root;
	    };
	    var findLastParentListNode = function (editor, elm) {
	      var parentLists = editor.dom.getParents(elm, 'ol,ul', getClosestListRootElm(editor, elm));
	      return last(parentLists);
	    };
	    var getSelectedLists = function (editor) {
	      var firstList = findLastParentListNode(editor, editor.selection.getStart());
	      var subsequentLists = filter(editor.selection.getSelectedBlocks(), NodeType.isOlUlNode);
	      return firstList.toArray().concat(subsequentLists);
	    };
	    var getSelectedListRoots = function (editor) {
	      var selectedLists = getSelectedLists(editor);
	      return getUniqueListRoots(editor, selectedLists);
	    };
	    var getUniqueListRoots = function (editor, lists) {
	      var listRoots = map(lists, function (list) {
	        return findLastParentListNode(editor, list).getOr(list);
	      });
	      return global$7.unique(listRoots);
	    };
	    var isList = function (editor) {
	      var list = getParentList(editor);
	      return HTMLElement.isPrototypeOf(list);
	    };
	    var Selection = {
	      isList: isList,
	      getParentList: getParentList,
	      getSelectedSubLists: getSelectedSubLists,
	      getSelectedListItems: getSelectedListItems,
	      getClosestListRootElm: getClosestListRootElm,
	      getSelectedDlItems: getSelectedDlItems,
	      getSelectedListRoots: getSelectedListRoots
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie())) : Option.none();
	    };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || domGlobals.document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom());
	      });
	      return Element.fromDom(fragment);
	    };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var keys = Object.keys;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var ELEMENT$1 = ELEMENT;
	    var is = function (element, selector) {
	      var dom = element.dom();
	      if (dom.nodeType !== ELEMENT$1) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$1 = browser.isIE() ? ieContains : regularContains;
	    var is$1 = is;
	
	    var parent = function (element) {
	      return Option.from(element.dom().parentNode).map(Element.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom().childNodes, Element.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom().childNodes;
	      return Option.from(cs[index]).map(Element.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	    var spot = Immutable('element', 'offset');
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var remove = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        domGlobals.console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var clone = function (element) {
	      return foldl(element.dom().attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        domGlobals.console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var set = function (element, property, value) {
	      var dom = element.dom();
	      internalSet(dom, property, value);
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return Element.fromDom(original.dom().cloneNode(isDeep));
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = Element.fromTag(tag);
	      var attributes = clone(original);
	      setAll(nu, attributes);
	      return nu;
	    };
	    var mutate = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      before(original, nu);
	      var children$1 = children(original);
	      append$1(nu, children$1);
	      remove(original);
	      return nu;
	    };
	
	    var joinSegment = function (parent, child) {
	      append(parent.item, child.list);
	    };
	    var joinSegments = function (segments) {
	      for (var i = 1; i < segments.length; i++) {
	        joinSegment(segments[i - 1], segments[i]);
	      }
	    };
	    var appendSegments = function (head$1, tail) {
	      lift2(last(head$1), head(tail), joinSegment);
	    };
	    var createSegment = function (scope, listType) {
	      var segment = {
	        list: Element.fromTag(listType, scope),
	        item: Element.fromTag('li', scope)
	      };
	      append(segment.list, segment.item);
	      return segment;
	    };
	    var createSegments = function (scope, entry, size) {
	      var segments = [];
	      for (var i = 0; i < size; i++) {
	        segments.push(createSegment(scope, entry.listType));
	      }
	      return segments;
	    };
	    var populateSegments = function (segments, entry) {
	      for (var i = 0; i < segments.length - 1; i++) {
	        set(segments[i].item, 'list-style-type', 'none');
	      }
	      last(segments).each(function (segment) {
	        setAll(segment.list, entry.listAttributes);
	        setAll(segment.item, entry.itemAttributes);
	        append$1(segment.item, entry.content);
	      });
	    };
	    var normalizeSegment = function (segment, entry) {
	      if (name(segment.list) !== entry.listType) {
	        segment.list = mutate(segment.list, entry.listType);
	      }
	      setAll(segment.list, entry.listAttributes);
	    };
	    var createItem = function (scope, attr, content) {
	      var item = Element.fromTag('li', scope);
	      setAll(item, attr);
	      append$1(item, content);
	      return item;
	    };
	    var appendItem = function (segment, item) {
	      append(segment.list, item);
	      segment.item = item;
	    };
	    var writeShallow = function (scope, cast, entry) {
	      var newCast = cast.slice(0, entry.depth);
	      last(newCast).each(function (segment) {
	        var item = createItem(scope, entry.itemAttributes, entry.content);
	        appendItem(segment, item);
	        normalizeSegment(segment, entry);
	      });
	      return newCast;
	    };
	    var writeDeep = function (scope, cast, entry) {
	      var segments = createSegments(scope, entry, entry.depth - cast.length);
	      joinSegments(segments);
	      populateSegments(segments, entry);
	      appendSegments(cast, segments);
	      return cast.concat(segments);
	    };
	    var composeList = function (scope, entries) {
	      var cast = foldl(entries, function (cast, entry) {
	        return entry.depth > cast.length ? writeDeep(scope, cast, entry) : writeShallow(scope, cast, entry);
	      }, []);
	      return head(cast).map(function (segment) {
	        return segment.list;
	      });
	    };
	
	    var isList$1 = function (el) {
	      return is$1(el, 'OL,UL');
	    };
	    var hasFirstChildList = function (el) {
	      return firstChild(el).map(isList$1).getOr(false);
	    };
	    var hasLastChildList = function (el) {
	      return lastChild(el).map(isList$1).getOr(false);
	    };
	
	    var isIndented = function (entry) {
	      return entry.depth > 0;
	    };
	    var isSelected = function (entry) {
	      return entry.isSelected;
	    };
	    var cloneItemContent = function (li) {
	      var children$1 = children(li);
	      var content = hasLastChildList(li) ? children$1.slice(0, -1) : children$1;
	      return map(content, deep);
	    };
	    var createEntry = function (li, depth, isSelected) {
	      return parent(li).filter(isElement).map(function (list) {
	        return {
	          depth: depth,
	          isSelected: isSelected,
	          content: cloneItemContent(li),
	          itemAttributes: clone(li),
	          listAttributes: clone(list),
	          listType: name(list)
	        };
	      });
	    };
	
	    var indentEntry = function (indentation, entry) {
	      switch (indentation) {
	      case 'Indent':
	        entry.depth++;
	        break;
	      case 'Outdent':
	        entry.depth--;
	        break;
	      case 'Flatten':
	        entry.depth = 0;
	      }
	    };
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var shallow = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow);
	
	    var cloneListProperties = function (target, source) {
	      target.listType = source.listType;
	      target.listAttributes = merge({}, source.listAttributes);
	    };
	    var previousSiblingEntry = function (entries, start) {
	      var depth = entries[start].depth;
	      for (var i = start - 1; i >= 0; i--) {
	        if (entries[i].depth === depth) {
	          return Option.some(entries[i]);
	        }
	        if (entries[i].depth < depth) {
	          break;
	        }
	      }
	      return Option.none();
	    };
	    var normalizeEntries = function (entries) {
	      each(entries, function (entry, i) {
	        previousSiblingEntry(entries, i).each(function (matchingEntry) {
	          cloneListProperties(entry, matchingEntry);
	        });
	      });
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var parseItem = function (depth, itemSelection, selectionState, item) {
	      return firstChild(item).filter(isList$1).fold(function () {
	        itemSelection.each(function (selection) {
	          if (eq(selection.start, item)) {
	            selectionState.set(true);
	          }
	        });
	        var currentItemEntry = createEntry(item, depth, selectionState.get());
	        itemSelection.each(function (selection) {
	          if (eq(selection.end, item)) {
	            selectionState.set(false);
	          }
	        });
	        var childListEntries = lastChild(item).filter(isList$1).map(function (list) {
	          return parseList(depth, itemSelection, selectionState, list);
	        }).getOr([]);
	        return currentItemEntry.toArray().concat(childListEntries);
	      }, function (list) {
	        return parseList(depth, itemSelection, selectionState, list);
	      });
	    };
	    var parseList = function (depth, itemSelection, selectionState, list) {
	      return bind(children(list), function (element) {
	        var parser = isList$1(element) ? parseList : parseItem;
	        var newDepth = depth + 1;
	        return parser(newDepth, itemSelection, selectionState, element);
	      });
	    };
	    var parseLists = function (lists, itemSelection) {
	      var selectionState = Cell(false);
	      var initialDepth = 0;
	      return map(lists, function (list) {
	        return {
	          sourceList: list,
	          entries: parseList(initialDepth, itemSelection, selectionState, list)
	        };
	      });
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var createTextBlock = function (editor, contentNode) {
	      var dom = editor.dom;
	      var blockElements = editor.schema.getBlockElements();
	      var fragment = dom.createFragment();
	      var node, textBlock, blockName, hasContentNode;
	      if (editor.settings.forced_root_block) {
	        blockName = editor.settings.forced_root_block;
	      }
	      if (blockName) {
	        textBlock = dom.create(blockName);
	        if (textBlock.tagName === editor.settings.forced_root_block) {
	          dom.setAttribs(textBlock, editor.settings.forced_root_block_attrs);
	        }
	        if (!NodeType.isBlock(contentNode.firstChild, blockElements)) {
	          fragment.appendChild(textBlock);
	        }
	      }
	      if (contentNode) {
	        while (node = contentNode.firstChild) {
	          var nodeName = node.nodeName;
	          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
	            hasContentNode = true;
	          }
	          if (NodeType.isBlock(node, blockElements)) {
	            fragment.appendChild(node);
	            textBlock = null;
	          } else {
	            if (blockName) {
	              if (!textBlock) {
	                textBlock = dom.create(blockName);
	                fragment.appendChild(textBlock);
	              }
	              textBlock.appendChild(node);
	            } else {
	              fragment.appendChild(node);
	            }
	          }
	        }
	      }
	      if (!editor.settings.forced_root_block) {
	        fragment.appendChild(dom.create('br'));
	      } else {
	        if (!hasContentNode && (!global$8.ie || global$8.ie > 10)) {
	          textBlock.appendChild(dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      return fragment;
	    };
	
	    var outdentedComposer = function (editor, entries) {
	      return map(entries, function (entry) {
	        var content = fromElements(entry.content);
	        return Element.fromDom(createTextBlock(editor, content.dom()));
	      });
	    };
	    var indentedComposer = function (editor, entries) {
	      normalizeEntries(entries);
	      return composeList(editor.contentDocument, entries).toArray();
	    };
	    var composeEntries = function (editor, entries) {
	      return bind(groupBy(entries, isIndented), function (entries) {
	        var groupIsIndented = head(entries).map(isIndented).getOr(false);
	        return groupIsIndented ? indentedComposer(editor, entries) : outdentedComposer(editor, entries);
	      });
	    };
	    var indentSelectedEntries = function (entries, indentation) {
	      each(filter(entries, isSelected), function (entry) {
	        return indentEntry(indentation, entry);
	      });
	    };
	    var getItemSelection = function (editor) {
	      var selectedListItems = map(Selection.getSelectedListItems(editor), Element.fromDom);
	      return lift2(find(selectedListItems, not(hasFirstChildList)), find(reverse(selectedListItems), not(hasFirstChildList)), function (start, end) {
	        return {
	          start: start,
	          end: end
	        };
	      });
	    };
	    var listsIndentation = function (editor, lists, indentation) {
	      var entrySets = parseLists(lists, getItemSelection(editor));
	      each(entrySets, function (entrySet) {
	        indentSelectedEntries(entrySet.entries, indentation);
	        before$1(entrySet.sourceList, composeEntries(editor, entrySet.entries));
	        remove(entrySet.sourceList);
	      });
	    };
	
	    var DOM$1 = global$6.DOM;
	    var splitList = function (editor, ul, li) {
	      var tmpRng, fragment, bookmarks, node, newBlock;
	      var removeAndKeepBookmarks = function (targetNode) {
	        global$5.each(bookmarks, function (node) {
	          targetNode.parentNode.insertBefore(node, li.parentNode);
	        });
	        DOM$1.remove(targetNode);
	      };
	      bookmarks = DOM$1.select('span[data-mce-type="bookmark"]', ul);
	      newBlock = createTextBlock(editor, li);
	      tmpRng = DOM$1.createRng();
	      tmpRng.setStartAfter(li);
	      tmpRng.setEndAfter(ul);
	      fragment = tmpRng.extractContents();
	      for (node = fragment.firstChild; node; node = node.firstChild) {
	        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
	          DOM$1.remove(node);
	          break;
	        }
	      }
	      if (!editor.dom.isEmpty(fragment)) {
	        DOM$1.insertAfter(fragment, ul);
	      }
	      DOM$1.insertAfter(newBlock, ul);
	      if (NodeType.isEmpty(editor.dom, li.parentNode)) {
	        removeAndKeepBookmarks(li.parentNode);
	      }
	      DOM$1.remove(li);
	      if (NodeType.isEmpty(editor.dom, ul)) {
	        DOM$1.remove(ul);
	      }
	    };
	    var SplitList = { splitList: splitList };
	
	    var outdentDlItem = function (editor, item) {
	      if (is$1(item, 'dd')) {
	        mutate(item, 'dt');
	      } else if (is$1(item, 'dt')) {
	        parent(item).each(function (dl) {
	          return SplitList.splitList(editor, dl.dom(), item.dom());
	        });
	      }
	    };
	    var indentDlItem = function (item) {
	      if (is$1(item, 'dt')) {
	        mutate(item, 'dd');
	      }
	    };
	    var dlIndentation = function (editor, indentation, dlItems) {
	      if (indentation === 'Indent') {
	        each(dlItems, indentDlItem);
	      } else {
	        each(dlItems, function (item) {
	          return outdentDlItem(editor, item);
	        });
	      }
	    };
	
	    var selectionIndentation = function (editor, indentation) {
	      var lists = map(Selection.getSelectedListRoots(editor), Element.fromDom);
	      var dlItems = map(Selection.getSelectedDlItems(editor), Element.fromDom);
	      var isHandled = false;
	      if (lists.length || dlItems.length) {
	        var bookmark = editor.selection.getBookmark();
	        listsIndentation(editor, lists, indentation);
	        dlIndentation(editor, indentation, dlItems);
	        editor.selection.moveToBookmark(bookmark);
	        editor.selection.setRng(Range.normalizeRange(editor.selection.getRng()));
	        editor.nodeChanged();
	        isHandled = true;
	      }
	      return isHandled;
	    };
	    var indentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Indent');
	    };
	    var outdentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Outdent');
	    };
	    var flattenListSelection = function (editor) {
	      return selectionIndentation(editor, 'Flatten');
	    };
	
	    var updateListStyle = function (dom, el, detail) {
	      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
	      dom.setStyle(el, 'list-style-type', type);
	    };
	    var setAttribs = function (elm, attrs) {
	      global$5.each(attrs, function (value, key) {
	        elm.setAttribute(key, value);
	      });
	    };
	    var updateListAttrs = function (dom, el, detail) {
	      setAttribs(el, detail['list-attributes']);
	      global$5.each(dom.select('li', el), function (li) {
	        setAttribs(li, detail['list-item-attributes']);
	      });
	    };
	    var updateListWithDetails = function (dom, el, detail) {
	      updateListStyle(dom, el, detail);
	      updateListAttrs(dom, el, detail);
	    };
	    var removeStyles = function (dom, element, styles) {
	      global$5.each(styles, function (style) {
	        var _a;
	        return dom.setStyle(element, (_a = {}, _a[style] = '', _a));
	      });
	    };
	    var getEndPointNode = function (editor, rng, start, root) {
	      var container, offset;
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (container.nodeType === 1) {
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	      }
	      if (!start && NodeType.isBr(container.nextSibling)) {
	        container = container.nextSibling;
	      }
	      while (container.parentNode !== root) {
	        if (NodeType.isTextBlock(editor, container)) {
	          return container;
	        }
	        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
	          return container;
	        }
	        container = container.parentNode;
	      }
	      return container;
	    };
	    var getSelectedTextBlocks = function (editor, rng, root) {
	      var textBlocks = [], dom = editor.dom;
	      var startNode = getEndPointNode(editor, rng, true, root);
	      var endNode = getEndPointNode(editor, rng, false, root);
	      var block;
	      var siblings = [];
	      for (var node = startNode; node; node = node.nextSibling) {
	        siblings.push(node);
	        if (node === endNode) {
	          break;
	        }
	      }
	      global$5.each(siblings, function (node) {
	        if (NodeType.isTextBlock(editor, node)) {
	          textBlocks.push(node);
	          block = null;
	          return;
	        }
	        if (dom.isBlock(node) || NodeType.isBr(node)) {
	          if (NodeType.isBr(node)) {
	            dom.remove(node);
	          }
	          block = null;
	          return;
	        }
	        var nextSibling = node.nextSibling;
	        if (global$4.isBookmarkNode(node)) {
	          if (NodeType.isTextBlock(editor, nextSibling) || !nextSibling && node.parentNode === root) {
	            block = null;
	            return;
	          }
	        }
	        if (!block) {
	          block = dom.create('p');
	          node.parentNode.insertBefore(block, node);
	          textBlocks.push(block);
	        }
	        block.appendChild(node);
	      });
	      return textBlocks;
	    };
	    var hasCompatibleStyle = function (dom, sib, detail) {
	      var sibStyle = dom.getStyle(sib, 'list-style-type');
	      var detailStyle = detail ? detail['list-style-type'] : '';
	      detailStyle = detailStyle === null ? '' : detailStyle;
	      return sibStyle === detailStyle;
	    };
	    var applyList = function (editor, listName, detail) {
	      if (detail === void 0) {
	        detail = {};
	      }
	      var rng = editor.selection.getRng(true);
	      var bookmark;
	      var listItemName = 'LI';
	      var root = Selection.getClosestListRootElm(editor, editor.selection.getStart(true));
	      var dom = editor.dom;
	      if (dom.getContentEditable(editor.selection.getNode()) === 'false') {
	        return;
	      }
	      listName = listName.toUpperCase();
	      if (listName === 'DL') {
	        listItemName = 'DT';
	      }
	      bookmark = Bookmark.createBookmark(rng);
	      global$5.each(getSelectedTextBlocks(editor, rng, root), function (block) {
	        var listBlock, sibling;
	        sibling = block.previousSibling;
	        if (sibling && NodeType.isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
	          listBlock = sibling;
	          block = dom.rename(block, listItemName);
	          sibling.appendChild(block);
	        } else {
	          listBlock = dom.create(listName);
	          block.parentNode.insertBefore(listBlock, block);
	          listBlock.appendChild(block);
	          block = dom.rename(block, listItemName);
	        }
	        removeStyles(dom, block, [
	          'margin',
	          'margin-right',
	          'margin-bottom',
	          'margin-left',
	          'margin-top',
	          'padding',
	          'padding-right',
	          'padding-bottom',
	          'padding-left',
	          'padding-top'
	        ]);
	        updateListWithDetails(dom, listBlock, detail);
	        mergeWithAdjacentLists(editor.dom, listBlock);
	      });
	      editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	    };
	    var isValidLists = function (list1, list2) {
	      return list1 && list2 && NodeType.isListNode(list1) && list1.nodeName === list2.nodeName;
	    };
	    var hasSameListStyle = function (dom, list1, list2) {
	      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
	      var style = dom.getStyle(list2, 'list-style-type', true);
	      return targetStyle === style;
	    };
	    var hasSameClasses = function (elm1, elm2) {
	      return elm1.className === elm2.className;
	    };
	    var shouldMerge = function (dom, list1, list2) {
	      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
	    };
	    var mergeWithAdjacentLists = function (dom, listBlock) {
	      var sibling, node;
	      sibling = listBlock.nextSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.firstChild) {
	          listBlock.appendChild(node);
	        }
	        dom.remove(sibling);
	      }
	      sibling = listBlock.previousSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.lastChild) {
	          listBlock.insertBefore(node, listBlock.firstChild);
	        }
	        dom.remove(sibling);
	      }
	    };
	    var updateList = function (dom, list, listName, detail) {
	      if (list.nodeName !== listName) {
	        var newList = dom.rename(list, listName);
	        updateListWithDetails(dom, newList, detail);
	      } else {
	        updateListWithDetails(dom, list, detail);
	      }
	    };
	    var toggleMultipleLists = function (editor, parentList, lists, listName, detail) {
	      if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	        flattenListSelection(editor);
	      } else {
	        var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	        global$5.each([parentList].concat(lists), function (elm) {
	          updateList(editor.dom, elm, listName, detail);
	        });
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	    var hasListStyleDetail = function (detail) {
	      return 'list-style-type' in detail;
	    };
	    var toggleSingleList = function (editor, parentList, listName, detail) {
	      if (parentList === editor.getBody()) {
	        return;
	      }
	      if (parentList) {
	        if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	          flattenListSelection(editor);
	        } else {
	          var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	          updateListWithDetails(editor.dom, parentList, detail);
	          mergeWithAdjacentLists(editor.dom, editor.dom.rename(parentList, listName));
	          editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	        }
	      } else {
	        applyList(editor, listName, detail);
	      }
	    };
	    var toggleList = function (editor, listName, detail) {
	      var parentList = Selection.getParentList(editor);
	      var selectedSubLists = Selection.getSelectedSubLists(editor);
	      detail = detail ? detail : {};
	      if (parentList && selectedSubLists.length > 0) {
	        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
	      } else {
	        toggleSingleList(editor, parentList, listName, detail);
	      }
	    };
	    var ToggleList = {
	      toggleList: toggleList,
	      mergeWithAdjacentLists: mergeWithAdjacentLists
	    };
	
	    var DOM$2 = global$6.DOM;
	    var normalizeList = function (dom, ul) {
	      var sibling;
	      var parentNode = ul.parentNode;
	      if (parentNode.nodeName === 'LI' && parentNode.firstChild === ul) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	          if (NodeType.isEmpty(dom, parentNode)) {
	            DOM$2.remove(parentNode);
	          }
	        } else {
	          DOM$2.setStyle(parentNode, 'listStyleType', 'none');
	        }
	      }
	      if (NodeType.isListNode(parentNode)) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	        }
	      }
	    };
	    var normalizeLists = function (dom, element) {
	      global$5.each(global$5.grep(dom.select('ol,ul', element)), function (ul) {
	        normalizeList(dom, ul);
	      });
	    };
	    var NormalizeLists = {
	      normalizeList: normalizeList,
	      normalizeLists: normalizeLists
	    };
	
	    var findNextCaretContainer = function (editor, rng, isForward, root) {
	      var node = rng.startContainer;
	      var offset = rng.startOffset;
	      var nonEmptyBlocks, walker;
	      if (node.nodeType === 3 && (isForward ? offset < node.data.length : offset > 0)) {
	        return node;
	      }
	      nonEmptyBlocks = editor.schema.getNonEmptyElements();
	      if (node.nodeType === 1) {
	        node = global$1.getNode(node, offset);
	      }
	      walker = new global$2(node, root);
	      if (isForward) {
	        if (NodeType.isBogusBr(editor.dom, node)) {
	          walker.next();
	        }
	      }
	      while (node = walker[isForward ? 'next' : 'prev2']()) {
	        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
	          return node;
	        }
	        if (nonEmptyBlocks[node.nodeName]) {
	          return node;
	        }
	        if (node.nodeType === 3 && node.data.length > 0) {
	          return node;
	        }
	      }
	    };
	    var hasOnlyOneBlockChild = function (dom, elm) {
	      var childNodes = elm.childNodes;
	      return childNodes.length === 1 && !NodeType.isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
	    };
	    var unwrapSingleBlockChild = function (dom, elm) {
	      if (hasOnlyOneBlockChild(dom, elm)) {
	        dom.remove(elm.firstChild, true);
	      }
	    };
	    var moveChildren = function (dom, fromElm, toElm) {
	      var node, targetElm;
	      targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
	      unwrapSingleBlockChild(dom, fromElm);
	      if (!NodeType.isEmpty(dom, fromElm, true)) {
	        while (node = fromElm.firstChild) {
	          targetElm.appendChild(node);
	        }
	      }
	    };
	    var mergeLiElements = function (dom, fromElm, toElm) {
	      var node, listNode;
	      var ul = fromElm.parentNode;
	      if (!NodeType.isChildOfBody(dom, fromElm) || !NodeType.isChildOfBody(dom, toElm)) {
	        return;
	      }
	      if (NodeType.isListNode(toElm.lastChild)) {
	        listNode = toElm.lastChild;
	      }
	      if (ul === toElm.lastChild) {
	        if (NodeType.isBr(ul.previousSibling)) {
	          dom.remove(ul.previousSibling);
	        }
	      }
	      node = toElm.lastChild;
	      if (node && NodeType.isBr(node) && fromElm.hasChildNodes()) {
	        dom.remove(node);
	      }
	      if (NodeType.isEmpty(dom, toElm, true)) {
	        dom.$(toElm).empty();
	      }
	      moveChildren(dom, fromElm, toElm);
	      if (listNode) {
	        toElm.appendChild(listNode);
	      }
	      var contains = contains$1(Element.fromDom(toElm), Element.fromDom(fromElm));
	      var nestedLists = contains ? dom.getParents(fromElm, NodeType.isListNode, toElm) : [];
	      dom.remove(fromElm);
	      each(nestedLists, function (list) {
	        if (NodeType.isEmpty(dom, list) && list !== dom.getRoot()) {
	          dom.remove(list);
	        }
	      });
	    };
	    var mergeIntoEmptyLi = function (editor, fromLi, toLi) {
	      editor.dom.$(toLi).empty();
	      mergeLiElements(editor.dom, fromLi, toLi);
	      editor.selection.setCursorLocation(toLi);
	    };
	    var mergeForward = function (editor, rng, fromLi, toLi) {
	      var dom = editor.dom;
	      if (dom.isEmpty(toLi)) {
	        mergeIntoEmptyLi(editor, fromLi, toLi);
	      } else {
	        var bookmark = Bookmark.createBookmark(rng);
	        mergeLiElements(dom, fromLi, toLi);
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	    var mergeBackward = function (editor, rng, fromLi, toLi) {
	      var bookmark = Bookmark.createBookmark(rng);
	      mergeLiElements(editor.dom, fromLi, toLi);
	      var resolvedBookmark = Bookmark.resolveBookmark(bookmark);
	      editor.selection.setRng(resolvedBookmark);
	    };
	    var backspaceDeleteFromListToListCaret = function (editor, isForward) {
	      var dom = editor.dom, selection = editor.selection;
	      var selectionStartElm = selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var li = dom.getParent(selection.getStart(), 'LI', root);
	      var ul, rng, otherLi;
	      if (li) {
	        ul = li.parentNode;
	        if (ul === editor.getBody() && NodeType.isEmpty(dom, ul)) {
	          return true;
	        }
	        rng = Range.normalizeRange(selection.getRng(true));
	        otherLi = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	        if (otherLi && otherLi !== li) {
	          if (isForward) {
	            mergeForward(editor, rng, otherLi, li);
	          } else {
	            mergeBackward(editor, rng, li, otherLi);
	          }
	          return true;
	        } else if (!otherLi) {
	          if (!isForward) {
	            flattenListSelection(editor);
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var removeBlock = function (dom, block, root) {
	      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
	      dom.remove(block);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        dom.remove(parentBlock);
	      }
	    };
	    var backspaceDeleteIntoListCaret = function (editor, isForward) {
	      var dom = editor.dom;
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
	      if (block && dom.isEmpty(block)) {
	        var rng = Range.normalizeRange(editor.selection.getRng(true));
	        var otherLi_1 = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	        if (otherLi_1) {
	          editor.undoManager.transact(function () {
	            removeBlock(dom, block, root);
	            ToggleList.mergeWithAdjacentLists(dom, otherLi_1.parentNode);
	            editor.selection.select(otherLi_1, true);
	            editor.selection.collapse(isForward);
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var backspaceDeleteCaret = function (editor, isForward) {
	      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
	    };
	    var backspaceDeleteRange = function (editor) {
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
	      if (startListParent || Selection.getSelectedListItems(editor).length > 0) {
	        editor.undoManager.transact(function () {
	          editor.execCommand('Delete');
	          NormalizeLists.normalizeLists(editor.dom, editor.getBody());
	        });
	        return true;
	      }
	      return false;
	    };
	    var backspaceDelete = function (editor, isForward) {
	      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
	    };
	    var setup = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode === global$3.BACKSPACE) {
	          if (backspaceDelete(editor, false)) {
	            e.preventDefault();
	          }
	        } else if (e.keyCode === global$3.DELETE) {
	          if (backspaceDelete(editor, true)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	    var Delete = {
	      setup: setup,
	      backspaceDelete: backspaceDelete
	    };
	
	    var get = function (editor) {
	      return {
	        backspaceDelete: function (isForward) {
	          Delete.backspaceDelete(editor, isForward);
	        }
	      };
	    };
	    var Api = { get: get };
	
	    var queryListCommandState = function (editor, listName) {
	      return function () {
	        var parentList = editor.dom.getParent(editor.selection.getStart(), 'UL,OL,DL');
	        return parentList && parentList.nodeName === listName;
	      };
	    };
	    var register = function (editor) {
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command.toLowerCase();
	        if (cmd === 'indent') {
	          indentListSelection(editor);
	        } else if (cmd === 'outdent') {
	          outdentListSelection(editor);
	        }
	      });
	      editor.addCommand('InsertUnorderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'UL', detail);
	      });
	      editor.addCommand('InsertOrderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'OL', detail);
	      });
	      editor.addCommand('InsertDefinitionList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'DL', detail);
	      });
	      editor.addCommand('RemoveList', function () {
	        flattenListSelection(editor);
	      });
	      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
	      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
	      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
	    };
	    var Commands = { register: register };
	
	    var shouldIndentOnTab = function (editor) {
	      return editor.getParam('lists_indent_on_tab', true);
	    };
	    var Settings = { shouldIndentOnTab: shouldIndentOnTab };
	
	    var setupTabKey = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode !== global$3.TAB || global$3.metaKeyPressed(e)) {
	          return;
	        }
	        editor.undoManager.transact(function () {
	          if (e.shiftKey ? outdentListSelection(editor) : indentListSelection(editor)) {
	            e.preventDefault();
	          }
	        });
	      });
	    };
	    var setup$1 = function (editor) {
	      if (Settings.shouldIndentOnTab(editor)) {
	        setupTabKey(editor);
	      }
	      Delete.setup(editor);
	    };
	    var Keyboard = { setup: setup$1 };
	
	    var findIndex = function (list, predicate) {
	      for (var index = 0; index < list.length; index++) {
	        var element = list[index];
	        if (predicate(element)) {
	          return index;
	        }
	      }
	      return -1;
	    };
	    var listState = function (editor, listName) {
	      return function (e) {
	        var ctrl = e.control;
	        editor.on('NodeChange', function (e) {
	          var tableCellIndex = findIndex(e.parents, NodeType.isTableCellNode);
	          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
	          var lists = global$5.grep(parents, NodeType.isListNode);
	          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
	        });
	      };
	    };
	    var register$1 = function (editor) {
	      var hasPlugin = function (editor, plugin) {
	        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
	        return global$5.inArray(plugins.split(/[ ,]/), plugin) !== -1;
	      };
	      if (!hasPlugin(editor, 'advlist')) {
	        editor.addButton('numlist', {
	          active: false,
	          title: 'Numbered list',
	          cmd: 'InsertOrderedList',
	          onPostRender: listState(editor, 'OL')
	        });
	        editor.addButton('bullist', {
	          active: false,
	          title: 'Bullet list',
	          cmd: 'InsertUnorderedList',
	          onPostRender: listState(editor, 'UL')
	        });
	      }
	      editor.addButton('indent', {
	        icon: 'indent',
	        title: 'Increase indent',
	        cmd: 'Indent'
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('lists', function (editor) {
	      Keyboard.setup(editor);
	      Buttons.register(editor);
	      Commands.register(editor);
	      return Api.get(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "media" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/media')
	//   ES2015:
	//     import 'tinymce/plugins/media'
	__webpack_require__(552);

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	(function () {
	var media = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getScripts = function (editor) {
	      return editor.getParam('media_scripts');
	    };
	    var getAudioTemplateCallback = function (editor) {
	      return editor.getParam('audio_template_callback');
	    };
	    var getVideoTemplateCallback = function (editor) {
	      return editor.getParam('video_template_callback');
	    };
	    var hasLiveEmbeds = function (editor) {
	      return editor.getParam('media_live_embeds', true);
	    };
	    var shouldFilterHtml = function (editor) {
	      return editor.getParam('media_filter_html', true);
	    };
	    var getUrlResolver = function (editor) {
	      return editor.getParam('media_url_resolver');
	    };
	    var hasAltSource = function (editor) {
	      return editor.getParam('media_alt_source', true);
	    };
	    var hasPoster = function (editor) {
	      return editor.getParam('media_poster', true);
	    };
	    var hasDimensions = function (editor) {
	      return editor.getParam('media_dimensions', true);
	    };
	    var Settings = {
	      getScripts: getScripts,
	      getAudioTemplateCallback: getAudioTemplateCallback,
	      getVideoTemplateCallback: getVideoTemplateCallback,
	      hasLiveEmbeds: hasLiveEmbeds,
	      shouldFilterHtml: shouldFilterHtml,
	      getUrlResolver: getUrlResolver,
	      hasAltSource: hasAltSource,
	      hasPoster: hasPoster,
	      hasDimensions: hasDimensions
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var get = function (obj, key) {
	      return has(obj, key) ? Option.from(obj[key]) : Option.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.html.SaxParser');
	
	    var getVideoScriptMatch = function (prefixes, src) {
	      if (prefixes) {
	        for (var i = 0; i < prefixes.length; i++) {
	          if (src.indexOf(prefixes[i].filter) !== -1) {
	            return prefixes[i];
	          }
	        }
	      }
	    };
	    var VideoScript = { getVideoScriptMatch: getVideoScriptMatch };
	
	    var DOM = global$3.DOM;
	    var trimPx = function (value) {
	      return value.replace(/px$/, '');
	    };
	    var getEphoxEmbedData = function (attrs) {
	      var style = attrs.map.style;
	      var styles = style ? DOM.parseStyle(style) : {};
	      return {
	        type: 'ephox-embed-iri',
	        source1: attrs.map['data-ephox-embed-iri'],
	        source2: '',
	        poster: '',
	        width: get(styles, 'max-width').map(trimPx).getOr(''),
	        height: get(styles, 'max-height').map(trimPx).getOr('')
	      };
	    };
	    var htmlToData = function (prefixes, html) {
	      var isEphoxEmbed = Cell(false);
	      var data = {};
	      global$4({
	        validate: false,
	        allow_conditional_comments: true,
	        special: 'script,noscript',
	        start: function (name, attrs) {
	          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
	            isEphoxEmbed.set(true);
	            data = getEphoxEmbedData(attrs);
	          } else {
	            if (!data.source1 && name === 'param') {
	              data.source1 = attrs.map.movie;
	            }
	            if (name === 'iframe' || name === 'object' || name === 'embed' || name === 'video' || name === 'audio') {
	              if (!data.type) {
	                data.type = name;
	              }
	              data = global$2.extend(attrs.map, data);
	            }
	            if (name === 'script') {
	              var videoScript = VideoScript.getVideoScriptMatch(prefixes, attrs.map.src);
	              if (!videoScript) {
	                return;
	              }
	              data = {
	                type: 'script',
	                source1: attrs.map.src,
	                width: videoScript.width,
	                height: videoScript.height
	              };
	            }
	            if (name === 'source') {
	              if (!data.source1) {
	                data.source1 = attrs.map.src;
	              } else if (!data.source2) {
	                data.source2 = attrs.map.src;
	              }
	            }
	            if (name === 'img' && !data.poster) {
	              data.poster = attrs.map.src;
	            }
	          }
	        }
	      }).parse(html);
	      data.source1 = data.source1 || data.src || data.data;
	      data.source2 = data.source2 || '';
	      data.poster = data.poster || '';
	      return data;
	    };
	    var HtmlToData = { htmlToData: htmlToData };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var guess = function (url) {
	      var mimes = {
	        mp3: 'audio/mpeg',
	        wav: 'audio/wav',
	        mp4: 'video/mp4',
	        webm: 'video/webm',
	        ogg: 'video/ogg',
	        swf: 'application/x-shockwave-flash'
	      };
	      var fileEnd = url.toLowerCase().split('.').pop();
	      var mime = mimes[fileEnd];
	      return mime ? mime : '';
	    };
	    var Mime = { guess: guess };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Writer');
	
	    var DOM$1 = global$3.DOM;
	    var addPx = function (value) {
	      return /^[0-9.]+$/.test(value) ? value + 'px' : value;
	    };
	    var setAttributes = function (attrs, updatedAttrs) {
	      for (var name in updatedAttrs) {
	        var value = '' + updatedAttrs[name];
	        if (attrs.map[name]) {
	          var i = attrs.length;
	          while (i--) {
	            var attr = attrs[i];
	            if (attr.name === name) {
	              if (value) {
	                attrs.map[name] = value;
	                attr.value = value;
	              } else {
	                delete attrs.map[name];
	                attrs.splice(i, 1);
	              }
	            }
	          }
	        } else if (value) {
	          attrs.push({
	            name: name,
	            value: value
	          });
	          attrs.map[name] = value;
	        }
	      }
	    };
	    var updateEphoxEmbed = function (data, attrs) {
	      var style = attrs.map.style;
	      var styleMap = style ? DOM$1.parseStyle(style) : {};
	      styleMap['max-width'] = addPx(data.width);
	      styleMap['max-height'] = addPx(data.height);
	      setAttributes(attrs, { style: DOM$1.serializeStyle(styleMap) });
	    };
	    var updateHtml = function (html, data, updateAll) {
	      var writer = global$7();
	      var isEphoxEmbed = Cell(false);
	      var sourceCount = 0;
	      var hasImage;
	      global$4({
	        validate: false,
	        allow_conditional_comments: true,
	        special: 'script,noscript',
	        comment: function (text) {
	          writer.comment(text);
	        },
	        cdata: function (text) {
	          writer.cdata(text);
	        },
	        text: function (text, raw) {
	          writer.text(text, raw);
	        },
	        start: function (name, attrs, empty) {
	          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
	            isEphoxEmbed.set(true);
	            updateEphoxEmbed(data, attrs);
	          } else {
	            switch (name) {
	            case 'video':
	            case 'object':
	            case 'embed':
	            case 'img':
	            case 'iframe':
	              if (data.height !== undefined && data.width !== undefined) {
	                setAttributes(attrs, {
	                  width: data.width,
	                  height: data.height
	                });
	              }
	              break;
	            }
	            if (updateAll) {
	              switch (name) {
	              case 'video':
	                setAttributes(attrs, {
	                  poster: data.poster,
	                  src: ''
	                });
	                if (data.source2) {
	                  setAttributes(attrs, { src: '' });
	                }
	                break;
	              case 'iframe':
	                setAttributes(attrs, { src: data.source1 });
	                break;
	              case 'source':
	                sourceCount++;
	                if (sourceCount <= 2) {
	                  setAttributes(attrs, {
	                    src: data['source' + sourceCount],
	                    type: data['source' + sourceCount + 'mime']
	                  });
	                  if (!data['source' + sourceCount]) {
	                    return;
	                  }
	                }
	                break;
	              case 'img':
	                if (!data.poster) {
	                  return;
	                }
	                hasImage = true;
	                break;
	              }
	            }
	          }
	          writer.start(name, attrs, empty);
	        },
	        end: function (name) {
	          if (!isEphoxEmbed.get()) {
	            if (name === 'video' && updateAll) {
	              for (var index = 1; index <= 2; index++) {
	                if (data['source' + index]) {
	                  var attrs = [];
	                  attrs.map = {};
	                  if (sourceCount < index) {
	                    setAttributes(attrs, {
	                      src: data['source' + index],
	                      type: data['source' + index + 'mime']
	                    });
	                    writer.start('source', attrs, true);
	                  }
	                }
	              }
	            }
	            if (data.poster && name === 'object' && updateAll && !hasImage) {
	              var imgAttrs = [];
	              imgAttrs.map = {};
	              setAttributes(imgAttrs, {
	                src: data.poster,
	                width: data.width,
	                height: data.height
	              });
	              writer.start('img', imgAttrs, true);
	            }
	          }
	          writer.end(name);
	        }
	      }, global$6({})).parse(html);
	      return writer.getContent();
	    };
	    var UpdateHtml = { updateHtml: updateHtml };
	
	    var urlPatterns = [
	      {
	        regex: /youtu\.be\/([\w\-_\?&=.]+)/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: '//www.youtube.com/embed/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /youtube\.com(.+)v=([^&]+)(&([a-z0-9&=\-_]+))?/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: '//www.youtube.com/embed/$2?$4',
	        allowFullscreen: true
	      },
	      {
	        regex: /youtube.com\/embed\/([a-z0-9\?&=\-_]+)/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: '//www.youtube.com/embed/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /vimeo\.com\/([0-9]+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: '//player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc',
	        allowFullscreen: true
	      },
	      {
	        regex: /vimeo\.com\/(.*)\/([0-9]+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: '//player.vimeo.com/video/$2?title=0&amp;byline=0',
	        allowFullscreen: true
	      },
	      {
	        regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: '//maps.google.com/maps/ms?msid=$2&output=embed"',
	        allowFullscreen: false
	      },
	      {
	        regex: /dailymotion\.com\/video\/([^_]+)/,
	        type: 'iframe',
	        w: 480,
	        h: 270,
	        url: '//www.dailymotion.com/embed/video/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /dai\.ly\/([^_]+)/,
	        type: 'iframe',
	        w: 480,
	        h: 270,
	        url: '//www.dailymotion.com/embed/video/$1',
	        allowFullscreen: true
	      }
	    ];
	    var getUrl = function (pattern, url) {
	      var match = pattern.regex.exec(url);
	      var newUrl = pattern.url;
	      var _loop_1 = function (i) {
	        newUrl = newUrl.replace('$' + i, function () {
	          return match[i] ? match[i] : '';
	        });
	      };
	      for (var i = 0; i < match.length; i++) {
	        _loop_1(i);
	      }
	      return newUrl.replace(/\?$/, '');
	    };
	    var matchPattern = function (url) {
	      var pattern = urlPatterns.filter(function (pattern) {
	        return pattern.regex.test(url);
	      });
	      if (pattern.length > 0) {
	        return global$2.extend({}, pattern[0], { url: getUrl(pattern[0], url) });
	      } else {
	        return null;
	      }
	    };
	
	    var getIframeHtml = function (data) {
	      var allowFullscreen = data.allowFullscreen ? ' allowFullscreen="1"' : '';
	      return '<iframe src="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
	    };
	    var getFlashHtml = function (data) {
	      var html = '<object data="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
	      if (data.poster) {
	        html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
	      }
	      html += '</object>';
	      return html;
	    };
	    var getAudioHtml = function (data, audioTemplateCallback) {
	      if (audioTemplateCallback) {
	        return audioTemplateCallback(data);
	      } else {
	        return '<audio controls="controls" src="' + data.source1 + '">' + (data.source2 ? '\n<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</audio>';
	      }
	    };
	    var getVideoHtml = function (data, videoTemplateCallback) {
	      if (videoTemplateCallback) {
	        return videoTemplateCallback(data);
	      } else {
	        return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
	      }
	    };
	    var getScriptHtml = function (data) {
	      return '<script src="' + data.source1 + '"></script>';
	    };
	    var dataToHtml = function (editor, dataIn) {
	      var data = global$2.extend({}, dataIn);
	      if (!data.source1) {
	        global$2.extend(data, HtmlToData.htmlToData(Settings.getScripts(editor), data.embed));
	        if (!data.source1) {
	          return '';
	        }
	      }
	      if (!data.source2) {
	        data.source2 = '';
	      }
	      if (!data.poster) {
	        data.poster = '';
	      }
	      data.source1 = editor.convertURL(data.source1, 'source');
	      data.source2 = editor.convertURL(data.source2, 'source');
	      data.source1mime = Mime.guess(data.source1);
	      data.source2mime = Mime.guess(data.source2);
	      data.poster = editor.convertURL(data.poster, 'poster');
	      var pattern = matchPattern(data.source1);
	      if (pattern) {
	        data.source1 = pattern.url;
	        data.type = pattern.type;
	        data.allowFullscreen = pattern.allowFullscreen;
	        data.width = data.width || pattern.w;
	        data.height = data.height || pattern.h;
	      }
	      if (data.embed) {
	        return UpdateHtml.updateHtml(data.embed, data, true);
	      } else {
	        var videoScript = VideoScript.getVideoScriptMatch(Settings.getScripts(editor), data.source1);
	        if (videoScript) {
	          data.type = 'script';
	          data.width = videoScript.width;
	          data.height = videoScript.height;
	        }
	        var audioTemplateCallback = Settings.getAudioTemplateCallback(editor);
	        var videoTemplateCallback = Settings.getVideoTemplateCallback(editor);
	        data.width = data.width || 300;
	        data.height = data.height || 150;
	        global$2.each(data, function (value, key) {
	          data[key] = editor.dom.encode(value);
	        });
	        if (data.type === 'iframe') {
	          return getIframeHtml(data);
	        } else if (data.source1mime === 'application/x-shockwave-flash') {
	          return getFlashHtml(data);
	        } else if (data.source1mime.indexOf('audio') !== -1) {
	          return getAudioHtml(data, audioTemplateCallback);
	        } else if (data.type === 'script') {
	          return getScriptHtml(data);
	        } else {
	          return getVideoHtml(data, videoTemplateCallback);
	        }
	      }
	    };
	    var DataToHtml = { dataToHtml: dataToHtml };
	
	    var cache = {};
	    var embedPromise = function (data, dataToHtml, handler) {
	      return new global$5(function (res, rej) {
	        var wrappedResolve = function (response) {
	          if (response.html) {
	            cache[data.source1] = response;
	          }
	          return res({
	            url: data.source1,
	            html: response.html ? response.html : dataToHtml(data)
	          });
	        };
	        if (cache[data.source1]) {
	          wrappedResolve(cache[data.source1]);
	        } else {
	          handler({ url: data.source1 }, wrappedResolve, rej);
	        }
	      });
	    };
	    var defaultPromise = function (data, dataToHtml) {
	      return new global$5(function (res) {
	        res({
	          html: dataToHtml(data),
	          url: data.source1
	        });
	      });
	    };
	    var loadedData = function (editor) {
	      return function (data) {
	        return DataToHtml.dataToHtml(editor, data);
	      };
	    };
	    var getEmbedHtml = function (editor, data) {
	      var embedHandler = Settings.getUrlResolver(editor);
	      return embedHandler ? embedPromise(data, loadedData(editor), embedHandler) : defaultPromise(data, loadedData(editor));
	    };
	    var isCached = function (url) {
	      return cache.hasOwnProperty(url);
	    };
	    var Service = {
	      getEmbedHtml: getEmbedHtml,
	      isCached: isCached
	    };
	
	    var trimPx$1 = function (value) {
	      return value.replace(/px$/, '');
	    };
	    var addPx$1 = function (value) {
	      return /^[0-9.]+$/.test(value) ? value + 'px' : value;
	    };
	    var getSize = function (name) {
	      return function (elm) {
	        return elm ? trimPx$1(elm.style[name]) : '';
	      };
	    };
	    var setSize = function (name) {
	      return function (elm, value) {
	        if (elm) {
	          elm.style[name] = addPx$1(value);
	        }
	      };
	    };
	    var Size = {
	      getMaxWidth: getSize('maxWidth'),
	      getMaxHeight: getSize('maxHeight'),
	      setMaxWidth: setSize('maxWidth'),
	      setMaxHeight: setSize('maxHeight')
	    };
	
	    var doSyncSize = function (widthCtrl, heightCtrl) {
	      widthCtrl.state.set('oldVal', widthCtrl.value());
	      heightCtrl.state.set('oldVal', heightCtrl.value());
	    };
	    var doSizeControls = function (win, f) {
	      var widthCtrl = win.find('#width')[0];
	      var heightCtrl = win.find('#height')[0];
	      var constrained = win.find('#constrain')[0];
	      if (widthCtrl && heightCtrl && constrained) {
	        f(widthCtrl, heightCtrl, constrained.checked());
	      }
	    };
	    var doUpdateSize = function (widthCtrl, heightCtrl, isContrained) {
	      var oldWidth = widthCtrl.state.get('oldVal');
	      var oldHeight = heightCtrl.state.get('oldVal');
	      var newWidth = widthCtrl.value();
	      var newHeight = heightCtrl.value();
	      if (isContrained && oldWidth && oldHeight && newWidth && newHeight) {
	        if (newWidth !== oldWidth) {
	          newHeight = Math.round(newWidth / oldWidth * newHeight);
	          if (!isNaN(newHeight)) {
	            heightCtrl.value(newHeight);
	          }
	        } else {
	          newWidth = Math.round(newHeight / oldHeight * newWidth);
	          if (!isNaN(newWidth)) {
	            widthCtrl.value(newWidth);
	          }
	        }
	      }
	      doSyncSize(widthCtrl, heightCtrl);
	    };
	    var syncSize = function (win) {
	      doSizeControls(win, doSyncSize);
	    };
	    var updateSize = function (win) {
	      doSizeControls(win, doUpdateSize);
	    };
	    var createUi = function (onChange) {
	      var recalcSize = function () {
	        onChange(function (win) {
	          updateSize(win);
	        });
	      };
	      return {
	        type: 'container',
	        label: 'Dimensions',
	        layout: 'flex',
	        align: 'center',
	        spacing: 5,
	        items: [
	          {
	            name: 'width',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Width'
	          },
	          {
	            type: 'label',
	            text: 'x'
	          },
	          {
	            name: 'height',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Height'
	          },
	          {
	            name: 'constrain',
	            type: 'checkbox',
	            checked: true,
	            text: 'Constrain proportions'
	          }
	        ]
	      };
	    };
	    var SizeManager = {
	      createUi: createUi,
	      syncSize: syncSize,
	      updateSize: updateSize
	    };
	
	    var embedChange = global$1.ie && global$1.ie <= 8 ? 'onChange' : 'onInput';
	    var handleError = function (editor) {
	      return function (error) {
	        var errorMessage = error && error.msg ? 'Media embed handler error: ' + error.msg : 'Media embed handler threw unknown error.';
	        editor.notificationManager.open({
	          type: 'error',
	          text: errorMessage
	        });
	      };
	    };
	    var getData = function (editor) {
	      var element = editor.selection.getNode();
	      var dataEmbed = element.getAttribute('data-ephox-embed-iri');
	      if (dataEmbed) {
	        return {
	          'source1': dataEmbed,
	          'data-ephox-embed-iri': dataEmbed,
	          'width': Size.getMaxWidth(element),
	          'height': Size.getMaxHeight(element)
	        };
	      }
	      return element.getAttribute('data-mce-object') ? HtmlToData.htmlToData(Settings.getScripts(editor), editor.serializer.serialize(element, { selection: true })) : {};
	    };
	    var getSource = function (editor) {
	      var elm = editor.selection.getNode();
	      if (elm.getAttribute('data-mce-object') || elm.getAttribute('data-ephox-embed-iri')) {
	        return editor.selection.getContent();
	      }
	    };
	    var addEmbedHtml = function (win, editor) {
	      return function (response) {
	        var html = response.html;
	        var embed = win.find('#embed')[0];
	        var data = global$2.extend(HtmlToData.htmlToData(Settings.getScripts(editor), html), { source1: response.url });
	        win.fromJSON(data);
	        if (embed) {
	          embed.value(html);
	          SizeManager.updateSize(win);
	        }
	      };
	    };
	    var selectPlaceholder = function (editor, beforeObjects) {
	      var i;
	      var y;
	      var afterObjects = editor.dom.select('img[data-mce-object]');
	      for (i = 0; i < beforeObjects.length; i++) {
	        for (y = afterObjects.length - 1; y >= 0; y--) {
	          if (beforeObjects[i] === afterObjects[y]) {
	            afterObjects.splice(y, 1);
	          }
	        }
	      }
	      editor.selection.select(afterObjects[0]);
	    };
	    var handleInsert = function (editor, html) {
	      var beforeObjects = editor.dom.select('img[data-mce-object]');
	      editor.insertContent(html);
	      selectPlaceholder(editor, beforeObjects);
	      editor.nodeChanged();
	    };
	    var submitForm = function (win, editor) {
	      var data = win.toJSON();
	      data.embed = UpdateHtml.updateHtml(data.embed, data);
	      if (data.embed && Service.isCached(data.source1)) {
	        handleInsert(editor, data.embed);
	      } else {
	        Service.getEmbedHtml(editor, data).then(function (response) {
	          handleInsert(editor, response.html);
	        }).catch(handleError(editor));
	      }
	    };
	    var populateMeta = function (win, meta) {
	      global$2.each(meta, function (value, key) {
	        win.find('#' + key).value(value);
	      });
	    };
	    var showDialog = function (editor) {
	      var win;
	      var data;
	      var generalFormItems = [{
	          name: 'source1',
	          type: 'filepicker',
	          filetype: 'media',
	          size: 40,
	          autofocus: true,
	          label: 'Source',
	          onpaste: function () {
	            setTimeout(function () {
	              Service.getEmbedHtml(editor, win.toJSON()).then(addEmbedHtml(win, editor)).catch(handleError(editor));
	            }, 1);
	          },
	          onchange: function (e) {
	            Service.getEmbedHtml(editor, win.toJSON()).then(addEmbedHtml(win, editor)).catch(handleError(editor));
	            populateMeta(win, e.meta);
	          },
	          onbeforecall: function (e) {
	            e.meta = win.toJSON();
	          }
	        }];
	      var advancedFormItems = [];
	      var reserialise = function (update) {
	        update(win);
	        data = win.toJSON();
	        win.find('#embed').value(UpdateHtml.updateHtml(data.embed, data));
	      };
	      if (Settings.hasAltSource(editor)) {
	        advancedFormItems.push({
	          name: 'source2',
	          type: 'filepicker',
	          filetype: 'media',
	          size: 40,
	          label: 'Alternative source'
	        });
	      }
	      if (Settings.hasPoster(editor)) {
	        advancedFormItems.push({
	          name: 'poster',
	          type: 'filepicker',
	          filetype: 'image',
	          size: 40,
	          label: 'Poster'
	        });
	      }
	      if (Settings.hasDimensions(editor)) {
	        var control = SizeManager.createUi(reserialise);
	        generalFormItems.push(control);
	      }
	      data = getData(editor);
	      var embedTextBox = {
	        id: 'mcemediasource',
	        type: 'textbox',
	        flex: 1,
	        name: 'embed',
	        value: getSource(editor),
	        multiline: true,
	        rows: 5,
	        label: 'Source'
	      };
	      var updateValueOnChange = function () {
	        data = global$2.extend({}, HtmlToData.htmlToData(Settings.getScripts(editor), this.value()));
	        this.parent().parent().fromJSON(data);
	      };
	      embedTextBox[embedChange] = updateValueOnChange;
	      var body = [
	        {
	          title: 'General',
	          type: 'form',
	          items: generalFormItems
	        },
	        {
	          title: 'Embed',
	          type: 'container',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          padding: 10,
	          spacing: 10,
	          items: [
	            {
	              type: 'label',
	              text: 'Paste your embed code below:',
	              forId: 'mcemediasource'
	            },
	            embedTextBox
	          ]
	        }
	      ];
	      if (advancedFormItems.length > 0) {
	        body.push({
	          title: 'Advanced',
	          type: 'form',
	          items: advancedFormItems
	        });
	      }
	      win = editor.windowManager.open({
	        title: 'Insert/edit media',
	        data: data,
	        bodyType: 'tabpanel',
	        body: body,
	        onSubmit: function () {
	          SizeManager.updateSize(win);
	          submitForm(win, editor);
	        }
	      });
	      SizeManager.syncSize(win);
	    };
	    var Dialog = { showDialog: showDialog };
	
	    var get$1 = function (editor) {
	      var showDialog = function () {
	        Dialog.showDialog(editor);
	      };
	      return { showDialog: showDialog };
	    };
	    var Api = { get: get$1 };
	
	    var register = function (editor) {
	      var showDialog = function () {
	        Dialog.showDialog(editor);
	      };
	      editor.addCommand('mceMedia', showDialog);
	    };
	    var Commands = { register: register };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var sanitize = function (editor, html) {
	      if (Settings.shouldFilterHtml(editor) === false) {
	        return html;
	      }
	      var writer = global$7();
	      var blocked;
	      global$4({
	        validate: false,
	        allow_conditional_comments: false,
	        special: 'script,noscript',
	        comment: function (text) {
	          writer.comment(text);
	        },
	        cdata: function (text) {
	          writer.cdata(text);
	        },
	        text: function (text, raw) {
	          writer.text(text, raw);
	        },
	        start: function (name, attrs, empty) {
	          blocked = true;
	          if (name === 'script' || name === 'noscript' || name === 'svg') {
	            return;
	          }
	          for (var i = attrs.length - 1; i >= 0; i--) {
	            var attrName = attrs[i].name;
	            if (attrName.indexOf('on') === 0) {
	              delete attrs.map[attrName];
	              attrs.splice(i, 1);
	            }
	            if (attrName === 'style') {
	              attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
	            }
	          }
	          writer.start(name, attrs, empty);
	          blocked = false;
	        },
	        end: function (name) {
	          if (blocked) {
	            return;
	          }
	          writer.end(name);
	        }
	      }, global$6({})).parse(html);
	      return writer.getContent();
	    };
	    var Sanitize = { sanitize: sanitize };
	
	    var createPlaceholderNode = function (editor, node) {
	      var placeHolder;
	      var name = node.name;
	      placeHolder = new global$8('img', 1);
	      placeHolder.shortEnded = true;
	      retainAttributesAndInnerHtml(editor, node, placeHolder);
	      placeHolder.attr({
	        'width': node.attr('width') || '300',
	        'height': node.attr('height') || (name === 'audio' ? '30' : '150'),
	        'style': node.attr('style'),
	        'src': global$1.transparentSrc,
	        'data-mce-object': name,
	        'class': 'mce-object mce-object-' + name
	      });
	      return placeHolder;
	    };
	    var createPreviewIframeNode = function (editor, node) {
	      var previewWrapper;
	      var previewNode;
	      var shimNode;
	      var name = node.name;
	      previewWrapper = new global$8('span', 1);
	      previewWrapper.attr({
	        'contentEditable': 'false',
	        'style': node.attr('style'),
	        'data-mce-object': name,
	        'class': 'mce-preview-object mce-object-' + name
	      });
	      retainAttributesAndInnerHtml(editor, node, previewWrapper);
	      previewNode = new global$8(name, 1);
	      previewNode.attr({
	        src: node.attr('src'),
	        allowfullscreen: node.attr('allowfullscreen'),
	        style: node.attr('style'),
	        class: node.attr('class'),
	        width: node.attr('width'),
	        height: node.attr('height'),
	        frameborder: '0'
	      });
	      shimNode = new global$8('span', 1);
	      shimNode.attr('class', 'mce-shim');
	      previewWrapper.append(previewNode);
	      previewWrapper.append(shimNode);
	      return previewWrapper;
	    };
	    var retainAttributesAndInnerHtml = function (editor, sourceNode, targetNode) {
	      var attrName;
	      var attrValue;
	      var attribs;
	      var ai;
	      var innerHtml;
	      attribs = sourceNode.attributes;
	      ai = attribs.length;
	      while (ai--) {
	        attrName = attribs[ai].name;
	        attrValue = attribs[ai].value;
	        if (attrName !== 'width' && attrName !== 'height' && attrName !== 'style') {
	          if (attrName === 'data' || attrName === 'src') {
	            attrValue = editor.convertURL(attrValue, attrName);
	          }
	          targetNode.attr('data-mce-p-' + attrName, attrValue);
	        }
	      }
	      innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
	      if (innerHtml) {
	        targetNode.attr('data-mce-html', escape(Sanitize.sanitize(editor, innerHtml)));
	        targetNode.firstChild = null;
	      }
	    };
	    var isWithinEphoxEmbed = function (node) {
	      while (node = node.parent) {
	        if (node.attr('data-ephox-embed-iri')) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var placeHolderConverter = function (editor) {
	      return function (nodes) {
	        var i = nodes.length;
	        var node;
	        var videoScript;
	        while (i--) {
	          node = nodes[i];
	          if (!node.parent) {
	            continue;
	          }
	          if (node.parent.attr('data-mce-object')) {
	            continue;
	          }
	          if (node.name === 'script') {
	            videoScript = VideoScript.getVideoScriptMatch(Settings.getScripts(editor), node.attr('src'));
	            if (!videoScript) {
	              continue;
	            }
	          }
	          if (videoScript) {
	            if (videoScript.width) {
	              node.attr('width', videoScript.width.toString());
	            }
	            if (videoScript.height) {
	              node.attr('height', videoScript.height.toString());
	            }
	          }
	          if (node.name === 'iframe' && Settings.hasLiveEmbeds(editor) && global$1.ceFalse) {
	            if (!isWithinEphoxEmbed(node)) {
	              node.replace(createPreviewIframeNode(editor, node));
	            }
	          } else {
	            if (!isWithinEphoxEmbed(node)) {
	              node.replace(createPlaceholderNode(editor, node));
	            }
	          }
	        }
	      };
	    };
	    var Nodes = {
	      createPreviewIframeNode: createPreviewIframeNode,
	      createPlaceholderNode: createPlaceholderNode,
	      placeHolderConverter: placeHolderConverter
	    };
	
	    var setup = function (editor) {
	      editor.on('preInit', function () {
	        var specialElements = editor.schema.getSpecialElements();
	        global$2.each('video audio iframe object'.split(' '), function (name) {
	          specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	        });
	        var boolAttrs = editor.schema.getBoolAttrs();
	        global$2.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
	          boolAttrs[name] = {};
	        });
	        editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', Nodes.placeHolderConverter(editor));
	        editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
	          var i = nodes.length;
	          var node;
	          var realElm;
	          var ai;
	          var attribs;
	          var innerHtml;
	          var innerNode;
	          var realElmName;
	          var className;
	          while (i--) {
	            node = nodes[i];
	            if (!node.parent) {
	              continue;
	            }
	            realElmName = node.attr(name);
	            realElm = new global$8(realElmName, 1);
	            if (realElmName !== 'audio' && realElmName !== 'script') {
	              className = node.attr('class');
	              if (className && className.indexOf('mce-preview-object') !== -1) {
	                realElm.attr({
	                  width: node.firstChild.attr('width'),
	                  height: node.firstChild.attr('height')
	                });
	              } else {
	                realElm.attr({
	                  width: node.attr('width'),
	                  height: node.attr('height')
	                });
	              }
	            }
	            realElm.attr({ style: node.attr('style') });
	            attribs = node.attributes;
	            ai = attribs.length;
	            while (ai--) {
	              var attrName = attribs[ai].name;
	              if (attrName.indexOf('data-mce-p-') === 0) {
	                realElm.attr(attrName.substr(11), attribs[ai].value);
	              }
	            }
	            if (realElmName === 'script') {
	              realElm.attr('type', 'text/javascript');
	            }
	            innerHtml = node.attr('data-mce-html');
	            if (innerHtml) {
	              innerNode = new global$8('#text', 3);
	              innerNode.raw = true;
	              innerNode.value = Sanitize.sanitize(editor, unescape(innerHtml));
	              realElm.append(innerNode);
	            }
	            node.replace(realElm);
	          }
	        });
	      });
	      editor.on('setContent', function () {
	        editor.$('span.mce-preview-object').each(function (index, elm) {
	          var $elm = editor.$(elm);
	          if ($elm.find('span.mce-shim', elm).length === 0) {
	            $elm.append('<span class="mce-shim"></span>');
	          }
	        });
	      });
	    };
	    var FilterContent = { setup: setup };
	
	    var setup$1 = function (editor) {
	      editor.on('ResolveName', function (e) {
	        var name;
	        if (e.target.nodeType === 1 && (name = e.target.getAttribute('data-mce-object'))) {
	          e.name = name;
	        }
	      });
	    };
	    var ResolveName = { setup: setup$1 };
	
	    var setup$2 = function (editor) {
	      editor.on('click keyup', function () {
	        var selectedNode = editor.selection.getNode();
	        if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
	          if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
	            selectedNode.setAttribute('data-mce-selected', '2');
	          }
	        }
	      });
	      editor.on('ObjectSelected', function (e) {
	        var objectType = e.target.getAttribute('data-mce-object');
	        if (objectType === 'audio' || objectType === 'script') {
	          e.preventDefault();
	        }
	      });
	      editor.on('objectResized', function (e) {
	        var target = e.target;
	        var html;
	        if (target.getAttribute('data-mce-object')) {
	          html = target.getAttribute('data-mce-html');
	          if (html) {
	            html = unescape(html);
	            target.setAttribute('data-mce-html', escape(UpdateHtml.updateHtml(html, {
	              width: e.width,
	              height: e.height
	            })));
	          }
	        }
	      });
	    };
	    var Selection = { setup: setup$2 };
	
	    var register$1 = function (editor) {
	      editor.addButton('media', {
	        tooltip: 'Insert/edit media',
	        cmd: 'mceMedia',
	        stateSelector: [
	          'img[data-mce-object]',
	          'span[data-mce-object]',
	          'div[data-ephox-embed-iri]'
	        ]
	      });
	      editor.addMenuItem('media', {
	        icon: 'media',
	        text: 'Media',
	        cmd: 'mceMedia',
	        context: 'insert',
	        prependToContext: true
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('media', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	      ResolveName.setup(editor);
	      FilterContent.setup(editor);
	      Selection.setup(editor);
	      return Api.get(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "paste" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/paste')
	//   ES2015:
	//     import 'tinymce/plugins/paste'
	__webpack_require__(554);

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {(function () {
	var paste = (function (domGlobals) {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasProPlugin = function (editor) {
	      if (/(^|[ ,])powerpaste([, ]|$)/.test(editor.settings.plugins) && global$1.get('powerpaste')) {
	        if (typeof domGlobals.window.console !== 'undefined' && domGlobals.window.console.log) {
	          domGlobals.window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var DetectProPlugin = { hasProPlugin: hasProPlugin };
	
	    var get = function (clipboard, quirks) {
	      return {
	        clipboard: clipboard,
	        quirks: quirks
	      };
	    };
	    var Api = { get: get };
	
	    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
	      return editor.fire('PastePreProcess', {
	        content: html,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
	      return editor.fire('PastePostProcess', {
	        node: node,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePlainTextToggle = function (editor, state) {
	      return editor.fire('PastePlainTextToggle', { state: state });
	    };
	    var firePaste = function (editor, ieFake) {
	      return editor.fire('paste', { ieFake: ieFake });
	    };
	    var Events = {
	      firePastePreProcess: firePastePreProcess,
	      firePastePostProcess: firePastePostProcess,
	      firePastePlainTextToggle: firePastePlainTextToggle,
	      firePaste: firePaste
	    };
	
	    var shouldPlainTextInform = function (editor) {
	      return editor.getParam('paste_plaintext_inform', true);
	    };
	    var shouldBlockDrop = function (editor) {
	      return editor.getParam('paste_block_drop', false);
	    };
	    var shouldPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false);
	    };
	    var shouldFilterDrop = function (editor) {
	      return editor.getParam('paste_filter_drop', true);
	    };
	    var getPreProcess = function (editor) {
	      return editor.getParam('paste_preprocess');
	    };
	    var getPostProcess = function (editor) {
	      return editor.getParam('paste_postprocess');
	    };
	    var getWebkitStyles = function (editor) {
	      return editor.getParam('paste_webkit_styles');
	    };
	    var shouldRemoveWebKitStyles = function (editor) {
	      return editor.getParam('paste_remove_styles_if_webkit', true);
	    };
	    var shouldMergeFormats = function (editor) {
	      return editor.getParam('paste_merge_formats', true);
	    };
	    var isSmartPasteEnabled = function (editor) {
	      return editor.getParam('smart_paste', true);
	    };
	    var isPasteAsTextEnabled = function (editor) {
	      return editor.getParam('paste_as_text', false);
	    };
	    var getRetainStyleProps = function (editor) {
	      return editor.getParam('paste_retain_style_properties');
	    };
	    var getWordValidElements = function (editor) {
	      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
	      return editor.getParam('paste_word_valid_elements', defaultValidElements);
	    };
	    var shouldConvertWordFakeLists = function (editor) {
	      return editor.getParam('paste_convert_word_fake_lists', true);
	    };
	    var shouldUseDefaultFilters = function (editor) {
	      return editor.getParam('paste_enable_default_filters', true);
	    };
	    var Settings = {
	      shouldPlainTextInform: shouldPlainTextInform,
	      shouldBlockDrop: shouldBlockDrop,
	      shouldPasteDataImages: shouldPasteDataImages,
	      shouldFilterDrop: shouldFilterDrop,
	      getPreProcess: getPreProcess,
	      getPostProcess: getPostProcess,
	      getWebkitStyles: getWebkitStyles,
	      shouldRemoveWebKitStyles: shouldRemoveWebKitStyles,
	      shouldMergeFormats: shouldMergeFormats,
	      isSmartPasteEnabled: isSmartPasteEnabled,
	      isPasteAsTextEnabled: isPasteAsTextEnabled,
	      getRetainStyleProps: getRetainStyleProps,
	      getWordValidElements: getWordValidElements,
	      shouldConvertWordFakeLists: shouldConvertWordFakeLists,
	      shouldUseDefaultFilters: shouldUseDefaultFilters
	    };
	
	    var shouldInformUserAboutPlainText = function (editor, userIsInformedState) {
	      return userIsInformedState.get() === false && Settings.shouldPlainTextInform(editor);
	    };
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        text: editor.translate(message),
	        type: 'info'
	      });
	    };
	    var togglePlainTextPaste = function (editor, clipboard, userIsInformedState) {
	      if (clipboard.pasteFormat.get() === 'text') {
	        clipboard.pasteFormat.set('html');
	        Events.firePastePlainTextToggle(editor, false);
	      } else {
	        clipboard.pasteFormat.set('text');
	        Events.firePastePlainTextToggle(editor, true);
	        if (shouldInformUserAboutPlainText(editor, userIsInformedState)) {
	          displayNotification(editor, 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.');
	          userIsInformedState.set(true);
	        }
	      }
	      editor.focus();
	    };
	    var Actions = { togglePlainTextPaste: togglePlainTextPaste };
	
	    var register = function (editor, clipboard, userIsInformedState) {
	      editor.addCommand('mceTogglePlainTextPaste', function () {
	        Actions.togglePlainTextPaste(editor, clipboard, userIsInformedState);
	      });
	      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
	        if (value.content) {
	          clipboard.pasteHtml(value.content, value.internal);
	        }
	        if (value.text) {
	          clipboard.pasteText(value.text);
	        }
	      });
	    };
	    var Commands = { register: register };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var internalMimeType = 'x-tinymce/html';
	    var internalMark = '<!-- ' + internalMimeType + ' -->';
	    var mark = function (html) {
	      return internalMark + html;
	    };
	    var unmark = function (html) {
	      return html.replace(internalMark, '');
	    };
	    var isMarked = function (html) {
	      return html.indexOf(internalMark) !== -1;
	    };
	    var InternalHtml = {
	      mark: mark,
	      unmark: unmark,
	      isMarked: isMarked,
	      internalHtmlMime: function () {
	        return internalMimeType;
	      }
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var isPlainText = function (text) {
	      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
	    };
	    var toBRs = function (text) {
	      return text.replace(/\r?\n/g, '<br>');
	    };
	    var openContainer = function (rootTag, rootAttrs) {
	      var key;
	      var attrs = [];
	      var tag = '<' + rootTag;
	      if (typeof rootAttrs === 'object') {
	        for (key in rootAttrs) {
	          if (rootAttrs.hasOwnProperty(key)) {
	            attrs.push(key + '="' + global$6.encodeAllRaw(rootAttrs[key]) + '"');
	          }
	        }
	        if (attrs.length) {
	          tag += ' ' + attrs.join(' ');
	        }
	      }
	      return tag + '>';
	    };
	    var toBlockElements = function (text, rootTag, rootAttrs) {
	      var blocks = text.split(/\n\n/);
	      var tagOpen = openContainer(rootTag, rootAttrs);
	      var tagClose = '</' + rootTag + '>';
	      var paragraphs = global$4.map(blocks, function (p) {
	        return p.split(/\n/).join('<br />');
	      });
	      var stitch = function (p) {
	        return tagOpen + p + tagClose;
	      };
	      return paragraphs.length === 1 ? paragraphs[0] : global$4.map(paragraphs, stitch).join('');
	    };
	    var convert = function (text, rootTag, rootAttrs) {
	      return rootTag ? toBlockElements(text, rootTag, rootAttrs) : toBRs(text);
	    };
	    var Newlines = {
	      isPlainText: isPlainText,
	      convert: convert,
	      toBRs: toBRs,
	      toBlockElements: toBlockElements
	    };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.DomParser');
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Serializer');
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    function filter(content, items) {
	      global$4.each(items, function (v) {
	        if (v.constructor === RegExp) {
	          content = content.replace(v, '');
	        } else {
	          content = content.replace(v[0], v[1]);
	        }
	      });
	      return content;
	    }
	    function innerText(html) {
	      var schema = global$a();
	      var domParser = global$7({}, schema);
	      var text = '';
	      var shortEndedElements = schema.getShortEndedElements();
	      var ignoreElements = global$4.makeMap('script noscript style textarea video audio iframe object', ' ');
	      var blockElements = schema.getBlockElements();
	      function walk(node) {
	        var name = node.name, currentNode = node;
	        if (name === 'br') {
	          text += '\n';
	          return;
	        }
	        if (name === 'wbr') {
	          return;
	        }
	        if (shortEndedElements[name]) {
	          text += ' ';
	        }
	        if (ignoreElements[name]) {
	          text += ' ';
	          return;
	        }
	        if (node.type === 3) {
	          text += node.value;
	        }
	        if (!node.shortEnded) {
	          if (node = node.firstChild) {
	            do {
	              walk(node);
	            } while (node = node.next);
	          }
	        }
	        if (blockElements[name] && currentNode.next) {
	          text += '\n';
	          if (name === 'p') {
	            text += '\n';
	          }
	        }
	      }
	      html = filter(html, [/<!\[[^\]]+\]>/g]);
	      walk(domParser.parse(html));
	      return text;
	    }
	    function trimHtml(html) {
	      function trimSpaces(all, s1, s2) {
	        if (!s1 && !s2) {
	          return ' ';
	        }
	        return '\xA0';
	      }
	      html = filter(html, [
	        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
	        /<!--StartFragment-->|<!--EndFragment-->/g,
	        [
	          /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
	          trimSpaces
	        ],
	        /<br class="Apple-interchange-newline">/g,
	        /<br>$/i
	      ]);
	      return html;
	    }
	    function createIdGenerator(prefix) {
	      var count = 0;
	      return function () {
	        return prefix + count++;
	      };
	    }
	    var isMsEdge = function () {
	      return domGlobals.navigator.userAgent.indexOf(' Edge/') !== -1;
	    };
	    var Utils = {
	      filter: filter,
	      innerText: innerText,
	      trimHtml: trimHtml,
	      createIdGenerator: createIdGenerator,
	      isMsEdge: isMsEdge
	    };
	
	    function isWordContent(content) {
	      return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content);
	    }
	    function isNumericList(text) {
	      var found, patterns;
	      patterns = [
	        /^[IVXLMCD]{1,2}\.[ \u00a0]/,
	        /^[ivxlmcd]{1,2}\.[ \u00a0]/,
	        /^[a-z]{1,2}[\.\)][ \u00a0]/,
	        /^[A-Z]{1,2}[\.\)][ \u00a0]/,
	        /^[0-9]+\.[ \u00a0]/,
	        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
	        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
	      ];
	      text = text.replace(/^[\u00a0 ]+/, '');
	      global$4.each(patterns, function (pattern) {
	        if (pattern.test(text)) {
	          found = true;
	          return false;
	        }
	      });
	      return found;
	    }
	    function isBulletList(text) {
	      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
	    }
	    function convertFakeListsToProperLists(node) {
	      var currentListNode, prevListNode, lastLevel = 1;
	      function getText(node) {
	        var txt = '';
	        if (node.type === 3) {
	          return node.value;
	        }
	        if (node = node.firstChild) {
	          do {
	            txt += getText(node);
	          } while (node = node.next);
	        }
	        return txt;
	      }
	      function trimListStart(node, regExp) {
	        if (node.type === 3) {
	          if (regExp.test(node.value)) {
	            node.value = node.value.replace(regExp, '');
	            return false;
	          }
	        }
	        if (node = node.firstChild) {
	          do {
	            if (!trimListStart(node, regExp)) {
	              return false;
	            }
	          } while (node = node.next);
	        }
	        return true;
	      }
	      function removeIgnoredNodes(node) {
	        if (node._listIgnore) {
	          node.remove();
	          return;
	        }
	        if (node = node.firstChild) {
	          do {
	            removeIgnoredNodes(node);
	          } while (node = node.next);
	        }
	      }
	      function convertParagraphToLi(paragraphNode, listName, start) {
	        var level = paragraphNode._listLevel || lastLevel;
	        if (level !== lastLevel) {
	          if (level < lastLevel) {
	            if (currentListNode) {
	              currentListNode = currentListNode.parent.parent;
	            }
	          } else {
	            prevListNode = currentListNode;
	            currentListNode = null;
	          }
	        }
	        if (!currentListNode || currentListNode.name !== listName) {
	          prevListNode = prevListNode || currentListNode;
	          currentListNode = new global$9(listName, 1);
	          if (start > 1) {
	            currentListNode.attr('start', '' + start);
	          }
	          paragraphNode.wrap(currentListNode);
	        } else {
	          currentListNode.append(paragraphNode);
	        }
	        paragraphNode.name = 'li';
	        if (level > lastLevel && prevListNode) {
	          prevListNode.lastChild.append(currentListNode);
	        }
	        lastLevel = level;
	        removeIgnoredNodes(paragraphNode);
	        trimListStart(paragraphNode, /^\u00a0+/);
	        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
	        trimListStart(paragraphNode, /^\u00a0+/);
	      }
	      var elements = [];
	      var child = node.firstChild;
	      while (typeof child !== 'undefined' && child !== null) {
	        elements.push(child);
	        child = child.walk();
	        if (child !== null) {
	          while (typeof child !== 'undefined' && child.parent !== node) {
	            child = child.walk();
	          }
	        }
	      }
	      for (var i = 0; i < elements.length; i++) {
	        node = elements[i];
	        if (node.name === 'p' && node.firstChild) {
	          var nodeText = getText(node);
	          if (isBulletList(nodeText)) {
	            convertParagraphToLi(node, 'ul');
	            continue;
	          }
	          if (isNumericList(nodeText)) {
	            var matches = /([0-9]+)\./.exec(nodeText);
	            var start = 1;
	            if (matches) {
	              start = parseInt(matches[1], 10);
	            }
	            convertParagraphToLi(node, 'ol', start);
	            continue;
	          }
	          if (node._listLevel) {
	            convertParagraphToLi(node, 'ul', 1);
	            continue;
	          }
	          currentListNode = null;
	        } else {
	          prevListNode = currentListNode;
	          currentListNode = null;
	        }
	      }
	    }
	    function filterStyles(editor, validStyles, node, styleValue) {
	      var outputStyles = {}, matches;
	      var styles = editor.dom.parseStyle(styleValue);
	      global$4.each(styles, function (value, name) {
	        switch (name) {
	        case 'mso-list':
	          matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
	          if (matches) {
	            node._listLevel = parseInt(matches[1], 10);
	          }
	          if (/Ignore/i.test(value) && node.firstChild) {
	            node._listIgnore = true;
	            node.firstChild._listIgnore = true;
	          }
	          break;
	        case 'horiz-align':
	          name = 'text-align';
	          break;
	        case 'vert-align':
	          name = 'vertical-align';
	          break;
	        case 'font-color':
	        case 'mso-foreground':
	          name = 'color';
	          break;
	        case 'mso-background':
	        case 'mso-highlight':
	          name = 'background';
	          break;
	        case 'font-weight':
	        case 'font-style':
	          if (value !== 'normal') {
	            outputStyles[name] = value;
	          }
	          return;
	        case 'mso-element':
	          if (/^(comment|comment-list)$/i.test(value)) {
	            node.remove();
	            return;
	          }
	          break;
	        }
	        if (name.indexOf('mso-comment') === 0) {
	          node.remove();
	          return;
	        }
	        if (name.indexOf('mso-') === 0) {
	          return;
	        }
	        if (Settings.getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
	          outputStyles[name] = value;
	        }
	      });
	      if (/(bold)/i.test(outputStyles['font-weight'])) {
	        delete outputStyles['font-weight'];
	        node.wrap(new global$9('b', 1));
	      }
	      if (/(italic)/i.test(outputStyles['font-style'])) {
	        delete outputStyles['font-style'];
	        node.wrap(new global$9('i', 1));
	      }
	      outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
	      if (outputStyles) {
	        return outputStyles;
	      }
	      return null;
	    }
	    var filterWordContent = function (editor, content) {
	      var retainStyleProperties, validStyles;
	      retainStyleProperties = Settings.getRetainStyleProps(editor);
	      if (retainStyleProperties) {
	        validStyles = global$4.makeMap(retainStyleProperties.split(/[, ]/));
	      }
	      content = Utils.filter(content, [
	        /<br class="?Apple-interchange-newline"?>/gi,
	        /<b[^>]+id="?docs-internal-[^>]*>/gi,
	        /<!--[\s\S]+?-->/gi,
	        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	        [
	          /<(\/?)s>/gi,
	          '<$1strike>'
	        ],
	        [
	          /&nbsp;/gi,
	          '\xA0'
	        ],
	        [
	          /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
	          function (str, spaces) {
	            return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join('\xA0') : '';
	          }
	        ]
	      ]);
	      var validElements = Settings.getWordValidElements(editor);
	      var schema = global$a({
	        valid_elements: validElements,
	        valid_children: '-li[p]'
	      });
	      global$4.each(schema.elements, function (rule) {
	        if (!rule.attributes.class) {
	          rule.attributes.class = {};
	          rule.attributesOrder.push('class');
	        }
	        if (!rule.attributes.style) {
	          rule.attributes.style = {};
	          rule.attributesOrder.push('style');
	        }
	      });
	      var domParser = global$7({}, schema);
	      domParser.addAttributeFilter('style', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
	          if (node.name === 'span' && node.parent && !node.attributes.length) {
	            node.unwrap();
	          }
	        }
	      });
	      domParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, className;
	        while (i--) {
	          node = nodes[i];
	          className = node.attr('class');
	          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
	            node.remove();
	          }
	          node.attr('class', null);
	        }
	      });
	      domParser.addNodeFilter('del', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].remove();
	        }
	      });
	      domParser.addNodeFilter('a', function (nodes) {
	        var i = nodes.length, node, href, name;
	        while (i--) {
	          node = nodes[i];
	          href = node.attr('href');
	          name = node.attr('name');
	          if (href && href.indexOf('#_msocom_') !== -1) {
	            node.remove();
	            continue;
	          }
	          if (href && href.indexOf('file://') === 0) {
	            href = href.split('#')[1];
	            if (href) {
	              href = '#' + href;
	            }
	          }
	          if (!href && !name) {
	            node.unwrap();
	          } else {
	            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
	              node.unwrap();
	              continue;
	            }
	            node.attr({
	              href: href,
	              name: name
	            });
	          }
	        }
	      });
	      var rootNode = domParser.parse(content);
	      if (Settings.shouldConvertWordFakeLists(editor)) {
	        convertFakeListsToProperLists(rootNode);
	      }
	      content = global$8({ validate: editor.settings.validate }, schema).serialize(rootNode);
	      return content;
	    };
	    var preProcess = function (editor, content) {
	      return Settings.shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
	    };
	    var WordFilter = {
	      preProcess: preProcess,
	      isWordContent: isWordContent
	    };
	
	    var preProcess$1 = function (editor, html) {
	      var parser = global$7({}, editor.schema);
	      parser.addNodeFilter('meta', function (nodes) {
	        global$4.each(nodes, function (node) {
	          return node.remove();
	        });
	      });
	      var fragment = parser.parse(html, {
	        forced_root_block: false,
	        isRootContent: true
	      });
	      return global$8({ validate: editor.settings.validate }, editor.schema).serialize(fragment);
	    };
	    var processResult = function (content, cancelled) {
	      return {
	        content: content,
	        cancelled: cancelled
	      };
	    };
	    var postProcessFilter = function (editor, html, internal, isWordHtml) {
	      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
	      var postProcessArgs = Events.firePastePostProcess(editor, tempBody, internal, isWordHtml);
	      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
	    };
	    var filterContent = function (editor, content, internal, isWordHtml) {
	      var preProcessArgs = Events.firePastePreProcess(editor, content, internal, isWordHtml);
	      var filteredContent = preProcess$1(editor, preProcessArgs.content);
	      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
	        return postProcessFilter(editor, filteredContent, internal, isWordHtml);
	      } else {
	        return processResult(filteredContent, preProcessArgs.isDefaultPrevented());
	      }
	    };
	    var process = function (editor, html, internal) {
	      var isWordHtml = WordFilter.isWordContent(html);
	      var content = isWordHtml ? WordFilter.preProcess(editor, html) : html;
	      return filterContent(editor, content, internal, isWordHtml);
	    };
	    var ProcessFilters = { process: process };
	
	    var pasteHtml = function (editor, html) {
	      editor.insertContent(html, {
	        merge: Settings.shouldMergeFormats(editor),
	        paste: true
	      });
	      return true;
	    };
	    var isAbsoluteUrl = function (url) {
	      return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
	    };
	    var isImageUrl = function (url) {
	      return isAbsoluteUrl(url) && /.(gif|jpe?g|png)$/.test(url);
	    };
	    var createImage = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.insertContent('<img src="' + url + '">');
	      });
	      return true;
	    };
	    var createLink = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.execCommand('mceInsertLink', false, url);
	      });
	      return true;
	    };
	    var linkSelection = function (editor, html, pasteHtmlFn) {
	      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
	    };
	    var insertImage = function (editor, html, pasteHtmlFn) {
	      return isImageUrl(html) ? createImage(editor, html, pasteHtmlFn) : false;
	    };
	    var smartInsertContent = function (editor, html) {
	      global$4.each([
	        linkSelection,
	        insertImage,
	        pasteHtml
	      ], function (action) {
	        return action(editor, html, pasteHtml) !== true;
	      });
	    };
	    var insertContent = function (editor, html) {
	      if (Settings.isSmartPasteEnabled(editor) === false) {
	        pasteHtml(editor, html);
	      } else {
	        smartInsertContent(editor, html);
	      }
	    };
	    var SmartPaste = {
	      isImageUrl: isImageUrl,
	      isAbsoluteUrl: isAbsoluteUrl,
	      insertContent: insertContent
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isFunction = isType('function');
	
	    var nativeSlice = Array.prototype.slice;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter$1 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var exports$1 = {}, module = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module, undefined));
	    var Promise = module.exports.boltExport;
	
	    var nu = function (baseFn) {
	      var data = Option.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        data = Option.some(x);
	        run(callbacks);
	        callbacks = [];
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          domGlobals.setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      domGlobals.setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$1 = function (baseFn) {
	      return make(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$1,
	      pure: pure$1
	    };
	
	    var par = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par$1 = function (futures) {
	      return par(futures, Future.nu);
	    };
	    var traverse = function (array, fn) {
	      return par$1(map(array, fn));
	    };
	    var mapM = traverse;
	
	    var value = function () {
	      var subject = Cell(Option.none());
	      var clear = function () {
	        subject.set(Option.none());
	      };
	      var set = function (s) {
	        subject.set(Option.some(s));
	      };
	      var on = function (f) {
	        subject.get().each(f);
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var pasteHtml$1 = function (editor, html, internalFlag) {
	      var internal = internalFlag ? internalFlag : InternalHtml.isMarked(html);
	      var args = ProcessFilters.process(editor, InternalHtml.unmark(html), internal);
	      if (args.cancelled === false) {
	        SmartPaste.insertContent(editor, args.content);
	      }
	    };
	    var pasteText = function (editor, text) {
	      text = editor.dom.encode(text).replace(/\r\n/g, '\n');
	      text = Newlines.convert(text, editor.settings.forced_root_block, editor.settings.forced_root_block_attrs);
	      pasteHtml$1(editor, text, false);
	    };
	    var getDataTransferItems = function (dataTransfer) {
	      var items = {};
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      if (dataTransfer) {
	        if (dataTransfer.getData) {
	          var legacyText = dataTransfer.getData('Text');
	          if (legacyText && legacyText.length > 0) {
	            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
	              items['text/plain'] = legacyText;
	            }
	          }
	        }
	        if (dataTransfer.types) {
	          for (var i = 0; i < dataTransfer.types.length; i++) {
	            var contentType = dataTransfer.types[i];
	            try {
	              items[contentType] = dataTransfer.getData(contentType);
	            } catch (ex) {
	              items[contentType] = '';
	            }
	          }
	        }
	      }
	      return items;
	    };
	    var getClipboardContent = function (editor, clipboardEvent) {
	      var content = getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
	      return Utils.isMsEdge() ? global$4.extend(content, { 'text/html': '' }) : content;
	    };
	    var hasContentType = function (clipboardContent, mimeType) {
	      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
	    };
	    var hasHtmlOrText = function (content) {
	      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
	    };
	    var getBase64FromUri = function (uri) {
	      var idx;
	      idx = uri.indexOf(',');
	      if (idx !== -1) {
	        return uri.substr(idx + 1);
	      }
	      return null;
	    };
	    var isValidDataUriImage = function (settings, imgElm) {
	      return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
	    };
	    var extractFilename = function (editor, str) {
	      var m = str.match(/([\s\S]+?)\.(?:jpeg|jpg|png|gif)$/i);
	      return m ? editor.dom.encode(m[1]) : null;
	    };
	    var uniqueId = Utils.createIdGenerator('mceclip');
	    var pasteImage = function (editor, imageItem) {
	      var base64 = getBase64FromUri(imageItem.uri);
	      var id = uniqueId();
	      var name = editor.settings.images_reuse_filename && imageItem.blob.name ? extractFilename(editor, imageItem.blob.name) : id;
	      var img = new domGlobals.Image();
	      img.src = imageItem.uri;
	      if (isValidDataUriImage(editor.settings, img)) {
	        var blobCache = editor.editorUpload.blobCache;
	        var blobInfo = void 0, existingBlobInfo = void 0;
	        existingBlobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.base64() === base64;
	        });
	        if (!existingBlobInfo) {
	          blobInfo = blobCache.create(id, imageItem.blob, base64, name);
	          blobCache.add(blobInfo);
	        } else {
	          blobInfo = existingBlobInfo;
	        }
	        pasteHtml$1(editor, '<img src="' + blobInfo.blobUri() + '">', false);
	      } else {
	        pasteHtml$1(editor, '<img src="' + imageItem.uri + '">', false);
	      }
	    };
	    var isClipboardEvent = function (event) {
	      return event.type === 'paste';
	    };
	    var readBlobsAsDataUris = function (items) {
	      return mapM(items, function (item) {
	        return Future.nu(function (resolve) {
	          var blob = item.getAsFile ? item.getAsFile() : item;
	          var reader = new window.FileReader();
	          reader.onload = function () {
	            resolve({
	              blob: blob,
	              uri: reader.result
	            });
	          };
	          reader.readAsDataURL(blob);
	        });
	      });
	    };
	    var getImagesFromDataTransfer = function (dataTransfer) {
	      var items = dataTransfer.items ? map(from$1(dataTransfer.items), function (item) {
	        return item.getAsFile();
	      }) : [];
	      var files = dataTransfer.files ? from$1(dataTransfer.files) : [];
	      var images = filter$1(items.length > 0 ? items : files, function (file) {
	        return /^image\/(jpeg|png|gif|bmp)$/.test(file.type);
	      });
	      return images;
	    };
	    var pasteImageData = function (editor, e, rng) {
	      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
	      if (editor.settings.paste_data_images && dataTransfer) {
	        var images = getImagesFromDataTransfer(dataTransfer);
	        if (images.length > 0) {
	          e.preventDefault();
	          readBlobsAsDataUris(images).get(function (blobResults) {
	            if (rng) {
	              editor.selection.setRng(rng);
	            }
	            each(blobResults, function (result) {
	              pasteImage(editor, result);
	            });
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var isBrokenAndroidClipboardEvent = function (e) {
	      var clipboardData = e.clipboardData;
	      return domGlobals.navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
	    };
	    var isKeyboardPasteEvent = function (e) {
	      return global$5.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
	    };
	    var registerEventHandlers = function (editor, pasteBin, pasteFormat) {
	      var keyboardPasteEvent = value();
	      var keyboardPastePlainTextState;
	      editor.on('keydown', function (e) {
	        function removePasteBinOnKeyUp(e) {
	          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	            pasteBin.remove();
	          }
	        }
	        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
	          if (keyboardPastePlainTextState && global$2.webkit && domGlobals.navigator.userAgent.indexOf('Version/') !== -1) {
	            return;
	          }
	          e.stopImmediatePropagation();
	          keyboardPasteEvent.set(e);
	          window.setTimeout(function () {
	            keyboardPasteEvent.clear();
	          }, 100);
	          if (global$2.ie && keyboardPastePlainTextState) {
	            e.preventDefault();
	            Events.firePaste(editor, true);
	            return;
	          }
	          pasteBin.remove();
	          pasteBin.create();
	          editor.once('keyup', removePasteBinOnKeyUp);
	          editor.once('paste', function () {
	            editor.off('keyup', removePasteBinOnKeyUp);
	          });
	        }
	      });
	      function insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
	        var content, isPlainTextHtml;
	        if (hasContentType(clipboardContent, 'text/html')) {
	          content = clipboardContent['text/html'];
	        } else {
	          content = pasteBin.getHtml();
	          internal = internal ? internal : InternalHtml.isMarked(content);
	          if (pasteBin.isDefaultContent(content)) {
	            plainTextMode = true;
	          }
	        }
	        content = Utils.trimHtml(content);
	        pasteBin.remove();
	        isPlainTextHtml = internal === false && Newlines.isPlainText(content);
	        if (!content.length || isPlainTextHtml) {
	          plainTextMode = true;
	        }
	        if (plainTextMode) {
	          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
	            content = clipboardContent['text/plain'];
	          } else {
	            content = Utils.innerText(content);
	          }
	        }
	        if (pasteBin.isDefaultContent(content)) {
	          if (!isKeyBoardPaste) {
	            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
	          }
	          return;
	        }
	        if (plainTextMode) {
	          pasteText(editor, content);
	        } else {
	          pasteHtml$1(editor, content, internal);
	        }
	      }
	      var getLastRng = function () {
	        return pasteBin.getLastRng() || editor.selection.getRng();
	      };
	      editor.on('paste', function (e) {
	        var isKeyBoardPaste = keyboardPasteEvent.isSet();
	        var clipboardContent = getClipboardContent(editor, e);
	        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
	        var internal = hasContentType(clipboardContent, InternalHtml.internalHtmlMime());
	        keyboardPastePlainTextState = false;
	        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
	          pasteBin.remove();
	          return;
	        }
	        if (!hasHtmlOrText(clipboardContent) && pasteImageData(editor, e, getLastRng())) {
	          pasteBin.remove();
	          return;
	        }
	        if (!isKeyBoardPaste) {
	          e.preventDefault();
	        }
	        if (global$2.ie && (!isKeyBoardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
	          pasteBin.create();
	          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
	            e.stopPropagation();
	          });
	          editor.getDoc().execCommand('Paste', false, null);
	          clipboardContent['text/html'] = pasteBin.getHtml();
	        }
	        if (hasContentType(clipboardContent, 'text/html')) {
	          e.preventDefault();
	          if (!internal) {
	            internal = InternalHtml.isMarked(clipboardContent['text/html']);
	          }
	          insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	        } else {
	          global$3.setEditorTimeout(editor, function () {
	            insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	          }, 0);
	        }
	      });
	    };
	    var registerEventsAndFilters = function (editor, pasteBin, pasteFormat) {
	      registerEventHandlers(editor, pasteBin, pasteFormat);
	      var src;
	      editor.parser.addNodeFilter('img', function (nodes, name, args) {
	        var isPasteInsert = function (args) {
	          return args.data && args.data.paste === true;
	        };
	        var remove = function (node) {
	          if (!node.attr('data-mce-object') && src !== global$2.transparentSrc) {
	            node.remove();
	          }
	        };
	        var isWebKitFakeUrl = function (src) {
	          return src.indexOf('webkit-fake-url') === 0;
	        };
	        var isDataUri = function (src) {
	          return src.indexOf('data:') === 0;
	        };
	        if (!editor.settings.paste_data_images && isPasteInsert(args)) {
	          var i = nodes.length;
	          while (i--) {
	            src = nodes[i].attributes.map.src;
	            if (!src) {
	              continue;
	            }
	            if (isWebKitFakeUrl(src)) {
	              remove(nodes[i]);
	            } else if (!editor.settings.allow_html_data_urls && isDataUri(src)) {
	              remove(nodes[i]);
	            }
	          }
	        }
	      });
	    };
	
	    var getPasteBinParent = function (editor) {
	      return global$2.ie && editor.inline ? domGlobals.document.body : editor.getBody();
	    };
	    var isExternalPasteBin = function (editor) {
	      return getPasteBinParent(editor) !== editor.getBody();
	    };
	    var delegatePasteEvents = function (editor, pasteBinElm, pasteBinDefaultContent) {
	      if (isExternalPasteBin(editor)) {
	        editor.dom.bind(pasteBinElm, 'paste keyup', function (e) {
	          if (!isDefault(editor, pasteBinDefaultContent)) {
	            editor.fire('paste');
	          }
	        });
	      }
	    };
	    var create = function (editor, lastRngCell, pasteBinDefaultContent) {
	      var dom = editor.dom, body = editor.getBody();
	      var pasteBinElm;
	      lastRngCell.set(editor.selection.getRng());
	      pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
	        'id': 'mcepastebin',
	        'class': 'mce-pastebin',
	        'contentEditable': true,
	        'data-mce-bogus': 'all',
	        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
	      }, pasteBinDefaultContent);
	      if (global$2.ie || global$2.gecko) {
	        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
	      }
	      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
	        e.stopPropagation();
	      });
	      delegatePasteEvents(editor, pasteBinElm, pasteBinDefaultContent);
	      pasteBinElm.focus();
	      editor.selection.select(pasteBinElm, true);
	    };
	    var remove = function (editor, lastRngCell) {
	      if (getEl(editor)) {
	        var pasteBinClone = void 0;
	        var lastRng = lastRngCell.get();
	        while (pasteBinClone = editor.dom.get('mcepastebin')) {
	          editor.dom.remove(pasteBinClone);
	          editor.dom.unbind(pasteBinClone);
	        }
	        if (lastRng) {
	          editor.selection.setRng(lastRng);
	        }
	      }
	      lastRngCell.set(null);
	    };
	    var getEl = function (editor) {
	      return editor.dom.get('mcepastebin');
	    };
	    var getHtml = function (editor) {
	      var pasteBinElm, pasteBinClones, i, dirtyWrappers, cleanWrapper;
	      var copyAndRemove = function (toElm, fromElm) {
	        toElm.appendChild(fromElm);
	        editor.dom.remove(fromElm, true);
	      };
	      pasteBinClones = global$4.grep(getPasteBinParent(editor).childNodes, function (elm) {
	        return elm.id === 'mcepastebin';
	      });
	      pasteBinElm = pasteBinClones.shift();
	      global$4.each(pasteBinClones, function (pasteBinClone) {
	        copyAndRemove(pasteBinElm, pasteBinClone);
	      });
	      dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
	      for (i = dirtyWrappers.length - 1; i >= 0; i--) {
	        cleanWrapper = editor.dom.create('div');
	        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
	        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
	      }
	      return pasteBinElm ? pasteBinElm.innerHTML : '';
	    };
	    var getLastRng = function (lastRng) {
	      return lastRng.get();
	    };
	    var isDefaultContent = function (pasteBinDefaultContent, content) {
	      return content === pasteBinDefaultContent;
	    };
	    var isPasteBin = function (elm) {
	      return elm && elm.id === 'mcepastebin';
	    };
	    var isDefault = function (editor, pasteBinDefaultContent) {
	      var pasteBinElm = getEl(editor);
	      return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
	    };
	    var PasteBin = function (editor) {
	      var lastRng = Cell(null);
	      var pasteBinDefaultContent = '%MCEPASTEBIN%';
	      return {
	        create: function () {
	          return create(editor, lastRng, pasteBinDefaultContent);
	        },
	        remove: function () {
	          return remove(editor, lastRng);
	        },
	        getEl: function () {
	          return getEl(editor);
	        },
	        getHtml: function () {
	          return getHtml(editor);
	        },
	        getLastRng: function () {
	          return getLastRng(lastRng);
	        },
	        isDefault: function () {
	          return isDefault(editor, pasteBinDefaultContent);
	        },
	        isDefaultContent: function (content) {
	          return isDefaultContent(pasteBinDefaultContent, content);
	        }
	      };
	    };
	
	    var Clipboard = function (editor, pasteFormat) {
	      var pasteBin = PasteBin(editor);
	      editor.on('preInit', function () {
	        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
	      });
	      return {
	        pasteFormat: pasteFormat,
	        pasteHtml: function (html, internalFlag) {
	          return pasteHtml$1(editor, html, internalFlag);
	        },
	        pasteText: function (text) {
	          return pasteText(editor, text);
	        },
	        pasteImageData: function (e, rng) {
	          return pasteImageData(editor, e, rng);
	        },
	        getDataTransferItems: getDataTransferItems,
	        hasHtmlOrText: hasHtmlOrText,
	        hasContentType: hasContentType
	      };
	    };
	
	    var noop$1 = function () {
	    };
	    var hasWorkingClipboardApi = function (clipboardData) {
	      return global$2.iOS === false && clipboardData !== undefined && typeof clipboardData.setData === 'function' && Utils.isMsEdge() !== true;
	    };
	    var setHtml5Clipboard = function (clipboardData, html, text) {
	      if (hasWorkingClipboardApi(clipboardData)) {
	        try {
	          clipboardData.clearData();
	          clipboardData.setData('text/html', html);
	          clipboardData.setData('text/plain', text);
	          clipboardData.setData(InternalHtml.internalHtmlMime(), html);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    };
	    var setClipboardData = function (evt, data, fallback, done) {
	      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
	        evt.preventDefault();
	        done();
	      } else {
	        fallback(data.html, done);
	      }
	    };
	    var fallback = function (editor) {
	      return function (html, done) {
	        var markedHtml = InternalHtml.mark(html);
	        var outer = editor.dom.create('div', {
	          'contenteditable': 'false',
	          'data-mce-bogus': 'all'
	        });
	        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
	        editor.dom.setStyles(outer, {
	          position: 'fixed',
	          top: '0',
	          left: '-3000px',
	          width: '1000px',
	          overflow: 'hidden'
	        });
	        outer.appendChild(inner);
	        editor.dom.add(editor.getBody(), outer);
	        var range = editor.selection.getRng();
	        inner.focus();
	        var offscreenRange = editor.dom.createRng();
	        offscreenRange.selectNodeContents(inner);
	        editor.selection.setRng(offscreenRange);
	        setTimeout(function () {
	          editor.selection.setRng(range);
	          outer.parentNode.removeChild(outer);
	          done();
	        }, 0);
	      };
	    };
	    var getData = function (editor) {
	      return {
	        html: editor.selection.getContent({ contextual: true }),
	        text: editor.selection.getContent({ format: 'text' })
	      };
	    };
	    var isTableSelection = function (editor) {
	      return !!editor.dom.getParent(editor.selection.getStart(), 'td[data-mce-selected],th[data-mce-selected]', editor.getBody());
	    };
	    var hasSelectedContent = function (editor) {
	      return !editor.selection.isCollapsed() || isTableSelection(editor);
	    };
	    var cut = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), function () {
	            setTimeout(function () {
	              editor.execCommand('Delete');
	            }, 0);
	          });
	        }
	      };
	    };
	    var copy = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), noop$1);
	        }
	      };
	    };
	    var register$1 = function (editor) {
	      editor.on('cut', cut(editor));
	      editor.on('copy', copy(editor));
	    };
	    var CutCopy = { register: register$1 };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var getCaretRangeFromEvent = function (editor, e) {
	      return global$b.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
	    };
	    var isPlainTextFileUrl = function (content) {
	      var plainTextContent = content['text/plain'];
	      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
	    };
	    var setFocusedRange = function (editor, rng) {
	      editor.focus();
	      editor.selection.setRng(rng);
	    };
	    var setup = function (editor, clipboard, draggingInternallyState) {
	      if (Settings.shouldBlockDrop(editor)) {
	        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        });
	      }
	      if (!Settings.shouldPasteDataImages(editor)) {
	        editor.on('drop', function (e) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
	            e.preventDefault();
	          }
	        });
	      }
	      editor.on('drop', function (e) {
	        var dropContent, rng;
	        rng = getCaretRangeFromEvent(editor, e);
	        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
	          return;
	        }
	        dropContent = clipboard.getDataTransferItems(e.dataTransfer);
	        var internal = clipboard.hasContentType(dropContent, InternalHtml.internalHtmlMime());
	        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
	          return;
	        }
	        if (rng && Settings.shouldFilterDrop(editor)) {
	          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	          if (content_1) {
	            e.preventDefault();
	            global$3.setEditorTimeout(editor, function () {
	              editor.undoManager.transact(function () {
	                if (dropContent['mce-internal']) {
	                  editor.execCommand('Delete');
	                }
	                setFocusedRange(editor, rng);
	                content_1 = Utils.trimHtml(content_1);
	                if (!dropContent['text/html']) {
	                  clipboard.pasteText(content_1);
	                } else {
	                  clipboard.pasteHtml(content_1, internal);
	                }
	              });
	            });
	          }
	        }
	      });
	      editor.on('dragstart', function (e) {
	        draggingInternallyState.set(true);
	      });
	      editor.on('dragover dragend', function (e) {
	        if (Settings.shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
	          e.preventDefault();
	          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
	        }
	        if (e.type === 'dragend') {
	          draggingInternallyState.set(false);
	        }
	      });
	    };
	    var DragDrop = { setup: setup };
	
	    var setup$1 = function (editor) {
	      var plugin = editor.plugins.paste;
	      var preProcess = Settings.getPreProcess(editor);
	      if (preProcess) {
	        editor.on('PastePreProcess', function (e) {
	          preProcess.call(plugin, plugin, e);
	        });
	      }
	      var postProcess = Settings.getPostProcess(editor);
	      if (postProcess) {
	        editor.on('PastePostProcess', function (e) {
	          postProcess.call(plugin, plugin, e);
	        });
	      }
	    };
	    var PrePostProcess = { setup: setup$1 };
	
	    function addPreProcessFilter(editor, filterFunc) {
	      editor.on('PastePreProcess', function (e) {
	        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
	      });
	    }
	    function addPostProcessFilter(editor, filterFunc) {
	      editor.on('PastePostProcess', function (e) {
	        filterFunc(editor, e.node);
	      });
	    }
	    function removeExplorerBrElementsAfterBlocks(editor, html) {
	      if (!WordFilter.isWordContent(html)) {
	        return html;
	      }
	      var blockElements = [];
	      global$4.each(editor.schema.getBlockElements(), function (block, blockName) {
	        blockElements.push(blockName);
	      });
	      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
	      html = Utils.filter(html, [[
	          explorerBlocksRegExp,
	          '$1'
	        ]]);
	      html = Utils.filter(html, [
	        [
	          /<br><br>/g,
	          '<BR><BR>'
	        ],
	        [
	          /<br>/g,
	          ' '
	        ],
	        [
	          /<BR><BR>/g,
	          '<br>'
	        ]
	      ]);
	      return html;
	    }
	    function removeWebKitStyles(editor, content, internal, isWordHtml) {
	      if (isWordHtml || internal) {
	        return content;
	      }
	      var webKitStylesSetting = Settings.getWebkitStyles(editor);
	      var webKitStyles;
	      if (Settings.shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
	        return content;
	      }
	      if (webKitStylesSetting) {
	        webKitStyles = webKitStylesSetting.split(/[, ]/);
	      }
	      if (webKitStyles) {
	        var dom_1 = editor.dom, node_1 = editor.selection.getNode();
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
	          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
	          var outputStyles = {};
	          if (webKitStyles === 'none') {
	            return before + after;
	          }
	          for (var i = 0; i < webKitStyles.length; i++) {
	            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
	            if (/color/.test(webKitStyles[i])) {
	              inputValue = dom_1.toHex(inputValue);
	              currentValue = dom_1.toHex(currentValue);
	            }
	            if (currentValue !== inputValue) {
	              outputStyles[webKitStyles[i]] = inputValue;
	            }
	          }
	          outputStyles = dom_1.serializeStyle(outputStyles, 'span');
	          if (outputStyles) {
	            return before + ' style="' + outputStyles + '"' + after;
	          }
	          return before + after;
	        });
	      } else {
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
	      }
	      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
	        return before + ' style="' + value + '"' + after;
	      });
	      return content;
	    }
	    function removeUnderlineAndFontInAnchor(editor, root) {
	      editor.$('a', root).find('font,u').each(function (i, node) {
	        editor.dom.remove(node, true);
	      });
	    }
	    var setup$2 = function (editor) {
	      if (global$2.webkit) {
	        addPreProcessFilter(editor, removeWebKitStyles);
	      }
	      if (global$2.ie) {
	        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
	        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
	      }
	    };
	    var Quirks = { setup: setup$2 };
	
	    var stateChange = function (editor, clipboard, e) {
	      var ctrl = e.control;
	      ctrl.active(clipboard.pasteFormat.get() === 'text');
	      editor.on('PastePlainTextToggle', function (e) {
	        ctrl.active(e.state);
	      });
	    };
	    var register$2 = function (editor, clipboard) {
	      var postRender = curry(stateChange, editor, clipboard);
	      editor.addButton('pastetext', {
	        active: false,
	        icon: 'pastetext',
	        tooltip: 'Paste as text',
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	      editor.addMenuItem('pastetext', {
	        text: 'Paste as text',
	        selectable: true,
	        active: clipboard.pasteFormat,
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	    };
	    var Buttons = { register: register$2 };
	
	    global$1.add('paste', function (editor) {
	      if (DetectProPlugin.hasProPlugin(editor) === false) {
	        var userIsInformedState = Cell(false);
	        var draggingInternallyState = Cell(false);
	        var pasteFormat = Cell(Settings.isPasteAsTextEnabled(editor) ? 'text' : 'html');
	        var clipboard = Clipboard(editor, pasteFormat);
	        var quirks = Quirks.setup(editor);
	        Buttons.register(editor, clipboard);
	        Commands.register(editor, clipboard, userIsInformedState);
	        PrePostProcess.setup(editor);
	        CutCopy.register(editor);
	        DragDrop.setup(editor, clipboard, draggingInternallyState);
	        return Api.get(clipboard, quirks);
	      }
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "table" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/table')
	//   ES2015:
	//     import 'tinymce/plugins/table'
	__webpack_require__(556);

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	(function () {
	var table = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return !f.apply(null, args);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isBoolean = isType('boolean');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(i);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var keys = Object.keys;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$1 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var sort = function (arr) {
	      return arr.slice(0).sort();
	    };
	    var reqMessage = function (required, keys) {
	      throw new Error('All required keys (' + sort(required).join(', ') + ') were not specified. Specified keys were: ' + sort(keys).join(', ') + '.');
	    };
	    var unsuppMessage = function (unsupported) {
	      throw new Error('Unsupported keys for object: ' + sort(unsupported).join(', '));
	    };
	    var validateStrArr = function (label, array) {
	      if (!isArray(array)) {
	        throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
	      }
	      each(array, function (a) {
	        if (!isString(a)) {
	          throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
	        }
	      });
	    };
	    var invalidTypeMessage = function (incorrect, type) {
	      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort(incorrect).join(', ') + ') were not.');
	    };
	    var checkDupes = function (everything) {
	      var sorted = sort(everything);
	      var dupe = find(sorted, function (s, i) {
	        return i < sorted.length - 1 && s === sorted[i + 1];
	      });
	      dupe.each(function (d) {
	        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
	      });
	    };
	
	    var MixedBag = function (required, optional) {
	      var everything = required.concat(optional);
	      if (everything.length === 0) {
	        throw new Error('You must specify at least one required or optional field.');
	      }
	      validateStrArr('required', required);
	      validateStrArr('optional', optional);
	      checkDupes(everything);
	      return function (obj) {
	        var keys$1 = keys(obj);
	        var allReqd = forall(required, function (req) {
	          return contains(keys$1, req);
	        });
	        if (!allReqd) {
	          reqMessage(required, keys$1);
	        }
	        var unsupported = filter(keys$1, function (key) {
	          return !contains(everything, key);
	        });
	        if (unsupported.length > 0) {
	          unsuppMessage(unsupported);
	        }
	        var r = {};
	        each(required, function (req) {
	          r[req] = constant(obj[req]);
	        });
	        each(optional, function (opt) {
	          r[opt] = constant(Object.prototype.hasOwnProperty.call(obj, opt) ? Option.some(obj[opt]) : Option.none());
	        });
	        return r;
	      };
	    };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isComment = function (element) {
	      return type(element) === COMMENT || name(element) === '#comment';
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        domGlobals.console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom(), key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get = function (element, key) {
	      var v = element.dom().getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var has = function (element, key) {
	      var dom = element.dom();
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove = function (element, key) {
	      element.dom().removeAttribute(key);
	    };
	    var clone = function (element) {
	      return foldl(element.dom().attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var checkRange = function (str, substr, start) {
	      if (substr === '') {
	        return true;
	      }
	      if (str.length < substr.length) {
	        return false;
	      }
	      var x = str.substr(start, start + substr.length);
	      return x === substr;
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var trim = function (str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom().parentNode : element.dom();
	      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
	    };
	    var body = cached(function () {
	      return getBody(Element.fromDom(domGlobals.document));
	    });
	    var getBody = function (doc) {
	      var b = doc.dom().body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return Element.fromDom(b);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        domGlobals.console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var internalRemove = function (dom, property) {
	      if (isSupported(dom)) {
	        dom.style.removeProperty(property);
	      }
	    };
	    var set$1 = function (element, property, value) {
	      var dom = element.dom();
	      internalSet(dom, property, value);
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom();
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$1 = function (element, property) {
	      var dom = element.dom();
	      var styles = domGlobals.window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      var v = r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	      return v === null ? undefined : v;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom();
	      var raw = getUnsafeProperty(dom, property);
	      return Option.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var remove$1 = function (element, property) {
	      var dom = element.dom();
	      internalRemove(dom, property);
	      if (has(element, 'style') && trim(get(element, 'style')) === '') {
	        remove(element, 'style');
	      }
	    };
	    var copy = function (source, target) {
	      var sourceDom = source.dom();
	      var targetDom = target.dom();
	      if (isSupported(sourceDom) && isSupported(targetDom)) {
	        targetDom.style.cssText = sourceDom.style.cssText;
	      }
	    };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var ELEMENT$1 = ELEMENT;
	    var DOCUMENT$1 = DOCUMENT;
	    var is = function (element, selector) {
	      var dom = element.dom();
	      if (dom.nodeType !== ELEMENT$1) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT$1 && dom.nodeType !== DOCUMENT$1 || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$2 = browser.isIE() ? ieContains : regularContains;
	    var is$1 = is;
	
	    var owner = function (element) {
	      return Element.fromDom(element.dom().ownerDocument);
	    };
	    var defaultView = function (element) {
	      return Element.fromDom(element.dom().ownerDocument.defaultView);
	    };
	    var parent = function (element) {
	      return Option.from(element.dom().parentNode).map(Element.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom();
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = Element.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var prevSibling = function (element) {
	      return Option.from(element.dom().previousSibling).map(Element.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Option.from(element.dom().nextSibling).map(Element.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom().childNodes, Element.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom().childNodes;
	      return Option.from(cs[index]).map(Element.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var spot = Immutable('element', 'offset');
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom().insertBefore(element.dom(), v.dom());
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var after$1 = function (marker, elements) {
	      each(elements, function (x, i) {
	        var e = i === 0 ? marker : elements[i - 1];
	        after(e, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom().textContent = '';
	      each(children(element), function (rogue) {
	        remove$2(rogue);
	      });
	    };
	    var remove$2 = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove$2(wrapper);
	    };
	
	    var dimension = Immutable('width', 'height');
	    var dimensions = Immutable('width', 'height');
	    var grid = Immutable('rows', 'columns');
	    var address = Immutable('row', 'column');
	    var coords = Immutable('x', 'y');
	    var detail = Immutable('element', 'rowspan', 'colspan');
	    var detailnew = Immutable('element', 'rowspan', 'colspan', 'isNew');
	    var extended = Immutable('element', 'rowspan', 'colspan', 'row', 'column');
	    var rowdata = Immutable('element', 'cells', 'section');
	    var elementnew = Immutable('element', 'isNew');
	    var rowdatanew = Immutable('element', 'cells', 'section', 'isNew');
	    var rowcells = Immutable('cells', 'section');
	    var rowdetails = Immutable('details', 'section');
	    var bounds = Immutable('startRow', 'startCol', 'finishRow', 'finishCol');
	
	    var ancestors = function (scope, predicate, isRoot) {
	      return filter(parents(scope, isRoot), predicate);
	    };
	    var children$1 = function (scope, predicate) {
	      return filter(children(scope), predicate);
	    };
	    var descendants = function (scope, predicate) {
	      var result = [];
	      each(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    var ancestors$1 = function (scope, selector, isRoot) {
	      return ancestors(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var children$2 = function (scope, selector) {
	      return children$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	    var descendants$1 = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      return is(scope, a) ? Option.some(scope) : isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
	    }
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom();
	      var stop = isFunction(isRoot) ? isRoot : constant(false);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = Element.fromDom(element);
	        if (predicate(el)) {
	          return Option.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Option.none();
	    };
	    var closest = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	    var child$1 = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(Element.fromDom(node));
	      };
	      var result = find(scope.dom().childNodes, pred);
	      return result.map(Element.fromDom);
	    };
	    var descendant = function (scope, predicate) {
	      var descend = function (node) {
	        for (var i = 0; i < node.childNodes.length; i++) {
	          var child_1 = Element.fromDom(node.childNodes[i]);
	          if (predicate(child_1)) {
	            return Option.some(child_1);
	          }
	          var res = descend(node.childNodes[i]);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Option.none();
	      };
	      return descend(scope.dom());
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var child$2 = function (scope, selector) {
	      return child$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	    var descendant$1 = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      return ClosestOrAncestor(is, ancestor$1, scope, selector, isRoot);
	    };
	
	    var firstLayer = function (scope, selector) {
	      return filterFirstLayer(scope, selector, constant(true));
	    };
	    var filterFirstLayer = function (scope, selector, predicate) {
	      return bind(children(scope), function (x) {
	        return is(x, selector) ? predicate(x) ? [x] : [] : filterFirstLayer(x, selector, predicate);
	      });
	    };
	    var LayerSelector = {
	      firstLayer: firstLayer,
	      filterFirstLayer: filterFirstLayer
	    };
	
	    var lookup = function (tags, element, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      if (isRoot(element)) {
	        return Option.none();
	      }
	      if (contains(tags, name(element))) {
	        return Option.some(element);
	      }
	      var isRootOrUpperTable = function (elm) {
	        return is(elm, 'table') || isRoot(elm);
	      };
	      return ancestor$1(element, tags.join(','), isRootOrUpperTable);
	    };
	    var cell = function (element, isRoot) {
	      return lookup([
	        'td',
	        'th'
	      ], element, isRoot);
	    };
	    var cells = function (ancestor) {
	      return LayerSelector.firstLayer(ancestor, 'th,td');
	    };
	    var notCell = function (element, isRoot) {
	      return lookup([
	        'caption',
	        'tr',
	        'tbody',
	        'tfoot',
	        'thead'
	      ], element, isRoot);
	    };
	    var neighbours = function (selector, element) {
	      return parent(element).map(function (parent) {
	        return children$2(parent, selector);
	      });
	    };
	    var neighbourCells = curry(neighbours, 'th,td');
	    var neighbourRows = curry(neighbours, 'tr');
	    var firstCell = function (ancestor) {
	      return descendant$1(ancestor, 'th,td');
	    };
	    var table = function (element, isRoot) {
	      return closest$1(element, 'table', isRoot);
	    };
	    var row = function (element, isRoot) {
	      return lookup(['tr'], element, isRoot);
	    };
	    var rows = function (ancestor) {
	      return LayerSelector.firstLayer(ancestor, 'tr');
	    };
	    var attr = function (element, property) {
	      return parseInt(get(element, property), 10);
	    };
	    var grid$1 = function (element, rowProp, colProp) {
	      var rowsCount = attr(element, rowProp);
	      var cols = attr(element, colProp);
	      return grid(rowsCount, cols);
	    };
	    var TableLookup = {
	      cell: cell,
	      firstCell: firstCell,
	      cells: cells,
	      neighbourCells: neighbourCells,
	      table: table,
	      row: row,
	      rows: rows,
	      notCell: notCell,
	      neighbourRows: neighbourRows,
	      attr: attr,
	      grid: grid$1
	    };
	
	    var fromTable = function (table) {
	      var rows = TableLookup.rows(table);
	      return map(rows, function (row) {
	        var element = row;
	        var parent$1 = parent(element);
	        var parentSection = parent$1.map(function (p) {
	          var parentName = name(p);
	          return parentName === 'tfoot' || parentName === 'thead' || parentName === 'tbody' ? parentName : 'tbody';
	        }).getOr('tbody');
	        var cells = map(TableLookup.cells(row), function (cell) {
	          var rowspan = has(cell, 'rowspan') ? parseInt(get(cell, 'rowspan'), 10) : 1;
	          var colspan = has(cell, 'colspan') ? parseInt(get(cell, 'colspan'), 10) : 1;
	          return detail(cell, rowspan, colspan);
	        });
	        return rowdata(element, cells, parentSection);
	      });
	    };
	    var fromPastedRows = function (rows, example) {
	      return map(rows, function (row) {
	        var cells = map(TableLookup.cells(row), function (cell) {
	          var rowspan = has(cell, 'rowspan') ? parseInt(get(cell, 'rowspan'), 10) : 1;
	          var colspan = has(cell, 'colspan') ? parseInt(get(cell, 'colspan'), 10) : 1;
	          return detail(cell, rowspan, colspan);
	        });
	        return rowdata(row, cells, example.section());
	      });
	    };
	    var DetailsList = {
	      fromTable: fromTable,
	      fromPastedRows: fromPastedRows
	    };
	
	    var key = function (row, column) {
	      return row + ',' + column;
	    };
	    var getAt = function (warehouse, row, column) {
	      var raw = warehouse.access()[key(row, column)];
	      return raw !== undefined ? Option.some(raw) : Option.none();
	    };
	    var findItem = function (warehouse, item, comparator) {
	      var filtered = filterItems(warehouse, function (detail) {
	        return comparator(item, detail.element());
	      });
	      return filtered.length > 0 ? Option.some(filtered[0]) : Option.none();
	    };
	    var filterItems = function (warehouse, predicate) {
	      var all = bind(warehouse.all(), function (r) {
	        return r.cells();
	      });
	      return filter(all, predicate);
	    };
	    var generate = function (list) {
	      var access = {};
	      var cells = [];
	      var maxRows = list.length;
	      var maxColumns = 0;
	      each(list, function (details, r) {
	        var currentRow = [];
	        each(details.cells(), function (detail) {
	          var start = 0;
	          while (access[key(r, start)] !== undefined) {
	            start++;
	          }
	          var current = extended(detail.element(), detail.rowspan(), detail.colspan(), r, start);
	          for (var i = 0; i < detail.colspan(); i++) {
	            for (var j = 0; j < detail.rowspan(); j++) {
	              var cr = r + j;
	              var cc = start + i;
	              var newpos = key(cr, cc);
	              access[newpos] = current;
	              maxColumns = Math.max(maxColumns, cc + 1);
	            }
	          }
	          currentRow.push(current);
	        });
	        cells.push(rowdata(details.element(), currentRow, details.section()));
	      });
	      var grid$1 = grid(maxRows, maxColumns);
	      return {
	        grid: constant(grid$1),
	        access: constant(access),
	        all: constant(cells)
	      };
	    };
	    var justCells = function (warehouse) {
	      var rows = map(warehouse.all(), function (w) {
	        return w.cells();
	      });
	      return flatten(rows);
	    };
	    var Warehouse = {
	      generate: generate,
	      getAt: getAt,
	      findItem: findItem,
	      filterItems: filterItems,
	      justCells: justCells
	    };
	
	    var statsStruct = Immutable('minRow', 'minCol', 'maxRow', 'maxCol');
	    var findSelectedStats = function (house, isSelected) {
	      var totalColumns = house.grid().columns();
	      var totalRows = house.grid().rows();
	      var minRow = totalRows;
	      var minCol = totalColumns;
	      var maxRow = 0;
	      var maxCol = 0;
	      each$1(house.access(), function (detail) {
	        if (isSelected(detail)) {
	          var startRow = detail.row();
	          var endRow = startRow + detail.rowspan() - 1;
	          var startCol = detail.column();
	          var endCol = startCol + detail.colspan() - 1;
	          if (startRow < minRow) {
	            minRow = startRow;
	          } else if (endRow > maxRow) {
	            maxRow = endRow;
	          }
	          if (startCol < minCol) {
	            minCol = startCol;
	          } else if (endCol > maxCol) {
	            maxCol = endCol;
	          }
	        }
	      });
	      return statsStruct(minRow, minCol, maxRow, maxCol);
	    };
	    var makeCell = function (list, seenSelected, rowIndex) {
	      var row = list[rowIndex].element();
	      var td = Element.fromTag('td');
	      append(td, Element.fromTag('br'));
	      var f = seenSelected ? append : prepend;
	      f(row, td);
	    };
	    var fillInGaps = function (list, house, stats, isSelected) {
	      var totalColumns = house.grid().columns();
	      var totalRows = house.grid().rows();
	      for (var i = 0; i < totalRows; i++) {
	        var seenSelected = false;
	        for (var j = 0; j < totalColumns; j++) {
	          if (!(i < stats.minRow() || i > stats.maxRow() || j < stats.minCol() || j > stats.maxCol())) {
	            var needCell = Warehouse.getAt(house, i, j).filter(isSelected).isNone();
	            if (needCell) {
	              makeCell(list, seenSelected, i);
	            } else {
	              seenSelected = true;
	            }
	          }
	        }
	      }
	    };
	    var clean = function (table, stats) {
	      var emptyRows = filter(LayerSelector.firstLayer(table, 'tr'), function (row) {
	        return row.dom().childElementCount === 0;
	      });
	      each(emptyRows, remove$2);
	      if (stats.minCol() === stats.maxCol() || stats.minRow() === stats.maxRow()) {
	        each(LayerSelector.firstLayer(table, 'th,td'), function (cell) {
	          remove(cell, 'rowspan');
	          remove(cell, 'colspan');
	        });
	      }
	      remove(table, 'width');
	      remove(table, 'height');
	      remove$1(table, 'width');
	      remove$1(table, 'height');
	    };
	    var extract = function (table, selectedSelector) {
	      var isSelected = function (detail) {
	        return is(detail.element(), selectedSelector);
	      };
	      var list = DetailsList.fromTable(table);
	      var house = Warehouse.generate(list);
	      var stats = findSelectedStats(house, isSelected);
	      var selector = 'th:not(' + selectedSelector + ')' + ',td:not(' + selectedSelector + ')';
	      var unselectedCells = LayerSelector.filterFirstLayer(table, 'th,td', function (cell) {
	        return is(cell, selector);
	      });
	      each(unselectedCells, remove$2);
	      fillInGaps(list, house, stats, isSelected);
	      clean(table, stats);
	      return table;
	    };
	    var CopySelected = { extract: extract };
	
	    function NodeValue (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom().nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    }
	
	    var api = NodeValue(isText, 'text');
	    var get$2 = function (element) {
	      return api.get(element);
	    };
	    var getOption = function (element) {
	      return api.getOption(element);
	    };
	    var set$2 = function (element, value) {
	      api.set(element, value);
	    };
	
	    var getEnd = function (element) {
	      return name(element) === 'img' ? 1 : getOption(element).fold(function () {
	        return children(element).length;
	      }, function (v) {
	        return v.length;
	      });
	    };
	    var NBSP = '\xA0';
	    var isTextNodeWithCursorPosition = function (el) {
	      return getOption(el).filter(function (text) {
	        return text.trim().length !== 0 || text.indexOf(NBSP) > -1;
	      }).isSome();
	    };
	    var elementsWithCursorPosition = [
	      'img',
	      'br'
	    ];
	    var isCursorPosition = function (elem) {
	      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
	      return hasCursorPosition || contains(elementsWithCursorPosition, name(elem));
	    };
	
	    var first = function (element) {
	      return descendant(element, isCursorPosition);
	    };
	    var last$1 = function (element) {
	      return descendantRtl(element, isCursorPosition);
	    };
	    var descendantRtl = function (scope, predicate) {
	      var descend = function (element) {
	        var children$1 = children(element);
	        for (var i = children$1.length - 1; i >= 0; i--) {
	          var child = children$1[i];
	          if (predicate(child)) {
	            return Option.some(child);
	          }
	          var res = descend(child);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Option.none();
	      };
	      return descend(scope);
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return Element.fromDom(original.dom().cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone$1(original, false);
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = Element.fromTag(tag);
	      var attributes = clone(original);
	      setAll(nu, attributes);
	      return nu;
	    };
	    var copy$1 = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      var cloneChildren = children(deep(original));
	      append$1(nu, cloneChildren);
	      return nu;
	    };
	
	    var createCell = function () {
	      var td = Element.fromTag('td');
	      append(td, Element.fromTag('br'));
	      return td;
	    };
	    var replace = function (cell, tag, attrs) {
	      var replica = copy$1(cell, tag);
	      each$1(attrs, function (v, k) {
	        if (v === null) {
	          remove(replica, k);
	        } else {
	          set(replica, k, v);
	        }
	      });
	      return replica;
	    };
	    var pasteReplace = function (cell) {
	      return cell;
	    };
	    var newRow = function (doc) {
	      return function () {
	        return Element.fromTag('tr', doc.dom());
	      };
	    };
	    var cloneFormats = function (oldCell, newCell, formats) {
	      var first$1 = first(oldCell);
	      return first$1.map(function (firstText) {
	        var formatSelector = formats.join(',');
	        var parents = ancestors$1(firstText, formatSelector, function (element) {
	          return eq(element, oldCell);
	        });
	        return foldr(parents, function (last, parent) {
	          var clonedFormat = shallow(parent);
	          remove(clonedFormat, 'contenteditable');
	          append(last, clonedFormat);
	          return clonedFormat;
	        }, newCell);
	      }).getOr(newCell);
	    };
	    var cellOperations = function (mutate, doc, formatsToClone) {
	      var newCell = function (prev) {
	        var docu = owner(prev.element());
	        var td = Element.fromTag(name(prev.element()), docu.dom());
	        var formats = formatsToClone.getOr([
	          'strong',
	          'em',
	          'b',
	          'i',
	          'span',
	          'font',
	          'h1',
	          'h2',
	          'h3',
	          'h4',
	          'h5',
	          'h6',
	          'p',
	          'div'
	        ]);
	        var lastNode = formats.length > 0 ? cloneFormats(prev.element(), td, formats) : td;
	        append(lastNode, Element.fromTag('br'));
	        copy(prev.element(), td);
	        remove$1(td, 'height');
	        if (prev.colspan() !== 1) {
	          remove$1(prev.element(), 'width');
	        }
	        mutate(prev.element(), td);
	        return td;
	      };
	      return {
	        row: newRow(doc),
	        cell: newCell,
	        replace: replace,
	        gap: createCell
	      };
	    };
	    var paste = function (doc) {
	      return {
	        row: newRow(doc),
	        cell: createCell,
	        replace: pasteReplace,
	        gap: createCell
	      };
	    };
	    var TableFill = {
	      cellOperations: cellOperations,
	      paste: paste
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(Element.fromDom(div));
	    };
	
	    var inSelection = function (bounds, detail) {
	      var leftEdge = detail.column();
	      var rightEdge = detail.column() + detail.colspan() - 1;
	      var topEdge = detail.row();
	      var bottomEdge = detail.row() + detail.rowspan() - 1;
	      return leftEdge <= bounds.finishCol() && rightEdge >= bounds.startCol() && (topEdge <= bounds.finishRow() && bottomEdge >= bounds.startRow());
	    };
	    var isWithin = function (bounds, detail) {
	      return detail.column() >= bounds.startCol() && detail.column() + detail.colspan() - 1 <= bounds.finishCol() && detail.row() >= bounds.startRow() && detail.row() + detail.rowspan() - 1 <= bounds.finishRow();
	    };
	    var isRectangular = function (warehouse, bounds) {
	      var isRect = true;
	      var detailIsWithin = curry(isWithin, bounds);
	      for (var i = bounds.startRow(); i <= bounds.finishRow(); i++) {
	        for (var j = bounds.startCol(); j <= bounds.finishCol(); j++) {
	          isRect = isRect && Warehouse.getAt(warehouse, i, j).exists(detailIsWithin);
	        }
	      }
	      return isRect ? Option.some(bounds) : Option.none();
	    };
	    var CellBounds = {
	      inSelection: inSelection,
	      isWithin: isWithin,
	      isRectangular: isRectangular
	    };
	
	    var getBounds = function (detailA, detailB) {
	      return bounds(Math.min(detailA.row(), detailB.row()), Math.min(detailA.column(), detailB.column()), Math.max(detailA.row() + detailA.rowspan() - 1, detailB.row() + detailB.rowspan() - 1), Math.max(detailA.column() + detailA.colspan() - 1, detailB.column() + detailB.colspan() - 1));
	    };
	    var getAnyBox = function (warehouse, startCell, finishCell) {
	      var startCoords = Warehouse.findItem(warehouse, startCell, eq);
	      var finishCoords = Warehouse.findItem(warehouse, finishCell, eq);
	      return startCoords.bind(function (sc) {
	        return finishCoords.map(function (fc) {
	          return getBounds(sc, fc);
	        });
	      });
	    };
	    var getBox = function (warehouse, startCell, finishCell) {
	      return getAnyBox(warehouse, startCell, finishCell).bind(function (bounds) {
	        return CellBounds.isRectangular(warehouse, bounds);
	      });
	    };
	    var CellGroup = {
	      getAnyBox: getAnyBox,
	      getBox: getBox
	    };
	
	    var moveBy = function (warehouse, cell, row, column) {
	      return Warehouse.findItem(warehouse, cell, eq).bind(function (detail) {
	        var startRow = row > 0 ? detail.row() + detail.rowspan() - 1 : detail.row();
	        var startCol = column > 0 ? detail.column() + detail.colspan() - 1 : detail.column();
	        var dest = Warehouse.getAt(warehouse, startRow + row, startCol + column);
	        return dest.map(function (d) {
	          return d.element();
	        });
	      });
	    };
	    var intercepts = function (warehouse, start, finish) {
	      return CellGroup.getAnyBox(warehouse, start, finish).map(function (bounds) {
	        var inside = Warehouse.filterItems(warehouse, curry(CellBounds.inSelection, bounds));
	        return map(inside, function (detail) {
	          return detail.element();
	        });
	      });
	    };
	    var parentCell = function (warehouse, innerCell) {
	      var isContainedBy = function (c1, c2) {
	        return contains$2(c2, c1);
	      };
	      return Warehouse.findItem(warehouse, innerCell, isContainedBy).map(function (detail) {
	        return detail.element();
	      });
	    };
	    var CellFinder = {
	      moveBy: moveBy,
	      intercepts: intercepts,
	      parentCell: parentCell
	    };
	
	    var moveBy$1 = function (cell, deltaRow, deltaColumn) {
	      return TableLookup.table(cell).bind(function (table) {
	        var warehouse = getWarehouse(table);
	        return CellFinder.moveBy(warehouse, cell, deltaRow, deltaColumn);
	      });
	    };
	    var intercepts$1 = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return CellFinder.intercepts(warehouse, first, last);
	    };
	    var nestedIntercepts = function (table, first, firstTable, last, lastTable) {
	      var warehouse = getWarehouse(table);
	      var optStartCell = eq(table, firstTable) ? Option.some(first) : CellFinder.parentCell(warehouse, first);
	      var optLastCell = eq(table, lastTable) ? Option.some(last) : CellFinder.parentCell(warehouse, last);
	      return optStartCell.bind(function (startCell) {
	        return optLastCell.bind(function (lastCell) {
	          return CellFinder.intercepts(warehouse, startCell, lastCell);
	        });
	      });
	    };
	    var getBox$1 = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return CellGroup.getBox(warehouse, first, last);
	    };
	    var getWarehouse = function (table) {
	      var list = DetailsList.fromTable(table);
	      return Warehouse.generate(list);
	    };
	    var TablePositions = {
	      moveBy: moveBy$1,
	      intercepts: intercepts$1,
	      nestedIntercepts: nestedIntercepts,
	      getBox: getBox$1
	    };
	
	    var TagBoundaries = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'li',
	      'table',
	      'thead',
	      'tbody',
	      'tfoot',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	
	    function DomUniverse () {
	      var clone$1 = function (element) {
	        return Element.fromDom(element.dom().cloneNode(false));
	      };
	      var document = function (element) {
	        return element.dom().ownerDocument;
	      };
	      var isBoundary = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        if (name(element) === 'body') {
	          return true;
	        }
	        return contains(TagBoundaries, name(element));
	      };
	      var isEmptyTag = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        return contains([
	          'br',
	          'img',
	          'hr',
	          'input'
	        ], name(element));
	      };
	      var comparePosition = function (element, other) {
	        return element.dom().compareDocumentPosition(other.dom());
	      };
	      var copyAttributesTo = function (source, destination) {
	        var as = clone(source);
	        setAll(destination, as);
	      };
	      return {
	        up: constant({
	          selector: ancestor$1,
	          closest: closest$1,
	          predicate: ancestor,
	          all: parents
	        }),
	        down: constant({
	          selector: descendants$1,
	          predicate: descendants
	        }),
	        styles: constant({
	          get: get$1,
	          getRaw: getRaw,
	          set: set$1,
	          remove: remove$1
	        }),
	        attrs: constant({
	          get: get,
	          set: set,
	          remove: remove,
	          copyTo: copyAttributesTo
	        }),
	        insert: constant({
	          before: before,
	          after: after,
	          afterAll: after$1,
	          append: append,
	          appendAll: append$1,
	          prepend: prepend,
	          wrap: wrap
	        }),
	        remove: constant({
	          unwrap: unwrap,
	          remove: remove$2
	        }),
	        create: constant({
	          nu: Element.fromTag,
	          clone: clone$1,
	          text: Element.fromText
	        }),
	        query: constant({
	          comparePosition: comparePosition,
	          prevSibling: prevSibling,
	          nextSibling: nextSibling
	        }),
	        property: constant({
	          children: children,
	          name: name,
	          parent: parent,
	          document: document,
	          isText: isText,
	          isComment: isComment,
	          isElement: isElement,
	          getText: get$2,
	          setText: set$2,
	          isBoundary: isBoundary,
	          isEmptyTag: isEmptyTag
	        }),
	        eq: eq,
	        is: is$1
	      };
	    }
	
	    var leftRight = Immutable('left', 'right');
	    var brokenPath = Immutable('first', 'second', 'splits');
	    var bisect = function (universe, parent, child) {
	      var children = universe.property().children(parent);
	      var index = findIndex(children, curry(universe.eq, child));
	      return index.map(function (ind) {
	        return {
	          before: constant(children.slice(0, ind)),
	          after: constant(children.slice(ind + 1))
	        };
	      });
	    };
	    var breakToRight = function (universe, parent, child) {
	      return bisect(universe, parent, child).map(function (parts) {
	        var second = universe.create().clone(parent);
	        universe.insert().appendAll(second, parts.after());
	        universe.insert().after(parent, second);
	        return leftRight(parent, second);
	      });
	    };
	    var breakToLeft = function (universe, parent, child) {
	      return bisect(universe, parent, child).map(function (parts) {
	        var prior = universe.create().clone(parent);
	        universe.insert().appendAll(prior, parts.before().concat([child]));
	        universe.insert().appendAll(parent, parts.after());
	        universe.insert().before(parent, prior);
	        return leftRight(prior, parent);
	      });
	    };
	    var breakPath = function (universe, item, isTop, breaker) {
	      var next = function (child, group, splits) {
	        var fallback = brokenPath(child, Option.none(), splits);
	        if (isTop(child)) {
	          return brokenPath(child, group, splits);
	        } else {
	          return universe.property().parent(child).bind(function (parent) {
	            return breaker(universe, parent, child).map(function (breakage) {
	              var extra = [{
	                  first: breakage.left,
	                  second: breakage.right
	                }];
	              var nextChild = isTop(parent) ? parent : breakage.left();
	              return next(nextChild, Option.some(breakage.right()), splits.concat(extra));
	            });
	          }).getOr(fallback);
	        }
	      };
	      return next(item, Option.none(), []);
	    };
	
	    var all$1 = function (universe, look, elements, f) {
	      var head = elements[0];
	      var tail = elements.slice(1);
	      return f(universe, look, head, tail);
	    };
	    var oneAll = function (universe, look, elements) {
	      return elements.length > 0 ? all$1(universe, look, elements, unsafeOne) : Option.none();
	    };
	    var unsafeOne = function (universe, look, head, tail) {
	      var start = look(universe, head);
	      return foldr(tail, function (b, a) {
	        var current = look(universe, a);
	        return commonElement(universe, b, current);
	      }, start);
	    };
	    var commonElement = function (universe, start, end) {
	      return start.bind(function (s) {
	        return end.filter(curry(universe.eq, s));
	      });
	    };
	
	    var eq$1 = function (universe, item) {
	      return curry(universe.eq, item);
	    };
	    var unsafeSubset = function (universe, common, ps1, ps2) {
	      var children = universe.property().children(common);
	      if (universe.eq(common, ps1[0])) {
	        return Option.some([ps1[0]]);
	      }
	      if (universe.eq(common, ps2[0])) {
	        return Option.some([ps2[0]]);
	      }
	      var finder = function (ps) {
	        var topDown = reverse(ps);
	        var index = findIndex(topDown, eq$1(universe, common)).getOr(-1);
	        var item = index < topDown.length - 1 ? topDown[index + 1] : topDown[index];
	        return findIndex(children, eq$1(universe, item));
	      };
	      var startIndex = finder(ps1);
	      var endIndex = finder(ps2);
	      return startIndex.bind(function (sIndex) {
	        return endIndex.map(function (eIndex) {
	          var first = Math.min(sIndex, eIndex);
	          var last = Math.max(sIndex, eIndex);
	          return children.slice(first, last + 1);
	        });
	      });
	    };
	    var ancestors$2 = function (universe, start, end, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      var ps1 = [start].concat(universe.up().all(start));
	      var ps2 = [end].concat(universe.up().all(end));
	      var prune = function (path) {
	        var index = findIndex(path, isRoot);
	        return index.fold(function () {
	          return path;
	        }, function (ind) {
	          return path.slice(0, ind + 1);
	        });
	      };
	      var pruned1 = prune(ps1);
	      var pruned2 = prune(ps2);
	      var shared = find(pruned1, function (x) {
	        return exists(pruned2, eq$1(universe, x));
	      });
	      return {
	        firstpath: constant(pruned1),
	        secondpath: constant(pruned2),
	        shared: constant(shared)
	      };
	    };
	    var subset = function (universe, start, end) {
	      var ancs = ancestors$2(universe, start, end);
	      return ancs.shared().bind(function (shared) {
	        return unsafeSubset(universe, shared, ancs.firstpath(), ancs.secondpath());
	      });
	    };
	    var SubsetFn = {
	      subset: subset,
	      ancestors: ancestors$2
	    };
	
	    var sharedOne = oneAll;
	    var subset$1 = SubsetFn.subset;
	    var ancestors$3 = SubsetFn.ancestors;
	    var breakToLeft$1 = breakToLeft;
	    var breakToRight$1 = breakToRight;
	    var breakPath$1 = breakPath;
	    var Parent = {
	      sharedOne: sharedOne,
	      subset: subset$1,
	      ancestors: ancestors$3,
	      breakToLeft: breakToLeft$1,
	      breakToRight: breakToRight$1,
	      breakPath: breakPath$1
	    };
	
	    var universe = DomUniverse();
	    var sharedOne$1 = function (look, elements) {
	      return Parent.sharedOne(universe, function (_universe, element) {
	        return look(element);
	      }, elements);
	    };
	    var subset$2 = function (start, finish) {
	      return Parent.subset(universe, start, finish);
	    };
	    var ancestors$4 = function (start, finish, isRoot) {
	      return Parent.ancestors(universe, start, finish, isRoot);
	    };
	    var breakToLeft$2 = function (parent, child) {
	      return Parent.breakToLeft(universe, parent, child);
	    };
	    var breakToRight$2 = function (parent, child) {
	      return Parent.breakToRight(universe, parent, child);
	    };
	    var breakPath$2 = function (child, isTop, breaker) {
	      return Parent.breakPath(universe, child, isTop, function (u, p, c) {
	        return breaker(p, c);
	      });
	    };
	    var DomParent = {
	      sharedOne: sharedOne$1,
	      subset: subset$2,
	      ancestors: ancestors$4,
	      breakToLeft: breakToLeft$2,
	      breakToRight: breakToRight$2,
	      breakPath: breakPath$2
	    };
	
	    var create = MixedBag([
	      'boxes',
	      'start',
	      'finish'
	    ], []);
	    var Identified = { create: create };
	
	    var lookupTable = function (container) {
	      return ancestor$1(container, 'table');
	    };
	    var identify = function (start, finish, isRoot) {
	      var getIsRoot = function (rootTable) {
	        return function (element) {
	          return isRoot !== undefined && isRoot(element) || eq(element, rootTable);
	        };
	      };
	      if (eq(start, finish)) {
	        return Option.some(Identified.create({
	          boxes: Option.some([start]),
	          start: start,
	          finish: finish
	        }));
	      } else {
	        return lookupTable(start).bind(function (startTable) {
	          return lookupTable(finish).bind(function (finishTable) {
	            if (eq(startTable, finishTable)) {
	              return Option.some(Identified.create({
	                boxes: TablePositions.intercepts(startTable, start, finish),
	                start: start,
	                finish: finish
	              }));
	            } else if (contains$2(startTable, finishTable)) {
	              var ancestorCells = ancestors$1(finish, 'td,th', getIsRoot(startTable));
	              var finishCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : finish;
	              return Option.some(Identified.create({
	                boxes: TablePositions.nestedIntercepts(startTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: finishCell
	              }));
	            } else if (contains$2(finishTable, startTable)) {
	              var ancestorCells = ancestors$1(start, 'td,th', getIsRoot(finishTable));
	              var startCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : start;
	              return Option.some(Identified.create({
	                boxes: TablePositions.nestedIntercepts(finishTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: startCell
	              }));
	            } else {
	              return DomParent.ancestors(start, finish).shared().bind(function (lca) {
	                return closest$1(lca, 'table', isRoot).bind(function (lcaTable) {
	                  var finishAncestorCells = ancestors$1(finish, 'td,th', getIsRoot(lcaTable));
	                  var finishCell = finishAncestorCells.length > 0 ? finishAncestorCells[finishAncestorCells.length - 1] : finish;
	                  var startAncestorCells = ancestors$1(start, 'td,th', getIsRoot(lcaTable));
	                  var startCell = startAncestorCells.length > 0 ? startAncestorCells[startAncestorCells.length - 1] : start;
	                  return Option.some(Identified.create({
	                    boxes: TablePositions.nestedIntercepts(lcaTable, start, startTable, finish, finishTable),
	                    start: startCell,
	                    finish: finishCell
	                  }));
	                });
	              });
	            }
	          });
	        });
	      }
	    };
	    var retrieve = function (container, selector) {
	      var sels = descendants$1(container, selector);
	      return sels.length > 0 ? Option.some(sels) : Option.none();
	    };
	    var getLast = function (boxes, lastSelectedSelector) {
	      return find(boxes, function (box) {
	        return is(box, lastSelectedSelector);
	      });
	    };
	    var getEdges = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return descendant$1(container, firstSelectedSelector).bind(function (first) {
	        return descendant$1(container, lastSelectedSelector).bind(function (last) {
	          return DomParent.sharedOne(lookupTable, [
	            first,
	            last
	          ]).map(function (tbl) {
	            return {
	              first: constant(first),
	              last: constant(last),
	              table: constant(tbl)
	            };
	          });
	        });
	      });
	    };
	    var expandTo = function (finish, firstSelectedSelector) {
	      return ancestor$1(finish, 'table').bind(function (table) {
	        return descendant$1(table, firstSelectedSelector).bind(function (start) {
	          return identify(start, finish).bind(function (identified) {
	            return identified.boxes().map(function (boxes) {
	              return {
	                boxes: constant(boxes),
	                start: constant(identified.start()),
	                finish: constant(identified.finish())
	              };
	            });
	          });
	        });
	      });
	    };
	    var shiftSelection = function (boxes, deltaRow, deltaColumn, firstSelectedSelector, lastSelectedSelector) {
	      return getLast(boxes, lastSelectedSelector).bind(function (last) {
	        return TablePositions.moveBy(last, deltaRow, deltaColumn).bind(function (finish) {
	          return expandTo(finish, firstSelectedSelector);
	        });
	      });
	    };
	    var CellSelection = {
	      identify: identify,
	      retrieve: retrieve,
	      shiftSelection: shiftSelection,
	      getEdges: getEdges
	    };
	
	    var retrieve$1 = function (container, selector) {
	      return CellSelection.retrieve(container, selector);
	    };
	    var retrieveBox = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return CellSelection.getEdges(container, firstSelectedSelector, lastSelectedSelector).bind(function (edges) {
	        var isRoot = function (ancestor) {
	          return eq(container, ancestor);
	        };
	        var firstAncestor = ancestor$1(edges.first(), 'thead,tfoot,tbody,table', isRoot);
	        var lastAncestor = ancestor$1(edges.last(), 'thead,tfoot,tbody,table', isRoot);
	        return firstAncestor.bind(function (fA) {
	          return lastAncestor.bind(function (lA) {
	            return eq(fA, lA) ? TablePositions.getBox(edges.table(), edges.first(), edges.last()) : Option.none();
	          });
	        });
	      });
	    };
	    var TableSelection = {
	      retrieve: retrieve$1,
	      retrieveBox: retrieveBox
	    };
	
	    var selected = 'data-mce-selected';
	    var selectedSelector = 'td[' + selected + '],th[' + selected + ']';
	    var attributeSelector = '[' + selected + ']';
	    var firstSelected = 'data-mce-first-selected';
	    var firstSelectedSelector = 'td[' + firstSelected + '],th[' + firstSelected + ']';
	    var lastSelected = 'data-mce-last-selected';
	    var lastSelectedSelector = 'td[' + lastSelected + '],th[' + lastSelected + ']';
	    var Ephemera = {
	      selected: constant(selected),
	      selectedSelector: constant(selectedSelector),
	      attributeSelector: constant(attributeSelector),
	      firstSelected: constant(firstSelected),
	      firstSelectedSelector: constant(firstSelectedSelector),
	      lastSelected: constant(lastSelected),
	      lastSelectedSelector: constant(lastSelectedSelector)
	    };
	
	    var generate$1 = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var argLength = arguments.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var args = new Array(argLength);
	          for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i];
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              if (arguments.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
	              }
	              var target = arguments[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              domGlobals.console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$1 };
	
	    var type$1 = Adt.generate([
	      { none: [] },
	      { multiple: ['elements'] },
	      { single: ['selection'] }
	    ]);
	    var cata = function (subject, onNone, onMultiple, onSingle) {
	      return subject.fold(onNone, onMultiple, onSingle);
	    };
	    var SelectionTypes = {
	      cata: cata,
	      none: type$1.none,
	      multiple: type$1.multiple,
	      single: type$1.single
	    };
	
	    var selection = function (cell, selections) {
	      return SelectionTypes.cata(selections.get(), constant([]), identity, constant([cell]));
	    };
	    var unmergable = function (cell, selections) {
	      var hasSpan = function (elem) {
	        return has(elem, 'rowspan') && parseInt(get(elem, 'rowspan'), 10) > 1 || has(elem, 'colspan') && parseInt(get(elem, 'colspan'), 10) > 1;
	      };
	      var candidates = selection(cell, selections);
	      return candidates.length > 0 && forall(candidates, hasSpan) ? Option.some(candidates) : Option.none();
	    };
	    var mergable = function (table, selections) {
	      return SelectionTypes.cata(selections.get(), Option.none, function (cells, _env) {
	        if (cells.length === 0) {
	          return Option.none();
	        }
	        return TableSelection.retrieveBox(table, Ephemera.firstSelectedSelector(), Ephemera.lastSelectedSelector()).bind(function (bounds) {
	          return cells.length > 1 ? Option.some({
	            bounds: constant(bounds),
	            cells: constant(cells)
	          }) : Option.none();
	        });
	      }, Option.none);
	    };
	    var CellOperations = {
	      mergable: mergable,
	      unmergable: unmergable,
	      selection: selection
	    };
	
	    var noMenu = function (cell) {
	      return {
	        element: constant(cell),
	        mergable: Option.none,
	        unmergable: Option.none,
	        selection: constant([cell])
	      };
	    };
	    var forMenu = function (selections, table, cell) {
	      return {
	        element: constant(cell),
	        mergable: constant(CellOperations.mergable(table, selections)),
	        unmergable: constant(CellOperations.unmergable(cell, selections)),
	        selection: constant(CellOperations.selection(cell, selections))
	      };
	    };
	    var notCell$1 = function (element) {
	      return noMenu(element);
	    };
	    var paste$1 = Immutable('element', 'clipboard', 'generators');
	    var pasteRows = function (selections, table, cell, clipboard, generators) {
	      return {
	        element: constant(cell),
	        mergable: Option.none,
	        unmergable: Option.none,
	        selection: constant(CellOperations.selection(cell, selections)),
	        clipboard: constant(clipboard),
	        generators: constant(generators)
	      };
	    };
	    var TableTargets = {
	      noMenu: noMenu,
	      forMenu: forMenu,
	      notCell: notCell$1,
	      paste: paste$1,
	      pasteRows: pasteRows
	    };
	
	    var extractSelected = function (cells) {
	      return TableLookup.table(cells[0]).map(deep).map(function (replica) {
	        return [CopySelected.extract(replica, Ephemera.attributeSelector())];
	      });
	    };
	    var serializeElements = function (editor, elements) {
	      return map(elements, function (elm) {
	        return editor.selection.serializer.serialize(elm.dom(), {});
	      }).join('');
	    };
	    var getTextContent = function (elements) {
	      return map(elements, function (element) {
	        return element.dom().innerText;
	      }).join('');
	    };
	    var registerEvents = function (editor, selections, actions, cellSelection) {
	      editor.on('BeforeGetContent', function (e) {
	        var multiCellContext = function (cells) {
	          e.preventDefault();
	          extractSelected(cells).each(function (elements) {
	            e.content = e.format === 'text' ? getTextContent(elements) : serializeElements(editor, elements);
	          });
	        };
	        if (e.selection === true) {
	          SelectionTypes.cata(selections.get(), noop, multiCellContext, noop);
	        }
	      });
	      editor.on('BeforeSetContent', function (e) {
	        if (e.selection === true && e.paste === true) {
	          var cellOpt = Option.from(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
	          cellOpt.each(function (domCell) {
	            var cell = Element.fromDom(domCell);
	            TableLookup.table(cell).each(function (table) {
	              var elements = filter(fromHtml$1(e.content), function (content) {
	                return name(content) !== 'meta';
	              });
	              if (elements.length === 1 && name(elements[0]) === 'table') {
	                e.preventDefault();
	                var doc = Element.fromDom(editor.getDoc());
	                var generators = TableFill.paste(doc);
	                var targets = TableTargets.paste(cell, elements[0], generators);
	                actions.pasteCells(table, targets).each(function (rng) {
	                  editor.selection.setRng(rng);
	                  editor.focus();
	                  cellSelection.clear(table);
	                });
	              }
	            });
	          });
	        }
	      });
	    };
	    var Clipboard = { registerEvents: registerEvents };
	
	    function Dimension (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom();
	        if (isSupported(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$1(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$1(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    }
	
	    var api$1 = Dimension('height', function (element) {
	      var dom = element.dom();
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$3 = function (element) {
	      return api$1.get(element);
	    };
	    var getOuter = function (element) {
	      return api$1.getOuter(element);
	    };
	
	    var api$2 = Dimension('width', function (element) {
	      return element.dom().offsetWidth;
	    });
	    var get$4 = function (element) {
	      return api$2.get(element);
	    };
	    var getOuter$1 = function (element) {
	      return api$2.getOuter(element);
	    };
	
	    var platform = PlatformDetection$1.detect();
	    var needManualCalc = function () {
	      return platform.browser.isIE() || platform.browser.isEdge();
	    };
	    var toNumber = function (px, fallback) {
	      var num = parseFloat(px);
	      return isNaN(num) ? fallback : num;
	    };
	    var getProp = function (elm, name, fallback) {
	      return toNumber(get$1(elm, name), fallback);
	    };
	    var getCalculatedHeight = function (cell) {
	      var paddingTop = getProp(cell, 'padding-top', 0);
	      var paddingBottom = getProp(cell, 'padding-bottom', 0);
	      var borderTop = getProp(cell, 'border-top-width', 0);
	      var borderBottom = getProp(cell, 'border-bottom-width', 0);
	      var height = cell.dom().getBoundingClientRect().height;
	      var boxSizing = get$1(cell, 'box-sizing');
	      var borders = borderTop + borderBottom;
	      return boxSizing === 'border-box' ? height : height - paddingTop - paddingBottom - borders;
	    };
	    var getWidth = function (cell) {
	      return getProp(cell, 'width', get$4(cell));
	    };
	    var getHeight = function (cell) {
	      return needManualCalc() ? getCalculatedHeight(cell) : getProp(cell, 'height', get$3(cell));
	    };
	    var RuntimeSize = {
	      getWidth: getWidth,
	      getHeight: getHeight
	    };
	
	    var genericSizeRegex = /(\d+(\.\d+)?)(\w|%)*/;
	    var percentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
	    var pixelBasedSizeRegex = /(\d+(\.\d+)?)px|em/;
	    var setPixelWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + 'px');
	    };
	    var setPercentageWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + '%');
	    };
	    var setHeight = function (cell, amount) {
	      set$1(cell, 'height', amount + 'px');
	    };
	    var getHeightValue = function (cell) {
	      return getRaw(cell, 'height').getOrThunk(function () {
	        return RuntimeSize.getHeight(cell) + 'px';
	      });
	    };
	    var convert = function (cell, number, getter, setter) {
	      var newSize = TableLookup.table(cell).map(function (table) {
	        var total = getter(table);
	        return Math.floor(number / 100 * total);
	      }).getOr(number);
	      setter(cell, newSize);
	      return newSize;
	    };
	    var normalizePixelSize = function (value, cell, getter, setter) {
	      var number = parseInt(value, 10);
	      return endsWith(value, '%') && name(cell) !== 'table' ? convert(cell, number, getter, setter) : number;
	    };
	    var getTotalHeight = function (cell) {
	      var value = getHeightValue(cell);
	      if (!value) {
	        return get$3(cell);
	      }
	      return normalizePixelSize(value, cell, get$3, setHeight);
	    };
	    var get$5 = function (cell, type, f) {
	      var v = f(cell);
	      var span = getSpan(cell, type);
	      return v / span;
	    };
	    var getSpan = function (cell, type) {
	      return has(cell, type) ? parseInt(get(cell, type), 10) : 1;
	    };
	    var getRawWidth = function (element) {
	      var cssWidth = getRaw(element, 'width');
	      return cssWidth.fold(function () {
	        return Option.from(get(element, 'width'));
	      }, function (width) {
	        return Option.some(width);
	      });
	    };
	    var normalizePercentageWidth = function (cellWidth, tableSize) {
	      return cellWidth / tableSize.pixelWidth() * 100;
	    };
	    var choosePercentageSize = function (element, width, tableSize) {
	      var percentMatch = percentageBasedSizeRegex.exec(width);
	      if (percentMatch !== null) {
	        return parseFloat(percentMatch[1]);
	      } else {
	        var intWidth = get$4(element);
	        return normalizePercentageWidth(intWidth, tableSize);
	      }
	    };
	    var getPercentageWidth = function (cell, tableSize) {
	      var width = getRawWidth(cell);
	      return width.fold(function () {
	        var intWidth = get$4(cell);
	        return normalizePercentageWidth(intWidth, tableSize);
	      }, function (w) {
	        return choosePercentageSize(cell, w, tableSize);
	      });
	    };
	    var normalizePixelWidth = function (cellWidth, tableSize) {
	      return cellWidth / 100 * tableSize.pixelWidth();
	    };
	    var choosePixelSize = function (element, width, tableSize) {
	      var pixelMatch = pixelBasedSizeRegex.exec(width);
	      if (pixelMatch !== null) {
	        return parseInt(pixelMatch[1], 10);
	      }
	      var percentMatch = percentageBasedSizeRegex.exec(width);
	      if (percentMatch !== null) {
	        var floatWidth = parseFloat(percentMatch[1]);
	        return normalizePixelWidth(floatWidth, tableSize);
	      }
	      return get$4(element);
	    };
	    var getPixelWidth = function (cell, tableSize) {
	      var width = getRawWidth(cell);
	      return width.fold(function () {
	        return get$4(cell);
	      }, function (w) {
	        return choosePixelSize(cell, w, tableSize);
	      });
	    };
	    var getHeight$1 = function (cell) {
	      return get$5(cell, 'rowspan', getTotalHeight);
	    };
	    var getGenericWidth = function (cell) {
	      var width = getRawWidth(cell);
	      return width.bind(function (w) {
	        var match = genericSizeRegex.exec(w);
	        if (match !== null) {
	          return Option.some({
	            width: constant(parseFloat(match[1])),
	            unit: constant(match[3])
	          });
	        } else {
	          return Option.none();
	        }
	      });
	    };
	    var setGenericWidth = function (cell, amount, unit) {
	      set$1(cell, 'width', amount + unit);
	    };
	    var Sizes = {
	      percentageBasedSizeRegex: constant(percentageBasedSizeRegex),
	      pixelBasedSizeRegex: constant(pixelBasedSizeRegex),
	      setPixelWidth: setPixelWidth,
	      setPercentageWidth: setPercentageWidth,
	      setHeight: setHeight,
	      getPixelWidth: getPixelWidth,
	      getPercentageWidth: getPercentageWidth,
	      getGenericWidth: getGenericWidth,
	      setGenericWidth: setGenericWidth,
	      getHeight: getHeight$1,
	      getRawWidth: getRawWidth
	    };
	
	    var halve = function (main, other) {
	      var width = Sizes.getGenericWidth(main);
	      width.each(function (w) {
	        var newWidth = w.width() / 2;
	        Sizes.setGenericWidth(main, newWidth, w.unit());
	        Sizes.setGenericWidth(other, newWidth, w.unit());
	      });
	    };
	    var CellMutations = { halve: halve };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: constant(left),
	        top: constant(top),
	        translate: translate
	      };
	    };
	    var Position = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return Position(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      return a !== undefined ? a : b !== undefined ? b : 0;
	    };
	    var absolute = function (element) {
	      var doc = element.dom().ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      var scrollTop = firstDefinedOrZero(win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom();
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return Position(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return Position(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var rowInfo = Immutable('row', 'y');
	    var colInfo = Immutable('col', 'x');
	    var rtlEdge = function (cell) {
	      var pos = absolute(cell);
	      return pos.left() + getOuter$1(cell);
	    };
	    var ltrEdge = function (cell) {
	      return absolute(cell).left();
	    };
	    var getLeftEdge = function (index, cell) {
	      return colInfo(index, ltrEdge(cell));
	    };
	    var getRightEdge = function (index, cell) {
	      return colInfo(index, rtlEdge(cell));
	    };
	    var getTop = function (cell) {
	      return absolute(cell).top();
	    };
	    var getTopEdge = function (index, cell) {
	      return rowInfo(index, getTop(cell));
	    };
	    var getBottomEdge = function (index, cell) {
	      return rowInfo(index, getTop(cell) + getOuter(cell));
	    };
	    var findPositions = function (getInnerEdge, getOuterEdge, array) {
	      if (array.length === 0) {
	        return [];
	      }
	      var lines = map(array.slice(1), function (cellOption, index) {
	        return cellOption.map(function (cell) {
	          return getInnerEdge(index, cell);
	        });
	      });
	      var lastLine = array[array.length - 1].map(function (cell) {
	        return getOuterEdge(array.length - 1, cell);
	      });
	      return lines.concat([lastLine]);
	    };
	    var negate = function (step) {
	      return -step;
	    };
	    var height = {
	      delta: identity,
	      positions: function (optElements) {
	        return findPositions(getTopEdge, getBottomEdge, optElements);
	      },
	      edge: getTop
	    };
	    var ltr = {
	      delta: identity,
	      edge: ltrEdge,
	      positions: function (optElements) {
	        return findPositions(getLeftEdge, getRightEdge, optElements);
	      }
	    };
	    var rtl = {
	      delta: negate,
	      edge: rtlEdge,
	      positions: function (optElements) {
	        return findPositions(getRightEdge, getLeftEdge, optElements);
	      }
	    };
	    var BarPositions = {
	      height: height,
	      rtl: rtl,
	      ltr: ltr
	    };
	
	    var ResizeDirection = {
	      ltr: BarPositions.ltr,
	      rtl: BarPositions.rtl
	    };
	
	    function TableDirection (directionAt) {
	      var auto = function (table) {
	        return directionAt(table).isRtl() ? ResizeDirection.rtl : ResizeDirection.ltr;
	      };
	      var delta = function (amount, table) {
	        return auto(table).delta(amount, table);
	      };
	      var positions = function (cols, table) {
	        return auto(table).positions(cols, table);
	      };
	      var edge = function (cell) {
	        return auto(cell).edge(cell);
	      };
	      return {
	        delta: delta,
	        edge: edge,
	        positions: positions
	      };
	    }
	
	    var getGridSize = function (table) {
	      var input = DetailsList.fromTable(table);
	      var warehouse = Warehouse.generate(input);
	      return warehouse.grid();
	    };
	    var TableGridSize = { getGridSize: getGridSize };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Option.none();
	    };
	
	    var setIfNot = function (element, property, value, ignore) {
	      if (value === ignore) {
	        remove(element, property);
	      } else {
	        set(element, property, value);
	      }
	    };
	    var render = function (table, grid) {
	      var newRows = [];
	      var newCells = [];
	      var renderSection = function (gridSection, sectionName) {
	        var section = child$2(table, sectionName).getOrThunk(function () {
	          var tb = Element.fromTag(sectionName, owner(table).dom());
	          append(table, tb);
	          return tb;
	        });
	        empty(section);
	        var rows = map(gridSection, function (row) {
	          if (row.isNew()) {
	            newRows.push(row.element());
	          }
	          var tr = row.element();
	          empty(tr);
	          each(row.cells(), function (cell) {
	            if (cell.isNew()) {
	              newCells.push(cell.element());
	            }
	            setIfNot(cell.element(), 'colspan', cell.colspan(), 1);
	            setIfNot(cell.element(), 'rowspan', cell.rowspan(), 1);
	            append(tr, cell.element());
	          });
	          return tr;
	        });
	        append$1(section, rows);
	      };
	      var removeSection = function (sectionName) {
	        child$2(table, sectionName).each(remove$2);
	      };
	      var renderOrRemoveSection = function (gridSection, sectionName) {
	        if (gridSection.length > 0) {
	          renderSection(gridSection, sectionName);
	        } else {
	          removeSection(sectionName);
	        }
	      };
	      var headSection = [];
	      var bodySection = [];
	      var footSection = [];
	      each(grid, function (row) {
	        switch (row.section()) {
	        case 'thead':
	          headSection.push(row);
	          break;
	        case 'tbody':
	          bodySection.push(row);
	          break;
	        case 'tfoot':
	          footSection.push(row);
	          break;
	        }
	      });
	      renderOrRemoveSection(headSection, 'thead');
	      renderOrRemoveSection(bodySection, 'tbody');
	      renderOrRemoveSection(footSection, 'tfoot');
	      return {
	        newRows: constant(newRows),
	        newCells: constant(newCells)
	      };
	    };
	    var copy$2 = function (grid) {
	      var rows = map(grid, function (row) {
	        var tr = shallow(row.element());
	        each(row.cells(), function (cell) {
	          var clonedCell = deep(cell.element());
	          setIfNot(clonedCell, 'colspan', cell.colspan(), 1);
	          setIfNot(clonedCell, 'rowspan', cell.rowspan(), 1);
	          append(tr, clonedCell);
	        });
	        return tr;
	      });
	      return rows;
	    };
	    var Redraw = {
	      render: render,
	      copy: copy$2
	    };
	
	    var read = function (element, attr) {
	      var value = get(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$3 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom().classList !== undefined;
	    };
	    var get$6 = function (element) {
	      return read(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add(element, 'class', clazz);
	    };
	    var remove$4 = function (element, clazz) {
	      return remove$3(element, 'class', clazz);
	    };
	
	    var add$2 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom().classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom().classList : get$6(element);
	      if (classList.length === 0) {
	        remove(element, 'class');
	      }
	    };
	    var remove$5 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom().classList;
	        classList.remove(clazz);
	      } else {
	        remove$4(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$1 = function (element, clazz) {
	      return supports(element) && element.dom().classList.contains(clazz);
	    };
	
	    var repeat = function (repititions, f) {
	      var r = [];
	      for (var i = 0; i < repititions; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	    var range = function (start, end) {
	      var r = [];
	      for (var i = start; i < end; i++) {
	        r.push(i);
	      }
	      return r;
	    };
	    var deduce = function (xs, index) {
	      if (index < 0 || index >= xs.length - 1) {
	        return Option.none();
	      }
	      var current = xs[index].fold(function () {
	        var rest = reverse(xs.slice(0, index));
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (c) {
	        return Option.some({
	          value: c,
	          delta: 0
	        });
	      });
	      var next = xs[index + 1].fold(function () {
	        var rest = xs.slice(index + 1);
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (n) {
	        return Option.some({
	          value: n,
	          delta: 1
	        });
	      });
	      return current.bind(function (c) {
	        return next.map(function (n) {
	          var extras = n.delta + c.delta;
	          return Math.abs(n.value - c.value) / extras;
	        });
	      });
	    };
	
	    var columns = function (warehouse) {
	      var grid = warehouse.grid();
	      var cols = range(0, grid.columns());
	      var rowsArr = range(0, grid.rows());
	      return map(cols, function (col) {
	        var getBlock = function () {
	          return bind(rowsArr, function (r) {
	            return Warehouse.getAt(warehouse, r, col).filter(function (detail) {
	              return detail.column() === col;
	            }).fold(constant([]), function (detail) {
	              return [detail];
	            });
	          });
	        };
	        var isSingle = function (detail) {
	          return detail.colspan() === 1;
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, 0, col);
	        };
	        return decide(getBlock, isSingle, getFallback);
	      });
	    };
	    var decide = function (getBlock, isSingle, getFallback) {
	      var inBlock = getBlock();
	      var singleInBlock = find(inBlock, isSingle);
	      var detailOption = singleInBlock.orThunk(function () {
	        return Option.from(inBlock[0]).orThunk(getFallback);
	      });
	      return detailOption.map(function (detail) {
	        return detail.element();
	      });
	    };
	    var rows$1 = function (warehouse) {
	      var grid = warehouse.grid();
	      var rowsArr = range(0, grid.rows());
	      var cols = range(0, grid.columns());
	      return map(rowsArr, function (row) {
	        var getBlock = function () {
	          return bind(cols, function (c) {
	            return Warehouse.getAt(warehouse, row, c).filter(function (detail) {
	              return detail.row() === row;
	            }).fold(constant([]), function (detail) {
	              return [detail];
	            });
	          });
	        };
	        var isSingle = function (detail) {
	          return detail.rowspan() === 1;
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, row, 0);
	        };
	        return decide(getBlock, isSingle, getFallback);
	      });
	    };
	    var Blocks = {
	      columns: columns,
	      rows: rows$1
	    };
	
	    var css = function (namespace) {
	      var dashNamespace = namespace.replace(/\./g, '-');
	      var resolve = function (str) {
	        return dashNamespace + '-' + str;
	      };
	      return { resolve: resolve };
	    };
	
	    var styles = css('ephox-snooker');
	    var Styles = { resolve: styles.resolve };
	
	    var col = function (column, x, y, w, h) {
	      var blocker = Element.fromTag('div');
	      setAll$1(blocker, {
	        position: 'absolute',
	        left: x - w / 2 + 'px',
	        top: y + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll(blocker, {
	        'data-column': column,
	        'role': 'presentation'
	      });
	      return blocker;
	    };
	    var row$1 = function (r, x, y, w, h) {
	      var blocker = Element.fromTag('div');
	      setAll$1(blocker, {
	        position: 'absolute',
	        left: x + 'px',
	        top: y - h / 2 + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll(blocker, {
	        'data-row': r,
	        'role': 'presentation'
	      });
	      return blocker;
	    };
	    var Bar = {
	      col: col,
	      row: row$1
	    };
	
	    var resizeBar = Styles.resolve('resizer-bar');
	    var resizeRowBar = Styles.resolve('resizer-rows');
	    var resizeColBar = Styles.resolve('resizer-cols');
	    var BAR_THICKNESS = 7;
	    var destroy = function (wire) {
	      var previous = descendants$1(wire.parent(), '.' + resizeBar);
	      each(previous, remove$2);
	    };
	    var drawBar = function (wire, positions, create) {
	      var origin = wire.origin();
	      each(positions, function (cpOption, i) {
	        cpOption.each(function (cp) {
	          var bar = create(origin, cp);
	          add$2(bar, resizeBar);
	          append(wire.parent(), bar);
	        });
	      });
	    };
	    var refreshCol = function (wire, colPositions, position, tableHeight) {
	      drawBar(wire, colPositions, function (origin, cp) {
	        var colBar = Bar.col(cp.col(), cp.x() - origin.left(), position.top() - origin.top(), BAR_THICKNESS, tableHeight);
	        add$2(colBar, resizeColBar);
	        return colBar;
	      });
	    };
	    var refreshRow = function (wire, rowPositions, position, tableWidth) {
	      drawBar(wire, rowPositions, function (origin, cp) {
	        var rowBar = Bar.row(cp.row(), position.left() - origin.left(), cp.y() - origin.top(), tableWidth, BAR_THICKNESS);
	        add$2(rowBar, resizeRowBar);
	        return rowBar;
	      });
	    };
	    var refreshGrid = function (wire, table, rows, cols, hdirection, vdirection) {
	      var position = absolute(table);
	      var rowPositions = rows.length > 0 ? hdirection.positions(rows, table) : [];
	      refreshRow(wire, rowPositions, position, getOuter$1(table));
	      var colPositions = cols.length > 0 ? vdirection.positions(cols, table) : [];
	      refreshCol(wire, colPositions, position, getOuter(table));
	    };
	    var refresh = function (wire, table, hdirection, vdirection) {
	      destroy(wire);
	      var list = DetailsList.fromTable(table);
	      var warehouse = Warehouse.generate(list);
	      var rows = Blocks.rows(warehouse);
	      var cols = Blocks.columns(warehouse);
	      refreshGrid(wire, table, rows, cols, hdirection, vdirection);
	    };
	    var each$2 = function (wire, f) {
	      var bars = descendants$1(wire.parent(), '.' + resizeBar);
	      each(bars, f);
	    };
	    var hide = function (wire) {
	      each$2(wire, function (bar) {
	        set$1(bar, 'display', 'none');
	      });
	    };
	    var show = function (wire) {
	      each$2(wire, function (bar) {
	        set$1(bar, 'display', 'block');
	      });
	    };
	    var isRowBar = function (element) {
	      return has$1(element, resizeRowBar);
	    };
	    var isColBar = function (element) {
	      return has$1(element, resizeColBar);
	    };
	    var Bars = {
	      refresh: refresh,
	      hide: hide,
	      show: show,
	      destroy: destroy,
	      isRowBar: isRowBar,
	      isColBar: isColBar
	    };
	
	    var addCell = function (gridRow, index, cell) {
	      var cells = gridRow.cells();
	      var before = cells.slice(0, index);
	      var after = cells.slice(index);
	      var newCells = before.concat([cell]).concat(after);
	      return setCells(gridRow, newCells);
	    };
	    var mutateCell = function (gridRow, index, cell) {
	      var cells = gridRow.cells();
	      cells[index] = cell;
	    };
	    var setCells = function (gridRow, cells) {
	      return rowcells(cells, gridRow.section());
	    };
	    var mapCells = function (gridRow, f) {
	      var cells = gridRow.cells();
	      var r = map(cells, f);
	      return rowcells(r, gridRow.section());
	    };
	    var getCell = function (gridRow, index) {
	      return gridRow.cells()[index];
	    };
	    var getCellElement = function (gridRow, index) {
	      return getCell(gridRow, index).element();
	    };
	    var cellLength = function (gridRow) {
	      return gridRow.cells().length;
	    };
	    var GridRow = {
	      addCell: addCell,
	      setCells: setCells,
	      mutateCell: mutateCell,
	      getCell: getCell,
	      getCellElement: getCellElement,
	      mapCells: mapCells,
	      cellLength: cellLength
	    };
	
	    var getColumn = function (grid, index) {
	      return map(grid, function (row) {
	        return GridRow.getCell(row, index);
	      });
	    };
	    var getRow = function (grid, index) {
	      return grid[index];
	    };
	    var findDiff = function (xs, comp) {
	      if (xs.length === 0) {
	        return 0;
	      }
	      var first = xs[0];
	      var index = findIndex(xs, function (x) {
	        return !comp(first.element(), x.element());
	      });
	      return index.fold(function () {
	        return xs.length;
	      }, function (ind) {
	        return ind;
	      });
	    };
	    var subgrid = function (grid, row, column, comparator) {
	      var restOfRow = getRow(grid, row).cells().slice(column);
	      var endColIndex = findDiff(restOfRow, comparator);
	      var restOfColumn = getColumn(grid, column).slice(row);
	      var endRowIndex = findDiff(restOfColumn, comparator);
	      return {
	        colspan: constant(endColIndex),
	        rowspan: constant(endRowIndex)
	      };
	    };
	    var TableGrid = { subgrid: subgrid };
	
	    var toDetails = function (grid, comparator) {
	      var seen = map(grid, function (row, ri) {
	        return map(row.cells(), function (col, ci) {
	          return false;
	        });
	      });
	      var updateSeen = function (ri, ci, rowspan, colspan) {
	        for (var r = ri; r < ri + rowspan; r++) {
	          for (var c = ci; c < ci + colspan; c++) {
	            seen[r][c] = true;
	          }
	        }
	      };
	      return map(grid, function (row, ri) {
	        var details = bind(row.cells(), function (cell, ci) {
	          if (seen[ri][ci] === false) {
	            var result = TableGrid.subgrid(grid, ri, ci, comparator);
	            updateSeen(ri, ci, result.rowspan(), result.colspan());
	            return [detailnew(cell.element(), result.rowspan(), result.colspan(), cell.isNew())];
	          } else {
	            return [];
	          }
	        });
	        return rowdetails(details, row.section());
	      });
	    };
	    var toGrid = function (warehouse, generators, isNew) {
	      var grid = [];
	      for (var i = 0; i < warehouse.grid().rows(); i++) {
	        var rowCells = [];
	        for (var j = 0; j < warehouse.grid().columns(); j++) {
	          var element = Warehouse.getAt(warehouse, i, j).map(function (item) {
	            return elementnew(item.element(), isNew);
	          }).getOrThunk(function () {
	            return elementnew(generators.gap(), true);
	          });
	          rowCells.push(element);
	        }
	        var row = rowcells(rowCells, warehouse.all()[i].section());
	        grid.push(row);
	      }
	      return grid;
	    };
	    var Transitions = {
	      toDetails: toDetails,
	      toGrid: toGrid
	    };
	
	    var fromWarehouse = function (warehouse, generators) {
	      return Transitions.toGrid(warehouse, generators, false);
	    };
	    var deriveRows = function (rendered, generators) {
	      var findRow = function (details) {
	        var rowOfCells = findMap(details, function (detail) {
	          return parent(detail.element()).map(function (row) {
	            var isNew = parent(row).isNone();
	            return elementnew(row, isNew);
	          });
	        });
	        return rowOfCells.getOrThunk(function () {
	          return elementnew(generators.row(), true);
	        });
	      };
	      return map(rendered, function (details) {
	        var row = findRow(details.details());
	        return rowdatanew(row.element(), details.details(), details.section(), row.isNew());
	      });
	    };
	    var toDetailList = function (grid, generators) {
	      var rendered = Transitions.toDetails(grid, eq);
	      return deriveRows(rendered, generators);
	    };
	    var findInWarehouse = function (warehouse, element) {
	      var all = flatten(map(warehouse.all(), function (r) {
	        return r.cells();
	      }));
	      return find(all, function (e) {
	        return eq(element, e.element());
	      });
	    };
	    var run = function (operation, extract, adjustment, postAction, genWrappers) {
	      return function (wire, table, target, generators, direction) {
	        var input = DetailsList.fromTable(table);
	        var warehouse = Warehouse.generate(input);
	        var output = extract(warehouse, target).map(function (info) {
	          var model = fromWarehouse(warehouse, generators);
	          var result = operation(model, info, eq, genWrappers(generators));
	          var grid = toDetailList(result.grid(), generators);
	          return {
	            grid: constant(grid),
	            cursor: result.cursor
	          };
	        });
	        return output.fold(function () {
	          return Option.none();
	        }, function (out) {
	          var newElements = Redraw.render(table, out.grid());
	          adjustment(table, out.grid(), direction);
	          postAction(table);
	          Bars.refresh(wire, table, BarPositions.height, direction);
	          return Option.some({
	            cursor: out.cursor,
	            newRows: newElements.newRows,
	            newCells: newElements.newCells
	          });
	        });
	      };
	    };
	    var onCell = function (warehouse, target) {
	      return TableLookup.cell(target.element()).bind(function (cell) {
	        return findInWarehouse(warehouse, cell);
	      });
	    };
	    var onPaste = function (warehouse, target) {
	      return TableLookup.cell(target.element()).bind(function (cell) {
	        return findInWarehouse(warehouse, cell).map(function (details) {
	          var value = __assign(__assign({}, details), {
	            generators: target.generators,
	            clipboard: target.clipboard
	          });
	          return value;
	        });
	      });
	    };
	    var onPasteRows = function (warehouse, target) {
	      var details = map(target.selection(), function (cell) {
	        return TableLookup.cell(cell).bind(function (lc) {
	          return findInWarehouse(warehouse, lc);
	        });
	      });
	      var cells = cat(details);
	      return cells.length > 0 ? Option.some({
	        cells: cells,
	        generators: target.generators,
	        clipboard: target.clipboard
	      }) : Option.none();
	    };
	    var onMergable = function (_warehouse, target) {
	      return target.mergable();
	    };
	    var onUnmergable = function (_warehouse, target) {
	      return target.unmergable();
	    };
	    var onCells = function (warehouse, target) {
	      var details = map(target.selection(), function (cell) {
	        return TableLookup.cell(cell).bind(function (lc) {
	          return findInWarehouse(warehouse, lc);
	        });
	      });
	      var cells = cat(details);
	      return cells.length > 0 ? Option.some(cells) : Option.none();
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (opt) {
	        return value(o);
	      };
	      var orThunk = function (f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOption = function () {
	        return Option.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOption: toOption
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOption: Option.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var measure = function (startAddress, gridA, gridB) {
	      if (startAddress.row() >= gridA.length || startAddress.column() > GridRow.cellLength(gridA[0])) {
	        return Result.error('invalid start address out of table bounds, row: ' + startAddress.row() + ', column: ' + startAddress.column());
	      }
	      var rowRemainder = gridA.slice(startAddress.row());
	      var colRemainder = rowRemainder[0].cells().slice(startAddress.column());
	      var colRequired = GridRow.cellLength(gridB[0]);
	      var rowRequired = gridB.length;
	      return Result.value({
	        rowDelta: constant(rowRemainder.length - rowRequired),
	        colDelta: constant(colRemainder.length - colRequired)
	      });
	    };
	    var measureWidth = function (gridA, gridB) {
	      var colLengthA = GridRow.cellLength(gridA[0]);
	      var colLengthB = GridRow.cellLength(gridB[0]);
	      return {
	        rowDelta: constant(0),
	        colDelta: constant(colLengthA - colLengthB)
	      };
	    };
	    var fill = function (cells, generator) {
	      return map(cells, function () {
	        return elementnew(generator.cell(), true);
	      });
	    };
	    var rowFill = function (grid, amount, generator) {
	      return grid.concat(repeat(amount, function (_row) {
	        return GridRow.setCells(grid[grid.length - 1], fill(grid[grid.length - 1].cells(), generator));
	      }));
	    };
	    var colFill = function (grid, amount, generator) {
	      return map(grid, function (row) {
	        return GridRow.setCells(row, row.cells().concat(fill(range(0, amount), generator)));
	      });
	    };
	    var tailor = function (gridA, delta, generator) {
	      var fillCols = delta.colDelta() < 0 ? colFill : identity;
	      var fillRows = delta.rowDelta() < 0 ? rowFill : identity;
	      var modifiedCols = fillCols(gridA, Math.abs(delta.colDelta()), generator);
	      var tailoredGrid = fillRows(modifiedCols, Math.abs(delta.rowDelta()), generator);
	      return tailoredGrid;
	    };
	    var Fitment = {
	      measure: measure,
	      measureWidth: measureWidth,
	      tailor: tailor
	    };
	
	    var merge = function (grid, bounds, comparator, substitution) {
	      if (grid.length === 0) {
	        return grid;
	      }
	      for (var i = bounds.startRow(); i <= bounds.finishRow(); i++) {
	        for (var j = bounds.startCol(); j <= bounds.finishCol(); j++) {
	          GridRow.mutateCell(grid[i], j, elementnew(substitution(), false));
	        }
	      }
	      return grid;
	    };
	    var unmerge = function (grid, target, comparator, substitution) {
	      var first = true;
	      for (var i = 0; i < grid.length; i++) {
	        for (var j = 0; j < GridRow.cellLength(grid[0]); j++) {
	          var current = GridRow.getCellElement(grid[i], j);
	          var isToReplace = comparator(current, target);
	          if (isToReplace === true && first === false) {
	            GridRow.mutateCell(grid[i], j, elementnew(substitution(), true));
	          } else if (isToReplace === true) {
	            first = false;
	          }
	        }
	      }
	      return grid;
	    };
	    var uniqueCells = function (row, comparator) {
	      return foldl(row, function (rest, cell) {
	        return exists(rest, function (currentCell) {
	          return comparator(currentCell.element(), cell.element());
	        }) ? rest : rest.concat([cell]);
	      }, []);
	    };
	    var splitRows = function (grid, index, comparator, substitution) {
	      if (index > 0 && index < grid.length) {
	        var rowPrevCells = grid[index - 1].cells();
	        var cells = uniqueCells(rowPrevCells, comparator);
	        each(cells, function (cell) {
	          var replacement = Option.none();
	          var _loop_1 = function (i) {
	            var _loop_2 = function (j) {
	              var current = grid[i].cells()[j];
	              var isToReplace = comparator(current.element(), cell.element());
	              if (isToReplace) {
	                if (replacement.isNone()) {
	                  replacement = Option.some(substitution());
	                }
	                replacement.each(function (sub) {
	                  GridRow.mutateCell(grid[i], j, elementnew(sub, true));
	                });
	              }
	            };
	            for (var j = 0; j < GridRow.cellLength(grid[0]); j++) {
	              _loop_2(j);
	            }
	          };
	          for (var i = index; i < grid.length; i++) {
	            _loop_1(i);
	          }
	        });
	      }
	      return grid;
	    };
	    var MergingOperations = {
	      merge: merge,
	      unmerge: unmerge,
	      splitRows: splitRows
	    };
	
	    var isSpanning = function (grid, row, col, comparator) {
	      var candidate = GridRow.getCell(grid[row], col);
	      var matching = curry(comparator, candidate.element());
	      var currentRow = grid[row];
	      return grid.length > 1 && GridRow.cellLength(currentRow) > 1 && (col > 0 && matching(GridRow.getCellElement(currentRow, col - 1)) || col < currentRow.cells().length - 1 && matching(GridRow.getCellElement(currentRow, col + 1)) || row > 0 && matching(GridRow.getCellElement(grid[row - 1], col)) || row < grid.length - 1 && matching(GridRow.getCellElement(grid[row + 1], col)));
	    };
	    var mergeTables = function (startAddress, gridA, gridB, generator, comparator) {
	      var startRow = startAddress.row();
	      var startCol = startAddress.column();
	      var mergeHeight = gridB.length;
	      var mergeWidth = GridRow.cellLength(gridB[0]);
	      var endRow = startRow + mergeHeight;
	      var endCol = startCol + mergeWidth;
	      for (var r = startRow; r < endRow; r++) {
	        for (var c = startCol; c < endCol; c++) {
	          if (isSpanning(gridA, r, c, comparator)) {
	            MergingOperations.unmerge(gridA, GridRow.getCellElement(gridA[r], c), comparator, generator.cell);
	          }
	          var newCell = GridRow.getCellElement(gridB[r - startRow], c - startCol);
	          var replacement = generator.replace(newCell);
	          GridRow.mutateCell(gridA[r], c, elementnew(replacement, true));
	        }
	      }
	      return gridA;
	    };
	    var merge$1 = function (startAddress, gridA, gridB, generator, comparator) {
	      var result = Fitment.measure(startAddress, gridA, gridB);
	      return result.map(function (delta) {
	        var fittedGrid = Fitment.tailor(gridA, delta, generator);
	        return mergeTables(startAddress, fittedGrid, gridB, generator, comparator);
	      });
	    };
	    var insert = function (index, gridA, gridB, generator, comparator) {
	      MergingOperations.splitRows(gridA, index, comparator, generator.cell);
	      var delta = Fitment.measureWidth(gridB, gridA);
	      var fittedNewGrid = Fitment.tailor(gridB, delta, generator);
	      var secondDelta = Fitment.measureWidth(gridA, fittedNewGrid);
	      var fittedOldGrid = Fitment.tailor(gridA, secondDelta, generator);
	      return fittedOldGrid.slice(0, index).concat(fittedNewGrid).concat(fittedOldGrid.slice(index, fittedOldGrid.length));
	    };
	    var TableMerge = {
	      merge: merge$1,
	      insert: insert
	    };
	
	    var insertRowAt = function (grid, index, example, comparator, substitution) {
	      var before = grid.slice(0, index);
	      var after = grid.slice(index);
	      var between = GridRow.mapCells(grid[example], function (ex, c) {
	        var withinSpan = index > 0 && index < grid.length && comparator(GridRow.getCellElement(grid[index - 1], c), GridRow.getCellElement(grid[index], c));
	        var ret = withinSpan ? GridRow.getCell(grid[index], c) : elementnew(substitution(ex.element(), comparator), true);
	        return ret;
	      });
	      return before.concat([between]).concat(after);
	    };
	    var insertColumnAt = function (grid, index, example, comparator, substitution) {
	      return map(grid, function (row) {
	        var withinSpan = index > 0 && index < GridRow.cellLength(row) && comparator(GridRow.getCellElement(row, index - 1), GridRow.getCellElement(row, index));
	        var sub = withinSpan ? GridRow.getCell(row, index) : elementnew(substitution(GridRow.getCellElement(row, example), comparator), true);
	        return GridRow.addCell(row, index, sub);
	      });
	    };
	    var splitCellIntoColumns = function (grid, exampleRow, exampleCol, comparator, substitution) {
	      var index = exampleCol + 1;
	      return map(grid, function (row, i) {
	        var isTargetCell = i === exampleRow;
	        var sub = isTargetCell ? elementnew(substitution(GridRow.getCellElement(row, exampleCol), comparator), true) : GridRow.getCell(row, exampleCol);
	        return GridRow.addCell(row, index, sub);
	      });
	    };
	    var splitCellIntoRows = function (grid, exampleRow, exampleCol, comparator, substitution) {
	      var index = exampleRow + 1;
	      var before = grid.slice(0, index);
	      var after = grid.slice(index);
	      var between = GridRow.mapCells(grid[exampleRow], function (ex, i) {
	        var isTargetCell = i === exampleCol;
	        return isTargetCell ? elementnew(substitution(ex.element(), comparator), true) : ex;
	      });
	      return before.concat([between]).concat(after);
	    };
	    var deleteColumnsAt = function (grid, start, finish) {
	      var rows = map(grid, function (row) {
	        var cells = row.cells().slice(0, start).concat(row.cells().slice(finish + 1));
	        return rowcells(cells, row.section());
	      });
	      return filter(rows, function (row) {
	        return row.cells().length > 0;
	      });
	    };
	    var deleteRowsAt = function (grid, start, finish) {
	      return grid.slice(0, start).concat(grid.slice(finish + 1));
	    };
	    var ModificationOperations = {
	      insertRowAt: insertRowAt,
	      insertColumnAt: insertColumnAt,
	      splitCellIntoColumns: splitCellIntoColumns,
	      splitCellIntoRows: splitCellIntoRows,
	      deleteRowsAt: deleteRowsAt,
	      deleteColumnsAt: deleteColumnsAt
	    };
	
	    var replaceIn = function (grid, targets, comparator, substitution) {
	      var isTarget = function (cell) {
	        return exists(targets, function (target) {
	          return comparator(cell.element(), target.element());
	        });
	      };
	      return map(grid, function (row) {
	        return GridRow.mapCells(row, function (cell) {
	          return isTarget(cell) ? elementnew(substitution(cell.element(), comparator), true) : cell;
	        });
	      });
	    };
	    var notStartRow = function (grid, rowIndex, colIndex, comparator) {
	      return GridRow.getCellElement(grid[rowIndex], colIndex) !== undefined && (rowIndex > 0 && comparator(GridRow.getCellElement(grid[rowIndex - 1], colIndex), GridRow.getCellElement(grid[rowIndex], colIndex)));
	    };
	    var notStartColumn = function (row, index, comparator) {
	      return index > 0 && comparator(GridRow.getCellElement(row, index - 1), GridRow.getCellElement(row, index));
	    };
	    var replaceColumn = function (grid, index, comparator, substitution) {
	      var targets = bind(grid, function (row, i) {
	        var alreadyAdded = notStartRow(grid, i, index, comparator) || notStartColumn(row, index, comparator);
	        return alreadyAdded ? [] : [GridRow.getCell(row, index)];
	      });
	      return replaceIn(grid, targets, comparator, substitution);
	    };
	    var replaceRow = function (grid, index, comparator, substitution) {
	      var targetRow = grid[index];
	      var targets = bind(targetRow.cells(), function (item, i) {
	        var alreadyAdded = notStartRow(grid, index, i, comparator) || notStartColumn(targetRow, i, comparator);
	        return alreadyAdded ? [] : [item];
	      });
	      return replaceIn(grid, targets, comparator, substitution);
	    };
	    var TransformOperations = {
	      replaceColumn: replaceColumn,
	      replaceRow: replaceRow
	    };
	
	    var adt = Adt.generate([
	      { none: [] },
	      { only: ['index'] },
	      {
	        left: [
	          'index',
	          'next'
	        ]
	      },
	      {
	        middle: [
	          'prev',
	          'index',
	          'next'
	        ]
	      },
	      {
	        right: [
	          'prev',
	          'index'
	        ]
	      }
	    ]);
	    var ColumnContext = __assign({}, adt);
	
	    var neighbours$1 = function (input, index) {
	      if (input.length === 0) {
	        return ColumnContext.none();
	      }
	      if (input.length === 1) {
	        return ColumnContext.only(0);
	      }
	      if (index === 0) {
	        return ColumnContext.left(0, 1);
	      }
	      if (index === input.length - 1) {
	        return ColumnContext.right(index - 1, index);
	      }
	      if (index > 0 && index < input.length - 1) {
	        return ColumnContext.middle(index - 1, index, index + 1);
	      }
	      return ColumnContext.none();
	    };
	    var determine = function (input, column, step, tableSize) {
	      var result = input.slice(0);
	      var context = neighbours$1(input, column);
	      var zero = function (array) {
	        return map(array, constant(0));
	      };
	      var onNone = constant(zero(result));
	      var onOnly = function (index) {
	        return tableSize.singleColumnWidth(result[index], step);
	      };
	      var onChange = function (index, next) {
	        if (step >= 0) {
	          var newNext = Math.max(tableSize.minCellWidth(), result[next] - step);
	          return zero(result.slice(0, index)).concat([
	            step,
	            newNext - result[next]
	          ]).concat(zero(result.slice(next + 1)));
	        } else {
	          var newThis = Math.max(tableSize.minCellWidth(), result[index] + step);
	          var diffx = result[index] - newThis;
	          return zero(result.slice(0, index)).concat([
	            newThis - result[index],
	            diffx
	          ]).concat(zero(result.slice(next + 1)));
	        }
	      };
	      var onLeft = onChange;
	      var onMiddle = function (_prev, index, next) {
	        return onChange(index, next);
	      };
	      var onRight = function (_prev, index) {
	        if (step >= 0) {
	          return zero(result.slice(0, index)).concat([step]);
	        } else {
	          var size = Math.max(tableSize.minCellWidth(), result[index] + step);
	          return zero(result.slice(0, index)).concat([size - result[index]]);
	        }
	      };
	      return context.fold(onNone, onOnly, onLeft, onMiddle, onRight);
	    };
	    var Deltas = { determine: determine };
	
	    var getSpan$1 = function (cell, type) {
	      return has(cell, type) && parseInt(get(cell, type), 10) > 1;
	    };
	    var hasColspan = function (cell) {
	      return getSpan$1(cell, 'colspan');
	    };
	    var hasRowspan = function (cell) {
	      return getSpan$1(cell, 'rowspan');
	    };
	    var getInt = function (element, property) {
	      return parseInt(get$1(element, property), 10);
	    };
	    var CellUtils = {
	      hasColspan: hasColspan,
	      hasRowspan: hasRowspan,
	      minWidth: constant(10),
	      minHeight: constant(10),
	      getInt: getInt
	    };
	
	    var getRaw$1 = function (cell, property, getter) {
	      return getRaw(cell, property).fold(function () {
	        return getter(cell) + 'px';
	      }, function (raw) {
	        return raw;
	      });
	    };
	    var getRawW = function (cell, tableSize) {
	      return getRaw$1(cell, 'width', function (e) {
	        return Sizes.getPixelWidth(e, tableSize);
	      });
	    };
	    var getRawH = function (cell) {
	      return getRaw$1(cell, 'height', Sizes.getHeight);
	    };
	    var getWidthFrom = function (warehouse, direction, getWidth, fallback, tableSize) {
	      var columns = Blocks.columns(warehouse);
	      var backups = map(columns, function (cellOption) {
	        return cellOption.map(direction.edge);
	      });
	      return map(columns, function (cellOption, c) {
	        var columnCell = cellOption.filter(not(CellUtils.hasColspan));
	        return columnCell.fold(function () {
	          var deduced = deduce(backups, c);
	          return fallback(deduced);
	        }, function (cell) {
	          return getWidth(cell, tableSize);
	        });
	      });
	    };
	    var getDeduced = function (deduced) {
	      return deduced.map(function (d) {
	        return d + 'px';
	      }).getOr('');
	    };
	    var getRawWidths = function (warehouse, direction, tableSize) {
	      return getWidthFrom(warehouse, direction, getRawW, getDeduced, tableSize);
	    };
	    var getPercentageWidths = function (warehouse, direction, tableSize) {
	      return getWidthFrom(warehouse, direction, Sizes.getPercentageWidth, function (deduced) {
	        return deduced.fold(function () {
	          return tableSize.minCellWidth();
	        }, function (cellWidth) {
	          return cellWidth / tableSize.pixelWidth() * 100;
	        });
	      }, tableSize);
	    };
	    var getPixelWidths = function (warehouse, direction, tableSize) {
	      return getWidthFrom(warehouse, direction, Sizes.getPixelWidth, function (deduced) {
	        return deduced.getOrThunk(tableSize.minCellWidth);
	      }, tableSize);
	    };
	    var getHeightFrom = function (warehouse, direction, getHeight, fallback) {
	      var rows = Blocks.rows(warehouse);
	      var backups = map(rows, function (cellOption) {
	        return cellOption.map(direction.edge);
	      });
	      return map(rows, function (cellOption, c) {
	        var rowCell = cellOption.filter(not(CellUtils.hasRowspan));
	        return rowCell.fold(function () {
	          var deduced = deduce(backups, c);
	          return fallback(deduced);
	        }, function (cell) {
	          return getHeight(cell);
	        });
	      });
	    };
	    var getPixelHeights = function (warehouse, direction) {
	      return getHeightFrom(warehouse, direction, Sizes.getHeight, function (deduced) {
	        return deduced.getOrThunk(CellUtils.minHeight);
	      });
	    };
	    var getRawHeights = function (warehouse, direction) {
	      return getHeightFrom(warehouse, direction, getRawH, getDeduced);
	    };
	    var ColumnSizes = {
	      getRawWidths: getRawWidths,
	      getPixelWidths: getPixelWidths,
	      getPercentageWidths: getPercentageWidths,
	      getPixelHeights: getPixelHeights,
	      getRawHeights: getRawHeights
	    };
	
	    var total = function (start, end, measures) {
	      var r = 0;
	      for (var i = start; i < end; i++) {
	        r += measures[i] !== undefined ? measures[i] : 0;
	      }
	      return r;
	    };
	    var recalculateWidth = function (warehouse, widths) {
	      var all = Warehouse.justCells(warehouse);
	      return map(all, function (cell) {
	        var width = total(cell.column(), cell.column() + cell.colspan(), widths);
	        return {
	          element: cell.element,
	          width: constant(width),
	          colspan: cell.colspan
	        };
	      });
	    };
	    var recalculateHeight = function (warehouse, heights) {
	      var all = Warehouse.justCells(warehouse);
	      return map(all, function (cell) {
	        var height = total(cell.row(), cell.row() + cell.rowspan(), heights);
	        return {
	          element: cell.element,
	          height: constant(height),
	          rowspan: cell.rowspan
	        };
	      });
	    };
	    var matchRowHeight = function (warehouse, heights) {
	      return map(warehouse.all(), function (row, i) {
	        return {
	          element: row.element,
	          height: constant(heights[i])
	        };
	      });
	    };
	    var Recalculations = {
	      recalculateWidth: recalculateWidth,
	      recalculateHeight: recalculateHeight,
	      matchRowHeight: matchRowHeight
	    };
	
	    var percentageSize = function (width, element) {
	      var floatWidth = parseFloat(width);
	      var pixelWidth = get$4(element);
	      var getCellDelta = function (delta) {
	        return delta / pixelWidth * 100;
	      };
	      var singleColumnWidth = function (w, _delta) {
	        return [100 - w];
	      };
	      var minCellWidth = function () {
	        return CellUtils.minWidth() / pixelWidth * 100;
	      };
	      var setTableWidth = function (table, _newWidths, delta) {
	        var ratio = delta / 100;
	        var change = ratio * floatWidth;
	        Sizes.setPercentageWidth(table, floatWidth + change);
	      };
	      return {
	        width: constant(floatWidth),
	        pixelWidth: constant(pixelWidth),
	        getWidths: ColumnSizes.getPercentageWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: minCellWidth,
	        setElementWidth: Sizes.setPercentageWidth,
	        setTableWidth: setTableWidth
	      };
	    };
	    var pixelSize = function (width) {
	      var getCellDelta = identity;
	      var singleColumnWidth = function (w, delta) {
	        var newNext = Math.max(CellUtils.minWidth(), w + delta);
	        return [newNext - w];
	      };
	      var setTableWidth = function (table, newWidths, _delta) {
	        var total = foldr(newWidths, function (b, a) {
	          return b + a;
	        }, 0);
	        Sizes.setPixelWidth(table, total);
	      };
	      return {
	        width: constant(width),
	        pixelWidth: constant(width),
	        getWidths: ColumnSizes.getPixelWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: CellUtils.minWidth,
	        setElementWidth: Sizes.setPixelWidth,
	        setTableWidth: setTableWidth
	      };
	    };
	    var chooseSize = function (element, width) {
	      var percentMatch = Sizes.percentageBasedSizeRegex().exec(width);
	      if (percentMatch !== null) {
	        return percentageSize(percentMatch[1], element);
	      }
	      var pixelMatch = Sizes.pixelBasedSizeRegex().exec(width);
	      if (pixelMatch !== null) {
	        var intWidth = parseInt(pixelMatch[1], 10);
	        return pixelSize(intWidth);
	      }
	      var fallbackWidth = get$4(element);
	      return pixelSize(fallbackWidth);
	    };
	    var getTableSize = function (element) {
	      var width = Sizes.getRawWidth(element);
	      return width.fold(function () {
	        var fallbackWidth = get$4(element);
	        return pixelSize(fallbackWidth);
	      }, function (w) {
	        return chooseSize(element, w);
	      });
	    };
	    var TableSize = { getTableSize: getTableSize };
	
	    var getWarehouse$1 = function (list) {
	      return Warehouse.generate(list);
	    };
	    var sumUp = function (newSize) {
	      return foldr(newSize, function (b, a) {
	        return b + a;
	      }, 0);
	    };
	    var getTableWarehouse = function (table) {
	      var list = DetailsList.fromTable(table);
	      return getWarehouse$1(list);
	    };
	    var adjustWidth = function (table, delta, index, direction) {
	      var tableSize = TableSize.getTableSize(table);
	      var step = tableSize.getCellDelta(delta);
	      var warehouse = getTableWarehouse(table);
	      var widths = tableSize.getWidths(warehouse, direction, tableSize);
	      var deltas = Deltas.determine(widths, index, step, tableSize);
	      var newWidths = map(deltas, function (dx, i) {
	        return dx + widths[i];
	      });
	      var newSizes = Recalculations.recalculateWidth(warehouse, newWidths);
	      each(newSizes, function (cell) {
	        tableSize.setElementWidth(cell.element(), cell.width());
	      });
	      if (index === warehouse.grid().columns() - 1) {
	        tableSize.setTableWidth(table, newWidths, step);
	      }
	    };
	    var adjustHeight = function (table, delta, index, direction) {
	      var warehouse = getTableWarehouse(table);
	      var heights = ColumnSizes.getPixelHeights(warehouse, direction);
	      var newHeights = map(heights, function (dy, i) {
	        return index === i ? Math.max(delta + dy, CellUtils.minHeight()) : dy;
	      });
	      var newCellSizes = Recalculations.recalculateHeight(warehouse, newHeights);
	      var newRowSizes = Recalculations.matchRowHeight(warehouse, newHeights);
	      each(newRowSizes, function (row) {
	        Sizes.setHeight(row.element(), row.height());
	      });
	      each(newCellSizes, function (cell) {
	        Sizes.setHeight(cell.element(), cell.height());
	      });
	      var total = sumUp(newHeights);
	      Sizes.setHeight(table, total);
	    };
	    var adjustWidthTo = function (table, list, direction) {
	      var tableSize = TableSize.getTableSize(table);
	      var warehouse = getWarehouse$1(list);
	      var widths = tableSize.getWidths(warehouse, direction, tableSize);
	      var newSizes = Recalculations.recalculateWidth(warehouse, widths);
	      each(newSizes, function (cell) {
	        tableSize.setElementWidth(cell.element(), cell.width());
	      });
	      if (newSizes.length > 0) {
	        tableSize.setTableWidth(table, widths, tableSize.getCellDelta(0));
	      }
	    };
	    var Adjustments = {
	      adjustWidth: adjustWidth,
	      adjustHeight: adjustHeight,
	      adjustWidthTo: adjustWidthTo
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var base = function (handleUnsupported, required) {
	      return baseWith(handleUnsupported, required, {
	        validate: isFunction,
	        label: 'function'
	      });
	    };
	    var baseWith = function (handleUnsupported, required, pred) {
	      if (required.length === 0) {
	        throw new Error('You must specify at least one required field.');
	      }
	      validateStrArr('required', required);
	      checkDupes(required);
	      return function (obj) {
	        var keys$1 = keys(obj);
	        var allReqd = forall(required, function (req) {
	          return contains(keys$1, req);
	        });
	        if (!allReqd) {
	          reqMessage(required, keys$1);
	        }
	        handleUnsupported(required, keys$1);
	        var invalidKeys = filter(required, function (key) {
	          return !pred.validate(obj[key], key);
	        });
	        if (invalidKeys.length > 0) {
	          invalidTypeMessage(invalidKeys, pred.label);
	        }
	        return obj;
	      };
	    };
	    var handleExact = function (required, keys) {
	      var unsupported = filter(keys, function (key) {
	        return !contains(required, key);
	      });
	      if (unsupported.length > 0) {
	        unsuppMessage(unsupported);
	      }
	    };
	    var exactly = function (required) {
	      return base(handleExact, required);
	    };
	
	    var verifyGenerators = exactly([
	      'cell',
	      'row',
	      'replace',
	      'gap'
	    ]);
	    var elementToData = function (element) {
	      var colspan = has(element, 'colspan') ? parseInt(get(element, 'colspan'), 10) : 1;
	      var rowspan = has(element, 'rowspan') ? parseInt(get(element, 'rowspan'), 10) : 1;
	      return {
	        element: constant(element),
	        colspan: constant(colspan),
	        rowspan: constant(rowspan)
	      };
	    };
	    var modification = function (generators, toData) {
	      if (toData === void 0) {
	        toData = elementToData;
	      }
	      verifyGenerators(generators);
	      var position = Cell(Option.none());
	      var nu = function (data) {
	        return generators.cell(data);
	      };
	      var nuFrom = function (element) {
	        var data = toData(element);
	        return nu(data);
	      };
	      var add = function (element) {
	        var replacement = nuFrom(element);
	        if (position.get().isNone()) {
	          position.set(Option.some(replacement));
	        }
	        recent = Option.some({
	          item: element,
	          replacement: replacement
	        });
	        return replacement;
	      };
	      var recent = Option.none();
	      var getOrInit = function (element, comparator) {
	        return recent.fold(function () {
	          return add(element);
	        }, function (p) {
	          return comparator(element, p.item) ? p.replacement : add(element);
	        });
	      };
	      return {
	        getOrInit: getOrInit,
	        cursor: position.get
	      };
	    };
	    var transform = function (scope, tag) {
	      return function (generators) {
	        var position = Cell(Option.none());
	        verifyGenerators(generators);
	        var list = [];
	        var find$1 = function (element, comparator) {
	          return find(list, function (x) {
	            return comparator(x.item, element);
	          });
	        };
	        var makeNew = function (element) {
	          var attrs = { scope: scope };
	          var cell = generators.replace(element, tag, attrs);
	          list.push({
	            item: element,
	            sub: cell
	          });
	          if (position.get().isNone()) {
	            position.set(Option.some(cell));
	          }
	          return cell;
	        };
	        var replaceOrInit = function (element, comparator) {
	          return find$1(element, comparator).fold(function () {
	            return makeNew(element);
	          }, function (p) {
	            return comparator(element, p.item) ? p.sub : makeNew(element);
	          });
	        };
	        return {
	          replaceOrInit: replaceOrInit,
	          cursor: position.get
	        };
	      };
	    };
	    var merging = function (generators) {
	      verifyGenerators(generators);
	      var position = Cell(Option.none());
	      var combine = function (cell) {
	        if (position.get().isNone()) {
	          position.set(Option.some(cell));
	        }
	        return function () {
	          var raw = generators.cell({
	            element: constant(cell),
	            colspan: constant(1),
	            rowspan: constant(1)
	          });
	          remove$1(raw, 'width');
	          remove$1(cell, 'width');
	          return raw;
	        };
	      };
	      return {
	        combine: combine,
	        cursor: position.get
	      };
	    };
	    var Generators = {
	      modification: modification,
	      transform: transform,
	      merging: merging
	    };
	
	    var blockList = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'table',
	      'thead',
	      'tfoot',
	      'tbody',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	    var isList = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains([
	        'ol',
	        'ul'
	      ], tagName);
	    };
	    var isBlock = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains(blockList, tagName);
	    };
	    var isFormatting = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains([
	        'address',
	        'pre',
	        'p',
	        'h1',
	        'h2',
	        'h3',
	        'h4',
	        'h5',
	        'h6'
	      ], tagName);
	    };
	    var isHeading = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains([
	        'h1',
	        'h2',
	        'h3',
	        'h4',
	        'h5',
	        'h6'
	      ], tagName);
	    };
	    var isContainer = function (universe, item) {
	      return contains([
	        'div',
	        'li',
	        'td',
	        'th',
	        'blockquote',
	        'body',
	        'caption'
	      ], universe.property().name(item));
	    };
	    var isEmptyTag = function (universe, item) {
	      return contains([
	        'br',
	        'img',
	        'hr',
	        'input'
	      ], universe.property().name(item));
	    };
	    var isFrame = function (universe, item) {
	      return universe.property().name(item) === 'iframe';
	    };
	    var isInline = function (universe, item) {
	      return !(isBlock(universe, item) || isEmptyTag(universe, item)) && universe.property().name(item) !== 'li';
	    };
	    var Structure = {
	      isBlock: isBlock,
	      isList: isList,
	      isFormatting: isFormatting,
	      isHeading: isHeading,
	      isContainer: isContainer,
	      isEmptyTag: isEmptyTag,
	      isFrame: isFrame,
	      isInline: isInline
	    };
	
	    var universe$1 = DomUniverse();
	    var isBlock$1 = function (element) {
	      return Structure.isBlock(universe$1, element);
	    };
	    var isList$1 = function (element) {
	      return Structure.isList(universe$1, element);
	    };
	    var isFormatting$1 = function (element) {
	      return Structure.isFormatting(universe$1, element);
	    };
	    var isHeading$1 = function (element) {
	      return Structure.isHeading(universe$1, element);
	    };
	    var isContainer$1 = function (element) {
	      return Structure.isContainer(universe$1, element);
	    };
	    var isEmptyTag$1 = function (element) {
	      return Structure.isEmptyTag(universe$1, element);
	    };
	    var isFrame$1 = function (element) {
	      return Structure.isFrame(universe$1, element);
	    };
	    var isInline$1 = function (element) {
	      return Structure.isInline(universe$1, element);
	    };
	    var DomStructure = {
	      isBlock: isBlock$1,
	      isList: isList$1,
	      isFormatting: isFormatting$1,
	      isHeading: isHeading$1,
	      isContainer: isContainer$1,
	      isEmptyTag: isEmptyTag$1,
	      isFrame: isFrame$1,
	      isInline: isInline$1
	    };
	
	    var merge$2 = function (cells) {
	      var isBr = function (el) {
	        return name(el) === 'br';
	      };
	      var advancedBr = function (children) {
	        return forall(children, function (c) {
	          return isBr(c) || isText(c) && get$2(c).trim().length === 0;
	        });
	      };
	      var isListItem = function (el) {
	        return name(el) === 'li' || ancestor(el, DomStructure.isList).isSome();
	      };
	      var siblingIsBlock = function (el) {
	        return nextSibling(el).map(function (rightSibling) {
	          if (DomStructure.isBlock(rightSibling)) {
	            return true;
	          }
	          if (DomStructure.isEmptyTag(rightSibling)) {
	            return name(rightSibling) === 'img' ? false : true;
	          }
	          return false;
	        }).getOr(false);
	      };
	      var markCell = function (cell) {
	        return last$1(cell).bind(function (rightEdge) {
	          var rightSiblingIsBlock = siblingIsBlock(rightEdge);
	          return parent(rightEdge).map(function (parent) {
	            return rightSiblingIsBlock === true || isListItem(parent) || isBr(rightEdge) || DomStructure.isBlock(parent) && !eq(cell, parent) ? [] : [Element.fromTag('br')];
	          });
	        }).getOr([]);
	      };
	      var markContent = function () {
	        var content = bind(cells, function (cell) {
	          var children$1 = children(cell);
	          return advancedBr(children$1) ? [] : children$1.concat(markCell(cell));
	        });
	        return content.length === 0 ? [Element.fromTag('br')] : content;
	      };
	      var contents = markContent();
	      empty(cells[0]);
	      append$1(cells[0], contents);
	    };
	    var TableContent = { merge: merge$2 };
	
	    var prune = function (table) {
	      var cells = TableLookup.cells(table);
	      if (cells.length === 0) {
	        remove$2(table);
	      }
	    };
	    var outcome = Immutable('grid', 'cursor');
	    var elementFromGrid = function (grid, row, column) {
	      return findIn(grid, row, column).orThunk(function () {
	        return findIn(grid, 0, 0);
	      });
	    };
	    var findIn = function (grid, row, column) {
	      return Option.from(grid[row]).bind(function (r) {
	        return Option.from(r.cells()[column]).bind(function (c) {
	          return Option.from(c.element());
	        });
	      });
	    };
	    var bundle = function (grid, row, column) {
	      return outcome(grid, findIn(grid, row, column));
	    };
	    var uniqueRows = function (details) {
	      return foldl(details, function (rest, detail) {
	        return exists(rest, function (currentDetail) {
	          return currentDetail.row() === detail.row();
	        }) ? rest : rest.concat([detail]);
	      }, []).sort(function (detailA, detailB) {
	        return detailA.row() - detailB.row();
	      });
	    };
	    var uniqueColumns = function (details) {
	      return foldl(details, function (rest, detail) {
	        return exists(rest, function (currentDetail) {
	          return currentDetail.column() === detail.column();
	        }) ? rest : rest.concat([detail]);
	      }, []).sort(function (detailA, detailB) {
	        return detailA.column() - detailB.column();
	      });
	    };
	    var insertRowBefore = function (grid, detail, comparator, genWrappers) {
	      var example = detail.row();
	      var targetIndex = detail.row();
	      var newGrid = ModificationOperations.insertRowAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
	      return bundle(newGrid, targetIndex, detail.column());
	    };
	    var insertRowsBefore = function (grid, details, comparator, genWrappers) {
	      var example = details[0].row();
	      var targetIndex = details[0].row();
	      var rows = uniqueRows(details);
	      var newGrid = foldl(rows, function (newG, _row) {
	        return ModificationOperations.insertRowAt(newG, targetIndex, example, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, targetIndex, details[0].column());
	    };
	    var insertRowAfter = function (grid, detail, comparator, genWrappers) {
	      var example = detail.row();
	      var targetIndex = detail.row() + detail.rowspan();
	      var newGrid = ModificationOperations.insertRowAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
	      return bundle(newGrid, targetIndex, detail.column());
	    };
	    var insertRowsAfter = function (grid, details, comparator, genWrappers) {
	      var rows = uniqueRows(details);
	      var example = rows[rows.length - 1].row();
	      var targetIndex = rows[rows.length - 1].row() + rows[rows.length - 1].rowspan();
	      var newGrid = foldl(rows, function (newG, _row) {
	        return ModificationOperations.insertRowAt(newG, targetIndex, example, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, targetIndex, details[0].column());
	    };
	    var insertColumnBefore = function (grid, detail, comparator, genWrappers) {
	      var example = detail.column();
	      var targetIndex = detail.column();
	      var newGrid = ModificationOperations.insertColumnAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
	      return bundle(newGrid, detail.row(), targetIndex);
	    };
	    var insertColumnsBefore = function (grid, details, comparator, genWrappers) {
	      var columns = uniqueColumns(details);
	      var example = columns[0].column();
	      var targetIndex = columns[0].column();
	      var newGrid = foldl(columns, function (newG, _row) {
	        return ModificationOperations.insertColumnAt(newG, targetIndex, example, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, details[0].row(), targetIndex);
	    };
	    var insertColumnAfter = function (grid, detail, comparator, genWrappers) {
	      var example = detail.column();
	      var targetIndex = detail.column() + detail.colspan();
	      var newGrid = ModificationOperations.insertColumnAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
	      return bundle(newGrid, detail.row(), targetIndex);
	    };
	    var insertColumnsAfter = function (grid, details, comparator, genWrappers) {
	      var example = details[details.length - 1].column();
	      var targetIndex = details[details.length - 1].column() + details[details.length - 1].colspan();
	      var columns = uniqueColumns(details);
	      var newGrid = foldl(columns, function (newG, _row) {
	        return ModificationOperations.insertColumnAt(newG, targetIndex, example, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, details[0].row(), targetIndex);
	    };
	    var makeRowHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = TransformOperations.replaceRow(grid, detail.row(), comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var makeColumnHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = TransformOperations.replaceColumn(grid, detail.column(), comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var unmakeRowHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = TransformOperations.replaceRow(grid, detail.row(), comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var unmakeColumnHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = TransformOperations.replaceColumn(grid, detail.column(), comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var splitCellIntoColumns$1 = function (grid, detail, comparator, genWrappers) {
	      var newGrid = ModificationOperations.splitCellIntoColumns(grid, detail.row(), detail.column(), comparator, genWrappers.getOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var splitCellIntoRows$1 = function (grid, detail, comparator, genWrappers) {
	      var newGrid = ModificationOperations.splitCellIntoRows(grid, detail.row(), detail.column(), comparator, genWrappers.getOrInit);
	      return bundle(newGrid, detail.row(), detail.column());
	    };
	    var eraseColumns = function (grid, details, _comparator, _genWrappers) {
	      var columns = uniqueColumns(details);
	      var newGrid = ModificationOperations.deleteColumnsAt(grid, columns[0].column(), columns[columns.length - 1].column());
	      var cursor = elementFromGrid(newGrid, details[0].row(), details[0].column());
	      return outcome(newGrid, cursor);
	    };
	    var eraseRows = function (grid, details, _comparator, _genWrappers) {
	      var rows = uniqueRows(details);
	      var newGrid = ModificationOperations.deleteRowsAt(grid, rows[0].row(), rows[rows.length - 1].row());
	      var cursor = elementFromGrid(newGrid, details[0].row(), details[0].column());
	      return outcome(newGrid, cursor);
	    };
	    var mergeCells = function (grid, mergable, comparator, _genWrappers) {
	      var cells = mergable.cells();
	      TableContent.merge(cells);
	      var newGrid = MergingOperations.merge(grid, mergable.bounds(), comparator, constant(cells[0]));
	      return outcome(newGrid, Option.from(cells[0]));
	    };
	    var unmergeCells = function (grid, unmergable, comparator, genWrappers) {
	      var newGrid = foldr(unmergable, function (b, cell) {
	        return MergingOperations.unmerge(b, cell, comparator, genWrappers.combine(cell));
	      }, grid);
	      return outcome(newGrid, Option.from(unmergable[0]));
	    };
	    var pasteCells = function (grid, pasteDetails, comparator, _genWrappers) {
	      var gridify = function (table, generators) {
	        var list = DetailsList.fromTable(table);
	        var wh = Warehouse.generate(list);
	        return Transitions.toGrid(wh, generators, true);
	      };
	      var gridB = gridify(pasteDetails.clipboard(), pasteDetails.generators());
	      var startAddress = address(pasteDetails.row(), pasteDetails.column());
	      var mergedGrid = TableMerge.merge(startAddress, grid, gridB, pasteDetails.generators(), comparator);
	      return mergedGrid.fold(function () {
	        return outcome(grid, Option.some(pasteDetails.element()));
	      }, function (nuGrid) {
	        var cursor = elementFromGrid(nuGrid, pasteDetails.row(), pasteDetails.column());
	        return outcome(nuGrid, cursor);
	      });
	    };
	    var gridifyRows = function (rows, generators, example) {
	      var pasteDetails = DetailsList.fromPastedRows(rows, example);
	      var wh = Warehouse.generate(pasteDetails);
	      return Transitions.toGrid(wh, generators, true);
	    };
	    var pasteRowsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
	      var example = grid[pasteDetails.cells[0].row()];
	      var index = pasteDetails.cells[0].row();
	      var gridB = gridifyRows(pasteDetails.clipboard(), pasteDetails.generators(), example);
	      var mergedGrid = TableMerge.insert(index, grid, gridB, pasteDetails.generators(), comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row(), pasteDetails.cells[0].column());
	      return outcome(mergedGrid, cursor);
	    };
	    var pasteRowsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
	      var example = grid[pasteDetails.cells[0].row()];
	      var index = pasteDetails.cells[pasteDetails.cells.length - 1].row() + pasteDetails.cells[pasteDetails.cells.length - 1].rowspan();
	      var gridB = gridifyRows(pasteDetails.clipboard(), pasteDetails.generators(), example);
	      var mergedGrid = TableMerge.insert(index, grid, gridB, pasteDetails.generators(), comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row(), pasteDetails.cells[0].column());
	      return outcome(mergedGrid, cursor);
	    };
	    var resize = Adjustments.adjustWidthTo;
	    var TableOperations = {
	      insertRowBefore: run(insertRowBefore, onCell, noop, noop, Generators.modification),
	      insertRowsBefore: run(insertRowsBefore, onCells, noop, noop, Generators.modification),
	      insertRowAfter: run(insertRowAfter, onCell, noop, noop, Generators.modification),
	      insertRowsAfter: run(insertRowsAfter, onCells, noop, noop, Generators.modification),
	      insertColumnBefore: run(insertColumnBefore, onCell, resize, noop, Generators.modification),
	      insertColumnsBefore: run(insertColumnsBefore, onCells, resize, noop, Generators.modification),
	      insertColumnAfter: run(insertColumnAfter, onCell, resize, noop, Generators.modification),
	      insertColumnsAfter: run(insertColumnsAfter, onCells, resize, noop, Generators.modification),
	      splitCellIntoColumns: run(splitCellIntoColumns$1, onCell, resize, noop, Generators.modification),
	      splitCellIntoRows: run(splitCellIntoRows$1, onCell, noop, noop, Generators.modification),
	      eraseColumns: run(eraseColumns, onCells, resize, prune, Generators.modification),
	      eraseRows: run(eraseRows, onCells, noop, prune, Generators.modification),
	      makeColumnHeader: run(makeColumnHeader, onCell, noop, noop, Generators.transform('row', 'th')),
	      unmakeColumnHeader: run(unmakeColumnHeader, onCell, noop, noop, Generators.transform(null, 'td')),
	      makeRowHeader: run(makeRowHeader, onCell, noop, noop, Generators.transform('col', 'th')),
	      unmakeRowHeader: run(unmakeRowHeader, onCell, noop, noop, Generators.transform(null, 'td')),
	      mergeCells: run(mergeCells, onMergable, noop, noop, Generators.merging),
	      unmergeCells: run(unmergeCells, onUnmergable, resize, noop, Generators.merging),
	      pasteCells: run(pasteCells, onPaste, resize, noop, Generators.modification),
	      pasteRowsBefore: run(pasteRowsBefore, onPasteRows, noop, noop, Generators.modification),
	      pasteRowsAfter: run(pasteRowsAfter, onPasteRows, noop, noop, Generators.modification)
	    };
	
	    var getBody$1 = function (editor) {
	      return Element.fromDom(editor.getBody());
	    };
	    var getPixelWidth$1 = function (elm) {
	      return elm.getBoundingClientRect().width;
	    };
	    var getPixelHeight = function (elm) {
	      return elm.getBoundingClientRect().height;
	    };
	    var getIsRoot = function (editor) {
	      return function (element) {
	        return eq(element, getBody$1(editor));
	      };
	    };
	    var removePxSuffix = function (size) {
	      return size ? size.replace(/px$/, '') : '';
	    };
	    var addSizeSuffix = function (size) {
	      if (/^[0-9]+$/.test(size)) {
	        size += 'px';
	      }
	      return size;
	    };
	    var removeDataStyle = function (table) {
	      var dataStyleCells = descendants$1(table, 'td[data-mce-style],th[data-mce-style]');
	      remove(table, 'data-mce-style');
	      each(dataStyleCells, function (cell) {
	        remove(cell, 'data-mce-style');
	      });
	    };
	
	    var getDirection = function (element) {
	      return get$1(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
	    };
	
	    var ltr$1 = { isRtl: constant(false) };
	    var rtl$1 = { isRtl: constant(true) };
	    var directionAt = function (element) {
	      var dir = getDirection(element);
	      return dir === 'rtl' ? rtl$1 : ltr$1;
	    };
	    var Direction = { directionAt: directionAt };
	
	    var defaultTableToolbar = [
	      'tableprops',
	      'tabledelete',
	      '|',
	      'tableinsertrowbefore',
	      'tableinsertrowafter',
	      'tabledeleterow',
	      '|',
	      'tableinsertcolbefore',
	      'tableinsertcolafter',
	      'tabledeletecol'
	    ];
	    var defaultStyles = {
	      'border-collapse': 'collapse',
	      'width': '100%'
	    };
	    var defaultAttributes = { border: '1' };
	    var getDefaultAttributes = function (editor) {
	      return editor.getParam('table_default_attributes', defaultAttributes, 'object');
	    };
	    var getDefaultStyles = function (editor) {
	      return editor.getParam('table_default_styles', defaultStyles, 'object');
	    };
	    var hasTableResizeBars = function (editor) {
	      return editor.getParam('table_resize_bars', true, 'boolean');
	    };
	    var hasTabNavigation = function (editor) {
	      return editor.getParam('table_tab_navigation', true, 'boolean');
	    };
	    var hasAdvancedCellTab = function (editor) {
	      return editor.getParam('table_cell_advtab', true, 'boolean');
	    };
	    var hasAdvancedRowTab = function (editor) {
	      return editor.getParam('table_row_advtab', true, 'boolean');
	    };
	    var hasAdvancedTableTab = function (editor) {
	      return editor.getParam('table_advtab', true, 'boolean');
	    };
	    var hasAppearanceOptions = function (editor) {
	      return editor.getParam('table_appearance_options', true, 'boolean');
	    };
	    var hasTableGrid = function (editor) {
	      return editor.getParam('table_grid', true, 'boolean');
	    };
	    var shouldStyleWithCss = function (editor) {
	      return editor.getParam('table_style_by_css', false, 'boolean');
	    };
	    var getCellClassList = function (editor) {
	      return editor.getParam('table_cell_class_list', [], 'array');
	    };
	    var getRowClassList = function (editor) {
	      return editor.getParam('table_row_class_list', [], 'array');
	    };
	    var getTableClassList = function (editor) {
	      return editor.getParam('table_class_list', [], 'array');
	    };
	    var getColorPickerCallback = function (editor) {
	      return editor.getParam('color_picker_callback');
	    };
	    var isPixelsForced = function (editor) {
	      return editor.getParam('table_responsive_width') === false;
	    };
	    var getCloneElements = function (editor) {
	      var cloneElements = editor.getParam('table_clone_elements');
	      if (isString(cloneElements)) {
	        return Option.some(cloneElements.split(/[ ,]/));
	      } else if (Array.isArray(cloneElements)) {
	        return Option.some(cloneElements);
	      } else {
	        return Option.none();
	      }
	    };
	    var hasObjectResizing = function (editor) {
	      var objectResizing = editor.getParam('object_resizing', true);
	      return objectResizing === 'table' || objectResizing;
	    };
	    var getToolbar = function (editor) {
	      var toolbar = editor.getParam('table_toolbar', defaultTableToolbar);
	      if (toolbar === '' || toolbar === false) {
	        return [];
	      } else if (isString(toolbar)) {
	        return toolbar.split(/[ ,]/);
	      } else if (isArray(toolbar)) {
	        return toolbar;
	      } else {
	        return [];
	      }
	    };
	
	    var fireNewRow = function (editor, row) {
	      return editor.fire('newrow', { node: row });
	    };
	    var fireNewCell = function (editor, cell) {
	      return editor.fire('newcell', { node: cell });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	
	    var TableActions = function (editor, lazyWire) {
	      var isTableBody = function (editor) {
	        return name(getBody$1(editor)) === 'table';
	      };
	      var lastRowGuard = function (table) {
	        var size = TableGridSize.getGridSize(table);
	        return isTableBody(editor) === false || size.rows() > 1;
	      };
	      var lastColumnGuard = function (table) {
	        var size = TableGridSize.getGridSize(table);
	        return isTableBody(editor) === false || size.columns() > 1;
	      };
	      var cloneFormats = getCloneElements(editor);
	      var execute = function (operation, guard, mutate, lazyWire) {
	        return function (table, target) {
	          removeDataStyle(table);
	          var wire = lazyWire();
	          var doc = Element.fromDom(editor.getDoc());
	          var direction = TableDirection(Direction.directionAt);
	          var generators = TableFill.cellOperations(mutate, doc, cloneFormats);
	          return guard(table) ? operation(wire, table, target, generators, direction).bind(function (result) {
	            each(result.newRows(), function (row) {
	              fireNewRow(editor, row.dom());
	            });
	            each(result.newCells(), function (cell) {
	              fireNewCell(editor, cell.dom());
	            });
	            return result.cursor().map(function (cell) {
	              var rng = editor.dom.createRng();
	              rng.setStart(cell.dom(), 0);
	              rng.setEnd(cell.dom(), 0);
	              return rng;
	            });
	          }) : Option.none();
	        };
	      };
	      var deleteRow = execute(TableOperations.eraseRows, lastRowGuard, noop, lazyWire);
	      var deleteColumn = execute(TableOperations.eraseColumns, lastColumnGuard, noop, lazyWire);
	      var insertRowsBefore = execute(TableOperations.insertRowsBefore, always, noop, lazyWire);
	      var insertRowsAfter = execute(TableOperations.insertRowsAfter, always, noop, lazyWire);
	      var insertColumnsBefore = execute(TableOperations.insertColumnsBefore, always, CellMutations.halve, lazyWire);
	      var insertColumnsAfter = execute(TableOperations.insertColumnsAfter, always, CellMutations.halve, lazyWire);
	      var mergeCells = execute(TableOperations.mergeCells, always, noop, lazyWire);
	      var unmergeCells = execute(TableOperations.unmergeCells, always, noop, lazyWire);
	      var pasteRowsBefore = execute(TableOperations.pasteRowsBefore, always, noop, lazyWire);
	      var pasteRowsAfter = execute(TableOperations.pasteRowsAfter, always, noop, lazyWire);
	      var pasteCells = execute(TableOperations.pasteCells, always, noop, lazyWire);
	      return {
	        deleteRow: deleteRow,
	        deleteColumn: deleteColumn,
	        insertRowsBefore: insertRowsBefore,
	        insertRowsAfter: insertRowsAfter,
	        insertColumnsBefore: insertColumnsBefore,
	        insertColumnsAfter: insertColumnsAfter,
	        mergeCells: mergeCells,
	        unmergeCells: unmergeCells,
	        pasteRowsBefore: pasteRowsBefore,
	        pasteRowsAfter: pasteRowsAfter,
	        pasteCells: pasteCells
	      };
	    };
	
	    var copyRows = function (table, target, generators) {
	      var list = DetailsList.fromTable(table);
	      var house = Warehouse.generate(list);
	      var details = onCells(house, target);
	      return details.map(function (selectedCells) {
	        var grid = Transitions.toGrid(house, generators, false);
	        var slicedGrid = grid.slice(selectedCells[0].row(), selectedCells[selectedCells.length - 1].row() + selectedCells[selectedCells.length - 1].rowspan());
	        var slicedDetails = toDetailList(slicedGrid, generators);
	        return Redraw.copy(slicedDetails);
	      });
	    };
	    var CopyRows = { copyRows: copyRows };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getTDTHOverallStyle = function (dom, elm, name) {
	      var cells = dom.select('td,th', elm);
	      var firstChildStyle;
	      var checkChildren = function (firstChildStyle, elms) {
	        for (var i = 0; i < elms.length; i++) {
	          var currentStyle = dom.getStyle(elms[i], name);
	          if (typeof firstChildStyle === 'undefined') {
	            firstChildStyle = currentStyle;
	          }
	          if (firstChildStyle !== currentStyle) {
	            return '';
	          }
	        }
	        return firstChildStyle;
	      };
	      firstChildStyle = checkChildren(firstChildStyle, cells);
	      return firstChildStyle;
	    };
	    var applyAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('align' + name, {}, elm);
	      }
	    };
	    var applyVAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('valign' + name, {}, elm);
	      }
	    };
	    var unApplyAlign = function (editor, elm) {
	      global$1.each('left center right'.split(' '), function (name) {
	        editor.formatter.remove('align' + name, {}, elm);
	      });
	    };
	    var unApplyVAlign = function (editor, elm) {
	      global$1.each('top middle bottom'.split(' '), function (name) {
	        editor.formatter.remove('valign' + name, {}, elm);
	      });
	    };
	    var Styles$1 = {
	      applyAlign: applyAlign,
	      applyVAlign: applyVAlign,
	      unApplyAlign: unApplyAlign,
	      unApplyVAlign: unApplyVAlign,
	      getTDTHOverallStyle: getTDTHOverallStyle
	    };
	
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      var appendItems = function (values, output) {
	        output = output || [];
	        global$1.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	            if (itemCallback) {
	              itemCallback(menuItem);
	            }
	          }
	          output.push(menuItem);
	        });
	        return output;
	      };
	      return appendItems(inputList, startItems || []);
	    };
	    function styleFieldHasFocus(e) {
	      return e.control.rootControl.find('#style')[0].getEl().isEqualNode(domGlobals.document.activeElement);
	    }
	    var syncAdvancedStyleFields = function (editor, evt) {
	      if (styleFieldHasFocus(evt)) {
	        updateAdvancedFields(editor, evt);
	      } else {
	        updateStyleField(editor, evt);
	      }
	    };
	    var updateStyleField = function (editor, evt) {
	      var dom = editor.dom;
	      var rootControl = evt.control.rootControl;
	      var data = rootControl.toJSON();
	      var css = dom.parseStyle(data.style);
	      css['border-style'] = data.borderStyle;
	      css['border-color'] = data.borderColor;
	      css['background-color'] = data.backgroundColor;
	      css.width = data.width ? addSizeSuffix(data.width) : '';
	      css.height = data.height ? addSizeSuffix(data.height) : '';
	      rootControl.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
	    };
	    var updateAdvancedFields = function (editor, evt) {
	      var dom = editor.dom;
	      var rootControl = evt.control.rootControl;
	      var data = rootControl.toJSON();
	      var css = dom.parseStyle(data.style);
	      rootControl.find('#borderStyle').value(css['border-style'] || '');
	      rootControl.find('#borderColor').value(css['border-color'] || '');
	      rootControl.find('#backgroundColor').value(css['background-color'] || '');
	      rootControl.find('#width').value(css.width || '');
	      rootControl.find('#height').value(css.height || '');
	    };
	    var extractAdvancedStyles = function (dom, elm) {
	      var css = dom.parseStyle(dom.getAttrib(elm, 'style'));
	      var data = {};
	      if (css['border-style']) {
	        data.borderStyle = css['border-style'];
	      }
	      if (css['border-color']) {
	        data.borderColor = css['border-color'];
	      }
	      if (css['background-color']) {
	        data.backgroundColor = css['background-color'];
	      }
	      data.style = dom.serializeStyle(css);
	      return data;
	    };
	    var createStyleForm = function (editor) {
	      var createColorPickAction = function () {
	        var colorPickerCallback = getColorPickerCallback(editor);
	        if (colorPickerCallback) {
	          return function (evt) {
	            return colorPickerCallback.call(editor, function (value) {
	              evt.control.value(value).fire('change');
	            }, evt.control.value());
	          };
	        }
	      };
	      return {
	        title: 'Advanced',
	        type: 'form',
	        defaults: { onchange: curry(updateStyleField, editor) },
	        items: [
	          {
	            label: 'Style',
	            name: 'style',
	            type: 'textbox',
	            onchange: curry(updateAdvancedFields, editor)
	          },
	          {
	            type: 'form',
	            padding: 0,
	            formItemDefaults: {
	              layout: 'grid',
	              alignH: [
	                'start',
	                'right'
	              ]
	            },
	            defaults: { size: 7 },
	            items: [
	              {
	                label: 'Border style',
	                type: 'listbox',
	                name: 'borderStyle',
	                width: 90,
	                onselect: curry(updateStyleField, editor),
	                values: [
	                  {
	                    text: 'Select...',
	                    value: ''
	                  },
	                  {
	                    text: 'Solid',
	                    value: 'solid'
	                  },
	                  {
	                    text: 'Dotted',
	                    value: 'dotted'
	                  },
	                  {
	                    text: 'Dashed',
	                    value: 'dashed'
	                  },
	                  {
	                    text: 'Double',
	                    value: 'double'
	                  },
	                  {
	                    text: 'Groove',
	                    value: 'groove'
	                  },
	                  {
	                    text: 'Ridge',
	                    value: 'ridge'
	                  },
	                  {
	                    text: 'Inset',
	                    value: 'inset'
	                  },
	                  {
	                    text: 'Outset',
	                    value: 'outset'
	                  },
	                  {
	                    text: 'None',
	                    value: 'none'
	                  },
	                  {
	                    text: 'Hidden',
	                    value: 'hidden'
	                  }
	                ]
	              },
	              {
	                label: 'Border color',
	                type: 'colorbox',
	                name: 'borderColor',
	                onaction: createColorPickAction()
	              },
	              {
	                label: 'Background color',
	                type: 'colorbox',
	                name: 'backgroundColor',
	                onaction: createColorPickAction()
	              }
	            ]
	          }
	        ]
	      };
	    };
	    var Helpers = {
	      createStyleForm: createStyleForm,
	      buildListItems: buildListItems,
	      updateStyleField: updateStyleField,
	      extractAdvancedStyles: extractAdvancedStyles,
	      updateAdvancedFields: updateAdvancedFields,
	      syncAdvancedStyleFields: syncAdvancedStyleFields
	    };
	
	    var updateStyles = function (elm, cssText) {
	      delete elm.dataset.mceStyle;
	      elm.style.cssText += ';' + cssText;
	    };
	    var extractDataFromElement = function (editor, elm) {
	      var dom = editor.dom;
	      var data = {
	        width: dom.getStyle(elm, 'width') || dom.getAttrib(elm, 'width'),
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        scope: dom.getAttrib(elm, 'scope'),
	        class: dom.getAttrib(elm, 'class'),
	        type: elm.nodeName.toLowerCase(),
	        style: '',
	        align: '',
	        valign: ''
	      };
	      global$1.each('left center right'.split(' '), function (name) {
	        if (editor.formatter.matchNode(elm, 'align' + name)) {
	          data.align = name;
	        }
	      });
	      global$1.each('top middle bottom'.split(' '), function (name) {
	        if (editor.formatter.matchNode(elm, 'valign' + name)) {
	          data.valign = name;
	        }
	      });
	      if (hasAdvancedCellTab(editor)) {
	        global$1.extend(data, Helpers.extractAdvancedStyles(dom, elm));
	      }
	      return data;
	    };
	    var onSubmitCellForm = function (editor, cells, evt) {
	      var dom = editor.dom;
	      var data;
	      function setAttrib(elm, name, value) {
	        if (cells.length === 1 || value) {
	          dom.setAttrib(elm, name, value);
	        }
	      }
	      function setStyle(elm, name, value) {
	        if (cells.length === 1 || value) {
	          dom.setStyle(elm, name, value);
	        }
	      }
	      if (hasAdvancedCellTab(editor)) {
	        Helpers.syncAdvancedStyleFields(editor, evt);
	      }
	      data = evt.control.rootControl.toJSON();
	      editor.undoManager.transact(function () {
	        global$1.each(cells, function (cellElm) {
	          setAttrib(cellElm, 'scope', data.scope);
	          if (cells.length === 1) {
	            setAttrib(cellElm, 'style', data.style);
	          } else {
	            updateStyles(cellElm, data.style);
	          }
	          setAttrib(cellElm, 'class', data.class);
	          setStyle(cellElm, 'width', addSizeSuffix(data.width));
	          setStyle(cellElm, 'height', addSizeSuffix(data.height));
	          if (data.type && cellElm.nodeName.toLowerCase() !== data.type) {
	            cellElm = dom.rename(cellElm, data.type);
	          }
	          if (cells.length === 1) {
	            Styles$1.unApplyAlign(editor, cellElm);
	            Styles$1.unApplyVAlign(editor, cellElm);
	          }
	          if (data.align) {
	            Styles$1.applyAlign(editor, cellElm, data.align);
	          }
	          if (data.valign) {
	            Styles$1.applyVAlign(editor, cellElm, data.valign);
	          }
	        });
	        editor.focus();
	      });
	    };
	    var open = function (editor) {
	      var cellElm, data, classListCtrl, cells = [];
	      cells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
	      cellElm = editor.dom.getParent(editor.selection.getStart(), 'td,th');
	      if (!cells.length && cellElm) {
	        cells.push(cellElm);
	      }
	      cellElm = cellElm || cells[0];
	      if (!cellElm) {
	        return;
	      }
	      if (cells.length > 1) {
	        data = {
	          width: '',
	          height: '',
	          scope: '',
	          class: '',
	          align: '',
	          valign: '',
	          style: '',
	          type: cellElm.nodeName.toLowerCase()
	        };
	      } else {
	        data = extractDataFromElement(editor, cellElm);
	      }
	      if (getCellClassList(editor).length > 0) {
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: Helpers.buildListItems(getCellClassList(editor), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  block: 'td',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        };
	      }
	      var generalCellForm = {
	        type: 'form',
	        layout: 'flex',
	        direction: 'column',
	        labelGapCalc: 'children',
	        padding: 0,
	        items: [
	          {
	            type: 'form',
	            layout: 'grid',
	            columns: 2,
	            labelGapCalc: false,
	            padding: 0,
	            defaults: {
	              type: 'textbox',
	              maxWidth: 50
	            },
	            items: [
	              {
	                label: 'Width',
	                name: 'width',
	                onchange: curry(Helpers.updateStyleField, editor)
	              },
	              {
	                label: 'Height',
	                name: 'height',
	                onchange: curry(Helpers.updateStyleField, editor)
	              },
	              {
	                label: 'Cell type',
	                name: 'type',
	                type: 'listbox',
	                text: 'None',
	                minWidth: 90,
	                maxWidth: null,
	                values: [
	                  {
	                    text: 'Cell',
	                    value: 'td'
	                  },
	                  {
	                    text: 'Header cell',
	                    value: 'th'
	                  }
	                ]
	              },
	              {
	                label: 'Scope',
	                name: 'scope',
	                type: 'listbox',
	                text: 'None',
	                minWidth: 90,
	                maxWidth: null,
	                values: [
	                  {
	                    text: 'None',
	                    value: ''
	                  },
	                  {
	                    text: 'Row',
	                    value: 'row'
	                  },
	                  {
	                    text: 'Column',
	                    value: 'col'
	                  },
	                  {
	                    text: 'Row group',
	                    value: 'rowgroup'
	                  },
	                  {
	                    text: 'Column group',
	                    value: 'colgroup'
	                  }
	                ]
	              },
	              {
	                label: 'H Align',
	                name: 'align',
	                type: 'listbox',
	                text: 'None',
	                minWidth: 90,
	                maxWidth: null,
	                values: [
	                  {
	                    text: 'None',
	                    value: ''
	                  },
	                  {
	                    text: 'Left',
	                    value: 'left'
	                  },
	                  {
	                    text: 'Center',
	                    value: 'center'
	                  },
	                  {
	                    text: 'Right',
	                    value: 'right'
	                  }
	                ]
	              },
	              {
	                label: 'V Align',
	                name: 'valign',
	                type: 'listbox',
	                text: 'None',
	                minWidth: 90,
	                maxWidth: null,
	                values: [
	                  {
	                    text: 'None',
	                    value: ''
	                  },
	                  {
	                    text: 'Top',
	                    value: 'top'
	                  },
	                  {
	                    text: 'Middle',
	                    value: 'middle'
	                  },
	                  {
	                    text: 'Bottom',
	                    value: 'bottom'
	                  }
	                ]
	              }
	            ]
	          },
	          classListCtrl
	        ]
	      };
	      if (hasAdvancedCellTab(editor)) {
	        editor.windowManager.open({
	          title: 'Cell properties',
	          bodyType: 'tabpanel',
	          data: data,
	          body: [
	            {
	              title: 'General',
	              type: 'form',
	              items: generalCellForm
	            },
	            Helpers.createStyleForm(editor)
	          ],
	          onsubmit: curry(onSubmitCellForm, editor, cells)
	        });
	      } else {
	        editor.windowManager.open({
	          title: 'Cell properties',
	          data: data,
	          body: generalCellForm,
	          onsubmit: curry(onSubmitCellForm, editor, cells)
	        });
	      }
	    };
	    var CellDialog = { open: open };
	
	    var extractDataFromElement$1 = function (editor, elm) {
	      var dom = editor.dom;
	      var data = {
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        scope: dom.getAttrib(elm, 'scope'),
	        class: dom.getAttrib(elm, 'class'),
	        align: '',
	        style: '',
	        type: elm.parentNode.nodeName.toLowerCase()
	      };
	      global$1.each('left center right'.split(' '), function (name) {
	        if (editor.formatter.matchNode(elm, 'align' + name)) {
	          data.align = name;
	        }
	      });
	      if (hasAdvancedRowTab(editor)) {
	        global$1.extend(data, Helpers.extractAdvancedStyles(dom, elm));
	      }
	      return data;
	    };
	    var switchRowType = function (dom, rowElm, toType) {
	      var tableElm = dom.getParent(rowElm, 'table');
	      var oldParentElm = rowElm.parentNode;
	      var parentElm = dom.select(toType, tableElm)[0];
	      if (!parentElm) {
	        parentElm = dom.create(toType);
	        if (tableElm.firstChild) {
	          if (tableElm.firstChild.nodeName === 'CAPTION') {
	            dom.insertAfter(parentElm, tableElm.firstChild);
	          } else {
	            tableElm.insertBefore(parentElm, tableElm.firstChild);
	          }
	        } else {
	          tableElm.appendChild(parentElm);
	        }
	      }
	      parentElm.appendChild(rowElm);
	      if (!oldParentElm.hasChildNodes()) {
	        dom.remove(oldParentElm);
	      }
	    };
	    function onSubmitRowForm(editor, rows, oldData, evt) {
	      var dom = editor.dom;
	      function setAttrib(elm, name, value) {
	        if (rows.length === 1 || value) {
	          dom.setAttrib(elm, name, value);
	        }
	      }
	      function setStyle(elm, name, value) {
	        if (rows.length === 1 || value) {
	          dom.setStyle(elm, name, value);
	        }
	      }
	      if (hasAdvancedRowTab(editor)) {
	        Helpers.syncAdvancedStyleFields(editor, evt);
	      }
	      var data = evt.control.rootControl.toJSON();
	      editor.undoManager.transact(function () {
	        global$1.each(rows, function (rowElm) {
	          setAttrib(rowElm, 'scope', data.scope);
	          setAttrib(rowElm, 'style', data.style);
	          setAttrib(rowElm, 'class', data.class);
	          setStyle(rowElm, 'height', addSizeSuffix(data.height));
	          if (data.type !== rowElm.parentNode.nodeName.toLowerCase()) {
	            switchRowType(editor.dom, rowElm, data.type);
	          }
	          if (data.align !== oldData.align) {
	            Styles$1.unApplyAlign(editor, rowElm);
	            Styles$1.applyAlign(editor, rowElm, data.align);
	          }
	        });
	        editor.focus();
	      });
	    }
	    var open$1 = function (editor) {
	      var dom = editor.dom;
	      var tableElm, cellElm, rowElm, classListCtrl, data;
	      var rows = [];
	      var generalRowForm;
	      tableElm = dom.getParent(editor.selection.getStart(), 'table');
	      cellElm = dom.getParent(editor.selection.getStart(), 'td,th');
	      global$1.each(tableElm.rows, function (row) {
	        global$1.each(row.cells, function (cell) {
	          if (dom.getAttrib(cell, 'data-mce-selected') || cell === cellElm) {
	            rows.push(row);
	            return false;
	          }
	        });
	      });
	      rowElm = rows[0];
	      if (!rowElm) {
	        return;
	      }
	      if (rows.length > 1) {
	        data = {
	          height: '',
	          scope: '',
	          style: '',
	          class: '',
	          align: '',
	          type: rowElm.parentNode.nodeName.toLowerCase()
	        };
	      } else {
	        data = extractDataFromElement$1(editor, rowElm);
	      }
	      if (getRowClassList(editor).length > 0) {
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: Helpers.buildListItems(getRowClassList(editor), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  block: 'tr',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        };
	      }
	      generalRowForm = {
	        type: 'form',
	        columns: 2,
	        padding: 0,
	        defaults: { type: 'textbox' },
	        items: [
	          {
	            type: 'listbox',
	            name: 'type',
	            label: 'Row type',
	            text: 'Header',
	            maxWidth: null,
	            values: [
	              {
	                text: 'Header',
	                value: 'thead'
	              },
	              {
	                text: 'Body',
	                value: 'tbody'
	              },
	              {
	                text: 'Footer',
	                value: 'tfoot'
	              }
	            ]
	          },
	          {
	            type: 'listbox',
	            name: 'align',
	            label: 'Alignment',
	            text: 'None',
	            maxWidth: null,
	            values: [
	              {
	                text: 'None',
	                value: ''
	              },
	              {
	                text: 'Left',
	                value: 'left'
	              },
	              {
	                text: 'Center',
	                value: 'center'
	              },
	              {
	                text: 'Right',
	                value: 'right'
	              }
	            ]
	          },
	          {
	            label: 'Height',
	            name: 'height'
	          },
	          classListCtrl
	        ]
	      };
	      if (hasAdvancedRowTab(editor)) {
	        editor.windowManager.open({
	          title: 'Row properties',
	          data: data,
	          bodyType: 'tabpanel',
	          body: [
	            {
	              title: 'General',
	              type: 'form',
	              items: generalRowForm
	            },
	            Helpers.createStyleForm(editor)
	          ],
	          onsubmit: curry(onSubmitRowForm, editor, rows, data)
	        });
	      } else {
	        editor.windowManager.open({
	          title: 'Row properties',
	          data: data,
	          body: generalRowForm,
	          onsubmit: curry(onSubmitRowForm, editor, rows, data)
	        });
	      }
	    };
	    var RowDialog = { open: open$1 };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var DefaultRenderOptions = {
	      styles: {
	        'border-collapse': 'collapse',
	        'width': '100%'
	      },
	      attributes: { border: '1' },
	      percentages: true
	    };
	    var makeTable = function () {
	      return Element.fromTag('table');
	    };
	    var tableBody = function () {
	      return Element.fromTag('tbody');
	    };
	    var tableRow = function () {
	      return Element.fromTag('tr');
	    };
	    var tableHeaderCell = function () {
	      return Element.fromTag('th');
	    };
	    var tableCell = function () {
	      return Element.fromTag('td');
	    };
	    var render$1 = function (rows, columns, rowHeaders, columnHeaders, renderOpts) {
	      if (renderOpts === void 0) {
	        renderOpts = DefaultRenderOptions;
	      }
	      var table = makeTable();
	      setAll$1(table, renderOpts.styles);
	      setAll(table, renderOpts.attributes);
	      var tbody = tableBody();
	      append(table, tbody);
	      var trs = [];
	      for (var i = 0; i < rows; i++) {
	        var tr = tableRow();
	        for (var j = 0; j < columns; j++) {
	          var td = i < rowHeaders || j < columnHeaders ? tableHeaderCell() : tableCell();
	          if (j < columnHeaders) {
	            set(td, 'scope', 'row');
	          }
	          if (i < rowHeaders) {
	            set(td, 'scope', 'col');
	          }
	          append(td, Element.fromTag('br'));
	          if (renderOpts.percentages) {
	            set$1(td, 'width', 100 / columns + '%');
	          }
	          append(tr, td);
	        }
	        trs.push(tr);
	      }
	      append$1(tbody, trs);
	      return table;
	    };
	
	    var get$7 = function (element) {
	      return element.dom().innerHTML;
	    };
	    var getOuter$2 = function (element) {
	      var container = Element.fromTag('div');
	      var clone = Element.fromDom(element.dom().cloneNode(true));
	      append(container, clone);
	      return get$7(container);
	    };
	
	    var placeCaretInCell = function (editor, cell) {
	      editor.selection.select(cell.dom(), true);
	      editor.selection.collapse(true);
	    };
	    var selectFirstCellInTable = function (editor, tableElm) {
	      descendant$1(tableElm, 'td,th').each(curry(placeCaretInCell, editor));
	    };
	    var fireEvents = function (editor, table) {
	      each(descendants$1(table, 'tr'), function (row) {
	        fireNewRow(editor, row.dom());
	        each(descendants$1(row, 'th,td'), function (cell) {
	          fireNewCell(editor, cell.dom());
	        });
	      });
	    };
	    var isPercentage = function (width) {
	      return isString(width) && width.indexOf('%') !== -1;
	    };
	    var insert$1 = function (editor, columns, rows) {
	      var defaultStyles = getDefaultStyles(editor);
	      var options = {
	        styles: defaultStyles,
	        attributes: getDefaultAttributes(editor),
	        percentages: isPercentage(defaultStyles.width) && !isPixelsForced(editor)
	      };
	      var table = render$1(rows, columns, 0, 0, options);
	      set(table, 'data-mce-id', '__mce');
	      var html = getOuter$2(table);
	      editor.insertContent(html);
	      return descendant$1(getBody$1(editor), 'table[data-mce-id="__mce"]').map(function (table) {
	        if (isPixelsForced(editor)) {
	          set$1(table, 'width', get$1(table, 'width'));
	        }
	        remove(table, 'data-mce-id');
	        fireEvents(editor, table);
	        selectFirstCellInTable(editor, table);
	        return table.dom();
	      }).getOr(null);
	    };
	    var InsertTable = { insert: insert$1 };
	
	    function styleTDTH(dom, elm, name, value) {
	      if (elm.tagName === 'TD' || elm.tagName === 'TH') {
	        dom.setStyle(elm, name, value);
	      } else {
	        if (elm.children) {
	          for (var i = 0; i < elm.children.length; i++) {
	            styleTDTH(dom, elm.children[i], name, value);
	          }
	        }
	      }
	    }
	    var extractDataFromElement$2 = function (editor, tableElm) {
	      var dom = editor.dom;
	      var data = {
	        width: dom.getStyle(tableElm, 'width') || dom.getAttrib(tableElm, 'width'),
	        height: dom.getStyle(tableElm, 'height') || dom.getAttrib(tableElm, 'height'),
	        cellspacing: dom.getStyle(tableElm, 'border-spacing') || dom.getAttrib(tableElm, 'cellspacing'),
	        cellpadding: dom.getAttrib(tableElm, 'data-mce-cell-padding') || dom.getAttrib(tableElm, 'cellpadding') || Styles$1.getTDTHOverallStyle(editor.dom, tableElm, 'padding'),
	        border: dom.getAttrib(tableElm, 'data-mce-border') || dom.getAttrib(tableElm, 'border') || Styles$1.getTDTHOverallStyle(editor.dom, tableElm, 'border'),
	        borderColor: dom.getAttrib(tableElm, 'data-mce-border-color'),
	        caption: !!dom.select('caption', tableElm)[0],
	        class: dom.getAttrib(tableElm, 'class')
	      };
	      global$1.each('left center right'.split(' '), function (name) {
	        if (editor.formatter.matchNode(tableElm, 'align' + name)) {
	          data.align = name;
	        }
	      });
	      if (hasAdvancedTableTab(editor)) {
	        global$1.extend(data, Helpers.extractAdvancedStyles(dom, tableElm));
	      }
	      return data;
	    };
	    var applyDataToElement = function (editor, tableElm, data) {
	      var dom = editor.dom;
	      var attrs = {};
	      var styles = {};
	      attrs.class = data.class;
	      styles.height = addSizeSuffix(data.height);
	      if (dom.getAttrib(tableElm, 'width') && !shouldStyleWithCss(editor)) {
	        attrs.width = removePxSuffix(data.width);
	      } else {
	        styles.width = addSizeSuffix(data.width);
	      }
	      if (shouldStyleWithCss(editor)) {
	        styles['border-width'] = addSizeSuffix(data.border);
	        styles['border-spacing'] = addSizeSuffix(data.cellspacing);
	        global$1.extend(attrs, {
	          'data-mce-border-color': data.borderColor,
	          'data-mce-cell-padding': data.cellpadding,
	          'data-mce-border': data.border
	        });
	      } else {
	        global$1.extend(attrs, {
	          border: data.border,
	          cellpadding: data.cellpadding,
	          cellspacing: data.cellspacing
	        });
	      }
	      if (shouldStyleWithCss(editor)) {
	        if (tableElm.children) {
	          for (var i = 0; i < tableElm.children.length; i++) {
	            styleTDTH(dom, tableElm.children[i], {
	              'border-width': addSizeSuffix(data.border),
	              'border-color': data.borderColor,
	              'padding': addSizeSuffix(data.cellpadding)
	            });
	          }
	        }
	      }
	      if (data.style) {
	        global$1.extend(styles, dom.parseStyle(data.style));
	      } else {
	        styles = global$1.extend({}, dom.parseStyle(dom.getAttrib(tableElm, 'style')), styles);
	      }
	      attrs.style = dom.serializeStyle(styles);
	      dom.setAttribs(tableElm, attrs);
	    };
	    var onSubmitTableForm = function (editor, tableElm, evt) {
	      var dom = editor.dom;
	      var captionElm;
	      var data;
	      if (hasAdvancedTableTab(editor)) {
	        Helpers.syncAdvancedStyleFields(editor, evt);
	      }
	      data = evt.control.rootControl.toJSON();
	      if (data.class === false) {
	        delete data.class;
	      }
	      editor.undoManager.transact(function () {
	        if (!tableElm) {
	          tableElm = InsertTable.insert(editor, data.cols || 1, data.rows || 1);
	        }
	        applyDataToElement(editor, tableElm, data);
	        captionElm = dom.select('caption', tableElm)[0];
	        if (captionElm && !data.caption) {
	          dom.remove(captionElm);
	        }
	        if (!captionElm && data.caption) {
	          captionElm = dom.create('caption');
	          captionElm.innerHTML = !global$2.ie ? '<br data-mce-bogus="1"/>' : '\xA0';
	          tableElm.insertBefore(captionElm, tableElm.firstChild);
	        }
	        Styles$1.unApplyAlign(editor, tableElm);
	        if (data.align) {
	          Styles$1.applyAlign(editor, tableElm, data.align);
	        }
	        editor.focus();
	        editor.addVisual();
	      });
	    };
	    var open$2 = function (editor, isProps) {
	      var dom = editor.dom;
	      var tableElm, colsCtrl, rowsCtrl, classListCtrl, data = {}, generalTableForm;
	      if (isProps === true) {
	        tableElm = dom.getParent(editor.selection.getStart(), 'table');
	        if (tableElm) {
	          data = extractDataFromElement$2(editor, tableElm);
	        }
	      } else {
	        colsCtrl = {
	          label: 'Cols',
	          name: 'cols'
	        };
	        rowsCtrl = {
	          label: 'Rows',
	          name: 'rows'
	        };
	      }
	      if (getTableClassList(editor).length > 0) {
	        if (data.class) {
	          data.class = data.class.replace(/\s*mce\-item\-table\s*/g, '');
	        }
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: Helpers.buildListItems(getTableClassList(editor), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  block: 'table',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        };
	      }
	      generalTableForm = {
	        type: 'form',
	        layout: 'flex',
	        direction: 'column',
	        labelGapCalc: 'children',
	        padding: 0,
	        items: [
	          {
	            type: 'form',
	            labelGapCalc: false,
	            padding: 0,
	            layout: 'grid',
	            columns: 2,
	            defaults: {
	              type: 'textbox',
	              maxWidth: 50
	            },
	            items: hasAppearanceOptions(editor) ? [
	              colsCtrl,
	              rowsCtrl,
	              {
	                label: 'Width',
	                name: 'width',
	                onchange: curry(Helpers.updateStyleField, editor)
	              },
	              {
	                label: 'Height',
	                name: 'height',
	                onchange: curry(Helpers.updateStyleField, editor)
	              },
	              {
	                label: 'Cell spacing',
	                name: 'cellspacing'
	              },
	              {
	                label: 'Cell padding',
	                name: 'cellpadding'
	              },
	              {
	                label: 'Border',
	                name: 'border'
	              },
	              {
	                label: 'Caption',
	                name: 'caption',
	                type: 'checkbox'
	              }
	            ] : [
	              colsCtrl,
	              rowsCtrl,
	              {
	                label: 'Width',
	                name: 'width',
	                onchange: curry(Helpers.updateStyleField, editor)
	              },
	              {
	                label: 'Height',
	                name: 'height',
	                onchange: curry(Helpers.updateStyleField, editor)
	              }
	            ]
	          },
	          {
	            label: 'Alignment',
	            name: 'align',
	            type: 'listbox',
	            text: 'None',
	            values: [
	              {
	                text: 'None',
	                value: ''
	              },
	              {
	                text: 'Left',
	                value: 'left'
	              },
	              {
	                text: 'Center',
	                value: 'center'
	              },
	              {
	                text: 'Right',
	                value: 'right'
	              }
	            ]
	          },
	          classListCtrl
	        ]
	      };
	      if (hasAdvancedTableTab(editor)) {
	        editor.windowManager.open({
	          title: 'Table properties',
	          data: data,
	          bodyType: 'tabpanel',
	          body: [
	            {
	              title: 'General',
	              type: 'form',
	              items: generalTableForm
	            },
	            Helpers.createStyleForm(editor)
	          ],
	          onsubmit: curry(onSubmitTableForm, editor, tableElm)
	        });
	      } else {
	        editor.windowManager.open({
	          title: 'Table properties',
	          data: data,
	          body: generalTableForm,
	          onsubmit: curry(onSubmitTableForm, editor, tableElm)
	        });
	      }
	    };
	    var TableDialog = { open: open$2 };
	
	    var each$3 = global$1.each;
	    var registerCommands = function (editor, actions, cellSelection, selections, clipboardRows) {
	      var isRoot = getIsRoot(editor);
	      var eraseTable = function () {
	        getSelectionStartCell().orThunk(getSelectionStartCaption).each(function (cellOrCaption) {
	          var table = TableLookup.table(cellOrCaption, isRoot);
	          table.filter(not(isRoot)).each(function (table) {
	            var cursor = Element.fromText('');
	            after(table, cursor);
	            remove$2(table);
	            var rng = editor.dom.createRng();
	            rng.setStart(cursor.dom(), 0);
	            rng.setEnd(cursor.dom(), 0);
	            editor.selection.setRng(rng);
	          });
	        });
	      };
	      var getSelectionStartFromSelector = function (selector) {
	        return function () {
	          return Option.from(editor.dom.getParent(editor.selection.getStart(), selector)).map(Element.fromDom);
	        };
	      };
	      var getSelectionStartCaption = getSelectionStartFromSelector('caption');
	      var getSelectionStartCell = getSelectionStartFromSelector('th,td');
	      var getTableFromCell = function (cell) {
	        return TableLookup.table(cell, isRoot);
	      };
	      var getSize = function (table) {
	        return {
	          width: getPixelWidth$1(table.dom()),
	          height: getPixelWidth$1(table.dom())
	        };
	      };
	      var resizeChange = function (editor, oldSize, table) {
	        var newSize = getSize(table);
	        if (oldSize.width !== newSize.width || oldSize.height !== newSize.height) {
	          fireObjectResizeStart(editor, table.dom(), oldSize.width, oldSize.height);
	          fireObjectResized(editor, table.dom(), newSize.width, newSize.height);
	        }
	      };
	      var actOnSelection = function (execute) {
	        getSelectionStartCell().each(function (cell) {
	          getTableFromCell(cell).each(function (table) {
	            var targets = TableTargets.forMenu(selections, table, cell);
	            var beforeSize = getSize(table);
	            execute(table, targets).each(function (rng) {
	              resizeChange(editor, beforeSize, table);
	              editor.selection.setRng(rng);
	              editor.focus();
	              cellSelection.clear(table);
	              removeDataStyle(table);
	            });
	          });
	        });
	      };
	      var copyRowSelection = function (execute) {
	        return getSelectionStartCell().bind(function (cell) {
	          return getTableFromCell(cell).bind(function (table) {
	            var doc = Element.fromDom(editor.getDoc());
	            var targets = TableTargets.forMenu(selections, table, cell);
	            var generators = TableFill.cellOperations(noop, doc, Option.none());
	            return CopyRows.copyRows(table, targets, generators);
	          });
	        });
	      };
	      var pasteOnSelection = function (execute) {
	        clipboardRows.get().each(function (rows) {
	          var clonedRows = map(rows, function (row) {
	            return deep(row);
	          });
	          getSelectionStartCell().each(function (cell) {
	            getTableFromCell(cell).each(function (table) {
	              var doc = Element.fromDom(editor.getDoc());
	              var generators = TableFill.paste(doc);
	              var targets = TableTargets.pasteRows(selections, table, cell, clonedRows, generators);
	              execute(table, targets).each(function (rng) {
	                editor.selection.setRng(rng);
	                editor.focus();
	                cellSelection.clear(table);
	              });
	            });
	          });
	        });
	      };
	      each$3({
	        mceTableSplitCells: function () {
	          actOnSelection(actions.unmergeCells);
	        },
	        mceTableMergeCells: function () {
	          actOnSelection(actions.mergeCells);
	        },
	        mceTableInsertRowBefore: function () {
	          actOnSelection(actions.insertRowsBefore);
	        },
	        mceTableInsertRowAfter: function () {
	          actOnSelection(actions.insertRowsAfter);
	        },
	        mceTableInsertColBefore: function () {
	          actOnSelection(actions.insertColumnsBefore);
	        },
	        mceTableInsertColAfter: function () {
	          actOnSelection(actions.insertColumnsAfter);
	        },
	        mceTableDeleteCol: function () {
	          actOnSelection(actions.deleteColumn);
	        },
	        mceTableDeleteRow: function () {
	          actOnSelection(actions.deleteRow);
	        },
	        mceTableCutRow: function (grid) {
	          clipboardRows.set(copyRowSelection());
	          actOnSelection(actions.deleteRow);
	        },
	        mceTableCopyRow: function (grid) {
	          clipboardRows.set(copyRowSelection());
	        },
	        mceTablePasteRowBefore: function (grid) {
	          pasteOnSelection(actions.pasteRowsBefore);
	        },
	        mceTablePasteRowAfter: function (grid) {
	          pasteOnSelection(actions.pasteRowsAfter);
	        },
	        mceTableDelete: eraseTable
	      }, function (func, name) {
	        editor.addCommand(name, func);
	      });
	      each$3({
	        mceInsertTable: curry(TableDialog.open, editor),
	        mceTableProps: curry(TableDialog.open, editor, true),
	        mceTableRowProps: curry(RowDialog.open, editor),
	        mceTableCellProps: curry(CellDialog.open, editor)
	      }, function (func, name) {
	        editor.addCommand(name, function (ui, val) {
	          func(val);
	        });
	      });
	    };
	    var Commands = { registerCommands: registerCommands };
	
	    var only = function (element) {
	      var parent = Option.from(element.dom().documentElement).map(Element.fromDom).getOr(element);
	      return {
	        parent: constant(parent),
	        view: constant(element),
	        origin: constant(Position(0, 0))
	      };
	    };
	    var detached = function (editable, chrome) {
	      var origin = function () {
	        return absolute(chrome);
	      };
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: origin
	      };
	    };
	    var body$1 = function (editable, chrome) {
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: constant(Position(0, 0))
	      };
	    };
	    var ResizeWire = {
	      only: only,
	      detached: detached,
	      body: body$1
	    };
	
	    var Event = function (fields) {
	      var struct = Immutable.apply(null, fields);
	      var handlers = [];
	      var bind = function (handler) {
	        if (handler === undefined) {
	          throw new Error('Event bind error: undefined handler');
	        }
	        handlers.push(handler);
	      };
	      var unbind = function (handler) {
	        handlers = filter(handlers, function (h) {
	          return h !== handler;
	        });
	      };
	      var trigger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        var event = struct.apply(null, args);
	        each(handlers, function (handler) {
	          handler(event);
	        });
	      };
	      return {
	        bind: bind,
	        unbind: unbind,
	        trigger: trigger
	      };
	    };
	
	    var create$1 = function (typeDefs) {
	      var registry = map$1(typeDefs, function (event) {
	        return {
	          bind: event.bind,
	          unbind: event.unbind
	        };
	      });
	      var trigger = map$1(typeDefs, function (event) {
	        return event.trigger;
	      });
	      return {
	        registry: registry,
	        trigger: trigger
	      };
	    };
	    var Events = { create: create$1 };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: constant(target),
	        x: constant(x),
	        y: constant(y),
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: constant(raw)
	      };
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (!filter(rawEvent)) {
	          return;
	        }
	        var target = Element.fromDom(rawEvent.target);
	        var stop = function () {
	          rawEvent.stopPropagation();
	        };
	        var prevent = function () {
	          rawEvent.preventDefault();
	        };
	        var kill = compose(prevent, stop);
	        var evt = mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	        handler(evt);
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom().addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$1 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom().removeEventListener(event, handler, useCapture);
	    };
	
	    var filter$1 = constant(true);
	    var bind$2 = function (element, event, handler) {
	      return bind$1(element, event, filter$1, handler);
	    };
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var shallow$1 = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge$3 = baseMerge(shallow$1);
	
	    var styles$1 = css('ephox-dragster');
	    var Styles$2 = { resolve: styles$1.resolve };
	
	    var Blocker = function (options) {
	      var settings = merge$3({ layerClass: Styles$2.resolve('blocker') }, options);
	      var div = Element.fromTag('div');
	      set(div, 'role', 'presentation');
	      setAll$1(div, {
	        position: 'fixed',
	        left: '0px',
	        top: '0px',
	        width: '100%',
	        height: '100%'
	      });
	      add$2(div, Styles$2.resolve('blocker'));
	      add$2(div, settings.layerClass);
	      var element = function () {
	        return div;
	      };
	      var destroy = function () {
	        remove$2(div);
	      };
	      return {
	        element: element,
	        destroy: destroy
	      };
	    };
	
	    var DragMode = exactly([
	      'compare',
	      'extract',
	      'mutate',
	      'sink'
	    ]);
	    var DragSink = exactly([
	      'element',
	      'start',
	      'stop',
	      'destroy'
	    ]);
	    var DragApi = exactly([
	      'forceDrop',
	      'drop',
	      'move',
	      'delayDrop'
	    ]);
	
	    var compare = function (old, nu) {
	      return Position(nu.left() - old.left(), nu.top() - old.top());
	    };
	    var extract$1 = function (event) {
	      return Option.some(Position(event.x(), event.y()));
	    };
	    var mutate = function (mutation, info) {
	      mutation.mutate(info.left(), info.top());
	    };
	    var sink = function (dragApi, settings) {
	      var blocker = Blocker(settings);
	      var mdown = bind$2(blocker.element(), 'mousedown', dragApi.forceDrop);
	      var mup = bind$2(blocker.element(), 'mouseup', dragApi.drop);
	      var mmove = bind$2(blocker.element(), 'mousemove', dragApi.move);
	      var mout = bind$2(blocker.element(), 'mouseout', dragApi.delayDrop);
	      var destroy = function () {
	        blocker.destroy();
	        mup.unbind();
	        mmove.unbind();
	        mout.unbind();
	        mdown.unbind();
	      };
	      var start = function (parent) {
	        append(parent, blocker.element());
	      };
	      var stop = function () {
	        remove$2(blocker.element());
	      };
	      return DragSink({
	        element: blocker.element,
	        start: start,
	        stop: stop,
	        destroy: destroy
	      });
	    };
	    var MouseDrag = DragMode({
	      compare: compare,
	      extract: extract$1,
	      sink: sink,
	      mutate: mutate
	    });
	
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	        }
	        timer = domGlobals.setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    function InDrag () {
	      var previous = Option.none();
	      var reset = function () {
	        previous = Option.none();
	      };
	      var update = function (mode, nu) {
	        var result = previous.map(function (old) {
	          return mode.compare(old, nu);
	        });
	        previous = Option.some(nu);
	        return result;
	      };
	      var onEvent = function (event, mode) {
	        var dataOption = mode.extract(event);
	        dataOption.each(function (data) {
	          var offset = update(mode, data);
	          offset.each(function (d) {
	            events.trigger.move(d);
	          });
	        });
	      };
	      var events = Events.create({ move: Event(['info']) });
	      return {
	        onEvent: onEvent,
	        reset: reset,
	        events: events.registry
	      };
	    }
	
	    function NoDrag () {
	      return {
	        onEvent: noop,
	        reset: noop
	      };
	    }
	
	    function Movement () {
	      var noDragState = NoDrag();
	      var inDragState = InDrag();
	      var dragState = noDragState;
	      var on = function () {
	        dragState.reset();
	        dragState = inDragState;
	      };
	      var off = function () {
	        dragState.reset();
	        dragState = noDragState;
	      };
	      var onEvent = function (event, mode) {
	        dragState.onEvent(event, mode);
	      };
	      var isOn = function () {
	        return dragState === inDragState;
	      };
	      return {
	        on: on,
	        off: off,
	        isOn: isOn,
	        onEvent: onEvent,
	        events: inDragState.events
	      };
	    }
	
	    var setup = function (mutation, mode, settings) {
	      var active = false;
	      var events = Events.create({
	        start: Event([]),
	        stop: Event([])
	      });
	      var movement = Movement();
	      var drop = function () {
	        sink.stop();
	        if (movement.isOn()) {
	          movement.off();
	          events.trigger.stop();
	        }
	      };
	      var throttledDrop = last$2(drop, 200);
	      var go = function (parent) {
	        sink.start(parent);
	        movement.on();
	        events.trigger.start();
	      };
	      var mousemove = function (event) {
	        throttledDrop.cancel();
	        movement.onEvent(event, mode);
	      };
	      movement.events.move.bind(function (event) {
	        mode.mutate(mutation, event.info());
	      });
	      var on = function () {
	        active = true;
	      };
	      var off = function () {
	        active = false;
	      };
	      var runIfActive = function (f) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          if (active) {
	            f.apply(null, args);
	          }
	        };
	      };
	      var sink = mode.sink(DragApi({
	        forceDrop: drop,
	        drop: runIfActive(drop),
	        move: runIfActive(mousemove),
	        delayDrop: runIfActive(throttledDrop.throttle)
	      }), settings);
	      var destroy = function () {
	        sink.destroy();
	      };
	      return {
	        element: sink.element,
	        go: go,
	        on: on,
	        off: off,
	        destroy: destroy,
	        events: events.registry
	      };
	    };
	    var Dragging = { setup: setup };
	
	    var transform$1 = function (mutation, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var mode = settings.mode !== undefined ? settings.mode : MouseDrag;
	      return Dragging.setup(mutation, mode, settings);
	    };
	    var Dragger = { transform: transform$1 };
	
	    var Mutation = function () {
	      var events = Events.create({
	        drag: Event([
	          'xDelta',
	          'yDelta'
	        ])
	      });
	      var mutate = function (x, y) {
	        events.trigger.drag(x, y);
	      };
	      return {
	        mutate: mutate,
	        events: events.registry
	      };
	    };
	
	    var BarMutation = function () {
	      var events = Events.create({
	        drag: Event([
	          'xDelta',
	          'yDelta',
	          'target'
	        ])
	      });
	      var target = Option.none();
	      var delegate = Mutation();
	      delegate.events.drag.bind(function (event) {
	        target.each(function (t) {
	          events.trigger.drag(event.xDelta(), event.yDelta(), t);
	        });
	      });
	      var assign = function (t) {
	        target = Option.some(t);
	      };
	      var get = function () {
	        return target;
	      };
	      return {
	        assign: assign,
	        get: get,
	        mutate: delegate.mutate,
	        events: events.registry
	      };
	    };
	
	    var isContentEditableTrue = function (elm) {
	      return get(elm, 'contenteditable') === 'true';
	    };
	    var findClosestContentEditable = function (target, isRoot) {
	      return closest$1(target, '[contenteditable]', isRoot);
	    };
	
	    var resizeBarDragging = Styles.resolve('resizer-bar-dragging');
	    var BarManager = function (wire, direction, hdirection) {
	      var mutation = BarMutation();
	      var resizing = Dragger.transform(mutation, {});
	      var hoverTable = Option.none();
	      var getResizer = function (element, type) {
	        return Option.from(get(element, type));
	      };
	      mutation.events.drag.bind(function (event) {
	        getResizer(event.target(), 'data-row').each(function (_dataRow) {
	          var currentRow = CellUtils.getInt(event.target(), 'top');
	          set$1(event.target(), 'top', currentRow + event.yDelta() + 'px');
	        });
	        getResizer(event.target(), 'data-column').each(function (_dataCol) {
	          var currentCol = CellUtils.getInt(event.target(), 'left');
	          set$1(event.target(), 'left', currentCol + event.xDelta() + 'px');
	        });
	      });
	      var getDelta = function (target, dir) {
	        var newX = CellUtils.getInt(target, dir);
	        var oldX = parseInt(get(target, 'data-initial-' + dir), 10);
	        return newX - oldX;
	      };
	      resizing.events.stop.bind(function () {
	        mutation.get().each(function (target) {
	          hoverTable.each(function (table) {
	            getResizer(target, 'data-row').each(function (row) {
	              var delta = getDelta(target, 'top');
	              remove(target, 'data-initial-top');
	              events.trigger.adjustHeight(table, delta, parseInt(row, 10));
	            });
	            getResizer(target, 'data-column').each(function (column) {
	              var delta = getDelta(target, 'left');
	              remove(target, 'data-initial-left');
	              events.trigger.adjustWidth(table, delta, parseInt(column, 10));
	            });
	            Bars.refresh(wire, table, hdirection, direction);
	          });
	        });
	      });
	      var handler = function (target, dir) {
	        events.trigger.startAdjust();
	        mutation.assign(target);
	        set(target, 'data-initial-' + dir, parseInt(get$1(target, dir), 10));
	        add$2(target, resizeBarDragging);
	        set$1(target, 'opacity', '0.2');
	        resizing.go(wire.parent());
	      };
	      var mousedown = bind$2(wire.parent(), 'mousedown', function (event) {
	        if (Bars.isRowBar(event.target())) {
	          handler(event.target(), 'top');
	        }
	        if (Bars.isColBar(event.target())) {
	          handler(event.target(), 'left');
	        }
	      });
	      var isRoot = function (e) {
	        return eq(e, wire.view());
	      };
	      var findClosestEditableTable = function (target) {
	        return closest$1(target, 'table', isRoot).filter(function (table) {
	          return findClosestContentEditable(table, isRoot).exists(isContentEditableTrue);
	        });
	      };
	      var mouseover = bind$2(wire.view(), 'mouseover', function (event) {
	        findClosestEditableTable(event.target()).fold(function () {
	          if (inBody(event.target())) {
	            Bars.destroy(wire);
	          }
	        }, function (table) {
	          hoverTable = Option.some(table);
	          Bars.refresh(wire, table, hdirection, direction);
	        });
	      });
	      var destroy = function () {
	        mousedown.unbind();
	        mouseover.unbind();
	        resizing.destroy();
	        Bars.destroy(wire);
	      };
	      var refresh = function (tbl) {
	        Bars.refresh(wire, tbl, hdirection, direction);
	      };
	      var events = Events.create({
	        adjustHeight: Event([
	          'table',
	          'delta',
	          'row'
	        ]),
	        adjustWidth: Event([
	          'table',
	          'delta',
	          'column'
	        ]),
	        startAdjust: Event([])
	      });
	      return {
	        destroy: destroy,
	        refresh: refresh,
	        on: resizing.on,
	        off: resizing.off,
	        hideBars: curry(Bars.hide, wire),
	        showBars: curry(Bars.show, wire),
	        events: events.registry
	      };
	    };
	
	    var create$2 = function (wire, vdirection) {
	      var hdirection = BarPositions.height;
	      var manager = BarManager(wire, vdirection, hdirection);
	      var events = Events.create({
	        beforeResize: Event(['table']),
	        afterResize: Event(['table']),
	        startDrag: Event([])
	      });
	      manager.events.adjustHeight.bind(function (event) {
	        events.trigger.beforeResize(event.table());
	        var delta = hdirection.delta(event.delta(), event.table());
	        Adjustments.adjustHeight(event.table(), delta, event.row(), hdirection);
	        events.trigger.afterResize(event.table());
	      });
	      manager.events.startAdjust.bind(function (event) {
	        events.trigger.startDrag();
	      });
	      manager.events.adjustWidth.bind(function (event) {
	        events.trigger.beforeResize(event.table());
	        var delta = vdirection.delta(event.delta(), event.table());
	        Adjustments.adjustWidth(event.table(), delta, event.column(), vdirection);
	        events.trigger.afterResize(event.table());
	      });
	      return {
	        on: manager.on,
	        off: manager.off,
	        hideBars: manager.hideBars,
	        showBars: manager.showBars,
	        destroy: manager.destroy,
	        events: events.registry
	      };
	    };
	    var TableResize = { create: create$2 };
	
	    var createContainer = function () {
	      var container = Element.fromTag('div');
	      setAll$1(container, {
	        position: 'static',
	        height: '0',
	        width: '0',
	        padding: '0',
	        margin: '0',
	        border: '0'
	      });
	      append(body(), container);
	      return container;
	    };
	    var get$8 = function (editor, container) {
	      return editor.inline ? ResizeWire.body(getBody$1(editor), createContainer()) : ResizeWire.only(Element.fromDom(editor.getDoc()));
	    };
	    var remove$6 = function (editor, wire) {
	      if (editor.inline) {
	        remove$2(wire.parent());
	      }
	    };
	    var TableWire = {
	      get: get$8,
	      remove: remove$6
	    };
	
	    var ResizeHandler = function (editor) {
	      var selectionRng = Option.none();
	      var resize = Option.none();
	      var wire = Option.none();
	      var percentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
	      var startW, startRawW;
	      var isTable = function (elm) {
	        return elm.nodeName === 'TABLE';
	      };
	      var getRawWidth = function (elm) {
	        return editor.dom.getStyle(elm, 'width') || editor.dom.getAttrib(elm, 'width');
	      };
	      var lazyResize = function () {
	        return resize;
	      };
	      var lazyWire = function () {
	        return wire.getOr(ResizeWire.only(Element.fromDom(editor.getBody())));
	      };
	      var destroy = function () {
	        resize.each(function (sz) {
	          sz.destroy();
	        });
	        wire.each(function (w) {
	          TableWire.remove(editor, w);
	        });
	      };
	      editor.on('init', function () {
	        var direction = TableDirection(Direction.directionAt);
	        var rawWire = TableWire.get(editor);
	        wire = Option.some(rawWire);
	        if (hasObjectResizing(editor) && hasTableResizeBars(editor)) {
	          var sz = TableResize.create(rawWire, direction);
	          sz.on();
	          sz.events.startDrag.bind(function (event) {
	            selectionRng = Option.some(editor.selection.getRng());
	          });
	          sz.events.beforeResize.bind(function (event) {
	            var rawTable = event.table().dom();
	            fireObjectResizeStart(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable));
	          });
	          sz.events.afterResize.bind(function (event) {
	            var table = event.table();
	            var rawTable = table.dom();
	            removeDataStyle(table);
	            selectionRng.each(function (rng) {
	              editor.selection.setRng(rng);
	              editor.focus();
	            });
	            fireObjectResized(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable));
	            editor.undoManager.add();
	          });
	          resize = Option.some(sz);
	        }
	      });
	      editor.on('ObjectResizeStart', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          startW = e.width;
	          startRawW = getRawWidth(targetElm);
	        }
	      });
	      editor.on('ObjectResized', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          var table = targetElm;
	          if (percentageBasedSizeRegex.test(startRawW)) {
	            var percentW = parseFloat(percentageBasedSizeRegex.exec(startRawW)[1]);
	            var targetPercentW = e.width * percentW / startW;
	            editor.dom.setStyle(table, 'width', targetPercentW + '%');
	          } else {
	            var newCellSizes_1 = [];
	            global$1.each(table.rows, function (row) {
	              global$1.each(row.cells, function (cell) {
	                var width = editor.dom.getStyle(cell, 'width', true);
	                newCellSizes_1.push({
	                  cell: cell,
	                  width: width
	                });
	              });
	            });
	            global$1.each(newCellSizes_1, function (newCellSize) {
	              editor.dom.setStyle(newCellSize.cell, 'width', newCellSize.width);
	              editor.dom.setAttrib(newCellSize.cell, 'width', null);
	            });
	          }
	        }
	      });
	      return {
	        lazyResize: lazyResize,
	        lazyWire: lazyWire,
	        destroy: destroy
	      };
	    };
	
	    var adt$1 = Adt.generate([
	      { none: ['current'] },
	      { first: ['current'] },
	      {
	        middle: [
	          'current',
	          'target'
	        ]
	      },
	      { last: ['current'] }
	    ]);
	    var none$1 = function (current) {
	      if (current === void 0) {
	        current = undefined;
	      }
	      return adt$1.none(current);
	    };
	    var CellLocation = __assign(__assign({}, adt$1), { none: none$1 });
	
	    var detect$4 = function (current, isRoot) {
	      return TableLookup.table(current, isRoot).bind(function (table) {
	        var all = TableLookup.cells(table);
	        var index = findIndex(all, function (x) {
	          return eq(current, x);
	        });
	        return index.map(function (ind) {
	          return {
	            index: constant(ind),
	            all: constant(all)
	          };
	        });
	      });
	    };
	    var next = function (current, isRoot) {
	      var detection = detect$4(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none(current);
	      }, function (info) {
	        return info.index() + 1 < info.all().length ? CellLocation.middle(current, info.all()[info.index() + 1]) : CellLocation.last(current);
	      });
	    };
	    var prev = function (current, isRoot) {
	      var detection = detect$4(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none();
	      }, function (info) {
	        return info.index() - 1 >= 0 ? CellLocation.middle(current, info.all()[info.index() - 1]) : CellLocation.first(current);
	      });
	    };
	    var CellNavigation = {
	      next: next,
	      prev: prev
	    };
	
	    var create$3 = Immutable('start', 'soffset', 'finish', 'foffset');
	    var SimRange = { create: create$3 };
	
	    var adt$2 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata$1 = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$2 = adt$2.before;
	    var on = adt$2.on;
	    var after$2 = adt$2.after;
	    var Situ = {
	      before: before$2,
	      on: on,
	      after: after$2,
	      cata: cata$1,
	      getStart: getStart
	    };
	
	    var adt$3 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$3.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return Element.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$3.domRange;
	    var relative = adt$3.relative;
	    var exact = adt$3.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range$1 = SimRange.create;
	    var Selection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range$1
	    };
	
	    var selectNodeContents = function (win, element) {
	      var rng = win.document.createRange();
	      selectNodeContentsUsing(rng, element);
	      return rng;
	    };
	    var selectNodeContentsUsing = function (rng, element) {
	      rng.selectNodeContents(element.dom());
	    };
	    var setStart = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setStartBefore(e.dom());
	      }, function (e, o) {
	        rng.setStart(e.dom(), o);
	      }, function (e) {
	        rng.setStartAfter(e.dom());
	      });
	    };
	    var setFinish = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setEndBefore(e.dom());
	      }, function (e, o) {
	        rng.setEnd(e.dom(), o);
	      }, function (e) {
	        rng.setEndAfter(e.dom());
	      });
	    };
	    var relativeToNative = function (win, startSitu, finishSitu) {
	      var range = win.document.createRange();
	      setStart(range, startSitu);
	      setFinish(range, finishSitu);
	      return range;
	    };
	    var exactToNative = function (win, start, soffset, finish, foffset) {
	      var rng = win.document.createRange();
	      rng.setStart(start.dom(), soffset);
	      rng.setEnd(finish.dom(), foffset);
	      return rng;
	    };
	    var toRect = function (rect) {
	      return {
	        left: constant(rect.left),
	        top: constant(rect.top),
	        right: constant(rect.right),
	        bottom: constant(rect.bottom),
	        width: constant(rect.width),
	        height: constant(rect.height)
	      };
	    };
	    var getFirstRect = function (rng) {
	      var rects = rng.getClientRects();
	      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Option.some(rect).map(toRect) : Option.none();
	    };
	
	    var adt$4 = Adt.generate([
	      {
	        ltr: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      },
	      {
	        rtl: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var fromRange = function (win, type, range) {
	      return type(Element.fromDom(range.startContainer), range.startOffset, Element.fromDom(range.endContainer), range.endOffset);
	    };
	    var getRanges = function (win, selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return {
	            ltr: constant(rng),
	            rtl: Option.none
	          };
	        },
	        relative: function (startSitu, finishSitu) {
	          return {
	            ltr: cached(function () {
	              return relativeToNative(win, startSitu, finishSitu);
	            }),
	            rtl: cached(function () {
	              return Option.some(relativeToNative(win, finishSitu, startSitu));
	            })
	          };
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return {
	            ltr: cached(function () {
	              return exactToNative(win, start, soffset, finish, foffset);
	            }),
	            rtl: cached(function () {
	              return Option.some(exactToNative(win, finish, foffset, start, soffset));
	            })
	          };
	        }
	      });
	    };
	    var doDiagnose = function (win, ranges) {
	      var rng = ranges.ltr();
	      if (rng.collapsed) {
	        var reversed = ranges.rtl().filter(function (rev) {
	          return rev.collapsed === false;
	        });
	        return reversed.map(function (rev) {
	          return adt$4.rtl(Element.fromDom(rev.endContainer), rev.endOffset, Element.fromDom(rev.startContainer), rev.startOffset);
	        }).getOrThunk(function () {
	          return fromRange(win, adt$4.ltr, rng);
	        });
	      } else {
	        return fromRange(win, adt$4.ltr, rng);
	      }
	    };
	    var diagnose = function (win, selection) {
	      var ranges = getRanges(win, selection);
	      return doDiagnose(win, ranges);
	    };
	    var asLtrRange = function (win, selection) {
	      var diagnosis = diagnose(win, selection);
	      return diagnosis.match({
	        ltr: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(start.dom(), soffset);
	          rng.setEnd(finish.dom(), foffset);
	          return rng;
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(finish.dom(), foffset);
	          rng.setEnd(start.dom(), soffset);
	          return rng;
	        }
	      });
	    };
	
	    var searchForPoint = function (rectForOffset, x, y, maxX, length) {
	      if (length === 0) {
	        return 0;
	      } else if (x === maxX) {
	        return length - 1;
	      }
	      var xDelta = maxX;
	      for (var i = 1; i < length; i++) {
	        var rect = rectForOffset(i);
	        var curDeltaX = Math.abs(x - rect.left);
	        if (y <= rect.bottom) {
	          if (y < rect.top || curDeltaX > xDelta) {
	            return i - 1;
	          } else {
	            xDelta = curDeltaX;
	          }
	        }
	      }
	      return 0;
	    };
	    var inRect = function (rect, x, y) {
	      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
	    };
	
	    var locateOffset = function (doc, textnode, x, y, rect) {
	      var rangeForOffset = function (o) {
	        var r = doc.dom().createRange();
	        r.setStart(textnode.dom(), o);
	        r.collapse(true);
	        return r;
	      };
	      var rectForOffset = function (o) {
	        var r = rangeForOffset(o);
	        return r.getBoundingClientRect();
	      };
	      var length = get$2(textnode).length;
	      var offset = searchForPoint(rectForOffset, x, y, rect.right, length);
	      return rangeForOffset(offset);
	    };
	    var locate = function (doc, node, x, y) {
	      var r = doc.dom().createRange();
	      r.selectNode(node.dom());
	      var rects = r.getClientRects();
	      var foundRect = findMap(rects, function (rect) {
	        return inRect(rect, x, y) ? Option.some(rect) : Option.none();
	      });
	      return foundRect.map(function (rect) {
	        return locateOffset(doc, node, x, y, rect);
	      });
	    };
	
	    var searchInChildren = function (doc, node, x, y) {
	      var r = doc.dom().createRange();
	      var nodes = children(node);
	      return findMap(nodes, function (n) {
	        r.selectNode(n.dom());
	        return inRect(r.getBoundingClientRect(), x, y) ? locateNode(doc, n, x, y) : Option.none();
	      });
	    };
	    var locateNode = function (doc, node, x, y) {
	      return isText(node) ? locate(doc, node, x, y) : searchInChildren(doc, node, x, y);
	    };
	    var locate$1 = function (doc, node, x, y) {
	      var r = doc.dom().createRange();
	      r.selectNode(node.dom());
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locateNode(doc, node, boundedX, boundedY);
	    };
	
	    var COLLAPSE_TO_LEFT = true;
	    var COLLAPSE_TO_RIGHT = false;
	    var getCollapseDirection = function (rect, x) {
	      return x - rect.left < rect.right - x ? COLLAPSE_TO_LEFT : COLLAPSE_TO_RIGHT;
	    };
	    var createCollapsedNode = function (doc, target, collapseDirection) {
	      var r = doc.dom().createRange();
	      r.selectNode(target.dom());
	      r.collapse(collapseDirection);
	      return r;
	    };
	    var locateInElement = function (doc, node, x) {
	      var cursorRange = doc.dom().createRange();
	      cursorRange.selectNode(node.dom());
	      var rect = cursorRange.getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      var f = collapseDirection === COLLAPSE_TO_LEFT ? first : last$1;
	      return f(node).map(function (target) {
	        return createCollapsedNode(doc, target, collapseDirection);
	      });
	    };
	    var locateInEmpty = function (doc, node, x) {
	      var rect = node.dom().getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      return Option.some(createCollapsedNode(doc, node, collapseDirection));
	    };
	    var search = function (doc, node, x) {
	      var f = children(node).length === 0 ? locateInEmpty : locateInElement;
	      return f(doc, node, x);
	    };
	
	    var caretPositionFromPoint = function (doc, x, y) {
	      return Option.from(doc.dom().caretPositionFromPoint(x, y)).bind(function (pos) {
	        if (pos.offsetNode === null) {
	          return Option.none();
	        }
	        var r = doc.dom().createRange();
	        r.setStart(pos.offsetNode, pos.offset);
	        r.collapse();
	        return Option.some(r);
	      });
	    };
	    var caretRangeFromPoint = function (doc, x, y) {
	      return Option.from(doc.dom().caretRangeFromPoint(x, y));
	    };
	    var searchTextNodes = function (doc, node, x, y) {
	      var r = doc.dom().createRange();
	      r.selectNode(node.dom());
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locate$1(doc, node, boundedX, boundedY);
	    };
	    var searchFromPoint = function (doc, x, y) {
	      return Element.fromPoint(doc, x, y).bind(function (elem) {
	        var fallback = function () {
	          return search(doc, elem, x);
	        };
	        return children(elem).length === 0 ? fallback() : searchTextNodes(doc, elem, x, y).orThunk(fallback);
	      });
	    };
	    var availableSearch = document.caretPositionFromPoint ? caretPositionFromPoint : document.caretRangeFromPoint ? caretRangeFromPoint : searchFromPoint;
	    var fromPoint$1 = function (win, x, y) {
	      var doc = Element.fromDom(win.document);
	      return availableSearch(doc, x, y).map(function (rng) {
	        return SimRange.create(Element.fromDom(rng.startContainer), rng.startOffset, Element.fromDom(rng.endContainer), rng.endOffset);
	      });
	    };
	
	    var beforeSpecial = function (element, offset) {
	      var name$1 = name(element);
	      if ('input' === name$1) {
	        return Situ.after(element);
	      } else if (!contains([
	          'br',
	          'img'
	        ], name$1)) {
	        return Situ.on(element, offset);
	      } else {
	        return offset === 0 ? Situ.before(element) : Situ.after(element);
	      }
	    };
	    var preprocessRelative = function (startSitu, finishSitu) {
	      var start = startSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      var finish = finishSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      return Selection.relative(start, finish);
	    };
	    var preprocessExact = function (start, soffset, finish, foffset) {
	      var startSitu = beforeSpecial(start, soffset);
	      var finishSitu = beforeSpecial(finish, foffset);
	      return Selection.relative(startSitu, finishSitu);
	    };
	    var preprocess = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          var start = Element.fromDom(rng.startContainer);
	          var finish = Element.fromDom(rng.endContainer);
	          return preprocessExact(start, rng.startOffset, finish, rng.endOffset);
	        },
	        relative: preprocessRelative,
	        exact: preprocessExact
	      });
	    };
	
	    var makeRange = function (start, soffset, finish, foffset) {
	      var doc = owner(start);
	      var rng = doc.dom().createRange();
	      rng.setStart(start.dom(), soffset);
	      rng.setEnd(finish.dom(), foffset);
	      return rng;
	    };
	    var after$3 = function (start, soffset, finish, foffset) {
	      var r = makeRange(start, soffset, finish, foffset);
	      var same = eq(start, finish) && soffset === foffset;
	      return r.collapsed && !same;
	    };
	
	    var doSetNativeRange = function (win, rng) {
	      Option.from(win.getSelection()).each(function (selection) {
	        selection.removeAllRanges();
	        selection.addRange(rng);
	      });
	    };
	    var doSetRange = function (win, start, soffset, finish, foffset) {
	      var rng = exactToNative(win, start, soffset, finish, foffset);
	      doSetNativeRange(win, rng);
	    };
	    var setLegacyRtlRange = function (win, selection, start, soffset, finish, foffset) {
	      selection.collapse(start.dom(), soffset);
	      selection.extend(finish.dom(), foffset);
	    };
	    var setRangeFromRelative = function (win, relative) {
	      return diagnose(win, relative).match({
	        ltr: function (start, soffset, finish, foffset) {
	          doSetRange(win, start, soffset, finish, foffset);
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var selection = win.getSelection();
	          if (selection.setBaseAndExtent) {
	            selection.setBaseAndExtent(start.dom(), soffset, finish.dom(), foffset);
	          } else if (selection.extend) {
	            try {
	              setLegacyRtlRange(win, selection, start, soffset, finish, foffset);
	            } catch (e) {
	              doSetRange(win, finish, foffset, start, soffset);
	            }
	          } else {
	            doSetRange(win, finish, foffset, start, soffset);
	          }
	        }
	      });
	    };
	    var setExact = function (win, start, soffset, finish, foffset) {
	      var relative = preprocessExact(start, soffset, finish, foffset);
	      setRangeFromRelative(win, relative);
	    };
	    var setRelative = function (win, startSitu, finishSitu) {
	      var relative = preprocessRelative(startSitu, finishSitu);
	      setRangeFromRelative(win, relative);
	    };
	    var toNative = function (selection) {
	      var win = Selection.getWin(selection).dom();
	      var getDomRange = function (start, soffset, finish, foffset) {
	        return exactToNative(win, start, soffset, finish, foffset);
	      };
	      var filtered = preprocess(selection);
	      return diagnose(win, filtered).match({
	        ltr: getDomRange,
	        rtl: getDomRange
	      });
	    };
	    var readRange = function (selection) {
	      if (selection.rangeCount > 0) {
	        var firstRng = selection.getRangeAt(0);
	        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
	        return Option.some(SimRange.create(Element.fromDom(firstRng.startContainer), firstRng.startOffset, Element.fromDom(lastRng.endContainer), lastRng.endOffset));
	      } else {
	        return Option.none();
	      }
	    };
	    var doGetExact = function (selection) {
	      var anchor = Element.fromDom(selection.anchorNode);
	      var focus = Element.fromDom(selection.focusNode);
	      return after$3(anchor, selection.anchorOffset, focus, selection.focusOffset) ? Option.some(SimRange.create(anchor, selection.anchorOffset, focus, selection.focusOffset)) : readRange(selection);
	    };
	    var setToElement = function (win, element) {
	      var rng = selectNodeContents(win, element);
	      doSetNativeRange(win, rng);
	    };
	    var getExact = function (win) {
	      return Option.from(win.getSelection()).filter(function (sel) {
	        return sel.rangeCount > 0;
	      }).bind(doGetExact);
	    };
	    var get$9 = function (win) {
	      return getExact(win).map(function (range) {
	        return Selection.exact(range.start(), range.soffset(), range.finish(), range.foffset());
	      });
	    };
	    var getFirstRect$1 = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getFirstRect(rng);
	    };
	    var getAtPoint = function (win, x, y) {
	      return fromPoint$1(win, x, y);
	    };
	    var clear = function (win) {
	      var selection = win.getSelection();
	      selection.removeAllRanges();
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var forward = function (editor, isRoot, cell, lazyWire) {
	      return go(editor, isRoot, CellNavigation.next(cell), lazyWire);
	    };
	    var backward = function (editor, isRoot, cell, lazyWire) {
	      return go(editor, isRoot, CellNavigation.prev(cell), lazyWire);
	    };
	    var getCellFirstCursorPosition = function (editor, cell) {
	      var selection = Selection.exact(cell, 0, cell, 0);
	      return toNative(selection);
	    };
	    var getNewRowCursorPosition = function (editor, table) {
	      var rows = descendants$1(table, 'tr');
	      return last(rows).bind(function (last) {
	        return descendant$1(last, 'td,th').map(function (first) {
	          return getCellFirstCursorPosition(editor, first);
	        });
	      });
	    };
	    var go = function (editor, isRoot, cell, actions, lazyWire) {
	      return cell.fold(Option.none, Option.none, function (current, next) {
	        return first(next).map(function (cell) {
	          return getCellFirstCursorPosition(editor, cell);
	        });
	      }, function (current) {
	        return TableLookup.table(current, isRoot).bind(function (table) {
	          var targets = TableTargets.noMenu(current);
	          editor.undoManager.transact(function () {
	            actions.insertRowsAfter(table, targets);
	          });
	          return getNewRowCursorPosition(editor, table);
	        });
	      });
	    };
	    var rootElements = [
	      'table',
	      'li',
	      'dl'
	    ];
	    var handle$1 = function (event, editor, actions, lazyWire) {
	      if (event.keyCode === global$3.TAB) {
	        var body_1 = getBody$1(editor);
	        var isRoot_1 = function (element) {
	          var name$1 = name(element);
	          return eq(element, body_1) || contains(rootElements, name$1);
	        };
	        var rng = editor.selection.getRng();
	        if (rng.collapsed) {
	          var start = Element.fromDom(rng.startContainer);
	          TableLookup.cell(start, isRoot_1).each(function (cell) {
	            event.preventDefault();
	            var navigation = event.shiftKey ? backward : forward;
	            var rng = navigation(editor, isRoot_1, cell, actions, lazyWire);
	            rng.each(function (range) {
	              editor.selection.setRng(range);
	            });
	          });
	        }
	      }
	    };
	    var TabContext = { handle: handle$1 };
	
	    var create$4 = Immutable('selection', 'kill');
	    var Response = { create: create$4 };
	
	    var create$5 = function (start, soffset, finish, foffset) {
	      return {
	        start: constant(Situ.on(start, soffset)),
	        finish: constant(Situ.on(finish, foffset))
	      };
	    };
	    var Situs = { create: create$5 };
	
	    var convertToRange = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return SimRange.create(Element.fromDom(rng.startContainer), rng.startOffset, Element.fromDom(rng.endContainer), rng.endOffset);
	    };
	    var makeSitus = Situs.create;
	    var Util = {
	      convertToRange: convertToRange,
	      makeSitus: makeSitus
	    };
	
	    var sync = function (container, isRoot, start, soffset, finish, foffset, selectRange) {
	      if (!(eq(start, finish) && soffset === foffset)) {
	        return closest$1(start, 'td,th', isRoot).bind(function (s) {
	          return closest$1(finish, 'td,th', isRoot).bind(function (f) {
	            return detect$5(container, isRoot, s, f, selectRange);
	          });
	        });
	      } else {
	        return Option.none();
	      }
	    };
	    var detect$5 = function (container, isRoot, start, finish, selectRange) {
	      if (!eq(start, finish)) {
	        return CellSelection.identify(start, finish, isRoot).bind(function (cellSel) {
	          var boxes = cellSel.boxes().getOr([]);
	          if (boxes.length > 0) {
	            selectRange(container, boxes, cellSel.start(), cellSel.finish());
	            return Option.some(Response.create(Option.some(Util.makeSitus(start, 0, start, getEnd(start))), true));
	          } else {
	            return Option.none();
	          }
	        });
	      } else {
	        return Option.none();
	      }
	    };
	    var update = function (rows, columns, container, selected, annotations) {
	      var updateSelection = function (newSels) {
	        annotations.clear(container);
	        annotations.selectRange(container, newSels.boxes(), newSels.start(), newSels.finish());
	        return newSels.boxes();
	      };
	      return CellSelection.shiftSelection(selected, rows, columns, annotations.firstSelectedSelector(), annotations.lastSelectedSelector()).map(updateSelection);
	    };
	    var KeySelection = {
	      sync: sync,
	      detect: detect$5,
	      update: update
	    };
	
	    var traverse = Immutable('item', 'mode');
	    var backtrack = function (universe, item, _direction, transition) {
	      if (transition === void 0) {
	        transition = sidestep;
	      }
	      return universe.property().parent(item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var sidestep = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      return direction.sibling(universe, item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var advance = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      var children = universe.property().children(item);
	      var result = direction.first(children);
	      return result.map(function (r) {
	        return traverse(r, transition);
	      });
	    };
	    var successors = [
	      {
	        current: backtrack,
	        next: sidestep,
	        fallback: Option.none()
	      },
	      {
	        current: sidestep,
	        next: advance,
	        fallback: Option.some(backtrack)
	      },
	      {
	        current: advance,
	        next: advance,
	        fallback: Option.some(sidestep)
	      }
	    ];
	    var go$1 = function (universe, item, mode, direction, rules) {
	      if (rules === void 0) {
	        rules = successors;
	      }
	      var ruleOpt = find(rules, function (succ) {
	        return succ.current === mode;
	      });
	      return ruleOpt.bind(function (rule) {
	        return rule.current(universe, item, direction, rule.next).orThunk(function () {
	          return rule.fallback.bind(function (fb) {
	            return go$1(universe, item, fb, direction);
	          });
	        });
	      });
	    };
	
	    var left = function () {
	      var sibling = function (universe, item) {
	        return universe.query().prevSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Option.some(children[children.length - 1]) : Option.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var right = function () {
	      var sibling = function (universe, item) {
	        return universe.query().nextSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Option.some(children[0]) : Option.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var Walkers = {
	      left: left,
	      right: right
	    };
	
	    var hone = function (universe, item, predicate, mode, direction, isRoot) {
	      var next = go$1(universe, item, mode, direction);
	      return next.bind(function (n) {
	        if (isRoot(n.item())) {
	          return Option.none();
	        } else {
	          return predicate(n.item()) ? Option.some(n.item()) : hone(universe, n.item(), predicate, n.mode(), direction, isRoot);
	        }
	      });
	    };
	    var left$1 = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.left(), isRoot);
	    };
	    var right$1 = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.right(), isRoot);
	    };
	
	    var isLeaf = function (universe) {
	      return function (element) {
	        return universe.property().children(element).length === 0;
	      };
	    };
	    var before$3 = function (universe, item, isRoot) {
	      return seekLeft(universe, item, isLeaf(universe), isRoot);
	    };
	    var after$4 = function (universe, item, isRoot) {
	      return seekRight(universe, item, isLeaf(universe), isRoot);
	    };
	    var seekLeft = left$1;
	    var seekRight = right$1;
	
	    var universe$2 = DomUniverse();
	    var before$4 = function (element, isRoot) {
	      return before$3(universe$2, element, isRoot);
	    };
	    var after$5 = function (element, isRoot) {
	      return after$4(universe$2, element, isRoot);
	    };
	    var seekLeft$1 = function (element, predicate, isRoot) {
	      return seekLeft(universe$2, element, predicate, isRoot);
	    };
	    var seekRight$1 = function (element, predicate, isRoot) {
	      return seekRight(universe$2, element, predicate, isRoot);
	    };
	
	    var ancestor$2 = function (scope, predicate, isRoot) {
	      return ancestor(scope, predicate, isRoot).isSome();
	    };
	
	    var point = Immutable('element', 'offset');
	    var delta = Immutable('element', 'deltaOffset');
	    var range$2 = Immutable('element', 'start', 'finish');
	    var points = Immutable('begin', 'end');
	    var text = Immutable('element', 'text');
	
	    var adt$5 = Adt.generate([
	      { none: ['message'] },
	      { success: [] },
	      { failedUp: ['cell'] },
	      { failedDown: ['cell'] }
	    ]);
	    var isOverlapping = function (bridge, before, after) {
	      var beforeBounds = bridge.getRect(before);
	      var afterBounds = bridge.getRect(after);
	      return afterBounds.right > beforeBounds.left && afterBounds.left < beforeBounds.right;
	    };
	    var isRow = function (elem) {
	      return closest$1(elem, 'tr');
	    };
	    var verify = function (bridge, before, beforeOffset, after, afterOffset, failure, isRoot) {
	      return closest$1(after, 'td,th', isRoot).bind(function (afterCell) {
	        return closest$1(before, 'td,th', isRoot).map(function (beforeCell) {
	          if (!eq(afterCell, beforeCell)) {
	            return DomParent.sharedOne(isRow, [
	              afterCell,
	              beforeCell
	            ]).fold(function () {
	              return isOverlapping(bridge, beforeCell, afterCell) ? adt$5.success() : failure(beforeCell);
	            }, function (_sharedRow) {
	              return failure(beforeCell);
	            });
	          } else {
	            return eq(after, afterCell) && getEnd(afterCell) === afterOffset ? failure(beforeCell) : adt$5.none('in same cell');
	          }
	        });
	      }).getOr(adt$5.none('default'));
	    };
	    var cata$2 = function (subject, onNone, onSuccess, onFailedUp, onFailedDown) {
	      return subject.fold(onNone, onSuccess, onFailedUp, onFailedDown);
	    };
	    var BeforeAfter = __assign(__assign({}, adt$5), {
	      verify: verify,
	      cata: cata$2
	    });
	
	    var inAncestor = Immutable('ancestor', 'descendants', 'element', 'index');
	    var inParent = Immutable('parent', 'children', 'element', 'index');
	    var indexInParent = function (element) {
	      return parent(element).bind(function (parent) {
	        var children$1 = children(parent);
	        return indexOf(children$1, element).map(function (index) {
	          return inParent(parent, children$1, element, index);
	        });
	      });
	    };
	    var indexOf = function (elements, element) {
	      return findIndex(elements, curry(eq, element));
	    };
	
	    var isBr = function (elem) {
	      return name(elem) === 'br';
	    };
	    var gatherer = function (cand, gather, isRoot) {
	      return gather(cand, isRoot).bind(function (target) {
	        return isText(target) && get$2(target).trim().length === 0 ? gatherer(target, gather, isRoot) : Option.some(target);
	      });
	    };
	    var handleBr = function (isRoot, element, direction) {
	      return direction.traverse(element).orThunk(function () {
	        return gatherer(element, direction.gather, isRoot);
	      }).map(direction.relative);
	    };
	    var findBr = function (element, offset) {
	      return child(element, offset).filter(isBr).orThunk(function () {
	        return child(element, offset - 1).filter(isBr);
	      });
	    };
	    var handleParent = function (isRoot, element, offset, direction) {
	      return findBr(element, offset).bind(function (br) {
	        return direction.traverse(br).fold(function () {
	          return gatherer(br, direction.gather, isRoot).map(direction.relative);
	        }, function (adjacent) {
	          return indexInParent(adjacent).map(function (info) {
	            return Situ.on(info.parent(), info.index());
	          });
	        });
	      });
	    };
	    var tryBr = function (isRoot, element, offset, direction) {
	      var target = isBr(element) ? handleBr(isRoot, element, direction) : handleParent(isRoot, element, offset, direction);
	      return target.map(function (tgt) {
	        return {
	          start: constant(tgt),
	          finish: constant(tgt)
	        };
	      });
	    };
	    var process = function (analysis) {
	      return BeforeAfter.cata(analysis, function (message) {
	        return Option.none();
	      }, function () {
	        return Option.none();
	      }, function (cell) {
	        return Option.some(point(cell, 0));
	      }, function (cell) {
	        return Option.some(point(cell, getEnd(cell)));
	      });
	    };
	    var BrTags = {
	      tryBr: tryBr,
	      process: process
	    };
	
	    var nu$3 = MixedBag([
	      'left',
	      'top',
	      'right',
	      'bottom'
	    ], []);
	    var moveDown = function (caret, amount) {
	      return nu$3({
	        left: caret.left(),
	        top: caret.top() + amount,
	        right: caret.right(),
	        bottom: caret.bottom() + amount
	      });
	    };
	    var moveUp = function (caret, amount) {
	      return nu$3({
	        left: caret.left(),
	        top: caret.top() - amount,
	        right: caret.right(),
	        bottom: caret.bottom() - amount
	      });
	    };
	    var moveBottomTo = function (caret, bottom) {
	      var height = caret.bottom() - caret.top();
	      return nu$3({
	        left: caret.left(),
	        top: bottom - height,
	        right: caret.right(),
	        bottom: bottom
	      });
	    };
	    var moveTopTo = function (caret, top) {
	      var height = caret.bottom() - caret.top();
	      return nu$3({
	        left: caret.left(),
	        top: top,
	        right: caret.right(),
	        bottom: top + height
	      });
	    };
	    var translate = function (caret, xDelta, yDelta) {
	      return nu$3({
	        left: caret.left() + xDelta,
	        top: caret.top() + yDelta,
	        right: caret.right() + xDelta,
	        bottom: caret.bottom() + yDelta
	      });
	    };
	    var getTop$1 = function (caret) {
	      return caret.top();
	    };
	    var getBottom = function (caret) {
	      return caret.bottom();
	    };
	    var toString = function (caret) {
	      return '(' + caret.left() + ', ' + caret.top() + ') -> (' + caret.right() + ', ' + caret.bottom() + ')';
	    };
	    var Carets = {
	      nu: nu$3,
	      moveUp: moveUp,
	      moveDown: moveDown,
	      moveBottomTo: moveBottomTo,
	      moveTopTo: moveTopTo,
	      getTop: getTop$1,
	      getBottom: getBottom,
	      translate: translate,
	      toString: toString
	    };
	
	    var getPartialBox = function (bridge, element, offset) {
	      if (offset >= 0 && offset < getEnd(element)) {
	        return bridge.getRangedRect(element, offset, element, offset + 1);
	      } else if (offset > 0) {
	        return bridge.getRangedRect(element, offset - 1, element, offset);
	      }
	      return Option.none();
	    };
	    var toCaret = function (rect) {
	      return Carets.nu({
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom
	      });
	    };
	    var getElemBox = function (bridge, element) {
	      return Option.some(bridge.getRect(element));
	    };
	    var getBoxAt = function (bridge, element, offset) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return getPartialBox(bridge, element, offset).map(toCaret);
	      } else {
	        return Option.none();
	      }
	    };
	    var getEntireBox = function (bridge, element) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return bridge.getRangedRect(element, 0, element, getEnd(element)).map(toCaret);
	      } else {
	        return Option.none();
	      }
	    };
	    var Rectangles = {
	      getBoxAt: getBoxAt,
	      getEntireBox: getEntireBox
	    };
	
	    var JUMP_SIZE = 5;
	    var NUM_RETRIES = 100;
	    var adt$6 = Adt.generate([
	      { none: [] },
	      { retry: ['caret'] }
	    ]);
	    var isOutside = function (caret, box) {
	      return caret.left() < box.left() || Math.abs(box.right() - caret.left()) < 1 || caret.left() > box.right();
	    };
	    var inOutsideBlock = function (bridge, element, caret) {
	      return closest(element, DomStructure.isBlock).fold(constant(false), function (cell) {
	        return Rectangles.getEntireBox(bridge, cell).exists(function (box) {
	          return isOutside(caret, box);
	        });
	      });
	    };
	    var adjustDown = function (bridge, element, guessBox, original, caret) {
	      var lowerCaret = Carets.moveDown(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.bottom() - original.bottom()) < 1) {
	        return adt$6.retry(lowerCaret);
	      } else if (guessBox.top() > caret.bottom()) {
	        return adt$6.retry(lowerCaret);
	      } else if (guessBox.top() === caret.bottom()) {
	        return adt$6.retry(Carets.moveDown(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt$6.retry(Carets.translate(lowerCaret, JUMP_SIZE, 0)) : adt$6.none();
	      }
	    };
	    var adjustUp = function (bridge, element, guessBox, original, caret) {
	      var higherCaret = Carets.moveUp(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.top() - original.top()) < 1) {
	        return adt$6.retry(higherCaret);
	      } else if (guessBox.bottom() < caret.top()) {
	        return adt$6.retry(higherCaret);
	      } else if (guessBox.bottom() === caret.top()) {
	        return adt$6.retry(Carets.moveUp(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt$6.retry(Carets.translate(higherCaret, JUMP_SIZE, 0)) : adt$6.none();
	      }
	    };
	    var upMovement = {
	      point: Carets.getTop,
	      adjuster: adjustUp,
	      move: Carets.moveUp,
	      gather: before$4
	    };
	    var downMovement = {
	      point: Carets.getBottom,
	      adjuster: adjustDown,
	      move: Carets.moveDown,
	      gather: after$5
	    };
	    var isAtTable = function (bridge, x, y) {
	      return bridge.elementFromPoint(x, y).filter(function (elm) {
	        return name(elm) === 'table';
	      }).isSome();
	    };
	    var adjustForTable = function (bridge, movement, original, caret, numRetries) {
	      return adjustTil(bridge, movement, original, movement.move(caret, JUMP_SIZE), numRetries);
	    };
	    var adjustTil = function (bridge, movement, original, caret, numRetries) {
	      if (numRetries === 0) {
	        return Option.some(caret);
	      }
	      if (isAtTable(bridge, caret.left(), movement.point(caret))) {
	        return adjustForTable(bridge, movement, original, caret, numRetries - 1);
	      }
	      return bridge.situsFromPoint(caret.left(), movement.point(caret)).bind(function (guess) {
	        return guess.start().fold(Option.none, function (element) {
	          return Rectangles.getEntireBox(bridge, element).bind(function (guessBox) {
	            return movement.adjuster(bridge, element, guessBox, original, caret).fold(Option.none, function (newCaret) {
	              return adjustTil(bridge, movement, original, newCaret, numRetries - 1);
	            });
	          }).orThunk(function () {
	            return Option.some(caret);
	          });
	        }, Option.none);
	      });
	    };
	    var ieTryDown = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left(), caret.bottom() + JUMP_SIZE);
	    };
	    var ieTryUp = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left(), caret.top() - JUMP_SIZE);
	    };
	    var checkScroll = function (movement, adjusted, bridge) {
	      if (movement.point(adjusted) > bridge.getInnerHeight()) {
	        return Option.some(movement.point(adjusted) - bridge.getInnerHeight());
	      } else if (movement.point(adjusted) < 0) {
	        return Option.some(-movement.point(adjusted));
	      } else {
	        return Option.none();
	      }
	    };
	    var retry = function (movement, bridge, caret) {
	      var moved = movement.move(caret, JUMP_SIZE);
	      var adjusted = adjustTil(bridge, movement, caret, moved, NUM_RETRIES).getOr(moved);
	      return checkScroll(movement, adjusted, bridge).fold(function () {
	        return bridge.situsFromPoint(adjusted.left(), movement.point(adjusted));
	      }, function (delta) {
	        bridge.scrollBy(0, delta);
	        return bridge.situsFromPoint(adjusted.left(), movement.point(adjusted) - delta);
	      });
	    };
	    var Retries = {
	      tryUp: curry(retry, upMovement),
	      tryDown: curry(retry, downMovement),
	      ieTryUp: ieTryUp,
	      ieTryDown: ieTryDown,
	      getJumpSize: constant(JUMP_SIZE)
	    };
	
	    var MAX_RETRIES = 20;
	    var platform$1 = PlatformDetection$1.detect();
	    var findSpot = function (bridge, isRoot, direction) {
	      return bridge.getSelection().bind(function (sel) {
	        return BrTags.tryBr(isRoot, sel.finish(), sel.foffset(), direction).fold(function () {
	          return Option.some(point(sel.finish(), sel.foffset()));
	        }, function (brNeighbour) {
	          var range = bridge.fromSitus(brNeighbour);
	          var analysis = BeforeAfter.verify(bridge, sel.finish(), sel.foffset(), range.finish(), range.foffset(), direction.failure, isRoot);
	          return BrTags.process(analysis);
	        });
	      });
	    };
	    var scan = function (bridge, isRoot, element, offset, direction, numRetries) {
	      if (numRetries === 0) {
	        return Option.none();
	      }
	      return tryCursor(bridge, isRoot, element, offset, direction).bind(function (situs) {
	        var range = bridge.fromSitus(situs);
	        var analysis = BeforeAfter.verify(bridge, element, offset, range.finish(), range.foffset(), direction.failure, isRoot);
	        return BeforeAfter.cata(analysis, function () {
	          return Option.none();
	        }, function () {
	          return Option.some(situs);
	        }, function (cell) {
	          if (eq(element, cell) && offset === 0) {
	            return tryAgain(bridge, element, offset, Carets.moveUp, direction);
	          } else {
	            return scan(bridge, isRoot, cell, 0, direction, numRetries - 1);
	          }
	        }, function (cell) {
	          if (eq(element, cell) && offset === getEnd(cell)) {
	            return tryAgain(bridge, element, offset, Carets.moveDown, direction);
	          } else {
	            return scan(bridge, isRoot, cell, getEnd(cell), direction, numRetries - 1);
	          }
	        });
	      });
	    };
	    var tryAgain = function (bridge, element, offset, move, direction) {
	      return Rectangles.getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, move(box, Retries.getJumpSize()));
	      });
	    };
	    var tryAt = function (bridge, direction, box) {
	      if (platform$1.browser.isChrome() || platform$1.browser.isSafari() || platform$1.browser.isFirefox() || platform$1.browser.isEdge()) {
	        return direction.otherRetry(bridge, box);
	      } else if (platform$1.browser.isIE()) {
	        return direction.ieRetry(bridge, box);
	      } else {
	        return Option.none();
	      }
	    };
	    var tryCursor = function (bridge, isRoot, element, offset, direction) {
	      return Rectangles.getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, box);
	      });
	    };
	    var handle$2 = function (bridge, isRoot, direction) {
	      return findSpot(bridge, isRoot, direction).bind(function (spot) {
	        return scan(bridge, isRoot, spot.element(), spot.offset(), direction, MAX_RETRIES).map(bridge.fromSitus);
	      });
	    };
	    var TableKeys = { handle: handle$2 };
	
	    var detection = PlatformDetection$1.detect();
	    var inSameTable = function (elem, table) {
	      return ancestor$2(elem, function (e) {
	        return parent(e).exists(function (p) {
	          return eq(p, table);
	        });
	      });
	    };
	    var simulate = function (bridge, isRoot, direction, initial, anchor) {
	      return closest$1(initial, 'td,th', isRoot).bind(function (start) {
	        return closest$1(start, 'table', isRoot).bind(function (table) {
	          if (!inSameTable(anchor, table)) {
	            return Option.none();
	          }
	          return TableKeys.handle(bridge, isRoot, direction).bind(function (range) {
	            return closest$1(range.finish(), 'td,th', isRoot).map(function (finish) {
	              return {
	                start: constant(start),
	                finish: constant(finish),
	                range: constant(range)
	              };
	            });
	          });
	        });
	      });
	    };
	    var navigate = function (bridge, isRoot, direction, initial, anchor, precheck) {
	      if (detection.browser.isIE()) {
	        return Option.none();
	      } else {
	        return precheck(initial, isRoot).orThunk(function () {
	          return simulate(bridge, isRoot, direction, initial, anchor).map(function (info) {
	            var range = info.range();
	            return Response.create(Option.some(Util.makeSitus(range.start(), range.soffset(), range.finish(), range.foffset())), true);
	          });
	        });
	      }
	    };
	    var firstUpCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants$1(table, 'tr');
	          if (eq(startRow, rows[0])) {
	            return seekLeft$1(table, function (element) {
	              return last$1(element).isSome();
	            }, isRoot).map(function (last) {
	              var lastOffset = getEnd(last);
	              return Response.create(Option.some(Util.makeSitus(last, lastOffset, last, lastOffset)), true);
	            });
	          } else {
	            return Option.none();
	          }
	        });
	      });
	    };
	    var lastDownCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants$1(table, 'tr');
	          if (eq(startRow, rows[rows.length - 1])) {
	            return seekRight$1(table, function (element) {
	              return first(element).isSome();
	            }, isRoot).map(function (first) {
	              return Response.create(Option.some(Util.makeSitus(first, 0, first, 0)), true);
	            });
	          } else {
	            return Option.none();
	          }
	        });
	      });
	    };
	    var select = function (bridge, container, isRoot, direction, initial, anchor, selectRange) {
	      return simulate(bridge, isRoot, direction, initial, anchor).bind(function (info) {
	        return KeySelection.detect(container, isRoot, info.start(), info.finish(), selectRange);
	      });
	    };
	    var VerticalMovement = {
	      navigate: navigate,
	      select: select,
	      firstUpCheck: firstUpCheck,
	      lastDownCheck: lastDownCheck
	    };
	
	    var findCell = function (target, isRoot) {
	      return closest$1(target, 'td,th', isRoot);
	    };
	    function MouseSelection (bridge, container, isRoot, annotations) {
	      var cursor = Option.none();
	      var clearState = function () {
	        cursor = Option.none();
	      };
	      var mousedown = function (event) {
	        annotations.clear(container);
	        cursor = findCell(event.target(), isRoot);
	      };
	      var mouseover = function (event) {
	        cursor.each(function (start) {
	          annotations.clear(container);
	          findCell(event.target(), isRoot).each(function (finish) {
	            CellSelection.identify(start, finish, isRoot).each(function (cellSel) {
	              var boxes = cellSel.boxes().getOr([]);
	              if (boxes.length > 1 || boxes.length === 1 && !eq(start, finish)) {
	                annotations.selectRange(container, boxes, cellSel.start(), cellSel.finish());
	                bridge.selectContents(finish);
	              }
	            });
	          });
	        });
	      };
	      var mouseup = function (_event) {
	        cursor.each(clearState);
	      };
	      return {
	        mousedown: mousedown,
	        mouseover: mouseover,
	        mouseup: mouseup
	      };
	    }
	
	    var down = {
	      traverse: nextSibling,
	      gather: after$5,
	      relative: Situ.before,
	      otherRetry: Retries.tryDown,
	      ieRetry: Retries.ieTryDown,
	      failure: BeforeAfter.failedDown
	    };
	    var up = {
	      traverse: prevSibling,
	      gather: before$4,
	      relative: Situ.before,
	      otherRetry: Retries.tryUp,
	      ieRetry: Retries.ieTryUp,
	      failure: BeforeAfter.failedUp
	    };
	    var KeyDirection = {
	      down: down,
	      up: up
	    };
	
	    var isKey = function (key) {
	      return function (keycode) {
	        return keycode === key;
	      };
	    };
	    var isUp = isKey(38);
	    var isDown = isKey(40);
	    var isNavigation = function (keycode) {
	      return keycode >= 37 && keycode <= 40;
	    };
	    var SelectionKeys = {
	      ltr: {
	        isBackward: isKey(37),
	        isForward: isKey(39)
	      },
	      rtl: {
	        isBackward: isKey(39),
	        isForward: isKey(37)
	      },
	      isUp: isUp,
	      isDown: isDown,
	      isNavigation: isNavigation
	    };
	
	    var toRaw = function (sr) {
	      return {
	        left: sr.left(),
	        top: sr.top(),
	        right: sr.right(),
	        bottom: sr.bottom(),
	        width: sr.width(),
	        height: sr.height()
	      };
	    };
	    var Rect = { toRaw: toRaw };
	
	    var isSafari = PlatformDetection$1.detect().browser.isSafari();
	    var get$a = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom() : domGlobals.document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return Position(x, y);
	    };
	    var by = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom() : domGlobals.document;
	      var win = doc.defaultView;
	      win.scrollBy(x, y);
	    };
	
	    var WindowBridge = function (win) {
	      var elementFromPoint = function (x, y) {
	        return Element.fromPoint(Element.fromDom(win.document), x, y);
	      };
	      var getRect = function (element) {
	        return element.dom().getBoundingClientRect();
	      };
	      var getRangedRect = function (start, soffset, finish, foffset) {
	        var sel = Selection.exact(start, soffset, finish, foffset);
	        return getFirstRect$1(win, sel).map(Rect.toRaw);
	      };
	      var getSelection = function () {
	        return get$9(win).map(function (exactAdt) {
	          return Util.convertToRange(win, exactAdt);
	        });
	      };
	      var fromSitus = function (situs) {
	        var relative = Selection.relative(situs.start(), situs.finish());
	        return Util.convertToRange(win, relative);
	      };
	      var situsFromPoint = function (x, y) {
	        return getAtPoint(win, x, y).map(function (exact) {
	          return Situs.create(exact.start(), exact.soffset(), exact.finish(), exact.foffset());
	        });
	      };
	      var clearSelection = function () {
	        clear(win);
	      };
	      var selectContents = function (element) {
	        setToElement(win, element);
	      };
	      var setSelection = function (sel) {
	        setExact(win, sel.start(), sel.soffset(), sel.finish(), sel.foffset());
	      };
	      var setRelativeSelection = function (start, finish) {
	        setRelative(win, start, finish);
	      };
	      var getInnerHeight = function () {
	        return win.innerHeight;
	      };
	      var getScrollY = function () {
	        var pos = get$a(Element.fromDom(win.document));
	        return pos.top();
	      };
	      var scrollBy = function (x, y) {
	        by(x, y, Element.fromDom(win.document));
	      };
	      return {
	        elementFromPoint: elementFromPoint,
	        getRect: getRect,
	        getRangedRect: getRangedRect,
	        getSelection: getSelection,
	        fromSitus: fromSitus,
	        situsFromPoint: situsFromPoint,
	        clearSelection: clearSelection,
	        setSelection: setSelection,
	        setRelativeSelection: setRelativeSelection,
	        selectContents: selectContents,
	        getInnerHeight: getInnerHeight,
	        getScrollY: getScrollY,
	        scrollBy: scrollBy
	      };
	    };
	
	    var rc = Immutable('rows', 'cols');
	    var mouse = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var handlers = MouseSelection(bridge, container, isRoot, annotations);
	      return {
	        mousedown: handlers.mousedown,
	        mouseover: handlers.mouseover,
	        mouseup: handlers.mouseup
	      };
	    };
	    var keyboard = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var clearToNavigate = function () {
	        annotations.clear(container);
	        return Option.none();
	      };
	      var keydown = function (event, start, soffset, finish, foffset, direction) {
	        var realEvent = event.raw();
	        var keycode = realEvent.which;
	        var shiftKey = realEvent.shiftKey === true;
	        var handler = CellSelection.retrieve(container, annotations.selectedSelector()).fold(function () {
	          if (SelectionKeys.isDown(keycode) && shiftKey) {
	            return curry(VerticalMovement.select, bridge, container, isRoot, KeyDirection.down, finish, start, annotations.selectRange);
	          } else if (SelectionKeys.isUp(keycode) && shiftKey) {
	            return curry(VerticalMovement.select, bridge, container, isRoot, KeyDirection.up, finish, start, annotations.selectRange);
	          } else if (SelectionKeys.isDown(keycode)) {
	            return curry(VerticalMovement.navigate, bridge, isRoot, KeyDirection.down, finish, start, VerticalMovement.lastDownCheck);
	          } else if (SelectionKeys.isUp(keycode)) {
	            return curry(VerticalMovement.navigate, bridge, isRoot, KeyDirection.up, finish, start, VerticalMovement.firstUpCheck);
	          } else {
	            return Option.none;
	          }
	        }, function (selected) {
	          var update = function (attempts) {
	            return function () {
	              var navigation = findMap(attempts, function (delta) {
	                return KeySelection.update(delta.rows(), delta.cols(), container, selected, annotations);
	              });
	              return navigation.fold(function () {
	                return CellSelection.getEdges(container, annotations.firstSelectedSelector(), annotations.lastSelectedSelector()).map(function (edges) {
	                  var relative = SelectionKeys.isDown(keycode) || direction.isForward(keycode) ? Situ.after : Situ.before;
	                  bridge.setRelativeSelection(Situ.on(edges.first(), 0), relative(edges.table()));
	                  annotations.clear(container);
	                  return Response.create(Option.none(), true);
	                });
	              }, function (_) {
	                return Option.some(Response.create(Option.none(), true));
	              });
	            };
	          };
	          if (SelectionKeys.isDown(keycode) && shiftKey) {
	            return update([rc(+1, 0)]);
	          } else if (SelectionKeys.isUp(keycode) && shiftKey) {
	            return update([rc(-1, 0)]);
	          } else if (direction.isBackward(keycode) && shiftKey) {
	            return update([
	              rc(0, -1),
	              rc(-1, 0)
	            ]);
	          } else if (direction.isForward(keycode) && shiftKey) {
	            return update([
	              rc(0, +1),
	              rc(+1, 0)
	            ]);
	          } else if (SelectionKeys.isNavigation(keycode) && shiftKey === false) {
	            return clearToNavigate;
	          } else {
	            return Option.none;
	          }
	        });
	        return handler();
	      };
	      var keyup = function (event, start, soffset, finish, foffset) {
	        return CellSelection.retrieve(container, annotations.selectedSelector()).fold(function () {
	          var realEvent = event.raw();
	          var keycode = realEvent.which;
	          var shiftKey = realEvent.shiftKey === true;
	          if (shiftKey === false) {
	            return Option.none();
	          }
	          if (SelectionKeys.isNavigation(keycode)) {
	            return KeySelection.sync(container, isRoot, start, soffset, finish, foffset, annotations.selectRange);
	          } else {
	            return Option.none();
	          }
	        }, Option.none);
	      };
	      return {
	        keydown: keydown,
	        keyup: keyup
	      };
	    };
	    var InputHandlers = {
	      mouse: mouse,
	      keyboard: keyboard
	    };
	
	    var remove$7 = function (element, classes) {
	      each(classes, function (x) {
	        remove$5(element, x);
	      });
	    };
	
	    var addClass = function (clazz) {
	      return function (element) {
	        add$2(element, clazz);
	      };
	    };
	    var removeClasses = function (classes) {
	      return function (element) {
	        remove$7(element, classes);
	      };
	    };
	
	    var byClass = function (ephemera) {
	      var addSelectionClass = addClass(ephemera.selected());
	      var removeSelectionClasses = removeClasses([
	        ephemera.selected(),
	        ephemera.lastSelected(),
	        ephemera.firstSelected()
	      ]);
	      var clear = function (container) {
	        var sels = descendants$1(container, ephemera.selectedSelector());
	        each(sels, removeSelectionClasses);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each(cells, addSelectionClass);
	        add$2(start, ephemera.firstSelected());
	        add$2(finish, ephemera.lastSelected());
	      };
	      return {
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var byAttr = function (ephemera) {
	      var removeSelectionAttributes = function (element) {
	        remove(element, ephemera.selected());
	        remove(element, ephemera.firstSelected());
	        remove(element, ephemera.lastSelected());
	      };
	      var addSelectionAttribute = function (element) {
	        set(element, ephemera.selected(), '1');
	      };
	      var clear = function (container) {
	        var sels = descendants$1(container, ephemera.selectedSelector());
	        each(sels, removeSelectionAttributes);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each(cells, addSelectionAttribute);
	        set(start, ephemera.firstSelected(), '1');
	        set(finish, ephemera.lastSelected(), '1');
	      };
	      return {
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var SelectionAnnotation = {
	      byClass: byClass,
	      byAttr: byAttr
	    };
	
	    var hasInternalTarget = function (e) {
	      return has$1(Element.fromDom(e.target), 'ephox-snooker-resizer-bar') === false;
	    };
	    function CellSelection$1 (editor, lazyResize) {
	      var handlerStruct = MixedBag([
	        'mousedown',
	        'mouseover',
	        'mouseup',
	        'keyup',
	        'keydown'
	      ], []);
	      var handlers = Option.none();
	      var annotations = SelectionAnnotation.byAttr(Ephemera);
	      editor.on('init', function (e) {
	        var win = editor.getWin();
	        var body = getBody$1(editor);
	        var isRoot = getIsRoot(editor);
	        var syncSelection = function () {
	          var sel = editor.selection;
	          var start = Element.fromDom(sel.getStart());
	          var end = Element.fromDom(sel.getEnd());
	          var shared = DomParent.sharedOne(TableLookup.table, [
	            start,
	            end
	          ]);
	          shared.fold(function () {
	            annotations.clear(body);
	          }, noop);
	        };
	        var mouseHandlers = InputHandlers.mouse(win, body, isRoot, annotations);
	        var keyHandlers = InputHandlers.keyboard(win, body, isRoot, annotations);
	        var hasShiftKey = function (event) {
	          return event.raw().shiftKey === true;
	        };
	        var handleResponse = function (event, response) {
	          if (!hasShiftKey(event)) {
	            return;
	          }
	          if (response.kill()) {
	            event.kill();
	          }
	          response.selection().each(function (ns) {
	            var relative = Selection.relative(ns.start(), ns.finish());
	            var rng = asLtrRange(win, relative);
	            editor.selection.setRng(rng);
	          });
	        };
	        var keyup = function (event) {
	          var wrappedEvent = wrapEvent(event);
	          if (wrappedEvent.raw().shiftKey && SelectionKeys.isNavigation(wrappedEvent.raw().which)) {
	            var rng = editor.selection.getRng();
	            var start = Element.fromDom(rng.startContainer);
	            var end = Element.fromDom(rng.endContainer);
	            keyHandlers.keyup(wrappedEvent, start, rng.startOffset, end, rng.endOffset).each(function (response) {
	              handleResponse(wrappedEvent, response);
	            });
	          }
	        };
	        var keydown = function (event) {
	          var wrappedEvent = wrapEvent(event);
	          lazyResize().each(function (resize) {
	            resize.hideBars();
	          });
	          var rng = editor.selection.getRng();
	          var startContainer = Element.fromDom(editor.selection.getStart());
	          var start = Element.fromDom(rng.startContainer);
	          var end = Element.fromDom(rng.endContainer);
	          var direction = Direction.directionAt(startContainer).isRtl() ? SelectionKeys.rtl : SelectionKeys.ltr;
	          keyHandlers.keydown(wrappedEvent, start, rng.startOffset, end, rng.endOffset, direction).each(function (response) {
	            handleResponse(wrappedEvent, response);
	          });
	          lazyResize().each(function (resize) {
	            resize.showBars();
	          });
	        };
	        var isMouseEvent = function (event) {
	          return event.hasOwnProperty('x') && event.hasOwnProperty('y');
	        };
	        var wrapEvent = function (event) {
	          var target = Element.fromDom(event.target);
	          var stop = function () {
	            event.stopPropagation();
	          };
	          var prevent = function () {
	            event.preventDefault();
	          };
	          var kill = compose(prevent, stop);
	          return {
	            target: constant(target),
	            x: constant(isMouseEvent(event) ? event.x : null),
	            y: constant(isMouseEvent(event) ? event.y : null),
	            stop: stop,
	            prevent: prevent,
	            kill: kill,
	            raw: constant(event)
	          };
	        };
	        var isLeftMouse = function (raw) {
	          return raw.button === 0;
	        };
	        var isLeftButtonPressed = function (raw) {
	          if (raw.buttons === undefined) {
	            return true;
	          }
	          if (global$2.ie && global$2.ie >= 12 && raw.buttons === 0) {
	            return true;
	          }
	          return (raw.buttons & 1) !== 0;
	        };
	        var mouseDown = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mousedown(wrapEvent(e));
	          }
	        };
	        var mouseOver = function (e) {
	          if (isLeftButtonPressed(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseover(wrapEvent(e));
	          }
	        };
	        var mouseUp = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseup(wrapEvent(e));
	          }
	        };
	        editor.on('mousedown', mouseDown);
	        editor.on('mouseover', mouseOver);
	        editor.on('mouseup', mouseUp);
	        editor.on('keyup', keyup);
	        editor.on('keydown', keydown);
	        editor.on('nodechange', syncSelection);
	        handlers = Option.some(handlerStruct({
	          mousedown: mouseDown,
	          mouseover: mouseOver,
	          mouseup: mouseUp,
	          keyup: keyup,
	          keydown: keydown
	        }));
	      });
	      var destroy = function () {
	        handlers.each(function (handlers) {
	        });
	      };
	      return {
	        clear: annotations.clear,
	        destroy: destroy
	      };
	    }
	
	    var Selections = function (editor) {
	      var get = function () {
	        var body = getBody$1(editor);
	        return TableSelection.retrieve(body, Ephemera.selectedSelector()).fold(function () {
	          if (editor.selection.getStart() === undefined) {
	            return SelectionTypes.none();
	          } else {
	            return SelectionTypes.single(editor.selection);
	          }
	        }, function (cells) {
	          return SelectionTypes.multiple(cells);
	        });
	      };
	      return { get: get };
	    };
	
	    var each$4 = global$1.each;
	    var addButtons = function (editor) {
	      var menuItems = [];
	      each$4('inserttable tableprops deletetable | cell row column'.split(' '), function (name) {
	        if (name === '|') {
	          menuItems.push({ text: '-' });
	        } else {
	          menuItems.push(editor.menuItems[name]);
	        }
	      });
	      editor.addButton('table', {
	        type: 'menubutton',
	        title: 'Table',
	        menu: menuItems
	      });
	      function cmd(command) {
	        return function () {
	          editor.execCommand(command);
	        };
	      }
	      editor.addButton('tableprops', {
	        title: 'Table properties',
	        onclick: cmd('mceTableProps'),
	        icon: 'table'
	      });
	      editor.addButton('tabledelete', {
	        title: 'Delete table',
	        onclick: cmd('mceTableDelete')
	      });
	      editor.addButton('tablecellprops', {
	        title: 'Cell properties',
	        onclick: cmd('mceTableCellProps')
	      });
	      editor.addButton('tablemergecells', {
	        title: 'Merge cells',
	        onclick: cmd('mceTableMergeCells')
	      });
	      editor.addButton('tablesplitcells', {
	        title: 'Split cell',
	        onclick: cmd('mceTableSplitCells')
	      });
	      editor.addButton('tableinsertrowbefore', {
	        title: 'Insert row before',
	        onclick: cmd('mceTableInsertRowBefore')
	      });
	      editor.addButton('tableinsertrowafter', {
	        title: 'Insert row after',
	        onclick: cmd('mceTableInsertRowAfter')
	      });
	      editor.addButton('tabledeleterow', {
	        title: 'Delete row',
	        onclick: cmd('mceTableDeleteRow')
	      });
	      editor.addButton('tablerowprops', {
	        title: 'Row properties',
	        onclick: cmd('mceTableRowProps')
	      });
	      editor.addButton('tablecutrow', {
	        title: 'Cut row',
	        onclick: cmd('mceTableCutRow')
	      });
	      editor.addButton('tablecopyrow', {
	        title: 'Copy row',
	        onclick: cmd('mceTableCopyRow')
	      });
	      editor.addButton('tablepasterowbefore', {
	        title: 'Paste row before',
	        onclick: cmd('mceTablePasteRowBefore')
	      });
	      editor.addButton('tablepasterowafter', {
	        title: 'Paste row after',
	        onclick: cmd('mceTablePasteRowAfter')
	      });
	      editor.addButton('tableinsertcolbefore', {
	        title: 'Insert column before',
	        onclick: cmd('mceTableInsertColBefore')
	      });
	      editor.addButton('tableinsertcolafter', {
	        title: 'Insert column after',
	        onclick: cmd('mceTableInsertColAfter')
	      });
	      editor.addButton('tabledeletecol', {
	        title: 'Delete column',
	        onclick: cmd('mceTableDeleteCol')
	      });
	    };
	    var addToolbars = function (editor) {
	      var isTable = function (table) {
	        var selectorMatched = editor.dom.is(table, 'table') && editor.getBody().contains(table);
	        return selectorMatched;
	      };
	      var toolbar = getToolbar(editor);
	      if (toolbar.length > 0) {
	        editor.addContextToolbar(isTable, toolbar.join(' '));
	      }
	    };
	    var Buttons = {
	      addButtons: addButtons,
	      addToolbars: addToolbars
	    };
	
	    var addMenuItems = function (editor, selections) {
	      var targets = Option.none();
	      var tableCtrls = [];
	      var cellCtrls = [];
	      var mergeCtrls = [];
	      var unmergeCtrls = [];
	      var noTargetDisable = function (ctrl) {
	        ctrl.disabled(true);
	      };
	      var ctrlEnable = function (ctrl) {
	        ctrl.disabled(false);
	      };
	      var pushTable = function () {
	        var self = this;
	        tableCtrls.push(self);
	        targets.fold(function () {
	          noTargetDisable(self);
	        }, function (targets) {
	          ctrlEnable(self);
	        });
	      };
	      var pushCell = function () {
	        var self = this;
	        cellCtrls.push(self);
	        targets.fold(function () {
	          noTargetDisable(self);
	        }, function (targets) {
	          ctrlEnable(self);
	        });
	      };
	      var pushMerge = function () {
	        var self = this;
	        mergeCtrls.push(self);
	        targets.fold(function () {
	          noTargetDisable(self);
	        }, function (targets) {
	          self.disabled(targets.mergable().isNone());
	        });
	      };
	      var pushUnmerge = function () {
	        var self = this;
	        unmergeCtrls.push(self);
	        targets.fold(function () {
	          noTargetDisable(self);
	        }, function (targets) {
	          self.disabled(targets.unmergable().isNone());
	        });
	      };
	      var setDisabledCtrls = function () {
	        targets.fold(function () {
	          each(tableCtrls, noTargetDisable);
	          each(cellCtrls, noTargetDisable);
	          each(mergeCtrls, noTargetDisable);
	          each(unmergeCtrls, noTargetDisable);
	        }, function (targets) {
	          each(tableCtrls, ctrlEnable);
	          each(cellCtrls, ctrlEnable);
	          each(mergeCtrls, function (mergeCtrl) {
	            mergeCtrl.disabled(targets.mergable().isNone());
	          });
	          each(unmergeCtrls, function (unmergeCtrl) {
	            unmergeCtrl.disabled(targets.unmergable().isNone());
	          });
	        });
	      };
	      editor.on('init', function () {
	        editor.on('nodechange', function (e) {
	          var cellOpt = Option.from(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
	          targets = cellOpt.bind(function (cellDom) {
	            var cell = Element.fromDom(cellDom);
	            var table = TableLookup.table(cell);
	            return table.map(function (table) {
	              return TableTargets.forMenu(selections, table, cell);
	            });
	          });
	          setDisabledCtrls();
	        });
	      });
	      var generateTableGrid = function () {
	        var html = '';
	        html = '<table role="grid" class="mce-grid mce-grid-border" aria-readonly="true">';
	        for (var y = 0; y < 10; y++) {
	          html += '<tr>';
	          for (var x = 0; x < 10; x++) {
	            html += '<td role="gridcell" tabindex="-1"><a id="mcegrid' + (y * 10 + x) + '" href="#" ' + 'data-mce-x="' + x + '" data-mce-y="' + y + '"></a></td>';
	          }
	          html += '</tr>';
	        }
	        html += '</table>';
	        html += '<div class="mce-text-center" role="presentation">1 x 1</div>';
	        return html;
	      };
	      var selectGrid = function (editor, tx, ty, control) {
	        var table = control.getEl().getElementsByTagName('table')[0];
	        var x, y, focusCell, cell, active;
	        var rtl = control.isRtl() || control.parent().rel === 'tl-tr';
	        table.nextSibling.innerHTML = tx + 1 + ' x ' + (ty + 1);
	        if (rtl) {
	          tx = 9 - tx;
	        }
	        for (y = 0; y < 10; y++) {
	          for (x = 0; x < 10; x++) {
	            cell = table.rows[y].childNodes[x].firstChild;
	            active = (rtl ? x >= tx : x <= tx) && y <= ty;
	            editor.dom.toggleClass(cell, 'mce-active', active);
	            if (active) {
	              focusCell = cell;
	            }
	          }
	        }
	        return focusCell.parentNode;
	      };
	      var insertTable = hasTableGrid(editor) === false ? {
	        text: 'Table',
	        icon: 'table',
	        context: 'table',
	        onclick: cmd('mceInsertTable')
	      } : {
	        text: 'Table',
	        icon: 'table',
	        context: 'table',
	        ariaHideMenu: true,
	        onclick: function (e) {
	          if (e.aria) {
	            this.parent().hideAll();
	            e.stopImmediatePropagation();
	            editor.execCommand('mceInsertTable');
	          }
	        },
	        onshow: function () {
	          selectGrid(editor, 0, 0, this.menu.items()[0]);
	        },
	        onhide: function () {
	          var elements = this.menu.items()[0].getEl().getElementsByTagName('a');
	          editor.dom.removeClass(elements, 'mce-active');
	          editor.dom.addClass(elements[0], 'mce-active');
	        },
	        menu: [{
	            type: 'container',
	            html: generateTableGrid(),
	            onPostRender: function () {
	              this.lastX = this.lastY = 0;
	            },
	            onmousemove: function (e) {
	              var target = e.target;
	              var x, y;
	              if (target.tagName.toUpperCase() === 'A') {
	                x = parseInt(target.getAttribute('data-mce-x'), 10);
	                y = parseInt(target.getAttribute('data-mce-y'), 10);
	                if (this.isRtl() || this.parent().rel === 'tl-tr') {
	                  x = 9 - x;
	                }
	                if (x !== this.lastX || y !== this.lastY) {
	                  selectGrid(editor, x, y, e.control);
	                  this.lastX = x;
	                  this.lastY = y;
	                }
	              }
	            },
	            onclick: function (e) {
	              var self = this;
	              if (e.target.tagName.toUpperCase() === 'A') {
	                e.preventDefault();
	                e.stopPropagation();
	                self.parent().cancel();
	                editor.undoManager.transact(function () {
	                  InsertTable.insert(editor, self.lastX + 1, self.lastY + 1);
	                });
	                editor.addVisual();
	              }
	            }
	          }]
	      };
	      function cmd(command) {
	        return function () {
	          editor.execCommand(command);
	        };
	      }
	      var tableProperties = {
	        text: 'Table properties',
	        context: 'table',
	        onPostRender: pushTable,
	        onclick: cmd('mceTableProps')
	      };
	      var deleteTable = {
	        text: 'Delete table',
	        context: 'table',
	        onPostRender: pushTable,
	        cmd: 'mceTableDelete'
	      };
	      var row = {
	        text: 'Row',
	        context: 'table',
	        menu: [
	          {
	            text: 'Insert row before',
	            onclick: cmd('mceTableInsertRowBefore'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Insert row after',
	            onclick: cmd('mceTableInsertRowAfter'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Delete row',
	            onclick: cmd('mceTableDeleteRow'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Row properties',
	            onclick: cmd('mceTableRowProps'),
	            onPostRender: pushCell
	          },
	          { text: '-' },
	          {
	            text: 'Cut row',
	            onclick: cmd('mceTableCutRow'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Copy row',
	            onclick: cmd('mceTableCopyRow'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Paste row before',
	            onclick: cmd('mceTablePasteRowBefore'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Paste row after',
	            onclick: cmd('mceTablePasteRowAfter'),
	            onPostRender: pushCell
	          }
	        ]
	      };
	      var column = {
	        text: 'Column',
	        context: 'table',
	        menu: [
	          {
	            text: 'Insert column before',
	            onclick: cmd('mceTableInsertColBefore'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Insert column after',
	            onclick: cmd('mceTableInsertColAfter'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Delete column',
	            onclick: cmd('mceTableDeleteCol'),
	            onPostRender: pushCell
	          }
	        ]
	      };
	      var cell = {
	        separator: 'before',
	        text: 'Cell',
	        context: 'table',
	        menu: [
	          {
	            text: 'Cell properties',
	            onclick: cmd('mceTableCellProps'),
	            onPostRender: pushCell
	          },
	          {
	            text: 'Merge cells',
	            onclick: cmd('mceTableMergeCells'),
	            onPostRender: pushMerge
	          },
	          {
	            text: 'Split cell',
	            onclick: cmd('mceTableSplitCells'),
	            onPostRender: pushUnmerge
	          }
	        ]
	      };
	      editor.addMenuItem('inserttable', insertTable);
	      editor.addMenuItem('tableprops', tableProperties);
	      editor.addMenuItem('deletetable', deleteTable);
	      editor.addMenuItem('row', row);
	      editor.addMenuItem('column', column);
	      editor.addMenuItem('cell', cell);
	    };
	    var MenuItems = { addMenuItems: addMenuItems };
	
	    var getClipboardRows = function (clipboardRows) {
	      return clipboardRows.get().fold(function () {
	        return;
	      }, function (rows) {
	        return map(rows, function (row) {
	          return row.dom();
	        });
	      });
	    };
	    var setClipboardRows = function (rows, clipboardRows) {
	      var sugarRows = map(rows, Element.fromDom);
	      clipboardRows.set(Option.from(sugarRows));
	    };
	    var getApi = function (editor, clipboardRows) {
	      return {
	        insertTable: function (columns, rows) {
	          return InsertTable.insert(editor, columns, rows);
	        },
	        setClipboardRows: function (rows) {
	          return setClipboardRows(rows, clipboardRows);
	        },
	        getClipboardRows: function () {
	          return getClipboardRows(clipboardRows);
	        }
	      };
	    };
	
	    function Plugin(editor) {
	      var resizeHandler = ResizeHandler(editor);
	      var cellSelection = CellSelection$1(editor, resizeHandler.lazyResize);
	      var actions = TableActions(editor, resizeHandler.lazyWire);
	      var selections = Selections(editor);
	      var clipboardRows = Cell(Option.none());
	      Commands.registerCommands(editor, actions, cellSelection, selections, clipboardRows);
	      Clipboard.registerEvents(editor, selections, actions, cellSelection);
	      MenuItems.addMenuItems(editor, selections);
	      Buttons.addButtons(editor);
	      Buttons.addToolbars(editor);
	      editor.on('PreInit', function () {
	        editor.serializer.addTempAttr(Ephemera.firstSelected());
	        editor.serializer.addTempAttr(Ephemera.lastSelected());
	      });
	      if (hasTabNavigation(editor)) {
	        editor.on('keydown', function (e) {
	          TabContext.handle(e, editor, actions, resizeHandler.lazyWire);
	        });
	      }
	      editor.on('remove', function () {
	        resizeHandler.destroy();
	        cellSelection.destroy();
	      });
	      return getApi(editor, clipboardRows);
	    }
	    global.add('table', Plugin);
	    function Plugin$1 () {
	    }
	
	    return Plugin$1;
	
	}(window));
	})();


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// Exports the "textcolor" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/textcolor')
	//   ES2015:
	//     import 'tinymce/plugins/textcolor'
	__webpack_require__(558);

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	(function () {
	var textcolor = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var getCurrentColor = function (editor, format) {
	      var color;
	      editor.dom.getParents(editor.selection.getStart(), function (elm) {
	        var value;
	        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
	          color = color ? color : value;
	        }
	      });
	      return color;
	    };
	    var mapColors = function (colorMap) {
	      var i;
	      var colors = [];
	      for (i = 0; i < colorMap.length; i += 2) {
	        colors.push({
	          text: colorMap[i + 1],
	          color: '#' + colorMap[i]
	        });
	      }
	      return colors;
	    };
	    var applyFormat = function (editor, format, value) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.apply(format, { value: value });
	        editor.nodeChanged();
	      });
	    };
	    var removeFormat = function (editor, format) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.remove(format, { value: null }, null, true);
	        editor.nodeChanged();
	      });
	    };
	    var TextColor = {
	      getCurrentColor: getCurrentColor,
	      mapColors: mapColors,
	      applyFormat: applyFormat,
	      removeFormat: removeFormat
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceApplyTextcolor', function (format, value) {
	        TextColor.applyFormat(editor, format, value);
	      });
	      editor.addCommand('mceRemoveTextcolor', function (format) {
	        TextColor.removeFormat(editor, format);
	      });
	    };
	    var Commands = { register: register };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var defaultColorMap = [
	      '000000',
	      'Black',
	      '993300',
	      'Burnt orange',
	      '333300',
	      'Dark olive',
	      '003300',
	      'Dark green',
	      '003366',
	      'Dark azure',
	      '000080',
	      'Navy Blue',
	      '333399',
	      'Indigo',
	      '333333',
	      'Very dark gray',
	      '800000',
	      'Maroon',
	      'FF6600',
	      'Orange',
	      '808000',
	      'Olive',
	      '008000',
	      'Green',
	      '008080',
	      'Teal',
	      '0000FF',
	      'Blue',
	      '666699',
	      'Grayish blue',
	      '808080',
	      'Gray',
	      'FF0000',
	      'Red',
	      'FF9900',
	      'Amber',
	      '99CC00',
	      'Yellow green',
	      '339966',
	      'Sea green',
	      '33CCCC',
	      'Turquoise',
	      '3366FF',
	      'Royal blue',
	      '800080',
	      'Purple',
	      '999999',
	      'Medium gray',
	      'FF00FF',
	      'Magenta',
	      'FFCC00',
	      'Gold',
	      'FFFF00',
	      'Yellow',
	      '00FF00',
	      'Lime',
	      '00FFFF',
	      'Aqua',
	      '00CCFF',
	      'Sky blue',
	      '993366',
	      'Red violet',
	      'FFFFFF',
	      'White',
	      'FF99CC',
	      'Pink',
	      'FFCC99',
	      'Peach',
	      'FFFF99',
	      'Light yellow',
	      'CCFFCC',
	      'Pale green',
	      'CCFFFF',
	      'Pale cyan',
	      '99CCFF',
	      'Light sky blue',
	      'CC99FF',
	      'Plum'
	    ];
	    var getTextColorMap = function (editor) {
	      return editor.getParam('textcolor_map', defaultColorMap);
	    };
	    var getForeColorMap = function (editor) {
	      return editor.getParam('forecolor_map', getTextColorMap(editor));
	    };
	    var getBackColorMap = function (editor) {
	      return editor.getParam('backcolor_map', getTextColorMap(editor));
	    };
	    var getTextColorRows = function (editor) {
	      return editor.getParam('textcolor_rows', 5);
	    };
	    var getTextColorCols = function (editor) {
	      return editor.getParam('textcolor_cols', 8);
	    };
	    var getForeColorRows = function (editor) {
	      return editor.getParam('forecolor_rows', getTextColorRows(editor));
	    };
	    var getBackColorRows = function (editor) {
	      return editor.getParam('backcolor_rows', getTextColorRows(editor));
	    };
	    var getForeColorCols = function (editor) {
	      return editor.getParam('forecolor_cols', getTextColorCols(editor));
	    };
	    var getBackColorCols = function (editor) {
	      return editor.getParam('backcolor_cols', getTextColorCols(editor));
	    };
	    var getColorPickerCallback = function (editor) {
	      return editor.getParam('color_picker_callback', null);
	    };
	    var hasColorPicker = function (editor) {
	      return typeof getColorPickerCallback(editor) === 'function';
	    };
	    var Settings = {
	      getForeColorMap: getForeColorMap,
	      getBackColorMap: getBackColorMap,
	      getForeColorRows: getForeColorRows,
	      getBackColorRows: getBackColorRows,
	      getForeColorCols: getForeColorCols,
	      getBackColorCols: getBackColorCols,
	      getColorPickerCallback: getColorPickerCallback,
	      hasColorPicker: hasColorPicker
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var getHtml = function (cols, rows, colorMap, hasColorPicker) {
	      var colors, color, html, last, x, y, i, count = 0;
	      var id = global$1.DOM.uniqueId('mcearia');
	      var getColorCellHtml = function (color, title) {
	        var isNoColor = color === 'transparent';
	        return '<td class="mce-grid-cell' + (isNoColor ? ' mce-colorbtn-trans' : '') + '">' + '<div id="' + id + '-' + count++ + '"' + ' data-mce-color="' + (color ? color : '') + '"' + ' role="option"' + ' tabIndex="-1"' + ' style="' + (color ? 'background-color: ' + color : '') + '"' + ' title="' + global$3.translate(title) + '">' + (isNoColor ? '&#215;' : '') + '</div>' + '</td>';
	      };
	      colors = TextColor.mapColors(colorMap);
	      colors.push({
	        text: global$3.translate('No color'),
	        color: 'transparent'
	      });
	      html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
	      last = colors.length - 1;
	      for (y = 0; y < rows; y++) {
	        html += '<tr>';
	        for (x = 0; x < cols; x++) {
	          i = y * cols + x;
	          if (i > last) {
	            html += '<td></td>';
	          } else {
	            color = colors[i];
	            html += getColorCellHtml(color.color, color.text);
	          }
	        }
	        html += '</tr>';
	      }
	      if (hasColorPicker) {
	        html += '<tr>' + '<td colspan="' + cols + '" class="mce-custom-color-btn">' + '<div id="' + id + '-c" class="mce-widget mce-btn mce-btn-small mce-btn-flat" ' + 'role="button" tabindex="-1" aria-labelledby="' + id + '-c" style="width: 100%">' + '<button type="button" role="presentation" tabindex="-1">' + global$3.translate('Custom...') + '</button>' + '</div>' + '</td>' + '</tr>';
	        html += '<tr>';
	        for (x = 0; x < cols; x++) {
	          html += getColorCellHtml('', 'Custom color');
	        }
	        html += '</tr>';
	      }
	      html += '</tbody></table>';
	      return html;
	    };
	    var ColorPickerHtml = { getHtml: getHtml };
	
	    var setDivColor = function setDivColor(div, value) {
	      div.style.background = value;
	      div.setAttribute('data-mce-color', value);
	    };
	    var onButtonClick = function (editor) {
	      return function (e) {
	        var ctrl = e.control;
	        if (ctrl._color) {
	          editor.execCommand('mceApplyTextcolor', ctrl.settings.format, ctrl._color);
	        } else {
	          editor.execCommand('mceRemoveTextcolor', ctrl.settings.format);
	        }
	      };
	    };
	    var onPanelClick = function (editor, cols) {
	      return function (e) {
	        var buttonCtrl = this.parent();
	        var value;
	        var currentColor = TextColor.getCurrentColor(editor, buttonCtrl.settings.format);
	        var selectColor = function (value) {
	          editor.execCommand('mceApplyTextcolor', buttonCtrl.settings.format, value);
	          buttonCtrl.hidePanel();
	          buttonCtrl.color(value);
	        };
	        var resetColor = function () {
	          editor.execCommand('mceRemoveTextcolor', buttonCtrl.settings.format);
	          buttonCtrl.hidePanel();
	          buttonCtrl.resetColor();
	        };
	        if (global$1.DOM.getParent(e.target, '.mce-custom-color-btn')) {
	          buttonCtrl.hidePanel();
	          var colorPickerCallback = Settings.getColorPickerCallback(editor);
	          colorPickerCallback.call(editor, function (value) {
	            var tableElm = buttonCtrl.panel.getEl().getElementsByTagName('table')[0];
	            var customColorCells, div, i;
	            customColorCells = global$2.map(tableElm.rows[tableElm.rows.length - 1].childNodes, function (elm) {
	              return elm.firstChild;
	            });
	            for (i = 0; i < customColorCells.length; i++) {
	              div = customColorCells[i];
	              if (!div.getAttribute('data-mce-color')) {
	                break;
	              }
	            }
	            if (i === cols) {
	              for (i = 0; i < cols - 1; i++) {
	                setDivColor(customColorCells[i], customColorCells[i + 1].getAttribute('data-mce-color'));
	              }
	            }
	            setDivColor(div, value);
	            selectColor(value);
	          }, currentColor);
	        }
	        value = e.target.getAttribute('data-mce-color');
	        if (value) {
	          if (this.lastId) {
	            global$1.DOM.get(this.lastId).setAttribute('aria-selected', 'false');
	          }
	          e.target.setAttribute('aria-selected', true);
	          this.lastId = e.target.id;
	          if (value === 'transparent') {
	            resetColor();
	          } else {
	            selectColor(value);
	          }
	        } else if (value !== null) {
	          buttonCtrl.hidePanel();
	        }
	      };
	    };
	    var renderColorPicker = function (editor, foreColor) {
	      return function () {
	        var cols = foreColor ? Settings.getForeColorCols(editor) : Settings.getBackColorCols(editor);
	        var rows = foreColor ? Settings.getForeColorRows(editor) : Settings.getBackColorRows(editor);
	        var colorMap = foreColor ? Settings.getForeColorMap(editor) : Settings.getBackColorMap(editor);
	        var hasColorPicker = Settings.hasColorPicker(editor);
	        return ColorPickerHtml.getHtml(cols, rows, colorMap, hasColorPicker);
	      };
	    };
	    var register$1 = function (editor) {
	      editor.addButton('forecolor', {
	        type: 'colorbutton',
	        tooltip: 'Text color',
	        format: 'forecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, true),
	          onclick: onPanelClick(editor, Settings.getForeColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	      editor.addButton('backcolor', {
	        type: 'colorbutton',
	        tooltip: 'Background color',
	        format: 'hilitecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, false),
	          onclick: onPanelClick(editor, Settings.getBackColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('textcolor', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	(function () {
	var modern = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.ThemeManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.EditorManager');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var isBrandingEnabled = function (editor) {
	      return editor.getParam('branding', true, 'boolean');
	    };
	    var hasMenubar = function (editor) {
	      return getMenubar(editor) !== false;
	    };
	    var getMenubar = function (editor) {
	      return editor.getParam('menubar');
	    };
	    var hasStatusbar = function (editor) {
	      return editor.getParam('statusbar', true, 'boolean');
	    };
	    var getToolbarSize = function (editor) {
	      return editor.getParam('toolbar_items_size');
	    };
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly', false, 'boolean');
	    };
	    var getFixedToolbarContainer = function (editor) {
	      return editor.getParam('fixed_toolbar_container');
	    };
	    var getInlineToolbarPositionHandler = function (editor) {
	      return editor.getParam('inline_toolbar_position_handler');
	    };
	    var getMenu = function (editor) {
	      return editor.getParam('menu');
	    };
	    var getRemovedMenuItems = function (editor) {
	      return editor.getParam('removed_menuitems', '');
	    };
	    var getMinWidth = function (editor) {
	      return editor.getParam('min_width', 100, 'number');
	    };
	    var getMinHeight = function (editor) {
	      return editor.getParam('min_height', 100, 'number');
	    };
	    var getMaxWidth = function (editor) {
	      return editor.getParam('max_width', 65535, 'number');
	    };
	    var getMaxHeight = function (editor) {
	      return editor.getParam('max_height', 65535, 'number');
	    };
	    var isSkinDisabled = function (editor) {
	      return editor.settings.skin === false;
	    };
	    var isInline = function (editor) {
	      return editor.getParam('inline', false, 'boolean');
	    };
	    var getResize = function (editor) {
	      var resize = editor.getParam('resize', 'vertical');
	      if (resize === false) {
	        return 'none';
	      } else if (resize === 'both') {
	        return 'both';
	      } else {
	        return 'vertical';
	      }
	    };
	    var getSkinUrl = function (editor) {
	      var settings = editor.settings;
	      var skin = settings.skin;
	      var skinUrl = settings.skin_url;
	      if (skin !== false) {
	        var skinName = skin ? skin : 'lightgray';
	        if (skinUrl) {
	          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
	        } else {
	          skinUrl = global$1.baseURL + '/skins/' + skinName;
	        }
	      }
	      return skinUrl;
	    };
	    var getIndexedToolbars = function (settings, defaultToolbar) {
	      var toolbars = [];
	      for (var i = 1; i < 10; i++) {
	        var toolbar = settings['toolbar' + i];
	        if (!toolbar) {
	          break;
	        }
	        toolbars.push(toolbar);
	      }
	      var mainToolbar = settings.toolbar ? [settings.toolbar] : [defaultToolbar];
	      return toolbars.length > 0 ? toolbars : mainToolbar;
	    };
	    var getToolbars = function (editor) {
	      var toolbar = editor.getParam('toolbar');
	      var defaultToolbar = 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image';
	      if (toolbar === false) {
	        return [];
	      } else if (global$2.isArray(toolbar)) {
	        return global$2.grep(toolbar, function (toolbar) {
	          return toolbar.length > 0;
	        });
	      } else {
	        return getIndexedToolbars(editor.settings, defaultToolbar);
	      }
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.ui.Factory');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var fireSkinLoaded = function (editor) {
	      return editor.fire('SkinLoaded');
	    };
	    var fireResizeEditor = function (editor) {
	      return editor.fire('ResizeEditor');
	    };
	    var fireBeforeRenderUI = function (editor) {
	      return editor.fire('BeforeRenderUI');
	    };
	    var Events = {
	      fireSkinLoaded: fireSkinLoaded,
	      fireResizeEditor: fireResizeEditor,
	      fireBeforeRenderUI: fireBeforeRenderUI
	    };
	
	    var focus = function (panel, type) {
	      return function () {
	        var item = panel.find(type)[0];
	        if (item) {
	          item.focus(true);
	        }
	      };
	    };
	    var addKeys = function (editor, panel) {
	      editor.shortcuts.add('Alt+F9', '', focus(panel, 'menubar'));
	      editor.shortcuts.add('Alt+F10,F10', '', focus(panel, 'toolbar'));
	      editor.shortcuts.add('Alt+F11', '', focus(panel, 'elementpath'));
	      panel.on('cancel', function () {
	        editor.focus();
	      });
	    };
	    var A11y = { addKeys: addKeys };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.geom.Rect');
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var getUiContainerDelta = function (ctrl) {
	      var uiContainer = getUiContainer(ctrl);
	      if (uiContainer && global$3.DOM.getStyle(uiContainer, 'position', true) !== 'static') {
	        var containerPos = global$3.DOM.getPos(uiContainer);
	        var dx = uiContainer.scrollLeft - containerPos.x;
	        var dy = uiContainer.scrollTop - containerPos.y;
	        return Option.some({
	          x: dx,
	          y: dy
	        });
	      } else {
	        return Option.none();
	      }
	    };
	    var setUiContainer = function (editor, ctrl) {
	      var uiContainer = global$3.DOM.select(editor.settings.ui_container)[0];
	      ctrl.getRoot().uiContainer = uiContainer;
	    };
	    var getUiContainer = function (ctrl) {
	      return ctrl ? ctrl.getRoot().uiContainer : null;
	    };
	    var inheritUiContainer = function (fromCtrl, toCtrl) {
	      return toCtrl.uiContainer = getUiContainer(fromCtrl);
	    };
	    var UiContainer = {
	      getUiContainerDelta: getUiContainerDelta,
	      setUiContainer: setUiContainer,
	      getUiContainer: getUiContainer,
	      inheritUiContainer: inheritUiContainer
	    };
	
	    var createToolbar = function (editor, items, size) {
	      var toolbarItems = [];
	      var buttonGroup;
	      if (!items) {
	        return;
	      }
	      global$2.each(items.split(/[ ,]/), function (item) {
	        var itemName;
	        var bindSelectorChanged = function () {
	          var selection = editor.selection;
	          if (item.settings.stateSelector) {
	            selection.selectorChanged(item.settings.stateSelector, function (state) {
	              item.active(state);
	            }, true);
	          }
	          if (item.settings.disabledStateSelector) {
	            selection.selectorChanged(item.settings.disabledStateSelector, function (state) {
	              item.disabled(state);
	            });
	          }
	        };
	        if (item === '|') {
	          buttonGroup = null;
	        } else {
	          if (!buttonGroup) {
	            buttonGroup = {
	              type: 'buttongroup',
	              items: []
	            };
	            toolbarItems.push(buttonGroup);
	          }
	          if (editor.buttons[item]) {
	            itemName = item;
	            item = editor.buttons[itemName];
	            if (typeof item === 'function') {
	              item = item();
	            }
	            item.type = item.type || 'button';
	            item.size = size;
	            item = global$4.create(item);
	            buttonGroup.items.push(item);
	            if (editor.initialized) {
	              bindSelectorChanged();
	            } else {
	              editor.on('init', bindSelectorChanged);
	            }
	          }
	        }
	      });
	      return {
	        type: 'toolbar',
	        layout: 'flow',
	        items: toolbarItems
	      };
	    };
	    var createToolbars = function (editor, size) {
	      var toolbars = [];
	      var addToolbar = function (items) {
	        if (items) {
	          toolbars.push(createToolbar(editor, items, size));
	        }
	      };
	      global$2.each(getToolbars(editor), function (toolbar) {
	        addToolbar(toolbar);
	      });
	      if (toolbars.length) {
	        return {
	          type: 'panel',
	          layout: 'stack',
	          classes: 'toolbar-grp',
	          ariaRoot: true,
	          ariaRemember: true,
	          items: toolbars
	        };
	      }
	    };
	    var Toolbar = {
	      createToolbar: createToolbar,
	      createToolbars: createToolbars
	    };
	
	    var DOM = global$3.DOM;
	    var toClientRect = function (geomRect) {
	      return {
	        left: geomRect.x,
	        top: geomRect.y,
	        width: geomRect.w,
	        height: geomRect.h,
	        right: geomRect.x + geomRect.w,
	        bottom: geomRect.y + geomRect.h
	      };
	    };
	    var hideAllFloatingPanels = function (editor) {
	      global$2.each(editor.contextToolbars, function (toolbar) {
	        if (toolbar.panel) {
	          toolbar.panel.hide();
	        }
	      });
	    };
	    var movePanelTo = function (panel, pos) {
	      panel.moveTo(pos.left, pos.top);
	    };
	    var togglePositionClass = function (panel, relPos, predicate) {
	      relPos = relPos ? relPos.substr(0, 2) : '';
	      global$2.each({
	        t: 'down',
	        b: 'up'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
	      });
	      global$2.each({
	        l: 'left',
	        r: 'right'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
	      });
	    };
	    var userConstrain = function (handler, x, y, elementRect, contentAreaRect, panelRect) {
	      panelRect = toClientRect({
	        x: x,
	        y: y,
	        w: panelRect.w,
	        h: panelRect.h
	      });
	      if (handler) {
	        panelRect = handler({
	          elementRect: toClientRect(elementRect),
	          contentAreaRect: toClientRect(contentAreaRect),
	          panelRect: panelRect
	        });
	      }
	      return panelRect;
	    };
	    var addContextualToolbars = function (editor) {
	      var scrollContainer;
	      var getContextToolbars = function () {
	        return editor.contextToolbars || [];
	      };
	      var getElementRect = function (elm) {
	        var pos, targetRect, root;
	        pos = DOM.getPos(editor.getContentAreaContainer());
	        targetRect = editor.dom.getRect(elm);
	        root = editor.dom.getRoot();
	        if (root.nodeName === 'BODY') {
	          targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
	          targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
	        }
	        targetRect.x += pos.x;
	        targetRect.y += pos.y;
	        return targetRect;
	      };
	      var reposition = function (match, shouldShow) {
	        var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
	        var handler = getInlineToolbarPositionHandler(editor);
	        if (editor.removed) {
	          return;
	        }
	        if (!match || !match.toolbar.panel) {
	          hideAllFloatingPanels(editor);
	          return;
	        }
	        testPositions = [
	          'bc-tc',
	          'tc-bc',
	          'tl-bl',
	          'bl-tl',
	          'tr-br',
	          'br-tr'
	        ];
	        panel = match.toolbar.panel;
	        if (shouldShow) {
	          panel.show();
	        }
	        elementRect = getElementRect(match.element);
	        panelRect = DOM.getRect(panel.getEl());
	        contentAreaRect = DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
	        var delta = UiContainer.getUiContainerDelta(panel).getOr({
	          x: 0,
	          y: 0
	        });
	        elementRect.x += delta.x;
	        elementRect.y += delta.y;
	        panelRect.x += delta.x;
	        panelRect.y += delta.y;
	        contentAreaRect.x += delta.x;
	        contentAreaRect.y += delta.y;
	        smallElementWidthThreshold = 25;
	        if (DOM.getStyle(match.element, 'display', true) !== 'inline') {
	          var clientRect = match.element.getBoundingClientRect();
	          elementRect.w = clientRect.width;
	          elementRect.h = clientRect.height;
	        }
	        if (!editor.inline) {
	          contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
	        }
	        if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
	          elementRect = global$6.inflate(elementRect, 0, 8);
	        }
	        relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
	        elementRect = global$6.clamp(elementRect, contentAreaRect);
	        if (relPos) {
	          relRect = global$6.relativePosition(panelRect, elementRect, relPos);
	          movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	        } else {
	          contentAreaRect.h += panelRect.h;
	          elementRect = global$6.intersect(contentAreaRect, elementRect);
	          if (elementRect) {
	            relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, [
	              'bc-tc',
	              'bl-tl',
	              'br-tr'
	            ]);
	            if (relPos) {
	              relRect = global$6.relativePosition(panelRect, elementRect, relPos);
	              movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	            } else {
	              movePanelTo(panel, userConstrain(handler, elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
	            }
	          } else {
	            panel.hide();
	          }
	        }
	        togglePositionClass(panel, relPos, function (pos1, pos2) {
	          return pos1 === pos2;
	        });
	      };
	      var repositionHandler = function (show) {
	        return function () {
	          var execute = function () {
	            if (editor.selection) {
	              reposition(findFrontMostMatch(editor.selection.getNode()), show);
	            }
	          };
	          global$7.requestAnimationFrame(execute);
	        };
	      };
	      var bindScrollEvent = function (panel) {
	        if (!scrollContainer) {
	          var reposition_1 = repositionHandler(true);
	          var uiContainer_1 = UiContainer.getUiContainer(panel);
	          scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
	          DOM.bind(scrollContainer, 'scroll', reposition_1);
	          DOM.bind(uiContainer_1, 'scroll', reposition_1);
	          editor.on('remove', function () {
	            DOM.unbind(scrollContainer, 'scroll', reposition_1);
	            DOM.unbind(uiContainer_1, 'scroll', reposition_1);
	          });
	        }
	      };
	      var showContextToolbar = function (match) {
	        var panel;
	        if (match.toolbar.panel) {
	          match.toolbar.panel.show();
	          reposition(match);
	          return;
	        }
	        panel = global$4.create({
	          type: 'floatpanel',
	          role: 'dialog',
	          classes: 'tinymce tinymce-inline arrow',
	          ariaLabel: 'Inline toolbar',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: true,
	          fixed: true,
	          border: 1,
	          items: Toolbar.createToolbar(editor, match.toolbar.items),
	          oncancel: function () {
	            editor.focus();
	          }
	        });
	        UiContainer.setUiContainer(editor, panel);
	        bindScrollEvent(panel);
	        match.toolbar.panel = panel;
	        panel.renderTo().reflow();
	        reposition(match);
	      };
	      var hideAllContextToolbars = function () {
	        global$2.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.hide();
	          }
	        });
	      };
	      var findFrontMostMatch = function (targetElm) {
	        var i, y, parentsAndSelf;
	        var toolbars = getContextToolbars();
	        parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
	        for (i = parentsAndSelf.length - 1; i >= 0; i--) {
	          for (y = toolbars.length - 1; y >= 0; y--) {
	            if (toolbars[y].predicate(parentsAndSelf[i])) {
	              return {
	                toolbar: toolbars[y],
	                element: parentsAndSelf[i]
	              };
	            }
	          }
	        }
	        return null;
	      };
	      editor.on('click keyup setContent ObjectResized', function (e) {
	        if (e.type === 'setcontent' && !e.selection) {
	          return;
	        }
	        global$7.setEditorTimeout(editor, function () {
	          var match;
	          match = findFrontMostMatch(editor.selection.getNode());
	          if (match) {
	            hideAllContextToolbars();
	            showContextToolbar(match);
	          } else {
	            hideAllContextToolbars();
	          }
	        });
	      });
	      editor.on('blur hide contextmenu', hideAllContextToolbars);
	      editor.on('ObjectResizeStart', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.hide();
	        }
	      });
	      editor.on('ResizeEditor ResizeWindow', repositionHandler(true));
	      editor.on('nodeChange', repositionHandler(false));
	      editor.on('remove', function () {
	        global$2.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.remove();
	          }
	        });
	        editor.contextToolbars = {};
	      });
	      editor.shortcuts.add('ctrl+F9', '', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.items()[0].focus();
	        }
	      });
	    };
	    var ContextToolbars = { addContextualToolbars: addContextualToolbars };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isArray = isType('array');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(i);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var defaultMenus = {
	      file: {
	        title: 'File',
	        items: 'newdocument restoredraft | preview | print'
	      },
	      edit: {
	        title: 'Edit',
	        items: 'undo redo | cut copy paste pastetext | selectall'
	      },
	      view: {
	        title: 'View',
	        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen'
	      },
	      insert: {
	        title: 'Insert',
	        items: 'image link media template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
	      },
	      format: {
	        title: 'Format',
	        items: 'bold italic underline strikethrough superscript subscript codeformat | blockformats align | removeformat'
	      },
	      tools: {
	        title: 'Tools',
	        items: 'spellchecker spellcheckerlanguage | a11ycheck code'
	      },
	      table: { title: 'Table' },
	      help: { title: 'Help' }
	    };
	    var delimiterMenuNamePair = function () {
	      return {
	        name: '|',
	        item: { text: '|' }
	      };
	    };
	    var createMenuNameItemPair = function (name, item) {
	      var menuItem = item ? {
	        name: name,
	        item: item
	      } : null;
	      return name === '|' ? delimiterMenuNamePair() : menuItem;
	    };
	    var hasItemName = function (namedMenuItems, name) {
	      return findIndex(namedMenuItems, function (namedMenuItem) {
	        return namedMenuItem.name === name;
	      }).isSome();
	    };
	    var isSeparator = function (namedMenuItem) {
	      return namedMenuItem && namedMenuItem.item.text === '|';
	    };
	    var cleanupMenu = function (namedMenuItems, removedMenuItems) {
	      var menuItemsPass1 = filter(namedMenuItems, function (namedMenuItem) {
	        return removedMenuItems.hasOwnProperty(namedMenuItem.name) === false;
	      });
	      var menuItemsPass2 = filter(menuItemsPass1, function (namedMenuItem, i) {
	        return !isSeparator(namedMenuItem) || !isSeparator(menuItemsPass1[i - 1]);
	      });
	      return filter(menuItemsPass2, function (namedMenuItem, i) {
	        return !isSeparator(namedMenuItem) || i > 0 && i < menuItemsPass2.length - 1;
	      });
	    };
	    var createMenu = function (editorMenuItems, menus, removedMenuItems, context) {
	      var menuButton, menu, namedMenuItems, isUserDefined;
	      if (menus) {
	        menu = menus[context];
	        isUserDefined = true;
	      } else {
	        menu = defaultMenus[context];
	      }
	      if (menu) {
	        menuButton = { text: menu.title };
	        namedMenuItems = [];
	        global$2.each((menu.items || '').split(/[ ,]/), function (name) {
	          var namedMenuItem = createMenuNameItemPair(name, editorMenuItems[name]);
	          if (namedMenuItem) {
	            namedMenuItems.push(namedMenuItem);
	          }
	        });
	        if (!isUserDefined) {
	          global$2.each(editorMenuItems, function (item, name) {
	            if (item.context === context && !hasItemName(namedMenuItems, name)) {
	              if (item.separator === 'before') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	              if (item.prependToContext) {
	                namedMenuItems.unshift(createMenuNameItemPair(name, item));
	              } else {
	                namedMenuItems.push(createMenuNameItemPair(name, item));
	              }
	              if (item.separator === 'after') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	            }
	          });
	        }
	        menuButton.menu = map(cleanupMenu(namedMenuItems, removedMenuItems), function (menuItem) {
	          return menuItem.item;
	        });
	        if (!menuButton.menu.length) {
	          return null;
	        }
	      }
	      return menuButton;
	    };
	    var getDefaultMenubar = function (editor) {
	      var name;
	      var defaultMenuBar = [];
	      var menu = getMenu(editor);
	      if (menu) {
	        for (name in menu) {
	          defaultMenuBar.push(name);
	        }
	      } else {
	        for (name in defaultMenus) {
	          defaultMenuBar.push(name);
	        }
	      }
	      return defaultMenuBar;
	    };
	    var createMenuButtons = function (editor) {
	      var menuButtons = [];
	      var defaultMenuBar = getDefaultMenubar(editor);
	      var removedMenuItems = global$2.makeMap(getRemovedMenuItems(editor).split(/[ ,]/));
	      var menubar = getMenubar(editor);
	      var enabledMenuNames = typeof menubar === 'string' ? menubar.split(/[ ,]/) : defaultMenuBar;
	      for (var i = 0; i < enabledMenuNames.length; i++) {
	        var menuItems = enabledMenuNames[i];
	        var menu = createMenu(editor.menuItems, getMenu(editor), removedMenuItems, menuItems);
	        if (menu) {
	          menuButtons.push(menu);
	        }
	      }
	      return menuButtons;
	    };
	    var Menubar = { createMenuButtons: createMenuButtons };
	
	    var DOM$1 = global$3.DOM;
	    var getSize = function (elm) {
	      return {
	        width: elm.clientWidth,
	        height: elm.clientHeight
	      };
	    };
	    var resizeTo = function (editor, width, height) {
	      var containerElm, iframeElm, containerSize, iframeSize;
	      containerElm = editor.getContainer();
	      iframeElm = editor.getContentAreaContainer().firstChild;
	      containerSize = getSize(containerElm);
	      iframeSize = getSize(iframeElm);
	      if (width !== null) {
	        width = Math.max(getMinWidth(editor), width);
	        width = Math.min(getMaxWidth(editor), width);
	        DOM$1.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
	        DOM$1.setStyle(iframeElm, 'width', width);
	      }
	      height = Math.max(getMinHeight(editor), height);
	      height = Math.min(getMaxHeight(editor), height);
	      DOM$1.setStyle(iframeElm, 'height', height);
	      Events.fireResizeEditor(editor);
	    };
	    var resizeBy = function (editor, dw, dh) {
	      var elm = editor.getContentAreaContainer();
	      resizeTo(editor, elm.clientWidth + dw, elm.clientHeight + dh);
	    };
	    var Resize = {
	      resizeTo: resizeTo,
	      resizeBy: resizeBy
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var api = function (elm) {
	      return {
	        element: function () {
	          return elm;
	        }
	      };
	    };
	    var trigger = function (sidebar, panel, callbackName) {
	      var callback = sidebar.settings[callbackName];
	      if (callback) {
	        callback(api(panel.getEl('body')));
	      }
	    };
	    var hidePanels = function (name, container, sidebars) {
	      global$2.each(sidebars, function (sidebar) {
	        var panel = container.items().filter('#' + sidebar.name)[0];
	        if (panel && panel.visible() && sidebar.name !== name) {
	          trigger(sidebar, panel, 'onhide');
	          panel.visible(false);
	        }
	      });
	    };
	    var deactivateButtons = function (toolbar) {
	      toolbar.items().each(function (ctrl) {
	        ctrl.active(false);
	      });
	    };
	    var findSidebar = function (sidebars, name) {
	      return global$2.grep(sidebars, function (sidebar) {
	        return sidebar.name === name;
	      })[0];
	    };
	    var showPanel = function (editor, name, sidebars) {
	      return function (e) {
	        var btnCtrl = e.control;
	        var container = btnCtrl.parents().filter('panel')[0];
	        var panel = container.find('#' + name)[0];
	        var sidebar = findSidebar(sidebars, name);
	        hidePanels(name, container, sidebars);
	        deactivateButtons(btnCtrl.parent());
	        if (panel && panel.visible()) {
	          trigger(sidebar, panel, 'onhide');
	          panel.hide();
	          btnCtrl.active(false);
	        } else {
	          if (panel) {
	            panel.show();
	            trigger(sidebar, panel, 'onshow');
	          } else {
	            panel = global$4.create({
	              type: 'container',
	              name: name,
	              layout: 'stack',
	              classes: 'sidebar-panel',
	              html: ''
	            });
	            container.prepend(panel);
	            trigger(sidebar, panel, 'onrender');
	            trigger(sidebar, panel, 'onshow');
	          }
	          btnCtrl.active(true);
	        }
	        Events.fireResizeEditor(editor);
	      };
	    };
	    var isModernBrowser = function () {
	      return !global$8.ie || global$8.ie >= 11;
	    };
	    var hasSidebar = function (editor) {
	      return isModernBrowser() && editor.sidebars ? editor.sidebars.length > 0 : false;
	    };
	    var createSidebar = function (editor) {
	      var buttons = global$2.map(editor.sidebars, function (sidebar) {
	        var settings = sidebar.settings;
	        return {
	          type: 'button',
	          icon: settings.icon,
	          image: settings.image,
	          tooltip: settings.tooltip,
	          onclick: showPanel(editor, sidebar.name, editor.sidebars)
	        };
	      });
	      return {
	        type: 'panel',
	        name: 'sidebar',
	        layout: 'stack',
	        classes: 'sidebar',
	        items: [{
	            type: 'toolbar',
	            layout: 'stack',
	            classes: 'sidebar-toolbar',
	            items: buttons
	          }]
	      };
	    };
	    var Sidebar = {
	      hasSidebar: hasSidebar,
	      createSidebar: createSidebar
	    };
	
	    var fireSkinLoaded$1 = function (editor) {
	      var done = function () {
	        editor._skinLoaded = true;
	        Events.fireSkinLoaded(editor);
	      };
	      return function () {
	        if (editor.initialized) {
	          done();
	        } else {
	          editor.on('init', done);
	        }
	      };
	    };
	    var SkinLoaded = { fireSkinLoaded: fireSkinLoaded$1 };
	
	    var DOM$2 = global$3.DOM;
	    var switchMode = function (panel) {
	      return function (e) {
	        panel.find('*').disabled(e.mode === 'readonly');
	      };
	    };
	    var editArea = function (border) {
	      return {
	        type: 'panel',
	        name: 'iframe',
	        layout: 'stack',
	        classes: 'edit-area',
	        border: border,
	        html: ''
	      };
	    };
	    var editAreaContainer = function (editor) {
	      return {
	        type: 'panel',
	        layout: 'stack',
	        classes: 'edit-aria-container',
	        border: '1 0 0 0',
	        items: [
	          editArea('0'),
	          Sidebar.createSidebar(editor)
	        ]
	      };
	    };
	    var render = function (editor, theme, args) {
	      var panel, resizeHandleCtrl, startSize;
	      if (isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM$2.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	      panel = theme.panel = global$4.create({
	        type: 'panel',
	        role: 'application',
	        classes: 'tinymce',
	        style: 'visibility: hidden',
	        layout: 'stack',
	        border: 1,
	        items: [
	          {
	            type: 'container',
	            classes: 'top-part',
	            items: [
	              hasMenubar(editor) === false ? null : {
	                type: 'menubar',
	                border: '0 0 1 0',
	                items: Menubar.createMenuButtons(editor)
	              },
	              Toolbar.createToolbars(editor, getToolbarSize(editor))
	            ]
	          },
	          Sidebar.hasSidebar(editor) ? editAreaContainer(editor) : editArea('1 0 0 0')
	        ]
	      });
	      UiContainer.setUiContainer(editor, panel);
	      if (getResize(editor) !== 'none') {
	        resizeHandleCtrl = {
	          type: 'resizehandle',
	          direction: getResize(editor),
	          onResizeStart: function () {
	            var elm = editor.getContentAreaContainer().firstChild;
	            startSize = {
	              width: elm.clientWidth,
	              height: elm.clientHeight
	            };
	          },
	          onResize: function (e) {
	            if (getResize(editor) === 'both') {
	              Resize.resizeTo(editor, startSize.width + e.deltaX, startSize.height + e.deltaY);
	            } else {
	              Resize.resizeTo(editor, null, startSize.height + e.deltaY);
	            }
	          }
	        };
	      }
	      if (hasStatusbar(editor)) {
	        var linkHtml = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce" rel="noopener" target="_blank" role="presentation" tabindex="-1">Tiny</a>';
	        var html = global$5.translate([
	          'Powered by {0}',
	          linkHtml
	        ]);
	        var brandingLabel = isBrandingEnabled(editor) ? {
	          type: 'label',
	          classes: 'branding',
	          html: ' ' + html
	        } : null;
	        panel.add({
	          type: 'panel',
	          name: 'statusbar',
	          classes: 'statusbar',
	          layout: 'flow',
	          border: '1 0 0 0',
	          ariaRoot: true,
	          items: [
	            {
	              type: 'elementpath',
	              editor: editor
	            },
	            resizeHandleCtrl,
	            brandingLabel
	          ]
	        });
	      }
	      Events.fireBeforeRenderUI(editor);
	      editor.on('SwitchMode', switchMode(panel));
	      panel.renderBefore(args.targetNode).reflow();
	      if (isReadOnly(editor)) {
	        editor.setMode('readonly');
	      }
	      if (args.width) {
	        DOM$2.setStyle(panel.getEl(), 'width', args.width);
	      }
	      editor.on('remove', function () {
	        panel.remove();
	        panel = null;
	      });
	      A11y.addKeys(editor, panel);
	      ContextToolbars.addContextualToolbars(editor);
	      return {
	        iframeContainer: panel.find('#iframe')[0].getEl(),
	        editorContainer: panel.getEl()
	      };
	    };
	    var Iframe = { render: render };
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var count = 0;
	    var funcs = {
	      id: function () {
	        return 'mceu_' + count++;
	      },
	      create: function (name, attrs, children) {
	        var elm = domGlobals.document.createElement(name);
	        global$3.DOM.setAttribs(elm, attrs);
	        if (typeof children === 'string') {
	          elm.innerHTML = children;
	        } else {
	          global$2.each(children, function (child) {
	            if (child.nodeType) {
	              elm.appendChild(child);
	            }
	          });
	        }
	        return elm;
	      },
	      createFragment: function (html) {
	        return global$3.DOM.createFragment(html);
	      },
	      getWindowSize: function () {
	        return global$3.DOM.getViewPort();
	      },
	      getSize: function (elm) {
	        var width, height;
	        if (elm.getBoundingClientRect) {
	          var rect = elm.getBoundingClientRect();
	          width = Math.max(rect.width || rect.right - rect.left, elm.offsetWidth);
	          height = Math.max(rect.height || rect.bottom - rect.bottom, elm.offsetHeight);
	        } else {
	          width = elm.offsetWidth;
	          height = elm.offsetHeight;
	        }
	        return {
	          width: width,
	          height: height
	        };
	      },
	      getPos: function (elm, root) {
	        return global$3.DOM.getPos(elm, root || funcs.getContainer());
	      },
	      getContainer: function () {
	        return global$8.container ? global$8.container : domGlobals.document.body;
	      },
	      getViewPort: function (win) {
	        return global$3.DOM.getViewPort(win);
	      },
	      get: function (id) {
	        return domGlobals.document.getElementById(id);
	      },
	      addClass: function (elm, cls) {
	        return global$3.DOM.addClass(elm, cls);
	      },
	      removeClass: function (elm, cls) {
	        return global$3.DOM.removeClass(elm, cls);
	      },
	      hasClass: function (elm, cls) {
	        return global$3.DOM.hasClass(elm, cls);
	      },
	      toggleClass: function (elm, cls, state) {
	        return global$3.DOM.toggleClass(elm, cls, state);
	      },
	      css: function (elm, name, value) {
	        return global$3.DOM.setStyle(elm, name, value);
	      },
	      getRuntimeStyle: function (elm, name) {
	        return global$3.DOM.getStyle(elm, name, true);
	      },
	      on: function (target, name, callback, scope) {
	        return global$3.DOM.bind(target, name, callback, scope);
	      },
	      off: function (target, name, callback) {
	        return global$3.DOM.unbind(target, name, callback);
	      },
	      fire: function (target, name, args) {
	        return global$3.DOM.fire(target, name, args);
	      },
	      innerHtml: function (elm, html) {
	        global$3.DOM.setHTML(elm, html);
	      }
	    };
	
	    var isStatic = function (elm) {
	      return funcs.getRuntimeStyle(elm, 'position') === 'static';
	    };
	    var isFixed = function (ctrl) {
	      return ctrl.state.get('fixed');
	    };
	    function calculateRelativePosition(ctrl, targetElm, rel) {
	      var ctrlElm, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
	      viewport = getWindowViewPort();
	      pos = funcs.getPos(targetElm, UiContainer.getUiContainer(ctrl));
	      x = pos.x;
	      y = pos.y;
	      if (isFixed(ctrl) && isStatic(domGlobals.document.body)) {
	        x -= viewport.x;
	        y -= viewport.y;
	      }
	      ctrlElm = ctrl.getEl();
	      size = funcs.getSize(ctrlElm);
	      selfW = size.width;
	      selfH = size.height;
	      size = funcs.getSize(targetElm);
	      targetW = size.width;
	      targetH = size.height;
	      rel = (rel || '').split('');
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	      if (rel[0] === 'c') {
	        y += Math.round(targetH / 2);
	      }
	      if (rel[1] === 'c') {
	        x += Math.round(targetW / 2);
	      }
	      if (rel[3] === 'b') {
	        y -= selfH;
	      }
	      if (rel[4] === 'r') {
	        x -= selfW;
	      }
	      if (rel[3] === 'c') {
	        y -= Math.round(selfH / 2);
	      }
	      if (rel[4] === 'c') {
	        x -= Math.round(selfW / 2);
	      }
	      return {
	        x: x,
	        y: y,
	        w: selfW,
	        h: selfH
	      };
	    }
	    var getUiContainerViewPort = function (customUiContainer) {
	      return {
	        x: 0,
	        y: 0,
	        w: customUiContainer.scrollWidth - 1,
	        h: customUiContainer.scrollHeight - 1
	      };
	    };
	    var getWindowViewPort = function () {
	      var win = domGlobals.window;
	      var x = Math.max(win.pageXOffset, domGlobals.document.body.scrollLeft, domGlobals.document.documentElement.scrollLeft);
	      var y = Math.max(win.pageYOffset, domGlobals.document.body.scrollTop, domGlobals.document.documentElement.scrollTop);
	      var w = win.innerWidth || domGlobals.document.documentElement.clientWidth;
	      var h = win.innerHeight || domGlobals.document.documentElement.clientHeight;
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var getViewPortRect = function (ctrl) {
	      var customUiContainer = UiContainer.getUiContainer(ctrl);
	      return customUiContainer && !isFixed(ctrl) ? getUiContainerViewPort(customUiContainer) : getWindowViewPort();
	    };
	    var Movable = {
	      testMoveRel: function (elm, rels) {
	        var viewPortRect = getViewPortRect(this);
	        for (var i = 0; i < rels.length; i++) {
	          var pos = calculateRelativePosition(this, elm, rels[i]);
	          if (isFixed(this)) {
	            if (pos.x > 0 && pos.x + pos.w < viewPortRect.w && pos.y > 0 && pos.y + pos.h < viewPortRect.h) {
	              return rels[i];
	            }
	          } else {
	            if (pos.x > viewPortRect.x && pos.x + pos.w < viewPortRect.w + viewPortRect.x && pos.y > viewPortRect.y && pos.y + pos.h < viewPortRect.h + viewPortRect.y) {
	              return rels[i];
	            }
	          }
	        }
	        return rels[0];
	      },
	      moveRel: function (elm, rel) {
	        if (typeof rel !== 'string') {
	          rel = this.testMoveRel(elm, rel);
	        }
	        var pos = calculateRelativePosition(this, elm, rel);
	        return this.moveTo(pos.x, pos.y);
	      },
	      moveBy: function (dx, dy) {
	        var self = this, rect = self.layoutRect();
	        self.moveTo(rect.x + dx, rect.y + dy);
	        return self;
	      },
	      moveTo: function (x, y) {
	        var self = this;
	        function constrain(value, max, size) {
	          if (value < 0) {
	            return 0;
	          }
	          if (value + size > max) {
	            value = max - size;
	            return value < 0 ? 0 : value;
	          }
	          return value;
	        }
	        if (self.settings.constrainToViewport) {
	          var viewPortRect = getViewPortRect(this);
	          var layoutRect = self.layoutRect();
	          x = constrain(x, viewPortRect.w + viewPortRect.x, layoutRect.w);
	          y = constrain(y, viewPortRect.h + viewPortRect.y, layoutRect.h);
	        }
	        var uiContainer = UiContainer.getUiContainer(self);
	        if (uiContainer && isStatic(uiContainer) && !isFixed(self)) {
	          x -= uiContainer.scrollLeft;
	          y -= uiContainer.scrollTop;
	        }
	        if (uiContainer) {
	          x += 1;
	          y += 1;
	        }
	        if (self.state.get('rendered')) {
	          self.layoutRect({
	            x: x,
	            y: y
	          }).repaint();
	        } else {
	          self.settings.x = x;
	          self.settings.y = y;
	        }
	        self.fire('move', {
	          x: x,
	          y: y
	        });
	        return self;
	      }
	    };
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.util.Class');
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.util.EventDispatcher');
	
	    var BoxUtils = {
	      parseBox: function (value) {
	        var len;
	        var radix = 10;
	        if (!value) {
	          return;
	        }
	        if (typeof value === 'number') {
	          value = value || 0;
	          return {
	            top: value,
	            left: value,
	            bottom: value,
	            right: value
	          };
	        }
	        value = value.split(' ');
	        len = value.length;
	        if (len === 1) {
	          value[1] = value[2] = value[3] = value[0];
	        } else if (len === 2) {
	          value[2] = value[0];
	          value[3] = value[1];
	        } else if (len === 3) {
	          value[3] = value[1];
	        }
	        return {
	          top: parseInt(value[0], radix) || 0,
	          right: parseInt(value[1], radix) || 0,
	          bottom: parseInt(value[2], radix) || 0,
	          left: parseInt(value[3], radix) || 0
	        };
	      },
	      measureBox: function (elm, prefix) {
	        function getStyle(name) {
	          var defaultView = elm.ownerDocument.defaultView;
	          if (defaultView) {
	            var computedStyle = defaultView.getComputedStyle(elm, null);
	            if (computedStyle) {
	              name = name.replace(/[A-Z]/g, function (a) {
	                return '-' + a;
	              });
	              return computedStyle.getPropertyValue(name);
	            } else {
	              return null;
	            }
	          }
	          return elm.currentStyle[name];
	        }
	        function getSide(name) {
	          var val = parseFloat(getStyle(name));
	          return isNaN(val) ? 0 : val;
	        }
	        return {
	          top: getSide(prefix + 'TopWidth'),
	          right: getSide(prefix + 'RightWidth'),
	          bottom: getSide(prefix + 'BottomWidth'),
	          left: getSide(prefix + 'LeftWidth')
	        };
	      }
	    };
	
	    function noop$1() {
	    }
	    function ClassList(onchange) {
	      this.cls = [];
	      this.cls._map = {};
	      this.onchange = onchange || noop$1;
	      this.prefix = '';
	    }
	    global$2.extend(ClassList.prototype, {
	      add: function (cls) {
	        if (cls && !this.contains(cls)) {
	          this.cls._map[cls] = true;
	          this.cls.push(cls);
	          this._change();
	        }
	        return this;
	      },
	      remove: function (cls) {
	        if (this.contains(cls)) {
	          var i = void 0;
	          for (i = 0; i < this.cls.length; i++) {
	            if (this.cls[i] === cls) {
	              break;
	            }
	          }
	          this.cls.splice(i, 1);
	          delete this.cls._map[cls];
	          this._change();
	        }
	        return this;
	      },
	      toggle: function (cls, state) {
	        var curState = this.contains(cls);
	        if (curState !== state) {
	          if (curState) {
	            this.remove(cls);
	          } else {
	            this.add(cls);
	          }
	          this._change();
	        }
	        return this;
	      },
	      contains: function (cls) {
	        return !!this.cls._map[cls];
	      },
	      _change: function () {
	        delete this.clsValue;
	        this.onchange.call(this);
	      }
	    });
	    ClassList.prototype.toString = function () {
	      var value;
	      if (this.clsValue) {
	        return this.clsValue;
	      }
	      value = '';
	      for (var i = 0; i < this.cls.length; i++) {
	        if (i > 0) {
	          value += ' ';
	        }
	        value += this.prefix + this.cls[i];
	      }
	      return value;
	    };
	
	    function unique(array) {
	      var uniqueItems = [];
	      var i = array.length, item;
	      while (i--) {
	        item = array[i];
	        if (!item.__checked) {
	          uniqueItems.push(item);
	          item.__checked = 1;
	        }
	      }
	      i = uniqueItems.length;
	      while (i--) {
	        delete uniqueItems[i].__checked;
	      }
	      return uniqueItems;
	    }
	    var expression = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
	    var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g;
	    var whiteSpace = /^\s*|\s*$/g;
	    var Collection;
	    var Selector = global$a.extend({
	      init: function (selector) {
	        var match = this.match;
	        function compileNameFilter(name) {
	          if (name) {
	            name = name.toLowerCase();
	            return function (item) {
	              return name === '*' || item.type === name;
	            };
	          }
	        }
	        function compileIdFilter(id) {
	          if (id) {
	            return function (item) {
	              return item._name === id;
	            };
	          }
	        }
	        function compileClassesFilter(classes) {
	          if (classes) {
	            classes = classes.split('.');
	            return function (item) {
	              var i = classes.length;
	              while (i--) {
	                if (!item.classes.contains(classes[i])) {
	                  return false;
	                }
	              }
	              return true;
	            };
	          }
	        }
	        function compileAttrFilter(name, cmp, check) {
	          if (name) {
	            return function (item) {
	              var value = item[name] ? item[name]() : '';
	              return !cmp ? !!check : cmp === '=' ? value === check : cmp === '*=' ? value.indexOf(check) >= 0 : cmp === '~=' ? (' ' + value + ' ').indexOf(' ' + check + ' ') >= 0 : cmp === '!=' ? value !== check : cmp === '^=' ? value.indexOf(check) === 0 : cmp === '$=' ? value.substr(value.length - check.length) === check : false;
	            };
	          }
	        }
	        function compilePsuedoFilter(name) {
	          var notSelectors;
	          if (name) {
	            name = /(?:not\((.+)\))|(.+)/i.exec(name);
	            if (!name[1]) {
	              name = name[2];
	              return function (item, index, length) {
	                return name === 'first' ? index === 0 : name === 'last' ? index === length - 1 : name === 'even' ? index % 2 === 0 : name === 'odd' ? index % 2 === 1 : item[name] ? item[name]() : false;
	              };
	            }
	            notSelectors = parseChunks(name[1], []);
	            return function (item) {
	              return !match(item, notSelectors);
	            };
	          }
	        }
	        function compile(selector, filters, direct) {
	          var parts;
	          function add(filter) {
	            if (filter) {
	              filters.push(filter);
	            }
	          }
	          parts = expression.exec(selector.replace(whiteSpace, ''));
	          add(compileNameFilter(parts[1]));
	          add(compileIdFilter(parts[2]));
	          add(compileClassesFilter(parts[3]));
	          add(compileAttrFilter(parts[4], parts[5], parts[6]));
	          add(compilePsuedoFilter(parts[7]));
	          filters.pseudo = !!parts[7];
	          filters.direct = direct;
	          return filters;
	        }
	        function parseChunks(selector, selectors) {
	          var parts = [];
	          var extra, matches, i;
	          do {
	            chunker.exec('');
	            matches = chunker.exec(selector);
	            if (matches) {
	              selector = matches[3];
	              parts.push(matches[1]);
	              if (matches[2]) {
	                extra = matches[3];
	                break;
	              }
	            }
	          } while (matches);
	          if (extra) {
	            parseChunks(extra, selectors);
	          }
	          selector = [];
	          for (i = 0; i < parts.length; i++) {
	            if (parts[i] !== '>') {
	              selector.push(compile(parts[i], [], parts[i - 1] === '>'));
	            }
	          }
	          selectors.push(selector);
	          return selectors;
	        }
	        this._selectors = parseChunks(selector, []);
	      },
	      match: function (control, selectors) {
	        var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
	        selectors = selectors || this._selectors;
	        for (i = 0, l = selectors.length; i < l; i++) {
	          selector = selectors[i];
	          sl = selector.length;
	          item = control;
	          count = 0;
	          for (si = sl - 1; si >= 0; si--) {
	            filters = selector[si];
	            while (item) {
	              if (filters.pseudo) {
	                siblings = item.parent().items();
	                index = length = siblings.length;
	                while (index--) {
	                  if (siblings[index] === item) {
	                    break;
	                  }
	                }
	              }
	              for (fi = 0, fl = filters.length; fi < fl; fi++) {
	                if (!filters[fi](item, index, length)) {
	                  fi = fl + 1;
	                  break;
	                }
	              }
	              if (fi === fl) {
	                count++;
	                break;
	              } else {
	                if (si === sl - 1) {
	                  break;
	                }
	              }
	              item = item.parent();
	            }
	          }
	          if (count === sl) {
	            return true;
	          }
	        }
	        return false;
	      },
	      find: function (container) {
	        var matches = [], i, l;
	        var selectors = this._selectors;
	        function collect(items, selector, index) {
	          var i, l, fi, fl, item;
	          var filters = selector[index];
	          for (i = 0, l = items.length; i < l; i++) {
	            item = items[i];
	            for (fi = 0, fl = filters.length; fi < fl; fi++) {
	              if (!filters[fi](item, i, l)) {
	                fi = fl + 1;
	                break;
	              }
	            }
	            if (fi === fl) {
	              if (index === selector.length - 1) {
	                matches.push(item);
	              } else {
	                if (item.items) {
	                  collect(item.items(), selector, index + 1);
	                }
	              }
	            } else if (filters.direct) {
	              return;
	            }
	            if (item.items) {
	              collect(item.items(), selector, index);
	            }
	          }
	        }
	        if (container.items) {
	          for (i = 0, l = selectors.length; i < l; i++) {
	            collect(container.items(), selectors[i], 0);
	          }
	          if (l > 1) {
	            matches = unique(matches);
	          }
	        }
	        if (!Collection) {
	          Collection = Selector.Collection;
	        }
	        return new Collection(matches);
	      }
	    });
	
	    var Collection$1, proto;
	    var push = Array.prototype.push, slice = Array.prototype.slice;
	    proto = {
	      length: 0,
	      init: function (items) {
	        if (items) {
	          this.add(items);
	        }
	      },
	      add: function (items) {
	        var self = this;
	        if (!global$2.isArray(items)) {
	          if (items instanceof Collection$1) {
	            self.add(items.toArray());
	          } else {
	            push.call(self, items);
	          }
	        } else {
	          push.apply(self, items);
	        }
	        return self;
	      },
	      set: function (items) {
	        var self = this;
	        var len = self.length;
	        var i;
	        self.length = 0;
	        self.add(items);
	        for (i = self.length; i < len; i++) {
	          delete self[i];
	        }
	        return self;
	      },
	      filter: function (selector) {
	        var self = this;
	        var i, l;
	        var matches = [];
	        var item, match;
	        if (typeof selector === 'string') {
	          selector = new Selector(selector);
	          match = function (item) {
	            return selector.match(item);
	          };
	        } else {
	          match = selector;
	        }
	        for (i = 0, l = self.length; i < l; i++) {
	          item = self[i];
	          if (match(item)) {
	            matches.push(item);
	          }
	        }
	        return new Collection$1(matches);
	      },
	      slice: function () {
	        return new Collection$1(slice.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      each: function (callback) {
	        global$2.each(this, callback);
	        return this;
	      },
	      toArray: function () {
	        return global$2.toArray(this);
	      },
	      indexOf: function (ctrl) {
	        var self = this;
	        var i = self.length;
	        while (i--) {
	          if (self[i] === ctrl) {
	            break;
	          }
	        }
	        return i;
	      },
	      reverse: function () {
	        return new Collection$1(global$2.toArray(this).reverse());
	      },
	      hasClass: function (cls) {
	        return this[0] ? this[0].classes.contains(cls) : false;
	      },
	      prop: function (name, value) {
	        var self = this;
	        var item;
	        if (value !== undefined) {
	          self.each(function (item) {
	            if (item[name]) {
	              item[name](value);
	            }
	          });
	          return self;
	        }
	        item = self[0];
	        if (item && item[name]) {
	          return item[name]();
	        }
	      },
	      exec: function (name) {
	        var self = this, args = global$2.toArray(arguments).slice(1);
	        self.each(function (item) {
	          if (item[name]) {
	            item[name].apply(item, args);
	          }
	        });
	        return self;
	      },
	      remove: function () {
	        var i = this.length;
	        while (i--) {
	          this[i].remove();
	        }
	        return this;
	      },
	      addClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.add(cls);
	        });
	      },
	      removeClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.remove(cls);
	        });
	      }
	    };
	    global$2.each('fire on off show hide append prepend before after reflow'.split(' '), function (name) {
	      proto[name] = function () {
	        var args = global$2.toArray(arguments);
	        this.each(function (ctrl) {
	          if (name in ctrl) {
	            ctrl[name].apply(ctrl, args);
	          }
	        });
	        return this;
	      };
	    });
	    global$2.each('text name disabled active selected checked visible parent value data'.split(' '), function (name) {
	      proto[name] = function (value) {
	        return this.prop(name, value);
	      };
	    });
	    Collection$1 = global$a.extend(proto);
	    Selector.Collection = Collection$1;
	    var Collection$2 = Collection$1;
	
	    var Binding = function (settings) {
	      this.create = settings.create;
	    };
	    Binding.create = function (model, name) {
	      return new Binding({
	        create: function (otherModel, otherName) {
	          var bindings;
	          var fromSelfToOther = function (e) {
	            otherModel.set(otherName, e.value);
	          };
	          var fromOtherToSelf = function (e) {
	            model.set(name, e.value);
	          };
	          otherModel.on('change:' + otherName, fromOtherToSelf);
	          model.on('change:' + name, fromSelfToOther);
	          bindings = otherModel._bindings;
	          if (!bindings) {
	            bindings = otherModel._bindings = [];
	            otherModel.on('destroy', function () {
	              var i = bindings.length;
	              while (i--) {
	                bindings[i]();
	              }
	            });
	          }
	          bindings.push(function () {
	            model.off('change:' + name, fromSelfToOther);
	          });
	          return model.get(name);
	        }
	      });
	    };
	
	    var global$c = tinymce.util.Tools.resolve('tinymce.util.Observable');
	
	    function isNode(node) {
	      return node.nodeType > 0;
	    }
	    function isEqual(a, b) {
	      var k, checked;
	      if (a === b) {
	        return true;
	      }
	      if (a === null || b === null) {
	        return a === b;
	      }
	      if (typeof a !== 'object' || typeof b !== 'object') {
	        return a === b;
	      }
	      if (global$2.isArray(b)) {
	        if (a.length !== b.length) {
	          return false;
	        }
	        k = a.length;
	        while (k--) {
	          if (!isEqual(a[k], b[k])) {
	            return false;
	          }
	        }
	      }
	      if (isNode(a) || isNode(b)) {
	        return a === b;
	      }
	      checked = {};
	      for (k in b) {
	        if (!isEqual(a[k], b[k])) {
	          return false;
	        }
	        checked[k] = true;
	      }
	      for (k in a) {
	        if (!checked[k] && !isEqual(a[k], b[k])) {
	          return false;
	        }
	      }
	      return true;
	    }
	    var ObservableObject = global$a.extend({
	      Mixins: [global$c],
	      init: function (data) {
	        var name, value;
	        data = data || {};
	        for (name in data) {
	          value = data[name];
	          if (value instanceof Binding) {
	            data[name] = value.create(this, name);
	          }
	        }
	        this.data = data;
	      },
	      set: function (name, value) {
	        var key, args;
	        var oldValue = this.data[name];
	        if (value instanceof Binding) {
	          value = value.create(this, name);
	        }
	        if (typeof name === 'object') {
	          for (key in name) {
	            this.set(key, name[key]);
	          }
	          return this;
	        }
	        if (!isEqual(oldValue, value)) {
	          this.data[name] = value;
	          args = {
	            target: this,
	            name: name,
	            value: value,
	            oldValue: oldValue
	          };
	          this.fire('change:' + name, args);
	          this.fire('change', args);
	        }
	        return this;
	      },
	      get: function (name) {
	        return this.data[name];
	      },
	      has: function (name) {
	        return name in this.data;
	      },
	      bind: function (name) {
	        return Binding.create(this, name);
	      },
	      destroy: function () {
	        this.fire('destroy');
	      }
	    });
	
	    var dirtyCtrls = {}, animationFrameRequested;
	    var ReflowQueue = {
	      add: function (ctrl) {
	        var parent = ctrl.parent();
	        if (parent) {
	          if (!parent._layout || parent._layout.isNative()) {
	            return;
	          }
	          if (!dirtyCtrls[parent._id]) {
	            dirtyCtrls[parent._id] = parent;
	          }
	          if (!animationFrameRequested) {
	            animationFrameRequested = true;
	            global$7.requestAnimationFrame(function () {
	              var id, ctrl;
	              animationFrameRequested = false;
	              for (id in dirtyCtrls) {
	                ctrl = dirtyCtrls[id];
	                if (ctrl.state.get('rendered')) {
	                  ctrl.reflow();
	                }
	              }
	              dirtyCtrls = {};
	            }, domGlobals.document.body);
	          }
	        }
	      },
	      remove: function (ctrl) {
	        if (dirtyCtrls[ctrl._id]) {
	          delete dirtyCtrls[ctrl._id];
	        }
	      }
	    };
	
	    var hasMouseWheelEventSupport = 'onmousewheel' in domGlobals.document;
	    var hasWheelEventSupport = false;
	    var classPrefix = 'mce-';
	    var Control, idCounter = 0;
	    var proto$1 = {
	      Statics: { classPrefix: classPrefix },
	      isRtl: function () {
	        return Control.rtl;
	      },
	      classPrefix: classPrefix,
	      init: function (settings) {
	        var self = this;
	        var classes, defaultClasses;
	        function applyClasses(classes) {
	          var i;
	          classes = classes.split(' ');
	          for (i = 0; i < classes.length; i++) {
	            self.classes.add(classes[i]);
	          }
	        }
	        self.settings = settings = global$2.extend({}, self.Defaults, settings);
	        self._id = settings.id || 'mceu_' + idCounter++;
	        self._aria = { role: settings.role };
	        self._elmCache = {};
	        self.$ = global$9;
	        self.state = new ObservableObject({
	          visible: true,
	          active: false,
	          disabled: false,
	          value: ''
	        });
	        self.data = new ObservableObject(settings.data);
	        self.classes = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl().className = this.toString();
	          }
	        });
	        self.classes.prefix = self.classPrefix;
	        classes = settings.classes;
	        if (classes) {
	          if (self.Defaults) {
	            defaultClasses = self.Defaults.classes;
	            if (defaultClasses && classes !== defaultClasses) {
	              applyClasses(defaultClasses);
	            }
	          }
	          applyClasses(classes);
	        }
	        global$2.each('title text name visible disabled active value'.split(' '), function (name) {
	          if (name in settings) {
	            self[name](settings[name]);
	          }
	        });
	        self.on('click', function () {
	          if (self.disabled()) {
	            return false;
	          }
	        });
	        self.settings = settings;
	        self.borderBox = BoxUtils.parseBox(settings.border);
	        self.paddingBox = BoxUtils.parseBox(settings.padding);
	        self.marginBox = BoxUtils.parseBox(settings.margin);
	        if (settings.hidden) {
	          self.hide();
	        }
	      },
	      Properties: 'parent,name',
	      getContainerElm: function () {
	        var uiContainer = UiContainer.getUiContainer(this);
	        return uiContainer ? uiContainer : funcs.getContainer();
	      },
	      getParentCtrl: function (elm) {
	        var ctrl;
	        var lookup = this.getRoot().controlIdLookup;
	        while (elm && lookup) {
	          ctrl = lookup[elm.id];
	          if (ctrl) {
	            break;
	          }
	          elm = elm.parentNode;
	        }
	        return ctrl;
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var settings = self.settings;
	        var borderBox, layoutRect;
	        var elm = self.getEl();
	        var width, height, minWidth, minHeight, autoResize;
	        var startMinWidth, startMinHeight, initialSize;
	        borderBox = self.borderBox = self.borderBox || BoxUtils.measureBox(elm, 'border');
	        self.paddingBox = self.paddingBox || BoxUtils.measureBox(elm, 'padding');
	        self.marginBox = self.marginBox || BoxUtils.measureBox(elm, 'margin');
	        initialSize = funcs.getSize(elm);
	        startMinWidth = settings.minWidth;
	        startMinHeight = settings.minHeight;
	        minWidth = startMinWidth || initialSize.width;
	        minHeight = startMinHeight || initialSize.height;
	        width = settings.width;
	        height = settings.height;
	        autoResize = settings.autoResize;
	        autoResize = typeof autoResize !== 'undefined' ? autoResize : !width && !height;
	        width = width || minWidth;
	        height = height || minHeight;
	        var deltaW = borderBox.left + borderBox.right;
	        var deltaH = borderBox.top + borderBox.bottom;
	        var maxW = settings.maxWidth || 65535;
	        var maxH = settings.maxHeight || 65535;
	        self._layoutRect = layoutRect = {
	          x: settings.x || 0,
	          y: settings.y || 0,
	          w: width,
	          h: height,
	          deltaW: deltaW,
	          deltaH: deltaH,
	          contentW: width - deltaW,
	          contentH: height - deltaH,
	          innerW: width - deltaW,
	          innerH: height - deltaH,
	          startMinWidth: startMinWidth || 0,
	          startMinHeight: startMinHeight || 0,
	          minW: Math.min(minWidth, maxW),
	          minH: Math.min(minHeight, maxH),
	          maxW: maxW,
	          maxH: maxH,
	          autoResize: autoResize,
	          scrollW: 0
	        };
	        self._lastLayoutRect = {};
	        return layoutRect;
	      },
	      layoutRect: function (newRect) {
	        var self = this;
	        var curRect = self._layoutRect, lastLayoutRect, size, deltaWidth, deltaHeight, repaintControls;
	        if (!curRect) {
	          curRect = self.initLayoutRect();
	        }
	        if (newRect) {
	          deltaWidth = curRect.deltaW;
	          deltaHeight = curRect.deltaH;
	          if (newRect.x !== undefined) {
	            curRect.x = newRect.x;
	          }
	          if (newRect.y !== undefined) {
	            curRect.y = newRect.y;
	          }
	          if (newRect.minW !== undefined) {
	            curRect.minW = newRect.minW;
	          }
	          if (newRect.minH !== undefined) {
	            curRect.minH = newRect.minH;
	          }
	          size = newRect.w;
	          if (size !== undefined) {
	            size = size < curRect.minW ? curRect.minW : size;
	            size = size > curRect.maxW ? curRect.maxW : size;
	            curRect.w = size;
	            curRect.innerW = size - deltaWidth;
	          }
	          size = newRect.h;
	          if (size !== undefined) {
	            size = size < curRect.minH ? curRect.minH : size;
	            size = size > curRect.maxH ? curRect.maxH : size;
	            curRect.h = size;
	            curRect.innerH = size - deltaHeight;
	          }
	          size = newRect.innerW;
	          if (size !== undefined) {
	            size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
	            size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
	            curRect.innerW = size;
	            curRect.w = size + deltaWidth;
	          }
	          size = newRect.innerH;
	          if (size !== undefined) {
	            size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
	            size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
	            curRect.innerH = size;
	            curRect.h = size + deltaHeight;
	          }
	          if (newRect.contentW !== undefined) {
	            curRect.contentW = newRect.contentW;
	          }
	          if (newRect.contentH !== undefined) {
	            curRect.contentH = newRect.contentH;
	          }
	          lastLayoutRect = self._lastLayoutRect;
	          if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y || lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
	            repaintControls = Control.repaintControls;
	            if (repaintControls) {
	              if (repaintControls.map && !repaintControls.map[self._id]) {
	                repaintControls.push(self);
	                repaintControls.map[self._id] = true;
	              }
	            }
	            lastLayoutRect.x = curRect.x;
	            lastLayoutRect.y = curRect.y;
	            lastLayoutRect.w = curRect.w;
	            lastLayoutRect.h = curRect.h;
	          }
	          return self;
	        }
	        return curRect;
	      },
	      repaint: function () {
	        var self = this;
	        var style, bodyStyle, bodyElm, rect, borderBox;
	        var borderW, borderH, lastRepaintRect, round, value;
	        round = !domGlobals.document.createRange ? Math.round : function (value) {
	          return value;
	        };
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right;
	        borderH = borderBox.top + borderBox.bottom;
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = round(rect.x) + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = round(rect.y) + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	        if (rect.w !== lastRepaintRect.w) {
	          value = round(rect.w - borderW);
	          style.width = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	        if (rect.h !== lastRepaintRect.h) {
	          value = round(rect.h - borderH);
	          style.height = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	        if (self._hasBody && rect.innerW !== lastRepaintRect.innerW) {
	          value = round(rect.innerW);
	          bodyElm = self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyElm.style;
	            bodyStyle.width = (value >= 0 ? value : 0) + 'px';
	          }
	          lastRepaintRect.innerW = rect.innerW;
	        }
	        if (self._hasBody && rect.innerH !== lastRepaintRect.innerH) {
	          value = round(rect.innerH);
	          bodyElm = bodyElm || self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyStyle || bodyElm.style;
	            bodyStyle.height = (value >= 0 ? value : 0) + 'px';
	          }
	          lastRepaintRect.innerH = rect.innerH;
	        }
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	      },
	      updateLayoutRect: function () {
	        var self = this;
	        self.parent()._lastRect = null;
	        funcs.css(self.getEl(), {
	          width: '',
	          height: ''
	        });
	        self._layoutRect = self._lastRepaintRect = self._lastLayoutRect = null;
	        self.initLayoutRect();
	      },
	      on: function (name, callback) {
	        var self = this;
	        function resolveCallbackName(name) {
	          var callback, scope;
	          if (typeof name !== 'string') {
	            return name;
	          }
	          return function (e) {
	            if (!callback) {
	              self.parentsAndSelf().each(function (ctrl) {
	                var callbacks = ctrl.settings.callbacks;
	                if (callbacks && (callback = callbacks[name])) {
	                  scope = ctrl;
	                  return false;
	                }
	              });
	            }
	            if (!callback) {
	              e.action = name;
	              this.fire('execute', e);
	              return;
	            }
	            return callback.call(scope, e);
	          };
	        }
	        getEventDispatcher(self).on(name, resolveCallbackName(callback));
	        return self;
	      },
	      off: function (name, callback) {
	        getEventDispatcher(this).off(name, callback);
	        return this;
	      },
	      fire: function (name, args, bubble) {
	        var self = this;
	        args = args || {};
	        if (!args.control) {
	          args.control = self;
	        }
	        args = getEventDispatcher(self).fire(name, args);
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	        return args;
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      },
	      parents: function (selector) {
	        var self = this;
	        var ctrl, parents = new Collection$2();
	        for (ctrl = self.parent(); ctrl; ctrl = ctrl.parent()) {
	          parents.add(ctrl);
	        }
	        if (selector) {
	          parents = parents.filter(selector);
	        }
	        return parents;
	      },
	      parentsAndSelf: function (selector) {
	        return new Collection$2(this).add(this.parents(selector));
	      },
	      next: function () {
	        var parentControls = this.parent().items();
	        return parentControls[parentControls.indexOf(this) + 1];
	      },
	      prev: function () {
	        var parentControls = this.parent().items();
	        return parentControls[parentControls.indexOf(this) - 1];
	      },
	      innerHtml: function (html) {
	        this.$el.html(html);
	        return this;
	      },
	      getEl: function (suffix) {
	        var id = suffix ? this._id + '-' + suffix : this._id;
	        if (!this._elmCache[id]) {
	          this._elmCache[id] = global$9('#' + id)[0];
	        }
	        return this._elmCache[id];
	      },
	      show: function () {
	        return this.visible(true);
	      },
	      hide: function () {
	        return this.visible(false);
	      },
	      focus: function () {
	        try {
	          this.getEl().focus();
	        } catch (ex) {
	        }
	        return this;
	      },
	      blur: function () {
	        this.getEl().blur();
	        return this;
	      },
	      aria: function (name, value) {
	        var self = this, elm = self.getEl(self.ariaTarget);
	        if (typeof value === 'undefined') {
	          return self._aria[name];
	        }
	        self._aria[name] = value;
	        if (self.state.get('rendered')) {
	          elm.setAttribute(name === 'role' ? name : 'aria-' + name, value);
	        }
	        return self;
	      },
	      encode: function (text, translate) {
	        if (translate !== false) {
	          text = this.translate(text);
	        }
	        return (text || '').replace(/[&<>"]/g, function (match) {
	          return '&#' + match.charCodeAt(0) + ';';
	        });
	      },
	      translate: function (text) {
	        return Control.translate ? Control.translate(text) : text;
	      },
	      before: function (items) {
	        var self = this, parent = self.parent();
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self), true);
	        }
	        return self;
	      },
	      after: function (items) {
	        var self = this, parent = self.parent();
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self));
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var elm = self.getEl();
	        var parent = self.parent();
	        var newItems, i;
	        if (self.items) {
	          var controls = self.items().toArray();
	          i = controls.length;
	          while (i--) {
	            controls[i].remove();
	          }
	        }
	        if (parent && parent.items) {
	          newItems = [];
	          parent.items().each(function (item) {
	            if (item !== self) {
	              newItems.push(item);
	            }
	          });
	          parent.items().set(newItems);
	          parent._lastRect = null;
	        }
	        if (self._eventsRoot && self._eventsRoot === self) {
	          global$9(elm).off();
	        }
	        var lookup = self.getRoot().controlIdLookup;
	        if (lookup) {
	          delete lookup[self._id];
	        }
	        if (elm && elm.parentNode) {
	          elm.parentNode.removeChild(elm);
	        }
	        self.state.set('rendered', false);
	        self.state.destroy();
	        self.fire('remove');
	        return self;
	      },
	      renderBefore: function (elm) {
	        global$9(elm).before(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	      renderTo: function (elm) {
	        global$9(elm || this.getContainerElm()).append(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	      preRender: function () {
	      },
	      render: function () {
	      },
	      renderHtml: function () {
	        return '<div id="' + this._id + '" class="' + this.classes + '"></div>';
	      },
	      postRender: function () {
	        var self = this;
	        var settings = self.settings;
	        var elm, box, parent, name, parentEventsRoot;
	        self.$el = global$9(self.getEl());
	        self.state.set('rendered', true);
	        for (name in settings) {
	          if (name.indexOf('on') === 0) {
	            self.on(name.substr(2), settings[name]);
	          }
	        }
	        if (self._eventsRoot) {
	          for (parent = self.parent(); !parentEventsRoot && parent; parent = parent.parent()) {
	            parentEventsRoot = parent._eventsRoot;
	          }
	          if (parentEventsRoot) {
	            for (name in parentEventsRoot._nativeEvents) {
	              self._nativeEvents[name] = true;
	            }
	          }
	        }
	        bindPendingEvents(self);
	        if (settings.style) {
	          elm = self.getEl();
	          if (elm) {
	            elm.setAttribute('style', settings.style);
	            elm.style.cssText = settings.style;
	          }
	        }
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	        var root = self.getRoot();
	        if (!root.controlIdLookup) {
	          root.controlIdLookup = {};
	        }
	        root.controlIdLookup[self._id] = self;
	        for (var key in self._aria) {
	          self.aria(key, self._aria[key]);
	        }
	        if (self.state.get('visible') === false) {
	          self.getEl().style.display = 'none';
	        }
	        self.bindStates();
	        self.state.on('change:visible', function (e) {
	          var state = e.value;
	          var parentCtrl;
	          if (self.state.get('rendered')) {
	            self.getEl().style.display = state === false ? 'none' : '';
	            self.getEl().getBoundingClientRect();
	          }
	          parentCtrl = self.parent();
	          if (parentCtrl) {
	            parentCtrl._lastRect = null;
	          }
	          self.fire(state ? 'show' : 'hide');
	          ReflowQueue.add(self);
	        });
	        self.fire('postrender', {}, false);
	      },
	      bindStates: function () {
	      },
	      scrollIntoView: function (align) {
	        function getOffset(elm, rootElm) {
	          var x, y, parent = elm;
	          x = y = 0;
	          while (parent && parent !== rootElm && parent.nodeType) {
	            x += parent.offsetLeft || 0;
	            y += parent.offsetTop || 0;
	            parent = parent.offsetParent;
	          }
	          return {
	            x: x,
	            y: y
	          };
	        }
	        var elm = this.getEl(), parentElm = elm.parentNode;
	        var x, y, width, height, parentWidth, parentHeight;
	        var pos = getOffset(elm, parentElm);
	        x = pos.x;
	        y = pos.y;
	        width = elm.offsetWidth;
	        height = elm.offsetHeight;
	        parentWidth = parentElm.clientWidth;
	        parentHeight = parentElm.clientHeight;
	        if (align === 'end') {
	          x -= parentWidth - width;
	          y -= parentHeight - height;
	        } else if (align === 'center') {
	          x -= parentWidth / 2 - width / 2;
	          y -= parentHeight / 2 - height / 2;
	        }
	        parentElm.scrollLeft = x;
	        parentElm.scrollTop = y;
	        return this;
	      },
	      getRoot: function () {
	        var ctrl = this, rootControl;
	        var parents = [];
	        while (ctrl) {
	          if (ctrl.rootControl) {
	            rootControl = ctrl.rootControl;
	            break;
	          }
	          parents.push(ctrl);
	          rootControl = ctrl;
	          ctrl = ctrl.parent();
	        }
	        if (!rootControl) {
	          rootControl = this;
	        }
	        var i = parents.length;
	        while (i--) {
	          parents[i].rootControl = rootControl;
	        }
	        return rootControl;
	      },
	      reflow: function () {
	        ReflowQueue.remove(this);
	        var parent = this.parent();
	        if (parent && parent._layout && !parent._layout.isNative()) {
	          parent.reflow();
	        }
	        return this;
	      }
	    };
	    global$2.each('text title visible disabled active value'.split(' '), function (name) {
	      proto$1[name] = function (value) {
	        if (arguments.length === 0) {
	          return this.state.get(name);
	        }
	        if (typeof value !== 'undefined') {
	          this.state.set(name, value);
	        }
	        return this;
	      };
	    });
	    Control = global$a.extend(proto$1);
	    function getEventDispatcher(obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new global$b({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (state && global$b.isNative(name)) {
	              if (!obj._nativeEvents) {
	                obj._nativeEvents = {};
	              }
	              obj._nativeEvents[name] = true;
	              if (obj.state.get('rendered')) {
	                bindPendingEvents(obj);
	              }
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    }
	    function bindPendingEvents(eventCtrl) {
	      var i, l, parents, eventRootCtrl, nativeEvents, name;
	      function delegate(e) {
	        var control = eventCtrl.getParentCtrl(e.target);
	        if (control) {
	          control.fire(e.type, e);
	        }
	      }
	      function mouseLeaveHandler() {
	        var ctrl = eventRootCtrl._lastHoverCtrl;
	        if (ctrl) {
	          ctrl.fire('mouseleave', { target: ctrl.getEl() });
	          ctrl.parents().each(function (ctrl) {
	            ctrl.fire('mouseleave', { target: ctrl.getEl() });
	          });
	          eventRootCtrl._lastHoverCtrl = null;
	        }
	      }
	      function mouseEnterHandler(e) {
	        var ctrl = eventCtrl.getParentCtrl(e.target), lastCtrl = eventRootCtrl._lastHoverCtrl, idx = 0, i, parents, lastParents;
	        if (ctrl !== lastCtrl) {
	          eventRootCtrl._lastHoverCtrl = ctrl;
	          parents = ctrl.parents().toArray().reverse();
	          parents.push(ctrl);
	          if (lastCtrl) {
	            lastParents = lastCtrl.parents().toArray().reverse();
	            lastParents.push(lastCtrl);
	            for (idx = 0; idx < lastParents.length; idx++) {
	              if (parents[idx] !== lastParents[idx]) {
	                break;
	              }
	            }
	            for (i = lastParents.length - 1; i >= idx; i--) {
	              lastCtrl = lastParents[i];
	              lastCtrl.fire('mouseleave', { target: lastCtrl.getEl() });
	            }
	          }
	          for (i = idx; i < parents.length; i++) {
	            ctrl = parents[i];
	            ctrl.fire('mouseenter', { target: ctrl.getEl() });
	          }
	        }
	      }
	      function fixWheelEvent(e) {
	        e.preventDefault();
	        if (e.type === 'mousewheel') {
	          e.deltaY = -1 / 40 * e.wheelDelta;
	          if (e.wheelDeltaX) {
	            e.deltaX = -1 / 40 * e.wheelDeltaX;
	          }
	        } else {
	          e.deltaX = 0;
	          e.deltaY = e.detail;
	        }
	        e = eventCtrl.fire('wheel', e);
	      }
	      nativeEvents = eventCtrl._nativeEvents;
	      if (nativeEvents) {
	        parents = eventCtrl.parents().toArray();
	        parents.unshift(eventCtrl);
	        for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
	          eventRootCtrl = parents[i]._eventsRoot;
	        }
	        if (!eventRootCtrl) {
	          eventRootCtrl = parents[parents.length - 1] || eventCtrl;
	        }
	        eventCtrl._eventsRoot = eventRootCtrl;
	        for (l = i, i = 0; i < l; i++) {
	          parents[i]._eventsRoot = eventRootCtrl;
	        }
	        var eventRootDelegates = eventRootCtrl._delegates;
	        if (!eventRootDelegates) {
	          eventRootDelegates = eventRootCtrl._delegates = {};
	        }
	        for (name in nativeEvents) {
	          if (!nativeEvents) {
	            return false;
	          }
	          if (name === 'wheel' && !hasWheelEventSupport) {
	            if (hasMouseWheelEventSupport) {
	              global$9(eventCtrl.getEl()).on('mousewheel', fixWheelEvent);
	            } else {
	              global$9(eventCtrl.getEl()).on('DOMMouseScroll', fixWheelEvent);
	            }
	            continue;
	          }
	          if (name === 'mouseenter' || name === 'mouseleave') {
	            if (!eventRootCtrl._hasMouseEnter) {
	              global$9(eventRootCtrl.getEl()).on('mouseleave', mouseLeaveHandler).on('mouseover', mouseEnterHandler);
	              eventRootCtrl._hasMouseEnter = 1;
	            }
	          } else if (!eventRootDelegates[name]) {
	            global$9(eventRootCtrl.getEl()).on(name, delegate);
	            eventRootDelegates[name] = true;
	          }
	          nativeEvents[name] = false;
	        }
	      }
	    }
	    var Control$1 = Control;
	
	    var hasTabstopData = function (elm) {
	      return elm.getAttribute('data-mce-tabstop') ? true : false;
	    };
	    function KeyboardNavigation (settings) {
	      var root = settings.root;
	      var focusedElement, focusedControl;
	      function isElement(node) {
	        return node && node.nodeType === 1;
	      }
	      try {
	        focusedElement = domGlobals.document.activeElement;
	      } catch (ex) {
	        focusedElement = domGlobals.document.body;
	      }
	      focusedControl = root.getParentCtrl(focusedElement);
	      function getRole(elm) {
	        elm = elm || focusedElement;
	        if (isElement(elm)) {
	          return elm.getAttribute('role');
	        }
	        return null;
	      }
	      function getParentRole(elm) {
	        var role, parent = elm || focusedElement;
	        while (parent = parent.parentNode) {
	          if (role = getRole(parent)) {
	            return role;
	          }
	        }
	      }
	      function getAriaProp(name) {
	        var elm = focusedElement;
	        if (isElement(elm)) {
	          return elm.getAttribute('aria-' + name);
	        }
	      }
	      function isTextInputElement(elm) {
	        var tagName = elm.tagName.toUpperCase();
	        return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
	      }
	      function canFocus(elm) {
	        if (isTextInputElement(elm) && !elm.hidden) {
	          return true;
	        }
	        if (hasTabstopData(elm)) {
	          return true;
	        }
	        if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(elm))) {
	          return true;
	        }
	        return false;
	      }
	      function getFocusElements(elm) {
	        var elements = [];
	        function collect(elm) {
	          if (elm.nodeType !== 1 || elm.style.display === 'none' || elm.disabled) {
	            return;
	          }
	          if (canFocus(elm)) {
	            elements.push(elm);
	          }
	          for (var i = 0; i < elm.childNodes.length; i++) {
	            collect(elm.childNodes[i]);
	          }
	        }
	        collect(elm || root.getEl());
	        return elements;
	      }
	      function getNavigationRoot(targetControl) {
	        var navigationRoot, controls;
	        targetControl = targetControl || focusedControl;
	        controls = targetControl.parents().toArray();
	        controls.unshift(targetControl);
	        for (var i = 0; i < controls.length; i++) {
	          navigationRoot = controls[i];
	          if (navigationRoot.settings.ariaRoot) {
	            break;
	          }
	        }
	        return navigationRoot;
	      }
	      function focusFirst(targetControl) {
	        var navigationRoot = getNavigationRoot(targetControl);
	        var focusElements = getFocusElements(navigationRoot.getEl());
	        if (navigationRoot.settings.ariaRemember && 'lastAriaIndex' in navigationRoot) {
	          moveFocusToIndex(navigationRoot.lastAriaIndex, focusElements);
	        } else {
	          moveFocusToIndex(0, focusElements);
	        }
	      }
	      function moveFocusToIndex(idx, elements) {
	        if (idx < 0) {
	          idx = elements.length - 1;
	        } else if (idx >= elements.length) {
	          idx = 0;
	        }
	        if (elements[idx]) {
	          elements[idx].focus();
	        }
	        return idx;
	      }
	      function moveFocus(dir, elements) {
	        var idx = -1;
	        var navigationRoot = getNavigationRoot();
	        elements = elements || getFocusElements(navigationRoot.getEl());
	        for (var i = 0; i < elements.length; i++) {
	          if (elements[i] === focusedElement) {
	            idx = i;
	          }
	        }
	        idx += dir;
	        navigationRoot.lastAriaIndex = moveFocusToIndex(idx, elements);
	      }
	      function left() {
	        var parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          moveFocus(-1, getFocusElements(focusedElement.parentNode));
	        } else if (focusedControl.parent().submenu) {
	          cancel();
	        } else {
	          moveFocus(-1);
	        }
	      }
	      function right() {
	        var role = getRole(), parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          moveFocus(1, getFocusElements(focusedElement.parentNode));
	        } else if (role === 'menuitem' && parentRole === 'menu' && getAriaProp('haspopup')) {
	          enter();
	        } else {
	          moveFocus(1);
	        }
	      }
	      function up() {
	        moveFocus(-1);
	      }
	      function down() {
	        var role = getRole(), parentRole = getParentRole();
	        if (role === 'menuitem' && parentRole === 'menubar') {
	          enter();
	        } else if (role === 'button' && getAriaProp('haspopup')) {
	          enter({ key: 'down' });
	        } else {
	          moveFocus(1);
	        }
	      }
	      function tab(e) {
	        var parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          var elm = getFocusElements(focusedControl.getEl('body'))[0];
	          if (elm) {
	            elm.focus();
	          }
	        } else {
	          moveFocus(e.shiftKey ? -1 : 1);
	        }
	      }
	      function cancel() {
	        focusedControl.fire('cancel');
	      }
	      function enter(aria) {
	        aria = aria || {};
	        focusedControl.fire('click', {
	          target: focusedElement,
	          aria: aria
	        });
	      }
	      root.on('keydown', function (e) {
	        function handleNonTabOrEscEvent(e, handler) {
	          if (isTextInputElement(focusedElement) || hasTabstopData(focusedElement)) {
	            return;
	          }
	          if (getRole(focusedElement) === 'slider') {
	            return;
	          }
	          if (handler(e) !== false) {
	            e.preventDefault();
	          }
	        }
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        switch (e.keyCode) {
	        case 37:
	          handleNonTabOrEscEvent(e, left);
	          break;
	        case 39:
	          handleNonTabOrEscEvent(e, right);
	          break;
	        case 38:
	          handleNonTabOrEscEvent(e, up);
	          break;
	        case 40:
	          handleNonTabOrEscEvent(e, down);
	          break;
	        case 27:
	          cancel();
	          break;
	        case 14:
	        case 13:
	        case 32:
	          handleNonTabOrEscEvent(e, enter);
	          break;
	        case 9:
	          tab(e);
	          e.preventDefault();
	          break;
	        }
	      });
	      root.on('focusin', function (e) {
	        focusedElement = e.target;
	        focusedControl = e.control;
	      });
	      return { focusFirst: focusFirst };
	    }
	
	    var selectorCache = {};
	    var Container = Control$1.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        if (settings.fixed) {
	          self.state.set('fixed', true);
	        }
	        self._items = new Collection$2();
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	        self.bodyClasses = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl('body').className = this.toString();
	          }
	        });
	        self.bodyClasses.prefix = self.classPrefix;
	        self.classes.add('container');
	        self.bodyClasses.add('container-body');
	        if (settings.containerCls) {
	          self.classes.add(settings.containerCls);
	        }
	        self._layout = global$4.create((settings.layout || '') + 'layout');
	        if (self.settings.items) {
	          self.add(self.settings.items);
	        } else {
	          self.add(self.render());
	        }
	        self._hasBody = true;
	      },
	      items: function () {
	        return this._items;
	      },
	      find: function (selector) {
	        selector = selectorCache[selector] = selectorCache[selector] || new Selector(selector);
	        return selector.find(this);
	      },
	      add: function (items) {
	        var self = this;
	        self.items().add(self.create(items)).parent(self);
	        return self;
	      },
	      focus: function (keyboard) {
	        var self = this;
	        var focusCtrl, keyboardNav, items;
	        if (keyboard) {
	          keyboardNav = self.keyboardNav || self.parents().eq(-1)[0].keyboardNav;
	          if (keyboardNav) {
	            keyboardNav.focusFirst(self);
	            return;
	          }
	        }
	        items = self.find('*');
	        if (self.statusbar) {
	          items.add(self.statusbar.items());
	        }
	        items.each(function (ctrl) {
	          if (ctrl.settings.autofocus) {
	            focusCtrl = null;
	            return false;
	          }
	          if (ctrl.canFocus) {
	            focusCtrl = focusCtrl || ctrl;
	          }
	        });
	        if (focusCtrl) {
	          focusCtrl.focus();
	        }
	        return self;
	      },
	      replace: function (oldItem, newItem) {
	        var ctrlElm;
	        var items = this.items();
	        var i = items.length;
	        while (i--) {
	          if (items[i] === oldItem) {
	            items[i] = newItem;
	            break;
	          }
	        }
	        if (i >= 0) {
	          ctrlElm = newItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	          ctrlElm = oldItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	        }
	        newItem.parent(this);
	      },
	      create: function (items) {
	        var self = this;
	        var settings;
	        var ctrlItems = [];
	        if (!global$2.isArray(items)) {
	          items = [items];
	        }
	        global$2.each(items, function (item) {
	          if (item) {
	            if (!(item instanceof Control$1)) {
	              if (typeof item === 'string') {
	                item = { type: item };
	              }
	              settings = global$2.extend({}, self.settings.defaults, item);
	              item.type = settings.type = settings.type || item.type || self.settings.defaultType || (settings.defaults ? settings.defaults.type : null);
	              item = global$4.create(settings);
	            }
	            ctrlItems.push(item);
	          }
	        });
	        return ctrlItems;
	      },
	      renderNew: function () {
	        var self = this;
	        self.items().each(function (ctrl, index) {
	          var containerElm;
	          ctrl.parent(self);
	          if (!ctrl.state.get('rendered')) {
	            containerElm = self.getEl('body');
	            if (containerElm.hasChildNodes() && index <= containerElm.childNodes.length - 1) {
	              global$9(containerElm.childNodes[index]).before(ctrl.renderHtml());
	            } else {
	              global$9(containerElm).append(ctrl.renderHtml());
	            }
	            ctrl.postRender();
	            ReflowQueue.add(ctrl);
	          }
	        });
	        self._layout.applyClasses(self.items().filter(':visible'));
	        self._lastRect = null;
	        return self;
	      },
	      append: function (items) {
	        return this.add(items).renderNew();
	      },
	      prepend: function (items) {
	        var self = this;
	        self.items().set(self.create(items).concat(self.items().toArray()));
	        return self.renderNew();
	      },
	      insert: function (items, index, before) {
	        var self = this;
	        var curItems, beforeItems, afterItems;
	        items = self.create(items);
	        curItems = self.items();
	        if (!before && index < curItems.length - 1) {
	          index += 1;
	        }
	        if (index >= 0 && index < curItems.length) {
	          beforeItems = curItems.slice(0, index).toArray();
	          afterItems = curItems.slice(index).toArray();
	          curItems.set(beforeItems.concat(items, afterItems));
	        }
	        return self.renderNew();
	      },
	      fromJSON: function (data) {
	        var self = this;
	        for (var name in data) {
	          self.find('#' + name).value(data[name]);
	        }
	        return self;
	      },
	      toJSON: function () {
	        var self = this, data = {};
	        self.find('*').each(function (ctrl) {
	          var name = ctrl.name(), value = ctrl.value();
	          if (name && typeof value !== 'undefined') {
	            data[name] = value;
	          }
	        });
	        return data;
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, role = this.settings.role;
	        self.preRender();
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        var box;
	        self.items().exec('postRender');
	        self._super();
	        self._layout.postRender(self);
	        self.state.set('rendered', true);
	        if (self.settings.style) {
	          self.$el.css(self.settings.style);
	        }
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	        if (!self.parent()) {
	          self.keyboardNav = KeyboardNavigation({ root: self });
	        }
	        return self;
	      },
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	        self._layout.recalc(self);
	        return layoutRect;
	      },
	      recalc: function () {
	        var self = this;
	        var rect = self._layoutRect;
	        var lastRect = self._lastRect;
	        if (!lastRect || lastRect.w !== rect.w || lastRect.h !== rect.h) {
	          self._layout.recalc(self);
	          rect = self.layoutRect();
	          self._lastRect = {
	            x: rect.x,
	            y: rect.y,
	            w: rect.w,
	            h: rect.h
	          };
	          return true;
	        }
	      },
	      reflow: function () {
	        var i;
	        ReflowQueue.remove(this);
	        if (this.visible()) {
	          Control$1.repaintControls = [];
	          Control$1.repaintControls.map = {};
	          this.recalc();
	          i = Control$1.repaintControls.length;
	          while (i--) {
	            Control$1.repaintControls[i].repaint();
	          }
	          if (this.settings.layout !== 'flow' && this.settings.layout !== 'stack') {
	            this.repaint();
	          }
	          Control$1.repaintControls = [];
	        }
	        return this;
	      }
	    });
	
	    function getDocumentSize(doc) {
	      var documentElement, body, scrollWidth, clientWidth;
	      var offsetWidth, scrollHeight, clientHeight, offsetHeight;
	      var max = Math.max;
	      documentElement = doc.documentElement;
	      body = doc.body;
	      scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
	      clientWidth = max(documentElement.clientWidth, body.clientWidth);
	      offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	      scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
	      clientHeight = max(documentElement.clientHeight, body.clientHeight);
	      offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	      return {
	        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
	        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
	      };
	    }
	    function updateWithTouchData(e) {
	      var keys, i;
	      if (e.changedTouches) {
	        keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
	        for (i = 0; i < keys.length; i++) {
	          e[keys[i]] = e.changedTouches[0][keys[i]];
	        }
	      }
	    }
	    function DragHelper (id, settings) {
	      var $eventOverlay;
	      var doc = settings.document || domGlobals.document;
	      var downButton;
	      var start, stop, drag, startX, startY;
	      settings = settings || {};
	      var handleElement = doc.getElementById(settings.handle || id);
	      start = function (e) {
	        var docSize = getDocumentSize(doc);
	        var handleElm, cursor;
	        updateWithTouchData(e);
	        e.preventDefault();
	        downButton = e.button;
	        handleElm = handleElement;
	        startX = e.screenX;
	        startY = e.screenY;
	        if (domGlobals.window.getComputedStyle) {
	          cursor = domGlobals.window.getComputedStyle(handleElm, null).getPropertyValue('cursor');
	        } else {
	          cursor = handleElm.runtimeStyle.cursor;
	        }
	        $eventOverlay = global$9('<div></div>').css({
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          width: docSize.width,
	          height: docSize.height,
	          zIndex: 2147483647,
	          opacity: 0.0001,
	          cursor: cursor
	        }).appendTo(doc.body);
	        global$9(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
	        settings.start(e);
	      };
	      drag = function (e) {
	        updateWithTouchData(e);
	        if (e.button !== downButton) {
	          return stop(e);
	        }
	        e.deltaX = e.screenX - startX;
	        e.deltaY = e.screenY - startY;
	        e.preventDefault();
	        settings.drag(e);
	      };
	      stop = function (e) {
	        updateWithTouchData(e);
	        global$9(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
	        $eventOverlay.remove();
	        if (settings.stop) {
	          settings.stop(e);
	        }
	      };
	      this.destroy = function () {
	        global$9(handleElement).off();
	      };
	      global$9(handleElement).on('mousedown touchstart', start);
	    }
	
	    var Scrollable = {
	      init: function () {
	        var self = this;
	        self.on('repaint', self.renderScroll);
	      },
	      renderScroll: function () {
	        var self = this, margin = 2;
	        function repaintScroll() {
	          var hasScrollH, hasScrollV, bodyElm;
	          function repaintAxis(axisName, posName, sizeName, contentSizeName, hasScroll, ax) {
	            var containerElm, scrollBarElm, scrollThumbElm;
	            var containerSize, scrollSize, ratio, rect;
	            var posNameLower, sizeNameLower;
	            scrollBarElm = self.getEl('scroll' + axisName);
	            if (scrollBarElm) {
	              posNameLower = posName.toLowerCase();
	              sizeNameLower = sizeName.toLowerCase();
	              global$9(self.getEl('absend')).css(posNameLower, self.layoutRect()[contentSizeName] - 1);
	              if (!hasScroll) {
	                global$9(scrollBarElm).css('display', 'none');
	                return;
	              }
	              global$9(scrollBarElm).css('display', 'block');
	              containerElm = self.getEl('body');
	              scrollThumbElm = self.getEl('scroll' + axisName + 't');
	              containerSize = containerElm['client' + sizeName] - margin * 2;
	              containerSize -= hasScrollH && hasScrollV ? scrollBarElm['client' + ax] : 0;
	              scrollSize = containerElm['scroll' + sizeName];
	              ratio = containerSize / scrollSize;
	              rect = {};
	              rect[posNameLower] = containerElm['offset' + posName] + margin;
	              rect[sizeNameLower] = containerSize;
	              global$9(scrollBarElm).css(rect);
	              rect = {};
	              rect[posNameLower] = containerElm['scroll' + posName] * ratio;
	              rect[sizeNameLower] = containerSize * ratio;
	              global$9(scrollThumbElm).css(rect);
	            }
	          }
	          bodyElm = self.getEl('body');
	          hasScrollH = bodyElm.scrollWidth > bodyElm.clientWidth;
	          hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
	          repaintAxis('h', 'Left', 'Width', 'contentW', hasScrollH, 'Height');
	          repaintAxis('v', 'Top', 'Height', 'contentH', hasScrollV, 'Width');
	        }
	        function addScroll() {
	          function addScrollAxis(axisName, posName, sizeName, deltaPosName, ax) {
	            var scrollStart;
	            var axisId = self._id + '-scroll' + axisName, prefix = self.classPrefix;
	            global$9(self.getEl()).append('<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + axisName + '">' + '<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' + '</div>');
	            self.draghelper = new DragHelper(axisId + 't', {
	              start: function () {
	                scrollStart = self.getEl('body')['scroll' + posName];
	                global$9('#' + axisId).addClass(prefix + 'active');
	              },
	              drag: function (e) {
	                var ratio, hasScrollH, hasScrollV, containerSize;
	                var layoutRect = self.layoutRect();
	                hasScrollH = layoutRect.contentW > layoutRect.innerW;
	                hasScrollV = layoutRect.contentH > layoutRect.innerH;
	                containerSize = self.getEl('body')['client' + sizeName] - margin * 2;
	                containerSize -= hasScrollH && hasScrollV ? self.getEl('scroll' + axisName)['client' + ax] : 0;
	                ratio = containerSize / self.getEl('body')['scroll' + sizeName];
	                self.getEl('body')['scroll' + posName] = scrollStart + e['delta' + deltaPosName] / ratio;
	              },
	              stop: function () {
	                global$9('#' + axisId).removeClass(prefix + 'active');
	              }
	            });
	          }
	          self.classes.add('scroll');
	          addScrollAxis('v', 'Top', 'Height', 'Y', 'Width');
	          addScrollAxis('h', 'Left', 'Width', 'X', 'Height');
	        }
	        if (self.settings.autoScroll) {
	          if (!self._hasScroll) {
	            self._hasScroll = true;
	            addScroll();
	            self.on('wheel', function (e) {
	              var bodyEl = self.getEl('body');
	              bodyEl.scrollLeft += (e.deltaX || 0) * 10;
	              bodyEl.scrollTop += e.deltaY * 10;
	              repaintScroll();
	            });
	            global$9(self.getEl('body')).on('scroll', repaintScroll);
	          }
	          repaintScroll();
	        }
	      }
	    };
	
	    var Panel = Container.extend({
	      Defaults: {
	        layout: 'fit',
	        containerCls: 'panel'
	      },
	      Mixins: [Scrollable],
	      renderHtml: function () {
	        var self = this;
	        var layout = self._layout;
	        var innerHtml = self.settings.html;
	        self.preRender();
	        layout.preRender(self);
	        if (typeof innerHtml === 'undefined') {
	          innerHtml = '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>';
	        } else {
	          if (typeof innerHtml === 'function') {
	            innerHtml = innerHtml.call(self);
	          }
	          self._hasBody = false;
	        }
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1" role="group">' + (self._preBodyHtml || '') + innerHtml + '</div>';
	      }
	    });
	
	    var Resizable = {
	      resizeToContent: function () {
	        this._layoutRect.autoResize = true;
	        this._lastRect = null;
	        this.reflow();
	      },
	      resizeTo: function (w, h) {
	        if (w <= 1 || h <= 1) {
	          var rect = funcs.getWindowSize();
	          w = w <= 1 ? w * rect.w : w;
	          h = h <= 1 ? h * rect.h : h;
	        }
	        this._layoutRect.autoResize = false;
	        return this.layoutRect({
	          minW: w,
	          minH: h,
	          w: w,
	          h: h
	        }).reflow();
	      },
	      resizeBy: function (dw, dh) {
	        var self = this, rect = self.layoutRect();
	        return self.resizeTo(rect.w + dw, rect.h + dh);
	      }
	    };
	
	    var documentClickHandler, documentScrollHandler, windowResizeHandler;
	    var visiblePanels = [];
	    var zOrder = [];
	    var hasModal;
	    function isChildOf(ctrl, parent) {
	      while (ctrl) {
	        if (ctrl === parent) {
	          return true;
	        }
	        ctrl = ctrl.parent();
	      }
	    }
	    function skipOrHidePanels(e) {
	      var i = visiblePanels.length;
	      while (i--) {
	        var panel = visiblePanels[i], clickCtrl = panel.getParentCtrl(e.target);
	        if (panel.settings.autohide) {
	          if (clickCtrl) {
	            if (isChildOf(clickCtrl, panel) || panel.parent() === clickCtrl) {
	              continue;
	            }
	          }
	          e = panel.fire('autohide', { target: e.target });
	          if (!e.isDefaultPrevented()) {
	            panel.hide();
	          }
	        }
	      }
	    }
	    function bindDocumentClickHandler() {
	      if (!documentClickHandler) {
	        documentClickHandler = function (e) {
	          if (e.button === 2) {
	            return;
	          }
	          skipOrHidePanels(e);
	        };
	        global$9(domGlobals.document).on('click touchstart', documentClickHandler);
	      }
	    }
	    function bindDocumentScrollHandler() {
	      if (!documentScrollHandler) {
	        documentScrollHandler = function () {
	          var i;
	          i = visiblePanels.length;
	          while (i--) {
	            repositionPanel(visiblePanels[i]);
	          }
	        };
	        global$9(domGlobals.window).on('scroll', documentScrollHandler);
	      }
	    }
	    function bindWindowResizeHandler() {
	      if (!windowResizeHandler) {
	        var docElm_1 = domGlobals.document.documentElement;
	        var clientWidth_1 = docElm_1.clientWidth, clientHeight_1 = docElm_1.clientHeight;
	        windowResizeHandler = function () {
	          if (!domGlobals.document.all || clientWidth_1 !== docElm_1.clientWidth || clientHeight_1 !== docElm_1.clientHeight) {
	            clientWidth_1 = docElm_1.clientWidth;
	            clientHeight_1 = docElm_1.clientHeight;
	            FloatPanel.hideAll();
	          }
	        };
	        global$9(domGlobals.window).on('resize', windowResizeHandler);
	      }
	    }
	    function repositionPanel(panel) {
	      var scrollY = funcs.getViewPort().y;
	      function toggleFixedChildPanels(fixed, deltaY) {
	        var parent;
	        for (var i = 0; i < visiblePanels.length; i++) {
	          if (visiblePanels[i] !== panel) {
	            parent = visiblePanels[i].parent();
	            while (parent && (parent = parent.parent())) {
	              if (parent === panel) {
	                visiblePanels[i].fixed(fixed).moveBy(0, deltaY).repaint();
	              }
	            }
	          }
	        }
	      }
	      if (panel.settings.autofix) {
	        if (!panel.state.get('fixed')) {
	          panel._autoFixY = panel.layoutRect().y;
	          if (panel._autoFixY < scrollY) {
	            panel.fixed(true).layoutRect({ y: 0 }).repaint();
	            toggleFixedChildPanels(true, scrollY - panel._autoFixY);
	          }
	        } else {
	          if (panel._autoFixY > scrollY) {
	            panel.fixed(false).layoutRect({ y: panel._autoFixY }).repaint();
	            toggleFixedChildPanels(false, panel._autoFixY - scrollY);
	          }
	        }
	      }
	    }
	    function addRemove(add, ctrl) {
	      var i, zIndex = FloatPanel.zIndex || 65535, topModal;
	      if (add) {
	        zOrder.push(ctrl);
	      } else {
	        i = zOrder.length;
	        while (i--) {
	          if (zOrder[i] === ctrl) {
	            zOrder.splice(i, 1);
	          }
	        }
	      }
	      if (zOrder.length) {
	        for (i = 0; i < zOrder.length; i++) {
	          if (zOrder[i].modal) {
	            zIndex++;
	            topModal = zOrder[i];
	          }
	          zOrder[i].getEl().style.zIndex = zIndex;
	          zOrder[i].zIndex = zIndex;
	          zIndex++;
	        }
	      }
	      var modalBlockEl = global$9('#' + ctrl.classPrefix + 'modal-block', ctrl.getContainerElm())[0];
	      if (topModal) {
	        global$9(modalBlockEl).css('z-index', topModal.zIndex - 1);
	      } else if (modalBlockEl) {
	        modalBlockEl.parentNode.removeChild(modalBlockEl);
	        hasModal = false;
	      }
	      FloatPanel.currentZIndex = zIndex;
	    }
	    var FloatPanel = Panel.extend({
	      Mixins: [
	        Movable,
	        Resizable
	      ],
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self._eventsRoot = self;
	        self.classes.add('floatpanel');
	        if (settings.autohide) {
	          bindDocumentClickHandler();
	          bindWindowResizeHandler();
	          visiblePanels.push(self);
	        }
	        if (settings.autofix) {
	          bindDocumentScrollHandler();
	          self.on('move', function () {
	            repositionPanel(this);
	          });
	        }
	        self.on('postrender show', function (e) {
	          if (e.control === self) {
	            var $modalBlockEl_1;
	            var prefix_1 = self.classPrefix;
	            if (self.modal && !hasModal) {
	              $modalBlockEl_1 = global$9('#' + prefix_1 + 'modal-block', self.getContainerElm());
	              if (!$modalBlockEl_1[0]) {
	                $modalBlockEl_1 = global$9('<div id="' + prefix_1 + 'modal-block" class="' + prefix_1 + 'reset ' + prefix_1 + 'fade"></div>').appendTo(self.getContainerElm());
	              }
	              global$7.setTimeout(function () {
	                $modalBlockEl_1.addClass(prefix_1 + 'in');
	                global$9(self.getEl()).addClass(prefix_1 + 'in');
	              });
	              hasModal = true;
	            }
	            addRemove(true, self);
	          }
	        });
	        self.on('show', function () {
	          self.parents().each(function (ctrl) {
	            if (ctrl.state.get('fixed')) {
	              self.fixed(true);
	              return false;
	            }
	          });
	        });
	        if (settings.popover) {
	          self._preBodyHtml = '<div class="' + self.classPrefix + 'arrow"></div>';
	          self.classes.add('popover').add('bottom').add(self.isRtl() ? 'end' : 'start');
	        }
	        self.aria('label', settings.ariaLabel);
	        self.aria('labelledby', self._id);
	        self.aria('describedby', self.describedBy || self._id + '-none');
	      },
	      fixed: function (state) {
	        var self = this;
	        if (self.state.get('fixed') !== state) {
	          if (self.state.get('rendered')) {
	            var viewport = funcs.getViewPort();
	            if (state) {
	              self.layoutRect().y -= viewport.y;
	            } else {
	              self.layoutRect().y += viewport.y;
	            }
	          }
	          self.classes.toggle('fixed', state);
	          self.state.set('fixed', state);
	        }
	        return self;
	      },
	      show: function () {
	        var self = this;
	        var i;
	        var state = self._super();
	        i = visiblePanels.length;
	        while (i--) {
	          if (visiblePanels[i] === self) {
	            break;
	          }
	        }
	        if (i === -1) {
	          visiblePanels.push(self);
	        }
	        return state;
	      },
	      hide: function () {
	        removeVisiblePanel(this);
	        addRemove(false, this);
	        return this._super();
	      },
	      hideAll: function () {
	        FloatPanel.hideAll();
	      },
	      close: function () {
	        var self = this;
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	          addRemove(false, self);
	        }
	        return self;
	      },
	      remove: function () {
	        removeVisiblePanel(this);
	        this._super();
	      },
	      postRender: function () {
	        var self = this;
	        if (self.settings.bodyRole) {
	          this.getEl('body').setAttribute('role', self.settings.bodyRole);
	        }
	        return self._super();
	      }
	    });
	    FloatPanel.hideAll = function () {
	      var i = visiblePanels.length;
	      while (i--) {
	        var panel = visiblePanels[i];
	        if (panel && panel.settings.autohide) {
	          panel.hide();
	          visiblePanels.splice(i, 1);
	        }
	      }
	    };
	    function removeVisiblePanel(panel) {
	      var i;
	      i = visiblePanels.length;
	      while (i--) {
	        if (visiblePanels[i] === panel) {
	          visiblePanels.splice(i, 1);
	        }
	      }
	      i = zOrder.length;
	      while (i--) {
	        if (zOrder[i] === panel) {
	          zOrder.splice(i, 1);
	        }
	      }
	    }
	
	    var isFixed$1 = function (inlineToolbarContainer, editor) {
	      return !!(inlineToolbarContainer && !editor.settings.ui_container);
	    };
	    var render$1 = function (editor, theme, args) {
	      var panel, inlineToolbarContainer;
	      var DOM = global$3.DOM;
	      var fixedToolbarContainer = getFixedToolbarContainer(editor);
	      if (fixedToolbarContainer) {
	        inlineToolbarContainer = DOM.select(fixedToolbarContainer)[0];
	      }
	      var reposition = function () {
	        if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
	          var scrollContainer = editor.selection.getScrollContainer(), body = editor.getBody();
	          var deltaX = 0, deltaY = 0;
	          if (scrollContainer) {
	            var bodyPos = DOM.getPos(body), scrollContainerPos = DOM.getPos(scrollContainer);
	            deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
	            deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
	          }
	          panel.fixed(false).moveRel(body, editor.rtl ? [
	            'tr-br',
	            'br-tr'
	          ] : [
	            'tl-bl',
	            'bl-tl',
	            'tr-br'
	          ]).moveBy(deltaX, deltaY);
	        }
	      };
	      var show = function () {
	        if (panel) {
	          panel.show();
	          reposition();
	          DOM.addClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	      var hide = function () {
	        if (panel) {
	          panel.hide();
	          FloatPanel.hideAll();
	          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	      var render = function () {
	        if (panel) {
	          if (!panel.visible()) {
	            show();
	          }
	          return;
	        }
	        panel = theme.panel = global$4.create({
	          type: inlineToolbarContainer ? 'panel' : 'floatpanel',
	          role: 'application',
	          classes: 'tinymce tinymce-inline',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: true,
	          fixed: isFixed$1(inlineToolbarContainer, editor),
	          border: 1,
	          items: [
	            hasMenubar(editor) === false ? null : {
	              type: 'menubar',
	              border: '0 0 1 0',
	              items: Menubar.createMenuButtons(editor)
	            },
	            Toolbar.createToolbars(editor, getToolbarSize(editor))
	          ]
	        });
	        UiContainer.setUiContainer(editor, panel);
	        Events.fireBeforeRenderUI(editor);
	        if (inlineToolbarContainer) {
	          panel.renderTo(inlineToolbarContainer).reflow();
	        } else {
	          panel.renderTo().reflow();
	        }
	        A11y.addKeys(editor, panel);
	        show();
	        ContextToolbars.addContextualToolbars(editor);
	        editor.on('nodeChange', reposition);
	        editor.on('ResizeWindow', reposition);
	        editor.on('activate', show);
	        editor.on('deactivate', hide);
	        editor.nodeChanged();
	      };
	      editor.settings.content_editable = true;
	      editor.on('focus', function () {
	        if (isSkinDisabled(editor) === false && args.skinUiCss) {
	          DOM.styleSheetLoader.load(args.skinUiCss, render, render);
	        } else {
	          render();
	        }
	      });
	      editor.on('blur hide', hide);
	      editor.on('remove', function () {
	        if (panel) {
	          panel.remove();
	          panel = null;
	        }
	      });
	      if (isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	      return {};
	    };
	    var Inline = { render: render$1 };
	
	    function Throbber (elm, inline) {
	      var self = this;
	      var state;
	      var classPrefix = Control$1.classPrefix;
	      var timer;
	      self.show = function (time, callback) {
	        function render() {
	          if (state) {
	            global$9(elm).append('<div class="' + classPrefix + 'throbber' + (inline ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>');
	            if (callback) {
	              callback();
	            }
	          }
	        }
	        self.hide();
	        state = true;
	        if (time) {
	          timer = global$7.setTimeout(render, time);
	        } else {
	          render();
	        }
	        return self;
	      };
	      self.hide = function () {
	        var child = elm.lastChild;
	        global$7.clearTimeout(timer);
	        if (child && child.className.indexOf('throbber') !== -1) {
	          child.parentNode.removeChild(child);
	        }
	        state = false;
	        return self;
	      };
	    }
	
	    var setup = function (editor, theme) {
	      var throbber;
	      editor.on('ProgressState', function (e) {
	        throbber = throbber || new Throbber(theme.panel.getEl('body'));
	        if (e.state) {
	          throbber.show(e.time);
	        } else {
	          throbber.hide();
	        }
	      });
	    };
	    var ProgressState = { setup: setup };
	
	    var renderUI = function (editor, theme, args) {
	      var skinUrl = getSkinUrl(editor);
	      if (skinUrl) {
	        args.skinUiCss = skinUrl + '/skin.min.css';
	        editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
	      }
	      ProgressState.setup(editor, theme);
	      return isInline(editor) ? Inline.render(editor, theme, args) : Iframe.render(editor, theme, args);
	    };
	    var Render = { renderUI: renderUI };
	
	    var Tooltip = Control$1.extend({
	      Mixins: [Movable],
	      Defaults: { classes: 'widget tooltip tooltip-n' },
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        return '<div id="' + self._id + '" class="' + self.classes + '" role="presentation">' + '<div class="' + prefix + 'tooltip-arrow"></div>' + '<div class="' + prefix + 'tooltip-inner">' + self.encode(self.state.get('text')) + '</div>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl().lastChild.innerHTML = self.encode(e.value);
	        });
	        return self._super();
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	        style.zIndex = 65535 + 65535;
	      }
	    });
	
	    var Widget = Control$1.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        self.canFocus = true;
	        if (settings.tooltip && Widget.tooltips !== false) {
	          self.on('mouseenter', function (e) {
	            var tooltip = self.tooltip().moveTo(-65535);
	            if (e.control === self) {
	              var rel = tooltip.text(settings.tooltip).show().testMoveRel(self.getEl(), [
	                'bc-tc',
	                'bc-tl',
	                'bc-tr'
	              ]);
	              tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
	              tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
	              tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
	              tooltip.moveRel(self.getEl(), rel);
	            } else {
	              tooltip.hide();
	            }
	          });
	          self.on('mouseleave mousedown click', function () {
	            self.tooltip().remove();
	            self._tooltip = null;
	          });
	        }
	        self.aria('label', settings.ariaLabel || settings.tooltip);
	      },
	      tooltip: function () {
	        if (!this._tooltip) {
	          this._tooltip = new Tooltip({ type: 'tooltip' });
	          UiContainer.inheritUiContainer(this, this._tooltip);
	          this._tooltip.renderTo();
	        }
	        return this._tooltip;
	      },
	      postRender: function () {
	        var self = this, settings = self.settings;
	        self._super();
	        if (!self.parent() && (settings.width || settings.height)) {
	          self.initLayoutRect();
	          self.repaint();
	        }
	        if (settings.autofocus) {
	          self.focus();
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        function disable(state) {
	          self.aria('disabled', state);
	          self.classes.toggle('disabled', state);
	        }
	        function active(state) {
	          self.aria('pressed', state);
	          self.classes.toggle('active', state);
	        }
	        self.state.on('change:disabled', function (e) {
	          disable(e.value);
	        });
	        self.state.on('change:active', function (e) {
	          active(e.value);
	        });
	        if (self.state.get('disabled')) {
	          disable(true);
	        }
	        if (self.state.get('active')) {
	          active(true);
	        }
	        return self._super();
	      },
	      remove: function () {
	        this._super();
	        if (this._tooltip) {
	          this._tooltip.remove();
	          this._tooltip = null;
	        }
	      }
	    });
	
	    var Progress = Widget.extend({
	      Defaults: { value: 0 },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('progress');
	        if (!self.settings.filter) {
	          self.settings.filter = function (value) {
	            return Math.round(value);
	          };
	        }
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = this.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div class="' + prefix + 'bar-container">' + '<div class="' + prefix + 'bar"></div>' + '</div>' + '<div class="' + prefix + 'text">0%</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.value(self.settings.value);
	        return self;
	      },
	      bindStates: function () {
	        var self = this;
	        function setValue(value) {
	          value = self.settings.filter(value);
	          self.getEl().lastChild.innerHTML = value + '%';
	          self.getEl().firstChild.firstChild.style.width = value + '%';
	        }
	        self.state.on('change:value', function (e) {
	          setValue(e.value);
	        });
	        setValue(self.state.get('value'));
	        return self._super();
	      }
	    });
	
	    var updateLiveRegion = function (ctx, text) {
	      ctx.getEl().lastChild.textContent = text + (ctx.progressBar ? ' ' + ctx.progressBar.value() + '%' : '');
	    };
	    var Notification = Control$1.extend({
	      Mixins: [Movable],
	      Defaults: { classes: 'widget notification' },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.maxWidth = settings.maxWidth;
	        if (settings.text) {
	          self.text(settings.text);
	        }
	        if (settings.icon) {
	          self.icon = settings.icon;
	        }
	        if (settings.color) {
	          self.color = settings.color;
	        }
	        if (settings.type) {
	          self.classes.add('notification-' + settings.type);
	        }
	        if (settings.timeout && (settings.timeout < 0 || settings.timeout > 0) && !settings.closeButton) {
	          self.closeButton = false;
	        } else {
	          self.classes.add('has-close');
	          self.closeButton = true;
	        }
	        if (settings.progressBar) {
	          self.progressBar = new Progress();
	        }
	        self.on('click', function (e) {
	          if (e.target.className.indexOf(self.classPrefix + 'close') !== -1) {
	            self.close();
	          }
	        });
	      },
	      renderHtml: function () {
	        var self = this;
	        var prefix = self.classPrefix;
	        var icon = '', closeButton = '', progressBar = '', notificationStyle = '';
	        if (self.icon) {
	          icon = '<i class="' + prefix + 'ico' + ' ' + prefix + 'i-' + self.icon + '"></i>';
	        }
	        notificationStyle = ' style="max-width: ' + self.maxWidth + 'px;' + (self.color ? 'background-color: ' + self.color + ';"' : '"');
	        if (self.closeButton) {
	          closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">\xD7</button>';
	        }
	        if (self.progressBar) {
	          progressBar = self.progressBar.renderHtml();
	        }
	        return '<div id="' + self._id + '" class="' + self.classes + '"' + notificationStyle + ' role="presentation">' + icon + '<div class="' + prefix + 'notification-inner">' + self.state.get('text') + '</div>' + progressBar + closeButton + '<div style="clip: rect(1px, 1px, 1px, 1px);height: 1px;overflow: hidden;position: absolute;width: 1px;"' + ' aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        global$7.setTimeout(function () {
	          self.$el.addClass(self.classPrefix + 'in');
	          updateLiveRegion(self, self.state.get('text'));
	        }, 100);
	        return self._super();
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl().firstChild.innerHTML = e.value;
	          updateLiveRegion(self, e.value);
	        });
	        if (self.progressBar) {
	          self.progressBar.bindStates();
	          self.progressBar.state.on('change:value', function (e) {
	            updateLiveRegion(self, self.state.get('text'));
	          });
	        }
	        return self._super();
	      },
	      close: function () {
	        var self = this;
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	        }
	        return self;
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	        style.zIndex = 65535 - 1;
	      }
	    });
	
	    function NotificationManagerImpl (editor) {
	      var getEditorContainer = function (editor) {
	        return editor.inline ? editor.getElement() : editor.getContentAreaContainer();
	      };
	      var getContainerWidth = function () {
	        var container = getEditorContainer(editor);
	        return funcs.getSize(container).width;
	      };
	      var prePositionNotifications = function (notifications) {
	        each(notifications, function (notification) {
	          notification.moveTo(0, 0);
	        });
	      };
	      var positionNotifications = function (notifications) {
	        if (notifications.length > 0) {
	          var firstItem = notifications.slice(0, 1)[0];
	          var container = getEditorContainer(editor);
	          firstItem.moveRel(container, 'tc-tc');
	          each(notifications, function (notification, index) {
	            if (index > 0) {
	              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
	            }
	          });
	        }
	      };
	      var reposition = function (notifications) {
	        prePositionNotifications(notifications);
	        positionNotifications(notifications);
	      };
	      var open = function (args, closeCallback) {
	        var extendedArgs = global$2.extend(args, { maxWidth: getContainerWidth() });
	        var notif = new Notification(extendedArgs);
	        notif.args = extendedArgs;
	        if (extendedArgs.timeout > 0) {
	          notif.timer = setTimeout(function () {
	            notif.close();
	            closeCallback();
	          }, extendedArgs.timeout);
	        }
	        notif.on('close', function () {
	          closeCallback();
	        });
	        notif.renderTo();
	        return notif;
	      };
	      var close = function (notification) {
	        notification.close();
	      };
	      var getArgs = function (notification) {
	        return notification.args;
	      };
	      return {
	        open: open,
	        close: close,
	        reposition: reposition,
	        getArgs: getArgs
	      };
	    }
	
	    var windows = [];
	    var oldMetaValue = '';
	    function toggleFullScreenState(state) {
	      var noScaleMetaValue = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0';
	      var viewport = global$9('meta[name=viewport]')[0], contentValue;
	      if (global$8.overrideViewPort === false) {
	        return;
	      }
	      if (!viewport) {
	        viewport = domGlobals.document.createElement('meta');
	        viewport.setAttribute('name', 'viewport');
	        domGlobals.document.getElementsByTagName('head')[0].appendChild(viewport);
	      }
	      contentValue = viewport.getAttribute('content');
	      if (contentValue && typeof oldMetaValue !== 'undefined') {
	        oldMetaValue = contentValue;
	      }
	      viewport.setAttribute('content', state ? noScaleMetaValue : oldMetaValue);
	    }
	    function toggleBodyFullScreenClasses(classPrefix, state) {
	      if (checkFullscreenWindows() && state === false) {
	        global$9([
	          domGlobals.document.documentElement,
	          domGlobals.document.body
	        ]).removeClass(classPrefix + 'fullscreen');
	      }
	    }
	    function checkFullscreenWindows() {
	      for (var i = 0; i < windows.length; i++) {
	        if (windows[i]._fullscreen) {
	          return true;
	        }
	      }
	      return false;
	    }
	    function handleWindowResize() {
	      if (!global$8.desktop) {
	        var lastSize_1 = {
	          w: domGlobals.window.innerWidth,
	          h: domGlobals.window.innerHeight
	        };
	        global$7.setInterval(function () {
	          var w = domGlobals.window.innerWidth, h = domGlobals.window.innerHeight;
	          if (lastSize_1.w !== w || lastSize_1.h !== h) {
	            lastSize_1 = {
	              w: w,
	              h: h
	            };
	            global$9(domGlobals.window).trigger('resize');
	          }
	        }, 100);
	      }
	      function reposition() {
	        var i;
	        var rect = funcs.getWindowSize();
	        var layoutRect;
	        for (i = 0; i < windows.length; i++) {
	          layoutRect = windows[i].layoutRect();
	          windows[i].moveTo(windows[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2), windows[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2));
	        }
	      }
	      global$9(domGlobals.window).on('resize', reposition);
	    }
	    var Window = FloatPanel.extend({
	      modal: true,
	      Defaults: {
	        border: 1,
	        layout: 'flex',
	        containerCls: 'panel',
	        role: 'dialog',
	        callbacks: {
	          submit: function () {
	            this.fire('submit', { data: this.toJSON() });
	          },
	          close: function () {
	            this.close();
	          }
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	        self.classes.add('window');
	        self.bodyClasses.add('window-body');
	        self.state.set('fixed', true);
	        if (settings.buttons) {
	          self.statusbar = new Panel({
	            layout: 'flex',
	            border: '1 0 0 0',
	            spacing: 3,
	            padding: 10,
	            align: 'center',
	            pack: self.isRtl() ? 'start' : 'end',
	            defaults: { type: 'button' },
	            items: settings.buttons
	          });
	          self.statusbar.classes.add('foot');
	          self.statusbar.parent(self);
	        }
	        self.on('click', function (e) {
	          var closeClass = self.classPrefix + 'close';
	          if (funcs.hasClass(e.target, closeClass) || funcs.hasClass(e.target.parentNode, closeClass)) {
	            self.close();
	          }
	        });
	        self.on('cancel', function () {
	          self.close();
	        });
	        self.on('move', function (e) {
	          if (e.control === self) {
	            FloatPanel.hideAll();
	          }
	        });
	        self.aria('describedby', self.describedBy || self._id + '-none');
	        self.aria('label', settings.title);
	        self._fullscreen = false;
	      },
	      recalc: function () {
	        var self = this;
	        var statusbar = self.statusbar;
	        var layoutRect, width, x, needsRecalc;
	        if (self._fullscreen) {
	          self.layoutRect(funcs.getWindowSize());
	          self.layoutRect().contentH = self.layoutRect().innerH;
	        }
	        self._super();
	        layoutRect = self.layoutRect();
	        if (self.settings.title && !self._fullscreen) {
	          width = layoutRect.headerW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width / 2);
	            self.layoutRect({
	              w: width,
	              x: x
	            });
	            needsRecalc = true;
	          }
	        }
	        if (statusbar) {
	          statusbar.layoutRect({ w: self.layoutRect().innerW }).recalc();
	          width = statusbar.layoutRect().minW + layoutRect.deltaW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width - layoutRect.w);
	            self.layoutRect({
	              w: width,
	              x: x
	            });
	            needsRecalc = true;
	          }
	        }
	        if (needsRecalc) {
	          self.recalc();
	        }
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var layoutRect = self._super();
	        var deltaH = 0, headEl;
	        if (self.settings.title && !self._fullscreen) {
	          headEl = self.getEl('head');
	          var size = funcs.getSize(headEl);
	          layoutRect.headerW = size.width;
	          layoutRect.headerH = size.height;
	          deltaH += layoutRect.headerH;
	        }
	        if (self.statusbar) {
	          deltaH += self.statusbar.layoutRect().h;
	        }
	        layoutRect.deltaH += deltaH;
	        layoutRect.minH += deltaH;
	        layoutRect.h += deltaH;
	        var rect = funcs.getWindowSize();
	        layoutRect.x = self.settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2);
	        layoutRect.y = self.settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2);
	        return layoutRect;
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, id = self._id, prefix = self.classPrefix;
	        var settings = self.settings;
	        var headerHtml = '', footerHtml = '', html = settings.html;
	        self.preRender();
	        layout.preRender(self);
	        if (settings.title) {
	          headerHtml = '<div id="' + id + '-head" class="' + prefix + 'window-head">' + '<div id="' + id + '-title" class="' + prefix + 'title">' + self.encode(settings.title) + '</div>' + '<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' + '<button type="button" class="' + prefix + 'close" aria-hidden="true">' + '<i class="mce-ico mce-i-remove"></i>' + '</button>' + '</div>';
	        }
	        if (settings.url) {
	          html = '<iframe src="' + settings.url + '" tabindex="-1"></iframe>';
	        }
	        if (typeof html === 'undefined') {
	          html = layout.renderHtml(self);
	        }
	        if (self.statusbar) {
	          footerHtml = self.statusbar.renderHtml();
	        }
	        return '<div id="' + id + '" class="' + self.classes + '" hidefocus="1">' + '<div class="' + self.classPrefix + 'reset" role="application">' + headerHtml + '<div id="' + id + '-body" class="' + self.bodyClasses + '">' + html + '</div>' + footerHtml + '</div>' + '</div>';
	      },
	      fullscreen: function (state) {
	        var self = this;
	        var documentElement = domGlobals.document.documentElement;
	        var slowRendering;
	        var prefix = self.classPrefix;
	        var layoutRect;
	        if (state !== self._fullscreen) {
	          global$9(domGlobals.window).on('resize', function () {
	            var time;
	            if (self._fullscreen) {
	              if (!slowRendering) {
	                time = new Date().getTime();
	                var rect = funcs.getWindowSize();
	                self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	                if (new Date().getTime() - time > 50) {
	                  slowRendering = true;
	                }
	              } else {
	                if (!self._timer) {
	                  self._timer = global$7.setTimeout(function () {
	                    var rect = funcs.getWindowSize();
	                    self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	                    self._timer = 0;
	                  }, 50);
	                }
	              }
	            }
	          });
	          layoutRect = self.layoutRect();
	          self._fullscreen = state;
	          if (!state) {
	            self.borderBox = BoxUtils.parseBox(self.settings.border);
	            self.getEl('head').style.display = '';
	            layoutRect.deltaH += layoutRect.headerH;
	            global$9([
	              documentElement,
	              domGlobals.document.body
	            ]).removeClass(prefix + 'fullscreen');
	            self.classes.remove('fullscreen');
	            self.moveTo(self._initial.x, self._initial.y).resizeTo(self._initial.w, self._initial.h);
	          } else {
	            self._initial = {
	              x: layoutRect.x,
	              y: layoutRect.y,
	              w: layoutRect.w,
	              h: layoutRect.h
	            };
	            self.borderBox = BoxUtils.parseBox('0');
	            self.getEl('head').style.display = 'none';
	            layoutRect.deltaH -= layoutRect.headerH + 2;
	            global$9([
	              documentElement,
	              domGlobals.document.body
	            ]).addClass(prefix + 'fullscreen');
	            self.classes.add('fullscreen');
	            var rect = funcs.getWindowSize();
	            self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	          }
	        }
	        return self.reflow();
	      },
	      postRender: function () {
	        var self = this;
	        var startPos;
	        setTimeout(function () {
	          self.classes.add('in');
	          self.fire('open');
	        }, 0);
	        self._super();
	        if (self.statusbar) {
	          self.statusbar.postRender();
	        }
	        self.focus();
	        this.dragHelper = new DragHelper(self._id + '-dragh', {
	          start: function () {
	            startPos = {
	              x: self.layoutRect().x,
	              y: self.layoutRect().y
	            };
	          },
	          drag: function (e) {
	            self.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY);
	          }
	        });
	        self.on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            self.close();
	          }
	        });
	        windows.push(self);
	        toggleFullScreenState(true);
	      },
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	      remove: function () {
	        var self = this;
	        var i;
	        self.dragHelper.destroy();
	        self._super();
	        if (self.statusbar) {
	          this.statusbar.remove();
	        }
	        toggleBodyFullScreenClasses(self.classPrefix, false);
	        i = windows.length;
	        while (i--) {
	          if (windows[i] === self) {
	            windows.splice(i, 1);
	          }
	        }
	        toggleFullScreenState(windows.length > 0);
	      },
	      getContentWindow: function () {
	        var ifr = this.getEl().getElementsByTagName('iframe')[0];
	        return ifr ? ifr.contentWindow : null;
	      }
	    });
	    handleWindowResize();
	
	    var MessageBox = Window.extend({
	      init: function (settings) {
	        settings = {
	          border: 1,
	          padding: 20,
	          layout: 'flex',
	          pack: 'center',
	          align: 'center',
	          containerCls: 'panel',
	          autoScroll: true,
	          buttons: {
	            type: 'button',
	            text: 'Ok',
	            action: 'ok'
	          },
	          items: {
	            type: 'label',
	            multiline: true,
	            maxWidth: 500,
	            maxHeight: 200
	          }
	        };
	        this._super(settings);
	      },
	      Statics: {
	        OK: 1,
	        OK_CANCEL: 2,
	        YES_NO: 3,
	        YES_NO_CANCEL: 4,
	        msgBox: function (settings) {
	          var buttons;
	          var callback = settings.callback || function () {
	          };
	          function createButton(text, status, primary) {
	            return {
	              type: 'button',
	              text: text,
	              subtype: primary ? 'primary' : '',
	              onClick: function (e) {
	                e.control.parents()[1].close();
	                callback(status);
	              }
	            };
	          }
	          switch (settings.buttons) {
	          case MessageBox.OK_CANCEL:
	            buttons = [
	              createButton('Ok', true, true),
	              createButton('Cancel', false)
	            ];
	            break;
	          case MessageBox.YES_NO:
	          case MessageBox.YES_NO_CANCEL:
	            buttons = [
	              createButton('Yes', 1, true),
	              createButton('No', 0)
	            ];
	            if (settings.buttons === MessageBox.YES_NO_CANCEL) {
	              buttons.push(createButton('Cancel', -1));
	            }
	            break;
	          default:
	            buttons = [createButton('Ok', true, true)];
	            break;
	          }
	          return new Window({
	            padding: 20,
	            x: settings.x,
	            y: settings.y,
	            minWidth: 300,
	            minHeight: 100,
	            layout: 'flex',
	            pack: 'center',
	            align: 'center',
	            buttons: buttons,
	            title: settings.title,
	            role: 'alertdialog',
	            items: {
	              type: 'label',
	              multiline: true,
	              maxWidth: 500,
	              maxHeight: 200,
	              text: settings.text
	            },
	            onPostRender: function () {
	              this.aria('describedby', this.items()[0]._id);
	            },
	            onClose: settings.onClose,
	            onCancel: function () {
	              callback(false);
	            }
	          }).renderTo(domGlobals.document.body).reflow();
	        },
	        alert: function (settings, callback) {
	          if (typeof settings === 'string') {
	            settings = { text: settings };
	          }
	          settings.callback = callback;
	          return MessageBox.msgBox(settings);
	        },
	        confirm: function (settings, callback) {
	          if (typeof settings === 'string') {
	            settings = { text: settings };
	          }
	          settings.callback = callback;
	          settings.buttons = MessageBox.OK_CANCEL;
	          return MessageBox.msgBox(settings);
	        }
	      }
	    });
	
	    function WindowManagerImpl (editor) {
	      var open = function (args, params, closeCallback) {
	        var win;
	        args.title = args.title || ' ';
	        args.url = args.url || args.file;
	        if (args.url) {
	          args.width = parseInt(args.width || 320, 10);
	          args.height = parseInt(args.height || 240, 10);
	        }
	        if (args.body) {
	          args.items = {
	            defaults: args.defaults,
	            type: args.bodyType || 'form',
	            items: args.body,
	            data: args.data,
	            callbacks: args.commands
	          };
	        }
	        if (!args.url && !args.buttons) {
	          args.buttons = [
	            {
	              text: 'Ok',
	              subtype: 'primary',
	              onclick: function () {
	                win.find('form')[0].submit();
	              }
	            },
	            {
	              text: 'Cancel',
	              onclick: function () {
	                win.close();
	              }
	            }
	          ];
	        }
	        win = new Window(args);
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        if (args.data) {
	          win.on('postRender', function () {
	            this.find('*').each(function (ctrl) {
	              var name = ctrl.name();
	              if (name in args.data) {
	                ctrl.value(args.data[name]);
	              }
	            });
	          });
	        }
	        win.features = args || {};
	        win.params = params || {};
	        win = win.renderTo(domGlobals.document.body).reflow();
	        return win;
	      };
	      var alert = function (message, choiceCallback, closeCallback) {
	        var win;
	        win = MessageBox.alert(message, function () {
	          choiceCallback();
	        });
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        return win;
	      };
	      var confirm = function (message, choiceCallback, closeCallback) {
	        var win;
	        win = MessageBox.confirm(message, function (state) {
	          choiceCallback(state);
	        });
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        return win;
	      };
	      var close = function (window) {
	        window.close();
	      };
	      var getParams = function (window) {
	        return window.params;
	      };
	      var setParams = function (window, params) {
	        window.params = params;
	      };
	      return {
	        open: open,
	        alert: alert,
	        confirm: confirm,
	        close: close,
	        getParams: getParams,
	        setParams: setParams
	      };
	    }
	
	    var get = function (editor) {
	      var renderUI = function (args) {
	        return Render.renderUI(editor, this, args);
	      };
	      var resizeTo = function (w, h) {
	        return Resize.resizeTo(editor, w, h);
	      };
	      var resizeBy = function (dw, dh) {
	        return Resize.resizeBy(editor, dw, dh);
	      };
	      var getNotificationManagerImpl = function () {
	        return NotificationManagerImpl(editor);
	      };
	      var getWindowManagerImpl = function () {
	        return WindowManagerImpl();
	      };
	      return {
	        renderUI: renderUI,
	        resizeTo: resizeTo,
	        resizeBy: resizeBy,
	        getNotificationManagerImpl: getNotificationManagerImpl,
	        getWindowManagerImpl: getWindowManagerImpl
	      };
	    };
	    var ThemeApi = { get: get };
	
	    var Layout = global$a.extend({
	      Defaults: {
	        firstControlClass: 'first',
	        lastControlClass: 'last'
	      },
	      init: function (settings) {
	        this.settings = global$2.extend({}, this.Defaults, settings);
	      },
	      preRender: function (container) {
	        container.bodyClasses.add(this.settings.containerClass);
	      },
	      applyClasses: function (items) {
	        var self = this;
	        var settings = self.settings;
	        var firstClass, lastClass, firstItem, lastItem;
	        firstClass = settings.firstControlClass;
	        lastClass = settings.lastControlClass;
	        items.each(function (item) {
	          item.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
	          if (item.visible()) {
	            if (!firstItem) {
	              firstItem = item;
	            }
	            lastItem = item;
	          }
	        });
	        if (firstItem) {
	          firstItem.classes.add(firstClass);
	        }
	        if (lastItem) {
	          lastItem.classes.add(lastClass);
	        }
	      },
	      renderHtml: function (container) {
	        var self = this;
	        var html = '';
	        self.applyClasses(container.items());
	        container.items().each(function (item) {
	          html += item.renderHtml();
	        });
	        return html;
	      },
	      recalc: function () {
	      },
	      postRender: function () {
	      },
	      isNative: function () {
	        return false;
	      }
	    });
	
	    var AbsoluteLayout = Layout.extend({
	      Defaults: {
	        containerClass: 'abs-layout',
	        controlClass: 'abs-layout-item'
	      },
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          var settings = ctrl.settings;
	          ctrl.layoutRect({
	            x: settings.x,
	            y: settings.y,
	            w: settings.w,
	            h: settings.h
	          });
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	      renderHtml: function (container) {
	        return '<div id="' + container._id + '-absend" class="' + container.classPrefix + 'abs-end"></div>' + this._super(container);
	      }
	    });
	
	    var Button = Widget.extend({
	      Defaults: {
	        classes: 'widget btn',
	        role: 'button'
	      },
	      init: function (settings) {
	        var self = this;
	        var size;
	        self._super(settings);
	        settings = self.settings;
	        size = self.settings.size;
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	        self.on('touchstart', function (e) {
	          self.fire('click', e);
	          e.preventDefault();
	        });
	        if (settings.subtype) {
	          self.classes.add(settings.subtype);
	        }
	        if (size) {
	          self.classes.add('btn-' + size);
	        }
	        if (settings.icon) {
	          self.icon(settings.icon);
	        }
	      },
	      icon: function (icon) {
	        if (!arguments.length) {
	          return this.state.get('icon');
	        }
	        this.state.set('icon', icon);
	        return this;
	      },
	      repaint: function () {
	        var btnElm = this.getEl().firstChild;
	        var btnStyle;
	        if (btnElm) {
	          btnStyle = btnElm.style;
	          btnStyle.width = btnStyle.height = '100%';
	        }
	        this._super();
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.state.get('icon'), image;
	        var text = self.state.get('text');
	        var textHtml = '';
	        var ariaPressed;
	        var settings = self.settings;
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        icon = icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1"' + ariaPressed + '>' + '<button id="' + id + '-button" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this, $ = self.$, textCls = self.classPrefix + 'txt';
	        function setButtonText(text) {
	          var $span = $('span.' + textCls, self.getEl());
	          if (text) {
	            if (!$span[0]) {
	              $('button:first', self.getEl()).append('<span class="' + textCls + '"></span>');
	              $span = $('span.' + textCls, self.getEl());
	            }
	            $span.html(self.encode(text));
	          } else {
	            $span.remove();
	          }
	          self.classes.toggle('btn-has-text', !!text);
	        }
	        self.state.on('change:text', function (e) {
	          setButtonText(e.value);
	        });
	        self.state.on('change:icon', function (e) {
	          var icon = e.value;
	          var prefix = self.classPrefix;
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	          var btnElm = self.getEl().firstChild;
	          var iconElm = btnElm.getElementsByTagName('i')[0];
	          if (icon) {
	            if (!iconElm || iconElm !== btnElm.firstChild) {
	              iconElm = domGlobals.document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	          setButtonText(self.state.get('text'));
	        });
	        return self._super();
	      }
	    });
	
	    var BrowseButton = Button.extend({
	      init: function (settings) {
	        var self = this;
	        settings = global$2.extend({
	          text: 'Browse...',
	          multiple: false,
	          accept: null
	        }, settings);
	        self._super(settings);
	        self.classes.add('browsebutton');
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	      postRender: function () {
	        var self = this;
	        var input = funcs.create('input', {
	          type: 'file',
	          id: self._id + '-browse',
	          accept: self.settings.accept
	        });
	        self._super();
	        global$9(input).on('change', function (e) {
	          var files = e.target.files;
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	          e.preventDefault();
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	        global$9(input).on('click', function (e) {
	          e.stopPropagation();
	        });
	        global$9(self.getEl('button')).on('click touchstart', function (e) {
	          e.stopPropagation();
	          input.click();
	          e.preventDefault();
	        });
	        self.getEl().appendChild(input);
	      },
	      remove: function () {
	        global$9(this.getEl('button')).off();
	        global$9(this.getEl('input')).off();
	        this._super();
	      }
	    });
	
	    var ButtonGroup = Container.extend({
	      Defaults: {
	        defaultType: 'button',
	        role: 'group'
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout;
	        self.classes.add('btn-group');
	        self.preRender();
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      }
	    });
	
	    var Checkbox = Widget.extend({
	      Defaults: {
	        classes: 'checkbox',
	        role: 'checkbox',
	        checked: false
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	        self.on('click', function (e) {
	          e.preventDefault();
	          if (!self.disabled()) {
	            self.checked(!self.checked());
	          }
	        });
	        self.checked(self.settings.checked);
	      },
	      checked: function (state) {
	        if (!arguments.length) {
	          return this.state.get('checked');
	        }
	        this.state.set('checked', state);
	        return this;
	      },
	      value: function (state) {
	        if (!arguments.length) {
	          return this.checked();
	        }
	        return this.checked(state);
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' + '<span id="' + id + '-al" class="' + prefix + 'label">' + self.encode(self.state.get('text')) + '</span>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        function checked(state) {
	          self.classes.toggle('checked', state);
	          self.aria('checked', state);
	        }
	        self.state.on('change:text', function (e) {
	          self.getEl('al').firstChild.data = self.translate(e.value);
	        });
	        self.state.on('change:checked change:value', function (e) {
	          self.fire('change');
	          checked(e.value);
	        });
	        self.state.on('change:icon', function (e) {
	          var icon = e.value;
	          var prefix = self.classPrefix;
	          if (typeof icon === 'undefined') {
	            return self.settings.icon;
	          }
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	          var btnElm = self.getEl().firstChild;
	          var iconElm = btnElm.getElementsByTagName('i')[0];
	          if (icon) {
	            if (!iconElm || iconElm !== btnElm.firstChild) {
	              iconElm = domGlobals.document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	        });
	        if (self.state.get('checked')) {
	          checked(true);
	        }
	        return self._super();
	      }
	    });
	
	    var global$d = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var ComboBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('combobox');
	        self.subinput = true;
	        self.ariaTarget = 'inp';
	        settings.menu = settings.menu || settings.values;
	        if (settings.menu) {
	          settings.icon = 'caret';
	        }
	        self.on('click', function (e) {
	          var elm = e.target;
	          var root = self.getEl();
	          if (!global$9.contains(root, elm) && elm !== root) {
	            return;
	          }
	          while (elm && elm !== root) {
	            if (elm.id && elm.id.indexOf('-open') !== -1) {
	              self.fire('action');
	              if (settings.menu) {
	                self.showMenu();
	                if (e.aria) {
	                  self.menu.items()[0].focus();
	                }
	              }
	            }
	            elm = elm.parentNode;
	          }
	        });
	        self.on('keydown', function (e) {
	          var rootControl;
	          if (e.keyCode === 13 && e.target.nodeName === 'INPUT') {
	            e.preventDefault();
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	        self.on('keyup', function (e) {
	          if (e.target.nodeName === 'INPUT') {
	            var oldValue = self.state.get('value');
	            var newValue = e.target.value;
	            if (newValue !== oldValue) {
	              self.state.set('value', newValue);
	              self.fire('autocomplete', e);
	            }
	          }
	        });
	        self.on('mouseover', function (e) {
	          var tooltip = self.tooltip().moveTo(-65535);
	          if (self.statusLevel() && e.target.className.indexOf(self.classPrefix + 'status') !== -1) {
	            var statusMessage = self.statusMessage() || 'Ok';
	            var rel = tooltip.text(statusMessage).show().testMoveRel(e.target, [
	              'bc-tc',
	              'bc-tl',
	              'bc-tr'
	            ]);
	            tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
	            tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
	            tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
	            tooltip.moveRel(e.target, rel);
	          }
	        });
	      },
	      statusLevel: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusLevel', value);
	        }
	        return this.state.get('statusLevel');
	      },
	      statusMessage: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusMessage', value);
	        }
	        return this.state.get('statusMessage');
	      },
	      showMenu: function () {
	        var self = this;
	        var settings = self.settings;
	        var menu;
	        if (!self.menu) {
	          menu = settings.menu || [];
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	          }
	          self.menu = global$4.create(menu).parent(self).renderTo(self.getContainerElm());
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control === self.menu) {
	              self.focus();
	            }
	          });
	          self.menu.on('show hide', function (e) {
	            e.control.items().each(function (ctrl) {
	              ctrl.active(ctrl.value() === self.value());
	            });
	          }).fire('show');
	          self.menu.on('select', function (e) {
	            self.value(e.control.value());
	          });
	          self.on('focusin', function (e) {
	            if (e.target.tagName.toUpperCase() === 'INPUT') {
	              self.menu.hide();
	            }
	          });
	          self.aria('expanded', true);
	        }
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	      },
	      focus: function () {
	        this.getEl('inp').focus();
	      },
	      repaint: function () {
	        var self = this, elm = self.getEl(), openElm = self.getEl('open'), rect = self.layoutRect();
	        var width, lineHeight, innerPadding = 0;
	        var inputElm = elm.firstChild;
	        if (self.statusLevel() && self.statusLevel() !== 'none') {
	          innerPadding = parseInt(funcs.getRuntimeStyle(inputElm, 'padding-right'), 10) - parseInt(funcs.getRuntimeStyle(inputElm, 'padding-left'), 10);
	        }
	        if (openElm) {
	          width = rect.w - funcs.getSize(openElm).width - 10;
	        } else {
	          width = rect.w - 10;
	        }
	        var doc = domGlobals.document;
	        if (doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          lineHeight = self.layoutRect().h - 2 + 'px';
	        }
	        global$9(inputElm).css({
	          width: width - innerPadding,
	          lineHeight: lineHeight
	        });
	        self._super();
	        return self;
	      },
	      postRender: function () {
	        var self = this;
	        global$9(this.getEl('inp')).on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	        return self._super();
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix;
	        var value = self.state.get('value') || '';
	        var icon, text, openBtnHtml = '', extraAttrs = '', statusHtml = '';
	        if ('spellcheck' in settings) {
	          extraAttrs += ' spellcheck="' + settings.spellcheck + '"';
	        }
	        if (settings.maxLength) {
	          extraAttrs += ' maxlength="' + settings.maxLength + '"';
	        }
	        if (settings.size) {
	          extraAttrs += ' size="' + settings.size + '"';
	        }
	        if (settings.subtype) {
	          extraAttrs += ' type="' + settings.subtype + '"';
	        }
	        statusHtml = '<i id="' + id + '-status" class="mce-status mce-ico" style="display: none"></i>';
	        if (self.disabled()) {
	          extraAttrs += ' disabled="disabled"';
	        }
	        icon = settings.icon;
	        if (icon && icon !== 'caret') {
	          icon = prefix + 'ico ' + prefix + 'i-' + settings.icon;
	        }
	        text = self.state.get('text');
	        if (icon || text) {
	          openBtnHtml = '<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' + '<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' + (icon !== 'caret' ? '<i class="' + icon + '"></i>' : '<i class="' + prefix + 'caret"></i>') + (text ? (icon ? ' ' : '') + text : '') + '</button>' + '</div>';
	          self.classes.add('has-open');
	        }
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' + self.encode(value, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' + self.encode(settings.placeholder) + '" />' + statusHtml + openBtnHtml + '</div>';
	      },
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl('inp').value);
	        }
	        return this.state.get('value');
	      },
	      showAutoComplete: function (items, term) {
	        var self = this;
	        if (items.length === 0) {
	          self.hideMenu();
	          return;
	        }
	        var insert = function (value, title) {
	          return function () {
	            self.fire('selectitem', {
	              title: title,
	              value: value
	            });
	          };
	        };
	        if (self.menu) {
	          self.menu.items().remove();
	        } else {
	          self.menu = global$4.create({
	            type: 'menu',
	            classes: 'combobox-menu',
	            layout: 'flow'
	          }).parent(self).renderTo();
	        }
	        global$2.each(items, function (item) {
	          self.menu.add({
	            text: item.title,
	            url: item.previewUrl,
	            match: term,
	            classes: 'menu-item-ellipsis',
	            onclick: insert(item.value, item.title)
	          });
	        });
	        self.menu.renderNew();
	        self.hideMenu();
	        self.menu.on('cancel', function (e) {
	          if (e.control.parent() === self.menu) {
	            e.stopPropagation();
	            self.focus();
	            self.hideMenu();
	          }
	        });
	        self.menu.on('select', function () {
	          self.focus();
	        });
	        var maxW = self.layoutRect().w;
	        self.menu.layoutRect({
	          w: maxW,
	          minW: 0,
	          maxW: maxW
	        });
	        self.menu.repaint();
	        self.menu.reflow();
	        self.menu.show();
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	      },
	      hideMenu: function () {
	        if (this.menu) {
	          this.menu.hide();
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.getEl('inp').value !== e.value) {
	            self.getEl('inp').value = e.value;
	          }
	        });
	        self.state.on('change:disabled', function (e) {
	          self.getEl('inp').disabled = e.value;
	        });
	        self.state.on('change:statusLevel', function (e) {
	          var statusIconElm = self.getEl('status');
	          var prefix = self.classPrefix, value = e.value;
	          funcs.css(statusIconElm, 'display', value === 'none' ? 'none' : '');
	          funcs.toggleClass(statusIconElm, prefix + 'i-checkmark', value === 'ok');
	          funcs.toggleClass(statusIconElm, prefix + 'i-warning', value === 'warn');
	          funcs.toggleClass(statusIconElm, prefix + 'i-error', value === 'error');
	          self.classes.toggle('has-status', value !== 'none');
	          self.repaint();
	        });
	        funcs.on(self.getEl('status'), 'mouseleave', function () {
	          self.tooltip().hide();
	        });
	        self.on('cancel', function (e) {
	          if (self.menu && self.menu.visible()) {
	            e.stopPropagation();
	            self.hideMenu();
	          }
	        });
	        var focusIdx = function (idx, menu) {
	          if (menu && menu.items().length > 0) {
	            menu.items().eq(idx)[0].focus();
	          }
	        };
	        self.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          if (e.target.nodeName === 'INPUT') {
	            if (keyCode === global$d.DOWN) {
	              e.preventDefault();
	              self.fire('autocomplete');
	              focusIdx(0, self.menu);
	            } else if (keyCode === global$d.UP) {
	              e.preventDefault();
	              focusIdx(-1, self.menu);
	            }
	          }
	        });
	        return self._super();
	      },
	      remove: function () {
	        global$9(this.getEl('inp')).off();
	        if (this.menu) {
	          this.menu.remove();
	        }
	        this._super();
	      }
	    });
	
	    var ColorBox = ComboBox.extend({
	      init: function (settings) {
	        var self = this;
	        settings.spellcheck = false;
	        if (settings.onaction) {
	          settings.icon = 'none';
	        }
	        self._super(settings);
	        self.classes.add('colorbox');
	        self.on('change keyup postrender', function () {
	          self.repaintColor(self.value());
	        });
	      },
	      repaintColor: function (value) {
	        var openElm = this.getEl('open');
	        var elm = openElm ? openElm.getElementsByTagName('i')[0] : null;
	        if (elm) {
	          try {
	            elm.style.background = value;
	          } catch (ex) {
	          }
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.state.get('rendered')) {
	            self.repaintColor(e.value);
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var PanelButton = Button.extend({
	      showPanel: function () {
	        var self = this, settings = self.settings;
	        self.classes.add('opened');
	        if (!self.panel) {
	          var panelSettings = settings.panel;
	          if (panelSettings.type) {
	            panelSettings = {
	              layout: 'grid',
	              items: panelSettings
	            };
	          }
	          panelSettings.role = panelSettings.role || 'dialog';
	          panelSettings.popover = true;
	          panelSettings.autohide = true;
	          panelSettings.ariaRoot = true;
	          self.panel = new FloatPanel(panelSettings).on('hide', function () {
	            self.classes.remove('opened');
	          }).on('cancel', function (e) {
	            e.stopPropagation();
	            self.focus();
	            self.hidePanel();
	          }).parent(self).renderTo(self.getContainerElm());
	          self.panel.fire('show');
	          self.panel.reflow();
	        } else {
	          self.panel.show();
	        }
	        var rtlRels = [
	          'bc-tc',
	          'bc-tl',
	          'bc-tr'
	        ];
	        var ltrRels = [
	          'bc-tc',
	          'bc-tr',
	          'bc-tl',
	          'tc-bc',
	          'tc-br',
	          'tc-bl'
	        ];
	        var rel = self.panel.testMoveRel(self.getEl(), settings.popoverAlign || (self.isRtl() ? rtlRels : ltrRels));
	        self.panel.classes.toggle('start', rel.substr(-1) === 'l');
	        self.panel.classes.toggle('end', rel.substr(-1) === 'r');
	        var isTop = rel.substr(0, 1) === 't';
	        self.panel.classes.toggle('bottom', !isTop);
	        self.panel.classes.toggle('top', isTop);
	        self.panel.moveRel(self.getEl(), rel);
	      },
	      hidePanel: function () {
	        var self = this;
	        if (self.panel) {
	          self.panel.hide();
	        }
	      },
	      postRender: function () {
	        var self = this;
	        self.aria('haspopup', true);
	        self.on('click', function (e) {
	          if (e.control === self) {
	            if (self.panel && self.panel.visible()) {
	              self.hidePanel();
	            } else {
	              self.showPanel();
	              self.panel.focus(!!e.aria);
	            }
	          }
	        });
	        return self._super();
	      },
	      remove: function () {
	        if (this.panel) {
	          this.panel.remove();
	          this.panel = null;
	        }
	        return this._super();
	      }
	    });
	
	    var DOM$3 = global$3.DOM;
	    var ColorButton = PanelButton.extend({
	      init: function (settings) {
	        this._super(settings);
	        this.classes.add('splitbtn');
	        this.classes.add('colorbutton');
	      },
	      color: function (color) {
	        if (color) {
	          this._color = color;
	          this.getEl('preview').style.backgroundColor = color;
	          return this;
	        }
	        return this._color;
	      },
	      resetColor: function () {
	        this._color = null;
	        this.getEl('preview').style.backgroundColor = null;
	        return this;
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix, text = self.state.get('text');
	        var icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	        var image = self.settings.image ? ' style="background-image: url(\'' + self.settings.image + '\')"' : '';
	        var textHtml = '';
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        return '<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1" aria-haspopup="true">' + '<button role="presentation" hidefocus="1" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + '<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	        self.on('click', function (e) {
	          if (e.aria && e.aria.key === 'down') {
	            return;
	          }
	          if (e.control === self && !DOM$3.getParent(e.target, '.' + self.classPrefix + 'open')) {
	            e.stopImmediatePropagation();
	            onClickHandler.call(self, e);
	          }
	        });
	        delete self.settings.onclick;
	        return self._super();
	      }
	    });
	
	    var global$e = tinymce.util.Tools.resolve('tinymce.util.Color');
	
	    var ColorPicker = Widget.extend({
	      Defaults: { classes: 'widget colorpicker' },
	      init: function (settings) {
	        this._super(settings);
	      },
	      postRender: function () {
	        var self = this;
	        var color = self.color();
	        var hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
	        hueRootElm = self.getEl('h');
	        huePointElm = self.getEl('hp');
	        svRootElm = self.getEl('sv');
	        svPointElm = self.getEl('svp');
	        function getPos(elm, event) {
	          var pos = funcs.getPos(elm);
	          var x, y;
	          x = event.pageX - pos.x;
	          y = event.pageY - pos.y;
	          x = Math.max(0, Math.min(x / elm.clientWidth, 1));
	          y = Math.max(0, Math.min(y / elm.clientHeight, 1));
	          return {
	            x: x,
	            y: y
	          };
	        }
	        function updateColor(hsv, hueUpdate) {
	          var hue = (360 - hsv.h) / 360;
	          funcs.css(huePointElm, { top: hue * 100 + '%' });
	          if (!hueUpdate) {
	            funcs.css(svPointElm, {
	              left: hsv.s + '%',
	              top: 100 - hsv.v + '%'
	            });
	          }
	          svRootElm.style.background = global$e({
	            s: 100,
	            v: 100,
	            h: hsv.h
	          }).toHex();
	          self.color().parse({
	            s: hsv.s,
	            v: hsv.v,
	            h: hsv.h
	          });
	        }
	        function updateSaturationAndValue(e) {
	          var pos;
	          pos = getPos(svRootElm, e);
	          hsv.s = pos.x * 100;
	          hsv.v = (1 - pos.y) * 100;
	          updateColor(hsv);
	          self.fire('change');
	        }
	        function updateHue(e) {
	          var pos;
	          pos = getPos(hueRootElm, e);
	          hsv = color.toHsv();
	          hsv.h = (1 - pos.y) * 360;
	          updateColor(hsv, true);
	          self.fire('change');
	        }
	        self._repaint = function () {
	          hsv = color.toHsv();
	          updateColor(hsv);
	        };
	        self._super();
	        self._svdraghelper = new DragHelper(self._id + '-sv', {
	          start: updateSaturationAndValue,
	          drag: updateSaturationAndValue
	        });
	        self._hdraghelper = new DragHelper(self._id + '-h', {
	          start: updateHue,
	          drag: updateHue
	        });
	        self._repaint();
	      },
	      rgb: function () {
	        return this.color().toRgb();
	      },
	      value: function (value) {
	        var self = this;
	        if (arguments.length) {
	          self.color().parse(value);
	          if (self._rendered) {
	            self._repaint();
	          }
	        } else {
	          return self.color().toHex();
	        }
	      },
	      color: function () {
	        if (!this._color) {
	          this._color = global$e();
	        }
	        return this._color;
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var prefix = self.classPrefix;
	        var hueHtml;
	        var stops = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';
	        function getOldIeFallbackHtml() {
	          var i, l, html = '', gradientPrefix, stopsList;
	          gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
	          stopsList = stops.split(',');
	          for (i = 0, l = stopsList.length - 1; i < l; i++) {
	            html += '<div class="' + prefix + 'colorpicker-h-chunk" style="' + 'height:' + 100 / l + '%;' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' + '-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' + '"></div>';
	          }
	          return html;
	        }
	        var gradientCssText = 'background: -ms-linear-gradient(top,' + stops + ');' + 'background: linear-gradient(to bottom,' + stops + ');';
	        hueHtml = '<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + gradientCssText + '">' + getOldIeFallbackHtml() + '<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' + '</div>';
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' + '<div class="' + prefix + 'colorpicker-overlay1">' + '<div class="' + prefix + 'colorpicker-overlay2">' + '<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' + '<div class="' + prefix + 'colorpicker-selector2"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + hueHtml + '</div>';
	      }
	    });
	
	    var DropZone = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        settings = global$2.extend({
	          height: 100,
	          text: 'Drop an image here',
	          multiple: false,
	          accept: null
	        }, settings);
	        self._super(settings);
	        self.classes.add('dropzone');
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	      renderHtml: function () {
	        var self = this;
	        var attrs, elm;
	        var cfg = self.settings;
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	        elm = funcs.create('div', attrs, '<span>' + this.translate(cfg.text) + '</span>');
	        if (cfg.height) {
	          funcs.css(elm, 'height', cfg.height + 'px');
	        }
	        if (cfg.width) {
	          funcs.css(elm, 'width', cfg.width + 'px');
	        }
	        elm.className = self.classes;
	        return elm.outerHTML;
	      },
	      postRender: function () {
	        var self = this;
	        var toggleDragClass = function (e) {
	          e.preventDefault();
	          self.classes.toggle('dragenter');
	          self.getEl().className = self.classes;
	        };
	        var filter = function (files) {
	          var accept = self.settings.accept;
	          if (typeof accept !== 'string') {
	            return files;
	          }
	          var re = new RegExp('(' + accept.split(/\s*,\s*/).join('|') + ')$', 'i');
	          return global$2.grep(files, function (file) {
	            return re.test(file.name);
	          });
	        };
	        self._super();
	        self.$el.on('dragover', function (e) {
	          e.preventDefault();
	        });
	        self.$el.on('dragenter', toggleDragClass);
	        self.$el.on('dragleave', toggleDragClass);
	        self.$el.on('drop', function (e) {
	          e.preventDefault();
	          if (self.state.get('disabled')) {
	            return;
	          }
	          var files = filter(e.dataTransfer.files);
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	      },
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	
	    var Path = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        if (!settings.delimiter) {
	          settings.delimiter = '\xBB';
	        }
	        self._super(settings);
	        self.classes.add('path');
	        self.canFocus = true;
	        self.on('click', function (e) {
	          var index;
	          var target = e.target;
	          if (index = target.getAttribute('data-index')) {
	            self.fire('select', {
	              value: self.row()[index],
	              index: index
	            });
	          }
	        });
	        self.row(self.settings.row);
	      },
	      focus: function () {
	        var self = this;
	        self.getEl().firstChild.focus();
	        return self;
	      },
	      row: function (row) {
	        if (!arguments.length) {
	          return this.state.get('row');
	        }
	        this.state.set('row', row);
	        return this;
	      },
	      renderHtml: function () {
	        var self = this;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + self._getDataPathHtml(self.state.get('row')) + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:row', function (e) {
	          self.innerHtml(self._getDataPathHtml(e.value));
	        });
	        return self._super();
	      },
	      _getDataPathHtml: function (data) {
	        var self = this;
	        var parts = data || [];
	        var i, l, html = '';
	        var prefix = self.classPrefix;
	        for (i = 0, l = parts.length; i < l; i++) {
	          html += (i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + self.settings.delimiter + ' </div>' : '') + '<div role="button" class="' + prefix + 'path-item' + (i === l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' + i + '" tabindex="-1" id="' + self._id + '-' + i + '" aria-level="' + (i + 1) + '">' + parts[i].name + '</div>';
	        }
	        if (!html) {
	          html = '<div class="' + prefix + 'path-item">\xA0</div>';
	        }
	        return html;
	      }
	    });
	
	    var ElementPath = Path.extend({
	      postRender: function () {
	        var self = this, editor = self.settings.editor;
	        function isHidden(elm) {
	          if (elm.nodeType === 1) {
	            if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
	              return true;
	            }
	            if (elm.getAttribute('data-mce-type') === 'bookmark') {
	              return true;
	            }
	          }
	          return false;
	        }
	        if (editor.settings.elementpath !== false) {
	          self.on('select', function (e) {
	            editor.focus();
	            editor.selection.select(this.row()[e.index].element);
	            editor.nodeChanged();
	          });
	          editor.on('nodeChange', function (e) {
	            var outParents = [];
	            var parents = e.parents;
	            var i = parents.length;
	            while (i--) {
	              if (parents[i].nodeType === 1 && !isHidden(parents[i])) {
	                var args = editor.fire('ResolveName', {
	                  name: parents[i].nodeName.toLowerCase(),
	                  target: parents[i]
	                });
	                if (!args.isDefaultPrevented()) {
	                  outParents.push({
	                    name: args.name,
	                    element: parents[i]
	                  });
	                }
	                if (args.isPropagationStopped()) {
	                  break;
	                }
	              }
	            }
	            self.row(outParents);
	          });
	        }
	        return self._super();
	      }
	    });
	
	    var FormItem = Container.extend({
	      Defaults: {
	        layout: 'flex',
	        align: 'center',
	        defaults: { flex: 1 }
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	        self.classes.add('formitem');
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<div id="' + self._id + '-title" class="' + prefix + 'title">' + self.settings.title + '</div>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      }
	    });
	
	    var Form = Container.extend({
	      Defaults: {
	        containerCls: 'form',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: 15,
	        labelGap: 30,
	        spacing: 10,
	        callbacks: {
	          submit: function () {
	            this.submit();
	          }
	        }
	      },
	      preRender: function () {
	        var self = this, items = self.items();
	        if (!self.settings.formItemDefaults) {
	          self.settings.formItemDefaults = {
	            layout: 'flex',
	            autoResize: 'overflow',
	            defaults: { flex: 1 }
	          };
	        }
	        items.each(function (ctrl) {
	          var formItem;
	          var label = ctrl.settings.label;
	          if (label) {
	            formItem = new FormItem(global$2.extend({
	              items: {
	                type: 'label',
	                id: ctrl._id + '-l',
	                text: label,
	                flex: 0,
	                forId: ctrl._id,
	                disabled: ctrl.disabled()
	              }
	            }, self.settings.formItemDefaults));
	            formItem.type = 'formitem';
	            ctrl.aria('labelledby', ctrl._id + '-l');
	            if (typeof ctrl.settings.flex === 'undefined') {
	              ctrl.settings.flex = 1;
	            }
	            self.replace(ctrl, formItem);
	            formItem.add(ctrl);
	          }
	        });
	      },
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.fromJSON(self.settings.data);
	      },
	      bindStates: function () {
	        var self = this;
	        self._super();
	        function recalcLabels() {
	          var maxLabelWidth = 0;
	          var labels = [];
	          var i, labelGap, items;
	          if (self.settings.labelGapCalc === false) {
	            return;
	          }
	          if (self.settings.labelGapCalc === 'children') {
	            items = self.find('formitem');
	          } else {
	            items = self.items();
	          }
	          items.filter('formitem').each(function (item) {
	            var labelCtrl = item.items()[0], labelWidth = labelCtrl.getEl().clientWidth;
	            maxLabelWidth = labelWidth > maxLabelWidth ? labelWidth : maxLabelWidth;
	            labels.push(labelCtrl);
	          });
	          labelGap = self.settings.labelGap || 0;
	          i = labels.length;
	          while (i--) {
	            labels[i].settings.minWidth = maxLabelWidth + labelGap;
	          }
	        }
	        self.on('show', recalcLabels);
	        recalcLabels();
	      }
	    });
	
	    var FieldSet = Form.extend({
	      Defaults: {
	        containerCls: 'fieldset',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: '25 15 5 15',
	        labelGap: 30,
	        spacing: 10,
	        border: 1
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	        self.preRender();
	        layout.preRender(self);
	        return '<fieldset id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<legend id="' + self._id + '-title" class="' + prefix + 'fieldset-title">' + self.settings.title + '</legend>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</fieldset>';
	      }
	    });
	
	    var unique$1 = 0;
	    var generate = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique$1++;
	      return prefix + '_' + random + unique$1 + String(time);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows$1 = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows$1, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows$1),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var ELEMENT$1 = ELEMENT;
	    var DOCUMENT$1 = DOCUMENT;
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT$1 && dom.nodeType !== DOCUMENT$1 || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$1 = browser.isIE() ? ieContains : regularContains;
	
	    var spot = Immutable('element', 'offset');
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var trim = global$2.trim;
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (node && node.nodeType === 1) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var create = function (type, title, url, level, attach) {
	      return {
	        type: type,
	        title: title,
	        url: url,
	        level: level,
	        attach: attach
	      };
	    };
	    var isChildOfContentEditableTrue = function (node) {
	      while (node = node.parentNode) {
	        var value = node.contentEditable;
	        if (value && value !== 'inherit') {
	          return isContentEditableTrue(node);
	        }
	      }
	      return false;
	    };
	    var select = function (selector, root) {
	      return map(descendants(Element.fromDom(root), selector), function (element) {
	        return element.dom();
	      });
	    };
	    var getElementText = function (elm) {
	      return elm.innerText || elm.textContent;
	    };
	    var getOrGenerateId = function (elm) {
	      return elm.id ? elm.id : generate('h');
	    };
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName === 'A' && (elm.id || elm.name);
	    };
	    var isValidAnchor = function (elm) {
	      return isAnchor(elm) && isEditable(elm);
	    };
	    var isHeader = function (elm) {
	      return elm && /^(H[1-6])$/.test(elm.nodeName);
	    };
	    var isEditable = function (elm) {
	      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
	    };
	    var isValidHeader = function (elm) {
	      return isHeader(elm) && isEditable(elm);
	    };
	    var getLevel = function (elm) {
	      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
	    };
	    var headerTarget = function (elm) {
	      var headerId = getOrGenerateId(elm);
	      var attach = function () {
	        elm.id = headerId;
	      };
	      return create('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
	    };
	    var anchorTarget = function (elm) {
	      var anchorId = elm.id || elm.name;
	      var anchorText = getElementText(elm);
	      return create('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
	    };
	    var getHeaderTargets = function (elms) {
	      return map(filter(elms, isValidHeader), headerTarget);
	    };
	    var getAnchorTargets = function (elms) {
	      return map(filter(elms, isValidAnchor), anchorTarget);
	    };
	    var getTargetElements = function (elm) {
	      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
	      return elms;
	    };
	    var hasTitle = function (target) {
	      return trim(target.title).length > 0;
	    };
	    var find$2 = function (elm) {
	      var elms = getTargetElements(elm);
	      return filter(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
	    };
	    var LinkTargets = { find: find$2 };
	
	    var getActiveEditor = function () {
	      return window.tinymce ? window.tinymce.activeEditor : global$1.activeEditor;
	    };
	    var history = {};
	    var HISTORY_LENGTH = 5;
	    var clearHistory = function () {
	      history = {};
	    };
	    var toMenuItem = function (target) {
	      return {
	        title: target.title,
	        value: {
	          title: { raw: target.title },
	          url: target.url,
	          attach: target.attach
	        }
	      };
	    };
	    var toMenuItems = function (targets) {
	      return global$2.map(targets, toMenuItem);
	    };
	    var staticMenuItem = function (title, url) {
	      return {
	        title: title,
	        value: {
	          title: title,
	          url: url,
	          attach: noop
	        }
	      };
	    };
	    var isUniqueUrl = function (url, targets) {
	      var foundTarget = exists(targets, function (target) {
	        return target.url === url;
	      });
	      return !foundTarget;
	    };
	    var getSetting = function (editorSettings, name, defaultValue) {
	      var value = name in editorSettings ? editorSettings[name] : defaultValue;
	      return value === false ? null : value;
	    };
	    var createMenuItems = function (term, targets, fileType, editorSettings) {
	      var separator = { title: '-' };
	      var fromHistoryMenuItems = function (history) {
	        var historyItems = history.hasOwnProperty(fileType) ? history[fileType] : [];
	        var uniqueHistory = filter(historyItems, function (url) {
	          return isUniqueUrl(url, targets);
	        });
	        return global$2.map(uniqueHistory, function (url) {
	          return {
	            title: url,
	            value: {
	              title: url,
	              url: url,
	              attach: noop
	            }
	          };
	        });
	      };
	      var fromMenuItems = function (type) {
	        var filteredTargets = filter(targets, function (target) {
	          return target.type === type;
	        });
	        return toMenuItems(filteredTargets);
	      };
	      var anchorMenuItems = function () {
	        var anchorMenuItems = fromMenuItems('anchor');
	        var topAnchor = getSetting(editorSettings, 'anchor_top', '#top');
	        var bottomAchor = getSetting(editorSettings, 'anchor_bottom', '#bottom');
	        if (topAnchor !== null) {
	          anchorMenuItems.unshift(staticMenuItem('<top>', topAnchor));
	        }
	        if (bottomAchor !== null) {
	          anchorMenuItems.push(staticMenuItem('<bottom>', bottomAchor));
	        }
	        return anchorMenuItems;
	      };
	      var join = function (items) {
	        return foldl(items, function (a, b) {
	          var bothEmpty = a.length === 0 || b.length === 0;
	          return bothEmpty ? a.concat(b) : a.concat(separator, b);
	        }, []);
	      };
	      if (editorSettings.typeahead_urls === false) {
	        return [];
	      }
	      return fileType === 'file' ? join([
	        filterByQuery(term, fromHistoryMenuItems(history)),
	        filterByQuery(term, fromMenuItems('header')),
	        filterByQuery(term, anchorMenuItems())
	      ]) : filterByQuery(term, fromHistoryMenuItems(history));
	    };
	    var addToHistory = function (url, fileType) {
	      var items = history[fileType];
	      if (!/^https?/.test(url)) {
	        return;
	      }
	      if (items) {
	        if (indexOf(items, url).isNone()) {
	          history[fileType] = items.slice(0, HISTORY_LENGTH).concat(url);
	        }
	      } else {
	        history[fileType] = [url];
	      }
	    };
	    var filterByQuery = function (term, menuItems) {
	      var lowerCaseTerm = term.toLowerCase();
	      var result = global$2.grep(menuItems, function (item) {
	        return item.title.toLowerCase().indexOf(lowerCaseTerm) !== -1;
	      });
	      return result.length === 1 && result[0].title === term ? [] : result;
	    };
	    var getTitle = function (linkDetails) {
	      var title = linkDetails.title;
	      return title.raw ? title.raw : title;
	    };
	    var setupAutoCompleteHandler = function (ctrl, editorSettings, bodyElm, fileType) {
	      var autocomplete = function (term) {
	        var linkTargets = LinkTargets.find(bodyElm);
	        var menuItems = createMenuItems(term, linkTargets, fileType, editorSettings);
	        ctrl.showAutoComplete(menuItems, term);
	      };
	      ctrl.on('autocomplete', function () {
	        autocomplete(ctrl.value());
	      });
	      ctrl.on('selectitem', function (e) {
	        var linkDetails = e.value;
	        ctrl.value(linkDetails.url);
	        var title = getTitle(linkDetails);
	        if (fileType === 'image') {
	          ctrl.fire('change', {
	            meta: {
	              alt: title,
	              attach: linkDetails.attach
	            }
	          });
	        } else {
	          ctrl.fire('change', {
	            meta: {
	              text: title,
	              attach: linkDetails.attach
	            }
	          });
	        }
	        ctrl.focus();
	      });
	      ctrl.on('click', function (e) {
	        if (ctrl.value().length === 0 && e.target.nodeName === 'INPUT') {
	          autocomplete('');
	        }
	      });
	      ctrl.on('PostRender', function () {
	        ctrl.getRoot().on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            addToHistory(ctrl.value(), fileType);
	          }
	        });
	      });
	    };
	    var statusToUiState = function (result) {
	      var status = result.status, message = result.message;
	      if (status === 'valid') {
	        return {
	          status: 'ok',
	          message: message
	        };
	      } else if (status === 'unknown') {
	        return {
	          status: 'warn',
	          message: message
	        };
	      } else if (status === 'invalid') {
	        return {
	          status: 'warn',
	          message: message
	        };
	      } else {
	        return {
	          status: 'none',
	          message: ''
	        };
	      }
	    };
	    var setupLinkValidatorHandler = function (ctrl, editorSettings, fileType) {
	      var validatorHandler = editorSettings.filepicker_validator_handler;
	      if (validatorHandler) {
	        var validateUrl_1 = function (url) {
	          if (url.length === 0) {
	            ctrl.statusLevel('none');
	            return;
	          }
	          validatorHandler({
	            url: url,
	            type: fileType
	          }, function (result) {
	            var uiState = statusToUiState(result);
	            ctrl.statusMessage(uiState.message);
	            ctrl.statusLevel(uiState.status);
	          });
	        };
	        ctrl.state.on('change:value', function (e) {
	          validateUrl_1(e.value);
	        });
	      }
	    };
	    var FilePicker = ComboBox.extend({
	      Statics: { clearHistory: clearHistory },
	      init: function (settings) {
	        var self = this, editor = getActiveEditor(), editorSettings = editor.settings;
	        var actionCallback, fileBrowserCallback, fileBrowserCallbackTypes;
	        var fileType = settings.filetype;
	        settings.spellcheck = false;
	        fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
	        if (fileBrowserCallbackTypes) {
	          fileBrowserCallbackTypes = global$2.makeMap(fileBrowserCallbackTypes, /[, ]/);
	        }
	        if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType]) {
	          fileBrowserCallback = editorSettings.file_picker_callback;
	          if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	            actionCallback = function () {
	              var meta = self.fire('beforecall').meta;
	              meta = global$2.extend({ filetype: fileType }, meta);
	              fileBrowserCallback.call(editor, function (value, meta) {
	                self.value(value).fire('change', { meta: meta });
	              }, self.value(), meta);
	            };
	          } else {
	            fileBrowserCallback = editorSettings.file_browser_callback;
	            if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	              actionCallback = function () {
	                fileBrowserCallback(self.getEl('inp').id, self.value(), fileType, window);
	              };
	            }
	          }
	        }
	        if (actionCallback) {
	          settings.icon = 'browse';
	          settings.onaction = actionCallback;
	        }
	        self._super(settings);
	        self.classes.add('filepicker');
	        setupAutoCompleteHandler(self, editorSettings, editor.getBody(), fileType);
	        setupLinkValidatorHandler(self, editorSettings, fileType);
	      }
	    });
	
	    var FitLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var contLayoutRect = container.layoutRect(), paddingBox = container.paddingBox;
	        container.items().filter(':visible').each(function (ctrl) {
	          ctrl.layoutRect({
	            x: paddingBox.left,
	            y: paddingBox.top,
	            w: contLayoutRect.innerW - paddingBox.right - paddingBox.left,
	            h: contLayoutRect.innerH - paddingBox.top - paddingBox.bottom
	          });
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      }
	    });
	
	    var FlexLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
	        var ctrl, ctrlLayoutRect, ctrlSettings, flex;
	        var maxSizeItems = [];
	        var size, maxSize, ratio, rect, pos, maxAlignEndPos;
	        var sizeName, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
	        var alignAxisName, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
	        var alignDeltaSizeName, alignContentSizeName;
	        var max = Math.max, min = Math.min;
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        contPaddingBox = container.paddingBox;
	        contSettings = container.settings;
	        direction = container.isRtl() ? contSettings.direction || 'row-reversed' : contSettings.direction;
	        align = contSettings.align;
	        pack = container.isRtl() ? contSettings.pack || 'end' : contSettings.pack;
	        spacing = contSettings.spacing || 0;
	        if (direction === 'row-reversed' || direction === 'column-reverse') {
	          items = items.set(items.toArray().reverse());
	          direction = direction.split('-')[0];
	        }
	        if (direction === 'column') {
	          posName = 'y';
	          sizeName = 'h';
	          minSizeName = 'minH';
	          maxSizeName = 'maxH';
	          innerSizeName = 'innerH';
	          beforeName = 'top';
	          deltaSizeName = 'deltaH';
	          contentSizeName = 'contentH';
	          alignBeforeName = 'left';
	          alignSizeName = 'w';
	          alignAxisName = 'x';
	          alignInnerSizeName = 'innerW';
	          alignMinSizeName = 'minW';
	          alignAfterName = 'right';
	          alignDeltaSizeName = 'deltaW';
	          alignContentSizeName = 'contentW';
	        } else {
	          posName = 'x';
	          sizeName = 'w';
	          minSizeName = 'minW';
	          maxSizeName = 'maxW';
	          innerSizeName = 'innerW';
	          beforeName = 'left';
	          deltaSizeName = 'deltaW';
	          contentSizeName = 'contentW';
	          alignBeforeName = 'top';
	          alignSizeName = 'h';
	          alignAxisName = 'y';
	          alignInnerSizeName = 'innerH';
	          alignMinSizeName = 'minH';
	          alignAfterName = 'bottom';
	          alignDeltaSizeName = 'deltaH';
	          alignContentSizeName = 'contentH';
	        }
	        availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
	        maxAlignEndPos = totalFlex = 0;
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          ctrlSettings = ctrl.settings;
	          flex = ctrlSettings.flex;
	          availableSpace -= i < l - 1 ? spacing : 0;
	          if (flex > 0) {
	            totalFlex += flex;
	            if (ctrlLayoutRect[maxSizeName]) {
	              maxSizeItems.push(ctrl);
	            }
	            ctrlLayoutRect.flex = flex;
	          }
	          availableSpace -= ctrlLayoutRect[minSizeName];
	          size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
	          if (size > maxAlignEndPos) {
	            maxAlignEndPos = size;
	          }
	        }
	        rect = {};
	        if (availableSpace < 0) {
	          rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        } else {
	          rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        }
	        rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[alignDeltaSizeName];
	        rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
	        rect[alignContentSizeName] = maxAlignEndPos;
	        rect.minW = min(rect.minW, contLayoutRect.maxW);
	        rect.minH = min(rect.minH, contLayoutRect.maxH);
	        rect.minW = max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = max(rect.minH, contLayoutRect.startMinHeight);
	        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	          container.layoutRect(rect);
	          this.recalc(container);
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	          return;
	        }
	        ratio = availableSpace / totalFlex;
	        for (i = 0, l = maxSizeItems.length; i < l; i++) {
	          ctrl = maxSizeItems[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          maxSize = ctrlLayoutRect[maxSizeName];
	          size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
	          if (size > maxSize) {
	            availableSpace -= ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName];
	            totalFlex -= ctrlLayoutRect.flex;
	            ctrlLayoutRect.flex = 0;
	            ctrlLayoutRect.maxFlexSize = maxSize;
	          } else {
	            ctrlLayoutRect.maxFlexSize = 0;
	          }
	        }
	        ratio = availableSpace / totalFlex;
	        pos = contPaddingBox[beforeName];
	        rect = {};
	        if (totalFlex === 0) {
	          if (pack === 'end') {
	            pos = availableSpace + contPaddingBox[beforeName];
	          } else if (pack === 'center') {
	            pos = Math.round(contLayoutRect[innerSizeName] / 2 - (contLayoutRect[innerSizeName] - availableSpace) / 2) + contPaddingBox[beforeName];
	            if (pos < 0) {
	              pos = contPaddingBox[beforeName];
	            }
	          } else if (pack === 'justify') {
	            pos = contPaddingBox[beforeName];
	            spacing = Math.floor(availableSpace / (items.length - 1));
	          }
	        }
	        rect[alignAxisName] = contPaddingBox[alignBeforeName];
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
	          if (align === 'center') {
	            rect[alignAxisName] = Math.round(contLayoutRect[alignInnerSizeName] / 2 - ctrlLayoutRect[alignSizeName] / 2);
	          } else if (align === 'stretch') {
	            rect[alignSizeName] = max(ctrlLayoutRect[alignMinSizeName] || 0, contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]);
	            rect[alignAxisName] = contPaddingBox[alignBeforeName];
	          } else if (align === 'end') {
	            rect[alignAxisName] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top;
	          }
	          if (ctrlLayoutRect.flex > 0) {
	            size += ctrlLayoutRect.flex * ratio;
	          }
	          rect[sizeName] = size;
	          rect[posName] = pos;
	          ctrl.layoutRect(rect);
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	          pos += size + spacing;
	        }
	      }
	    });
	
	    var FlowLayout = Layout.extend({
	      Defaults: {
	        containerClass: 'flow-layout',
	        controlClass: 'flow-layout-item',
	        endClass: 'break'
	      },
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	      isNative: function () {
	        return true;
	      }
	    });
	
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	
	    var toggleFormat = function (editor, fmt) {
	      return function () {
	        editor.execCommand('mceToggleFormat', false, fmt);
	      };
	    };
	    var addFormatChangedListener = function (editor, name, changed) {
	      var handler = function (state) {
	        changed(state, name);
	      };
	      if (editor.formatter) {
	        editor.formatter.formatChanged(name, handler);
	      } else {
	        editor.on('init', function () {
	          editor.formatter.formatChanged(name, handler);
	        });
	      }
	    };
	    var postRenderFormatToggle = function (editor, name) {
	      return function (e) {
	        addFormatChangedListener(editor, name, function (state) {
	          e.control.active(state);
	        });
	      };
	    };
	
	    var register = function (editor) {
	      var alignFormats = [
	        'alignleft',
	        'aligncenter',
	        'alignright',
	        'alignjustify'
	      ];
	      var defaultAlign = 'alignleft';
	      var alignMenuItems = [
	        {
	          text: 'Left',
	          icon: 'alignleft',
	          onclick: toggleFormat(editor, 'alignleft')
	        },
	        {
	          text: 'Center',
	          icon: 'aligncenter',
	          onclick: toggleFormat(editor, 'aligncenter')
	        },
	        {
	          text: 'Right',
	          icon: 'alignright',
	          onclick: toggleFormat(editor, 'alignright')
	        },
	        {
	          text: 'Justify',
	          icon: 'alignjustify',
	          onclick: toggleFormat(editor, 'alignjustify')
	        }
	      ];
	      editor.addMenuItem('align', {
	        text: 'Align',
	        menu: alignMenuItems
	      });
	      editor.addButton('align', {
	        type: 'menubutton',
	        icon: defaultAlign,
	        menu: alignMenuItems,
	        onShowMenu: function (e) {
	          var menu = e.control.menu;
	          global$2.each(alignFormats, function (formatName, idx) {
	            menu.items().eq(idx).each(function (item) {
	              return item.active(editor.formatter.match(formatName));
	            });
	          });
	        },
	        onPostRender: function (e) {
	          var ctrl = e.control;
	          global$2.each(alignFormats, function (formatName, idx) {
	            addFormatChangedListener(editor, formatName, function (state) {
	              ctrl.icon(defaultAlign);
	              if (state) {
	                ctrl.icon(formatName);
	              }
	            });
	          });
	        }
	      });
	      global$2.each({
	        alignleft: [
	          'Align left',
	          'JustifyLeft'
	        ],
	        aligncenter: [
	          'Align center',
	          'JustifyCenter'
	        ],
	        alignright: [
	          'Align right',
	          'JustifyRight'
	        ],
	        alignjustify: [
	          'Justify',
	          'JustifyFull'
	        ],
	        alignnone: [
	          'No alignment',
	          'JustifyNone'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: postRenderFormatToggle(editor, name)
	        });
	      });
	    };
	    var Align = { register: register };
	
	    var getFirstFont = function (fontFamily) {
	      return fontFamily ? fontFamily.split(',')[0] : '';
	    };
	    var findMatchingValue = function (items, fontFamily) {
	      var font = fontFamily ? fontFamily.toLowerCase() : '';
	      var value;
	      global$2.each(items, function (item) {
	        if (item.value.toLowerCase() === font) {
	          value = item.value;
	        }
	      });
	      global$2.each(items, function (item) {
	        if (!value && getFirstFont(item.value).toLowerCase() === getFirstFont(font).toLowerCase()) {
	          value = item.value;
	        }
	      });
	      return value;
	    };
	    var createFontNameListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	        self.state.set('value', null);
	        editor.on('init nodeChange', function (e) {
	          var fontFamily = editor.queryCommandValue('FontName');
	          var match = findMatchingValue(items, fontFamily);
	          self.value(match ? match : null);
	          if (!match && fontFamily) {
	            self.text(getFirstFont(fontFamily));
	          }
	        });
	      };
	    };
	    var createFormats = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	      return formats;
	    };
	    var getFontItems = function (editor) {
	      var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
	      var fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
	      return global$2.map(fonts, function (font) {
	        return {
	          text: { raw: font[0] },
	          value: font[1],
	          textStyle: font[1].indexOf('dings') === -1 ? 'font-family:' + font[1] : ''
	        };
	      });
	    };
	    var registerButtons = function (editor) {
	      editor.addButton('fontselect', function () {
	        var items = getFontItems(editor);
	        return {
	          type: 'listbox',
	          text: 'Font Family',
	          tooltip: 'Font Family',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontNameListBoxChangeHandler(editor, items),
	          onselect: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontName', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	    var register$1 = function (editor) {
	      registerButtons(editor);
	    };
	    var FontSelect = { register: register$1 };
	
	    var round = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      }
	      return fontSize;
	    };
	    var findMatchingValue$1 = function (items, pt, px) {
	      var value;
	      global$2.each(items, function (item) {
	        if (item.value === px) {
	          value = px;
	        } else if (item.value === pt) {
	          value = pt;
	        }
	      });
	      return value;
	    };
	    var createFontSizeListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	        editor.on('init nodeChange', function (e) {
	          var px, pt, precision, match;
	          px = editor.queryCommandValue('FontSize');
	          if (px) {
	            for (precision = 3; !match && precision >= 0; precision--) {
	              pt = toPt(px, precision);
	              match = findMatchingValue$1(items, pt, px);
	            }
	          }
	          self.value(match ? match : null);
	          if (!match) {
	            self.text(pt);
	          }
	        });
	      };
	    };
	    var getFontSizeItems = function (editor) {
	      var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
	      var fontsizeFormats = editor.settings.fontsize_formats || defaultFontsizeFormats;
	      return global$2.map(fontsizeFormats.split(' '), function (item) {
	        var text = item, value = item;
	        var values = item.split('=');
	        if (values.length > 1) {
	          text = values[0];
	          value = values[1];
	        }
	        return {
	          text: text,
	          value: value
	        };
	      });
	    };
	    var registerButtons$1 = function (editor) {
	      editor.addButton('fontsizeselect', function () {
	        var items = getFontSizeItems(editor);
	        return {
	          type: 'listbox',
	          text: 'Font Sizes',
	          tooltip: 'Font Sizes',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontSizeListBoxChangeHandler(editor, items),
	          onclick: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontSize', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	    var register$2 = function (editor) {
	      registerButtons$1(editor);
	    };
	    var FontSizeSelect = { register: register$2 };
	
	    var hideMenuObjects = function (editor, menu) {
	      var count = menu.length;
	      global$2.each(menu, function (item) {
	        if (item.menu) {
	          item.hidden = hideMenuObjects(editor, item.menu) === 0;
	        }
	        var formatName = item.format;
	        if (formatName) {
	          item.hidden = !editor.formatter.canApply(formatName);
	        }
	        if (item.hidden) {
	          count--;
	        }
	      });
	      return count;
	    };
	    var hideFormatMenuItems = function (editor, menu) {
	      var count = menu.items().length;
	      menu.items().each(function (item) {
	        if (item.menu) {
	          item.visible(hideFormatMenuItems(editor, item.menu) > 0);
	        }
	        if (!item.menu && item.settings.menu) {
	          item.visible(hideMenuObjects(editor, item.settings.menu) > 0);
	        }
	        var formatName = item.settings.format;
	        if (formatName) {
	          item.visible(editor.formatter.canApply(formatName));
	        }
	        if (!item.visible()) {
	          count--;
	        }
	      });
	      return count;
	    };
	    var createFormatMenu = function (editor) {
	      var count = 0;
	      var newFormats = [];
	      var defaultStyleFormats = [
	        {
	          title: 'Headings',
	          items: [
	            {
	              title: 'Heading 1',
	              format: 'h1'
	            },
	            {
	              title: 'Heading 2',
	              format: 'h2'
	            },
	            {
	              title: 'Heading 3',
	              format: 'h3'
	            },
	            {
	              title: 'Heading 4',
	              format: 'h4'
	            },
	            {
	              title: 'Heading 5',
	              format: 'h5'
	            },
	            {
	              title: 'Heading 6',
	              format: 'h6'
	            }
	          ]
	        },
	        {
	          title: 'Inline',
	          items: [
	            {
	              title: 'Bold',
	              icon: 'bold',
	              format: 'bold'
	            },
	            {
	              title: 'Italic',
	              icon: 'italic',
	              format: 'italic'
	            },
	            {
	              title: 'Underline',
	              icon: 'underline',
	              format: 'underline'
	            },
	            {
	              title: 'Strikethrough',
	              icon: 'strikethrough',
	              format: 'strikethrough'
	            },
	            {
	              title: 'Superscript',
	              icon: 'superscript',
	              format: 'superscript'
	            },
	            {
	              title: 'Subscript',
	              icon: 'subscript',
	              format: 'subscript'
	            },
	            {
	              title: 'Code',
	              icon: 'code',
	              format: 'code'
	            }
	          ]
	        },
	        {
	          title: 'Blocks',
	          items: [
	            {
	              title: 'Paragraph',
	              format: 'p'
	            },
	            {
	              title: 'Blockquote',
	              format: 'blockquote'
	            },
	            {
	              title: 'Div',
	              format: 'div'
	            },
	            {
	              title: 'Pre',
	              format: 'pre'
	            }
	          ]
	        },
	        {
	          title: 'Alignment',
	          items: [
	            {
	              title: 'Left',
	              icon: 'alignleft',
	              format: 'alignleft'
	            },
	            {
	              title: 'Center',
	              icon: 'aligncenter',
	              format: 'aligncenter'
	            },
	            {
	              title: 'Right',
	              icon: 'alignright',
	              format: 'alignright'
	            },
	            {
	              title: 'Justify',
	              icon: 'alignjustify',
	              format: 'alignjustify'
	            }
	          ]
	        }
	      ];
	      var createMenu = function (formats) {
	        var menu = [];
	        if (!formats) {
	          return;
	        }
	        global$2.each(formats, function (format) {
	          var menuItem = {
	            text: format.title,
	            icon: format.icon
	          };
	          if (format.items) {
	            menuItem.menu = createMenu(format.items);
	          } else {
	            var formatName = format.format || 'custom' + count++;
	            if (!format.format) {
	              format.name = formatName;
	              newFormats.push(format);
	            }
	            menuItem.format = formatName;
	            menuItem.cmd = format.cmd;
	          }
	          menu.push(menuItem);
	        });
	        return menu;
	      };
	      var createStylesMenu = function () {
	        var menu;
	        if (editor.settings.style_formats_merge) {
	          if (editor.settings.style_formats) {
	            menu = createMenu(defaultStyleFormats.concat(editor.settings.style_formats));
	          } else {
	            menu = createMenu(defaultStyleFormats);
	          }
	        } else {
	          menu = createMenu(editor.settings.style_formats || defaultStyleFormats);
	        }
	        return menu;
	      };
	      editor.on('init', function () {
	        global$2.each(newFormats, function (format) {
	          editor.formatter.register(format.name, format);
	        });
	      });
	      return {
	        type: 'menu',
	        items: createStylesMenu(),
	        onPostRender: function (e) {
	          editor.fire('renderFormatsMenu', { control: e.control });
	        },
	        itemDefaults: {
	          preview: true,
	          textStyle: function () {
	            if (this.settings.format) {
	              return editor.formatter.getCssText(this.settings.format);
	            }
	          },
	          onPostRender: function () {
	            var self = this;
	            self.parent().on('show', function () {
	              var formatName, command;
	              formatName = self.settings.format;
	              if (formatName) {
	                self.disabled(!editor.formatter.canApply(formatName));
	                self.active(editor.formatter.match(formatName));
	              }
	              command = self.settings.cmd;
	              if (command) {
	                self.active(editor.queryCommandState(command));
	              }
	            });
	          },
	          onclick: function () {
	            if (this.settings.format) {
	              toggleFormat(editor, this.settings.format)();
	            }
	            if (this.settings.cmd) {
	              editor.execCommand(this.settings.cmd);
	            }
	          }
	        }
	      };
	    };
	    var registerMenuItems = function (editor, formatMenu) {
	      editor.addMenuItem('formats', {
	        text: 'Formats',
	        menu: formatMenu
	      });
	    };
	    var registerButtons$2 = function (editor, formatMenu) {
	      editor.addButton('styleselect', {
	        type: 'menubutton',
	        text: 'Formats',
	        menu: formatMenu,
	        onShowMenu: function () {
	          if (editor.settings.style_formats_autohide) {
	            hideFormatMenuItems(editor, this.menu);
	          }
	        }
	      });
	    };
	    var register$3 = function (editor) {
	      var formatMenu = createFormatMenu(editor);
	      registerMenuItems(editor, formatMenu);
	      registerButtons$2(editor, formatMenu);
	    };
	    var Formats = { register: register$3 };
	
	    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
	    var createFormats$1 = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	      return formats;
	    };
	    var createListBoxChangeHandler = function (editor, items, formatName) {
	      return function () {
	        var self = this;
	        editor.on('nodeChange', function (e) {
	          var formatter = editor.formatter;
	          var value = null;
	          global$2.each(e.parents, function (node) {
	            global$2.each(items, function (item) {
	              if (formatName) {
	                if (formatter.matchNode(node, formatName, { value: item.value })) {
	                  value = item.value;
	                }
	              } else {
	                if (formatter.matchNode(node, item.value)) {
	                  value = item.value;
	                }
	              }
	              if (value) {
	                return false;
	              }
	            });
	            if (value) {
	              return false;
	            }
	          });
	          self.value(value);
	        });
	      };
	    };
	    var lazyFormatSelectBoxItems = function (editor, blocks) {
	      return function () {
	        var items = [];
	        global$2.each(blocks, function (block) {
	          items.push({
	            text: block[0],
	            value: block[1],
	            textStyle: function () {
	              return editor.formatter.getCssText(block[1]);
	            }
	          });
	        });
	        return {
	          type: 'listbox',
	          text: blocks[0][0],
	          values: items,
	          fixedWidth: true,
	          onselect: function (e) {
	            if (e.control) {
	              var fmt = e.control.value();
	              toggleFormat(editor, fmt)();
	            }
	          },
	          onPostRender: createListBoxChangeHandler(editor, items)
	        };
	      };
	    };
	    var buildMenuItems = function (editor, blocks) {
	      return global$2.map(blocks, function (block) {
	        return {
	          text: block[0],
	          onclick: toggleFormat(editor, block[1]),
	          textStyle: function () {
	            return editor.formatter.getCssText(block[1]);
	          }
	        };
	      });
	    };
	    var register$4 = function (editor) {
	      var blocks = createFormats$1(editor.settings.block_formats || defaultBlocks);
	      editor.addMenuItem('blockformats', {
	        text: 'Blocks',
	        menu: buildMenuItems(editor, blocks)
	      });
	      editor.addButton('formatselect', lazyFormatSelectBoxItems(editor, blocks));
	    };
	    var FormatSelect = { register: register$4 };
	
	    var createCustomMenuItems = function (editor, names) {
	      var items, nameList;
	      if (typeof names === 'string') {
	        nameList = names.split(' ');
	      } else if (global$2.isArray(names)) {
	        return flatten(global$2.map(names, function (names) {
	          return createCustomMenuItems(editor, names);
	        }));
	      }
	      items = global$2.grep(nameList, function (name) {
	        return name === '|' || name in editor.menuItems;
	      });
	      return global$2.map(items, function (name) {
	        return name === '|' ? { text: '-' } : editor.menuItems[name];
	      });
	    };
	    var isSeparator$1 = function (menuItem) {
	      return menuItem && menuItem.text === '-';
	    };
	    var trimMenuItems = function (menuItems) {
	      var menuItems2 = filter(menuItems, function (menuItem, i) {
	        return !isSeparator$1(menuItem) || !isSeparator$1(menuItems[i - 1]);
	      });
	      return filter(menuItems2, function (menuItem, i) {
	        return !isSeparator$1(menuItem) || i > 0 && i < menuItems2.length - 1;
	      });
	    };
	    var createContextMenuItems = function (editor, context) {
	      var outputMenuItems = [{ text: '-' }];
	      var menuItems = global$2.grep(editor.menuItems, function (menuItem) {
	        return menuItem.context === context;
	      });
	      global$2.each(menuItems, function (menuItem) {
	        if (menuItem.separator === 'before') {
	          outputMenuItems.push({ text: '|' });
	        }
	        if (menuItem.prependToContext) {
	          outputMenuItems.unshift(menuItem);
	        } else {
	          outputMenuItems.push(menuItem);
	        }
	        if (menuItem.separator === 'after') {
	          outputMenuItems.push({ text: '|' });
	        }
	      });
	      return outputMenuItems;
	    };
	    var createInsertMenu = function (editor) {
	      var insertButtonItems = editor.settings.insert_button_items;
	      if (insertButtonItems) {
	        return trimMenuItems(createCustomMenuItems(editor, insertButtonItems));
	      } else {
	        return trimMenuItems(createContextMenuItems(editor, 'insert'));
	      }
	    };
	    var registerButtons$3 = function (editor) {
	      editor.addButton('insert', {
	        type: 'menubutton',
	        icon: 'insert',
	        menu: [],
	        oncreatemenu: function () {
	          this.menu.add(createInsertMenu(editor));
	          this.menu.renderNew();
	        }
	      });
	    };
	    var register$5 = function (editor) {
	      registerButtons$3(editor);
	    };
	    var InsertButton = { register: register$5 };
	
	    var registerFormatButtons = function (editor) {
	      global$2.each({
	        bold: 'Bold',
	        italic: 'Italic',
	        underline: 'Underline',
	        strikethrough: 'Strikethrough',
	        subscript: 'Subscript',
	        superscript: 'Superscript'
	      }, function (text, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: text,
	          onPostRender: postRenderFormatToggle(editor, name),
	          onclick: toggleFormat(editor, name)
	        });
	      });
	    };
	    var registerCommandButtons = function (editor) {
	      global$2.each({
	        outdent: [
	          'Decrease indent',
	          'Outdent'
	        ],
	        indent: [
	          'Increase indent',
	          'Indent'
	        ],
	        cut: [
	          'Cut',
	          'Cut'
	        ],
	        copy: [
	          'Copy',
	          'Copy'
	        ],
	        paste: [
	          'Paste',
	          'Paste'
	        ],
	        help: [
	          'Help',
	          'mceHelp'
	        ],
	        selectall: [
	          'Select all',
	          'SelectAll'
	        ],
	        visualaid: [
	          'Visual aids',
	          'mceToggleVisualAid'
	        ],
	        newdocument: [
	          'New document',
	          'mceNewDocument'
	        ],
	        removeformat: [
	          'Clear formatting',
	          'RemoveFormat'
	        ],
	        remove: [
	          'Remove',
	          'Delete'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          tooltip: item[0],
	          cmd: item[1]
	        });
	      });
	    };
	    var registerCommandToggleButtons = function (editor) {
	      global$2.each({
	        blockquote: [
	          'Blockquote',
	          'mceBlockQuote'
	        ],
	        subscript: [
	          'Subscript',
	          'Subscript'
	        ],
	        superscript: [
	          'Superscript',
	          'Superscript'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: postRenderFormatToggle(editor, name)
	        });
	      });
	    };
	    var registerButtons$4 = function (editor) {
	      registerFormatButtons(editor);
	      registerCommandButtons(editor);
	      registerCommandToggleButtons(editor);
	    };
	    var registerMenuItems$1 = function (editor) {
	      global$2.each({
	        bold: [
	          'Bold',
	          'Bold',
	          'Meta+B'
	        ],
	        italic: [
	          'Italic',
	          'Italic',
	          'Meta+I'
	        ],
	        underline: [
	          'Underline',
	          'Underline',
	          'Meta+U'
	        ],
	        strikethrough: [
	          'Strikethrough',
	          'Strikethrough'
	        ],
	        subscript: [
	          'Subscript',
	          'Subscript'
	        ],
	        superscript: [
	          'Superscript',
	          'Superscript'
	        ],
	        removeformat: [
	          'Clear formatting',
	          'RemoveFormat'
	        ],
	        newdocument: [
	          'New document',
	          'mceNewDocument'
	        ],
	        cut: [
	          'Cut',
	          'Cut',
	          'Meta+X'
	        ],
	        copy: [
	          'Copy',
	          'Copy',
	          'Meta+C'
	        ],
	        paste: [
	          'Paste',
	          'Paste',
	          'Meta+V'
	        ],
	        selectall: [
	          'Select all',
	          'SelectAll',
	          'Meta+A'
	        ]
	      }, function (item, name) {
	        editor.addMenuItem(name, {
	          text: item[0],
	          icon: name,
	          shortcut: item[2],
	          cmd: item[1]
	        });
	      });
	      editor.addMenuItem('codeformat', {
	        text: 'Code',
	        icon: 'code',
	        onclick: toggleFormat(editor, 'code')
	      });
	    };
	    var register$6 = function (editor) {
	      registerButtons$4(editor);
	      registerMenuItems$1(editor);
	    };
	    var SimpleControls = { register: register$6 };
	
	    var toggleUndoRedoState = function (editor, type) {
	      return function () {
	        var self = this;
	        var checkState = function () {
	          var typeFn = type === 'redo' ? 'hasRedo' : 'hasUndo';
	          return editor.undoManager ? editor.undoManager[typeFn]() : false;
	        };
	        self.disabled(!checkState());
	        editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function () {
	          self.disabled(editor.readonly || !checkState());
	        });
	      };
	    };
	    var registerMenuItems$2 = function (editor) {
	      editor.addMenuItem('undo', {
	        text: 'Undo',
	        icon: 'undo',
	        shortcut: 'Meta+Z',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	      editor.addMenuItem('redo', {
	        text: 'Redo',
	        icon: 'redo',
	        shortcut: 'Meta+Y',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	    var registerButtons$5 = function (editor) {
	      editor.addButton('undo', {
	        tooltip: 'Undo',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	      editor.addButton('redo', {
	        tooltip: 'Redo',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	    var register$7 = function (editor) {
	      registerMenuItems$2(editor);
	      registerButtons$5(editor);
	    };
	    var UndoRedo = { register: register$7 };
	
	    var toggleVisualAidState = function (editor) {
	      return function () {
	        var self = this;
	        editor.on('VisualAid', function (e) {
	          self.active(e.hasVisual);
	        });
	        self.active(editor.hasVisual);
	      };
	    };
	    var registerMenuItems$3 = function (editor) {
	      editor.addMenuItem('visualaid', {
	        text: 'Visual aids',
	        selectable: true,
	        onPostRender: toggleVisualAidState(editor),
	        cmd: 'mceToggleVisualAid'
	      });
	    };
	    var register$8 = function (editor) {
	      registerMenuItems$3(editor);
	    };
	    var VisualAid = { register: register$8 };
	
	    var setupEnvironment = function () {
	      Widget.tooltips = !global$8.iOS;
	      Control$1.translate = function (text) {
	        return global$1.translate(text);
	      };
	    };
	    var setupUiContainer = function (editor) {
	      if (editor.settings.ui_container) {
	        global$8.container = descendant(Element.fromDom(domGlobals.document.body), editor.settings.ui_container).fold(constant(null), function (elm) {
	          return elm.dom();
	        });
	      }
	    };
	    var setupRtlMode = function (editor) {
	      if (editor.rtl) {
	        Control$1.rtl = true;
	      }
	    };
	    var setupHideFloatPanels = function (editor) {
	      editor.on('mousedown progressstate', function () {
	        FloatPanel.hideAll();
	      });
	    };
	    var setup$1 = function (editor) {
	      setupRtlMode(editor);
	      setupHideFloatPanels(editor);
	      setupUiContainer(editor);
	      setupEnvironment();
	      FormatSelect.register(editor);
	      Align.register(editor);
	      SimpleControls.register(editor);
	      UndoRedo.register(editor);
	      FontSizeSelect.register(editor);
	      FontSelect.register(editor);
	      Formats.register(editor);
	      VisualAid.register(editor);
	      InsertButton.register(editor);
	    };
	    var FormatControls = { setup: setup$1 };
	
	    var GridLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var settings, rows, cols, items, contLayoutRect, width, height, rect, ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY;
	        var colWidths = [];
	        var rowHeights = [];
	        var ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
	        settings = container.settings;
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        cols = settings.columns || Math.ceil(Math.sqrt(items.length));
	        rows = Math.ceil(items.length / cols);
	        spacingH = settings.spacingH || settings.spacing || 0;
	        spacingV = settings.spacingV || settings.spacing || 0;
	        alignH = settings.alignH || settings.align;
	        alignV = settings.alignV || settings.align;
	        contPaddingBox = container.paddingBox;
	        reverseRows = 'reverseRows' in settings ? settings.reverseRows : container.isRtl();
	        if (alignH && typeof alignH === 'string') {
	          alignH = [alignH];
	        }
	        if (alignV && typeof alignV === 'string') {
	          alignV = [alignV];
	        }
	        for (x = 0; x < cols; x++) {
	          colWidths.push(0);
	        }
	        for (y = 0; y < rows; y++) {
	          rowHeights.push(0);
	        }
	        for (y = 0; y < rows; y++) {
	          for (x = 0; x < cols; x++) {
	            ctrl = items[y * cols + x];
	            if (!ctrl) {
	              break;
	            }
	            ctrlLayoutRect = ctrl.layoutRect();
	            ctrlMinWidth = ctrlLayoutRect.minW;
	            ctrlMinHeight = ctrlLayoutRect.minH;
	            colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
	            rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y];
	          }
	        }
	        availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
	        for (maxX = 0, x = 0; x < cols; x++) {
	          maxX += colWidths[x] + (x > 0 ? spacingH : 0);
	          availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x];
	        }
	        availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
	        for (maxY = 0, y = 0; y < rows; y++) {
	          maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
	          availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y];
	        }
	        maxX += contPaddingBox.left + contPaddingBox.right;
	        maxY += contPaddingBox.top + contPaddingBox.bottom;
	        rect = {};
	        rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
	        rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
	        rect.contentW = rect.minW - contLayoutRect.deltaW;
	        rect.contentH = rect.minH - contLayoutRect.deltaH;
	        rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
	        rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
	        rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
	        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	          container.layoutRect(rect);
	          this.recalc(container);
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	          return;
	        }
	        if (contLayoutRect.autoResize) {
	          rect = container.layoutRect(rect);
	          rect.contentW = rect.minW - contLayoutRect.deltaW;
	          rect.contentH = rect.minH - contLayoutRect.deltaH;
	        }
	        var flexV;
	        if (settings.packV === 'start') {
	          flexV = 0;
	        } else {
	          flexV = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0;
	        }
	        var totalFlex = 0;
	        var flexWidths = settings.flexWidths;
	        if (flexWidths) {
	          for (x = 0; x < flexWidths.length; x++) {
	            totalFlex += flexWidths[x];
	          }
	        } else {
	          totalFlex = cols;
	        }
	        var ratio = availableWidth / totalFlex;
	        for (x = 0; x < cols; x++) {
	          colWidths[x] += flexWidths ? flexWidths[x] * ratio : ratio;
	        }
	        posY = contPaddingBox.top;
	        for (y = 0; y < rows; y++) {
	          posX = contPaddingBox.left;
	          height = rowHeights[y] + flexV;
	          for (x = 0; x < cols; x++) {
	            if (reverseRows) {
	              idx = y * cols + cols - 1 - x;
	            } else {
	              idx = y * cols + x;
	            }
	            ctrl = items[idx];
	            if (!ctrl) {
	              break;
	            }
	            ctrlSettings = ctrl.settings;
	            ctrlLayoutRect = ctrl.layoutRect();
	            width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
	            ctrlLayoutRect.x = posX;
	            ctrlLayoutRect.y = posY;
	            align = ctrlSettings.alignH || (alignH ? alignH[x] || alignH[0] : null);
	            if (align === 'center') {
	              ctrlLayoutRect.x = posX + width / 2 - ctrlLayoutRect.w / 2;
	            } else if (align === 'right') {
	              ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w;
	            } else if (align === 'stretch') {
	              ctrlLayoutRect.w = width;
	            }
	            align = ctrlSettings.alignV || (alignV ? alignV[x] || alignV[0] : null);
	            if (align === 'center') {
	              ctrlLayoutRect.y = posY + height / 2 - ctrlLayoutRect.h / 2;
	            } else if (align === 'bottom') {
	              ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h;
	            } else if (align === 'stretch') {
	              ctrlLayoutRect.h = height;
	            }
	            ctrl.layoutRect(ctrlLayoutRect);
	            posX += width + spacingH;
	            if (ctrl.recalc) {
	              ctrl.recalc();
	            }
	          }
	          posY += height + spacingV;
	        }
	      }
	    });
	
	    var Iframe$1 = Widget.extend({
	      renderHtml: function () {
	        var self = this;
	        self.classes.add('iframe');
	        self.canFocus = false;
	        return '<iframe id="' + self._id + '" class="' + self.classes + '" tabindex="-1" src="' + (self.settings.url || 'javascript:\'\'') + '" frameborder="0"></iframe>';
	      },
	      src: function (src) {
	        this.getEl().src = src;
	      },
	      html: function (html, callback) {
	        var self = this, body = this.getEl().contentWindow.document.body;
	        if (!body) {
	          global$7.setTimeout(function () {
	            self.html(html);
	          });
	        } else {
	          body.innerHTML = html;
	          if (callback) {
	            callback();
	          }
	        }
	        return this;
	      }
	    });
	
	    var InfoBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('widget').add('infobox');
	        self.canFocus = false;
	      },
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	      help: function (state) {
	        this.state.set('help', state);
	      },
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + self.encode(self.state.get('text')) + '<button role="button" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' + '</button>' + '</div>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl('body').firstChild.data = self.encode(e.value);
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        self.state.on('change:help', function (e) {
	          self.classes.toggle('has-help', e.value);
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var Label = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('widget').add('label');
	        self.canFocus = false;
	        if (settings.multiline) {
	          self.classes.add('autoscroll');
	        }
	        if (settings.strong) {
	          self.classes.add('strong');
	        }
	      },
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	        if (self.settings.multiline) {
	          var size = funcs.getSize(self.getEl());
	          if (size.width > layoutRect.maxW) {
	            layoutRect.minW = layoutRect.maxW;
	            self.classes.add('multiline');
	          }
	          self.getEl().style.width = layoutRect.minW + 'px';
	          layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, funcs.getSize(self.getEl()).height);
	        }
	        return layoutRect;
	      },
	      repaint: function () {
	        var self = this;
	        if (!self.settings.multiline) {
	          self.getEl().style.lineHeight = self.layoutRect().h + 'px';
	        }
	        return self._super();
	      },
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	      renderHtml: function () {
	        var self = this;
	        var targetCtrl, forName, forId = self.settings.forId;
	        var text = self.settings.html ? self.settings.html : self.encode(self.state.get('text'));
	        if (!forId && (forName = self.settings.forName)) {
	          targetCtrl = self.getRoot().find('#' + forName)[0];
	          if (targetCtrl) {
	            forId = targetCtrl._id;
	          }
	        }
	        if (forId) {
	          return '<label id="' + self._id + '" class="' + self.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' + text + '</label>';
	        }
	        return '<span id="' + self._id + '" class="' + self.classes + '">' + text + '</span>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.innerHtml(self.encode(e.value));
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var Toolbar$1 = Container.extend({
	      Defaults: {
	        role: 'toolbar',
	        layout: 'flow'
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('toolbar');
	      },
	      postRender: function () {
	        var self = this;
	        self.items().each(function (ctrl) {
	          ctrl.classes.add('toolbar-item');
	        });
	        return self._super();
	      }
	    });
	
	    var MenuBar = Toolbar$1.extend({
	      Defaults: {
	        role: 'menubar',
	        containerCls: 'menubar',
	        ariaRoot: true,
	        defaults: { type: 'menubutton' }
	      }
	    });
	
	    function isChildOf$1(node, parent) {
	      while (node) {
	        if (parent === node) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    }
	    var MenuButton = Button.extend({
	      init: function (settings) {
	        var self = this;
	        self._renderOpen = true;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('menubtn');
	        if (settings.fixedWidth) {
	          self.classes.add('fixed-width');
	        }
	        self.aria('haspopup', true);
	        self.state.set('menu', settings.menu || self.render());
	      },
	      showMenu: function (toggle) {
	        var self = this;
	        var menu;
	        if (self.menu && self.menu.visible() && toggle !== false) {
	          return self.hideMenu();
	        }
	        if (!self.menu) {
	          menu = self.state.get('menu') || [];
	          self.classes.add('opened');
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              animate: true,
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	            menu.animate = true;
	          }
	          if (!menu.renderTo) {
	            self.menu = global$4.create(menu).parent(self).renderTo();
	          } else {
	            self.menu = menu.parent(self).show().renderTo();
	          }
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control.parent() === self.menu) {
	              e.stopPropagation();
	              self.focus();
	              self.hideMenu();
	            }
	          });
	          self.menu.on('select', function () {
	            self.focus();
	          });
	          self.menu.on('show hide', function (e) {
	            if (e.type === 'hide' && e.control.parent() === self) {
	              self.classes.remove('opened-under');
	            }
	            if (e.control === self.menu) {
	              self.activeMenu(e.type === 'show');
	              self.classes.toggle('opened', e.type === 'show');
	            }
	            self.aria('expanded', e.type === 'show');
	          }).fire('show');
	        }
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.repaint();
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	        var menuLayoutRect = self.menu.layoutRect();
	        var selfBottom = self.$el.offset().top + self.layoutRect().h;
	        if (selfBottom > menuLayoutRect.y && selfBottom < menuLayoutRect.y + menuLayoutRect.h) {
	          self.classes.add('opened-under');
	        }
	        self.fire('showmenu');
	      },
	      hideMenu: function () {
	        var self = this;
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	          self.menu.hide();
	        }
	      },
	      activeMenu: function (state) {
	        this.classes.toggle('active', state);
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.settings.icon, image;
	        var text = self.state.get('text');
	        var textHtml = '';
	        image = self.settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        self.aria('role', self.parent() instanceof MenuBar ? 'menuitem' : 'button');
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1" aria-labelledby="' + id + '">' + '<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self.on('click', function (e) {
	          if (e.control === self && isChildOf$1(e.target, self.getEl())) {
	            self.focus();
	            self.showMenu(!e.aria);
	            if (e.aria) {
	              self.menu.items().filter(':visible')[0].focus();
	            }
	          }
	        });
	        self.on('mouseenter', function (e) {
	          var overCtrl = e.control;
	          var parent = self.parent();
	          var hasVisibleSiblingMenu;
	          if (overCtrl && parent && overCtrl instanceof MenuButton && overCtrl.parent() === parent) {
	            parent.items().filter('MenuButton').each(function (ctrl) {
	              if (ctrl.hideMenu && ctrl !== overCtrl) {
	                if (ctrl.menu && ctrl.menu.visible()) {
	                  hasVisibleSiblingMenu = true;
	                }
	                ctrl.hideMenu();
	              }
	            });
	            if (hasVisibleSiblingMenu) {
	              overCtrl.focus();
	              overCtrl.showMenu();
	            }
	          }
	        });
	        return self._super();
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:menu', function () {
	          if (self.menu) {
	            self.menu.remove();
	          }
	          self.menu = null;
	        });
	        return self._super();
	      },
	      remove: function () {
	        this._super();
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	
	    var Menu = FloatPanel.extend({
	      Defaults: {
	        defaultType: 'menuitem',
	        border: 1,
	        layout: 'stack',
	        role: 'application',
	        bodyRole: 'menu',
	        ariaRoot: true
	      },
	      init: function (settings) {
	        var self = this;
	        settings.autohide = true;
	        settings.constrainToViewport = true;
	        if (typeof settings.items === 'function') {
	          settings.itemsFactory = settings.items;
	          settings.items = [];
	        }
	        if (settings.itemDefaults) {
	          var items = settings.items;
	          var i = items.length;
	          while (i--) {
	            items[i] = global$2.extend({}, settings.itemDefaults, items[i]);
	          }
	        }
	        self._super(settings);
	        self.classes.add('menu');
	        if (settings.animate && global$8.ie !== 11) {
	          self.classes.add('animate');
	        }
	      },
	      repaint: function () {
	        this.classes.toggle('menu-align', true);
	        this._super();
	        this.getEl().style.height = '';
	        this.getEl('body').style.height = '';
	        return this;
	      },
	      cancel: function () {
	        var self = this;
	        self.hideAll();
	        self.fire('select');
	      },
	      load: function () {
	        var self = this;
	        var time, factory;
	        function hideThrobber() {
	          if (self.throbber) {
	            self.throbber.hide();
	            self.throbber = null;
	          }
	        }
	        factory = self.settings.itemsFactory;
	        if (!factory) {
	          return;
	        }
	        if (!self.throbber) {
	          self.throbber = new Throbber(self.getEl('body'), true);
	          if (self.items().length === 0) {
	            self.throbber.show();
	            self.fire('loading');
	          } else {
	            self.throbber.show(100, function () {
	              self.items().remove();
	              self.fire('loading');
	            });
	          }
	          self.on('hide close', hideThrobber);
	        }
	        self.requestTime = time = new Date().getTime();
	        self.settings.itemsFactory(function (items) {
	          if (items.length === 0) {
	            self.hide();
	            return;
	          }
	          if (self.requestTime !== time) {
	            return;
	          }
	          self.getEl().style.width = '';
	          self.getEl('body').style.width = '';
	          hideThrobber();
	          self.items().remove();
	          self.getEl('body').innerHTML = '';
	          self.add(items);
	          self.renderNew();
	          self.fire('loaded');
	        });
	      },
	      hideAll: function () {
	        var self = this;
	        this.find('menuitem').exec('hideMenu');
	        return self._super();
	      },
	      preRender: function () {
	        var self = this;
	        self.items().each(function (ctrl) {
	          var settings = ctrl.settings;
	          if (settings.icon || settings.image || settings.selectable) {
	            self._hasIcons = true;
	            return false;
	          }
	        });
	        if (self.settings.itemsFactory) {
	          self.on('postrender', function () {
	            if (self.settings.itemsFactory) {
	              self.load();
	            }
	          });
	        }
	        self.on('show hide', function (e) {
	          if (e.control === self) {
	            if (e.type === 'show') {
	              global$7.setTimeout(function () {
	                self.classes.add('in');
	              }, 0);
	            } else {
	              self.classes.remove('in');
	            }
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var ListBox = MenuButton.extend({
	      init: function (settings) {
	        var self = this;
	        var values, selected, selectedText, lastItemCtrl;
	        function setSelected(menuValues) {
	          for (var i = 0; i < menuValues.length; i++) {
	            selected = menuValues[i].selected || settings.value === menuValues[i].value;
	            if (selected) {
	              selectedText = selectedText || menuValues[i].text;
	              self.state.set('value', menuValues[i].value);
	              return true;
	            }
	            if (menuValues[i].menu) {
	              if (setSelected(menuValues[i].menu)) {
	                return true;
	              }
	            }
	          }
	        }
	        self._super(settings);
	        settings = self.settings;
	        self._values = values = settings.values;
	        if (values) {
	          if (typeof settings.value !== 'undefined') {
	            setSelected(values);
	          }
	          if (!selected && values.length > 0) {
	            selectedText = values[0].text;
	            self.state.set('value', values[0].value);
	          }
	          self.state.set('menu', values);
	        }
	        self.state.set('text', settings.text || selectedText);
	        self.classes.add('listbox');
	        self.on('select', function (e) {
	          var ctrl = e.control;
	          if (lastItemCtrl) {
	            e.lastControl = lastItemCtrl;
	          }
	          if (settings.multiple) {
	            ctrl.active(!ctrl.active());
	          } else {
	            self.value(e.control.value());
	          }
	          lastItemCtrl = ctrl;
	        });
	      },
	      value: function (value) {
	        if (arguments.length === 0) {
	          return this.state.get('value');
	        }
	        if (typeof value === 'undefined') {
	          return this;
	        }
	        function valueExists(values) {
	          return exists(values, function (a) {
	            return a.menu ? valueExists(a.menu) : a.value === value;
	          });
	        }
	        if (this.settings.values) {
	          if (valueExists(this.settings.values)) {
	            this.state.set('value', value);
	          } else if (value === null) {
	            this.state.set('value', null);
	          }
	        } else {
	          this.state.set('value', value);
	        }
	        return this;
	      },
	      bindStates: function () {
	        var self = this;
	        function activateMenuItemsByValue(menu, value) {
	          if (menu instanceof Menu) {
	            menu.items().each(function (ctrl) {
	              if (!ctrl.hasMenus()) {
	                ctrl.active(ctrl.value() === value);
	              }
	            });
	          }
	        }
	        function getSelectedItem(menuValues, value) {
	          var selectedItem;
	          if (!menuValues) {
	            return;
	          }
	          for (var i = 0; i < menuValues.length; i++) {
	            if (menuValues[i].value === value) {
	              return menuValues[i];
	            }
	            if (menuValues[i].menu) {
	              selectedItem = getSelectedItem(menuValues[i].menu, value);
	              if (selectedItem) {
	                return selectedItem;
	              }
	            }
	          }
	        }
	        self.on('show', function (e) {
	          activateMenuItemsByValue(e.control, self.value());
	        });
	        self.state.on('change:value', function (e) {
	          var selectedItem = getSelectedItem(self.state.get('menu'), e.value);
	          if (selectedItem) {
	            self.text(selectedItem.text);
	          } else {
	            self.text(self.settings.text);
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var toggleTextStyle = function (ctrl, state) {
	      var textStyle = ctrl._textStyle;
	      if (textStyle) {
	        var textElm = ctrl.getEl('text');
	        textElm.setAttribute('style', textStyle);
	        if (state) {
	          textElm.style.color = '';
	          textElm.style.backgroundColor = '';
	        }
	      }
	    };
	    var MenuItem = Widget.extend({
	      Defaults: {
	        border: 0,
	        role: 'menuitem'
	      },
	      init: function (settings) {
	        var self = this;
	        var text;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('menu-item');
	        if (settings.menu) {
	          self.classes.add('menu-item-expand');
	        }
	        if (settings.preview) {
	          self.classes.add('menu-item-preview');
	        }
	        text = self.state.get('text');
	        if (text === '-' || text === '|') {
	          self.classes.add('menu-item-sep');
	          self.aria('role', 'separator');
	          self.state.set('text', '-');
	        }
	        if (settings.selectable) {
	          self.aria('role', 'menuitemcheckbox');
	          self.classes.add('menu-item-checkbox');
	          settings.icon = 'selected';
	        }
	        if (!settings.preview && !settings.selectable) {
	          self.classes.add('menu-item-normal');
	        }
	        self.on('mousedown', function (e) {
	          e.preventDefault();
	        });
	        if (settings.menu && !settings.ariaHideMenu) {
	          self.aria('haspopup', true);
	        }
	      },
	      hasMenus: function () {
	        return !!this.settings.menu;
	      },
	      showMenu: function () {
	        var self = this;
	        var settings = self.settings;
	        var menu;
	        var parent = self.parent();
	        parent.items().each(function (ctrl) {
	          if (ctrl !== self) {
	            ctrl.hideMenu();
	          }
	        });
	        if (settings.menu) {
	          menu = self.menu;
	          if (!menu) {
	            menu = settings.menu;
	            if (menu.length) {
	              menu = {
	                type: 'menu',
	                items: menu
	              };
	            } else {
	              menu.type = menu.type || 'menu';
	            }
	            if (parent.settings.itemDefaults) {
	              menu.itemDefaults = parent.settings.itemDefaults;
	            }
	            menu = self.menu = global$4.create(menu).parent(self).renderTo();
	            menu.reflow();
	            menu.on('cancel', function (e) {
	              e.stopPropagation();
	              self.focus();
	              menu.hide();
	            });
	            menu.on('show hide', function (e) {
	              if (e.control.items) {
	                e.control.items().each(function (ctrl) {
	                  ctrl.active(ctrl.settings.selected);
	                });
	              }
	            }).fire('show');
	            menu.on('hide', function (e) {
	              if (e.control === menu) {
	                self.classes.remove('selected');
	              }
	            });
	            menu.submenu = true;
	          } else {
	            menu.show();
	          }
	          menu._parentMenu = parent;
	          menu.classes.add('menu-sub');
	          var rel = menu.testMoveRel(self.getEl(), self.isRtl() ? [
	            'tl-tr',
	            'bl-br',
	            'tr-tl',
	            'br-bl'
	          ] : [
	            'tr-tl',
	            'br-bl',
	            'tl-tr',
	            'bl-br'
	          ]);
	          menu.moveRel(self.getEl(), rel);
	          menu.rel = rel;
	          rel = 'menu-sub-' + rel;
	          menu.classes.remove(menu._lastRel).add(rel);
	          menu._lastRel = rel;
	          self.classes.add('selected');
	          self.aria('expanded', true);
	        }
	      },
	      hideMenu: function () {
	        var self = this;
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	          self.menu.hide();
	          self.aria('expanded', false);
	        }
	        return self;
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var settings = self.settings;
	        var prefix = self.classPrefix;
	        var text = self.state.get('text');
	        var icon = self.settings.icon, image = '', shortcut = settings.shortcut;
	        var url = self.encode(settings.url), iconHtml = '';
	        function convertShortcut(shortcut) {
	          var i, value, replace = {};
	          if (global$8.mac) {
	            replace = {
	              alt: '&#x2325;',
	              ctrl: '&#x2318;',
	              shift: '&#x21E7;',
	              meta: '&#x2318;'
	            };
	          } else {
	            replace = { meta: 'Ctrl' };
	          }
	          shortcut = shortcut.split('+');
	          for (i = 0; i < shortcut.length; i++) {
	            value = replace[shortcut[i].toLowerCase()];
	            if (value) {
	              shortcut[i] = value;
	            }
	          }
	          return shortcut.join('+');
	        }
	        function escapeRegExp(str) {
	          return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	        function markMatches(text) {
	          var match = settings.match || '';
	          return match ? text.replace(new RegExp(escapeRegExp(match), 'gi'), function (match) {
	            return '!mce~match[' + match + ']mce~match!';
	          }) : text;
	        }
	        function boldMatches(text) {
	          return text.replace(new RegExp(escapeRegExp('!mce~match['), 'g'), '<b>').replace(new RegExp(escapeRegExp(']mce~match!'), 'g'), '</b>');
	        }
	        if (icon) {
	          self.parent().classes.add('menu-has-icons');
	        }
	        if (settings.image) {
	          image = ' style="background-image: url(\'' + settings.image + '\')"';
	        }
	        if (shortcut) {
	          shortcut = convertShortcut(shortcut);
	        }
	        icon = prefix + 'ico ' + prefix + 'i-' + (self.settings.icon || 'none');
	        iconHtml = text !== '-' ? '<i class="' + icon + '"' + image + '></i>\xA0' : '';
	        text = boldMatches(self.encode(markMatches(text)));
	        url = boldMatches(self.encode(markMatches(url)));
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1">' + iconHtml + (text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') + (shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') + (settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') + (url ? '<div class="' + prefix + 'menu-item-link">' + url + '</div>' : '') + '</div>';
	      },
	      postRender: function () {
	        var self = this, settings = self.settings;
	        var textStyle = settings.textStyle;
	        if (typeof textStyle === 'function') {
	          textStyle = textStyle.call(this);
	        }
	        if (textStyle) {
	          var textElm = self.getEl('text');
	          if (textElm) {
	            textElm.setAttribute('style', textStyle);
	            self._textStyle = textStyle;
	          }
	        }
	        self.on('mouseenter click', function (e) {
	          if (e.control === self) {
	            if (!settings.menu && e.type === 'click') {
	              self.fire('select');
	              global$7.requestAnimationFrame(function () {
	                self.parent().hideAll();
	              });
	            } else {
	              self.showMenu();
	              if (e.aria) {
	                self.menu.focus(true);
	              }
	            }
	          }
	        });
	        self._super();
	        return self;
	      },
	      hover: function () {
	        var self = this;
	        self.parent().items().each(function (ctrl) {
	          ctrl.classes.remove('selected');
	        });
	        self.classes.toggle('selected', true);
	        return self;
	      },
	      active: function (state) {
	        toggleTextStyle(this, state);
	        if (typeof state !== 'undefined') {
	          this.aria('checked', state);
	        }
	        return this._super(state);
	      },
	      remove: function () {
	        this._super();
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	
	    var Radio = Checkbox.extend({
	      Defaults: {
	        classes: 'radio',
	        role: 'radio'
	      }
	    });
	
	    var ResizeHandle = Widget.extend({
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        self.classes.add('resizehandle');
	        if (self.settings.direction === 'both') {
	          self.classes.add('resizehandle-both');
	        }
	        self.canFocus = false;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.resizeDragHelper = new DragHelper(this._id, {
	          start: function () {
	            self.fire('ResizeStart');
	          },
	          drag: function (e) {
	            if (self.settings.direction !== 'both') {
	              e.deltaX = 0;
	            }
	            self.fire('Resize', e);
	          },
	          stop: function () {
	            self.fire('ResizeEnd');
	          }
	        });
	      },
	      remove: function () {
	        if (this.resizeDragHelper) {
	          this.resizeDragHelper.destroy();
	        }
	        return this._super();
	      }
	    });
	
	    function createOptions(options) {
	      var strOptions = '';
	      if (options) {
	        for (var i = 0; i < options.length; i++) {
	          strOptions += '<option value="' + options[i] + '">' + options[i] + '</option>';
	        }
	      }
	      return strOptions;
	    }
	    var SelectBox = Widget.extend({
	      Defaults: {
	        classes: 'selectbox',
	        role: 'selectbox',
	        options: []
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        if (self.settings.size) {
	          self.size = self.settings.size;
	        }
	        if (self.settings.options) {
	          self._options = self.settings.options;
	        }
	        self.on('keydown', function (e) {
	          var rootControl;
	          if (e.keyCode === 13) {
	            e.preventDefault();
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	      },
	      options: function (state) {
	        if (!arguments.length) {
	          return this.state.get('options');
	        }
	        this.state.set('options', state);
	        return this;
	      },
	      renderHtml: function () {
	        var self = this;
	        var options, size = '';
	        options = createOptions(self._options);
	        if (self.size) {
	          size = ' size = "' + self.size + '"';
	        }
	        return '<select id="' + self._id + '" class="' + self.classes + '"' + size + '>' + options + '</select>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:options', function (e) {
	          self.getEl().innerHTML = createOptions(e.value);
	        });
	        return self._super();
	      }
	    });
	
	    function constrain(value, minVal, maxVal) {
	      if (value < minVal) {
	        value = minVal;
	      }
	      if (value > maxVal) {
	        value = maxVal;
	      }
	      return value;
	    }
	    function setAriaProp(el, name, value) {
	      el.setAttribute('aria-' + name, value);
	    }
	    function updateSliderHandle(ctrl, value) {
	      var maxHandlePos, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
	      if (ctrl.settings.orientation === 'v') {
	        stylePosName = 'top';
	        sizeName = 'height';
	        shortSizeName = 'h';
	      } else {
	        stylePosName = 'left';
	        sizeName = 'width';
	        shortSizeName = 'w';
	      }
	      handleEl = ctrl.getEl('handle');
	      maxHandlePos = (ctrl.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
	      styleValue = maxHandlePos * ((value - ctrl._minValue) / (ctrl._maxValue - ctrl._minValue)) + 'px';
	      handleEl.style[stylePosName] = styleValue;
	      handleEl.style.height = ctrl.layoutRect().h + 'px';
	      setAriaProp(handleEl, 'valuenow', value);
	      setAriaProp(handleEl, 'valuetext', '' + ctrl.settings.previewFilter(value));
	      setAriaProp(handleEl, 'valuemin', ctrl._minValue);
	      setAriaProp(handleEl, 'valuemax', ctrl._maxValue);
	    }
	    var Slider = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        if (!settings.previewFilter) {
	          settings.previewFilter = function (value) {
	            return Math.round(value * 100) / 100;
	          };
	        }
	        self._super(settings);
	        self.classes.add('slider');
	        if (settings.orientation === 'v') {
	          self.classes.add('vertical');
	        }
	        self._minValue = isNumber(settings.minValue) ? settings.minValue : 0;
	        self._maxValue = isNumber(settings.maxValue) ? settings.maxValue : 100;
	        self._initValue = self.state.get('value');
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' + '</div>';
	      },
	      reset: function () {
	        this.value(this._initValue).repaint();
	      },
	      postRender: function () {
	        var self = this;
	        var minValue, maxValue, screenCordName, stylePosName, sizeName, shortSizeName;
	        function toFraction(min, max, val) {
	          return (val + min) / (max - min);
	        }
	        function fromFraction(min, max, val) {
	          return val * (max - min) - min;
	        }
	        function handleKeyboard(minValue, maxValue) {
	          function alter(delta) {
	            var value;
	            value = self.value();
	            value = fromFraction(minValue, maxValue, toFraction(minValue, maxValue, value) + delta * 0.05);
	            value = constrain(value, minValue, maxValue);
	            self.value(value);
	            self.fire('dragstart', { value: value });
	            self.fire('drag', { value: value });
	            self.fire('dragend', { value: value });
	          }
	          self.on('keydown', function (e) {
	            switch (e.keyCode) {
	            case 37:
	            case 38:
	              alter(-1);
	              break;
	            case 39:
	            case 40:
	              alter(1);
	              break;
	            }
	          });
	        }
	        function handleDrag(minValue, maxValue, handleEl) {
	          var startPos, startHandlePos, maxHandlePos, handlePos, value;
	          self._dragHelper = new DragHelper(self._id, {
	            handle: self._id + '-handle',
	            start: function (e) {
	              startPos = e[screenCordName];
	              startHandlePos = parseInt(self.getEl('handle').style[stylePosName], 10);
	              maxHandlePos = (self.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
	              self.fire('dragstart', { value: value });
	            },
	            drag: function (e) {
	              var delta = e[screenCordName] - startPos;
	              handlePos = constrain(startHandlePos + delta, 0, maxHandlePos);
	              handleEl.style[stylePosName] = handlePos + 'px';
	              value = minValue + handlePos / maxHandlePos * (maxValue - minValue);
	              self.value(value);
	              self.tooltip().text('' + self.settings.previewFilter(value)).show().moveRel(handleEl, 'bc tc');
	              self.fire('drag', { value: value });
	            },
	            stop: function () {
	              self.tooltip().hide();
	              self.fire('dragend', { value: value });
	            }
	          });
	        }
	        minValue = self._minValue;
	        maxValue = self._maxValue;
	        if (self.settings.orientation === 'v') {
	          screenCordName = 'screenY';
	          stylePosName = 'top';
	          sizeName = 'height';
	          shortSizeName = 'h';
	        } else {
	          screenCordName = 'screenX';
	          stylePosName = 'left';
	          sizeName = 'width';
	          shortSizeName = 'w';
	        }
	        self._super();
	        handleKeyboard(minValue, maxValue);
	        handleDrag(minValue, maxValue, self.getEl('handle'));
	      },
	      repaint: function () {
	        this._super();
	        updateSliderHandle(this, this.value());
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          updateSliderHandle(self, e.value);
	        });
	        return self._super();
	      }
	    });
	
	    var Spacer = Widget.extend({
	      renderHtml: function () {
	        var self = this;
	        self.classes.add('spacer');
	        self.canFocus = false;
	        return '<div id="' + self._id + '" class="' + self.classes + '"></div>';
	      }
	    });
	
	    var SplitButton = MenuButton.extend({
	      Defaults: {
	        classes: 'widget btn splitbtn',
	        role: 'button'
	      },
	      repaint: function () {
	        var self = this;
	        var elm = self.getEl();
	        var rect = self.layoutRect();
	        var mainButtonElm, menuButtonElm;
	        self._super();
	        mainButtonElm = elm.firstChild;
	        menuButtonElm = elm.lastChild;
	        global$9(mainButtonElm).css({
	          width: rect.w - funcs.getSize(menuButtonElm).width,
	          height: rect.h - 2
	        });
	        global$9(menuButtonElm).css({ height: rect.h - 2 });
	        return self;
	      },
	      activeMenu: function (state) {
	        var self = this;
	        global$9(self.getEl().lastChild).toggleClass(self.classPrefix + 'active', state);
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var prefix = self.classPrefix;
	        var image;
	        var icon = self.state.get('icon');
	        var text = self.state.get('text');
	        var settings = self.settings;
	        var textHtml = '', ariaPressed;
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        icon = settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	        return '<div id="' + id + '" class="' + self.classes + '" role="button"' + ariaPressed + ' tabindex="-1">' + '<button type="button" hidefocus="1" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + (self._menuBtnText ? (icon ? '\xA0' : '') + self._menuBtnText : '') + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	        self.on('click', function (e) {
	          var node = e.target;
	          if (e.control === this) {
	            while (node) {
	              if (e.aria && e.aria.key !== 'down' || node.nodeName === 'BUTTON' && node.className.indexOf('open') === -1) {
	                e.stopImmediatePropagation();
	                if (onClickHandler) {
	                  onClickHandler.call(this, e);
	                }
	                return;
	              }
	              node = node.parentNode;
	            }
	          }
	        });
	        delete self.settings.onclick;
	        return self._super();
	      }
	    });
	
	    var StackLayout = FlowLayout.extend({
	      Defaults: {
	        containerClass: 'stack-layout',
	        controlClass: 'stack-layout-item',
	        endClass: 'break'
	      },
	      isNative: function () {
	        return true;
	      }
	    });
	
	    var TabPanel = Panel.extend({
	      Defaults: {
	        layout: 'absolute',
	        defaults: { type: 'panel' }
	      },
	      activateTab: function (idx) {
	        var activeTabElm;
	        if (this.activeTabId) {
	          activeTabElm = this.getEl(this.activeTabId);
	          global$9(activeTabElm).removeClass(this.classPrefix + 'active');
	          activeTabElm.setAttribute('aria-selected', 'false');
	        }
	        this.activeTabId = 't' + idx;
	        activeTabElm = this.getEl('t' + idx);
	        activeTabElm.setAttribute('aria-selected', 'true');
	        global$9(activeTabElm).addClass(this.classPrefix + 'active');
	        this.items()[idx].show().fire('showtab');
	        this.reflow();
	        this.items().each(function (item, i) {
	          if (idx !== i) {
	            item.hide();
	          }
	        });
	      },
	      renderHtml: function () {
	        var self = this;
	        var layout = self._layout;
	        var tabsHtml = '';
	        var prefix = self.classPrefix;
	        self.preRender();
	        layout.preRender(self);
	        self.items().each(function (ctrl, i) {
	          var id = self._id + '-t' + i;
	          ctrl.aria('role', 'tabpanel');
	          ctrl.aria('labelledby', id);
	          tabsHtml += '<div id="' + id + '" class="' + prefix + 'tab" ' + 'unselectable="on" role="tab" aria-controls="' + ctrl._id + '" aria-selected="false" tabIndex="-1">' + self.encode(ctrl.settings.title) + '</div>';
	        });
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + '<div id="' + self._id + '-head" class="' + prefix + 'tabs" role="tablist">' + tabsHtml + '</div>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.settings.activeTab = self.settings.activeTab || 0;
	        self.activateTab(self.settings.activeTab);
	        this.on('click', function (e) {
	          var targetParent = e.target.parentNode;
	          if (targetParent && targetParent.id === self._id + '-head') {
	            var i = targetParent.childNodes.length;
	            while (i--) {
	              if (targetParent.childNodes[i] === e.target) {
	                self.activateTab(i);
	              }
	            }
	          }
	        });
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var rect, minW, minH;
	        minW = funcs.getSize(self.getEl('head')).width;
	        minW = minW < 0 ? 0 : minW;
	        minH = 0;
	        self.items().each(function (item) {
	          minW = Math.max(minW, item.layoutRect().minW);
	          minH = Math.max(minH, item.layoutRect().minH);
	        });
	        self.items().each(function (ctrl) {
	          ctrl.settings.x = 0;
	          ctrl.settings.y = 0;
	          ctrl.settings.w = minW;
	          ctrl.settings.h = minH;
	          ctrl.layoutRect({
	            x: 0,
	            y: 0,
	            w: minW,
	            h: minH
	          });
	        });
	        var headH = funcs.getSize(self.getEl('head')).height;
	        self.settings.minWidth = minW;
	        self.settings.minHeight = minH + headH;
	        rect = self._super();
	        rect.deltaH += headH;
	        rect.innerH = rect.h - rect.deltaH;
	        return rect;
	      }
	    });
	
	    var TextBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('textbox');
	        if (settings.multiline) {
	          self.classes.add('multiline');
	        } else {
	          self.on('keydown', function (e) {
	            var rootControl;
	            if (e.keyCode === 13) {
	              e.preventDefault();
	              self.parents().reverse().each(function (ctrl) {
	                if (ctrl.toJSON) {
	                  rootControl = ctrl;
	                  return false;
	                }
	              });
	              self.fire('submit', { data: rootControl.toJSON() });
	            }
	          });
	          self.on('keyup', function (e) {
	            self.state.set('value', e.target.value);
	          });
	        }
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect, borderBox, borderW, borderH = 0, lastRepaintRect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	        var doc = domGlobals.document;
	        if (!self.settings.multiline && doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          style.lineHeight = rect.h - borderH + 'px';
	        }
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right + 8;
	        borderH = borderBox.top + borderBox.bottom + (self.settings.multiline ? 8 : 0);
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = rect.x + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = rect.y + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	        if (rect.w !== lastRepaintRect.w) {
	          style.width = rect.w - borderW + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	        if (rect.h !== lastRepaintRect.h) {
	          style.height = rect.h - borderH + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	        return self;
	      },
	      renderHtml: function () {
	        var self = this;
	        var settings = self.settings;
	        var attrs, elm;
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	        global$2.each([
	          'rows',
	          'spellcheck',
	          'maxLength',
	          'size',
	          'readonly',
	          'min',
	          'max',
	          'step',
	          'list',
	          'pattern',
	          'placeholder',
	          'required',
	          'multiple'
	        ], function (name) {
	          attrs[name] = settings[name];
	        });
	        if (self.disabled()) {
	          attrs.disabled = 'disabled';
	        }
	        if (settings.subtype) {
	          attrs.type = settings.subtype;
	        }
	        elm = funcs.create(settings.multiline ? 'textarea' : 'input', attrs);
	        elm.value = self.state.get('value');
	        elm.className = self.classes.toString();
	        return elm.outerHTML;
	      },
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl().value);
	        }
	        return this.state.get('value');
	      },
	      postRender: function () {
	        var self = this;
	        self.getEl().value = self.state.get('value');
	        self._super();
	        self.$el.on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.getEl().value !== e.value) {
	            self.getEl().value = e.value;
	          }
	        });
	        self.state.on('change:disabled', function (e) {
	          self.getEl().disabled = e.value;
	        });
	        return self._super();
	      },
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	
	    var getApi = function () {
	      return {
	        Selector: Selector,
	        Collection: Collection$2,
	        ReflowQueue: ReflowQueue,
	        Control: Control$1,
	        Factory: global$4,
	        KeyboardNavigation: KeyboardNavigation,
	        Container: Container,
	        DragHelper: DragHelper,
	        Scrollable: Scrollable,
	        Panel: Panel,
	        Movable: Movable,
	        Resizable: Resizable,
	        FloatPanel: FloatPanel,
	        Window: Window,
	        MessageBox: MessageBox,
	        Tooltip: Tooltip,
	        Widget: Widget,
	        Progress: Progress,
	        Notification: Notification,
	        Layout: Layout,
	        AbsoluteLayout: AbsoluteLayout,
	        Button: Button,
	        ButtonGroup: ButtonGroup,
	        Checkbox: Checkbox,
	        ComboBox: ComboBox,
	        ColorBox: ColorBox,
	        PanelButton: PanelButton,
	        ColorButton: ColorButton,
	        ColorPicker: ColorPicker,
	        Path: Path,
	        ElementPath: ElementPath,
	        FormItem: FormItem,
	        Form: Form,
	        FieldSet: FieldSet,
	        FilePicker: FilePicker,
	        FitLayout: FitLayout,
	        FlexLayout: FlexLayout,
	        FlowLayout: FlowLayout,
	        FormatControls: FormatControls,
	        GridLayout: GridLayout,
	        Iframe: Iframe$1,
	        InfoBox: InfoBox,
	        Label: Label,
	        Toolbar: Toolbar$1,
	        MenuBar: MenuBar,
	        MenuButton: MenuButton,
	        MenuItem: MenuItem,
	        Throbber: Throbber,
	        Menu: Menu,
	        ListBox: ListBox,
	        Radio: Radio,
	        ResizeHandle: ResizeHandle,
	        SelectBox: SelectBox,
	        Slider: Slider,
	        Spacer: Spacer,
	        SplitButton: SplitButton,
	        StackLayout: StackLayout,
	        TabPanel: TabPanel,
	        TextBox: TextBox,
	        DropZone: DropZone,
	        BrowseButton: BrowseButton
	      };
	    };
	    var appendTo = function (target) {
	      if (target.ui) {
	        global$2.each(getApi(), function (ref, key) {
	          target.ui[key] = ref;
	        });
	      } else {
	        target.ui = getApi();
	      }
	    };
	    var registerToFactory = function () {
	      global$2.each(getApi(), function (ref, key) {
	        global$4.add(key, ref);
	      });
	    };
	    var Api = {
	      appendTo: appendTo,
	      registerToFactory: registerToFactory
	    };
	
	    Api.registerToFactory();
	    Api.appendTo(window.tinymce ? window.tinymce : {});
	    global.add('modern', function (editor) {
	      FormatControls.setup(editor);
	      return ThemeApi.get(editor);
	    });
	    function Theme () {
	    }
	
	    return Theme;
	
	}(window));
	})();


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {// 4.9.11 (2020-07-13)
	(function () {
	(function (domGlobals) {
	    'use strict';
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return !f.apply(null, args);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNull = isType('null');
	    var isBoolean = isType('boolean');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(i);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var url = function () {
	      return Global$1.getOrDie('URL');
	    };
	    var createObjectURL = function (blob) {
	      return url().createObjectURL(blob);
	    };
	    var revokeObjectURL = function (u) {
	      url().revokeObjectURL(u);
	    };
	    var URL = {
	      createObjectURL: createObjectURL,
	      revokeObjectURL: revokeObjectURL
	    };
	
	    var nav = domGlobals.navigator, userAgent = nav.userAgent;
	    var opera, webkit, ie, ie11, ie12, gecko, mac, iDevice, android, fileApi, phone, tablet, windowsPhone;
	    var matchMediaQuery = function (query) {
	      return 'matchMedia' in domGlobals.window ? domGlobals.matchMedia(query).matches : false;
	    };
	    opera = false;
	    android = /Android/.test(userAgent);
	    webkit = /WebKit/.test(userAgent);
	    ie = !webkit && !opera && /MSIE/gi.test(userAgent) && /Explorer/gi.test(nav.appName);
	    ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
	    ie11 = userAgent.indexOf('Trident/') !== -1 && (userAgent.indexOf('rv:') !== -1 || nav.appName.indexOf('Netscape') !== -1) ? 11 : false;
	    ie12 = userAgent.indexOf('Edge/') !== -1 && !ie && !ie11 ? 12 : false;
	    ie = ie || ie11 || ie12;
	    gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
	    mac = userAgent.indexOf('Mac') !== -1;
	    iDevice = /(iPad|iPhone)/.test(userAgent);
	    fileApi = 'FormData' in domGlobals.window && 'FileReader' in domGlobals.window && 'URL' in domGlobals.window && !!URL.createObjectURL;
	    phone = matchMediaQuery('only screen and (max-device-width: 480px)') && (android || iDevice);
	    tablet = matchMediaQuery('only screen and (min-width: 800px)') && (android || iDevice);
	    windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
	    if (ie12) {
	      webkit = false;
	    }
	    var contentEditable = !iDevice || fileApi || parseInt(userAgent.match(/AppleWebKit\/(\d*)/)[1], 10) >= 534;
	    var Env = {
	      opera: opera,
	      webkit: webkit,
	      ie: ie,
	      gecko: gecko,
	      mac: mac,
	      iOS: iDevice,
	      android: android,
	      contentEditable: contentEditable,
	      transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
	      caretAfter: ie !== 8,
	      range: domGlobals.window.getSelection && 'Range' in domGlobals.window,
	      documentMode: ie && !ie12 ? domGlobals.document.documentMode || 7 : 10,
	      fileApi: fileApi,
	      ceFalse: ie === false || ie > 8,
	      cacheSuffix: null,
	      container: null,
	      overrideViewPort: null,
	      experimentalShadowDom: false,
	      canHaveCSP: ie === false || ie > 11,
	      desktop: !phone && !tablet,
	      windowsPhone: windowsPhone
	    };
	
	    var promise = function () {
	      function bind(fn, thisArg) {
	        return function () {
	          fn.apply(thisArg, arguments);
	        };
	      }
	      var isArray = Array.isArray || function (value) {
	        return Object.prototype.toString.call(value) === '[object Array]';
	      };
	      var Promise = function (fn) {
	        if (typeof this !== 'object') {
	          throw new TypeError('Promises must be constructed via new');
	        }
	        if (typeof fn !== 'function') {
	          throw new TypeError('not a function');
	        }
	        this._state = null;
	        this._value = null;
	        this._deferreds = [];
	        doResolve(fn, bind(resolve, this), bind(reject, this));
	      };
	      var asap = Promise.immediateFn || typeof setImmediate === 'function' && setImmediate || function (fn) {
	        setTimeout(fn, 1);
	      };
	      function handle(deferred) {
	        var me = this;
	        if (this._state === null) {
	          this._deferreds.push(deferred);
	          return;
	        }
	        asap(function () {
	          var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
	          if (cb === null) {
	            (me._state ? deferred.resolve : deferred.reject)(me._value);
	            return;
	          }
	          var ret;
	          try {
	            ret = cb(me._value);
	          } catch (e) {
	            deferred.reject(e);
	            return;
	          }
	          deferred.resolve(ret);
	        });
	      }
	      function resolve(newValue) {
	        try {
	          if (newValue === this) {
	            throw new TypeError('A promise cannot be resolved with itself.');
	          }
	          if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	            var then = newValue.then;
	            if (typeof then === 'function') {
	              doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	              return;
	            }
	          }
	          this._state = true;
	          this._value = newValue;
	          finale.call(this);
	        } catch (e) {
	          reject.call(this, e);
	        }
	      }
	      function reject(newValue) {
	        this._state = false;
	        this._value = newValue;
	        finale.call(this);
	      }
	      function finale() {
	        for (var i = 0, len = this._deferreds.length; i < len; i++) {
	          handle.call(this, this._deferreds[i]);
	        }
	        this._deferreds = null;
	      }
	      function Handler(onFulfilled, onRejected, resolve, reject) {
	        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	        this.resolve = resolve;
	        this.reject = reject;
	      }
	      function doResolve(fn, onFulfilled, onRejected) {
	        var done = false;
	        try {
	          fn(function (value) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onFulfilled(value);
	          }, function (reason) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onRejected(reason);
	          });
	        } catch (ex) {
	          if (done) {
	            return;
	          }
	          done = true;
	          onRejected(ex);
	        }
	      }
	      Promise.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	      };
	      Promise.prototype.then = function (onFulfilled, onRejected) {
	        var me = this;
	        return new Promise(function (resolve, reject) {
	          handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	        });
	      };
	      Promise.all = function () {
	        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
	        return new Promise(function (resolve, reject) {
	          if (args.length === 0) {
	            return resolve([]);
	          }
	          var remaining = args.length;
	          function res(i, val) {
	            try {
	              if (val && (typeof val === 'object' || typeof val === 'function')) {
	                var then = val.then;
	                if (typeof then === 'function') {
	                  then.call(val, function (val) {
	                    res(i, val);
	                  }, reject);
	                  return;
	                }
	              }
	              args[i] = val;
	              if (--remaining === 0) {
	                resolve(args);
	              }
	            } catch (ex) {
	              reject(ex);
	            }
	          }
	          for (var i = 0; i < args.length; i++) {
	            res(i, args[i]);
	          }
	        });
	      };
	      Promise.resolve = function (value) {
	        if (value && typeof value === 'object' && value.constructor === Promise) {
	          return value;
	        }
	        return new Promise(function (resolve) {
	          resolve(value);
	        });
	      };
	      Promise.reject = function (value) {
	        return new Promise(function (resolve, reject) {
	          reject(value);
	        });
	      };
	      Promise.race = function (values) {
	        return new Promise(function (resolve, reject) {
	          for (var i = 0, len = values.length; i < len; i++) {
	            values[i].then(resolve, reject);
	          }
	        });
	      };
	      return Promise;
	    };
	    var promiseObj = window.Promise ? window.Promise : promise();
	
	    var requestAnimationFramePromise;
	    var requestAnimationFrame = function (callback, element) {
	      var i, requestAnimationFrameFunc = domGlobals.window.requestAnimationFrame;
	      var vendors = [
	        'ms',
	        'moz',
	        'webkit'
	      ];
	      var featurefill = function (callback) {
	        domGlobals.window.setTimeout(callback, 0);
	      };
	      for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
	        requestAnimationFrameFunc = domGlobals.window[vendors[i] + 'RequestAnimationFrame'];
	      }
	      if (!requestAnimationFrameFunc) {
	        requestAnimationFrameFunc = featurefill;
	      }
	      requestAnimationFrameFunc(callback, element);
	    };
	    var wrappedSetTimeout = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 0;
	      }
	      return setTimeout(callback, time);
	    };
	    var wrappedSetInterval = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 1;
	      }
	      return setInterval(callback, time);
	    };
	    var wrappedClearTimeout = function (id) {
	      return clearTimeout(id);
	    };
	    var wrappedClearInterval = function (id) {
	      return clearInterval(id);
	    };
	    var debounce = function (callback, time) {
	      var timer, func;
	      func = function () {
	        var args = arguments;
	        clearTimeout(timer);
	        timer = wrappedSetTimeout(function () {
	          callback.apply(this, args);
	        }, time);
	      };
	      func.stop = function () {
	        clearTimeout(timer);
	      };
	      return func;
	    };
	    var Delay = {
	      requestAnimationFrame: function (callback, element) {
	        if (requestAnimationFramePromise) {
	          requestAnimationFramePromise.then(callback);
	          return;
	        }
	        requestAnimationFramePromise = new promiseObj(function (resolve) {
	          if (!element) {
	            element = domGlobals.document.body;
	          }
	          requestAnimationFrame(resolve, element);
	        }).then(callback);
	      },
	      setTimeout: wrappedSetTimeout,
	      setInterval: wrappedSetInterval,
	      setEditorTimeout: function (editor, callback, time) {
	        return wrappedSetTimeout(function () {
	          if (!editor.removed) {
	            callback();
	          }
	        }, time);
	      },
	      setEditorInterval: function (editor, callback, time) {
	        var timer;
	        timer = wrappedSetInterval(function () {
	          if (!editor.removed) {
	            callback();
	          } else {
	            clearInterval(timer);
	          }
	        }, time);
	        return timer;
	      },
	      debounce: debounce,
	      throttle: debounce,
	      clearInterval: wrappedClearInterval,
	      clearTimeout: wrappedClearTimeout
	    };
	
	    var eventExpandoPrefix = 'mce-data-';
	    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
	    var deprecated = {
	      keyLocation: 1,
	      layerX: 1,
	      layerY: 1,
	      returnValue: 1,
	      webkitMovementX: 1,
	      webkitMovementY: 1,
	      keyIdentifier: 1
	    };
	    var hasIsDefaultPrevented = function (event) {
	      return event.isDefaultPrevented === returnTrue || event.isDefaultPrevented === returnFalse;
	    };
	    var returnFalse = function () {
	      return false;
	    };
	    var returnTrue = function () {
	      return true;
	    };
	    var addEvent = function (target, name, callback, capture) {
	      if (target.addEventListener) {
	        target.addEventListener(name, callback, capture || false);
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + name, callback);
	      }
	    };
	    var removeEvent = function (target, name, callback, capture) {
	      if (target.removeEventListener) {
	        target.removeEventListener(name, callback, capture || false);
	      } else if (target.detachEvent) {
	        target.detachEvent('on' + name, callback);
	      }
	    };
	    var getTargetFromShadowDom = function (event, defaultTarget) {
	      if (event.composedPath) {
	        var composedPath = event.composedPath();
	        if (composedPath && composedPath.length > 0) {
	          return composedPath[0];
	        }
	      }
	      return defaultTarget;
	    };
	    var fix = function (originalEvent, data) {
	      var name;
	      var event = data || {};
	      for (name in originalEvent) {
	        if (!deprecated[name]) {
	          event[name] = originalEvent[name];
	        }
	      }
	      if (!event.target) {
	        event.target = event.srcElement || domGlobals.document;
	      }
	      if (Env.experimentalShadowDom) {
	        event.target = getTargetFromShadowDom(originalEvent, event.target);
	      }
	      if (originalEvent && mouseEventRe.test(originalEvent.type) && originalEvent.pageX === undefined && originalEvent.clientX !== undefined) {
	        var eventDoc = event.target.ownerDocument || domGlobals.document;
	        var doc = eventDoc.documentElement;
	        var body = eventDoc.body;
	        event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	        event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	      }
	      event.preventDefault = function () {
	        event.isDefaultPrevented = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.preventDefault) {
	            originalEvent.preventDefault();
	          } else {
	            originalEvent.returnValue = false;
	          }
	        }
	      };
	      event.stopPropagation = function () {
	        event.isPropagationStopped = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.stopPropagation) {
	            originalEvent.stopPropagation();
	          } else {
	            originalEvent.cancelBubble = true;
	          }
	        }
	      };
	      event.stopImmediatePropagation = function () {
	        event.isImmediatePropagationStopped = returnTrue;
	        event.stopPropagation();
	      };
	      if (hasIsDefaultPrevented(event) === false) {
	        event.isDefaultPrevented = returnFalse;
	        event.isPropagationStopped = returnFalse;
	        event.isImmediatePropagationStopped = returnFalse;
	      }
	      if (typeof event.metaKey === 'undefined') {
	        event.metaKey = false;
	      }
	      return event;
	    };
	    var bindOnReady = function (win, callback, eventUtils) {
	      var doc = win.document, event = { type: 'ready' };
	      if (eventUtils.domLoaded) {
	        callback(event);
	        return;
	      }
	      var isDocReady = function () {
	        return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
	      };
	      var readyHandler = function () {
	        if (!eventUtils.domLoaded) {
	          eventUtils.domLoaded = true;
	          callback(event);
	        }
	      };
	      var waitForDomLoaded = function () {
	        if (isDocReady()) {
	          removeEvent(doc, 'readystatechange', waitForDomLoaded);
	          readyHandler();
	        }
	      };
	      var tryScroll = function () {
	        try {
	          doc.documentElement.doScroll('left');
	        } catch (ex) {
	          Delay.setTimeout(tryScroll);
	          return;
	        }
	        readyHandler();
	      };
	      if (doc.addEventListener && !(Env.ie && Env.ie < 11)) {
	        if (isDocReady()) {
	          readyHandler();
	        } else {
	          addEvent(win, 'DOMContentLoaded', readyHandler);
	        }
	      } else {
	        addEvent(doc, 'readystatechange', waitForDomLoaded);
	        if (doc.documentElement.doScroll && win.self === win.top) {
	          tryScroll();
	        }
	      }
	      addEvent(win, 'load', readyHandler);
	    };
	    var EventUtils = function () {
	      var self = this;
	      var events = {}, count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
	      expando = eventExpandoPrefix + (+new Date()).toString(32);
	      hasMouseEnterLeave = 'onmouseenter' in domGlobals.document.documentElement;
	      hasFocusIn = 'onfocusin' in domGlobals.document.documentElement;
	      mouseEnterLeave = {
	        mouseenter: 'mouseover',
	        mouseleave: 'mouseout'
	      };
	      count = 1;
	      self.domLoaded = false;
	      self.events = events;
	      var executeHandlers = function (evt, id) {
	        var callbackList, i, l, callback;
	        var container = events[id];
	        callbackList = container && container[evt.type];
	        if (callbackList) {
	          for (i = 0, l = callbackList.length; i < l; i++) {
	            callback = callbackList[i];
	            if (callback && callback.func.call(callback.scope, evt) === false) {
	              evt.preventDefault();
	            }
	            if (evt.isImmediatePropagationStopped()) {
	              return;
	            }
	          }
	        }
	      };
	      self.bind = function (target, names, callback, scope) {
	        var id, callbackList, i, name, fakeName, nativeHandler, capture;
	        var win = domGlobals.window;
	        var defaultNativeHandler = function (evt) {
	          executeHandlers(fix(evt || win.event), id);
	        };
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return;
	        }
	        if (!target[expando]) {
	          id = count++;
	          target[expando] = id;
	          events[id] = {};
	        } else {
	          id = target[expando];
	        }
	        scope = scope || target;
	        names = names.split(' ');
	        i = names.length;
	        while (i--) {
	          name = names[i];
	          nativeHandler = defaultNativeHandler;
	          fakeName = capture = false;
	          if (name === 'DOMContentLoaded') {
	            name = 'ready';
	          }
	          if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
	            callback.call(scope, fix({ type: name }));
	            continue;
	          }
	          if (!hasMouseEnterLeave) {
	            fakeName = mouseEnterLeave[name];
	            if (fakeName) {
	              nativeHandler = function (evt) {
	                var current, related;
	                current = evt.currentTarget;
	                related = evt.relatedTarget;
	                if (related && current.contains) {
	                  related = current.contains(related);
	                } else {
	                  while (related && related !== current) {
	                    related = related.parentNode;
	                  }
	                }
	                if (!related) {
	                  evt = fix(evt || win.event);
	                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
	                  evt.target = current;
	                  executeHandlers(evt, id);
	                }
	              };
	            }
	          }
	          if (!hasFocusIn && (name === 'focusin' || name === 'focusout')) {
	            capture = true;
	            fakeName = name === 'focusin' ? 'focus' : 'blur';
	            nativeHandler = function (evt) {
	              evt = fix(evt || win.event);
	              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
	              executeHandlers(evt, id);
	            };
	          }
	          callbackList = events[id][name];
	          if (!callbackList) {
	            events[id][name] = callbackList = [{
	                func: callback,
	                scope: scope
	              }];
	            callbackList.fakeName = fakeName;
	            callbackList.capture = capture;
	            callbackList.nativeHandler = nativeHandler;
	            if (name === 'ready') {
	              bindOnReady(target, nativeHandler, self);
	            } else {
	              addEvent(target, fakeName || name, nativeHandler, capture);
	            }
	          } else {
	            if (name === 'ready' && self.domLoaded) {
	              callback({ type: name });
	            } else {
	              callbackList.push({
	                func: callback,
	                scope: scope
	              });
	            }
	          }
	        }
	        target = callbackList = 0;
	        return callback;
	      };
	      self.unbind = function (target, names, callback) {
	        var id, callbackList, i, ci, name, eventMap;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        id = target[expando];
	        if (id) {
	          eventMap = events[id];
	          if (names) {
	            names = names.split(' ');
	            i = names.length;
	            while (i--) {
	              name = names[i];
	              callbackList = eventMap[name];
	              if (callbackList) {
	                if (callback) {
	                  ci = callbackList.length;
	                  while (ci--) {
	                    if (callbackList[ci].func === callback) {
	                      var nativeHandler = callbackList.nativeHandler;
	                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
	                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
	                      callbackList.nativeHandler = nativeHandler;
	                      callbackList.fakeName = fakeName;
	                      callbackList.capture = capture;
	                      eventMap[name] = callbackList;
	                    }
	                  }
	                }
	                if (!callback || callbackList.length === 0) {
	                  delete eventMap[name];
	                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	                }
	              }
	            }
	          } else {
	            for (name in eventMap) {
	              callbackList = eventMap[name];
	              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	            }
	            eventMap = {};
	          }
	          for (name in eventMap) {
	            return self;
	          }
	          delete events[id];
	          try {
	            delete target[expando];
	          } catch (ex) {
	            target[expando] = null;
	          }
	        }
	        return self;
	      };
	      self.fire = function (target, name, args) {
	        var id;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        args = fix(null, args);
	        args.type = name;
	        args.target = target;
	        do {
	          id = target[expando];
	          if (id) {
	            executeHandlers(args, id);
	          }
	          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
	        } while (target && !args.isPropagationStopped());
	        return self;
	      };
	      self.clean = function (target) {
	        var i, children;
	        var unbind = self.unbind;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        if (target[expando]) {
	          unbind(target);
	        }
	        if (!target.getElementsByTagName) {
	          target = target.document;
	        }
	        if (target && target.getElementsByTagName) {
	          unbind(target);
	          children = target.getElementsByTagName('*');
	          i = children.length;
	          while (i--) {
	            target = children[i];
	            if (target[expando]) {
	              unbind(target);
	            }
	          }
	        }
	        return self;
	      };
	      self.destroy = function () {
	        events = {};
	      };
	      self.cancel = function (e) {
	        if (e) {
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        return false;
	      };
	    };
	    EventUtils.Event = new EventUtils();
	    EventUtils.Event.bind(domGlobals.window, 'ready', function () {
	    });
	
	    var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains$1, expando = 'sizzle' + -new Date(), preferredDoc = domGlobals.window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	        }
	        return 0;
	      }, strundefined = typeof undefined, MAX_NEGATIVE = 1 << 31, hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, indexOf$1 = arr.indexOf || function (elem) {
	        var i = 0, len = this.length;
	        for (; i < len; i++) {
	          if (this[i] === elem) {
	            return i;
	          }
	        }
	        return -1;
	      }, booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped', whitespace = '[\\x20\\t\\r\\n\\f]', identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+', attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]', pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)', rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'), rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'), rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'), rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g'), rpseudo = new RegExp(pseudos), ridentifier = new RegExp('^' + identifier + '$'), matchExpr = {
	        ID: new RegExp('^#(' + identifier + ')'),
	        CLASS: new RegExp('^\\.(' + identifier + ')'),
	        TAG: new RegExp('^(' + identifier + '|[*])'),
	        ATTR: new RegExp('^' + attributes),
	        PSEUDO: new RegExp('^' + pseudos),
	        CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
	        bool: new RegExp('^(?:' + booleans + ')$', 'i'),
	        needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
	      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig'), funescape = function (_, escaped, escapedWhitespace) {
	        var high = '0x' + escaped - 65536;
	        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
	      };
	    try {
	      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
	      arr[preferredDoc.childNodes.length].nodeType;
	    } catch (e) {
	      push = {
	        apply: arr.length ? function (target, els) {
	          push_native.apply(target, slice.call(els));
	        } : function (target, els) {
	          var j = target.length, i = 0;
	          while (target[j++] = els[i++]) {
	          }
	          target.length = j - 1;
	        }
	      };
	    }
	    var Sizzle = function (selector, context, results, seed) {
	      var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
	      if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
	        setDocument(context);
	      }
	      context = context || document;
	      results = results || [];
	      if (!selector || typeof selector !== 'string') {
	        return results;
	      }
	      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	        return [];
	      }
	      if (documentIsHTML && !seed) {
	        if (match = rquickExpr.exec(selector)) {
	          if (m = match[1]) {
	            if (nodeType === 9) {
	              elem = context.getElementById(m);
	              if (elem && elem.parentNode) {
	                if (elem.id === m) {
	                  results.push(elem);
	                  return results;
	                }
	              } else {
	                return results;
	              }
	            } else {
	              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains$1(context, elem) && elem.id === m) {
	                results.push(elem);
	                return results;
	              }
	            }
	          } else if (match[2]) {
	            push.apply(results, context.getElementsByTagName(selector));
	            return results;
	          } else if ((m = match[3]) && support.getElementsByClassName) {
	            push.apply(results, context.getElementsByClassName(m));
	            return results;
	          }
	        }
	        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	          nid = old = expando;
	          newContext = context;
	          newSelector = nodeType === 9 && selector;
	          if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
	            groups = tokenize(selector);
	            if (old = context.getAttribute('id')) {
	              nid = old.replace(rescape, '\\$&');
	            } else {
	              context.setAttribute('id', nid);
	            }
	            nid = '[id=\'' + nid + '\'] ';
	            i = groups.length;
	            while (i--) {
	              groups[i] = nid + toSelector(groups[i]);
	            }
	            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	            newSelector = groups.join(',');
	          }
	          if (newSelector) {
	            try {
	              push.apply(results, newContext.querySelectorAll(newSelector));
	              return results;
	            } catch (qsaError) {
	            } finally {
	              if (!old) {
	                context.removeAttribute('id');
	              }
	            }
	          }
	        }
	      }
	      return select(selector.replace(rtrim, '$1'), context, results, seed);
	    };
	    function createCache() {
	      var keys = [];
	      function cache(key, value) {
	        if (keys.push(key + ' ') > Expr.cacheLength) {
	          delete cache[keys.shift()];
	        }
	        return cache[key + ' '] = value;
	      }
	      return cache;
	    }
	    function markFunction(fn) {
	      fn[expando] = true;
	      return fn;
	    }
	    function siblingCheck(a, b) {
	      var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
	      if (diff) {
	        return diff;
	      }
	      if (cur) {
	        while (cur = cur.nextSibling) {
	          if (cur === b) {
	            return -1;
	          }
	        }
	      }
	      return a ? 1 : -1;
	    }
	    function createInputPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return name === 'input' && elem.type === type;
	      };
	    }
	    function createButtonPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return (name === 'input' || name === 'button') && elem.type === type;
	      };
	    }
	    function createPositionalPseudo(fn) {
	      return markFunction(function (argument) {
	        argument = +argument;
	        return markFunction(function (seed, matches) {
	          var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
	          while (i--) {
	            if (seed[j = matchIndexes[i]]) {
	              seed[j] = !(matches[j] = seed[j]);
	            }
	          }
	        });
	      });
	    }
	    function testContext(context) {
	      return context && typeof context.getElementsByTagName !== strundefined && context;
	    }
	    support = Sizzle.support = {};
	    isXML = Sizzle.isXML = function (elem) {
	      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	      return documentElement ? documentElement.nodeName !== 'HTML' : false;
	    };
	    setDocument = Sizzle.setDocument = function (node) {
	      var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
	      function getTop(win) {
	        try {
	          return win.top;
	        } catch (ex) {
	        }
	        return null;
	      }
	      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
	        return document;
	      }
	      document = doc;
	      docElem = doc.documentElement;
	      documentIsHTML = !isXML(doc);
	      if (parent && parent !== getTop(parent)) {
	        if (parent.addEventListener) {
	          parent.addEventListener('unload', function () {
	            setDocument();
	          }, false);
	        } else if (parent.attachEvent) {
	          parent.attachEvent('onunload', function () {
	            setDocument();
	          });
	        }
	      }
	      support.attributes = true;
	      support.getElementsByTagName = true;
	      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
	      support.getById = true;
	      Expr.find.ID = function (id, context) {
	        if (typeof context.getElementById !== strundefined && documentIsHTML) {
	          var m = context.getElementById(id);
	          return m && m.parentNode ? [m] : [];
	        }
	      };
	      Expr.filter.ID = function (id) {
	        var attrId = id.replace(runescape, funescape);
	        return function (elem) {
	          return elem.getAttribute('id') === attrId;
	        };
	      };
	      Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
	        if (typeof context.getElementsByTagName !== strundefined) {
	          return context.getElementsByTagName(tag);
	        }
	      } : function (tag, context) {
	        var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
	        if (tag === '*') {
	          while (elem = results[i++]) {
	            if (elem.nodeType === 1) {
	              tmp.push(elem);
	            }
	          }
	          return tmp;
	        }
	        return results;
	      };
	      Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
	        if (documentIsHTML) {
	          return context.getElementsByClassName(className);
	        }
	      };
	      rbuggyMatches = [];
	      rbuggyQSA = [];
	      support.disconnectedMatch = true;
	      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
	      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
	      hasCompare = rnative.test(docElem.compareDocumentPosition);
	      contains$1 = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
	        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
	        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
	      } : function (a, b) {
	        if (b) {
	          while (b = b.parentNode) {
	            if (b === a) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	      sortOrder = hasCompare ? function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	        if (compare) {
	          return compare;
	        }
	        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
	        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	          if (a === doc || a.ownerDocument === preferredDoc && contains$1(preferredDoc, a)) {
	            return -1;
	          }
	          if (b === doc || b.ownerDocument === preferredDoc && contains$1(preferredDoc, b)) {
	            return 1;
	          }
	          return sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
	        }
	        return compare & 4 ? -1 : 1;
	      } : function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
	        if (!aup || !bup) {
	          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
	        } else if (aup === bup) {
	          return siblingCheck(a, b);
	        }
	        cur = a;
	        while (cur = cur.parentNode) {
	          ap.unshift(cur);
	        }
	        cur = b;
	        while (cur = cur.parentNode) {
	          bp.unshift(cur);
	        }
	        while (ap[i] === bp[i]) {
	          i++;
	        }
	        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
	      };
	      return doc;
	    };
	    Sizzle.matches = function (expr, elements) {
	      return Sizzle(expr, null, null, elements);
	    };
	    Sizzle.matchesSelector = function (elem, expr) {
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	      expr = expr.replace(rattributeQuotes, '=\'$1\']');
	      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	        try {
	          var ret = matches.call(elem, expr);
	          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
	            return ret;
	          }
	        } catch (e) {
	        }
	      }
	      return Sizzle(expr, document, null, [elem]).length > 0;
	    };
	    Sizzle.contains = function (context, elem) {
	      if ((context.ownerDocument || context) !== document) {
	        setDocument(context);
	      }
	      return contains$1(context, elem);
	    };
	    Sizzle.attr = function (elem, name) {
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
	    };
	    Sizzle.error = function (msg) {
	      throw new Error('Syntax error, unrecognized expression: ' + msg);
	    };
	    Sizzle.uniqueSort = function (results) {
	      var elem, duplicates = [], j = 0, i = 0;
	      hasDuplicate = !support.detectDuplicates;
	      sortInput = !support.sortStable && results.slice(0);
	      results.sort(sortOrder);
	      if (hasDuplicate) {
	        while (elem = results[i++]) {
	          if (elem === results[i]) {
	            j = duplicates.push(i);
	          }
	        }
	        while (j--) {
	          results.splice(duplicates[j], 1);
	        }
	      }
	      sortInput = null;
	      return results;
	    };
	    getText = Sizzle.getText = function (elem) {
	      var node, ret = '', i = 0, nodeType = elem.nodeType;
	      if (!nodeType) {
	        while (node = elem[i++]) {
	          ret += getText(node);
	        }
	      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	        if (typeof elem.textContent === 'string') {
	          return elem.textContent;
	        } else {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            ret += getText(elem);
	          }
	        }
	      } else if (nodeType === 3 || nodeType === 4) {
	        return elem.nodeValue;
	      }
	      return ret;
	    };
	    Expr = Sizzle.selectors = {
	      cacheLength: 50,
	      createPseudo: markFunction,
	      match: matchExpr,
	      attrHandle: {},
	      find: {},
	      relative: {
	        '>': {
	          dir: 'parentNode',
	          first: true
	        },
	        ' ': { dir: 'parentNode' },
	        '+': {
	          dir: 'previousSibling',
	          first: true
	        },
	        '~': { dir: 'previousSibling' }
	      },
	      preFilter: {
	        ATTR: function (match) {
	          match[1] = match[1].replace(runescape, funescape);
	          match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
	          if (match[2] === '~=') {
	            match[3] = ' ' + match[3] + ' ';
	          }
	          return match.slice(0, 4);
	        },
	        CHILD: function (match) {
	          match[1] = match[1].toLowerCase();
	          if (match[1].slice(0, 3) === 'nth') {
	            if (!match[3]) {
	              Sizzle.error(match[0]);
	            }
	            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
	            match[5] = +(match[7] + match[8] || match[3] === 'odd');
	          } else if (match[3]) {
	            Sizzle.error(match[0]);
	          }
	          return match;
	        },
	        PSEUDO: function (match) {
	          var excess, unquoted = !match[6] && match[2];
	          if (matchExpr.CHILD.test(match[0])) {
	            return null;
	          }
	          if (match[3]) {
	            match[2] = match[4] || match[5] || '';
	          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
	            match[0] = match[0].slice(0, excess);
	            match[2] = unquoted.slice(0, excess);
	          }
	          return match.slice(0, 3);
	        }
	      },
	      filter: {
	        TAG: function (nodeNameSelector) {
	          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
	          return nodeNameSelector === '*' ? function () {
	            return true;
	          } : function (elem) {
	            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	          };
	        },
	        CLASS: function (className) {
	          var pattern = classCache[className + ' '];
	          return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
	            return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
	          });
	        },
	        ATTR: function (name, operator, check) {
	          return function (elem) {
	            var result = Sizzle.attr(elem, name);
	            if (result == null) {
	              return operator === '!=';
	            }
	            if (!operator) {
	              return true;
	            }
	            result += '';
	            return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
	          };
	        },
	        CHILD: function (type, what, argument, first, last) {
	          var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
	          return first === 1 && last === 0 ? function (elem) {
	            return !!elem.parentNode;
	          } : function (elem, context, xml) {
	            var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
	            if (parent) {
	              if (simple) {
	                while (dir) {
	                  node = elem;
	                  while (node = node[dir]) {
	                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	                      return false;
	                    }
	                  }
	                  start = dir = type === 'only' && !start && 'nextSibling';
	                }
	                return true;
	              }
	              start = [forward ? parent.firstChild : parent.lastChild];
	              if (forward && useCache) {
	                outerCache = parent[expando] || (parent[expando] = {});
	                cache = outerCache[type] || [];
	                nodeIndex = cache[0] === dirruns && cache[1];
	                diff = cache[0] === dirruns && cache[2];
	                node = nodeIndex && parent.childNodes[nodeIndex];
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if (node.nodeType === 1 && ++diff && node === elem) {
	                    outerCache[type] = [
	                      dirruns,
	                      nodeIndex,
	                      diff
	                    ];
	                    break;
	                  }
	                }
	              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
	                diff = cache[1];
	              } else {
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	                    if (useCache) {
	                      (node[expando] || (node[expando] = {}))[type] = [
	                        dirruns,
	                        diff
	                      ];
	                    }
	                    if (node === elem) {
	                      break;
	                    }
	                  }
	                }
	              }
	              diff -= last;
	              return diff === first || diff % first === 0 && diff / first >= 0;
	            }
	          };
	        },
	        PSEUDO: function (pseudo, argument) {
	          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
	          if (fn[expando]) {
	            return fn(argument);
	          }
	          if (fn.length > 1) {
	            args = [
	              pseudo,
	              pseudo,
	              '',
	              argument
	            ];
	            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
	              var idx, matched = fn(seed, argument), i = matched.length;
	              while (i--) {
	                idx = indexOf$1.call(seed, matched[i]);
	                seed[idx] = !(matches[idx] = matched[i]);
	              }
	            }) : function (elem) {
	              return fn(elem, 0, args);
	            };
	          }
	          return fn;
	        }
	      },
	      pseudos: {
	        not: markFunction(function (selector) {
	          var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
	          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
	            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
	            while (i--) {
	              if (elem = unmatched[i]) {
	                seed[i] = !(matches[i] = elem);
	              }
	            }
	          }) : function (elem, context, xml) {
	            input[0] = elem;
	            matcher(input, null, xml, results);
	            return !results.pop();
	          };
	        }),
	        has: markFunction(function (selector) {
	          return function (elem) {
	            return Sizzle(selector, elem).length > 0;
	          };
	        }),
	        contains: markFunction(function (text) {
	          text = text.replace(runescape, funescape);
	          return function (elem) {
	            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
	          };
	        }),
	        lang: markFunction(function (lang) {
	          if (!ridentifier.test(lang || '')) {
	            Sizzle.error('unsupported lang: ' + lang);
	          }
	          lang = lang.replace(runescape, funescape).toLowerCase();
	          return function (elem) {
	            var elemLang;
	            do {
	              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
	                elemLang = elemLang.toLowerCase();
	                return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
	              }
	            } while ((elem = elem.parentNode) && elem.nodeType === 1);
	            return false;
	          };
	        }),
	        target: function (elem) {
	          var hash = domGlobals.window.location && domGlobals.window.location.hash;
	          return hash && hash.slice(1) === elem.id;
	        },
	        root: function (elem) {
	          return elem === docElem;
	        },
	        focus: function (elem) {
	          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	        },
	        enabled: function (elem) {
	          return elem.disabled === false;
	        },
	        disabled: function (elem) {
	          return elem.disabled === true;
	        },
	        checked: function (elem) {
	          var nodeName = elem.nodeName.toLowerCase();
	          return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
	        },
	        selected: function (elem) {
	          if (elem.parentNode) {
	            elem.parentNode.selectedIndex;
	          }
	          return elem.selected === true;
	        },
	        empty: function (elem) {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            if (elem.nodeType < 6) {
	              return false;
	            }
	          }
	          return true;
	        },
	        parent: function (elem) {
	          return !Expr.pseudos.empty(elem);
	        },
	        header: function (elem) {
	          return rheader.test(elem.nodeName);
	        },
	        input: function (elem) {
	          return rinputs.test(elem.nodeName);
	        },
	        button: function (elem) {
	          var name = elem.nodeName.toLowerCase();
	          return name === 'input' && elem.type === 'button' || name === 'button';
	        },
	        text: function (elem) {
	          var attr;
	          return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
	        },
	        first: createPositionalPseudo(function () {
	          return [0];
	        }),
	        last: createPositionalPseudo(function (matchIndexes, length) {
	          return [length - 1];
	        }),
	        eq: createPositionalPseudo(function (matchIndexes, length, argument) {
	          return [argument < 0 ? argument + length : argument];
	        }),
	        even: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 0;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        odd: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 1;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; --i >= 0;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; ++i < length;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        })
	      }
	    };
	    Expr.pseudos.nth = Expr.pseudos.eq;
	    for (i in {
	        radio: true,
	        checkbox: true,
	        file: true,
	        password: true,
	        image: true
	      }) {
	      Expr.pseudos[i] = createInputPseudo(i);
	    }
	    for (i in {
	        submit: true,
	        reset: true
	      }) {
	      Expr.pseudos[i] = createButtonPseudo(i);
	    }
	    function setFilters() {
	    }
	    setFilters.prototype = Expr.filters = Expr.pseudos;
	    Expr.setFilters = new setFilters();
	    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
	      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
	      if (cached) {
	        return parseOnly ? 0 : cached.slice(0);
	      }
	      soFar = selector;
	      groups = [];
	      preFilters = Expr.preFilter;
	      while (soFar) {
	        if (!matched || (match = rcomma.exec(soFar))) {
	          if (match) {
	            soFar = soFar.slice(match[0].length) || soFar;
	          }
	          groups.push(tokens = []);
	        }
	        matched = false;
	        if (match = rcombinators.exec(soFar)) {
	          matched = match.shift();
	          tokens.push({
	            value: matched,
	            type: match[0].replace(rtrim, ' ')
	          });
	          soFar = soFar.slice(matched.length);
	        }
	        for (type in Expr.filter) {
	          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
	            matched = match.shift();
	            tokens.push({
	              value: matched,
	              type: type,
	              matches: match
	            });
	            soFar = soFar.slice(matched.length);
	          }
	        }
	        if (!matched) {
	          break;
	        }
	      }
	      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
	    };
	    function toSelector(tokens) {
	      var i = 0, len = tokens.length, selector = '';
	      for (; i < len; i++) {
	        selector += tokens[i].value;
	      }
	      return selector;
	    }
	    function addCombinator(matcher, combinator, base) {
	      var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
	      return combinator.first ? function (elem, context, xml) {
	        while (elem = elem[dir]) {
	          if (elem.nodeType === 1 || checkNonElements) {
	            return matcher(elem, context, xml);
	          }
	        }
	      } : function (elem, context, xml) {
	        var oldCache, outerCache, newCache = [
	            dirruns,
	            doneName
	          ];
	        if (xml) {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              if (matcher(elem, context, xml)) {
	                return true;
	              }
	            }
	          }
	        } else {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              outerCache = elem[expando] || (elem[expando] = {});
	              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	                return newCache[2] = oldCache[2];
	              } else {
	                outerCache[dir] = newCache;
	                if (newCache[2] = matcher(elem, context, xml)) {
	                  return true;
	                }
	              }
	            }
	          }
	        }
	      };
	    }
	    function elementMatcher(matchers) {
	      return matchers.length > 1 ? function (elem, context, xml) {
	        var i = matchers.length;
	        while (i--) {
	          if (!matchers[i](elem, context, xml)) {
	            return false;
	          }
	        }
	        return true;
	      } : matchers[0];
	    }
	    function multipleContexts(selector, contexts, results) {
	      var i = 0, len = contexts.length;
	      for (; i < len; i++) {
	        Sizzle(selector, contexts[i], results);
	      }
	      return results;
	    }
	    function condense(unmatched, map, filter, context, xml) {
	      var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
	      for (; i < len; i++) {
	        if (elem = unmatched[i]) {
	          if (!filter || filter(elem, context, xml)) {
	            newUnmatched.push(elem);
	            if (mapped) {
	              map.push(i);
	            }
	          }
	        }
	      }
	      return newUnmatched;
	    }
	    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
	      if (postFilter && !postFilter[expando]) {
	        postFilter = setMatcher(postFilter);
	      }
	      if (postFinder && !postFinder[expando]) {
	        postFinder = setMatcher(postFinder, postSelector);
	      }
	      return markFunction(function (seed, results, context, xml) {
	        var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
	        if (matcher) {
	          matcher(matcherIn, matcherOut, context, xml);
	        }
	        if (postFilter) {
	          temp = condense(matcherOut, postMap);
	          postFilter(temp, [], context, xml);
	          i = temp.length;
	          while (i--) {
	            if (elem = temp[i]) {
	              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
	            }
	          }
	        }
	        if (seed) {
	          if (postFinder || preFilter) {
	            if (postFinder) {
	              temp = [];
	              i = matcherOut.length;
	              while (i--) {
	                if (elem = matcherOut[i]) {
	                  temp.push(matcherIn[i] = elem);
	                }
	              }
	              postFinder(null, matcherOut = [], temp, xml);
	            }
	            i = matcherOut.length;
	            while (i--) {
	              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf$1.call(seed, elem) : preMap[i]) > -1) {
	                seed[temp] = !(results[temp] = elem);
	              }
	            }
	          }
	        } else {
	          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
	          if (postFinder) {
	            postFinder(null, results, matcherOut, xml);
	          } else {
	            push.apply(results, matcherOut);
	          }
	        }
	      });
	    }
	    function matcherFromTokens(tokens) {
	      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
	          return elem === checkContext;
	        }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
	          return indexOf$1.call(checkContext, elem) > -1;
	        }, implicitRelative, true), matchers = [function (elem, context, xml) {
	            return !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
	          }];
	      for (; i < len; i++) {
	        if (matcher = Expr.relative[tokens[i].type]) {
	          matchers = [addCombinator(elementMatcher(matchers), matcher)];
	        } else {
	          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	          if (matcher[expando]) {
	            j = ++i;
	            for (; j < len; j++) {
	              if (Expr.relative[tokens[j].type]) {
	                break;
	              }
	            }
	            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
	          }
	          matchers.push(matcher);
	        }
	      }
	      return elementMatcher(matchers);
	    }
	    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
	      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
	          var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
	          if (outermost) {
	            outermostContext = context !== document && context;
	          }
	          for (; i !== len && (elem = elems[i]) != null; i++) {
	            if (byElement && elem) {
	              j = 0;
	              while (matcher = elementMatchers[j++]) {
	                if (matcher(elem, context, xml)) {
	                  results.push(elem);
	                  break;
	                }
	              }
	              if (outermost) {
	                dirruns = dirrunsUnique;
	              }
	            }
	            if (bySet) {
	              if (elem = !matcher && elem) {
	                matchedCount--;
	              }
	              if (seed) {
	                unmatched.push(elem);
	              }
	            }
	          }
	          matchedCount += i;
	          if (bySet && i !== matchedCount) {
	            j = 0;
	            while (matcher = setMatchers[j++]) {
	              matcher(unmatched, setMatched, context, xml);
	            }
	            if (seed) {
	              if (matchedCount > 0) {
	                while (i--) {
	                  if (!(unmatched[i] || setMatched[i])) {
	                    setMatched[i] = pop.call(results);
	                  }
	                }
	              }
	              setMatched = condense(setMatched);
	            }
	            push.apply(results, setMatched);
	            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	              Sizzle.uniqueSort(results);
	            }
	          }
	          if (outermost) {
	            dirruns = dirrunsUnique;
	            outermostContext = contextBackup;
	          }
	          return unmatched;
	        };
	      return bySet ? markFunction(superMatcher) : superMatcher;
	    }
	    compile = Sizzle.compile = function (selector, match) {
	      var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
	      if (!cached) {
	        if (!match) {
	          match = tokenize(selector);
	        }
	        i = match.length;
	        while (i--) {
	          cached = matcherFromTokens(match[i]);
	          if (cached[expando]) {
	            setMatchers.push(cached);
	          } else {
	            elementMatchers.push(cached);
	          }
	        }
	        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	        cached.selector = selector;
	      }
	      return cached;
	    };
	    select = Sizzle.select = function (selector, context, results, seed) {
	      var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
	      results = results || [];
	      if (match.length === 1) {
	        tokens = match[0] = match[0].slice(0);
	        if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
	          if (!context) {
	            return results;
	          } else if (compiled) {
	            context = context.parentNode;
	          }
	          selector = selector.slice(tokens.shift().value.length);
	        }
	        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
	        while (i--) {
	          token = tokens[i];
	          if (Expr.relative[type = token.type]) {
	            break;
	          }
	          if (find = Expr.find[type]) {
	            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	              tokens.splice(i, 1);
	              selector = seed.length && toSelector(tokens);
	              if (!selector) {
	                push.apply(results, seed);
	                return results;
	              }
	              break;
	            }
	          }
	        }
	      }
	      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
	      return results;
	    };
	    support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
	    support.detectDuplicates = !!hasDuplicate;
	    setDocument();
	    support.sortDetached = true;
	
	    var isArray$1 = Array.isArray;
	    var toArray = function (obj) {
	      var array = obj, i, l;
	      if (!isArray$1(obj)) {
	        array = [];
	        for (i = 0, l = obj.length; i < l; i++) {
	          array[i] = obj[i];
	        }
	      }
	      return array;
	    };
	    var each$1 = function (o, cb, s) {
	      var n, l;
	      if (!o) {
	        return 0;
	      }
	      s = s || o;
	      if (o.length !== undefined) {
	        for (n = 0, l = o.length; n < l; n++) {
	          if (cb.call(s, o[n], n, o) === false) {
	            return 0;
	          }
	        }
	      } else {
	        for (n in o) {
	          if (o.hasOwnProperty(n)) {
	            if (cb.call(s, o[n], n, o) === false) {
	              return 0;
	            }
	          }
	        }
	      }
	      return 1;
	    };
	    var map$1 = function (array, callback) {
	      var out = [];
	      each$1(array, function (item, index) {
	        out.push(callback(item, index, array));
	      });
	      return out;
	    };
	    var filter$1 = function (a, f) {
	      var o = [];
	      each$1(a, function (v, index) {
	        if (!f || f(v, index, a)) {
	          o.push(v);
	        }
	      });
	      return o;
	    };
	    var indexOf$2 = function (a, v) {
	      var i, l;
	      if (a) {
	        for (i = 0, l = a.length; i < l; i++) {
	          if (a[i] === v) {
	            return i;
	          }
	        }
	      }
	      return -1;
	    };
	    var reduce = function (collection, iteratee, accumulator, thisArg) {
	      var i = 0;
	      if (arguments.length < 3) {
	        accumulator = collection[0];
	      }
	      for (; i < collection.length; i++) {
	        accumulator = iteratee.call(thisArg, accumulator, collection[i], i);
	      }
	      return accumulator;
	    };
	    var findIndex$1 = function (array, predicate, thisArg) {
	      var i, l;
	      for (i = 0, l = array.length; i < l; i++) {
	        if (predicate.call(thisArg, array[i], i, array)) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var find$1 = function (array, predicate, thisArg) {
	      var idx = findIndex$1(array, predicate, thisArg);
	      if (idx !== -1) {
	        return array[idx];
	      }
	      return undefined;
	    };
	    var last$1 = function (collection) {
	      return collection[collection.length - 1];
	    };
	    var ArrUtils = {
	      isArray: isArray$1,
	      toArray: toArray,
	      each: each$1,
	      map: map$1,
	      filter: filter$1,
	      indexOf: indexOf$2,
	      reduce: reduce,
	      findIndex: findIndex$1,
	      find: find$1,
	      last: last$1
	    };
	
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	    var trim = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
	    };
	    var is = function (obj, type) {
	      if (!type) {
	        return obj !== undefined;
	      }
	      if (type === 'array' && ArrUtils.isArray(obj)) {
	        return true;
	      }
	      return typeof obj === type;
	    };
	    var makeMap = function (items, delim, map) {
	      var i;
	      items = items || [];
	      delim = delim || ',';
	      if (typeof items === 'string') {
	        items = items.split(delim);
	      }
	      map = map || {};
	      i = items.length;
	      while (i--) {
	        map[items[i]] = {};
	      }
	      return map;
	    };
	    var hasOwnProperty = function (obj, prop) {
	      return Object.prototype.hasOwnProperty.call(obj, prop);
	    };
	    var create = function (s, p, root) {
	      var self = this;
	      var sp, ns, cn, scn, c, de = 0;
	      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
	      cn = s[3].match(/(^|\.)(\w+)$/i)[2];
	      ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	      if (ns[cn]) {
	        return;
	      }
	      if (s[2] === 'static') {
	        ns[cn] = p;
	        if (this.onCreate) {
	          this.onCreate(s[2], s[3], ns[cn]);
	        }
	        return;
	      }
	      if (!p[cn]) {
	        p[cn] = function () {
	        };
	        de = 1;
	      }
	      ns[cn] = p[cn];
	      self.extend(ns[cn].prototype, p);
	      if (s[5]) {
	        sp = self.resolve(s[5]).prototype;
	        scn = s[5].match(/\.(\w+)$/i)[1];
	        c = ns[cn];
	        if (de) {
	          ns[cn] = function () {
	            return sp[scn].apply(this, arguments);
	          };
	        } else {
	          ns[cn] = function () {
	            this.parent = sp[scn];
	            return c.apply(this, arguments);
	          };
	        }
	        ns[cn].prototype[cn] = ns[cn];
	        self.each(sp, function (f, n) {
	          ns[cn].prototype[n] = sp[n];
	        });
	        self.each(p, function (f, n) {
	          if (sp[n]) {
	            ns[cn].prototype[n] = function () {
	              this.parent = sp[n];
	              return f.apply(this, arguments);
	            };
	          } else {
	            if (n !== cn) {
	              ns[cn].prototype[n] = f;
	            }
	          }
	        });
	      }
	      self.each(p.static, function (f, n) {
	        ns[cn][n] = f;
	      });
	    };
	    var extend = function (obj, ext) {
	      var x = [];
	      for (var _i = 2; _i < arguments.length; _i++) {
	        x[_i - 2] = arguments[_i];
	      }
	      var i, l, name;
	      var args = arguments;
	      var value;
	      for (i = 1, l = args.length; i < l; i++) {
	        ext = args[i];
	        for (name in ext) {
	          if (ext.hasOwnProperty(name)) {
	            value = ext[name];
	            if (value !== undefined) {
	              obj[name] = value;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var walk = function (o, f, n, s) {
	      s = s || this;
	      if (o) {
	        if (n) {
	          o = o[n];
	        }
	        ArrUtils.each(o, function (o, i) {
	          if (f.call(s, o, i, n) === false) {
	            return false;
	          }
	          walk(o, f, n, s);
	        });
	      }
	    };
	    var createNS = function (n, o) {
	      var i, v;
	      o = o || domGlobals.window;
	      n = n.split('.');
	      for (i = 0; i < n.length; i++) {
	        v = n[i];
	        if (!o[v]) {
	          o[v] = {};
	        }
	        o = o[v];
	      }
	      return o;
	    };
	    var resolve$1 = function (n, o) {
	      var i, l;
	      o = o || domGlobals.window;
	      n = n.split('.');
	      for (i = 0, l = n.length; i < l; i++) {
	        o = o[n[i]];
	        if (!o) {
	          break;
	        }
	      }
	      return o;
	    };
	    var explode = function (s, d) {
	      if (!s || is(s, 'array')) {
	        return s;
	      }
	      return ArrUtils.map(s.split(d || ','), trim);
	    };
	    var _addCacheSuffix = function (url) {
	      var cacheSuffix = Env.cacheSuffix;
	      if (cacheSuffix) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
	      }
	      return url;
	    };
	    var Tools = {
	      trim: trim,
	      isArray: ArrUtils.isArray,
	      is: is,
	      toArray: ArrUtils.toArray,
	      makeMap: makeMap,
	      each: ArrUtils.each,
	      map: ArrUtils.map,
	      grep: ArrUtils.filter,
	      inArray: ArrUtils.indexOf,
	      hasOwn: hasOwnProperty,
	      extend: extend,
	      create: create,
	      walk: walk,
	      createNS: createNS,
	      resolve: resolve$1,
	      explode: explode,
	      _addCacheSuffix: _addCacheSuffix
	    };
	
	    var doc = domGlobals.document, push$1 = Array.prototype.push, slice$1 = Array.prototype.slice;
	    var rquickExpr$1 = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	    var Event = EventUtils.Event;
	    var skipUniques = Tools.makeMap('children,contents,next,prev');
	    var isDefined = function (obj) {
	      return typeof obj !== 'undefined';
	    };
	    var isString$1 = function (obj) {
	      return typeof obj === 'string';
	    };
	    var isWindow = function (obj) {
	      return obj && obj === obj.window;
	    };
	    var createFragment = function (html, fragDoc) {
	      var frag, node, container;
	      fragDoc = fragDoc || doc;
	      container = fragDoc.createElement('div');
	      frag = fragDoc.createDocumentFragment();
	      container.innerHTML = html;
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
	      var i;
	      if (isString$1(sourceItem)) {
	        sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
	      } else if (sourceItem.length && !sourceItem.nodeType) {
	        sourceItem = DomQuery.makeArray(sourceItem);
	        if (reverse) {
	          for (i = sourceItem.length - 1; i >= 0; i--) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        } else {
	          for (i = 0; i < sourceItem.length; i++) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        }
	        return targetNodes;
	      }
	      if (sourceItem.nodeType) {
	        i = targetNodes.length;
	        while (i--) {
	          callback.call(targetNodes[i], sourceItem);
	        }
	      }
	      return targetNodes;
	    };
	    var hasClass = function (node, className) {
	      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    };
	    var wrap = function (elements, wrapper, all) {
	      var lastParent, newWrapper;
	      wrapper = DomQuery(wrapper)[0];
	      elements.each(function () {
	        var self = this;
	        if (!all || lastParent !== self.parentNode) {
	          lastParent = self.parentNode;
	          newWrapper = wrapper.cloneNode(false);
	          self.parentNode.insertBefore(newWrapper, self);
	          newWrapper.appendChild(self);
	        } else {
	          newWrapper.appendChild(self);
	        }
	      });
	      return elements;
	    };
	    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
	    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
	    var propFix = {
	      for: 'htmlFor',
	      class: 'className',
	      readonly: 'readOnly'
	    };
	    var cssFix = { float: 'cssFloat' };
	    var attrHooks = {}, cssHooks = {};
	    var DomQuery = function (selector, context) {
	      return new DomQuery.fn.init(selector, context);
	    };
	    var inArray = function (item, array) {
	      var i;
	      if (array.indexOf) {
	        return array.indexOf(item);
	      }
	      i = array.length;
	      while (i--) {
	        if (array[i] === item) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var whiteSpaceRegExp$1 = /^\s*|\s*$/g;
	    var trim$1 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$1, '');
	    };
	    var each$2 = function (obj, callback) {
	      var length, key, i, value;
	      if (obj) {
	        length = obj.length;
	        if (length === undefined) {
	          for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	              value = obj[key];
	              if (callback.call(value, key, value) === false) {
	                break;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < length; i++) {
	            value = obj[i];
	            if (callback.call(value, i, value) === false) {
	              break;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var grep = function (array, callback) {
	      var out = [];
	      each$2(array, function (i, item) {
	        if (callback(item, i)) {
	          out.push(item);
	        }
	      });
	      return out;
	    };
	    var getElementDocument = function (element) {
	      if (!element) {
	        return doc;
	      }
	      if (element.nodeType === 9) {
	        return element;
	      }
	      return element.ownerDocument;
	    };
	    DomQuery.fn = DomQuery.prototype = {
	      constructor: DomQuery,
	      selector: '',
	      context: null,
	      length: 0,
	      init: function (selector, context) {
	        var self = this;
	        var match, node;
	        if (!selector) {
	          return self;
	        }
	        if (selector.nodeType) {
	          self.context = self[0] = selector;
	          self.length = 1;
	          return self;
	        }
	        if (context && context.nodeType) {
	          self.context = context;
	        } else {
	          if (context) {
	            return DomQuery(selector).attr(context);
	          }
	          self.context = context = domGlobals.document;
	        }
	        if (isString$1(selector)) {
	          self.selector = selector;
	          if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
	            match = [
	              null,
	              selector,
	              null
	            ];
	          } else {
	            match = rquickExpr$1.exec(selector);
	          }
	          if (match) {
	            if (match[1]) {
	              node = createFragment(selector, getElementDocument(context)).firstChild;
	              while (node) {
	                push$1.call(self, node);
	                node = node.nextSibling;
	              }
	            } else {
	              node = getElementDocument(context).getElementById(match[2]);
	              if (!node) {
	                return self;
	              }
	              if (node.id !== match[2]) {
	                return self.find(selector);
	              }
	              self.length = 1;
	              self[0] = node;
	            }
	          } else {
	            return DomQuery(context).find(selector);
	          }
	        } else {
	          this.add(selector, false);
	        }
	        return self;
	      },
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	      add: function (items, sort) {
	        var self = this;
	        var nodes, i;
	        if (isString$1(items)) {
	          return self.add(DomQuery(items));
	        }
	        if (sort !== false) {
	          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
	          self.length = nodes.length;
	          for (i = 0; i < nodes.length; i++) {
	            self[i] = nodes[i];
	          }
	        } else {
	          push$1.apply(self, DomQuery.makeArray(items));
	        }
	        return self;
	      },
	      attr: function (name, value) {
	        var self = this;
	        var hook;
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.attr(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            var hook;
	            if (this.nodeType === 1) {
	              hook = attrHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              if (value === null) {
	                this.removeAttribute(name, 2);
	              } else {
	                this.setAttribute(name, value, 2);
	              }
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType === 1) {
	            hook = attrHooks[name];
	            if (hook && hook.get) {
	              return hook.get(self[0], name);
	            }
	            if (booleanMap[name]) {
	              return self.prop(name) ? name : undefined;
	            }
	            value = self[0].getAttribute(name, 2);
	            if (value === null) {
	              value = undefined;
	            }
	          }
	          return value;
	        }
	        return self;
	      },
	      removeAttr: function (name) {
	        return this.attr(name, null);
	      },
	      prop: function (name, value) {
	        var self = this;
	        name = propFix[name] || name;
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.prop(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            if (this.nodeType === 1) {
	              this[name] = value;
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType && name in self[0]) {
	            return self[0][name];
	          }
	          return value;
	        }
	        return self;
	      },
	      css: function (name, value) {
	        var self = this;
	        var elm, hook;
	        var camel = function (name) {
	          return name.replace(/-(\D)/g, function (a, b) {
	            return b.toUpperCase();
	          });
	        };
	        var dashed = function (name) {
	          return name.replace(/[A-Z]/g, function (a) {
	            return '-' + a;
	          });
	        };
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.css(name, value);
	          });
	        } else {
	          if (isDefined(value)) {
	            name = camel(name);
	            if (typeof value === 'number' && !numericCssMap[name]) {
	              value = value.toString() + 'px';
	            }
	            self.each(function () {
	              var style = this.style;
	              hook = cssHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              try {
	                this.style[cssFix[name] || name] = value;
	              } catch (ex) {
	              }
	              if (value === null || value === '') {
	                if (style.removeProperty) {
	                  style.removeProperty(dashed(name));
	                } else {
	                  style.removeAttribute(name);
	                }
	              }
	            });
	          } else {
	            elm = self[0];
	            hook = cssHooks[name];
	            if (hook && hook.get) {
	              return hook.get(elm);
	            }
	            if (elm.ownerDocument.defaultView) {
	              try {
	                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
	              } catch (ex) {
	                return undefined;
	              }
	            } else if (elm.currentStyle) {
	              return elm.currentStyle[camel(name)];
	            } else {
	              return '';
	            }
	          }
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          Event.clean(node);
	          if (node.parentNode) {
	            node.parentNode.removeChild(node);
	          }
	        }
	        return this;
	      },
	      empty: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          while (node.firstChild) {
	            node.removeChild(node.firstChild);
	          }
	        }
	        return this;
	      },
	      html: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          try {
	            while (i--) {
	              self[i].innerHTML = value;
	            }
	          } catch (ex) {
	            DomQuery(self[i]).empty().append(value);
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerHTML : '';
	      },
	      text: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          while (i--) {
	            if ('innerText' in self[i]) {
	              self[i].innerText = value;
	            } else {
	              self[0].textContent = value;
	            }
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerText || self[0].textContent : '';
	      },
	      append: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.appendChild(node);
	          }
	        });
	      },
	      prepend: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.insertBefore(node, this.firstChild);
	          }
	        }, true);
	      },
	      before: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this);
	          });
	        }
	        return self;
	      },
	      after: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this.nextSibling);
	          }, true);
	        }
	        return self;
	      },
	      appendTo: function (val) {
	        DomQuery(val).append(this);
	        return this;
	      },
	      prependTo: function (val) {
	        DomQuery(val).prepend(this);
	        return this;
	      },
	      replaceWith: function (content) {
	        return this.before(content).remove();
	      },
	      wrap: function (content) {
	        return wrap(this, content);
	      },
	      wrapAll: function (content) {
	        return wrap(this, content, true);
	      },
	      wrapInner: function (content) {
	        this.each(function () {
	          DomQuery(this).contents().wrapAll(content);
	        });
	        return this;
	      },
	      unwrap: function () {
	        return this.parent().each(function () {
	          DomQuery(this).replaceWith(this.childNodes);
	        });
	      },
	      clone: function () {
	        var result = [];
	        this.each(function () {
	          result.push(this.cloneNode(true));
	        });
	        return DomQuery(result);
	      },
	      addClass: function (className) {
	        return this.toggleClass(className, true);
	      },
	      removeClass: function (className) {
	        return this.toggleClass(className, false);
	      },
	      toggleClass: function (className, state) {
	        var self = this;
	        if (typeof className !== 'string') {
	          return self;
	        }
	        if (className.indexOf(' ') !== -1) {
	          each$2(className.split(' '), function () {
	            self.toggleClass(this, state);
	          });
	        } else {
	          self.each(function (index, node) {
	            var existingClassName, classState;
	            classState = hasClass(node, className);
	            if (classState !== state) {
	              existingClassName = node.className;
	              if (classState) {
	                node.className = trim$1((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
	              } else {
	                node.className += existingClassName ? ' ' + className : className;
	              }
	            }
	          });
	        }
	        return self;
	      },
	      hasClass: function (className) {
	        return hasClass(this[0], className);
	      },
	      each: function (callback) {
	        return each$2(this, callback);
	      },
	      on: function (name, callback) {
	        return this.each(function () {
	          Event.bind(this, name, callback);
	        });
	      },
	      off: function (name, callback) {
	        return this.each(function () {
	          Event.unbind(this, name, callback);
	        });
	      },
	      trigger: function (name) {
	        return this.each(function () {
	          if (typeof name === 'object') {
	            Event.fire(this, name.type, name);
	          } else {
	            Event.fire(this, name);
	          }
	        });
	      },
	      show: function () {
	        return this.css('display', '');
	      },
	      hide: function () {
	        return this.css('display', 'none');
	      },
	      slice: function () {
	        return new DomQuery(slice$1.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      first: function () {
	        return this.eq(0);
	      },
	      last: function () {
	        return this.eq(-1);
	      },
	      find: function (selector) {
	        var i, l;
	        var ret = [];
	        for (i = 0, l = this.length; i < l; i++) {
	          DomQuery.find(selector, this[i], ret);
	        }
	        return DomQuery(ret);
	      },
	      filter: function (selector) {
	        if (typeof selector === 'function') {
	          return DomQuery(grep(this.toArray(), function (item, i) {
	            return selector(i, item);
	          }));
	        }
	        return DomQuery(DomQuery.filter(selector, this.toArray()));
	      },
	      closest: function (selector) {
	        var result = [];
	        if (selector instanceof DomQuery) {
	          selector = selector[0];
	        }
	        this.each(function (i, node) {
	          while (node) {
	            if (typeof selector === 'string' && DomQuery(node).is(selector)) {
	              result.push(node);
	              break;
	            } else if (node === selector) {
	              result.push(node);
	              break;
	            }
	            node = node.parentNode;
	          }
	        });
	        return DomQuery(result);
	      },
	      offset: function (offset) {
	        var elm, doc, docElm;
	        var x = 0, y = 0, pos;
	        if (!offset) {
	          elm = this[0];
	          if (elm) {
	            doc = elm.ownerDocument;
	            docElm = doc.documentElement;
	            if (elm.getBoundingClientRect) {
	              pos = elm.getBoundingClientRect();
	              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
	              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
	            }
	          }
	          return {
	            left: x,
	            top: y
	          };
	        }
	        return this.css(offset);
	      },
	      push: push$1,
	      sort: [].sort,
	      splice: [].splice
	    };
	    Tools.extend(DomQuery, {
	      extend: Tools.extend,
	      makeArray: function (object) {
	        if (isWindow(object) || object.nodeType) {
	          return [object];
	        }
	        return Tools.toArray(object);
	      },
	      inArray: inArray,
	      isArray: Tools.isArray,
	      each: each$2,
	      trim: trim$1,
	      grep: grep,
	      find: Sizzle,
	      expr: Sizzle.selectors,
	      unique: Sizzle.uniqueSort,
	      text: Sizzle.getText,
	      contains: Sizzle.contains,
	      filter: function (expr, elems, not) {
	        var i = elems.length;
	        if (not) {
	          expr = ':not(' + expr + ')';
	        }
	        while (i--) {
	          if (elems[i].nodeType !== 1) {
	            elems.splice(i, 1);
	          }
	        }
	        if (elems.length === 1) {
	          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
	        } else {
	          elems = DomQuery.find.matches(expr, elems);
	        }
	        return elems;
	      }
	    });
	    var dir = function (el, prop, until) {
	      var matched = [];
	      var cur = el[prop];
	      if (typeof until !== 'string' && until instanceof DomQuery) {
	        until = until[0];
	      }
	      while (cur && cur.nodeType !== 9) {
	        if (until !== undefined) {
	          if (cur === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(cur).is(until)) {
	            break;
	          }
	        }
	        if (cur.nodeType === 1) {
	          matched.push(cur);
	        }
	        cur = cur[prop];
	      }
	      return matched;
	    };
	    var sibling = function (node, siblingName, nodeType, until) {
	      var result = [];
	      if (until instanceof DomQuery) {
	        until = until[0];
	      }
	      for (; node; node = node[siblingName]) {
	        if (nodeType && node.nodeType !== nodeType) {
	          continue;
	        }
	        if (until !== undefined) {
	          if (node === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(node).is(until)) {
	            break;
	          }
	        }
	        result.push(node);
	      }
	      return result;
	    };
	    var firstSibling = function (node, siblingName, nodeType) {
	      for (node = node[siblingName]; node; node = node[siblingName]) {
	        if (node.nodeType === nodeType) {
	          return node;
	        }
	      }
	      return null;
	    };
	    each$2({
	      parent: function (node) {
	        var parent = node.parentNode;
	        return parent && parent.nodeType !== 11 ? parent : null;
	      },
	      parents: function (node) {
	        return dir(node, 'parentNode');
	      },
	      next: function (node) {
	        return firstSibling(node, 'nextSibling', 1);
	      },
	      prev: function (node) {
	        return firstSibling(node, 'previousSibling', 1);
	      },
	      children: function (node) {
	        return sibling(node.firstChild, 'nextSibling', 1);
	      },
	      contents: function (node) {
	        return Tools.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          if (!skipUniques[name]) {
	            result = DomQuery.unique(result);
	          }
	          if (name.indexOf('parents') === 0) {
	            result = result.reverse();
	          }
	        }
	        result = DomQuery(result);
	        if (selector) {
	          return result.filter(selector);
	        }
	        return result;
	      };
	    });
	    each$2({
	      parentsUntil: function (node, until) {
	        return dir(node, 'parentNode', until);
	      },
	      nextUntil: function (node, until) {
	        return sibling(node, 'nextSibling', 1, until).slice(1);
	      },
	      prevUntil: function (node, until) {
	        return sibling(node, 'previousSibling', 1, until).slice(1);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector, filter) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          result = DomQuery.unique(result);
	          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
	            result = result.reverse();
	          }
	        }
	        result = DomQuery(result);
	        if (filter) {
	          return result.filter(filter);
	        }
	        return result;
	      };
	    });
	    DomQuery.fn.is = function (selector) {
	      return !!selector && this.filter(selector).length > 0;
	    };
	    DomQuery.fn.init.prototype = DomQuery.fn;
	    DomQuery.overrideDefaults = function (callback) {
	      var defaults;
	      var sub = function (selector, context) {
	        defaults = defaults || callback();
	        if (arguments.length === 0) {
	          selector = defaults.element;
	        }
	        if (!context) {
	          context = defaults.context;
	        }
	        return new sub.fn.init(selector, context);
	      };
	      DomQuery.extend(sub, this);
	      return sub;
	    };
	    var appendHooks = function (targetHooks, prop, hooks) {
	      each$2(hooks, function (name, func) {
	        targetHooks[name] = targetHooks[name] || {};
	        targetHooks[name][prop] = func;
	      });
	    };
	    if (Env.ie && Env.ie < 8) {
	      appendHooks(attrHooks, 'get', {
	        maxlength: function (elm) {
	          var value = elm.maxLength;
	          if (value === 2147483647) {
	            return undefined;
	          }
	          return value;
	        },
	        size: function (elm) {
	          var value = elm.size;
	          if (value === 20) {
	            return undefined;
	          }
	          return value;
	        },
	        class: function (elm) {
	          return elm.className;
	        },
	        style: function (elm) {
	          var value = elm.style.cssText;
	          if (value.length === 0) {
	            return undefined;
	          }
	          return value;
	        }
	      });
	      appendHooks(attrHooks, 'set', {
	        class: function (elm, value) {
	          elm.className = value;
	        },
	        style: function (elm, value) {
	          elm.style.cssText = value;
	        }
	      });
	    }
	    if (Env.ie && Env.ie < 9) {
	      cssFix.float = 'styleFloat';
	      appendHooks(cssHooks, 'set', {
	        opacity: function (elm, value) {
	          var style = elm.style;
	          if (value === null || value === '') {
	            style.removeAttribute('filter');
	          } else {
	            style.zoom = 1;
	            style.filter = 'alpha(opacity=' + value * 100 + ')';
	          }
	        }
	      });
	    }
	    DomQuery.attrHooks = attrHooks;
	    DomQuery.cssHooks = cssHooks;
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$2 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$2(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie$1 = 'IE';
	    var opera$1 = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie$1, current),
	        isOpera: isBrowser(opera$1, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie$1),
	      opera: constant(opera$1),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android$1 = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android$1, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android$1),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains$2 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var trim$2 = function (str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    };
	    var lTrim = function (str) {
	      return str.replace(/^\s+/g, '');
	    };
	    var rTrim = function (str) {
	      return str.replace(/\s+$/g, '');
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$2(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$2(uastring, 'edge/') && contains$2(uastring, 'chrome') && contains$2(uastring, 'safari') && contains$2(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'chrome') && !contains$2(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'msie') || contains$2(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$2(uastring, 'safari') || contains$2(uastring, 'mobile/')) && contains$2(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$2(uastring, 'iphone') || contains$2(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	
	    var keys = Object.keys;
	    var hasOwnProperty$1 = Object.hasOwnProperty;
	    var each$3 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$2 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$3(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      each$3(obj, function (x, i) {
	        var branch = pred(x, i) ? t : f;
	        branch[i] = x;
	      });
	      return {
	        t: t,
	        f: f
	      };
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty$1.call(obj, key);
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom().parentNode : element.dom();
	      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        domGlobals.console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom(), key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      each$3(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get = function (element, key) {
	      var v = element.dom().getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom();
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove = function (element, key) {
	      element.dom().removeAttribute(key);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        domGlobals.console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom();
	      each$3(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$1 = function (element, property) {
	      var dom = element.dom();
	      var styles = domGlobals.window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      var v = r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	      return v === null ? undefined : v;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom();
	      var raw = getUnsafeProperty(dom, property);
	      return Option.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom();
	      if (isSupported(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var toArray$1 = function (target, f) {
	      var r = [];
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	      return r;
	    };
	    var Recurse = { toArray: toArray$1 };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var ELEMENT$1 = ELEMENT;
	    var DOCUMENT$1 = DOCUMENT;
	    var is$1 = function (element, selector) {
	      var dom = element.dom();
	      if (dom.nodeType !== ELEMENT$1) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT$1 && dom.nodeType !== DOCUMENT$1 || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$3 = browser.isIE() ? ieContains : regularContains;
	
	    var owner = function (element) {
	      return Element.fromDom(element.dom().ownerDocument);
	    };
	    var documentElement = function (element) {
	      return Element.fromDom(element.dom().ownerDocument.documentElement);
	    };
	    var defaultView = function (element) {
	      return Element.fromDom(element.dom().ownerDocument.defaultView);
	    };
	    var parent = function (element) {
	      return Option.from(element.dom().parentNode).map(Element.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom();
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = Element.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var prevSibling = function (element) {
	      return Option.from(element.dom().previousSibling).map(Element.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Option.from(element.dom().nextSibling).map(Element.fromDom);
	    };
	    var prevSiblings = function (element) {
	      return reverse(Recurse.toArray(element, prevSibling));
	    };
	    var nextSiblings = function (element) {
	      return Recurse.toArray(element, nextSibling);
	    };
	    var children = function (element) {
	      return map(element.dom().childNodes, Element.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom().childNodes;
	      return Option.from(cs[index]).map(Element.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	    var childNodesCount = function (element) {
	      return element.dom().childNodes.length;
	    };
	    var spot = Immutable('element', 'offset');
	
	    var browser$1 = PlatformDetection$1.detect().browser;
	    var firstElement = function (nodes) {
	      return find(nodes, isElement);
	    };
	    var getTableCaptionDeltaY = function (elm) {
	      if (browser$1.isFirefox() && name(elm) === 'table') {
	        return firstElement(children(elm)).filter(function (elm) {
	          return name(elm) === 'caption';
	        }).bind(function (caption) {
	          return firstElement(nextSiblings(caption)).map(function (body) {
	            var bodyTop = body.dom().offsetTop;
	            var captionTop = caption.dom().offsetTop;
	            var captionHeight = caption.dom().offsetHeight;
	            return bodyTop <= captionTop ? -captionHeight : 0;
	          });
	        }).getOr(0);
	      } else {
	        return 0;
	      }
	    };
	    var getPos = function (body, elm, rootElm) {
	      var x = 0, y = 0, offsetParent;
	      var doc = body.ownerDocument;
	      var pos;
	      rootElm = rootElm ? rootElm : body;
	      if (elm) {
	        if (rootElm === body && elm.getBoundingClientRect && get$1(Element.fromDom(body), 'position') === 'static') {
	          pos = elm.getBoundingClientRect();
	          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
	          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
	          return {
	            x: x,
	            y: y
	          };
	        }
	        offsetParent = elm;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x += offsetParent.offsetLeft || 0;
	          y += offsetParent.offsetTop || 0;
	          offsetParent = offsetParent.offsetParent;
	        }
	        offsetParent = elm.parentNode;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x -= offsetParent.scrollLeft || 0;
	          y -= offsetParent.scrollTop || 0;
	          offsetParent = offsetParent.parentNode;
	        }
	        y += getTableCaptionDeltaY(Element.fromDom(elm));
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var Position = { getPos: getPos };
	
	    var exports$1 = {}, module$1 = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module$1, undefined));
	    var Promise = module$1.exports.boltExport;
	
	    var nu$3 = function (baseFn) {
	      var data = Option.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$3(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        data = Option.some(x);
	        run(callbacks);
	        callbacks = [];
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          domGlobals.setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu$3(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$3,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      domGlobals.setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$4 = function (baseFn) {
	      return make(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$4,
	      pure: pure$1
	    };
	
	    var par = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par$1 = function (futures) {
	      return par(futures, Future.nu);
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (opt) {
	        return value(o);
	      };
	      var orThunk = function (f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOption = function () {
	        return Option.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOption: toOption
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOption: Option.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    function StyleSheetLoader(document, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var idCount = 0;
	      var loadedStates = {};
	      var maxLoadTime;
	      maxLoadTime = settings.maxLoadTime || 5000;
	      var appendToHead = function (node) {
	        document.getElementsByTagName('head')[0].appendChild(node);
	      };
	      var load = function (url, loadedCallback, errorCallback) {
	        var link, style, startTime, state;
	        var passed = function () {
	          var callbacks = state.passed;
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = 2;
	          state.passed = [];
	          state.failed = [];
	        };
	        var failed = function () {
	          var callbacks = state.failed;
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = 3;
	          state.passed = [];
	          state.failed = [];
	        };
	        var isOldWebKit = function () {
	          var webKitChunks = domGlobals.navigator.userAgent.match(/WebKit\/(\d*)/);
	          return !!(webKitChunks && parseInt(webKitChunks[1], 10) < 536);
	        };
	        var wait = function (testCallback, waitCallback) {
	          if (!testCallback()) {
	            if (new Date().getTime() - startTime < maxLoadTime) {
	              Delay.setTimeout(waitCallback);
	            } else {
	              failed();
	            }
	          }
	        };
	        var waitForWebKitLinkLoaded = function () {
	          wait(function () {
	            var styleSheets = document.styleSheets;
	            var styleSheet, i = styleSheets.length, owner;
	            while (i--) {
	              styleSheet = styleSheets[i];
	              owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
	              if (owner && owner.id === link.id) {
	                passed();
	                return true;
	              }
	            }
	          }, waitForWebKitLinkLoaded);
	        };
	        var waitForGeckoLinkLoaded = function () {
	          wait(function () {
	            try {
	              var cssRules = style.sheet.cssRules;
	              passed();
	              return !!cssRules;
	            } catch (ex) {
	            }
	          }, waitForGeckoLinkLoaded);
	        };
	        url = Tools._addCacheSuffix(url);
	        if (!loadedStates[url]) {
	          state = {
	            passed: [],
	            failed: []
	          };
	          loadedStates[url] = state;
	        } else {
	          state = loadedStates[url];
	        }
	        if (loadedCallback) {
	          state.passed.push(loadedCallback);
	        }
	        if (errorCallback) {
	          state.failed.push(errorCallback);
	        }
	        if (state.status === 1) {
	          return;
	        }
	        if (state.status === 2) {
	          passed();
	          return;
	        }
	        if (state.status === 3) {
	          failed();
	          return;
	        }
	        state.status = 1;
	        link = document.createElement('link');
	        link.rel = 'stylesheet';
	        link.type = 'text/css';
	        link.id = 'u' + idCount++;
	        link.async = false;
	        link.defer = false;
	        startTime = new Date().getTime();
	        if (settings.contentCssCors) {
	          link.crossOrigin = 'anonymous';
	        }
	        if ('onload' in link && !isOldWebKit()) {
	          link.onload = waitForWebKitLinkLoaded;
	          link.onerror = failed;
	        } else {
	          if (domGlobals.navigator.userAgent.indexOf('Firefox') > 0) {
	            style = document.createElement('style');
	            style.textContent = '@import "' + url + '"';
	            waitForGeckoLinkLoaded();
	            appendToHead(style);
	            return;
	          }
	          waitForWebKitLinkLoaded();
	        }
	        appendToHead(link);
	        link.href = url;
	      };
	      var loadF = function (url) {
	        return Future.nu(function (resolve) {
	          load(url, compose(resolve, constant(Result.value(url))), compose(resolve, constant(Result.error(url))));
	        });
	      };
	      var unbox = function (result) {
	        return result.fold(identity, identity);
	      };
	      var loadAll = function (urls, success, failure) {
	        par$1(map(urls, loadF)).get(function (result) {
	          var parts = partition(result, function (r) {
	            return r.isValue();
	          });
	          if (parts.fail.length > 0) {
	            failure(parts.fail.map(unbox));
	          } else {
	            success(parts.pass.map(unbox));
	          }
	        });
	      };
	      return {
	        load: load,
	        loadAll: loadAll
	      };
	    }
	
	    function TreeWalker (startNode, rootNode) {
	      var node = startNode;
	      var findSibling = function (node, startName, siblingName, shallow) {
	        var sibling, parent;
	        if (node) {
	          if (!shallow && node[startName]) {
	            return node[startName];
	          }
	          if (node !== rootNode) {
	            sibling = node[siblingName];
	            if (sibling) {
	              return sibling;
	            }
	            for (parent = node.parentNode; parent && parent !== rootNode; parent = parent.parentNode) {
	              sibling = parent[siblingName];
	              if (sibling) {
	                return sibling;
	              }
	            }
	          }
	        }
	      };
	      var findPreviousNode = function (node, startName, siblingName, shallow) {
	        var sibling, parent, child;
	        if (node) {
	          sibling = node[siblingName];
	          if (rootNode && sibling === rootNode) {
	            return;
	          }
	          if (sibling) {
	            if (!shallow) {
	              for (child = sibling[startName]; child; child = child[startName]) {
	                if (!child[startName]) {
	                  return child;
	                }
	              }
	            }
	            return sibling;
	          }
	          parent = node.parentNode;
	          if (parent && parent !== rootNode) {
	            return parent;
	          }
	        }
	      };
	      this.current = function () {
	        return node;
	      };
	      this.next = function (shallow) {
	        node = findSibling(node, 'firstChild', 'nextSibling', shallow);
	        return node;
	      };
	      this.prev = function (shallow) {
	        node = findSibling(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	      this.prev2 = function (shallow) {
	        node = findPreviousNode(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	    }
	
	    var blocks = [
	      'article',
	      'aside',
	      'details',
	      'div',
	      'dt',
	      'figcaption',
	      'footer',
	      'form',
	      'fieldset',
	      'header',
	      'hgroup',
	      'html',
	      'main',
	      'nav',
	      'section',
	      'summary',
	      'body',
	      'p',
	      'dl',
	      'multicol',
	      'dd',
	      'figure',
	      'address',
	      'center',
	      'blockquote',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'listing',
	      'xmp',
	      'pre',
	      'plaintext',
	      'menu',
	      'dir',
	      'ul',
	      'ol',
	      'li',
	      'hr',
	      'table',
	      'tbody',
	      'thead',
	      'tfoot',
	      'th',
	      'tr',
	      'td',
	      'caption'
	    ];
	    var voids = [
	      'area',
	      'base',
	      'basefont',
	      'br',
	      'col',
	      'frame',
	      'hr',
	      'img',
	      'input',
	      'isindex',
	      'link',
	      'meta',
	      'param',
	      'embed',
	      'source',
	      'wbr',
	      'track'
	    ];
	    var tableCells = [
	      'td',
	      'th'
	    ];
	    var tableSections = [
	      'thead',
	      'tbody',
	      'tfoot'
	    ];
	    var textBlocks = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'p',
	      'div',
	      'address',
	      'pre',
	      'form',
	      'blockquote',
	      'center',
	      'dir',
	      'fieldset',
	      'header',
	      'footer',
	      'article',
	      'section',
	      'hgroup',
	      'aside',
	      'nav',
	      'figure'
	    ];
	    var headings = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6'
	    ];
	    var listItems = [
	      'li',
	      'dd',
	      'dt'
	    ];
	    var lists = [
	      'ul',
	      'ol',
	      'dl'
	    ];
	    var wsElements = [
	      'pre',
	      'script',
	      'textarea',
	      'style'
	    ];
	    var lazyLookup = function (items) {
	      var lookup;
	      return function (node) {
	        lookup = lookup ? lookup : mapToObject(items, constant(true));
	        return lookup.hasOwnProperty(name(node));
	      };
	    };
	    var isHeading = lazyLookup(headings);
	    var isBlock = lazyLookup(blocks);
	    var isInline = function (node) {
	      return isElement(node) && !isBlock(node);
	    };
	    var isBr = function (node) {
	      return isElement(node) && name(node) === 'br';
	    };
	    var isTextBlock = lazyLookup(textBlocks);
	    var isList = lazyLookup(lists);
	    var isListItem = lazyLookup(listItems);
	    var isVoid = lazyLookup(voids);
	    var isTableSection = lazyLookup(tableSections);
	    var isTableCell = lazyLookup(tableCells);
	    var isWsPreserveElement = lazyLookup(wsElements);
	
	    var isNodeType = function (type) {
	      return function (node) {
	        return !!node && node.nodeType === type;
	      };
	    };
	    var isRestrictedNode = function (node) {
	      return !!node && !Object.getPrototypeOf(node);
	    };
	    var isElement$1 = isNodeType(1);
	    var matchNodeNames = function (names) {
	      var items = names.toLowerCase().split(' ');
	      return function (node) {
	        var i, name;
	        if (node && node.nodeType) {
	          name = node.nodeName.toLowerCase();
	          for (i = 0; i < items.length; i++) {
	            if (name === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var matchStyleValues = function (name, values) {
	      var items = values.toLowerCase().split(' ');
	      return function (node) {
	        var i, cssValue;
	        if (isElement$1(node)) {
	          for (i = 0; i < items.length; i++) {
	            var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
	            cssValue = computed ? computed.getPropertyValue(name) : null;
	            if (cssValue === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var hasPropValue = function (propName, propValue) {
	      return function (node) {
	        return isElement$1(node) && node[propName] === propValue;
	      };
	    };
	    var hasAttribute = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$1(node) && node.hasAttribute(attrName);
	      };
	    };
	    var hasAttributeValue = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$1(node) && node.getAttribute(attrName) === attrValue;
	      };
	    };
	    var isBogus = function (node) {
	      return isElement$1(node) && node.hasAttribute('data-mce-bogus');
	    };
	    var isBogusAll = function (node) {
	      return isElement$1(node) && node.getAttribute('data-mce-bogus') === 'all';
	    };
	    var isTable = function (node) {
	      return isElement$1(node) && node.tagName === 'TABLE';
	    };
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement$1(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isText$1 = isNodeType(3);
	    var isComment = isNodeType(8);
	    var isDocument = isNodeType(9);
	    var isDocumentFragment = isNodeType(11);
	    var isBr$1 = matchNodeNames('br');
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var NodeType = {
	      isText: isText$1,
	      isElement: isElement$1,
	      isComment: isComment,
	      isDocument: isDocument,
	      isDocumentFragment: isDocumentFragment,
	      isBr: isBr$1,
	      isContentEditableTrue: isContentEditableTrue,
	      isContentEditableFalse: isContentEditableFalse,
	      isRestrictedNode: isRestrictedNode,
	      matchNodeNames: matchNodeNames,
	      hasPropValue: hasPropValue,
	      hasAttribute: hasAttribute,
	      hasAttributeValue: hasAttributeValue,
	      matchStyleValues: matchStyleValues,
	      isBogus: isBogus,
	      isBogusAll: isBogusAll,
	      isTable: isTable
	    };
	
	    var surroundedBySpans = function (node) {
	      var previousIsSpan = node.previousSibling && node.previousSibling.nodeName === 'SPAN';
	      var nextIsSpan = node.nextSibling && node.nextSibling.nodeName === 'SPAN';
	      return previousIsSpan && nextIsSpan;
	    };
	    var isBookmarkNode = function (node) {
	      return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var trimNode = function (dom, node) {
	      var i, children = node.childNodes;
	      if (NodeType.isElement(node) && isBookmarkNode(node)) {
	        return;
	      }
	      for (i = children.length - 1; i >= 0; i--) {
	        trimNode(dom, children[i]);
	      }
	      if (NodeType.isDocument(node) === false) {
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          var trimmedLength = Tools.trim(node.nodeValue).length;
	          if (dom.isBlock(node.parentNode) || trimmedLength > 0) {
	            return;
	          }
	          if (trimmedLength === 0 && surroundedBySpans(node)) {
	            return;
	          }
	        } else if (NodeType.isElement(node)) {
	          children = node.childNodes;
	          if (children.length === 1 && isBookmarkNode(children[0])) {
	            node.parentNode.insertBefore(children[0], node);
	          }
	          if (children.length || isVoid(Element.fromDom(node))) {
	            return;
	          }
	        }
	        dom.remove(node);
	      }
	      return node;
	    };
	    var TrimNode = { trimNode: trimNode };
	
	    var makeMap$1 = Tools.makeMap;
	    var namedEntities, baseEntities, reverseEntities;
	    var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var rawCharsRegExp = /[<>&\"\']/g;
	    var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
	    var asciiMap = {
	      128: '\u20AC',
	      130: '\u201A',
	      131: '\u0192',
	      132: '\u201E',
	      133: '\u2026',
	      134: '\u2020',
	      135: '\u2021',
	      136: '\u02c6',
	      137: '\u2030',
	      138: '\u0160',
	      139: '\u2039',
	      140: '\u0152',
	      142: '\u017d',
	      145: '\u2018',
	      146: '\u2019',
	      147: '\u201C',
	      148: '\u201D',
	      149: '\u2022',
	      150: '\u2013',
	      151: '\u2014',
	      152: '\u02DC',
	      153: '\u2122',
	      154: '\u0161',
	      155: '\u203A',
	      156: '\u0153',
	      158: '\u017e',
	      159: '\u0178'
	    };
	    baseEntities = {
	      '"': '&quot;',
	      '\'': '&#39;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '`': '&#96;'
	    };
	    reverseEntities = {
	      '&lt;': '<',
	      '&gt;': '>',
	      '&amp;': '&',
	      '&quot;': '"',
	      '&apos;': '\''
	    };
	    var nativeDecode = function (text) {
	      var elm;
	      elm = Element.fromTag('div').dom();
	      elm.innerHTML = text;
	      return elm.textContent || elm.innerText || text;
	    };
	    var buildEntitiesLookup = function (items, radix) {
	      var i, chr, entity;
	      var lookup = {};
	      if (items) {
	        items = items.split(',');
	        radix = radix || 10;
	        for (i = 0; i < items.length; i += 2) {
	          chr = String.fromCharCode(parseInt(items[i], radix));
	          if (!baseEntities[chr]) {
	            entity = '&' + items[i + 1] + ';';
	            lookup[chr] = entity;
	            lookup[entity] = chr;
	          }
	        }
	        return lookup;
	      }
	    };
	    namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	    var encodeRaw = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeAllRaw = function (text) {
	      return ('' + text).replace(rawCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeNumeric = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        if (chr.length > 1) {
	          return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	        }
	        return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
	      });
	    };
	    var encodeNamed = function (text, attr, entities) {
	      entities = entities || namedEntities;
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || entities[chr] || chr;
	      });
	    };
	    var getEncodeFunc = function (name, entities) {
	      var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
	      var encodeNamedAndNumeric = function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          if (baseEntities[chr] !== undefined) {
	            return baseEntities[chr];
	          }
	          if (entitiesMap[chr] !== undefined) {
	            return entitiesMap[chr];
	          }
	          if (chr.length > 1) {
	            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	          }
	          return '&#' + chr.charCodeAt(0) + ';';
	        });
	      };
	      var encodeCustomNamed = function (text, attr) {
	        return encodeNamed(text, attr, entitiesMap);
	      };
	      var nameMap = makeMap$1(name.replace(/\+/g, ','));
	      if (nameMap.named && nameMap.numeric) {
	        return encodeNamedAndNumeric;
	      }
	      if (nameMap.named) {
	        if (entities) {
	          return encodeCustomNamed;
	        }
	        return encodeNamed;
	      }
	      if (nameMap.numeric) {
	        return encodeNumeric;
	      }
	      return encodeRaw;
	    };
	    var decode = function (text) {
	      return text.replace(entityRegExp, function (all, numeric) {
	        if (numeric) {
	          if (numeric.charAt(0).toLowerCase() === 'x') {
	            numeric = parseInt(numeric.substr(1), 16);
	          } else {
	            numeric = parseInt(numeric, 10);
	          }
	          if (numeric > 65535) {
	            numeric -= 65536;
	            return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
	          }
	          return asciiMap[numeric] || String.fromCharCode(numeric);
	        }
	        return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
	      });
	    };
	    var Entities = {
	      encodeRaw: encodeRaw,
	      encodeAllRaw: encodeAllRaw,
	      encodeNumeric: encodeNumeric,
	      encodeNamed: encodeNamed,
	      getEncodeFunc: getEncodeFunc,
	      decode: decode
	    };
	
	    var mapCache = {}, dummyObj = {};
	    var makeMap$2 = Tools.makeMap, each$4 = Tools.each, extend$1 = Tools.extend, explode$1 = Tools.explode, inArray$1 = Tools.inArray;
	    var split = function (items, delim) {
	      items = Tools.trim(items);
	      return items ? items.split(delim || ' ') : [];
	    };
	    var compileSchema = function (type) {
	      var schema = {};
	      var globalAttributes, blockContent;
	      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	      var add = function (name, attributes, children) {
	        var ni, attributesOrder, element;
	        var arrayToMap = function (array, obj) {
	          var map = {};
	          var i, l;
	          for (i = 0, l = array.length; i < l; i++) {
	            map[array[i]] = obj || {};
	          }
	          return map;
	        };
	        children = children || [];
	        attributes = attributes || '';
	        if (typeof children === 'string') {
	          children = split(children);
	        }
	        name = split(name);
	        ni = name.length;
	        while (ni--) {
	          attributesOrder = split([
	            globalAttributes,
	            attributes
	          ].join(' '));
	          element = {
	            attributes: arrayToMap(attributesOrder),
	            attributesOrder: attributesOrder,
	            children: arrayToMap(children, dummyObj)
	          };
	          schema[name[ni]] = element;
	        }
	      };
	      var addAttrs = function (name, attributes) {
	        var ni, schemaItem, i, l;
	        name = split(name);
	        ni = name.length;
	        attributes = split(attributes);
	        while (ni--) {
	          schemaItem = schema[name[ni]];
	          for (i = 0, l = attributes.length; i < l; i++) {
	            schemaItem.attributes[attributes[i]] = {};
	            schemaItem.attributesOrder.push(attributes[i]);
	          }
	        }
	      };
	      if (mapCache[type]) {
	        return mapCache[type];
	      }
	      globalAttributes = 'id accesskey class dir lang style tabindex title role';
	      blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
	      phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
	      if (type !== 'html4') {
	        globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
	        blockContent += ' article aside details dialog figure main header footer hgroup section nav';
	        phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
	      }
	      if (type !== 'html5-strict') {
	        globalAttributes += ' xml:lang';
	        html4PhrasingContent = 'acronym applet basefont big font strike tt';
	        phrasingContent = [
	          phrasingContent,
	          html4PhrasingContent
	        ].join(' ');
	        each$4(split(html4PhrasingContent), function (name) {
	          add(name, '', phrasingContent);
	        });
	        html4BlockContent = 'center dir isindex noframes';
	        blockContent = [
	          blockContent,
	          html4BlockContent
	        ].join(' ');
	        flowContent = [
	          blockContent,
	          phrasingContent
	        ].join(' ');
	        each$4(split(html4BlockContent), function (name) {
	          add(name, '', flowContent);
	        });
	      }
	      flowContent = flowContent || [
	        blockContent,
	        phrasingContent
	      ].join(' ');
	      add('html', 'manifest', 'head body');
	      add('head', '', 'base command link meta noscript script style title');
	      add('title hr noscript br');
	      add('base', 'href target');
	      add('link', 'href rel media hreflang type sizes hreflang');
	      add('meta', 'name http-equiv content charset');
	      add('style', 'media type scoped');
	      add('script', 'src async defer type charset');
	      add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
	      add('address dt dd div caption', '', flowContent);
	      add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
	      add('blockquote', 'cite', flowContent);
	      add('ol', 'reversed start type', 'li');
	      add('ul', '', 'li');
	      add('li', 'value', flowContent);
	      add('dl', '', 'dt dd');
	      add('a', 'href target rel media hreflang type', phrasingContent);
	      add('q', 'cite', phrasingContent);
	      add('ins del', 'cite datetime', flowContent);
	      add('img', 'src sizes srcset alt usemap ismap width height');
	      add('iframe', 'src name width height', flowContent);
	      add('embed', 'src type width height');
	      add('object', 'data type typemustmatch name usemap form width height', [
	        flowContent,
	        'param'
	      ].join(' '));
	      add('param', 'name value');
	      add('map', 'name', [
	        flowContent,
	        'area'
	      ].join(' '));
	      add('area', 'alt coords shape href target rel media hreflang type');
	      add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
	      add('colgroup', 'span', 'col');
	      add('col', 'span');
	      add('tbody thead tfoot', '', 'tr');
	      add('tr', '', 'td th');
	      add('td', 'colspan rowspan headers', flowContent);
	      add('th', 'colspan rowspan headers scope abbr', flowContent);
	      add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
	      add('fieldset', 'disabled form name', [
	        flowContent,
	        'legend'
	      ].join(' '));
	      add('label', 'form for', phrasingContent);
	      add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
	      add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
	      add('select', 'disabled form multiple name required size', 'option optgroup');
	      add('optgroup', 'disabled label', 'option');
	      add('option', 'disabled label selected value');
	      add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
	      add('menu', 'type label', [
	        flowContent,
	        'li'
	      ].join(' '));
	      add('noscript', '', flowContent);
	      if (type !== 'html4') {
	        add('wbr');
	        add('ruby', '', [
	          phrasingContent,
	          'rt rp'
	        ].join(' '));
	        add('figcaption', '', flowContent);
	        add('mark rt rp summary bdi', '', phrasingContent);
	        add('canvas', 'width height', flowContent);
	        add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('picture', '', 'img source');
	        add('source', 'src srcset type media sizes');
	        add('track', 'kind src srclang label default');
	        add('datalist', '', [
	          phrasingContent,
	          'option'
	        ].join(' '));
	        add('article section nav aside main header footer', '', flowContent);
	        add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
	        add('figure', '', [
	          flowContent,
	          'figcaption'
	        ].join(' '));
	        add('time', 'datetime', phrasingContent);
	        add('dialog', 'open', flowContent);
	        add('command', 'type label icon disabled checked radiogroup command');
	        add('output', 'for form name', phrasingContent);
	        add('progress', 'value max', phrasingContent);
	        add('meter', 'value min max low high optimum', phrasingContent);
	        add('details', 'open', [
	          flowContent,
	          'summary'
	        ].join(' '));
	        add('keygen', 'autofocus challenge disabled form keytype name');
	      }
	      if (type !== 'html5-strict') {
	        addAttrs('script', 'language xml:space');
	        addAttrs('style', 'xml:space');
	        addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
	        addAttrs('embed', 'align name hspace vspace');
	        addAttrs('param', 'valuetype type');
	        addAttrs('a', 'charset name rev shape coords');
	        addAttrs('br', 'clear');
	        addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
	        addAttrs('img', 'name longdesc align border hspace vspace');
	        addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
	        addAttrs('font basefont', 'size color face');
	        addAttrs('input', 'usemap align');
	        addAttrs('select', 'onchange');
	        addAttrs('textarea');
	        addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
	        addAttrs('ul', 'type compact');
	        addAttrs('li', 'type');
	        addAttrs('ol dl menu dir', 'compact');
	        addAttrs('pre', 'width xml:space');
	        addAttrs('hr', 'align noshade size width');
	        addAttrs('isindex', 'prompt');
	        addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
	        addAttrs('col', 'width align char charoff valign');
	        addAttrs('colgroup', 'width align char charoff valign');
	        addAttrs('thead', 'align char charoff valign');
	        addAttrs('tr', 'align char charoff valign bgcolor');
	        addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
	        addAttrs('form', 'accept');
	        addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
	        addAttrs('tfoot', 'align char charoff valign');
	        addAttrs('tbody', 'align char charoff valign');
	        addAttrs('area', 'nohref');
	        addAttrs('body', 'background bgcolor text link vlink alink');
	      }
	      if (type !== 'html4') {
	        addAttrs('input button select textarea', 'autofocus');
	        addAttrs('input textarea', 'placeholder');
	        addAttrs('a', 'download');
	        addAttrs('link script img', 'crossorigin');
	        addAttrs('iframe', 'sandbox seamless allowfullscreen');
	      }
	      each$4(split('a form meter progress dfn'), function (name) {
	        if (schema[name]) {
	          delete schema[name].children[name];
	        }
	      });
	      delete schema.caption.children.table;
	      delete schema.script;
	      mapCache[type] = schema;
	      return schema;
	    };
	    var compileElementMap = function (value, mode) {
	      var styles;
	      if (value) {
	        styles = {};
	        if (typeof value === 'string') {
	          value = { '*': value };
	        }
	        each$4(value, function (value, key) {
	          styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$1(value, /[, ]/);
	        });
	      }
	      return styles;
	    };
	    function Schema(settings) {
	      var elements = {};
	      var children = {};
	      var patternElements = [];
	      var validStyles;
	      var invalidStyles;
	      var schemaItems;
	      var whiteSpaceElementsMap, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
	      var blockElementsMap, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
	      var customElementsMap = {}, specialElements = {};
	      var createLookupTable = function (option, defaultValue, extendWith) {
	        var value = settings[option];
	        if (!value) {
	          value = mapCache[option];
	          if (!value) {
	            value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
	            value = extend$1(value, extendWith);
	            mapCache[option] = value;
	          }
	        } else {
	          value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
	        }
	        return value;
	      };
	      settings = settings || {};
	      schemaItems = compileSchema(settings.schema);
	      if (settings.verify_html === false) {
	        settings.valid_elements = '*[*]';
	      }
	      validStyles = compileElementMap(settings.valid_styles);
	      invalidStyles = compileElementMap(settings.invalid_styles, 'map');
	      validClasses = compileElementMap(settings.valid_classes, 'map');
	      whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
	      selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
	      shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
	      boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
	      nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object ' + 'script pre code', shortEndedElementsMap);
	      moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
	      textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside main nav figure');
	      blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
	      textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' + 'dfn code mark q sup sub samp');
	      each$4((settings.special || 'script noscript iframe noframes noembed title style textarea xmp').split(' '), function (name) {
	        specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	      });
	      var patternToRegExp = function (str) {
	        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
	      };
	      var addValidElements = function (validElements) {
	        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, key, value;
	        var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
	        if (validElements) {
	          validElements = split(validElements, ',');
	          if (elements['@']) {
	            globalAttributes = elements['@'].attributes;
	            globalAttributesOrder = elements['@'].attributesOrder;
	          }
	          for (ei = 0, el = validElements.length; ei < el; ei++) {
	            matches = elementRuleRegExp.exec(validElements[ei]);
	            if (matches) {
	              prefix = matches[1];
	              elementName = matches[2];
	              outputName = matches[3];
	              attrData = matches[5];
	              attributes = {};
	              attributesOrder = [];
	              element = {
	                attributes: attributes,
	                attributesOrder: attributesOrder
	              };
	              if (prefix === '#') {
	                element.paddEmpty = true;
	              }
	              if (prefix === '-') {
	                element.removeEmpty = true;
	              }
	              if (matches[4] === '!') {
	                element.removeEmptyAttrs = true;
	              }
	              if (globalAttributes) {
	                for (key in globalAttributes) {
	                  attributes[key] = globalAttributes[key];
	                }
	                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
	              }
	              if (attrData) {
	                attrData = split(attrData, '|');
	                for (ai = 0, al = attrData.length; ai < al; ai++) {
	                  matches = attrRuleRegExp.exec(attrData[ai]);
	                  if (matches) {
	                    attr = {};
	                    attrType = matches[1];
	                    attrName = matches[2].replace(/[\\:]:/g, ':');
	                    prefix = matches[3];
	                    value = matches[4];
	                    if (attrType === '!') {
	                      element.attributesRequired = element.attributesRequired || [];
	                      element.attributesRequired.push(attrName);
	                      attr.required = true;
	                    }
	                    if (attrType === '-') {
	                      delete attributes[attrName];
	                      attributesOrder.splice(inArray$1(attributesOrder, attrName), 1);
	                      continue;
	                    }
	                    if (prefix) {
	                      if (prefix === '=') {
	                        element.attributesDefault = element.attributesDefault || [];
	                        element.attributesDefault.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.defaultValue = value;
	                      }
	                      if (prefix === ':') {
	                        element.attributesForced = element.attributesForced || [];
	                        element.attributesForced.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.forcedValue = value;
	                      }
	                      if (prefix === '<') {
	                        attr.validValues = makeMap$2(value, '?');
	                      }
	                    }
	                    if (hasPatternsRegExp.test(attrName)) {
	                      element.attributePatterns = element.attributePatterns || [];
	                      attr.pattern = patternToRegExp(attrName);
	                      element.attributePatterns.push(attr);
	                    } else {
	                      if (!attributes[attrName]) {
	                        attributesOrder.push(attrName);
	                      }
	                      attributes[attrName] = attr;
	                    }
	                  }
	                }
	              }
	              if (!globalAttributes && elementName === '@') {
	                globalAttributes = attributes;
	                globalAttributesOrder = attributesOrder;
	              }
	              if (outputName) {
	                element.outputName = elementName;
	                elements[outputName] = element;
	              }
	              if (hasPatternsRegExp.test(elementName)) {
	                element.pattern = patternToRegExp(elementName);
	                patternElements.push(element);
	              } else {
	                elements[elementName] = element;
	              }
	            }
	          }
	        }
	      };
	      var setValidElements = function (validElements) {
	        elements = {};
	        patternElements = [];
	        addValidElements(validElements);
	        each$4(schemaItems, function (element, name) {
	          children[name] = element.children;
	        });
	      };
	      var addCustomElements = function (customElements) {
	        var customElementRegExp = /^(~)?(.+)$/;
	        if (customElements) {
	          mapCache.text_block_elements = mapCache.block_elements = null;
	          each$4(split(customElements, ','), function (rule) {
	            var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
	            children[name] = children[cloneName];
	            customElementsMap[name] = cloneName;
	            if (!inline) {
	              blockElementsMap[name.toUpperCase()] = {};
	              blockElementsMap[name] = {};
	            }
	            if (!elements[name]) {
	              var customRule = elements[cloneName];
	              customRule = extend$1({}, customRule);
	              delete customRule.removeEmptyAttrs;
	              delete customRule.removeEmpty;
	              elements[name] = customRule;
	            }
	            each$4(children, function (element, elmName) {
	              if (element[cloneName]) {
	                children[elmName] = element = extend$1({}, children[elmName]);
	                element[name] = element[cloneName];
	              }
	            });
	          });
	        }
	      };
	      var addValidChildren = function (validChildren) {
	        var childRuleRegExp = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
	        mapCache[settings.schema] = null;
	        if (validChildren) {
	          each$4(split(validChildren, ','), function (rule) {
	            var matches = childRuleRegExp.exec(rule);
	            var parent, prefix;
	            if (matches) {
	              prefix = matches[1];
	              if (prefix) {
	                parent = children[matches[2]];
	              } else {
	                parent = children[matches[2]] = { '#comment': {} };
	              }
	              parent = children[matches[2]];
	              each$4(split(matches[3], '|'), function (child) {
	                if (prefix === '-') {
	                  delete parent[child];
	                } else {
	                  parent[child] = {};
	                }
	              });
	            }
	          });
	        }
	      };
	      var getElementRule = function (name) {
	        var element = elements[name], i;
	        if (element) {
	          return element;
	        }
	        i = patternElements.length;
	        while (i--) {
	          element = patternElements[i];
	          if (element.pattern.test(name)) {
	            return element;
	          }
	        }
	      };
	      if (!settings.valid_elements) {
	        each$4(schemaItems, function (element, name) {
	          elements[name] = {
	            attributes: element.attributes,
	            attributesOrder: element.attributesOrder
	          };
	          children[name] = element.children;
	        });
	        if (settings.schema !== 'html5') {
	          each$4(split('strong/b em/i'), function (item) {
	            item = split(item, '/');
	            elements[item[1]].outputName = item[0];
	          });
	        }
	        each$4(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function (name) {
	          if (elements[name]) {
	            elements[name].removeEmpty = true;
	          }
	        });
	        each$4(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
	          elements[name].paddEmpty = true;
	        });
	        each$4(split('span'), function (name) {
	          elements[name].removeEmptyAttrs = true;
	        });
	      } else {
	        setValidElements(settings.valid_elements);
	      }
	      addCustomElements(settings.custom_elements);
	      addValidChildren(settings.valid_children);
	      addValidElements(settings.extended_valid_elements);
	      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	      each$4({
	        dd: 'dl',
	        dt: 'dl',
	        li: 'ul ol',
	        td: 'tr',
	        th: 'tr',
	        tr: 'tbody thead tfoot',
	        tbody: 'table',
	        thead: 'table',
	        tfoot: 'table',
	        legend: 'fieldset',
	        area: 'map',
	        param: 'video audio object'
	      }, function (parents, item) {
	        if (elements[item]) {
	          elements[item].parentsRequired = split(parents);
	        }
	      });
	      if (settings.invalid_elements) {
	        each$4(explode$1(settings.invalid_elements), function (item) {
	          if (elements[item]) {
	            delete elements[item];
	          }
	        });
	      }
	      if (!getElementRule('span')) {
	        addValidElements('span[!data-mce-type|*]');
	      }
	      var getValidStyles = function () {
	        return validStyles;
	      };
	      var getInvalidStyles = function () {
	        return invalidStyles;
	      };
	      var getValidClasses = function () {
	        return validClasses;
	      };
	      var getBoolAttrs = function () {
	        return boolAttrMap;
	      };
	      var getBlockElements = function () {
	        return blockElementsMap;
	      };
	      var getTextBlockElements = function () {
	        return textBlockElementsMap;
	      };
	      var getTextInlineElements = function () {
	        return textInlineElementsMap;
	      };
	      var getShortEndedElements = function () {
	        return shortEndedElementsMap;
	      };
	      var getSelfClosingElements = function () {
	        return selfClosingElementsMap;
	      };
	      var getNonEmptyElements = function () {
	        return nonEmptyElementsMap;
	      };
	      var getMoveCaretBeforeOnEnterElements = function () {
	        return moveCaretBeforeOnEnterElementsMap;
	      };
	      var getWhiteSpaceElements = function () {
	        return whiteSpaceElementsMap;
	      };
	      var getSpecialElements = function () {
	        return specialElements;
	      };
	      var isValidChild = function (name, child) {
	        var parent = children[name.toLowerCase()];
	        return !!(parent && parent[child.toLowerCase()]);
	      };
	      var isValid = function (name, attr) {
	        var attrPatterns, i;
	        var rule = getElementRule(name);
	        if (rule) {
	          if (attr) {
	            if (rule.attributes[attr]) {
	              return true;
	            }
	            attrPatterns = rule.attributePatterns;
	            if (attrPatterns) {
	              i = attrPatterns.length;
	              while (i--) {
	                if (attrPatterns[i].pattern.test(name)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            return true;
	          }
	        }
	        return false;
	      };
	      var getCustomElements = function () {
	        return customElementsMap;
	      };
	      return {
	        children: children,
	        elements: elements,
	        getValidStyles: getValidStyles,
	        getValidClasses: getValidClasses,
	        getBlockElements: getBlockElements,
	        getInvalidStyles: getInvalidStyles,
	        getShortEndedElements: getShortEndedElements,
	        getTextBlockElements: getTextBlockElements,
	        getTextInlineElements: getTextInlineElements,
	        getBoolAttrs: getBoolAttrs,
	        getElementRule: getElementRule,
	        getSelfClosingElements: getSelfClosingElements,
	        getNonEmptyElements: getNonEmptyElements,
	        getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
	        getWhiteSpaceElements: getWhiteSpaceElements,
	        getSpecialElements: getSpecialElements,
	        isValidChild: isValidChild,
	        isValid: isValid,
	        getCustomElements: getCustomElements,
	        addValidElements: addValidElements,
	        setValidElements: setValidElements,
	        addCustomElements: addCustomElements,
	        addValidChildren: addValidChildren
	      };
	    }
	
	    var toHex = function (match, r, g, b) {
	      var hex = function (val) {
	        val = parseInt(val, 10).toString(16);
	        return val.length > 1 ? val : '0' + val;
	      };
	      return '#' + hex(r) + hex(g) + hex(b);
	    };
	    function Styles(settings, schema) {
	      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
	      var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
	      var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
	      var trimRightRegExp = /\s+$/;
	      var i;
	      var encodingLookup = {};
	      var encodingItems;
	      var validStyles;
	      var invalidStyles;
	      var invisibleChar = '\uFEFF';
	      settings = settings || {};
	      if (schema) {
	        validStyles = schema.getValidStyles();
	        invalidStyles = schema.getInvalidStyles();
	      }
	      encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
	      for (i = 0; i < encodingItems.length; i++) {
	        encodingLookup[encodingItems[i]] = invisibleChar + i;
	        encodingLookup[invisibleChar + i] = encodingItems[i];
	      }
	      return {
	        toHex: function (color) {
	          return color.replace(rgbRegExp, toHex);
	        },
	        parse: function (css) {
	          var styles = {};
	          var matches, name, value, isEncoded;
	          var urlConverter = settings.url_converter;
	          var urlConverterScope = settings.url_converter_scope || this;
	          var compress = function (prefix, suffix, noJoin) {
	            var top, right, bottom, left;
	            top = styles[prefix + '-top' + suffix];
	            if (!top) {
	              return;
	            }
	            right = styles[prefix + '-right' + suffix];
	            if (!right) {
	              return;
	            }
	            bottom = styles[prefix + '-bottom' + suffix];
	            if (!bottom) {
	              return;
	            }
	            left = styles[prefix + '-left' + suffix];
	            if (!left) {
	              return;
	            }
	            var box = [
	              top,
	              right,
	              bottom,
	              left
	            ];
	            i = box.length - 1;
	            while (i--) {
	              if (box[i] !== box[i + 1]) {
	                break;
	              }
	            }
	            if (i > -1 && noJoin) {
	              return;
	            }
	            styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
	            delete styles[prefix + '-top' + suffix];
	            delete styles[prefix + '-right' + suffix];
	            delete styles[prefix + '-bottom' + suffix];
	            delete styles[prefix + '-left' + suffix];
	          };
	          var canCompress = function (key) {
	            var value = styles[key], i;
	            if (!value) {
	              return;
	            }
	            value = value.split(' ');
	            i = value.length;
	            while (i--) {
	              if (value[i] !== value[0]) {
	                return false;
	              }
	            }
	            styles[key] = value[0];
	            return true;
	          };
	          var compress2 = function (target, a, b, c) {
	            if (!canCompress(a)) {
	              return;
	            }
	            if (!canCompress(b)) {
	              return;
	            }
	            if (!canCompress(c)) {
	              return;
	            }
	            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
	            delete styles[a];
	            delete styles[b];
	            delete styles[c];
	          };
	          var encode = function (str) {
	            isEncoded = true;
	            return encodingLookup[str];
	          };
	          var decode = function (str, keepSlashes) {
	            if (isEncoded) {
	              str = str.replace(/\uFEFF[0-9]/g, function (str) {
	                return encodingLookup[str];
	              });
	            }
	            if (!keepSlashes) {
	              str = str.replace(/\\([\'\";:])/g, '$1');
	            }
	            return str;
	          };
	          var decodeSingleHexSequence = function (escSeq) {
	            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
	          };
	          var decodeHexSequences = function (value) {
	            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
	          };
	          var processUrl = function (match, url, url2, url3, str, str2) {
	            str = str || str2;
	            if (str) {
	              str = decode(str);
	              return '\'' + str.replace(/\'/g, '\\\'') + '\'';
	            }
	            url = decode(url || url2 || url3);
	            if (!settings.allow_script_urls) {
	              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
	              if (/(java|vb)script:/i.test(scriptUrl)) {
	                return '';
	              }
	              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
	                return '';
	              }
	            }
	            if (urlConverter) {
	              url = urlConverter.call(urlConverterScope, url, 'style');
	            }
	            return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
	          };
	          if (css) {
	            css = css.replace(/[\u0000-\u001F]/g, '');
	            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
	              return str.replace(/[;:]/g, encode);
	            });
	            while (matches = styleRegExp.exec(css)) {
	              styleRegExp.lastIndex = matches.index + matches[0].length;
	              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
	              value = matches[2].replace(trimRightRegExp, '');
	              if (name && value) {
	                name = decodeHexSequences(name);
	                value = decodeHexSequences(value);
	                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
	                  continue;
	                }
	                if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
	                  continue;
	                }
	                if (name === 'font-weight' && value === '700') {
	                  value = 'bold';
	                } else if (name === 'color' || name === 'background-color') {
	                  value = value.toLowerCase();
	                }
	                value = value.replace(rgbRegExp, toHex);
	                value = value.replace(urlOrStrRegExp, processUrl);
	                styles[name] = isEncoded ? decode(value, true) : value;
	              }
	            }
	            compress('border', '', true);
	            compress('border', '-width');
	            compress('border', '-color');
	            compress('border', '-style');
	            compress('padding', '');
	            compress('margin', '');
	            compress2('border', 'border-width', 'border-style', 'border-color');
	            if (styles.border === 'medium none') {
	              delete styles.border;
	            }
	            if (styles['border-image'] === 'none') {
	              delete styles['border-image'];
	            }
	          }
	          return styles;
	        },
	        serialize: function (styles, elementName) {
	          var css = '', name, value;
	          var serializeStyles = function (name) {
	            var styleList, i, l, value;
	            styleList = validStyles[name];
	            if (styleList) {
	              for (i = 0, l = styleList.length; i < l; i++) {
	                name = styleList[i];
	                value = styles[name];
	                if (value) {
	                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	                }
	              }
	            }
	          };
	          var isValid = function (name, elementName) {
	            var styleMap;
	            styleMap = invalidStyles['*'];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            styleMap = invalidStyles[elementName];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            return true;
	          };
	          if (elementName && validStyles) {
	            serializeStyles('*');
	            serializeStyles(elementName);
	          } else {
	            for (name in styles) {
	              value = styles[name];
	              if (value && (!invalidStyles || isValid(name, elementName))) {
	                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	              }
	            }
	          }
	          return css;
	        }
	      };
	    }
	
	    var each$5 = Tools.each;
	    var grep$1 = Tools.grep;
	    var isIE = Env.ie;
	    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
	    var whiteSpaceRegExp$2 = /^[ \t\r\n]*$/;
	    var setupAttrHooks = function (styles, settings, getContext) {
	      var attrHooks = {};
	      var keepValues = settings.keep_values;
	      var keepUrlHook = {
	        set: function ($elm, value, name) {
	          if (settings.url_converter) {
	            value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
	          }
	          $elm.attr('data-mce-' + name, value).attr(name, value);
	        },
	        get: function ($elm, name) {
	          return $elm.attr('data-mce-' + name) || $elm.attr(name);
	        }
	      };
	      attrHooks = {
	        style: {
	          set: function ($elm, value) {
	            if (value !== null && typeof value === 'object') {
	              $elm.css(value);
	              return;
	            }
	            if (keepValues) {
	              $elm.attr('data-mce-style', value);
	            }
	            $elm.attr('style', value);
	          },
	          get: function ($elm) {
	            var value = $elm.attr('data-mce-style') || $elm.attr('style');
	            value = styles.serialize(styles.parse(value), $elm[0].nodeName);
	            return value;
	          }
	        }
	      };
	      if (keepValues) {
	        attrHooks.href = attrHooks.src = keepUrlHook;
	      }
	      return attrHooks;
	    };
	    var updateInternalStyleAttr = function (styles, $elm) {
	      var rawValue = $elm.attr('style');
	      var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
	      if (!value) {
	        value = null;
	      }
	      $elm.attr('data-mce-style', value);
	    };
	    var findNodeIndex = function (node, normalized) {
	      var idx = 0, lastNodeType, nodeType;
	      if (node) {
	        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
	          nodeType = node.nodeType;
	          if (normalized && nodeType === 3) {
	            if (nodeType === lastNodeType || !node.nodeValue.length) {
	              continue;
	            }
	          }
	          idx++;
	          lastNodeType = nodeType;
	        }
	      }
	      return idx;
	    };
	    function DOMUtils(doc, settings) {
	      var _this = this;
	      if (settings === void 0) {
	        settings = {};
	      }
	      var attrHooks;
	      var addedStyles = {};
	      var win = domGlobals.window;
	      var files = {};
	      var counter = 0;
	      var stdMode = true;
	      var boxModel = true;
	      var styleSheetLoader = StyleSheetLoader(doc, { contentCssCors: settings.contentCssCors });
	      var boundEvents = [];
	      var schema = settings.schema ? settings.schema : Schema({});
	      var styles = Styles({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope
	      }, settings.schema);
	      var events = settings.ownEvents ? new EventUtils(settings.proxy) : EventUtils.Event;
	      var blockElementsMap = schema.getBlockElements();
	      var $ = DomQuery.overrideDefaults(function () {
	        return {
	          context: doc,
	          element: self.getRoot()
	        };
	      });
	      var isBlock = function (node) {
	        if (typeof node === 'string') {
	          return !!blockElementsMap[node];
	        } else if (node) {
	          var type = node.nodeType;
	          if (type) {
	            return !!(type === 1 && blockElementsMap[node.nodeName]);
	          }
	        }
	        return false;
	      };
	      var get = function (elm) {
	        if (elm && doc && typeof elm === 'string') {
	          var node = doc.getElementById(elm);
	          if (node && node.id !== elm) {
	            return doc.getElementsByName(elm)[1];
	          } else {
	            return node;
	          }
	        }
	        return elm;
	      };
	      var $$ = function (elm) {
	        if (typeof elm === 'string') {
	          elm = get(elm);
	        }
	        return $(elm);
	      };
	      var getAttrib = function (elm, name, defaultVal) {
	        var hook, value;
	        var $elm = $$(elm);
	        if ($elm.length) {
	          hook = attrHooks[name];
	          if (hook && hook.get) {
	            value = hook.get($elm, name);
	          } else {
	            value = $elm.attr(name);
	          }
	        }
	        if (typeof value === 'undefined') {
	          value = defaultVal || '';
	        }
	        return value;
	      };
	      var getAttribs = function (elm) {
	        var node = get(elm);
	        if (!node) {
	          return [];
	        }
	        return node.attributes;
	      };
	      var setAttrib = function (elm, name, value) {
	        var originalValue, hook;
	        if (value === '') {
	          value = null;
	        }
	        var $elm = $$(elm);
	        originalValue = $elm.attr(name);
	        if (!$elm.length) {
	          return;
	        }
	        hook = attrHooks[name];
	        if (hook && hook.set) {
	          hook.set($elm, value, name);
	        } else {
	          $elm.attr(name, value);
	        }
	        if (originalValue !== value && settings.onSetAttrib) {
	          settings.onSetAttrib({
	            attrElm: $elm,
	            attrName: name,
	            attrValue: value
	          });
	        }
	      };
	      var clone = function (node, deep) {
	        if (!isIE || node.nodeType !== 1 || deep) {
	          return node.cloneNode(deep);
	        }
	        if (!deep) {
	          var clone_1 = doc.createElement(node.nodeName);
	          each$5(getAttribs(node), function (attr) {
	            setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
	          });
	          return clone_1;
	        }
	        return null;
	      };
	      var getRoot = function () {
	        return settings.root_element || doc.body;
	      };
	      var getViewPort = function (argWin) {
	        var actWin = !argWin ? win : argWin;
	        var doc = actWin.document;
	        var rootElm =  doc.documentElement ;
	        return {
	          x: actWin.pageXOffset || rootElm.scrollLeft,
	          y: actWin.pageYOffset || rootElm.scrollTop,
	          w: actWin.innerWidth || rootElm.clientWidth,
	          h: actWin.innerHeight || rootElm.clientHeight
	        };
	      };
	      var getPos = function (elm, rootElm) {
	        return Position.getPos(doc.body, get(elm), rootElm);
	      };
	      var setStyle = function (elm, name, value) {
	        var $elm = $$(elm).css(name, value);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var setStyles = function (elm, stylesArg) {
	        var $elm = $$(elm).css(stylesArg);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var getStyle = function (elm, name, computed) {
	        var $elm = $$(elm);
	        if (computed) {
	          return $elm.css(name);
	        }
	        name = name.replace(/-(\D)/g, function (a, b) {
	          return b.toUpperCase();
	        });
	        if (name === 'float') {
	          name = Env.ie && Env.ie < 12 ? 'styleFloat' : 'cssFloat';
	        }
	        return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
	      };
	      var getSize = function (elm) {
	        var w, h;
	        elm = get(elm);
	        w = getStyle(elm, 'width');
	        h = getStyle(elm, 'height');
	        if (w.indexOf('px') === -1) {
	          w = 0;
	        }
	        if (h.indexOf('px') === -1) {
	          h = 0;
	        }
	        return {
	          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
	          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
	        };
	      };
	      var getRect = function (elm) {
	        var pos, size;
	        elm = get(elm);
	        pos = getPos(elm);
	        size = getSize(elm);
	        return {
	          x: pos.x,
	          y: pos.y,
	          w: size.w,
	          h: size.h
	        };
	      };
	      var is = function (elm, selector) {
	        var i;
	        if (!elm) {
	          return false;
	        }
	        if (!Array.isArray(elm)) {
	          if (selector === '*') {
	            return elm.nodeType === 1;
	          }
	          if (simpleSelectorRe.test(selector)) {
	            var selectors = selector.toLowerCase().split(/,/);
	            var elmName = elm.nodeName.toLowerCase();
	            for (i = selectors.length - 1; i >= 0; i--) {
	              if (selectors[i] === elmName) {
	                return true;
	              }
	            }
	            return false;
	          }
	          if (elm.nodeType && elm.nodeType !== 1) {
	            return false;
	          }
	        }
	        var elms = !Array.isArray(elm) ? [elm] : elm;
	        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
	      };
	      var getParents = function (elm, selector, root, collect) {
	        var result = [];
	        var selectorVal;
	        var node = get(elm);
	        collect = collect === undefined;
	        root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
	        if (Tools.is(selector, 'string')) {
	          selectorVal = selector;
	          if (selector === '*') {
	            selector = function (node) {
	              return node.nodeType === 1;
	            };
	          } else {
	            selector = function (node) {
	              return is(node, selectorVal);
	            };
	          }
	        }
	        while (node) {
	          if (node === root || !node.nodeType || node.nodeType === 9) {
	            break;
	          }
	          if (!selector || typeof selector === 'function' && selector(node)) {
	            if (collect) {
	              result.push(node);
	            } else {
	              return [node];
	            }
	          }
	          node = node.parentNode;
	        }
	        return collect ? result : null;
	      };
	      var getParent = function (node, selector, root) {
	        var parents = getParents(node, selector, root, false);
	        return parents && parents.length > 0 ? parents[0] : null;
	      };
	      var _findSib = function (node, selector, name) {
	        var func = selector;
	        if (node) {
	          if (typeof selector === 'string') {
	            func = function (node) {
	              return is(node, selector);
	            };
	          }
	          for (node = node[name]; node; node = node[name]) {
	            if (typeof func === 'function' && func(node)) {
	              return node;
	            }
	          }
	        }
	        return null;
	      };
	      var getNext = function (node, selector) {
	        return _findSib(node, selector, 'nextSibling');
	      };
	      var getPrev = function (node, selector) {
	        return _findSib(node, selector, 'previousSibling');
	      };
	      var select = function (selector, scope) {
	        return Sizzle(selector, get(scope) || settings.root_element || doc, []);
	      };
	      var run = function (elm, func, scope) {
	        var result;
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        if (!node) {
	          return false;
	        }
	        if (Tools.isArray(node) && (node.length || node.length === 0)) {
	          result = [];
	          each$5(node, function (elm, i) {
	            if (elm) {
	              if (typeof elm === 'string') {
	                elm = get(elm);
	              }
	              result.push(func.call(scope, elm, i));
	            }
	          });
	          return result;
	        }
	        var context = scope ? scope : _this;
	        return func.call(context, node);
	      };
	      var setAttribs = function (elm, attrs) {
	        $$(elm).each(function (i, node) {
	          each$5(attrs, function (value, name) {
	            setAttrib(node, name, value);
	          });
	        });
	      };
	      var setHTML = function (elm, html) {
	        var $elm = $$(elm);
	        if (isIE) {
	          $elm.each(function (i, target) {
	            if (target.canHaveHTML === false) {
	              return;
	            }
	            while (target.firstChild) {
	              target.removeChild(target.firstChild);
	            }
	            try {
	              target.innerHTML = '<br>' + html;
	              target.removeChild(target.firstChild);
	            } catch (ex) {
	              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
	            }
	            return html;
	          });
	        } else {
	          $elm.html(html);
	        }
	      };
	      var add = function (parentElm, name, attrs, html, create) {
	        return run(parentElm, function (parentElm) {
	          var newElm = typeof name === 'string' ? doc.createElement(name) : name;
	          setAttribs(newElm, attrs);
	          if (html) {
	            if (typeof html !== 'string' && html.nodeType) {
	              newElm.appendChild(html);
	            } else if (typeof html === 'string') {
	              setHTML(newElm, html);
	            }
	          }
	          return !create ? parentElm.appendChild(newElm) : newElm;
	        });
	      };
	      var create = function (name, attrs, html) {
	        return add(doc.createElement(name), name, attrs, html, true);
	      };
	      var decode = Entities.decode;
	      var encode = Entities.encodeAllRaw;
	      var createHTML = function (name, attrs, html) {
	        var outHtml = '', key;
	        outHtml += '<' + name;
	        for (key in attrs) {
	          if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] !== 'undefined') {
	            outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
	          }
	        }
	        if (typeof html !== 'undefined') {
	          return outHtml + '>' + html + '</' + name + '>';
	        }
	        return outHtml + ' />';
	      };
	      var createFragment = function (html) {
	        var node;
	        var container = doc.createElement('div');
	        var frag = doc.createDocumentFragment();
	        frag.appendChild(container);
	        if (html) {
	          container.innerHTML = html;
	        }
	        while (node = container.firstChild) {
	          frag.appendChild(node);
	        }
	        frag.removeChild(container);
	        return frag;
	      };
	      var remove = function (node, keepChildren) {
	        var $node = $$(node);
	        if (keepChildren) {
	          $node.each(function () {
	            var child;
	            while (child = this.firstChild) {
	              if (child.nodeType === 3 && child.data.length === 0) {
	                this.removeChild(child);
	              } else {
	                this.parentNode.insertBefore(child, this);
	              }
	            }
	          }).remove();
	        } else {
	          $node.remove();
	        }
	        return $node.length > 1 ? $node.toArray() : $node[0];
	      };
	      var removeAllAttribs = function (e) {
	        return run(e, function (e) {
	          var i;
	          var attrs = e.attributes;
	          for (i = attrs.length - 1; i >= 0; i--) {
	            e.removeAttributeNode(attrs.item(i));
	          }
	        });
	      };
	      var parseStyle = function (cssText) {
	        return styles.parse(cssText);
	      };
	      var serializeStyle = function (stylesArg, name) {
	        return styles.serialize(stylesArg, name);
	      };
	      var addStyle = function (cssText) {
	        var head, styleElm;
	        if (self !== DOMUtils.DOM && doc === domGlobals.document) {
	          if (addedStyles[cssText]) {
	            return;
	          }
	          addedStyles[cssText] = true;
	        }
	        styleElm = doc.getElementById('mceDefaultStyles');
	        if (!styleElm) {
	          styleElm = doc.createElement('style');
	          styleElm.id = 'mceDefaultStyles';
	          styleElm.type = 'text/css';
	          head = doc.getElementsByTagName('head')[0];
	          if (head.firstChild) {
	            head.insertBefore(styleElm, head.firstChild);
	          } else {
	            head.appendChild(styleElm);
	          }
	        }
	        if (styleElm.styleSheet) {
	          styleElm.styleSheet.cssText += cssText;
	        } else {
	          styleElm.appendChild(doc.createTextNode(cssText));
	        }
	      };
	      var loadCSS = function (url) {
	        var head;
	        if (self !== DOMUtils.DOM && doc === domGlobals.document) {
	          DOMUtils.DOM.loadCSS(url);
	          return;
	        }
	        if (!url) {
	          url = '';
	        }
	        head = doc.getElementsByTagName('head')[0];
	        each$5(url.split(','), function (url) {
	          var link;
	          url = Tools._addCacheSuffix(url);
	          if (files[url]) {
	            return;
	          }
	          files[url] = true;
	          link = create('link', {
	            rel: 'stylesheet',
	            href: url
	          });
	          head.appendChild(link);
	        });
	      };
	      var toggleClass = function (elm, cls, state) {
	        $$(elm).toggleClass(cls, state).each(function () {
	          if (this.className === '') {
	            DomQuery(this).attr('class', null);
	          }
	        });
	      };
	      var addClass = function (elm, cls) {
	        $$(elm).addClass(cls);
	      };
	      var removeClass = function (elm, cls) {
	        toggleClass(elm, cls, false);
	      };
	      var hasClass = function (elm, cls) {
	        return $$(elm).hasClass(cls);
	      };
	      var show = function (elm) {
	        $$(elm).show();
	      };
	      var hide = function (elm) {
	        $$(elm).hide();
	      };
	      var isHidden = function (elm) {
	        return $$(elm).css('display') === 'none';
	      };
	      var uniqueId = function (prefix) {
	        return (!prefix ? 'mce_' : prefix) + counter++;
	      };
	      var getOuterHTML = function (elm) {
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        return NodeType.isElement(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
	      };
	      var setOuterHTML = function (elm, html) {
	        $$(elm).each(function () {
	          try {
	            if ('outerHTML' in this) {
	              this.outerHTML = html;
	              return;
	            }
	          } catch (ex) {
	          }
	          remove(DomQuery(this).html(html), true);
	        });
	      };
	      var insertAfter = function (node, reference) {
	        var referenceNode = get(reference);
	        return run(node, function (node) {
	          var parent, nextSibling;
	          parent = referenceNode.parentNode;
	          nextSibling = referenceNode.nextSibling;
	          if (nextSibling) {
	            parent.insertBefore(node, nextSibling);
	          } else {
	            parent.appendChild(node);
	          }
	          return node;
	        });
	      };
	      var replace = function (newElm, oldElm, keepChildren) {
	        return run(oldElm, function (oldElm) {
	          if (Tools.is(oldElm, 'array')) {
	            newElm = newElm.cloneNode(true);
	          }
	          if (keepChildren) {
	            each$5(grep$1(oldElm.childNodes), function (node) {
	              newElm.appendChild(node);
	            });
	          }
	          return oldElm.parentNode.replaceChild(newElm, oldElm);
	        });
	      };
	      var rename = function (elm, name) {
	        var newElm;
	        if (elm.nodeName !== name.toUpperCase()) {
	          newElm = create(name);
	          each$5(getAttribs(elm), function (attrNode) {
	            setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
	          });
	          replace(newElm, elm, true);
	        }
	        return newElm || elm;
	      };
	      var findCommonAncestor = function (a, b) {
	        var ps = a, pe;
	        while (ps) {
	          pe = b;
	          while (pe && ps !== pe) {
	            pe = pe.parentNode;
	          }
	          if (ps === pe) {
	            break;
	          }
	          ps = ps.parentNode;
	        }
	        if (!ps && a.ownerDocument) {
	          return a.ownerDocument.documentElement;
	        }
	        return ps;
	      };
	      var toHex = function (rgbVal) {
	        return styles.toHex(Tools.trim(rgbVal));
	      };
	      var isEmpty = function (node, elements) {
	        var i, attributes, type, whitespace, walker, name, brCount = 0;
	        node = node.firstChild;
	        if (node) {
	          walker = new TreeWalker(node, node.parentNode);
	          elements = elements || (schema ? schema.getNonEmptyElements() : null);
	          whitespace = schema ? schema.getWhiteSpaceElements() : {};
	          do {
	            type = node.nodeType;
	            if (NodeType.isElement(node)) {
	              var bogusVal = node.getAttribute('data-mce-bogus');
	              if (bogusVal) {
	                node = walker.next(bogusVal === 'all');
	                continue;
	              }
	              name = node.nodeName.toLowerCase();
	              if (elements && elements[name]) {
	                if (name === 'br') {
	                  brCount++;
	                  node = walker.next();
	                  continue;
	                }
	                return false;
	              }
	              attributes = getAttribs(node);
	              i = attributes.length;
	              while (i--) {
	                name = attributes[i].nodeName;
	                if (name === 'name' || name === 'data-mce-bookmark') {
	                  return false;
	                }
	              }
	            }
	            if (type === 8) {
	              return false;
	            }
	            if (type === 3 && !whiteSpaceRegExp$2.test(node.nodeValue)) {
	              return false;
	            }
	            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && whiteSpaceRegExp$2.test(node.nodeValue)) {
	              return false;
	            }
	            node = walker.next();
	          } while (node);
	        }
	        return brCount <= 1;
	      };
	      var createRng = function () {
	        return doc.createRange();
	      };
	      var split = function (parentElm, splitElm, replacementElm) {
	        var r = createRng(), bef, aft, pa;
	        if (parentElm && splitElm) {
	          r.setStart(parentElm.parentNode, findNodeIndex(parentElm));
	          r.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
	          bef = r.extractContents();
	          r = createRng();
	          r.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
	          r.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
	          aft = r.extractContents();
	          pa = parentElm.parentNode;
	          pa.insertBefore(TrimNode.trimNode(self, bef), parentElm);
	          if (replacementElm) {
	            pa.insertBefore(replacementElm, parentElm);
	          } else {
	            pa.insertBefore(splitElm, parentElm);
	          }
	          pa.insertBefore(TrimNode.trimNode(self, aft), parentElm);
	          remove(parentElm);
	          return replacementElm || splitElm;
	        }
	      };
	      var bind = function (target, name, func, scope) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          while (i--) {
	            target[i] = bind(target[i], name, func, scope);
	          }
	          return target;
	        }
	        if (settings.collect && (target === doc || target === win)) {
	          boundEvents.push([
	            target,
	            name,
	            func,
	            scope
	          ]);
	        }
	        return events.bind(target, name, func, scope || self);
	      };
	      var unbind = function (target, name, func) {
	        var i;
	        if (Tools.isArray(target)) {
	          i = target.length;
	          while (i--) {
	            target[i] = unbind(target[i], name, func);
	          }
	          return target;
	        }
	        if (boundEvents && (target === doc || target === win)) {
	          i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
	              events.unbind(item[0], item[1], item[2]);
	            }
	          }
	        }
	        return events.unbind(target, name, func);
	      };
	      var fire = function (target, name, evt) {
	        return events.fire(target, name, evt);
	      };
	      var getContentEditable = function (node) {
	        if (node && NodeType.isElement(node)) {
	          var contentEditable = node.getAttribute('data-mce-contenteditable');
	          if (contentEditable && contentEditable !== 'inherit') {
	            return contentEditable;
	          }
	          return node.contentEditable !== 'inherit' ? node.contentEditable : null;
	        } else {
	          return null;
	        }
	      };
	      var getContentEditableParent = function (node) {
	        var root = getRoot();
	        var state = null;
	        for (; node && node !== root; node = node.parentNode) {
	          state = getContentEditable(node);
	          if (state !== null) {
	            break;
	          }
	        }
	        return state;
	      };
	      var destroy = function () {
	        if (boundEvents) {
	          var i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            events.unbind(item[0], item[1], item[2]);
	          }
	        }
	        if (Sizzle.setDocument) {
	          Sizzle.setDocument();
	        }
	      };
	      var isChildOf = function (node, parent) {
	        while (node) {
	          if (parent === node) {
	            return true;
	          }
	          node = node.parentNode;
	        }
	        return false;
	      };
	      var dumpRng = function (r) {
	        return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
	      };
	      var self = {
	        doc: doc,
	        settings: settings,
	        win: win,
	        files: files,
	        stdMode: stdMode,
	        boxModel: boxModel,
	        styleSheetLoader: styleSheetLoader,
	        boundEvents: boundEvents,
	        styles: styles,
	        schema: schema,
	        events: events,
	        isBlock: isBlock,
	        $: $,
	        $$: $$,
	        root: null,
	        clone: clone,
	        getRoot: getRoot,
	        getViewPort: getViewPort,
	        getRect: getRect,
	        getSize: getSize,
	        getParent: getParent,
	        getParents: getParents,
	        get: get,
	        getNext: getNext,
	        getPrev: getPrev,
	        select: select,
	        is: is,
	        add: add,
	        create: create,
	        createHTML: createHTML,
	        createFragment: createFragment,
	        remove: remove,
	        setStyle: setStyle,
	        getStyle: getStyle,
	        setStyles: setStyles,
	        removeAllAttribs: removeAllAttribs,
	        setAttrib: setAttrib,
	        setAttribs: setAttribs,
	        getAttrib: getAttrib,
	        getPos: getPos,
	        parseStyle: parseStyle,
	        serializeStyle: serializeStyle,
	        addStyle: addStyle,
	        loadCSS: loadCSS,
	        addClass: addClass,
	        removeClass: removeClass,
	        hasClass: hasClass,
	        toggleClass: toggleClass,
	        show: show,
	        hide: hide,
	        isHidden: isHidden,
	        uniqueId: uniqueId,
	        setHTML: setHTML,
	        getOuterHTML: getOuterHTML,
	        setOuterHTML: setOuterHTML,
	        decode: decode,
	        encode: encode,
	        insertAfter: insertAfter,
	        replace: replace,
	        rename: rename,
	        findCommonAncestor: findCommonAncestor,
	        toHex: toHex,
	        run: run,
	        getAttribs: getAttribs,
	        isEmpty: isEmpty,
	        createRng: createRng,
	        nodeIndex: findNodeIndex,
	        split: split,
	        bind: bind,
	        unbind: unbind,
	        fire: fire,
	        getContentEditable: getContentEditable,
	        getContentEditableParent: getContentEditableParent,
	        destroy: destroy,
	        isChildOf: isChildOf,
	        dumpRng: dumpRng
	      };
	      attrHooks = setupAttrHooks(styles, settings, function () {
	        return self;
	      });
	      return self;
	    }
	    (function (DOMUtils) {
	      DOMUtils.DOM = DOMUtils(domGlobals.document);
	      DOMUtils.nodeIndex = findNodeIndex;
	    }(DOMUtils || (DOMUtils = {})));
	    var DOMUtils$1 = DOMUtils;
	
	    var DOM = DOMUtils$1.DOM;
	    var each$6 = Tools.each, grep$2 = Tools.grep;
	    var isFunction$1 = function (f) {
	      return typeof f === 'function';
	    };
	    var ScriptLoader = function () {
	      var QUEUED = 0;
	      var LOADING = 1;
	      var LOADED = 2;
	      var FAILED = 3;
	      var states = {};
	      var queue = [];
	      var scriptLoadedCallbacks = {};
	      var queueLoadedCallbacks = [];
	      var loading = 0;
	      var loadScript = function (url, success, failure) {
	        var dom = DOM;
	        var elm, id;
	        var done = function () {
	          dom.remove(id);
	          if (elm) {
	            elm.onreadystatechange = elm.onload = elm = null;
	          }
	          success();
	        };
	        var error = function () {
	          if (isFunction$1(failure)) {
	            failure();
	          } else {
	            if (typeof console !== 'undefined' && console.log) {
	              console.log('Failed to load script: ' + url);
	            }
	          }
	        };
	        id = dom.uniqueId();
	        elm = domGlobals.document.createElement('script');
	        elm.id = id;
	        elm.type = 'text/javascript';
	        elm.src = Tools._addCacheSuffix(url);
	        elm.onload = done;
	        elm.onerror = error;
	        (domGlobals.document.getElementsByTagName('head')[0] || domGlobals.document.body).appendChild(elm);
	      };
	      this.isDone = function (url) {
	        return states[url] === LOADED;
	      };
	      this.markDone = function (url) {
	        states[url] = LOADED;
	      };
	      this.add = this.load = function (url, success, scope, failure) {
	        var state = states[url];
	        if (state === undefined) {
	          queue.push(url);
	          states[url] = QUEUED;
	        }
	        if (success) {
	          if (!scriptLoadedCallbacks[url]) {
	            scriptLoadedCallbacks[url] = [];
	          }
	          scriptLoadedCallbacks[url].push({
	            success: success,
	            failure: failure,
	            scope: scope || this
	          });
	        }
	      };
	      this.remove = function (url) {
	        delete states[url];
	        delete scriptLoadedCallbacks[url];
	      };
	      this.loadQueue = function (success, scope, failure) {
	        this.loadScripts(queue, success, scope, failure);
	      };
	      this.loadScripts = function (scripts, success, scope, failure) {
	        var loadScripts;
	        var failures = [];
	        var execCallbacks = function (name, url) {
	          each$6(scriptLoadedCallbacks[url], function (callback) {
	            if (isFunction$1(callback[name])) {
	              callback[name].call(callback.scope);
	            }
	          });
	          scriptLoadedCallbacks[url] = undefined;
	        };
	        queueLoadedCallbacks.push({
	          success: success,
	          failure: failure,
	          scope: scope || this
	        });
	        loadScripts = function () {
	          var loadingScripts = grep$2(scripts);
	          scripts.length = 0;
	          each$6(loadingScripts, function (url) {
	            if (states[url] === LOADED) {
	              execCallbacks('success', url);
	              return;
	            }
	            if (states[url] === FAILED) {
	              execCallbacks('failure', url);
	              return;
	            }
	            if (states[url] !== LOADING) {
	              states[url] = LOADING;
	              loading++;
	              loadScript(url, function () {
	                states[url] = LOADED;
	                loading--;
	                execCallbacks('success', url);
	                loadScripts();
	              }, function () {
	                states[url] = FAILED;
	                loading--;
	                failures.push(url);
	                execCallbacks('failure', url);
	                loadScripts();
	              });
	            }
	          });
	          if (!loading) {
	            var notifyCallbacks = queueLoadedCallbacks.slice(0);
	            queueLoadedCallbacks.length = 0;
	            each$6(notifyCallbacks, function (callback) {
	              if (failures.length === 0) {
	                if (isFunction$1(callback.success)) {
	                  callback.success.call(callback.scope);
	                }
	              } else {
	                if (isFunction$1(callback.failure)) {
	                  callback.failure.call(callback.scope, failures);
	                }
	              }
	            });
	          }
	        };
	        loadScripts();
	      };
	    };
	    ScriptLoader.ScriptLoader = new ScriptLoader();
	
	    var each$7 = Tools.each;
	    function AddOnManager() {
	      var _this = this;
	      var items = [];
	      var urls = {};
	      var lookup = {};
	      var _listeners = [];
	      var get = function (name) {
	        if (lookup[name]) {
	          return lookup[name].instance;
	        }
	        return undefined;
	      };
	      var dependencies = function (name) {
	        var result;
	        if (lookup[name]) {
	          result = lookup[name].dependencies;
	        }
	        return result || [];
	      };
	      var requireLangPack = function (name, languages) {
	        var language = AddOnManager.language;
	        if (language && AddOnManager.languageLoad !== false) {
	          if (languages) {
	            languages = ',' + languages + ',';
	            if (languages.indexOf(',' + language.substr(0, 2) + ',') !== -1) {
	              language = language.substr(0, 2);
	            } else if (languages.indexOf(',' + language + ',') === -1) {
	              return;
	            }
	          }
	          ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
	        }
	      };
	      var add = function (id, addOn, dependencies) {
	        items.push(addOn);
	        lookup[id] = {
	          instance: addOn,
	          dependencies: dependencies
	        };
	        var result = partition(_listeners, function (listener) {
	          return listener.name === id;
	        });
	        _listeners = result.fail;
	        each$7(result.pass, function (listener) {
	          listener.callback();
	        });
	        return addOn;
	      };
	      var remove = function (name) {
	        delete urls[name];
	        delete lookup[name];
	      };
	      var createUrl = function (baseUrl, dep) {
	        if (typeof dep === 'object') {
	          return dep;
	        }
	        return typeof baseUrl === 'string' ? {
	          prefix: '',
	          resource: dep,
	          suffix: ''
	        } : {
	          prefix: baseUrl.prefix,
	          resource: dep,
	          suffix: baseUrl.suffix
	        };
	      };
	      var addComponents = function (pluginName, scripts) {
	        var pluginUrl = _this.urls[pluginName];
	        each$7(scripts, function (script) {
	          ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
	        });
	      };
	      var loadDependencies = function (name, addOnUrl, success, scope) {
	        var deps = dependencies(name);
	        each$7(deps, function (dep) {
	          var newUrl = createUrl(addOnUrl, dep);
	          load(newUrl.resource, newUrl, undefined, undefined);
	        });
	        if (success) {
	          if (scope) {
	            success.call(scope);
	          } else {
	            success.call(ScriptLoader);
	          }
	        }
	      };
	      var load = function (name, addOnUrl, success, scope, failure) {
	        if (urls[name]) {
	          return;
	        }
	        var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
	        if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
	          urlString = AddOnManager.baseURL + '/' + urlString;
	        }
	        urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
	        if (lookup[name]) {
	          loadDependencies(name, addOnUrl, success, scope);
	        } else {
	          ScriptLoader.ScriptLoader.add(urlString, function () {
	            return loadDependencies(name, addOnUrl, success, scope);
	          }, scope, failure);
	        }
	      };
	      var waitFor = function (name, callback) {
	        if (lookup.hasOwnProperty(name)) {
	          callback();
	        } else {
	          _listeners.push({
	            name: name,
	            callback: callback
	          });
	        }
	      };
	      return {
	        items: items,
	        urls: urls,
	        lookup: lookup,
	        _listeners: _listeners,
	        get: get,
	        dependencies: dependencies,
	        requireLangPack: requireLangPack,
	        add: add,
	        remove: remove,
	        createUrl: createUrl,
	        addComponents: addComponents,
	        load: load,
	        waitFor: waitFor
	      };
	    }
	    (function (AddOnManager) {
	      AddOnManager.PluginManager = AddOnManager();
	      AddOnManager.ThemeManager = AddOnManager();
	    }(AddOnManager || (AddOnManager = {})));
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom().insertBefore(element.dom(), v.dom());
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	    var wrap$1 = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom().textContent = '';
	      each(children(element), function (rogue) {
	        remove$1(rogue);
	      });
	    };
	    var remove$1 = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove$1(wrapper);
	    };
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer === null) {
	          timer = domGlobals.setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	        }
	        timer = domGlobals.setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var read = function (element, attr) {
	      var value = get(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$2 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom().classList !== undefined;
	    };
	    var get$2 = function (element) {
	      return read(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$2(element, 'class', clazz);
	    };
	
	    var add$2 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom().classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom().classList : get$2(element);
	      if (classList.length === 0) {
	        remove(element, 'class');
	      }
	    };
	    var remove$4 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom().classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$2 = function (element, clazz) {
	      return supports(element) && element.dom().classList.contains(clazz);
	    };
	
	    var descendants = function (scope, predicate) {
	      var result = [];
	      each(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    var descendants$1 = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      return is(scope, a) ? Option.some(scope) : isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
	    }
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom();
	      var stop = isFunction(isRoot) ? isRoot : constant(false);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = Element.fromDom(element);
	        if (predicate(el)) {
	          return Option.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Option.none();
	    };
	    var closest = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor(scope, function (e) {
	        return is$1(e, selector);
	      }, isRoot);
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      return ClosestOrAncestor(is$1, ancestor$1, scope, selector, isRoot);
	    };
	
	    var annotation = constant('mce-annotation');
	    var dataAnnotation = constant('data-mce-annotation');
	    var dataAnnotationId = constant('data-mce-annotation-uid');
	
	    var identify = function (editor, annotationName) {
	      var rng = editor.selection.getRng();
	      var start = Element.fromDom(rng.startContainer);
	      var root = Element.fromDom(editor.getBody());
	      var selector = annotationName.fold(function () {
	        return '.' + annotation();
	      }, function (an) {
	        return '[' + dataAnnotation() + '="' + an + '"]';
	      });
	      var newStart = child(start, rng.startOffset).getOr(start);
	      var closest = closest$1(newStart, selector, function (n) {
	        return eq(n, root);
	      });
	      var getAttr = function (c, property) {
	        if (has$1(c, property)) {
	          return Option.some(get(c, property));
	        } else {
	          return Option.none();
	        }
	      };
	      return closest.bind(function (c) {
	        return getAttr(c, '' + dataAnnotationId()).bind(function (uid) {
	          return getAttr(c, '' + dataAnnotation()).map(function (name) {
	            var elements = findMarkers(editor, uid);
	            return {
	              uid: uid,
	              name: name,
	              elements: elements
	            };
	          });
	        });
	      });
	    };
	    var isAnnotation = function (elem) {
	      return isElement(elem) && has$2(elem, annotation());
	    };
	    var findMarkers = function (editor, uid) {
	      var body = Element.fromDom(editor.getBody());
	      return descendants$1(body, '[' + dataAnnotationId() + '="' + uid + '"]');
	    };
	    var findAll = function (editor, name) {
	      var body = Element.fromDom(editor.getBody());
	      var markers = descendants$1(body, '[' + dataAnnotation() + '="' + name + '"]');
	      var directory = {};
	      each(markers, function (m) {
	        var uid = get(m, dataAnnotationId());
	        var nodesAlready = directory.hasOwnProperty(uid) ? directory[uid] : [];
	        directory[uid] = nodesAlready.concat([m]);
	      });
	      return directory;
	    };
	
	    var setup = function (editor, registry) {
	      var changeCallbacks = Cell({});
	      var initData = function () {
	        return {
	          listeners: [],
	          previous: Cell(Option.none())
	        };
	      };
	      var withCallbacks = function (name, f) {
	        updateCallbacks(name, function (data) {
	          f(data);
	          return data;
	        });
	      };
	      var updateCallbacks = function (name, f) {
	        var callbackMap = changeCallbacks.get();
	        var data = callbackMap.hasOwnProperty(name) ? callbackMap[name] : initData();
	        var outputData = f(data);
	        callbackMap[name] = outputData;
	        changeCallbacks.set(callbackMap);
	      };
	      var fireCallbacks = function (name, uid, elements) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(true, name, {
	              uid: uid,
	              nodes: map(elements, function (elem) {
	                return elem.dom();
	              })
	            });
	          });
	        });
	      };
	      var fireNoAnnotation = function (name) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(false, name);
	          });
	        });
	      };
	      var onNodeChange = last$2(function () {
	        var callbackMap = changeCallbacks.get();
	        var annotations = sort(keys(callbackMap));
	        each(annotations, function (name) {
	          updateCallbacks(name, function (data) {
	            var prev = data.previous.get();
	            identify(editor, Option.some(name)).fold(function () {
	              if (prev.isSome()) {
	                fireNoAnnotation(name);
	                data.previous.set(Option.none());
	              }
	            }, function (_a) {
	              var uid = _a.uid, name = _a.name, elements = _a.elements;
	              if (!prev.is(uid)) {
	                fireCallbacks(name, uid, elements);
	                data.previous.set(Option.some(uid));
	              }
	            });
	            return {
	              previous: data.previous,
	              listeners: data.listeners
	            };
	          });
	        });
	      }, 30);
	      editor.on('remove', function () {
	        onNodeChange.cancel();
	      });
	      editor.on('nodeChange', function () {
	        onNodeChange.throttle();
	      });
	      var addListener = function (name, f) {
	        updateCallbacks(name, function (data) {
	          return {
	            previous: data.previous,
	            listeners: data.listeners.concat([f])
	          };
	        });
	      };
	      return { addListener: addListener };
	    };
	
	    var setup$1 = function (editor, registry) {
	      var identifyParserNode = function (span) {
	        var optAnnotation = Option.from(span.attributes.map[dataAnnotation()]);
	        return optAnnotation.bind(registry.lookup);
	      };
	      editor.on('init', function () {
	        editor.serializer.addNodeFilter('span', function (spans) {
	          each(spans, function (span) {
	            identifyParserNode(span).each(function (settings) {
	              if (settings.persistent === false) {
	                span.unwrap();
	              }
	            });
	          });
	        });
	      });
	    };
	
	    var create$1 = function () {
	      var annotations = {};
	      var register = function (name, settings) {
	        annotations[name] = {
	          name: name,
	          settings: settings
	        };
	      };
	      var lookup = function (name) {
	        return annotations.hasOwnProperty(name) ? Option.from(annotations[name]).map(function (a) {
	          return a.settings;
	        }) : Option.none();
	      };
	      return {
	        register: register,
	        lookup: lookup
	      };
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var unique = 0;
	    var generate = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var add$3 = function (element, classes) {
	      each(classes, function (x) {
	        add$2(element, x);
	      });
	    };
	
	    var clone = function (original, isDeep) {
	      return Element.fromDom(original.dom().cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone(original, false);
	    };
	    var deep = function (original) {
	      return clone(original, true);
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(Element.fromDom(div));
	    };
	
	    var get$3 = function (element) {
	      return element.dom().innerHTML;
	    };
	    var set$1 = function (element, content) {
	      var owner$1 = owner(element);
	      var docDom = owner$1.dom();
	      var fragment = Element.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml$1(content, docDom);
	      append$1(fragment, contentElements);
	      empty(element);
	      append(element, fragment);
	    };
	
	    var ZWSP = '\uFEFF';
	    var isZwsp = function (chr) {
	      return chr === ZWSP;
	    };
	    var trim$3 = function (text) {
	      return text.replace(new RegExp(ZWSP, 'g'), '');
	    };
	    var Zwsp = {
	      isZwsp: isZwsp,
	      ZWSP: ZWSP,
	      trim: trim$3
	    };
	
	    var isElement$2 = NodeType.isElement;
	    var isText$2 = NodeType.isText;
	    var isCaretContainerBlock = function (node) {
	      if (isText$2(node)) {
	        node = node.parentNode;
	      }
	      return isElement$2(node) && node.hasAttribute('data-mce-caret');
	    };
	    var isCaretContainerInline = function (node) {
	      return isText$2(node) && Zwsp.isZwsp(node.data);
	    };
	    var isCaretContainer = function (node) {
	      return isCaretContainerBlock(node) || isCaretContainerInline(node);
	    };
	    var hasContent = function (node) {
	      return node.firstChild !== node.lastChild || !NodeType.isBr(node.firstChild);
	    };
	    var insertInline = function (node, before) {
	      var doc, sibling, textNode, parentNode;
	      doc = node.ownerDocument;
	      textNode = doc.createTextNode(Zwsp.ZWSP);
	      parentNode = node.parentNode;
	      if (!before) {
	        sibling = node.nextSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (startsWithCaretContainer(sibling)) {
	            sibling.splitText(1);
	            return sibling;
	          }
	        }
	        if (node.nextSibling) {
	          parentNode.insertBefore(textNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(textNode);
	        }
	      } else {
	        sibling = node.previousSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (endsWithCaretContainer(sibling)) {
	            return sibling.splitText(sibling.data.length - 1);
	          }
	        }
	        parentNode.insertBefore(textNode, node);
	      }
	      return textNode;
	    };
	    var isBeforeInline = function (pos) {
	      var container = pos.container();
	      if (!pos || !NodeType.isText(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset()) === Zwsp.ZWSP || pos.isAtStart() && isCaretContainerInline(container.previousSibling);
	    };
	    var isAfterInline = function (pos) {
	      var container = pos.container();
	      if (!pos || !NodeType.isText(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset() - 1) === Zwsp.ZWSP || pos.isAtEnd() && isCaretContainerInline(container.nextSibling);
	    };
	    var createBogusBr = function () {
	      var br = domGlobals.document.createElement('br');
	      br.setAttribute('data-mce-bogus', '1');
	      return br;
	    };
	    var insertBlock = function (blockName, node, before) {
	      var doc, blockNode, parentNode;
	      doc = node.ownerDocument;
	      blockNode = doc.createElement(blockName);
	      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
	      blockNode.setAttribute('data-mce-bogus', 'all');
	      blockNode.appendChild(createBogusBr());
	      parentNode = node.parentNode;
	      if (!before) {
	        if (node.nextSibling) {
	          parentNode.insertBefore(blockNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(blockNode);
	        }
	      } else {
	        parentNode.insertBefore(blockNode, node);
	      }
	      return blockNode;
	    };
	    var startsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[0] === Zwsp.ZWSP;
	    };
	    var endsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[node.data.length - 1] === Zwsp.ZWSP;
	    };
	    var trimBogusBr = function (elm) {
	      var brs = elm.getElementsByTagName('br');
	      var lastBr = brs[brs.length - 1];
	      if (NodeType.isBogus(lastBr)) {
	        lastBr.parentNode.removeChild(lastBr);
	      }
	    };
	    var showCaretContainerBlock = function (caretContainer) {
	      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
	        trimBogusBr(caretContainer);
	        caretContainer.removeAttribute('data-mce-caret');
	        caretContainer.removeAttribute('data-mce-bogus');
	        caretContainer.removeAttribute('style');
	        caretContainer.removeAttribute('_moz_abspos');
	        return caretContainer;
	      }
	      return null;
	    };
	    var isRangeInCaretContainerBlock = function (range) {
	      return isCaretContainerBlock(range.startContainer);
	    };
	
	    var isContentEditableTrue$1 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$1 = NodeType.isContentEditableFalse;
	    var isBr$2 = NodeType.isBr;
	    var isText$3 = NodeType.isText;
	    var isInvalidTextElement = NodeType.matchNodeNames('script style textarea');
	    var isAtomicInline = NodeType.matchNodeNames('img input textarea hr iframe video audio object');
	    var isTable$1 = NodeType.matchNodeNames('table');
	    var isCaretContainer$1 = isCaretContainer;
	    var isCaretCandidate = function (node) {
	      if (isCaretContainer$1(node)) {
	        return false;
	      }
	      if (isText$3(node)) {
	        if (isInvalidTextElement(node.parentNode)) {
	          return false;
	        }
	        return true;
	      }
	      return isAtomicInline(node) || isBr$2(node) || isTable$1(node) || isNonUiContentEditableFalse(node);
	    };
	    var isUnselectable = function (node) {
	      return NodeType.isElement(node) && node.getAttribute('unselectable') === 'true';
	    };
	    var isNonUiContentEditableFalse = function (node) {
	      return isUnselectable(node) === false && isContentEditableFalse$1(node);
	    };
	    var isInEditable = function (node, root) {
	      for (node = node.parentNode; node && node !== root; node = node.parentNode) {
	        if (isNonUiContentEditableFalse(node)) {
	          return false;
	        }
	        if (isContentEditableTrue$1(node)) {
	          return true;
	        }
	      }
	      return true;
	    };
	    var isAtomicContentEditableFalse = function (node) {
	      if (!isNonUiContentEditableFalse(node)) {
	        return false;
	      }
	      return foldl(from$1(node.getElementsByTagName('*')), function (result, elm) {
	        return result || isContentEditableTrue$1(elm);
	      }, false) !== true;
	    };
	    var isAtomic = function (node) {
	      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
	    };
	    var isEditableCaretCandidate = function (node, root) {
	      return isCaretCandidate(node) && isInEditable(node, root);
	    };
	
	    var round = Math.round;
	    var clone$1 = function (rect) {
	      if (!rect) {
	        return {
	          left: 0,
	          top: 0,
	          bottom: 0,
	          right: 0,
	          width: 0,
	          height: 0
	        };
	      }
	      return {
	        left: round(rect.left),
	        top: round(rect.top),
	        bottom: round(rect.bottom),
	        right: round(rect.right),
	        width: round(rect.width),
	        height: round(rect.height)
	      };
	    };
	    var collapse = function (rect, toStart) {
	      rect = clone$1(rect);
	      if (toStart) {
	        rect.right = rect.left;
	      } else {
	        rect.left = rect.left + rect.width;
	        rect.right = rect.left;
	      }
	      rect.width = 0;
	      return rect;
	    };
	    var isEqual = function (rect1, rect2) {
	      return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
	    };
	    var isValidOverflow = function (overflowY, rect1, rect2) {
	      return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
	    };
	    var isAbove = function (rect1, rect2) {
	      var halfHeight = Math.min(rect2.height / 2, rect1.height / 2);
	      if (rect1.bottom - halfHeight < rect2.top) {
	        return true;
	      }
	      if (rect1.top > rect2.bottom) {
	        return false;
	      }
	      return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
	    };
	    var isBelow = function (rect1, rect2) {
	      if (rect1.top > rect2.bottom) {
	        return true;
	      }
	      if (rect1.bottom < rect2.top) {
	        return false;
	      }
	      return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
	    };
	    var containsXY = function (rect, clientX, clientY) {
	      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
	    };
	    var overflowX = function (outer, inner) {
	      if (inner.left > outer.left && inner.right < outer.right) {
	        return 0;
	      } else {
	        return inner.left < outer.left ? inner.left - outer.left : inner.right - outer.right;
	      }
	    };
	    var overflowY = function (outer, inner) {
	      if (inner.top > outer.top && inner.bottom < outer.bottom) {
	        return 0;
	      } else {
	        return inner.top < outer.top ? inner.top - outer.top : inner.bottom - outer.bottom;
	      }
	    };
	    var getOverflow = function (outer, inner) {
	      return {
	        x: overflowX(outer, inner),
	        y: overflowY(outer, inner)
	      };
	    };
	
	    var getSelectedNode = function (range) {
	      var startContainer = range.startContainer, startOffset = range.startOffset;
	      if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
	        return startContainer.childNodes[startOffset];
	      }
	      return null;
	    };
	    var getNode = function (container, offset) {
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        if (offset >= container.childNodes.length) {
	          offset = container.childNodes.length - 1;
	        }
	        container = container.childNodes[offset];
	      }
	      return container;
	    };
	
	    var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]');
	    var isExtendingChar = function (ch) {
	      return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	    };
	
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie())) : Option.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Option.none();
	    };
	
	    var slice$2 = [].slice;
	    var or = function () {
	      var x = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        x[_i] = arguments[_i];
	      }
	      var args = slice$2.call(arguments);
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (args[i](x)) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var and = function () {
	      var x = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        x[_i] = arguments[_i];
	      }
	      var args = slice$2.call(arguments);
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (!args[i](x)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    };
	    var Predicate = {
	      and: and,
	      or: or
	    };
	
	    var isElement$3 = NodeType.isElement;
	    var isCaretCandidate$1 = isCaretCandidate;
	    var isBlock$1 = NodeType.matchStyleValues('display', 'block table');
	    var isFloated = NodeType.matchStyleValues('float', 'left right');
	    var isValidElementCaretCandidate = Predicate.and(isElement$3, isCaretCandidate$1, not(isFloated));
	    var isNotPre = not(NodeType.matchStyleValues('white-space', 'pre pre-line pre-wrap'));
	    var isText$4 = NodeType.isText;
	    var isBr$3 = NodeType.isBr;
	    var nodeIndex = DOMUtils$1.nodeIndex;
	    var resolveIndex = getNode;
	    var createRange = function (doc) {
	      return 'createRange' in doc ? doc.createRange() : DOMUtils$1.DOM.createRng();
	    };
	    var isWhiteSpace = function (chr) {
	      return chr && /[\r\n\t ]/.test(chr);
	    };
	    var isRange = function (rng) {
	      return !!rng.setStart && !!rng.setEnd;
	    };
	    var isHiddenWhiteSpaceRange = function (range) {
	      var container = range.startContainer;
	      var offset = range.startOffset;
	      var text;
	      if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode) && NodeType.isText(container)) {
	        text = container.data;
	        if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var getBrClientRect = function (brNode) {
	      var doc = brNode.ownerDocument;
	      var rng = createRange(doc);
	      var nbsp = doc.createTextNode('\xA0');
	      var parentNode = brNode.parentNode;
	      var clientRect;
	      parentNode.insertBefore(nbsp, brNode);
	      rng.setStart(nbsp, 0);
	      rng.setEnd(nbsp, 1);
	      clientRect = clone$1(rng.getBoundingClientRect());
	      parentNode.removeChild(nbsp);
	      return clientRect;
	    };
	    var getBoundingClientRectWebKitText = function (rng) {
	      var sc = rng.startContainer;
	      var ec = rng.endContainer;
	      var so = rng.startOffset;
	      var eo = rng.endOffset;
	      if (sc === ec && NodeType.isText(ec) && so === 0 && eo === 1) {
	        var newRng = rng.cloneRange();
	        newRng.setEndAfter(ec);
	        return getBoundingClientRect(newRng);
	      } else {
	        return null;
	      }
	    };
	    var isZeroRect = function (r) {
	      return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
	    };
	    var getBoundingClientRect = function (item) {
	      var clientRect, clientRects;
	      clientRects = item.getClientRects();
	      if (clientRects.length > 0) {
	        clientRect = clone$1(clientRects[0]);
	      } else {
	        clientRect = clone$1(item.getBoundingClientRect());
	      }
	      if (!isRange(item) && isBr$3(item) && isZeroRect(clientRect)) {
	        return getBrClientRect(item);
	      }
	      if (isZeroRect(clientRect) && isRange(item)) {
	        return getBoundingClientRectWebKitText(item);
	      }
	      return clientRect;
	    };
	    var collapseAndInflateWidth = function (clientRect, toStart) {
	      var newClientRect = collapse(clientRect, toStart);
	      newClientRect.width = 1;
	      newClientRect.right = newClientRect.left + 1;
	      return newClientRect;
	    };
	    var getCaretPositionClientRects = function (caretPosition) {
	      var clientRects = [];
	      var beforeNode, node;
	      var addUniqueAndValidRect = function (clientRect) {
	        if (clientRect.height === 0) {
	          return;
	        }
	        if (clientRects.length > 0) {
	          if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
	            return;
	          }
	        }
	        clientRects.push(clientRect);
	      };
	      var addCharacterOffset = function (container, offset) {
	        var range = createRange(container.ownerDocument);
	        if (offset < container.data.length) {
	          if (isExtendingChar(container.data[offset])) {
	            return clientRects;
	          }
	          if (isExtendingChar(container.data[offset - 1])) {
	            range.setStart(container, offset);
	            range.setEnd(container, offset + 1);
	            if (!isHiddenWhiteSpaceRange(range)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	              return clientRects;
	            }
	          }
	        }
	        if (offset > 0) {
	          range.setStart(container, offset - 1);
	          range.setEnd(container, offset);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	          }
	        }
	        if (offset < container.data.length) {
	          range.setStart(container, offset);
	          range.setEnd(container, offset + 1);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
	          }
	        }
	      };
	      if (isText$4(caretPosition.container())) {
	        addCharacterOffset(caretPosition.container(), caretPosition.offset());
	        return clientRects;
	      }
	      if (isElement$3(caretPosition.container())) {
	        if (caretPosition.isAtEnd()) {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, node.data.length);
	          }
	          if (isValidElementCaretCandidate(node) && !isBr$3(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	          }
	        } else {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, 0);
	          }
	          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	            return clientRects;
	          }
	          beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
	          if (isValidElementCaretCandidate(beforeNode) && !isBr$3(beforeNode)) {
	            if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
	            }
	          }
	          if (isValidElementCaretCandidate(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
	          }
	        }
	      }
	      return clientRects;
	    };
	    function CaretPosition(container, offset, clientRects) {
	      var isAtStart = function () {
	        if (isText$4(container)) {
	          return offset === 0;
	        }
	        return offset === 0;
	      };
	      var isAtEnd = function () {
	        if (isText$4(container)) {
	          return offset >= container.data.length;
	        }
	        return offset >= container.childNodes.length;
	      };
	      var toRange = function () {
	        var range;
	        range = createRange(container.ownerDocument);
	        range.setStart(container, offset);
	        range.setEnd(container, offset);
	        return range;
	      };
	      var getClientRects = function () {
	        if (!clientRects) {
	          clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
	        }
	        return clientRects;
	      };
	      var isVisible = function () {
	        return getClientRects().length > 0;
	      };
	      var isEqual = function (caretPosition) {
	        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
	      };
	      var getNode = function (before) {
	        return resolveIndex(container, before ? offset - 1 : offset);
	      };
	      return {
	        container: constant(container),
	        offset: constant(offset),
	        toRange: toRange,
	        getClientRects: getClientRects,
	        isVisible: isVisible,
	        isAtStart: isAtStart,
	        isAtEnd: isAtEnd,
	        isEqual: isEqual,
	        getNode: getNode
	      };
	    }
	    (function (CaretPosition) {
	      CaretPosition.fromRangeStart = function (range) {
	        return CaretPosition(range.startContainer, range.startOffset);
	      };
	      CaretPosition.fromRangeEnd = function (range) {
	        return CaretPosition(range.endContainer, range.endOffset);
	      };
	      CaretPosition.after = function (node) {
	        return CaretPosition(node.parentNode, nodeIndex(node) + 1);
	      };
	      CaretPosition.before = function (node) {
	        return CaretPosition(node.parentNode, nodeIndex(node));
	      };
	      CaretPosition.isAbove = function (pos1, pos2) {
	        return lift2(head(pos2.getClientRects()), last(pos1.getClientRects()), isAbove).getOr(false);
	      };
	      CaretPosition.isBelow = function (pos1, pos2) {
	        return lift2(last(pos2.getClientRects()), head(pos1.getClientRects()), isBelow).getOr(false);
	      };
	      CaretPosition.isAtStart = function (pos) {
	        return pos ? pos.isAtStart() : false;
	      };
	      CaretPosition.isAtEnd = function (pos) {
	        return pos ? pos.isAtEnd() : false;
	      };
	      CaretPosition.isTextPosition = function (pos) {
	        return pos ? NodeType.isText(pos.container()) : false;
	      };
	      CaretPosition.isElementPosition = function (pos) {
	        return CaretPosition.isTextPosition(pos) === false;
	      };
	    }(CaretPosition || (CaretPosition = {})));
	    var CaretPosition$1 = CaretPosition;
	
	    var isText$5 = NodeType.isText;
	    var isBogus$1 = NodeType.isBogus;
	    var nodeIndex$1 = DOMUtils$1.nodeIndex;
	    var normalizedParent = function (node) {
	      var parentNode = node.parentNode;
	      if (isBogus$1(parentNode)) {
	        return normalizedParent(parentNode);
	      }
	      return parentNode;
	    };
	    var getChildNodes = function (node) {
	      if (!node) {
	        return [];
	      }
	      return ArrUtils.reduce(node.childNodes, function (result, node) {
	        if (isBogus$1(node) && node.nodeName !== 'BR') {
	          result = result.concat(getChildNodes(node));
	        } else {
	          result.push(node);
	        }
	        return result;
	      }, []);
	    };
	    var normalizedTextOffset = function (node, offset) {
	      while (node = node.previousSibling) {
	        if (!isText$5(node)) {
	          break;
	        }
	        offset += node.data.length;
	      }
	      return offset;
	    };
	    var equal = function (a) {
	      return function (b) {
	        return a === b;
	      };
	    };
	    var normalizedNodeIndex = function (node) {
	      var nodes, index, numTextFragments;
	      nodes = getChildNodes(normalizedParent(node));
	      index = ArrUtils.findIndex(nodes, equal(node), node);
	      nodes = nodes.slice(0, index + 1);
	      numTextFragments = ArrUtils.reduce(nodes, function (result, node, i) {
	        if (isText$5(node) && isText$5(nodes[i - 1])) {
	          result++;
	        }
	        return result;
	      }, 0);
	      nodes = ArrUtils.filter(nodes, NodeType.matchNodeNames(node.nodeName));
	      index = ArrUtils.findIndex(nodes, equal(node), node);
	      return index - numTextFragments;
	    };
	    var createPathItem = function (node) {
	      var name;
	      if (isText$5(node)) {
	        name = 'text()';
	      } else {
	        name = node.nodeName.toLowerCase();
	      }
	      return name + '[' + normalizedNodeIndex(node) + ']';
	    };
	    var parentsUntil = function (root, node, predicate) {
	      var parents = [];
	      for (node = node.parentNode; node !== root; node = node.parentNode) {
	        if (predicate && predicate(node)) {
	          break;
	        }
	        parents.push(node);
	      }
	      return parents;
	    };
	    var create$2 = function (root, caretPosition) {
	      var container, offset, path = [], outputOffset, childNodes, parents;
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (isText$5(container)) {
	        outputOffset = normalizedTextOffset(container, offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length) {
	          outputOffset = 'after';
	          offset = childNodes.length - 1;
	        } else {
	          outputOffset = 'before';
	        }
	        container = childNodes[offset];
	      }
	      path.push(createPathItem(container));
	      parents = parentsUntil(root, container);
	      parents = ArrUtils.filter(parents, not(NodeType.isBogus));
	      path = path.concat(ArrUtils.map(parents, function (node) {
	        return createPathItem(node);
	      }));
	      return path.reverse().join('/') + ',' + outputOffset;
	    };
	    var resolvePathItem = function (node, name, index) {
	      var nodes = getChildNodes(node);
	      nodes = ArrUtils.filter(nodes, function (node, index) {
	        return !isText$5(node) || !isText$5(nodes[index - 1]);
	      });
	      nodes = ArrUtils.filter(nodes, NodeType.matchNodeNames(name));
	      return nodes[index];
	    };
	    var findTextPosition = function (container, offset) {
	      var node = container, targetOffset = 0, dataLen;
	      while (isText$5(node)) {
	        dataLen = node.data.length;
	        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
	          container = node;
	          offset = offset - targetOffset;
	          break;
	        }
	        if (!isText$5(node.nextSibling)) {
	          container = node;
	          offset = dataLen;
	          break;
	        }
	        targetOffset += dataLen;
	        node = node.nextSibling;
	      }
	      if (isText$5(container) && offset > container.data.length) {
	        offset = container.data.length;
	      }
	      return CaretPosition$1(container, offset);
	    };
	    var resolve$2 = function (root, path) {
	      var parts, container, offset;
	      if (!path) {
	        return null;
	      }
	      parts = path.split(',');
	      path = parts[0].split('/');
	      offset = parts.length > 1 ? parts[1] : 'before';
	      container = ArrUtils.reduce(path, function (result, value) {
	        value = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
	        if (!value) {
	          return null;
	        }
	        if (value[1] === 'text()') {
	          value[1] = '#text';
	        }
	        return resolvePathItem(result, value[1], parseInt(value[2], 10));
	      }, root);
	      if (!container) {
	        return null;
	      }
	      if (!isText$5(container)) {
	        if (offset === 'after') {
	          offset = nodeIndex$1(container) + 1;
	        } else {
	          offset = nodeIndex$1(container);
	        }
	        return CaretPosition$1(container.parentNode, offset);
	      }
	      return findTextPosition(container, parseInt(offset, 10));
	    };
	
	    var trimEmptyTextNode = function (dom, node) {
	      if (NodeType.isText(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var insertNode = function (dom, rng, node) {
	      rng.insertNode(node);
	      trimEmptyTextNode(dom, node.previousSibling);
	      trimEmptyTextNode(dom, node.nextSibling);
	    };
	    var insertFragment = function (dom, rng, frag) {
	      var firstChild = Option.from(frag.firstChild);
	      var lastChild = Option.from(frag.lastChild);
	      rng.insertNode(frag);
	      firstChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.previousSibling);
	      });
	      lastChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.nextSibling);
	      });
	    };
	    var rangeInsertNode = function (dom, rng, node) {
	      if (NodeType.isDocumentFragment(node)) {
	        insertFragment(dom, rng, node);
	      } else {
	        insertNode(dom, rng, node);
	      }
	    };
	
	    var isContentEditableFalse$2 = NodeType.isContentEditableFalse;
	    var getNormalizedTextOffset = function (trim, container, offset) {
	      var node, trimmedOffset;
	      trimmedOffset = trim(container.data.slice(0, offset)).length;
	      for (node = container.previousSibling; node && NodeType.isText(node); node = node.previousSibling) {
	        trimmedOffset += trim(node.data).length;
	      }
	      return trimmedOffset;
	    };
	    var getPoint = function (dom, trim, normalized, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      var point = [];
	      var childNodes, after = 0;
	      var root = dom.getRoot();
	      if (NodeType.isText(container)) {
	        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length && childNodes.length) {
	          after = 1;
	          offset = Math.max(0, childNodes.length - 1);
	        }
	        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
	      }
	      for (; container && container !== root; container = container.parentNode) {
	        point.push(dom.nodeIndex(container, normalized));
	      }
	      return point;
	    };
	    var getLocation = function (trim, selection, normalized, rng) {
	      var dom = selection.dom, bookmark = {};
	      bookmark.start = getPoint(dom, trim, normalized, rng, true);
	      if (!selection.isCollapsed()) {
	        bookmark.end = getPoint(dom, trim, normalized, rng, false);
	      }
	      return bookmark;
	    };
	    var findIndex$2 = function (dom, name, element) {
	      var count = 0;
	      Tools.each(dom.select(name), function (node) {
	        if (node.getAttribute('data-mce-bogus') === 'all') {
	          return;
	        }
	        if (node === element) {
	          return false;
	        }
	        count++;
	      });
	      return count;
	    };
	    var moveEndPoint = function (rng, start) {
	      var container, offset, childNodes;
	      var prefix = start ? 'start' : 'end';
	      container = rng[prefix + 'Container'];
	      offset = rng[prefix + 'Offset'];
	      if (NodeType.isElement(container) && container.nodeName === 'TR') {
	        childNodes = container.childNodes;
	        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
	        if (container) {
	          offset = start ? 0 : container.childNodes.length;
	          rng['set' + (start ? 'Start' : 'End')](container, offset);
	        }
	      }
	    };
	    var normalizeTableCellSelection = function (rng) {
	      moveEndPoint(rng, true);
	      moveEndPoint(rng, false);
	      return rng;
	    };
	    var findSibling = function (node, offset) {
	      var sibling;
	      if (NodeType.isElement(node)) {
	        node = getNode(node, offset);
	        if (isContentEditableFalse$2(node)) {
	          return node;
	        }
	      }
	      if (isCaretContainer(node)) {
	        if (NodeType.isText(node) && isCaretContainerBlock(node)) {
	          node = node.parentNode;
	        }
	        sibling = node.previousSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	        sibling = node.nextSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	      }
	    };
	    var findAdjacentContentEditableFalseElm = function (rng) {
	      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
	    };
	    var getOffsetBookmark = function (trim, normalized, selection) {
	      var element = selection.getNode();
	      var name = element ? element.nodeName : null;
	      var rng = selection.getRng();
	      if (isContentEditableFalse$2(element) || name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, element)
	        };
	      }
	      var sibling = findAdjacentContentEditableFalseElm(rng);
	      if (sibling) {
	        name = sibling.tagName;
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, sibling)
	        };
	      }
	      return getLocation(trim, selection, normalized, rng);
	    };
	    var getCaretBookmark = function (selection) {
	      var rng = selection.getRng();
	      return {
	        start: create$2(selection.dom.getRoot(), CaretPosition$1.fromRangeStart(rng)),
	        end: create$2(selection.dom.getRoot(), CaretPosition$1.fromRangeEnd(rng))
	      };
	    };
	    var getRangeBookmark = function (selection) {
	      return { rng: selection.getRng() };
	    };
	    var createBookmarkSpan = function (dom, id, filled) {
	      var args = {
	        'data-mce-type': 'bookmark',
	        'id': id,
	        'style': 'overflow:hidden;line-height:0px'
	      };
	      return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
	    };
	    var getPersistentBookmark = function (selection, filled) {
	      var dom = selection.dom;
	      var rng = selection.getRng();
	      var id = dom.uniqueId();
	      var collapsed = selection.isCollapsed();
	      var element = selection.getNode();
	      var name = element.nodeName;
	      if (name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(dom, name, element)
	        };
	      }
	      var rng2 = normalizeTableCellSelection(rng.cloneRange());
	      if (!collapsed) {
	        rng2.collapse(false);
	        var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
	        rangeInsertNode(dom, rng2, endBookmarkNode);
	      }
	      rng = normalizeTableCellSelection(rng);
	      rng.collapse(true);
	      var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
	      rangeInsertNode(dom, rng, startBookmarkNode);
	      selection.moveToBookmark({
	        id: id,
	        keep: 1
	      });
	      return { id: id };
	    };
	    var getBookmark = function (selection, type, normalized) {
	      if (type === 2) {
	        return getOffsetBookmark(Zwsp.trim, normalized, selection);
	      } else if (type === 3) {
	        return getCaretBookmark(selection);
	      } else if (type) {
	        return getRangeBookmark(selection);
	      } else {
	        return getPersistentBookmark(selection, false);
	      }
	    };
	    var GetBookmark = {
	      getBookmark: getBookmark,
	      getUndoBookmark: curry(getOffsetBookmark, identity, true),
	      getPersistentBookmark: getPersistentBookmark
	    };
	
	    var CARET_ID = '_mce_caret';
	    var isCaretNode = function (node) {
	      return NodeType.isElement(node) && node.id === CARET_ID;
	    };
	    var getParentCaretContainer = function (body, node) {
	      while (node && node !== body) {
	        if (node.id === CARET_ID) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isElement$4 = NodeType.isElement;
	    var isText$6 = NodeType.isText;
	    var removeNode = function (node) {
	      var parentNode = node.parentNode;
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	    };
	    var getNodeValue = function (node) {
	      try {
	        return node.nodeValue;
	      } catch (ex) {
	        return '';
	      }
	    };
	    var setNodeValue = function (node, text) {
	      if (text.length === 0) {
	        removeNode(node);
	      } else {
	        node.nodeValue = text;
	      }
	    };
	    var trimCount = function (text) {
	      var trimmedText = Zwsp.trim(text);
	      return {
	        count: text.length - trimmedText.length,
	        text: trimmedText
	      };
	    };
	    var removeUnchanged = function (caretContainer, pos) {
	      remove$5(caretContainer);
	      return pos;
	    };
	    var removeTextAndReposition = function (caretContainer, pos) {
	      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
	      var after = trimCount(caretContainer.data.substr(pos.offset()));
	      var text = before.text + after.text;
	      if (text.length > 0) {
	        setNodeValue(caretContainer, text);
	        return CaretPosition$1(caretContainer, pos.offset() - before.count);
	      } else {
	        return pos;
	      }
	    };
	    var removeElementAndReposition = function (caretContainer, pos) {
	      var parentNode = pos.container();
	      var newPosition = indexOf(from$1(parentNode.childNodes), caretContainer).map(function (index) {
	        return index < pos.offset() ? CaretPosition$1(parentNode, pos.offset() - 1) : pos;
	      }).getOr(pos);
	      remove$5(caretContainer);
	      return newPosition;
	    };
	    var removeTextCaretContainer = function (caretContainer, pos) {
	      return isText$6(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeElementCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeAndReposition = function (container, pos) {
	      return CaretPosition$1.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
	    };
	    var remove$5 = function (caretContainerNode) {
	      if (isElement$4(caretContainerNode) && isCaretContainer(caretContainerNode)) {
	        if (hasContent(caretContainerNode)) {
	          caretContainerNode.removeAttribute('data-mce-caret');
	        } else {
	          removeNode(caretContainerNode);
	        }
	      }
	      if (isText$6(caretContainerNode)) {
	        var text = Zwsp.trim(getNodeValue(caretContainerNode));
	        setNodeValue(caretContainerNode, text);
	      }
	    };
	    var CaretContainerRemove = {
	      removeAndReposition: removeAndReposition,
	      remove: remove$5
	    };
	
	    var browser$2 = PlatformDetection$1.detect().browser;
	    var isContentEditableFalse$3 = NodeType.isContentEditableFalse;
	    var isTableCell$1 = function (node) {
	      return NodeType.isElement(node) && /^(TD|TH)$/i.test(node.tagName);
	    };
	    var getAbsoluteClientRect = function (root, element, before) {
	      var clientRect = collapse(element.getBoundingClientRect(), before);
	      var docElm, scrollX, scrollY, margin, rootRect;
	      if (root.tagName === 'BODY') {
	        docElm = root.ownerDocument.documentElement;
	        scrollX = root.scrollLeft || docElm.scrollLeft;
	        scrollY = root.scrollTop || docElm.scrollTop;
	      } else {
	        rootRect = root.getBoundingClientRect();
	        scrollX = root.scrollLeft - rootRect.left;
	        scrollY = root.scrollTop - rootRect.top;
	      }
	      clientRect.left += scrollX;
	      clientRect.right += scrollX;
	      clientRect.top += scrollY;
	      clientRect.bottom += scrollY;
	      clientRect.width = 1;
	      margin = element.offsetWidth - element.clientWidth;
	      if (margin > 0) {
	        if (before) {
	          margin *= -1;
	        }
	        clientRect.left += margin;
	        clientRect.right += margin;
	      }
	      return clientRect;
	    };
	    var trimInlineCaretContainers = function (root) {
	      var contentEditableFalseNodes, node, sibling, i, data;
	      contentEditableFalseNodes = DomQuery('*[contentEditable=false]', root);
	      for (i = 0; i < contentEditableFalseNodes.length; i++) {
	        node = contentEditableFalseNodes[i];
	        sibling = node.previousSibling;
	        if (endsWithCaretContainer(sibling)) {
	          data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(data.length - 1, 1);
	          }
	        }
	        sibling = node.nextSibling;
	        if (startsWithCaretContainer(sibling)) {
	          data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(0, 1);
	          }
	        }
	      }
	    };
	    var FakeCaret = function (root, isBlock, hasFocus) {
	      var lastVisualCaret = Cell(Option.none());
	      var cursorInterval, caretContainerNode;
	      var show = function (before, element) {
	        var clientRect, rng;
	        hide();
	        if (isTableCell$1(element)) {
	          return null;
	        }
	        if (isBlock(element)) {
	          caretContainerNode = insertBlock('p', element, before);
	          clientRect = getAbsoluteClientRect(root, element, before);
	          DomQuery(caretContainerNode).css('top', clientRect.top);
	          var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(root)[0];
	          lastVisualCaret.set(Option.some({
	            caret: caret,
	            element: element,
	            before: before
	          }));
	          lastVisualCaret.get().each(function (caretState) {
	            if (before) {
	              DomQuery(caretState.caret).addClass('mce-visual-caret-before');
	            }
	          });
	          startBlink();
	          rng = element.ownerDocument.createRange();
	          rng.setStart(caretContainerNode, 0);
	          rng.setEnd(caretContainerNode, 0);
	        } else {
	          caretContainerNode = insertInline(element, before);
	          rng = element.ownerDocument.createRange();
	          if (isContentEditableFalse$3(caretContainerNode.nextSibling)) {
	            rng.setStart(caretContainerNode, 0);
	            rng.setEnd(caretContainerNode, 0);
	          } else {
	            rng.setStart(caretContainerNode, 1);
	            rng.setEnd(caretContainerNode, 1);
	          }
	          return rng;
	        }
	        return rng;
	      };
	      var hide = function () {
	        trimInlineCaretContainers(root);
	        if (caretContainerNode) {
	          CaretContainerRemove.remove(caretContainerNode);
	          caretContainerNode = null;
	        }
	        lastVisualCaret.get().each(function (caretState) {
	          DomQuery(caretState.caret).remove();
	          lastVisualCaret.set(Option.none());
	        });
	        clearInterval(cursorInterval);
	      };
	      var startBlink = function () {
	        cursorInterval = Delay.setInterval(function () {
	          if (hasFocus()) {
	            DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
	          } else {
	            DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
	          }
	        }, 500);
	      };
	      var reposition = function () {
	        lastVisualCaret.get().each(function (caretState) {
	          var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
	          DomQuery(caretState.caret).css(clientRect);
	        });
	      };
	      var destroy = function () {
	        return Delay.clearInterval(cursorInterval);
	      };
	      var getCss = function () {
	        return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
	      };
	      return {
	        show: show,
	        hide: hide,
	        getCss: getCss,
	        reposition: reposition,
	        destroy: destroy
	      };
	    };
	    var isFakeCaretTableBrowser = function () {
	      return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
	    };
	    var isFakeCaretTarget = function (node) {
	      return isContentEditableFalse$3(node) || NodeType.isTable(node) && isFakeCaretTableBrowser();
	    };
	
	    var isContentEditableFalse$4 = NodeType.isContentEditableFalse;
	    var isBlockLike = NodeType.matchStyleValues('display', 'block table table-cell table-caption list-item');
	    var isCaretContainer$2 = isCaretContainer;
	    var isCaretContainerBlock$1 = isCaretContainerBlock;
	    var isElement$5 = NodeType.isElement;
	    var isCaretCandidate$2 = isCaretCandidate;
	    var isForwards = function (direction) {
	      return direction > 0;
	    };
	    var isBackwards = function (direction) {
	      return direction < 0;
	    };
	    var skipCaretContainers = function (walk, shallow) {
	      var node;
	      while (node = walk(shallow)) {
	        if (!isCaretContainerBlock$1(node)) {
	          return node;
	        }
	      }
	      return null;
	    };
	    var findNode = function (node, direction, predicateFn, rootNode, shallow) {
	      var walker = new TreeWalker(node, rootNode);
	      if (isBackwards(direction)) {
	        if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
	          node = skipCaretContainers(walker.prev, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.prev, shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      if (isForwards(direction)) {
	        if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
	          node = skipCaretContainers(walker.next, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.next, shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var getParentBlock = function (node, rootNode) {
	      while (node && node !== rootNode) {
	        if (isBlockLike(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
	      return getParentBlock(caretPosition1.container(), rootNode) === getParentBlock(caretPosition2.container(), rootNode);
	    };
	    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
	      var container, offset;
	      if (!caretPosition) {
	        return null;
	      }
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (!isElement$5(container)) {
	        return null;
	      }
	      return container.childNodes[offset + relativeOffset];
	    };
	    var beforeAfter = function (before, node) {
	      var range = node.ownerDocument.createRange();
	      if (before) {
	        range.setStartBefore(node);
	        range.setEndBefore(node);
	      } else {
	        range.setStartAfter(node);
	        range.setEndAfter(node);
	      }
	      return range;
	    };
	    var isNodesInSameBlock = function (root, node1, node2) {
	      return getParentBlock(node1, root) === getParentBlock(node2, root);
	    };
	    var lean = function (left, root, node) {
	      var sibling, siblingName;
	      if (left) {
	        siblingName = 'previousSibling';
	      } else {
	        siblingName = 'nextSibling';
	      }
	      while (node && node !== root) {
	        sibling = node[siblingName];
	        if (isCaretContainer$2(sibling)) {
	          sibling = sibling[siblingName];
	        }
	        if (isContentEditableFalse$4(sibling)) {
	          if (isNodesInSameBlock(root, sibling, node)) {
	            return sibling;
	          }
	          break;
	        }
	        if (isCaretCandidate$2(sibling)) {
	          break;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var before$2 = curry(beforeAfter, true);
	    var after$1 = curry(beforeAfter, false);
	    var normalizeRange = function (direction, root, range) {
	      var node, container, offset, location;
	      var leanLeft = curry(lean, true, root);
	      var leanRight = curry(lean, false, root);
	      container = range.startContainer;
	      offset = range.startOffset;
	      if (isCaretContainerBlock(container)) {
	        if (!isElement$5(container)) {
	          container = container.parentNode;
	        }
	        location = container.getAttribute('data-mce-caret');
	        if (location === 'before') {
	          node = container.nextSibling;
	          if (isFakeCaretTarget(node)) {
	            return before$2(node);
	          }
	        }
	        if (location === 'after') {
	          node = container.previousSibling;
	          if (isFakeCaretTarget(node)) {
	            return after$1(node);
	          }
	        }
	      }
	      if (!range.collapsed) {
	        return range;
	      }
	      if (NodeType.isText(container)) {
	        if (isCaretContainer$2(container)) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (endsWithCaretContainer(container) && offset >= container.data.length - 1) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (startsWithCaretContainer(container) && offset <= 1) {
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          return range;
	        }
	        if (offset === container.data.length) {
	          node = leanRight(container);
	          if (node) {
	            return before$2(node);
	          }
	          return range;
	        }
	        if (offset === 0) {
	          node = leanLeft(container);
	          if (node) {
	            return after$1(node);
	          }
	          return range;
	        }
	      }
	      return range;
	    };
	    var getRelativeCefElm = function (forward, caretPosition) {
	      return Option.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$4);
	    };
	    var getNormalizedRangeEndPoint = function (direction, root, range) {
	      var normalizedRange = normalizeRange(direction, root, range);
	      if (direction === -1) {
	        return CaretPosition.fromRangeStart(normalizedRange);
	      }
	      return CaretPosition.fromRangeEnd(normalizedRange);
	    };
	    var getElementFromPosition = function (pos) {
	      return Option.from(pos.getNode()).map(Element.fromDom);
	    };
	    var getElementFromPrevPosition = function (pos) {
	      return Option.from(pos.getNode(true)).map(Element.fromDom);
	    };
	    var getVisualCaretPosition = function (walkFn, caretPosition) {
	      while (caretPosition = walkFn(caretPosition)) {
	        if (caretPosition.isVisible()) {
	          return caretPosition;
	        }
	      }
	      return caretPosition;
	    };
	    var isMoveInsideSameBlock = function (from, to) {
	      var inSameBlock = isInSameBlock(from, to);
	      if (!inSameBlock && NodeType.isBr(from.getNode())) {
	        return true;
	      }
	      return inSameBlock;
	    };
	
	    var HDirection;
	    (function (HDirection) {
	      HDirection[HDirection['Backwards'] = -1] = 'Backwards';
	      HDirection[HDirection['Forwards'] = 1] = 'Forwards';
	    }(HDirection || (HDirection = {})));
	    var isContentEditableFalse$5 = NodeType.isContentEditableFalse;
	    var isText$7 = NodeType.isText;
	    var isElement$6 = NodeType.isElement;
	    var isBr$4 = NodeType.isBr;
	    var isCaretCandidate$3 = isCaretCandidate;
	    var isAtomic$1 = isAtomic;
	    var isEditableCaretCandidate$1 = isEditableCaretCandidate;
	    var getParents = function (node, root) {
	      var parents = [];
	      while (node && node !== root) {
	        parents.push(node);
	        node = node.parentNode;
	      }
	      return parents;
	    };
	    var nodeAtIndex = function (container, offset) {
	      if (container.hasChildNodes() && offset < container.childNodes.length) {
	        return container.childNodes[offset];
	      }
	      return null;
	    };
	    var getCaretCandidatePosition = function (direction, node) {
	      if (isForwards(direction)) {
	        if (isCaretCandidate$3(node.previousSibling) && !isText$7(node.previousSibling)) {
	          return CaretPosition$1.before(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition$1(node, 0);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isCaretCandidate$3(node.nextSibling) && !isText$7(node.nextSibling)) {
	          return CaretPosition$1.after(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition$1(node, node.data.length);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isBr$4(node)) {
	          return CaretPosition$1.before(node);
	        }
	        return CaretPosition$1.after(node);
	      }
	      return CaretPosition$1.before(node);
	    };
	    var moveForwardFromBr = function (root, nextNode) {
	      var nextSibling = nextNode.nextSibling;
	      if (nextSibling && isCaretCandidate$3(nextSibling)) {
	        if (isText$7(nextSibling)) {
	          return CaretPosition$1(nextSibling, 0);
	        } else {
	          return CaretPosition$1.before(nextSibling);
	        }
	      } else {
	        return findCaretPosition(HDirection.Forwards, CaretPosition$1.after(nextNode), root);
	      }
	    };
	    var findCaretPosition = function (direction, startPos, root) {
	      var node, nextNode, innerNode;
	      var rootContentEditableFalseElm, caretPosition;
	      if (!isElement$6(root) || !startPos) {
	        return null;
	      }
	      if (startPos.isEqual(CaretPosition$1.after(root)) && root.lastChild) {
	        caretPosition = CaretPosition$1.after(root.lastChild);
	        if (isBackwards(direction) && isCaretCandidate$3(root.lastChild) && isElement$6(root.lastChild)) {
	          return isBr$4(root.lastChild) ? CaretPosition$1.before(root.lastChild) : caretPosition;
	        }
	      } else {
	        caretPosition = startPos;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (isText$7(container)) {
	        if (isBackwards(direction) && offset > 0) {
	          return CaretPosition$1(container, --offset);
	        }
	        if (isForwards(direction) && offset < container.length) {
	          return CaretPosition$1(container, ++offset);
	        }
	        node = container;
	      } else {
	        if (isBackwards(direction) && offset > 0) {
	          nextNode = nodeAtIndex(container, offset - 1);
	          if (isCaretCandidate$3(nextNode)) {
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition$1(innerNode, innerNode.data.length);
	                }
	                return CaretPosition$1.after(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition$1(nextNode, nextNode.data.length);
	            }
	            return CaretPosition$1.before(nextNode);
	          }
	        }
	        if (isForwards(direction) && offset < container.childNodes.length) {
	          nextNode = nodeAtIndex(container, offset);
	          if (isCaretCandidate$3(nextNode)) {
	            if (isBr$4(nextNode)) {
	              return moveForwardFromBr(root, nextNode);
	            }
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition$1(innerNode, 0);
	                }
	                return CaretPosition$1.before(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition$1(nextNode, 0);
	            }
	            return CaretPosition$1.after(nextNode);
	          }
	        }
	        node = nextNode ? nextNode : caretPosition.getNode();
	      }
	      if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
	        node = findNode(node, direction, constant(true), root, true);
	        if (isEditableCaretCandidate$1(node, root)) {
	          return getCaretCandidatePosition(direction, node);
	        }
	      }
	      nextNode = findNode(node, direction, isEditableCaretCandidate$1, root);
	      rootContentEditableFalseElm = ArrUtils.last(filter(getParents(container, root), isContentEditableFalse$5));
	      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
	        if (isForwards(direction)) {
	          caretPosition = CaretPosition$1.after(rootContentEditableFalseElm);
	        } else {
	          caretPosition = CaretPosition$1.before(rootContentEditableFalseElm);
	        }
	        return caretPosition;
	      }
	      if (nextNode) {
	        return getCaretCandidatePosition(direction, nextNode);
	      }
	      return null;
	    };
	    var CaretWalker = function (root) {
	      return {
	        next: function (caretPosition) {
	          return findCaretPosition(HDirection.Forwards, caretPosition, root);
	        },
	        prev: function (caretPosition) {
	          return findCaretPosition(HDirection.Backwards, caretPosition, root);
	        }
	      };
	    };
	
	    var walkToPositionIn = function (forward, root, start) {
	      var position = forward ? CaretPosition$1.before(start) : CaretPosition$1.after(start);
	      return fromPosition(forward, root, position);
	    };
	    var afterElement = function (node) {
	      return NodeType.isBr(node) ? CaretPosition$1.before(node) : CaretPosition$1.after(node);
	    };
	    var isBeforeOrStart = function (position) {
	      if (CaretPosition$1.isTextPosition(position)) {
	        return position.offset() === 0;
	      } else {
	        return isCaretCandidate(position.getNode());
	      }
	    };
	    var isAfterOrEnd = function (position) {
	      if (CaretPosition$1.isTextPosition(position)) {
	        var container = position.container();
	        return position.offset() === container.data.length;
	      } else {
	        return isCaretCandidate(position.getNode(true));
	      }
	    };
	    var isBeforeAfterSameElement = function (from, to) {
	      return !CaretPosition$1.isTextPosition(from) && !CaretPosition$1.isTextPosition(to) && from.getNode() === to.getNode(true);
	    };
	    var isAtBr = function (position) {
	      return !CaretPosition$1.isTextPosition(position) && NodeType.isBr(position.getNode());
	    };
	    var shouldSkipPosition = function (forward, from, to) {
	      if (forward) {
	        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
	      } else {
	        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
	      }
	    };
	    var fromPosition = function (forward, root, pos) {
	      var walker = CaretWalker(root);
	      return Option.from(forward ? walker.next(pos) : walker.prev(pos));
	    };
	    var navigate = function (forward, root, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
	          return fromPosition(forward, root, to);
	        } else {
	          return Option.some(to);
	        }
	      });
	    };
	    var navigateIgnore = function (forward, root, from, ignoreFilter) {
	      return navigate(forward, root, from).bind(function (pos) {
	        return ignoreFilter(pos) ? navigateIgnore(forward, root, pos, ignoreFilter) : Option.some(pos);
	      });
	    };
	    var positionIn = function (forward, element) {
	      var startNode = forward ? element.firstChild : element.lastChild;
	      if (NodeType.isText(startNode)) {
	        return Option.some(CaretPosition$1(startNode, forward ? 0 : startNode.data.length));
	      } else if (startNode) {
	        if (isCaretCandidate(startNode)) {
	          return Option.some(forward ? CaretPosition$1.before(startNode) : afterElement(startNode));
	        } else {
	          return walkToPositionIn(forward, element, startNode);
	        }
	      } else {
	        return Option.none();
	      }
	    };
	    var nextPosition = curry(fromPosition, true);
	    var prevPosition = curry(fromPosition, false);
	    var CaretFinder = {
	      fromPosition: fromPosition,
	      nextPosition: nextPosition,
	      prevPosition: prevPosition,
	      navigate: navigate,
	      navigateIgnore: navigateIgnore,
	      positionIn: positionIn,
	      firstPositionIn: curry(positionIn, true),
	      lastPositionIn: curry(positionIn, false)
	    };
	
	    var isStringPathBookmark = function (bookmark) {
	      return typeof bookmark.start === 'string';
	    };
	    var isRangeBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('rng');
	    };
	    var isIdBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('id');
	    };
	    var isIndexBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('name');
	    };
	    var isPathBookmark = function (bookmark) {
	      return Tools.isArray(bookmark.start);
	    };
	
	    var addBogus = function (dom, node) {
	      if (NodeType.isElement(node) && dom.isBlock(node) && !node.innerHTML && !Env.ie) {
	        node.innerHTML = '<br data-mce-bogus="1" />';
	      }
	      return node;
	    };
	    var resolveCaretPositionBookmark = function (dom, bookmark) {
	      var rng, pos;
	      rng = dom.createRng();
	      pos = resolve$2(dom.getRoot(), bookmark.start);
	      rng.setStart(pos.container(), pos.offset());
	      pos = resolve$2(dom.getRoot(), bookmark.end);
	      rng.setEnd(pos.container(), pos.offset());
	      return rng;
	    };
	    var insertZwsp = function (node, rng) {
	      var textNode = node.ownerDocument.createTextNode(Zwsp.ZWSP);
	      node.appendChild(textNode);
	      rng.setStart(textNode, 0);
	      rng.setEnd(textNode, 0);
	    };
	    var isEmpty = function (node) {
	      return node.hasChildNodes() === false;
	    };
	    var tryFindRangePosition = function (node, rng) {
	      return CaretFinder.lastPositionIn(node).fold(function () {
	        return false;
	      }, function (pos) {
	        rng.setStart(pos.container(), pos.offset());
	        rng.setEnd(pos.container(), pos.offset());
	        return true;
	      });
	    };
	    var padEmptyCaretContainer = function (root, node, rng) {
	      if (isEmpty(node) && getParentCaretContainer(root, node)) {
	        insertZwsp(node, rng);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var setEndPoint = function (dom, start, bookmark, rng) {
	      var point = bookmark[start ? 'start' : 'end'];
	      var i, node, offset, children;
	      var root = dom.getRoot();
	      if (point) {
	        offset = point[0];
	        for (node = root, i = point.length - 1; i >= 1; i--) {
	          children = node.childNodes;
	          if (padEmptyCaretContainer(root, node, rng)) {
	            return true;
	          }
	          if (point[i] > children.length - 1) {
	            if (padEmptyCaretContainer(root, node, rng)) {
	              return true;
	            }
	            return tryFindRangePosition(node, rng);
	          }
	          node = children[point[i]];
	        }
	        if (node.nodeType === 3) {
	          offset = Math.min(point[0], node.nodeValue.length);
	        }
	        if (node.nodeType === 1) {
	          offset = Math.min(point[0], node.childNodes.length);
	        }
	        if (start) {
	          rng.setStart(node, offset);
	        } else {
	          rng.setEnd(node, offset);
	        }
	      }
	      return true;
	    };
	    var isValidTextNode = function (node) {
	      return NodeType.isText(node) && node.data.length > 0;
	    };
	    var restoreEndPoint = function (dom, suffix, bookmark) {
	      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
	      var keep = bookmark.keep;
	      var container, offset;
	      if (marker) {
	        node = marker.parentNode;
	        if (suffix === 'start') {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.nextSibling)) {
	              node = marker.nextSibling;
	              idx = 0;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker) + 1;
	            }
	          }
	          container = node;
	          offset = idx;
	        } else {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker);
	            }
	          }
	          container = node;
	          offset = idx;
	        }
	        if (!keep) {
	          prev = marker.previousSibling;
	          next = marker.nextSibling;
	          Tools.each(Tools.grep(marker.childNodes), function (node) {
	            if (NodeType.isText(node)) {
	              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
	            }
	          });
	          while (marker = dom.get(bookmark.id + '_' + suffix)) {
	            dom.remove(marker, true);
	          }
	          if (prev && next && prev.nodeType === next.nodeType && NodeType.isText(prev) && !Env.opera) {
	            idx = prev.nodeValue.length;
	            prev.appendData(next.nodeValue);
	            dom.remove(next);
	            if (suffix === 'start') {
	              container = prev;
	              offset = idx;
	            } else {
	              container = prev;
	              offset = idx;
	            }
	          }
	        }
	        return Option.some(CaretPosition$1(container, offset));
	      } else {
	        return Option.none();
	      }
	    };
	    var alt = function (o1, o2) {
	      return o1.isSome() ? o1 : o2;
	    };
	    var resolvePaths = function (dom, bookmark) {
	      var rng = dom.createRng();
	      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
	        return Option.some(rng);
	      } else {
	        return Option.none();
	      }
	    };
	    var resolveId = function (dom, bookmark) {
	      var startPos = restoreEndPoint(dom, 'start', bookmark);
	      var endPos = restoreEndPoint(dom, 'end', bookmark);
	      return lift2(startPos, alt(endPos, startPos), function (spos, epos) {
	        var rng = dom.createRng();
	        rng.setStart(addBogus(dom, spos.container()), spos.offset());
	        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
	        return rng;
	      });
	    };
	    var resolveIndex$1 = function (dom, bookmark) {
	      return Option.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
	        var rng = dom.createRng();
	        rng.selectNode(elm);
	        return rng;
	      });
	    };
	    var resolve$3 = function (selection, bookmark) {
	      var dom = selection.dom;
	      if (bookmark) {
	        if (isPathBookmark(bookmark)) {
	          return resolvePaths(dom, bookmark);
	        } else if (isStringPathBookmark(bookmark)) {
	          return Option.some(resolveCaretPositionBookmark(dom, bookmark));
	        } else if (isIdBookmark(bookmark)) {
	          return resolveId(dom, bookmark);
	        } else if (isIndexBookmark(bookmark)) {
	          return resolveIndex$1(dom, bookmark);
	        } else if (isRangeBookmark(bookmark)) {
	          return Option.some(bookmark.rng);
	        }
	      }
	      return Option.none();
	    };
	    var ResolveBookmark = { resolve: resolve$3 };
	
	    var getBookmark$1 = function (selection, type, normalized) {
	      return GetBookmark.getBookmark(selection, type, normalized);
	    };
	    var moveToBookmark = function (selection, bookmark) {
	      ResolveBookmark.resolve(selection, bookmark).each(function (rng) {
	        selection.setRng(rng);
	      });
	    };
	    var isBookmarkNode$1 = function (node) {
	      return NodeType.isElement(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var Bookmarks = {
	      getBookmark: getBookmark$1,
	      moveToBookmark: moveToBookmark,
	      isBookmarkNode: isBookmarkNode$1
	    };
	
	    var isInlineBlock = function (node) {
	      return node && /^(IMG)$/.test(node.nodeName);
	    };
	    var moveStart = function (dom, selection, rng) {
	      var offset = rng.startOffset;
	      var container = rng.startContainer, walker, node, nodes;
	      if (rng.startContainer === rng.endContainer) {
	        if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
	          return;
	        }
	      }
	      if (container.nodeType === 1) {
	        nodes = container.childNodes;
	        if (offset < nodes.length) {
	          container = nodes[offset];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	        } else {
	          container = nodes[nodes.length - 1];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	          walker.next(true);
	        }
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3 && !isWhiteSpaceNode(node)) {
	            rng.setStart(node, 0);
	            selection.setRng(rng);
	            return;
	          }
	        }
	      }
	    };
	    var getNonWhiteSpaceSibling = function (node, next, inc) {
	      if (node) {
	        next = next ? 'nextSibling' : 'previousSibling';
	        for (node = inc ? node : node[next]; node; node = node[next]) {
	          if (node.nodeType === 1 || !isWhiteSpaceNode(node)) {
	            return node;
	          }
	        }
	      }
	    };
	    var isTextBlock$1 = function (editor, name) {
	      if (name.nodeType) {
	        name = name.nodeName;
	      }
	      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
	    };
	    var isValid = function (ed, parent, child) {
	      return ed.schema.isValidChild(parent, child);
	    };
	    var isWhiteSpaceNode = function (node) {
	      return node && node.nodeType === 3 && /^([\t \r\n]+|)$/.test(node.nodeValue);
	    };
	    var replaceVars = function (value, vars) {
	      if (typeof value !== 'string') {
	        value = value(vars);
	      } else if (vars) {
	        value = value.replace(/%(\w+)/g, function (str, name) {
	          return vars[name] || str;
	        });
	      }
	      return value;
	    };
	    var isEq = function (str1, str2) {
	      str1 = str1 || '';
	      str2 = str2 || '';
	      str1 = '' + (str1.nodeName || str1);
	      str2 = '' + (str2.nodeName || str2);
	      return str1.toLowerCase() === str2.toLowerCase();
	    };
	    var normalizeStyleValue = function (dom, value, name) {
	      if (name === 'color' || name === 'backgroundColor') {
	        value = dom.toHex(value);
	      }
	      if (name === 'fontWeight' && value === 700) {
	        value = 'bold';
	      }
	      if (name === 'fontFamily') {
	        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	      }
	      return '' + value;
	    };
	    var getStyle = function (dom, node, name) {
	      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
	    };
	    var getTextDecoration = function (dom, node) {
	      var decoration;
	      dom.getParent(node, function (n) {
	        decoration = dom.getStyle(n, 'text-decoration');
	        return decoration && decoration !== 'none';
	      });
	      return decoration;
	    };
	    var getParents$1 = function (dom, node, selector) {
	      return dom.getParents(node, selector, dom.getRoot());
	    };
	    var FormatUtils = {
	      isInlineBlock: isInlineBlock,
	      moveStart: moveStart,
	      getNonWhiteSpaceSibling: getNonWhiteSpaceSibling,
	      isTextBlock: isTextBlock$1,
	      isValid: isValid,
	      isWhiteSpaceNode: isWhiteSpaceNode,
	      replaceVars: replaceVars,
	      isEq: isEq,
	      normalizeStyleValue: normalizeStyleValue,
	      getStyle: getStyle,
	      getTextDecoration: getTextDecoration,
	      getParents: getParents$1
	    };
	
	    var isBookmarkNode$2 = Bookmarks.isBookmarkNode;
	    var getParents$2 = FormatUtils.getParents, isWhiteSpaceNode$1 = FormatUtils.isWhiteSpaceNode, isTextBlock$2 = FormatUtils.isTextBlock;
	    var findLeaf = function (node, offset) {
	      if (typeof offset === 'undefined') {
	        offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	      }
	      while (node && node.hasChildNodes()) {
	        node = node.childNodes[offset];
	        if (node) {
	          offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	        }
	      }
	      return {
	        node: node,
	        offset: offset
	      };
	    };
	    var excludeTrailingWhitespace = function (endContainer, endOffset) {
	      var leaf = findLeaf(endContainer, endOffset);
	      if (leaf.node) {
	        while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
	          leaf = findLeaf(leaf.node.previousSibling);
	        }
	        if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 && leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
	          if (leaf.offset > 1) {
	            endContainer = leaf.node;
	            endContainer.splitText(leaf.offset - 1);
	          }
	        }
	      }
	      return endContainer;
	    };
	    var isBogusBr = function (node) {
	      return node.nodeName === 'BR' && node.getAttribute('data-mce-bogus') && !node.nextSibling;
	    };
	    var findParentContentEditable = function (dom, node) {
	      var parent = node;
	      while (parent) {
	        if (parent.nodeType === 1 && dom.getContentEditable(parent)) {
	          return dom.getContentEditable(parent) === 'false' ? parent : node;
	        }
	        parent = parent.parentNode;
	      }
	      return node;
	    };
	    var findSpace = function (start, remove, node, offset) {
	      var pos, pos2;
	      var str = node.nodeValue;
	      if (typeof offset === 'undefined') {
	        offset = start ? str.length : 0;
	      }
	      if (start) {
	        pos = str.lastIndexOf(' ', offset);
	        pos2 = str.lastIndexOf('\xA0', offset);
	        pos = pos > pos2 ? pos : pos2;
	        if (pos !== -1 && !remove && (pos < offset || !start) && pos <= str.length) {
	          pos++;
	        }
	      } else {
	        pos = str.indexOf(' ', offset);
	        pos2 = str.indexOf('\xA0', offset);
	        pos = pos !== -1 && (pos2 === -1 || pos < pos2) ? pos : pos2;
	      }
	      return pos;
	    };
	    var findWordEndPoint = function (dom, body, container, offset, start, remove) {
	      var walker, node, pos, lastTextNode;
	      if (container.nodeType === 3) {
	        pos = findSpace(start, remove, container, offset);
	        if (pos !== -1) {
	          return {
	            container: container,
	            offset: pos
	          };
	        }
	        lastTextNode = container;
	      }
	      walker = new TreeWalker(container, dom.getParent(container, dom.isBlock) || body);
	      while (node = walker[start ? 'prev' : 'next']()) {
	        if (node.nodeType === 3 && !isBookmarkNode$2(node.parentNode)) {
	          lastTextNode = node;
	          pos = findSpace(start, remove, node);
	          if (pos !== -1) {
	            return {
	              container: node,
	              offset: pos
	            };
	          }
	        } else if (dom.isBlock(node) || FormatUtils.isEq(node, 'BR')) {
	          break;
	        }
	      }
	      if (lastTextNode) {
	        if (start) {
	          offset = 0;
	        } else {
	          offset = lastTextNode.length;
	        }
	        return {
	          container: lastTextNode,
	          offset: offset
	        };
	      }
	    };
	    var findSelectorEndPoint = function (dom, format, rng, container, siblingName) {
	      var parents, i, y, curFormat;
	      if (container.nodeType === 3 && container.nodeValue.length === 0 && container[siblingName]) {
	        container = container[siblingName];
	      }
	      parents = getParents$2(dom, container);
	      for (i = 0; i < parents.length; i++) {
	        for (y = 0; y < format.length; y++) {
	          curFormat = format[y];
	          if ('collapsed' in curFormat && curFormat.collapsed !== rng.collapsed) {
	            continue;
	          }
	          if (dom.is(parents[i], curFormat.selector)) {
	            return parents[i];
	          }
	        }
	      }
	      return container;
	    };
	    var findBlockEndPoint = function (editor, format, container, siblingName) {
	      var node;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      if (!format[0].wrapper) {
	        node = dom.getParent(container, format[0].block, root);
	      }
	      if (!node) {
	        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
	        node = dom.getParent(container.nodeType === 3 ? container.parentNode : container, function (node) {
	          return node !== root && isTextBlock$2(editor, node);
	        }, scopeRoot);
	      }
	      if (node && format[0].wrapper) {
	        node = getParents$2(dom, node, 'ul,ol').reverse()[0] || node;
	      }
	      if (!node) {
	        node = container;
	        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
	          node = node[siblingName];
	          if (FormatUtils.isEq(node, 'br')) {
	            break;
	          }
	        }
	      }
	      return node || container;
	    };
	    var findParentContainer = function (dom, format, startContainer, startOffset, endContainer, endOffset, start) {
	      var container, parent, sibling, siblingName, root;
	      container = parent = start ? startContainer : endContainer;
	      siblingName = start ? 'previousSibling' : 'nextSibling';
	      root = dom.getRoot();
	      if (container.nodeType === 3 && !isWhiteSpaceNode$1(container)) {
	        if (start ? startOffset > 0 : endOffset < container.nodeValue.length) {
	          return container;
	        }
	      }
	      while (true) {
	        if (!format[0].block_expand && dom.isBlock(parent)) {
	          return parent;
	        }
	        for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
	          if (!isBookmarkNode$2(sibling) && !isWhiteSpaceNode$1(sibling) && !isBogusBr(sibling)) {
	            return parent;
	          }
	        }
	        if (parent === root || parent.parentNode === root) {
	          container = parent;
	          break;
	        }
	        parent = parent.parentNode;
	      }
	      return container;
	    };
	    var expandRng = function (editor, rng, format, remove) {
	      var endPoint, startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      var dom = editor.dom;
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = getNode(startContainer, startOffset);
	        if (startContainer.nodeType === 3) {
	          startOffset = 0;
	        }
	      }
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getNode(endContainer, rng.collapsed ? endOffset : endOffset - 1);
	        if (endContainer.nodeType === 3) {
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      startContainer = findParentContentEditable(dom, startContainer);
	      endContainer = findParentContentEditable(dom, endContainer);
	      if (isBookmarkNode$2(startContainer.parentNode) || isBookmarkNode$2(startContainer)) {
	        startContainer = isBookmarkNode$2(startContainer) ? startContainer : startContainer.parentNode;
	        if (rng.collapsed) {
	          startContainer = startContainer.previousSibling || startContainer;
	        } else {
	          startContainer = startContainer.nextSibling || startContainer;
	        }
	        if (startContainer.nodeType === 3) {
	          startOffset = rng.collapsed ? startContainer.length : 0;
	        }
	      }
	      if (isBookmarkNode$2(endContainer.parentNode) || isBookmarkNode$2(endContainer)) {
	        endContainer = isBookmarkNode$2(endContainer) ? endContainer : endContainer.parentNode;
	        if (rng.collapsed) {
	          endContainer = endContainer.nextSibling || endContainer;
	        } else {
	          endContainer = endContainer.previousSibling || endContainer;
	        }
	        if (endContainer.nodeType === 3) {
	          endOffset = rng.collapsed ? 0 : endContainer.length;
	        }
	      }
	      if (rng.collapsed) {
	        endPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, remove);
	        if (endPoint) {
	          startContainer = endPoint.container;
	          startOffset = endPoint.offset;
	        }
	        endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, remove);
	        if (endPoint) {
	          endContainer = endPoint.container;
	          endOffset = endPoint.offset;
	        }
	      }
	      if (format[0].inline) {
	        endContainer = remove ? endContainer : excludeTrailingWhitespace(endContainer, endOffset);
	      }
	      if (format[0].inline || format[0].block_expand) {
	        if (!format[0].inline || (startContainer.nodeType !== 3 || startOffset === 0)) {
	          startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	        }
	        if (!format[0].inline || (endContainer.nodeType !== 3 || endOffset === endContainer.nodeValue.length)) {
	          endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	        }
	      }
	      if (format[0].selector && format[0].expand !== false && !format[0].inline) {
	        startContainer = findSelectorEndPoint(dom, format, rng, startContainer, 'previousSibling');
	        endContainer = findSelectorEndPoint(dom, format, rng, endContainer, 'nextSibling');
	      }
	      if (format[0].block || format[0].selector) {
	        startContainer = findBlockEndPoint(editor, format, startContainer, 'previousSibling');
	        endContainer = findBlockEndPoint(editor, format, endContainer, 'nextSibling');
	        if (format[0].block) {
	          if (!dom.isBlock(startContainer)) {
	            startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	          }
	          if (!dom.isBlock(endContainer)) {
	            endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	          }
	        }
	      }
	      if (startContainer.nodeType === 1) {
	        startOffset = dom.nodeIndex(startContainer);
	        startContainer = startContainer.parentNode;
	      }
	      if (endContainer.nodeType === 1) {
	        endOffset = dom.nodeIndex(endContainer) + 1;
	        endContainer = endContainer.parentNode;
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	    var ExpandRange = { expandRng: expandRng };
	
	    var each$8 = Tools.each;
	    var getEndChild = function (container, index) {
	      var childNodes = container.childNodes;
	      index--;
	      if (index > childNodes.length - 1) {
	        index = childNodes.length - 1;
	      } else if (index < 0) {
	        index = 0;
	      }
	      return childNodes[index] || container;
	    };
	    var walk$1 = function (dom, rng, callback) {
	      var startContainer = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endContainer = rng.endContainer;
	      var endOffset = rng.endOffset;
	      var ancestor;
	      var startPoint;
	      var endPoint;
	      var node;
	      var parent;
	      var siblings;
	      var nodes;
	      nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
	      if (nodes.length > 0) {
	        each$8(nodes, function (node) {
	          callback([node]);
	        });
	        return;
	      }
	      var exclude = function (nodes) {
	        var node;
	        node = nodes[0];
	        if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
	          nodes.splice(0, 1);
	        }
	        node = nodes[nodes.length - 1];
	        if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
	          nodes.splice(nodes.length - 1, 1);
	        }
	        return nodes;
	      };
	      var collectSiblings = function (node, name, endNode) {
	        var siblings = [];
	        for (; node && node !== endNode; node = node[name]) {
	          siblings.push(node);
	        }
	        return siblings;
	      };
	      var findEndPoint = function (node, root) {
	        do {
	          if (node.parentNode === root) {
	            return node;
	          }
	          node = node.parentNode;
	        } while (node);
	      };
	      var walkBoundary = function (startNode, endNode, next) {
	        var siblingName = next ? 'nextSibling' : 'previousSibling';
	        for (node = startNode, parent = node.parentNode; node && node !== endNode; node = parent) {
	          parent = node.parentNode;
	          siblings = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
	          if (siblings.length) {
	            if (!next) {
	              siblings.reverse();
	            }
	            callback(exclude(siblings));
	          }
	        }
	      };
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = startContainer.childNodes[startOffset];
	      }
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getEndChild(endContainer, endOffset);
	      }
	      if (startContainer === endContainer) {
	        return callback(exclude([startContainer]));
	      }
	      ancestor = dom.findCommonAncestor(startContainer, endContainer);
	      for (node = startContainer; node; node = node.parentNode) {
	        if (node === endContainer) {
	          return walkBoundary(startContainer, ancestor, true);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      for (node = endContainer; node; node = node.parentNode) {
	        if (node === startContainer) {
	          return walkBoundary(endContainer, ancestor);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      startPoint = findEndPoint(startContainer, ancestor) || startContainer;
	      endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	      walkBoundary(startContainer, startPoint, true);
	      siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
	      if (siblings.length) {
	        callback(exclude(siblings));
	      }
	      walkBoundary(endContainer, endPoint);
	    };
	    var RangeWalk = { walk: walk$1 };
	
	    var zeroWidth = function () {
	      return '\uFEFF';
	    };
	
	    function NodeValue (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom().nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    }
	
	    var api = NodeValue(isText, 'text');
	    var get$4 = function (element) {
	      return api.get(element);
	    };
	
	    var isZeroWidth = function (elem) {
	      return isText(elem) && get$4(elem) === zeroWidth();
	    };
	    var context = function (editor, elem, wrapName, nodeName) {
	      return parent(elem).fold(function () {
	        return 'skipping';
	      }, function (parent) {
	        if (nodeName === 'br' || isZeroWidth(elem)) {
	          return 'valid';
	        } else if (isAnnotation(elem)) {
	          return 'existing';
	        } else if (isCaretNode(elem)) {
	          return 'caret';
	        } else if (!FormatUtils.isValid(editor, wrapName, nodeName) || !FormatUtils.isValid(editor, name(parent), wrapName)) {
	          return 'invalid-child';
	        } else {
	          return 'valid';
	        }
	      });
	    };
	
	    var shouldApplyToTrailingSpaces = function (rng) {
	      return rng.startContainer.nodeType === 3 && rng.startContainer.nodeValue.length >= rng.startOffset && rng.startContainer.nodeValue[rng.startOffset] === '\xA0';
	    };
	    var applyWordGrab = function (editor, rng) {
	      var r = ExpandRange.expandRng(editor, rng, [{ inline: true }], shouldApplyToTrailingSpaces(rng));
	      rng.setStart(r.startContainer, r.startOffset);
	      rng.setEnd(r.endContainer, r.endOffset);
	      editor.selection.setRng(rng);
	    };
	    var makeAnnotation = function (eDoc, _a, annotationName, decorate) {
	      var _b = _a.uid, uid = _b === void 0 ? generate('mce-annotation') : _b, data = __rest(_a, ['uid']);
	      var master = Element.fromTag('span', eDoc);
	      add$2(master, annotation());
	      set(master, '' + dataAnnotationId(), uid);
	      set(master, '' + dataAnnotation(), annotationName);
	      var _c = decorate(uid, data), _d = _c.attributes, attributes = _d === void 0 ? {} : _d, _e = _c.classes, classes = _e === void 0 ? [] : _e;
	      setAll(master, attributes);
	      add$3(master, classes);
	      return master;
	    };
	    var annotate = function (editor, rng, annotationName, decorate, data) {
	      var newWrappers = [];
	      var master = makeAnnotation(editor.getDoc(), data, annotationName, decorate);
	      var wrapper = Cell(Option.none());
	      var finishWrapper = function () {
	        wrapper.set(Option.none());
	      };
	      var getOrOpenWrapper = function () {
	        return wrapper.get().getOrThunk(function () {
	          var nu = shallow(master);
	          newWrappers.push(nu);
	          wrapper.set(Option.some(nu));
	          return nu;
	        });
	      };
	      var processElements = function (elems) {
	        each(elems, processElement);
	      };
	      var processElement = function (elem) {
	        var ctx = context(editor, elem, 'span', name(elem));
	        switch (ctx) {
	        case 'invalid-child': {
	            finishWrapper();
	            var children$1 = children(elem);
	            processElements(children$1);
	            finishWrapper();
	            break;
	          }
	        case 'valid': {
	            var w = getOrOpenWrapper();
	            wrap$1(elem, w);
	            break;
	          }
	        case 'skipping':
	        case 'existing':
	        case 'caret':
	        }
	      };
	      var processNodes = function (nodes) {
	        var elems = map(nodes, Element.fromDom);
	        processElements(elems);
	      };
	      RangeWalk.walk(editor.dom, rng, function (nodes) {
	        finishWrapper();
	        processNodes(nodes);
	      });
	      return newWrappers;
	    };
	    var annotateWithBookmark = function (editor, name, settings, data) {
	      editor.undoManager.transact(function () {
	        var initialRng = editor.selection.getRng();
	        if (initialRng.collapsed) {
	          applyWordGrab(editor, initialRng);
	        }
	        if (editor.selection.getRng().collapsed) {
	          var wrapper = makeAnnotation(editor.getDoc(), data, name, settings.decorate);
	          set$1(wrapper, '\xA0');
	          editor.selection.getRng().insertNode(wrapper.dom());
	          editor.selection.select(wrapper.dom());
	        } else {
	          var bookmark = GetBookmark.getPersistentBookmark(editor.selection, false);
	          var rng = editor.selection.getRng();
	          annotate(editor, rng, name, settings.decorate, data);
	          editor.selection.moveToBookmark(bookmark);
	        }
	      });
	    };
	
	    function Annotator (editor) {
	      var registry = create$1();
	      setup$1(editor, registry);
	      var changes = setup(editor);
	      return {
	        register: function (name, settings) {
	          registry.register(name, settings);
	        },
	        annotate: function (name, data) {
	          registry.lookup(name).each(function (settings) {
	            annotateWithBookmark(editor, name, settings, data);
	          });
	        },
	        annotationChanged: function (name, callback) {
	          changes.addListener(name, callback);
	        },
	        remove: function (name) {
	          identify(editor, Option.some(name)).each(function (_a) {
	            var elements = _a.elements;
	            each(elements, unwrap);
	          });
	        },
	        getAll: function (name) {
	          var directory = findAll(editor, name);
	          return map$2(directory, function (elems) {
	            return map(elems, function (elem) {
	              return elem.dom();
	            });
	          });
	        }
	      };
	    }
	
	    var hasOnlyOneChild = function (node) {
	      return node.firstChild && node.firstChild === node.lastChild;
	    };
	    var isPaddingNode = function (node) {
	      return node.name === 'br' || node.value === '\xA0';
	    };
	    var isPaddedEmptyBlock = function (schema, node) {
	      var blockElements = schema.getBlockElements();
	      return blockElements[node.name] && hasOnlyOneChild(node) && isPaddingNode(node.firstChild);
	    };
	    var isEmptyFragmentElement = function (schema, node) {
	      var nonEmptyElements = schema.getNonEmptyElements();
	      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
	    };
	    var isListFragment = function (schema, fragment) {
	      var firstChild = fragment.firstChild;
	      var lastChild = fragment.lastChild;
	      if (firstChild && firstChild.name === 'meta') {
	        firstChild = firstChild.next;
	      }
	      if (lastChild && lastChild.attr('id') === 'mce_marker') {
	        lastChild = lastChild.prev;
	      }
	      if (isEmptyFragmentElement(schema, lastChild)) {
	        lastChild = lastChild.prev;
	      }
	      if (!firstChild || firstChild !== lastChild) {
	        return false;
	      }
	      return firstChild.name === 'ul' || firstChild.name === 'ol';
	    };
	    var cleanupDomFragment = function (domFragment) {
	      var firstChild = domFragment.firstChild;
	      var lastChild = domFragment.lastChild;
	      if (firstChild && firstChild.nodeName === 'META') {
	        firstChild.parentNode.removeChild(firstChild);
	      }
	      if (lastChild && lastChild.id === 'mce_marker') {
	        lastChild.parentNode.removeChild(lastChild);
	      }
	      return domFragment;
	    };
	    var toDomFragment = function (dom, serializer, fragment) {
	      var html = serializer.serialize(fragment);
	      var domFragment = dom.createFragment(html);
	      return cleanupDomFragment(domFragment);
	    };
	    var listItems$1 = function (elm) {
	      return Tools.grep(elm.childNodes, function (child) {
	        return child.nodeName === 'LI';
	      });
	    };
	    var isPadding = function (node) {
	      return node.data === '\xA0' || NodeType.isBr(node);
	    };
	    var isListItemPadded = function (node) {
	      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
	    };
	    var isEmptyOrPadded = function (elm) {
	      return !elm.firstChild || isListItemPadded(elm);
	    };
	    var trimListItems = function (elms) {
	      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
	    };
	    var getParentLi = function (dom, node) {
	      var parentBlock = dom.getParent(node, dom.isBlock);
	      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
	    };
	    var isParentBlockLi = function (dom, node) {
	      return !!getParentLi(dom, node);
	    };
	    var getSplit = function (parentNode, rng) {
	      var beforeRng = rng.cloneRange();
	      var afterRng = rng.cloneRange();
	      beforeRng.setStartBefore(parentNode);
	      afterRng.setEndAfter(parentNode);
	      return [
	        beforeRng.cloneContents(),
	        afterRng.cloneContents()
	      ];
	    };
	    var findFirstIn = function (node, rootNode) {
	      var caretPos = CaretPosition$1.before(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.next(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var findLastOf = function (node, rootNode) {
	      var caretPos = CaretPosition$1.after(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.prev(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var insertMiddle = function (target, elms, rootNode, rng) {
	      var parts = getSplit(target, rng);
	      var parentElm = target.parentNode;
	      parentElm.insertBefore(parts[0], target);
	      Tools.each(elms, function (li) {
	        parentElm.insertBefore(li, target);
	      });
	      parentElm.insertBefore(parts[1], target);
	      parentElm.removeChild(target);
	      return findLastOf(elms[elms.length - 1], rootNode);
	    };
	    var insertBefore = function (target, elms, rootNode) {
	      var parentElm = target.parentNode;
	      Tools.each(elms, function (elm) {
	        parentElm.insertBefore(elm, target);
	      });
	      return findFirstIn(target, rootNode);
	    };
	    var insertAfter = function (target, elms, rootNode, dom) {
	      dom.insertAfter(elms.reverse(), target);
	      return findLastOf(elms[0], rootNode);
	    };
	    var insertAtCaret = function (serializer, dom, rng, fragment) {
	      var domFragment = toDomFragment(dom, serializer, fragment);
	      var liTarget = getParentLi(dom, rng.startContainer);
	      var liElms = trimListItems(listItems$1(domFragment.firstChild));
	      var BEGINNING = 1, END = 2;
	      var rootNode = dom.getRoot();
	      var isAt = function (location) {
	        var caretPos = CaretPosition$1.fromRangeStart(rng);
	        var caretWalker = CaretWalker(dom.getRoot());
	        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
	      };
	      if (isAt(BEGINNING)) {
	        return insertBefore(liTarget, liElms, rootNode);
	      } else if (isAt(END)) {
	        return insertAfter(liTarget, liElms, rootNode, dom);
	      }
	      return insertMiddle(liTarget, liElms, rootNode, rng);
	    };
	    var InsertList = {
	      isListFragment: isListFragment,
	      insertAtCaret: insertAtCaret,
	      isParentBlockLi: isParentBlockLi,
	      trimListItems: trimListItems,
	      listItems: listItems$1
	    };
	
	    var each$9 = Tools.each;
	    var ElementUtils = function (dom) {
	      this.compare = function (node1, node2) {
	        if (node1.nodeName !== node2.nodeName) {
	          return false;
	        }
	        var getAttribs = function (node) {
	          var attribs = {};
	          each$9(dom.getAttribs(node), function (attr) {
	            var name = attr.nodeName.toLowerCase();
	            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
	              attribs[name] = dom.getAttrib(node, name);
	            }
	          });
	          return attribs;
	        };
	        var compareObjects = function (obj1, obj2) {
	          var value, name;
	          for (name in obj1) {
	            if (obj1.hasOwnProperty(name)) {
	              value = obj2[name];
	              if (typeof value === 'undefined') {
	                return false;
	              }
	              if (obj1[name] !== value) {
	                return false;
	              }
	              delete obj2[name];
	            }
	          }
	          for (name in obj2) {
	            if (obj2.hasOwnProperty(name)) {
	              return false;
	            }
	          }
	          return true;
	        };
	        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
	          return false;
	        }
	        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
	          return false;
	        }
	        return !Bookmarks.isBookmarkNode(node1) && !Bookmarks.isBookmarkNode(node2);
	      };
	    };
	
	    var getLastChildren = function (elm) {
	      var children = [];
	      var rawNode = elm.dom();
	      while (rawNode) {
	        children.push(Element.fromDom(rawNode));
	        rawNode = rawNode.lastChild;
	      }
	      return children;
	    };
	    var removeTrailingBr = function (elm) {
	      var allBrs = descendants$1(elm, 'br');
	      var brs = filter(getLastChildren(elm).slice(-1), isBr);
	      if (allBrs.length === brs.length) {
	        each(brs, remove$1);
	      }
	    };
	    var fillWithPaddingBr = function (elm) {
	      empty(elm);
	      append(elm, Element.fromHtml('<br data-mce-bogus="1">'));
	    };
	    var isPaddingContents = function (elm) {
	      return isText(elm) ? get$4(elm) === '\xA0' : isBr(elm);
	    };
	    var isPaddedElement = function (elm) {
	      return filter(children(elm), isPaddingContents).length === 1;
	    };
	    var trimBlockTrailingBr = function (elm) {
	      lastChild(elm).each(function (lastChild) {
	        prevSibling(lastChild).each(function (lastChildPrevSibling) {
	          if (isBlock(elm) && isBr(lastChild) && isBlock(lastChildPrevSibling)) {
	            remove$1(lastChild);
	          }
	        });
	      });
	    };
	    var PaddingBr = {
	      removeTrailingBr: removeTrailingBr,
	      fillWithPaddingBr: fillWithPaddingBr,
	      isPaddedElement: isPaddedElement,
	      trimBlockTrailingBr: trimBlockTrailingBr
	    };
	
	    var makeMap$3 = Tools.makeMap;
	    function Writer (settings) {
	      var html = [];
	      var indent, indentBefore, indentAfter, encode, htmlOutput;
	      settings = settings || {};
	      indent = settings.indent;
	      indentBefore = makeMap$3(settings.indent_before || '');
	      indentAfter = makeMap$3(settings.indent_after || '');
	      encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
	      htmlOutput = settings.element_format === 'html';
	      return {
	        start: function (name, attrs, empty) {
	          var i, l, attr, value;
	          if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	          html.push('<', name);
	          if (attrs) {
	            for (i = 0, l = attrs.length; i < l; i++) {
	              attr = attrs[i];
	              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
	            }
	          }
	          if (!empty || htmlOutput) {
	            html[html.length] = '>';
	          } else {
	            html[html.length] = ' />';
	          }
	          if (empty && indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        end: function (name) {
	          var value;
	          html.push('</', name, '>');
	          if (indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        text: function (text, raw) {
	          if (text.length > 0) {
	            html[html.length] = raw ? text : encode(text);
	          }
	        },
	        cdata: function (text) {
	          html.push('<![CDATA[', text, ']]>');
	        },
	        comment: function (text) {
	          html.push('<!--', text, '-->');
	        },
	        pi: function (name, text) {
	          if (text) {
	            html.push('<?', name, ' ', encode(text), '?>');
	          } else {
	            html.push('<?', name, '?>');
	          }
	          if (indent) {
	            html.push('\n');
	          }
	        },
	        doctype: function (text) {
	          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
	        },
	        reset: function () {
	          html.length = 0;
	        },
	        getContent: function () {
	          return html.join('').replace(/\n$/, '');
	        }
	      };
	    }
	
	    function HtmlSerializer (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var writer = Writer(settings);
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      var serialize = function (node) {
	        var handlers, validate;
	        validate = settings.validate;
	        handlers = {
	          3: function (node) {
	            writer.text(node.value, node.raw);
	          },
	          8: function (node) {
	            writer.comment(node.value);
	          },
	          7: function (node) {
	            writer.pi(node.name, node.value);
	          },
	          10: function (node) {
	            writer.doctype(node.value);
	          },
	          4: function (node) {
	            writer.cdata(node.value);
	          },
	          11: function (node) {
	            if (node = node.firstChild) {
	              do {
	                walk(node);
	              } while (node = node.next);
	            }
	          }
	        };
	        writer.reset();
	        var walk = function (node) {
	          var handler = handlers[node.type];
	          var name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
	          if (!handler) {
	            name = node.name;
	            isEmpty = node.shortEnded;
	            attrs = node.attributes;
	            if (validate && attrs && attrs.length > 1) {
	              sortedAttrs = [];
	              sortedAttrs.map = {};
	              elementRule = schema.getElementRule(node.name);
	              if (elementRule) {
	                for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
	                  attrName = elementRule.attributesOrder[i];
	                  if (attrName in attrs.map) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                for (i = 0, l = attrs.length; i < l; i++) {
	                  attrName = attrs[i].name;
	                  if (!(attrName in sortedAttrs.map)) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                attrs = sortedAttrs;
	              }
	            }
	            writer.start(node.name, attrs, isEmpty);
	            if (!isEmpty) {
	              if (node = node.firstChild) {
	                do {
	                  walk(node);
	                } while (node = node.next);
	              }
	              writer.end(name);
	            }
	          } else {
	            handler(node);
	          }
	        };
	        if (node.type === 1 && !settings.inner) {
	          walk(node);
	        } else {
	          handlers[11](node);
	        }
	        return writer.getContent();
	      };
	      return { serialize: serialize };
	    }
	
	    var createRange$1 = function (sc, so, ec, eo) {
	      var rng = domGlobals.document.createRange();
	      rng.setStart(sc, so);
	      rng.setEnd(ec, eo);
	      return rng;
	    };
	    var normalizeBlockSelectionRange = function (rng) {
	      var startPos = CaretPosition$1.fromRangeStart(rng);
	      var endPos = CaretPosition$1.fromRangeEnd(rng);
	      var rootNode = rng.commonAncestorContainer;
	      return CaretFinder.fromPosition(false, rootNode, endPos).map(function (newEndPos) {
	        if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
	          return createRange$1(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
	        } else {
	          return rng;
	        }
	      }).getOr(rng);
	    };
	    var normalize = function (rng) {
	      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
	    };
	    var RangeNormalizer = { normalize: normalize };
	
	    var isAfterNbsp = function (container, offset) {
	      return NodeType.isText(container) && container.nodeValue[offset - 1] === '\xA0';
	    };
	    var trimOrPadLeftRight = function (rng, html) {
	      var container, offset;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      var hasSiblingText = function (siblingName) {
	        return container[siblingName] && container[siblingName].nodeType === 3;
	      };
	      if (container.nodeType === 3) {
	        if (offset > 0) {
	          html = html.replace(/^&nbsp;/, ' ');
	        } else if (!hasSiblingText('previousSibling')) {
	          html = html.replace(/^ /, '&nbsp;');
	        }
	        if (offset < container.length) {
	          html = html.replace(/&nbsp;(<br>|)$/, ' ');
	        } else if (!hasSiblingText('nextSibling')) {
	          html = html.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;');
	        }
	      }
	      return html;
	    };
	    var trimNbspAfterDeleteAndPadValue = function (rng, value) {
	      var container, offset;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      if (container.nodeType === 3 && rng.collapsed) {
	        if (container.data[offset] === '\xA0') {
	          container.deleteData(offset, 1);
	          if (!/[\u00a0| ]$/.test(value)) {
	            value += ' ';
	          }
	        } else if (container.data[offset - 1] === '\xA0') {
	          container.deleteData(offset - 1, 1);
	          if (!/[\u00a0| ]$/.test(value)) {
	            value = ' ' + value;
	          }
	        }
	      }
	      return value;
	    };
	
	    var isTableCell$2 = NodeType.matchNodeNames('td th');
	    var selectionSetContent = function (editor, content) {
	      var rng = editor.selection.getRng();
	      var container = rng.startContainer;
	      var offset = rng.startOffset;
	      if (rng.collapsed && isAfterNbsp(container, offset) && NodeType.isText(container)) {
	        container.insertData(offset - 1, ' ');
	        container.deleteData(offset, 1);
	        rng.setStart(container, offset);
	        rng.setEnd(container, offset);
	        editor.selection.setRng(rng);
	      }
	      editor.selection.setContent(content);
	    };
	    var validInsertion = function (editor, value, parentNode) {
	      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
	        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
	      } else {
	        var node = parentNode.firstChild;
	        var node2 = parentNode.lastChild;
	        if (!node || node === node2 && node.nodeName === 'BR') {
	          editor.dom.setHTML(parentNode, value);
	        } else {
	          selectionSetContent(editor, value);
	        }
	      }
	    };
	    var trimBrsFromTableCell = function (dom, elm) {
	      Option.from(dom.getParent(elm, 'td,th')).map(Element.fromDom).each(PaddingBr.trimBlockTrailingBr);
	    };
	    var reduceInlineTextElements = function (editor, merge) {
	      var textInlineElements = editor.schema.getTextInlineElements();
	      var dom = editor.dom;
	      if (merge) {
	        var root_1 = editor.getBody(), elementUtils_1 = new ElementUtils(dom);
	        Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
	          for (var testNode = node.parentNode; testNode && testNode !== root_1; testNode = testNode.parentNode) {
	            if (textInlineElements[node.nodeName.toLowerCase()] && elementUtils_1.compare(testNode, node)) {
	              dom.remove(node, true);
	            }
	          }
	        });
	      }
	    };
	    var markFragmentElements = function (fragment) {
	      var node = fragment;
	      while (node = node.walk()) {
	        if (node.type === 1) {
	          node.attr('data-mce-fragment', '1');
	        }
	      }
	    };
	    var umarkFragmentElements = function (elm) {
	      Tools.each(elm.getElementsByTagName('*'), function (elm) {
	        elm.removeAttribute('data-mce-fragment');
	      });
	    };
	    var isPartOfFragment = function (node) {
	      return !!node.getAttribute('data-mce-fragment');
	    };
	    var canHaveChildren = function (editor, node) {
	      return node && !editor.schema.getShortEndedElements()[node.nodeName];
	    };
	    var moveSelectionToMarker = function (editor, marker) {
	      var parentEditableFalseElm, parentBlock, nextRng;
	      var dom = editor.dom, selection = editor.selection;
	      var node, node2;
	      var getContentEditableFalseParent = function (node) {
	        var root = editor.getBody();
	        for (; node && node !== root; node = node.parentNode) {
	          if (editor.dom.getContentEditable(node) === 'false') {
	            return node;
	          }
	        }
	        return null;
	      };
	      if (!marker) {
	        return;
	      }
	      editor.selection.scrollIntoView(marker);
	      parentEditableFalseElm = getContentEditableFalseParent(marker);
	      if (parentEditableFalseElm) {
	        dom.remove(marker);
	        selection.select(parentEditableFalseElm);
	        return;
	      }
	      var rng = dom.createRng();
	      node = marker.previousSibling;
	      if (node && node.nodeType === 3) {
	        rng.setStart(node, node.nodeValue.length);
	        if (!Env.ie) {
	          node2 = marker.nextSibling;
	          if (node2 && node2.nodeType === 3) {
	            node.appendData(node2.data);
	            node2.parentNode.removeChild(node2);
	          }
	        }
	      } else {
	        rng.setStartBefore(marker);
	        rng.setEndBefore(marker);
	      }
	      var findNextCaretRng = function (rng) {
	        var caretPos = CaretPosition$1.fromRangeStart(rng);
	        var caretWalker = CaretWalker(editor.getBody());
	        caretPos = caretWalker.next(caretPos);
	        if (caretPos) {
	          return caretPos.toRange();
	        }
	      };
	      parentBlock = dom.getParent(marker, dom.isBlock);
	      dom.remove(marker);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        editor.$(parentBlock).empty();
	        rng.setStart(parentBlock, 0);
	        rng.setEnd(parentBlock, 0);
	        if (!isTableCell$2(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
	          rng = nextRng;
	          dom.remove(parentBlock);
	        } else {
	          dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      selection.setRng(rng);
	    };
	    var insertHtmlAtCaret = function (editor, value, details) {
	      var parser, serializer, parentNode, rootNode, fragment, args;
	      var marker, rng, node, bookmarkHtml, merge;
	      var selection = editor.selection, dom = editor.dom;
	      if (/^ | $/.test(value)) {
	        value = trimOrPadLeftRight(selection.getRng(), value);
	      }
	      parser = editor.parser;
	      merge = details.merge;
	      serializer = HtmlSerializer({ validate: editor.settings.validate }, editor.schema);
	      bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
	      args = {
	        content: value,
	        format: 'html',
	        selection: true,
	        paste: details.paste
	      };
	      args = editor.fire('BeforeSetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('SetContent', {
	          content: args.content,
	          format: 'html',
	          selection: true,
	          paste: details.paste
	        });
	        return;
	      }
	      value = args.content;
	      if (value.indexOf('{$caret}') === -1) {
	        value += '{$caret}';
	      }
	      value = value.replace(/\{\$caret\}/, bookmarkHtml);
	      rng = selection.getRng();
	      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
	      var body = editor.getBody();
	      if (caretElement === body && selection.isCollapsed()) {
	        if (dom.isBlock(body.firstChild) && canHaveChildren(editor, body.firstChild) && dom.isEmpty(body.firstChild)) {
	          rng = dom.createRng();
	          rng.setStart(body.firstChild, 0);
	          rng.setEnd(body.firstChild, 0);
	          selection.setRng(rng);
	        }
	      }
	      if (!selection.isCollapsed()) {
	        editor.selection.setRng(RangeNormalizer.normalize(editor.selection.getRng()));
	        editor.getDoc().execCommand('Delete', false, null);
	        value = trimNbspAfterDeleteAndPadValue(editor.selection.getRng(), value);
	      }
	      parentNode = selection.getNode();
	      var parserArgs = {
	        context: parentNode.nodeName.toLowerCase(),
	        data: details.data,
	        insert: true
	      };
	      fragment = parser.parse(value, parserArgs);
	      if (details.paste === true && InsertList.isListFragment(editor.schema, fragment) && InsertList.isParentBlockLi(dom, parentNode)) {
	        rng = InsertList.insertAtCaret(serializer, dom, editor.selection.getRng(), fragment);
	        editor.selection.setRng(rng);
	        editor.fire('SetContent', args);
	        return;
	      }
	      markFragmentElements(fragment);
	      node = fragment.lastChild;
	      if (node.attr('id') === 'mce_marker') {
	        marker = node;
	        for (node = node.prev; node; node = node.walk(true)) {
	          if (node.type === 3 || !dom.isBlock(node.name)) {
	            if (editor.schema.isValidChild(node.parent.name, 'span')) {
	              node.parent.insert(marker, node, node.name === 'br');
	            }
	            break;
	          }
	        }
	      }
	      editor._selectionOverrides.showBlockCaretContainer(parentNode);
	      if (!parserArgs.invalid) {
	        value = serializer.serialize(fragment);
	        validInsertion(editor, value, parentNode);
	      } else {
	        selectionSetContent(editor, bookmarkHtml);
	        parentNode = selection.getNode();
	        rootNode = editor.getBody();
	        if (parentNode.nodeType === 9) {
	          parentNode = node = rootNode;
	        } else {
	          node = parentNode;
	        }
	        while (node !== rootNode) {
	          parentNode = node;
	          node = node.parentNode;
	        }
	        value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
	        value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
	          return serializer.serialize(fragment);
	        })));
	        if (parentNode === rootNode) {
	          dom.setHTML(rootNode, value);
	        } else {
	          dom.setOuterHTML(parentNode, value);
	        }
	      }
	      reduceInlineTextElements(editor, merge);
	      moveSelectionToMarker(editor, dom.get('mce_marker'));
	      umarkFragmentElements(editor.getBody());
	      trimBrsFromTableCell(editor.dom, editor.selection.getStart());
	      editor.fire('SetContent', args);
	      editor.addVisual();
	    };
	    var processValue = function (value) {
	      var details;
	      if (typeof value !== 'string') {
	        details = Tools.extend({
	          paste: value.paste,
	          data: { paste: value.paste }
	        }, value);
	        return {
	          content: value.content,
	          details: details
	        };
	      }
	      return {
	        content: value,
	        details: {}
	      };
	    };
	    var insertAtCaret$1 = function (editor, value) {
	      var result = processValue(value);
	      insertHtmlAtCaret(editor, result.content, result.details);
	    };
	    var InsertContent = { insertAtCaret: insertAtCaret$1 };
	
	    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
	    var hasStrongRtl = function (text) {
	      return strongRtl.test(text);
	    };
	
	    var getBodySetting = function (editor, name, defaultValue) {
	      var value = editor.getParam(name, defaultValue);
	      if (value.indexOf('=') !== -1) {
	        var bodyObj = editor.getParam(name, '', 'hash');
	        return bodyObj.hasOwnProperty(editor.id) ? bodyObj[editor.id] : defaultValue;
	      } else {
	        return value;
	      }
	    };
	    var getIframeAttrs = function (editor) {
	      return editor.getParam('iframe_attrs', {});
	    };
	    var getDocType = function (editor) {
	      return editor.getParam('doctype', '<!DOCTYPE html>');
	    };
	    var getDocumentBaseUrl = function (editor) {
	      return editor.getParam('document_base_url', '');
	    };
	    var getBodyId = function (editor) {
	      return getBodySetting(editor, 'body_id', 'tinymce');
	    };
	    var getBodyClass = function (editor) {
	      return getBodySetting(editor, 'body_class', '');
	    };
	    var getContentSecurityPolicy = function (editor) {
	      return editor.getParam('content_security_policy', '');
	    };
	    var shouldPutBrInPre = function (editor) {
	      return editor.getParam('br_in_pre', true);
	    };
	    var getForcedRootBlock = function (editor) {
	      if (editor.getParam('force_p_newlines', false)) {
	        return 'p';
	      }
	      var block = editor.getParam('forced_root_block', 'p');
	      return block === false ? '' : block;
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	    var getBrNewLineSelector = function (editor) {
	      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
	    };
	    var getNoNewLineSelector = function (editor) {
	      return editor.getParam('no_newline_selector', '');
	    };
	    var shouldKeepStyles = function (editor) {
	      return editor.getParam('keep_styles', true);
	    };
	    var shouldEndContainerOnEmptyBlock = function (editor) {
	      return editor.getParam('end_container_on_empty_block', false);
	    };
	    var getFontStyleValues = function (editor) {
	      return Tools.explode(editor.getParam('font_size_style_values', ''));
	    };
	    var getFontSizeClasses = function (editor) {
	      return Tools.explode(editor.getParam('font_size_classes', ''));
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter', constant(true), 'function');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	    var shouldReuseFileName = function (editor) {
	      return editor.getParam('images_reuse_filename', false, 'boolean');
	    };
	    var shouldReplaceBlobUris = function (editor) {
	      return editor.getParam('images_replace_blob_uris', true, 'boolean');
	    };
	    var getImageUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', '', 'string');
	    };
	    var getImageUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path', '', 'string');
	    };
	    var getImagesUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials', false, 'boolean');
	    };
	    var getImagesUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', null, 'function');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getInlineBoundarySelector = function (editor) {
	      return editor.getParam('inline_boundaries_selector', 'a[href],code,.mce-annotation', 'string');
	    };
	    var Settings = {
	      getIframeAttrs: getIframeAttrs,
	      getDocType: getDocType,
	      getDocumentBaseUrl: getDocumentBaseUrl,
	      getBodyId: getBodyId,
	      getBodyClass: getBodyClass,
	      getContentSecurityPolicy: getContentSecurityPolicy,
	      shouldPutBrInPre: shouldPutBrInPre,
	      getForcedRootBlock: getForcedRootBlock,
	      getForcedRootBlockAttrs: getForcedRootBlockAttrs,
	      getBrNewLineSelector: getBrNewLineSelector,
	      getNoNewLineSelector: getNoNewLineSelector,
	      shouldKeepStyles: shouldKeepStyles,
	      shouldEndContainerOnEmptyBlock: shouldEndContainerOnEmptyBlock,
	      getFontStyleValues: getFontStyleValues,
	      getFontSizeClasses: getFontSizeClasses,
	      getImagesDataImgFilter: getImagesDataImgFilter,
	      isAutomaticUploadsEnabled: isAutomaticUploadsEnabled,
	      shouldReuseFileName: shouldReuseFileName,
	      shouldReplaceBlobUris: shouldReplaceBlobUris,
	      getImageUploadUrl: getImageUploadUrl,
	      getImageUploadBasePath: getImageUploadBasePath,
	      getImagesUploadCredentials: getImagesUploadCredentials,
	      getImagesUploadHandler: getImagesUploadHandler,
	      shouldUseContentCssCors: shouldUseContentCssCors,
	      getInlineBoundarySelector: getInlineBoundarySelector
	    };
	
	    var isInlineTarget = function (editor, elm) {
	      return is$1(Element.fromDom(elm), Settings.getInlineBoundarySelector(editor));
	    };
	    var isRtl = function (element) {
	      return DOMUtils$1.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
	    };
	    var findInlineParents = function (isInlineTarget, rootNode, pos) {
	      return filter(DOMUtils$1.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
	    };
	    var findRootInline = function (isInlineTarget, rootNode, pos) {
	      var parents = findInlineParents(isInlineTarget, rootNode, pos);
	      return Option.from(parents[parents.length - 1]);
	    };
	    var hasSameParentBlock = function (rootNode, node1, node2) {
	      var block1 = getParentBlock(node1, rootNode);
	      var block2 = getParentBlock(node2, rootNode);
	      return block1 && block1 === block2;
	    };
	    var isAtZwsp = function (pos) {
	      return isBeforeInline(pos) || isAfterInline(pos);
	    };
	    var normalizePosition = function (forward, pos) {
	      if (!pos) {
	        return pos;
	      }
	      var container = pos.container(), offset = pos.offset();
	      if (forward) {
	        if (isCaretContainerInline(container)) {
	          if (NodeType.isText(container.nextSibling)) {
	            return CaretPosition$1(container.nextSibling, 0);
	          } else {
	            return CaretPosition$1.after(container);
	          }
	        } else {
	          return isBeforeInline(pos) ? CaretPosition$1(container, offset + 1) : pos;
	        }
	      } else {
	        if (isCaretContainerInline(container)) {
	          if (NodeType.isText(container.previousSibling)) {
	            return CaretPosition$1(container.previousSibling, container.previousSibling.data.length);
	          } else {
	            return CaretPosition$1.before(container);
	          }
	        } else {
	          return isAfterInline(pos) ? CaretPosition$1(container, offset - 1) : pos;
	        }
	      }
	    };
	    var normalizeForwards = curry(normalizePosition, true);
	    var normalizeBackwards = curry(normalizePosition, false);
	    var InlineUtils = {
	      isInlineTarget: isInlineTarget,
	      findRootInline: findRootInline,
	      isRtl: isRtl,
	      isAtZwsp: isAtZwsp,
	      normalizePosition: normalizePosition,
	      normalizeForwards: normalizeForwards,
	      normalizeBackwards: normalizeBackwards,
	      hasSameParentBlock: hasSameParentBlock
	    };
	
	    var isBeforeRoot = function (rootNode) {
	      return function (elm) {
	        return eq(rootNode, Element.fromDom(elm.dom().parentNode));
	      };
	    };
	    var getParentBlock$1 = function (rootNode, elm) {
	      return contains$3(rootNode, elm) ? closest(elm, function (element) {
	        return isTextBlock(element) || isListItem(element);
	      }, isBeforeRoot(rootNode)) : Option.none();
	    };
	    var placeCaretInEmptyBody = function (editor) {
	      var body = editor.getBody();
	      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
	      editor.selection.setCursorLocation(node, 0);
	    };
	    var paddEmptyBody = function (editor) {
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        placeCaretInEmptyBody(editor);
	      }
	    };
	    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
	      return lift2(CaretFinder.firstPositionIn(elm), CaretFinder.lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	        var normalizedFromPos = InlineUtils.normalizePosition(false, fromPos);
	        if (forward) {
	          return CaretFinder.nextPosition(elm, normalizedFromPos).map(function (nextPos) {
	            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
	          }).getOr(false);
	        } else {
	          return CaretFinder.prevPosition(elm, normalizedFromPos).map(function (prevPos) {
	            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
	          }).getOr(false);
	        }
	      }).getOr(true);
	    };
	    var DeleteUtils = {
	      getParentBlock: getParentBlock$1,
	      paddEmptyBody: paddEmptyBody,
	      willDeleteLastPositionInElement: willDeleteLastPositionInElement
	    };
	
	    var ancestor$2 = function (scope, selector, isRoot) {
	      return ancestor$1(scope, selector, isRoot).isSome();
	    };
	
	    var hasWhitespacePreserveParent = function (rootNode, node) {
	      var rootElement = Element.fromDom(rootNode);
	      var startNode = Element.fromDom(node);
	      return ancestor$2(startNode, 'pre,code', curry(eq, rootElement));
	    };
	    var isWhitespace = function (rootNode, node) {
	      return NodeType.isText(node) && /^[ \t\r\n]*$/.test(node.data) && hasWhitespacePreserveParent(rootNode, node) === false;
	    };
	    var isNamedAnchor = function (node) {
	      return NodeType.isElement(node) && node.nodeName === 'A' && node.hasAttribute('name');
	    };
	    var isContent = function (rootNode, node) {
	      return isCaretCandidate(node) && isWhitespace(rootNode, node) === false || isNamedAnchor(node) || isBookmark(node);
	    };
	    var isBookmark = NodeType.hasAttribute('data-mce-bookmark');
	    var isBogus$2 = NodeType.hasAttribute('data-mce-bogus');
	    var isBogusAll$1 = NodeType.hasAttributeValue('data-mce-bogus', 'all');
	    var isEmptyNode = function (targetNode) {
	      var walker, node, brCount = 0;
	      if (isContent(targetNode, targetNode)) {
	        return false;
	      } else {
	        node = targetNode.firstChild;
	        if (!node) {
	          return true;
	        }
	        walker = new TreeWalker(node, targetNode);
	        do {
	          if (isBogusAll$1(node)) {
	            node = walker.next(true);
	            continue;
	          }
	          if (isBogus$2(node)) {
	            node = walker.next();
	            continue;
	          }
	          if (NodeType.isBr(node)) {
	            brCount++;
	            node = walker.next();
	            continue;
	          }
	          if (isContent(targetNode, node)) {
	            return false;
	          }
	          node = walker.next();
	        } while (node);
	        return brCount <= 1;
	      }
	    };
	    var isEmpty$1 = function (elm) {
	      return isEmptyNode(elm.dom());
	    };
	    var Empty = { isEmpty: isEmpty$1 };
	
	    var BlockPosition = Immutable('block', 'position');
	    var BlockBoundary = Immutable('from', 'to');
	    var getBlockPosition = function (rootNode, pos) {
	      var rootElm = Element.fromDom(rootNode);
	      var containerElm = Element.fromDom(pos.container());
	      return DeleteUtils.getParentBlock(rootElm, containerElm).map(function (block) {
	        return BlockPosition(block, pos);
	      });
	    };
	    var isDifferentBlocks = function (blockBoundary) {
	      return eq(blockBoundary.from().block(), blockBoundary.to().block()) === false;
	    };
	    var hasSameParent = function (blockBoundary) {
	      return parent(blockBoundary.from().block()).bind(function (parent1) {
	        return parent(blockBoundary.to().block()).filter(function (parent2) {
	          return eq(parent1, parent2);
	        });
	      }).isSome();
	    };
	    var isEditable = function (blockBoundary) {
	      return NodeType.isContentEditableFalse(blockBoundary.from().block().dom()) === false && NodeType.isContentEditableFalse(blockBoundary.to().block().dom()) === false;
	    };
	    var skipLastBr = function (rootNode, forward, blockPosition) {
	      if (NodeType.isBr(blockPosition.position().getNode()) && Empty.isEmpty(blockPosition.block()) === false) {
	        return CaretFinder.positionIn(false, blockPosition.block().dom()).bind(function (lastPositionInBlock) {
	          if (lastPositionInBlock.isEqual(blockPosition.position())) {
	            return CaretFinder.fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
	              return getBlockPosition(rootNode, to);
	            });
	          } else {
	            return Option.some(blockPosition);
	          }
	        }).getOr(blockPosition);
	      } else {
	        return blockPosition;
	      }
	    };
	    var readFromRange = function (rootNode, forward, rng) {
	      var fromBlockPos = getBlockPosition(rootNode, CaretPosition$1.fromRangeStart(rng));
	      var toBlockPos = fromBlockPos.bind(function (blockPos) {
	        return CaretFinder.fromPosition(forward, rootNode, blockPos.position()).bind(function (to) {
	          return getBlockPosition(rootNode, to).map(function (blockPos) {
	            return skipLastBr(rootNode, forward, blockPos);
	          });
	        });
	      });
	      return lift2(fromBlockPos, toBlockPos, BlockBoundary).filter(function (blockBoundary) {
	        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable(blockBoundary);
	      });
	    };
	    var read$1 = function (rootNode, forward, rng) {
	      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Option.none();
	    };
	    var BlockMergeBoundary = { read: read$1 };
	
	    var dropLast = function (xs) {
	      return xs.slice(0, -1);
	    };
	    var parentsUntil$1 = function (start, root, predicate) {
	      if (contains$3(root, start)) {
	        return dropLast(parents(start, function (elm) {
	          return predicate(elm) || eq(elm, root);
	        }));
	      } else {
	        return [];
	      }
	    };
	    var parents$1 = function (start, root) {
	      return parentsUntil$1(start, root, constant(false));
	    };
	    var parentsAndSelf = function (start, root) {
	      return [start].concat(parents$1(start, root));
	    };
	    var Parents = {
	      parentsUntil: parentsUntil$1,
	      parents: parents$1,
	      parentsAndSelf: parentsAndSelf
	    };
	
	    var getChildrenUntilBlockBoundary = function (block) {
	      var children$1 = children(block);
	      return findIndex(children$1, isBlock).fold(function () {
	        return children$1;
	      }, function (index) {
	        return children$1.slice(0, index);
	      });
	    };
	    var extractChildren = function (block) {
	      var children = getChildrenUntilBlockBoundary(block);
	      each(children, remove$1);
	      return children;
	    };
	    var removeEmptyRoot = function (rootNode, block) {
	      var parents = Parents.parentsAndSelf(block, rootNode);
	      return find(parents.reverse(), Empty.isEmpty).each(remove$1);
	    };
	    var isEmptyBefore = function (el) {
	      return filter(prevSiblings(el), function (el) {
	        return !Empty.isEmpty(el);
	      }).length === 0;
	    };
	    var nestedBlockMerge = function (rootNode, fromBlock, toBlock, insertionPoint) {
	      if (Empty.isEmpty(toBlock)) {
	        PaddingBr.fillWithPaddingBr(toBlock);
	        return CaretFinder.firstPositionIn(toBlock.dom());
	      }
	      if (isEmptyBefore(insertionPoint) && Empty.isEmpty(fromBlock)) {
	        before(insertionPoint, Element.fromTag('br'));
	      }
	      var position = CaretFinder.prevPosition(toBlock.dom(), CaretPosition$1.before(insertionPoint.dom()));
	      each(extractChildren(fromBlock), function (child) {
	        before(insertionPoint, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var sidelongBlockMerge = function (rootNode, fromBlock, toBlock) {
	      if (Empty.isEmpty(toBlock)) {
	        remove$1(toBlock);
	        if (Empty.isEmpty(fromBlock)) {
	          PaddingBr.fillWithPaddingBr(fromBlock);
	        }
	        return CaretFinder.firstPositionIn(fromBlock.dom());
	      }
	      var position = CaretFinder.lastPositionIn(toBlock.dom());
	      each(extractChildren(fromBlock), function (child) {
	        append(toBlock, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var findInsertionPoint = function (toBlock, block) {
	      var parentsAndSelf = Parents.parentsAndSelf(block, toBlock);
	      return Option.from(parentsAndSelf[parentsAndSelf.length - 1]);
	    };
	    var getInsertionPoint = function (fromBlock, toBlock) {
	      return contains$3(toBlock, fromBlock) ? findInsertionPoint(toBlock, fromBlock) : Option.none();
	    };
	    var trimBr = function (first, block) {
	      CaretFinder.positionIn(first, block.dom()).map(function (position) {
	        return position.getNode();
	      }).map(Element.fromDom).filter(isBr).each(remove$1);
	    };
	    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
	      trimBr(true, fromBlock);
	      trimBr(false, toBlock);
	      return getInsertionPoint(fromBlock, toBlock).fold(curry(sidelongBlockMerge, rootNode, fromBlock, toBlock), curry(nestedBlockMerge, rootNode, fromBlock, toBlock));
	    };
	    var mergeBlocks = function (rootNode, forward, block1, block2) {
	      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
	    };
	    var MergeBlocks = { mergeBlocks: mergeBlocks };
	
	    var backspaceDelete = function (editor, forward) {
	      var position;
	      var rootNode = Element.fromDom(editor.getBody());
	      position = BlockMergeBoundary.read(rootNode.dom(), forward, editor.selection.getRng()).bind(function (blockBoundary) {
	        return MergeBlocks.mergeBlocks(rootNode, forward, blockBoundary.from().block(), blockBoundary.to().block());
	      });
	      position.each(function (pos) {
	        editor.selection.setRng(pos.toRange());
	      });
	      return position.isSome();
	    };
	    var BlockBoundaryDelete = { backspaceDelete: backspaceDelete };
	
	    var deleteRangeMergeBlocks = function (rootNode, selection) {
	      var rng = selection.getRng();
	      return lift2(DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.startContainer)), DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.endContainer)), function (block1, block2) {
	        if (eq(block1, block2) === false) {
	          rng.deleteContents();
	          MergeBlocks.mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
	            selection.setRng(pos.toRange());
	          });
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var isRawNodeInTable = function (root, rawNode) {
	      var node = Element.fromDom(rawNode);
	      var isRoot = curry(eq, root);
	      return ancestor(node, isTableCell, isRoot).isSome();
	    };
	    var isSelectionInTable = function (root, rng) {
	      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
	    };
	    var isEverythingSelected = function (root, rng) {
	      var noPrevious = CaretFinder.prevPosition(root.dom(), CaretPosition$1.fromRangeStart(rng)).isNone();
	      var noNext = CaretFinder.nextPosition(root.dom(), CaretPosition$1.fromRangeEnd(rng)).isNone();
	      return !isSelectionInTable(root, rng) && noPrevious && noNext;
	    };
	    var emptyEditor = function (editor) {
	      editor.setContent('');
	      editor.selection.setCursorLocation();
	      return true;
	    };
	    var deleteRange = function (editor) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
	    };
	    var backspaceDelete$1 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? false : deleteRange(editor);
	    };
	    var BlockRangeDelete = { backspaceDelete: backspaceDelete$1 };
	
	    var generate$1 = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var argLength = arguments.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var args = new Array(argLength);
	          for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i];
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              if (arguments.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
	              }
	              var target = arguments[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              domGlobals.console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$1 };
	
	    var isBr$5 = function (pos) {
	      return getElementFromPosition(pos).exists(isBr);
	    };
	    var findBr = function (forward, root, pos) {
	      var parentBlocks = filter(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	      var scope = head(parentBlocks).getOr(root);
	      return CaretFinder.fromPosition(forward, scope.dom(), pos).filter(isBr$5);
	    };
	    var isBeforeBr = function (root, pos) {
	      return getElementFromPosition(pos).exists(isBr) || findBr(true, root, pos).isSome();
	    };
	    var isAfterBr = function (root, pos) {
	      return getElementFromPrevPosition(pos).exists(isBr) || findBr(false, root, pos).isSome();
	    };
	    var findPreviousBr = curry(findBr, false);
	    var findNextBr = curry(findBr, true);
	
	    var is$2 = function (expected) {
	      return function (actual) {
	        return expected === actual;
	      };
	    };
	    var isNbsp = is$2('\xA0');
	    var isWhiteSpace$1 = function (chr) {
	      return /^[\r\n\t ]$/.test(chr);
	    };
	    var isContent$1 = function (chr) {
	      return !isWhiteSpace$1(chr) && !isNbsp(chr);
	    };
	
	    var isChar = function (forward, predicate, pos) {
	      return Option.from(pos.container()).filter(NodeType.isText).exists(function (text) {
	        var delta = forward ? 0 : -1;
	        return predicate(text.data.charAt(pos.offset() + delta));
	      });
	    };
	    var isBeforeSpace = curry(isChar, true, isWhiteSpace$1);
	    var isAfterSpace = curry(isChar, false, isWhiteSpace$1);
	    var isEmptyText = function (pos) {
	      var container = pos.container();
	      return NodeType.isText(container) && container.data.length === 0;
	    };
	    var isNextToContentEditableFalse = function (relativeOffset, caretPosition) {
	      var node = getChildNodeAtRelativeOffset(relativeOffset, caretPosition);
	      return NodeType.isContentEditableFalse(node) && !NodeType.isBogusAll(node);
	    };
	    var isBeforeContentEditableFalse = curry(isNextToContentEditableFalse, 0);
	    var isAfterContentEditableFalse = curry(isNextToContentEditableFalse, -1);
	    var isNextToTable = function (relativeOffset, caretPosition) {
	      return NodeType.isTable(getChildNodeAtRelativeOffset(relativeOffset, caretPosition));
	    };
	    var isBeforeTable = curry(isNextToTable, 0);
	    var isAfterTable = curry(isNextToTable, -1);
	
	    var isCompoundElement = function (node) {
	      return isTableCell(Element.fromDom(node)) || isListItem(Element.fromDom(node));
	    };
	    var DeleteAction = Adt.generate([
	      { remove: ['element'] },
	      { moveToElement: ['element'] },
	      { moveToPosition: ['position'] }
	    ]);
	    var isAtContentEditableBlockCaret = function (forward, from) {
	      var elm = from.getNode(forward === false);
	      var caretLocation = forward ? 'after' : 'before';
	      return NodeType.isElement(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
	    };
	    var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
	      var inSameBlock = function (elm) {
	        return isInline(Element.fromDom(elm)) && !isInSameBlock(from, to, root);
	      };
	      return getRelativeCefElm(!forward, from).fold(function () {
	        return getRelativeCefElm(forward, to).fold(constant(false), inSameBlock);
	      }, inSameBlock);
	    };
	    var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
	      var toCefElm = to.getNode(forward === false);
	      return DeleteUtils.getParentBlock(Element.fromDom(root), Element.fromDom(from.getNode())).map(function (blockElm) {
	        return Empty.isEmpty(blockElm) ? DeleteAction.remove(blockElm.dom()) : DeleteAction.moveToElement(toCefElm);
	      }).orThunk(function () {
	        return Option.some(DeleteAction.moveToElement(toCefElm));
	      });
	    };
	    var findCefPosition = function (root, forward, from) {
	      return CaretFinder.fromPosition(forward, root, from).bind(function (to) {
	        if (isCompoundElement(to.getNode())) {
	          return Option.none();
	        } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
	          return Option.none();
	        } else if (forward && NodeType.isContentEditableFalse(to.getNode())) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward === false && NodeType.isContentEditableFalse(to.getNode(true))) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward && isAfterContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else if (forward === false && isBeforeContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else {
	          return Option.none();
	        }
	      });
	    };
	    var getContentEditableBlockAction = function (forward, elm) {
	      if (forward && NodeType.isContentEditableFalse(elm.nextSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.nextSibling));
	      } else if (forward === false && NodeType.isContentEditableFalse(elm.previousSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.previousSibling));
	      } else {
	        return Option.none();
	      }
	    };
	    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
	      return deleteAction.fold(function (elm) {
	        return Option.some(DeleteAction.remove(elm));
	      }, function (elm) {
	        return Option.some(DeleteAction.moveToElement(elm));
	      }, function (to) {
	        if (isInSameBlock(from, to, root)) {
	          return Option.none();
	        } else {
	          return Option.some(DeleteAction.moveToPosition(to));
	        }
	      });
	    };
	    var getContentEditableAction = function (root, forward, from) {
	      if (isAtContentEditableBlockCaret(forward, from)) {
	        return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
	          return findCefPosition(root, forward, from);
	        }, Option.some);
	      } else {
	        return findCefPosition(root, forward, from).bind(function (deleteAction) {
	          return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
	        });
	      }
	    };
	    var read$2 = function (root, forward, rng) {
	      var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
	      var from = CaretPosition$1.fromRangeStart(normalizedRange);
	      var rootElement = Element.fromDom(root);
	      if (forward === false && isAfterContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode(true)));
	      } else if (forward && isBeforeContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode()));
	      } else if (forward === false && isBeforeContentEditableFalse(from) && isAfterBr(rootElement, from)) {
	        return findPreviousBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else if (forward && isAfterContentEditableFalse(from) && isBeforeBr(rootElement, from)) {
	        return findNextBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else {
	        return getContentEditableAction(root, forward, from);
	      }
	    };
	
	    var isCollapsibleWhitespace = function (c) {
	      return ' \f\n\r\t\x0B'.indexOf(c) !== -1;
	    };
	    var normalizeContent = function (content, isStartOfContent, isEndOfContent) {
	      var result = foldl(content.split(''), function (acc, c) {
	        if (isCollapsibleWhitespace(c) || c === '\xA0') {
	          if (acc.previousCharIsSpace || acc.str === '' && isStartOfContent || acc.str.length === content.length - 1 && isEndOfContent) {
	            return {
	              previousCharIsSpace: false,
	              str: acc.str + '\xA0'
	            };
	          } else {
	            return {
	              previousCharIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            previousCharIsSpace: false,
	            str: acc.str + c
	          };
	        }
	      }, {
	        previousCharIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	    var normalize$1 = function (node, offset, count) {
	      if (count === 0) {
	        return;
	      }
	      var whitespace = node.data.slice(offset, offset + count);
	      var isEndOfContent = offset + count >= node.data.length;
	      var isStartOfContent = offset === 0;
	      node.replaceData(offset, count, normalizeContent(whitespace, isStartOfContent, isEndOfContent));
	    };
	    var normalizeWhitespaceAfter = function (node, offset) {
	      var content = node.data.slice(offset);
	      var whitespaceCount = content.length - lTrim(content).length;
	      return normalize$1(node, offset, whitespaceCount);
	    };
	    var normalizeWhitespaceBefore = function (node, offset) {
	      var content = node.data.slice(0, offset);
	      var whitespaceCount = content.length - rTrim(content).length;
	      return normalize$1(node, offset - whitespaceCount, whitespaceCount);
	    };
	    var mergeTextNodes = function (prevNode, nextNode, normalizeWhitespace) {
	      var whitespaceOffset = rTrim(prevNode.data).length;
	      prevNode.appendData(nextNode.data);
	      remove$1(Element.fromDom(nextNode));
	      if (normalizeWhitespace) {
	        normalizeWhitespaceAfter(prevNode, whitespaceOffset);
	      }
	      return prevNode;
	    };
	
	    var needsReposition = function (pos, elm) {
	      var container = pos.container();
	      var offset = pos.offset();
	      return CaretPosition$1.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition$1.before(elm).offset();
	    };
	    var reposition = function (elm, pos) {
	      return needsReposition(pos, elm) ? CaretPosition$1(pos.container(), pos.offset() - 1) : pos;
	    };
	    var beforeOrStartOf = function (node) {
	      return NodeType.isText(node) ? CaretPosition$1(node, 0) : CaretPosition$1.before(node);
	    };
	    var afterOrEndOf = function (node) {
	      return NodeType.isText(node) ? CaretPosition$1(node, node.data.length) : CaretPosition$1.after(node);
	    };
	    var getPreviousSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.previousSibling)) {
	        return Option.some(afterOrEndOf(elm.previousSibling));
	      } else {
	        return elm.previousSibling ? CaretFinder.lastPositionIn(elm.previousSibling) : Option.none();
	      }
	    };
	    var getNextSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.nextSibling)) {
	        return Option.some(beforeOrStartOf(elm.nextSibling));
	      } else {
	        return elm.nextSibling ? CaretFinder.firstPositionIn(elm.nextSibling) : Option.none();
	      }
	    };
	    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
	      var startPosition = CaretPosition$1.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
	      return CaretFinder.prevPosition(rootElement, startPosition).fold(function () {
	        return CaretFinder.nextPosition(rootElement, CaretPosition$1.after(elm));
	      }, Option.some);
	    };
	    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
	      return CaretFinder.nextPosition(rootElement, CaretPosition$1.after(elm)).fold(function () {
	        return CaretFinder.prevPosition(rootElement, CaretPosition$1.before(elm));
	      }, Option.some);
	    };
	    var findCaretPositionBackwards = function (rootElement, elm) {
	      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
	        return getNextSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionBackwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPositionForward = function (rootElement, elm) {
	      return getNextSiblingCaretPosition(elm).orThunk(function () {
	        return getPreviousSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionForwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPosition$1 = function (forward, rootElement, elm) {
	      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
	    };
	    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
	      return findCaretPosition$1(forward, rootElement, elm).map(curry(reposition, elm));
	    };
	    var setSelection = function (editor, forward, pos) {
	      pos.fold(function () {
	        editor.focus();
	      }, function (pos) {
	        editor.selection.setRng(pos.toRange(), forward);
	      });
	    };
	    var eqRawNode = function (rawNode) {
	      return function (elm) {
	        return elm.dom() === rawNode;
	      };
	    };
	    var isBlock$2 = function (editor, elm) {
	      return elm && editor.schema.getBlockElements().hasOwnProperty(name(elm));
	    };
	    var paddEmptyBlock = function (elm) {
	      if (Empty.isEmpty(elm)) {
	        var br = Element.fromHtml('<br data-mce-bogus="1">');
	        empty(elm);
	        append(elm, br);
	        return Option.some(CaretPosition$1.before(br.dom()));
	      } else {
	        return Option.none();
	      }
	    };
	    var deleteNormalized = function (elm, afterDeletePosOpt, normalizeWhitespace) {
	      var prevTextOpt = prevSibling(elm).filter(isText);
	      var nextTextOpt = nextSibling(elm).filter(isText);
	      remove$1(elm);
	      return lift3(prevTextOpt, nextTextOpt, afterDeletePosOpt, function (prev, next, pos) {
	        var prevNode = prev.dom(), nextNode = next.dom();
	        var offset = prevNode.data.length;
	        mergeTextNodes(prevNode, nextNode, normalizeWhitespace);
	        return pos.container() === nextNode ? CaretPosition$1(prevNode, offset) : pos;
	      }).orThunk(function () {
	        if (normalizeWhitespace) {
	          prevTextOpt.each(function (elm) {
	            return normalizeWhitespaceBefore(elm.dom(), elm.dom().length);
	          });
	          nextTextOpt.each(function (elm) {
	            return normalizeWhitespaceAfter(elm.dom(), 0);
	          });
	        }
	        return afterDeletePosOpt;
	      });
	    };
	    var isInlineElement = function (editor, element) {
	      return has(editor.schema.getTextInlineElements(), name(element));
	    };
	    var deleteElement = function (editor, forward, elm, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom());
	      var parentBlock = ancestor(elm, curry(isBlock$2, editor), eqRawNode(editor.getBody()));
	      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos, isInlineElement(editor, elm));
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        editor.selection.setCursorLocation();
	      } else {
	        parentBlock.bind(paddEmptyBlock).fold(function () {
	          if (moveCaret) {
	            setSelection(editor, forward, normalizedAfterDeletePos);
	          }
	        }, function (paddPos) {
	          if (moveCaret) {
	            setSelection(editor, forward, Option.some(paddPos));
	          }
	        });
	      }
	    };
	    var DeleteElement = { deleteElement: deleteElement };
	
	    var deleteElement$1 = function (editor, forward) {
	      return function (element) {
	        editor._selectionOverrides.hideFakeCaret();
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(element));
	        return true;
	      };
	    };
	    var moveToElement = function (editor, forward) {
	      return function (element) {
	        var pos = forward ? CaretPosition$1.before(element) : CaretPosition$1.after(element);
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var moveToPosition = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var backspaceDeleteCaret = function (editor, forward) {
	      var result = read$2(editor.getBody(), forward, editor.selection.getRng()).map(function (deleteAction) {
	        return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
	      });
	      return result.getOr(false);
	    };
	    var deleteOffscreenSelection = function (rootElement) {
	      each(descendants$1(rootElement, '.mce-offscreen-selection'), remove$1);
	    };
	    var backspaceDeleteRange = function (editor, forward) {
	      var selectedElement = editor.selection.getNode();
	      if (NodeType.isContentEditableFalse(selectedElement)) {
	        deleteOffscreenSelection(Element.fromDom(editor.getBody()));
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(editor.selection.getNode()));
	        DeleteUtils.paddEmptyBody(editor);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var getContentEditableRoot = function (root, node) {
	      while (node && node !== root) {
	        if (NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var paddEmptyElement = function (editor) {
	      var br;
	      var ceRoot = getContentEditableRoot(editor.getBody(), editor.selection.getNode());
	      if (NodeType.isContentEditableTrue(ceRoot) && editor.dom.isBlock(ceRoot) && editor.dom.isEmpty(ceRoot)) {
	        br = editor.dom.create('br', { 'data-mce-bogus': '1' });
	        editor.dom.setHTML(ceRoot, '');
	        ceRoot.appendChild(br);
	        editor.selection.setRng(CaretPosition$1.before(br).toRange());
	      }
	      return true;
	    };
	    var backspaceDelete$2 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return backspaceDeleteCaret(editor, forward);
	      } else {
	        return backspaceDeleteRange(editor, forward);
	      }
	    };
	    var CefDelete = {
	      backspaceDelete: backspaceDelete$2,
	      paddEmptyElement: paddEmptyElement
	    };
	
	    var isText$8 = NodeType.isText;
	    var startsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[0] === Zwsp.ZWSP;
	    };
	    var endsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[node.data.length - 1] === Zwsp.ZWSP;
	    };
	    var createZwsp = function (node) {
	      return node.ownerDocument.createTextNode(Zwsp.ZWSP);
	    };
	    var insertBefore$1 = function (node) {
	      if (isText$8(node.previousSibling)) {
	        if (endsWithCaretContainer$1(node.previousSibling)) {
	          return node.previousSibling;
	        } else {
	          node.previousSibling.appendData(Zwsp.ZWSP);
	          return node.previousSibling;
	        }
	      } else if (isText$8(node)) {
	        if (startsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.insertData(0, Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        node.parentNode.insertBefore(newNode, node);
	        return newNode;
	      }
	    };
	    var insertAfter$1 = function (node) {
	      if (isText$8(node.nextSibling)) {
	        if (startsWithCaretContainer$1(node.nextSibling)) {
	          return node.nextSibling;
	        } else {
	          node.nextSibling.insertData(0, Zwsp.ZWSP);
	          return node.nextSibling;
	        }
	      } else if (isText$8(node)) {
	        if (endsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.appendData(Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        if (node.nextSibling) {
	          node.parentNode.insertBefore(newNode, node.nextSibling);
	        } else {
	          node.parentNode.appendChild(newNode);
	        }
	        return newNode;
	      }
	    };
	    var insertInline$1 = function (before, node) {
	      return before ? insertBefore$1(node) : insertAfter$1(node);
	    };
	    var insertInlineBefore = curry(insertInline$1, true);
	    var insertInlineAfter = curry(insertInline$1, false);
	
	    var insertInlinePos = function (pos, before) {
	      if (NodeType.isText(pos.container())) {
	        return insertInline$1(before, pos.container());
	      } else {
	        return insertInline$1(before, pos.getNode());
	      }
	    };
	    var isPosCaretContainer = function (pos, caret) {
	      var caretNode = caret.get();
	      return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
	    };
	    var renderCaret = function (caret, location) {
	      return location.fold(function (element) {
	        CaretContainerRemove.remove(caret.get());
	        var text = insertInlineBefore(element);
	        caret.set(text);
	        return Option.some(CaretPosition$1(text, text.length - 1));
	      }, function (element) {
	        return CaretFinder.firstPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            CaretContainerRemove.remove(caret.get());
	            var text = insertInlinePos(pos, true);
	            caret.set(text);
	            return CaretPosition$1(text, 1);
	          } else {
	            return CaretPosition$1(caret.get(), 1);
	          }
	        });
	      }, function (element) {
	        return CaretFinder.lastPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            CaretContainerRemove.remove(caret.get());
	            var text = insertInlinePos(pos, false);
	            caret.set(text);
	            return CaretPosition$1(text, text.length - 1);
	          } else {
	            return CaretPosition$1(caret.get(), caret.get().length - 1);
	          }
	        });
	      }, function (element) {
	        CaretContainerRemove.remove(caret.get());
	        var text = insertInlineAfter(element);
	        caret.set(text);
	        return Option.some(CaretPosition$1(text, 1));
	      });
	    };
	    var BoundaryCaret = { renderCaret: renderCaret };
	
	    var evaluateUntil = function (fns, args) {
	      for (var i = 0; i < fns.length; i++) {
	        var result = fns[i].apply(null, args);
	        if (result.isSome()) {
	          return result;
	        }
	      }
	      return Option.none();
	    };
	    var LazyEvaluator = { evaluateUntil: evaluateUntil };
	
	    var Location = Adt.generate([
	      { before: ['element'] },
	      { start: ['element'] },
	      { end: ['element'] },
	      { after: ['element'] }
	    ]);
	    var rescope = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var before$3 = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return CaretFinder.nextPosition(scope, nPos).bind(curry(InlineUtils.findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.before(inline);
	        });
	      }, Option.none);
	    };
	    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
	      return getParentCaretContainer(rootNode, elm) === null;
	    };
	    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
	      return InlineUtils.findRootInline(isInlineTarget, rootNode, pos).filter(curry(isNotInsideFormatCaretContainer, rootNode));
	    };
	    var start = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var prevPos = CaretFinder.prevPosition(inline, nPos);
	        return prevPos.isNone() ? Option.some(Location.start(inline)) : Option.none();
	      });
	    };
	    var end = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var nextPos = CaretFinder.nextPosition(inline, nPos);
	        return nextPos.isNone() ? Option.some(Location.end(inline)) : Option.none();
	      });
	    };
	    var after$2 = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return CaretFinder.prevPosition(scope, nPos).bind(curry(InlineUtils.findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.after(inline);
	        });
	      }, Option.none);
	    };
	    var isValidLocation = function (location) {
	      return InlineUtils.isRtl(getElement(location)) === false;
	    };
	    var readLocation = function (isInlineTarget, rootNode, pos) {
	      var location = LazyEvaluator.evaluateUntil([
	        before$3,
	        start,
	        end,
	        after$2
	      ], [
	        isInlineTarget,
	        rootNode,
	        pos
	      ]);
	      return location.filter(isValidLocation);
	    };
	    var getElement = function (location) {
	      return location.fold(identity, identity, identity, identity);
	    };
	    var getName = function (location) {
	      return location.fold(constant('before'), constant('start'), constant('end'), constant('after'));
	    };
	    var outside = function (location) {
	      return location.fold(Location.before, Location.before, Location.after, Location.after);
	    };
	    var inside = function (location) {
	      return location.fold(Location.start, Location.start, Location.end, Location.end);
	    };
	    var isEq$1 = function (location1, location2) {
	      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
	    };
	    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
	      return lift2(InlineUtils.findRootInline(isInlineTarget, rootNode, from), InlineUtils.findRootInline(isInlineTarget, rootNode, to), function (fromInline, toInline) {
	        if (fromInline !== toInline && InlineUtils.hasSameParentBlock(rootNode, fromInline, toInline)) {
	          return Location.after(forward ? fromInline : toInline);
	        } else {
	          return location;
	        }
	      }).getOr(location);
	    };
	    var skipNoMovement = function (fromLocation, toLocation) {
	      return fromLocation.fold(constant(true), function (fromLocation) {
	        return !isEq$1(fromLocation, toLocation);
	      });
	    };
	    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var to = CaretFinder.fromPosition(forward, rootNode, from).map(curry(InlineUtils.normalizePosition, forward));
	      var location = to.fold(function () {
	        return fromLocation.map(outside);
	      }, function (to) {
	        return readLocation(isInlineTarget, rootNode, to).map(curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter(curry(skipNoMovement, fromLocation));
	      });
	      return location.filter(isValidLocation);
	    };
	    var findLocationSimple = function (forward, location) {
	      if (forward) {
	        return location.fold(compose(Option.some, Location.start), Option.none, compose(Option.some, Location.after), Option.none);
	      } else {
	        return location.fold(Option.none, compose(Option.some, Location.before), Option.none, compose(Option.some, Location.end));
	      }
	    };
	    var findLocation = function (forward, isInlineTarget, rootNode, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var fromLocation = readLocation(isInlineTarget, rootNode, from);
	      return readLocation(isInlineTarget, rootNode, from).bind(curry(findLocationSimple, forward)).orThunk(function () {
	        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
	      });
	    };
	    var BoundaryLocation = {
	      readLocation: readLocation,
	      findLocation: findLocation,
	      prevLocation: curry(findLocation, false),
	      nextLocation: curry(findLocation, true),
	      getElement: getElement,
	      outside: outside,
	      inside: inside
	    };
	
	    var hasSelectionModifyApi = function (editor) {
	      return isFunction(editor.selection.getSel().modify);
	    };
	    var moveRel = function (forward, selection, pos) {
	      var delta = forward ? 1 : -1;
	      selection.setRng(CaretPosition$1(pos.container(), pos.offset() + delta).toRange());
	      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
	      return true;
	    };
	    var moveByWord = function (forward, editor) {
	      var rng = editor.selection.getRng();
	      var pos = forward ? CaretPosition$1.fromRangeEnd(rng) : CaretPosition$1.fromRangeStart(rng);
	      if (!hasSelectionModifyApi(editor)) {
	        return false;
	      } else if (forward && isBeforeInline(pos)) {
	        return moveRel(true, editor.selection, pos);
	      } else if (!forward && isAfterInline(pos)) {
	        return moveRel(false, editor.selection, pos);
	      } else {
	        return false;
	      }
	    };
	    var WordSelection = {
	      hasSelectionModifyApi: hasSelectionModifyApi,
	      moveByWord: moveByWord
	    };
	
	    var setCaretPosition = function (editor, pos) {
	      var rng = editor.dom.createRng();
	      rng.setStart(pos.container(), pos.offset());
	      rng.setEnd(pos.container(), pos.offset());
	      editor.selection.setRng(rng);
	    };
	    var isFeatureEnabled = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	    var setSelected = function (state, elm) {
	      if (state) {
	        elm.setAttribute('data-mce-selected', 'inline-boundary');
	      } else {
	        elm.removeAttribute('data-mce-selected');
	      }
	    };
	    var renderCaretLocation = function (editor, caret, location) {
	      return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	        setCaretPosition(editor, pos);
	        return location;
	      });
	    };
	    var findLocation$1 = function (editor, caret, forward) {
	      var rootNode = editor.getBody();
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var location = BoundaryLocation.findLocation(forward, isInlineTarget, rootNode, from);
	      return location.bind(function (location) {
	        return renderCaretLocation(editor, caret, location);
	      });
	    };
	    var toggleInlines = function (isInlineTarget, dom, elms) {
	      var selectedInlines = filter(dom.select('*[data-mce-selected="inline-boundary"]'), isInlineTarget);
	      var targetInlines = filter(elms, isInlineTarget);
	      each(difference(selectedInlines, targetInlines), curry(setSelected, false));
	      each(difference(targetInlines, selectedInlines), curry(setSelected, true));
	    };
	    var safeRemoveCaretContainer = function (editor, caret) {
	      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
	        var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        if (CaretPosition$1.isTextPosition(pos) && InlineUtils.isAtZwsp(pos) === false) {
	          setCaretPosition(editor, CaretContainerRemove.removeAndReposition(caret.get(), pos));
	          caret.set(null);
	        }
	      }
	    };
	    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
	      if (editor.selection.isCollapsed()) {
	        var inlines = filter(elms, isInlineTarget);
	        each(inlines, function (inline) {
	          var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	          BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
	            return renderCaretLocation(editor, caret, location);
	          });
	        });
	      }
	    };
	    var move = function (editor, caret, forward) {
	      return function () {
	        return isFeatureEnabled(editor) ? findLocation$1(editor, caret, forward).isSome() : false;
	      };
	    };
	    var moveWord = function (forward, editor, caret) {
	      return function () {
	        return isFeatureEnabled(editor) ? WordSelection.moveByWord(forward, editor) : false;
	      };
	    };
	    var setupSelectedState = function (editor) {
	      var caret = Cell(null);
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      editor.on('NodeChange', function (e) {
	        if (isFeatureEnabled(editor)) {
	          toggleInlines(isInlineTarget, editor.dom, e.parents);
	          safeRemoveCaretContainer(editor, caret);
	          renderInsideInlineCaret(isInlineTarget, editor, caret, e.parents);
	        }
	      });
	      return caret;
	    };
	    var moveNextWord = curry(moveWord, true);
	    var movePrevWord = curry(moveWord, false);
	    var BoundarySelection = {
	      move: move,
	      moveNextWord: moveNextWord,
	      movePrevWord: movePrevWord,
	      setupSelectedState: setupSelectedState,
	      setCaretPosition: setCaretPosition
	    };
	
	    var isFeatureEnabled$1 = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	    var rangeFromPositions = function (from, to) {
	      var range = domGlobals.document.createRange();
	      range.setStart(from.container(), from.offset());
	      range.setEnd(to.container(), to.offset());
	      return range;
	    };
	    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
	      return lift2(CaretFinder.firstPositionIn(elm), CaretFinder.lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	        return CaretFinder.nextPosition(elm, normalizedFirstPos).map(function (pos) {
	          return pos.isEqual(normalizedLastPos);
	        }).getOr(true);
	      }).getOr(true);
	    };
	    var setCaretLocation = function (editor, caret) {
	      return function (location) {
	        return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	          BoundarySelection.setCaretPosition(editor, pos);
	          return true;
	        }).getOr(false);
	      };
	    };
	    var deleteFromTo = function (editor, caret, from, to) {
	      var rootNode = editor.getBody();
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      editor.undoManager.ignore(function () {
	        editor.selection.setRng(rangeFromPositions(from, to));
	        editor.execCommand('Delete');
	        BoundaryLocation.readLocation(isInlineTarget, rootNode, CaretPosition$1.fromRangeStart(editor.selection.getRng())).map(BoundaryLocation.inside).map(setCaretLocation(editor, caret));
	      });
	      editor.nodeChanged();
	    };
	    var rescope$1 = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
	      var rootNode = rescope$1(editor.getBody(), from.container());
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var fromLocation = BoundaryLocation.readLocation(isInlineTarget, rootNode, from);
	      return fromLocation.bind(function (location) {
	        if (forward) {
	          return location.fold(constant(Option.some(BoundaryLocation.inside(location))), Option.none, constant(Option.some(BoundaryLocation.outside(location))), Option.none);
	        } else {
	          return location.fold(Option.none, constant(Option.some(BoundaryLocation.outside(location))), Option.none, constant(Option.some(BoundaryLocation.inside(location))));
	        }
	      }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
	        var toPosition = CaretFinder.navigate(forward, rootNode, from);
	        var toLocation = toPosition.bind(function (pos) {
	          return BoundaryLocation.readLocation(isInlineTarget, rootNode, pos);
	        });
	        if (fromLocation.isSome() && toLocation.isSome()) {
	          return InlineUtils.findRootInline(isInlineTarget, rootNode, from).map(function (elm) {
	            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
	              DeleteElement.deleteElement(editor, forward, Element.fromDom(elm));
	              return true;
	            } else {
	              return false;
	            }
	          }).getOr(false);
	        } else {
	          return toLocation.bind(function (_) {
	            return toPosition.map(function (to) {
	              if (forward) {
	                deleteFromTo(editor, caret, from, to);
	              } else {
	                deleteFromTo(editor, caret, to, from);
	              }
	              return true;
	            });
	          }).getOr(false);
	        }
	      });
	    };
	    var backspaceDelete$3 = function (editor, caret, forward) {
	      if (editor.selection.isCollapsed() && isFeatureEnabled$1(editor)) {
	        var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        return backspaceDeleteCollapsed(editor, caret, forward, from);
	      }
	      return false;
	    };
	    var InlineBoundaryDelete = { backspaceDelete: backspaceDelete$3 };
	
	    var tableCellRng = Immutable('start', 'end');
	    var tableSelection = Immutable('rng', 'table', 'cells');
	    var deleteAction = Adt.generate([
	      { removeTable: ['element'] },
	      { emptyCells: ['cells'] }
	    ]);
	    var isRootFromElement = function (root) {
	      return curry(eq, root);
	    };
	    var getClosestCell = function (container, isRoot) {
	      return closest$1(Element.fromDom(container), 'td,th', isRoot);
	    };
	    var getClosestTable = function (cell, isRoot) {
	      return ancestor$1(cell, 'table', isRoot);
	    };
	    var isExpandedCellRng = function (cellRng) {
	      return eq(cellRng.start(), cellRng.end()) === false;
	    };
	    var getTableFromCellRng = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start(), isRoot).bind(function (startParentTable) {
	        return getClosestTable(cellRng.end(), isRoot).bind(function (endParentTable) {
	          return eq(startParentTable, endParentTable) ? Option.some(startParentTable) : Option.none();
	        });
	      });
	    };
	    var getTableCells = function (table) {
	      return descendants$1(table, 'td,th');
	    };
	    var getCellRangeFromStartTable = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start(), isRoot).bind(function (table) {
	        return last(getTableCells(table)).map(function (endCell) {
	          return tableCellRng(cellRng.start(), endCell);
	        });
	      });
	    };
	    var partialSelection = function (isRoot, rng) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return rng.collapsed ? Option.none() : lift2(startCell, endCell, tableCellRng).fold(function () {
	        return startCell.fold(function () {
	          return endCell.bind(function (endCell) {
	            return getClosestTable(endCell, isRoot).bind(function (table) {
	              return head(getTableCells(table)).map(function (startCell) {
	                return tableCellRng(startCell, endCell);
	              });
	            });
	          });
	        }, function (startCell) {
	          return getClosestTable(startCell, isRoot).bind(function (table) {
	            return last(getTableCells(table)).map(function (endCell) {
	              return tableCellRng(startCell, endCell);
	            });
	          });
	        });
	      }, function (cellRng) {
	        return isWithinSameTable(isRoot, cellRng) ? Option.none() : getCellRangeFromStartTable(cellRng, isRoot);
	      });
	    };
	    var isWithinSameTable = function (isRoot, cellRng) {
	      return getTableFromCellRng(cellRng, isRoot).isSome();
	    };
	    var getCellRng = function (rng, isRoot) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return lift2(startCell, endCell, tableCellRng).filter(isExpandedCellRng).filter(function (cellRng) {
	        return isWithinSameTable(isRoot, cellRng);
	      }).orThunk(function () {
	        return partialSelection(isRoot, rng);
	      });
	    };
	    var getTableSelectionFromCellRng = function (cellRng, isRoot) {
	      return getTableFromCellRng(cellRng, isRoot).map(function (table) {
	        return tableSelection(cellRng, table, getTableCells(table));
	      });
	    };
	    var getTableSelectionFromRng = function (root, rng) {
	      var isRoot = isRootFromElement(root);
	      return getCellRng(rng, isRoot).bind(function (cellRng) {
	        return getTableSelectionFromCellRng(cellRng, isRoot);
	      });
	    };
	    var getCellIndex = function (cells, cell) {
	      return findIndex(cells, function (x) {
	        return eq(x, cell);
	      });
	    };
	    var getSelectedCells = function (tableSelection) {
	      return lift2(getCellIndex(tableSelection.cells(), tableSelection.rng().start()), getCellIndex(tableSelection.cells(), tableSelection.rng().end()), function (startIndex, endIndex) {
	        return tableSelection.cells().slice(startIndex, endIndex + 1);
	      });
	    };
	    var getAction = function (tableSelection) {
	      return getSelectedCells(tableSelection).map(function (selected) {
	        var cells = tableSelection.cells();
	        return selected.length === cells.length ? deleteAction.removeTable(tableSelection.table()) : deleteAction.emptyCells(selected);
	      });
	    };
	    var getActionFromCells = function (cells) {
	      return deleteAction.emptyCells(cells);
	    };
	    var getActionFromRange = function (root, rng) {
	      return getTableSelectionFromRng(root, rng).bind(getAction);
	    };
	    var TableDeleteAction = {
	      getActionFromRange: getActionFromRange,
	      getActionFromCells: getActionFromCells
	    };
	
	    var getRanges = function (selection) {
	      var ranges = [];
	      if (selection) {
	        for (var i = 0; i < selection.rangeCount; i++) {
	          ranges.push(selection.getRangeAt(i));
	        }
	      }
	      return ranges;
	    };
	    var getSelectedNodes = function (ranges) {
	      return bind(ranges, function (range) {
	        var node = getSelectedNode(range);
	        return node ? [Element.fromDom(node)] : [];
	      });
	    };
	    var hasMultipleRanges = function (selection) {
	      return getRanges(selection).length > 1;
	    };
	    var MultiRange = {
	      getRanges: getRanges,
	      getSelectedNodes: getSelectedNodes,
	      hasMultipleRanges: hasMultipleRanges
	    };
	
	    var getCellsFromRanges = function (ranges) {
	      return filter(MultiRange.getSelectedNodes(ranges), isTableCell);
	    };
	    var getCellsFromElement = function (elm) {
	      var selectedCells = descendants$1(elm, 'td[data-mce-selected],th[data-mce-selected]');
	      return selectedCells;
	    };
	    var getCellsFromElementOrRanges = function (ranges, element) {
	      var selectedCells = getCellsFromElement(element);
	      var rangeCells = getCellsFromRanges(ranges);
	      return selectedCells.length > 0 ? selectedCells : rangeCells;
	    };
	    var getCellsFromEditor = function (editor) {
	      return getCellsFromElementOrRanges(MultiRange.getRanges(editor.selection.getSel()), Element.fromDom(editor.getBody()));
	    };
	    var TableCellSelection = {
	      getCellsFromRanges: getCellsFromRanges,
	      getCellsFromElement: getCellsFromElement,
	      getCellsFromElementOrRanges: getCellsFromElementOrRanges,
	      getCellsFromEditor: getCellsFromEditor
	    };
	
	    var emptyCells = function (editor, cells) {
	      each(cells, PaddingBr.fillWithPaddingBr);
	      editor.selection.setCursorLocation(cells[0].dom(), 0);
	      return true;
	    };
	    var deleteTableElement = function (editor, table) {
	      DeleteElement.deleteElement(editor, false, table);
	      return true;
	    };
	    var deleteCellRange = function (editor, rootElm, rng) {
	      return TableDeleteAction.getActionFromRange(rootElm, rng).map(function (action) {
	        return action.fold(curry(deleteTableElement, editor), curry(emptyCells, editor));
	      });
	    };
	    var deleteCaptionRange = function (editor, caption) {
	      return emptyElement(editor, caption);
	    };
	    var deleteTableRange = function (editor, rootElm, rng, startElm) {
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCellRange(editor, rootElm, rng);
	      }, function (caption) {
	        return deleteCaptionRange(editor, caption);
	      }).getOr(false);
	    };
	    var deleteRange$1 = function (editor, startElm) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      var selectedCells = TableCellSelection.getCellsFromEditor(editor);
	      return selectedCells.length !== 0 ? emptyCells(editor, selectedCells) : deleteTableRange(editor, rootNode, rng, startElm);
	    };
	    var getParentCell = function (rootElm, elm) {
	      return find(Parents.parentsAndSelf(elm, rootElm), isTableCell);
	    };
	    var getParentCaption = function (rootElm, elm) {
	      return find(Parents.parentsAndSelf(elm, rootElm), function (elm) {
	        return name(elm) === 'caption';
	      });
	    };
	    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return getParentCell(rootElm, Element.fromDom(to.getNode())).map(function (toCell) {
	          return eq(toCell, fromCell) === false;
	        });
	      });
	    };
	    var emptyElement = function (editor, elm) {
	      PaddingBr.fillWithPaddingBr(elm);
	      editor.selection.setCursorLocation(elm.dom(), 0);
	      return Option.some(true);
	    };
	    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
	      return CaretFinder.firstPositionIn(fromCaption.dom()).bind(function (first) {
	        return CaretFinder.lastPositionIn(fromCaption.dom()).map(function (last) {
	          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
	        });
	      }).getOr(true);
	    };
	    var emptyCaretCaption = function (editor, elm) {
	      return emptyElement(editor, elm);
	    };
	    var validateCaretCaption = function (rootElm, fromCaption, to) {
	      return getParentCaption(rootElm, Element.fromDom(to.getNode())).map(function (toCaption) {
	        return eq(toCaption, fromCaption) === false;
	      });
	    };
	    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
	      }).or(Option.some(true));
	    };
	    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return getParentCell(rootElm, startElm).bind(function (fromCell) {
	        return Empty.isEmpty(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
	      });
	    };
	    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return Empty.isEmpty(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
	    };
	    var deleteCaret = function (editor, forward, startElm) {
	      var rootElm = Element.fromDom(editor.getBody());
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCaretCells(editor, forward, rootElm, startElm);
	      }, function (fromCaption) {
	        return deleteCaretCaption(editor, forward, rootElm, fromCaption);
	      }).getOr(false);
	    };
	    var backspaceDelete$4 = function (editor, forward) {
	      var startElm = Element.fromDom(editor.selection.getStart(true));
	      var cells = TableCellSelection.getCellsFromEditor(editor);
	      return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret(editor, forward, startElm) : deleteRange$1(editor, startElm);
	    };
	    var TableDelete = { backspaceDelete: backspaceDelete$4 };
	
	    var isEq$2 = FormatUtils.isEq;
	    var matchesUnInheritedFormatSelector = function (ed, node, name) {
	      var formatList = ed.formatter.get(name);
	      if (formatList) {
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].inherit === false && ed.dom.is(node, formatList[i].selector)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var matchParents = function (editor, node, name, vars) {
	      var root = editor.dom.getRoot();
	      if (node === root) {
	        return false;
	      }
	      node = editor.dom.getParent(node, function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, name)) {
	          return true;
	        }
	        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
	      });
	      return matchNode(editor, node, name, vars);
	    };
	    var matchName = function (dom, node, format) {
	      if (isEq$2(node, format.inline)) {
	        return true;
	      }
	      if (isEq$2(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return node.nodeType === 1 && dom.is(node, format.selector);
	      }
	    };
	    var matchItems = function (dom, node, format, itemName, similar, vars) {
	      var key, value;
	      var items = format[itemName];
	      var i;
	      if (format.onmatch) {
	        return format.onmatch(node, format, itemName);
	      }
	      if (items) {
	        if (typeof items.length === 'undefined') {
	          for (key in items) {
	            if (items.hasOwnProperty(key)) {
	              if (itemName === 'attributes') {
	                value = dom.getAttrib(node, key);
	              } else {
	                value = FormatUtils.getStyle(dom, node, key);
	              }
	              if (similar && !value && !format.exact) {
	                return;
	              }
	              if ((!similar || format.exact) && !isEq$2(value, FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(items[key], vars), key))) {
	                return;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < items.length; i++) {
	            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : FormatUtils.getStyle(dom, node, items[i])) {
	              return format;
	            }
	          }
	        }
	      }
	      return format;
	    };
	    var matchNode = function (ed, node, name, vars, similar) {
	      var formatList = ed.formatter.get(name);
	      var format, i, x, classes;
	      var dom = ed.dom;
	      if (formatList && node) {
	        for (i = 0; i < formatList.length; i++) {
	          format = formatList[i];
	          if (matchName(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
	            if (classes = format.classes) {
	              for (x = 0; x < classes.length; x++) {
	                if (!ed.dom.hasClass(node, classes[x])) {
	                  return;
	                }
	              }
	            }
	            return format;
	          }
	        }
	      }
	    };
	    var match = function (editor, name, vars, node) {
	      var startNode;
	      if (node) {
	        return matchParents(editor, node, name, vars);
	      }
	      node = editor.selection.getNode();
	      if (matchParents(editor, node, name, vars)) {
	        return true;
	      }
	      startNode = editor.selection.getStart();
	      if (startNode !== node) {
	        if (matchParents(editor, startNode, name, vars)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var matchAll = function (editor, names, vars) {
	      var startElement;
	      var matchedFormatNames = [];
	      var checkedMap = {};
	      startElement = editor.selection.getStart();
	      editor.dom.getParent(startElement, function (node) {
	        var i, name;
	        for (i = 0; i < names.length; i++) {
	          name = names[i];
	          if (!checkedMap[name] && matchNode(editor, node, name, vars)) {
	            checkedMap[name] = true;
	            matchedFormatNames.push(name);
	          }
	        }
	      }, editor.dom.getRoot());
	      return matchedFormatNames;
	    };
	    var canApply = function (editor, name) {
	      var formatList = editor.formatter.get(name);
	      var startNode, parents, i, x, selector;
	      var dom = editor.dom;
	      if (formatList) {
	        startNode = editor.selection.getStart();
	        parents = FormatUtils.getParents(dom, startNode);
	        for (x = formatList.length - 1; x >= 0; x--) {
	          selector = formatList[x].selector;
	          if (!selector || formatList[x].defaultBlock) {
	            return true;
	          }
	          for (i = parents.length - 1; i >= 0; i--) {
	            if (dom.is(parents[i], selector)) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    };
	    var MatchFormat = {
	      matchNode: matchNode,
	      matchName: matchName,
	      match: match,
	      matchAll: matchAll,
	      canApply: canApply,
	      matchesUnInheritedFormatSelector: matchesUnInheritedFormatSelector
	    };
	
	    var splitText = function (node, offset) {
	      return node.splitText(offset);
	    };
	    var split$1 = function (rng) {
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      if (startContainer === endContainer && NodeType.isText(startContainer)) {
	        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          endContainer = splitText(startContainer, startOffset);
	          startContainer = endContainer.previousSibling;
	          if (endOffset > startOffset) {
	            endOffset = endOffset - startOffset;
	            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
	            endOffset = endContainer.nodeValue.length;
	            startOffset = 0;
	          } else {
	            endOffset = 0;
	          }
	        }
	      } else {
	        if (NodeType.isText(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          startContainer = splitText(startContainer, startOffset);
	          startOffset = 0;
	        }
	        if (NodeType.isText(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
	          endContainer = splitText(endContainer, endOffset).previousSibling;
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	    var SplitRange = { split: split$1 };
	
	    var ZWSP$1 = Zwsp.ZWSP, CARET_ID$1 = '_mce_caret';
	    var importNode = function (ownerDocument, node) {
	      return ownerDocument.importNode(node, true);
	    };
	    var getEmptyCaretContainers = function (node) {
	      var nodes = [];
	      while (node) {
	        if (node.nodeType === 3 && node.nodeValue !== ZWSP$1 || node.childNodes.length > 1) {
	          return [];
	        }
	        if (node.nodeType === 1) {
	          nodes.push(node);
	        }
	        node = node.firstChild;
	      }
	      return nodes;
	    };
	    var isCaretContainerEmpty = function (node) {
	      return getEmptyCaretContainers(node).length > 0;
	    };
	    var findFirstTextNode = function (node) {
	      var walker;
	      if (node) {
	        walker = new TreeWalker(node, node);
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var createCaretContainer = function (fill) {
	      var caretContainer = Element.fromTag('span');
	      setAll(caretContainer, {
	        'id': CARET_ID$1,
	        'data-mce-bogus': '1',
	        'data-mce-type': 'format-caret'
	      });
	      if (fill) {
	        append(caretContainer, Element.fromText(ZWSP$1));
	      }
	      return caretContainer;
	    };
	    var trimZwspFromCaretContainer = function (caretContainerNode) {
	      var textNode = findFirstTextNode(caretContainerNode);
	      if (textNode && textNode.nodeValue.charAt(0) === ZWSP$1) {
	        textNode.deleteData(0, 1);
	      }
	      return textNode;
	    };
	    var removeCaretContainerNode = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (isCaretContainerEmpty(node)) {
	        DeleteElement.deleteElement(editor, false, Element.fromDom(node), moveCaret);
	      } else {
	        var rng = selection.getRng();
	        var block = dom.getParent(node, dom.isBlock);
	        var textNode = trimZwspFromCaretContainer(node);
	        if (rng.startContainer === textNode && rng.startOffset > 0) {
	          rng.setStart(textNode, rng.startOffset - 1);
	        }
	        if (rng.endContainer === textNode && rng.endOffset > 0) {
	          rng.setEnd(textNode, rng.endOffset - 1);
	        }
	        dom.remove(node, true);
	        if (block && dom.isEmpty(block)) {
	          PaddingBr.fillWithPaddingBr(Element.fromDom(block));
	        }
	        selection.setRng(rng);
	      }
	    };
	    var removeCaretContainer = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (!node) {
	        node = getParentCaretContainer(editor.getBody(), selection.getStart());
	        if (!node) {
	          while (node = dom.get(CARET_ID$1)) {
	            removeCaretContainerNode(editor, node, false);
	          }
	        }
	      } else {
	        removeCaretContainerNode(editor, node, moveCaret);
	      }
	    };
	    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
	      var dom = editor.dom, block = dom.getParent(formatNode, curry(FormatUtils.isTextBlock, editor));
	      if (block && dom.isEmpty(block)) {
	        formatNode.parentNode.replaceChild(caretContainer, formatNode);
	      } else {
	        PaddingBr.removeTrailingBr(Element.fromDom(formatNode));
	        if (dom.isEmpty(formatNode)) {
	          formatNode.parentNode.replaceChild(caretContainer, formatNode);
	        } else {
	          dom.insertAfter(caretContainer, formatNode);
	        }
	      }
	    };
	    var appendNode = function (parentNode, node) {
	      parentNode.appendChild(node);
	      return node;
	    };
	    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
	      var innerMostFormatNode = foldr(formatNodes, function (parentNode, formatNode) {
	        return appendNode(parentNode, formatNode.cloneNode(false));
	      }, caretContainer);
	      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP$1));
	    };
	    var applyCaretFormat = function (editor, name, vars) {
	      var rng, caretContainer, textNode, offset, bookmark, container, text;
	      var selection = editor.selection;
	      rng = selection.getRng(true);
	      offset = rng.startOffset;
	      container = rng.startContainer;
	      text = container.nodeValue;
	      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
	      if (caretContainer) {
	        textNode = findFirstTextNode(caretContainer);
	      }
	      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
	      if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
	        bookmark = selection.getBookmark();
	        rng.collapse(true);
	        rng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name));
	        rng = SplitRange.split(rng);
	        editor.formatter.apply(name, vars, rng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        if (!caretContainer || textNode.nodeValue !== ZWSP$1) {
	          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom());
	          textNode = caretContainer.firstChild;
	          rng.insertNode(caretContainer);
	          offset = 1;
	          editor.formatter.apply(name, vars, caretContainer);
	        } else {
	          editor.formatter.apply(name, vars, caretContainer);
	        }
	        selection.setCursorLocation(textNode, offset);
	      }
	    };
	    var removeCaretFormat = function (editor, name, vars, similar) {
	      var dom = editor.dom, selection = editor.selection;
	      var container, offset, bookmark;
	      var hasContentAfter, node, formatNode;
	      var parents = [], rng = selection.getRng();
	      var caretContainer;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      node = container;
	      if (container.nodeType === 3) {
	        if (offset !== container.nodeValue.length) {
	          hasContentAfter = true;
	        }
	        node = node.parentNode;
	      }
	      while (node) {
	        if (MatchFormat.matchNode(editor, node, name, vars, similar)) {
	          formatNode = node;
	          break;
	        }
	        if (node.nextSibling) {
	          hasContentAfter = true;
	        }
	        parents.push(node);
	        node = node.parentNode;
	      }
	      if (!formatNode) {
	        return;
	      }
	      if (hasContentAfter) {
	        bookmark = selection.getBookmark();
	        rng.collapse(true);
	        var expandedRng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name), true);
	        expandedRng = SplitRange.split(expandedRng);
	        editor.formatter.remove(name, vars, expandedRng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
	        var newCaretContainer = createCaretContainer(false).dom();
	        var caretNode = insertFormatNodesIntoCaretContainer(parents, newCaretContainer);
	        if (caretContainer) {
	          insertCaretContainerNode(editor, newCaretContainer, caretContainer);
	        } else {
	          insertCaretContainerNode(editor, newCaretContainer, formatNode);
	        }
	        removeCaretContainerNode(editor, caretContainer, false);
	        selection.setCursorLocation(caretNode, 1);
	        if (dom.isEmpty(formatNode)) {
	          dom.remove(formatNode);
	        }
	      }
	    };
	    var disableCaretContainer = function (editor, keyCode) {
	      var selection = editor.selection, body = editor.getBody();
	      removeCaretContainer(editor, null, false);
	      if ((keyCode === 8 || keyCode === 46) && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP$1) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	      if (keyCode === 37 || keyCode === 39) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	    };
	    var setup$2 = function (editor) {
	      editor.on('mouseup keydown', function (e) {
	        disableCaretContainer(editor, e.keyCode);
	      });
	    };
	    var replaceWithCaretFormat = function (targetNode, formatNodes) {
	      var caretContainer = createCaretContainer(false);
	      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom());
	      before(Element.fromDom(targetNode), caretContainer);
	      remove$1(Element.fromDom(targetNode));
	      return CaretPosition$1(innerMost, 0);
	    };
	    var isFormatElement = function (editor, element) {
	      var inlineElements = editor.schema.getTextInlineElements();
	      return inlineElements.hasOwnProperty(name(element)) && !isCaretNode(element.dom()) && !NodeType.isBogus(element.dom());
	    };
	    var isEmptyCaretFormatElement = function (element) {
	      return isCaretNode(element.dom()) && isCaretContainerEmpty(element.dom());
	    };
	
	    var getParentInlines = function (rootElm, startElm) {
	      var parents = Parents.parentsAndSelf(startElm, rootElm);
	      return findIndex(parents, isBlock).fold(constant(parents), function (index) {
	        return parents.slice(0, index);
	      });
	    };
	    var hasOnlyOneChild$1 = function (elm) {
	      return children(elm).length === 1;
	    };
	    var deleteLastPosition = function (forward, editor, target, parentInlines) {
	      var isFormatElement$1 = curry(isFormatElement, editor);
	      var formatNodes = map(filter(parentInlines, isFormatElement$1), function (elm) {
	        return elm.dom();
	      });
	      if (formatNodes.length === 0) {
	        DeleteElement.deleteElement(editor, forward, target);
	      } else {
	        var pos = replaceWithCaretFormat(target.dom(), formatNodes);
	        editor.selection.setRng(pos.toRange());
	      }
	    };
	    var deleteCaret$1 = function (editor, forward) {
	      var rootElm = Element.fromDom(editor.getBody());
	      var startElm = Element.fromDom(editor.selection.getStart());
	      var parentInlines = filter(getParentInlines(rootElm, startElm), hasOnlyOneChild$1);
	      return last(parentInlines).map(function (target) {
	        var fromPos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        if (DeleteUtils.willDeleteLastPositionInElement(forward, fromPos, target.dom()) && !isEmptyCaretFormatElement(target)) {
	          deleteLastPosition(forward, editor, target, parentInlines);
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var backspaceDelete$5 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
	    };
	    var InlineFormatDelete = { backspaceDelete: backspaceDelete$5 };
	
	    var getPos$1 = function (elm) {
	      var x = 0, y = 0;
	      var offsetParent = elm;
	      while (offsetParent && offsetParent.nodeType) {
	        x += offsetParent.offsetLeft || 0;
	        y += offsetParent.offsetTop || 0;
	        offsetParent = offsetParent.offsetParent;
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var fireScrollIntoViewEvent = function (editor, elm, alignToTop) {
	      var scrollEvent = {
	        elm: elm,
	        alignToTop: alignToTop
	      };
	      editor.fire('scrollIntoView', scrollEvent);
	      return scrollEvent.isDefaultPrevented();
	    };
	    var scrollElementIntoView = function (editor, elm, alignToTop) {
	      var y, viewPort;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      var viewPortY, viewPortH, offsetY = 0;
	      if (fireScrollIntoViewEvent(editor, elm, alignToTop)) {
	        return;
	      }
	      if (!NodeType.isElement(elm)) {
	        return;
	      }
	      if (alignToTop === false) {
	        offsetY = elm.offsetHeight;
	      }
	      if (root.nodeName !== 'BODY') {
	        var scrollContainer = editor.selection.getScrollContainer();
	        if (scrollContainer) {
	          y = getPos$1(elm).y - getPos$1(scrollContainer).y + offsetY;
	          viewPortH = scrollContainer.clientHeight;
	          viewPortY = scrollContainer.scrollTop;
	          if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
	            scrollContainer.scrollTop = y < viewPortY ? y : y - viewPortH + 25;
	          }
	          return;
	        }
	      }
	      viewPort = dom.getViewPort(editor.getWin());
	      y = dom.getPos(elm).y + offsetY;
	      viewPortY = viewPort.y;
	      viewPortH = viewPort.h;
	      if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
	        editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25);
	      }
	    };
	    var getViewPortRect = function (editor) {
	      if (editor.inline) {
	        return editor.getBody().getBoundingClientRect();
	      } else {
	        var win = editor.getWin();
	        return {
	          left: 0,
	          right: win.innerWidth,
	          top: 0,
	          bottom: win.innerHeight,
	          width: win.innerWidth,
	          height: win.innerHeight
	        };
	      }
	    };
	    var scrollBy = function (editor, dx, dy) {
	      if (editor.inline) {
	        editor.getBody().scrollLeft += dx;
	        editor.getBody().scrollTop += dy;
	      } else {
	        editor.getWin().scrollBy(dx, dy);
	      }
	    };
	    var scrollRangeIntoView = function (editor, rng) {
	      head(CaretPosition.fromRangeStart(rng).getClientRects()).each(function (rngRect) {
	        var bodyRect = getViewPortRect(editor);
	        var overflow = getOverflow(bodyRect, rngRect);
	        var margin = 4;
	        var dx = overflow.x > 0 ? overflow.x + margin : overflow.x - margin;
	        var dy = overflow.y > 0 ? overflow.y + margin : overflow.y - margin;
	        scrollBy(editor, overflow.x !== 0 ? dx : 0, overflow.y !== 0 ? dy : 0);
	      });
	    };
	    var ScrollIntoView = {
	      scrollElementIntoView: scrollElementIntoView,
	      scrollRangeIntoView: scrollRangeIntoView
	    };
	
	    var isContentEditableTrue$2 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$6 = NodeType.isContentEditableFalse;
	    var showCaret = function (direction, editor, node, before, scrollIntoView) {
	      return editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView);
	    };
	    var getNodeRange = function (node) {
	      var rng = node.ownerDocument.createRange();
	      rng.selectNode(node);
	      return rng;
	    };
	    var selectNode = function (editor, node) {
	      var e = editor.fire('BeforeObjectSelected', { target: node });
	      if (e.isDefaultPrevented()) {
	        return null;
	      }
	      return getNodeRange(node);
	    };
	    var renderCaretAtRange = function (editor, range, scrollIntoView) {
	      var normalizedRange = normalizeRange(1, editor.getBody(), range);
	      var caretPosition = CaretPosition$1.fromRangeStart(normalizedRange);
	      var caretPositionNode = caretPosition.getNode();
	      if (isContentEditableFalse$6(caretPositionNode)) {
	        return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
	      }
	      var caretPositionBeforeNode = caretPosition.getNode(true);
	      if (isContentEditableFalse$6(caretPositionBeforeNode)) {
	        return showCaret(1, editor, caretPositionBeforeNode, false, false);
	      }
	      var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
	        return isContentEditableFalse$6(node) || isContentEditableTrue$2(node);
	      });
	      if (isContentEditableFalse$6(ceRoot)) {
	        return showCaret(1, editor, ceRoot, false, scrollIntoView);
	      }
	      return null;
	    };
	    var renderRangeCaret = function (editor, range, scrollIntoView) {
	      if (!range || !range.collapsed) {
	        return range;
	      }
	      var caretRange = renderCaretAtRange(editor, range, scrollIntoView);
	      if (caretRange) {
	        return caretRange;
	      }
	      return range;
	    };
	    var moveToRange = function (editor, rng) {
	      editor.selection.setRng(rng);
	      ScrollIntoView.scrollRangeIntoView(editor, editor.selection.getRng());
	    };
	
	    var trimEmptyTextNode$1 = function (dom, node) {
	      if (NodeType.isText(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var deleteContentAndShowCaret = function (editor, range, node, direction, forward, peekCaretPosition) {
	      var caretRange = showCaret(direction, editor, peekCaretPosition.getNode(!forward), forward, true);
	      if (range.collapsed) {
	        var deleteRange = range.cloneRange();
	        if (forward) {
	          deleteRange.setEnd(caretRange.startContainer, caretRange.startOffset);
	        } else {
	          deleteRange.setStart(caretRange.endContainer, caretRange.endOffset);
	        }
	        deleteRange.deleteContents();
	      } else {
	        range.deleteContents();
	      }
	      editor.selection.setRng(caretRange);
	      trimEmptyTextNode$1(editor.dom, node);
	      return true;
	    };
	    var deleteCefBoundaryText = function (editor, forward) {
	      var range = editor.selection.getRng();
	      if (!NodeType.isText(range.commonAncestorContainer)) {
	        return false;
	      }
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
	      var isBeforeContentEditableFalseFn = forward ? isBeforeContentEditableFalse : isAfterContentEditableFalse;
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var nextCaretPosition = InlineUtils.normalizePosition(forward, getNextPosFn(caretPosition));
	      if (!nextCaretPosition) {
	        return false;
	      } else if (isBeforeContentEditableFalseFn(nextCaretPosition)) {
	        return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, nextCaretPosition);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeContentEditableFalseFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, peekCaretPosition);
	        }
	      }
	      return false;
	    };
	    var backspaceDelete$6 = function (editor, forward) {
	      return deleteCefBoundaryText(editor, forward);
	    };
	    var CefBoundaryDelete = { backspaceDelete: backspaceDelete$6 };
	
	    var nativeCommand = function (editor, command) {
	      editor.getDoc().execCommand(command, false, null);
	    };
	    var deleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (CefBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (InlineBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (InlineFormatDelete.backspaceDelete(editor, false)) {
	        return;
	      } else {
	        nativeCommand(editor, 'Delete');
	        DeleteUtils.paddEmptyBody(editor);
	      }
	    };
	    var forwardDeleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (CefBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (InlineBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (InlineFormatDelete.backspaceDelete(editor, true)) {
	        return;
	      } else {
	        nativeCommand(editor, 'ForwardDelete');
	      }
	    };
	    var DeleteCommands = {
	      deleteCommand: deleteCommand,
	      forwardDeleteCommand: forwardDeleteCommand
	    };
	
	    var getSpecifiedFontProp = function (propName, rootElm, elm) {
	      var getProperty = function (elm) {
	        return getRaw(elm, propName);
	      };
	      var isRoot = function (elm) {
	        return eq(Element.fromDom(rootElm), elm);
	      };
	      return closest(Element.fromDom(elm), function (elm) {
	        return getProperty(elm).isSome();
	      }, isRoot).bind(getProperty);
	    };
	    var round$1 = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round$1(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      }
	      return fontSize;
	    };
	    var normalizeFontFamily = function (fontFamily) {
	      return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
	    };
	    var getComputedFontProp = function (propName, elm) {
	      return Option.from(DOMUtils$1.DOM.getStyle(elm, propName, true));
	    };
	    var getFontProp = function (propName) {
	      return function (rootElm, elm) {
	        return Option.from(elm).map(Element.fromDom).filter(isElement).bind(function (element) {
	          return getSpecifiedFontProp(propName, rootElm, element.dom()).or(getComputedFontProp(propName, element.dom()));
	        }).getOr('');
	      };
	    };
	    var FontInfo = {
	      getFontSize: getFontProp('font-size'),
	      getFontFamily: compose(normalizeFontFamily, getFontProp('font-family')),
	      toPt: toPt
	    };
	
	    var findFirstCaretElement = function (editor) {
	      return CaretFinder.firstPositionIn(editor.getBody()).map(function (caret) {
	        var container = caret.container();
	        return NodeType.isText(container) ? container.parentNode : container;
	      });
	    };
	    var isRangeAtStartOfNode = function (rng, root) {
	      return rng.startContainer === root && rng.startOffset === 0;
	    };
	    var getCaretElement = function (editor) {
	      return Option.from(editor.selection.getRng()).bind(function (rng) {
	        var root = editor.getBody();
	        return isRangeAtStartOfNode(rng, root) ? Option.none() : Option.from(editor.selection.getStart(true));
	      });
	    };
	    var fromFontSizeNumber = function (editor, value) {
	      if (/^[0-9\.]+$/.test(value)) {
	        var fontSizeNumber = parseInt(value, 10);
	        if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
	          var fontSizes = Settings.getFontStyleValues(editor);
	          var fontClasses = Settings.getFontSizeClasses(editor);
	          if (fontClasses) {
	            return fontClasses[fontSizeNumber - 1] || value;
	          } else {
	            return fontSizes[fontSizeNumber - 1] || value;
	          }
	        } else {
	          return value;
	        }
	      } else {
	        return value;
	      }
	    };
	    var fontNameAction = function (editor, value) {
	      editor.formatter.toggle('fontname', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontNameQuery = function (editor) {
	      return getCaretElement(editor).fold(function () {
	        return findFirstCaretElement(editor).map(function (caretElement) {
	          return FontInfo.getFontFamily(editor.getBody(), caretElement);
	        }).getOr('');
	      }, function (caretElement) {
	        return FontInfo.getFontFamily(editor.getBody(), caretElement);
	      });
	    };
	    var fontSizeAction = function (editor, value) {
	      editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontSizeQuery = function (editor) {
	      return getCaretElement(editor).fold(function () {
	        return findFirstCaretElement(editor).map(function (caretElement) {
	          return FontInfo.getFontSize(editor.getBody(), caretElement);
	        }).getOr('');
	      }, function (caretElement) {
	        return FontInfo.getFontSize(editor.getBody(), caretElement);
	      });
	    };
	
	    var isEq$3 = function (rng1, rng2) {
	      return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
	    };
	    var RangeCompare = { isEq: isEq$3 };
	
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var hasParent = function (node, rootNode, predicate) {
	      return findParent(node, rootNode, predicate) !== null;
	    };
	    var hasParentWithName = function (node, rootNode, name) {
	      return hasParent(node, rootNode, function (node) {
	        return node.nodeName === name;
	      });
	    };
	    var isTable$2 = function (node) {
	      return node && node.nodeName === 'TABLE';
	    };
	    var isTableCell$3 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var isCeFalseCaretContainer = function (node, rootNode) {
	      return isCaretContainer(node) && hasParent(node, rootNode, isCaretNode) === false;
	    };
	    var hasBrBeforeAfter = function (dom, node, left) {
	      var walker = new TreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (NodeType.isBr(node)) {
	          return true;
	        }
	      }
	    };
	    var isPrevNode = function (node, name) {
	      return node.previousSibling && node.previousSibling.nodeName === name;
	    };
	    var hasContentEditableFalseParent = function (body, node) {
	      while (node && node !== body) {
	        if (NodeType.isContentEditableFalse(node)) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    };
	    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
	      var walker, lastInlineElement, parentBlockContainer;
	      var body = dom.getRoot();
	      var node;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	      if (left && NodeType.isBr(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
	        return Option.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
	      }
	      walker = new TreeWalker(startNode, parentBlockContainer);
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
	          return Option.none();
	        }
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          if (hasParentWithName(node, body, 'A') === false) {
	            return Option.some(CaretPosition(node, left ? node.nodeValue.length : 0));
	          }
	          return Option.none();
	        }
	        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          return Option.none();
	        }
	        lastInlineElement = node;
	      }
	      if (collapsed && lastInlineElement) {
	        return Option.some(CaretPosition(lastInlineElement, 0));
	      }
	      return Option.none();
	    };
	    var normalizeEndPoint = function (dom, collapsed, start, rng) {
	      var container, offset, walker;
	      var body = dom.getRoot();
	      var node, nonEmptyElementsMap;
	      var directionLeft, isAfterNode, normalized = false;
	      container = rng[(start ? 'start' : 'end') + 'Container'];
	      offset = rng[(start ? 'start' : 'end') + 'Offset'];
	      isAfterNode = NodeType.isElement(container) && offset === container.childNodes.length;
	      nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      directionLeft = start;
	      if (isCaretContainer(container)) {
	        return Option.none();
	      }
	      if (NodeType.isElement(container) && offset > container.childNodes.length - 1) {
	        directionLeft = false;
	      }
	      if (NodeType.isDocument(container)) {
	        container = body;
	        offset = 0;
	      }
	      if (container === body) {
	        if (directionLeft) {
	          node = container.childNodes[offset > 0 ? offset - 1 : 0];
	          if (node) {
	            if (isCaretContainer(node)) {
	              return Option.none();
	            }
	            if (nonEmptyElementsMap[node.nodeName] || isTable$2(node)) {
	              return Option.none();
	            }
	          }
	        }
	        if (container.hasChildNodes()) {
	          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
	          container = container.childNodes[offset];
	          offset = NodeType.isText(container) && isAfterNode ? container.data.length : 0;
	          if (!collapsed && container === body.lastChild && isTable$2(container)) {
	            return Option.none();
	          }
	          if (hasContentEditableFalseParent(body, container) || isCaretContainer(container)) {
	            return Option.none();
	          }
	          if (container.hasChildNodes() && isTable$2(container) === false) {
	            node = container;
	            walker = new TreeWalker(container, body);
	            do {
	              if (NodeType.isContentEditableFalse(node) || isCaretContainer(node)) {
	                normalized = false;
	                break;
	              }
	              if (NodeType.isText(node) && node.nodeValue.length > 0) {
	                offset = directionLeft ? 0 : node.nodeValue.length;
	                container = node;
	                normalized = true;
	                break;
	              }
	              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$3(node)) {
	                offset = dom.nodeIndex(node);
	                container = node.parentNode;
	                if (!directionLeft) {
	                  offset++;
	                }
	                normalized = true;
	                break;
	              }
	            } while (node = directionLeft ? walker.next() : walker.prev());
	          }
	        }
	      }
	      if (collapsed) {
	        if (NodeType.isText(container) && offset === 0) {
	          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
	            container = pos.container();
	            offset = pos.offset();
	            normalized = true;
	          });
	        }
	        if (NodeType.isElement(container)) {
	          node = container.childNodes[offset];
	          if (!node) {
	            node = container.childNodes[offset - 1];
	          }
	          if (node && NodeType.isBr(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
	            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
	              container = pos.container();
	              offset = pos.offset();
	              normalized = true;
	            });
	          }
	        }
	      }
	      if (directionLeft && !collapsed && NodeType.isText(container) && offset === container.nodeValue.length) {
	        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
	          container = pos.container();
	          offset = pos.offset();
	          normalized = true;
	        });
	      }
	      return normalized ? Option.some(CaretPosition(container, offset)) : Option.none();
	    };
	    var normalize$2 = function (dom, rng) {
	      var collapsed = rng.collapsed, normRng = rng.cloneRange();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
	        if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
	          normRng.setStart(pos.container(), pos.offset());
	        }
	      });
	      if (!collapsed) {
	        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
	          normRng.setEnd(pos.container(), pos.offset());
	        });
	      }
	      if (collapsed) {
	        normRng.collapse(true);
	      }
	      return RangeCompare.isEq(rng, normRng) ? Option.none() : Option.some(normRng);
	    };
	    var NormalizeRange = { normalize: normalize$2 };
	
	    var hasRightSideContent = function (schema, container, parentBlock) {
	      var walker = new TreeWalker(container, parentBlock);
	      var node;
	      var nonEmptyElementsMap = schema.getNonEmptyElements();
	      while (node = walker.next()) {
	        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
	          return true;
	        }
	      }
	    };
	    var scrollToBr = function (dom, selection, brElm) {
	      var marker = dom.create('span', {}, '&nbsp;');
	      brElm.parentNode.insertBefore(marker, brElm);
	      selection.scrollIntoView(marker);
	      dom.remove(marker);
	    };
	    var moveSelectionToBr = function (dom, selection, brElm, extraBr) {
	      var rng = dom.createRng();
	      if (!extraBr) {
	        rng.setStartAfter(brElm);
	        rng.setEndAfter(brElm);
	      } else {
	        rng.setStartBefore(brElm);
	        rng.setEndBefore(brElm);
	      }
	      selection.setRng(rng);
	    };
	    var insertBrAtCaret = function (editor, evt) {
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var rng = selection.getRng();
	      var brElm;
	      var extraBr;
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && container.nodeType === 3) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var parentBlock = dom.getParent(container, dom.isBlock);
	      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      var isControlKey = evt && evt.ctrlKey;
	      if (containerBlockName === 'LI' && !isControlKey) {
	        parentBlock = containerBlock;
	      }
	      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
	        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
	          brElm = dom.create('br');
	          rng.insertNode(brElm);
	          rng.setStartAfter(brElm);
	          rng.setEndAfter(brElm);
	          extraBr = true;
	        }
	      }
	      brElm = dom.create('br');
	      rangeInsertNode(dom, rng, brElm);
	      scrollToBr(dom, selection, brElm);
	      moveSelectionToBr(dom, selection, brElm, extraBr);
	      editor.undoManager.add();
	    };
	    var insertBrBefore = function (editor, inline) {
	      var br = Element.fromTag('br');
	      before(Element.fromDom(inline), br);
	      editor.undoManager.add();
	    };
	    var insertBrAfter = function (editor, inline) {
	      if (!hasBrAfter(editor.getBody(), inline)) {
	        after(Element.fromDom(inline), Element.fromTag('br'));
	      }
	      var br = Element.fromTag('br');
	      after(Element.fromDom(inline), br);
	      scrollToBr(editor.dom, editor.selection, br.dom());
	      moveSelectionToBr(editor.dom, editor.selection, br.dom(), false);
	      editor.undoManager.add();
	    };
	    var isBeforeBr$1 = function (pos) {
	      return NodeType.isBr(pos.getNode());
	    };
	    var hasBrAfter = function (rootNode, startNode) {
	      if (isBeforeBr$1(CaretPosition$1.after(startNode))) {
	        return true;
	      } else {
	        return CaretFinder.nextPosition(rootNode, CaretPosition$1.after(startNode)).map(function (pos) {
	          return NodeType.isBr(pos.getNode());
	        }).getOr(false);
	      }
	    };
	    var isAnchorLink = function (elm) {
	      return elm && elm.nodeName === 'A' && 'href' in elm;
	    };
	    var isInsideAnchor = function (location) {
	      return location.fold(constant(false), isAnchorLink, isAnchorLink, constant(false));
	    };
	    var readInlineAnchorLocation = function (editor) {
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var position = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), position).filter(isInsideAnchor);
	    };
	    var insertBrOutsideAnchor = function (editor, location) {
	      location.fold(noop, curry(insertBrBefore, editor), curry(insertBrAfter, editor), noop);
	    };
	    var insert = function (editor, evt) {
	      var anchorLocation = readInlineAnchorLocation(editor);
	      if (anchorLocation.isSome()) {
	        anchorLocation.each(curry(insertBrOutsideAnchor, editor));
	      } else {
	        insertBrAtCaret(editor, evt);
	      }
	    };
	    var InsertBr = { insert: insert };
	
	    var create$3 = Immutable('start', 'soffset', 'finish', 'foffset');
	    var SimRange = { create: create$3 };
	
	    var adt = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$4 = adt.before;
	    var on = adt.on;
	    var after$3 = adt.after;
	    var Situ = {
	      before: before$4,
	      on: on,
	      after: after$3,
	      cata: cata,
	      getStart: getStart
	    };
	
	    var adt$1 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$1.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return Element.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$1.domRange;
	    var relative = adt$1.relative;
	    var exact = adt$1.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range = SimRange.create;
	    var Selection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range
	    };
	
	    var browser$3 = PlatformDetection$1.detect().browser;
	    var clamp = function (offset, element) {
	      var max = isText(element) ? get$4(element).length : children(element).length + 1;
	      if (offset > max) {
	        return max;
	      } else if (offset < 0) {
	        return 0;
	      }
	      return offset;
	    };
	    var normalizeRng = function (rng) {
	      return Selection.range(rng.start(), clamp(rng.soffset(), rng.start()), rng.finish(), clamp(rng.foffset(), rng.finish()));
	    };
	    var isOrContains = function (root, elm) {
	      return !NodeType.isRestrictedNode(elm.dom()) && (contains$3(root, elm) || eq(root, elm));
	    };
	    var isRngInRoot = function (root) {
	      return function (rng) {
	        return isOrContains(root, rng.start()) && isOrContains(root, rng.finish());
	      };
	    };
	    var shouldStore = function (editor) {
	      return editor.inline === true || browser$3.isIE();
	    };
	    var nativeRangeToSelectionRange = function (r) {
	      return Selection.range(Element.fromDom(r.startContainer), r.startOffset, Element.fromDom(r.endContainer), r.endOffset);
	    };
	    var readRange = function (win) {
	      var selection = win.getSelection();
	      var rng = !selection || selection.rangeCount === 0 ? Option.none() : Option.from(selection.getRangeAt(0));
	      return rng.map(nativeRangeToSelectionRange);
	    };
	    var getBookmark$2 = function (root) {
	      var win = defaultView(root);
	      return readRange(win.dom()).filter(isRngInRoot(root));
	    };
	    var validate = function (root, bookmark) {
	      return Option.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
	    };
	    var bookmarkToNativeRng = function (bookmark) {
	      var rng = domGlobals.document.createRange();
	      try {
	        rng.setStart(bookmark.start().dom(), bookmark.soffset());
	        rng.setEnd(bookmark.finish().dom(), bookmark.foffset());
	        return Option.some(rng);
	      } catch (_) {
	        return Option.none();
	      }
	    };
	    var store = function (editor) {
	      var newBookmark = shouldStore(editor) ? getBookmark$2(Element.fromDom(editor.getBody())) : Option.none();
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var storeNative = function (editor, rng) {
	      var root = Element.fromDom(editor.getBody());
	      var range = shouldStore(editor) ? Option.from(rng) : Option.none();
	      var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var getRng = function (editor) {
	      var bookmark = editor.bookmark ? editor.bookmark : Option.none();
	      return bookmark.bind(curry(validate, Element.fromDom(editor.getBody()))).bind(bookmarkToNativeRng);
	    };
	    var restore = function (editor) {
	      getRng(editor).each(function (rng) {
	        editor.selection.setRng(rng);
	      });
	    };
	    var SelectionBookmark = {
	      store: store,
	      storeNative: storeNative,
	      readRange: readRange,
	      restore: restore,
	      getRng: getRng,
	      getBookmark: getBookmark$2,
	      validate: validate
	    };
	
	    var indentElement = function (dom, command, useMargin, value, unit, element) {
	      if (dom.getContentEditable(element) === 'false') {
	        return;
	      }
	      var indentStyleName = useMargin ? 'margin' : 'padding';
	      indentStyleName = element.nodeName === 'TABLE' ? 'margin' : indentStyleName;
	      indentStyleName += dom.getStyle(element, 'direction', true) === 'rtl' ? 'Right' : 'Left';
	      if (command === 'outdent') {
	        var styleValue = Math.max(0, parseInt(element.style[indentStyleName] || 0, 10) - value);
	        dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
	      } else {
	        var styleValue = parseInt(element.style[indentStyleName] || 0, 10) + value + unit;
	        dom.setStyle(element, indentStyleName, styleValue);
	      }
	    };
	    var isListComponent = function (el) {
	      return isList(el) || isListItem(el);
	    };
	    var parentIsListComponent = function (el) {
	      return parent(el).map(isListComponent).getOr(false);
	    };
	    var getBlocksToIndent = function (editor) {
	      return filter(map(editor.selection.getSelectedBlocks(), Element.fromDom), function (el) {
	        return !isListComponent(el) && !parentIsListComponent(el);
	      });
	    };
	    var handle = function (editor, command) {
	      var settings = editor.settings, dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
	      var indentUnit = /[a-z%]+$/i.exec(settings.indentation)[0];
	      var indentValue = parseInt(settings.indentation, 10);
	      var useMargin = editor.getParam('indent_use_margin', false);
	      if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
	        if (!settings.forced_root_block && !dom.getParent(selection.getNode(), dom.isBlock)) {
	          formatter.apply('div');
	        }
	      }
	      each(getBlocksToIndent(editor), function (block) {
	        indentElement(dom, command, useMargin, indentValue, indentUnit, block.dom());
	      });
	    };
	
	    var each$a = Tools.each, extend$2 = Tools.extend;
	    var map$3 = Tools.map, inArray$2 = Tools.inArray;
	    function EditorCommands (editor) {
	      var dom, selection, formatter;
	      var commands = {
	        state: {},
	        exec: {},
	        value: {}
	      };
	      var settings = editor.settings, bookmark;
	      editor.on('PreInit', function () {
	        dom = editor.dom;
	        selection = editor.selection;
	        settings = editor.settings;
	        formatter = editor.formatter;
	      });
	      var execCommand = function (command, ui, value, args) {
	        var func, customCommand, state = false;
	        if (editor.removed) {
	          return;
	        }
	        if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
	          editor.focus();
	        } else {
	          SelectionBookmark.restore(editor);
	        }
	        args = editor.fire('BeforeExecCommand', {
	          command: command,
	          ui: ui,
	          value: value
	        });
	        if (args.isDefaultPrevented()) {
	          return false;
	        }
	        customCommand = command.toLowerCase();
	        if (func = commands.exec[customCommand]) {
	          func(customCommand, ui, value);
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        each$a(editor.plugins, function (p) {
	          if (p.execCommand && p.execCommand(command, ui, value)) {
	            editor.fire('ExecCommand', {
	              command: command,
	              ui: ui,
	              value: value
	            });
	            state = true;
	            return false;
	          }
	        });
	        if (state) {
	          return state;
	        }
	        if (editor.theme && editor.theme.execCommand && editor.theme.execCommand(command, ui, value)) {
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        try {
	          state = editor.getDoc().execCommand(command, ui, value);
	        } catch (ex) {
	        }
	        if (state) {
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        return false;
	      };
	      var queryCommandState = function (command) {
	        var func;
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = commands.state[command]) {
	          return func(command);
	        }
	        try {
	          return editor.getDoc().queryCommandState(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      var queryCommandValue = function (command) {
	        var func;
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = commands.value[command]) {
	          return func(command);
	        }
	        try {
	          return editor.getDoc().queryCommandValue(command);
	        } catch (ex) {
	        }
	      };
	      var addCommands = function (commandList, type) {
	        type = type || 'exec';
	        each$a(commandList, function (callback, command) {
	          each$a(command.toLowerCase().split(','), function (command) {
	            commands[type][command] = callback;
	          });
	        });
	      };
	      var addCommand = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.exec[command] = function (command, ui, value, args) {
	          return callback.call(scope || editor, ui, value, args);
	        };
	      };
	      var queryCommandSupported = function (command) {
	        command = command.toLowerCase();
	        if (commands.exec[command]) {
	          return true;
	        }
	        try {
	          return editor.getDoc().queryCommandSupported(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      var addQueryStateHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.state[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	      var addQueryValueHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.value[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	      var hasCustomCommand = function (command) {
	        command = command.toLowerCase();
	        return !!commands.exec[command];
	      };
	      extend$2(this, {
	        execCommand: execCommand,
	        queryCommandState: queryCommandState,
	        queryCommandValue: queryCommandValue,
	        queryCommandSupported: queryCommandSupported,
	        addCommands: addCommands,
	        addCommand: addCommand,
	        addQueryStateHandler: addQueryStateHandler,
	        addQueryValueHandler: addQueryValueHandler,
	        hasCustomCommand: hasCustomCommand
	      });
	      var execNativeCommand = function (command, ui, value) {
	        if (ui === undefined) {
	          ui = false;
	        }
	        if (value === undefined) {
	          value = null;
	        }
	        return editor.getDoc().execCommand(command, ui, value);
	      };
	      var isFormatMatch = function (name) {
	        return formatter.match(name);
	      };
	      var toggleFormat = function (name, value) {
	        formatter.toggle(name, value ? { value: value } : undefined);
	        editor.nodeChanged();
	      };
	      var storeSelection = function (type) {
	        bookmark = selection.getBookmark(type);
	      };
	      var restoreSelection = function () {
	        selection.moveToBookmark(bookmark);
	      };
	      addCommands({
	        'mceResetDesignMode,mceBeginUndoLevel': function () {
	        },
	        'mceEndUndoLevel,mceAddUndoLevel': function () {
	          editor.undoManager.add();
	        },
	        'Cut,Copy,Paste': function (command) {
	          var doc = editor.getDoc();
	          var failed;
	          try {
	            execNativeCommand(command);
	          } catch (ex) {
	            failed = true;
	          }
	          if (command === 'paste' && !doc.queryCommandEnabled(command)) {
	            failed = true;
	          }
	          if (failed || !doc.queryCommandSupported(command)) {
	            var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
	            if (Env.mac) {
	              msg = msg.replace(/Ctrl\+/g, '\u2318+');
	            }
	            editor.notificationManager.open({
	              text: msg,
	              type: 'error'
	            });
	          }
	        },
	        'unlink': function () {
	          if (selection.isCollapsed()) {
	            var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
	            if (elm) {
	              editor.dom.remove(elm, true);
	            }
	            return;
	          }
	          formatter.remove('link');
	        },
	        'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
	          var align = command.substring(7);
	          if (align === 'full') {
	            align = 'justify';
	          }
	          each$a('left,center,right,justify'.split(','), function (name) {
	            if (align !== name) {
	              formatter.remove('align' + name);
	            }
	          });
	          if (align !== 'none') {
	            toggleFormat('align' + align);
	          }
	        },
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var listElm, listParent;
	          execNativeCommand(command);
	          listElm = dom.getParent(selection.getNode(), 'ol,ul');
	          if (listElm) {
	            listParent = listElm.parentNode;
	            if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
	              storeSelection();
	              dom.split(listParent, listElm);
	              restoreSelection();
	            }
	          }
	        },
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          toggleFormat(command);
	        },
	        'ForeColor,HiliteColor': function (command, ui, value) {
	          toggleFormat(command, value);
	        },
	        'FontName': function (command, ui, value) {
	          fontNameAction(editor, value);
	        },
	        'FontSize': function (command, ui, value) {
	          fontSizeAction(editor, value);
	        },
	        'RemoveFormat': function (command) {
	          formatter.remove(command);
	        },
	        'mceBlockQuote': function () {
	          toggleFormat('blockquote');
	        },
	        'FormatBlock': function (command, ui, value) {
	          return toggleFormat(value || 'p');
	        },
	        'mceCleanup': function () {
	          var bookmark = selection.getBookmark();
	          editor.setContent(editor.getContent());
	          selection.moveToBookmark(bookmark);
	        },
	        'mceRemoveNode': function (command, ui, value) {
	          var node = value || selection.getNode();
	          if (node !== editor.getBody()) {
	            storeSelection();
	            editor.dom.remove(node, true);
	            restoreSelection();
	          }
	        },
	        'mceSelectNodeDepth': function (command, ui, value) {
	          var counter = 0;
	          dom.getParent(selection.getNode(), function (node) {
	            if (node.nodeType === 1 && counter++ === value) {
	              selection.select(node);
	              return false;
	            }
	          }, editor.getBody());
	        },
	        'mceSelectNode': function (command, ui, value) {
	          selection.select(value);
	        },
	        'mceInsertContent': function (command, ui, value) {
	          InsertContent.insertAtCaret(editor, value);
	        },
	        'mceInsertRawHTML': function (command, ui, value) {
	          selection.setContent('tiny_mce_marker');
	          var content = editor.getContent();
	          editor.setContent(content.replace(/tiny_mce_marker/g, function () {
	            return value;
	          }));
	        },
	        'mceToggleFormat': function (command, ui, value) {
	          toggleFormat(value);
	        },
	        'mceSetContent': function (command, ui, value) {
	          editor.setContent(value);
	        },
	        'Indent,Outdent': function (command) {
	          handle(editor, command);
	        },
	        'mceRepaint': function () {
	        },
	        'InsertHorizontalRule': function () {
	          editor.execCommand('mceInsertContent', false, '<hr />');
	        },
	        'mceToggleVisualAid': function () {
	          editor.hasVisual = !editor.hasVisual;
	          editor.addVisual();
	        },
	        'mceReplaceContent': function (command, ui, value) {
	          editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, selection.getContent({ format: 'text' })));
	        },
	        'mceInsertLink': function (command, ui, value) {
	          var anchor;
	          if (typeof value === 'string') {
	            value = { href: value };
	          }
	          anchor = dom.getParent(selection.getNode(), 'a');
	          value.href = value.href.replace(' ', '%20');
	          if (!anchor || !value.href) {
	            formatter.remove('link');
	          }
	          if (value.href) {
	            formatter.apply('link', value, anchor);
	          }
	        },
	        'selectAll': function () {
	          var editingHost = dom.getParent(selection.getStart(), NodeType.isContentEditableTrue);
	          if (editingHost) {
	            var rng = dom.createRng();
	            rng.selectNodeContents(editingHost);
	            selection.setRng(rng);
	          }
	        },
	        'delete': function () {
	          DeleteCommands.deleteCommand(editor);
	        },
	        'forwardDelete': function () {
	          DeleteCommands.forwardDeleteCommand(editor);
	        },
	        'mceNewDocument': function () {
	          editor.setContent('');
	        },
	        'InsertLineBreak': function (command, ui, value) {
	          InsertBr.insert(editor, value);
	          return true;
	        }
	      });
	      var alignStates = function (name) {
	        return function () {
	          var nodes = selection.isCollapsed() ? [dom.getParent(selection.getNode(), dom.isBlock)] : selection.getSelectedBlocks();
	          var matches = map$3(nodes, function (node) {
	            return !!formatter.matchNode(node, name);
	          });
	          return inArray$2(matches, true) !== -1;
	        };
	      };
	      addCommands({
	        'JustifyLeft': alignStates('alignleft'),
	        'JustifyCenter': alignStates('aligncenter'),
	        'JustifyRight': alignStates('alignright'),
	        'JustifyFull': alignStates('alignjustify'),
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          return isFormatMatch(command);
	        },
	        'mceBlockQuote': function () {
	          return isFormatMatch('blockquote');
	        },
	        'Outdent': function () {
	          var node;
	          if (settings.inline_styles) {
	            if ((node = dom.getParent(selection.getStart(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return true;
	            }
	            if ((node = dom.getParent(selection.getEnd(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return true;
	            }
	          }
	          return queryCommandState('InsertUnorderedList') || queryCommandState('InsertOrderedList') || !settings.inline_styles && !!dom.getParent(selection.getNode(), 'BLOCKQUOTE');
	        },
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var list = dom.getParent(selection.getNode(), 'ul,ol');
	          return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
	        }
	      }, 'state');
	      addCommands({
	        Undo: function () {
	          editor.undoManager.undo();
	        },
	        Redo: function () {
	          editor.undoManager.redo();
	        }
	      });
	      addQueryValueHandler('FontName', function () {
	        return fontNameQuery(editor);
	      }, this);
	      addQueryValueHandler('FontSize', function () {
	        return fontSizeQuery(editor);
	      }, this);
	    }
	
	    var nativeEvents = Tools.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend', ' ');
	    var Dispatcher = function (settings) {
	      var self = this;
	      var scope, bindings = {}, toggleEvent;
	      var returnFalse = function () {
	        return false;
	      };
	      var returnTrue = function () {
	        return true;
	      };
	      settings = settings || {};
	      scope = settings.scope || self;
	      toggleEvent = settings.toggleEvent || returnFalse;
	      var fire = function (name, args) {
	        var handlers, i, l, callback;
	        name = name.toLowerCase();
	        args = args || {};
	        args.type = name;
	        if (!args.target) {
	          args.target = scope;
	        }
	        if (!args.preventDefault) {
	          args.preventDefault = function () {
	            args.isDefaultPrevented = returnTrue;
	          };
	          args.stopPropagation = function () {
	            args.isPropagationStopped = returnTrue;
	          };
	          args.stopImmediatePropagation = function () {
	            args.isImmediatePropagationStopped = returnTrue;
	          };
	          args.isDefaultPrevented = returnFalse;
	          args.isPropagationStopped = returnFalse;
	          args.isImmediatePropagationStopped = returnFalse;
	        }
	        if (settings.beforeFire) {
	          settings.beforeFire(args);
	        }
	        handlers = bindings[name];
	        if (handlers) {
	          for (i = 0, l = handlers.length; i < l; i++) {
	            callback = handlers[i];
	            if (callback.once) {
	              off(name, callback.func);
	            }
	            if (args.isImmediatePropagationStopped()) {
	              args.stopPropagation();
	              return args;
	            }
	            if (callback.func.call(scope, args) === false) {
	              args.preventDefault();
	              return args;
	            }
	          }
	        }
	        return args;
	      };
	      var on = function (name, callback, prepend, extra) {
	        var handlers, names, i;
	        if (callback === false) {
	          callback = returnFalse;
	        }
	        if (callback) {
	          callback = { func: callback };
	          if (extra) {
	            Tools.extend(callback, extra);
	          }
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	            if (!handlers) {
	              handlers = bindings[name] = [];
	              toggleEvent(name, true);
	            }
	            if (prepend) {
	              handlers.unshift(callback);
	            } else {
	              handlers.push(callback);
	            }
	          }
	        }
	        return self;
	      };
	      var off = function (name, callback) {
	        var i, handlers, bindingName, names, hi;
	        if (name) {
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	            if (!name) {
	              for (bindingName in bindings) {
	                toggleEvent(bindingName, false);
	                delete bindings[bindingName];
	              }
	              return self;
	            }
	            if (handlers) {
	              if (!callback) {
	                handlers.length = 0;
	              } else {
	                hi = handlers.length;
	                while (hi--) {
	                  if (handlers[hi].func === callback) {
	                    handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
	                    bindings[name] = handlers;
	                  }
	                }
	              }
	              if (!handlers.length) {
	                toggleEvent(name, false);
	                delete bindings[name];
	              }
	            }
	          }
	        } else {
	          for (name in bindings) {
	            toggleEvent(name, false);
	          }
	          bindings = {};
	        }
	        return self;
	      };
	      var once = function (name, callback, prepend) {
	        return on(name, callback, prepend, { once: true });
	      };
	      var has = function (name) {
	        name = name.toLowerCase();
	        return !(!bindings[name] || bindings[name].length === 0);
	      };
	      self.fire = fire;
	      self.on = on;
	      self.off = off;
	      self.once = once;
	      self.has = has;
	    };
	    Dispatcher.isNative = function (name) {
	      return !!nativeEvents[name.toLowerCase()];
	    };
	
	    var getEventDispatcher = function (obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new Dispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (Dispatcher.isNative(name) && obj.toggleNativeEvent) {
	              obj.toggleNativeEvent(name, state);
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    };
	    var Observable = {
	      fire: function (name, args, bubble) {
	        var self = this;
	        if (self.removed && name !== 'remove' && name !== 'detach') {
	          return args;
	        }
	        args = getEventDispatcher(self).fire(name, args, bubble);
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	        return args;
	      },
	      on: function (name, callback, prepend) {
	        return getEventDispatcher(this).on(name, callback, prepend);
	      },
	      off: function (name, callback) {
	        return getEventDispatcher(this).off(name, callback);
	      },
	      once: function (name, callback) {
	        return getEventDispatcher(this).once(name, callback);
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      }
	    };
	
	    var firePreProcess = function (editor, args) {
	      return editor.fire('PreProcess', args);
	    };
	    var firePostProcess = function (editor, args) {
	      return editor.fire('PostProcess', args);
	    };
	    var fireRemove = function (editor) {
	      return editor.fire('remove');
	    };
	    var fireDetach = function (editor) {
	      return editor.fire('detach');
	    };
	    var fireSwitchMode = function (editor, mode) {
	      return editor.fire('SwitchMode', { mode: mode });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	    var Events = {
	      firePreProcess: firePreProcess,
	      firePostProcess: firePostProcess,
	      fireRemove: fireRemove,
	      fireDetach: fireDetach,
	      fireSwitchMode: fireSwitchMode,
	      fireObjectResizeStart: fireObjectResizeStart,
	      fireObjectResized: fireObjectResized
	    };
	
	    var setEditorCommandState = function (editor, cmd, state) {
	      try {
	        editor.getDoc().execCommand(cmd, false, state);
	      } catch (ex) {
	      }
	    };
	    var toggleClass = function (elm, cls, state) {
	      if (has$2(elm, cls) && state === false) {
	        remove$4(elm, cls);
	      } else if (state) {
	        add$2(elm, cls);
	      }
	    };
	    var toggleReadOnly = function (editor, state) {
	      toggleClass(Element.fromDom(editor.getBody()), 'mce-content-readonly', state);
	      if (state) {
	        editor.selection.controlSelection.hideResizeRect();
	        editor.readonly = true;
	        editor.getBody().contentEditable = 'false';
	      } else {
	        editor.readonly = false;
	        editor.getBody().contentEditable = 'true';
	        setEditorCommandState(editor, 'StyleWithCSS', false);
	        setEditorCommandState(editor, 'enableInlineTableEditing', false);
	        setEditorCommandState(editor, 'enableObjectResizing', false);
	        editor.focus();
	        editor.nodeChanged();
	      }
	    };
	    var setMode = function (editor, mode) {
	      if (mode === getMode(editor)) {
	        return;
	      }
	      if (editor.initialized) {
	        toggleReadOnly(editor, mode === 'readonly');
	      } else {
	        editor.on('init', function () {
	          toggleReadOnly(editor, mode === 'readonly');
	        });
	      }
	      Events.fireSwitchMode(editor, mode);
	    };
	    var getMode = function (editor) {
	      return editor.readonly ? 'readonly' : 'design';
	    };
	    var isReadOnly = function (editor) {
	      return editor.readonly === true;
	    };
	
	    var DOM$1 = DOMUtils$1.DOM;
	    var customEventRootDelegates;
	    var getEventTarget = function (editor, eventName) {
	      if (eventName === 'selectionchange') {
	        return editor.getDoc();
	      }
	      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
	        return editor.getDoc().documentElement;
	      }
	      if (editor.settings.event_root) {
	        if (!editor.eventRoot) {
	          editor.eventRoot = DOM$1.select(editor.settings.event_root)[0];
	        }
	        return editor.eventRoot;
	      }
	      return editor.getBody();
	    };
	    var isListening = function (editor) {
	      return !editor.hidden && !editor.readonly;
	    };
	    var fireEvent = function (editor, eventName, e) {
	      if (isListening(editor)) {
	        editor.fire(eventName, e);
	      } else if (isReadOnly(editor)) {
	        e.preventDefault();
	      }
	    };
	    var bindEventDelegate = function (editor, eventName) {
	      var eventRootElm, delegate;
	      if (!editor.delegates) {
	        editor.delegates = {};
	      }
	      if (editor.delegates[eventName] || editor.removed) {
	        return;
	      }
	      eventRootElm = getEventTarget(editor, eventName);
	      if (editor.settings.event_root) {
	        if (!customEventRootDelegates) {
	          customEventRootDelegates = {};
	          editor.editorManager.on('removeEditor', function () {
	            var name;
	            if (!editor.editorManager.activeEditor) {
	              if (customEventRootDelegates) {
	                for (name in customEventRootDelegates) {
	                  editor.dom.unbind(getEventTarget(editor, name));
	                }
	                customEventRootDelegates = null;
	              }
	            }
	          });
	        }
	        if (customEventRootDelegates[eventName]) {
	          return;
	        }
	        delegate = function (e) {
	          var target = e.target;
	          var editors = editor.editorManager.get();
	          var i = editors.length;
	          while (i--) {
	            var body = editors[i].getBody();
	            if (body === target || DOM$1.isChildOf(target, body)) {
	              fireEvent(editors[i], eventName, e);
	            }
	          }
	        };
	        customEventRootDelegates[eventName] = delegate;
	        DOM$1.bind(eventRootElm, eventName, delegate);
	      } else {
	        delegate = function (e) {
	          fireEvent(editor, eventName, e);
	        };
	        DOM$1.bind(eventRootElm, eventName, delegate);
	        editor.delegates[eventName] = delegate;
	      }
	    };
	    var EditorObservable = {
	      bindPendingEventDelegates: function () {
	        var self = this;
	        Tools.each(self._pendingNativeEvents, function (name) {
	          bindEventDelegate(self, name);
	        });
	      },
	      toggleNativeEvent: function (name, state) {
	        var self = this;
	        if (name === 'focus' || name === 'blur') {
	          return;
	        }
	        if (state) {
	          if (self.initialized) {
	            bindEventDelegate(self, name);
	          } else {
	            if (!self._pendingNativeEvents) {
	              self._pendingNativeEvents = [name];
	            } else {
	              self._pendingNativeEvents.push(name);
	            }
	          }
	        } else if (self.initialized) {
	          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          delete self.delegates[name];
	        }
	      },
	      unbindAllNativeEvents: function () {
	        var self = this;
	        var body = self.getBody();
	        var dom = self.dom;
	        var name;
	        if (self.delegates) {
	          for (name in self.delegates) {
	            self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          }
	          delete self.delegates;
	        }
	        if (!self.inline && body && dom) {
	          body.onload = null;
	          dom.unbind(self.getWin());
	          dom.unbind(self.getDoc());
	        }
	        if (dom) {
	          dom.unbind(body);
	          dom.unbind(self.getContainer());
	        }
	      }
	    };
	    EditorObservable = Tools.extend({}, Observable, EditorObservable);
	    var EditorObservable$1 = EditorObservable;
	
	    var sectionResult = Immutable('sections', 'settings');
	    var detection = PlatformDetection$1.detect();
	    var isTouch = detection.deviceType.isTouch();
	    var mobilePlugins = [
	      'lists',
	      'autolink',
	      'autosave'
	    ];
	    var defaultMobileSettings = { theme: 'mobile' };
	    var normalizePlugins = function (plugins) {
	      var pluginNames = isArray(plugins) ? plugins.join(' ') : plugins;
	      var trimmedPlugins = map(isString(pluginNames) ? pluginNames.split(' ') : [], trim$2);
	      return filter(trimmedPlugins, function (item) {
	        return item.length > 0;
	      });
	    };
	    var filterMobilePlugins = function (plugins) {
	      return filter(plugins, curry(contains, mobilePlugins));
	    };
	    var extractSections = function (keys, settings) {
	      var result = bifilter(settings, function (value, key) {
	        return contains(keys, key);
	      });
	      return sectionResult(result.t, result.f);
	    };
	    var getSection = function (sectionResult, name, defaults) {
	      var sections = sectionResult.sections();
	      var sectionSettings = sections.hasOwnProperty(name) ? sections[name] : {};
	      return Tools.extend({}, defaults, sectionSettings);
	    };
	    var hasSection = function (sectionResult, name) {
	      return sectionResult.sections().hasOwnProperty(name);
	    };
	    var getDefaultSettings = function (id, documentBaseUrl, editor) {
	      return {
	        id: id,
	        theme: 'modern',
	        delta_width: 0,
	        delta_height: 0,
	        popup_css: '',
	        plugins: '',
	        document_base_url: documentBaseUrl,
	        add_form_submit_trigger: true,
	        submit_patch: true,
	        add_unload_trigger: true,
	        convert_urls: true,
	        relative_urls: true,
	        remove_script_host: true,
	        object_resizing: true,
	        doctype: '<!DOCTYPE html>',
	        visual: true,
	        font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
	        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
	        forced_root_block: 'p',
	        hidden_input: true,
	        render_ui: true,
	        indentation: '40px',
	        inline_styles: true,
	        convert_fonts_to_spans: true,
	        indent: 'simple',
	        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        entity_encoding: 'named',
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        ie7_compat: true
	      };
	    };
	    var getExternalPlugins = function (overrideSettings, settings) {
	      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
	      if (overrideSettings && overrideSettings.external_plugins) {
	        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
	      } else {
	        return userDefinedExternalPlugins;
	      }
	    };
	    var combinePlugins = function (forcedPlugins, plugins) {
	      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
	    };
	    var processPlugins = function (isTouchDevice, sectionResult, defaultOverrideSettings, settings) {
	      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
	      var plugins = normalizePlugins(settings.plugins);
	      var platformPlugins = isTouchDevice && hasSection(sectionResult, 'mobile') ? filterMobilePlugins(plugins) : plugins;
	      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
	      return Tools.extend(settings, { plugins: combinedPlugins.join(' ') });
	    };
	    var isOnMobile = function (isTouchDevice, sectionResult) {
	      var isInline = sectionResult.settings().inline;
	      return isTouchDevice && hasSection(sectionResult, 'mobile') && !isInline;
	    };
	    var combineSettings = function (isTouchDevice, defaultSettings, defaultOverrideSettings, settings) {
	      var sectionResult = extractSections(['mobile'], settings);
	      var extendedSettings = Tools.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isTouchDevice, sectionResult) ? getSection(sectionResult, 'mobile', defaultMobileSettings) : {}, {
	        validate: true,
	        content_editable: sectionResult.settings().inline,
	        external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
	      });
	      return processPlugins(isTouchDevice, sectionResult, defaultOverrideSettings, extendedSettings);
	    };
	    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
	      var defaultSettings = getDefaultSettings(id, documentBaseUrl, editor);
	      return combineSettings(isTouch, defaultSettings, defaultOverrideSettings, settings);
	    };
	    var getFiltered = function (predicate, editor, name) {
	      return Option.from(editor.settings[name]).filter(predicate);
	    };
	    var getParamObject = function (value) {
	      var output = {};
	      if (typeof value === 'string') {
	        each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
	          var arr = val.split('=');
	          if (arr.length > 1) {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[1]);
	          } else {
	            output[Tools.trim(arr[0])] = Tools.trim(arr);
	          }
	        });
	      } else {
	        output = value;
	      }
	      return output;
	    };
	    var isArrayOf = function (p) {
	      return function (a) {
	        return isArray(a) && forall(a, p);
	      };
	    };
	    var getParam = function (editor, name, defaultVal, type) {
	      var value = name in editor.settings ? editor.settings[name] : defaultVal;
	      if (type === 'hash') {
	        return getParamObject(value);
	      } else if (type === 'string') {
	        return getFiltered(isString, editor, name).getOr(defaultVal);
	      } else if (type === 'number') {
	        return getFiltered(isNumber, editor, name).getOr(defaultVal);
	      } else if (type === 'boolean') {
	        return getFiltered(isBoolean, editor, name).getOr(defaultVal);
	      } else if (type === 'object') {
	        return getFiltered(isObject, editor, name).getOr(defaultVal);
	      } else if (type === 'array') {
	        return getFiltered(isArray, editor, name).getOr(defaultVal);
	      } else if (type === 'string[]') {
	        return getFiltered(isArrayOf(isString), editor, name).getOr(defaultVal);
	      } else if (type === 'function') {
	        return getFiltered(isFunction, editor, name).getOr(defaultVal);
	      } else {
	        return value;
	      }
	    };
	
	    var each$b = Tools.each, explode$2 = Tools.explode;
	    var keyCodeLookup = {
	      f1: 112,
	      f2: 113,
	      f3: 114,
	      f4: 115,
	      f5: 116,
	      f6: 117,
	      f7: 118,
	      f8: 119,
	      f9: 120,
	      f10: 121,
	      f11: 122,
	      f12: 123
	    };
	    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	    function Shortcuts (editor) {
	      var self = this;
	      var shortcuts = {};
	      var pendingPatterns = [];
	      var parseShortcut = function (pattern) {
	        var id, key;
	        var shortcut = {};
	        each$b(explode$2(pattern, '+'), function (value) {
	          if (value in modifierNames) {
	            shortcut[value] = true;
	          } else {
	            if (/^[0-9]{2,}$/.test(value)) {
	              shortcut.keyCode = parseInt(value, 10);
	            } else {
	              shortcut.charCode = value.charCodeAt(0);
	              shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
	            }
	          }
	        });
	        id = [shortcut.keyCode];
	        for (key in modifierNames) {
	          if (shortcut[key]) {
	            id.push(key);
	          } else {
	            shortcut[key] = false;
	          }
	        }
	        shortcut.id = id.join(',');
	        if (shortcut.access) {
	          shortcut.alt = true;
	          if (Env.mac) {
	            shortcut.ctrl = true;
	          } else {
	            shortcut.shift = true;
	          }
	        }
	        if (shortcut.meta) {
	          if (Env.mac) {
	            shortcut.meta = true;
	          } else {
	            shortcut.ctrl = true;
	            shortcut.meta = false;
	          }
	        }
	        return shortcut;
	      };
	      var createShortcut = function (pattern, desc, cmdFunc, scope) {
	        var shortcuts;
	        shortcuts = Tools.map(explode$2(pattern, '>'), parseShortcut);
	        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
	          func: cmdFunc,
	          scope: scope || editor
	        });
	        return Tools.extend(shortcuts[0], {
	          desc: editor.translate(desc),
	          subpatterns: shortcuts.slice(1)
	        });
	      };
	      var hasModifier = function (e) {
	        return e.altKey || e.ctrlKey || e.metaKey;
	      };
	      var isFunctionKey = function (e) {
	        return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
	      };
	      var matchShortcut = function (e, shortcut) {
	        if (!shortcut) {
	          return false;
	        }
	        if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
	          return false;
	        }
	        if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
	          return false;
	        }
	        if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
	          e.preventDefault();
	          return true;
	        }
	        return false;
	      };
	      var executeShortcutAction = function (shortcut) {
	        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
	      };
	      editor.on('keyup keypress keydown', function (e) {
	        if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
	          each$b(shortcuts, function (shortcut) {
	            if (matchShortcut(e, shortcut)) {
	              pendingPatterns = shortcut.subpatterns.slice(0);
	              if (e.type === 'keydown') {
	                executeShortcutAction(shortcut);
	              }
	              return true;
	            }
	          });
	          if (matchShortcut(e, pendingPatterns[0])) {
	            if (pendingPatterns.length === 1) {
	              if (e.type === 'keydown') {
	                executeShortcutAction(pendingPatterns[0]);
	              }
	            }
	            pendingPatterns.shift();
	          }
	        }
	      });
	      self.add = function (pattern, desc, cmdFunc, scope) {
	        var cmd;
	        cmd = cmdFunc;
	        if (typeof cmdFunc === 'string') {
	          cmdFunc = function () {
	            editor.execCommand(cmd, false, null);
	          };
	        } else if (Tools.isArray(cmd)) {
	          cmdFunc = function () {
	            editor.execCommand(cmd[0], cmd[1], cmd[2]);
	          };
	        }
	        each$b(explode$2(Tools.trim(pattern.toLowerCase())), function (pattern) {
	          var shortcut = createShortcut(pattern, desc, cmdFunc, scope);
	          shortcuts[shortcut.id] = shortcut;
	        });
	        return true;
	      };
	      self.remove = function (pattern) {
	        var shortcut = createShortcut(pattern);
	        if (shortcuts[shortcut.id]) {
	          delete shortcuts[shortcut.id];
	          return true;
	        }
	        return false;
	      };
	    }
	
	    var hasFocus = function (element) {
	      var doc = owner(element).dom();
	      return element.dom() === doc.activeElement;
	    };
	    var active = function (_doc) {
	      var doc = _doc !== undefined ? _doc.dom() : domGlobals.document;
	      return Option.from(doc.activeElement).map(Element.fromDom);
	    };
	    var search = function (element) {
	      return active(owner(element)).filter(function (e) {
	        return element.dom().contains(e.dom());
	      });
	    };
	
	    var getContentEditableHost = function (editor, node) {
	      return editor.dom.getParent(node, function (node) {
	        return editor.dom.getContentEditable(node) === 'true';
	      });
	    };
	    var getCollapsedNode = function (rng) {
	      return rng.collapsed ? Option.from(getNode(rng.startContainer, rng.startOffset)).map(Element.fromDom) : Option.none();
	    };
	    var getFocusInElement = function (root, rng) {
	      return getCollapsedNode(rng).bind(function (node) {
	        if (isTableSection(node)) {
	          return Option.some(node);
	        } else if (contains$3(root, node) === false) {
	          return Option.some(root);
	        } else {
	          return Option.none();
	        }
	      });
	    };
	    var normalizeSelection = function (editor, rng) {
	      getFocusInElement(Element.fromDom(editor.getBody()), rng).bind(function (elm) {
	        return CaretFinder.firstPositionIn(elm.dom());
	      }).fold(function () {
	        editor.selection.normalize();
	        return;
	      }, function (caretPos) {
	        return editor.selection.setRng(caretPos.toRange());
	      });
	    };
	    var focusBody = function (body) {
	      if (body.setActive) {
	        try {
	          body.setActive();
	        } catch (ex) {
	          body.focus();
	        }
	      } else {
	        body.focus();
	      }
	    };
	    var hasElementFocus = function (elm) {
	      return hasFocus(elm) || search(elm).isSome();
	    };
	    var hasIframeFocus = function (editor) {
	      return editor.iframeElement && hasFocus(Element.fromDom(editor.iframeElement));
	    };
	    var hasInlineFocus = function (editor) {
	      var rawBody = editor.getBody();
	      return rawBody && hasElementFocus(Element.fromDom(rawBody));
	    };
	    var hasFocus$1 = function (editor) {
	      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
	    };
	    var focusEditor = function (editor) {
	      var selection = editor.selection, contentEditable = editor.settings.content_editable;
	      var body = editor.getBody();
	      var rng = selection.getRng();
	      editor.quirks.refreshContentEditable();
	      var contentEditableHost = getContentEditableHost(editor, selection.getNode());
	      if (editor.$.contains(body, contentEditableHost)) {
	        focusBody(contentEditableHost);
	        normalizeSelection(editor, rng);
	        activateEditor(editor);
	        return;
	      }
	      if (editor.bookmark !== undefined && hasFocus$1(editor) === false) {
	        SelectionBookmark.getRng(editor).each(function (bookmarkRng) {
	          editor.selection.setRng(bookmarkRng);
	          rng = bookmarkRng;
	        });
	      }
	      if (!contentEditable) {
	        if (!Env.opera) {
	          focusBody(body);
	        }
	        editor.getWin().focus();
	      }
	      if (Env.gecko || contentEditable) {
	        focusBody(body);
	        normalizeSelection(editor, rng);
	      }
	      activateEditor(editor);
	    };
	    var activateEditor = function (editor) {
	      return editor.editorManager.setActive(editor);
	    };
	    var focus = function (editor, skipFocus) {
	      if (editor.removed) {
	        return;
	      }
	      skipFocus ? activateEditor(editor) : focusEditor(editor);
	    };
	    var EditorFocus = {
	      focus: focus,
	      hasFocus: hasFocus$1
	    };
	
	    var getProp = function (propName, elm) {
	      var rawElm = elm.dom();
	      return rawElm[propName];
	    };
	    var getComputedSizeProp = function (propName, elm) {
	      return parseInt(get$1(elm, propName), 10);
	    };
	    var getClientWidth = curry(getProp, 'clientWidth');
	    var getClientHeight = curry(getProp, 'clientHeight');
	    var getMarginTop = curry(getComputedSizeProp, 'margin-top');
	    var getMarginLeft = curry(getComputedSizeProp, 'margin-left');
	    var getBoundingClientRect$1 = function (elm) {
	      return elm.dom().getBoundingClientRect();
	    };
	    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
	      var clientWidth = getClientWidth(bodyElm);
	      var clientHeight = getClientHeight(bodyElm);
	      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
	    };
	    var transpose = function (inline, elm, clientX, clientY) {
	      var clientRect = getBoundingClientRect$1(elm);
	      var deltaX = inline ? clientRect.left + elm.dom().clientLeft + getMarginLeft(elm) : 0;
	      var deltaY = inline ? clientRect.top + elm.dom().clientTop + getMarginTop(elm) : 0;
	      var x = clientX - deltaX;
	      var y = clientY - deltaY;
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var isXYInContentArea = function (editor, clientX, clientY) {
	      var bodyElm = Element.fromDom(editor.getBody());
	      var targetElm = editor.inline ? bodyElm : documentElement(bodyElm);
	      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
	      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
	    };
	    var fromDomSafe = function (node) {
	      return Option.from(node).map(Element.fromDom);
	    };
	    var isEditorAttachedToDom = function (editor) {
	      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
	      return fromDomSafe(rawContainer).map(function (container) {
	        return contains$3(owner(container), container);
	      }).getOr(false);
	    };
	    var EditorView = {
	      isXYInContentArea: isXYInContentArea,
	      isEditorAttachedToDom: isEditorAttachedToDom
	    };
	
	    function NotificationManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a NotificationManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        close: unimplemented,
	        reposition: unimplemented,
	        getArgs: unimplemented
	      };
	    }
	
	    function NotificationManager (editor) {
	      var notifications = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
	      };
	      var getTopNotification = function () {
	        return Option.from(notifications[0]);
	      };
	      var isEqual = function (a, b) {
	        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
	      };
	      var reposition = function () {
	        if (notifications.length > 0) {
	          getImplementation().reposition(notifications);
	        }
	      };
	      var addNotification = function (notification) {
	        notifications.push(notification);
	      };
	      var closeNotification = function (notification) {
	        findIndex(notifications, function (otherNotification) {
	          return otherNotification === notification;
	        }).each(function (index) {
	          notifications.splice(index, 1);
	        });
	      };
	      var open = function (args) {
	        if (editor.removed || !EditorView.isEditorAttachedToDom(editor)) {
	          return;
	        }
	        return find(notifications, function (notification) {
	          return isEqual(getImplementation().getArgs(notification), args);
	        }).getOrThunk(function () {
	          editor.editorManager.setActive(editor);
	          var notification = getImplementation().open(args, function () {
	            closeNotification(notification);
	            reposition();
	          });
	          addNotification(notification);
	          reposition();
	          return notification;
	        });
	      };
	      var close = function () {
	        getTopNotification().each(function (notification) {
	          getImplementation().close(notification);
	          closeNotification(notification);
	          reposition();
	        });
	      };
	      var getNotifications = function () {
	        return notifications;
	      };
	      var registerEvents = function (editor) {
	        editor.on('SkinLoaded', function () {
	          var serviceMessage = editor.settings.service_message;
	          if (serviceMessage) {
	            open({
	              text: serviceMessage,
	              type: 'warning',
	              timeout: 0,
	              icon: ''
	            });
	          }
	        });
	        editor.on('ResizeEditor ResizeWindow', function () {
	          Delay.requestAnimationFrame(reposition);
	        });
	        editor.on('remove', function () {
	          each(notifications.slice(), function (notification) {
	            getImplementation().close(notification);
	          });
	        });
	      };
	      registerEvents(editor);
	      return {
	        open: open,
	        close: close,
	        getNotifications: getNotifications
	      };
	    }
	
	    function WindowManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a WindowManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        alert: unimplemented,
	        confirm: unimplemented,
	        close: unimplemented,
	        getParams: unimplemented,
	        setParams: unimplemented
	      };
	    }
	
	    function WindowManager (editor) {
	      var windows = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
	      };
	      var funcBind = function (scope, f) {
	        return function () {
	          return f ? f.apply(scope, arguments) : undefined;
	        };
	      };
	      var fireOpenEvent = function (win) {
	        editor.fire('OpenWindow', { win: win });
	      };
	      var fireCloseEvent = function (win) {
	        editor.fire('CloseWindow', { win: win });
	      };
	      var addWindow = function (win) {
	        windows.push(win);
	        fireOpenEvent(win);
	      };
	      var closeWindow = function (win) {
	        findIndex(windows, function (otherWindow) {
	          return otherWindow === win;
	        }).each(function (index) {
	          windows.splice(index, 1);
	          fireCloseEvent(win);
	          if (windows.length === 0) {
	            editor.focus();
	          }
	        });
	      };
	      var getTopWindow = function () {
	        return Option.from(windows[windows.length - 1]);
	      };
	      var open = function (args, params) {
	        editor.editorManager.setActive(editor);
	        SelectionBookmark.store(editor);
	        var win = getImplementation().open(args, params, closeWindow);
	        addWindow(win);
	        return win;
	      };
	      var alert = function (message, callback, scope) {
	        var win = getImplementation().alert(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	      var confirm = function (message, callback, scope) {
	        var win = getImplementation().confirm(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	      var close = function () {
	        getTopWindow().each(function (win) {
	          getImplementation().close(win);
	          closeWindow(win);
	        });
	      };
	      var getParams = function () {
	        return getTopWindow().map(getImplementation().getParams).getOr(null);
	      };
	      var setParams = function (params) {
	        getTopWindow().each(function (win) {
	          getImplementation().setParams(win, params);
	        });
	      };
	      var getWindows = function () {
	        return windows;
	      };
	      editor.on('remove', function () {
	        each(windows.slice(0), function (win) {
	          getImplementation().close(win);
	        });
	      });
	      return {
	        windows: windows,
	        open: open,
	        alert: alert,
	        confirm: confirm,
	        close: close,
	        getParams: getParams,
	        setParams: setParams,
	        getWindows: getWindows
	      };
	    }
	
	    var data = {};
	    var code = 'en';
	    var I18n = {
	      setCode: function (newCode) {
	        if (newCode) {
	          code = newCode;
	          this.rtl = this.data[newCode] ? this.data[newCode]._dir === 'rtl' : false;
	        }
	      },
	      getCode: function () {
	        return code;
	      },
	      rtl: false,
	      add: function (code, items) {
	        var langData = data[code];
	        if (!langData) {
	          data[code] = langData = {};
	        }
	        for (var name in items) {
	          langData[name] = items[name];
	        }
	        this.setCode(code);
	      },
	      translate: function (text) {
	        var langData = data[code] || {};
	        var toString = function (obj) {
	          if (Tools.is(obj, 'function')) {
	            return Object.prototype.toString.call(obj);
	          }
	          return !isEmpty(obj) ? '' + obj : '';
	        };
	        var isEmpty = function (text) {
	          return text === '' || text === null || Tools.is(text, 'undefined');
	        };
	        var getLangData = function (text) {
	          text = toString(text);
	          return Tools.hasOwn(langData, text) ? toString(langData[text]) : text;
	        };
	        if (isEmpty(text)) {
	          return '';
	        }
	        if (Tools.is(text, 'object') && Tools.hasOwn(text, 'raw')) {
	          return toString(text.raw);
	        }
	        if (Tools.is(text, 'array')) {
	          var values_1 = text.slice(1);
	          text = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
	            return Tools.hasOwn(values_1, $2) ? toString(values_1[$2]) : $1;
	          });
	        }
	        return getLangData(text).replace(/{context:\w+}$/, '');
	      },
	      data: data
	    };
	
	    var PluginManager = AddOnManager.PluginManager;
	    var resolvePluginName = function (targetUrl, suffix) {
	      for (var name in PluginManager.urls) {
	        var matchUrl = PluginManager.urls[name] + '/plugin' + suffix + '.js';
	        if (matchUrl === targetUrl) {
	          return name;
	        }
	      }
	      return null;
	    };
	    var pluginUrlToMessage = function (editor, url) {
	      var plugin = resolvePluginName(url, editor.suffix);
	      return plugin ? I18n.translate([
	        'Failed to load plugin: {0} from url {1}',
	        plugin,
	        url
	      ]) : I18n.translate([
	        'Failed to load plugin url: {0}',
	        url
	      ]);
	    };
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        type: 'error',
	        text: message
	      });
	    };
	    var displayError = function (editor, message) {
	      if (editor._skinLoaded) {
	        displayNotification(editor, message);
	      } else {
	        editor.on('SkinLoaded', function () {
	          displayNotification(editor, message);
	        });
	      }
	    };
	    var uploadError = function (editor, message) {
	      displayError(editor, I18n.translate([
	        'Failed to upload image: {0}',
	        message
	      ]));
	    };
	    var pluginLoadError = function (editor, url) {
	      displayError(editor, pluginUrlToMessage(editor, url));
	    };
	    var pluginInitError = function (editor, name, err) {
	      var message = I18n.translate([
	        'Failed to initialize plugin: {0}',
	        name
	      ]);
	      initError(message, err);
	      displayError(editor, message);
	    };
	    var initError = function (message) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var console = domGlobals.window.console;
	      if (console) {
	        if (console.error) {
	          console.error.apply(console, arguments);
	        } else {
	          console.log.apply(console, arguments);
	        }
	      }
	    };
	    var ErrorReporter = {
	      pluginLoadError: pluginLoadError,
	      pluginInitError: pluginInitError,
	      uploadError: uploadError,
	      displayError: displayError,
	      initError: initError
	    };
	
	    var PluginManager$1 = AddOnManager.PluginManager;
	
	    var ThemeManager = AddOnManager.ThemeManager;
	
	    function XMLHttpRequest () {
	      var f = Global$1.getOrDie('XMLHttpRequest');
	      return new f();
	    }
	
	    function Uploader (uploadStatus, settings) {
	      var pendingPromises = {};
	      var pathJoin = function (path1, path2) {
	        if (path1) {
	          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	        }
	        return path2;
	      };
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr, formData;
	        xhr = XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          var json;
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        formData = new domGlobals.FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var noUpload = function () {
	        return new promiseObj(function (resolve) {
	          resolve([]);
	        });
	      };
	      var handlerSuccess = function (blobInfo, url) {
	        return {
	          url: url,
	          blobInfo: blobInfo,
	          status: true
	        };
	      };
	      var handlerFailure = function (blobInfo, error) {
	        return {
	          url: '',
	          blobInfo: blobInfo,
	          status: false,
	          error: error
	        };
	      };
	      var resolvePending = function (blobUri, result) {
	        Tools.each(pendingPromises[blobUri], function (resolve) {
	          resolve(result);
	        });
	        delete pendingPromises[blobUri];
	      };
	      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
	        uploadStatus.markPending(blobInfo.blobUri());
	        return new promiseObj(function (resolve) {
	          var notification, progress;
	          var noop = function () {
	          };
	          try {
	            var closeNotification_1 = function () {
	              if (notification) {
	                notification.close();
	                progress = noop;
	              }
	            };
	            var success = function (url) {
	              closeNotification_1();
	              uploadStatus.markUploaded(blobInfo.blobUri(), url);
	              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
	              resolve(handlerSuccess(blobInfo, url));
	            };
	            var failure = function (error) {
	              closeNotification_1();
	              uploadStatus.removeFailed(blobInfo.blobUri());
	              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error));
	              resolve(handlerFailure(blobInfo, error));
	            };
	            progress = function (percent) {
	              if (percent < 0 || percent > 100) {
	                return;
	              }
	              if (!notification) {
	                notification = openNotification();
	              }
	              notification.progressBar.value(percent);
	            };
	            handler(blobInfo, success, failure, progress);
	          } catch (ex) {
	            resolve(handlerFailure(blobInfo, ex.message));
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var pendingUploadBlobInfo = function (blobInfo) {
	        var blobUri = blobInfo.blobUri();
	        return new promiseObj(function (resolve) {
	          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
	          pendingPromises[blobUri].push(resolve);
	        });
	      };
	      var uploadBlobs = function (blobInfos, openNotification) {
	        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
	          return !uploadStatus.isUploaded(blobInfo.blobUri());
	        });
	        return promiseObj.all(Tools.map(blobInfos, function (blobInfo) {
	          return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
	        }));
	      };
	      var upload = function (blobInfos, openNotification) {
	        return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
	      };
	      if (isFunction(settings.handler) === false) {
	        settings.handler = defaultHandler;
	      }
	      return { upload: upload };
	    }
	
	    function FileReader () {
	      var f = Global$1.getOrDie('FileReader');
	      return new f();
	    }
	
	    function Uint8Array (arr) {
	      var f = Global$1.getOrDie('Uint8Array');
	      return new f(arr);
	    }
	
	    var requestAnimationFrame$1 = function (callback) {
	      var f = Global$1.getOrDie('requestAnimationFrame');
	      f(callback);
	    };
	    var atob = function (base64) {
	      var f = Global$1.getOrDie('atob');
	      return f(base64);
	    };
	    var Window = {
	      atob: atob,
	      requestAnimationFrame: requestAnimationFrame$1
	    };
	
	    var blobUriToBlob = function (url) {
	      return new promiseObj(function (resolve, reject) {
	        var rejectWithError = function () {
	          reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
	        };
	        try {
	          var xhr = XMLHttpRequest();
	          xhr.open('GET', url, true);
	          xhr.responseType = 'blob';
	          xhr.onload = function () {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              rejectWithError();
	            }
	          };
	          xhr.onerror = rejectWithError;
	          xhr.send();
	        } catch (ex) {
	          rejectWithError();
	        }
	      });
	    };
	    var parseDataUri = function (uri) {
	      var type, matches;
	      var uriParts = decodeURIComponent(uri).split(',');
	      matches = /data:([^;]+)/.exec(uriParts[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uriParts[1]
	      };
	    };
	    var dataUriToBlob = function (uri) {
	      return new promiseObj(function (resolve) {
	        var str, arr, i;
	        var uriParts = parseDataUri(uri);
	        try {
	          str = Window.atob(uriParts.data);
	        } catch (e) {
	          resolve(new domGlobals.Blob([]));
	          return;
	        }
	        arr = Uint8Array(str.length);
	        for (i = 0; i < arr.length; i++) {
	          arr[i] = str.charCodeAt(i);
	        }
	        resolve(new domGlobals.Blob([arr], { type: uriParts.type }));
	      });
	    };
	    var uriToBlob = function (url) {
	      if (url.indexOf('blob:') === 0) {
	        return blobUriToBlob(url);
	      }
	      if (url.indexOf('data:') === 0) {
	        return dataUriToBlob(url);
	      }
	      return null;
	    };
	    var blobToDataUri = function (blob) {
	      return new promiseObj(function (resolve) {
	        var reader = FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var Conversions = {
	      uriToBlob: uriToBlob,
	      blobToDataUri: blobToDataUri,
	      parseDataUri: parseDataUri
	    };
	
	    var count = 0;
	    var uniqueId = function (prefix) {
	      return (prefix || 'blobid') + count++;
	    };
	    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
	      var base64, blobInfo;
	      if (img.src.indexOf('blob:') === 0) {
	        blobInfo = blobCache.getByUri(img.src);
	        if (blobInfo) {
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        } else {
	          Conversions.uriToBlob(img.src).then(function (blob) {
	            Conversions.blobToDataUri(blob).then(function (dataUri) {
	              base64 = Conversions.parseDataUri(dataUri).data;
	              blobInfo = blobCache.create(uniqueId(), blob, base64);
	              blobCache.add(blobInfo);
	              resolve({
	                image: img,
	                blobInfo: blobInfo
	              });
	            });
	          }, function (err) {
	            reject(err);
	          });
	        }
	        return;
	      }
	      base64 = Conversions.parseDataUri(img.src).data;
	      blobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	        return cachedBlobInfo.base64() === base64;
	      });
	      if (blobInfo) {
	        resolve({
	          image: img,
	          blobInfo: blobInfo
	        });
	      } else {
	        Conversions.uriToBlob(img.src).then(function (blob) {
	          blobInfo = blobCache.create(uniqueId(), blob, base64);
	          blobCache.add(blobInfo);
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }
	    };
	    var getAllImages = function (elm) {
	      return elm ? from$1(elm.getElementsByTagName('img')) : [];
	    };
	    function ImageScanner (uploadStatus, blobCache) {
	      var cachedPromises = {};
	      var findAll = function (elm, predicate) {
	        var images;
	        if (!predicate) {
	          predicate = constant(true);
	        }
	        images = filter(getAllImages(elm), function (img) {
	          var src = img.src;
	          if (!Env.fileApi) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-bogus')) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-placeholder')) {
	            return false;
	          }
	          if (!src || src === Env.transparentSrc) {
	            return false;
	          }
	          if (src.indexOf('blob:') === 0) {
	            return !uploadStatus.isUploaded(src) && predicate(img);
	          }
	          if (src.indexOf('data:') === 0) {
	            return predicate(img);
	          }
	          return false;
	        });
	        var promises = map(images, function (img) {
	          if (cachedPromises[img.src]) {
	            return new promiseObj(function (resolve) {
	              cachedPromises[img.src].then(function (imageInfo) {
	                if (typeof imageInfo === 'string') {
	                  return imageInfo;
	                }
	                resolve({
	                  image: img,
	                  blobInfo: imageInfo.blobInfo
	                });
	              });
	            });
	          }
	          var newPromise = new promiseObj(function (resolve, reject) {
	            imageToBlobInfo(blobCache, img, resolve, reject);
	          }).then(function (result) {
	            delete cachedPromises[result.image.src];
	            return result;
	          }).catch(function (error) {
	            delete cachedPromises[img.src];
	            return error;
	          });
	          cachedPromises[img.src] = newPromise;
	          return newPromise;
	        });
	        return promiseObj.all(promises);
	      };
	      return { findAll: findAll };
	    }
	
	    var count$1 = 0;
	    var seed = function () {
	      var rnd = function () {
	        return Math.round(Math.random() * 4294967295).toString(36);
	      };
	      var now = new Date().getTime();
	      return 's' + now.toString(36) + rnd() + rnd() + rnd();
	    };
	    var uuid = function (prefix) {
	      return prefix + count$1++ + seed();
	    };
	    var Uuid = { uuid: uuid };
	
	    function BlobCache () {
	      var cache = [];
	      var mimeToExt = function (mime) {
	        var mimes = {
	          'image/jpeg': 'jpg',
	          'image/jpg': 'jpg',
	          'image/gif': 'gif',
	          'image/png': 'png'
	        };
	        return mimes[mime.toLowerCase()] || 'dat';
	      };
	      var create = function (o, blob, base64, filename) {
	        if (isString(o)) {
	          var id = o;
	          return toBlobInfo({
	            id: id,
	            name: filename,
	            blob: blob,
	            base64: base64
	          });
	        } else if (isObject(o)) {
	          return toBlobInfo(o);
	        } else {
	          throw new Error('Unknown input type');
	        }
	      };
	      var toBlobInfo = function (o) {
	        var id, name;
	        if (!o.blob || !o.base64) {
	          throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
	        }
	        id = o.id || Uuid.uuid('blobid');
	        name = o.name || id;
	        return {
	          id: constant(id),
	          name: constant(name),
	          filename: constant(name + '.' + mimeToExt(o.blob.type)),
	          blob: constant(o.blob),
	          base64: constant(o.base64),
	          blobUri: constant(o.blobUri || URL.createObjectURL(o.blob)),
	          uri: constant(o.uri)
	        };
	      };
	      var add = function (blobInfo) {
	        if (!get(blobInfo.id())) {
	          cache.push(blobInfo);
	        }
	      };
	      var get = function (id) {
	        return findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.id() === id;
	        });
	      };
	      var findFirst = function (predicate) {
	        return filter(cache, predicate)[0];
	      };
	      var getByUri = function (blobUri) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.blobUri() === blobUri;
	        });
	      };
	      var removeByUri = function (blobUri) {
	        cache = filter(cache, function (blobInfo) {
	          if (blobInfo.blobUri() === blobUri) {
	            URL.revokeObjectURL(blobInfo.blobUri());
	            return false;
	          }
	          return true;
	        });
	      };
	      var destroy = function () {
	        each(cache, function (cachedBlobInfo) {
	          URL.revokeObjectURL(cachedBlobInfo.blobUri());
	        });
	        cache = [];
	      };
	      return {
	        create: create,
	        add: add,
	        get: get,
	        getByUri: getByUri,
	        findFirst: findFirst,
	        removeByUri: removeByUri,
	        destroy: destroy
	      };
	    }
	
	    function UploadStatus () {
	      var PENDING = 1, UPLOADED = 2;
	      var blobUriStatuses = {};
	      var createStatus = function (status, resultUri) {
	        return {
	          status: status,
	          resultUri: resultUri
	        };
	      };
	      var hasBlobUri = function (blobUri) {
	        return blobUri in blobUriStatuses;
	      };
	      var getResultUri = function (blobUri) {
	        var result = blobUriStatuses[blobUri];
	        return result ? result.resultUri : null;
	      };
	      var isPending = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
	      };
	      var isUploaded = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
	      };
	      var markPending = function (blobUri) {
	        blobUriStatuses[blobUri] = createStatus(PENDING, null);
	      };
	      var markUploaded = function (blobUri, resultUri) {
	        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
	      };
	      var removeFailed = function (blobUri) {
	        delete blobUriStatuses[blobUri];
	      };
	      var destroy = function () {
	        blobUriStatuses = {};
	      };
	      return {
	        hasBlobUri: hasBlobUri,
	        getResultUri: getResultUri,
	        isPending: isPending,
	        isUploaded: isUploaded,
	        markPending: markPending,
	        markUploaded: markUploaded,
	        removeFailed: removeFailed,
	        destroy: destroy
	      };
	    }
	
	    function EditorUpload (editor) {
	      var blobCache = BlobCache();
	      var uploader, imageScanner;
	      var uploadStatus = UploadStatus();
	      var urlFilters = [];
	      var aliveGuard = function (callback) {
	        return function (result) {
	          if (editor.selection) {
	            return callback(result);
	          }
	          return [];
	        };
	      };
	      var cacheInvalidator = function () {
	        return '?' + new Date().getTime();
	      };
	      var replaceString = function (content, search, replace) {
	        var index = 0;
	        do {
	          index = content.indexOf(search, index);
	          if (index !== -1) {
	            content = content.substring(0, index) + replace + content.substr(index + search.length);
	            index += replace.length - search.length + 1;
	          }
	        } while (index !== -1);
	        return content;
	      };
	      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
	        content = replaceString(content, 'src="' + targetUrl + '"', 'src="' + replacementUrl + '"');
	        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	        return content;
	      };
	      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
	        each(editor.undoManager.data, function (level) {
	          if (level.type === 'fragmented') {
	            level.fragments = map(level.fragments, function (fragment) {
	              return replaceImageUrl(fragment, targetUrl, replacementUrl);
	            });
	          } else {
	            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
	          }
	        });
	      };
	      var openNotification = function () {
	        return editor.notificationManager.open({
	          text: editor.translate('Image uploading...'),
	          type: 'info',
	          timeout: -1,
	          progressBar: true
	        });
	      };
	      var replaceImageUri = function (image, resultUri) {
	        blobCache.removeByUri(image.src);
	        replaceUrlInUndoStack(image.src, resultUri);
	        editor.$(image).attr({
	          'src': Settings.shouldReuseFileName(editor) ? resultUri + cacheInvalidator() : resultUri,
	          'data-mce-src': editor.convertURL(resultUri, 'src')
	        });
	      };
	      var uploadImages = function (callback) {
	        if (!uploader) {
	          uploader = Uploader(uploadStatus, {
	            url: Settings.getImageUploadUrl(editor),
	            basePath: Settings.getImageUploadBasePath(editor),
	            credentials: Settings.getImagesUploadCredentials(editor),
	            handler: Settings.getImagesUploadHandler(editor)
	          });
	        }
	        return scanForImages().then(aliveGuard(function (imageInfos) {
	          var blobInfos;
	          blobInfos = map(imageInfos, function (imageInfo) {
	            return imageInfo.blobInfo;
	          });
	          return uploader.upload(blobInfos, openNotification).then(aliveGuard(function (result) {
	            var filteredResult = map(result, function (uploadInfo, index) {
	              var image = imageInfos[index].image;
	              if (uploadInfo.status && Settings.shouldReplaceBlobUris(editor)) {
	                replaceImageUri(image, uploadInfo.url);
	              } else if (uploadInfo.error) {
	                ErrorReporter.uploadError(editor, uploadInfo.error);
	              }
	              return {
	                element: image,
	                status: uploadInfo.status
	              };
	            });
	            if (callback) {
	              callback(filteredResult);
	            }
	            return filteredResult;
	          }));
	        }));
	      };
	      var uploadImagesAuto = function (callback) {
	        if (Settings.isAutomaticUploadsEnabled(editor)) {
	          return uploadImages(callback);
	        }
	      };
	      var isValidDataUriImage = function (imgElm) {
	        if (forall(urlFilters, function (filter) {
	            return filter(imgElm);
	          }) === false) {
	          return false;
	        }
	        if (imgElm.getAttribute('src').indexOf('data:') === 0) {
	          var dataImgFilter = Settings.getImagesDataImgFilter(editor);
	          return dataImgFilter(imgElm);
	        }
	        return true;
	      };
	      var addFilter = function (filter) {
	        urlFilters.push(filter);
	      };
	      var scanForImages = function () {
	        if (!imageScanner) {
	          imageScanner = ImageScanner(uploadStatus, blobCache);
	        }
	        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
	          result = filter(result, function (resultItem) {
	            if (typeof resultItem === 'string') {
	              ErrorReporter.displayError(editor, resultItem);
	              return false;
	            }
	            return true;
	          });
	          each(result, function (resultItem) {
	            replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
	            resultItem.image.src = resultItem.blobInfo.blobUri();
	            resultItem.image.removeAttribute('data-mce-src');
	          });
	          return result;
	        }));
	      };
	      var destroy = function () {
	        blobCache.destroy();
	        uploadStatus.destroy();
	        imageScanner = uploader = null;
	      };
	      var replaceBlobUris = function (content) {
	        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
	          var resultUri = uploadStatus.getResultUri(blobUri);
	          if (resultUri) {
	            return 'src="' + resultUri + '"';
	          }
	          var blobInfo = blobCache.getByUri(blobUri);
	          if (!blobInfo) {
	            blobInfo = foldl(editor.editorManager.get(), function (result, editor) {
	              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
	            }, null);
	          }
	          if (blobInfo) {
	            var blob = blobInfo.blob();
	            return 'src="data:' + blob.type + ';base64,' + blobInfo.base64() + '"';
	          }
	          return match;
	        });
	      };
	      editor.on('setContent', function () {
	        if (Settings.isAutomaticUploadsEnabled(editor)) {
	          uploadImagesAuto();
	        } else {
	          scanForImages();
	        }
	      });
	      editor.on('RawSaveContent', function (e) {
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('getContent', function (e) {
	        if (e.source_view || e.format === 'raw') {
	          return;
	        }
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('PostRender', function () {
	        editor.parser.addNodeFilter('img', function (images) {
	          each(images, function (img) {
	            var src = img.attr('src');
	            if (blobCache.getByUri(src)) {
	              return;
	            }
	            var resultUri = uploadStatus.getResultUri(src);
	            if (resultUri) {
	              img.attr('src', resultUri);
	            }
	          });
	        });
	      });
	      return {
	        blobCache: blobCache,
	        addFilter: addFilter,
	        uploadImages: uploadImages,
	        uploadImagesAuto: uploadImagesAuto,
	        scanForImages: scanForImages,
	        destroy: destroy
	      };
	    }
	
	    var isBlockElement = function (blockElements, node) {
	      return blockElements.hasOwnProperty(node.nodeName);
	    };
	    var isValidTarget = function (blockElements, node) {
	      if (NodeType.isText(node)) {
	        return true;
	      } else if (NodeType.isElement(node)) {
	        return !isBlockElement(blockElements, node) && !Bookmarks.isBookmarkNode(node);
	      } else {
	        return false;
	      }
	    };
	    var hasBlockParent = function (blockElements, root, node) {
	      return exists(Parents.parents(Element.fromDom(node), Element.fromDom(root)), function (elm) {
	        return isBlockElement(blockElements, elm.dom());
	      });
	    };
	    var shouldRemoveTextNode = function (blockElements, node) {
	      if (NodeType.isText(node)) {
	        if (node.nodeValue.length === 0) {
	          return true;
	        } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var addRootBlocks = function (editor) {
	      var settings = editor.settings, dom = editor.dom, selection = editor.selection;
	      var schema = editor.schema, blockElements = schema.getBlockElements();
	      var node = selection.getStart();
	      var rootNode = editor.getBody();
	      var rng;
	      var startContainer, startOffset, endContainer, endOffset, rootBlockNode;
	      var tempNode, wrapped, restoreSelection;
	      var rootNodeName, forcedRootBlock;
	      forcedRootBlock = settings.forced_root_block;
	      if (!node || !NodeType.isElement(node) || !forcedRootBlock) {
	        return;
	      }
	      rootNodeName = rootNode.nodeName.toLowerCase();
	      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
	        return;
	      }
	      rng = selection.getRng();
	      startContainer = rng.startContainer;
	      startOffset = rng.startOffset;
	      endContainer = rng.endContainer;
	      endOffset = rng.endOffset;
	      restoreSelection = EditorFocus.hasFocus(editor);
	      node = rootNode.firstChild;
	      while (node) {
	        if (isValidTarget(blockElements, node)) {
	          if (shouldRemoveTextNode(blockElements, node)) {
	            tempNode = node;
	            node = node.nextSibling;
	            dom.remove(tempNode);
	            continue;
	          }
	          if (!rootBlockNode) {
	            rootBlockNode = dom.create(forcedRootBlock, editor.settings.forced_root_block_attrs);
	            node.parentNode.insertBefore(rootBlockNode, node);
	            wrapped = true;
	          }
	          tempNode = node;
	          node = node.nextSibling;
	          rootBlockNode.appendChild(tempNode);
	        } else {
	          rootBlockNode = null;
	          node = node.nextSibling;
	        }
	      }
	      if (wrapped && restoreSelection) {
	        rng.setStart(startContainer, startOffset);
	        rng.setEnd(endContainer, endOffset);
	        selection.setRng(rng);
	        editor.nodeChanged();
	      }
	    };
	    var setup$3 = function (editor) {
	      if (editor.settings.forced_root_block) {
	        editor.on('NodeChange', curry(addRootBlocks, editor));
	      }
	    };
	    var ForceBlocks = { setup: setup$3 };
	
	    var getStartNode = function (rng) {
	      var sc = rng.startContainer, so = rng.startOffset;
	      if (NodeType.isText(sc)) {
	        return so === 0 ? Option.some(Element.fromDom(sc)) : Option.none();
	      } else {
	        return Option.from(sc.childNodes[so]).map(Element.fromDom);
	      }
	    };
	    var getEndNode = function (rng) {
	      var ec = rng.endContainer, eo = rng.endOffset;
	      if (NodeType.isText(ec)) {
	        return eo === ec.data.length ? Option.some(Element.fromDom(ec)) : Option.none();
	      } else {
	        return Option.from(ec.childNodes[eo - 1]).map(Element.fromDom);
	      }
	    };
	    var getFirstChildren = function (node) {
	      return firstChild(node).fold(constant([node]), function (child) {
	        return [node].concat(getFirstChildren(child));
	      });
	    };
	    var getLastChildren$1 = function (node) {
	      return lastChild(node).fold(constant([node]), function (child) {
	        if (name(child) === 'br') {
	          return prevSibling(child).map(function (sibling) {
	            return [node].concat(getLastChildren$1(sibling));
	          }).getOr([]);
	        } else {
	          return [node].concat(getLastChildren$1(child));
	        }
	      });
	    };
	    var hasAllContentsSelected = function (elm, rng) {
	      return lift2(getStartNode(rng), getEndNode(rng), function (startNode, endNode) {
	        var start = find(getFirstChildren(elm), curry(eq, startNode));
	        var end = find(getLastChildren$1(elm), curry(eq, endNode));
	        return start.isSome() && end.isSome();
	      }).getOr(false);
	    };
	    var moveEndPoint$1 = function (dom, rng, node, start) {
	      var root = node, walker = new TreeWalker(node, root);
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      do {
	        if (node.nodeType === 3 && Tools.trim(node.nodeValue).length !== 0) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, node.nodeValue.length);
	          }
	          return;
	        }
	        if (nonEmptyElementsMap[node.nodeName] && !/^(TD|TH)$/.test(node.nodeName)) {
	          if (start) {
	            rng.setStartBefore(node);
	          } else {
	            if (node.nodeName === 'BR') {
	              rng.setEndBefore(node);
	            } else {
	              rng.setEndAfter(node);
	            }
	          }
	          return;
	        }
	        if (Env.ie && Env.ie < 11 && dom.isBlock(node) && dom.isEmpty(node)) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, 0);
	          }
	          return;
	        }
	      } while (node = start ? walker.next() : walker.prev());
	      if (root.nodeName === 'BODY') {
	        if (start) {
	          rng.setStart(root, 0);
	        } else {
	          rng.setEnd(root, root.childNodes.length);
	        }
	      }
	    };
	    var hasAnyRanges = function (editor) {
	      var sel = editor.selection.getSel();
	      return sel && sel.rangeCount > 0;
	    };
	
	    function NodeChange (editor) {
	      var lastRng, lastPath = [];
	      var isSameElementPath = function (startElm) {
	        var i, currentPath;
	        currentPath = editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);
	        if (currentPath.length === lastPath.length) {
	          for (i = currentPath.length; i >= 0; i--) {
	            if (currentPath[i] !== lastPath[i]) {
	              break;
	            }
	          }
	          if (i === -1) {
	            lastPath = currentPath;
	            return true;
	          }
	        }
	        lastPath = currentPath;
	        return false;
	      };
	      if (!('onselectionchange' in editor.getDoc())) {
	        editor.on('NodeChange Click MouseUp KeyUp Focus', function (e) {
	          var nativeRng, fakeRng;
	          nativeRng = editor.selection.getRng();
	          fakeRng = {
	            startContainer: nativeRng.startContainer,
	            startOffset: nativeRng.startOffset,
	            endContainer: nativeRng.endContainer,
	            endOffset: nativeRng.endOffset
	          };
	          if (e.type === 'nodechange' || !RangeCompare.isEq(fakeRng, lastRng)) {
	            editor.fire('SelectionChange');
	          }
	          lastRng = fakeRng;
	        });
	      }
	      editor.on('contextmenu', function () {
	        editor.fire('SelectionChange');
	      });
	      editor.on('SelectionChange', function () {
	        var startElm = editor.selection.getStart(true);
	        if (!startElm || !Env.range && editor.selection.isCollapsed()) {
	          return;
	        }
	        if (hasAnyRanges(editor) && !isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
	          editor.nodeChanged({ selectionChange: true });
	        }
	      });
	      editor.on('MouseUp', function (e) {
	        if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
	          if (editor.selection.getNode().nodeName === 'IMG') {
	            Delay.setEditorTimeout(editor, function () {
	              editor.nodeChanged();
	            });
	          } else {
	            editor.nodeChanged();
	          }
	        }
	      });
	      this.nodeChanged = function (args) {
	        var selection = editor.selection;
	        var node, parents, root;
	        if (editor.initialized && selection && !editor.settings.disable_nodechange && !editor.readonly) {
	          root = editor.getBody();
	          node = selection.getStart(true) || root;
	          if (node.ownerDocument !== editor.getDoc() || !editor.dom.isChildOf(node, root)) {
	            node = root;
	          }
	          parents = [];
	          editor.dom.getParent(node, function (node) {
	            if (node === root) {
	              return true;
	            }
	            parents.push(node);
	          });
	          args = args || {};
	          args.element = node;
	          args.parents = parents;
	          editor.fire('NodeChange', args);
	        }
	      };
	    }
	
	    var VK = {
	      BACKSPACE: 8,
	      DELETE: 46,
	      DOWN: 40,
	      ENTER: 13,
	      LEFT: 37,
	      RIGHT: 39,
	      SPACEBAR: 32,
	      TAB: 9,
	      UP: 38,
	      END: 35,
	      HOME: 36,
	      modifierPressed: function (e) {
	        return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e);
	      },
	      metaKeyPressed: function (e) {
	        return Env.mac ? e.metaKey : e.ctrlKey && !e.altKey;
	      }
	    };
	
	    var getNodeClientRects = function (node) {
	      var toArrayWithNode = function (clientRects) {
	        return map(clientRects, function (clientRect) {
	          clientRect = clone$1(clientRect);
	          clientRect.node = node;
	          return clientRect;
	        });
	      };
	      if (NodeType.isElement(node)) {
	        return toArrayWithNode(node.getClientRects());
	      }
	      if (NodeType.isText(node)) {
	        var rng = node.ownerDocument.createRange();
	        rng.setStart(node, 0);
	        rng.setEnd(node, node.data.length);
	        return toArrayWithNode(rng.getClientRects());
	      }
	    };
	    var getClientRects = function (node) {
	      return foldl(node, function (result, node) {
	        return result.concat(getNodeClientRects(node));
	      }, []);
	    };
	
	    var VDirection;
	    (function (VDirection) {
	      VDirection[VDirection['Up'] = -1] = 'Up';
	      VDirection[VDirection['Down'] = 1] = 'Down';
	    }(VDirection || (VDirection = {})));
	    var findUntil = function (direction, root, predicateFn, node) {
	      while (node = findNode(node, direction, isEditableCaretCandidate, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var walkUntil = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
	      var line = 0, node;
	      var result = [];
	      var targetClientRect;
	      var add = function (node) {
	        var i, clientRect, clientRects;
	        clientRects = getClientRects([node]);
	        if (direction === -1) {
	          clientRects = clientRects.reverse();
	        }
	        for (i = 0; i < clientRects.length; i++) {
	          clientRect = clientRects[i];
	          if (isBeflowFn(clientRect, targetClientRect)) {
	            continue;
	          }
	          if (result.length > 0 && isAboveFn(clientRect, ArrUtils.last(result))) {
	            line++;
	          }
	          clientRect.line = line;
	          if (predicateFn(clientRect)) {
	            return true;
	          }
	          result.push(clientRect);
	        }
	      };
	      targetClientRect = ArrUtils.last(caretPosition.getClientRects());
	      if (!targetClientRect) {
	        return result;
	      }
	      node = caretPosition.getNode();
	      add(node);
	      findUntil(direction, root, add, node);
	      return result;
	    };
	    var aboveLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line > lineNumber;
	    };
	    var isLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line === lineNumber;
	    };
	    var upUntil = curry(walkUntil, VDirection.Up, isAbove, isBelow);
	    var downUntil = curry(walkUntil, VDirection.Down, isBelow, isAbove);
	    var positionsUntil = function (direction, root, predicateFn, node) {
	      var caretWalker = CaretWalker(root);
	      var walkFn, isBelowFn, isAboveFn, caretPosition;
	      var result = [];
	      var line = 0, clientRect, targetClientRect;
	      var getClientRect = function (caretPosition) {
	        if (direction === 1) {
	          return ArrUtils.last(caretPosition.getClientRects());
	        }
	        return ArrUtils.last(caretPosition.getClientRects());
	      };
	      if (direction === 1) {
	        walkFn = caretWalker.next;
	        isBelowFn = isBelow;
	        isAboveFn = isAbove;
	        caretPosition = CaretPosition$1.after(node);
	      } else {
	        walkFn = caretWalker.prev;
	        isBelowFn = isAbove;
	        isAboveFn = isBelow;
	        caretPosition = CaretPosition$1.before(node);
	      }
	      targetClientRect = getClientRect(caretPosition);
	      do {
	        if (!caretPosition.isVisible()) {
	          continue;
	        }
	        clientRect = getClientRect(caretPosition);
	        if (isAboveFn(clientRect, targetClientRect)) {
	          continue;
	        }
	        if (result.length > 0 && isBelowFn(clientRect, ArrUtils.last(result))) {
	          line++;
	        }
	        clientRect = clone$1(clientRect);
	        clientRect.position = caretPosition;
	        clientRect.line = line;
	        if (predicateFn(clientRect)) {
	          return result;
	        }
	        result.push(clientRect);
	      } while (caretPosition = walkFn(caretPosition));
	      return result;
	    };
	    var isAboveLine = function (lineNumber) {
	      return function (clientRect) {
	        return aboveLineNumber(lineNumber, clientRect);
	      };
	    };
	    var isLine = function (lineNumber) {
	      return function (clientRect) {
	        return isLineNumber(lineNumber, clientRect);
	      };
	    };
	
	    var isContentEditableFalse$7 = NodeType.isContentEditableFalse;
	    var findNode$1 = findNode;
	    var distanceToRectLeft = function (clientRect, clientX) {
	      return Math.abs(clientRect.left - clientX);
	    };
	    var distanceToRectRight = function (clientRect, clientX) {
	      return Math.abs(clientRect.right - clientX);
	    };
	    var isInside = function (clientX, clientRect) {
	      return clientX >= clientRect.left && clientX <= clientRect.right;
	    };
	    var findClosestClientRect = function (clientRects, clientX) {
	      return ArrUtils.reduce(clientRects, function (oldClientRect, clientRect) {
	        var oldDistance, newDistance;
	        oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
	        newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	        if (isInside(clientX, clientRect)) {
	          return clientRect;
	        }
	        if (isInside(clientX, oldClientRect)) {
	          return oldClientRect;
	        }
	        if (newDistance === oldDistance && isContentEditableFalse$7(clientRect.node)) {
	          return clientRect;
	        }
	        if (newDistance < oldDistance) {
	          return clientRect;
	        }
	        return oldClientRect;
	      });
	    };
	    var walkUntil$1 = function (direction, root, predicateFn, node) {
	      while (node = findNode$1(node, direction, isEditableCaretCandidate, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var findLineNodeRects = function (root, targetNodeRect) {
	      var clientRects = [];
	      var collect = function (checkPosFn, node) {
	        var lineRects;
	        lineRects = filter(getClientRects([node]), function (clientRect) {
	          return !checkPosFn(clientRect, targetNodeRect);
	        });
	        clientRects = clientRects.concat(lineRects);
	        return lineRects.length === 0;
	      };
	      clientRects.push(targetNodeRect);
	      walkUntil$1(VDirection.Up, root, curry(collect, isAbove), targetNodeRect.node);
	      walkUntil$1(VDirection.Down, root, curry(collect, isBelow), targetNodeRect.node);
	      return clientRects;
	    };
	    var getFakeCaretTargets = function (root) {
	      return filter(from$1(root.getElementsByTagName('*')), isFakeCaretTarget);
	    };
	    var caretInfo = function (clientRect, clientX) {
	      return {
	        node: clientRect.node,
	        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
	      };
	    };
	    var closestCaret = function (root, clientX, clientY) {
	      var closestNodeRect;
	      var contentEditableFalseNodeRects = getClientRects(getFakeCaretTargets(root));
	      var targetNodeRects = filter(contentEditableFalseNodeRects, function (rect) {
	        return clientY >= rect.top && clientY <= rect.bottom;
	      });
	      closestNodeRect = findClosestClientRect(targetNodeRects, clientX);
	      if (closestNodeRect) {
	        closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect), clientX);
	        if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
	          return caretInfo(closestNodeRect, clientX);
	        }
	      }
	      return null;
	    };
	
	    var isXYWithinRange = function (clientX, clientY, range) {
	      if (range.collapsed) {
	        return false;
	      }
	      if (Env.ie && Env.ie <= 11 && range.startOffset === range.endOffset - 1 && range.startContainer === range.endContainer) {
	        var elm = range.startContainer.childNodes[range.startOffset];
	        if (NodeType.isElement(elm)) {
	          return exists(elm.getClientRects(), function (rect) {
	            return containsXY(rect, clientX, clientY);
	          });
	        }
	      }
	      return exists(range.getClientRects(), function (rect) {
	        return containsXY(rect, clientX, clientY);
	      });
	    };
	    var RangePoint = { isXYWithinRange: isXYWithinRange };
	
	    var getAbsolutePosition = function (elm) {
	      var doc, docElem, win, clientRect;
	      clientRect = elm.getBoundingClientRect();
	      doc = elm.ownerDocument;
	      docElem = doc.documentElement;
	      win = doc.defaultView;
	      return {
	        top: clientRect.top + win.pageYOffset - docElem.clientTop,
	        left: clientRect.left + win.pageXOffset - docElem.clientLeft
	      };
	    };
	    var getBodyPosition = function (editor) {
	      return editor.inline ? getAbsolutePosition(editor.getBody()) : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getScrollPosition = function (editor) {
	      var body = editor.getBody();
	      return editor.inline ? {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      } : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getBodyScroll = function (editor) {
	      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
	      var inlineScroll = {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      };
	      var iframeScroll = {
	        left: body.scrollLeft || docElm.scrollLeft,
	        top: body.scrollTop || docElm.scrollTop
	      };
	      return editor.inline ? inlineScroll : iframeScroll;
	    };
	    var getMousePosition = function (editor, event) {
	      if (event.target.ownerDocument !== editor.getDoc()) {
	        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
	        var scrollPosition = getBodyScroll(editor);
	        return {
	          left: event.pageX - iframePosition.left + scrollPosition.left,
	          top: event.pageY - iframePosition.top + scrollPosition.top
	        };
	      }
	      return {
	        left: event.pageX,
	        top: event.pageY
	      };
	    };
	    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
	      return {
	        pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
	        pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
	      };
	    };
	    var calc = function (editor, event) {
	      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
	    };
	    var MousePosition = { calc: calc };
	
	    var isContentEditableFalse$8 = NodeType.isContentEditableFalse, isContentEditableTrue$3 = NodeType.isContentEditableTrue;
	    var isDraggable = function (rootElm, elm) {
	      return isContentEditableFalse$8(elm) && elm !== rootElm;
	    };
	    var isValidDropTarget = function (editor, targetElement, dragElement) {
	      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
	        return false;
	      }
	      if (isContentEditableFalse$8(targetElement)) {
	        return false;
	      }
	      return true;
	    };
	    var cloneElement = function (elm) {
	      var cloneElm = elm.cloneNode(true);
	      cloneElm.removeAttribute('data-mce-selected');
	      return cloneElm;
	    };
	    var createGhost = function (editor, elm, width, height) {
	      var clonedElm = elm.cloneNode(true);
	      editor.dom.setStyles(clonedElm, {
	        width: width,
	        height: height
	      });
	      editor.dom.setAttrib(clonedElm, 'data-mce-selected', null);
	      var ghostElm = editor.dom.create('div', {
	        'class': 'mce-drag-container',
	        'data-mce-bogus': 'all',
	        'unselectable': 'on',
	        'contenteditable': 'false'
	      });
	      editor.dom.setStyles(ghostElm, {
	        position: 'absolute',
	        opacity: 0.5,
	        overflow: 'hidden',
	        border: 0,
	        padding: 0,
	        margin: 0,
	        width: width,
	        height: height
	      });
	      editor.dom.setStyles(clonedElm, {
	        margin: 0,
	        boxSizing: 'border-box'
	      });
	      ghostElm.appendChild(clonedElm);
	      return ghostElm;
	    };
	    var appendGhostToBody = function (ghostElm, bodyElm) {
	      if (ghostElm.parentNode !== bodyElm) {
	        bodyElm.appendChild(ghostElm);
	      }
	    };
	    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
	      var overflowX = 0, overflowY = 0;
	      ghostElm.style.left = position.pageX + 'px';
	      ghostElm.style.top = position.pageY + 'px';
	      if (position.pageX + width > maxX) {
	        overflowX = position.pageX + width - maxX;
	      }
	      if (position.pageY + height > maxY) {
	        overflowY = position.pageY + height - maxY;
	      }
	      ghostElm.style.width = width - overflowX + 'px';
	      ghostElm.style.height = height - overflowY + 'px';
	    };
	    var removeElement = function (elm) {
	      if (elm && elm.parentNode) {
	        elm.parentNode.removeChild(elm);
	      }
	    };
	    var isLeftMouseButtonPressed = function (e) {
	      return e.button === 0;
	    };
	    var hasDraggableElement = function (state) {
	      return state.element;
	    };
	    var applyRelPos = function (state, position) {
	      return {
	        pageX: position.pageX - state.relX,
	        pageY: position.pageY + 5
	      };
	    };
	    var start$1 = function (state, editor) {
	      return function (e) {
	        if (isLeftMouseButtonPressed(e)) {
	          var ceElm = find(editor.dom.getParents(e.target), Predicate.or(isContentEditableFalse$8, isContentEditableTrue$3)).getOr(null);
	          if (isDraggable(editor.getBody(), ceElm)) {
	            var elmPos = editor.dom.getPos(ceElm);
	            var bodyElm = editor.getBody();
	            var docElm = editor.getDoc().documentElement;
	            state.element = ceElm;
	            state.screenX = e.screenX;
	            state.screenY = e.screenY;
	            state.maxX = (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2;
	            state.maxY = (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2;
	            state.relX = e.pageX - elmPos.x;
	            state.relY = e.pageY - elmPos.y;
	            state.width = ceElm.offsetWidth;
	            state.height = ceElm.offsetHeight;
	            state.ghost = createGhost(editor, ceElm, state.width, state.height);
	          }
	        }
	      };
	    };
	    var move$1 = function (state, editor) {
	      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
	        editor._selectionOverrides.hideFakeCaret();
	        editor.selection.placeCaretAt(clientX, clientY);
	      }, 0);
	      return function (e) {
	        var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	        if (hasDraggableElement(state) && !state.dragging && movement > 10) {
	          var args = editor.fire('dragstart', { target: state.element });
	          if (args.isDefaultPrevented()) {
	            return;
	          }
	          state.dragging = true;
	          editor.focus();
	        }
	        if (state.dragging) {
	          var targetPos = applyRelPos(state, MousePosition.calc(editor, e));
	          appendGhostToBody(state.ghost, editor.getBody());
	          moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	          throttledPlaceCaretAt(e.clientX, e.clientY);
	        }
	      };
	    };
	    var getRawTarget = function (selection) {
	      var rng = selection.getSel().getRangeAt(0);
	      var startContainer = rng.startContainer;
	      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
	    };
	    var drop = function (state, editor) {
	      return function (e) {
	        if (state.dragging) {
	          if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
	            var targetClone_1 = cloneElement(state.element);
	            var args = editor.fire('drop', {
	              targetClone: targetClone_1,
	              clientX: e.clientX,
	              clientY: e.clientY
	            });
	            if (!args.isDefaultPrevented()) {
	              targetClone_1 = args.targetClone;
	              editor.undoManager.transact(function () {
	                removeElement(state.element);
	                editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
	                editor._selectionOverrides.hideFakeCaret();
	              });
	            }
	          }
	        }
	        removeDragState(state);
	      };
	    };
	    var stop = function (state, editor) {
	      return function () {
	        if (state.dragging) {
	          editor.fire('dragend');
	        }
	        removeDragState(state);
	      };
	    };
	    var removeDragState = function (state) {
	      state.dragging = false;
	      state.element = null;
	      removeElement(state.ghost);
	    };
	    var bindFakeDragEvents = function (editor) {
	      var state = {};
	      var pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
	      pageDom = DOMUtils$1.DOM;
	      rootDocument = domGlobals.document;
	      dragStartHandler = start$1(state, editor);
	      dragHandler = move$1(state, editor);
	      dropHandler = drop(state, editor);
	      dragEndHandler = stop(state, editor);
	      editor.on('mousedown', dragStartHandler);
	      editor.on('mousemove', dragHandler);
	      editor.on('mouseup', dropHandler);
	      pageDom.bind(rootDocument, 'mousemove', dragHandler);
	      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	      editor.on('remove', function () {
	        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
	        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
	      });
	    };
	    var blockIeDrop = function (editor) {
	      editor.on('drop', function (e) {
	        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	        if (isContentEditableFalse$8(realTarget) || isContentEditableFalse$8(editor.dom.getContentEditableParent(realTarget))) {
	          e.preventDefault();
	        }
	      });
	    };
	    var init = function (editor) {
	      bindFakeDragEvents(editor);
	      blockIeDrop(editor);
	    };
	    var DragDropOverrides = { init: init };
	
	    var setup$4 = function (editor) {
	      var renderFocusCaret = first(function () {
	        if (!editor.removed) {
	          var rng = editor.selection.getRng();
	          if (rng.collapsed) {
	            var caretRange = renderRangeCaret(editor, editor.selection.getRng(), false);
	            editor.selection.setRng(caretRange);
	          }
	        }
	      }, 0);
	      editor.on('focus', function () {
	        renderFocusCaret.throttle();
	      });
	      editor.on('blur', function () {
	        renderFocusCaret.cancel();
	      });
	    };
	    var CefFocus = { setup: setup$4 };
	
	    var isContentEditableTrue$4 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$9 = NodeType.isContentEditableFalse;
	    var getContentEditableRoot$1 = function (editor, node) {
	      var root = editor.getBody();
	      while (node && node !== root) {
	        if (isContentEditableTrue$4(node) || isContentEditableFalse$9(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var SelectionOverrides = function (editor) {
	      var isBlock = function (node) {
	        return editor.dom.isBlock(node);
	      };
	      var rootNode = editor.getBody();
	      var fakeCaret = FakeCaret(editor.getBody(), isBlock, function () {
	        return EditorFocus.hasFocus(editor);
	      });
	      var realSelectionId = 'sel-' + editor.dom.uniqueId();
	      var selectedContentEditableNode;
	      var isFakeSelectionElement = function (elm) {
	        return editor.dom.hasClass(elm, 'mce-offscreen-selection');
	      };
	      var getRealSelectionElement = function () {
	        var container = editor.dom.get(realSelectionId);
	        return container ? container.getElementsByTagName('*')[0] : container;
	      };
	      var setRange = function (range) {
	        if (range) {
	          editor.selection.setRng(range);
	        }
	      };
	      var getRange = function () {
	        return editor.selection.getRng();
	      };
	      var showCaret = function (direction, node, before, scrollIntoView) {
	        if (scrollIntoView === void 0) {
	          scrollIntoView = true;
	        }
	        var e;
	        e = editor.fire('ShowCaret', {
	          target: node,
	          direction: direction,
	          before: before
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        if (scrollIntoView) {
	          editor.selection.scrollIntoView(node, direction === -1);
	        }
	        return fakeCaret.show(before, node);
	      };
	      var getNormalizedRangeEndPoint = function (direction, range) {
	        range = normalizeRange(direction, rootNode, range);
	        if (direction === -1) {
	          return CaretPosition$1.fromRangeStart(range);
	        }
	        return CaretPosition$1.fromRangeEnd(range);
	      };
	      var showBlockCaretContainer = function (blockCaretContainer) {
	        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	          showCaretContainerBlock(blockCaretContainer);
	          setRange(getRange());
	          editor.selection.scrollIntoView(blockCaretContainer[0]);
	        }
	      };
	      var registerEvents = function () {
	        editor.on('mouseup', function (e) {
	          var range = getRange();
	          if (range.collapsed && EditorView.isXYInContentArea(editor, e.clientX, e.clientY)) {
	            setRange(renderCaretAtRange(editor, range, false));
	          }
	        });
	        editor.on('click', function (e) {
	          var contentEditableRoot;
	          contentEditableRoot = getContentEditableRoot$1(editor, e.target);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              e.preventDefault();
	              editor.focus();
	            }
	            if (isContentEditableTrue$4(contentEditableRoot)) {
	              if (editor.dom.isChildOf(contentEditableRoot, editor.selection.getNode())) {
	                removeContentEditableSelection();
	              }
	            }
	          }
	        });
	        editor.on('blur NewBlock', function () {
	          removeContentEditableSelection();
	        });
	        editor.on('ResizeWindow FullscreenStateChanged', function () {
	          return fakeCaret.reposition();
	        });
	        var handleTouchSelect = function (editor) {
	          var moved = false;
	          editor.on('touchstart', function () {
	            moved = false;
	          });
	          editor.on('touchmove', function () {
	            moved = true;
	          });
	          editor.on('touchend', function (e) {
	            var contentEditableRoot = getContentEditableRoot$1(editor, e.target);
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              if (!moved) {
	                e.preventDefault();
	                setContentEditableSelection(selectNode(editor, contentEditableRoot));
	              }
	            }
	          });
	        };
	        var hasNormalCaretPosition = function (elm) {
	          var caretWalker = CaretWalker(elm);
	          if (!elm.firstChild) {
	            return false;
	          }
	          var startPos = CaretPosition$1.before(elm.firstChild);
	          var newPos = caretWalker.next(startPos);
	          return newPos && !isBeforeContentEditableFalse(newPos) && !isAfterContentEditableFalse(newPos);
	        };
	        var isInSameBlock = function (node1, node2) {
	          var block1 = editor.dom.getParent(node1, editor.dom.isBlock);
	          var block2 = editor.dom.getParent(node2, editor.dom.isBlock);
	          return block1 === block2;
	        };
	        var hasBetterMouseTarget = function (targetNode, caretNode) {
	          var targetBlock = editor.dom.getParent(targetNode, editor.dom.isBlock);
	          var caretBlock = editor.dom.getParent(caretNode, editor.dom.isBlock);
	          if (targetBlock && editor.dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse$9(getContentEditableRoot$1(editor, targetBlock)) === false) {
	            return true;
	          }
	          return targetBlock && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
	        };
	        handleTouchSelect(editor);
	        editor.on('mousedown', function (e) {
	          var contentEditableRoot;
	          var targetElm = e.target;
	          if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !editor.dom.isChildOf(targetElm, rootNode)) {
	            return;
	          }
	          if (EditorView.isXYInContentArea(editor, e.clientX, e.clientY) === false) {
	            return;
	          }
	          contentEditableRoot = getContentEditableRoot$1(editor, targetElm);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              e.preventDefault();
	              setContentEditableSelection(selectNode(editor, contentEditableRoot));
	            } else {
	              removeContentEditableSelection();
	              if (!(isContentEditableTrue$4(contentEditableRoot) && e.shiftKey) && !RangePoint.isXYWithinRange(e.clientX, e.clientY, editor.selection.getRng())) {
	                hideFakeCaret();
	                editor.selection.placeCaretAt(e.clientX, e.clientY);
	              }
	            }
	          } else if (isFakeCaretTarget(targetElm) === false) {
	            removeContentEditableSelection();
	            hideFakeCaret();
	            var caretInfo = closestCaret(rootNode, e.clientX, e.clientY);
	            if (caretInfo) {
	              if (!hasBetterMouseTarget(e.target, caretInfo.node)) {
	                e.preventDefault();
	                var range = showCaret(1, caretInfo.node, caretInfo.before, false);
	                editor.getBody().focus();
	                setRange(range);
	              }
	            }
	          }
	        });
	        editor.on('keypress', function (e) {
	          if (VK.modifierPressed(e)) {
	            return;
	          }
	          switch (e.keyCode) {
	          default:
	            if (isContentEditableFalse$9(editor.selection.getNode())) {
	              e.preventDefault();
	            }
	            break;
	          }
	        });
	        editor.on('getSelectionRange', function (e) {
	          var rng = e.range;
	          if (selectedContentEditableNode) {
	            if (!selectedContentEditableNode.parentNode) {
	              selectedContentEditableNode = null;
	              return;
	            }
	            rng = rng.cloneRange();
	            rng.selectNode(selectedContentEditableNode);
	            e.range = rng;
	          }
	        });
	        editor.on('setSelectionRange', function (e) {
	          e.range = normalizeShortEndedElementSelection(e.range);
	          var rng = setContentEditableSelection(e.range, e.forward);
	          if (rng) {
	            e.range = rng;
	          }
	        });
	        var isPasteBin = function (node) {
	          return node.id === 'mcepastebin';
	        };
	        editor.on('AfterSetSelectionRange', function (e) {
	          var rng = e.range;
	          if (!isRangeInCaretContainer(rng) && !isPasteBin(rng.startContainer.parentNode)) {
	            hideFakeCaret();
	          }
	          if (!isFakeSelectionElement(rng.startContainer.parentNode)) {
	            removeContentEditableSelection();
	          }
	        });
	        editor.on('copy', function (e) {
	          var clipboardData = e.clipboardData;
	          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
	            var realSelectionElement = getRealSelectionElement();
	            if (realSelectionElement) {
	              e.preventDefault();
	              clipboardData.clearData();
	              clipboardData.setData('text/html', realSelectionElement.outerHTML);
	              clipboardData.setData('text/plain', realSelectionElement.outerText);
	            }
	          }
	        });
	        DragDropOverrides.init(editor);
	        CefFocus.setup(editor);
	      };
	      var addCss = function () {
	        var styles = editor.contentStyles, rootClass = '.mce-content-body';
	        styles.push(fakeCaret.getCss());
	        styles.push(rootClass + ' .mce-offscreen-selection {' + 'position: absolute;' + 'left: -9999999999px;' + 'max-width: 1000000px;' + '}' + rootClass + ' *[contentEditable=false] {' + 'cursor: default;' + '}' + rootClass + ' *[contentEditable=true] {' + 'cursor: text;' + '}');
	      };
	      var isWithinCaretContainer = function (node) {
	        return isCaretContainer(node) || startsWithCaretContainer(node) || endsWithCaretContainer(node);
	      };
	      var isRangeInCaretContainer = function (rng) {
	        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
	      };
	      var normalizeShortEndedElementSelection = function (rng) {
	        var shortEndedElements = editor.schema.getShortEndedElements();
	        var newRng = editor.dom.createRng();
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        if (has(shortEndedElements, startContainer.nodeName.toLowerCase())) {
	          if (startOffset === 0) {
	            newRng.setStartBefore(startContainer);
	          } else {
	            newRng.setStartAfter(startContainer);
	          }
	        } else {
	          newRng.setStart(startContainer, startOffset);
	        }
	        if (has(shortEndedElements, endContainer.nodeName.toLowerCase())) {
	          if (endOffset === 0) {
	            newRng.setEndBefore(endContainer);
	          } else {
	            newRng.setEndAfter(endContainer);
	          }
	        } else {
	          newRng.setEnd(endContainer, endOffset);
	        }
	        return newRng;
	      };
	      var setContentEditableSelection = function (range, forward) {
	        var node;
	        var $ = editor.$;
	        var dom = editor.dom;
	        var $realSelectionContainer, sel, startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
	        if (!range) {
	          return null;
	        }
	        if (range.collapsed) {
	          if (!isRangeInCaretContainer(range)) {
	            if (forward === false) {
	              caretPosition = getNormalizedRangeEndPoint(-1, range);
	              if (isFakeCaretTarget(caretPosition.getNode(true))) {
	                return showCaret(-1, caretPosition.getNode(true), false, false);
	              }
	              if (isFakeCaretTarget(caretPosition.getNode())) {
	                return showCaret(-1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
	              }
	            } else {
	              caretPosition = getNormalizedRangeEndPoint(1, range);
	              if (isFakeCaretTarget(caretPosition.getNode())) {
	                return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
	              }
	              if (isFakeCaretTarget(caretPosition.getNode(true))) {
	                return showCaret(1, caretPosition.getNode(true), false, false);
	              }
	            }
	          }
	          return null;
	        }
	        startContainer = range.startContainer;
	        startOffset = range.startOffset;
	        endOffset = range.endOffset;
	        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse$9(startContainer.parentNode)) {
	          startContainer = startContainer.parentNode;
	          startOffset = dom.nodeIndex(startContainer);
	          startContainer = startContainer.parentNode;
	        }
	        if (startContainer.nodeType !== 1) {
	          return null;
	        }
	        if (endOffset === startOffset + 1 && startContainer === range.endContainer) {
	          node = startContainer.childNodes[startOffset];
	        }
	        if (!isContentEditableFalse$9(node)) {
	          return null;
	        }
	        targetClone = origTargetClone = node.cloneNode(true);
	        e = editor.fire('ObjectSelected', {
	          target: node,
	          targetClone: targetClone
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        $realSelectionContainer = descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
	          return $([]);
	        }, function (elm) {
	          return $([elm.dom()]);
	        });
	        targetClone = e.targetClone;
	        if ($realSelectionContainer.length === 0) {
	          $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
	          $realSelectionContainer.appendTo(editor.getBody());
	        }
	        range = editor.dom.createRng();
	        if (targetClone === origTargetClone && Env.ie) {
	          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
	          range.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
	          range.setEndAfter(targetClone);
	        } else {
	          $realSelectionContainer.empty().append('\xA0').append(targetClone).append('\xA0');
	          range.setStart($realSelectionContainer[0].firstChild, 1);
	          range.setEnd($realSelectionContainer[0].lastChild, 0);
	        }
	        $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
	        $realSelectionContainer[0].focus();
	        sel = editor.selection.getSel();
	        sel.removeAllRanges();
	        sel.addRange(range);
	        each(descendants$1(Element.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
	          remove(elm, 'data-mce-selected');
	        });
	        node.setAttribute('data-mce-selected', '1');
	        selectedContentEditableNode = node;
	        hideFakeCaret();
	        return range;
	      };
	      var removeContentEditableSelection = function () {
	        if (selectedContentEditableNode) {
	          selectedContentEditableNode.removeAttribute('data-mce-selected');
	          descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$1);
	          selectedContentEditableNode = null;
	        }
	        descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$1);
	        selectedContentEditableNode = null;
	      };
	      var destroy = function () {
	        fakeCaret.destroy();
	        selectedContentEditableNode = null;
	      };
	      var hideFakeCaret = function () {
	        fakeCaret.hide();
	      };
	      if (Env.ceFalse) {
	        registerEvents();
	        addCss();
	      }
	      return {
	        showCaret: showCaret,
	        showBlockCaretContainer: showBlockCaretContainer,
	        hideFakeCaret: hideFakeCaret,
	        destroy: destroy
	      };
	    };
	
	    var isValidPrefixAttrName = function (name) {
	      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
	    };
	    var trimComments = function (text) {
	      var sanitizedText = text;
	      while (/<!--|--!?>/g.test(sanitizedText)) {
	        sanitizedText = sanitizedText.replace(/<!--|--!?>/g, '');
	      }
	      return sanitizedText;
	    };
	    var isInvalidUri = function (settings, uri) {
	      if (settings.allow_html_data_urls) {
	        return false;
	      } else if (/^data:image\//i.test(uri)) {
	        return settings.allow_svg_data_urls === false && /^data:image\/svg\+xml/i.test(uri);
	      } else {
	        return /^data:/i.test(uri);
	      }
	    };
	    var findEndTagIndex = function (schema, html, startIndex) {
	      var count = 1, index, matches, tokenRegExp, shortEndedElements;
	      shortEndedElements = schema.getShortEndedElements();
	      tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
	      tokenRegExp.lastIndex = index = startIndex;
	      while (matches = tokenRegExp.exec(html)) {
	        index = tokenRegExp.lastIndex;
	        if (matches[1] === '/') {
	          count--;
	        } else if (!matches[1]) {
	          if (matches[2] in shortEndedElements) {
	            continue;
	          }
	          count++;
	        }
	        if (count === 0) {
	          break;
	        }
	      }
	      return index;
	    };
	    var checkBogusAttribute = function (regExp, attrString) {
	      var matches = regExp.exec(attrString);
	      if (matches) {
	        var name = matches[1];
	        var value = matches[2];
	        return typeof name === 'string' && name.toLowerCase() === 'data-mce-bogus' ? value : null;
	      } else {
	        return null;
	      }
	    };
	    function SaxParser(settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var noop = function () {
	      };
	      settings = settings || {};
	      if (settings.fix_self_closing !== false) {
	        settings.fix_self_closing = true;
	      }
	      var comment = settings.comment ? settings.comment : noop;
	      var cdata = settings.cdata ? settings.cdata : noop;
	      var text = settings.text ? settings.text : noop;
	      var start = settings.start ? settings.start : noop;
	      var end = settings.end ? settings.end : noop;
	      var pi = settings.pi ? settings.pi : noop;
	      var doctype = settings.doctype ? settings.doctype : noop;
	      var parse = function (html) {
	        var matches, index = 0, value, endRegExp;
	        var stack = [];
	        var attrList, i, textData, name;
	        var isInternalElement, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
	        var validate, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
	        var attributesRequired, attributesDefault, attributesForced, processHtml;
	        var anyAttributesRequired, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
	        var decode = Entities.decode;
	        var fixSelfClosing;
	        var filteredUrlAttrs = Tools.makeMap('src,href,data,background,formaction,poster,xlink:href');
	        var scriptUriRegExp = /((java|vb)script|mhtml):/i;
	        var processEndTag = function (name) {
	          var pos, i;
	          pos = stack.length;
	          while (pos--) {
	            if (stack[pos].name === name) {
	              break;
	            }
	          }
	          if (pos >= 0) {
	            for (i = stack.length - 1; i >= pos; i--) {
	              name = stack[i];
	              if (name.valid) {
	                end(name.name);
	              }
	            }
	            stack.length = pos;
	          }
	        };
	        var parseAttribute = function (match, name, value, val2, val3) {
	          var attrRule, i;
	          var trimRegExp = /[\s\u0000-\u001F]+/g;
	          name = name.toLowerCase();
	          value = name in fillAttrsMap ? name : decode(value || val2 || val3 || '');
	          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
	            attrRule = validAttributesMap[name];
	            if (!attrRule && validAttributePatterns) {
	              i = validAttributePatterns.length;
	              while (i--) {
	                attrRule = validAttributePatterns[i];
	                if (attrRule.pattern.test(name)) {
	                  break;
	                }
	              }
	              if (i === -1) {
	                attrRule = null;
	              }
	            }
	            if (!attrRule) {
	              return;
	            }
	            if (attrRule.validValues && !(value in attrRule.validValues)) {
	              return;
	            }
	          }
	          if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
	            var uri = value.replace(trimRegExp, '');
	            try {
	              uri = decodeURIComponent(uri);
	            } catch (ex) {
	              uri = unescape(uri);
	            }
	            if (scriptUriRegExp.test(uri)) {
	              return;
	            }
	            if (isInvalidUri(settings, uri)) {
	              return;
	            }
	          }
	          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
	            return;
	          }
	          attrList.map[name] = value;
	          attrList.push({
	            name: name,
	            value: value
	          });
	        };
	        tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)--!?>)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:!DOCTYPE([\\w\\W]*?)>)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + ')', 'g');
	        attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	        shortEndedElements = schema.getShortEndedElements();
	        selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
	        fillAttrsMap = schema.getBoolAttrs();
	        validate = settings.validate;
	        removeInternalElements = settings.remove_internals;
	        fixSelfClosing = settings.fix_self_closing;
	        specialElements = schema.getSpecialElements();
	        processHtml = html + '>';
	        while (matches = tokenRegExp.exec(processHtml)) {
	          if (index < matches.index) {
	            text(decode(html.substr(index, matches.index - index)));
	          }
	          if (value = matches[6]) {
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            processEndTag(value);
	          } else if (value = matches[7]) {
	            if (matches.index + matches[0].length > html.length) {
	              text(decode(html.substr(matches.index)));
	              index = matches.index + matches[0].length;
	              continue;
	            }
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            isShortEnded = value in shortEndedElements;
	            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
	              processEndTag(value);
	            }
	            var bogusValue = checkBogusAttribute(attrRegExp, matches[8]);
	            if (bogusValue !== null) {
	              if (bogusValue === 'all') {
	                index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                tokenRegExp.lastIndex = index;
	                continue;
	              }
	              isValidElement = false;
	            }
	            if (!validate || (elementRule = schema.getElementRule(value))) {
	              isValidElement = true;
	              if (validate) {
	                validAttributesMap = elementRule.attributes;
	                validAttributePatterns = elementRule.attributePatterns;
	              }
	              if (attribsValue = matches[8]) {
	                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
	                if (isInternalElement && removeInternalElements) {
	                  isValidElement = false;
	                }
	                attrList = [];
	                attrList.map = {};
	                attribsValue.replace(attrRegExp, parseAttribute);
	              } else {
	                attrList = [];
	                attrList.map = {};
	              }
	              if (validate && !isInternalElement) {
	                attributesRequired = elementRule.attributesRequired;
	                attributesDefault = elementRule.attributesDefault;
	                attributesForced = elementRule.attributesForced;
	                anyAttributesRequired = elementRule.removeEmptyAttrs;
	                if (anyAttributesRequired && !attrList.length) {
	                  isValidElement = false;
	                }
	                if (attributesForced) {
	                  i = attributesForced.length;
	                  while (i--) {
	                    attr = attributesForced[i];
	                    name = attr.name;
	                    attrValue = attr.value;
	                    if (attrValue === '{$uid}') {
	                      attrValue = 'mce_' + idCount++;
	                    }
	                    attrList.map[name] = attrValue;
	                    attrList.push({
	                      name: name,
	                      value: attrValue
	                    });
	                  }
	                }
	                if (attributesDefault) {
	                  i = attributesDefault.length;
	                  while (i--) {
	                    attr = attributesDefault[i];
	                    name = attr.name;
	                    if (!(name in attrList.map)) {
	                      attrValue = attr.value;
	                      if (attrValue === '{$uid}') {
	                        attrValue = 'mce_' + idCount++;
	                      }
	                      attrList.map[name] = attrValue;
	                      attrList.push({
	                        name: name,
	                        value: attrValue
	                      });
	                    }
	                  }
	                }
	                if (attributesRequired) {
	                  i = attributesRequired.length;
	                  while (i--) {
	                    if (attributesRequired[i] in attrList.map) {
	                      break;
	                    }
	                  }
	                  if (i === -1) {
	                    isValidElement = false;
	                  }
	                }
	                if (attr = attrList.map['data-mce-bogus']) {
	                  if (attr === 'all') {
	                    index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                    tokenRegExp.lastIndex = index;
	                    continue;
	                  }
	                  isValidElement = false;
	                }
	              }
	              if (isValidElement) {
	                start(value, attrList, isShortEnded);
	              }
	            } else {
	              isValidElement = false;
	            }
	            if (endRegExp = specialElements[value]) {
	              endRegExp.lastIndex = index = matches.index + matches[0].length;
	              if (matches = endRegExp.exec(html)) {
	                if (isValidElement) {
	                  textData = html.substr(index, matches.index - index);
	                }
	                index = matches.index + matches[0].length;
	              } else {
	                textData = html.substr(index);
	                index = html.length;
	              }
	              if (isValidElement) {
	                if (textData.length > 0) {
	                  text(textData, true);
	                }
	                end(value);
	              }
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	            if (!isShortEnded) {
	              if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
	                stack.push({
	                  name: value,
	                  valid: isValidElement
	                });
	              } else if (isValidElement) {
	                end(value);
	              }
	            }
	          } else if (value = matches[1]) {
	            if (value.charAt(0) === '>') {
	              value = ' ' + value;
	            }
	            if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
	              value = ' ' + value;
	            }
	            comment(value);
	          } else if (value = matches[2]) {
	            cdata(trimComments(value));
	          } else if (value = matches[3]) {
	            doctype(value);
	          } else if (value = matches[4]) {
	            pi(value, matches[5]);
	          }
	          index = matches.index + matches[0].length;
	        }
	        if (index < html.length) {
	          text(decode(html.substr(index)));
	        }
	        for (i = stack.length - 1; i >= 0; i--) {
	          value = stack[i];
	          if (value.valid) {
	            end(value.name);
	          }
	        }
	      };
	      return { parse: parse };
	    }
	    (function (SaxParser) {
	      SaxParser.findEndTag = findEndTagIndex;
	    }(SaxParser || (SaxParser = {})));
	    var SaxParser$1 = SaxParser;
	
	    var trimHtml = function (tempAttrs, html) {
	      var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
	      return html.replace(trimContentRegExp, '');
	    };
	    var trimInternal = function (serializer, html) {
	      var content = html;
	      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
	      var endTagIndex, index, matchLength, matches, shortEndedElements;
	      var schema = serializer.schema;
	      content = trimHtml(serializer.getTempAttrs(), content);
	      shortEndedElements = schema.getShortEndedElements();
	      while (matches = bogusAllRegExp.exec(content)) {
	        index = bogusAllRegExp.lastIndex;
	        matchLength = matches[0].length;
	        if (shortEndedElements[matches[1]]) {
	          endTagIndex = index;
	        } else {
	          endTagIndex = SaxParser$1.findEndTag(schema, content, index);
	        }
	        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
	        bogusAllRegExp.lastIndex = index - matchLength;
	      }
	      return Zwsp.trim(content);
	    };
	    var trimExternal = trimInternal;
	    var TrimHtml = {
	      trimExternal: trimExternal,
	      trimInternal: trimInternal
	    };
	
	    var KEEP = 0, INSERT = 1, DELETE = 2;
	    var diff = function (left, right) {
	      var size = left.length + right.length + 2;
	      var vDown = new Array(size);
	      var vUp = new Array(size);
	      var snake = function (start, end, diag) {
	        return {
	          start: start,
	          end: end,
	          diag: diag
	        };
	      };
	      var buildScript = function (start1, end1, start2, end2, script) {
	        var middle = getMiddleSnake(start1, end1, start2, end2);
	        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
	          var i = start1;
	          var j = start2;
	          while (i < end1 || j < end2) {
	            if (i < end1 && j < end2 && left[i] === right[j]) {
	              script.push([
	                KEEP,
	                left[i]
	              ]);
	              ++i;
	              ++j;
	            } else {
	              if (end1 - start1 > end2 - start2) {
	                script.push([
	                  DELETE,
	                  left[i]
	                ]);
	                ++i;
	              } else {
	                script.push([
	                  INSERT,
	                  right[j]
	                ]);
	                ++j;
	              }
	            }
	          }
	        } else {
	          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
	          for (var i2 = middle.start; i2 < middle.end; ++i2) {
	            script.push([
	              KEEP,
	              left[i2]
	            ]);
	          }
	          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
	        }
	      };
	      var buildSnake = function (start, diag, end1, end2) {
	        var end = start;
	        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
	          ++end;
	        }
	        return snake(start, end, diag);
	      };
	      var getMiddleSnake = function (start1, end1, start2, end2) {
	        var m = end1 - start1;
	        var n = end2 - start2;
	        if (m === 0 || n === 0) {
	          return null;
	        }
	        var delta = m - n;
	        var sum = n + m;
	        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
	        vDown[1 + offset] = start1;
	        vUp[1 + offset] = end1 + 1;
	        var d, k, i, x, y;
	        for (d = 0; d <= offset; ++d) {
	          for (k = -d; k <= d; k += 2) {
	            i = k + offset;
	            if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
	              vDown[i] = vDown[i + 1];
	            } else {
	              vDown[i] = vDown[i - 1] + 1;
	            }
	            x = vDown[i];
	            y = x - start1 + start2 - k;
	            while (x < end1 && y < end2 && left[x] === right[y]) {
	              vDown[i] = ++x;
	              ++y;
	            }
	            if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
	              if (vUp[i - delta] <= vDown[i]) {
	                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	          for (k = delta - d; k <= delta + d; k += 2) {
	            i = k + offset - delta;
	            if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
	              vUp[i] = vUp[i + 1] - 1;
	            } else {
	              vUp[i] = vUp[i - 1];
	            }
	            x = vUp[i] - 1;
	            y = x - start1 + start2 - k;
	            while (x >= start1 && y >= start2 && left[x] === right[y]) {
	              vUp[i] = x--;
	              y--;
	            }
	            if (delta % 2 === 0 && -d <= k && k <= d) {
	              if (vUp[i] <= vDown[i + delta]) {
	                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	        }
	      };
	      var script = [];
	      buildScript(0, left.length, 0, right.length, script);
	      return script;
	    };
	    var Diff = {
	      KEEP: KEEP,
	      DELETE: DELETE,
	      INSERT: INSERT,
	      diff: diff
	    };
	
	    var getOuterHtml = function (elm) {
	      if (NodeType.isElement(elm)) {
	        return elm.outerHTML;
	      } else if (NodeType.isText(elm)) {
	        return Entities.encodeRaw(elm.data, false);
	      } else if (NodeType.isComment(elm)) {
	        return '<!--' + elm.data + '-->';
	      }
	      return '';
	    };
	    var createFragment$1 = function (html) {
	      var frag, node, container;
	      container = domGlobals.document.createElement('div');
	      frag = domGlobals.document.createDocumentFragment();
	      if (html) {
	        container.innerHTML = html;
	      }
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var insertAt = function (elm, html, index) {
	      var fragment = createFragment$1(html);
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.insertBefore(fragment, target);
	      } else {
	        elm.appendChild(fragment);
	      }
	    };
	    var removeAt = function (elm, index) {
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.removeChild(target);
	      }
	    };
	    var applyDiff = function (diff, elm) {
	      var index = 0;
	      each(diff, function (action) {
	        if (action[0] === Diff.KEEP) {
	          index++;
	        } else if (action[0] === Diff.INSERT) {
	          insertAt(elm, action[1], index);
	          index++;
	        } else if (action[0] === Diff.DELETE) {
	          removeAt(elm, index);
	        }
	      });
	    };
	    var read$3 = function (elm) {
	      return filter(map(from$1(elm.childNodes), getOuterHtml), function (item) {
	        return item.length > 0;
	      });
	    };
	    var write = function (fragments, elm) {
	      var currentFragments = map(from$1(elm.childNodes), getOuterHtml);
	      applyDiff(Diff.diff(currentFragments, fragments), elm);
	      return elm;
	    };
	    var Fragments = {
	      read: read$3,
	      write: write
	    };
	
	    var undoLevelDocument = Cell(Option.none());
	    var lazyTempDocument = function () {
	      return undoLevelDocument.get().getOrThunk(function () {
	        var doc = domGlobals.document.implementation.createHTMLDocument('undo');
	        undoLevelDocument.set(Option.some(doc));
	        return doc;
	      });
	    };
	    var hasIframes = function (html) {
	      return html.indexOf('</iframe>') !== -1;
	    };
	    var createFragmentedLevel = function (fragments) {
	      return {
	        type: 'fragmented',
	        fragments: fragments,
	        content: '',
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createCompleteLevel = function (content) {
	      return {
	        type: 'complete',
	        fragments: null,
	        content: content,
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createFromEditor = function (editor) {
	      var fragments, content, trimmedFragments;
	      fragments = Fragments.read(editor.getBody());
	      trimmedFragments = bind(fragments, function (html) {
	        var trimmed = TrimHtml.trimInternal(editor.serializer, html);
	        return trimmed.length > 0 ? [trimmed] : [];
	      });
	      content = trimmedFragments.join('');
	      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
	    };
	    var applyToEditor = function (editor, level, before) {
	      if (level.type === 'fragmented') {
	        Fragments.write(level.fragments, editor.getBody());
	      } else {
	        editor.setContent(level.content, { format: 'raw' });
	      }
	      editor.selection.moveToBookmark(before ? level.beforeBookmark : level.bookmark);
	    };
	    var getLevelContent = function (level) {
	      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
	    };
	    var getCleanLevelContent = function (level) {
	      var elm = Element.fromTag('body', lazyTempDocument());
	      set$1(elm, getLevelContent(level));
	      each(descendants$1(elm, '*[data-mce-bogus]'), unwrap);
	      return get$3(elm);
	    };
	    var hasEqualContent = function (level1, level2) {
	      return getLevelContent(level1) === getLevelContent(level2);
	    };
	    var hasEqualCleanedContent = function (level1, level2) {
	      return getCleanLevelContent(level1) === getCleanLevelContent(level2);
	    };
	    var isEq$4 = function (level1, level2) {
	      if (!level1 || !level2) {
	        return false;
	      } else if (hasEqualContent(level1, level2)) {
	        return true;
	      } else {
	        return hasEqualCleanedContent(level1, level2);
	      }
	    };
	    var Levels = {
	      createFragmentedLevel: createFragmentedLevel,
	      createCompleteLevel: createCompleteLevel,
	      createFromEditor: createFromEditor,
	      applyToEditor: applyToEditor,
	      isEq: isEq$4
	    };
	
	    function UndoManager (editor) {
	      var self = this, index = 0, data = [], beforeBookmark, isFirstTypedCharacter, locks = 0;
	      var isUnlocked = function () {
	        return locks === 0;
	      };
	      var setTyping = function (typing) {
	        if (isUnlocked()) {
	          self.typing = typing;
	        }
	      };
	      var setDirty = function (state) {
	        editor.setDirty(state);
	      };
	      var addNonTypingUndoLevel = function (e) {
	        setTyping(false);
	        self.add({}, e);
	      };
	      var endTyping = function () {
	        if (self.typing) {
	          setTyping(false);
	          self.add();
	        }
	      };
	      editor.on('init', function () {
	        self.add();
	      });
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command;
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          endTyping();
	          self.beforeChange();
	        }
	      });
	      editor.on('ExecCommand', function (e) {
	        var cmd = e.command;
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('ObjectResizeStart Cut', function () {
	        self.beforeChange();
	      });
	      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
	      editor.on('DragEnd', addNonTypingUndoLevel);
	      editor.on('KeyUp', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
	          addNonTypingUndoLevel();
	          editor.nodeChanged();
	        }
	        if (keyCode === 46 || keyCode === 8) {
	          editor.nodeChanged();
	        }
	        if (isFirstTypedCharacter && self.typing && Levels.isEq(Levels.createFromEditor(editor), data[0]) === false) {
	          if (editor.isDirty() === false) {
	            setDirty(true);
	            editor.fire('change', {
	              level: data[0],
	              lastLevel: null
	            });
	          }
	          editor.fire('TypingUndo');
	          isFirstTypedCharacter = false;
	          editor.nodeChanged();
	        }
	      });
	      editor.on('KeyDown', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
	          if (self.typing) {
	            addNonTypingUndoLevel(e);
	          }
	          return;
	        }
	        var modKey = e.ctrlKey && !e.altKey || e.metaKey;
	        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !self.typing && !modKey) {
	          self.beforeChange();
	          setTyping(true);
	          self.add({}, e);
	          isFirstTypedCharacter = true;
	        }
	      });
	      editor.on('MouseDown', function (e) {
	        if (self.typing) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      var isInsertReplacementText = function (event) {
	        return event.inputType === 'insertReplacementText';
	      };
	      var isInsertTextDataNull = function (event) {
	        return event.inputType === 'insertText' && event.data === null;
	      };
	      editor.on('input', function (e) {
	        if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e))) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.addShortcut('meta+z', '', 'Undo');
	      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
	        if (!e.isDefaultPrevented()) {
	          editor.nodeChanged();
	        }
	      });
	      self = {
	        data: data,
	        typing: false,
	        beforeChange: function () {
	          if (isUnlocked()) {
	            beforeBookmark = GetBookmark.getUndoBookmark(editor.selection);
	          }
	        },
	        add: function (level, event) {
	          var i;
	          var settings = editor.settings;
	          var lastLevel, currentLevel;
	          currentLevel = Levels.createFromEditor(editor);
	          level = level || {};
	          level = Tools.extend(level, currentLevel);
	          if (isUnlocked() === false || editor.removed) {
	            return null;
	          }
	          lastLevel = data[index];
	          if (editor.fire('BeforeAddUndo', {
	              level: level,
	              lastLevel: lastLevel,
	              originalEvent: event
	            }).isDefaultPrevented()) {
	            return null;
	          }
	          if (lastLevel && Levels.isEq(lastLevel, level)) {
	            return null;
	          }
	          if (data[index]) {
	            data[index].beforeBookmark = beforeBookmark;
	          }
	          if (settings.custom_undo_redo_levels) {
	            if (data.length > settings.custom_undo_redo_levels) {
	              for (i = 0; i < data.length - 1; i++) {
	                data[i] = data[i + 1];
	              }
	              data.length--;
	              index = data.length;
	            }
	          }
	          level.bookmark = GetBookmark.getUndoBookmark(editor.selection);
	          if (index < data.length - 1) {
	            data.length = index + 1;
	          }
	          data.push(level);
	          index = data.length - 1;
	          var args = {
	            level: level,
	            lastLevel: lastLevel,
	            originalEvent: event
	          };
	          editor.fire('AddUndo', args);
	          if (index > 0) {
	            setDirty(true);
	            editor.fire('change', args);
	          }
	          return level;
	        },
	        undo: function () {
	          var level;
	          if (self.typing) {
	            self.add();
	            self.typing = false;
	            setTyping(false);
	          }
	          if (index > 0) {
	            level = data[--index];
	            Levels.applyToEditor(editor, level, true);
	            setDirty(true);
	            editor.fire('undo', { level: level });
	          }
	          return level;
	        },
	        redo: function () {
	          var level;
	          if (index < data.length - 1) {
	            level = data[++index];
	            Levels.applyToEditor(editor, level, false);
	            setDirty(true);
	            editor.fire('redo', { level: level });
	          }
	          return level;
	        },
	        clear: function () {
	          data = [];
	          index = 0;
	          self.typing = false;
	          self.data = data;
	          editor.fire('ClearUndos');
	        },
	        hasUndo: function () {
	          return index > 0 || self.typing && data[0] && !Levels.isEq(Levels.createFromEditor(editor), data[0]);
	        },
	        hasRedo: function () {
	          return index < data.length - 1 && !self.typing;
	        },
	        transact: function (callback) {
	          endTyping();
	          self.beforeChange();
	          self.ignore(callback);
	          return self.add();
	        },
	        ignore: function (callback) {
	          try {
	            locks++;
	            callback();
	          } finally {
	            locks--;
	          }
	        },
	        extra: function (callback1, callback2) {
	          var lastLevel, bookmark;
	          if (self.transact(callback1)) {
	            bookmark = data[index].bookmark;
	            lastLevel = data[index - 1];
	            Levels.applyToEditor(editor, lastLevel, true);
	            if (self.transact(callback2)) {
	              data[index - 1].beforeBookmark = bookmark;
	            }
	          }
	        }
	      };
	      return self;
	    }
	
	    var postProcessHooks = {}, filter$2 = ArrUtils.filter, each$c = ArrUtils.each;
	    var addPostProcessHook = function (name, hook) {
	      var hooks = postProcessHooks[name];
	      if (!hooks) {
	        postProcessHooks[name] = hooks = [];
	      }
	      postProcessHooks[name].push(hook);
	    };
	    var postProcess = function (name, editor) {
	      each$c(postProcessHooks[name], function (hook) {
	        hook(editor);
	      });
	    };
	    addPostProcessHook('pre', function (editor) {
	      var rng = editor.selection.getRng();
	      var isPre, blocks;
	      var hasPreSibling = function (pre) {
	        return isPre(pre.previousSibling) && ArrUtils.indexOf(blocks, pre.previousSibling) !== -1;
	      };
	      var joinPre = function (pre1, pre2) {
	        DomQuery(pre2).remove();
	        DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
	      };
	      isPre = NodeType.matchNodeNames('pre');
	      if (!rng.collapsed) {
	        blocks = editor.selection.getSelectedBlocks();
	        each$c(filter$2(filter$2(blocks, isPre), hasPreSibling), function (pre) {
	          joinPre(pre.previousSibling, pre);
	        });
	      }
	    });
	    var Hooks = { postProcess: postProcess };
	
	    var MCE_ATTR_RE = /^(src|href|style)$/;
	    var each$d = Tools.each;
	    var isEq$5 = FormatUtils.isEq;
	    var isTableCell$4 = function (node) {
	      return /^(TH|TD)$/.test(node.nodeName);
	    };
	    var isChildOfInlineParent = function (dom, node, parent) {
	      return dom.isChildOf(node, parent) && node !== parent && !dom.isBlock(parent);
	    };
	    var getContainer = function (ed, rng, start) {
	      var container, offset, lastIdx;
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (NodeType.isElement(container)) {
	        lastIdx = container.childNodes.length - 1;
	        if (!start && offset) {
	          offset--;
	        }
	        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
	      }
	      if (NodeType.isText(container) && start && offset >= container.nodeValue.length) {
	        container = new TreeWalker(container, ed.getBody()).next() || container;
	      }
	      if (NodeType.isText(container) && !start && offset === 0) {
	        container = new TreeWalker(container, ed.getBody()).prev() || container;
	      }
	      return container;
	    };
	    var wrap$2 = function (dom, node, name, attrs) {
	      var wrapper = dom.create(name, attrs);
	      node.parentNode.insertBefore(wrapper, node);
	      wrapper.appendChild(node);
	      return wrapper;
	    };
	    var wrapWithSiblings = function (dom, node, next, name, attrs) {
	      var start = Element.fromDom(node);
	      var wrapper = Element.fromDom(dom.create(name, attrs));
	      var siblings = next ? nextSiblings(start) : prevSiblings(start);
	      append$1(wrapper, siblings);
	      if (next) {
	        before(start, wrapper);
	        prepend(wrapper, start);
	      } else {
	        after(start, wrapper);
	        append(wrapper, start);
	      }
	      return wrapper.dom();
	    };
	    var matchName$1 = function (dom, node, format) {
	      if (isEq$5(node, format.inline)) {
	        return true;
	      }
	      if (isEq$5(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return NodeType.isElement(node) && dom.is(node, format.selector);
	      }
	    };
	    var isColorFormatAndAnchor = function (node, format) {
	      return format.links && node.tagName === 'A';
	    };
	    var find$3 = function (dom, node, next, inc) {
	      node = FormatUtils.getNonWhiteSpaceSibling(node, next, inc);
	      return !node || (node.nodeName === 'BR' || dom.isBlock(node));
	    };
	    var removeNode$1 = function (ed, node, format) {
	      var parentNode = node.parentNode;
	      var rootBlockElm;
	      var dom = ed.dom, forcedRootBlock = ed.settings.forced_root_block;
	      if (format.block) {
	        if (!forcedRootBlock) {
	          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
	            if (!find$3(dom, node, false) && !find$3(dom, node.firstChild, true, 1)) {
	              node.insertBefore(dom.create('br'), node.firstChild);
	            }
	            if (!find$3(dom, node, true) && !find$3(dom, node.lastChild, false, 1)) {
	              node.appendChild(dom.create('br'));
	            }
	          }
	        } else {
	          if (parentNode === dom.getRoot()) {
	            if (!format.list_block || !isEq$5(node, format.list_block)) {
	              each$d(Tools.grep(node.childNodes), function (node) {
	                if (FormatUtils.isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
	                  if (!rootBlockElm) {
	                    rootBlockElm = wrap$2(dom, node, forcedRootBlock);
	                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
	                  } else {
	                    rootBlockElm.appendChild(node);
	                  }
	                } else {
	                  rootBlockElm = 0;
	                }
	              });
	            }
	          }
	        }
	      }
	      if (format.selector && format.inline && !isEq$5(format.inline, node)) {
	        return;
	      }
	      dom.remove(node, 1);
	    };
	    var removeFormat = function (ed, format, vars, node, compareNode) {
	      var i, attrs, stylesModified;
	      var dom = ed.dom;
	      if (!matchName$1(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
	        return false;
	      }
	      if (format.remove !== 'all') {
	        each$d(format.styles, function (value, name) {
	          value = FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(value, vars), name);
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	          if (format.remove_similar || (!compareNode || isEq$5(FormatUtils.getStyle(dom, compareNode, name), value))) {
	            dom.setStyle(node, name, '');
	          }
	          stylesModified = 1;
	        });
	        if (stylesModified && dom.getAttrib(node, 'style') === '') {
	          node.removeAttribute('style');
	          node.removeAttribute('data-mce-style');
	        }
	        each$d(format.attributes, function (value, name) {
	          var valueOut;
	          value = FormatUtils.replaceVars(value, vars);
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	          if (!compareNode || isEq$5(dom.getAttrib(compareNode, name), value)) {
	            if (name === 'class') {
	              value = dom.getAttrib(node, name);
	              if (value) {
	                valueOut = '';
	                each$d(value.split(/\s+/), function (cls) {
	                  if (/mce\-\w+/.test(cls)) {
	                    valueOut += (valueOut ? ' ' : '') + cls;
	                  }
	                });
	                if (valueOut) {
	                  dom.setAttrib(node, name, valueOut);
	                  return;
	                }
	              }
	            }
	            if (name === 'class') {
	              node.removeAttribute('className');
	            }
	            if (MCE_ATTR_RE.test(name)) {
	              node.removeAttribute('data-mce-' + name);
	            }
	            node.removeAttribute(name);
	          }
	        });
	        each$d(format.classes, function (value) {
	          value = FormatUtils.replaceVars(value, vars);
	          if (!compareNode || dom.hasClass(compareNode, value)) {
	            dom.removeClass(node, value);
	          }
	        });
	        attrs = dom.getAttribs(node);
	        for (i = 0; i < attrs.length; i++) {
	          var attrName = attrs[i].nodeName;
	          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
	            return false;
	          }
	        }
	      }
	      if (format.remove !== 'none') {
	        removeNode$1(ed, node, format);
	        return true;
	      }
	    };
	    var findFormatRoot = function (editor, container, name, vars, similar) {
	      var formatRoot;
	      each$d(FormatUtils.getParents(editor.dom, container.parentNode).reverse(), function (parent) {
	        var format;
	        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
	          format = MatchFormat.matchNode(editor, parent, name, vars, similar);
	          if (format && format.split !== false) {
	            formatRoot = parent;
	          }
	        }
	      });
	      return formatRoot;
	    };
	    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
	      var parent, clone, lastClone, firstClone, i, formatRootParent;
	      var dom = editor.dom;
	      if (formatRoot) {
	        formatRootParent = formatRoot.parentNode;
	        for (parent = container.parentNode; parent && parent !== formatRootParent; parent = parent.parentNode) {
	          clone = dom.clone(parent, false);
	          for (i = 0; i < formatList.length; i++) {
	            if (removeFormat(editor, formatList[i], vars, clone, clone)) {
	              clone = 0;
	              break;
	            }
	          }
	          if (clone) {
	            if (lastClone) {
	              clone.appendChild(lastClone);
	            }
	            if (!firstClone) {
	              firstClone = clone;
	            }
	            lastClone = clone;
	          }
	        }
	        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
	          container = dom.split(formatRoot, container);
	        }
	        if (lastClone) {
	          target.parentNode.insertBefore(lastClone, target);
	          firstClone.appendChild(target);
	        }
	      }
	      return container;
	    };
	    var remove$6 = function (ed, name, vars, node, similar) {
	      var formatList = ed.formatter.get(name), format = formatList[0];
	      var bookmark, rng, contentEditable = true;
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var splitToFormatRoot = function (container) {
	        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
	        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
	      };
	      var isRemoveBookmarkNode = function (node) {
	        return Bookmarks.isBookmarkNode(node) && NodeType.isElement(node) && (node.id === '_start' || node.id === '_end');
	      };
	      var process = function (node) {
	        var children, i, l, lastContentEditable, hasContentEditableState;
	        if (NodeType.isElement(node) && dom.getContentEditable(node)) {
	          lastContentEditable = contentEditable;
	          contentEditable = dom.getContentEditable(node) === 'true';
	          hasContentEditableState = true;
	        }
	        children = Tools.grep(node.childNodes);
	        if (contentEditable && !hasContentEditableState) {
	          for (i = 0, l = formatList.length; i < l; i++) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        if (format.deep) {
	          if (children.length) {
	            for (i = 0, l = children.length; i < l; i++) {
	              process(children[i]);
	            }
	            if (hasContentEditableState) {
	              contentEditable = lastContentEditable;
	            }
	          }
	        }
	      };
	      var unwrap = function (start) {
	        var node = dom.get(start ? '_start' : '_end');
	        var out = node[start ? 'firstChild' : 'lastChild'];
	        if (isRemoveBookmarkNode(out)) {
	          out = out[start ? 'firstChild' : 'lastChild'];
	        }
	        if (NodeType.isText(out) && out.data.length === 0) {
	          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
	        }
	        dom.remove(node, true);
	        return out;
	      };
	      var removeRngStyle = function (rng) {
	        var startContainer, endContainer;
	        var commonAncestorContainer = rng.commonAncestorContainer;
	        rng = ExpandRange.expandRng(ed, rng, formatList, true);
	        if (format.split) {
	          rng = SplitRange.split(rng);
	          startContainer = getContainer(ed, rng, true);
	          endContainer = getContainer(ed, rng);
	          if (startContainer !== endContainer) {
	            if (/^(TR|TH|TD)$/.test(startContainer.nodeName) && startContainer.firstChild) {
	              if (startContainer.nodeName === 'TR') {
	                startContainer = startContainer.firstChild.firstChild || startContainer;
	              } else {
	                startContainer = startContainer.firstChild || startContainer;
	              }
	            }
	            if (commonAncestorContainer && /^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName) && isTableCell$4(endContainer) && endContainer.firstChild) {
	              endContainer = endContainer.firstChild || endContainer;
	            }
	            if (isChildOfInlineParent(dom, startContainer, endContainer)) {
	              var marker = Option.from(startContainer.firstChild).getOr(startContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, true, 'span', {
	                'id': '_start',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(true);
	              return;
	            }
	            if (isChildOfInlineParent(dom, endContainer, startContainer)) {
	              var marker = Option.from(endContainer.lastChild).getOr(endContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, false, 'span', {
	                'id': '_end',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(false);
	              return;
	            }
	            startContainer = wrap$2(dom, startContainer, 'span', {
	              'id': '_start',
	              'data-mce-type': 'bookmark'
	            });
	            endContainer = wrap$2(dom, endContainer, 'span', {
	              'id': '_end',
	              'data-mce-type': 'bookmark'
	            });
	            splitToFormatRoot(startContainer);
	            splitToFormatRoot(endContainer);
	            startContainer = unwrap(true);
	            endContainer = unwrap();
	          } else {
	            startContainer = endContainer = splitToFormatRoot(startContainer);
	          }
	          rng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
	          rng.startOffset = dom.nodeIndex(startContainer);
	          rng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
	          rng.endOffset = dom.nodeIndex(endContainer) + 1;
	        }
	        RangeWalk.walk(dom, rng, function (nodes) {
	          each$d(nodes, function (node) {
	            process(node);
	            if (NodeType.isElement(node) && ed.dom.getStyle(node, 'text-decoration') === 'underline' && node.parentNode && FormatUtils.getTextDecoration(dom, node.parentNode) === 'underline') {
	              removeFormat(ed, {
	                deep: false,
	                exact: true,
	                inline: 'span',
	                styles: { textDecoration: 'underline' }
	              }, null, node);
	            }
	          });
	        });
	      };
	      if (node) {
	        if (node.nodeType) {
	          rng = dom.createRng();
	          rng.setStartBefore(node);
	          rng.setEndAfter(node);
	          removeRngStyle(rng);
	        } else {
	          removeRngStyle(node);
	        }
	        return;
	      }
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        return;
	      }
	      if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	        bookmark = GetBookmark.getPersistentBookmark(ed.selection, true);
	        removeRngStyle(selection.getRng());
	        selection.moveToBookmark(bookmark);
	        if (format.inline && MatchFormat.match(ed, name, vars, selection.getStart())) {
	          FormatUtils.moveStart(dom, selection, selection.getRng());
	        }
	        ed.nodeChanged();
	      } else {
	        removeCaretFormat(ed, name, vars, similar);
	      }
	    };
	    var RemoveFormat = {
	      removeFormat: removeFormat,
	      remove: remove$6
	    };
	
	    var each$e = Tools.each;
	    var isElementNode = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !isCaretNode(node) && !NodeType.isBogus(node);
	    };
	    var findElementSibling = function (node, siblingName) {
	      var sibling;
	      for (sibling = node; sibling; sibling = sibling[siblingName]) {
	        if (sibling.nodeType === 3 && sibling.nodeValue.length !== 0) {
	          return node;
	        }
	        if (sibling.nodeType === 1 && !Bookmarks.isBookmarkNode(sibling)) {
	          return sibling;
	        }
	      }
	      return node;
	    };
	    var mergeSiblingsNodes = function (dom, prev, next) {
	      var sibling, tmpSibling;
	      var elementUtils = new ElementUtils(dom);
	      if (prev && next) {
	        prev = findElementSibling(prev, 'previousSibling');
	        next = findElementSibling(next, 'nextSibling');
	        if (elementUtils.compare(prev, next)) {
	          for (sibling = prev.nextSibling; sibling && sibling !== next;) {
	            tmpSibling = sibling;
	            sibling = sibling.nextSibling;
	            prev.appendChild(tmpSibling);
	          }
	          dom.remove(next);
	          Tools.each(Tools.grep(next.childNodes), function (node) {
	            prev.appendChild(node);
	          });
	          return prev;
	        }
	      }
	      return next;
	    };
	    var processChildElements = function (node, filter, process) {
	      each$e(node.childNodes, function (node) {
	        if (isElementNode(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	    var hasStyle = function (dom, name) {
	      return curry(function (name, node) {
	        return !!(node && FormatUtils.getStyle(dom, node, name));
	      }, name);
	    };
	    var applyStyle = function (dom, name, value) {
	      return curry(function (name, value, node) {
	        dom.setStyle(node, name, value);
	        if (node.getAttribute('style') === '') {
	          node.removeAttribute('style');
	        }
	        unwrapEmptySpan(dom, node);
	      }, name, value);
	    };
	    var unwrapEmptySpan = function (dom, node) {
	      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
	        dom.remove(node, true);
	      }
	    };
	    var processUnderlineAndColor = function (dom, node) {
	      var textDecoration;
	      if (node.nodeType === 1 && node.parentNode && node.parentNode.nodeType === 1) {
	        textDecoration = FormatUtils.getTextDecoration(dom, node.parentNode);
	        if (dom.getStyle(node, 'color') && textDecoration) {
	          dom.setStyle(node, 'text-decoration', textDecoration);
	        } else if (dom.getStyle(node, 'text-decoration') === textDecoration) {
	          dom.setStyle(node, 'text-decoration', null);
	        }
	      }
	    };
	    var mergeUnderlineAndColor = function (dom, format, vars, node) {
	      if (format.styles.color || format.styles.textDecoration) {
	        Tools.walk(node, curry(processUnderlineAndColor, dom), 'childNodes');
	        processUnderlineAndColor(dom, node);
	      }
	    };
	    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
	      if (format.styles && format.styles.backgroundColor) {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', FormatUtils.replaceVars(format.styles.backgroundColor, vars)));
	      }
	    };
	    var mergeSubSup = function (dom, format, vars, node) {
	      if (format.inline === 'sub' || format.inline === 'sup') {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
	        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
	      }
	    };
	    var mergeSiblings = function (dom, format, vars, node) {
	      if (node && format.merge_siblings !== false) {
	        node = mergeSiblingsNodes(dom, FormatUtils.getNonWhiteSpaceSibling(node), node);
	        node = mergeSiblingsNodes(dom, node, FormatUtils.getNonWhiteSpaceSibling(node, true));
	      }
	    };
	    var clearChildStyles = function (dom, format, node) {
	      if (format.clear_child_styles) {
	        var selector = format.links ? '*:not(a)' : '*';
	        each$e(dom.select(selector, node), function (node) {
	          if (isElementNode(node)) {
	            each$e(format.styles, function (value, name) {
	              dom.setStyle(node, name, '');
	            });
	          }
	        });
	      }
	    };
	    var mergeWithChildren = function (editor, formatList, vars, node) {
	      each$e(formatList, function (format) {
	        each$e(editor.dom.select(format.inline, node), function (child) {
	          if (!isElementNode(child)) {
	            return;
	          }
	          RemoveFormat.removeFormat(editor, format, vars, child, format.exact ? child : null);
	        });
	        clearChildStyles(editor.dom, format, node);
	      });
	    };
	    var mergeWithParents = function (editor, format, name, vars, node) {
	      if (MatchFormat.matchNode(editor, node.parentNode, name, vars)) {
	        if (RemoveFormat.removeFormat(editor, format, vars, node)) {
	          return;
	        }
	      }
	      if (format.merge_with_parents) {
	        editor.dom.getParent(node.parentNode, function (parent) {
	          if (MatchFormat.matchNode(editor, parent, name, vars)) {
	            RemoveFormat.removeFormat(editor, format, vars, node);
	            return true;
	          }
	        });
	      }
	    };
	    var MergeFormats = {
	      mergeWithChildren: mergeWithChildren,
	      mergeUnderlineAndColor: mergeUnderlineAndColor,
	      mergeBackgroundColorAndFontSize: mergeBackgroundColorAndFontSize,
	      mergeSubSup: mergeSubSup,
	      mergeSiblings: mergeSiblings,
	      mergeWithParents: mergeWithParents
	    };
	
	    var each$f = Tools.each;
	    var isElementNode$1 = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !isCaretNode(node) && !NodeType.isBogus(node);
	    };
	    var applyFormat = function (ed, name, vars, node) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var bookmark, rng;
	      var isCollapsed = !node && ed.selection.isCollapsed();
	      var dom = ed.dom, selection = ed.selection;
	      var setElementFormat = function (elm, fmt) {
	        fmt = fmt || format;
	        if (elm) {
	          if (fmt.onformat) {
	            fmt.onformat(elm, fmt, vars, node);
	          }
	          each$f(fmt.styles, function (value, name) {
	            dom.setStyle(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	          if (fmt.styles) {
	            var styleVal = dom.getAttrib(elm, 'style');
	            if (styleVal) {
	              elm.setAttribute('data-mce-style', styleVal);
	            }
	          }
	          each$f(fmt.attributes, function (value, name) {
	            dom.setAttrib(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	          each$f(fmt.classes, function (value) {
	            value = FormatUtils.replaceVars(value, vars);
	            if (!dom.hasClass(elm, value)) {
	              dom.addClass(elm, value);
	            }
	          });
	        }
	      };
	      var applyNodeStyle = function (formatList, node) {
	        var found = false;
	        if (!format.selector) {
	          return false;
	        }
	        each$f(formatList, function (format) {
	          if ('collapsed' in format && format.collapsed !== isCollapsed) {
	            return;
	          }
	          if (dom.is(node, format.selector) && !isCaretNode(node)) {
	            setElementFormat(node, format);
	            found = true;
	            return false;
	          }
	        });
	        return found;
	      };
	      var applyRngStyle = function (dom, rng, bookmark, nodeSpecific) {
	        var newWrappers = [];
	        var wrapName, wrapElm, contentEditable = true;
	        wrapName = format.inline || format.block;
	        wrapElm = dom.create(wrapName);
	        setElementFormat(wrapElm);
	        RangeWalk.walk(dom, rng, function (nodes) {
	          var currentWrapElm;
	          var process = function (node) {
	            var nodeName, parentName, hasContentEditableState, lastContentEditable;
	            lastContentEditable = contentEditable;
	            nodeName = node.nodeName.toLowerCase();
	            parentName = node.parentNode.nodeName.toLowerCase();
	            if (node.nodeType === 1 && dom.getContentEditable(node)) {
	              lastContentEditable = contentEditable;
	              contentEditable = dom.getContentEditable(node) === 'true';
	              hasContentEditableState = true;
	            }
	            if (FormatUtils.isEq(nodeName, 'br')) {
	              currentWrapElm = 0;
	              if (format.block) {
	                dom.remove(node);
	              }
	              return;
	            }
	            if (format.wrapper && MatchFormat.matchNode(ed, node, name, vars)) {
	              currentWrapElm = 0;
	              return;
	            }
	            if (contentEditable && !hasContentEditableState && format.block && !format.wrapper && FormatUtils.isTextBlock(ed, nodeName) && FormatUtils.isValid(ed, parentName, wrapName)) {
	              node = dom.rename(node, wrapName);
	              setElementFormat(node);
	              newWrappers.push(node);
	              currentWrapElm = 0;
	              return;
	            }
	            if (format.selector) {
	              var found = applyNodeStyle(formatList, node);
	              if (!format.inline || found) {
	                currentWrapElm = 0;
	                return;
	              }
	            }
	            if (contentEditable && !hasContentEditableState && FormatUtils.isValid(ed, wrapName, nodeName) && FormatUtils.isValid(ed, parentName, wrapName) && !(!nodeSpecific && node.nodeType === 3 && node.nodeValue.length === 1 && node.nodeValue.charCodeAt(0) === 65279) && !isCaretNode(node) && (!format.inline || !dom.isBlock(node))) {
	              if (!currentWrapElm) {
	                currentWrapElm = dom.clone(wrapElm, false);
	                node.parentNode.insertBefore(currentWrapElm, node);
	                newWrappers.push(currentWrapElm);
	              }
	              currentWrapElm.appendChild(node);
	            } else {
	              currentWrapElm = 0;
	              each$f(Tools.grep(node.childNodes), process);
	              if (hasContentEditableState) {
	                contentEditable = lastContentEditable;
	              }
	              currentWrapElm = 0;
	            }
	          };
	          each$f(nodes, process);
	        });
	        if (format.links === true) {
	          each$f(newWrappers, function (node) {
	            var process = function (node) {
	              if (node.nodeName === 'A') {
	                setElementFormat(node, format);
	              }
	              each$f(Tools.grep(node.childNodes), process);
	            };
	            process(node);
	          });
	        }
	        each$f(newWrappers, function (node) {
	          var childCount;
	          var getChildCount = function (node) {
	            var count = 0;
	            each$f(node.childNodes, function (node) {
	              if (!FormatUtils.isWhiteSpaceNode(node) && !Bookmarks.isBookmarkNode(node)) {
	                count++;
	              }
	            });
	            return count;
	          };
	          var getChildElementNode = function (root) {
	            var child = false;
	            each$f(root.childNodes, function (node) {
	              if (isElementNode$1(node)) {
	                child = node;
	                return false;
	              }
	            });
	            return child;
	          };
	          var mergeStyles = function (node) {
	            var child, clone;
	            child = getChildElementNode(node);
	            if (child && !Bookmarks.isBookmarkNode(child) && MatchFormat.matchName(dom, child, format)) {
	              clone = dom.clone(child, false);
	              setElementFormat(clone);
	              dom.replace(clone, node, true);
	              dom.remove(child, 1);
	            }
	            return clone || node;
	          };
	          childCount = getChildCount(node);
	          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
	            dom.remove(node, 1);
	            return;
	          }
	          if (format.inline || format.wrapper) {
	            if (!format.exact && childCount === 1) {
	              node = mergeStyles(node);
	            }
	            MergeFormats.mergeWithChildren(ed, formatList, vars, node);
	            MergeFormats.mergeWithParents(ed, format, name, vars, node);
	            MergeFormats.mergeBackgroundColorAndFontSize(dom, format, vars, node);
	            MergeFormats.mergeSubSup(dom, format, vars, node);
	            MergeFormats.mergeSiblings(dom, format, vars, node);
	          }
	        });
	      };
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride && dom.is(node, formatList[i].selector)) {
	            setElementFormat(node, formatList[i]);
	            return;
	          }
	        }
	        return;
	      }
	      if (format) {
	        if (node) {
	          if (node.nodeType) {
	            if (!applyNodeStyle(formatList, node)) {
	              rng = dom.createRng();
	              rng.setStartBefore(node);
	              rng.setEndAfter(node);
	              applyRngStyle(dom, ExpandRange.expandRng(ed, rng, formatList), null, true);
	            }
	          } else {
	            applyRngStyle(dom, node, null, true);
	          }
	        } else {
	          if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	            var curSelNode = ed.selection.getNode();
	            if (!ed.settings.forced_root_block && formatList[0].defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
	              applyFormat(ed, formatList[0].defaultBlock);
	            }
	            ed.selection.setRng(RangeNormalizer.normalize(ed.selection.getRng()));
	            bookmark = GetBookmark.getPersistentBookmark(ed.selection, true);
	            applyRngStyle(dom, ExpandRange.expandRng(ed, selection.getRng(), formatList));
	            if (format.styles) {
	              MergeFormats.mergeUnderlineAndColor(dom, format, vars, curSelNode);
	            }
	            selection.moveToBookmark(bookmark);
	            FormatUtils.moveStart(dom, selection, selection.getRng());
	            ed.nodeChanged();
	          } else {
	            applyCaretFormat(ed, name, vars);
	          }
	        }
	        Hooks.postProcess(name, ed);
	      }
	    };
	    var ApplyFormat = { applyFormat: applyFormat };
	
	    var each$g = Tools.each;
	    var setup$5 = function (formatChangeData, editor) {
	      var currentFormats = {};
	      formatChangeData.set({});
	      editor.on('NodeChange', function (e) {
	        var parents = FormatUtils.getParents(editor.dom, e.element);
	        var matchedFormats = {};
	        parents = Tools.grep(parents, function (node) {
	          return node.nodeType === 1 && !node.getAttribute('data-mce-bogus');
	        });
	        each$g(formatChangeData.get(), function (callbacks, format) {
	          each$g(parents, function (node) {
	            if (editor.formatter.matchNode(node, format, {}, callbacks.similar)) {
	              if (!currentFormats[format]) {
	                each$g(callbacks, function (callback) {
	                  callback(true, {
	                    node: node,
	                    format: format,
	                    parents: parents
	                  });
	                });
	                currentFormats[format] = callbacks;
	              }
	              matchedFormats[format] = callbacks;
	              return false;
	            }
	            if (MatchFormat.matchesUnInheritedFormatSelector(editor, node, format)) {
	              return false;
	            }
	          });
	        });
	        each$g(currentFormats, function (callbacks, format) {
	          if (!matchedFormats[format]) {
	            delete currentFormats[format];
	            each$g(callbacks, function (callback) {
	              callback(false, {
	                node: e.element,
	                format: format,
	                parents: parents
	              });
	            });
	          }
	        });
	      });
	    };
	    var addListeners = function (formatChangeData, formats, callback, similar) {
	      var formatChangeItems = formatChangeData.get();
	      each$g(formats.split(','), function (format) {
	        if (!formatChangeItems[format]) {
	          formatChangeItems[format] = [];
	          formatChangeItems[format].similar = similar;
	        }
	        formatChangeItems[format].push(callback);
	      });
	      formatChangeData.set(formatChangeItems);
	    };
	    var formatChanged = function (editor, formatChangeState, formats, callback, similar) {
	      if (formatChangeState.get() === null) {
	        setup$5(formatChangeState, editor);
	      }
	      addListeners(formatChangeState, formats, callback, similar);
	    };
	    var FormatChanged = { formatChanged: formatChanged };
	
	    var get$5 = function (dom) {
	      var formats = {
	        valigntop: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'top' }
	          }],
	        valignmiddle: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'middle' }
	          }],
	        valignbottom: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'bottom' }
	          }],
	        alignleft: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-left',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'left' },
	            inherit: false,
	            preview: false,
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: { float: 'left' },
	            preview: 'font-family font-size'
	          }
	        ],
	        aligncenter: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'center' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-center',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'img',
	            collapsed: false,
	            styles: {
	              display: 'block',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: false
	          },
	          {
	            selector: 'table',
	            collapsed: false,
	            styles: {
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignright: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-right',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'right' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: { float: 'right' },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignjustify: [{
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'justify' },
	            inherit: false,
	            defaultBlock: 'div',
	            preview: 'font-family font-size'
	          }],
	        bold: [
	          {
	            inline: 'strong',
	            remove: 'all'
	          },
	          {
	            inline: 'span',
	            styles: { fontWeight: 'bold' }
	          },
	          {
	            inline: 'b',
	            remove: 'all'
	          }
	        ],
	        italic: [
	          {
	            inline: 'em',
	            remove: 'all'
	          },
	          {
	            inline: 'span',
	            styles: { fontStyle: 'italic' }
	          },
	          {
	            inline: 'i',
	            remove: 'all'
	          }
	        ],
	        underline: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'underline' },
	            exact: true
	          },
	          {
	            inline: 'u',
	            remove: 'all'
	          }
	        ],
	        strikethrough: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'line-through' },
	            exact: true
	          },
	          {
	            inline: 'strike',
	            remove: 'all'
	          }
	        ],
	        forecolor: {
	          inline: 'span',
	          styles: { color: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        hilitecolor: {
	          inline: 'span',
	          styles: { backgroundColor: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        fontname: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontFamily: '%value' },
	          clear_child_styles: true
	        },
	        fontsize: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontSize: '%value' },
	          clear_child_styles: true
	        },
	        fontsize_class: {
	          inline: 'span',
	          attributes: { class: '%value' }
	        },
	        blockquote: {
	          block: 'blockquote',
	          wrapper: 1,
	          remove: 'all'
	        },
	        subscript: { inline: 'sub' },
	        superscript: { inline: 'sup' },
	        code: { inline: 'code' },
	        link: {
	          inline: 'a',
	          selector: 'a',
	          remove: 'all',
	          split: true,
	          deep: true,
	          onmatch: function () {
	            return true;
	          },
	          onformat: function (elm, fmt, vars) {
	            Tools.each(vars, function (value, key) {
	              dom.setAttrib(elm, key, value);
	            });
	          }
	        },
	        removeformat: [
	          {
	            selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
	            remove: 'all',
	            split: true,
	            expand: false,
	            block_expand: true,
	            deep: true
	          },
	          {
	            selector: 'span',
	            attributes: [
	              'style',
	              'class'
	            ],
	            remove: 'empty',
	            split: true,
	            expand: false,
	            deep: true
	          },
	          {
	            selector: '*',
	            attributes: [
	              'style',
	              'class'
	            ],
	            split: false,
	            expand: false,
	            deep: true
	          }
	        ]
	      };
	      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function (name) {
	        formats[name] = {
	          block: name,
	          remove: 'all'
	        };
	      });
	      return formats;
	    };
	    var DefaultFormats = { get: get$5 };
	
	    function FormatRegistry (editor) {
	      var formats = {};
	      var get = function (name) {
	        return name ? formats[name] : formats;
	      };
	      var register = function (name, format) {
	        if (name) {
	          if (typeof name !== 'string') {
	            Tools.each(name, function (format, name) {
	              register(name, format);
	            });
	          } else {
	            format = format.length ? format : [format];
	            Tools.each(format, function (format) {
	              if (typeof format.deep === 'undefined') {
	                format.deep = !format.selector;
	              }
	              if (typeof format.split === 'undefined') {
	                format.split = !format.selector || format.inline;
	              }
	              if (typeof format.remove === 'undefined' && format.selector && !format.inline) {
	                format.remove = 'none';
	              }
	              if (format.selector && format.inline) {
	                format.mixed = true;
	                format.block_expand = true;
	              }
	              if (typeof format.classes === 'string') {
	                format.classes = format.classes.split(/\s+/);
	              }
	            });
	            formats[name] = format;
	          }
	        }
	      };
	      var unregister = function (name) {
	        if (name && formats[name]) {
	          delete formats[name];
	        }
	        return formats;
	      };
	      register(DefaultFormats.get(editor.dom));
	      register(editor.settings.formats);
	      return {
	        get: get,
	        register: register,
	        unregister: unregister
	      };
	    }
	
	    var each$h = Tools.each;
	    var dom = DOMUtils$1.DOM;
	    var parsedSelectorToHtml = function (ancestry, editor) {
	      var elm, item, fragment;
	      var schema = editor && editor.schema || Schema({});
	      var decorate = function (elm, item) {
	        if (item.classes.length) {
	          dom.addClass(elm, item.classes.join(' '));
	        }
	        dom.setAttribs(elm, item.attrs);
	      };
	      var createElement = function (sItem) {
	        var elm;
	        item = typeof sItem === 'string' ? {
	          name: sItem,
	          classes: [],
	          attrs: {}
	        } : sItem;
	        elm = dom.create(item.name);
	        decorate(elm, item);
	        return elm;
	      };
	      var getRequiredParent = function (elm, candidate) {
	        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
	        var elmRule = schema.getElementRule(name);
	        var parentsRequired = elmRule && elmRule.parentsRequired;
	        if (parentsRequired && parentsRequired.length) {
	          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
	        } else {
	          return false;
	        }
	      };
	      var wrapInHtml = function (elm, ancestry, siblings) {
	        var parent, parentCandidate, parentRequired;
	        var ancestor = ancestry.length > 0 && ancestry[0];
	        var ancestorName = ancestor && ancestor.name;
	        parentRequired = getRequiredParent(elm, ancestorName);
	        if (parentRequired) {
	          if (ancestorName === parentRequired) {
	            parentCandidate = ancestry[0];
	            ancestry = ancestry.slice(1);
	          } else {
	            parentCandidate = parentRequired;
	          }
	        } else if (ancestor) {
	          parentCandidate = ancestry[0];
	          ancestry = ancestry.slice(1);
	        } else if (!siblings) {
	          return elm;
	        }
	        if (parentCandidate) {
	          parent = createElement(parentCandidate);
	          parent.appendChild(elm);
	        }
	        if (siblings) {
	          if (!parent) {
	            parent = dom.create('div');
	            parent.appendChild(elm);
	          }
	          Tools.each(siblings, function (sibling) {
	            var siblingElm = createElement(sibling);
	            parent.insertBefore(siblingElm, elm);
	          });
	        }
	        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
	      };
	      if (ancestry && ancestry.length) {
	        item = ancestry[0];
	        elm = createElement(item);
	        fragment = dom.create('div');
	        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
	        return fragment;
	      } else {
	        return '';
	      }
	    };
	    var selectorToHtml = function (selector, editor) {
	      return parsedSelectorToHtml(parseSelector(selector), editor);
	    };
	    var parseSelectorItem = function (item) {
	      var tagName;
	      var obj = {
	        classes: [],
	        attrs: {}
	      };
	      item = obj.selector = Tools.trim(item);
	      if (item !== '*') {
	        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
	          switch ($1) {
	          case '#':
	            obj.attrs.id = $2;
	            break;
	          case '.':
	            obj.classes.push($2);
	            break;
	          case ':':
	            if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
	              obj.attrs[$2] = $2;
	            }
	            break;
	          }
	          if ($3 === '[') {
	            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
	            if (m) {
	              obj.attrs[m[1]] = m[2];
	            }
	          }
	          return '';
	        });
	      }
	      obj.name = tagName || 'div';
	      return obj;
	    };
	    var parseSelector = function (selector) {
	      if (!selector || typeof selector !== 'string') {
	        return [];
	      }
	      selector = selector.split(/\s*,\s*/)[0];
	      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
	      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
	        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
	        var obj = siblings.pop();
	        if (siblings.length) {
	          obj.siblings = siblings;
	        }
	        return obj;
	      }).reverse();
	    };
	    var getCssText = function (editor, format) {
	      var name, previewFrag, previewElm, items;
	      var previewCss = '', parentFontSize, previewStyles;
	      previewStyles = editor.settings.preview_styles;
	      if (previewStyles === false) {
	        return '';
	      }
	      if (typeof previewStyles !== 'string') {
	        previewStyles = 'font-family font-size font-weight font-style text-decoration ' + 'text-transform color background-color border border-radius outline text-shadow';
	      }
	      var removeVars = function (val) {
	        return val.replace(/%(\w+)/g, '');
	      };
	      if (typeof format === 'string') {
	        format = editor.formatter.get(format);
	        if (!format) {
	          return;
	        }
	        format = format[0];
	      }
	      if ('preview' in format) {
	        previewStyles = format.preview;
	        if (previewStyles === false) {
	          return '';
	        }
	      }
	      name = format.block || format.inline || 'span';
	      items = parseSelector(format.selector);
	      if (items.length) {
	        if (!items[0].name) {
	          items[0].name = name;
	        }
	        name = format.selector;
	        previewFrag = parsedSelectorToHtml(items, editor);
	      } else {
	        previewFrag = parsedSelectorToHtml([name], editor);
	      }
	      previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
	      each$h(format.styles, function (value, name) {
	        value = removeVars(value);
	        if (value) {
	          dom.setStyle(previewElm, name, value);
	        }
	      });
	      each$h(format.attributes, function (value, name) {
	        value = removeVars(value);
	        if (value) {
	          dom.setAttrib(previewElm, name, value);
	        }
	      });
	      each$h(format.classes, function (value) {
	        value = removeVars(value);
	        if (!dom.hasClass(previewElm, value)) {
	          dom.addClass(previewElm, value);
	        }
	      });
	      editor.fire('PreviewFormats');
	      dom.setStyles(previewFrag, {
	        position: 'absolute',
	        left: -65535
	      });
	      editor.getBody().appendChild(previewFrag);
	      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
	      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	      each$h(previewStyles.split(' '), function (name) {
	        var value = dom.getStyle(previewElm, name, true);
	        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
	          value = dom.getStyle(editor.getBody(), name, true);
	          if (dom.toHex(value).toLowerCase() === '#ffffff') {
	            return;
	          }
	        }
	        if (name === 'color') {
	          if (dom.toHex(value).toLowerCase() === '#000000') {
	            return;
	          }
	        }
	        if (name === 'font-size') {
	          if (/em|%$/.test(value)) {
	            if (parentFontSize === 0) {
	              return;
	            }
	            var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
	            value = numValue * parentFontSize + 'px';
	          }
	        }
	        if (name === 'border' && value) {
	          previewCss += 'padding:0 2px;';
	        }
	        previewCss += name + ':' + value + ';';
	      });
	      editor.fire('AfterPreviewFormats');
	      dom.remove(previewFrag);
	      return previewCss;
	    };
	    var Preview = {
	      getCssText: getCssText,
	      parseSelector: parseSelector,
	      selectorToHtml: selectorToHtml
	    };
	
	    var toggle = function (editor, formats, name, vars, node) {
	      var fmt = formats.get(name);
	      if (MatchFormat.match(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
	        RemoveFormat.remove(editor, name, vars, node);
	      } else {
	        ApplyFormat.applyFormat(editor, name, vars, node);
	      }
	    };
	    var ToggleFormat = { toggle: toggle };
	
	    var setup$6 = function (editor) {
	      editor.addShortcut('meta+b', '', 'Bold');
	      editor.addShortcut('meta+i', '', 'Italic');
	      editor.addShortcut('meta+u', '', 'Underline');
	      for (var i = 1; i <= 6; i++) {
	        editor.addShortcut('access+' + i, '', [
	          'FormatBlock',
	          false,
	          'h' + i
	        ]);
	      }
	      editor.addShortcut('access+7', '', [
	        'FormatBlock',
	        false,
	        'p'
	      ]);
	      editor.addShortcut('access+8', '', [
	        'FormatBlock',
	        false,
	        'div'
	      ]);
	      editor.addShortcut('access+9', '', [
	        'FormatBlock',
	        false,
	        'address'
	      ]);
	    };
	    var FormatShortcuts = { setup: setup$6 };
	
	    function Formatter (editor) {
	      var formats = FormatRegistry(editor);
	      var formatChangeState = Cell(null);
	      FormatShortcuts.setup(editor);
	      setup$2(editor);
	      return {
	        get: formats.get,
	        register: formats.register,
	        unregister: formats.unregister,
	        apply: curry(ApplyFormat.applyFormat, editor),
	        remove: curry(RemoveFormat.remove, editor),
	        toggle: curry(ToggleFormat.toggle, editor, formats),
	        match: curry(MatchFormat.match, editor),
	        matchAll: curry(MatchFormat.matchAll, editor),
	        matchNode: curry(MatchFormat.matchNode, editor),
	        canApply: curry(MatchFormat.canApply, editor),
	        formatChanged: curry(FormatChanged.formatChanged, editor, formatChangeState),
	        getCssText: curry(Preview.getCssText, editor)
	      };
	    }
	
	    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
	    var shallow$1 = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty$2.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow$1);
	
	    var register = function (htmlParser, settings, dom) {
	      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
	          node.attr(name, null);
	        }
	      });
	      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
	        var i = nodes.length, node, value;
	        var internalName = 'data-mce-' + name;
	        var urlConverter = settings.url_converter;
	        var urlConverterScope = settings.url_converter_scope;
	        while (i--) {
	          node = nodes[i];
	          value = node.attributes.map[internalName];
	          if (value !== undefined) {
	            node.attr(name, value.length > 0 ? value : null);
	            node.attr(internalName, null);
	          } else {
	            value = node.attributes.map[name];
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	            } else if (urlConverter) {
	              value = urlConverter.call(urlConverterScope, value, name, node.name);
	            }
	            node.attr(name, value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, value;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr('class');
	          if (value) {
	            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
	            node.attr('class', value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.attributes.map['data-mce-type'] === 'bookmark' && !args.cleanup) {
	            var hasChildren = Option.from(node.firstChild).exists(function (firstChild) {
	              return !Zwsp.isZwsp(firstChild.value);
	            });
	            if (hasChildren) {
	              node.unwrap();
	            } else {
	              node.remove();
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('noscript', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i].firstChild;
	          if (node) {
	            node.value = Entities.decode(node.value);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('script,style', function (nodes, name) {
	        var i = nodes.length, node, value, type;
	        var trim = function (value) {
	          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	        };
	        while (i--) {
	          node = nodes[i];
	          value = node.firstChild ? node.firstChild.value : '';
	          if (name === 'script') {
	            type = node.attr('type');
	            if (type) {
	              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
	            }
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
	            }
	          } else {
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('#comment', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.value.indexOf('[CDATA[') === 0) {
	            node.name = '#cdata';
	            node.type = 4;
	            node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '');
	          } else if (node.value.indexOf('mce:protected ') === 0) {
	            node.name = '#text';
	            node.type = 3;
	            node.raw = true;
	            node.value = unescape(node.value).substr(14);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.type === 7) {
	            node.remove();
	          } else if (node.type === 1) {
	            if (name === 'input' && !('type' in node.attributes.map)) {
	              node.attr('type', 'text');
	            }
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
	        each(nodes, function (node) {
	          if (node.attr('data-mce-type') === 'format-caret') {
	            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
	              node.remove();
	            } else {
	              node.unwrap();
	            }
	          }
	        });
	      });
	      htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].attr(name, null);
	        }
	      });
	    };
	    var trimTrailingBr = function (rootNode) {
	      var brNode1, brNode2;
	      var isBr = function (node) {
	        return node && node.name === 'br';
	      };
	      brNode1 = rootNode.lastChild;
	      if (isBr(brNode1)) {
	        brNode2 = brNode1.prev;
	        if (isBr(brNode2)) {
	          brNode1.remove();
	          brNode2.remove();
	        }
	      }
	    };
	    var DomSerializerFilters = {
	      register: register,
	      trimTrailingBr: trimTrailingBr
	    };
	
	    var preProcess = function (editor, node, args) {
	      var impl, doc, oldDoc;
	      var dom = editor.dom;
	      node = node.cloneNode(true);
	      impl = domGlobals.document.implementation;
	      if (impl.createHTMLDocument) {
	        doc = impl.createHTMLDocument('');
	        Tools.each(node.nodeName === 'BODY' ? node.childNodes : [node], function (node) {
	          doc.body.appendChild(doc.importNode(node, true));
	        });
	        if (node.nodeName !== 'BODY') {
	          node = doc.body.firstChild;
	        } else {
	          node = doc.body;
	        }
	        oldDoc = dom.doc;
	        dom.doc = doc;
	      }
	      Events.firePreProcess(editor, merge(args, { node: node }));
	      if (oldDoc) {
	        dom.doc = oldDoc;
	      }
	      return node;
	    };
	    var shouldFireEvent = function (editor, args) {
	      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
	    };
	    var process = function (editor, node, args) {
	      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
	    };
	    var DomSerializerPreProcess = { process: process };
	
	    var removeAttrs = function (node, names) {
	      each(names, function (name) {
	        node.attr(name, null);
	      });
	    };
	    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
	      domParser.addNodeFilter('font', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          var color = node.attr('color');
	          var face = node.attr('face');
	          var size = node.attr('size');
	          if (color) {
	            props.color = color;
	          }
	          if (face) {
	            props['font-family'] = face;
	          }
	          if (size) {
	            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
	          }
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	          removeAttrs(node, [
	            'color',
	            'face',
	            'size'
	          ]);
	        });
	      });
	    };
	    var addStrikeToSpanFilter = function (domParser, styles) {
	      domParser.addNodeFilter('strike', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          props['text-decoration'] = 'line-through';
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	        });
	      });
	    };
	    var addFilters = function (domParser, settings) {
	      var styles = Styles();
	      if (settings.convert_fonts_to_spans) {
	        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
	      }
	      addStrikeToSpanFilter(domParser, styles);
	    };
	    var register$1 = function (domParser, settings) {
	      if (settings.inline_styles) {
	        addFilters(domParser, settings);
	      }
	    };
	    var LegacyFilter = { register: register$1 };
	
	    var whiteSpaceRegExp$3 = /^[ \t\r\n]*$/;
	    var typeLookup = {
	      '#text': 3,
	      '#comment': 8,
	      '#cdata': 4,
	      '#pi': 7,
	      '#doctype': 10,
	      '#document-fragment': 11
	    };
	    var walk$2 = function (node, root, prev) {
	      var sibling;
	      var parent;
	      var startName = prev ? 'lastChild' : 'firstChild';
	      var siblingName = prev ? 'prev' : 'next';
	      if (node[startName]) {
	        return node[startName];
	      }
	      if (node !== root) {
	        sibling = node[siblingName];
	        if (sibling) {
	          return sibling;
	        }
	        for (parent = node.parent; parent && parent !== root; parent = parent.parent) {
	          sibling = parent[siblingName];
	          if (sibling) {
	            return sibling;
	          }
	        }
	      }
	    };
	    var Node$1 = function () {
	      function Node(name, type) {
	        this.name = name;
	        this.type = type;
	        if (type === 1) {
	          this.attributes = [];
	          this.attributes.map = {};
	        }
	      }
	      Node.create = function (name, attrs) {
	        var node, attrName;
	        node = new Node(name, typeLookup[name] || 1);
	        if (attrs) {
	          for (attrName in attrs) {
	            node.attr(attrName, attrs[attrName]);
	          }
	        }
	        return node;
	      };
	      Node.prototype.replace = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        self.insert(node, self);
	        self.remove();
	        return self;
	      };
	      Node.prototype.attr = function (name, value) {
	        var self = this;
	        var attrs, i;
	        if (typeof name !== 'string') {
	          for (i in name) {
	            self.attr(i, name[i]);
	          }
	          return self;
	        }
	        if (attrs = self.attributes) {
	          if (value !== undefined) {
	            if (value === null) {
	              if (name in attrs.map) {
	                delete attrs.map[name];
	                i = attrs.length;
	                while (i--) {
	                  if (attrs[i].name === name) {
	                    attrs = attrs.splice(i, 1);
	                    return self;
	                  }
	                }
	              }
	              return self;
	            }
	            if (name in attrs.map) {
	              i = attrs.length;
	              while (i--) {
	                if (attrs[i].name === name) {
	                  attrs[i].value = value;
	                  break;
	                }
	              }
	            } else {
	              attrs.push({
	                name: name,
	                value: value
	              });
	            }
	            attrs.map[name] = value;
	            return self;
	          }
	          return attrs.map[name];
	        }
	      };
	      Node.prototype.clone = function () {
	        var self = this;
	        var clone = new Node(self.name, self.type);
	        var i, l, selfAttrs, selfAttr, cloneAttrs;
	        if (selfAttrs = self.attributes) {
	          cloneAttrs = [];
	          cloneAttrs.map = {};
	          for (i = 0, l = selfAttrs.length; i < l; i++) {
	            selfAttr = selfAttrs[i];
	            if (selfAttr.name !== 'id') {
	              cloneAttrs[cloneAttrs.length] = {
	                name: selfAttr.name,
	                value: selfAttr.value
	              };
	              cloneAttrs.map[selfAttr.name] = selfAttr.value;
	            }
	          }
	          clone.attributes = cloneAttrs;
	        }
	        clone.value = self.value;
	        clone.shortEnded = self.shortEnded;
	        return clone;
	      };
	      Node.prototype.wrap = function (wrapper) {
	        var self = this;
	        self.parent.insert(wrapper, self);
	        wrapper.append(self);
	        return self;
	      };
	      Node.prototype.unwrap = function () {
	        var self = this;
	        var node, next;
	        for (node = self.firstChild; node;) {
	          next = node.next;
	          self.insert(node, self, true);
	          node = next;
	        }
	        self.remove();
	      };
	      Node.prototype.remove = function () {
	        var self = this, parent = self.parent, next = self.next, prev = self.prev;
	        if (parent) {
	          if (parent.firstChild === self) {
	            parent.firstChild = next;
	            if (next) {
	              next.prev = null;
	            }
	          } else {
	            prev.next = next;
	          }
	          if (parent.lastChild === self) {
	            parent.lastChild = prev;
	            if (prev) {
	              prev.next = null;
	            }
	          } else {
	            next.prev = prev;
	          }
	          self.parent = self.next = self.prev = null;
	        }
	        return self;
	      };
	      Node.prototype.append = function (node) {
	        var self = this;
	        var last;
	        if (node.parent) {
	          node.remove();
	        }
	        last = self.lastChild;
	        if (last) {
	          last.next = node;
	          node.prev = last;
	          self.lastChild = node;
	        } else {
	          self.lastChild = self.firstChild = node;
	        }
	        node.parent = self;
	        return node;
	      };
	      Node.prototype.insert = function (node, refNode, before) {
	        var parent;
	        if (node.parent) {
	          node.remove();
	        }
	        parent = refNode.parent || this;
	        if (before) {
	          if (refNode === parent.firstChild) {
	            parent.firstChild = node;
	          } else {
	            refNode.prev.next = node;
	          }
	          node.prev = refNode.prev;
	          node.next = refNode;
	          refNode.prev = node;
	        } else {
	          if (refNode === parent.lastChild) {
	            parent.lastChild = node;
	          } else {
	            refNode.next.prev = node;
	          }
	          node.next = refNode.next;
	          node.prev = refNode;
	          refNode.next = node;
	        }
	        node.parent = parent;
	        return node;
	      };
	      Node.prototype.getAll = function (name) {
	        var self = this;
	        var node;
	        var collection = [];
	        for (node = self.firstChild; node; node = walk$2(node, self)) {
	          if (node.name === name) {
	            collection.push(node);
	          }
	        }
	        return collection;
	      };
	      Node.prototype.empty = function () {
	        var self = this;
	        var nodes, i, node;
	        if (self.firstChild) {
	          nodes = [];
	          for (node = self.firstChild; node; node = walk$2(node, self)) {
	            nodes.push(node);
	          }
	          i = nodes.length;
	          while (i--) {
	            node = nodes[i];
	            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
	          }
	        }
	        self.firstChild = self.lastChild = null;
	        return self;
	      };
	      Node.prototype.isEmpty = function (elements, whitespace, predicate) {
	        var self = this;
	        var node = self.firstChild, i, name;
	        whitespace = whitespace || {};
	        if (node) {
	          do {
	            if (node.type === 1) {
	              if (node.attributes.map['data-mce-bogus']) {
	                continue;
	              }
	              if (elements[node.name]) {
	                return false;
	              }
	              i = node.attributes.length;
	              while (i--) {
	                name = node.attributes[i].name;
	                if (name === 'name' || name.indexOf('data-mce-bookmark') === 0) {
	                  return false;
	                }
	              }
	            }
	            if (node.type === 8) {
	              return false;
	            }
	            if (node.type === 3 && !whiteSpaceRegExp$3.test(node.value)) {
	              return false;
	            }
	            if (node.type === 3 && node.parent && whitespace[node.parent.name] && whiteSpaceRegExp$3.test(node.value)) {
	              return false;
	            }
	            if (predicate && predicate(node)) {
	              return false;
	            }
	          } while (node = walk$2(node, self));
	        }
	        return true;
	      };
	      Node.prototype.walk = function (prev) {
	        return walk$2(this, null, prev);
	      };
	      return Node;
	    }();
	
	    var paddEmptyNode = function (settings, args, blockElements, node) {
	      var brPreferred = settings.padd_empty_with_br || args.insert;
	      if (brPreferred && blockElements[node.name]) {
	        node.empty().append(new Node$1('br', 1)).shortEnded = true;
	      } else {
	        node.empty().append(new Node$1('#text', 3)).value = '\xA0';
	      }
	    };
	    var isPaddedWithNbsp = function (node) {
	      return hasOnlyChild(node, '#text') && node.firstChild.value === '\xA0';
	    };
	    var hasOnlyChild = function (node, name) {
	      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
	    };
	    var isPadded = function (schema, node) {
	      var rule = schema.getElementRule(node.name);
	      return rule && rule.paddEmpty;
	    };
	    var isEmpty$2 = function (schema, nonEmptyElements, whitespaceElements, node) {
	      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
	        return isPadded(schema, node);
	      });
	    };
	    var isLineBreakNode = function (node, blockElements) {
	      return node && (blockElements[node.name] || node.name === 'br');
	    };
	
	    var register$2 = function (parser, settings) {
	      var schema = parser.schema;
	      if (settings.remove_trailing_brs) {
	        parser.addNodeFilter('br', function (nodes, _, args) {
	          var i;
	          var l = nodes.length;
	          var node;
	          var blockElements = Tools.extend({}, schema.getBlockElements());
	          var nonEmptyElements = schema.getNonEmptyElements();
	          var parent, lastParent, prev, prevName;
	          var whiteSpaceElements = schema.getWhiteSpaceElements();
	          var elementRule, textNode;
	          blockElements.body = 1;
	          for (i = 0; i < l; i++) {
	            node = nodes[i];
	            parent = node.parent;
	            if (blockElements[node.parent.name] && node === parent.lastChild) {
	              prev = node.prev;
	              while (prev) {
	                prevName = prev.name;
	                if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
	                  if (prevName !== 'br') {
	                    break;
	                  }
	                  if (prevName === 'br') {
	                    node = null;
	                    break;
	                  }
	                }
	                prev = prev.prev;
	              }
	              if (node) {
	                node.remove();
	                if (isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, parent)) {
	                  elementRule = schema.getElementRule(parent.name);
	                  if (elementRule) {
	                    if (elementRule.removeEmpty) {
	                      parent.remove();
	                    } else if (elementRule.paddEmpty) {
	                      paddEmptyNode(settings, args, blockElements, parent);
	                    }
	                  }
	                }
	              }
	            } else {
	              lastParent = node;
	              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
	                lastParent = parent;
	                if (blockElements[parent.name]) {
	                  break;
	                }
	                parent = parent.parent;
	              }
	              if (lastParent === parent && settings.padd_empty_with_br !== true) {
	                textNode = new Node$1('#text', 3);
	                textNode.value = '\xA0';
	                node.replace(textNode);
	              }
	            }
	          }
	        });
	      }
	      parser.addAttributeFilter('href', function (nodes) {
	        var i = nodes.length, node;
	        var appendRel = function (rel) {
	          var parts = rel.split(' ').filter(function (p) {
	            return p.length > 0;
	          });
	          return parts.concat(['noopener']).sort().join(' ');
	        };
	        var addNoOpener = function (rel) {
	          var newRel = rel ? Tools.trim(rel) : '';
	          if (!/\b(noopener)\b/g.test(newRel)) {
	            return appendRel(newRel);
	          } else {
	            return newRel;
	          }
	        };
	        if (!settings.allow_unsafe_link_target) {
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.attr('target') === '_blank') {
	              node.attr('rel', addNoOpener(node.attr('rel')));
	            }
	          }
	        }
	      });
	      if (!settings.allow_html_in_named_anchor) {
	        parser.addAttributeFilter('id,name', function (nodes) {
	          var i = nodes.length, sibling, prevSibling, parent, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
	              parent = node.parent;
	              sibling = node.lastChild;
	              do {
	                prevSibling = sibling.prev;
	                parent.insert(sibling, node);
	                sibling = prevSibling;
	              } while (sibling);
	            }
	          }
	        });
	      }
	      if (settings.fix_list_elements) {
	        parser.addNodeFilter('ul,ol', function (nodes) {
	          var i = nodes.length, node, parentNode;
	          while (i--) {
	            node = nodes[i];
	            parentNode = node.parent;
	            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
	              if (node.prev && node.prev.name === 'li') {
	                node.prev.append(node);
	              } else {
	                var li = new Node$1('li', 1);
	                li.attr('style', 'list-style-type: none');
	                node.wrap(li);
	              }
	            }
	          }
	        });
	      }
	      if (settings.validate && schema.getValidClasses()) {
	        parser.addAttributeFilter('class', function (nodes) {
	          var i = nodes.length, node, classList, ci, className, classValue;
	          var validClasses = schema.getValidClasses();
	          var validClassesMap, valid;
	          while (i--) {
	            node = nodes[i];
	            classList = node.attr('class').split(' ');
	            classValue = '';
	            for (ci = 0; ci < classList.length; ci++) {
	              className = classList[ci];
	              valid = false;
	              validClassesMap = validClasses['*'];
	              if (validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              validClassesMap = validClasses[node.name];
	              if (!valid && validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              if (valid) {
	                if (classValue) {
	                  classValue += ' ';
	                }
	                classValue += className;
	              }
	            }
	            if (!classValue.length) {
	              classValue = null;
	            }
	            node.attr('class', classValue);
	          }
	        });
	      }
	    };
	
	    var makeMap$4 = Tools.makeMap, each$i = Tools.each, explode$3 = Tools.explode, extend$3 = Tools.extend;
	    function DomParser (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var nodeFilters = {};
	      var attributeFilters = [];
	      var matchedNodes = {};
	      var matchedAttributes = {};
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      settings.root_name = settings.root_name || 'body';
	      var fixInvalidChildren = function (nodes) {
	        var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
	        var nonEmptyElements, whitespaceElements, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
	        nonSplitableElements = makeMap$4('tr,td,th,tbody,thead,tfoot,table');
	        nonEmptyElements = schema.getNonEmptyElements();
	        whitespaceElements = schema.getWhiteSpaceElements();
	        textBlockElements = schema.getTextBlockElements();
	        specialElements = schema.getSpecialElements();
	        for (ni = 0; ni < nodes.length; ni++) {
	          node = nodes[ni];
	          if (!node.parent || node.fixed) {
	            continue;
	          }
	          if (textBlockElements[node.name] && node.parent.name === 'li') {
	            sibling = node.next;
	            while (sibling) {
	              if (textBlockElements[sibling.name]) {
	                sibling.name = 'li';
	                sibling.fixed = true;
	                node.parent.insert(sibling, node.parent);
	              } else {
	                break;
	              }
	              sibling = sibling.next;
	            }
	            node.unwrap(node);
	            continue;
	          }
	          parents = [node];
	          for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) && !nonSplitableElements[parent.name]; parent = parent.parent) {
	            parents.push(parent);
	          }
	          if (parent && parents.length > 1) {
	            parents.reverse();
	            newParent = currentNode = filterNode(parents[0].clone());
	            for (i = 0; i < parents.length - 1; i++) {
	              if (schema.isValidChild(currentNode.name, parents[i].name)) {
	                tempNode = filterNode(parents[i].clone());
	                currentNode.append(tempNode);
	              } else {
	                tempNode = currentNode;
	              }
	              for (childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
	                nextNode = childNode.next;
	                tempNode.append(childNode);
	                childNode = nextNode;
	              }
	              currentNode = tempNode;
	            }
	            if (!isEmpty$2(schema, nonEmptyElements, whitespaceElements, newParent)) {
	              parent.insert(newParent, parents[0], true);
	              parent.insert(node, newParent);
	            } else {
	              parent.insert(node, parents[0], true);
	            }
	            parent = parents[0];
	            if (isEmpty$2(schema, nonEmptyElements, whitespaceElements, parent) || hasOnlyChild(parent, 'br')) {
	              parent.empty().remove();
	            }
	          } else if (node.parent) {
	            if (node.name === 'li') {
	              sibling = node.prev;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.append(node);
	                continue;
	              }
	              sibling = node.next;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.insert(node, sibling.firstChild, true);
	                continue;
	              }
	              node.wrap(filterNode(new Node$1('ul', 1)));
	              continue;
	            }
	            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
	              node.wrap(filterNode(new Node$1('div', 1)));
	            } else {
	              if (specialElements[node.name]) {
	                node.empty().remove();
	              } else {
	                node.unwrap();
	              }
	            }
	          }
	        }
	      };
	      var filterNode = function (node) {
	        var i, name, list;
	        name = node.name;
	        if (name in nodeFilters) {
	          list = matchedNodes[name];
	          if (list) {
	            list.push(node);
	          } else {
	            matchedNodes[name] = [node];
	          }
	        }
	        i = attributeFilters.length;
	        while (i--) {
	          name = attributeFilters[i].name;
	          if (name in node.attributes.map) {
	            list = matchedAttributes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedAttributes[name] = [node];
	            }
	          }
	        }
	        return node;
	      };
	      var addNodeFilter = function (name, callback) {
	        each$i(explode$3(name), function (name) {
	          var list = nodeFilters[name];
	          if (!list) {
	            nodeFilters[name] = list = [];
	          }
	          list.push(callback);
	        });
	      };
	      var getNodeFilters = function () {
	        var out = [];
	        for (var name in nodeFilters) {
	          if (nodeFilters.hasOwnProperty(name)) {
	            out.push({
	              name: name,
	              callbacks: nodeFilters[name]
	            });
	          }
	        }
	        return out;
	      };
	      var addAttributeFilter = function (name, callback) {
	        each$i(explode$3(name), function (name) {
	          var i;
	          for (i = 0; i < attributeFilters.length; i++) {
	            if (attributeFilters[i].name === name) {
	              attributeFilters[i].callbacks.push(callback);
	              return;
	            }
	          }
	          attributeFilters.push({
	            name: name,
	            callbacks: [callback]
	          });
	        });
	      };
	      var getAttributeFilters = function () {
	        return [].concat(attributeFilters);
	      };
	      var parse = function (html, args) {
	        var parser, nodes, i, l, fi, fl, list, name;
	        var blockElements;
	        var invalidChildren = [];
	        var isInWhiteSpacePreservedElement;
	        var node;
	        args = args || {};
	        matchedNodes = {};
	        matchedAttributes = {};
	        blockElements = extend$3(makeMap$4('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var children = schema.children;
	        var validate = settings.validate;
	        var rootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
	        var whiteSpaceElements = schema.getWhiteSpaceElements();
	        var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
	        var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
	        var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
	        var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	        isInWhiteSpacePreservedElement = whiteSpaceElements.hasOwnProperty(args.context) || whiteSpaceElements.hasOwnProperty(settings.root_name);
	        var addRootBlocks = function () {
	          var node = rootNode.firstChild, next, rootBlockNode;
	          var trim = function (rootBlockNode) {
	            if (rootBlockNode) {
	              node = rootBlockNode.firstChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(startWhiteSpaceRegExp, '');
	              }
	              node = rootBlockNode.lastChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(endWhiteSpaceRegExp, '');
	              }
	            }
	          };
	          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
	            return;
	          }
	          while (node) {
	            next = node.next;
	            if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
	              if (!rootBlockNode) {
	                rootBlockNode = createNode(rootBlockName, 1);
	                rootBlockNode.attr(settings.forced_root_block_attrs);
	                rootNode.insert(rootBlockNode, node);
	                rootBlockNode.append(node);
	              } else {
	                rootBlockNode.append(node);
	              }
	            } else {
	              trim(rootBlockNode);
	              rootBlockNode = null;
	            }
	            node = next;
	          }
	          trim(rootBlockNode);
	        };
	        var createNode = function (name, type) {
	          var node = new Node$1(name, type);
	          var list;
	          if (name in nodeFilters) {
	            list = matchedNodes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedNodes[name] = [node];
	            }
	          }
	          return node;
	        };
	        var removeWhitespaceBefore = function (node) {
	          var textNode, textNodeNext, textVal, sibling;
	          var blockElements = schema.getBlockElements();
	          for (textNode = node.prev; textNode && textNode.type === 3;) {
	            textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	            if (textVal.length > 0) {
	              textNode.value = textVal;
	              return;
	            }
	            textNodeNext = textNode.next;
	            if (textNodeNext) {
	              if (textNodeNext.type === 3 && textNodeNext.value.length) {
	                textNode = textNode.prev;
	                continue;
	              }
	              if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
	                textNode = textNode.prev;
	                continue;
	              }
	            }
	            sibling = textNode.prev;
	            textNode.remove();
	            textNode = sibling;
	          }
	        };
	        var cloneAndExcludeBlocks = function (input) {
	          var name;
	          var output = {};
	          for (name in input) {
	            if (name !== 'li' && name !== 'p') {
	              output[name] = input[name];
	            }
	          }
	          return output;
	        };
	        parser = SaxParser$1({
	          validate: validate,
	          allow_script_urls: settings.allow_script_urls,
	          allow_conditional_comments: settings.allow_conditional_comments,
	          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	          cdata: function (text) {
	            node.append(createNode('#cdata', 4)).value = text;
	          },
	          text: function (text, raw) {
	            var textNode;
	            if (!isInWhiteSpacePreservedElement) {
	              text = text.replace(allWhiteSpaceRegExp, ' ');
	              if (isLineBreakNode(node.lastChild, blockElements)) {
	                text = text.replace(startWhiteSpaceRegExp, '');
	              }
	            }
	            if (text.length !== 0) {
	              textNode = createNode('#text', 3);
	              textNode.raw = !!raw;
	              node.append(textNode).value = text;
	            }
	          },
	          comment: function (text) {
	            node.append(createNode('#comment', 8)).value = text;
	          },
	          pi: function (name, text) {
	            node.append(createNode(name, 7)).value = text;
	            removeWhitespaceBefore(node);
	          },
	          doctype: function (text) {
	            var newNode;
	            newNode = node.append(createNode('#doctype', 10));
	            newNode.value = text;
	            removeWhitespaceBefore(node);
	          },
	          start: function (name, attrs, empty) {
	            var newNode, attrFiltersLen, elementRule, attrName, parent;
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              newNode = createNode(elementRule.outputName || name, 1);
	              newNode.attributes = attrs;
	              newNode.shortEnded = empty;
	              node.append(newNode);
	              parent = children[node.name];
	              if (parent && children[newNode.name] && !parent[newNode.name]) {
	                invalidChildren.push(newNode);
	              }
	              attrFiltersLen = attributeFilters.length;
	              while (attrFiltersLen--) {
	                attrName = attributeFilters[attrFiltersLen].name;
	                if (attrName in attrs.map) {
	                  list = matchedAttributes[attrName];
	                  if (list) {
	                    list.push(newNode);
	                  } else {
	                    matchedAttributes[attrName] = [newNode];
	                  }
	                }
	              }
	              if (blockElements[name]) {
	                removeWhitespaceBefore(newNode);
	              }
	              if (!empty) {
	                node = newNode;
	              }
	              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = true;
	              }
	            }
	          },
	          end: function (name) {
	            var textNode, elementRule, text, sibling, tempNode;
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              if (blockElements[name]) {
	                if (!isInWhiteSpacePreservedElement) {
	                  textNode = node.firstChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.next;
	                    } else {
	                      sibling = textNode.next;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.next;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                  textNode = node.lastChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.prev;
	                    } else {
	                      sibling = textNode.prev;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.prev;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                }
	              }
	              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = false;
	              }
	              if (elementRule.removeEmpty && isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node)) {
	                if (!node.attributes.map.name && !node.attr('id')) {
	                  tempNode = node.parent;
	                  if (blockElements[node.name]) {
	                    node.empty().remove();
	                  } else {
	                    node.unwrap();
	                  }
	                  node = tempNode;
	                  return;
	                }
	              }
	              if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node))) {
	                paddEmptyNode(settings, args, blockElements, node);
	              }
	              node = node.parent;
	            }
	          }
	        }, schema);
	        var rootNode = node = new Node$1(args.context || settings.root_name, 11);
	        parser.parse(html);
	        if (validate && invalidChildren.length) {
	          if (!args.context) {
	            fixInvalidChildren(invalidChildren);
	          } else {
	            args.invalid = true;
	          }
	        }
	        if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
	          addRootBlocks();
	        }
	        if (!args.invalid) {
	          for (name in matchedNodes) {
	            list = nodeFilters[name];
	            nodes = matchedNodes[name];
	            fi = nodes.length;
	            while (fi--) {
	              if (!nodes[fi].parent) {
	                nodes.splice(fi, 1);
	              }
	            }
	            for (i = 0, l = list.length; i < l; i++) {
	              list[i](nodes, name, args);
	            }
	          }
	          for (i = 0, l = attributeFilters.length; i < l; i++) {
	            list = attributeFilters[i];
	            if (list.name in matchedAttributes) {
	              nodes = matchedAttributes[list.name];
	              fi = nodes.length;
	              while (fi--) {
	                if (!nodes[fi].parent) {
	                  nodes.splice(fi, 1);
	                }
	              }
	              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
	                list.callbacks[fi](nodes, list.name, args);
	              }
	            }
	          }
	        }
	        return rootNode;
	      };
	      var exports = {
	        schema: schema,
	        addAttributeFilter: addAttributeFilter,
	        getAttributeFilters: getAttributeFilters,
	        addNodeFilter: addNodeFilter,
	        getNodeFilters: getNodeFilters,
	        filterNode: filterNode,
	        parse: parse
	      };
	      register$2(exports, settings);
	      LegacyFilter.register(exports, settings);
	      return exports;
	    }
	
	    var addTempAttr = function (htmlParser, tempAttrs, name) {
	      if (Tools.inArray(tempAttrs, name) === -1) {
	        htmlParser.addAttributeFilter(name, function (nodes, name) {
	          var i = nodes.length;
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        });
	        tempAttrs.push(name);
	      }
	    };
	    var postProcess$1 = function (editor, args, content) {
	      if (!args.no_events && editor) {
	        var outArgs = Events.firePostProcess(editor, merge(args, { content: content }));
	        return outArgs.content;
	      } else {
	        return content;
	      }
	    };
	    var getHtmlFromNode = function (dom, node, args) {
	      var html = Zwsp.trim(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
	      return args.selection || isWsPreserveElement(Element.fromDom(node)) ? html : Tools.trim(html);
	    };
	    var parseHtml = function (htmlParser, html, args) {
	      var parserArgs = args.selection ? merge({ forced_root_block: false }, args) : args;
	      var rootNode = htmlParser.parse(html, parserArgs);
	      DomSerializerFilters.trimTrailingBr(rootNode);
	      return rootNode;
	    };
	    var serializeNode = function (settings, schema, node) {
	      var htmlSerializer = HtmlSerializer(settings, schema);
	      return htmlSerializer.serialize(node);
	    };
	    var toHtml = function (editor, settings, schema, rootNode, args) {
	      var content = serializeNode(settings, schema, rootNode);
	      return postProcess$1(editor, args, content);
	    };
	    function DomSerializer (settings, editor) {
	      var dom, schema, htmlParser;
	      var tempAttrs = ['data-mce-selected'];
	      dom = editor && editor.dom ? editor.dom : DOMUtils$1.DOM;
	      schema = editor && editor.schema ? editor.schema : Schema(settings);
	      settings.entity_encoding = settings.entity_encoding || 'named';
	      settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
	      htmlParser = DomParser(settings, schema);
	      DomSerializerFilters.register(htmlParser, settings, dom);
	      var serialize = function (node, parserArgs) {
	        var args = merge({ format: 'html' }, parserArgs ? parserArgs : {});
	        var targetNode = DomSerializerPreProcess.process(editor, node, args);
	        var html = getHtmlFromNode(dom, targetNode, args);
	        var rootNode = parseHtml(htmlParser, html, args);
	        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
	      };
	      return {
	        schema: schema,
	        addNodeFilter: htmlParser.addNodeFilter,
	        addAttributeFilter: htmlParser.addAttributeFilter,
	        serialize: serialize,
	        addRules: function (rules) {
	          schema.addValidElements(rules);
	        },
	        setRules: function (rules) {
	          schema.setValidElements(rules);
	        },
	        addTempAttr: curry(addTempAttr, htmlParser, tempAttrs),
	        getTempAttrs: function () {
	          return tempAttrs;
	        }
	      };
	    }
	
	    function DomSerializer$1 (settings, editor) {
	      var domSerializer = DomSerializer(settings, editor);
	      return {
	        schema: domSerializer.schema,
	        addNodeFilter: domSerializer.addNodeFilter,
	        addAttributeFilter: domSerializer.addAttributeFilter,
	        serialize: domSerializer.serialize,
	        addRules: domSerializer.addRules,
	        setRules: domSerializer.setRules,
	        addTempAttr: domSerializer.addTempAttr,
	        getTempAttrs: domSerializer.getTempAttrs
	      };
	    }
	
	    function BookmarkManager(selection) {
	      return {
	        getBookmark: curry(Bookmarks.getBookmark, selection),
	        moveToBookmark: curry(Bookmarks.moveToBookmark, selection)
	      };
	    }
	    (function (BookmarkManager) {
	      BookmarkManager.isBookmarkNode = Bookmarks.isBookmarkNode;
	    }(BookmarkManager || (BookmarkManager = {})));
	    var BookmarkManager$1 = BookmarkManager;
	
	    var isContentEditableFalse$a = NodeType.isContentEditableFalse;
	    var isContentEditableTrue$5 = NodeType.isContentEditableTrue;
	    var getContentEditableRoot$2 = function (root, node) {
	      while (node && node !== root) {
	        if (isContentEditableTrue$5(node) || isContentEditableFalse$a(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var ControlSelection = function (selection, editor) {
	      var dom = editor.dom, each = Tools.each;
	      var selectedElm, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle;
	      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
	      var width, height;
	      var editableDoc = editor.getDoc(), rootDocument = domGlobals.document;
	      var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
	      var startScrollWidth, startScrollHeight;
	      resizeHandles = {
	        nw: [
	          0,
	          0,
	          -1,
	          -1
	        ],
	        ne: [
	          1,
	          0,
	          1,
	          -1
	        ],
	        se: [
	          1,
	          1,
	          1,
	          1
	        ],
	        sw: [
	          0,
	          1,
	          -1,
	          1
	        ]
	      };
	      var rootClass = '.mce-content-body';
	      editor.contentStyles.push(rootClass + ' div.mce-resizehandle {' + 'position: absolute;' + 'border: 1px solid black;' + 'box-sizing: content-box;' + 'background: #FFF;' + 'width: 7px;' + 'height: 7px;' + 'z-index: 10000' + '}' + rootClass + ' .mce-resizehandle:hover {' + 'background: #000' + '}' + rootClass + ' img[data-mce-selected],' + rootClass + ' hr[data-mce-selected] {' + 'outline: 1px solid black;' + 'resize: none' + '}' + rootClass + ' .mce-clonedresizable {' + 'position: absolute;' + (Env.gecko ? '' : 'outline: 1px dashed black;') + 'opacity: .5;' + 'filter: alpha(opacity=50);' + 'z-index: 10000' + '}' + rootClass + ' .mce-resize-helper {' + 'background: #555;' + 'background: rgba(0,0,0,0.75);' + 'border-radius: 3px;' + 'border: 1px;' + 'color: white;' + 'display: none;' + 'font-family: sans-serif;' + 'font-size: 12px;' + 'white-space: nowrap;' + 'line-height: 14px;' + 'margin: 5px 10px;' + 'padding: 5px;' + 'position: absolute;' + 'z-index: 10001' + '}');
	      var isImage = function (elm) {
	        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
	      };
	      var isEventOnImageOutsideRange = function (evt, range) {
	        return isImage(evt.target) && !RangePoint.isXYWithinRange(evt.clientX, evt.clientY, range);
	      };
	      var contextMenuSelectImage = function (evt) {
	        var target = evt.target;
	        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
	          editor.selection.select(target);
	        }
	      };
	      var getResizeTarget = function (elm) {
	        return editor.dom.is(elm, 'figure.image') ? elm.querySelector('img') : elm;
	      };
	      var isResizable = function (elm) {
	        var selector = editor.settings.object_resizing;
	        if (selector === false || Env.iOS) {
	          return false;
	        }
	        if (typeof selector !== 'string') {
	          selector = 'table,img,figure.image,div';
	        }
	        if (elm.getAttribute('data-mce-resize') === 'false') {
	          return false;
	        }
	        if (elm === editor.getBody()) {
	          return false;
	        }
	        return is$1(Element.fromDom(elm), selector);
	      };
	      var resizeGhostElement = function (e) {
	        var deltaX, deltaY, proportional;
	        var resizeHelperX, resizeHelperY;
	        deltaX = e.screenX - startX;
	        deltaY = e.screenY - startY;
	        width = deltaX * selectedHandle[2] + startW;
	        height = deltaY * selectedHandle[3] + startH;
	        width = width < 5 ? 5 : width;
	        height = height < 5 ? 5 : height;
	        if (isImage(selectedElm) && editor.settings.resize_img_proportional !== false) {
	          proportional = !VK.modifierPressed(e);
	        } else {
	          proportional = VK.modifierPressed(e) || isImage(selectedElm) && selectedHandle[2] * selectedHandle[3] !== 0;
	        }
	        if (proportional) {
	          if (abs(deltaX) > abs(deltaY)) {
	            height = round(width * ratio);
	            width = round(height / ratio);
	          } else {
	            width = round(height / ratio);
	            height = round(width * ratio);
	          }
	        }
	        dom.setStyles(getResizeTarget(selectedElmGhost), {
	          width: width,
	          height: height
	        });
	        resizeHelperX = selectedHandle.startPos.x + deltaX;
	        resizeHelperY = selectedHandle.startPos.y + deltaY;
	        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
	        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	        dom.setStyles(resizeHelper, {
	          left: resizeHelperX,
	          top: resizeHelperY,
	          display: 'block'
	        });
	        resizeHelper.innerHTML = width + ' &times; ' + height;
	        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
	          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
	        }
	        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
	          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
	        }
	        deltaX = rootElement.scrollWidth - startScrollWidth;
	        deltaY = rootElement.scrollHeight - startScrollHeight;
	        if (deltaX + deltaY !== 0) {
	          dom.setStyles(resizeHelper, {
	            left: resizeHelperX - deltaX,
	            top: resizeHelperY - deltaY
	          });
	        }
	        if (!resizeStarted) {
	          Events.fireObjectResizeStart(editor, selectedElm, startW, startH);
	          resizeStarted = true;
	        }
	      };
	      var endGhostResize = function () {
	        resizeStarted = false;
	        var setSizeProp = function (name, value) {
	          if (value) {
	            if (selectedElm.style[name] || !editor.schema.isValid(selectedElm.nodeName.toLowerCase(), name)) {
	              dom.setStyle(getResizeTarget(selectedElm), name, value);
	            } else {
	              dom.setAttrib(getResizeTarget(selectedElm), name, value);
	            }
	          }
	        };
	        setSizeProp('width', width);
	        setSizeProp('height', height);
	        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
	        dom.unbind(editableDoc, 'mouseup', endGhostResize);
	        if (rootDocument !== editableDoc) {
	          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
	          dom.unbind(rootDocument, 'mouseup', endGhostResize);
	        }
	        dom.remove(selectedElmGhost);
	        dom.remove(resizeHelper);
	        showResizeRect(selectedElm);
	        Events.fireObjectResized(editor, selectedElm, width, height);
	        dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
	        editor.nodeChanged();
	      };
	      var showResizeRect = function (targetElm) {
	        var position, targetWidth, targetHeight, e, rect;
	        hideResizeRect();
	        unbindResizeHandleEvents();
	        position = dom.getPos(targetElm, rootElement);
	        selectedElmX = position.x;
	        selectedElmY = position.y;
	        rect = targetElm.getBoundingClientRect();
	        targetWidth = rect.width || rect.right - rect.left;
	        targetHeight = rect.height || rect.bottom - rect.top;
	        if (selectedElm !== targetElm) {
	          selectedElm = targetElm;
	          width = height = 0;
	        }
	        e = editor.fire('ObjectSelected', { target: targetElm });
	        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
	          each(resizeHandles, function (handle, name) {
	            var handleElm;
	            var startDrag = function (e) {
	              startX = e.screenX;
	              startY = e.screenY;
	              startW = getResizeTarget(selectedElm).clientWidth;
	              startH = getResizeTarget(selectedElm).clientHeight;
	              ratio = startH / startW;
	              selectedHandle = handle;
	              handle.startPos = {
	                x: targetWidth * handle[0] + selectedElmX,
	                y: targetHeight * handle[1] + selectedElmY
	              };
	              startScrollWidth = rootElement.scrollWidth;
	              startScrollHeight = rootElement.scrollHeight;
	              selectedElmGhost = selectedElm.cloneNode(true);
	              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
	              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
	              selectedElmGhost.contentEditable = false;
	              selectedElmGhost.unSelectabe = true;
	              dom.setStyles(selectedElmGhost, {
	                left: selectedElmX,
	                top: selectedElmY,
	                margin: 0
	              });
	              selectedElmGhost.removeAttribute('data-mce-selected');
	              rootElement.appendChild(selectedElmGhost);
	              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
	              dom.bind(editableDoc, 'mouseup', endGhostResize);
	              if (rootDocument !== editableDoc) {
	                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
	                dom.bind(rootDocument, 'mouseup', endGhostResize);
	              }
	              resizeHelper = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-helper',
	                'data-mce-bogus': 'all'
	              }, startW + ' &times; ' + startH);
	            };
	            handleElm = dom.get('mceResizeHandle' + name);
	            if (handleElm) {
	              dom.remove(handleElm);
	            }
	            handleElm = dom.add(rootElement, 'div', {
	              'id': 'mceResizeHandle' + name,
	              'data-mce-bogus': 'all',
	              'class': 'mce-resizehandle',
	              'unselectable': true,
	              'style': 'cursor:' + name + '-resize; margin:0; padding:0'
	            });
	            if (Env.ie === 11) {
	              handleElm.contentEditable = false;
	            }
	            dom.bind(handleElm, 'mousedown', function (e) {
	              e.stopImmediatePropagation();
	              e.preventDefault();
	              startDrag(e);
	            });
	            handle.elm = handleElm;
	            dom.setStyles(handleElm, {
	              left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
	              top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
	            });
	          });
	        } else {
	          hideResizeRect();
	        }
	        selectedElm.setAttribute('data-mce-selected', '1');
	      };
	      var hideResizeRect = function () {
	        var name, handleElm;
	        unbindResizeHandleEvents();
	        if (selectedElm) {
	          selectedElm.removeAttribute('data-mce-selected');
	        }
	        for (name in resizeHandles) {
	          handleElm = dom.get('mceResizeHandle' + name);
	          if (handleElm) {
	            dom.unbind(handleElm);
	            dom.remove(handleElm);
	          }
	        }
	      };
	      var updateResizeRect = function (e) {
	        var startElm, controlElm;
	        var isChildOrEqual = function (node, parent) {
	          if (node) {
	            do {
	              if (node === parent) {
	                return true;
	              }
	            } while (node = node.parentNode);
	          }
	        };
	        if (resizeStarted || editor.removed) {
	          return;
	        }
	        each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
	          img.removeAttribute('data-mce-selected');
	        });
	        controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
	        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr')[0];
	        if (isChildOrEqual(controlElm, rootElement)) {
	          disableGeckoResize();
	          startElm = selection.getStart(true);
	          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
	            showResizeRect(controlElm);
	            return;
	          }
	        }
	        hideResizeRect();
	      };
	      var isWithinContentEditableFalse = function (elm) {
	        return isContentEditableFalse$a(getContentEditableRoot$2(editor.getBody(), elm));
	      };
	      var unbindResizeHandleEvents = function () {
	        for (var name in resizeHandles) {
	          var handle = resizeHandles[name];
	          if (handle.elm) {
	            dom.unbind(handle.elm);
	            delete handle.elm;
	          }
	        }
	      };
	      var disableGeckoResize = function () {
	        try {
	          editor.getDoc().execCommand('enableObjectResizing', false, false);
	        } catch (ex) {
	        }
	      };
	      editor.on('init', function () {
	        disableGeckoResize();
	        if (Env.ie && Env.ie >= 11) {
	          editor.on('mousedown click', function (e) {
	            var target = e.target, nodeName = target.nodeName;
	            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
	              if (e.button !== 2) {
	                editor.selection.select(target, nodeName === 'TABLE');
	              }
	              if (e.type === 'mousedown') {
	                editor.nodeChanged();
	              }
	            }
	          });
	          editor.dom.bind(rootElement, 'mscontrolselect', function (e) {
	            var delayedSelect = function (node) {
	              Delay.setEditorTimeout(editor, function () {
	                editor.selection.select(node);
	              });
	            };
	            if (isWithinContentEditableFalse(e.target)) {
	              e.preventDefault();
	              delayedSelect(e.target);
	              return;
	            }
	            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
	              e.preventDefault();
	              if (e.target.tagName === 'IMG') {
	                delayedSelect(e.target);
	              }
	            }
	          });
	        }
	        var throttledUpdateResizeRect = Delay.throttle(function (e) {
	          if (!editor.composing) {
	            updateResizeRect(e);
	          }
	        });
	        editor.on('nodechange ResizeEditor ResizeWindow drop FullscreenStateChanged', throttledUpdateResizeRect);
	        editor.on('keyup compositionend', function (e) {
	          if (selectedElm && selectedElm.nodeName === 'TABLE') {
	            throttledUpdateResizeRect(e);
	          }
	        });
	        editor.on('hide blur', hideResizeRect);
	        editor.on('contextmenu', contextMenuSelectImage);
	      });
	      editor.on('remove', unbindResizeHandleEvents);
	      var destroy = function () {
	        selectedElm = selectedElmGhost = null;
	      };
	      return {
	        isResizable: isResizable,
	        showResizeRect: showResizeRect,
	        hideResizeRect: hideResizeRect,
	        updateResizeRect: updateResizeRect,
	        destroy: destroy
	      };
	    };
	
	    var hasCeProperty = function (node) {
	      return NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node);
	    };
	    var findParent$1 = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var findClosestIeRange = function (clientX, clientY, doc) {
	      var element, rng, rects;
	      element = doc.elementFromPoint(clientX, clientY);
	      rng = doc.body.createTextRange();
	      if (!element || element.tagName === 'HTML') {
	        element = doc.body;
	      }
	      rng.moveToElementText(element);
	      rects = Tools.toArray(rng.getClientRects());
	      rects = rects.sort(function (a, b) {
	        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
	        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	        return a - b;
	      });
	      if (rects.length > 0) {
	        clientY = (rects[0].bottom + rects[0].top) / 2;
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	          return rng;
	        } catch (ex) {
	        }
	      }
	      return null;
	    };
	    var moveOutOfContentEditableFalse = function (rng, rootNode) {
	      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
	      return NodeType.isContentEditableFalse(findParent$1(parentElement, rootNode, hasCeProperty)) ? null : rng;
	    };
	    var fromPoint$1 = function (clientX, clientY, doc) {
	      var rng, point;
	      var pointDoc = doc;
	      if (pointDoc.caretPositionFromPoint) {
	        point = pointDoc.caretPositionFromPoint(clientX, clientY);
	        if (point) {
	          rng = doc.createRange();
	          rng.setStart(point.offsetNode, point.offset);
	          rng.collapse(true);
	        }
	      } else if (doc.caretRangeFromPoint) {
	        rng = doc.caretRangeFromPoint(clientX, clientY);
	      } else if (pointDoc.body.createTextRange) {
	        rng = pointDoc.body.createTextRange();
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	        } catch (ex) {
	          rng = findClosestIeRange(clientX, clientY, doc);
	        }
	        return moveOutOfContentEditableFalse(rng, doc.body);
	      }
	      return rng;
	    };
	    var CaretRangeFromPoint = { fromPoint: fromPoint$1 };
	
	    var processRanges = function (editor, ranges) {
	      return map(ranges, function (range) {
	        var evt = editor.fire('GetSelectionRange', { range: range });
	        return evt.range !== range ? evt.range : range;
	      });
	    };
	    var EventProcessRanges = { processRanges: processRanges };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || domGlobals.document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom());
	      });
	      return Element.fromDom(fragment);
	    };
	
	    var tableModel = Immutable('element', 'width', 'rows');
	    var tableRow = Immutable('element', 'cells');
	    var cellPosition = Immutable('x', 'y');
	    var getSpan = function (td, key) {
	      var value = parseInt(get(td, key), 10);
	      return isNaN(value) ? 1 : value;
	    };
	    var fillout = function (table, x, y, tr, td) {
	      var rowspan = getSpan(td, 'rowspan');
	      var colspan = getSpan(td, 'colspan');
	      var rows = table.rows();
	      for (var y2 = y; y2 < y + rowspan; y2++) {
	        if (!rows[y2]) {
	          rows[y2] = tableRow(deep(tr), []);
	        }
	        for (var x2 = x; x2 < x + colspan; x2++) {
	          var cells = rows[y2].cells();
	          cells[x2] = y2 === y && x2 === x ? td : shallow(td);
	        }
	      }
	    };
	    var cellExists = function (table, x, y) {
	      var rows = table.rows();
	      var cells = rows[y] ? rows[y].cells() : [];
	      return !!cells[x];
	    };
	    var skipCellsX = function (table, x, y) {
	      while (cellExists(table, x, y)) {
	        x++;
	      }
	      return x;
	    };
	    var getWidth = function (rows) {
	      return foldl(rows, function (acc, row) {
	        return row.cells().length > acc ? row.cells().length : acc;
	      }, 0);
	    };
	    var findElementPos = function (table, element) {
	      var rows = table.rows();
	      for (var y = 0; y < rows.length; y++) {
	        var cells = rows[y].cells();
	        for (var x = 0; x < cells.length; x++) {
	          if (eq(cells[x], element)) {
	            return Option.some(cellPosition(x, y));
	          }
	        }
	      }
	      return Option.none();
	    };
	    var extractRows = function (table, sx, sy, ex, ey) {
	      var newRows = [];
	      var rows = table.rows();
	      for (var y = sy; y <= ey; y++) {
	        var cells = rows[y].cells();
	        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
	        newRows.push(tableRow(rows[y].element(), slice));
	      }
	      return newRows;
	    };
	    var subTable = function (table, startPos, endPos) {
	      var sx = startPos.x(), sy = startPos.y();
	      var ex = endPos.x(), ey = endPos.y();
	      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
	      return tableModel(table.element(), getWidth(newRows), newRows);
	    };
	    var createDomTable = function (table, rows) {
	      var tableElement = shallow(table.element());
	      var tableBody = Element.fromTag('tbody');
	      append$1(tableBody, rows);
	      append(tableElement, tableBody);
	      return tableElement;
	    };
	    var modelRowsToDomRows = function (table) {
	      return map(table.rows(), function (row) {
	        var cells = map(row.cells(), function (cell) {
	          var td = deep(cell);
	          remove(td, 'colspan');
	          remove(td, 'rowspan');
	          return td;
	        });
	        var tr = shallow(row.element());
	        append$1(tr, cells);
	        return tr;
	      });
	    };
	    var fromDom$1 = function (tableElm) {
	      var table = tableModel(shallow(tableElm), 0, []);
	      each(descendants$1(tableElm, 'tr'), function (tr, y) {
	        each(descendants$1(tr, 'td,th'), function (td, x) {
	          fillout(table, skipCellsX(table, x, y), y, tr, td);
	        });
	      });
	      return tableModel(table.element(), getWidth(table.rows()), table.rows());
	    };
	    var toDom = function (table) {
	      return createDomTable(table, modelRowsToDomRows(table));
	    };
	    var subsection = function (table, startElement, endElement) {
	      return findElementPos(table, startElement).bind(function (startPos) {
	        return findElementPos(table, endElement).map(function (endPos) {
	          return subTable(table, startPos, endPos);
	        });
	      });
	    };
	    var SimpleTableModel = {
	      fromDom: fromDom$1,
	      toDom: toDom,
	      subsection: subsection
	    };
	
	    var findParentListContainer = function (parents) {
	      return find(parents, function (elm) {
	        return name(elm) === 'ul' || name(elm) === 'ol';
	      });
	    };
	    var getFullySelectedListWrappers = function (parents, rng) {
	      return find(parents, function (elm) {
	        return name(elm) === 'li' && hasAllContentsSelected(elm, rng);
	      }).fold(constant([]), function (li) {
	        return findParentListContainer(parents).map(function (listCont) {
	          return [
	            Element.fromTag('li'),
	            Element.fromTag(name(listCont))
	          ];
	        }).getOr([]);
	      });
	    };
	    var wrap$3 = function (innerElm, elms) {
	      var wrapped = foldl(elms, function (acc, elm) {
	        append(elm, acc);
	        return elm;
	      }, innerElm);
	      return elms.length > 0 ? fromElements([wrapped]) : wrapped;
	    };
	    var directListWrappers = function (commonAnchorContainer) {
	      if (isListItem(commonAnchorContainer)) {
	        return parent(commonAnchorContainer).filter(isList).fold(constant([]), function (listElm) {
	          return [
	            commonAnchorContainer,
	            listElm
	          ];
	        });
	      } else {
	        return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
	      }
	    };
	    var getWrapElements = function (rootNode, rng) {
	      var commonAnchorContainer = Element.fromDom(rng.commonAncestorContainer);
	      var parents = Parents.parentsAndSelf(commonAnchorContainer, rootNode);
	      var wrapElements = filter(parents, function (elm) {
	        return isInline(elm) || isHeading(elm);
	      });
	      var listWrappers = getFullySelectedListWrappers(parents, rng);
	      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
	      return map(allWrappers, shallow);
	    };
	    var emptyFragment = function () {
	      return fromElements([]);
	    };
	    var getFragmentFromRange = function (rootNode, rng) {
	      return wrap$3(Element.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
	    };
	    var getParentTable = function (rootElm, cell) {
	      return ancestor$1(cell, 'table', curry(eq, rootElm));
	    };
	    var getTableFragment = function (rootNode, selectedTableCells) {
	      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
	        var firstCell = selectedTableCells[0];
	        var lastCell = selectedTableCells[selectedTableCells.length - 1];
	        var fullTableModel = SimpleTableModel.fromDom(tableElm);
	        return SimpleTableModel.subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
	          return fromElements([SimpleTableModel.toDom(sectionedTableModel)]);
	        });
	      }).getOrThunk(emptyFragment);
	    };
	    var getSelectionFragment = function (rootNode, ranges) {
	      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
	    };
	    var read$4 = function (rootNode, ranges) {
	      var selectedCells = TableCellSelection.getCellsFromElementOrRanges(ranges, rootNode);
	      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
	    };
	    var FragmentReader = { read: read$4 };
	
	    var getTextContent = function (editor) {
	      return Option.from(editor.selection.getRng()).map(function (rng) {
	        var bin = editor.dom.add(editor.getBody(), 'div', {
	          'data-mce-bogus': 'all',
	          'style': 'overflow: hidden; opacity: 0;'
	        }, rng.cloneContents());
	        var text = Zwsp.trim(bin.innerText);
	        editor.dom.remove(bin);
	        return text;
	      }).getOr('');
	    };
	    var getHtmlContent = function (editor, args) {
	      var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
	      var sel = editor.selection.getSel();
	      var fragment;
	      var ranges = EventProcessRanges.processRanges(editor, MultiRange.getRanges(sel));
	      fragment = args.contextual ? FragmentReader.read(Element.fromDom(editor.getBody()), ranges).dom() : rng.cloneContents();
	      if (fragment) {
	        tmpElm.appendChild(fragment);
	      }
	      return editor.selection.serializer.serialize(tmpElm, args);
	    };
	    var getContent = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      args.get = true;
	      args.format = args.format || 'html';
	      args.selection = true;
	      args = editor.fire('BeforeGetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('GetContent', args);
	        return args.content;
	      }
	      if (args.format === 'text') {
	        return getTextContent(editor);
	      } else {
	        args.getInner = true;
	        var content = getHtmlContent(editor, args);
	        if (args.format === 'tree') {
	          return content;
	        } else {
	          args.content = editor.selection.isCollapsed() ? '' : content;
	          editor.fire('GetContent', args);
	          return args.content;
	        }
	      }
	    };
	    var GetSelectionContent = { getContent: getContent };
	
	    var setupArgs = function (args, content) {
	      return __assign(__assign({ format: 'html' }, args), {
	        set: true,
	        selection: true,
	        content: content
	      });
	    };
	    var cleanContent = function (editor, args) {
	      if (args.format !== 'raw') {
	        var node = editor.parser.parse(args.content, __assign({
	          isRootContent: true,
	          forced_root_block: false
	        }, args));
	        return HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(node);
	      } else {
	        return args.content;
	      }
	    };
	    var setContent = function (editor, content, args) {
	      var contentArgs = setupArgs(args, content);
	      var rng = editor.selection.getRng(), caretNode;
	      var doc = editor.getDoc();
	      var frag, temp;
	      if (!contentArgs.no_events) {
	        contentArgs = editor.fire('BeforeSetContent', contentArgs);
	        if (contentArgs.isDefaultPrevented()) {
	          editor.fire('SetContent', contentArgs);
	          return;
	        }
	      }
	      content = cleanContent(editor, contentArgs);
	      if (rng.insertNode) {
	        content += '<span id="__caret">_</span>';
	        if (rng.startContainer === doc && rng.endContainer === doc) {
	          doc.body.innerHTML = content;
	        } else {
	          rng.deleteContents();
	          if (doc.body.childNodes.length === 0) {
	            doc.body.innerHTML = content;
	          } else {
	            if (rng.createContextualFragment) {
	              rng.insertNode(rng.createContextualFragment(content));
	            } else {
	              frag = doc.createDocumentFragment();
	              temp = doc.createElement('div');
	              frag.appendChild(temp);
	              temp.outerHTML = content;
	              rng.insertNode(frag);
	            }
	          }
	        }
	        caretNode = editor.dom.get('__caret');
	        rng = doc.createRange();
	        rng.setStartBefore(caretNode);
	        rng.setEndBefore(caretNode);
	        editor.selection.setRng(rng);
	        editor.dom.remove('__caret');
	        try {
	          editor.selection.setRng(rng);
	        } catch (ex) {
	        }
	      } else {
	        var anyRng = rng;
	        if (anyRng.item) {
	          doc.execCommand('Delete', false, null);
	          anyRng = editor.selection.getRng();
	        }
	        if (/^\s+/.test(content)) {
	          anyRng.pasteHTML('<span id="__mce_tmp">_</span>' + content);
	          editor.dom.remove('__mce_tmp');
	        } else {
	          anyRng.pasteHTML(content);
	        }
	      }
	      if (!contentArgs.no_events) {
	        editor.fire('SetContent', contentArgs);
	      }
	    };
	    var SetSelectionContent = { setContent: setContent };
	
	    var getEndpointElement = function (root, rng, start, real, resolve) {
	      var container = start ? rng.startContainer : rng.endContainer;
	      var offset = start ? rng.startOffset : rng.endOffset;
	      return Option.from(container).map(Element.fromDom).map(function (elm) {
	        return !real || !rng.collapsed ? child(elm, resolve(elm, offset)).getOr(elm) : elm;
	      }).bind(function (elm) {
	        return isElement(elm) ? Option.some(elm) : parent(elm);
	      }).map(function (elm) {
	        return elm.dom();
	      }).getOr(root);
	    };
	    var getStart$2 = function (root, rng, real) {
	      return getEndpointElement(root, rng, true, real, function (elm, offset) {
	        return Math.min(childNodesCount(elm), offset);
	      });
	    };
	    var getEnd = function (root, rng, real) {
	      return getEndpointElement(root, rng, false, real, function (elm, offset) {
	        return offset > 0 ? offset - 1 : offset;
	      });
	    };
	    var skipEmptyTextNodes = function (node, forwards) {
	      var orig = node;
	      while (node && NodeType.isText(node) && node.length === 0) {
	        node = forwards ? node.nextSibling : node.previousSibling;
	      }
	      return node || orig;
	    };
	    var getNode$1 = function (root, rng) {
	      var elm, startContainer, endContainer, startOffset, endOffset;
	      if (!rng) {
	        return root;
	      }
	      startContainer = rng.startContainer;
	      endContainer = rng.endContainer;
	      startOffset = rng.startOffset;
	      endOffset = rng.endOffset;
	      elm = rng.commonAncestorContainer;
	      if (!rng.collapsed) {
	        if (startContainer === endContainer) {
	          if (endOffset - startOffset < 2) {
	            if (startContainer.hasChildNodes()) {
	              elm = startContainer.childNodes[startOffset];
	            }
	          }
	        }
	        if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
	          if (startContainer.length === startOffset) {
	            startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
	          } else {
	            startContainer = startContainer.parentNode;
	          }
	          if (endOffset === 0) {
	            endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
	          } else {
	            endContainer = endContainer.parentNode;
	          }
	          if (startContainer && startContainer === endContainer) {
	            return startContainer;
	          }
	        }
	      }
	      if (elm && elm.nodeType === 3) {
	        return elm.parentNode;
	      }
	      return elm;
	    };
	    var getSelectedBlocks = function (dom, rng, startElm, endElm) {
	      var node, root;
	      var selectedBlocks = [];
	      root = dom.getRoot();
	      startElm = dom.getParent(startElm || getStart$2(root, rng, rng.collapsed), dom.isBlock);
	      endElm = dom.getParent(endElm || getEnd(root, rng, rng.collapsed), dom.isBlock);
	      if (startElm && startElm !== root) {
	        selectedBlocks.push(startElm);
	      }
	      if (startElm && endElm && startElm !== endElm) {
	        node = startElm;
	        var walker = new TreeWalker(startElm, root);
	        while ((node = walker.next()) && node !== endElm) {
	          if (dom.isBlock(node)) {
	            selectedBlocks.push(node);
	          }
	        }
	      }
	      if (endElm && startElm !== endElm && endElm !== root) {
	        selectedBlocks.push(endElm);
	      }
	      return selectedBlocks;
	    };
	    var select$1 = function (dom, node, content) {
	      return Option.from(node).map(function (node) {
	        var idx = dom.nodeIndex(node);
	        var rng = dom.createRng();
	        rng.setStart(node.parentNode, idx);
	        rng.setEnd(node.parentNode, idx + 1);
	        if (content) {
	          moveEndPoint$1(dom, rng, node, true);
	          moveEndPoint$1(dom, rng, node, false);
	        }
	        return rng;
	      });
	    };
	
	    var each$j = Tools.each;
	    var isNativeIeSelection = function (rng) {
	      return !!rng.select;
	    };
	    var isAttachedToDom = function (node) {
	      return !!(node && node.ownerDocument) && contains$3(Element.fromDom(node.ownerDocument), Element.fromDom(node));
	    };
	    var isValidRange = function (rng) {
	      if (!rng) {
	        return false;
	      } else if (isNativeIeSelection(rng)) {
	        return true;
	      } else {
	        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
	      }
	    };
	    var Selection$1 = function (dom, win, serializer, editor) {
	      var bookmarkManager, controlSelection;
	      var selectedRange, explicitRange, selectorChangedData;
	      var setCursorLocation = function (node, offset) {
	        var rng = dom.createRng();
	        if (!node) {
	          moveEndPoint$1(dom, rng, editor.getBody(), true);
	          setRng(rng);
	        } else {
	          rng.setStart(node, offset);
	          rng.setEnd(node, offset);
	          setRng(rng);
	          collapse(false);
	        }
	      };
	      var getContent = function (args) {
	        return GetSelectionContent.getContent(editor, args);
	      };
	      var setContent = function (content, args) {
	        return SetSelectionContent.setContent(editor, content, args);
	      };
	      var getStart = function (real) {
	        return getStart$2(editor.getBody(), getRng(), real);
	      };
	      var getEnd$1 = function (real) {
	        return getEnd(editor.getBody(), getRng(), real);
	      };
	      var getBookmark = function (type, normalized) {
	        return bookmarkManager.getBookmark(type, normalized);
	      };
	      var moveToBookmark = function (bookmark) {
	        return bookmarkManager.moveToBookmark(bookmark);
	      };
	      var select = function (node, content) {
	        select$1(dom, node, content).each(setRng);
	        return node;
	      };
	      var isCollapsed = function () {
	        var rng = getRng(), sel = getSel();
	        if (!rng || rng.item) {
	          return false;
	        }
	        if (rng.compareEndPoints) {
	          return rng.compareEndPoints('StartToEnd', rng) === 0;
	        }
	        return !sel || rng.collapsed;
	      };
	      var collapse = function (toStart) {
	        var rng = getRng();
	        rng.collapse(!!toStart);
	        setRng(rng);
	      };
	      var getSel = function () {
	        return win.getSelection ? win.getSelection() : win.document.selection;
	      };
	      var getRng = function () {
	        var selection, rng, elm, doc;
	        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
	          try {
	            return sourceRange.compareBoundaryPoints(how, destinationRange);
	          } catch (ex) {
	            return -1;
	          }
	        };
	        if (!win) {
	          return null;
	        }
	        doc = win.document;
	        if (typeof doc === 'undefined' || doc === null) {
	          return null;
	        }
	        if (editor.bookmark !== undefined && EditorFocus.hasFocus(editor) === false) {
	          var bookmark = SelectionBookmark.getRng(editor);
	          if (bookmark.isSome()) {
	            return bookmark.map(function (r) {
	              return EventProcessRanges.processRanges(editor, [r])[0];
	            }).getOr(doc.createRange());
	          }
	        }
	        try {
	          if ((selection = getSel()) && !NodeType.isRestrictedNode(selection.anchorNode)) {
	            if (selection.rangeCount > 0) {
	              rng = selection.getRangeAt(0);
	            } else {
	              rng = selection.createRange ? selection.createRange() : doc.createRange();
	            }
	          }
	        } catch (ex) {
	        }
	        rng = EventProcessRanges.processRanges(editor, [rng])[0];
	        if (!rng) {
	          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
	        }
	        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
	          elm = dom.getRoot();
	          rng.setStart(elm, 0);
	          rng.setEnd(elm, 0);
	        }
	        if (selectedRange && explicitRange) {
	          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
	            rng = explicitRange;
	          } else {
	            selectedRange = null;
	            explicitRange = null;
	          }
	        }
	        return rng;
	      };
	      var setRng = function (rng, forward) {
	        var sel, node, evt;
	        if (!isValidRange(rng)) {
	          return;
	        }
	        var ieRange = isNativeIeSelection(rng) ? rng : null;
	        if (ieRange) {
	          explicitRange = null;
	          try {
	            ieRange.select();
	          } catch (ex) {
	          }
	          return;
	        }
	        sel = getSel();
	        evt = editor.fire('SetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	        rng = evt.range;
	        if (sel) {
	          explicitRange = rng;
	          try {
	            sel.removeAllRanges();
	            sel.addRange(rng);
	          } catch (ex) {
	          }
	          if (forward === false && sel.extend) {
	            sel.collapse(rng.endContainer, rng.endOffset);
	            sel.extend(rng.startContainer, rng.startOffset);
	          }
	          selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
	        }
	        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
	          if (rng.endOffset - rng.startOffset < 2) {
	            if (rng.startContainer.hasChildNodes()) {
	              node = rng.startContainer.childNodes[rng.startOffset];
	              if (node && node.tagName === 'IMG') {
	                sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
	                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
	                  sel.setBaseAndExtent(node, 0, node, 1);
	                }
	              }
	            }
	          }
	        }
	        editor.fire('AfterSetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	      };
	      var setNode = function (elm) {
	        setContent(dom.getOuterHTML(elm));
	        return elm;
	      };
	      var getNode = function () {
	        return getNode$1(editor.getBody(), getRng());
	      };
	      var getSelectedBlocks$1 = function (startElm, endElm) {
	        return getSelectedBlocks(dom, getRng(), startElm, endElm);
	      };
	      var isForward = function () {
	        var sel = getSel();
	        var anchorRange, focusRange;
	        if (!sel || !sel.anchorNode || !sel.focusNode) {
	          return true;
	        }
	        anchorRange = dom.createRng();
	        anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
	        anchorRange.collapse(true);
	        focusRange = dom.createRng();
	        focusRange.setStart(sel.focusNode, sel.focusOffset);
	        focusRange.collapse(true);
	        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
	      };
	      var normalize = function () {
	        var rng = getRng();
	        var sel = getSel();
	        if (!MultiRange.hasMultipleRanges(sel) && hasAnyRanges(editor)) {
	          var normRng = NormalizeRange.normalize(dom, rng);
	          normRng.each(function (normRng) {
	            setRng(normRng, isForward());
	          });
	          return normRng.getOr(rng);
	        }
	        return rng;
	      };
	      var selectorChanged = function (selector, callback) {
	        var currentSelectors;
	        if (!selectorChangedData) {
	          selectorChangedData = {};
	          currentSelectors = {};
	          editor.on('NodeChange', function (e) {
	            var node = e.element, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
	            each$j(selectorChangedData, function (callbacks, selector) {
	              each$j(parents, function (node) {
	                if (dom.is(node, selector)) {
	                  if (!currentSelectors[selector]) {
	                    each$j(callbacks, function (callback) {
	                      callback(true, {
	                        node: node,
	                        selector: selector,
	                        parents: parents
	                      });
	                    });
	                    currentSelectors[selector] = callbacks;
	                  }
	                  matchedSelectors[selector] = callbacks;
	                  return false;
	                }
	              });
	            });
	            each$j(currentSelectors, function (callbacks, selector) {
	              if (!matchedSelectors[selector]) {
	                delete currentSelectors[selector];
	                each$j(callbacks, function (callback) {
	                  callback(false, {
	                    node: node,
	                    selector: selector,
	                    parents: parents
	                  });
	                });
	              }
	            });
	          });
	        }
	        if (!selectorChangedData[selector]) {
	          selectorChangedData[selector] = [];
	        }
	        selectorChangedData[selector].push(callback);
	        return exports;
	      };
	      var getScrollContainer = function () {
	        var scrollContainer;
	        var node = dom.getRoot();
	        while (node && node.nodeName !== 'BODY') {
	          if (node.scrollHeight > node.clientHeight) {
	            scrollContainer = node;
	            break;
	          }
	          node = node.parentNode;
	        }
	        return scrollContainer;
	      };
	      var scrollIntoView = function (elm, alignToTop) {
	        return ScrollIntoView.scrollElementIntoView(editor, elm, alignToTop);
	      };
	      var placeCaretAt = function (clientX, clientY) {
	        return setRng(CaretRangeFromPoint.fromPoint(clientX, clientY, editor.getDoc()));
	      };
	      var getBoundingClientRect = function () {
	        var rng = getRng();
	        return rng.collapsed ? CaretPosition$1.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
	      };
	      var destroy = function () {
	        win = selectedRange = explicitRange = null;
	        controlSelection.destroy();
	      };
	      var exports = {
	        bookmarkManager: null,
	        controlSelection: null,
	        dom: dom,
	        win: win,
	        serializer: serializer,
	        editor: editor,
	        collapse: collapse,
	        setCursorLocation: setCursorLocation,
	        getContent: getContent,
	        setContent: setContent,
	        getBookmark: getBookmark,
	        moveToBookmark: moveToBookmark,
	        select: select,
	        isCollapsed: isCollapsed,
	        isForward: isForward,
	        setNode: setNode,
	        getNode: getNode,
	        getSel: getSel,
	        setRng: setRng,
	        getRng: getRng,
	        getStart: getStart,
	        getEnd: getEnd$1,
	        getSelectedBlocks: getSelectedBlocks$1,
	        normalize: normalize,
	        selectorChanged: selectorChanged,
	        getScrollContainer: getScrollContainer,
	        scrollIntoView: scrollIntoView,
	        placeCaretAt: placeCaretAt,
	        getBoundingClientRect: getBoundingClientRect,
	        destroy: destroy
	      };
	      bookmarkManager = BookmarkManager$1(exports);
	      controlSelection = ControlSelection(exports, editor);
	      exports.bookmarkManager = bookmarkManager;
	      exports.controlSelection = controlSelection;
	      return exports;
	    };
	
	    var BreakType;
	    (function (BreakType) {
	      BreakType[BreakType['Br'] = 0] = 'Br';
	      BreakType[BreakType['Block'] = 1] = 'Block';
	      BreakType[BreakType['Wrap'] = 2] = 'Wrap';
	      BreakType[BreakType['Eol'] = 3] = 'Eol';
	    }(BreakType || (BreakType = {})));
	    var flip = function (direction, positions) {
	      return direction === HDirection.Backwards ? positions.reverse() : positions;
	    };
	    var walk$3 = function (direction, caretWalker, pos) {
	      return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
	    };
	    var getBreakType = function (scope, direction, currentPos, nextPos) {
	      if (NodeType.isBr(nextPos.getNode(direction === HDirection.Forwards))) {
	        return BreakType.Br;
	      } else if (isInSameBlock(currentPos, nextPos) === false) {
	        return BreakType.Block;
	      } else {
	        return BreakType.Wrap;
	      }
	    };
	    var getPositionsUntil = function (predicate, direction, scope, start) {
	      var caretWalker = CaretWalker(scope);
	      var currentPos = start, nextPos;
	      var positions = [];
	      while (currentPos) {
	        nextPos = walk$3(direction, caretWalker, currentPos);
	        if (!nextPos) {
	          break;
	        }
	        if (NodeType.isBr(nextPos.getNode(false))) {
	          if (direction === HDirection.Forwards) {
	            return {
	              positions: flip(direction, positions).concat([nextPos]),
	              breakType: BreakType.Br,
	              breakAt: Option.some(nextPos)
	            };
	          } else {
	            return {
	              positions: flip(direction, positions),
	              breakType: BreakType.Br,
	              breakAt: Option.some(nextPos)
	            };
	          }
	        }
	        if (!nextPos.isVisible()) {
	          currentPos = nextPos;
	          continue;
	        }
	        if (predicate(currentPos, nextPos)) {
	          var breakType = getBreakType(scope, direction, currentPos, nextPos);
	          return {
	            positions: flip(direction, positions),
	            breakType: breakType,
	            breakAt: Option.some(nextPos)
	          };
	        }
	        positions.push(nextPos);
	        currentPos = nextPos;
	      }
	      return {
	        positions: flip(direction, positions),
	        breakType: BreakType.Eol,
	        breakAt: Option.none()
	      };
	    };
	    var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
	      return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
	        var positions = getPositionsUntilBreak(scope, pos).positions;
	        return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
	      }).getOr([]);
	    };
	    var findClosestHorizontalPositionFromPoint = function (positions, x) {
	      return foldl(positions, function (acc, newPos) {
	        return acc.fold(function () {
	          return Option.some(newPos);
	        }, function (lastPos) {
	          return lift2(head(lastPos.getClientRects()), head(newPos.getClientRects()), function (lastRect, newRect) {
	            var lastDist = Math.abs(x - lastRect.left);
	            var newDist = Math.abs(x - newRect.left);
	            return newDist <= lastDist ? newPos : lastPos;
	          }).or(acc);
	        });
	      }, Option.none());
	    };
	    var findClosestHorizontalPosition = function (positions, pos) {
	      return head(pos.getClientRects()).bind(function (targetRect) {
	        return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
	      });
	    };
	    var getPositionsUntilPreviousLine = curry(getPositionsUntil, CaretPosition.isAbove, -1);
	    var getPositionsUntilNextLine = curry(getPositionsUntil, CaretPosition.isBelow, 1);
	    var isAtFirstLine = function (scope, pos) {
	      return getPositionsUntilPreviousLine(scope, pos).breakAt.isNone();
	    };
	    var isAtLastLine = function (scope, pos) {
	      return getPositionsUntilNextLine(scope, pos).breakAt.isNone();
	    };
	    var getPositionsAbove = curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
	    var getPositionsBelow = curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
	    var getFirstLinePositions = function (scope) {
	      return CaretFinder.firstPositionIn(scope).map(function (pos) {
	        return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
	      }).getOr([]);
	    };
	    var getLastLinePositions = function (scope) {
	      return CaretFinder.lastPositionIn(scope).map(function (pos) {
	        return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
	      }).getOr([]);
	    };
	
	    var isContentEditableFalse$b = NodeType.isContentEditableFalse;
	    var getSelectedNode$1 = getSelectedNode;
	    var moveToCeFalseHorizontally = function (direction, editor, getNextPosFn, range) {
	      var forwards = direction === HDirection.Forwards;
	      var isBeforeContentEditableFalseFn = forwards ? isBeforeContentEditableFalse : isAfterContentEditableFalse;
	      if (!range.collapsed) {
	        var node = getSelectedNode$1(range);
	        if (isContentEditableFalse$b(node)) {
	          return showCaret(direction, editor, node, direction === HDirection.Backwards, true);
	        }
	      }
	      var rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      if (isBeforeContentEditableFalseFn(caretPosition)) {
	        return selectNode(editor, caretPosition.getNode(!forwards));
	      }
	      var nextCaretPosition = InlineUtils.normalizePosition(forwards, getNextPosFn(caretPosition));
	      if (!nextCaretPosition) {
	        if (rangeIsInContainerBlock) {
	          return range;
	        }
	        return null;
	      }
	      if (isBeforeContentEditableFalseFn(nextCaretPosition)) {
	        return showCaret(direction, editor, nextCaretPosition.getNode(!forwards), forwards, true);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeContentEditableFalseFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, true);
	        }
	      }
	      if (rangeIsInContainerBlock) {
	        return renderRangeCaret(editor, nextCaretPosition.toRange(), true);
	      }
	      return null;
	    };
	    var moveToCeFalseVertically = function (direction, editor, walkerFn, range) {
	      var caretPosition, linePositions, nextLinePositions;
	      var closestNextLineRect, caretClientRect, clientX;
	      var dist1, dist2, contentEditableFalseNode;
	      contentEditableFalseNode = getSelectedNode$1(range);
	      caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
	      nextLinePositions = filter(linePositions, isLine(1));
	      caretClientRect = ArrUtils.last(caretPosition.getClientRects());
	      if (isBeforeContentEditableFalse(caretPosition) || isBeforeTable(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode();
	      }
	      if (isAfterContentEditableFalse(caretPosition) || isAfterTable(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode(true);
	      }
	      if (!caretClientRect) {
	        return null;
	      }
	      clientX = caretClientRect.left;
	      closestNextLineRect = findClosestClientRect(nextLinePositions, clientX);
	      if (closestNextLineRect) {
	        if (isContentEditableFalse$b(closestNextLineRect.node)) {
	          dist1 = Math.abs(clientX - closestNextLineRect.left);
	          dist2 = Math.abs(clientX - closestNextLineRect.right);
	          return showCaret(direction, editor, closestNextLineRect.node, dist1 < dist2, true);
	        }
	      }
	      if (contentEditableFalseNode) {
	        var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), contentEditableFalseNode);
	        closestNextLineRect = findClosestClientRect(filter(caretPositions, isLine(1)), clientX);
	        if (closestNextLineRect) {
	          return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
	        }
	        closestNextLineRect = ArrUtils.last(filter(caretPositions, isLine(0)));
	        if (closestNextLineRect) {
	          return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
	        }
	      }
	    };
	    var createTextBlock = function (editor) {
	      var textBlock = editor.dom.create(Settings.getForcedRootBlock(editor));
	      if (!Env.ie || Env.ie >= 11) {
	        textBlock.innerHTML = '<br data-mce-bogus="1">';
	      }
	      return textBlock;
	    };
	    var exitPreBlock = function (editor, direction, range) {
	      var pre, caretPos, newBlock;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      if (range.collapsed && editor.settings.forced_root_block) {
	        pre = editor.dom.getParent(range.startContainer, 'PRE');
	        if (!pre) {
	          return;
	        }
	        if (direction === 1) {
	          caretPos = getNextVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
	        } else {
	          caretPos = getPrevVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
	        }
	        if (!caretPos) {
	          newBlock = createTextBlock(editor);
	          if (direction === 1) {
	            editor.$(pre).after(newBlock);
	          } else {
	            editor.$(pre).before(newBlock);
	          }
	          editor.selection.select(newBlock, true);
	          editor.selection.collapse();
	        }
	      }
	    };
	    var getHorizontalRange = function (editor, forward) {
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      var newRange;
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
	      var range = editor.selection.getRng();
	      newRange = moveToCeFalseHorizontally(direction, editor, getNextPosFn, range);
	      if (newRange) {
	        return newRange;
	      }
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	      return null;
	    };
	    var getVerticalRange = function (editor, down) {
	      var newRange;
	      var direction = down ? 1 : -1;
	      var walkerFn = down ? downUntil : upUntil;
	      var range = editor.selection.getRng();
	      newRange = moveToCeFalseVertically(direction, editor, walkerFn, range);
	      if (newRange) {
	        return newRange;
	      }
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	      return null;
	    };
	    var moveH = function (editor, forward) {
	      return function () {
	        var newRng = getHorizontalRange(editor, forward);
	        if (newRng) {
	          moveToRange(editor, newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	    var moveV = function (editor, down) {
	      return function () {
	        var newRng = getVerticalRange(editor, down);
	        if (newRng) {
	          moveToRange(editor, newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	    var isCefPosition = function (forward) {
	      return function (pos) {
	        return forward ? isAfterContentEditableFalse(pos) : isBeforeContentEditableFalse(pos);
	      };
	    };
	    var moveToLineEndPoint = function (editor, forward) {
	      return function () {
	        var from = forward ? CaretPosition$1.fromRangeEnd(editor.selection.getRng()) : CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        var result = forward ? getPositionsUntilNextLine(editor.getBody(), from) : getPositionsUntilPreviousLine(editor.getBody(), from);
	        var to = forward ? last(result.positions) : head(result.positions);
	        return to.filter(isCefPosition(forward)).fold(constant(false), function (pos) {
	          editor.selection.setRng(pos.toRange());
	          return true;
	        });
	      };
	    };
	
	    var deflate = function (rect, delta) {
	      return {
	        left: rect.left - delta,
	        top: rect.top - delta,
	        right: rect.right + delta * 2,
	        bottom: rect.bottom + delta * 2,
	        width: rect.width + delta,
	        height: rect.height + delta
	      };
	    };
	    var getCorners = function (getYAxisValue, tds) {
	      return bind(tds, function (td) {
	        var rect = deflate(clone$1(td.getBoundingClientRect()), -1);
	        return [
	          {
	            x: rect.left,
	            y: getYAxisValue(rect),
	            cell: td
	          },
	          {
	            x: rect.right,
	            y: getYAxisValue(rect),
	            cell: td
	          }
	        ];
	      });
	    };
	    var findClosestCorner = function (corners, x, y) {
	      return foldl(corners, function (acc, newCorner) {
	        return acc.fold(function () {
	          return Option.some(newCorner);
	        }, function (oldCorner) {
	          var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
	          var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
	          return Option.some(newDist < oldDist ? newCorner : oldCorner);
	        });
	      }, Option.none());
	    };
	    var getClosestCell$1 = function (getYAxisValue, isTargetCorner, table, x, y) {
	      var cells = descendants$1(Element.fromDom(table), 'td,th,caption').map(function (e) {
	        return e.dom();
	      });
	      var corners = filter(getCorners(getYAxisValue, cells), function (corner) {
	        return isTargetCorner(corner, y);
	      });
	      return findClosestCorner(corners, x, y).map(function (corner) {
	        return corner.cell;
	      });
	    };
	    var getBottomValue = function (rect) {
	      return rect.bottom;
	    };
	    var getTopValue = function (rect) {
	      return rect.top;
	    };
	    var isAbove$1 = function (corner, y) {
	      return corner.y < y;
	    };
	    var isBelow$1 = function (corner, y) {
	      return corner.y > y;
	    };
	    var getClosestCellAbove = curry(getClosestCell$1, getBottomValue, isAbove$1);
	    var getClosestCellBelow = curry(getClosestCell$1, getTopValue, isBelow$1);
	    var findClosestPositionInAboveCell = function (table, pos) {
	      return head(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellAbove(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
	      });
	    };
	    var findClosestPositionInBelowCell = function (table, pos) {
	      return last(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellBelow(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
	      });
	    };
	
	    var hasNextBreak = function (getPositionsUntil, scope, lineInfo) {
	      return lineInfo.breakAt.map(function (breakPos) {
	        return getPositionsUntil(scope, breakPos).breakAt.isSome();
	      }).getOr(false);
	    };
	    var startsWithWrapBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0;
	    };
	    var startsWithBrBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Br && lineInfo.positions.length === 1;
	    };
	    var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
	      var lineInfo = getPositionsUntil(scope, pos);
	      if (startsWithWrapBreak(lineInfo) || !NodeType.isBr(pos.getNode()) && startsWithBrBreak(lineInfo)) {
	        return !hasNextBreak(getPositionsUntil, scope, lineInfo);
	      } else {
	        return lineInfo.breakAt.isNone();
	      }
	    };
	    var isAtFirstTableCellLine = curry(isAtTableCellLine, getPositionsUntilPreviousLine);
	    var isAtLastTableCellLine = curry(isAtTableCellLine, getPositionsUntilNextLine);
	    var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
	      var caretPos = CaretPosition$1.fromRangeStart(rng);
	      return CaretFinder.positionIn(!forward, table).map(function (pos) {
	        return pos.isEqual(caretPos);
	      }).getOr(false);
	    };
	    var navigateHorizontally = function (editor, forward, table, td) {
	      var rng = editor.selection.getRng();
	      var direction = forward ? 1 : -1;
	      if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
	        var newRng = showCaret(direction, editor, table, !forward, true);
	        moveToRange(editor, newRng);
	        return true;
	      }
	      return false;
	    };
	    var getClosestAbovePosition = function (root, table, start) {
	      return findClosestPositionInAboveCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition$1.before(table)), rect.left);
	        });
	      }).getOr(CaretPosition$1.before(table));
	    };
	    var getClosestBelowPosition = function (root, table, start) {
	      return findClosestPositionInBelowCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition$1.after(table)), rect.left);
	        });
	      }).getOr(CaretPosition$1.after(table));
	    };
	    var getTable = function (previous, pos) {
	      var node = pos.getNode(previous);
	      return NodeType.isElement(node) && node.nodeName === 'TABLE' ? Option.some(node) : Option.none();
	    };
	    var renderBlock = function (down, editor, table, pos) {
	      var forcedRootBlock = Settings.getForcedRootBlock(editor);
	      if (forcedRootBlock) {
	        editor.undoManager.transact(function () {
	          var element = Element.fromTag(forcedRootBlock);
	          setAll(element, Settings.getForcedRootBlockAttrs(editor));
	          append(element, Element.fromTag('br'));
	          if (down) {
	            after(Element.fromDom(table), element);
	          } else {
	            before(Element.fromDom(table), element);
	          }
	          var rng = editor.dom.createRng();
	          rng.setStart(element.dom(), 0);
	          rng.setEnd(element.dom(), 0);
	          moveToRange(editor, rng);
	        });
	      } else {
	        moveToRange(editor, pos.toRange());
	      }
	    };
	    var moveCaret = function (editor, down, pos) {
	      var table = down ? getTable(true, pos) : getTable(false, pos);
	      var last = down === false;
	      table.fold(function () {
	        return moveToRange(editor, pos.toRange());
	      }, function (table) {
	        return CaretFinder.positionIn(last, editor.getBody()).filter(function (lastPos) {
	          return lastPos.isEqual(pos);
	        }).fold(function () {
	          return moveToRange(editor, pos.toRange());
	        }, function (_) {
	          return renderBlock(down, editor, table, pos);
	        });
	      });
	    };
	    var navigateVertically = function (editor, down, table, td) {
	      var rng = editor.selection.getRng();
	      var pos = CaretPosition$1.fromRangeStart(rng);
	      var root = editor.getBody();
	      if (!down && isAtFirstTableCellLine(td, pos)) {
	        var newPos = getClosestAbovePosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else if (down && isAtLastTableCellLine(td, pos)) {
	        var newPos = getClosestBelowPosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var moveH$1 = function (editor, forward) {
	      return function () {
	        return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	          return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
	            return navigateHorizontally(editor, forward, table);
	          });
	        }).getOr(false);
	      };
	    };
	    var moveV$1 = function (editor, forward) {
	      return function () {
	        return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	          return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
	            return navigateVertically(editor, forward, table, td);
	          });
	        }).getOr(false);
	      };
	    };
	
	    var isTarget = function (node) {
	      return contains(['figcaption'], name(node));
	    };
	    var rangeBefore = function (target) {
	      var rng = domGlobals.document.createRange();
	      rng.setStartBefore(target.dom());
	      rng.setEndBefore(target.dom());
	      return rng;
	    };
	    var insertElement = function (root, elm, forward) {
	      if (forward) {
	        append(root, elm);
	      } else {
	        prepend(root, elm);
	      }
	    };
	    var insertBr = function (root, forward) {
	      var br = Element.fromTag('br');
	      insertElement(root, br, forward);
	      return rangeBefore(br);
	    };
	    var insertBlock$1 = function (root, forward, blockName, attrs) {
	      var block = Element.fromTag(blockName);
	      var br = Element.fromTag('br');
	      setAll(block, attrs);
	      append(block, br);
	      insertElement(root, block, forward);
	      return rangeBefore(br);
	    };
	    var insertEmptyLine = function (root, rootBlockName, attrs, forward) {
	      if (rootBlockName === '') {
	        return insertBr(root, forward);
	      } else {
	        return insertBlock$1(root, forward, rootBlockName, attrs);
	      }
	    };
	    var getClosestTargetBlock = function (pos, root) {
	      var isRoot = curry(eq, root);
	      return closest(Element.fromDom(pos.container()), isBlock, isRoot).filter(isTarget);
	    };
	    var isAtFirstOrLastLine = function (root, forward, pos) {
	      return forward ? isAtLastLine(root.dom(), pos) : isAtFirstLine(root.dom(), pos);
	    };
	    var moveCaretToNewEmptyLine = function (editor, forward) {
	      var root = Element.fromDom(editor.getBody());
	      var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var rootBlock = Settings.getForcedRootBlock(editor);
	      var rootBlockAttrs = Settings.getForcedRootBlockAttrs(editor);
	      return getClosestTargetBlock(pos, root).exists(function () {
	        if (isAtFirstOrLastLine(root, forward, pos)) {
	          var rng = insertEmptyLine(root, rootBlock, rootBlockAttrs, forward);
	          editor.selection.setRng(rng);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var moveV$2 = function (editor, forward) {
	      return function () {
	        if (editor.selection.isCollapsed()) {
	          return moveCaretToNewEmptyLine(editor, forward);
	        } else {
	          return false;
	        }
	      };
	    };
	
	    var defaultPatterns = function (patterns) {
	      return map(patterns, function (pattern) {
	        return merge({
	          shiftKey: false,
	          altKey: false,
	          ctrlKey: false,
	          metaKey: false,
	          keyCode: 0,
	          action: noop
	        }, pattern);
	      });
	    };
	    var matchesEvent = function (pattern, evt) {
	      return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
	    };
	    var match$1 = function (patterns, evt) {
	      return bind(defaultPatterns(patterns), function (pattern) {
	        return matchesEvent(pattern, evt) ? [pattern] : [];
	      });
	    };
	    var action = function (f) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var args = Array.prototype.slice.call(arguments, 1);
	      return function () {
	        return f.apply(null, args);
	      };
	    };
	    var execute = function (patterns, evt) {
	      return find(match$1(patterns, evt), function (pattern) {
	        return pattern.action();
	      });
	    };
	    var MatchKeys = {
	      match: match$1,
	      action: action,
	      execute: execute
	    };
	
	    var executeKeydownOverride = function (editor, caret, evt) {
	      var os = PlatformDetection$1.detect().os;
	      MatchKeys.execute([
	        {
	          keyCode: VK.RIGHT,
	          action: moveH(editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: moveH(editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV(editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: moveH$1(editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: moveH$1(editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV$1(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV$1(editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: BoundarySelection.move(editor, caret, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: BoundarySelection.move(editor, caret, false)
	        },
	        {
	          keyCode: VK.RIGHT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: BoundarySelection.moveNextWord(editor, caret)
	        },
	        {
	          keyCode: VK.LEFT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: BoundarySelection.movePrevWord(editor, caret)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV$2(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV$2(editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$7 = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, caret, evt);
	        }
	      });
	    };
	    var ArrowKeys = { setup: setup$7 };
	
	    var executeKeydownOverride$1 = function (editor, caret, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefBoundaryDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefBoundaryDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(TableDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(TableDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var executeKeyupOverride = function (editor, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefDelete.paddEmptyElement, editor)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefDelete.paddEmptyElement, editor)
	        }
	      ], evt);
	    };
	    var setup$8 = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$1(editor, caret, evt);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupOverride(editor, evt);
	        }
	      });
	    };
	    var DeleteBackspaceKeys = { setup: setup$8 };
	
	    var firstNonWhiteSpaceNodeSibling = function (node) {
	      while (node) {
	        if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
	          return node;
	        }
	        node = node.nextSibling;
	      }
	    };
	    var moveToCaretPosition = function (editor, root) {
	      var walker, node, rng, lastNode = root, tempElm;
	      var dom = editor.dom;
	      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
	      if (!root) {
	        return;
	      }
	      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
	        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
	          root.insertBefore(dom.doc.createTextNode('\xA0'), root.firstChild);
	        }
	      }
	      rng = dom.createRng();
	      root.normalize();
	      if (root.hasChildNodes()) {
	        walker = new TreeWalker(root, root);
	        while (node = walker.current()) {
	          if (NodeType.isText(node)) {
	            rng.setStart(node, 0);
	            rng.setEnd(node, 0);
	            break;
	          }
	          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
	            rng.setStartBefore(node);
	            rng.setEndBefore(node);
	            break;
	          }
	          lastNode = node;
	          node = walker.next();
	        }
	        if (!node) {
	          rng.setStart(lastNode, 0);
	          rng.setEnd(lastNode, 0);
	        }
	      } else {
	        if (NodeType.isBr(root)) {
	          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
	            rng.setStartBefore(root);
	            rng.setEndBefore(root);
	          } else {
	            rng.setStartAfter(root);
	            rng.setEndAfter(root);
	          }
	        } else {
	          rng.setStart(root, 0);
	          rng.setEnd(root, 0);
	        }
	      }
	      editor.selection.setRng(rng);
	      dom.remove(tempElm);
	      editor.selection.scrollIntoView(root);
	    };
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var getParentBlock$2 = function (editor) {
	      return Option.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
	    };
	    var getParentBlockName = function (editor) {
	      return getParentBlock$2(editor).fold(constant(''), function (parentBlock) {
	        return parentBlock.nodeName.toUpperCase();
	      });
	    };
	    var isListItemParentBlock = function (editor) {
	      return getParentBlock$2(editor).filter(function (elm) {
	        return isListItem(Element.fromDom(elm));
	      }).isSome();
	    };
	    var NewLineUtils = {
	      moveToCaretPosition: moveToCaretPosition,
	      getEditableRoot: getEditableRoot,
	      getParentBlock: getParentBlock$2,
	      getParentBlockName: getParentBlockName,
	      isListItemParentBlock: isListItemParentBlock
	    };
	
	    var hasFirstChild = function (elm, name) {
	      return elm.firstChild && elm.firstChild.nodeName === name;
	    };
	    var hasParent$1 = function (elm, parentName) {
	      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
	    };
	    var isListBlock = function (elm) {
	      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
	    };
	    var isNestedList = function (elm) {
	      return isListBlock(elm) && isListBlock(elm.parentNode);
	    };
	    var getContainerBlock = function (containerBlock) {
	      var containerBlockParent = containerBlock.parentNode;
	      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
	        return containerBlockParent;
	      }
	      return containerBlock;
	    };
	    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
	      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	      while (node) {
	        if (NodeType.isElement(node)) {
	          break;
	        }
	        node = node[first ? 'nextSibling' : 'previousSibling'];
	      }
	      return node === parentBlock;
	    };
	    var insert$1 = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
	      var dom = editor.dom;
	      var rng = editor.selection.getRng();
	      if (containerBlock === editor.getBody()) {
	        return;
	      }
	      if (isNestedList(containerBlock)) {
	        newBlockName = 'LI';
	      }
	      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	        } else {
	          dom.replace(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	          newBlock.appendChild(dom.doc.createTextNode(' '));
	          newBlock.appendChild(containerBlock);
	        } else {
	          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	      } else {
	        containerBlock = getContainerBlock(containerBlock);
	        var tmpRng = rng.cloneRange();
	        tmpRng.setStartAfter(parentBlock);
	        tmpRng.setEndAfter(containerBlock);
	        var fragment = tmpRng.extractContents();
	        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
	          newBlock = fragment.firstChild;
	          dom.insertAfter(fragment, containerBlock);
	        } else {
	          dom.insertAfter(fragment, containerBlock);
	          dom.insertAfter(newBlock, containerBlock);
	        }
	      }
	      dom.remove(parentBlock);
	      NewLineUtils.moveToCaretPosition(editor, newBlock);
	    };
	    var InsertLi = { insert: insert$1 };
	
	    var trimZwsp = function (fragment) {
	      each(descendants(Element.fromDom(fragment), isText), function (text) {
	        var rawNode = text.dom();
	        rawNode.nodeValue = Zwsp.trim(rawNode.nodeValue);
	      });
	    };
	    var isEmptyAnchor = function (dom, elm) {
	      return elm && elm.nodeName === 'A' && dom.isEmpty(elm);
	    };
	    var isTableCell$5 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var emptyBlock = function (elm) {
	      elm.innerHTML = '<br data-mce-bogus="1">';
	    };
	    var containerAndSiblingName = function (container, nodeName) {
	      return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
	    };
	    var canSplitBlock = function (dom, node) {
	      return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
	    };
	    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
	      var node = block;
	      var firstChilds = [];
	      var i;
	      if (!node) {
	        return;
	      }
	      while (node = node.firstChild) {
	        if (dom.isBlock(node)) {
	          return;
	        }
	        if (NodeType.isElement(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          firstChilds.push(node);
	        }
	      }
	      i = firstChilds.length;
	      while (i--) {
	        node = firstChilds[i];
	        if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
	          dom.remove(node);
	        } else {
	          if (isEmptyAnchor(dom, node)) {
	            dom.remove(node);
	          }
	        }
	      }
	    };
	    var normalizeZwspOffset = function (start, container, offset) {
	      if (NodeType.isText(container) === false) {
	        return offset;
	      } else if (start) {
	        return offset === 1 && container.data.charAt(offset - 1) === Zwsp.ZWSP ? 0 : offset;
	      } else {
	        return offset === container.data.length - 1 && container.data.charAt(offset) === Zwsp.ZWSP ? container.data.length : offset;
	      }
	    };
	    var includeZwspInRange = function (rng) {
	      var newRng = rng.cloneRange();
	      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
	      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
	      return newRng;
	    };
	    var trimLeadingLineBreaks = function (node) {
	      do {
	        if (NodeType.isText(node)) {
	          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
	        }
	        node = node.firstChild;
	      } while (node);
	    };
	    var getEditableRoot$1 = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var applyAttributes = function (editor, node, forcedRootBlockAttrs) {
	      Option.from(forcedRootBlockAttrs.style).map(editor.dom.parseStyle).each(function (attrStyles) {
	        var currentStyles = getAllRaw(Element.fromDom(node));
	        var newStyles = __assign(__assign({}, currentStyles), attrStyles);
	        editor.dom.setStyles(node, newStyles);
	      });
	      var attrClassesOpt = Option.from(forcedRootBlockAttrs.class).map(function (attrClasses) {
	        return attrClasses.split(/\s+/);
	      });
	      var currentClassesOpt = Option.from(node.className).map(function (currentClasses) {
	        return filter(currentClasses.split(/\s+/), function (clazz) {
	          return clazz !== '';
	        });
	      });
	      lift2(attrClassesOpt, currentClassesOpt, function (attrClasses, currentClasses) {
	        var filteredClasses = filter(currentClasses, function (clazz) {
	          return !contains(attrClasses, clazz);
	        });
	        var newClasses = __spreadArrays(attrClasses, filteredClasses);
	        editor.dom.setAttrib(node, 'class', newClasses.join(' '));
	      });
	      var appliedAttrs = [
	        'style',
	        'class'
	      ];
	      var remainingAttrs = bifilter(forcedRootBlockAttrs, function (_, attrs) {
	        return !contains(appliedAttrs, attrs);
	      }).t;
	      editor.dom.setAttribs(node, remainingAttrs);
	    };
	    var setForcedBlockAttrs = function (editor, node) {
	      var forcedRootBlockName = Settings.getForcedRootBlock(editor);
	      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
	        var forcedRootBlockAttrs = Settings.getForcedRootBlockAttrs(editor);
	        applyAttributes(editor, node, forcedRootBlockAttrs);
	      }
	    };
	    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
	      var newBlock, parentBlock, startNode, node, next, rootBlockName;
	      var blockName = newBlockName || 'P';
	      var dom = editor.dom, editableRoot = getEditableRoot$1(dom, container);
	      parentBlock = dom.getParent(container, dom.isBlock);
	      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
	        parentBlock = parentBlock || editableRoot;
	        if (parentBlock === editor.getBody() || isTableCell$5(parentBlock)) {
	          rootBlockName = parentBlock.nodeName.toLowerCase();
	        } else {
	          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
	        }
	        if (!parentBlock.hasChildNodes()) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          parentBlock.appendChild(newBlock);
	          rng.setStart(newBlock, 0);
	          rng.setEnd(newBlock, 0);
	          return newBlock;
	        }
	        node = container;
	        while (node.parentNode !== parentBlock) {
	          node = node.parentNode;
	        }
	        while (node && !dom.isBlock(node)) {
	          startNode = node;
	          node = node.previousSibling;
	        }
	        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          startNode.parentNode.insertBefore(newBlock, startNode);
	          node = startNode;
	          while (node && !dom.isBlock(node)) {
	            next = node.nextSibling;
	            newBlock.appendChild(node);
	            node = next;
	          }
	          rng.setStart(container, offset);
	          rng.setEnd(container, offset);
	        }
	      }
	      return container;
	    };
	    var addBrToBlockIfNeeded = function (dom, block) {
	      var lastChild;
	      block.normalize();
	      lastChild = block.lastChild;
	      if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
	        dom.add(block, 'br');
	      }
	    };
	    var insert$2 = function (editor, evt) {
	      var tmpRng, editableRoot, container, offset, parentBlock, shiftKey;
	      var newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;
	      var dom = editor.dom;
	      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
	      var rng = editor.selection.getRng();
	      var createNewBlock = function (name) {
	        var node = container, block, clonedNode, caretNode;
	        var textInlineElements = schema.getTextInlineElements();
	        if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
	          block = dom.create(name || newBlockName);
	        } else {
	          block = parentBlock.cloneNode(false);
	        }
	        caretNode = block;
	        if (Settings.shouldKeepStyles(editor) === false) {
	          dom.setAttrib(block, 'style', null);
	          dom.setAttrib(block, 'class', null);
	        } else {
	          do {
	            if (textInlineElements[node.nodeName]) {
	              if (isCaretNode(node) || Bookmarks.isBookmarkNode(node)) {
	                continue;
	              }
	              clonedNode = node.cloneNode(false);
	              dom.setAttrib(clonedNode, 'id', '');
	              if (block.hasChildNodes()) {
	                clonedNode.appendChild(block.firstChild);
	                block.appendChild(clonedNode);
	              } else {
	                caretNode = clonedNode;
	                block.appendChild(clonedNode);
	              }
	            }
	          } while ((node = node.parentNode) && node !== editableRoot);
	        }
	        setForcedBlockAttrs(editor, block);
	        emptyBlock(caretNode);
	        return block;
	      };
	      var isCaretAtStartOrEndOfBlock = function (start) {
	        var walker, node, name, normalizedOffset;
	        normalizedOffset = normalizeZwspOffset(start, container, offset);
	        if (NodeType.isText(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
	          return false;
	        }
	        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
	          return true;
	        }
	        if (start && NodeType.isElement(container) && container === parentBlock.firstChild) {
	          return true;
	        }
	        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
	          return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
	        }
	        walker = new TreeWalker(container, parentBlock);
	        if (NodeType.isText(container)) {
	          if (start && normalizedOffset === 0) {
	            walker.prev();
	          } else if (!start && normalizedOffset === container.nodeValue.length) {
	            walker.next();
	          }
	        }
	        while (node = walker.current()) {
	          if (NodeType.isElement(node)) {
	            if (!node.getAttribute('data-mce-bogus')) {
	              name = node.nodeName.toLowerCase();
	              if (nonEmptyElementsMap[name] && name !== 'br') {
	                return false;
	              }
	            }
	          } else if (NodeType.isText(node) && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
	            return false;
	          }
	          if (start) {
	            walker.prev();
	          } else {
	            walker.next();
	          }
	        }
	        return true;
	      };
	      var insertNewBlockAfter = function () {
	        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
	          newBlock = createNewBlock(newBlockName);
	        } else {
	          newBlock = createNewBlock();
	        }
	        if (Settings.shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
	          newBlock = dom.split(containerBlock, parentBlock);
	        } else {
	          dom.insertAfter(newBlock, parentBlock);
	        }
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      };
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      newBlockName = Settings.getForcedRootBlock(editor);
	      shiftKey = evt.shiftKey;
	      if (NodeType.isElement(container) && container.hasChildNodes()) {
	        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && NodeType.isText(container)) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      editableRoot = getEditableRoot$1(dom, container);
	      if (!editableRoot) {
	        return;
	      }
	      if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
	        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
	      }
	      parentBlock = dom.getParent(container, dom.isBlock);
	      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
	      containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      if (containerBlockName === 'LI' && !evt.ctrlKey) {
	        parentBlock = containerBlock;
	        containerBlock = containerBlock.parentNode;
	        parentBlockName = containerBlockName;
	      }
	      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
	        if (dom.isEmpty(parentBlock)) {
	          InsertLi.insert(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
	          return;
	        }
	      }
	      if (newBlockName && parentBlock === editor.getBody()) {
	        return;
	      }
	      newBlockName = newBlockName || 'P';
	      if (isCaretContainerBlock(parentBlock)) {
	        newBlock = showCaretContainerBlock(parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        setForcedBlockAttrs(editor, newBlock);
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      } else if (isCaretAtStartOrEndOfBlock()) {
	        insertNewBlockAfter();
	      } else if (isCaretAtStartOrEndOfBlock(true)) {
	        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
	        NewLineUtils.moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
	      } else {
	        tmpRng = includeZwspInRange(rng).cloneRange();
	        tmpRng.setEndAfter(parentBlock);
	        fragment = tmpRng.extractContents();
	        trimZwsp(fragment);
	        trimLeadingLineBreaks(fragment);
	        newBlock = fragment.firstChild;
	        dom.insertAfter(fragment, parentBlock);
	        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
	        addBrToBlockIfNeeded(dom, parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        newBlock.normalize();
	        if (dom.isEmpty(newBlock)) {
	          dom.remove(newBlock);
	          insertNewBlockAfter();
	        } else {
	          setForcedBlockAttrs(editor, newBlock);
	          NewLineUtils.moveToCaretPosition(editor, newBlock);
	        }
	      }
	      dom.setAttrib(newBlock, 'id', '');
	      editor.fire('NewBlock', { newBlock: newBlock });
	    };
	    var InsertBlock = { insert: insert$2 };
	
	    var matchesSelector = function (editor, selector) {
	      return NewLineUtils.getParentBlock(editor).filter(function (parentBlock) {
	        return selector.length > 0 && is$1(Element.fromDom(parentBlock), selector);
	      }).isSome();
	    };
	    var shouldInsertBr = function (editor) {
	      return matchesSelector(editor, Settings.getBrNewLineSelector(editor));
	    };
	    var shouldBlockNewLine = function (editor) {
	      return matchesSelector(editor, Settings.getNoNewLineSelector(editor));
	    };
	    var ContextSelectors = {
	      shouldInsertBr: shouldInsertBr,
	      shouldBlockNewLine: shouldBlockNewLine
	    };
	
	    var newLineAction = Adt.generate([
	      { br: [] },
	      { block: [] },
	      { none: [] }
	    ]);
	    var shouldBlockNewLine$1 = function (editor, shiftKey) {
	      return ContextSelectors.shouldBlockNewLine(editor);
	    };
	    var isBrMode = function (requiredState) {
	      return function (editor, shiftKey) {
	        var brMode = Settings.getForcedRootBlock(editor) === '';
	        return brMode === requiredState;
	      };
	    };
	    var inListBlock = function (requiredState) {
	      return function (editor, shiftKey) {
	        return NewLineUtils.isListItemParentBlock(editor) === requiredState;
	      };
	    };
	    var inBlock = function (blockName, requiredState) {
	      return function (editor, shiftKey) {
	        var state = NewLineUtils.getParentBlockName(editor) === blockName.toUpperCase();
	        return state === requiredState;
	      };
	    };
	    var inPreBlock = function (requiredState) {
	      return inBlock('pre', requiredState);
	    };
	    var inSummaryBlock = function () {
	      return inBlock('summary', true);
	    };
	    var shouldPutBrInPre$1 = function (requiredState) {
	      return function (editor, shiftKey) {
	        return Settings.shouldPutBrInPre(editor) === requiredState;
	      };
	    };
	    var inBrContext = function (editor, shiftKey) {
	      return ContextSelectors.shouldInsertBr(editor);
	    };
	    var hasShiftKey = function (editor, shiftKey) {
	      return shiftKey;
	    };
	    var canInsertIntoEditableRoot = function (editor) {
	      var forcedRootBlock = Settings.getForcedRootBlock(editor);
	      var rootEditable = NewLineUtils.getEditableRoot(editor.dom, editor.selection.getStart());
	      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
	    };
	    var match$2 = function (predicates, action) {
	      return function (editor, shiftKey) {
	        var isMatch = foldl(predicates, function (res, p) {
	          return res && p(editor, shiftKey);
	        }, true);
	        return isMatch ? Option.some(action) : Option.none();
	      };
	    };
	    var getAction$1 = function (editor, evt) {
	      return LazyEvaluator.evaluateUntil([
	        match$2([shouldBlockNewLine$1], newLineAction.none()),
	        match$2([inSummaryBlock()], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false)
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true),
	          hasShiftKey
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true)
	        ], newLineAction.br()),
	        match$2([
	          inListBlock(true),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([inListBlock(true)], newLineAction.block()),
	        match$2([
	          isBrMode(true),
	          hasShiftKey,
	          canInsertIntoEditableRoot
	        ], newLineAction.block()),
	        match$2([isBrMode(true)], newLineAction.br()),
	        match$2([inBrContext], newLineAction.br()),
	        match$2([
	          isBrMode(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([canInsertIntoEditableRoot], newLineAction.block())
	      ], [
	        editor,
	        evt.shiftKey
	      ]).getOr(newLineAction.none());
	    };
	    var NewLineAction = { getAction: getAction$1 };
	
	    var insert$3 = function (editor, evt) {
	      NewLineAction.getAction(editor, evt).fold(function () {
	        InsertBr.insert(editor, evt);
	      }, function () {
	        InsertBlock.insert(editor, evt);
	      }, noop);
	    };
	    var InsertNewLine = { insert: insert$3 };
	
	    var endTypingLevel = function (undoManager) {
	      if (undoManager.typing) {
	        undoManager.typing = false;
	        undoManager.add();
	      }
	    };
	    var handleEnterKeyEvent = function (editor, event) {
	      if (event.isDefaultPrevented()) {
	        return;
	      }
	      event.preventDefault();
	      endTypingLevel(editor.undoManager);
	      editor.undoManager.transact(function () {
	        if (editor.selection.isCollapsed() === false) {
	          editor.execCommand('Delete');
	        }
	        InsertNewLine.insert(editor, event);
	      });
	    };
	    var setup$9 = function (editor) {
	      editor.on('keydown', function (event) {
	        if (event.keyCode === VK.ENTER) {
	          handleEnterKeyEvent(editor, event);
	        }
	      });
	    };
	    var EnterKey = { setup: setup$9 };
	
	    var insertTextAtPosition = function (text, pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (NodeType.isText(container)) {
	        container.insertData(offset, text);
	        return Option.some(CaretPosition(container, offset + text.length));
	      } else {
	        return getElementFromPosition(pos).map(function (elm) {
	          var textNode = Element.fromText(text);
	          if (pos.isAtEnd()) {
	            after(elm, textNode);
	          } else {
	            before(elm, textNode);
	          }
	          return CaretPosition(textNode.dom(), text.length);
	        });
	      }
	    };
	    var insertNbspAtPosition = curry(insertTextAtPosition, '\xA0');
	    var insertSpaceAtPosition = curry(insertTextAtPosition, ' ');
	
	    var navigateIgnoreEmptyTextNodes = function (forward, root, from) {
	      return CaretFinder.navigateIgnore(forward, root, from, isEmptyText);
	    };
	    var getClosestBlock = function (root, pos) {
	      return find(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	    };
	    var isAtBeforeAfterBlockBoundary = function (forward, root, pos) {
	      return navigateIgnoreEmptyTextNodes(forward, root.dom(), pos).forall(function (newPos) {
	        return getClosestBlock(root, pos).fold(function () {
	          return isInSameBlock(newPos, pos, root.dom()) === false;
	        }, function (fromBlock) {
	          return isInSameBlock(newPos, pos, root.dom()) === false && contains$3(fromBlock, Element.fromDom(newPos.container()));
	        });
	      });
	    };
	    var isAtBlockBoundary = function (forward, root, pos) {
	      return getClosestBlock(root, pos).fold(function () {
	        return navigateIgnoreEmptyTextNodes(forward, root.dom(), pos).forall(function (newPos) {
	          return isInSameBlock(newPos, pos, root.dom()) === false;
	        });
	      }, function (parent) {
	        return navigateIgnoreEmptyTextNodes(forward, parent.dom(), pos).isNone();
	      });
	    };
	    var isAtStartOfBlock = curry(isAtBlockBoundary, false);
	    var isAtEndOfBlock = curry(isAtBlockBoundary, true);
	    var isBeforeBlock = curry(isAtBeforeAfterBlockBoundary, false);
	    var isAfterBlock = curry(isAtBeforeAfterBlockBoundary, true);
	
	    var nbsp = '\xA0';
	    var isInMiddleOfText = function (pos) {
	      return CaretPosition.isTextPosition(pos) && !pos.isAtStart() && !pos.isAtEnd();
	    };
	    var getClosestBlock$1 = function (root, pos) {
	      var parentBlocks = filter(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	      return head(parentBlocks).getOr(root);
	    };
	    var hasSpaceBefore = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isAfterSpace(pos);
	      } else {
	        return isAfterSpace(pos) || CaretFinder.prevPosition(getClosestBlock$1(root, pos).dom(), pos).exists(isAfterSpace);
	      }
	    };
	    var hasSpaceAfter = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isBeforeSpace(pos);
	      } else {
	        return isBeforeSpace(pos) || CaretFinder.nextPosition(getClosestBlock$1(root, pos).dom(), pos).exists(isBeforeSpace);
	      }
	    };
	    var isPreValue = function (value) {
	      return contains([
	        'pre',
	        'pre-wrap'
	      ], value);
	    };
	    var isInPre = function (pos) {
	      return getElementFromPosition(pos).bind(function (elm) {
	        return closest(elm, isElement);
	      }).exists(function (elm) {
	        return isPreValue(get$1(elm, 'white-space'));
	      });
	    };
	    var isAtBeginningOfBody = function (root, pos) {
	      return CaretFinder.prevPosition(root.dom(), pos).isNone();
	    };
	    var isAtEndOfBody = function (root, pos) {
	      return CaretFinder.nextPosition(root.dom(), pos).isNone();
	    };
	    var isAtLineBoundary = function (root, pos) {
	      return isAtBeginningOfBody(root, pos) || isAtEndOfBody(root, pos) || isAtStartOfBlock(root, pos) || isAtEndOfBlock(root, pos) || isAfterBr(root, pos) || isBeforeBr(root, pos);
	    };
	    var needsToHaveNbsp = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtLineBoundary(root, pos) || hasSpaceBefore(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbspLeft = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtStartOfBlock(root, pos) || isBeforeBlock(root, pos) || isAfterBr(root, pos) || hasSpaceBefore(root, pos);
	      }
	    };
	    var leanRight = function (pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (NodeType.isText(container) && offset < container.data.length) {
	        return CaretPosition(container, offset + 1);
	      } else {
	        return pos;
	      }
	    };
	    var needsToBeNbspRight = function (root, pos) {
	      var afterPos = leanRight(pos);
	      if (isInPre(afterPos)) {
	        return false;
	      } else {
	        return isAtEndOfBlock(root, afterPos) || isAfterBlock(root, afterPos) || isBeforeBr(root, afterPos) || hasSpaceAfter(root, afterPos);
	      }
	    };
	    var needsToBeNbsp = function (root, pos) {
	      return needsToBeNbspLeft(root, pos) || needsToBeNbspRight(root, pos);
	    };
	    var isNbspAt = function (text, offset) {
	      return isNbsp(text.charAt(offset));
	    };
	    var hasNbsp = function (pos) {
	      var container = pos.container();
	      return NodeType.isText(container) && contains$2(container.data, nbsp);
	    };
	    var normalizeNbspMiddle = function (text) {
	      var chars = text.split('');
	      return map(chars, function (chr, i) {
	        if (isNbsp(chr) && i > 0 && i < chars.length - 1 && isContent$1(chars[i - 1]) && isContent$1(chars[i + 1])) {
	          return ' ';
	        } else {
	          return chr;
	        }
	      }).join('');
	    };
	    var normalizeNbspAtStart = function (root, node) {
	      var text = node.data;
	      var firstPos = CaretPosition(node, 0);
	      if (isNbspAt(text, 0) && !needsToBeNbsp(root, firstPos)) {
	        node.data = ' ' + text.slice(1);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspInMiddleOfTextNode = function (node) {
	      var text = node.data;
	      var newText = normalizeNbspMiddle(text);
	      if (newText !== text) {
	        node.data = newText;
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspAtEnd = function (root, node) {
	      var text = node.data;
	      var lastPos = CaretPosition(node, text.length - 1);
	      if (isNbspAt(text, text.length - 1) && !needsToBeNbsp(root, lastPos)) {
	        node.data = text.slice(0, -1) + ' ';
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbsps = function (root, pos) {
	      return Option.some(pos).filter(hasNbsp).bind(function (pos) {
	        var container = pos.container();
	        var normalized = normalizeNbspAtStart(root, container) || normalizeNbspInMiddleOfTextNode(container) || normalizeNbspAtEnd(root, container);
	        return normalized ? Option.some(pos) : Option.none();
	      });
	    };
	    var normalizeNbspsInEditor = function (editor) {
	      var root = Element.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        normalizeNbsps(root, CaretPosition.fromRangeStart(editor.selection.getRng())).each(function (pos) {
	          editor.selection.setRng(pos.toRange());
	        });
	      }
	    };
	
	    var locationToCaretPosition = function (root) {
	      return function (location) {
	        return location.fold(function (element) {
	          return CaretFinder.prevPosition(root.dom(), CaretPosition$1.before(element));
	        }, function (element) {
	          return CaretFinder.firstPositionIn(element);
	        }, function (element) {
	          return CaretFinder.lastPositionIn(element);
	        }, function (element) {
	          return CaretFinder.nextPosition(root.dom(), CaretPosition$1.after(element));
	        });
	      };
	    };
	    var insertInlineBoundarySpaceOrNbsp = function (root, pos) {
	      return function (checkPos) {
	        return needsToHaveNbsp(root, checkPos) ? insertNbspAtPosition(pos) : insertSpaceAtPosition(pos);
	      };
	    };
	    var setSelection$1 = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        editor.nodeChanged();
	        return true;
	      };
	    };
	    var insertSpaceOrNbspAtSelection = function (editor) {
	      var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var root = Element.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	        var caretPosition = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        return BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), caretPosition).bind(locationToCaretPosition(root)).bind(insertInlineBoundarySpaceOrNbsp(root, pos)).exists(setSelection$1(editor));
	      } else {
	        return false;
	      }
	    };
	
	    var executeKeydownOverride$2 = function (editor, evt) {
	      MatchKeys.execute([{
	          keyCode: VK.SPACEBAR,
	          action: MatchKeys.action(insertSpaceOrNbspAtSelection, editor)
	        }], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$a = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$2(editor, evt);
	        }
	      });
	    };
	    var SpaceKey = { setup: setup$a };
	
	    var findBlockCaretContainer = function (editor) {
	      return descendant(Element.fromDom(editor.getBody()), '*[data-mce-caret]').fold(constant(null), function (elm) {
	        return elm.dom();
	      });
	    };
	    var removeIeControlRect = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var showBlockCaretContainer = function (editor, blockCaretContainer) {
	      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	        showCaretContainerBlock(blockCaretContainer);
	        removeIeControlRect(editor);
	        editor.selection.scrollIntoView(blockCaretContainer);
	      }
	    };
	    var handleBlockContainer = function (editor, e) {
	      var blockCaretContainer = findBlockCaretContainer(editor);
	      if (!blockCaretContainer) {
	        return;
	      }
	      if (e.type === 'compositionstart') {
	        e.preventDefault();
	        e.stopPropagation();
	        showBlockCaretContainer(editor, blockCaretContainer);
	        return;
	      }
	      if (hasContent(blockCaretContainer)) {
	        showBlockCaretContainer(editor, blockCaretContainer);
	        editor.undoManager.add();
	      }
	    };
	    var setup$b = function (editor) {
	      editor.on('keyup compositionstart', curry(handleBlockContainer, editor));
	    };
	    var CaretContainerInput = { setup: setup$b };
	
	    var browser$4 = PlatformDetection$1.detect().browser;
	    var setupIeInput = function (editor) {
	      var keypressThrotter = first(function () {
	        if (!editor.composing) {
	          normalizeNbspsInEditor(editor);
	        }
	      }, 0);
	      if (browser$4.isIE()) {
	        editor.on('keypress', function (e) {
	          keypressThrotter.throttle();
	        });
	        editor.on('remove', function (e) {
	          keypressThrotter.cancel();
	        });
	      }
	    };
	    var setup$c = function (editor) {
	      setupIeInput(editor);
	      editor.on('input', function (e) {
	        if (e.isComposing === false) {
	          normalizeNbspsInEditor(editor);
	        }
	      });
	    };
	
	    var executeKeydownOverride$3 = function (editor, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.END,
	          action: moveToLineEndPoint(editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: moveToLineEndPoint(editor, false)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$d = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$3(editor, evt);
	        }
	      });
	    };
	    var HomeEndKeys = { setup: setup$d };
	
	    var setup$e = function (editor) {
	      var caret = BoundarySelection.setupSelectedState(editor);
	      CaretContainerInput.setup(editor);
	      ArrowKeys.setup(editor, caret);
	      DeleteBackspaceKeys.setup(editor, caret);
	      EnterKey.setup(editor);
	      SpaceKey.setup(editor);
	      setup$c(editor);
	      HomeEndKeys.setup(editor);
	    };
	    var KeyboardOverrides = { setup: setup$e };
	
	    function Quirks (editor) {
	      var each = Tools.each;
	      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection, settings = editor.settings, parser = editor.parser;
	      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var mceInternalDataType = isIE ? 'Text' : 'URL';
	      var setEditorCommandState = function (cmd, state) {
	        try {
	          editor.getDoc().execCommand(cmd, false, state);
	        } catch (ex) {
	        }
	      };
	      var isDefaultPrevented = function (e) {
	        return e.isDefaultPrevented();
	      };
	      var setMceInternalContent = function (e) {
	        var selectionHtml, internalContent;
	        if (e.dataTransfer) {
	          if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
	            selection.select(e.target);
	          }
	          selectionHtml = editor.selection.getContent();
	          if (selectionHtml.length > 0) {
	            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
	            e.dataTransfer.setData(mceInternalDataType, internalContent);
	          }
	        }
	      };
	      var getMceInternalContent = function (e) {
	        var internalContent;
	        if (e.dataTransfer) {
	          internalContent = e.dataTransfer.getData(mceInternalDataType);
	          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
	            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	            return {
	              id: unescape(internalContent[0]),
	              html: unescape(internalContent[1])
	            };
	          }
	        }
	        return null;
	      };
	      var insertClipboardContents = function (content, internal) {
	        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
	          editor.execCommand('mceInsertClipboardContent', false, {
	            content: content,
	            internal: internal
	          });
	        } else {
	          editor.execCommand('mceInsertContent', false, content);
	        }
	      };
	      var emptyEditorWhenDeleting = function () {
	        var serializeRng = function (rng) {
	          var body = dom.create('body');
	          var contents = rng.cloneContents();
	          body.appendChild(contents);
	          return selection.serializer.serialize(body, { format: 'html' });
	        };
	        var allContentsSelected = function (rng) {
	          var selection = serializeRng(rng);
	          var allRng = dom.createRng();
	          allRng.selectNode(editor.getBody());
	          var allSelection = serializeRng(allRng);
	          return selection === allSelection;
	        };
	        editor.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          var isCollapsed, body;
	          if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
	            isCollapsed = editor.selection.isCollapsed();
	            body = editor.getBody();
	            if (isCollapsed && !dom.isEmpty(body)) {
	              return;
	            }
	            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
	              return;
	            }
	            e.preventDefault();
	            editor.setContent('');
	            if (body.firstChild && dom.isBlock(body.firstChild)) {
	              editor.selection.setCursorLocation(body.firstChild, 0);
	            } else {
	              editor.selection.setCursorLocation(body, 0);
	            }
	            editor.nodeChanged();
	          }
	        });
	      };
	      var selectAll = function () {
	        editor.shortcuts.add('meta+a', null, 'SelectAll');
	      };
	      var inputMethodFocus = function () {
	        if (!editor.settings.content_editable) {
	          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
	            var rng;
	            if (e.target === editor.getDoc().documentElement) {
	              rng = selection.getRng();
	              editor.getBody().focus();
	              if (e.type === 'mousedown') {
	                if (isCaretContainer(rng.startContainer)) {
	                  return;
	                }
	                selection.placeCaretAt(e.clientX, e.clientY);
	              } else {
	                selection.setRng(rng);
	              }
	            }
	          });
	        }
	      };
	      var removeHrOnBackspace = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (!editor.getBody().getElementsByTagName('hr').length) {
	              return;
	            }
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var node = selection.getNode();
	              var previousSibling = node.previousSibling;
	              if (node.nodeName === 'HR') {
	                dom.remove(node);
	                e.preventDefault();
	                return;
	              }
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
	                dom.remove(previousSibling);
	                e.preventDefault();
	              }
	            }
	          }
	        });
	      };
	      var focusBody = function () {
	        if (!domGlobals.Range.prototype.getClientRects) {
	          editor.on('mousedown', function (e) {
	            if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
	              var body_1 = editor.getBody();
	              body_1.blur();
	              Delay.setEditorTimeout(editor, function () {
	                body_1.focus();
	              });
	            }
	          });
	        }
	      };
	      var selectControlElements = function () {
	        editor.on('click', function (e) {
	          var target = e.target;
	          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
	            e.preventDefault();
	            editor.selection.select(target);
	            editor.nodeChanged();
	          }
	          if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
	            e.preventDefault();
	            selection.select(target);
	          }
	        });
	      };
	      var removeStylesWhenDeletingAcrossBlockElements = function () {
	        var getAttributeApplyFunction = function () {
	          var template = dom.getAttribs(selection.getStart().cloneNode(false));
	          return function () {
	            var target = selection.getStart();
	            if (target !== editor.getBody()) {
	              dom.setAttrib(target, 'style', null);
	              each(template, function (attr) {
	                target.setAttributeNode(attr.cloneNode(true));
	              });
	            }
	          };
	        };
	        var isSelectionAcrossElements = function () {
	          return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
	        };
	        editor.on('keypress', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            editor.getDoc().execCommand('delete', false, null);
	            applyAttributes();
	            e.preventDefault();
	            return false;
	          }
	        });
	        dom.bind(editor.getDoc(), 'cut', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            Delay.setEditorTimeout(editor, function () {
	              applyAttributes();
	            });
	          }
	        });
	      };
	      var disableBackspaceIntoATable = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var previousSibling = selection.getNode().previousSibling;
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
	                e.preventDefault();
	                return false;
	              }
	            }
	          }
	        });
	      };
	      var removeBlockQuoteOnBackSpace = function () {
	        editor.on('keydown', function (e) {
	          var rng, container, offset, root, parent;
	          if (isDefaultPrevented(e) || e.keyCode !== VK.BACKSPACE) {
	            return;
	          }
	          rng = selection.getRng();
	          container = rng.startContainer;
	          offset = rng.startOffset;
	          root = dom.getRoot();
	          parent = container;
	          if (!rng.collapsed || offset !== 0) {
	            return;
	          }
	          while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
	            parent = parent.parentNode;
	          }
	          if (parent.tagName === 'BLOCKQUOTE') {
	            editor.formatter.toggle('blockquote', null, parent);
	            rng = dom.createRng();
	            rng.setStart(container, 0);
	            rng.setEnd(container, 0);
	            selection.setRng(rng);
	          }
	        });
	      };
	      var setGeckoEditingOptions = function () {
	        var setOpts = function () {
	          setEditorCommandState('StyleWithCSS', false);
	          setEditorCommandState('enableInlineTableEditing', false);
	          if (!settings.object_resizing) {
	            setEditorCommandState('enableObjectResizing', false);
	          }
	        };
	        if (!settings.readonly) {
	          editor.on('BeforeExecCommand MouseDown', setOpts);
	        }
	      };
	      var addBrAfterLastLinks = function () {
	        var fixLinks = function () {
	          each(dom.select('a'), function (node) {
	            var parentNode = node.parentNode;
	            var root = dom.getRoot();
	            if (parentNode.lastChild === node) {
	              while (parentNode && !dom.isBlock(parentNode)) {
	                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
	                  return;
	                }
	                parentNode = parentNode.parentNode;
	              }
	              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
	            }
	          });
	        };
	        editor.on('SetContent ExecCommand', function (e) {
	          if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
	            fixLinks();
	          }
	        });
	      };
	      var setDefaultBlockType = function () {
	        if (settings.forced_root_block) {
	          editor.on('init', function () {
	            setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block);
	          });
	        }
	      };
	      var normalizeSelection = function () {
	        editor.on('keyup focusin mouseup', function (e) {
	          if (!VK.modifierPressed(e)) {
	            selection.normalize();
	          }
	        }, true);
	      };
	      var showBrokenImageIcon = function () {
	        editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
	      };
	      var restoreFocusOnKeyDown = function () {
	        if (!editor.inline) {
	          editor.on('keydown', function () {
	            if (domGlobals.document.activeElement === domGlobals.document.body) {
	              editor.getWin().focus();
	            }
	          });
	        }
	      };
	      var bodyHeight = function () {
	        if (!editor.inline) {
	          editor.contentStyles.push('body {min-height: 150px}');
	          editor.on('click', function (e) {
	            var rng;
	            if (e.target.nodeName === 'HTML') {
	              if (Env.ie > 11) {
	                editor.getBody().focus();
	                return;
	              }
	              rng = editor.selection.getRng();
	              editor.getBody().focus();
	              editor.selection.setRng(rng);
	              editor.selection.normalize();
	              editor.nodeChanged();
	            }
	          });
	        }
	      };
	      var blockCmdArrowNavigation = function () {
	        if (Env.mac) {
	          editor.on('keydown', function (e) {
	            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
	              e.preventDefault();
	              editor.selection.getSel().modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
	            }
	          });
	        }
	      };
	      var disableAutoUrlDetect = function () {
	        setEditorCommandState('AutoUrlDetect', false);
	      };
	      var tapLinksAndImages = function () {
	        editor.on('click', function (e) {
	          var elm = e.target;
	          do {
	            if (elm.tagName === 'A') {
	              e.preventDefault();
	              return;
	            }
	          } while (elm = elm.parentNode);
	        });
	        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
	      };
	      var blockFormSubmitInsideEditor = function () {
	        editor.on('init', function () {
	          editor.dom.bind(editor.getBody(), 'submit', function (e) {
	            e.preventDefault();
	          });
	        });
	      };
	      var removeAppleInterchangeBrs = function () {
	        parser.addNodeFilter('br', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            if (nodes[i].attr('class') === 'Apple-interchange-newline') {
	              nodes[i].remove();
	            }
	          }
	        });
	      };
	      var ieInternalDragAndDrop = function () {
	        editor.on('dragstart', function (e) {
	          setMceInternalContent(e);
	        });
	        editor.on('drop', function (e) {
	          if (!isDefaultPrevented(e)) {
	            var internalContent = getMceInternalContent(e);
	            if (internalContent && internalContent.id !== editor.id) {
	              e.preventDefault();
	              var rng = CaretRangeFromPoint.fromPoint(e.x, e.y, editor.getDoc());
	              selection.setRng(rng);
	              insertClipboardContents(internalContent.html, true);
	            }
	          }
	        });
	      };
	      var refreshContentEditable = function () {
	      };
	      var isHidden = function () {
	        var sel;
	        if (!isGecko || editor.removed) {
	          return 0;
	        }
	        sel = editor.selection.getSel();
	        return !sel || !sel.rangeCount || sel.rangeCount === 0;
	      };
	      removeBlockQuoteOnBackSpace();
	      emptyEditorWhenDeleting();
	      if (!Env.windowsPhone) {
	        normalizeSelection();
	      }
	      if (isWebKit) {
	        inputMethodFocus();
	        selectControlElements();
	        setDefaultBlockType();
	        blockFormSubmitInsideEditor();
	        disableBackspaceIntoATable();
	        removeAppleInterchangeBrs();
	        if (Env.iOS) {
	          restoreFocusOnKeyDown();
	          bodyHeight();
	          tapLinksAndImages();
	        } else {
	          selectAll();
	        }
	      }
	      if (Env.ie >= 11) {
	        bodyHeight();
	        disableBackspaceIntoATable();
	      }
	      if (Env.ie) {
	        selectAll();
	        disableAutoUrlDetect();
	        ieInternalDragAndDrop();
	      }
	      if (isGecko) {
	        removeHrOnBackspace();
	        focusBody();
	        removeStylesWhenDeletingAcrossBlockElements();
	        setGeckoEditingOptions();
	        addBrAfterLastLinks();
	        showBrokenImageIcon();
	        blockCmdArrowNavigation();
	        disableBackspaceIntoATable();
	      }
	      return {
	        refreshContentEditable: refreshContentEditable,
	        isHidden: isHidden
	      };
	    }
	
	    var isTextBlockNode = function (node) {
	      return NodeType.isElement(node) && isTextBlock(Element.fromDom(node));
	    };
	    var normalizeSelection$1 = function (editor) {
	      var rng = editor.selection.getRng();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      if (CaretPosition.isElementPosition(startPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          CaretFinder.firstPositionIn(container).each(function (pos) {
	            return rng.setStart(pos.container(), pos.offset());
	          });
	        }
	      }
	      if (CaretPosition.isElementPosition(endPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          CaretFinder.lastPositionIn(container).each(function (pos) {
	            return rng.setEnd(pos.container(), pos.offset());
	          });
	        }
	      }
	      editor.selection.setRng(RangeNormalizer.normalize(rng));
	    };
	    var setup$f = function (editor) {
	      editor.on('click', function (e) {
	        if (e.detail >= 3) {
	          normalizeSelection$1(editor);
	        }
	      });
	    };
	
	    var preventSummaryToggle = function (editor) {
	      editor.on('click', function (e) {
	        if (editor.dom.getParent(e.target, 'details')) {
	          e.preventDefault();
	        }
	      });
	    };
	    var filterDetails = function (editor) {
	      editor.parser.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          details.attr('data-mce-open', details.attr('open'));
	          details.attr('open', 'open');
	        });
	      });
	      editor.serializer.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          var open = details.attr('data-mce-open');
	          details.attr('open', isString(open) ? open : null);
	          details.attr('data-mce-open', null);
	        });
	      });
	    };
	    var setup$g = function (editor) {
	      preventSummaryToggle(editor);
	      filterDetails(editor);
	    };
	
	    var DOM$2 = DOMUtils$1.DOM;
	    var appendStyle = function (editor, text) {
	      var head = Element.fromDom(editor.getDoc().head);
	      var tag = Element.fromTag('style');
	      set(tag, 'type', 'text/css');
	      append(tag, Element.fromText(text));
	      append(head, tag);
	    };
	    var createParser = function (editor) {
	      var parser = DomParser(editor.settings, editor.schema);
	      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	        var dom = editor.dom;
	        var value, internalName;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(name);
	          internalName = 'data-mce-' + name;
	          if (!node.attributes.map[internalName]) {
	            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
	              continue;
	            }
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	              if (!value.length) {
	                value = null;
	              }
	              node.attr(internalName, value);
	              node.attr(name, value);
	            } else if (name === 'tabindex') {
	              node.attr(internalName, value);
	              node.attr(name, null);
	            } else {
	              node.attr(internalName, editor.convertURL(value, name, node.name));
	            }
	          }
	        }
	      });
	      parser.addNodeFilter('script', function (nodes) {
	        var i = nodes.length, node, type;
	        while (i--) {
	          node = nodes[i];
	          type = node.attr('type') || 'no/type';
	          if (type.indexOf('mce-') !== 0) {
	            node.attr('type', 'mce-' + type);
	          }
	        }
	      });
	      parser.addNodeFilter('#cdata', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.type = 8;
	          node.name = '#comment';
	          node.value = '[CDATA[' + node.value + ']]';
	        }
	      });
	      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
	        var i = nodes.length, node;
	        var nonEmptyElements = editor.schema.getNonEmptyElements();
	        while (i--) {
	          node = nodes[i];
	          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
	            node.append(new Node$1('br', 1)).shortEnded = true;
	          }
	        }
	      });
	      return parser;
	    };
	    var autoFocus = function (editor) {
	      if (editor.settings.auto_focus) {
	        Delay.setEditorTimeout(editor, function () {
	          var focusEditor;
	          if (editor.settings.auto_focus === true) {
	            focusEditor = editor;
	          } else {
	            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
	          }
	          if (!focusEditor.destroyed) {
	            focusEditor.focus();
	          }
	        }, 100);
	      }
	    };
	    var initEditor = function (editor) {
	      editor.bindPendingEventDelegates();
	      editor.initialized = true;
	      editor.fire('init');
	      editor.focus(true);
	      editor.nodeChanged({ initial: true });
	      editor.execCallback('init_instance_callback', editor);
	      autoFocus(editor);
	    };
	    var getStyleSheetLoader = function (editor) {
	      return editor.inline ? DOM$2.styleSheetLoader : editor.dom.styleSheetLoader;
	    };
	    var initContentBody = function (editor, skipWrite) {
	      var settings = editor.settings;
	      var targetElm = editor.getElement();
	      var doc = editor.getDoc(), body, contentCssText;
	      if (!settings.inline) {
	        editor.getElement().style.visibility = editor.orgVisibility;
	      }
	      if (!skipWrite && !settings.content_editable) {
	        doc.open();
	        doc.write(editor.iframeHTML);
	        doc.close();
	      }
	      if (settings.content_editable) {
	        editor.on('remove', function () {
	          var bodyEl = this.getBody();
	          DOM$2.removeClass(bodyEl, 'mce-content-body');
	          DOM$2.removeClass(bodyEl, 'mce-edit-focus');
	          DOM$2.setAttrib(bodyEl, 'contentEditable', null);
	        });
	        DOM$2.addClass(targetElm, 'mce-content-body');
	        editor.contentDocument = doc = settings.content_document || domGlobals.document;
	        editor.contentWindow = settings.content_window || domGlobals.window;
	        editor.bodyElement = targetElm;
	        settings.content_document = settings.content_window = null;
	        settings.root_name = targetElm.nodeName.toLowerCase();
	      }
	      body = editor.getBody();
	      body.disabled = true;
	      editor.readonly = settings.readonly;
	      if (!editor.readonly) {
	        if (editor.inline && DOM$2.getStyle(body, 'position', true) === 'static') {
	          body.style.position = 'relative';
	        }
	        body.contentEditable = editor.getParam('content_editable_state', true);
	      }
	      body.disabled = false;
	      editor.editorUpload = EditorUpload(editor);
	      editor.schema = Schema(settings);
	      editor.dom = DOMUtils$1(doc, {
	        keep_values: true,
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        hex_colors: settings.force_hex_style_colors,
	        class_filter: settings.class_filter,
	        update_styles: true,
	        root_element: editor.inline ? editor.getBody() : null,
	        collect: settings.content_editable,
	        schema: editor.schema,
	        contentCssCors: Settings.shouldUseContentCssCors(editor),
	        onSetAttrib: function (e) {
	          editor.fire('SetAttrib', e);
	        }
	      });
	      editor.parser = createParser(editor);
	      editor.serializer = DomSerializer$1(settings, editor);
	      editor.selection = Selection$1(editor.dom, editor.getWin(), editor.serializer, editor);
	      editor.annotator = Annotator(editor);
	      editor.formatter = Formatter(editor);
	      editor.undoManager = UndoManager(editor);
	      editor._nodeChangeDispatcher = new NodeChange(editor);
	      editor._selectionOverrides = SelectionOverrides(editor);
	      setup$g(editor);
	      setup$f(editor);
	      KeyboardOverrides.setup(editor);
	      ForceBlocks.setup(editor);
	      editor.fire('PreInit');
	      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
	        doc.body.spellcheck = false;
	        DOM$2.setAttrib(body, 'spellcheck', 'false');
	      }
	      editor.quirks = Quirks(editor);
	      editor.fire('PostRender');
	      if (settings.directionality) {
	        body.dir = settings.directionality;
	      }
	      if (settings.nowrap) {
	        body.style.whiteSpace = 'nowrap';
	      }
	      if (settings.protect) {
	        editor.on('BeforeSetContent', function (e) {
	          Tools.each(settings.protect, function (pattern) {
	            e.content = e.content.replace(pattern, function (str) {
	              return '<!--mce:protected ' + escape(str) + '-->';
	            });
	          });
	        });
	      }
	      editor.on('SetContent', function () {
	        editor.addVisual(editor.getBody());
	      });
	      editor.load({
	        initial: true,
	        format: 'html'
	      });
	      editor.startContent = editor.getContent({ format: 'raw' });
	      editor.on('compositionstart compositionend', function (e) {
	        editor.composing = e.type === 'compositionstart';
	      });
	      if (editor.contentStyles.length > 0) {
	        contentCssText = '';
	        Tools.each(editor.contentStyles, function (style) {
	          contentCssText += style + '\r\n';
	        });
	        editor.dom.addStyle(contentCssText);
	      }
	      getStyleSheetLoader(editor).loadAll(editor.contentCSS, function (_) {
	        initEditor(editor);
	      }, function (urls) {
	        initEditor(editor);
	      });
	      if (settings.content_style) {
	        appendStyle(editor, settings.content_style);
	      }
	    };
	    var InitContentBody = { initContentBody: initContentBody };
	
	    var DOM$3 = DOMUtils$1.DOM;
	    var relaxDomain = function (editor, ifr) {
	      if (domGlobals.document.domain !== domGlobals.window.location.hostname && Env.ie && Env.ie < 12) {
	        var bodyUuid = Uuid.uuid('mce');
	        editor[bodyUuid] = function () {
	          InitContentBody.initContentBody(editor);
	        };
	        var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + domGlobals.document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
	        DOM$3.setAttrib(ifr, 'src', domainRelaxUrl);
	        return true;
	      }
	      return false;
	    };
	    var normalizeHeight = function (height) {
	      var normalizedHeight = typeof height === 'number' ? height + 'px' : height;
	      return normalizedHeight ? normalizedHeight : '';
	    };
	    var createIframeElement = function (id, title, height, customAttrs) {
	      var iframe = Element.fromTag('iframe');
	      setAll(iframe, customAttrs);
	      setAll(iframe, {
	        id: id + '_ifr',
	        frameBorder: '0',
	        allowTransparency: 'true',
	        title: title
	      });
	      setAll$1(iframe, {
	        width: '100%',
	        height: normalizeHeight(height),
	        display: 'block'
	      });
	      return iframe;
	    };
	    var getIframeHtml = function (editor) {
	      var bodyId, bodyClass, iframeHTML;
	      iframeHTML = Settings.getDocType(editor) + '<html><head>';
	      if (Settings.getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
	        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
	      }
	      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	      bodyId = Settings.getBodyId(editor);
	      bodyClass = Settings.getBodyClass(editor);
	      if (Settings.getContentSecurityPolicy(editor)) {
	        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + Settings.getContentSecurityPolicy(editor) + '" />';
	      }
	      iframeHTML += '</head><body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '"><br></body></html>';
	      return iframeHTML;
	    };
	    var createIframe = function (editor, o) {
	      var title = editor.editorManager.translate('Rich Text Area. Press ALT-F9 for menu. ' + 'Press ALT-F10 for toolbar. Press ALT-0 for help');
	      var ifr = createIframeElement(editor.id, title, o.height, Settings.getIframeAttrs(editor)).dom();
	      ifr.onload = function () {
	        ifr.onload = null;
	        editor.fire('load');
	      };
	      var isDomainRelaxed = relaxDomain(editor, ifr);
	      editor.contentAreaContainer = o.iframeContainer;
	      editor.iframeElement = ifr;
	      editor.iframeHTML = getIframeHtml(editor);
	      DOM$3.add(o.iframeContainer, ifr);
	      return isDomainRelaxed;
	    };
	    var init$1 = function (editor, boxInfo) {
	      var isDomainRelaxed = createIframe(editor, boxInfo);
	      if (boxInfo.editorContainer) {
	        DOM$3.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
	        editor.hidden = DOM$3.isHidden(boxInfo.editorContainer);
	      }
	      editor.getElement().style.display = 'none';
	      DOM$3.setAttrib(editor.id, 'aria-hidden', 'true');
	      if (!isDomainRelaxed) {
	        InitContentBody.initContentBody(editor);
	      }
	    };
	    var InitIframe = { init: init$1 };
	
	    var DOM$4 = DOMUtils$1.DOM;
	    var initPlugin = function (editor, initializedPlugins, plugin) {
	      var Plugin = PluginManager$1.get(plugin);
	      var pluginUrl = PluginManager$1.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
	      plugin = Tools.trim(plugin);
	      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
	        Tools.each(PluginManager$1.dependencies(plugin), function (dep) {
	          initPlugin(editor, initializedPlugins, dep);
	        });
	        if (editor.plugins[plugin]) {
	          return;
	        }
	        try {
	          var pluginInstance = new Plugin(editor, pluginUrl, editor.$);
	          editor.plugins[plugin] = pluginInstance;
	          if (pluginInstance.init) {
	            pluginInstance.init(editor, pluginUrl);
	            initializedPlugins.push(plugin);
	          }
	        } catch (e) {
	          ErrorReporter.pluginInitError(editor, plugin, e);
	        }
	      }
	    };
	    var trimLegacyPrefix = function (name) {
	      return name.replace(/^\-/, '');
	    };
	    var initPlugins = function (editor) {
	      var initializedPlugins = [];
	      Tools.each(editor.settings.plugins.split(/[ ,]/), function (name) {
	        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
	      });
	    };
	    var initTheme = function (editor) {
	      var Theme;
	      var theme = editor.settings.theme;
	      if (isString(theme)) {
	        editor.settings.theme = trimLegacyPrefix(theme);
	        Theme = ThemeManager.get(theme);
	        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
	        if (editor.theme.init) {
	          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
	        }
	      } else {
	        editor.theme = {};
	      }
	    };
	    var renderFromLoadedTheme = function (editor) {
	      var w, h, minHeight, re, info;
	      var settings = editor.settings;
	      var elm = editor.getElement();
	      w = settings.width || DOM$4.getStyle(elm, 'width') || '100%';
	      h = settings.height || DOM$4.getStyle(elm, 'height') || elm.offsetHeight;
	      minHeight = settings.min_height || 100;
	      re = /^[0-9\.]+(|px)$/i;
	      if (re.test('' + w)) {
	        w = Math.max(parseInt(w, 10), 100);
	      }
	      if (re.test('' + h)) {
	        h = Math.max(parseInt(h, 10), minHeight);
	      }
	      info = editor.theme.renderUI({
	        targetNode: elm,
	        width: w,
	        height: h,
	        deltaWidth: settings.delta_width,
	        deltaHeight: settings.delta_height
	      });
	      if (!settings.content_editable) {
	        h = (info.iframeHeight || h) + (typeof h === 'number' ? info.deltaHeight || 0 : '');
	        if (h < minHeight) {
	          h = minHeight;
	        }
	      }
	      info.height = h;
	      return info;
	    };
	    var renderFromThemeFunc = function (editor) {
	      var info;
	      var elm = editor.getElement();
	      info = editor.settings.theme(editor, elm);
	      if (info.editorContainer.nodeType) {
	        info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
	      }
	      if (info.iframeContainer && info.iframeContainer.nodeType) {
	        info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
	      }
	      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
	      return info;
	    };
	    var createThemeFalseResult = function (element) {
	      return {
	        editorContainer: element,
	        iframeContainer: element
	      };
	    };
	    var renderThemeFalseIframe = function (targetElement) {
	      var iframeContainer = DOM$4.create('div');
	      DOM$4.insertAfter(iframeContainer, targetElement);
	      return createThemeFalseResult(iframeContainer);
	    };
	    var renderThemeFalse = function (editor) {
	      var targetElement = editor.getElement();
	      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
	    };
	    var renderThemeUi = function (editor) {
	      var settings = editor.settings, elm = editor.getElement();
	      editor.orgDisplay = elm.style.display;
	      if (isString(settings.theme)) {
	        return renderFromLoadedTheme(editor);
	      } else if (isFunction(settings.theme)) {
	        return renderFromThemeFunc(editor);
	      } else {
	        return renderThemeFalse(editor);
	      }
	    };
	    var init$2 = function (editor) {
	      var settings = editor.settings;
	      var elm = editor.getElement();
	      var boxInfo;
	      editor.rtl = settings.rtl_ui || editor.editorManager.i18n.rtl;
	      editor.editorManager.i18n.setCode(settings.language);
	      settings.aria_label = settings.aria_label || DOM$4.getAttrib(elm, 'aria-label', editor.getLang('aria.rich_text_area'));
	      editor.fire('ScriptsLoaded');
	      initTheme(editor);
	      initPlugins(editor);
	      boxInfo = renderThemeUi(editor);
	      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
	      if (settings.content_css) {
	        Tools.each(Tools.explode(settings.content_css), function (u) {
	          editor.contentCSS.push(editor.documentBaseURI.toAbsolute(u));
	        });
	      }
	      if (settings.content_editable) {
	        return InitContentBody.initContentBody(editor);
	      } else {
	        return InitIframe.init(editor, boxInfo);
	      }
	    };
	    var Init = { init: init$2 };
	
	    var DOM$5 = DOMUtils$1.DOM;
	    var hasSkipLoadPrefix = function (name) {
	      return name.charAt(0) === '-';
	    };
	    var loadLanguage = function (scriptLoader, editor) {
	      var settings = editor.settings;
	      if (settings.language && settings.language !== 'en' && !settings.language_url) {
	        settings.language_url = editor.editorManager.baseURL + '/langs/' + settings.language + '.js';
	      }
	      if (settings.language_url && !editor.editorManager.i18n.data[settings.language]) {
	        scriptLoader.add(settings.language_url);
	      }
	    };
	    var loadTheme = function (scriptLoader, editor, suffix, callback) {
	      var settings = editor.settings, theme = settings.theme;
	      if (isString(theme)) {
	        if (!hasSkipLoadPrefix(theme) && !ThemeManager.urls.hasOwnProperty(theme)) {
	          var themeUrl = settings.theme_url;
	          if (themeUrl) {
	            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
	          } else {
	            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
	          }
	        }
	        scriptLoader.loadQueue(function () {
	          ThemeManager.waitFor(theme, callback);
	        });
	      } else {
	        callback();
	      }
	    };
	    var loadPlugins = function (settings, suffix) {
	      if (Tools.isArray(settings.plugins)) {
	        settings.plugins = settings.plugins.join(' ');
	      }
	      Tools.each(settings.external_plugins, function (url, name) {
	        PluginManager$1.load(name, url);
	        settings.plugins += ' ' + name;
	      });
	      Tools.each(settings.plugins.split(/[ ,]/), function (plugin) {
	        plugin = Tools.trim(plugin);
	        if (plugin && !PluginManager$1.urls[plugin]) {
	          if (hasSkipLoadPrefix(plugin)) {
	            plugin = plugin.substr(1, plugin.length);
	            var dependencies = PluginManager$1.dependencies(plugin);
	            Tools.each(dependencies, function (dep) {
	              var defaultSettings = {
	                prefix: 'plugins/',
	                resource: dep,
	                suffix: '/plugin' + suffix + '.js'
	              };
	              dep = PluginManager$1.createUrl(defaultSettings, dep);
	              PluginManager$1.load(dep.resource, dep);
	            });
	          } else {
	            PluginManager$1.load(plugin, {
	              prefix: 'plugins/',
	              resource: plugin,
	              suffix: '/plugin' + suffix + '.js'
	            });
	          }
	        }
	      });
	    };
	    var loadScripts = function (editor, suffix) {
	      var scriptLoader = ScriptLoader.ScriptLoader;
	      loadTheme(scriptLoader, editor, suffix, function () {
	        loadLanguage(scriptLoader, editor);
	        loadPlugins(editor.settings, suffix);
	        scriptLoader.loadQueue(function () {
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        }, editor, function (urls) {
	          ErrorReporter.pluginLoadError(editor, urls[0]);
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        });
	      });
	    };
	    var render = function (editor) {
	      var settings = editor.settings, id = editor.id;
	      var readyHandler = function () {
	        DOM$5.unbind(domGlobals.window, 'ready', readyHandler);
	        editor.render();
	      };
	      if (!EventUtils.Event.domLoaded) {
	        DOM$5.bind(domGlobals.window, 'ready', readyHandler);
	        return;
	      }
	      if (!editor.getElement()) {
	        return;
	      }
	      if (!Env.contentEditable) {
	        return;
	      }
	      if (!settings.inline) {
	        editor.orgVisibility = editor.getElement().style.visibility;
	        editor.getElement().style.visibility = 'hidden';
	      } else {
	        editor.inline = true;
	      }
	      var form = editor.getElement().form || DOM$5.getParent(id, 'form');
	      if (form) {
	        editor.formElement = form;
	        if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(editor.getElement().nodeName)) {
	          DOM$5.insertAfter(DOM$5.create('input', {
	            type: 'hidden',
	            name: id
	          }), id);
	          editor.hasHiddenInput = true;
	        }
	        editor.formEventDelegate = function (e) {
	          editor.fire(e.type, e);
	        };
	        DOM$5.bind(form, 'submit reset', editor.formEventDelegate);
	        editor.on('reset', function () {
	          editor.setContent(editor.startContent, { format: 'raw' });
	        });
	        if (settings.submit_patch && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
	          form._mceOldSubmit = form.submit;
	          form.submit = function () {
	            editor.editorManager.triggerSave();
	            editor.setDirty(false);
	            return form._mceOldSubmit(form);
	          };
	        }
	      }
	      editor.windowManager = WindowManager(editor);
	      editor.notificationManager = NotificationManager(editor);
	      if (settings.encoding === 'xml') {
	        editor.on('GetContent', function (e) {
	          if (e.save) {
	            e.content = DOM$5.encode(e.content);
	          }
	        });
	      }
	      if (settings.add_form_submit_trigger) {
	        editor.on('submit', function () {
	          if (editor.initialized) {
	            editor.save();
	          }
	        });
	      }
	      if (settings.add_unload_trigger) {
	        editor._beforeUnload = function () {
	          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
	            editor.save({
	              format: 'raw',
	              no_events: true,
	              set_dirty: false
	            });
	          }
	        };
	        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
	      }
	      editor.editorManager.add(editor);
	      loadScripts(editor, editor.suffix);
	    };
	    var Render = { render: render };
	
	    var add$4 = function (editor, name, settings) {
	      var sidebars = editor.sidebars ? editor.sidebars : [];
	      sidebars.push({
	        name: name,
	        settings: settings
	      });
	      editor.sidebars = sidebars;
	    };
	    var Sidebar = { add: add$4 };
	
	    var each$k = Tools.each, trim$4 = Tools.trim;
	    var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
	    var DEFAULT_PORTS = {
	      ftp: 21,
	      http: 80,
	      https: 443,
	      mailto: 25
	    };
	    var URI = function (url, settings) {
	      var self = this;
	      var baseUri, baseUrl;
	      url = trim$4(url);
	      settings = self.settings = settings || {};
	      baseUri = settings.base_uri;
	      if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
	        self.source = url;
	        return;
	      }
	      var isProtocolRelative = url.indexOf('//') === 0;
	      if (url.indexOf('/') === 0 && !isProtocolRelative) {
	        url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
	      }
	      if (!/^[\w\-]*:?\/\//.test(url)) {
	        baseUrl = settings.base_uri ? settings.base_uri.path : new URI(domGlobals.document.location.href).directory;
	        if (settings.base_uri.protocol == '') {
	          url = '//mce_host' + self.toAbsPath(baseUrl, url);
	        } else {
	          url = /([^#?]*)([#?]?.*)/.exec(url);
	          url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, url[1]) + url[2];
	        }
	      }
	      url = url.replace(/@@/g, '(mce_at)');
	      url = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	      each$k(queryParts, function (v, i) {
	        var part = url[i];
	        if (part) {
	          part = part.replace(/\(mce_at\)/g, '@@');
	        }
	        self[v] = part;
	      });
	      if (baseUri) {
	        if (!self.protocol) {
	          self.protocol = baseUri.protocol;
	        }
	        if (!self.userInfo) {
	          self.userInfo = baseUri.userInfo;
	        }
	        if (!self.port && self.host === 'mce_host') {
	          self.port = baseUri.port;
	        }
	        if (!self.host || self.host === 'mce_host') {
	          self.host = baseUri.host;
	        }
	        self.source = '';
	      }
	      if (isProtocolRelative) {
	        self.protocol = '';
	      }
	    };
	    URI.prototype = {
	      setPath: function (path) {
	        var self = this;
	        path = /^(.*?)\/?(\w+)?$/.exec(path);
	        self.path = path[0];
	        self.directory = path[1];
	        self.file = path[2];
	        self.source = '';
	        self.getURI();
	      },
	      toRelative: function (uri) {
	        var self = this;
	        var output;
	        if (uri === './') {
	          return uri;
	        }
	        uri = new URI(uri, { base_uri: self });
	        if (uri.host !== 'mce_host' && self.host !== uri.host && uri.host || self.port !== uri.port || self.protocol !== uri.protocol && uri.protocol !== '') {
	          return uri.getURI();
	        }
	        var tu = self.getURI(), uu = uri.getURI();
	        if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
	          return tu;
	        }
	        output = self.toRelPath(self.path, uri.path);
	        if (uri.query) {
	          output += '?' + uri.query;
	        }
	        if (uri.anchor) {
	          output += '#' + uri.anchor;
	        }
	        return output;
	      },
	      toAbsolute: function (uri, noHost) {
	        uri = new URI(uri, { base_uri: this });
	        return uri.getURI(noHost && this.isSameOrigin(uri));
	      },
	      isSameOrigin: function (uri) {
	        if (this.host == uri.host && this.protocol == uri.protocol) {
	          if (this.port == uri.port) {
	            return true;
	          }
	          var defaultPort = DEFAULT_PORTS[this.protocol];
	          if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
	            return true;
	          }
	        }
	        return false;
	      },
	      toRelPath: function (base, path) {
	        var items, breakPoint = 0, out = '', i, l;
	        base = base.substring(0, base.lastIndexOf('/'));
	        base = base.split('/');
	        items = path.split('/');
	        if (base.length >= items.length) {
	          for (i = 0, l = base.length; i < l; i++) {
	            if (i >= items.length || base[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (base.length < items.length) {
	          for (i = 0, l = items.length; i < l; i++) {
	            if (i >= base.length || base[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (breakPoint === 1) {
	          return path;
	        }
	        for (i = 0, l = base.length - (breakPoint - 1); i < l; i++) {
	          out += '../';
	        }
	        for (i = breakPoint - 1, l = items.length; i < l; i++) {
	          if (i !== breakPoint - 1) {
	            out += '/' + items[i];
	          } else {
	            out += items[i];
	          }
	        }
	        return out;
	      },
	      toAbsPath: function (base, path) {
	        var i, nb = 0, o = [], tr, outPath;
	        tr = /\/$/.test(path) ? '/' : '';
	        base = base.split('/');
	        path = path.split('/');
	        each$k(base, function (k) {
	          if (k) {
	            o.push(k);
	          }
	        });
	        base = o;
	        for (i = path.length - 1, o = []; i >= 0; i--) {
	          if (path[i].length === 0 || path[i] === '.') {
	            continue;
	          }
	          if (path[i] === '..') {
	            nb++;
	            continue;
	          }
	          if (nb > 0) {
	            nb--;
	            continue;
	          }
	          o.push(path[i]);
	        }
	        i = base.length - nb;
	        if (i <= 0) {
	          outPath = o.reverse().join('/');
	        } else {
	          outPath = base.slice(0, i).join('/') + '/' + o.reverse().join('/');
	        }
	        if (outPath.indexOf('/') !== 0) {
	          outPath = '/' + outPath;
	        }
	        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
	          outPath += tr;
	        }
	        return outPath;
	      },
	      getURI: function (noProtoHost) {
	        var s;
	        var self = this;
	        if (!self.source || noProtoHost) {
	          s = '';
	          if (!noProtoHost) {
	            if (self.protocol) {
	              s += self.protocol + '://';
	            } else {
	              s += '//';
	            }
	            if (self.userInfo) {
	              s += self.userInfo + '@';
	            }
	            if (self.host) {
	              s += self.host;
	            }
	            if (self.port) {
	              s += ':' + self.port;
	            }
	          }
	          if (self.path) {
	            s += self.path;
	          }
	          if (self.query) {
	            s += '?' + self.query;
	          }
	          if (self.anchor) {
	            s += '#' + self.anchor;
	          }
	          self.source = s;
	        }
	        return self.source;
	      }
	    };
	    URI.parseDataUri = function (uri) {
	      var type, matches;
	      uri = decodeURIComponent(uri).split(',');
	      matches = /data:([^;]+)/.exec(uri[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uri[1]
	      };
	    };
	    URI.getDocumentBaseUrl = function (loc) {
	      var baseUrl;
	      if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
	        baseUrl = loc.href;
	      } else {
	        baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
	      }
	      if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
	        baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	        if (!/[\/\\]$/.test(baseUrl)) {
	          baseUrl += '/';
	        }
	      }
	      return baseUrl;
	    };
	
	    var defaultFormat = 'html';
	    var trimEmptyContents = function (editor, html) {
	      var blockName = Settings.getForcedRootBlock(editor);
	      var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
	      return html.replace(emptyRegExp, '');
	    };
	    var getContentFromBody = function (editor, args, body) {
	      var content;
	      args.format = args.format ? args.format : defaultFormat;
	      args.get = true;
	      args.getInner = true;
	      if (!args.no_events) {
	        editor.fire('BeforeGetContent', args);
	      }
	      if (args.format === 'raw') {
	        content = Tools.trim(TrimHtml.trimExternal(editor.serializer, body.innerHTML));
	      } else if (args.format === 'text') {
	        content = Zwsp.trim(body.innerText || body.textContent);
	      } else if (args.format === 'tree') {
	        return editor.serializer.serialize(body, args);
	      } else {
	        content = trimEmptyContents(editor, editor.serializer.serialize(body, args));
	      }
	      if (args.format !== 'text' && !isWsPreserveElement(Element.fromDom(body))) {
	        args.content = Tools.trim(content);
	      } else {
	        args.content = content;
	      }
	      if (!args.no_events) {
	        editor.fire('GetContent', args);
	      }
	      return args.content;
	    };
	    var getContent$1 = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      return Option.from(editor.getBody()).fold(constant(args.format === 'tree' ? new Node$1('body', 11) : ''), function (body) {
	        return getContentFromBody(editor, args, body);
	      });
	    };
	
	    var traverse = function (node, fn) {
	      fn(node);
	      if (node.firstChild) {
	        traverse(node.firstChild, fn);
	      }
	      if (node.next) {
	        traverse(node.next, fn);
	      }
	    };
	    var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
	      var nodeMatches = {};
	      var attrMatches = {};
	      var matches = [];
	      if (node.firstChild) {
	        traverse(node.firstChild, function (node) {
	          each(nodeFilters, function (filter) {
	            if (filter.name === node.name) {
	              if (nodeMatches[filter.name]) {
	                nodeMatches[filter.name].nodes.push(node);
	              } else {
	                nodeMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	          each(attributeFilters, function (filter) {
	            if (typeof node.attr(filter.name) === 'string') {
	              if (attrMatches[filter.name]) {
	                attrMatches[filter.name].nodes.push(node);
	              } else {
	                attrMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	        });
	      }
	      for (var name in nodeMatches) {
	        if (nodeMatches.hasOwnProperty(name)) {
	          matches.push(nodeMatches[name]);
	        }
	      }
	      for (var name in attrMatches) {
	        if (attrMatches.hasOwnProperty(name)) {
	          matches.push(attrMatches[name]);
	        }
	      }
	      return matches;
	    };
	    var filter$3 = function (nodeFilters, attributeFilters, node) {
	      var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
	      each(matches, function (match) {
	        each(match.filter.callbacks, function (callback) {
	          callback(match.nodes, match.filter.name, {});
	        });
	      });
	    };
	
	    var defaultFormat$1 = 'html';
	    var isTreeNode = function (content) {
	      return content instanceof Node$1;
	    };
	    var moveSelection = function (editor) {
	      if (EditorFocus.hasFocus(editor)) {
	        CaretFinder.firstPositionIn(editor.getBody()).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = NodeType.isTable(node) ? CaretFinder.firstPositionIn(node).getOr(pos) : pos;
	          editor.selection.setRng(caretPos.toRange());
	        });
	      }
	    };
	    var setEditorHtml = function (editor, html) {
	      editor.dom.setHTML(editor.getBody(), html);
	      moveSelection(editor);
	    };
	    var setContentString = function (editor, body, content, args) {
	      var forcedRootBlockName, padd;
	      if (content.length === 0 || /^\s+$/.test(content)) {
	        padd = '<br data-mce-bogus="1">';
	        if (body.nodeName === 'TABLE') {
	          content = '<tr><td>' + padd + '</td></tr>';
	        } else if (/^(UL|OL)$/.test(body.nodeName)) {
	          content = '<li>' + padd + '</li>';
	        }
	        forcedRootBlockName = Settings.getForcedRootBlock(editor);
	        if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
	          content = padd;
	          content = editor.dom.createHTML(forcedRootBlockName, editor.settings.forced_root_block_attrs, content);
	        } else if (!content) {
	          content = '<br data-mce-bogus="1">';
	        }
	        setEditorHtml(editor, content);
	        editor.fire('SetContent', args);
	      } else {
	        if (args.format !== 'raw') {
	          content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
	            isRootContent: true,
	            insert: true
	          }));
	        }
	        args.content = isWsPreserveElement(Element.fromDom(body)) ? content : Tools.trim(content);
	        setEditorHtml(editor, args.content);
	        if (!args.no_events) {
	          editor.fire('SetContent', args);
	        }
	      }
	      return args.content;
	    };
	    var setContentTree = function (editor, body, content, args) {
	      filter$3(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
	      var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
	      args.content = isWsPreserveElement(Element.fromDom(body)) ? html : Tools.trim(html);
	      setEditorHtml(editor, args.content);
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	      return content;
	    };
	    var setContent$1 = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      args.format = args.format ? args.format : defaultFormat$1;
	      args.set = true;
	      args.content = isTreeNode(content) ? '' : content;
	      if (!isTreeNode(content) && !args.no_events) {
	        editor.fire('BeforeSetContent', args);
	        content = args.content;
	      }
	      return Option.from(editor.getBody()).fold(constant(content), function (body) {
	        return isTreeNode(content) ? setContentTree(editor, body, content, args) : setContentString(editor, body, content, args);
	      });
	    };
	
	    var DOM$6 = DOMUtils$1.DOM;
	    var restoreOriginalStyles = function (editor) {
	      DOM$6.setStyle(editor.id, 'display', editor.orgDisplay);
	    };
	    var safeDestroy = function (x) {
	      return Option.from(x).each(function (x) {
	        return x.destroy();
	      });
	    };
	    var clearDomReferences = function (editor) {
	      editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
	      editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
	      editor.iframeElement = editor.targetElm = null;
	      if (editor.selection) {
	        editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
	      }
	    };
	    var restoreForm = function (editor) {
	      var form = editor.formElement;
	      if (form) {
	        if (form._mceOldSubmit) {
	          form.submit = form._mceOldSubmit;
	          form._mceOldSubmit = null;
	        }
	        DOM$6.unbind(form, 'submit reset', editor.formEventDelegate);
	      }
	    };
	    var remove$7 = function (editor) {
	      if (!editor.removed) {
	        var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
	        var body = editor.getBody();
	        var element = editor.getElement();
	        if (body) {
	          editor.save({ is_removing: true });
	        }
	        editor.removed = true;
	        editor.unbindAllNativeEvents();
	        if (editor.hasHiddenInput && element) {
	          DOM$6.remove(element.nextSibling);
	        }
	        Events.fireRemove(editor);
	        editor.editorManager.remove(editor);
	        if (!editor.inline && body) {
	          restoreOriginalStyles(editor);
	        }
	        Events.fireDetach(editor);
	        DOM$6.remove(editor.getContainer());
	        safeDestroy(_selectionOverrides);
	        safeDestroy(editorUpload);
	        editor.destroy();
	      }
	    };
	    var destroy = function (editor, automatic) {
	      var selection = editor.selection, dom = editor.dom;
	      if (editor.destroyed) {
	        return;
	      }
	      if (!automatic && !editor.removed) {
	        editor.remove();
	        return;
	      }
	      if (!automatic) {
	        editor.editorManager.off('beforeunload', editor._beforeUnload);
	        if (editor.theme && editor.theme.destroy) {
	          editor.theme.destroy();
	        }
	        safeDestroy(selection);
	        safeDestroy(dom);
	      }
	      restoreForm(editor);
	      clearDomReferences(editor);
	      editor.destroyed = true;
	    };
	
	    var DOM$7 = DOMUtils$1.DOM;
	    var extend$4 = Tools.extend, each$l = Tools.each;
	    var resolve$4 = Tools.resolve;
	    var ie$2 = Env.ie;
	    var Editor = function (id, settings, editorManager) {
	      var self = this;
	      var documentBaseUrl = self.documentBaseUrl = editorManager.documentBaseURL;
	      var baseUri = editorManager.baseURI;
	      settings = getEditorSettings(self, id, documentBaseUrl, editorManager.defaultSettings, settings);
	      self.settings = settings;
	      AddOnManager.language = settings.language || 'en';
	      AddOnManager.languageLoad = settings.language_load;
	      AddOnManager.baseURL = editorManager.baseURL;
	      self.id = id;
	      self.setDirty(false);
	      self.plugins = {};
	      self.documentBaseURI = new URI(settings.document_base_url, { base_uri: baseUri });
	      self.baseURI = baseUri;
	      self.contentCSS = [];
	      self.contentStyles = [];
	      self.shortcuts = new Shortcuts(self);
	      self.loadedCSS = {};
	      self.editorCommands = new EditorCommands(self);
	      self.suffix = editorManager.suffix;
	      self.editorManager = editorManager;
	      self.inline = settings.inline;
	      self.buttons = {};
	      self.menuItems = {};
	      if (settings.cache_suffix) {
	        Env.cacheSuffix = settings.cache_suffix.replace(/^[\?\&]+/, '');
	      }
	      if (settings.override_viewport === false) {
	        Env.overrideViewPort = false;
	      }
	      editorManager.fire('SetupEditor', { editor: self });
	      self.execCallback('setup', self);
	      self.$ = DomQuery.overrideDefaults(function () {
	        return {
	          context: self.inline ? self.getBody() : self.getDoc(),
	          element: self.getBody()
	        };
	      });
	    };
	    Editor.prototype = {
	      render: function () {
	        Render.render(this);
	      },
	      focus: function (skipFocus) {
	        EditorFocus.focus(this, skipFocus);
	      },
	      hasFocus: function () {
	        return EditorFocus.hasFocus(this);
	      },
	      execCallback: function (name) {
	        var x = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          x[_i - 1] = arguments[_i];
	        }
	        var self = this;
	        var callback = self.settings[name], scope;
	        if (!callback) {
	          return;
	        }
	        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
	          callback = scope.func;
	          scope = scope.scope;
	        }
	        if (typeof callback === 'string') {
	          scope = callback.replace(/\.\w+$/, '');
	          scope = scope ? resolve$4(scope) : 0;
	          callback = resolve$4(callback);
	          self.callbackLookup = self.callbackLookup || {};
	          self.callbackLookup[name] = {
	            func: callback,
	            scope: scope
	          };
	        }
	        return callback.apply(scope || self, Array.prototype.slice.call(arguments, 1));
	      },
	      translate: function (text) {
	        if (text && Tools.is(text, 'string')) {
	          var lang_1 = this.settings.language || 'en', i18n_1 = this.editorManager.i18n;
	          text = i18n_1.data[lang_1 + '.' + text] || text.replace(/\{\#([^\}]+)\}/g, function (a, b) {
	            return i18n_1.data[lang_1 + '.' + b] || '{#' + b + '}';
	          });
	        }
	        return this.editorManager.translate(text);
	      },
	      getLang: function (name, defaultVal) {
	        return this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + name] || (defaultVal !== undefined ? defaultVal : '{#' + name + '}');
	      },
	      getParam: function (name, defaultVal, type) {
	        return getParam(this, name, defaultVal, type);
	      },
	      nodeChanged: function (args) {
	        this._nodeChangeDispatcher.nodeChanged(args);
	      },
	      addButton: function (name, settings) {
	        var self = this;
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	        if (settings.stateSelector && typeof settings.active === 'undefined') {
	          settings.active = false;
	        }
	        if (!settings.text && !settings.icon) {
	          settings.icon = name;
	        }
	        settings.tooltip = settings.tooltip || settings.title;
	        self.buttons[name] = settings;
	      },
	      addSidebar: function (name, settings) {
	        return Sidebar.add(this, name, settings);
	      },
	      addMenuItem: function (name, settings) {
	        var self = this;
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	        self.menuItems[name] = settings;
	      },
	      addContextToolbar: function (predicate, items) {
	        var self = this;
	        var selector;
	        self.contextToolbars = self.contextToolbars || [];
	        if (typeof predicate === 'string') {
	          selector = predicate;
	          predicate = function (elm) {
	            return self.dom.is(elm, selector);
	          };
	        }
	        self.contextToolbars.push({
	          id: Uuid.uuid('mcet'),
	          predicate: predicate,
	          items: items
	        });
	      },
	      addCommand: function (name, callback, scope) {
	        this.editorCommands.addCommand(name, callback, scope);
	      },
	      addQueryStateHandler: function (name, callback, scope) {
	        this.editorCommands.addQueryStateHandler(name, callback, scope);
	      },
	      addQueryValueHandler: function (name, callback, scope) {
	        this.editorCommands.addQueryValueHandler(name, callback, scope);
	      },
	      addShortcut: function (pattern, desc, cmdFunc, scope) {
	        this.shortcuts.add(pattern, desc, cmdFunc, scope);
	      },
	      execCommand: function (cmd, ui, value, args) {
	        return this.editorCommands.execCommand(cmd, ui, value, args);
	      },
	      queryCommandState: function (cmd) {
	        return this.editorCommands.queryCommandState(cmd);
	      },
	      queryCommandValue: function (cmd) {
	        return this.editorCommands.queryCommandValue(cmd);
	      },
	      queryCommandSupported: function (cmd) {
	        return this.editorCommands.queryCommandSupported(cmd);
	      },
	      show: function () {
	        var self = this;
	        if (self.hidden) {
	          self.hidden = false;
	          if (self.inline) {
	            self.getBody().contentEditable = true;
	          } else {
	            DOM$7.show(self.getContainer());
	            DOM$7.hide(self.id);
	          }
	          self.load();
	          self.fire('show');
	        }
	      },
	      hide: function () {
	        var self = this, doc = self.getDoc();
	        if (!self.hidden) {
	          if (ie$2 && doc && !self.inline) {
	            doc.execCommand('SelectAll');
	          }
	          self.save();
	          if (self.inline) {
	            self.getBody().contentEditable = false;
	            if (self === self.editorManager.focusedEditor) {
	              self.editorManager.focusedEditor = null;
	            }
	          } else {
	            DOM$7.hide(self.getContainer());
	            DOM$7.setStyle(self.id, 'display', self.orgDisplay);
	          }
	          self.hidden = true;
	          self.fire('hide');
	        }
	      },
	      isHidden: function () {
	        return !!this.hidden;
	      },
	      setProgressState: function (state, time) {
	        this.fire('ProgressState', {
	          state: state,
	          time: time
	        });
	      },
	      load: function (args) {
	        var self = this;
	        var elm = self.getElement(), html;
	        if (self.removed) {
	          return '';
	        }
	        if (elm) {
	          args = args || {};
	          args.load = true;
	          html = self.setContent(elm.value !== undefined ? elm.value : elm.innerHTML, args);
	          args.element = elm;
	          if (!args.no_events) {
	            self.fire('LoadContent', args);
	          }
	          args.element = elm = null;
	          return html;
	        }
	      },
	      save: function (args) {
	        var self = this;
	        var elm = self.getElement(), html, form;
	        if (!elm || !self.initialized || self.removed) {
	          return;
	        }
	        args = args || {};
	        args.save = true;
	        args.element = elm;
	        html = args.content = self.getContent(args);
	        if (!args.no_events) {
	          self.fire('SaveContent', args);
	        }
	        if (args.format === 'raw') {
	          self.fire('RawSaveContent', args);
	        }
	        html = args.content;
	        if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
	          if (args.is_removing || !self.inline) {
	            elm.innerHTML = html;
	          }
	          if (form = DOM$7.getParent(self.id, 'form')) {
	            each$l(form.elements, function (elm) {
	              if (elm.name === self.id) {
	                elm.value = html;
	                return false;
	              }
	            });
	          }
	        } else {
	          elm.value = html;
	        }
	        args.element = elm = null;
	        if (args.set_dirty !== false) {
	          self.setDirty(false);
	        }
	        return html;
	      },
	      setContent: function (content, args) {
	        return setContent$1(this, content, args);
	      },
	      getContent: function (args) {
	        return getContent$1(this, args);
	      },
	      insertContent: function (content, args) {
	        if (args) {
	          content = extend$4({ content: content }, args);
	        }
	        this.execCommand('mceInsertContent', false, content);
	      },
	      isDirty: function () {
	        return !this.isNotDirty;
	      },
	      setDirty: function (state) {
	        var oldState = !this.isNotDirty;
	        this.isNotDirty = !state;
	        if (state && state !== oldState) {
	          this.fire('dirty');
	        }
	      },
	      setMode: function (mode) {
	        setMode(this, mode);
	      },
	      getContainer: function () {
	        var self = this;
	        if (!self.container) {
	          self.container = DOM$7.get(self.editorContainer || self.id + '_parent');
	        }
	        return self.container;
	      },
	      getContentAreaContainer: function () {
	        return this.contentAreaContainer;
	      },
	      getElement: function () {
	        if (!this.targetElm) {
	          this.targetElm = DOM$7.get(this.id);
	        }
	        return this.targetElm;
	      },
	      getWin: function () {
	        var self = this;
	        var elm;
	        if (!self.contentWindow) {
	          elm = self.iframeElement;
	          if (elm) {
	            self.contentWindow = elm.contentWindow;
	          }
	        }
	        return self.contentWindow;
	      },
	      getDoc: function () {
	        var self = this;
	        var win;
	        if (!self.contentDocument) {
	          win = self.getWin();
	          if (win) {
	            self.contentDocument = win.document;
	          }
	        }
	        return self.contentDocument;
	      },
	      getBody: function () {
	        var doc = this.getDoc();
	        return this.bodyElement || (doc ? doc.body : null);
	      },
	      convertURL: function (url, name, elm) {
	        var self = this, settings = self.settings;
	        if (settings.urlconverter_callback) {
	          return self.execCallback('urlconverter_callback', url, elm, true, name);
	        }
	        if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
	          return url;
	        }
	        if (settings.relative_urls) {
	          return self.documentBaseURI.toRelative(url);
	        }
	        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	        return url;
	      },
	      addVisual: function (elm) {
	        var self = this;
	        var settings = self.settings;
	        var dom = self.dom;
	        var cls;
	        elm = elm || self.getBody();
	        if (self.hasVisual === undefined) {
	          self.hasVisual = settings.visual;
	        }
	        each$l(dom.select('table,a', elm), function (elm) {
	          var value;
	          switch (elm.nodeName) {
	          case 'TABLE':
	            cls = settings.visual_table_class || 'mce-item-table';
	            value = dom.getAttrib(elm, 'border');
	            if ((!value || value === '0') && self.hasVisual) {
	              dom.addClass(elm, cls);
	            } else {
	              dom.removeClass(elm, cls);
	            }
	            return;
	          case 'A':
	            if (!dom.getAttrib(elm, 'href')) {
	              value = dom.getAttrib(elm, 'name') || elm.id;
	              cls = settings.visual_anchor_class || 'mce-item-anchor';
	              if (value && self.hasVisual) {
	                dom.addClass(elm, cls);
	              } else {
	                dom.removeClass(elm, cls);
	              }
	            }
	            return;
	          }
	        });
	        self.fire('VisualAid', {
	          element: elm,
	          hasVisual: self.hasVisual
	        });
	      },
	      remove: function () {
	        remove$7(this);
	      },
	      destroy: function (automatic) {
	        destroy(this, automatic);
	      },
	      uploadImages: function (callback) {
	        return this.editorUpload.uploadImages(callback);
	      },
	      _scanForImages: function () {
	        return this.editorUpload.scanForImages();
	      }
	    };
	    extend$4(Editor.prototype, EditorObservable$1);
	
	    var isEditorUIElement = function (elm) {
	      return elm.className.toString().indexOf('mce-') !== -1;
	    };
	    var FocusManager = { isEditorUIElement: isEditorUIElement };
	
	    var isManualNodeChange = function (e) {
	      return e.type === 'nodechange' && e.selectionChange;
	    };
	    var registerPageMouseUp = function (editor, throttledStore) {
	      var mouseUpPage = function () {
	        throttledStore.throttle();
	      };
	      DOMUtils$1.DOM.bind(domGlobals.document, 'mouseup', mouseUpPage);
	      editor.on('remove', function () {
	        DOMUtils$1.DOM.unbind(domGlobals.document, 'mouseup', mouseUpPage);
	      });
	    };
	    var registerFocusOut = function (editor) {
	      editor.on('focusout', function () {
	        SelectionBookmark.store(editor);
	      });
	    };
	    var registerMouseUp = function (editor, throttledStore) {
	      editor.on('mouseup touchend', function (e) {
	        throttledStore.throttle();
	      });
	    };
	    var registerEditorEvents = function (editor, throttledStore) {
	      var browser = PlatformDetection$1.detect().browser;
	      if (browser.isIE()) {
	        registerFocusOut(editor);
	      } else {
	        registerMouseUp(editor, throttledStore);
	      }
	      editor.on('keyup nodechange', function (e) {
	        if (!isManualNodeChange(e)) {
	          SelectionBookmark.store(editor);
	        }
	      });
	    };
	    var register$3 = function (editor) {
	      var throttledStore = first(function () {
	        SelectionBookmark.store(editor);
	      }, 0);
	      if (editor.inline) {
	        registerPageMouseUp(editor, throttledStore);
	      }
	      editor.on('init', function () {
	        registerEditorEvents(editor, throttledStore);
	      });
	      editor.on('remove', function () {
	        throttledStore.cancel();
	      });
	    };
	    var SelectionRestore = { register: register$3 };
	
	    var documentFocusInHandler;
	    var DOM$8 = DOMUtils$1.DOM;
	    var isEditorUIElement$1 = function (elm) {
	      return FocusManager.isEditorUIElement(elm);
	    };
	    var isUIElement = function (editor, elm) {
	      var customSelector = editor ? editor.settings.custom_ui_selector : '';
	      var parent = DOM$8.getParent(elm, function (elm) {
	        return isEditorUIElement$1(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
	      });
	      return parent !== null;
	    };
	    var getActiveElement = function () {
	      try {
	        return domGlobals.document.activeElement;
	      } catch (ex) {
	        return domGlobals.document.body;
	      }
	    };
	    var registerEvents = function (editorManager, e) {
	      var editor = e.editor;
	      SelectionRestore.register(editor);
	      editor.on('focusin', function () {
	        var self = this;
	        var focusedEditor = editorManager.focusedEditor;
	        if (focusedEditor !== self) {
	          if (focusedEditor) {
	            focusedEditor.fire('blur', { focusedEditor: self });
	          }
	          editorManager.setActive(self);
	          editorManager.focusedEditor = self;
	          self.fire('focus', { blurredEditor: focusedEditor });
	          self.focus(true);
	        }
	      });
	      editor.on('focusout', function () {
	        var self = this;
	        Delay.setEditorTimeout(self, function () {
	          var focusedEditor = editorManager.focusedEditor;
	          if (!isUIElement(self, getActiveElement()) && focusedEditor === self) {
	            self.fire('blur', { focusedEditor: null });
	            editorManager.focusedEditor = null;
	          }
	        });
	      });
	      if (!documentFocusInHandler) {
	        documentFocusInHandler = function (e) {
	          var activeEditor = editorManager.activeEditor;
	          var target;
	          target = e.target;
	          if (activeEditor && target.ownerDocument === domGlobals.document) {
	            if (target !== domGlobals.document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
	              activeEditor.fire('blur', { focusedEditor: null });
	              editorManager.focusedEditor = null;
	            }
	          }
	        };
	        DOM$8.bind(domGlobals.document, 'focusin', documentFocusInHandler);
	      }
	    };
	    var unregisterDocumentEvents = function (editorManager, e) {
	      if (editorManager.focusedEditor === e.editor) {
	        editorManager.focusedEditor = null;
	      }
	      if (!editorManager.activeEditor) {
	        DOM$8.unbind(domGlobals.document, 'focusin', documentFocusInHandler);
	        documentFocusInHandler = null;
	      }
	    };
	    var setup$h = function (editorManager) {
	      editorManager.on('AddEditor', curry(registerEvents, editorManager));
	      editorManager.on('RemoveEditor', curry(unregisterDocumentEvents, editorManager));
	    };
	    var FocusController = {
	      setup: setup$h,
	      isEditorUIElement: isEditorUIElement$1,
	      isUIElement: isUIElement
	    };
	
	    var DOM$9 = DOMUtils$1.DOM;
	    var explode$4 = Tools.explode, each$m = Tools.each, extend$5 = Tools.extend;
	    var instanceCounter = 0, beforeUnloadDelegate, EditorManager, boundGlobalEvents = false;
	    var legacyEditors = [];
	    var editors = [];
	    var isValidLegacyKey = function (id) {
	      return id !== 'length';
	    };
	    var globalEventDelegate = function (e) {
	      var type = e.type;
	      each$m(EditorManager.get(), function (editor) {
	        switch (type) {
	        case 'scroll':
	          editor.fire('ScrollWindow', e);
	          break;
	        case 'resize':
	          editor.fire('ResizeWindow', e);
	          break;
	        }
	      });
	    };
	    var toggleGlobalEvents = function (state) {
	      if (state !== boundGlobalEvents) {
	        if (state) {
	          DomQuery(window).on('resize scroll', globalEventDelegate);
	        } else {
	          DomQuery(window).off('resize scroll', globalEventDelegate);
	        }
	        boundGlobalEvents = state;
	      }
	    };
	    var removeEditorFromList = function (targetEditor) {
	      var oldEditors = editors;
	      delete legacyEditors[targetEditor.id];
	      for (var i = 0; i < legacyEditors.length; i++) {
	        if (legacyEditors[i] === targetEditor) {
	          legacyEditors.splice(i, 1);
	          break;
	        }
	      }
	      editors = filter(editors, function (editor) {
	        return targetEditor !== editor;
	      });
	      if (EditorManager.activeEditor === targetEditor) {
	        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
	      }
	      if (EditorManager.focusedEditor === targetEditor) {
	        EditorManager.focusedEditor = null;
	      }
	      return oldEditors.length !== editors.length;
	    };
	    var purgeDestroyedEditor = function (editor) {
	      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
	        removeEditorFromList(editor);
	        editor.unbindAllNativeEvents();
	        editor.destroy(true);
	        editor.removed = true;
	        editor = null;
	      }
	      return editor;
	    };
	    EditorManager = {
	      defaultSettings: {},
	      $: DomQuery,
	      majorVersion: '4',
	      minorVersion: '9.11',
	      releaseDate: '2020-07-13',
	      editors: legacyEditors,
	      i18n: I18n,
	      activeEditor: null,
	      settings: {},
	      setup: function () {
	        var self = this;
	        var baseURL, documentBaseURL, suffix = '';
	        documentBaseURL = URI.getDocumentBaseUrl(domGlobals.document.location);
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
	          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(documentBaseURL)) {
	            documentBaseURL += '/';
	          }
	        }
	        var preInit = window.tinymce || window.tinyMCEPreInit;
	        if (preInit) {
	          baseURL = preInit.base || preInit.baseURL;
	          suffix = preInit.suffix;
	        } else {
	          var scripts = domGlobals.document.getElementsByTagName('script');
	          for (var i = 0; i < scripts.length; i++) {
	            var src = scripts[i].src || '';
	            if (src === '') {
	              continue;
	            }
	            var srcScript = src.substring(src.lastIndexOf('/'));
	            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
	              if (srcScript.indexOf('.min') !== -1) {
	                suffix = '.min';
	              }
	              baseURL = src.substring(0, src.lastIndexOf('/'));
	              break;
	            }
	          }
	          if (!baseURL && domGlobals.document.currentScript) {
	            var src = domGlobals.document.currentScript.src;
	            if (src.indexOf('.min') !== -1) {
	              suffix = '.min';
	            }
	            baseURL = src.substring(0, src.lastIndexOf('/'));
	          }
	        }
	        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	        self.documentBaseURL = documentBaseURL;
	        self.baseURI = new URI(self.baseURL);
	        self.suffix = suffix;
	        FocusController.setup(self);
	      },
	      overrideDefaults: function (defaultSettings) {
	        var baseUrl, suffix;
	        baseUrl = defaultSettings.base_url;
	        if (baseUrl) {
	          this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
	          this.baseURI = new URI(this.baseURL);
	        }
	        suffix = defaultSettings.suffix;
	        if (defaultSettings.suffix) {
	          this.suffix = suffix;
	        }
	        this.defaultSettings = defaultSettings;
	        var pluginBaseUrls = defaultSettings.plugin_base_urls;
	        for (var name in pluginBaseUrls) {
	          AddOnManager.PluginManager.urls[name] = pluginBaseUrls[name];
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        var result, invalidInlineTargets;
	        invalidInlineTargets = Tools.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu', ' ');
	        var isInvalidInlineTarget = function (settings, elm) {
	          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
	        };
	        var createId = function (elm) {
	          var id = elm.id;
	          if (!id) {
	            id = elm.name;
	            if (id && !DOM$9.get(id)) {
	              id = elm.name;
	            } else {
	              id = DOM$9.uniqueId();
	            }
	            elm.setAttribute('id', id);
	          }
	          return id;
	        };
	        var execCallback = function (name) {
	          var callback = settings[name];
	          if (!callback) {
	            return;
	          }
	          return callback.apply(self, Array.prototype.slice.call(arguments, 2));
	        };
	        var hasClass = function (elm, className) {
	          return className.constructor === RegExp ? className.test(elm.className) : DOM$9.hasClass(elm, className);
	        };
	        var findTargets = function (settings) {
	          var l, targets = [];
	          if (Env.ie && Env.ie < 11) {
	            ErrorReporter.initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
	            return [];
	          }
	          if (settings.types) {
	            each$m(settings.types, function (type) {
	              targets = targets.concat(DOM$9.select(type.selector));
	            });
	            return targets;
	          } else if (settings.selector) {
	            return DOM$9.select(settings.selector);
	          } else if (settings.target) {
	            return [settings.target];
	          }
	          switch (settings.mode) {
	          case 'exact':
	            l = settings.elements || '';
	            if (l.length > 0) {
	              each$m(explode$4(l), function (id) {
	                var elm;
	                if (elm = DOM$9.get(id)) {
	                  targets.push(elm);
	                } else {
	                  each$m(domGlobals.document.forms, function (f) {
	                    each$m(f.elements, function (e) {
	                      if (e.name === id) {
	                        id = 'mce_editor_' + instanceCounter++;
	                        DOM$9.setAttrib(e, 'id', id);
	                        targets.push(e);
	                      }
	                    });
	                  });
	                }
	              });
	            }
	            break;
	          case 'textareas':
	          case 'specific_textareas':
	            each$m(DOM$9.select('textarea'), function (elm) {
	              if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
	                return;
	              }
	              if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
	                targets.push(elm);
	              }
	            });
	            break;
	          }
	          return targets;
	        };
	        var provideResults = function (editors) {
	          result = editors;
	        };
	        var initEditors = function () {
	          var initCount = 0;
	          var editors = [];
	          var targets;
	          var createEditor = function (id, settings, targetElm) {
	            var editor = new Editor(id, settings, self);
	            editors.push(editor);
	            editor.on('init', function () {
	              if (++initCount === targets.length) {
	                provideResults(editors);
	              }
	            });
	            editor.targetElm = editor.targetElm || targetElm;
	            editor.render();
	          };
	          DOM$9.unbind(window, 'ready', initEditors);
	          execCallback('onpageload');
	          targets = DomQuery.unique(findTargets(settings));
	          if (settings.types) {
	            each$m(settings.types, function (type) {
	              Tools.each(targets, function (elm) {
	                if (DOM$9.is(elm, type.selector)) {
	                  createEditor(createId(elm), extend$5({}, settings, type), elm);
	                  return false;
	                }
	                return true;
	              });
	            });
	            return;
	          }
	          Tools.each(targets, function (elm) {
	            purgeDestroyedEditor(self.get(elm.id));
	          });
	          targets = Tools.grep(targets, function (elm) {
	            return !self.get(elm.id);
	          });
	          if (targets.length === 0) {
	            provideResults([]);
	          } else {
	            each$m(targets, function (elm) {
	              if (isInvalidInlineTarget(settings, elm)) {
	                ErrorReporter.initError('Could not initialize inline editor on invalid inline target element', elm);
	              } else {
	                createEditor(createId(elm), settings, elm);
	              }
	            });
	          }
	        };
	        self.settings = settings;
	        DOM$9.bind(window, 'ready', initEditors);
	        return new promiseObj(function (resolve) {
	          if (result) {
	            resolve(result);
	          } else {
	            provideResults = function (editors) {
	              resolve(editors);
	            };
	          }
	        });
	      },
	      get: function (id) {
	        if (arguments.length === 0) {
	          return editors.slice(0);
	        } else if (isString(id)) {
	          return find(editors, function (editor) {
	            return editor.id === id;
	          }).getOr(null);
	        } else if (isNumber(id)) {
	          return editors[id] ? editors[id] : null;
	        } else {
	          return null;
	        }
	      },
	      add: function (editor) {
	        var self = this;
	        var existingEditor;
	        existingEditor = legacyEditors[editor.id];
	        if (existingEditor === editor) {
	          return editor;
	        }
	        if (self.get(editor.id) === null) {
	          if (isValidLegacyKey(editor.id)) {
	            legacyEditors[editor.id] = editor;
	          }
	          legacyEditors.push(editor);
	          editors.push(editor);
	        }
	        toggleGlobalEvents(true);
	        self.activeEditor = editor;
	        self.fire('AddEditor', { editor: editor });
	        if (!beforeUnloadDelegate) {
	          beforeUnloadDelegate = function () {
	            self.fire('BeforeUnload');
	          };
	          DOM$9.bind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	        return editor;
	      },
	      createEditor: function (id, settings) {
	        return this.add(new Editor(id, settings, this));
	      },
	      remove: function (selector) {
	        var self = this;
	        var i, editor;
	        if (!selector) {
	          for (i = editors.length - 1; i >= 0; i--) {
	            self.remove(editors[i]);
	          }
	          return;
	        }
	        if (isString(selector)) {
	          each$m(DOM$9.select(selector), function (elm) {
	            editor = self.get(elm.id);
	            if (editor) {
	              self.remove(editor);
	            }
	          });
	          return;
	        }
	        editor = selector;
	        if (isNull(self.get(editor.id))) {
	          return null;
	        }
	        if (removeEditorFromList(editor)) {
	          self.fire('RemoveEditor', { editor: editor });
	        }
	        if (editors.length === 0) {
	          DOM$9.unbind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	        editor.remove();
	        toggleGlobalEvents(editors.length > 0);
	        return editor;
	      },
	      execCommand: function (cmd, ui, value) {
	        var self = this, editor = self.get(value);
	        switch (cmd) {
	        case 'mceAddEditor':
	          if (!self.get(value)) {
	            new Editor(value, self.settings, self).render();
	          }
	          return true;
	        case 'mceRemoveEditor':
	          if (editor) {
	            editor.remove();
	          }
	          return true;
	        case 'mceToggleEditor':
	          if (!editor) {
	            self.execCommand('mceAddEditor', 0, value);
	            return true;
	          }
	          if (editor.isHidden()) {
	            editor.show();
	          } else {
	            editor.hide();
	          }
	          return true;
	        }
	        if (self.activeEditor) {
	          return self.activeEditor.execCommand(cmd, ui, value);
	        }
	        return false;
	      },
	      triggerSave: function () {
	        each$m(editors, function (editor) {
	          editor.save();
	        });
	      },
	      addI18n: function (code, items) {
	        I18n.add(code, items);
	      },
	      translate: function (text) {
	        return I18n.translate(text);
	      },
	      setActive: function (editor) {
	        var activeEditor = this.activeEditor;
	        if (this.activeEditor !== editor) {
	          if (activeEditor) {
	            activeEditor.fire('deactivate', { relatedTarget: editor });
	          }
	          editor.fire('activate', { relatedTarget: activeEditor });
	        }
	        this.activeEditor = editor;
	      }
	    };
	    extend$5(EditorManager, Observable);
	    EditorManager.setup();
	    var EditorManager$1 = EditorManager;
	
	    function RangeUtils(dom) {
	      var walk = function (rng, callback) {
	        return RangeWalk.walk(dom, rng, callback);
	      };
	      var split = SplitRange.split;
	      var normalize = function (rng) {
	        return NormalizeRange.normalize(dom, rng).fold(constant(false), function (normalizedRng) {
	          rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
	          rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
	          return true;
	        });
	      };
	      return {
	        walk: walk,
	        split: split,
	        normalize: normalize
	      };
	    }
	    (function (RangeUtils) {
	      RangeUtils.compareRanges = RangeCompare.isEq;
	      RangeUtils.getCaretRangeFromPoint = CaretRangeFromPoint.fromPoint;
	      RangeUtils.getSelectedNode = getSelectedNode;
	      RangeUtils.getNode = getNode;
	    }(RangeUtils || (RangeUtils = {})));
	    var RangeUtils$1 = RangeUtils;
	
	    var min = Math.min, max = Math.max, round$2 = Math.round;
	    var relativePosition = function (rect, targetRect, rel) {
	      var x, y, w, h, targetW, targetH;
	      x = targetRect.x;
	      y = targetRect.y;
	      w = rect.w;
	      h = rect.h;
	      targetW = targetRect.w;
	      targetH = targetRect.h;
	      rel = (rel || '').split('');
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	      if (rel[0] === 'c') {
	        y += round$2(targetH / 2);
	      }
	      if (rel[1] === 'c') {
	        x += round$2(targetW / 2);
	      }
	      if (rel[3] === 'b') {
	        y -= h;
	      }
	      if (rel[4] === 'r') {
	        x -= w;
	      }
	      if (rel[3] === 'c') {
	        y -= round$2(h / 2);
	      }
	      if (rel[4] === 'c') {
	        x -= round$2(w / 2);
	      }
	      return create$4(x, y, w, h);
	    };
	    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
	      var pos, i;
	      for (i = 0; i < rels.length; i++) {
	        pos = relativePosition(rect, targetRect, rels[i]);
	        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
	          return rels[i];
	        }
	      }
	      return null;
	    };
	    var inflate = function (rect, w, h) {
	      return create$4(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
	    };
	    var intersect = function (rect, cropRect) {
	      var x1, y1, x2, y2;
	      x1 = max(rect.x, cropRect.x);
	      y1 = max(rect.y, cropRect.y);
	      x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
	      y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
	      if (x2 - x1 < 0 || y2 - y1 < 0) {
	        return null;
	      }
	      return create$4(x1, y1, x2 - x1, y2 - y1);
	    };
	    var clamp$1 = function (rect, clampRect, fixedSize) {
	      var underflowX1, underflowY1, overflowX2, overflowY2, x1, y1, x2, y2, cx2, cy2;
	      x1 = rect.x;
	      y1 = rect.y;
	      x2 = rect.x + rect.w;
	      y2 = rect.y + rect.h;
	      cx2 = clampRect.x + clampRect.w;
	      cy2 = clampRect.y + clampRect.h;
	      underflowX1 = max(0, clampRect.x - x1);
	      underflowY1 = max(0, clampRect.y - y1);
	      overflowX2 = max(0, x2 - cx2);
	      overflowY2 = max(0, y2 - cy2);
	      x1 += underflowX1;
	      y1 += underflowY1;
	      if (fixedSize) {
	        x2 += underflowX1;
	        y2 += underflowY1;
	        x1 -= overflowX2;
	        y1 -= overflowY2;
	      }
	      x2 -= overflowX2;
	      y2 -= overflowY2;
	      return create$4(x1, y1, x2 - x1, y2 - y1);
	    };
	    var create$4 = function (x, y, w, h) {
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var fromClientRect = function (clientRect) {
	      return create$4(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	    };
	    var Rect = {
	      inflate: inflate,
	      relativePosition: relativePosition,
	      findBestRelativePosition: findBestRelativePosition,
	      intersect: intersect,
	      clamp: clamp$1,
	      create: create$4,
	      fromClientRect: fromClientRect
	    };
	
	    var types = {};
	    var Factory = {
	      add: function (type, typeClass) {
	        types[type.toLowerCase()] = typeClass;
	      },
	      has: function (type) {
	        return !!types[type.toLowerCase()];
	      },
	      get: function (type) {
	        var lctype = type.toLowerCase();
	        var controlType = types.hasOwnProperty(lctype) ? types[lctype] : null;
	        if (controlType === null) {
	          throw new Error('Could not find module for type: ' + type);
	        }
	        return controlType;
	      },
	      create: function (type, settings) {
	        var ControlType;
	        if (typeof type === 'string') {
	          settings = settings || {};
	          settings.type = type;
	        } else {
	          settings = type;
	          type = settings.type;
	        }
	        type = type.toLowerCase();
	        ControlType = types[type];
	        if (!ControlType) {
	          throw new Error('Could not find control by type: ' + type);
	        }
	        ControlType = new ControlType(settings);
	        ControlType.type = type;
	        return ControlType;
	      }
	    };
	
	    var each$n = Tools.each, extend$6 = Tools.extend;
	    var extendClass, initializing;
	    var Class = function () {
	    };
	    Class.extend = extendClass = function (prop) {
	      var self = this;
	      var _super = self.prototype;
	      var prototype, name, member;
	      var Class = function () {
	        var i, mixins, mixin;
	        var self = this;
	        if (!initializing) {
	          if (self.init) {
	            self.init.apply(self, arguments);
	          }
	          mixins = self.Mixins;
	          if (mixins) {
	            i = mixins.length;
	            while (i--) {
	              mixin = mixins[i];
	              if (mixin.init) {
	                mixin.init.apply(self, arguments);
	              }
	            }
	          }
	        }
	      };
	      var dummy = function () {
	        return this;
	      };
	      var createMethod = function (name, fn) {
	        return function () {
	          var self = this;
	          var tmp = self._super;
	          var ret;
	          self._super = _super[name];
	          ret = fn.apply(self, arguments);
	          self._super = tmp;
	          return ret;
	        };
	      };
	      initializing = true;
	      prototype = new self();
	      initializing = false;
	      if (prop.Mixins) {
	        each$n(prop.Mixins, function (mixin) {
	          for (var name_1 in mixin) {
	            if (name_1 !== 'init') {
	              prop[name_1] = mixin[name_1];
	            }
	          }
	        });
	        if (_super.Mixins) {
	          prop.Mixins = _super.Mixins.concat(prop.Mixins);
	        }
	      }
	      if (prop.Methods) {
	        each$n(prop.Methods.split(','), function (name) {
	          prop[name] = dummy;
	        });
	      }
	      if (prop.Properties) {
	        each$n(prop.Properties.split(','), function (name) {
	          var fieldName = '_' + name;
	          prop[name] = function (value) {
	            var self = this;
	            if (value !== undefined) {
	              self[fieldName] = value;
	              return self;
	            }
	            return self[fieldName];
	          };
	        });
	      }
	      if (prop.Statics) {
	        each$n(prop.Statics, function (func, name) {
	          Class[name] = func;
	        });
	      }
	      if (prop.Defaults && _super.Defaults) {
	        prop.Defaults = extend$6({}, _super.Defaults, prop.Defaults);
	      }
	      for (name in prop) {
	        member = prop[name];
	        if (typeof member === 'function' && _super[name]) {
	          prototype[name] = createMethod(name, member);
	        } else {
	          prototype[name] = member;
	        }
	      }
	      Class.prototype = prototype;
	      Class.constructor = Class;
	      Class.extend = extendClass;
	      return Class;
	    };
	
	    var min$1 = Math.min, max$1 = Math.max, round$3 = Math.round;
	    var Color = function (value) {
	      var self = {};
	      var r = 0, g = 0, b = 0;
	      var rgb2hsv = function (r, g, b) {
	        var h, s, v, d, minRGB, maxRGB;
	        h = 0;
	        s = 0;
	        v = 0;
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	        minRGB = min$1(r, min$1(g, b));
	        maxRGB = max$1(r, max$1(g, b));
	        if (minRGB === maxRGB) {
	          v = minRGB;
	          return {
	            h: 0,
	            s: 0,
	            v: v * 100
	          };
	        }
	        d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	        h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	        h = 60 * (h - d / (maxRGB - minRGB));
	        s = (maxRGB - minRGB) / maxRGB;
	        v = maxRGB;
	        return {
	          h: round$3(h),
	          s: round$3(s * 100),
	          v: round$3(v * 100)
	        };
	      };
	      var hsvToRgb = function (hue, saturation, brightness) {
	        var side, chroma, x, match;
	        hue = (parseInt(hue, 10) || 0) % 360;
	        saturation = parseInt(saturation, 10) / 100;
	        brightness = parseInt(brightness, 10) / 100;
	        saturation = max$1(0, min$1(saturation, 1));
	        brightness = max$1(0, min$1(brightness, 1));
	        if (saturation === 0) {
	          r = g = b = round$3(255 * brightness);
	          return;
	        }
	        side = hue / 60;
	        chroma = brightness * saturation;
	        x = chroma * (1 - Math.abs(side % 2 - 1));
	        match = brightness - chroma;
	        switch (Math.floor(side)) {
	        case 0:
	          r = chroma;
	          g = x;
	          b = 0;
	          break;
	        case 1:
	          r = x;
	          g = chroma;
	          b = 0;
	          break;
	        case 2:
	          r = 0;
	          g = chroma;
	          b = x;
	          break;
	        case 3:
	          r = 0;
	          g = x;
	          b = chroma;
	          break;
	        case 4:
	          r = x;
	          g = 0;
	          b = chroma;
	          break;
	        case 5:
	          r = chroma;
	          g = 0;
	          b = x;
	          break;
	        default:
	          r = g = b = 0;
	        }
	        r = round$3(255 * (r + match));
	        g = round$3(255 * (g + match));
	        b = round$3(255 * (b + match));
	      };
	      var toHex = function () {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	          return val.length > 1 ? val : '0' + val;
	        };
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	      var toRgb = function () {
	        return {
	          r: r,
	          g: g,
	          b: b
	        };
	      };
	      var toHsv = function () {
	        return rgb2hsv(r, g, b);
	      };
	      var parse = function (value) {
	        var matches;
	        if (typeof value === 'object') {
	          if ('r' in value) {
	            r = value.r;
	            g = value.g;
	            b = value.b;
	          } else if ('v' in value) {
	            hsvToRgb(value.h, value.s, value.v);
	          }
	        } else {
	          if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
	            r = parseInt(matches[1], 10);
	            g = parseInt(matches[2], 10);
	            b = parseInt(matches[3], 10);
	          } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
	            r = parseInt(matches[1], 16);
	            g = parseInt(matches[2], 16);
	            b = parseInt(matches[3], 16);
	          } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
	            r = parseInt(matches[1] + matches[1], 16);
	            g = parseInt(matches[2] + matches[2], 16);
	            b = parseInt(matches[3] + matches[3], 16);
	          }
	        }
	        r = r < 0 ? 0 : r > 255 ? 255 : r;
	        g = g < 0 ? 0 : g > 255 ? 255 : g;
	        b = b < 0 ? 0 : b > 255 ? 255 : b;
	        return self;
	      };
	      if (value) {
	        parse(value);
	      }
	      self.toRgb = toRgb;
	      self.toHsv = toHsv;
	      self.toHex = toHex;
	      self.parse = parse;
	      return self;
	    };
	
	    var serialize = function (o, quote) {
	      var i, v, t, name;
	      quote = quote || '"';
	      if (o === null) {
	        return 'null';
	      }
	      t = typeof o;
	      if (t === 'string') {
	        v = '\bb\tt\nn\ff\rr""\'\'\\\\';
	        return quote + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function (a, b) {
	          if (quote === '"' && a === '\'') {
	            return a;
	          }
	          i = v.indexOf(b);
	          if (i + 1) {
	            return '\\' + v.charAt(i + 1);
	          }
	          a = b.charCodeAt().toString(16);
	          return '\\u' + '0000'.substring(a.length) + a;
	        }) + quote;
	      }
	      if (t === 'object') {
	        if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
	          for (i = 0, v = '['; i < o.length; i++) {
	            v += (i > 0 ? ',' : '') + serialize(o[i], quote);
	          }
	          return v + ']';
	        }
	        v = '{';
	        for (name in o) {
	          if (o.hasOwnProperty(name)) {
	            v += typeof o[name] !== 'function' ? (v.length > 1 ? ',' + quote : quote) + name + quote + ':' + serialize(o[name], quote) : '';
	          }
	        }
	        return v + '}';
	      }
	      return '' + o;
	    };
	    var JSON$1 = {
	      serialize: serialize,
	      parse: function (text) {
	        try {
	          return JSON.parse(text);
	        } catch (ex) {
	        }
	      }
	    };
	
	    var JSONP = {
	      callbacks: {},
	      count: 0,
	      send: function (settings) {
	        var self = this, dom = DOMUtils$1.DOM, count = settings.count !== undefined ? settings.count : self.count;
	        var id = 'tinymce_jsonp_' + count;
	        self.callbacks[count] = function (json) {
	          dom.remove(id);
	          delete self.callbacks[count];
	          settings.callback(json);
	        };
	        dom.add(dom.doc.body, 'script', {
	          id: id,
	          src: settings.url,
	          type: 'text/javascript'
	        });
	        self.count++;
	      }
	    };
	
	    var XHR = {
	      send: function (settings) {
	        var xhr, count = 0;
	        var ready = function () {
	          if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
	            if (settings.success && count < 10000 && xhr.status === 200) {
	              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
	            } else if (settings.error) {
	              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
	            }
	            xhr = null;
	          } else {
	            setTimeout(ready, 10);
	          }
	        };
	        settings.scope = settings.scope || this;
	        settings.success_scope = settings.success_scope || settings.scope;
	        settings.error_scope = settings.error_scope || settings.scope;
	        settings.async = settings.async === false ? false : true;
	        settings.data = settings.data || '';
	        XHR.fire('beforeInitialize', { settings: settings });
	        xhr = XMLHttpRequest();
	        if (xhr) {
	          if (xhr.overrideMimeType) {
	            xhr.overrideMimeType(settings.content_type);
	          }
	          xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	          if (settings.crossDomain) {
	            xhr.withCredentials = true;
	          }
	          if (settings.content_type) {
	            xhr.setRequestHeader('Content-Type', settings.content_type);
	          }
	          if (settings.requestheaders) {
	            Tools.each(settings.requestheaders, function (header) {
	              xhr.setRequestHeader(header.key, header.value);
	            });
	          }
	          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	          xhr = XHR.fire('beforeSend', {
	            xhr: xhr,
	            settings: settings
	          }).xhr;
	          xhr.send(settings.data);
	          if (!settings.async) {
	            return ready();
	          }
	          setTimeout(ready, 10);
	        }
	      }
	    };
	    Tools.extend(XHR, Observable);
	
	    var extend$7 = Tools.extend;
	    var JSONRequest = function (settings) {
	      this.settings = extend$7({}, settings);
	      this.count = 0;
	    };
	    JSONRequest.sendRPC = function (o) {
	      return new JSONRequest().send(o);
	    };
	    JSONRequest.prototype = {
	      send: function (args) {
	        var ecb = args.error, scb = args.success;
	        args = extend$7(this.settings, args);
	        args.success = function (c, x) {
	          c = JSON$1.parse(c);
	          if (typeof c === 'undefined') {
	            c = { error: 'JSON Parse error.' };
	          }
	          if (c.error) {
	            ecb.call(args.error_scope || args.scope, c.error, x);
	          } else {
	            scb.call(args.success_scope || args.scope, c.result);
	          }
	        };
	        args.error = function (ty, x) {
	          if (ecb) {
	            ecb.call(args.error_scope || args.scope, ty, x);
	          }
	        };
	        args.data = JSON$1.serialize({
	          id: args.id || 'c' + this.count++,
	          method: args.method,
	          params: args.params
	        });
	        args.content_type = 'application/json';
	        XHR.send(args);
	      }
	    };
	
	    var create$5 = function () {
	      return function () {
	        var data = {};
	        var keys = [];
	        var storage = {
	          getItem: function (key) {
	            var item = data[key];
	            return item ? item : null;
	          },
	          setItem: function (key, value) {
	            keys.push(key);
	            data[key] = String(value);
	          },
	          key: function (index) {
	            return keys[index];
	          },
	          removeItem: function (key) {
	            keys = keys.filter(function (k) {
	              return k === key;
	            });
	            delete data[key];
	          },
	          clear: function () {
	            keys = [];
	            data = {};
	          },
	          length: 0
	        };
	        Object.defineProperty(storage, 'length', {
	          get: function () {
	            return keys.length;
	          },
	          configurable: false,
	          enumerable: false
	        });
	        return storage;
	      }();
	    };
	
	    var localStorage;
	    try {
	      localStorage = domGlobals.window.localStorage;
	    } catch (e) {
	      localStorage = create$5();
	    }
	    var LocalStorage = localStorage;
	
	    var tinymce = EditorManager$1;
	    var publicApi = {
	      geom: { Rect: Rect },
	      util: {
	        Promise: promiseObj,
	        Delay: Delay,
	        Tools: Tools,
	        VK: VK,
	        URI: URI,
	        Class: Class,
	        EventDispatcher: Dispatcher,
	        Observable: Observable,
	        I18n: I18n,
	        XHR: XHR,
	        JSON: JSON$1,
	        JSONRequest: JSONRequest,
	        JSONP: JSONP,
	        LocalStorage: LocalStorage,
	        Color: Color
	      },
	      dom: {
	        EventUtils: EventUtils,
	        Sizzle: Sizzle,
	        DomQuery: DomQuery,
	        TreeWalker: TreeWalker,
	        DOMUtils: DOMUtils$1,
	        ScriptLoader: ScriptLoader,
	        RangeUtils: RangeUtils$1,
	        Serializer: DomSerializer$1,
	        ControlSelection: ControlSelection,
	        BookmarkManager: BookmarkManager$1,
	        Selection: Selection$1,
	        Event: EventUtils.Event
	      },
	      html: {
	        Styles: Styles,
	        Entities: Entities,
	        Node: Node$1,
	        Schema: Schema,
	        SaxParser: SaxParser$1,
	        DomParser: DomParser,
	        Writer: Writer,
	        Serializer: HtmlSerializer
	      },
	      ui: { Factory: Factory },
	      Env: Env,
	      AddOnManager: AddOnManager,
	      Annotator: Annotator,
	      Formatter: Formatter,
	      UndoManager: UndoManager,
	      EditorCommands: EditorCommands,
	      WindowManager: WindowManager,
	      NotificationManager: NotificationManager,
	      EditorObservable: EditorObservable$1,
	      Shortcuts: Shortcuts,
	      Editor: Editor,
	      FocusManager: FocusManager,
	      EditorManager: EditorManager$1,
	      DOM: DOMUtils$1.DOM,
	      ScriptLoader: ScriptLoader.ScriptLoader,
	      PluginManager: AddOnManager.PluginManager,
	      ThemeManager: AddOnManager.ThemeManager,
	      trim: Tools.trim,
	      isArray: Tools.isArray,
	      is: Tools.is,
	      toArray: Tools.toArray,
	      makeMap: Tools.makeMap,
	      each: Tools.each,
	      map: Tools.map,
	      grep: Tools.grep,
	      inArray: Tools.inArray,
	      extend: Tools.extend,
	      create: Tools.create,
	      walk: Tools.walk,
	      createNS: Tools.createNS,
	      resolve: Tools.resolve,
	      explode: Tools.explode,
	      _addCacheSuffix: Tools._addCacheSuffix,
	      isOpera: Env.opera,
	      isWebKit: Env.webkit,
	      isIE: Env.ie,
	      isGecko: Env.gecko,
	      isMac: Env.mac
	    };
	    tinymce = Tools.extend(tinymce, publicApi);
	    var Tinymce = tinymce;
	
	    var exportToModuleLoaders = function (tinymce) {
	      if (true) {
	        try {
	          module.exports = tinymce;
	        } catch (_) {
	        }
	      }
	    };
	    var exportToWindowGlobal = function (tinymce) {
	      window.tinymce = tinymce;
	      window.tinyMCE = tinymce;
	    };
	    exportToWindowGlobal(Tinymce);
	    exportToModuleLoaders(Tinymce);
	
	}(window));
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(538).setImmediate, (function() { return this; }())))

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(561);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(517);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(51)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/main.js